import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 2560 2560">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="">
        <path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2561.453369,2129.539062 
	C2562.000000,2273.969238 2562.000000,2417.938232 2562.000000,2561.953613 
	C1708.880249,2561.953613 855.760376,2561.953613 2.000000,2561.953613 
	C2.000000,2197.958496 2.000000,1833.916504 2.000000,1468.937256 
	C8.471620,1464.188232 12.787974,1458.979004 16.040529,1451.900635 
	C19.574871,1444.209229 26.882046,1438.772095 32.450851,1432.317383 
	C37.010376,1427.032471 44.254047,1430.494385 45.398830,1437.643677 
	C45.711487,1439.596191 45.265015,1441.656372 45.879639,1443.594116 
	C46.671356,1446.090454 48.298000,1447.708984 51.047554,1447.157837 
	C53.366447,1446.693115 53.988140,1444.708252 54.053539,1442.579346 
	C54.105141,1440.899780 53.765507,1439.256104 53.326019,1437.650269 
	C51.229473,1429.990234 54.339306,1425.474121 61.753628,1423.445068 
	C65.914742,1422.306274 70.781052,1421.620361 71.803192,1416.501343 
	C72.881660,1411.100220 68.182312,1409.215332 64.608932,1406.865601 
	C61.204479,1404.626831 59.131866,1401.601807 60.846901,1397.593018 
	C62.817402,1392.987061 67.295708,1393.056885 71.205757,1393.832397 
	C79.266472,1395.430786 86.861382,1396.541016 93.618660,1389.947388 
	C96.902779,1386.742798 98.505783,1383.105469 99.964340,1378.938965 
	C102.417519,1371.931030 106.389977,1371.256348 111.751335,1376.441528 
	C112.943077,1377.594116 113.803703,1379.070557 115.013565,1380.221313 
	C117.695580,1382.772217 120.826546,1383.398804 124.231766,1382.018555 
	C126.996422,1380.898193 128.279434,1378.585449 128.291794,1375.698120 
	C128.308563,1371.782715 125.688873,1369.872925 122.478668,1368.384033 
	C103.608620,1359.632080 103.626602,1359.157471 119.049629,1344.726807 
	C124.133072,1339.970459 128.163010,1339.775024 131.942047,1345.902710 
	C132.116745,1346.186035 132.311905,1346.457153 132.503036,1346.729980 
	C134.655487,1349.802734 136.957108,1352.750977 141.280182,1352.209839 
	C143.284622,1351.958740 143.942154,1350.408691 143.582352,1348.531372 
	C142.794083,1344.418457 139.886658,1342.526733 136.166092,1341.287720 
	C131.843887,1339.848267 124.870811,1340.455933 128.012741,1332.332520 
	C131.406738,1323.557251 140.014053,1319.099243 146.690445,1322.436523 
	C147.878235,1323.030273 148.864746,1324.000854 150.057144,1324.585693 
	C156.831665,1327.907959 160.956161,1325.220581 160.862457,1317.550781 
	C160.833694,1315.196411 160.150543,1312.947632 159.521942,1310.701660 
	C157.771103,1304.445312 160.297867,1301.777954 166.563980,1302.434937 
	C170.231491,1302.819580 173.873703,1302.952881 177.520569,1302.352295 
	C182.360931,1301.555176 185.961288,1303.392944 188.532272,1307.475952 
	C189.242554,1308.604004 189.912231,1309.758667 190.653091,1310.865601 
	C193.305740,1314.828857 196.108765,1318.690918 201.711975,1317.824707 
	C203.394409,1317.564453 204.872818,1316.352905 204.888336,1314.452515 
	C204.932480,1309.054565 201.240875,1306.153320 197.190857,1303.637451 
	C194.335861,1301.864014 190.901382,1301.418457 187.925644,1299.939697 
	C182.118591,1297.053711 179.544708,1289.614746 182.474243,1283.729126 
	C185.444809,1277.761108 190.445801,1277.407837 196.098312,1279.444336 
	C201.123505,1281.254761 205.912064,1283.586548 210.752792,1285.822388 
	C216.491852,1288.473145 220.021439,1287.360596 221.281845,1280.283569 
	C223.564682,1267.465942 232.667313,1264.089844 243.584534,1271.521484 
	C246.910172,1273.785400 248.969116,1277.550171 252.585709,1279.377075 
	C256.246887,1281.226440 259.856201,1280.542236 262.626678,1277.549194 
	C264.966034,1275.022095 264.666351,1272.024414 262.818970,1269.260498 
	C260.647522,1266.011719 257.658783,1265.657349 254.031708,1266.611572 
	C236.994583,1271.093750 236.113602,1270.029541 239.993515,1252.066895 
	C241.524292,1244.979980 243.372299,1238.394165 250.823135,1235.284790 
	C256.803802,1232.789185 261.918121,1233.161987 265.078247,1239.745483 
	C265.510651,1240.646362 265.947083,1241.547241 266.431030,1242.421875 
	C268.260620,1245.728271 270.255157,1248.817261 274.792603,1248.185547 
	C277.164093,1247.855469 278.276978,1246.178955 278.461670,1244.068848 
	C278.842377,1239.719360 277.399139,1235.031616 273.263672,1234.298950 
	C265.368530,1232.900391 261.075836,1226.943604 254.733459,1222.468018 
	C243.117905,1217.280884 241.436295,1218.025024 237.101547,1230.236694 
	C229.742676,1235.925293 223.444443,1243.114258 212.656342,1238.128174 
	C207.913666,1233.729492 203.343491,1230.572632 196.808823,1229.553711 
	C192.431442,1226.601685 188.324631,1224.546265 183.793121,1221.885254 
	C177.832321,1217.869141 172.477600,1218.326782 166.533524,1221.979736 
	C161.231201,1225.033691 158.062729,1229.401855 154.206741,1233.017822 
	C151.861557,1235.216919 149.019257,1236.668213 146.230194,1234.290039 
	C143.199707,1231.706055 143.385437,1227.856934 145.899597,1225.394287 
	C153.694305,1217.759155 158.489639,1208.933105 161.175064,1198.226318 
	C162.908203,1191.316284 171.609802,1189.981201 177.761658,1194.350098 
	C180.220551,1196.096191 181.860214,1198.667847 183.923340,1200.808594 
	C190.340164,1207.467041 196.715881,1205.973389 199.019424,1196.825928 
	C200.484894,1191.006470 202.188995,1187.607178 209.011398,1190.008911 
	C213.129730,1191.458740 213.131790,1187.696533 213.379898,1185.246826 
	C213.918060,1179.933228 217.083649,1176.098145 220.217163,1172.250488 
	C222.415771,1169.550903 225.289795,1167.466064 228.865341,1169.194702 
	C232.354034,1170.881348 231.310181,1174.173462 230.433960,1177.822266 
	C230.017120,1178.982056 229.815918,1179.430298 229.243408,1180.507324 
	C222.981033,1191.989380 224.050598,1194.126221 236.072571,1195.334351 
	C239.052078,1195.633789 242.658585,1195.262451 244.566391,1197.541992 
	C253.724503,1208.484131 268.435089,1209.963257 279.152283,1218.485596 
	C289.633240,1226.820068 295.578796,1224.150879 299.800140,1211.320190 
	C302.582703,1202.862549 311.484314,1199.787231 318.963531,1204.643188 
	C321.670776,1206.400879 323.305298,1209.857544 327.837769,1209.826904 
	C331.352539,1209.821045 334.110687,1210.284058 337.547272,1210.877197 
	C343.346161,1210.082031 343.146210,1206.167969 342.963318,1202.483887 
	C342.748230,1198.152222 341.766388,1193.687622 346.911011,1191.283325 
	C352.223358,1188.800659 355.702972,1192.138794 359.320801,1195.121094 
	C360.601440,1196.176880 361.893036,1197.225586 363.840637,1198.638672 
	C364.695862,1199.540649 364.992188,1199.946899 365.596802,1201.046631 
	C366.502899,1203.724731 366.412964,1205.739502 366.043884,1208.495117 
	C365.422699,1211.112793 364.689697,1212.908813 363.580261,1215.302124 
	C359.827515,1218.778687 358.094971,1221.947510 361.638947,1226.702637 
	C362.277527,1229.325806 362.182892,1231.237915 361.045105,1233.725830 
	C357.719116,1236.962402 353.798767,1236.538086 350.377197,1237.660767 
	C340.668518,1240.845947 336.229767,1246.479248 336.468018,1256.692017 
	C336.615906,1263.029785 334.948547,1267.642090 328.741913,1270.181519 
	C326.089111,1271.266968 322.354156,1272.950806 325.014252,1276.522583 
	C327.545471,1279.921143 331.282501,1278.431274 333.528168,1275.628052 
	C338.471008,1269.458252 345.207092,1267.172119 352.527039,1265.909424 
	C355.190765,1265.449829 357.825226,1265.725708 360.701660,1267.845215 
	C363.399658,1272.433838 362.713074,1276.745239 362.349365,1281.797607 
	C359.540070,1287.934692 358.686768,1293.307861 362.217834,1299.538818 
	C363.351288,1311.981567 362.608154,1323.642334 362.937805,1336.152832 
	C363.387512,1340.415649 363.042206,1343.817627 362.942535,1348.037842 
	C362.757904,1350.444946 362.593750,1352.024780 361.899048,1354.248291 
	C360.969635,1356.047363 360.148743,1357.047485 358.927246,1357.526978 
	C350.298248,1360.915161 352.825073,1363.772583 359.912354,1366.860840 
	C361.570618,1368.260864 362.362793,1369.470215 363.347229,1371.443359 
	C363.963867,1373.073486 364.212494,1374.037231 364.486633,1375.757324 
	C364.934357,1380.384399 364.293060,1384.342651 365.614288,1388.888184 
	C366.059082,1390.560547 366.231018,1391.534058 366.406403,1393.257568 
	C366.483612,1395.469727 366.263611,1396.906738 365.551056,1398.950195 
	C362.647736,1402.702759 357.932404,1405.611572 364.846863,1409.986816 
	C365.744537,1410.667969 366.084137,1410.971802 366.815796,1411.843628 
	C368.024811,1414.155273 368.137909,1415.974487 367.562500,1418.490234 
	C366.850830,1419.922485 366.178864,1420.463501 365.281982,1420.710693 
	C366.181519,1420.766724 367.055603,1420.951538 368.435425,1421.684326 
	C369.196228,1422.539917 369.432617,1422.941772 369.899170,1424.007568 
	C370.817566,1427.397827 370.454315,1430.301147 371.731262,1433.653076 
	C372.164978,1435.285767 372.348999,1436.236694 372.572235,1437.926270 
	C372.471405,1445.089111 374.849304,1451.177002 375.432068,1458.224609 
	C375.905029,1459.837280 376.098206,1460.772705 376.350800,1462.411377 
	C376.696228,1464.916260 376.668549,1466.767822 377.463501,1469.179077 
	C377.867065,1470.715210 378.040070,1471.604004 378.232178,1473.174194 
	C378.347107,1475.185547 378.202087,1476.504517 377.635132,1478.395630 
	C377.157440,1479.791870 375.926056,1479.645630 375.880005,1480.284546 
	C375.855042,1480.630981 376.909027,1480.894531 378.096130,1481.317017 
	C378.861786,1482.004272 379.106659,1482.344116 379.602356,1483.260010 
	C380.349823,1485.418335 380.599579,1487.064819 381.295654,1489.232178 
	C381.715668,1490.608765 381.910950,1491.406250 382.208649,1492.808838 
	C382.587708,1494.599365 382.814850,1495.796997 383.365845,1497.548584 
	C383.787933,1498.929443 383.990234,1499.732300 384.309875,1501.153320 
	C384.715149,1503.006958 385.011658,1504.239990 385.598236,1506.072754 
	C386.033600,1507.549438 386.233215,1508.411499 386.520447,1509.947632 
	C387.143463,1514.711304 388.249695,1518.660889 389.840485,1523.209229 
	C391.189636,1526.540161 392.060120,1529.282227 392.701904,1532.843506 
	C393.954163,1539.276489 395.237579,1544.953613 397.615479,1551.105103 
	C398.182892,1552.763916 398.439728,1553.736328 398.768127,1555.475952 
	C404.742462,1574.584839 410.429779,1592.994385 417.361206,1610.986694 
	C418.787537,1614.689209 420.425140,1618.398315 419.307434,1623.268555 
	C409.511230,1633.555420 403.393341,1645.199463 397.184753,1657.100342 
	C390.430359,1670.047485 384.491333,1683.411011 377.294678,1696.131714 
	C370.943390,1707.357788 366.934509,1719.989136 357.152222,1729.147095 
	C355.976532,1730.247925 355.346344,1732.054199 355.161072,1733.678589 
	C352.887421,1753.608887 339.906464,1768.017334 329.408783,1783.688599 
	C327.333313,1786.786865 325.190369,1789.867920 325.146423,1793.642334 
	C325.050842,1801.848633 322.791595,1809.362305 318.997803,1816.566406 
	C316.417419,1821.466309 316.456543,1825.193848 321.885620,1829.239502 
	C330.971344,1836.009644 328.888000,1843.980835 321.300720,1852.224976 
	C309.949554,1864.558838 294.961365,1875.636597 297.373932,1895.898193 
	C297.997925,1901.138916 294.143738,1903.651855 289.870514,1905.230347 
	C282.732635,1907.866943 280.058533,1912.965820 281.585144,1920.173340 
	C282.929626,1926.521362 281.029510,1931.255005 275.663239,1934.774536 
	C274.560425,1935.497803 273.211578,1936.462891 272.964172,1937.652466 
	C270.051117,1951.659546 259.952179,1962.731323 256.944672,1976.560669 
	C255.662796,1982.455200 253.816238,1987.085693 248.704041,1990.605957 
	C239.955109,1996.630615 240.264999,2001.169189 250.147583,2004.672729 
	C256.909515,2007.069946 259.709381,2011.322510 260.383728,2017.814697 
	C261.007477,2023.820190 260.079407,2029.147461 254.034210,2032.277954 
	C247.524628,2035.649170 247.525696,2040.612915 250.276733,2046.620239 
	C255.513672,2058.056152 255.137772,2058.591553 242.240112,2060.870605 
	C239.927567,2061.279541 237.565704,2061.483398 235.843826,2063.303223 
	C233.540329,2065.737793 232.887070,2068.608643 234.622284,2071.526855 
	C236.306503,2074.359375 238.985214,2074.132568 241.677979,2073.031006 
	C242.913406,2072.525635 244.042267,2071.797852 245.242645,2071.225586 
	C254.796661,2066.672119 255.857819,2067.139404 259.029266,2077.595947 
	C259.899200,2080.464355 260.223114,2083.667480 263.000061,2085.391846 
	C265.446747,2086.911377 268.414001,2087.188477 270.117706,2084.494385 
	C271.995331,2081.525391 268.962921,2080.580078 267.079926,2079.429932 
	C256.361023,2072.881836 253.053711,2067.602539 255.820984,2055.984375 
	C258.575470,2044.420166 261.795715,2032.612061 270.393463,2023.561523 
	C274.747498,2018.978516 277.351837,2013.927246 277.307678,2007.527222 
	C277.263641,2001.147095 280.096588,1996.579468 286.409058,1994.784668 
	C291.947662,1993.209961 295.131470,1990.361206 294.023865,1984.042480 
	C293.492371,1981.010742 294.342010,1978.012573 296.481445,1975.661011 
	C300.030334,1971.760620 304.310638,1968.698486 309.641357,1971.275635 
	C315.249695,1973.987061 315.687164,1979.741577 313.166901,1984.239136 
	C308.477051,1992.608643 306.519501,2002.388794 299.651520,2009.645752 
	C295.493134,2014.039551 292.851898,2019.520264 290.975220,2025.269897 
	C290.003204,2028.247803 290.180267,2031.276367 292.493530,2033.698120 
	C295.346649,2036.685059 297.942169,2034.333984 300.605591,2033.145996 
	C311.010223,2028.505615 315.358765,2031.131592 316.049377,2042.520142 
	C316.406982,2048.416992 314.523773,2053.768066 311.180359,2058.479980 
	C306.443176,2065.156250 300.313416,2065.619141 294.298828,2059.959717 
	C291.882507,2057.686279 290.060760,2054.774414 287.115753,2053.067139 
	C284.379883,2051.480957 281.214508,2050.404541 278.906677,2053.134277 
	C276.462372,2056.025635 278.503021,2058.766602 280.678162,2061.009521 
	C283.034393,2063.438965 286.055420,2064.915039 289.023590,2066.433105 
	C293.183563,2068.560791 297.693176,2070.404053 300.631317,2074.088135 
	C305.094269,2079.684326 309.494873,2082.937744 317.510742,2080.729492 
	C323.277832,2079.140625 328.342438,2086.579834 329.076782,2095.427734 
	C329.606750,2101.813232 325.243530,2103.329346 320.457367,2104.281006 
	C311.271515,2106.107178 305.973114,2103.707520 302.135193,2095.045166 
	C300.115021,2090.485352 296.963348,2089.346924 292.710083,2089.382324 
	C289.754944,2089.406982 287.559357,2090.760498 286.682800,2093.690674 
	C285.424988,2097.896240 287.806641,2100.682617 290.665283,2103.184814 
	C292.942444,2105.177979 295.492920,2106.902588 298.381134,2107.709229 
	C305.872528,2109.801270 311.465637,2113.959961 314.824524,2121.127441 
	C317.040894,2125.857178 320.901581,2126.927490 325.682007,2125.141357 
	C332.751251,2122.500000 337.999664,2124.723877 341.759583,2131.095703 
	C342.430420,2132.232422 341.499756,2130.870605 342.309082,2131.929199 
	C345.250732,2135.777588 348.531860,2139.137939 353.954987,2137.934082 
	C356.525543,2137.363525 357.944641,2135.164795 357.641998,2132.657959 
	C356.937012,2126.818115 353.704010,2121.984131 347.858093,2121.544189 
	C338.500061,2120.840576 334.792236,2115.284912 332.035828,2107.500244 
	C330.090851,2102.007080 331.154388,2098.394531 336.532227,2096.281738 
	C342.065033,2094.107910 345.894775,2090.778564 344.343658,2084.262695 
	C342.922546,2078.293213 338.052429,2077.025879 332.752350,2076.799805 
	C327.469604,2076.574219 322.868927,2075.577393 321.120789,2069.502930 
	C319.442139,2063.669922 319.595154,2058.713135 324.184753,2053.866699 
	C332.674957,2044.901001 332.838928,2042.246582 325.458405,2032.430786 
	C319.824829,2024.938354 319.095276,2016.588623 319.213928,2007.796875 
	C319.295074,2001.782837 320.165894,1995.835938 320.713867,1989.878662 
	C321.449005,1981.887207 328.636688,1981.745972 334.286621,1980.791504 
	C339.608582,1979.892456 343.654968,1982.716064 343.979187,1988.351318 
	C344.324280,1994.349121 348.214935,1996.892944 352.528351,1999.645386 
	C355.320648,2001.427124 358.461273,2003.927124 355.992584,2007.705078 
	C354.011536,2010.736816 350.730835,2009.390503 347.772858,2008.567993 
	C344.046722,2007.531738 340.356750,2001.541992 336.507355,2006.900757 
	C333.131042,2011.600952 335.038910,2017.176514 337.484070,2022.108398 
	C338.690948,2024.542725 340.479492,2027.398926 342.984314,2027.602417 
	C354.239960,2028.516968 362.577728,2036.865723 373.139709,2039.029053 
	C379.292297,2040.289185 383.649811,2042.757080 386.016846,2048.586182 
	C386.893036,2050.743896 387.817657,2052.916260 389.349976,2054.712646 
	C393.175110,2059.196777 401.563873,2060.586182 405.676300,2057.052490 
	C410.972321,2052.501709 408.935974,2047.587769 405.651184,2042.867676 
	C404.890717,2041.774902 403.912170,2040.836304 403.184937,2039.721680 
	C398.391785,2032.374512 400.005737,2028.780273 408.678741,2028.045044 
	C412.739929,2027.700806 417.567200,2028.262695 417.149017,2022.393921 
	C416.722229,2016.403931 412.386047,2014.857300 406.999451,2016.076904 
	C402.339569,2017.131836 397.532715,2018.758423 395.511108,2012.283081 
	C393.612823,2006.203003 391.267426,1999.631348 396.584137,1994.397095 
	C401.117279,1989.934204 406.997986,1990.712646 412.450043,1993.351196 
	C414.880341,1994.527466 416.472473,1996.814819 418.418365,1998.626343 
	C422.691559,2002.604492 427.331757,2002.811035 432.127411,1999.787109 
	C436.710785,1996.896851 440.011261,1992.792480 437.925354,1987.280029 
	C434.649841,1978.623413 437.301941,1974.172974 446.097198,1972.116821 
	C449.844421,1971.240845 451.231659,1967.119629 453.429718,1964.227539 
	C456.052063,1960.776855 458.130219,1956.936646 460.942169,1953.631470 
	C463.275238,1950.889282 466.250763,1949.536255 469.847076,1950.614990 
	C473.788391,1951.797241 474.250183,1955.243774 474.547577,1958.625000 
	C475.005280,1963.828735 473.682953,1968.505005 470.298615,1972.586304 
	C468.165894,1975.158203 466.186523,1977.876831 465.588470,1981.281982 
	C464.984344,1984.722046 465.208252,1988.135132 468.214203,1990.376343 
	C471.866791,1993.099854 474.347107,1990.038086 476.897491,1988.021851 
	C478.201813,1986.990723 479.291321,1985.694702 480.599426,1984.666138 
	C483.195404,1982.625122 485.809784,1979.852295 489.446106,1981.725342 
	C492.485687,1983.290894 492.726868,1986.714722 492.602753,1989.666626 
	C492.277435,1997.404053 494.339874,2003.918335 500.038452,2009.525269 
	C504.381744,2013.798584 506.380371,2019.458618 502.113953,2024.824707 
	C497.881226,2030.148682 493.186646,2026.819946 488.811066,2024.227539 
	C482.846008,2020.693481 477.828674,2021.336914 475.002655,2028.182251 
	C473.045349,2032.923340 469.914917,2035.874390 464.943451,2036.918091 
	C460.505371,2037.849854 458.858521,2041.749756 456.362274,2044.807495 
	C454.560242,2047.015381 452.125488,2048.139893 449.262878,2046.839233 
	C446.604279,2045.631348 447.042175,2043.199829 446.958496,2040.826538 
	C446.608856,2030.910889 445.477570,2021.005737 455.691040,2014.324219 
	C458.359222,2012.578857 459.297241,2008.538696 456.431061,2005.427124 
	C454.307281,2003.121826 451.380096,2001.681396 448.321350,2002.601440 
	C444.086273,2003.875244 444.572418,2007.950195 445.045868,2011.028198 
	C446.245789,2018.828491 445.724792,2024.957153 437.536713,2029.481934 
	C431.796570,2032.654053 433.755981,2037.914185 438.302612,2041.818115 
	C441.082123,2044.204834 444.483551,2046.453613 442.235443,2050.895996 
	C440.211456,2054.895508 436.486053,2056.091309 432.264435,2056.432861 
	C418.783081,2057.524658 418.657196,2057.529053 415.311096,2070.428223 
	C413.821381,2076.170654 411.229828,2080.847412 406.179565,2084.193115 
	C402.138947,2086.870117 400.428284,2090.680908 402.503784,2095.431396 
	C404.638947,2100.318115 408.221130,2102.808594 413.681763,2101.079346 
	C420.373749,2098.960449 424.476959,2101.696533 427.342529,2107.631836 
	C429.151245,2111.378174 431.842346,2114.600586 436.576721,2113.854492 
	C441.507141,2113.077148 442.453766,2108.794434 442.987457,2104.812500 
	C443.828400,2098.537598 446.782043,2094.185547 453.015015,2092.537598 
	C458.054596,2091.204834 460.409851,2087.869629 462.244049,2083.104736 
	C466.302185,2072.562744 475.221039,2068.559570 485.638733,2073.196289 
	C499.301849,2079.277588 512.511475,2086.379395 525.117493,2094.504883 
	C527.438965,2096.001221 529.621155,2097.908203 528.581299,2100.982910 
	C527.341614,2104.648682 523.586975,2106.758057 520.656982,2105.494141 
	C510.363251,2101.053955 498.005432,2102.989258 488.935699,2095.011230 
	C486.680847,2093.027832 484.156830,2091.352539 481.267365,2090.397217 
	C477.835175,2089.262207 474.623596,2089.754395 472.002747,2092.334229 
	C469.126556,2095.164795 469.996185,2098.260498 471.415833,2101.536865 
	C476.371490,2112.973877 475.521454,2114.368164 462.875366,2116.631836 
	C458.103485,2117.485840 451.959442,2117.050781 452.739075,2124.571533 
	C453.265289,2129.647705 459.943542,2131.985107 466.769470,2129.912109 
	C468.688690,2129.329346 470.415771,2128.276367 472.264923,2127.517334 
	C477.866638,2125.217529 481.246399,2127.081055 482.532135,2132.962158 
	C483.169861,2135.879150 483.498779,2138.914551 485.340302,2141.429932 
	C487.062347,2143.782227 489.416656,2144.802002 492.296173,2144.470215 
	C495.595490,2144.090088 497.138000,2141.610107 496.869080,2138.870361 
	C495.319916,2123.088135 509.915955,2121.194824 518.276917,2114.263184 
	C522.661804,2110.627930 525.809570,2114.054443 525.567810,2119.261719 
	C525.271179,2125.652100 523.526611,2131.729004 520.238220,2137.310059 
	C518.034241,2141.051025 515.460144,2144.535156 513.025024,2148.117188 
	C511.067780,2150.996094 509.678131,2154.033447 512.167664,2157.300293 
	C513.912292,2159.589600 516.400208,2160.620850 519.214111,2160.266357 
	C523.273743,2159.755615 524.481812,2156.675049 525.015991,2153.167480 
	C525.514587,2149.893066 524.928894,2144.848145 527.689087,2143.921387 
	C540.049561,2139.771240 542.300415,2131.119873 543.071777,2119.248535 
	C543.509033,2112.518555 552.250549,2109.046875 559.423523,2108.322266 
	C565.846497,2107.673584 567.252930,2113.389160 568.890137,2118.145264 
	C569.914429,2121.120850 571.780396,2123.330811 574.472900,2124.930176 
	C579.902222,2128.155029 583.924255,2127.889404 585.500305,2120.782959 
	C586.293091,2117.208008 586.973389,2113.571289 588.453674,2110.202881 
	C593.099365,2099.631348 604.272156,2097.133789 612.851318,2104.689209 
	C613.350342,2105.128662 613.765869,2105.661133 614.255432,2106.111816 
	C616.990601,2108.629395 619.750916,2111.341309 623.869202,2109.107910 
	C625.396729,2108.279541 626.078613,2106.649658 625.760498,2104.822754 
	C624.965881,2100.258789 621.458008,2099.519043 617.662476,2098.855225 
	C605.238647,2096.681885 599.644287,2080.218018 607.793518,2070.031250 
	C615.451233,2060.458740 615.630371,2060.281006 606.996399,2051.571045 
	C601.065491,2045.587646 600.693604,2039.427490 604.922791,2032.636353 
	C609.457825,2025.354126 614.136169,2025.262573 619.164917,2032.268555 
	C620.133484,2033.617920 620.847473,2035.170654 622.200073,2036.197388 
	C624.211731,2037.724365 626.424133,2038.719116 628.216614,2036.092529 
	C629.838257,2033.716431 629.016724,2030.889282 626.635315,2030.225220 
	C612.583679,2026.307129 611.090271,2008.407471 596.968506,2004.129761 
	C592.960815,2002.915649 590.433533,1996.749268 594.959045,1992.380005 
	C599.076660,1988.404785 602.937683,1991.059570 606.046997,1994.618286 
	C608.991577,1997.988892 612.089783,2001.781250 616.882324,1998.236572 
	C621.859436,1994.555176 621.823914,1989.087646 620.065735,1983.692627 
	C616.922729,1974.048462 616.839111,1974.020630 627.039001,1972.624390 
	C633.311218,1971.765747 636.676941,1968.502563 636.394958,1961.977905 
	C636.294556,1959.653320 635.898438,1957.322998 637.059082,1954.361938 
	C644.947632,1951.114990 647.500061,1957.141357 651.299683,1962.203247 
	C652.615967,1966.215698 651.749023,1969.396240 650.882080,1972.591553 
	C649.840759,1976.429443 648.376465,1980.562500 652.451416,1983.427856 
	C656.449890,1986.239502 660.594360,1985.168945 664.455933,1982.654053 
	C665.284058,1982.114868 666.122864,1981.592896 667.650391,1980.822998 
	C671.593445,1980.018677 674.153992,1981.312256 676.649170,1984.320068 
	C677.190491,1985.589111 677.367554,1986.227173 677.349731,1986.870483 
	C676.908264,2002.775513 677.731445,2003.492310 693.442261,2000.249512 
	C707.229919,2007.443359 719.332458,2015.850586 729.456482,2027.829956 
	C729.582397,2034.898560 727.161377,2040.359741 722.477234,2044.447876 
	C717.419617,2048.861816 715.335083,2053.801758 717.235901,2060.391357 
	C718.818298,2065.876953 716.162842,2068.835449 711.263184,2071.294434 
	C701.382507,2076.253174 699.755249,2079.779785 702.611633,2090.525879 
	C704.415771,2097.314209 703.313232,2101.338379 695.930664,2103.102295 
	C689.916565,2104.539307 681.276978,2103.472656 678.910339,2109.679688 
	C675.047668,2119.810303 667.692078,2129.058594 668.013916,2140.369385 
	C668.219727,2147.604980 666.336304,2152.522949 660.068604,2156.069580 
	C656.496399,2158.091064 653.907349,2161.238281 653.386841,2165.541016 
	C652.769409,2170.644531 654.148132,2174.428223 660.281677,2173.579102 
	C668.171753,2172.486816 674.652649,2173.991943 679.273560,2181.247314 
	C681.182251,2184.244385 684.690979,2185.057861 688.228149,2183.774170 
	C692.102722,2182.367676 693.937195,2179.396729 694.179016,2175.365723 
	C694.395020,2171.765625 693.052063,2167.930908 695.339539,2164.636963 
	C698.725098,2159.761963 709.915161,2161.869629 717.810669,2168.771484 
	C723.680359,2173.902588 725.724548,2182.653076 721.804810,2186.430420 
	C719.573425,2188.580811 716.330688,2188.761475 713.639832,2190.040771 
	C710.874817,2191.355225 708.130188,2192.886475 708.524536,2196.572754 
	C708.767334,2198.842041 710.629211,2199.907959 712.656067,2200.359131 
	C715.765747,2201.051514 720.063782,2200.793457 720.530273,2197.877197 
	C722.586975,2185.020996 734.409851,2177.744873 737.962219,2165.901855 
	C738.631287,2163.670898 739.179504,2161.336670 740.486145,2159.397705 
	C743.984009,2154.208984 749.187073,2151.456299 755.068237,2153.210938 
	C761.565796,2155.149170 759.758362,2161.009277 759.056824,2165.937744 
	C758.342773,2170.953613 756.154236,2175.473389 754.379578,2180.138672 
	C751.521423,2187.652344 753.482483,2195.731934 763.595886,2195.362793 
	C768.628418,2195.179199 772.594971,2197.794678 775.228210,2202.004883 
	C778.849792,2207.795654 784.140808,2209.548340 790.598877,2209.238525 
	C796.643677,2208.947998 801.756226,2210.671387 804.902466,2216.400146 
	C806.885315,2220.010254 810.338684,2221.114502 814.202759,2221.184326 
	C822.677612,2221.337891 828.863159,2224.874512 832.231689,2232.932861 
	C833.765381,2236.602051 836.403748,2239.008057 840.746094,2238.372559 
	C843.815308,2237.923340 845.251770,2235.689697 845.833496,2232.914307 
	C846.710999,2228.728027 844.575684,2225.999756 841.287720,2223.750488 
	C826.136902,2213.386475 826.152344,2213.363770 837.126038,2197.893799 
	C842.009155,2191.009766 839.567139,2183.136719 831.591553,2180.150879 
	C828.131165,2178.855469 824.244202,2179.281006 820.869873,2177.856934 
	C814.076111,2174.989746 812.883545,2168.960449 814.317749,2162.839355 
	C815.898926,2156.090820 821.417480,2155.790039 827.137024,2157.304932 
	C831.749268,2158.526367 835.441162,2161.366699 839.254822,2164.094238 
	C847.512573,2169.999756 851.724731,2168.058105 853.044189,2157.757080 
	C853.678955,2152.801514 853.469238,2147.718018 858.468323,2144.513916 
	C864.457397,2140.675049 872.319092,2140.943115 875.837463,2145.333984 
	C880.469360,2151.113770 880.307861,2163.095947 875.179138,2167.119141 
	C871.455872,2170.039551 867.595886,2172.589844 866.767517,2177.728271 
	C865.805725,2183.693848 868.419067,2186.297363 873.940735,2184.270996 
	C879.839966,2182.106689 884.837463,2179.091309 883.090454,2171.162109 
	C881.915833,2165.830566 885.198608,2163.786133 890.002991,2164.092285 
	C903.469116,2164.951172 913.712158,2172.782227 922.585510,2181.572998 
	C927.966248,2186.903564 927.528503,2194.730713 923.032959,2201.958008 
	C917.589783,2210.708984 920.495789,2216.041016 930.885864,2215.829346 
	C938.233643,2215.679688 941.633728,2218.423584 943.963440,2225.103516 
	C946.627869,2232.742920 952.054321,2234.305176 957.794434,2230.139404 
	C960.320618,2228.306152 962.331726,2226.007812 961.876953,2222.645752 
	C961.391663,2219.057861 958.485840,2218.018311 955.453308,2217.314697 
	C954.478577,2217.088867 953.472900,2217.055420 952.483704,2216.920410 
	C939.230347,2215.112549 936.070496,2209.242920 942.640381,2197.500732 
	C946.394958,2190.790771 949.815674,2184.131348 952.043091,2176.672363 
	C954.337769,2168.988281 961.298279,2166.499756 968.604248,2166.224365 
	C973.385925,2166.043945 976.393555,2169.528809 978.306763,2173.721924 
	C980.262268,2178.007324 978.735657,2181.472656 975.583252,2184.492676 
	C972.474548,2187.470459 968.694397,2189.835449 966.821228,2193.944580 
	C965.665649,2196.479492 965.085205,2199.164307 967.125061,2201.444824 
	C969.072876,2203.622314 971.729126,2204.020264 974.481140,2203.109375 
	C977.428711,2202.134521 978.472046,2199.818604 978.570312,2196.913086 
	C978.615540,2195.574951 978.503784,2194.246582 978.302368,2192.930176 
	C977.478333,2187.546143 978.125610,2182.745361 984.040894,2180.647705 
	C990.239685,2178.449951 996.463257,2178.793213 999.970093,2184.900635 
	C1004.803406,2193.318115 1011.809814,2195.819092 1020.863464,2195.390625 
	C1025.838013,2195.155273 1030.039307,2197.072998 1032.026611,2202.150391 
	C1033.589844,2206.144775 1035.505615,2209.779785 1040.723755,2207.745361 
	C1045.976318,2205.697754 1047.496582,2201.433350 1045.919312,2196.337646 
	C1043.958252,2190.002197 1042.403687,2183.967529 1049.589966,2178.837891 
	C1059.101685,2176.655029 1066.988037,2180.356934 1075.722412,2183.140625 
	C1083.918823,2193.953369 1083.918823,2193.953369 1097.258911,2188.217285 
	C1114.481567,2188.895020 1130.557129,2192.435059 1147.410645,2195.676270 
	C1151.958740,2197.230713 1154.228149,2204.823730 1160.545654,2198.573242 
	C1164.037842,2197.280518 1166.926025,2197.257324 1170.520264,2198.239746 
	C1174.342651,2200.219482 1175.401978,2203.456787 1176.946777,2206.358154 
	C1178.303589,2208.906250 1178.800171,2212.720703 1182.335571,2212.834229 
	C1186.680420,2212.973633 1186.636597,2208.525879 1188.081543,2205.757568 
	C1188.701904,2204.568604 1189.379395,2203.462646 1191.090698,2202.226318 
	C1202.459473,2200.211670 1213.057617,2200.011719 1224.192871,2203.822754 
	C1232.119873,2213.589355 1237.785522,2223.452637 1235.625610,2236.102783 
	C1234.429688,2243.106201 1237.158936,2246.615479 1244.922119,2246.484375 
	C1254.757202,2246.317627 1256.216675,2248.541260 1254.895508,2258.658447 
	C1253.962891,2265.800049 1254.376465,2272.945312 1249.535034,2279.495117 
	C1245.301392,2285.222412 1250.102539,2288.423340 1255.436523,2290.222656 
	C1259.422119,2291.567383 1264.802979,2290.583740 1266.941650,2295.104980 
	C1269.644165,2300.817627 1270.383179,2307.242432 1271.068726,2313.497559 
	C1271.477417,2317.226807 1268.203369,2319.234863 1265.672363,2321.406250 
	C1263.637817,2323.151611 1261.437378,2324.940430 1262.445679,2328.094971 
	C1262.890259,2329.485352 1264.214233,2330.128174 1265.625488,2329.906494 
	C1269.414185,2329.311523 1270.249634,2326.391846 1270.254639,2323.244141 
	C1270.264160,2317.104736 1273.678467,2313.452148 1278.701172,2310.743896 
	C1287.549072,2305.973145 1291.585815,2307.312500 1295.755737,2316.429932 
	C1297.815430,2320.933105 1299.344360,2326.423340 1305.839600,2325.739746 
	C1312.700806,2325.017334 1313.638428,2319.649414 1314.128906,2313.995605 
	C1314.718750,2307.198730 1318.533203,2302.306152 1324.063477,2298.584717 
	C1328.174805,2295.818115 1331.125610,2292.575928 1329.575562,2286.973389 
	C1327.924805,2281.006836 1323.291016,2280.711670 1318.496582,2280.851807 
	C1311.699463,2281.050293 1306.057861,2279.381104 1302.504639,2272.934082 
	C1300.002319,2268.394043 1295.561279,2267.067383 1290.677002,2266.666748 
	C1286.443115,2266.319824 1282.735107,2265.022949 1281.938599,2260.075684 
	C1281.195557,2255.461914 1282.252563,2251.420410 1286.218262,2248.583984 
	C1290.112915,2245.798584 1294.503418,2245.068359 1298.254517,2248.228271 
	C1303.548340,2252.687256 1309.417847,2255.053955 1316.180298,2256.214355 
	C1321.026245,2257.045898 1324.089111,2261.069336 1326.603882,2265.033936 
	C1330.120239,2270.577881 1334.746216,2273.460205 1341.471802,2273.301270 
	C1346.617065,2273.179199 1351.741943,2274.059082 1353.665283,2279.912842 
	C1355.546509,2285.637939 1353.582886,2290.336670 1349.046509,2294.130127 
	C1346.741821,2296.057373 1343.969360,2298.022217 1343.367432,2300.952148 
	C1341.103149,2311.975830 1337.278076,2321.779785 1327.679810,2328.831055 
	C1324.396240,2331.243408 1325.632690,2335.616699 1327.836548,2338.891113 
	C1330.396851,2342.695312 1333.946899,2342.337158 1337.602173,2340.738037 
	C1341.813843,2338.895752 1344.482178,2335.623291 1346.116333,2331.399414 
	C1347.317261,2328.294922 1348.342651,2325.095947 1350.236816,2322.315430 
	C1354.985962,2315.343750 1359.672974,2314.788818 1365.317749,2321.178467 
	C1369.822510,2326.277588 1375.074219,2329.140869 1381.808594,2329.186523 
	C1388.972534,2329.235107 1393.887451,2332.406006 1396.280762,2339.225830 
	C1397.965698,2344.027100 1400.778564,2346.564453 1406.121216,2344.467041 
	C1409.748779,2343.042725 1412.986694,2341.202881 1411.989136,2336.544922 
	C1410.767700,2330.841797 1406.753052,2329.731445 1401.415649,2329.977295 
	C1389.313721,2330.535156 1387.449829,2328.740234 1386.413086,2317.054443 
	C1385.681641,2308.812256 1390.280518,2303.473877 1398.947388,2302.189941 
	C1404.729614,2301.333252 1408.675049,2303.885010 1411.319458,2308.636230 
	C1414.290405,2313.974365 1418.513550,2317.083008 1424.631470,2317.989502 
	C1430.579834,2318.870850 1435.001343,2322.239258 1437.999878,2327.492432 
	C1441.312500,2333.296143 1445.993042,2335.001709 1452.355957,2332.505615 
	C1457.072266,2330.655029 1462.032959,2328.807617 1465.413452,2334.924561 
	C1468.907104,2341.246582 1468.338623,2351.309326 1464.099365,2355.504395 
	C1461.724487,2357.854248 1458.753052,2359.470459 1456.181641,2361.593262 
	C1452.521118,2364.615479 1450.385620,2368.428955 1452.193237,2373.022705 
	C1455.551025,2381.555908 1452.273193,2386.147705 1444.253174,2389.060059 
	C1440.478271,2390.430664 1435.125000,2391.391357 1436.707764,2397.612305 
	C1437.531250,2400.848389 1440.054199,2402.600830 1443.478149,2402.351562 
	C1448.867920,2401.959961 1452.499268,2398.895996 1452.710205,2393.607422 
	C1453.029907,2385.591064 1455.731201,2379.570801 1463.093506,2375.717041 
	C1466.311279,2374.032471 1467.042603,2370.436035 1467.095459,2367.012695 
	C1467.206421,2359.815918 1469.733765,2353.860107 1476.146851,2350.288086 
	C1481.490967,2347.311279 1483.450684,2342.980713 1483.276733,2337.119629 
	C1483.105835,2331.359375 1484.711548,2326.666016 1491.126587,2324.846436 
	C1495.600708,2323.577393 1500.715454,2322.303955 1499.143433,2315.696777 
	C1497.683960,2309.562256 1494.402588,2305.942871 1487.291382,2306.005859 
	C1477.015137,2306.096924 1473.751831,2302.811279 1473.394531,2293.555176 
	C1473.177002,2287.920166 1474.023438,2282.589600 1480.293701,2280.587646 
	C1486.663452,2278.553955 1493.170410,2278.175781 1497.134399,2284.889893 
	C1500.577637,2290.721924 1504.732910,2293.788818 1511.775391,2292.373047 
	C1517.062988,2291.310059 1520.650024,2294.106934 1523.201172,2298.560791 
	C1524.854980,2301.447754 1526.112183,2304.568604 1528.205078,2307.198242 
	C1530.791870,2310.448975 1534.122803,2311.450684 1537.994507,2310.041504 
	C1540.813721,2309.015869 1542.116943,2306.680908 1542.022949,2303.765137 
	C1541.889648,2299.630615 1539.612183,2296.976562 1535.752563,2295.664062 
	C1533.188599,2294.791992 1530.494507,2294.870605 1527.837158,2294.745361 
	C1522.122803,2294.475830 1517.075806,2293.094971 1515.864868,2286.500488 
	C1514.852051,2280.985596 1515.356812,2275.673828 1520.601562,2272.280029 
	C1526.167725,2268.678467 1532.853516,2267.839355 1537.229126,2272.690430 
	C1543.379028,2279.509033 1549.841187,2283.335938 1559.171143,2284.275391 
	C1566.530884,2285.016846 1568.087158,2292.569580 1569.341797,2298.784180 
	C1570.538818,2304.714355 1565.895264,2306.809814 1561.510376,2308.757324 
	C1560.901489,2309.027832 1560.255493,2309.229736 1559.678345,2309.555908 
	C1555.513672,2311.909912 1549.048828,2313.079590 1550.870361,2319.663818 
	C1552.668457,2326.163574 1558.562012,2327.029297 1564.702148,2326.717529 
	C1575.204712,2326.183594 1579.517822,2330.683105 1579.400879,2341.538086 
	C1579.329956,2348.122070 1571.749146,2354.381836 1564.063843,2354.086670 
	C1560.147949,2353.936035 1556.997437,2352.457764 1555.382935,2348.538818 
	C1554.369263,2346.077637 1553.300293,2343.590088 1551.140137,2341.858154 
	C1548.365234,2339.633301 1545.157104,2338.393799 1541.900391,2340.269287 
	C1538.324097,2342.329102 1538.949707,2345.936768 1539.873047,2349.195312 
	C1540.918213,2352.884277 1543.807129,2355.418213 1547.359741,2354.016846 
	C1558.080566,2349.787109 1562.630981,2354.911133 1565.458008,2364.354004 
	C1567.016602,2369.560303 1571.008545,2371.647949 1576.474731,2370.011230 
	C1581.549561,2368.491699 1584.770996,2365.718994 1583.194458,2359.800049 
	C1581.741821,2354.345947 1581.317993,2348.953125 1586.904785,2345.555176 
	C1592.489136,2342.158203 1598.401855,2342.860840 1604.133423,2345.549072 
	C1606.559082,2346.686768 1608.494019,2348.615234 1610.811157,2349.932129 
	C1613.634888,2351.537109 1616.643555,2352.487061 1618.482910,2348.822754 
	C1620.373169,2345.057617 1617.924316,2343.317871 1614.631470,2342.402100 
	C1609.655396,2341.018066 1605.302856,2338.650879 1602.567017,2334.125244 
	C1599.348267,2328.801025 1598.331665,2323.280029 1603.885864,2318.900879 
	C1609.310059,2314.624512 1614.947388,2314.758301 1620.024170,2319.875244 
	C1622.388184,2322.258301 1624.055420,2325.170898 1625.950195,2327.907715 
	C1627.513550,2330.166260 1629.407227,2332.603516 1632.246826,2332.242188 
	C1641.290771,2331.091797 1648.487061,2334.389648 1654.915771,2340.367676 
	C1656.990845,2342.297363 1659.646851,2342.959473 1662.258179,2341.202881 
	C1664.794312,2339.497070 1664.982178,2336.781250 1664.857178,2334.061035 
	C1664.687866,2330.373779 1662.848633,2328.558105 1659.031738,2329.125244 
	C1657.056519,2329.418945 1655.097900,2329.935059 1653.086792,2329.831055 
	C1646.205933,2329.475586 1637.402710,2322.230225 1636.350586,2316.029297 
	C1635.403687,2310.449219 1638.466553,2307.384766 1643.103638,2305.160400 
	C1653.201904,2300.316406 1658.924438,2300.890869 1664.639160,2307.434082 
	C1666.664673,2309.753418 1667.700684,2313.603760 1672.568481,2312.561035 
	C1672.443237,2308.282471 1668.586304,2307.672852 1666.229004,2305.868652 
	C1655.219116,2297.441895 1653.593628,2285.628906 1662.068726,2274.883057 
	C1668.712769,2266.458740 1667.814697,2263.007812 1657.322632,2260.781250 
	C1648.642944,2258.939453 1646.360718,2252.995117 1645.551514,2245.623535 
	C1644.776123,2238.559570 1646.745361,2233.025879 1654.595093,2231.308838 
	C1659.492065,2230.237793 1661.326050,2227.339600 1659.685669,2222.522949 
	C1658.436890,2218.856445 1656.674072,2215.575684 1651.947144,2216.450928 
	C1647.481567,2217.277832 1642.997314,2218.723877 1643.836670,2224.523438 
	C1645.062256,2232.990723 1642.091309,2238.143799 1633.460327,2239.536865 
	C1629.905273,2240.110596 1626.885132,2238.990479 1624.579712,2236.151855 
	C1622.151733,2233.162354 1622.497559,2230.007568 1624.041992,2226.787109 
	C1625.208740,2224.354248 1627.069214,2222.419678 1628.656982,2220.283447 
	C1635.084595,2211.635010 1632.267456,2202.584717 1622.114014,2199.068604 
	C1607.851685,2194.129395 1605.694824,2187.160645 1614.612305,2174.737793 
	C1615.970581,2172.845459 1617.639771,2171.163818 1618.697144,2169.069336 
	C1622.387573,2161.760742 1619.744507,2156.834717 1611.583374,2156.332520 
	C1606.285400,2156.006348 1601.425049,2155.561523 1600.482666,2148.194824 
	C1603.457275,2140.767822 1609.295532,2139.914062 1616.272583,2139.959961 
	C1622.314697,2144.052490 1627.689575,2146.044922 1634.450073,2143.149170 
	C1640.838989,2140.412354 1645.172729,2143.924072 1648.107544,2149.517334 
	C1650.296631,2153.689697 1652.439087,2158.037842 1658.238892,2157.329102 
	C1660.534180,2157.048584 1661.469971,2155.144531 1661.169800,2152.910645 
	C1660.352783,2146.831543 1655.925781,2145.149902 1650.690308,2144.204346 
	C1643.338013,2142.876465 1638.070801,2139.712646 1640.695435,2130.148438 
	C1645.856812,2124.383301 1651.578369,2121.069336 1659.488770,2120.999023 
	C1664.860474,2128.993652 1670.352173,2134.758301 1680.739990,2133.648438 
	C1686.262329,2133.058594 1689.931030,2137.084229 1691.523071,2142.370117 
	C1693.399170,2148.598633 1692.915161,2154.846436 1687.172241,2158.516602 
	C1679.946777,2163.134277 1676.200073,2168.435059 1677.855469,2177.396729 
	C1678.717163,2182.061279 1675.388184,2185.441895 1671.351440,2187.735840 
	C1668.755615,2189.210938 1665.651611,2189.927979 1663.593750,2192.181641 
	C1660.258667,2195.834229 1659.629639,2200.507080 1662.848999,2203.967285 
	C1666.659058,2208.062500 1670.058105,2204.243896 1672.873047,2201.503174 
	C1675.602905,2198.845215 1676.437012,2195.270996 1677.140991,2191.595215 
	C1679.740479,2178.022461 1691.476440,2173.213623 1703.209351,2180.756836 
	C1705.903442,2182.489014 1708.973633,2187.024658 1711.506714,2184.749512 
	C1715.024048,2181.590088 1710.486816,2180.200928 1707.941406,2179.067627 
	C1706.734619,2178.530273 1705.374756,2178.369629 1704.115356,2177.933350 
	C1696.791992,2175.397461 1694.504883,2169.044922 1693.001709,2162.482910 
	C1691.524780,2156.035400 1696.181030,2152.655273 1700.912476,2150.025879 
	C1706.417725,2146.967041 1708.505737,2142.425537 1709.609863,2136.411377 
	C1712.435791,2121.020264 1723.345703,2117.313965 1735.468994,2127.234619 
	C1736.753784,2128.285889 1737.863159,2129.572754 1739.440063,2130.206543 
	C1741.050537,2130.853760 1742.800659,2131.254395 1743.530884,2129.124756 
	C1744.015137,2127.712158 1743.036255,2126.650146 1741.782837,2125.939941 
	C1739.726929,2124.774902 1737.326172,2124.570557 1735.213257,2123.596191 
	C1727.098755,2119.853271 1722.911621,2108.747314 1726.520020,2100.647705 
	C1729.765381,2093.363770 1739.767456,2091.246826 1745.979248,2096.548828 
	C1747.517090,2097.861328 1748.529419,2099.600586 1749.638062,2101.264404 
	C1751.810791,2104.525391 1753.489380,2108.797119 1758.786865,2106.580078 
	C1761.018066,2105.646484 1763.214233,2104.011475 1762.908447,2101.472168 
	C1762.328613,2096.658691 1757.796143,2096.959229 1754.467041,2095.989502 
	C1742.664062,2092.551514 1741.678467,2091.349609 1741.920410,2078.789551 
	C1747.054321,2071.080322 1754.100952,2067.223633 1762.750488,2064.753906 
	C1765.872192,2065.726562 1767.043823,2067.700684 1768.010986,2069.859863 
	C1769.951660,2074.192627 1772.338989,2079.666992 1777.795776,2077.387207 
	C1783.970215,2074.807861 1780.068848,2069.528076 1778.369629,2065.451660 
	C1777.213135,2062.676758 1775.793213,2060.045654 1776.722046,2056.206055 
	C1778.851318,2052.276855 1781.649048,2050.434570 1786.105957,2050.032227 
	C1793.525635,2052.092041 1796.964722,2049.273682 1798.069702,2041.975708 
	C1804.030640,2032.280273 1814.204468,2028.737549 1822.058960,2022.309570 
	C1828.345703,2017.164795 1833.838379,2010.568115 1843.034180,2008.638916 
	C1854.178711,2011.650635 1854.178711,2011.650635 1855.949463,1998.440674 
	C1858.130127,1992.404297 1863.226074,1990.268921 1867.918945,1986.755615 
	C1870.389404,1985.499390 1872.774536,1985.268921 1873.739746,1982.172852 
	C1874.191650,1981.182373 1874.391113,1980.792480 1874.969849,1979.861694 
	C1878.674561,1976.478394 1882.182495,1973.815430 1884.954224,1969.470459 
	C1887.760742,1966.641968 1890.142944,1964.358765 1893.930298,1962.789551 
	C1895.645630,1962.505859 1896.623535,1962.641602 1898.224365,1963.363281 
	C1899.513062,1964.563599 1900.012695,1965.440796 1900.558350,1967.128662 
	C1903.720215,1976.371582 1902.763184,1983.514893 1894.114624,1988.383423 
	C1890.709717,1990.300049 1889.222168,1993.698120 1888.949951,1997.597412 
	C1888.810791,1999.589600 1889.270630,2001.908691 1888.334473,2003.516113 
	C1881.029785,2016.058838 1872.172852,2027.539551 1865.687134,2040.773438 
	C1862.163940,2047.962524 1850.628784,2045.165405 1845.816650,2037.595093 
	C1844.390381,2035.351074 1843.429810,2032.814697 1841.681885,2030.771606 
	C1838.774048,2027.372437 1835.206909,2028.032227 1831.593384,2029.250977 
	C1829.022827,2030.117920 1827.770020,2031.909668 1828.345825,2034.618774 
	C1829.153931,2038.421631 1830.907593,2041.486938 1835.166992,2042.249634 
	C1836.493042,2042.487061 1837.840454,2042.446167 1839.147339,2042.217896 
	C1848.069214,2040.660034 1853.084229,2044.735474 1855.197021,2053.170166 
	C1856.151611,2056.980713 1857.585205,2060.330811 1862.624756,2058.958496 
	C1867.253296,2057.698486 1870.930420,2055.491699 1869.244385,2049.883545 
	C1866.963013,2042.295288 1870.966309,2037.816650 1876.559570,2034.096313 
	C1882.225830,2030.327393 1885.390503,2025.491943 1885.439453,2018.396118 
	C1885.491455,2010.874023 1889.810913,2005.987427 1896.838623,2003.683594 
	C1901.799561,2002.057251 1904.271606,1999.487915 1901.928711,1994.078491 
	C1899.806274,1989.178223 1898.987549,1984.321411 1904.108398,1980.645020 
	C1908.759644,1977.305664 1913.989014,1976.443848 1919.247314,1978.791992 
	C1924.372192,1981.080322 1926.036743,1985.814575 1926.447021,1991.059204 
	C1926.711914,1994.445190 1926.003662,1997.683960 1924.422119,2001.480957 
	C1923.409302,2003.447876 1922.406372,2004.478638 1920.554565,2005.629883 
	C1917.550049,2006.930298 1914.623047,2007.577148 1917.203491,2011.817749 
	C1919.306396,2017.168701 1923.030518,2018.965332 1928.511963,2019.170166 
	C1936.682373,2018.625244 1942.169189,2020.967773 1944.325562,2028.886841 
	C1945.002563,2031.373169 1946.242798,2034.188721 1949.762085,2033.518188 
	C1953.374878,2032.829834 1954.895508,2029.955566 1954.192383,2026.816650 
	C1951.479248,2014.705200 1957.405029,2008.642334 1968.262085,2005.885498 
	C1972.354126,2004.846436 1973.139648,2002.055664 1973.194214,1998.427246 
	C1973.259399,1994.084351 1973.799072,1989.799194 1976.731201,1985.403564 
	C1980.563843,1981.516602 1984.764404,1981.176270 1989.869873,1981.435547 
	C1995.946289,1982.510010 1999.762329,1985.487305 2001.766113,1990.493896 
	C2003.400146,1994.576294 2004.805054,1997.481445 2010.394165,1995.026733 
	C2016.325195,1992.421631 2016.849976,1988.801880 2015.806885,1983.119141 
	C2014.690918,1977.037964 2011.309448,1978.856812 2007.784058,1979.648926 
	C2002.688232,1980.793945 1997.850586,1980.449951 1993.190430,1976.317139 
	C1991.741577,1973.868896 1991.426147,1971.843140 1991.256104,1968.981689 
	C1991.064087,1963.097656 1992.665771,1958.624390 1996.405762,1954.106079 
	C1997.750854,1952.845581 1998.629272,1952.285522 2000.273438,1951.552856 
	C2004.649780,1950.327759 2005.163452,1947.457886 2005.244995,1944.296753 
	C2005.409424,1937.915405 2006.933472,1932.172852 2013.920410,1930.178101 
	C2021.323242,1928.064209 2027.073975,1931.130493 2031.010376,1937.285278 
	C2035.542236,1944.371704 2040.987671,1942.046021 2046.611450,1939.411255 
	C2049.135254,1938.229004 2051.070312,1936.533081 2051.051270,1933.393433 
	C2050.965088,1919.170410 2064.311768,1912.602417 2069.536865,1901.319946 
	C2071.304688,1897.503174 2076.235107,1897.038086 2080.176025,1899.386841 
	C2084.146484,1901.753662 2084.678467,1905.709717 2083.871338,1909.921875 
	C2083.212891,1913.358398 2080.768311,1915.734741 2078.705078,1918.326416 
	C2076.782959,1920.739990 2076.722656,1923.175659 2078.665039,1925.582520 
	C2080.416992,1927.753540 2082.547852,1929.502808 2085.498047,1928.525146 
	C2087.999268,1927.696289 2090.537109,1926.556396 2090.918213,1923.344849 
	C2091.114258,1921.692993 2091.249756,1920.035156 2091.361084,1918.376709 
	C2091.791748,1911.957886 2094.751221,1907.283936 2101.409668,1906.727783 
	C2108.367676,1906.146973 2113.754883,1909.559448 2116.451660,1916.049805 
	C2119.116943,1922.464844 2115.869141,1926.883179 2110.469971,1930.127075 
	C2108.763672,1931.152222 2106.779541,1931.857422 2105.550781,1933.471069 
	C2102.605469,1937.338867 2103.352539,1941.393433 2106.768066,1944.084961 
	C2110.274414,1946.848022 2112.866455,1943.653198 2114.963623,1941.032349 
	C2116.683105,1938.883667 2117.020020,1936.160278 2117.395020,1933.522461 
	C2118.482910,1925.871948 2124.033447,1923.177246 2130.598633,1922.012085 
	C2137.711182,1920.749756 2141.798584,1925.035645 2144.682617,1930.759644 
	C2147.766113,1936.880127 2145.208252,1941.638184 2140.660645,1945.797974 
	C2139.433838,1946.920532 2138.135498,1947.972778 2137.023193,1949.210693 
	C2134.940674,1951.528809 2133.215088,1954.077637 2134.956787,1957.264526 
	C2136.805908,1960.648193 2139.982666,1959.929810 2142.918945,1959.247925 
	C2146.725098,1958.364502 2146.811035,1955.734497 2146.519531,1952.325684 
	C2145.644775,1942.101685 2148.149414,1938.764282 2156.577637,1937.870972 
	C2164.571289,1937.023804 2171.334473,1942.870605 2172.150146,1951.251343 
	C2172.709473,1956.997803 2169.990234,1960.760742 2165.107910,1963.282471 
	C2161.123779,1965.340210 2158.512207,1968.000977 2161.103271,1972.782715 
	C2162.757812,1975.836426 2165.452881,1976.760132 2168.718994,1975.986328 
	C2173.823486,1974.776978 2174.771729,1971.295288 2173.360352,1966.822388 
	C2171.563232,1961.128052 2174.067139,1957.191406 2178.960693,1953.467773 
	C2180.531738,1952.659912 2181.506592,1952.417969 2183.275391,1952.342285 
	C2189.362793,1953.346802 2194.330322,1954.856567 2197.354980,1960.003784 
	C2201.901611,1967.740967 2200.577393,1973.563354 2192.927734,1978.442017 
	C2189.690918,1980.506104 2184.877197,1981.664062 2186.618408,1987.043457 
	C2188.449219,1992.699341 2193.120361,1992.870850 2198.081055,1992.108887 
	C2204.718262,1991.089355 2209.916992,1992.773071 2212.201660,1999.853760 
	C2214.627930,2007.374268 2214.983643,2014.289795 2207.266357,2019.211304 
	C2205.034180,2020.634888 2202.609619,2021.793335 2200.771973,2023.786743 
	C2199.016357,2025.690918 2198.581543,2027.856201 2199.596924,2030.221802 
	C2200.589844,2032.535278 2202.264648,2034.079346 2204.944580,2033.877930 
	C2207.480713,2033.687256 2209.240967,2032.289062 2210.178467,2029.905151 
	C2210.918945,2028.022583 2211.201416,2026.032104 2211.205078,2024.044067 
	C2211.217773,2016.752686 2214.758789,2012.320068 2221.672119,2010.103149 
	C2224.652832,2009.147095 2229.099365,2008.753418 2228.965820,2004.564331 
	C2228.827881,2000.222290 2225.005615,1997.929077 2221.370850,1996.089966 
	C2219.567383,1995.177124 2217.531738,1995.130005 2215.559082,1994.836792 
	C2205.255615,1993.304688 2199.201416,1986.276855 2200.772461,1977.757080 
	C2202.056396,1970.793457 2210.765869,1967.483887 2220.715820,1970.177612 
	C2222.987549,1970.792603 2225.007080,1971.945312 2227.688965,1973.433594 
	C2230.104248,1974.749634 2231.455811,1976.205811 2233.374023,1978.121582 
	C2235.092041,1979.885132 2236.489502,1980.893555 2238.279053,1980.427246 
	C2247.047363,1978.142578 2253.068115,1981.188354 2257.004395,1989.328491 
	C2259.049805,1993.558228 2262.880371,1995.617065 2267.695801,1995.215576 
	C2275.266846,1994.584473 2280.385986,1997.845825 2283.680420,2004.598022 
	C2286.330811,2010.029907 2290.908691,2012.576416 2296.799316,2010.923584 
	C2305.531494,2008.473511 2310.230957,2012.695557 2312.839355,2020.120728 
	C2315.151611,2026.701416 2318.430908,2029.958008 2326.114258,2028.162476 
	C2332.411133,2026.690796 2336.774902,2031.272583 2340.140869,2035.950684 
	C2343.491455,2040.607422 2347.361572,2043.518188 2353.348145,2043.396484 
	C2358.849121,2043.284668 2362.468018,2046.299316 2365.462891,2050.833740 
	C2372.161865,2060.976562 2379.013428,2060.565186 2385.537109,2049.920898 
	C2386.927979,2047.651611 2387.763184,2045.072998 2389.283203,2042.873169 
	C2395.572266,2033.771362 2403.360352,2034.302856 2408.162598,2044.268921 
	C2409.569336,2047.188232 2409.747803,2051.076416 2415.259277,2050.258301 
	C2416.987549,2050.128418 2417.975830,2050.162109 2419.685791,2050.435059 
	C2433.343750,2057.901611 2435.361816,2064.307129 2428.847168,2077.370117 
	C2427.118652,2080.836182 2423.697998,2085.053711 2428.855225,2087.589600 
	C2433.453125,2089.850830 2435.678711,2085.379639 2437.689697,2081.792236 
	C2443.061768,2072.209961 2449.972412,2069.337891 2457.763916,2073.273193 
	C2465.050049,2076.953369 2466.268799,2084.749268 2460.412598,2090.477783 
	C2458.507324,2092.341309 2456.044678,2093.496338 2454.047363,2095.257812 
	C2451.731934,2097.300049 2451.263672,2099.803467 2452.706787,2102.421387 
	C2454.278564,2105.272705 2456.779053,2106.868652 2460.153564,2106.038330 
	C2463.225342,2105.282227 2464.315918,2102.871094 2464.175537,2099.967773 
	C2463.932617,2094.943359 2463.405762,2089.980225 2468.283203,2086.445801 
	C2474.167725,2082.181152 2483.763428,2082.073242 2488.167480,2088.169189 
	C2493.364014,2095.362061 2499.314941,2098.060547 2507.946045,2098.211670 
	C2514.276611,2098.322510 2518.456055,2103.319336 2521.323730,2108.934570 
	C2522.786621,2111.799316 2523.622559,2115.539551 2528.976318,2114.230469 
	C2530.662842,2113.861572 2531.644775,2113.721680 2533.390869,2113.579346 
	C2538.455322,2113.497070 2541.998291,2115.418457 2545.891846,2118.375000 
	C2548.122070,2120.649902 2549.056152,2122.842041 2550.096680,2125.704834 
	C2550.820801,2128.550537 2551.918945,2129.738281 2554.966309,2128.409424 
	C2557.462646,2127.895264 2559.259521,2128.019775 2561.453369,2129.539062 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.534183,1050.451660 
	C2.000000,1042.614136 2.000000,1035.228394 2.000000,1026.921265 
	C8.351949,1021.194519 10.950068,1014.244324 14.395789,1007.296631 
	C20.221655,995.549805 32.006138,986.749146 31.409498,971.837280 
	C43.405628,965.391663 44.890469,949.950195 56.410240,942.861450 
	C61.525780,939.713440 62.710171,933.509460 62.965996,927.769165 
	C63.268223,920.987549 65.508797,915.559998 71.100204,911.467712 
	C74.917671,908.673767 77.193253,904.478760 79.909134,900.680969 
	C86.153091,891.949463 91.398537,890.455261 101.308891,894.219727 
	C110.149200,897.577637 113.299950,895.758362 112.648804,886.233521 
	C112.163948,879.141113 114.361664,874.856812 120.784508,872.081116 
	C127.120613,869.342834 129.570541,864.358215 128.079086,857.442749 
	C126.237724,848.904724 128.928772,843.046814 138.107269,841.184021 
	C140.408936,840.716919 143.432983,839.955078 144.075684,837.919861 
	C148.026855,825.406860 160.438614,817.644531 162.805099,804.405762 
	C164.010040,797.665100 167.021301,792.758789 173.394531,789.752625 
	C178.922928,787.144897 182.028534,782.598633 181.992477,776.212830 
	C181.981125,774.201660 182.013550,771.447937 183.482834,770.558655 
	C195.683075,763.174133 195.745255,747.487854 205.661850,738.593323 
	C208.398834,736.138367 210.934280,733.000610 211.776794,729.559753 
	C215.236404,715.431091 226.406158,706.857788 234.999115,696.483521 
	C242.929825,686.908691 246.118301,686.396851 258.314331,690.968384 
	C261.618439,692.206909 265.107147,693.398315 267.171387,689.690491 
	C269.411682,685.666626 266.768188,682.761047 263.509674,680.563843 
	C261.289856,679.067078 258.540100,678.603882 256.288116,677.161682 
	C249.937881,673.094727 247.780014,664.285767 251.755356,658.880798 
	C255.611481,653.637878 261.629730,653.448975 268.558044,658.120667 
	C272.457275,660.749939 276.532379,667.326965 281.140930,662.971619 
	C286.080078,658.303772 278.939026,654.485474 276.603912,650.597717 
	C274.447083,647.006714 273.188721,643.390015 273.612305,639.254395 
	C274.377289,631.785950 278.312958,629.447754 285.243256,632.367188 
	C287.387665,633.270447 289.319977,634.657166 291.525970,635.437439 
	C300.542267,638.626526 305.344177,635.011047 303.463623,625.619568 
	C302.208649,619.352112 304.118988,615.921021 309.817688,614.246826 
	C317.046234,612.123108 320.681763,607.116821 322.263550,600.043579 
	C323.144592,596.103821 324.892975,592.383362 327.828766,589.560486 
	C332.917511,584.667419 335.597198,578.961975 335.495544,571.807617 
	C335.422241,566.650940 338.405365,563.113586 342.732086,560.627258 
	C347.641052,557.806335 350.281219,553.707703 351.597839,548.053406 
	C354.496582,535.605042 364.775726,531.566956 376.030151,537.973206 
	C378.626862,539.451294 380.650482,541.934998 383.605255,542.746155 
	C388.852112,544.186340 392.261017,541.524475 393.398895,536.807556 
	C394.663971,531.563354 391.025238,529.752441 386.446075,529.436707 
	C384.446777,529.298828 382.451874,529.867615 380.461273,529.714905 
	C373.979431,529.217834 370.081421,524.846741 372.597290,518.900208 
	C377.494507,507.325134 383.702698,496.205383 390.891571,485.947754 
	C394.777771,480.402679 401.909912,480.313263 408.153778,484.088989 
	C410.719849,485.640656 412.748260,487.969055 415.476959,489.289581 
	C418.066742,490.542847 420.629395,490.561890 423.028564,488.813171 
	C425.784760,486.804321 426.646027,484.010895 425.684906,480.859924 
	C423.945099,475.156067 420.814209,470.437531 414.575684,469.138641 
	C403.885590,466.912933 396.234314,458.523132 385.969727,455.384827 
	C383.164764,454.527252 381.280518,451.677368 380.507751,448.597748 
	C379.915497,446.237427 380.038849,443.852600 381.878143,442.061218 
	C383.759644,440.228699 386.085083,440.338654 388.403351,441.261749 
	C390.612122,442.141266 392.432983,443.623627 394.136841,445.211700 
	C400.865051,451.482574 407.948914,452.589142 415.867188,447.296906 
	C421.327240,443.647675 425.329498,444.000061 425.716858,451.847595 
	C426.009491,457.775330 428.800232,461.202850 435.118652,460.957489 
	C440.881683,460.733673 444.817871,458.267303 445.079865,452.084595 
	C445.355438,445.580231 448.530518,441.078918 453.256439,436.799622 
	C459.990448,430.702026 458.364197,423.863983 449.378601,421.219025 
	C442.418945,419.170380 437.264435,416.013672 434.999023,408.898224 
	C433.745422,404.960693 430.888947,403.026154 426.797211,402.723297 
	C422.716583,402.421356 418.812378,401.422089 415.948242,398.291504 
	C412.032257,394.011230 407.967010,389.483978 413.125183,383.564423 
	C417.558289,378.476959 426.271667,378.664490 431.010284,383.578888 
	C434.192444,386.879059 435.044891,394.281342 441.776825,391.646942 
	C448.603424,388.975525 445.113953,382.351440 445.187958,377.442780 
	C445.289124,370.728821 447.288300,365.742126 453.991425,363.399597 
	C461.075928,360.923798 463.294037,356.083038 462.589844,348.601410 
	C461.854004,340.783783 464.978546,339.128052 472.297821,342.525696 
	C475.619446,344.067627 478.716095,346.078094 481.784332,348.080017 
	C491.255432,354.259613 491.572174,357.016663 483.330750,364.352844 
	C479.640228,367.638062 477.048676,371.440765 477.022095,376.355194 
	C476.979156,384.283905 473.641235,389.589142 466.191101,392.547546 
	C462.014008,394.206207 457.839417,396.534454 460.991943,402.163513 
	C463.911621,407.376770 468.192322,405.601715 472.319275,403.792999 
	C476.701385,401.872498 480.984100,399.922272 480.552277,393.935913 
	C480.240967,389.620880 481.205170,385.706787 485.874908,384.352600 
	C491.462311,382.732300 497.096863,382.429565 501.963135,386.558960 
	C503.745941,388.071838 504.784119,390.284363 506.525970,391.848480 
	C508.637329,393.744415 511.049316,394.806091 513.822693,393.417847 
	C516.316223,392.169678 516.702393,389.727081 516.247375,387.380432 
	C514.535767,378.551758 518.885925,373.584076 526.450562,370.252106 
	C531.067566,368.218445 533.931824,364.605988 533.713501,359.305603 
	C533.455200,353.037537 536.189087,348.328674 541.054871,344.803558 
	C546.534607,340.833679 547.546509,334.991913 548.140930,328.943359 
	C548.333740,326.981049 548.425964,324.816345 546.042847,323.869049 
	C543.950500,323.037323 542.082397,323.799652 540.478394,325.098785 
	C537.260864,327.704773 535.728088,331.421356 534.006531,335.050110 
	C527.394470,348.986664 520.071472,351.111237 507.439880,342.694489 
	C503.985962,340.393127 500.328979,338.405884 496.261230,339.337708 
	C486.898071,341.482605 481.241974,336.748505 475.966797,329.986237 
	C469.417908,321.591003 463.436798,322.312805 458.891937,331.843262 
	C457.275055,335.233765 455.915100,338.548401 452.190582,340.099915 
	C447.381042,342.103424 442.940613,342.001007 439.867798,337.195953 
	C436.988586,332.693665 438.409790,328.255676 442.498505,325.902802 
	C451.459045,320.746368 454.636261,314.205872 450.419708,304.333221 
	C449.207947,301.496094 449.896576,297.466187 452.617523,296.175110 
	C464.641785,290.469543 468.583008,276.918060 479.331787,269.791107 
	C488.782104,263.525055 488.380188,262.653839 493.064209,272.668335 
	C494.864838,276.518127 497.479279,278.444489 501.623413,278.000183 
	C504.236450,277.720032 505.965424,276.047668 505.973145,273.361298 
	C505.986389,268.757874 502.452026,266.597382 498.869110,266.303802 
	C491.869263,265.730225 486.205170,264.127014 482.515350,257.308868 
	C480.936249,254.390976 476.911743,253.823563 473.448212,255.004974 
	C470.098724,256.147491 469.415253,259.148743 469.015594,262.214111 
	C468.886383,263.205444 468.884735,264.209442 468.801758,265.205048 
	C467.483734,281.019592 462.351807,283.520386 449.508392,274.582977 
	C445.406952,271.728912 441.526428,268.408844 436.700806,266.897308 
	C430.985352,265.107056 425.465881,265.857117 423.943146,272.497559 
	C422.519348,278.706543 425.754761,282.312195 432.476288,283.248138 
	C447.282532,285.309845 449.439270,289.762329 442.441162,303.001465 
	C439.436920,308.685059 438.001923,314.782013 436.541382,320.966705 
	C433.855469,332.340149 421.511078,336.083527 413.671661,327.517883 
	C408.245117,321.588593 401.880341,317.923981 394.643158,315.192657 
	C387.859344,312.632355 383.672974,308.083069 382.693695,300.592285 
	C382.025055,295.477875 382.291260,291.303833 388.009216,289.301117 
	C391.314484,288.143494 394.305084,286.151154 393.722198,282.140686 
	C393.002594,277.189728 388.843567,277.248749 385.152924,277.512451 
	C377.681763,278.046295 376.016693,272.291901 373.322906,267.317657 
	C368.877838,259.109497 362.869476,257.966278 357.776581,264.133301 
	C354.633087,267.939758 354.473969,270.835876 360.418304,271.209473 
	C366.264221,271.576782 371.527893,273.196289 375.846130,277.360657 
	C382.423462,283.703583 382.713867,288.365967 376.885468,295.483032 
	C374.767303,298.069489 372.231171,300.246216 369.901184,302.623596 
	C363.919189,308.727325 365.568146,316.529663 373.753723,317.091675 
	C382.511993,317.692963 387.842865,321.945343 392.748230,328.107117 
	C395.657684,331.761841 399.714325,333.048889 404.236969,333.231720 
	C410.268585,333.475616 415.593384,335.088989 417.622833,341.568665 
	C419.534912,347.673615 416.133301,351.798096 411.729889,355.255524 
	C406.870575,359.070892 403.510925,363.782898 401.433197,369.654541 
	C399.879639,374.044861 397.583069,378.333160 394.165009,381.510773 
	C389.337280,385.998871 386.232819,391.258698 384.584564,397.546570 
	C384.079071,399.475067 383.185486,401.297272 382.143768,403.011749 
	C379.795380,406.876770 376.876648,410.014771 371.896118,409.832184 
	C368.061707,409.691589 365.863983,407.255096 364.708008,403.856506 
	C363.142944,399.255310 364.634705,395.449585 367.856201,392.000092 
	C371.090546,388.536865 377.712494,386.094330 375.120667,380.250580 
	C372.399597,374.115326 369.027222,367.439301 361.047699,365.931458 
	C358.681793,365.484406 356.485626,364.526550 355.106354,362.538422 
	C352.080597,358.176941 347.905090,353.331604 352.937744,348.360901 
	C357.640137,343.716370 362.972137,345.990997 367.084167,350.083984 
	C370.401367,353.385864 373.203583,357.162659 378.214874,358.031921 
	C382.545013,358.782990 387.332123,359.979401 389.620728,354.910980 
	C391.920990,349.816833 389.311523,344.909546 384.869080,343.188965 
	C376.949921,340.121826 369.505829,337.154572 365.538696,328.930542 
	C365.006958,327.828247 363.277191,327.099579 362.033630,327.303680 
	C346.726135,329.815887 336.510040,317.394745 323.167328,314.105286 
	C317.179077,312.628937 312.462524,308.855652 309.472290,303.196564 
	C308.054779,300.513916 306.076660,298.268463 303.365723,296.748047 
	C297.258759,293.323090 293.282349,294.717773 291.048248,301.357422 
	C289.772705,305.148376 289.015106,309.114563 288.871155,313.126862 
	C288.684723,318.321930 287.399048,322.893158 283.306488,326.527069 
	C280.093231,329.380219 278.172119,332.880585 281.242401,337.037231 
	C283.031311,339.459106 285.535583,340.195374 288.310547,338.771759 
	C292.319550,336.715118 292.725311,333.142334 291.700562,329.327606 
	C290.112915,323.417572 289.552094,317.627869 296.402863,314.939697 
	C303.193909,312.275055 309.486877,315.157562 313.133759,320.589844 
	C317.024933,326.386139 321.242981,328.933594 327.976288,327.620392 
	C329.262665,327.369507 330.667175,327.671051 331.915009,328.129486 
	C338.273285,330.465485 342.837524,334.584198 343.962891,341.513428 
	C344.532013,345.017548 343.600525,348.505981 339.762482,349.629547 
	C333.001648,351.608734 326.533997,351.269440 321.453186,345.433807 
	C320.357025,344.174774 319.475983,342.751160 318.444672,341.443481 
	C316.166901,338.555176 313.400146,336.573639 309.988251,339.365021 
	C306.388031,342.310455 307.403320,345.878113 309.784241,349.121765 
	C311.674561,351.697021 314.609589,352.559967 317.568451,353.236938 
	C320.838348,353.985046 324.352020,354.629822 326.726166,356.991608 
	C333.855621,364.083923 340.608826,371.216217 352.310669,369.024597 
	C355.319427,368.461121 357.251190,371.942352 358.073914,375.048126 
	C358.759674,377.636841 358.905579,380.312256 359.289001,382.948761 
	C360.005798,387.877838 361.668335,393.459320 356.206482,396.503082 
	C350.064423,399.925873 345.523773,395.528870 341.180328,391.826996 
	C338.897064,389.881012 337.337524,387.111084 334.828796,385.481232 
	C329.237183,381.848511 323.512421,381.384827 318.511261,386.466217 
	C316.207153,388.807343 313.977234,391.788574 315.050415,395.371735 
	C316.096802,398.865631 319.586975,399.101288 322.529083,399.157837 
	C335.406921,399.405334 338.060181,410.391571 342.672455,418.791931 
	C345.067627,423.154327 341.542297,425.499268 336.993011,425.302673 
	C328.972198,424.956055 320.984222,424.681213 314.859558,418.098663 
	C312.656982,415.731445 309.581177,413.092926 306.086060,415.284302 
	C302.096436,417.785767 303.783081,421.677521 304.854675,425.209167 
	C308.418976,436.956055 308.405426,436.932098 295.812988,437.404327 
	C291.437653,437.568390 286.386322,437.656769 284.623901,442.305328 
	C282.981171,446.638214 285.658875,450.865692 288.632385,454.050415 
	C292.413727,458.100372 297.024902,457.287140 301.475281,454.884430 
	C302.940643,454.093323 304.234558,453.011047 305.693146,452.204498 
	C308.418243,450.697662 311.331665,449.459534 313.940430,452.085419 
	C316.218109,454.377991 314.933167,457.082001 313.919983,459.547089 
	C313.033813,461.703094 311.821655,463.711975 310.869659,465.844391 
	C304.670258,479.730469 304.210663,479.914520 290.360809,473.121857 
	C286.401337,471.179901 282.240051,470.028809 277.886627,469.810211 
	C274.350677,469.632629 270.669312,470.307068 271.090240,474.938354 
	C271.461548,479.023987 274.207977,481.454041 278.580017,481.381042 
	C280.275055,481.352783 281.794312,480.560516 283.321594,479.897339 
	C287.639099,478.022583 292.124603,477.179047 294.609283,482.189667 
	C297.393036,487.803436 294.206757,492.568512 290.685547,496.685516 
	C287.266449,500.683167 283.085571,500.434814 279.140533,497.324768 
	C275.495789,494.451447 272.333252,490.700989 267.190460,490.706421 
	C262.987213,490.710876 257.105408,486.880920 255.483658,493.923798 
	C254.083817,500.002960 253.295624,506.726013 260.067047,510.938660 
	C262.333832,512.348938 265.019653,512.954224 267.271393,514.392517 
	C273.211212,518.186584 275.211761,524.497437 271.875031,528.669312 
	C268.555817,532.819275 259.804840,533.672729 255.371796,530.212524 
	C253.502731,528.753662 252.382233,526.649292 251.103912,524.704590 
	C248.006897,519.993164 244.313370,519.922974 240.157623,523.232727 
	C238.064713,524.899597 236.349701,526.961975 234.394852,528.774170 
	C232.332092,530.686462 230.001465,532.040039 227.171219,530.878662 
	C224.308075,529.703796 223.832855,526.954529 223.539337,524.243530 
	C223.322968,522.244812 223.371750,520.227417 223.706070,518.260315 
	C224.700272,512.410583 222.004150,509.967468 216.430710,508.647308 
	C205.061188,505.954224 201.608322,496.201904 208.813934,486.934906 
	C214.089447,480.150116 220.801437,474.649994 225.983276,467.593140 
	C230.182358,461.874603 236.523102,463.562317 242.164062,467.184143 
	C247.311111,470.488831 252.472748,470.728851 255.819916,464.719513 
	C258.329956,460.213135 253.894302,452.079651 248.504059,450.005371 
	C244.320450,448.395386 241.597870,451.257996 238.404404,452.851959 
	C235.494080,454.304657 232.179733,456.834991 229.526657,453.133423 
	C227.190414,449.873932 229.235687,446.704163 231.693665,444.244141 
	C234.980972,440.954193 238.822983,438.230011 241.418747,434.243347 
	C244.394913,429.672455 248.367538,429.757935 252.758682,432.010101 
	C256.309998,433.831512 259.649017,436.144043 263.579224,437.119965 
	C266.647888,437.881958 269.971680,437.957123 271.333191,434.567352 
	C272.810760,430.888763 270.710846,427.006958 267.460968,426.537109 
	C257.292603,425.067139 249.533920,420.657013 243.980774,411.919067 
	C242.547073,409.663147 239.425308,409.039612 236.727982,410.470856 
	C233.713867,412.070251 234.477478,414.823944 234.839386,417.527222 
	C236.656555,431.100433 236.305893,431.794403 222.908966,435.034698 
	C217.448883,436.355377 214.742508,439.443298 214.912781,444.809052 
	C215.167068,452.822052 212.717133,459.015594 205.210464,462.971649 
	C200.696747,465.350311 198.768860,469.572723 199.619125,474.792328 
	C200.717010,481.532074 198.394135,486.607330 192.196259,489.635620 
	C185.160309,493.073425 181.616333,498.450531 182.145584,506.425720 
	C182.499268,511.755280 179.312180,515.191711 175.191772,517.750671 
	C169.850815,521.067688 167.166611,525.273193 168.321991,531.866699 
	C169.462936,538.377869 165.395950,542.344788 160.493301,545.774536 
	C156.616074,548.486877 152.833496,551.480896 154.256699,557.158386 
	C155.566238,562.382507 159.247940,564.705078 164.345413,565.418884 
	C169.207733,566.099792 172.928833,568.300903 171.538803,573.932434 
	C170.122284,579.671143 165.628571,580.658569 160.498917,579.414246 
	C156.952820,578.553955 153.595825,576.880737 149.828094,577.007263 
	C146.801819,577.108826 143.435486,577.064209 141.701767,579.890198 
	C139.655807,583.225159 142.684998,585.449951 144.567841,587.592041 
	C148.649719,592.236145 151.486038,596.825256 145.999771,602.342285 
	C142.202866,606.160522 137.912048,606.339722 133.112061,604.486511 
	C130.129471,603.334900 126.835014,600.703735 123.788643,603.427734 
	C119.983978,606.829834 123.748100,610.086792 124.889748,613.316650 
	C127.607918,621.006592 126.153900,625.475342 118.136536,628.186707 
	C109.601784,631.073120 104.149635,635.267273 104.359940,645.056519 
	C104.462738,649.841125 101.279633,653.010315 97.007858,654.892334 
	C90.589554,657.720032 87.180145,662.560364 86.694809,669.567200 
	C86.434959,673.318665 85.581123,677.225220 82.259933,679.244934 
	C74.697578,683.843750 69.954712,690.033691 68.633423,698.918335 
	C68.243118,701.542847 66.218689,703.590271 64.262550,705.478333 
	C45.405239,723.679321 30.476673,744.543091 20.669661,769.001221 
	C16.912718,778.370789 11.484035,780.536865 2.529533,776.498901 
	C2.000000,774.500000 2.000000,773.000000 2.000000,770.750000 
	C2.928243,769.102173 3.760909,768.108093 4.695336,767.220825 
	C14.522613,757.888611 14.314957,755.613403 2.493817,748.460205 
	C2.000000,745.222229 2.000000,742.444397 2.000000,738.833313 
	C6.241816,732.676514 11.892694,733.834534 17.620436,734.243469 
	C25.050167,734.773987 26.722099,732.007568 23.562435,725.305481 
	C22.852755,723.800232 21.761988,722.497742 20.974466,721.032410 
	C15.570661,710.977905 18.708220,705.744812 29.979462,706.191895 
	C33.997776,706.351257 38.740738,707.497559 39.781837,702.137451 
	C40.822311,696.780701 35.944466,695.912476 32.186237,694.658386 
	C28.205202,693.329956 24.177862,691.621826 24.846668,686.641357 
	C25.569679,681.257263 30.430117,680.637634 34.742294,679.985535 
	C38.146332,679.470764 41.259399,681.013672 44.492970,681.761169 
	C53.476662,683.837769 58.316437,680.888672 58.951462,671.888062 
	C59.464020,664.623230 61.617107,659.082397 68.229996,655.464478 
	C73.009941,652.849304 75.187080,648.419983 75.171730,642.999390 
	C75.154106,636.773621 77.286674,631.999573 83.467934,629.577332 
	C89.309921,627.288086 91.576523,622.909424 90.236626,616.810974 
	C88.647942,609.580078 90.677582,604.583008 98.058533,601.865540 
	C105.669922,599.063232 107.727371,593.324402 105.295845,585.744141 
	C102.993080,578.565186 104.469421,573.666077 112.600456,571.273376 
	C121.150978,568.757446 122.497421,564.994141 119.506676,556.108521 
	C116.015190,545.735168 115.993950,545.654358 126.380424,542.926636 
	C133.073318,541.168823 137.793533,538.371399 134.145447,530.377319 
	C130.897263,523.259583 134.019073,519.694885 140.818420,518.131226 
	C146.596741,516.802429 154.049011,517.230164 156.622635,511.123016 
	C160.728790,501.378998 166.444992,492.176941 168.291122,481.554993 
	C169.065674,477.098358 166.075592,474.906097 162.455246,473.379852 
	C158.875610,471.870850 156.111786,469.680450 155.769165,465.456573 
	C155.489899,462.014008 155.846649,458.716003 158.760513,456.377899 
	C162.045883,453.741669 165.056595,455.306702 167.842148,457.367493 
	C171.884766,460.358185 175.725296,464.033783 181.221802,460.422058 
	C186.191086,457.156799 186.322601,452.254608 185.671402,447.071533 
	C184.833908,440.405457 187.554230,436.707581 194.259857,434.719604 
	C203.096588,432.099762 203.462189,429.401764 196.451569,423.782043 
	C192.531128,420.639465 189.420898,416.680389 185.793106,413.438782 
	C180.044525,408.302002 171.993988,405.792633 164.841110,404.118896 
	C157.788559,402.468567 152.557602,399.885223 148.100449,394.692627 
	C146.583115,392.924927 145.072403,391.078247 142.827179,390.199890 
	C139.311890,388.824585 136.242889,389.600952 133.917511,392.589233 
	C131.735748,395.392883 132.135010,398.292206 134.424484,400.754517 
	C137.354553,403.905823 140.271545,407.957306 144.957062,407.638214 
	C153.388016,407.064117 158.529465,411.559784 163.540329,417.325684 
	C168.190002,422.676025 173.476669,426.484161 180.534943,420.262909 
	C182.760101,418.301605 185.417023,418.576385 187.318863,421.506531 
	C192.053574,428.801208 187.628433,438.712769 179.010010,439.866302 
	C177.359100,440.087219 175.449081,439.826202 174.158127,440.812439 
	C165.825714,447.178009 158.558426,446.448853 151.580399,438.451904 
	C149.024231,435.522491 145.025604,435.976288 141.221436,436.593994 
	C130.292969,438.368469 128.774246,437.088715 128.407211,426.552063 
	C128.361008,425.225647 128.573273,423.873718 128.265839,422.572266 
	C127.614220,419.813873 126.288086,417.056396 123.139938,417.479889 
	C119.605026,417.955322 120.106766,421.316406 120.200249,423.920807 
	C120.284187,426.259369 121.334831,428.445312 121.678093,430.747192 
	C122.935684,439.180420 119.867561,443.901367 111.649239,446.470642 
	C108.987411,447.302795 104.973862,446.516418 104.759674,450.702637 
	C104.608376,453.659698 107.423195,455.037506 109.618446,456.568146 
	C122.628227,465.639191 123.446747,468.950195 116.105751,483.699860 
	C113.259651,489.418304 111.851921,495.010925 116.561050,500.426392 
	C118.154640,502.259003 120.220100,503.548187 122.747131,502.603607 
	C125.299866,501.649384 125.887611,499.311005 125.862579,496.870880 
	C125.834633,494.146027 124.500031,491.753296 123.695801,489.220337 
	C120.891846,480.389008 123.898132,476.762817 133.297241,477.565826 
	C138.090469,477.975311 142.469330,479.633392 145.934814,482.965332 
	C150.165894,487.033356 152.759583,493.454102 148.848022,497.285095 
	C141.031204,504.940887 133.662567,514.194153 121.702301,515.965149 
	C117.450523,516.594788 113.064659,516.960449 108.743095,516.718140 
	C101.781296,516.327881 97.133385,518.524231 96.048058,526.123535 
	C95.570724,529.465759 93.683128,532.375000 91.206367,534.706543 
	C85.672173,539.916382 82.429672,546.355835 80.664169,553.643066 
	C79.440674,558.693176 76.569885,561.964661 71.097427,562.296692 
	C67.260635,562.529480 63.530052,561.925354 61.476849,558.323059 
	C58.701992,553.454407 61.367657,549.380493 64.118896,545.481873 
	C64.887466,544.392761 65.788269,543.404114 66.632576,542.372620 
	C69.227386,539.202515 71.842873,535.782288 69.827965,531.542664 
	C67.595833,526.846008 62.716599,526.310669 58.538754,527.170532 
	C49.048111,529.123901 42.427322,526.612671 38.195728,517.528442 
	C36.524208,513.940063 32.643707,511.773956 29.128136,514.934692 
	C25.764862,517.958557 27.592043,521.697693 30.243166,524.642273 
	C33.073753,527.786194 37.125961,528.429077 40.907490,529.728088 
	C49.222607,532.584412 51.934036,538.589539 48.583878,546.046021 
	C45.034672,553.945557 34.115532,559.959534 28.434559,557.120117 
	C25.489849,555.648315 24.485426,552.894226 23.492252,549.969788 
	C19.636742,538.617310 18.679813,538.229675 7.072011,542.529053 
	C5.786365,543.005249 4.504948,543.171570 2.583313,542.436523 
	C2.000000,532.621521 2.000000,523.242981 2.000000,512.932251 
	C3.523554,510.672882 4.550343,508.931396 5.824307,507.396423 
	C13.212576,498.494446 12.869428,496.540802 2.500429,490.464050 
	C2.000000,483.938812 2.000000,477.877625 2.000000,470.908203 
	C5.287930,467.375397 6.567950,463.767761 7.708105,459.817963 
	C9.725713,452.828461 10.674861,445.582062 13.727616,438.815582 
	C18.279644,428.725891 17.368071,427.329468 6.668115,424.464111 
	C5.375711,424.118011 4.120553,423.730621 2.515118,422.464050 
	C2.000000,403.291534 2.000000,384.583099 2.000000,364.937317 
	C5.788091,361.083038 8.847003,364.089844 12.116057,365.265991 
	C20.227083,368.184204 23.086975,366.816559 23.101521,358.705963 
	C23.115389,350.972107 24.183163,343.797974 28.652725,337.075958 
	C19.854122,344.274658 17.599598,358.801849 2.540568,358.440002 
	C2.000000,240.624878 2.000000,123.249756 2.000000,4.937315 
	C6.142303,2.047009 10.541037,3.075154 14.799966,3.074695 
	C531.439392,3.018962 1048.078857,3.020799 1565.583008,3.014215 
	C1575.959961,10.529193 1584.730957,18.871075 1589.606323,30.137035 
	C1591.922974,35.490253 1588.598145,40.047722 1583.416260,42.146523 
	C1575.983887,45.156849 1574.572144,50.170826 1576.684204,57.352966 
	C1578.607178,63.892189 1578.846069,69.939590 1570.340698,72.520668 
	C1560.303589,75.566528 1551.562744,73.372787 1548.314209,66.509979 
	C1544.390747,58.221031 1546.276489,52.212605 1554.568604,47.294479 
	C1558.638794,44.880459 1563.265625,42.898327 1561.730347,36.875057 
	C1561.050781,34.209347 1558.652222,33.516266 1556.120850,33.857803 
	C1550.458252,34.621807 1548.861450,38.242146 1548.256958,43.601360 
	C1547.021362,54.554852 1538.089722,59.184341 1527.964478,54.696316 
	C1524.884033,53.330956 1522.488647,50.888451 1519.571777,49.295753 
	C1511.722168,45.009495 1507.143433,47.147861 1505.926514,56.061024 
	C1505.020996,62.692928 1501.338013,66.998367 1495.869141,70.070915 
	C1491.406738,72.577988 1488.788208,76.087631 1488.864990,81.285172 
	C1488.984985,89.403564 1485.092407,94.527077 1477.396484,96.764717 
	C1472.303467,98.245514 1470.323975,101.053635 1472.074951,106.439949 
	C1473.598633,111.127052 1475.754028,116.370705 1470.307007,120.043030 
	C1464.804443,123.752701 1458.978638,122.903091 1453.154053,120.331253 
	C1447.856201,117.992035 1444.722778,110.994293 1437.604004,112.727760 
	C1430.227661,114.523926 1431.154419,122.155502 1428.109985,127.004044 
	C1420.794434,138.654007 1407.220825,138.837479 1400.522827,127.284531 
	C1399.201660,125.005547 1398.409424,121.947662 1394.844238,123.097137 
	C1392.100220,123.981812 1390.331543,126.014091 1390.695312,129.141449 
	C1391.137939,132.946609 1393.890137,133.466553 1397.144409,133.924179 
	C1406.676880,135.264664 1410.533691,139.486084 1410.430664,147.816833 
	C1410.309448,157.632828 1402.653320,162.234970 1394.056274,157.637726 
	C1392.287842,156.692078 1390.792236,155.334488 1389.162354,154.179596 
	C1378.465332,146.599991 1371.797241,148.961014 1368.167725,161.577896 
	C1364.788086,173.326523 1354.806641,177.289062 1346.219238,170.291000 
	C1337.791992,163.423340 1338.541504,154.645966 1348.131714,149.603439 
	C1352.496338,147.308563 1358.033447,146.204468 1357.270508,139.481003 
	C1356.906738,136.275681 1357.180298,132.005539 1352.889771,131.530609 
	C1348.475220,131.041962 1344.246948,133.745026 1344.549438,138.199051 
	C1345.238770,148.347977 1341.536865,155.162308 1333.027710,160.674500 
	C1327.744019,164.097275 1328.987061,169.901657 1334.790283,173.549713 
	C1337.604370,175.318649 1341.088501,175.777756 1343.736816,177.928726 
	C1348.737915,181.990723 1349.951660,189.792038 1346.402344,195.091248 
	C1342.805664,200.461212 1336.642822,201.680954 1330.793457,196.594467 
	C1324.063843,190.742477 1317.314209,186.433548 1308.089844,185.632858 
	C1302.877930,185.180466 1300.996704,179.968750 1300.357178,175.131119 
	C1299.542969,168.971909 1301.758057,163.912491 1307.107666,160.616974 
	C1311.965454,157.624313 1315.549072,154.256668 1314.377075,147.787003 
	C1313.492554,142.904053 1311.878540,141.038498 1306.325317,142.592453 
	C1293.775879,146.104141 1293.258301,145.670563 1285.230103,134.309402 
	C1283.162354,131.383209 1280.722046,129.213577 1277.168945,129.117752 
	C1269.169067,128.901947 1263.304321,125.132324 1258.578491,118.974335 
	C1256.482666,116.243507 1253.897217,114.006439 1250.041016,115.518051 
	C1246.383057,116.951904 1245.222168,120.044044 1245.550293,123.616737 
	C1246.392578,132.785431 1242.983154,139.098587 1234.000366,142.159286 
	C1229.103394,143.827789 1227.873047,147.676086 1228.247803,152.527267 
	C1228.786621,159.498840 1225.608765,164.224915 1218.704712,165.667297 
	C1211.647583,167.141632 1206.392578,163.820480 1202.593262,158.115738 
	C1199.241455,153.082703 1200.688721,148.666412 1204.846680,144.765747 
	C1207.305420,142.459183 1210.348877,141.020538 1213.032471,139.053009 
	C1216.333984,136.632446 1216.328247,133.555725 1214.808838,130.172607 
	C1213.462646,127.175880 1211.398193,125.241547 1207.864746,125.621536 
	C1204.092163,126.027222 1201.163086,128.063919 1201.276001,131.865448 
	C1201.568848,141.724060 1198.683350,149.289093 1189.104614,153.702087 
	C1186.171875,155.053238 1186.542603,158.850647 1186.425659,161.863617 
	C1186.192261,167.871567 1184.590088,173.354996 1178.376953,175.574203 
	C1171.909424,177.884247 1165.481445,176.850601 1160.981934,171.486206 
	C1155.997192,165.543182 1151.215942,161.781693 1142.468872,163.149307 
	C1135.535645,164.233337 1132.280640,157.791962 1130.452393,151.820465 
	C1128.701416,146.101730 1128.449463,139.712555 1134.347656,136.655350 
	C1141.976440,132.701065 1145.760254,127.782272 1145.806030,118.865242 
	C1145.841675,111.948296 1151.581543,108.735329 1158.013062,107.723190 
	C1163.667847,106.833313 1168.673706,107.912025 1171.479492,113.737930 
	C1174.551636,120.117126 1174.186890,125.964310 1169.014160,131.164795 
	C1166.865723,133.324799 1164.203613,134.727768 1161.624512,136.250046 
	C1157.947510,138.420425 1156.709473,141.563965 1157.991089,145.591049 
	C1159.028564,148.851013 1161.388916,150.616882 1164.813843,150.157120 
	C1168.936401,149.603714 1173.937866,148.011536 1173.361084,143.430618 
	C1171.912109,131.921051 1177.513794,126.206474 1187.247314,122.345383 
	C1191.118042,120.809982 1190.079590,116.762085 1189.690308,113.474808 
	C1188.802979,105.981148 1191.262329,100.412201 1198.575195,97.463554 
	C1206.194214,94.391510 1211.368896,97.754593 1215.644531,103.750893 
	C1218.147339,107.260918 1220.408447,111.486702 1225.879395,109.741089 
	C1231.189087,108.046913 1231.031006,103.276688 1231.245850,98.993767 
	C1231.607544,91.787498 1235.136230,87.016403 1241.922119,84.917152 
	C1247.585693,83.165131 1249.930542,80.363655 1248.666382,73.921196 
	C1246.875610,64.795105 1252.464478,59.732582 1260.413696,56.718258 
	C1263.446167,55.568317 1267.477539,54.970387 1265.654419,50.116646 
	C1264.221924,46.302944 1262.457520,42.408726 1257.221191,43.387207 
	C1252.922485,44.190483 1250.785400,47.126492 1251.563965,51.359306 
	C1252.946899,58.876373 1249.634277,63.507332 1243.171143,66.505302 
	C1236.942139,69.394661 1234.633423,74.412666 1234.743042,81.056496 
	C1234.827881,86.195732 1234.048340,91.247292 1228.723633,93.830261 
	C1222.726807,96.739349 1216.333130,98.273491 1211.112305,92.849617 
	C1205.824341,87.356049 1206.388306,80.712326 1209.786987,74.312317 
	C1211.531616,71.026993 1214.627075,68.849716 1217.224976,66.273132 
	C1220.436523,63.088120 1221.831299,59.342659 1218.428345,55.711617 
	C1214.953369,52.003777 1211.128052,53.898525 1207.641235,56.254791 
	C1206.815430,56.812859 1205.618774,57.564323 1205.593262,58.358433 
	C1205.150024,72.189720 1191.497070,80.451279 1190.605713,94.047874 
	C1190.112793,101.563805 1185.113770,105.042892 1178.761719,107.249039 
	C1172.495239,109.425522 1167.753784,106.884445 1163.774658,102.178726 
	C1162.913696,101.160492 1162.098633,100.104164 1161.226318,99.096466 
	C1158.808105,96.302818 1156.314209,92.969490 1152.143921,94.168472 
	C1147.360718,95.543617 1148.465820,100.018028 1148.710083,103.493576 
	C1149.316650,112.122673 1145.702393,117.492767 1137.333618,119.777260 
	C1128.179199,122.276199 1123.341553,120.250702 1117.798706,110.963303 
	C1116.004639,107.957237 1114.204346,105.366600 1110.380371,105.073044 
	C1105.222412,104.677086 1101.013184,105.741707 1103.650879,112.115952 
	C1107.600586,121.660690 1103.689087,127.296898 1095.499146,131.572662 
	C1090.819214,134.015961 1087.539185,137.888062 1087.183838,143.303177 
	C1086.693481,150.775070 1083.155151,155.666077 1076.345459,158.641800 
	C1072.164307,160.468842 1068.607788,163.129562 1070.850464,168.625793 
	C1072.436646,172.512909 1074.589111,176.002228 1079.630615,174.994568 
	C1085.202759,173.880875 1087.526733,169.898285 1086.692871,164.665070 
	C1085.229370,155.479736 1089.921631,150.990051 1097.833862,148.525375 
	C1106.191406,145.922012 1111.340820,149.821335 1114.491455,157.116455 
	C1116.732178,162.304565 1120.115234,163.857620 1125.621094,162.438141 
	C1133.476074,160.413010 1138.428955,164.374222 1141.229980,171.396423 
	C1144.198120,178.838013 1142.366089,185.078003 1135.101074,189.280869 
	C1128.854736,192.894409 1124.498657,197.012009 1124.650757,204.804733 
	C1124.776245,211.239563 1121.623535,215.537140 1115.112061,217.031845 
	C1110.497803,218.091049 1105.652344,219.460526 1102.284058,214.789337 
	C1098.452148,209.475006 1098.543335,203.517776 1101.047607,197.662994 
	C1102.786255,193.598297 1106.421387,190.920425 1109.143066,187.569229 
	C1112.019287,184.027588 1114.129028,180.113678 1111.160278,175.770630 
	C1108.788208,172.300308 1105.188232,173.802032 1101.991211,174.560760 
	C1096.854126,175.779953 1096.234985,179.547226 1097.070312,183.886429 
	C1098.240479,189.964798 1096.787720,195.073898 1092.038940,199.191254 
	C1084.512817,205.716827 1078.229370,205.258163 1073.201782,196.723526 
	C1069.129517,189.810379 1064.776978,185.173950 1055.883789,186.531998 
	C1050.460571,187.360138 1046.271118,184.552612 1043.968384,179.328995 
	C1043.030029,177.200455 1042.084229,175.007843 1040.277832,173.440964 
	C1037.338257,170.891312 1034.102417,171.316040 1030.958862,172.944931 
	C1028.239380,174.354004 1027.371582,176.804184 1028.034058,179.711273 
	C1028.840576,183.249725 1030.782593,186.519241 1034.693726,185.786438 
	C1045.441895,183.772614 1051.643433,188.274536 1055.626099,197.975906 
	C1057.721436,203.080063 1062.876221,203.340576 1067.736938,202.513992 
	C1074.907715,201.294586 1079.478271,203.788391 1080.724365,211.221481 
	C1081.894409,218.199921 1086.364990,219.538971 1092.480591,218.397186 
	C1097.256836,217.505432 1101.737915,217.651047 1105.240479,221.856918 
	C1109.966675,227.532196 1110.690186,235.951904 1106.631958,240.211472 
	C1101.517090,245.580154 1090.758057,246.236755 1085.989258,240.033447 
	C1080.327515,232.668610 1074.010498,228.308701 1064.667114,227.457870 
	C1059.844727,227.018753 1057.019531,222.435074 1054.023682,218.856857 
	C1051.194946,215.478348 1047.856567,213.760498 1043.466919,215.535202 
	C1039.084595,217.306931 1039.093994,221.036682 1039.722656,224.792938 
	C1040.847412,231.514526 1039.367310,236.729538 1032.219971,239.036697 
	C1025.054932,241.349594 1018.395569,241.476685 1013.299988,234.721603 
	C1012.697815,233.923370 1012.071411,233.142426 1011.498962,232.322952 
	C1008.867126,228.554657 1005.883911,225.705200 1000.690674,227.328384 
	C995.996155,228.795761 994.915894,232.419189 994.766541,236.667953 
	C994.550781,242.805832 992.161743,247.599472 986.489380,250.463257 
	C979.710876,253.885483 973.356812,252.364746 970.033264,246.487808 
	C965.789124,238.983170 967.454224,231.363373 974.025085,227.278641 
	C977.876953,224.884109 985.157715,225.440872 983.691101,218.084930 
	C982.242859,210.821442 975.826050,210.990524 970.131287,210.639175 
	C964.243530,210.275909 959.963867,207.422409 957.621460,202.099716 
	C954.842041,195.784332 950.687866,192.815796 943.481323,194.190750 
	C936.872253,195.451721 931.738037,192.949524 928.831726,186.552689 
	C927.726196,184.119446 926.517883,181.583725 923.922363,180.450211 
	C920.912903,179.135910 917.968933,179.816605 915.543701,181.938873 
	C912.984497,184.178329 912.787842,187.157455 913.745056,190.205475 
	C914.903748,193.895096 917.964783,194.557861 921.000427,193.575394 
	C930.701294,190.435822 937.093018,193.213943 940.409668,203.106262 
	C941.974609,207.773743 946.005188,208.180237 950.317688,207.679749 
	C957.769165,206.814941 964.444031,207.702988 967.463501,216.038559 
	C970.276184,223.803314 967.939880,230.431259 959.777771,236.689087 
	C955.947449,239.625732 951.909180,242.288773 954.181152,248.018402 
	C956.326782,253.429688 960.977478,252.487946 965.276428,251.919724 
	C972.022400,251.028091 976.341125,253.704346 977.745178,260.385193 
	C979.080505,266.739227 980.004883,273.248779 972.886108,277.096222 
	C966.916443,280.322601 960.908142,281.351013 955.455933,275.846375 
	C953.797913,274.172546 952.408142,272.306885 951.333801,270.224335 
	C949.409058,266.493073 947.488403,263.047241 942.212463,265.219025 
	C937.370300,267.212250 935.667542,270.467102 937.125977,275.520752 
	C939.036255,282.140045 938.064697,287.352753 930.415833,289.598419 
	C922.599915,291.893158 915.898804,289.769135 912.120850,283.418091 
	C907.823669,276.194214 909.205322,269.647430 916.941284,266.105591 
	C923.040100,263.313354 925.649902,259.388092 925.229126,252.964233 
	C924.676025,244.519821 929.499207,239.473450 936.102356,235.293121 
	C940.110046,232.755936 940.647888,228.823624 938.277039,224.801346 
	C935.687622,220.408356 931.676331,221.031540 927.681580,222.378159 
	C924.033630,223.607895 923.926880,226.624481 924.200378,229.756409 
	C924.957153,238.425247 921.681213,244.783035 913.344666,247.894241 
	C908.575500,249.674118 907.870300,253.089264 908.447449,257.470428 
	C909.529602,265.684631 907.785950,272.702240 899.993042,277.192657 
	C895.704956,279.663483 894.687012,283.886139 894.851318,288.405487 
	C895.130859,296.093384 891.830383,301.335632 884.433044,303.451385 
	C877.607849,305.403473 875.532593,309.517365 877.065857,316.244385 
	C878.195679,321.201263 879.046997,326.717590 873.128601,329.284698 
	C867.375732,331.780060 861.364075,331.497406 855.991455,327.716583 
	C853.239929,325.780273 851.293030,323.018158 849.227234,320.399048 
	C847.099121,317.700745 844.843689,315.117188 840.868469,316.855255 
	C837.505066,318.325867 835.075500,321.047485 835.775513,324.637360 
	C837.647949,334.238892 834.893982,340.665985 825.311035,344.292267 
	C821.066956,345.898285 820.422607,350.376984 821.499207,354.608368 
	C822.287415,357.706329 824.778259,357.467010 827.160522,356.787354 
	C831.314880,355.602203 834.553955,353.617737 834.022705,348.488953 
	C833.374634,342.231750 833.318298,336.005646 840.990479,333.973114 
	C847.703186,332.194794 853.430725,334.235443 857.912781,339.730713 
	C863.195801,346.208130 862.933716,352.750549 855.210083,356.171204 
	C845.697754,360.384003 843.980164,366.033386 847.238037,375.034668 
	C848.791626,379.327209 846.882080,382.827332 842.573975,384.796204 
	C840.452026,385.765930 838.244690,386.536957 836.174194,387.624084 
	C832.430664,389.589630 830.966492,392.586731 831.964111,396.739288 
	C833.021057,401.138794 835.982178,402.703125 840.187439,401.972534 
	C847.836792,400.643616 853.157043,403.524048 856.374390,410.502045 
	C858.816223,415.798096 863.330505,416.919830 868.689697,417.279327 
	C878.778625,417.955994 883.752136,424.853210 881.880615,434.847198 
	C880.471252,442.373505 871.394287,446.862732 865.865479,441.483978 
	C857.765930,433.604248 849.589966,428.809143 837.932861,430.112823 
	C833.184143,430.643921 830.462036,426.382080 828.779541,422.103394 
	C827.374146,418.529449 825.453125,415.447449 821.112976,415.216583 
	C815.740845,414.930878 811.086182,416.153229 813.162292,422.928009 
	C816.354187,433.343567 813.452881,440.337860 803.331177,444.631531 
	C799.852051,446.107361 798.711548,449.407501 800.321960,453.035950 
	C801.391235,455.445160 803.588928,456.249847 806.152100,455.865448 
	C810.113708,455.271454 811.465576,452.882782 811.765686,448.943176 
	C812.666565,437.117371 816.271729,433.575928 826.217102,433.733093 
	C831.027832,433.809143 834.556091,435.829834 836.644348,440.149323 
	C838.697998,444.397003 838.553406,448.517273 835.539368,452.348297 
	C833.471436,454.976776 830.955139,457.182861 828.708374,459.642883 
	C825.883667,462.735718 824.779541,466.205444 828.166809,469.309540 
	C832.115173,472.927887 835.563354,470.449158 838.492493,467.370056 
	C840.384033,465.381622 841.042297,462.711334 841.655273,460.113342 
	C843.155823,453.753296 846.259277,449.001648 853.400391,448.349640 
	C858.154480,447.915558 861.972534,449.763580 864.337463,453.888458 
	C868.039062,460.344543 866.355896,466.042542 861.020874,471.701233 
	C858.374146,476.209961 855.323303,479.684113 853.822754,484.781067 
	C853.097900,486.498077 852.433777,487.553772 853.229492,489.207916 
	C854.348328,489.998169 855.002197,490.450958 856.059692,491.393494 
	C856.568848,492.272491 856.656982,492.686920 856.557068,493.715637 
	C855.191406,495.668243 853.555481,496.288696 851.482178,497.427490 
	C849.806335,498.413971 848.646912,498.992157 846.896240,499.833160 
	C842.267822,501.508179 838.341492,503.115631 834.820801,506.755859 
	C831.748840,509.031952 828.867554,510.288696 825.373535,511.833893 
	C821.620056,512.935425 819.024170,514.744629 815.804382,516.884155 
	C814.169983,517.255798 813.222717,517.151550 811.677673,516.466125 
	C807.783936,511.298676 802.921265,512.638123 798.330383,512.663208 
	C792.596863,512.694519 786.439941,512.855957 784.252747,505.951904 
	C782.010071,498.872742 783.880859,492.860779 790.309021,488.523407 
	C794.648621,485.595184 799.672974,483.285797 796.680054,476.037750 
	C794.672668,471.176239 792.727356,467.993469 786.802917,468.516815 
	C778.863770,469.218201 773.288574,465.787506 770.926697,457.867126 
	C768.347778,449.218445 773.780762,444.320587 780.102539,441.121002 
	C785.362793,438.458710 787.431213,435.228455 787.443787,429.617798 
	C787.458252,423.172119 791.334534,418.506042 795.646667,414.143494 
	C798.041504,411.720642 802.237549,410.192841 800.233887,405.313507 
	C798.305542,400.617340 794.557922,398.859253 789.942810,398.916931 
	C781.642700,399.020630 775.840881,395.940796 773.337891,387.570282 
	C771.605408,381.776459 770.704956,376.553162 777.161011,372.808258 
	C786.355896,367.474640 793.761108,367.477753 799.007385,373.152710 
	C801.521912,375.872742 802.696411,379.500122 805.218750,382.189148 
	C807.559021,384.684021 810.460632,385.240387 813.378296,383.556091 
	C816.380249,381.823120 816.839478,378.856476 816.102478,375.678619 
	C815.278992,372.127808 812.959778,370.588959 809.455261,371.426331 
	C799.087402,373.903595 793.096985,368.426605 788.473572,360.211945 
	C786.473450,356.658264 784.425903,352.952393 779.247314,354.937073 
	C774.823792,356.632416 773.344971,359.960785 774.054199,364.503571 
	C775.246216,372.139618 774.040955,378.300568 765.398926,381.119934 
	C761.362610,382.436737 759.857910,386.628296 758.923462,390.561981 
	C758.308228,393.151825 757.906189,395.793427 756.967102,398.297943 
	C755.122131,403.218048 752.435242,407.363953 746.604553,407.822998 
	C742.128174,408.175415 738.839539,405.898163 736.974915,401.992004 
	C734.547241,396.906219 735.860718,392.311249 739.497009,388.179321 
	C742.944336,384.262177 747.204285,381.060669 747.189453,374.799957 
	C747.173462,368.030518 745.836731,364.240967 737.756409,364.507751 
	C725.925537,364.898407 721.528259,361.842651 720.087585,354.150940 
	C718.986816,348.273834 720.794312,343.550476 726.331421,340.805298 
	C732.894287,337.551605 738.800354,339.978333 745.468994,348.683502 
	C748.005798,351.994995 750.467407,355.197876 755.280273,353.580933 
	C759.735962,352.083984 762.889709,349.170349 762.972351,344.205902 
	C763.084412,337.473633 765.627747,332.363739 770.576294,327.593994 
	C776.898560,321.500153 774.876282,314.809998 766.462219,313.003082 
	C759.264465,311.457397 752.210938,309.728363 750.888794,301.383606 
	C749.606750,293.291382 753.775269,287.362946 760.897644,283.466675 
	C763.287354,282.159393 765.531982,280.576996 764.753784,277.252686 
	C764.272339,275.196198 763.159180,273.371429 761.097168,272.873322 
	C758.528381,272.252808 757.387024,274.330048 757.222290,276.326874 
	C756.475708,285.374207 750.768616,290.551147 743.512512,294.680237 
	C741.775452,295.668732 740.271912,297.038849 739.017273,298.610626 
	C737.096130,301.017120 735.469360,303.617249 736.870972,306.822327 
	C738.492432,310.530304 741.690247,309.436005 744.654541,309.185150 
	C755.834167,308.239166 761.059082,313.120483 760.548096,323.771332 
	C760.241455,330.163422 757.078125,334.325867 751.194763,336.622498 
	C745.075684,339.011230 739.793152,337.571625 736.173218,332.343994 
	C732.132629,326.508850 727.372986,322.988403 720.001892,322.208221 
	C711.810303,321.341217 708.710754,314.754730 706.981445,307.605591 
	C705.344482,300.838226 710.249084,298.176849 714.932312,295.388824 
	C718.655029,293.172638 723.057739,291.051086 721.901123,285.664398 
	C720.687561,280.012451 715.837036,278.692108 711.013123,278.986786 
	C701.679810,279.556854 694.573242,275.226562 687.740845,268.657196 
	C688.280701,275.048645 688.280701,275.048676 692.906372,276.067261 
	C701.725952,278.009399 708.860352,287.399109 707.916260,296.134155 
	C707.167480,303.061707 702.436523,304.704742 696.417236,304.020844 
	C691.711060,303.486115 687.720398,300.724243 683.246948,299.418518 
	C674.600098,296.894623 671.632568,298.115112 669.080688,306.668396 
	C667.457886,312.107666 664.640320,316.294800 660.112305,319.423645 
	C655.461975,322.636963 652.708801,326.579071 652.464172,332.586548 
	C652.177856,339.616089 647.448914,343.183655 640.822571,344.210510 
	C635.118164,345.094482 629.977417,343.810333 627.176880,338.297089 
	C623.932556,331.910156 626.454346,326.738586 631.508057,322.417938 
	C633.279602,320.903290 635.083984,319.403229 636.384277,317.433105 
	C638.510376,314.211975 639.744812,310.598724 637.860168,307.065826 
	C635.562744,302.759277 631.523987,304.894287 628.000244,305.157654 
	C622.366028,305.578796 615.647888,313.318817 611.689270,307.008820 
	C606.510376,298.753876 608.422546,288.373901 611.079346,278.923737 
	C611.881531,276.070251 614.708923,274.149353 614.563965,270.136810 
	C610.486816,276.845764 604.988953,281.051849 597.269348,282.021271 
	C591.261169,282.775757 585.948975,282.498138 582.419006,276.657196 
	C581.206665,274.651184 579.677612,272.855530 577.318604,272.078949 
	C574.625793,271.192444 572.004089,271.359985 569.746643,273.155670 
	C567.517212,274.928955 568.230469,277.276794 568.767029,279.591583 
	C571.920471,293.195374 571.931030,293.250793 558.687073,299.630157 
	C555.351013,301.237000 553.197998,303.380371 553.565735,307.279541 
	C553.833435,310.117645 555.113464,312.452759 557.862610,313.511536 
	C560.460205,314.511993 562.436096,313.074554 563.878418,311.111420 
	C567.233032,306.545471 570.549133,301.940002 574.331848,297.727753 
	C580.973877,290.331543 586.333984,290.671997 592.137390,298.693176 
	C593.700623,300.853760 595.028564,303.178864 596.156616,305.595825 
	C598.848999,311.364685 597.673645,315.304932 590.857483,316.459503 
	C589.213928,316.737885 587.541504,316.792725 585.896790,317.055420 
	C581.299622,317.789642 577.150879,319.269623 577.591553,324.994354 
	C577.996643,330.258240 582.295166,331.809906 586.304871,330.969879 
	C602.568359,327.562744 609.914673,342.579529 621.891785,347.937866 
	C625.961365,349.758545 625.045837,355.688568 623.132141,359.815125 
	C620.936890,364.548553 616.448364,367.591278 611.760559,365.953796 
	C599.254395,361.585297 584.539001,360.552643 577.846436,346.045593 
	C576.269287,342.626923 574.048218,339.655762 569.468018,340.418365 
	C564.745117,341.204712 560.968933,343.744324 560.282410,348.406891 
	C558.981262,357.243530 556.104675,364.940430 549.403809,371.205383 
	C547.216431,373.250427 546.932983,376.691284 548.891968,379.545776 
	C550.339050,381.654358 552.533386,382.404724 555.031067,382.001495 
	C558.463196,381.447388 560.113525,379.128204 560.751038,375.910522 
	C560.945312,374.929657 560.993835,373.927399 561.122437,372.937256 
	C562.934387,358.983734 574.210205,354.329834 585.587036,363.186890 
	C591.599548,367.867706 596.801819,373.453552 603.760315,377.065552 
	C608.539001,379.546082 609.806946,384.777100 606.697754,389.110321 
	C603.137756,394.071869 598.132935,392.328674 594.674805,388.615784 
	C590.190796,383.801483 586.069397,380.569305 579.221619,384.492523 
	C574.123596,387.413300 570.688538,390.739471 571.670227,397.092102 
	C572.495483,402.432892 570.928894,407.058289 566.783630,410.547943 
	C561.850403,414.700928 557.926880,419.483582 555.612183,425.591461 
	C554.666260,428.087524 552.945740,430.377594 550.757629,431.853577 
	C542.865601,437.177094 537.097717,442.573639 537.355713,453.936615 
	C537.554382,462.683777 523.588562,466.396973 514.768921,461.321777 
	C511.168274,459.249786 506.684204,453.019531 503.334259,459.347656 
	C500.853241,464.034393 506.697540,467.248474 511.157990,469.013947 
	C515.196106,470.612274 518.531860,472.654510 517.614868,477.657867 
	C516.714539,482.570190 513.001404,484.780792 508.516144,485.769623 
	C504.050812,486.754120 500.089294,484.679626 495.921783,483.534576 
	C487.685699,481.271576 484.278595,483.822327 485.590607,492.291901 
	C486.838257,500.346130 482.085022,503.792633 476.272034,507.966919 
	C474.386536,509.822510 472.918671,511.070648 471.274048,513.159058 
	C468.472137,523.174438 465.614105,531.993896 454.646515,535.248108 
	C450.573883,536.456421 450.670502,541.008301 450.780884,544.690369 
	C450.960938,550.697815 449.080536,555.751587 443.989044,560.286743 
	C442.382050,561.912781 441.134888,562.777344 439.176270,563.931763 
	C433.110077,566.430847 433.258972,571.285522 432.589752,575.922546 
	C431.375702,584.335144 426.387695,588.194092 418.177002,587.490662 
	C409.897736,586.781250 407.056488,582.968750 408.478607,574.806885 
	C409.442261,569.276184 412.555511,565.107910 416.247192,561.140564 
	C418.484009,558.736816 418.978821,555.817505 417.113159,552.884460 
	C416.150909,551.371704 414.642731,550.586670 412.838135,551.111633 
	C409.436218,552.101257 407.868835,554.887512 408.200439,557.989075 
	C409.114288,566.537476 405.750214,572.619507 399.016479,577.659058 
	C394.829895,580.792297 395.996002,585.376465 397.798370,589.558777 
	C400.952271,596.877136 397.891083,599.742249 390.641876,600.951294 
	C377.639191,603.119751 377.684906,603.394043 381.031860,616.267761 
	C383.397827,625.368225 381.206116,628.927979 371.423004,630.706482 
	C364.393860,631.984253 359.401215,633.976257 358.026337,642.576721 
	C356.470551,652.308777 346.738525,655.292114 337.689819,649.850525 
	C333.725647,647.466736 330.412170,643.866333 325.498016,643.347839 
	C322.532562,643.034973 319.121002,642.475525 317.904694,646.230957 
	C316.697784,649.957397 318.337433,653.579163 321.962280,654.115295 
	C332.990265,655.746277 339.548889,662.543701 344.864044,671.520020 
	C346.701263,674.622681 349.881958,675.263672 353.651031,674.344177 
	C359.154480,673.001465 364.462158,673.347412 367.074371,679.631958 
	C368.592010,683.283142 368.598267,687.223572 365.354675,689.736694 
	C360.361725,693.605347 354.303375,695.099548 348.524963,692.079956 
	C343.137756,689.264771 339.338562,682.749146 331.874603,685.331543 
	C325.216919,687.634949 324.895386,694.593079 321.839996,699.546814 
	C314.997589,710.640259 306.646698,711.899902 295.858429,703.551086 
	C294.379395,702.406433 292.806213,700.188660 290.822174,702.014038 
	C289.067810,703.628113 290.365875,705.734131 291.429779,707.429016 
	C292.319183,708.845947 293.652435,709.889526 294.841370,711.056213 
	C305.676971,721.689087 304.755676,734.880981 291.342834,742.202332 
	C282.004150,747.299927 274.255341,756.539795 261.822052,755.218872 
	C258.172150,754.831116 256.994080,758.289917 256.987549,761.537659 
	C256.970032,770.248657 252.195419,775.064026 244.229538,777.115295 
	C237.383911,778.877991 234.876404,782.726440 237.278961,789.599487 
	C240.225937,798.029968 237.095535,803.790527 228.711884,807.836182 
	C226.427780,810.510376 224.890671,812.804382 223.925232,816.223389 
	C222.943726,825.050720 218.702774,830.221863 210.826874,832.769409 
	C205.341629,834.543640 203.144501,838.786438 204.049637,844.470825 
	C205.200241,851.696777 202.831543,856.789551 195.684875,859.417725 
	C191.110794,861.099792 189.175568,864.791138 188.839706,869.496765 
	C188.329468,876.645508 185.085754,882.119385 178.854156,885.809631 
	C176.527069,887.187744 173.902649,889.086609 173.611176,891.604187 
	C171.791168,907.324768 159.381943,917.412292 153.097519,930.771118 
	C146.715042,944.338257 135.461594,954.810120 127.069130,967.187195 
	C123.186745,972.912781 118.585464,978.261597 114.409462,983.859436 
	C109.450226,990.507263 103.631866,993.730469 95.653122,988.555237 
	C93.988564,987.475586 92.091393,986.761292 90.107727,986.361694 
	C87.635468,985.863647 85.456192,986.173035 84.006561,988.515625 
	C82.785812,990.488525 83.553535,992.297974 84.429382,994.155762 
	C85.910919,997.298401 88.977104,998.953064 91.118462,1001.475403 
	C95.088448,1006.151611 93.732567,1010.708191 90.987160,1015.273315 
	C88.091972,1020.087646 84.114021,1019.725159 79.757378,1017.607056 
	C77.962807,1016.734558 76.161140,1015.829712 74.166092,1015.515442 
	C70.994461,1015.015808 67.864098,1015.319824 66.644249,1018.737610 
	C65.518463,1021.891968 68.098389,1023.545837 70.382812,1024.975708 
	C73.217850,1026.750122 76.382523,1027.816040 79.475822,1029.052002 
	C87.316460,1032.184937 90.038918,1037.419678 87.154472,1043.484253 
	C84.339478,1049.402832 76.303047,1051.652954 69.891205,1048.333862 
	C67.191315,1046.936279 65.380768,1044.376099 62.777428,1042.882568 
	C58.942135,1040.682251 55.663513,1041.630127 53.256535,1045.156982 
	C51.037731,1048.408203 51.585773,1051.477295 54.680664,1053.945557 
	C57.532917,1056.220215 60.812965,1057.961792 63.114075,1060.916626 
	C66.290047,1064.994873 65.915390,1068.992065 62.591595,1072.651489 
	C59.066547,1076.532593 55.501896,1075.213257 52.142979,1072.211060 
	C50.657345,1070.883179 49.378567,1069.261230 47.552288,1068.401245 
	C43.704330,1066.589233 40.188492,1067.528687 37.763649,1070.764648 
	C35.424515,1073.886230 36.418320,1077.193848 39.096642,1079.732056 
	C41.501862,1082.011475 44.443211,1083.720215 46.573509,1086.313110 
	C49.286701,1089.615356 51.041195,1093.247803 47.801033,1097.081055 
	C44.802364,1100.628662 41.239307,1099.270508 37.835846,1097.483887 
	C37.247177,1097.174805 36.711079,1096.772217 36.140778,1096.430054 
	C25.382088,1089.976562 20.905973,1092.041626 18.812010,1104.418823 
	C16.919413,1115.605713 13.783651,1118.103394 2.552839,1116.464600 
	C2.000000,1107.950928 2.000000,1099.901855 2.000000,1090.926392 
	C5.494483,1086.608643 6.089411,1082.961548 2.485585,1078.493530 
	C2.000000,1074.571289 2.000000,1071.142578 2.000000,1066.856934 
	C5.051178,1062.787720 9.259156,1063.590088 13.015535,1062.831299 
	C18.238003,1061.776367 21.653467,1058.810181 20.326674,1053.313232 
	C18.932833,1047.538330 14.332916,1049.886841 10.671449,1050.732544 
	C8.123701,1051.320923 5.637278,1052.241577 2.534183,1050.451660 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2561.388184,131.548676 
	C2562.000000,138.061188 2562.000000,144.122375 2562.000000,151.091782 
	C2557.528564,156.502121 2557.645996,162.012268 2558.364746,167.754639 
	C2559.117188,173.764771 2557.976074,178.963608 2551.689941,181.755692 
	C2547.041992,183.820236 2542.063232,186.175217 2543.921143,192.548981 
	C2545.638184,198.440033 2550.786621,199.008347 2556.042236,198.652069 
	C2557.697021,198.539886 2559.344971,198.455048 2561.461914,199.558548 
	C2562.000000,207.385818 2562.000000,214.771637 2562.000000,223.078735 
	C2552.399902,233.399551 2552.271973,236.104980 2561.502441,245.516174 
	C2562.000000,262.708466 2562.000000,279.416931 2562.000000,297.062683 
	C2561.529541,298.472687 2561.029541,298.910217 2560.501953,299.315155 
	C2557.750244,301.427368 2552.607422,301.158081 2552.511719,305.823639 
	C2552.403076,311.109467 2558.259521,310.501831 2561.504150,313.534180 
	C2562.000000,346.708466 2562.000000,379.416901 2562.000000,413.062683 
	C2554.725586,419.314972 2557.388916,425.111237 2561.589355,431.481018 
	C2562.000000,432.000000 2562.000000,433.000000 2562.000000,433.500000 
	C2558.312012,437.628143 2553.228027,436.410614 2548.885986,437.771912 
	C2545.389893,438.867889 2541.339355,439.602875 2541.730957,444.497559 
	C2542.126221,449.439178 2545.244385,452.131653 2550.100342,452.854462 
	C2553.700439,453.390350 2557.353271,451.754791 2561.465820,453.561554 
	C2562.000000,462.049103 2562.000000,470.098175 2562.000000,479.073639 
	C2561.069824,480.904175 2560.235107,481.896759 2559.352783,482.844849 
	C2551.561768,491.217072 2551.700684,492.639343 2561.502930,499.532440 
	C2562.000000,523.375122 2562.000000,546.750244 2562.000000,571.062683 
	C2557.091553,576.155701 2551.594482,574.935791 2547.034180,572.259277 
	C2538.045654,566.983582 2528.323242,568.588501 2518.818848,567.878052 
	C2515.843750,567.655579 2513.533936,568.902649 2512.235107,571.492676 
	C2509.163574,577.618164 2504.231201,578.924072 2498.009277,577.477295 
	C2489.518799,575.502991 2483.025391,578.432922 2478.246338,585.608521 
	C2476.957275,587.544495 2475.406250,589.310547 2473.715332,590.922974 
	C2466.893066,597.428162 2462.501221,597.096985 2456.427490,589.613220 
	C2455.416992,588.368042 2454.909424,586.633240 2452.263672,586.129944 
	C2450.723145,591.310303 2454.247314,594.666382 2456.581055,598.288269 
	C2459.681641,603.101013 2460.922607,607.954468 2457.905762,613.286011 
	C2453.757812,620.616089 2447.520752,621.606567 2442.039307,615.163330 
	C2438.988770,611.577820 2436.069336,609.225586 2431.129883,609.740112 
	C2424.423096,610.438721 2420.445801,604.965210 2415.236572,602.257080 
	C2411.778809,600.459534 2407.731934,597.286316 2404.556152,601.572937 
	C2401.477539,605.728088 2404.118164,609.791870 2407.342773,613.064575 
	C2409.218994,614.968933 2411.583496,616.281372 2413.655029,617.952576 
	C2417.437012,621.003967 2421.006348,624.388489 2418.157471,629.736084 
	C2415.232178,635.226990 2409.919189,635.308655 2405.052490,633.507263 
	C2397.874756,630.850159 2391.192383,627.024048 2385.221680,622.117859 
	C2382.130127,619.577332 2379.023438,617.035461 2375.447998,615.213989 
	C2365.587402,610.190491 2358.520508,612.614502 2353.827637,622.520386 
	C2347.670654,635.516846 2339.258789,637.998657 2327.311523,630.018311 
	C2324.120361,627.886658 2321.287354,627.746521 2317.985352,629.233215 
	C2314.683105,630.720032 2311.785156,633.253052 2307.193359,633.085327 
	C2304.947510,632.039001 2304.221191,630.558105 2303.645752,628.975708 
	C2302.235107,625.096741 2300.937988,620.770020 2295.375244,623.471680 
	C2290.201904,625.984253 2287.512451,629.719299 2291.092285,635.500977 
	C2292.330322,637.500732 2293.646240,639.466553 2292.103516,642.524597 
	C2280.902832,643.472473 2272.610107,649.336792 2263.596680,655.082764 
	C2258.804199,652.253967 2261.132812,648.357056 2261.163330,644.959106 
	C2261.211670,639.611206 2260.110352,634.272461 2254.807129,632.598572 
	C2249.314697,630.864990 2245.311279,635.414307 2242.794434,639.544128 
	C2239.742676,644.551514 2243.891357,648.160889 2247.147949,651.487061 
	C2248.537354,652.906006 2250.447266,653.707275 2252.387695,655.611328 
	C2253.985107,660.430115 2251.612061,662.816895 2247.649902,664.966797 
	C2245.967041,665.297363 2244.973633,665.307007 2244.033691,665.016235 
	C2230.866455,660.942749 2230.867920,660.937927 2226.821289,674.002625 
	C2216.173340,673.538879 2209.912109,680.043701 2202.945801,686.522705 
	C2199.782227,684.967712 2199.615234,682.125244 2198.501465,679.812927 
	C2196.422607,675.496399 2193.216309,673.820190 2189.016846,676.644592 
	C2185.053467,679.310181 2185.812500,682.593994 2188.784912,685.735291 
	C2190.557861,687.608887 2192.795654,689.213989 2192.719727,692.862976 
	C2186.913574,697.240540 2179.702148,698.720642 2176.639893,705.946899 
	C2175.775391,707.986694 2172.777100,708.486267 2170.434570,708.599060 
	C2161.508301,709.028748 2153.750488,712.543823 2145.724121,717.457031 
	C2142.561035,717.515991 2140.717285,715.928345 2138.575928,715.131531 
	C2129.765625,711.853027 2124.955566,715.156128 2125.998535,724.406372 
	C2126.781982,731.355652 2124.737793,735.940308 2118.275391,738.629578 
	C2116.135498,739.520020 2114.215820,740.905273 2112.902588,742.890381 
	C2110.336670,746.768799 2111.285156,750.486084 2113.759521,753.940979 
	C2115.793701,756.781311 2118.424072,758.787231 2122.192871,757.578064 
	C2126.429932,756.218811 2128.715332,753.251038 2128.721436,748.715027 
	C2128.725586,745.733582 2127.717529,742.836548 2127.858887,739.849426 
	C2128.070557,735.392090 2129.366699,731.922058 2135.590820,733.078308 
	C2139.483887,738.970337 2142.050293,744.886536 2145.048340,751.338501 
	C2139.727539,758.437500 2134.310547,764.465820 2138.771729,774.033386 
	C2140.726562,778.225647 2136.549072,780.664551 2132.989502,781.841003 
	C2126.093262,784.120239 2122.490479,788.499207 2122.715332,795.867981 
	C2122.896729,801.813782 2120.068604,805.943665 2114.979004,808.804626 
	C2112.667236,810.103943 2110.386230,811.550415 2108.556396,813.510925 
	C2104.029053,818.361084 2105.655518,822.875000 2110.133301,826.307983 
	C2114.753662,829.850159 2120.257568,826.782532 2120.645264,823.011719 
	C2121.919922,810.613770 2125.490234,800.425293 2137.726318,795.084717 
	C2137.467041,783.795654 2144.016602,777.402954 2153.371826,772.753113 
	C2154.929199,771.979126 2155.455811,769.429260 2157.421387,767.497864 
	C2161.855469,765.559631 2164.413818,767.118042 2166.229980,770.487976 
	C2173.291016,783.590393 2178.915771,797.548584 2189.231445,808.715759 
	C2190.328125,809.903076 2190.074707,811.878906 2189.648926,814.266357 
	C2188.987549,815.879517 2188.351318,816.637878 2187.516846,817.208496 
	C2184.241943,819.446899 2177.997803,819.806458 2180.408203,825.977478 
	C2182.555908,831.476501 2187.682617,829.041748 2191.813232,828.809021 
	C2192.472656,828.771851 2193.125244,828.956238 2194.343750,829.583374 
	C2197.968750,835.776917 2202.146973,838.663330 2209.293945,838.275146 
	C2217.433594,837.832947 2218.873047,841.092651 2214.664062,847.863281 
	C2208.882812,857.162842 2209.900635,862.082642 2219.119141,868.307434 
	C2222.691650,870.719604 2226.758057,872.371826 2229.811279,875.584534 
	C2236.978760,883.126282 2238.122070,889.118958 2232.627930,897.886719 
	C2229.068848,903.566711 2230.004150,907.002014 2235.727539,909.808533 
	C2243.398193,913.569641 2249.820068,918.434448 2252.707031,927.098022 
	C2254.237793,931.691833 2258.988281,932.545593 2263.034180,934.143555 
	C2273.140381,938.135193 2274.543701,941.577698 2270.610596,951.593384 
	C2266.125244,963.016724 2266.519775,964.896790 2276.350342,972.561584 
	C2281.885254,976.877197 2284.564697,982.923035 2287.302979,988.984741 
	C2289.003174,992.747986 2290.702148,996.212402 2295.634766,996.418945 
	C2300.131592,996.607239 2303.829102,998.565308 2303.285156,1003.601501 
	C2302.631592,1009.654541 2298.546875,1011.898071 2292.706055,1010.980896 
	C2293.059570,1011.454895 2294.051758,1011.398193 2294.422363,1011.970459 
	C2302.787109,1024.884888 2317.760498,1031.356567 2326.006104,1044.364502 
	C2331.554443,1053.117554 2339.470703,1046.210205 2346.169678,1047.158569 
	C2351.951660,1047.977051 2349.777344,1042.187622 2349.938232,1038.938843 
	C2350.215088,1033.357788 2353.149658,1030.387207 2358.473877,1029.602905 
	C2370.989502,1027.759155 2382.005371,1022.803406 2391.415771,1014.253723 
	C2394.674072,1011.293457 2398.808838,1009.793274 2402.973877,1008.533508 
	C2406.573730,1007.444519 2409.803711,1005.924194 2411.722168,1002.422485 
	C2412.698730,1000.640015 2413.996826,998.792725 2416.026123,998.485229 
	C2432.782959,995.945801 2444.849121,983.933838 2459.487305,977.143372 
	C2465.699463,974.261780 2471.901123,975.462280 2477.990479,977.460266 
	C2483.818604,979.372498 2487.649902,978.695496 2490.846680,972.363525 
	C2495.538818,963.068237 2502.063721,960.449036 2512.513916,963.004883 
	C2519.559326,964.727966 2523.959229,963.104431 2528.921143,957.575684 
	C2537.179199,948.373535 2548.336426,944.360291 2561.456787,945.538757 
	C2562.000000,955.378479 2562.000000,964.757019 2562.000000,975.067749 
	C2543.140137,990.687256 2522.537598,1001.573364 2499.940430,1010.032837 
	C2484.028564,1015.989624 2468.392090,1023.726685 2453.007324,1031.452271 
	C2447.574707,1034.180298 2443.330566,1038.691650 2439.854248,1043.442383 
	C2434.091309,1051.318359 2426.502197,1055.084717 2417.152832,1055.985474 
	C2410.877686,1056.589966 2406.186035,1059.189453 2402.154785,1064.390015 
	C2397.328369,1070.616089 2389.338135,1072.262939 2381.646484,1075.319824 
	C2374.300293,1074.053101 2367.057617,1070.291992 2362.722656,1080.420532 
	C2347.206787,1086.660522 2338.552734,1100.831787 2325.249268,1109.019287 
	C2319.503174,1112.555664 2314.295654,1116.282349 2307.359619,1116.735718 
	C2302.899902,1117.027222 2298.690674,1118.185303 2296.788574,1122.847046 
	C2294.612549,1128.180664 2298.100098,1131.631592 2301.305908,1135.040527 
	C2303.349609,1137.213623 2305.386230,1139.425537 2307.606689,1141.399170 
	C2312.569580,1145.810059 2321.283936,1144.630615 2322.132080,1138.490234 
	C2324.137939,1123.968750 2333.996826,1117.934937 2346.269531,1112.579590 
	C2349.949463,1111.244873 2352.968750,1111.150879 2356.675293,1112.447754 
	C2357.589844,1112.999878 2358.081299,1113.364868 2358.042725,1113.433838 
	C2351.816406,1124.569580 2357.011719,1141.552124 2340.557373,1147.480713 
	C2335.976318,1149.131348 2334.699219,1152.512817 2336.373535,1157.096558 
	C2337.621338,1160.511841 2339.963379,1161.786499 2343.406982,1160.831787 
	C2347.544189,1159.684692 2351.623535,1159.058472 2351.945557,1152.967285 
	C2352.802979,1136.738892 2354.829590,1134.561401 2368.759277,1132.161377 
	C2370.309082,1129.513794 2367.967529,1127.228149 2367.835205,1124.705811 
	C2367.521240,1118.709595 2370.011963,1114.285889 2375.020020,1111.424683 
	C2380.186523,1108.473389 2385.379395,1109.337158 2390.020264,1112.779785 
	C2394.734131,1116.276489 2394.714355,1121.204346 2393.568115,1126.367188 
	C2392.430176,1131.493652 2389.395264,1136.062744 2389.289307,1141.665771 
	C2391.589844,1130.870361 2398.039551,1123.352783 2407.112061,1117.825806 
	C2409.325439,1116.477295 2410.276855,1114.441895 2410.123291,1111.926392 
	C2409.641357,1104.041260 2413.871338,1098.705811 2419.707031,1094.315796 
	C2423.562256,1091.415771 2426.031494,1087.840454 2427.628174,1083.175659 
	C2432.282471,1069.577515 2443.266113,1066.794434 2453.917725,1076.191040 
	C2454.916992,1077.072754 2455.775635,1078.102661 2456.646973,1079.109985 
	C2459.127686,1081.977295 2462.149658,1082.513184 2465.689941,1081.463745 
	C2469.676270,1080.282349 2470.117676,1077.418457 2470.368164,1073.747192 
	C2471.052979,1063.711304 2478.861816,1055.917114 2488.032227,1055.548828 
	C2491.074219,1055.426514 2494.968018,1055.229858 2496.384277,1057.831055 
	C2503.496826,1070.896362 2522.249268,1068.298096 2527.250244,1083.317383 
	C2530.959717,1080.248047 2529.596924,1078.681274 2527.887695,1077.522705 
	C2524.868896,1075.476318 2521.430664,1074.100708 2518.747314,1071.490356 
	C2514.290771,1067.155396 2510.342529,1062.516357 2512.364502,1055.772095 
	C2514.248047,1049.491699 2518.897949,1045.274170 2525.268555,1044.694336 
	C2533.309082,1043.962402 2534.519531,1039.557983 2533.313965,1033.079224 
	C2532.618164,1029.339111 2532.237549,1025.736572 2535.379639,1022.867859 
	C2539.263916,1019.321289 2543.743896,1018.566528 2548.218262,1021.325806 
	C2552.252197,1023.813416 2552.274414,1027.634399 2550.885498,1031.907349 
	C2546.398193,1045.713989 2548.850586,1051.634521 2561.475098,1057.534302 
	C2562.000000,1074.708496 2562.000000,1091.416992 2562.000000,1109.062744 
	C2560.145508,1111.824219 2558.028809,1113.210693 2554.777588,1114.112793 
	C2546.528564,1115.386108 2541.226074,1119.432495 2537.907227,1126.241821 
	C2536.740967,1128.635132 2535.322266,1130.898560 2533.741455,1133.056152 
	C2531.201660,1136.522461 2527.990479,1138.586792 2523.521973,1137.988281 
	C2518.604736,1137.329468 2516.049072,1134.030273 2514.485352,1129.701172 
	C2512.965332,1125.493896 2513.686279,1121.146973 2513.222656,1116.131958 
	C2508.249023,1130.274048 2489.553467,1129.233032 2484.558350,1144.021484 
	C2482.603027,1149.810181 2473.348633,1147.651367 2470.581055,1141.000122 
	C2468.704590,1136.490601 2469.226807,1131.890991 2471.036621,1127.372559 
	C2472.095459,1124.728516 2474.665527,1122.449341 2472.539307,1117.134277 
	C2466.977783,1124.654785 2467.564453,1135.650513 2456.502686,1137.840210 
	C2445.897461,1139.939575 2438.663818,1135.170410 2429.463379,1126.969360 
	C2429.651123,1141.355225 2422.300293,1148.330444 2411.899414,1152.860352 
	C2409.145264,1154.060059 2407.898682,1156.322998 2408.736572,1159.384399 
	C2409.677246,1162.822266 2411.450928,1166.119873 2415.397217,1165.606079 
	C2424.991455,1164.356934 2431.198975,1167.662109 2435.018555,1176.825317 
	C2436.909424,1181.361816 2442.031250,1182.746948 2446.858643,1183.128906 
	C2454.308594,1183.718506 2459.527588,1187.194336 2461.495117,1194.545044 
	C2463.470947,1201.925293 2458.642090,1205.612305 2453.078857,1208.570679 
	C2447.917725,1211.315063 2446.708252,1215.866943 2446.745117,1221.167969 
	C2446.790527,1227.657227 2444.936279,1233.097290 2438.108398,1235.366089 
	C2431.052979,1237.710571 2424.843262,1235.437012 2419.538818,1230.940063 
	C2413.846680,1226.114380 2414.680664,1219.300415 2421.094971,1215.254150 
	C2423.061035,1214.014038 2425.319336,1213.263306 2427.264648,1211.968018 
	C2432.198730,1208.682007 2432.791260,1204.816284 2427.119629,1202.312256 
	C2417.666992,1198.138916 2409.896973,1192.375977 2404.564697,1183.411987 
	C2402.535156,1180.000000 2399.718750,1180.729126 2396.825684,1182.501709 
	C2391.704590,1185.639893 2389.180664,1190.416138 2387.056396,1195.889160 
	C2381.745605,1209.572021 2373.051514,1210.863037 2363.243408,1199.802734 
	C2361.472412,1197.805664 2360.225586,1195.392212 2358.311768,1193.520752 
	C2355.652344,1190.920288 2352.438232,1190.530273 2349.050049,1191.630859 
	C2345.629883,1192.741943 2346.104980,1195.738159 2346.284912,1198.332031 
	C2346.853760,1206.526001 2343.270996,1212.476562 2336.540283,1216.716064 
	C2332.057373,1219.539551 2330.640381,1223.614380 2330.952393,1228.667603 
	C2331.250977,1233.503418 2333.322754,1235.953247 2338.506592,1235.634155 
	C2347.751465,1235.065063 2356.992676,1233.674194 2364.199219,1242.468872 
	C2366.937988,1245.811401 2369.994385,1242.708740 2369.602295,1239.047241 
	C2368.500244,1228.751953 2375.058594,1223.898438 2382.669922,1219.877930 
	C2387.555908,1217.296997 2389.790771,1213.919189 2390.310303,1208.192993 
	C2391.174316,1198.671021 2396.032715,1194.011353 2402.072998,1195.227417 
	C2411.329834,1197.090942 2419.431641,1206.665894 2418.110352,1214.273804 
	C2417.069580,1220.266479 2412.872314,1222.424072 2407.357666,1222.678467 
	C2402.196533,1222.916626 2400.290283,1225.037476 2401.642578,1230.381958 
	C2403.938965,1239.457275 2401.507568,1246.837769 2392.804932,1251.478149 
	C2389.930908,1253.010742 2387.974365,1255.135254 2389.217285,1258.729370 
	C2390.096924,1261.273071 2391.998291,1262.453735 2394.626953,1262.155029 
	C2398.011719,1261.770386 2399.941650,1259.675537 2400.729248,1256.434326 
	C2401.203613,1254.483032 2401.160400,1252.454956 2401.571289,1250.502808 
	C2403.887207,1239.503418 2414.916016,1234.552368 2424.646973,1240.120361 
	C2427.268066,1241.619995 2429.256348,1243.982422 2431.798096,1245.554199 
	C2437.936035,1249.349609 2443.078369,1247.770386 2444.767334,1240.745483 
	C2446.452393,1233.736572 2449.408447,1228.306763 2456.314697,1225.652222 
	C2460.757568,1223.944824 2461.027100,1220.811035 2460.096436,1216.750854 
	C2459.048828,1212.180054 2458.535645,1207.427612 2460.835693,1203.059570 
	C2465.460938,1194.276001 2476.622803,1194.287598 2484.089600,1203.008301 
	C2488.066650,1207.653076 2490.608643,1214.312134 2498.910156,1212.355225 
	C2503.770752,1211.209351 2507.268066,1209.512939 2505.265869,1203.655273 
	C2502.517090,1195.613525 2505.864502,1190.134033 2512.518066,1185.994019 
	C2516.028076,1183.809937 2519.495117,1181.566406 2517.719727,1176.547974 
	C2516.002686,1171.694336 2512.010010,1173.096680 2508.429443,1173.293579 
	C2500.700439,1173.718506 2498.042480,1168.360962 2496.477783,1162.254517 
	C2494.451660,1154.346924 2499.366699,1144.649658 2506.707275,1141.466309 
	C2512.920898,1138.771362 2517.670166,1141.359741 2521.803467,1145.843506 
	C2523.175537,1147.331543 2523.868408,1149.243896 2524.634766,1151.094727 
	C2525.819824,1153.957275 2527.152100,1156.782837 2531.030029,1156.063965 
	C2534.348389,1155.448853 2534.765381,1152.569092 2535.184326,1149.951416 
	C2535.935547,1145.260376 2537.184814,1140.832642 2540.645264,1137.341187 
	C2546.558838,1131.375000 2553.066162,1131.268433 2561.482910,1137.498779 
	C2562.000000,1285.375122 2562.000000,1432.750244 2562.000000,1581.062744 
	C2559.457031,1584.467529 2556.409912,1582.973145 2553.567871,1583.063354 
	C2550.362305,1583.165161 2547.306396,1583.807495 2547.707764,1587.851196 
	C2548.074707,1591.545654 2550.849854,1592.525269 2554.215576,1591.952759 
	C2556.443115,1591.573975 2558.557129,1590.346069 2561.463379,1591.558350 
	C2562.000000,1602.044189 2562.000000,1612.088379 2562.000000,1623.066284 
	C2558.134521,1627.353149 2558.065674,1631.043457 2561.511475,1635.501221 
	C2562.000000,1642.061157 2562.000000,1648.122437 2562.000000,1655.091797 
	C2561.307617,1656.654175 2560.513428,1657.140991 2558.918945,1657.520996 
	C2552.473877,1656.184448 2546.330322,1649.109375 2540.959473,1659.358154 
	C2534.884766,1675.036499 2529.914307,1677.933228 2515.248291,1674.012207 
	C2514.035645,1673.327148 2513.521484,1672.909912 2513.019043,1672.476929 
	C2509.902100,1669.790527 2507.919434,1664.455322 2502.686768,1666.239258 
	C2497.622803,1667.965576 2499.084717,1673.528198 2497.543457,1678.137695 
	C2495.168945,1682.987427 2492.947266,1687.059814 2486.685059,1686.859619 
	C2484.739258,1685.371826 2484.390869,1683.740356 2483.974854,1682.124634 
	C2483.288330,1679.458984 2482.366211,1676.642700 2479.104004,1676.622070 
	C2475.562500,1676.599731 2475.203125,1679.796753 2474.754639,1682.357056 
	C2473.571289,1689.114746 2469.982910,1693.689819 2462.893555,1693.545776 
	C2454.426025,1693.373779 2451.180176,1687.195435 2449.227295,1679.923706 
	C2447.400391,1673.119873 2448.718018,1668.100708 2456.017334,1665.708862 
	C2458.183105,1664.999146 2460.779053,1664.254639 2460.309814,1661.130737 
	C2460.050049,1659.402344 2458.724365,1658.077148 2456.986816,1657.775269 
	C2453.562988,1657.180908 2452.206299,1659.644653 2451.445068,1662.288452 
	C2450.525391,1665.482910 2450.102783,1668.844849 2448.505371,1671.805420 
	C2444.611328,1679.024536 2437.256104,1679.899658 2430.971680,1673.281494 
	C2431.241455,1671.977539 2431.537598,1671.410522 2431.918457,1670.894897 
	C2433.933838,1668.167236 2438.319092,1665.769409 2436.064941,1662.002197 
	C2433.230713,1657.265747 2430.064697,1662.729370 2426.944824,1662.947632 
	C2425.973633,1663.015381 2425.028809,1663.015137 2423.485840,1662.373291 
	C2420.125977,1658.633057 2416.899902,1658.434814 2413.128418,1660.263062 
	C2405.547607,1663.937500 2399.622559,1661.323242 2394.883545,1655.023560 
	C2391.551514,1650.593872 2387.912598,1646.992554 2381.670898,1647.913208 
	C2374.013672,1649.042603 2369.665283,1644.884644 2367.604248,1638.159790 
	C2365.541016,1631.428101 2361.382812,1628.409058 2354.381592,1628.693848 
	C2349.216553,1628.904053 2344.413818,1627.482300 2340.927002,1623.397949 
	C2337.534668,1619.424438 2333.498779,1616.960571 2328.255371,1616.265991 
	C2325.533936,1615.905640 2323.110107,1614.689209 2323.130859,1610.591675 
	C2328.562744,1605.491577 2331.927979,1600.345581 2331.577881,1593.040771 
	C2331.360107,1588.495850 2334.055420,1584.918213 2337.679932,1582.348022 
	C2342.926270,1578.627808 2345.570068,1573.742432 2345.291016,1566.548340 
	C2345.639648,1560.142090 2349.240234,1557.861694 2354.294189,1557.086792 
	C2361.038330,1556.052734 2365.892578,1552.727173 2368.230957,1545.282471 
	C2370.077393,1542.456909 2372.469482,1542.430054 2374.756348,1541.973877 
	C2381.011475,1540.726318 2381.562256,1537.471558 2377.405762,1532.217773 
	C2376.130127,1527.459473 2378.538086,1525.077148 2382.206055,1522.696655 
	C2385.669189,1521.351562 2388.697266,1521.662842 2391.556641,1521.020508 
	C2394.906738,1520.268066 2399.714355,1520.390015 2398.873779,1515.194214 
	C2398.068115,1510.215332 2394.492920,1507.232544 2389.131836,1507.319824 
	C2386.330078,1507.365479 2384.471680,1509.513916 2381.687012,1511.326172 
	C2379.188721,1512.427124 2377.228516,1512.798584 2375.260254,1512.804443 
	C2367.260742,1512.828369 2362.813477,1516.629150 2360.344482,1524.397583 
	C2357.463867,1533.462158 2352.949951,1534.960693 2345.104004,1530.226196 
	C2345.142822,1528.197876 2345.857178,1527.186279 2346.597656,1526.148193 
	C2347.643311,1524.682251 2349.457275,1522.549683 2347.135986,1521.507812 
	C2345.049072,1520.571411 2344.625000,1523.634277 2343.156006,1525.611328 
	C2342.370117,1526.483276 2341.991699,1526.771606 2340.940918,1527.303955 
	C2336.670166,1528.154419 2333.944580,1526.199219 2330.602539,1524.077637 
	C2328.398682,1522.328857 2326.658691,1521.470337 2323.955078,1523.063232 
	C2322.478027,1523.496338 2321.596924,1523.589966 2320.022949,1523.482056 
	C2315.576416,1522.467651 2312.935303,1520.261230 2311.383789,1516.668335 
	C2310.181885,1513.886353 2308.392334,1511.551392 2305.498535,1510.312500 
	C2302.647461,1509.091919 2299.729004,1508.623291 2297.099121,1510.692993 
	C2295.405518,1512.026123 2295.052734,1514.011719 2295.645752,1516.063110 
	C2296.609375,1519.396851 2299.142578,1520.735840 2302.349609,1520.818604 
	C2307.155518,1520.942627 2312.480469,1519.375122 2315.549805,1525.964355 
	C2316.628662,1529.050537 2316.751221,1531.550171 2316.762451,1534.807617 
	C2316.483154,1541.610840 2313.413574,1545.324829 2307.603271,1547.085571 
	C2301.638428,1548.893311 2298.601318,1545.287354 2295.082520,1541.429932 
	C2287.952637,1533.614136 2280.635010,1535.431030 2277.344971,1545.460205 
	C2272.168457,1561.241455 2260.654541,1564.514160 2248.741943,1553.507568 
	C2245.944092,1550.922607 2243.052490,1548.662720 2239.059326,1549.760742 
	C2234.079834,1551.129883 2236.418213,1555.905762 2234.760254,1559.654297 
	C2231.157715,1562.263428 2228.680908,1560.408813 2226.256592,1558.614624 
	C2224.101074,1557.019531 2221.940186,1555.142334 2219.200195,1555.175415 
	C2208.980225,1555.298828 2201.288818,1551.496948 2196.414551,1542.132446 
	C2194.580078,1538.608154 2190.835205,1537.604126 2186.898926,1538.026978 
	C2182.485107,1538.500977 2179.834961,1540.211792 2182.108154,1545.183716 
	C2184.565674,1550.558716 2185.095947,1555.645020 2179.016846,1558.935425 
	C2173.897217,1561.706421 2168.273193,1563.803955 2163.320068,1559.006470 
	C2158.704834,1554.535889 2157.336426,1548.798950 2159.508057,1542.519653 
	C2159.942383,1541.263550 2160.552490,1539.999634 2161.446533,1539.051270 
	C2167.525146,1532.603149 2166.557373,1525.937988 2162.009033,1518.373535 
	C2161.209473,1511.729370 2162.435547,1506.153931 2165.322266,1500.223633 
	C2170.377441,1496.527100 2173.775879,1499.098389 2177.223389,1501.902588 
	C2178.631348,1503.047485 2180.397217,1503.325317 2181.103516,1501.147705 
	C2181.571045,1499.705688 2180.336670,1498.675293 2179.030762,1498.331299 
	C2174.563232,1497.153931 2170.035156,1496.159302 2166.893555,1491.327881 
	C2166.846680,1482.863159 2168.247559,1475.334961 2171.878418,1467.656982 
	C2178.359619,1464.220703 2182.346924,1468.315186 2186.726807,1471.080200 
	C2189.196777,1472.639526 2191.605469,1474.719971 2194.853271,1473.364624 
	C2195.788818,1472.974365 2196.179199,1471.864014 2196.033691,1470.856689 
	C2195.451172,1466.818115 2191.992188,1466.931274 2189.213623,1466.583618 
	C2182.664307,1465.764038 2178.779297,1461.456787 2174.882812,1455.936890 
	C2173.362549,1450.149170 2175.510254,1445.319580 2176.158203,1439.652832 
	C2178.934570,1433.857788 2187.592773,1436.034424 2188.333496,1430.324463 
	C2188.947266,1425.591431 2182.055420,1423.231323 2181.040039,1418.205078 
	C2180.913330,1417.578247 2180.585693,1416.989258 2180.157715,1415.680908 
	C2179.257324,1412.013184 2179.257080,1409.008667 2179.679688,1405.250488 
	C2179.996826,1404.045654 2180.170166,1403.581787 2180.743896,1402.503784 
	C2186.334961,1398.305420 2189.824951,1401.838013 2193.377197,1404.873169 
	C2195.791748,1406.936035 2198.245850,1408.552246 2201.395264,1406.449219 
	C2203.154297,1405.274536 2204.233643,1403.595337 2203.892334,1401.388916 
	C2203.365234,1397.984253 2200.927734,1396.356079 2197.917725,1395.401367 
	C2193.209473,1393.907959 2187.813477,1395.680786 2183.045410,1391.768311 
	C2180.492188,1384.822144 2183.951416,1378.833252 2184.007324,1371.905518 
	C2185.638428,1368.288086 2188.392578,1367.271973 2191.095459,1366.076416 
	C2199.887695,1362.187500 2200.255371,1361.024780 2195.669922,1352.336304 
	C2194.759033,1350.610718 2193.687744,1348.969727 2192.767578,1346.438232 
	C2192.147461,1343.130859 2192.908691,1340.813721 2194.755127,1338.084473 
	C2197.652344,1335.559692 2200.687744,1335.152710 2203.555420,1334.361572 
	C2207.003418,1333.410156 2209.625977,1331.970093 2209.874512,1327.797119 
	C2210.450684,1318.114380 2218.359375,1315.966431 2225.453613,1313.198120 
	C2232.745117,1310.352905 2237.498047,1314.345947 2241.634766,1319.666992 
	C2242.452637,1320.718994 2243.315674,1321.761597 2244.391602,1322.545288 
	C2246.366943,1323.983398 2248.561035,1325.104126 2250.635742,1322.935547 
	C2252.314941,1321.180298 2251.370605,1319.212402 2250.332764,1317.446045 
	C2248.968018,1315.122925 2246.511719,1313.733765 2244.843750,1310.753052 
	C2243.906250,1304.902100 2247.436279,1301.791138 2250.891602,1297.900391 
	C2253.005615,1296.654053 2254.769043,1297.030273 2256.327393,1296.600342 
	C2263.123291,1294.725342 2264.350586,1291.508911 2259.878906,1286.223022 
	C2256.236328,1281.917480 2253.502686,1277.782104 2256.091309,1274.301270 
	C2254.855713,1282.258179 2248.189209,1279.935181 2242.261230,1277.180176 
	C2237.381104,1274.911987 2234.105957,1273.840576 2230.980957,1279.742432 
	C2227.326416,1286.644897 2220.949707,1282.248047 2214.771973,1282.070312 
	C2216.254395,1289.910767 2214.261230,1296.408569 2207.497314,1300.838135 
	C2205.221191,1302.328613 2202.952881,1303.821899 2200.120605,1302.505371 
	C2196.949219,1301.031006 2196.054443,1298.211060 2196.336670,1295.025879 
	C2197.163330,1285.703491 2197.882812,1276.361450 2205.598145,1269.451416 
	C2208.080566,1267.228271 2209.916016,1264.350830 2210.562256,1260.949219 
	C2211.366943,1256.711426 2210.094482,1252.953491 2205.449951,1253.100708 
	C2196.876465,1253.372681 2192.373779,1247.614258 2186.832520,1241.848877 
	C2184.793701,1236.203735 2182.555664,1231.271240 2184.498535,1225.081299 
	C2191.184326,1219.836182 2199.179932,1220.012451 2206.206543,1217.096313 
	C2211.600830,1214.857788 2215.092041,1220.957642 2214.291504,1225.643555 
	C2212.161377,1238.114014 2221.467041,1243.071777 2228.403076,1249.767456 
	C2229.124268,1250.463501 2230.285645,1251.680664 2230.830078,1251.119141 
	C2238.026611,1243.697021 2251.387207,1250.297729 2257.073975,1239.530884 
	C2257.678711,1238.385986 2256.626221,1239.517700 2257.689453,1238.767456 
	C2267.196045,1232.059570 2276.420898,1226.418701 2275.172119,1211.425171 
	C2274.506104,1203.433350 2289.239502,1199.940186 2297.225586,1205.131592 
	C2301.136475,1207.674072 2303.870850,1211.815063 2308.266602,1213.633911 
	C2311.822754,1215.105469 2315.977783,1215.796387 2317.606934,1211.284790 
	C2319.145752,1207.023804 2316.287109,1203.720825 2312.208008,1203.475708 
	C2302.015137,1202.862793 2295.458008,1198.026123 2291.757080,1188.648804 
	C2290.605225,1185.730591 2288.309570,1183.608887 2284.685547,1184.521606 
	C2281.273193,1185.380981 2278.577393,1187.173584 2277.653076,1190.843018 
	C2277.240234,1192.481812 2277.257080,1194.166260 2277.567139,1195.807373 
	C2278.999756,1203.390625 2277.748047,1209.928589 2269.961670,1213.334717 
	C2263.562500,1216.134155 2253.461914,1213.001465 2248.758789,1205.974243 
	C2245.118408,1200.534424 2241.678711,1197.325684 2234.441650,1197.786987 
	C2226.950439,1198.264526 2223.428223,1192.365967 2221.986816,1185.715088 
	C2220.691650,1179.738037 2221.789551,1174.042358 2227.781006,1171.134399 
	C2234.122803,1168.056152 2240.115234,1169.380005 2245.043945,1174.631348 
	C2245.729248,1175.361206 2246.312744,1176.176270 2246.963135,1176.932251 
	C2249.202637,1179.535278 2250.173828,1184.173218 2255.115234,1182.685913 
	C2259.300293,1181.426270 2261.360840,1178.124634 2262.704834,1174.086182 
	C2266.522705,1162.615234 2273.063477,1159.063843 2284.427734,1161.703125 
	C2288.730957,1162.702393 2291.197998,1165.641968 2293.627930,1168.874023 
	C2295.739014,1171.682129 2298.514893,1172.171997 2301.607422,1170.667480 
	C2304.914062,1169.058838 2305.052002,1166.032104 2304.748047,1162.948853 
	C2304.391113,1159.333740 2302.273926,1157.654175 2298.668457,1157.882812 
	C2289.249268,1158.480225 2285.013184,1152.556274 2282.077148,1144.854126 
	C2278.688721,1135.965576 2269.635254,1133.909424 2262.630615,1140.448242 
	C2259.678467,1143.203979 2257.984619,1146.934082 2255.623779,1150.149414 
	C2248.549316,1159.784302 2239.732666,1166.890747 2228.005127,1170.446045 
	C2218.793945,1173.238525 2209.928955,1176.796143 2202.533203,1183.652710 
	C2196.837402,1188.933472 2189.594238,1190.279175 2181.471680,1186.419800 
	C2175.381836,1173.599487 2177.122803,1159.935303 2173.597656,1147.228516 
	C2172.468506,1143.158447 2171.453857,1138.936401 2170.534180,1133.936279 
	C2169.936035,1132.153687 2169.705811,1131.110596 2169.455078,1129.272461 
	C2169.449707,1123.314331 2167.851562,1118.457764 2166.271973,1112.814575 
	C2165.780029,1111.070435 2165.578369,1110.053345 2165.354004,1108.247070 
	C2161.850342,1082.795532 2153.585693,1059.352417 2146.694092,1035.586060 
	C2139.689697,1011.429688 2130.087891,988.122925 2122.157471,963.594604 
	C2121.759277,962.123962 2123.801270,961.140564 2121.475586,960.603882 
	C2120.594727,960.672363 2120.224121,960.580078 2119.399902,960.098145 
	C2116.664795,956.087463 2115.641602,951.824707 2112.763428,947.770142 
	C2111.907471,946.475647 2111.456787,945.709900 2110.763672,944.312073 
	C2109.268555,938.580078 2108.429199,933.319214 2104.703369,928.435181 
	C2103.926025,927.115662 2103.527344,926.340942 2102.888672,924.966431 
	C2101.586914,921.653320 2100.950439,918.761780 2098.933594,915.774048 
	C2098.105469,914.557129 2097.656982,913.843323 2096.928711,912.553223 
	C2095.754639,910.054260 2095.231201,907.979553 2093.984863,905.499390 
	C2093.270752,904.155823 2092.855957,903.385193 2092.089844,902.038208 
	C2087.345703,894.882446 2083.547363,888.050049 2082.723633,879.319641 
	C2081.896729,876.718750 2089.879395,873.098389 2081.020996,872.722534 
	C2079.905029,872.895508 2079.447510,872.907410 2078.333740,872.698242 
	C2077.333984,872.166382 2076.989990,871.855713 2076.221680,870.994080 
	C2074.129395,867.182129 2070.813232,864.826416 2070.515381,860.107361 
	C2072.052002,854.661865 2068.761475,850.010498 2070.533691,844.608032 
	C2078.838379,838.029602 2082.928467,838.513672 2087.816650,846.010254 
	C2088.903320,847.676636 2089.683105,849.528198 2090.715332,851.229553 
	C2092.493408,854.160583 2094.453125,857.049438 2098.547119,855.650452 
	C2102.047607,854.454285 2103.627197,851.468384 2104.209717,848.058594 
	C2104.856445,844.276001 2102.931885,841.705139 2099.660889,840.056458 
	C2096.902588,838.666077 2093.862549,838.779602 2090.892822,838.591187 
	C2087.102051,838.350464 2083.975830,837.205505 2081.473145,833.960449 
	C2073.562256,823.703186 2073.465088,823.778076 2062.045410,830.207275 
	C2060.035645,830.990601 2058.665771,830.939209 2056.669434,830.224915 
	C2054.855713,829.341309 2053.762695,828.579163 2052.199219,827.369995 
	C2051.429199,826.636780 2051.152832,826.315613 2050.529297,825.471313 
	C2049.392334,823.494507 2048.466797,822.143005 2046.807617,820.549500 
	C2045.294922,818.629517 2044.678101,817.039307 2045.081177,814.536987 
	C2046.761230,810.895203 2047.968872,807.977295 2042.980713,805.994934 
	C2041.656982,805.220825 2040.970337,804.696228 2039.972534,803.613037 
	C2039.149658,802.409729 2039.570801,801.141357 2038.622559,800.893555 
	C2038.155396,800.771484 2038.787476,802.208618 2037.256470,802.566040 
	C2036.222778,802.473511 2035.820435,802.284302 2035.033203,801.525085 
	C2034.104980,799.589050 2033.986816,798.176086 2034.384033,796.004028 
	C2036.837402,791.588562 2040.124146,789.452454 2045.101074,788.864685 
	C2048.818604,790.171936 2050.158691,792.983032 2052.003662,795.293396 
	C2054.855225,798.863403 2058.528320,799.857849 2062.674072,798.240601 
	C2066.882568,796.598816 2068.461426,793.001770 2068.626953,788.711426 
	C2068.730713,786.018677 2067.975098,783.434875 2067.228027,780.893433 
	C2065.743896,775.843018 2067.497314,772.544922 2072.314209,770.632202 
	C2074.161377,769.898621 2075.930176,768.955322 2077.624023,767.896912 
	C2081.702393,765.348755 2083.779297,761.795898 2082.522705,756.964417 
	C2081.292236,752.233459 2077.342285,750.651428 2073.228271,751.268250 
	C2064.654785,752.553833 2059.268555,749.110229 2055.634766,741.627136 
	C2053.694824,737.631470 2050.518799,735.375732 2045.889038,737.589478 
	C2042.131836,739.385925 2040.671753,742.621521 2041.285767,746.647400 
	C2042.033691,751.550964 2045.523560,752.842834 2049.950439,753.055298 
	C2062.591309,753.662170 2065.275635,755.950256 2067.272949,766.746155 
	C2068.089600,771.159119 2067.330566,774.850342 2063.265381,777.009705 
	C2057.383789,780.133728 2052.723633,785.113220 2045.804443,787.829468 
	C2040.992554,788.235718 2036.714233,789.601257 2033.206787,784.949707 
	C2032.537964,781.317505 2034.418091,779.299194 2035.827637,777.091248 
	C2038.096069,773.538452 2039.929077,769.642944 2035.745361,766.536987 
	C2031.415894,763.322571 2027.651978,765.309265 2024.745728,769.281799 
	C2023.964233,770.350098 2023.218140,771.442200 2021.656006,772.748657 
	C2020.155396,773.468262 2019.222290,773.641968 2017.546143,773.563721 
	C2015.913452,773.164062 2015.053101,772.744446 2013.687500,771.758972 
	C2012.438721,770.643188 2011.809814,769.924622 2010.853271,768.555176 
	C2009.608398,766.233459 2009.049805,764.450012 2009.667236,761.879944 
	C2012.265381,759.106934 2015.401245,757.296814 2013.282227,753.331177 
	C2010.796509,748.679321 2006.639160,749.070007 2001.722778,749.760864 
	C1999.224976,749.619263 1997.696045,748.851318 1996.082275,747.036865 
	C1995.589600,746.180054 1995.449219,745.817627 1995.252686,744.903076 
	C1995.193237,743.615417 1995.039673,742.912720 1994.284668,741.877319 
	C1992.755127,740.879944 1991.645752,740.305176 1990.001587,739.358032 
	C1988.460205,738.215393 1987.663208,737.246826 1986.650269,735.680115 
	C1985.600708,733.766296 1984.757935,732.444641 1983.046143,731.030640 
	C1980.333130,728.659851 1978.693726,726.211914 1976.809814,723.135193 
	C1975.297363,720.132263 1973.157471,718.476257 1971.133789,715.834229 
	C1970.729614,714.730591 1970.639526,714.260620 1970.572266,713.065796 
	C1973.005371,705.451599 1975.773926,698.745117 1973.885620,691.035828 
	C1972.867065,686.877563 1974.680420,683.063782 1978.903809,681.158020 
	C1984.486328,678.639038 1989.906494,678.947693 1994.928955,682.707031 
	C1998.181396,685.141357 2000.126221,688.758972 2002.919189,691.602905 
	C2006.379395,695.126221 2010.530151,695.658447 2014.831421,693.546082 
	C2019.119019,691.440369 2018.398071,687.684631 2017.395386,683.987671 
	C2015.773682,678.008545 2013.965454,672.160522 2022.402344,669.399963 
	C2032.893677,665.967285 2038.769043,667.276489 2042.297974,675.949036 
	C2045.280884,683.279968 2049.383789,685.817871 2056.883057,683.190857 
	C2062.901855,681.082581 2067.329346,682.804626 2069.299805,689.285767 
	C2071.711670,697.219238 2076.722168,701.361938 2085.377197,701.458862 
	C2092.430664,701.537720 2097.678223,704.822021 2098.090576,712.692749 
	C2098.393799,718.476562 2092.760254,722.921204 2084.961182,723.836853 
	C2079.809326,724.441589 2076.770752,722.188171 2074.954590,717.582214 
	C2072.955811,712.512512 2069.526855,709.154785 2063.706543,709.367859 
	C2058.127441,709.572083 2054.897461,712.351562 2055.427734,718.216064 
	C2055.914795,723.602722 2057.248779,728.581848 2064.518066,726.526245 
	C2072.694580,724.214111 2077.840820,727.321411 2081.429688,734.715637 
	C2083.319092,738.608765 2086.185303,742.491333 2091.479492,741.068726 
	C2096.653564,739.678406 2098.908691,735.461853 2099.018555,730.450256 
	C2099.174072,723.357117 2102.488770,718.481873 2108.438477,715.111816 
	C2113.272217,712.373596 2115.504150,708.254578 2115.221436,702.731140 
	C2114.822021,694.928589 2118.827393,690.435913 2125.875732,687.763672 
	C2130.516357,686.004272 2135.597900,684.206238 2133.185059,677.128296 
	C2130.434326,669.059204 2126.183105,665.865784 2118.497314,668.137024 
	C2112.220703,669.991943 2108.390625,668.517151 2105.471680,662.757935 
	C2103.047852,657.975586 2100.042725,652.775208 2093.520752,654.204407 
	C2086.959717,655.642273 2085.054688,661.194336 2084.850830,667.245972 
	C2084.641846,673.452698 2082.495117,678.207581 2076.372070,680.621643 
	C2070.709961,682.853943 2065.864014,682.594666 2062.924316,676.420776 
	C2059.299561,668.808228 2053.574951,664.618652 2044.925537,664.453430 
	C2039.693359,664.353577 2036.654785,660.704956 2034.027344,656.666687 
	C2031.200317,652.321411 2027.237183,650.436646 2022.055420,651.413635 
	C2016.795654,652.405334 2014.403809,655.908081 2013.015991,660.851624 
	C2008.600708,676.579651 2001.688843,678.405823 1989.341797,667.342957 
	C1982.684570,661.377930 1972.630249,662.553162 1972.900024,669.665039 
	C1973.347534,681.469543 1966.546021,687.004944 1958.139160,693.264526 
	C1957.189209,694.112610 1956.774170,694.417175 1955.618774,694.962524 
	C1954.355835,695.195129 1953.833374,695.187012 1952.576416,694.897339 
	C1951.481201,694.234436 1951.120239,693.853210 1950.385620,692.778931 
	C1949.120728,689.607971 1948.756348,687.062683 1949.445679,683.805908 
	C1956.616211,679.879517 1960.141968,675.325195 1960.154541,666.951599 
	C1960.172241,655.240479 1963.237061,654.198364 1975.207642,653.663757 
	C1986.036377,653.180176 1997.300659,651.831116 2003.557739,640.569092 
	C2005.193848,637.624390 2007.824341,636.048279 2011.041016,637.380127 
	C2020.698486,641.378418 2029.117798,635.358582 2038.134033,634.306702 
	C2040.111572,634.075989 2042.058594,632.791443 2042.919556,631.002502 
	C2046.437256,623.692322 2050.520264,621.004761 2058.084961,626.837708 
	C2061.410645,629.402161 2062.260254,625.235596 2062.437500,622.626526 
	C2062.783203,617.535889 2065.374512,615.528931 2070.989258,616.535278 
	C2074.384766,618.290710 2075.708252,621.121338 2077.751465,623.278809 
	C2080.546631,626.230042 2083.790039,627.374268 2087.641357,625.647339 
	C2090.979980,624.150146 2093.040283,621.624817 2092.444580,617.799194 
	C2091.802734,613.677979 2089.078857,611.474670 2085.025635,610.864746 
	C2082.727051,610.518860 2080.379150,610.539490 2077.420166,609.692322 
	C2072.417725,606.742004 2072.126465,603.819702 2075.319336,599.691101 
	C2080.554443,592.922363 2085.225098,585.711670 2089.534912,578.311096 
	C2092.149658,573.821228 2093.757568,569.505249 2087.844727,565.567688 
	C2082.888916,562.267517 2084.959229,558.084045 2089.371582,556.690674 
	C2096.281494,554.508850 2103.781738,552.903931 2109.072754,561.675293 
	C2110.080566,563.678162 2110.585205,565.076843 2111.308350,567.167725 
	C2112.335449,570.782043 2111.252930,573.706055 2111.476074,576.595520 
	C2112.112061,584.831665 2119.280762,588.554382 2126.386230,584.340271 
	C2128.411865,583.138916 2130.340332,582.117065 2133.425049,582.501282 
	C2145.667236,586.721741 2147.394043,585.855408 2149.515137,574.221069 
	C2150.378418,568.893433 2152.484375,564.997925 2156.550781,561.389038 
	C2160.119141,559.210144 2163.286377,557.887756 2167.083984,556.223022 
	C2173.029297,555.121704 2178.017090,553.357544 2182.898926,551.268433 
	C2184.690918,550.501648 2187.047607,549.847290 2186.596680,547.366211 
	C2186.192383,545.139771 2183.957031,544.513367 2181.937012,544.356750 
	C2176.253906,543.915894 2170.899170,543.262268 2172.769287,534.656250 
	C2179.477295,530.283020 2179.363037,524.900513 2176.929443,518.212830 
	C2179.535645,512.867371 2183.486816,513.698914 2186.054688,516.513306 
	C2191.319580,522.283691 2197.256592,527.690125 2197.926270,536.565125 
	C2198.653809,546.208130 2202.581543,547.765442 2210.989502,542.563904 
	C2216.065918,539.423279 2221.384277,536.702148 2225.676270,532.333496 
	C2228.522217,529.436768 2232.187256,527.690918 2237.202148,528.706055 
	C2240.980713,530.746887 2242.379150,536.119202 2247.367432,533.957947 
	C2251.309814,532.250061 2251.128174,528.288452 2251.563477,524.058228 
	C2254.414795,516.122864 2256.546631,508.433685 2267.498047,512.647522 
	C2270.699219,513.879150 2273.008789,509.588287 2275.814697,507.985565 
	C2280.186768,505.488190 2284.700928,500.929260 2289.165283,508.659729 
	C2288.307373,514.188660 2280.416992,520.561035 2289.031006,523.369995 
	C2296.407715,525.775513 2294.151367,516.031860 2297.406738,511.687683 
	C2299.861084,509.760956 2302.193604,509.283661 2304.509033,509.408325 
	C2311.200195,509.768433 2315.160400,507.333191 2316.009277,500.156555 
	C2316.683838,494.452423 2321.277588,492.379669 2326.178711,490.417603 
	C2333.638672,487.431000 2334.283447,484.756897 2328.916748,478.812286 
	C2325.736816,475.290161 2323.882080,471.994965 2325.333740,467.221527 
	C2326.132812,464.594604 2326.283691,461.825043 2323.226318,460.298706 
	C2320.831543,459.103149 2318.448242,459.810608 2316.793945,461.543854 
	C2311.261719,467.340271 2302.463135,466.428467 2296.597900,471.904755 
	C2292.775146,475.473785 2289.389648,470.727722 2285.219727,469.182068 
	C2281.635498,468.982910 2278.753174,468.824585 2275.205811,468.159424 
	C2271.056885,466.567535 2270.621582,464.032074 2271.393799,460.673309 
	C2272.199707,457.167206 2276.547607,452.513306 2271.539062,450.261810 
	C2266.237549,447.878601 2266.720703,455.210510 2263.803223,457.399780 
	C2262.420654,458.437103 2261.065674,459.203491 2258.645020,458.938110 
	C2249.226562,450.485443 2247.293701,450.909241 2243.473633,462.507172 
	C2237.866211,467.979187 2234.560303,464.765747 2232.755127,459.934479 
	C2229.992676,452.541718 2232.812744,446.586761 2238.853027,441.789612 
	C2248.573486,434.069885 2248.574707,433.738892 2242.847656,422.622375 
	C2242.545654,420.940308 2242.563965,419.958862 2242.646729,418.976044 
	C2242.924072,415.684509 2243.463623,412.262451 2239.813477,410.307251 
	C2238.238281,409.463379 2236.560791,409.684906 2235.267090,410.939301 
	C2232.133545,413.977051 2234.474121,417.002838 2235.613770,420.733704 
	C2235.982178,426.795135 2235.509521,431.905487 2230.019043,435.742249 
	C2225.245117,437.210602 2220.704102,436.280853 2216.378418,439.191467 
	C2211.724121,444.913910 2215.376709,447.473846 2219.631836,449.152679 
	C2224.205811,450.957153 2225.815918,453.508179 2224.070801,458.267151 
	C2221.346680,465.697083 2227.649170,471.334503 2228.327881,478.826202 
	C2228.057861,490.189606 2228.057861,490.189606 2242.037598,490.539490 
	C2246.510254,493.990601 2246.334961,497.543976 2242.128174,499.437836 
	C2235.767578,502.301086 2228.852539,503.504028 2221.792236,502.223816 
	C2218.545166,501.634979 2216.250244,499.523926 2215.826904,496.333771 
	C2214.985107,489.993866 2211.686523,484.532166 2209.966553,477.738892 
	C2209.983398,476.308746 2210.057861,475.657196 2210.214355,475.023132 
	C2211.132324,471.297974 2213.449951,466.544312 2207.540771,465.499969 
	C2200.286621,464.217926 2202.518066,470.360016 2201.871094,474.877136 
	C2200.478027,479.048737 2197.301514,480.904266 2194.746338,478.923218 
	C2188.682861,474.221771 2180.557861,471.339691 2178.473145,461.945435 
	C2178.794678,460.588837 2179.071777,459.997925 2179.472900,459.490387 
	C2181.720215,456.646210 2186.968262,454.533569 2183.528809,449.947693 
	C2179.523193,444.606476 2176.200195,450.307037 2171.962402,451.879059 
	C2165.728271,453.137329 2160.799072,455.446899 2156.188721,458.711456 
	C2153.015625,460.958160 2149.048584,463.632019 2145.766113,459.666229 
	C2142.447266,455.656403 2145.723877,452.505890 2149.377930,449.393188 
	C2152.145020,447.412933 2154.260498,445.806305 2155.853760,443.608337 
	C2157.516357,441.315155 2158.598633,438.937531 2156.685791,436.301788 
	C2155.672852,434.905701 2154.218262,434.030304 2152.422607,434.108856 
	C2149.247559,434.247772 2147.752441,436.333923 2147.003174,439.107513 
	C2146.394043,441.362518 2146.315430,443.717285 2145.704590,446.730042 
	C2144.701416,449.936920 2144.185303,452.632324 2142.012939,454.380737 
	C2140.074463,455.940948 2137.823486,456.186646 2135.518066,455.177032 
	C2133.408203,454.253021 2132.314697,452.255768 2133.051025,450.374756 
	C2136.101074,442.583801 2130.661621,436.439728 2129.315430,428.721802 
	C2128.885010,424.257416 2129.041748,420.595703 2129.688477,416.213013 
	C2131.505615,409.883148 2135.219238,406.654999 2140.905029,405.214142 
	C2149.513428,403.032623 2155.555420,397.725464 2158.659668,389.311890 
	C2159.545898,386.909515 2161.375977,384.140228 2158.576660,382.061371 
	C2156.103027,380.224335 2153.487305,381.734161 2151.176514,383.112427 
	C2149.182373,384.301758 2147.436523,385.876190 2144.756836,387.264832 
	C2134.493652,387.927643 2135.427490,395.324188 2134.276855,402.190979 
	C2124.651367,401.522430 2118.872070,395.707611 2114.135254,387.719971 
	C2115.714355,381.852783 2120.702393,377.629456 2118.189941,370.718628 
	C2118.107910,365.170135 2121.389648,362.021942 2124.463867,357.987213 
	C2128.657959,354.738281 2132.785156,352.442963 2135.095703,347.287994 
	C2143.899414,342.781036 2153.212158,342.656158 2162.617432,340.357727 
	C2172.547852,346.410950 2173.353516,346.225830 2178.028809,336.548828 
	C2180.114258,322.258728 2175.172607,316.956268 2162.248779,319.162933 
	C2158.657715,319.776123 2155.805664,319.041290 2152.964355,316.977844 
	C2150.944336,315.510834 2149.062744,313.017090 2145.417969,315.303131 
	C2135.814209,319.885284 2141.264404,326.847412 2141.477051,333.583099 
	C2134.295898,343.612030 2125.270996,340.747314 2115.630615,338.069397 
	C2111.953613,336.036499 2110.695801,332.921173 2108.807373,330.288696 
	C2105.288086,325.382172 2099.865234,325.881805 2095.455566,327.454651 
	C2090.814209,329.110138 2093.098145,334.170685 2093.002686,337.830170 
	C2092.928955,340.642487 2095.446045,342.335266 2096.842529,345.322083 
	C2097.826416,351.212585 2093.463623,352.383026 2089.694824,354.874817 
	C2078.873779,360.960388 2078.799561,363.290283 2089.163574,369.688843 
	C2091.210938,372.252289 2091.231934,374.269012 2090.191406,376.662903 
	C2086.319580,385.571533 2086.417969,385.645386 2096.220947,387.186310 
	C2112.591553,389.759644 2116.262451,394.015503 2116.036133,409.673645 
	C2115.971191,414.192566 2114.496094,417.573761 2109.857178,418.476166 
	C2105.604004,419.303528 2100.502930,421.923523 2098.506348,414.279358 
	C2098.675049,412.894135 2098.875244,412.264648 2099.199707,411.695038 
	C2100.927734,408.662903 2104.225342,405.989227 2101.669922,401.930786 
	C2100.285156,399.731628 2098.038818,398.913544 2095.645264,399.638763 
	C2090.773193,401.115082 2090.878174,405.346619 2090.706543,410.051514 
	C2090.175537,417.774017 2087.638184,421.869537 2080.029541,417.627655 
	C2076.741943,415.794830 2073.806152,415.995209 2070.713623,417.780914 
	C2067.661865,419.542969 2064.513916,419.919373 2060.656250,417.852631 
	C2056.733643,414.051331 2053.385498,410.706268 2047.664062,409.681641 
	C2043.439453,406.828705 2041.046387,403.327789 2043.975220,399.473633 
	C2047.879150,394.336578 2052.276123,388.997437 2060.886963,391.547913 
	C2063.093994,392.406158 2064.494385,393.296844 2066.072754,393.733185 
	C2070.192139,394.871948 2073.534180,393.928772 2074.005859,389.253784 
	C2074.411621,385.229126 2071.742676,383.417328 2067.831299,383.490814 
	C2066.201172,383.521393 2064.583984,383.838593 2062.255371,383.653748 
	C2049.628906,376.790192 2063.431396,372.535828 2063.388672,366.296753 
	C2058.117920,365.623749 2056.510742,372.974640 2050.733398,371.492310 
	C2049.132324,371.046875 2048.280518,370.597595 2047.412964,370.177002 
	C2037.210571,365.230225 2035.599854,366.181122 2034.574707,378.437988 
	C2034.053833,381.902283 2033.059204,385.151001 2030.236328,385.182648 
	C2022.866699,385.265289 2016.592041,390.306763 2008.417236,388.995544 
	C2003.405151,377.858307 2004.601685,372.547791 2012.638306,368.677338 
	C2016.843018,366.652405 2021.903809,365.500916 2020.709839,359.254303 
	C2019.599487,353.444672 2015.735596,349.814209 2009.926514,349.121765 
	C2004.137573,348.431671 1999.934326,346.105286 1997.574585,340.652466 
	C1995.454468,335.753571 1992.412964,330.640656 1998.367065,326.490479 
	C2003.975708,322.581360 2010.046875,321.992126 2015.886475,326.310516 
	C2018.039917,327.902985 2019.178711,330.428131 2021.398926,333.005676 
	C2022.306274,333.894775 2022.669800,334.245972 2023.533691,335.155731 
	C2027.645020,341.027771 2032.143433,338.782471 2036.354004,336.929993 
	C2040.386597,335.155792 2039.306519,331.265869 2038.807495,328.227753 
	C2037.722534,321.621826 2032.276001,322.712524 2027.826294,323.014191 
	C2015.691040,323.836823 2009.880615,318.195374 2010.740723,306.018036 
	C2011.239380,298.956451 2024.446777,293.716797 2031.557861,297.799286 
	C2033.886597,299.136200 2035.533569,301.245148 2037.754883,303.762726 
	C2039.200684,305.339569 2039.946045,306.544769 2041.067871,308.328949 
	C2043.395752,313.001434 2045.865356,312.378021 2049.074463,309.223083 
	C2049.951904,308.467346 2050.316162,308.177063 2051.259033,307.495300 
	C2054.197998,305.323273 2054.809814,303.107849 2054.423096,300.110046 
	C2053.443604,292.521576 2058.139893,289.134827 2064.688477,287.880707 
	C2071.325928,286.609558 2076.653320,288.702087 2079.158447,295.451019 
	C2081.646973,302.154816 2079.718750,307.425110 2072.966064,310.096191 
	C2066.971436,312.467499 2065.916992,316.931244 2067.383301,322.208710 
	C2068.417725,325.931519 2071.622803,326.902374 2075.415771,326.111389 
	C2081.381592,324.867188 2083.933350,321.516663 2082.779053,315.373749 
	C2081.580078,308.994019 2085.976562,305.765137 2090.232910,302.361908 
	C2095.189453,298.398926 2098.956055,293.879120 2095.181152,286.993927 
	C2092.860840,282.761749 2089.835938,281.211731 2084.625488,281.772949 
	C2077.186035,282.574219 2071.928711,277.322601 2070.388672,269.368347 
	C2069.439453,264.464355 2070.844482,260.570862 2075.656982,258.858612 
	C2082.354736,256.475525 2089.148926,256.046875 2093.293213,263.218658 
	C2097.494385,270.488556 2103.180664,273.478851 2111.451904,272.100555 
	C2115.869873,271.364380 2119.142822,273.471588 2121.461182,277.232880 
	C2123.028076,279.775391 2124.319092,282.547424 2126.709473,284.483002 
	C2129.637939,286.854218 2132.803467,286.975098 2136.004639,285.113220 
	C2138.488770,283.668457 2140.018066,281.444885 2139.716064,278.529236 
	C2139.324463,274.747345 2136.750000,272.754120 2133.271240,271.762451 
	C2132.626953,271.578796 2131.945801,271.345215 2131.303955,271.464905 
	C2122.111816,273.179077 2117.129639,269.596771 2114.860352,260.298767 
	C2112.658447,251.275848 2117.977539,247.482819 2124.581543,243.156494 
	C2125.442871,242.424759 2125.761230,242.111496 2126.574463,241.368103 
	C2128.635498,239.674179 2130.528076,238.611984 2129.942871,235.465820 
	C2129.620117,233.969131 2129.443115,233.094864 2129.172119,231.511871 
	C2125.945068,221.422714 2132.280029,219.934341 2139.116455,218.064209 
	C2146.304932,216.097717 2152.187744,215.772369 2154.437988,224.586502 
	C2155.387207,228.304199 2157.252197,231.155243 2161.631836,232.776566 
	C2163.831299,232.933685 2165.301514,233.025223 2167.500732,233.193146 
	C2173.976318,233.406387 2178.891357,234.927872 2180.130615,241.461807 
	C2181.419189,248.256470 2179.883545,254.470871 2173.522217,257.779938 
	C2166.596191,261.382629 2163.770508,265.395630 2166.654053,273.492035 
	C2169.528320,281.562347 2162.606689,283.886536 2156.877441,285.493805 
	C2151.107666,287.112305 2149.983398,291.468567 2149.693848,296.022675 
	C2149.391846,300.772522 2153.516846,302.715912 2157.260254,304.092621 
	C2163.335449,306.326965 2168.386963,302.967377 2169.152100,296.500061 
	C2169.347168,294.852631 2169.191162,293.175568 2169.337158,291.525696 
	C2170.293213,280.721222 2179.351562,276.393463 2188.527100,282.346527 
	C2192.168213,284.708771 2194.547363,288.548676 2198.309814,290.772430 
	C2201.657471,292.750946 2205.128418,293.693573 2208.526611,291.065460 
	C2211.720459,288.595398 2211.628174,285.490173 2209.248535,281.651794 
	C2208.520996,280.655518 2208.238525,280.246582 2207.565918,279.200256 
	C2204.967773,274.876556 2201.049316,275.112427 2197.552734,274.301361 
	C2191.780518,272.962372 2189.504883,268.933777 2189.441650,263.333008 
	C2189.352539,255.446289 2193.687744,252.365768 2201.012207,255.187286 
	C2203.496582,256.144257 2205.676025,257.714172 2207.906738,259.154388 
	C2214.037842,263.112793 2220.006836,267.134460 2228.052490,265.777924 
	C2232.282227,265.064789 2235.596436,267.755615 2238.904785,271.291168 
	C2241.725342,273.695770 2243.324951,276.444336 2246.938477,277.688904 
	C2249.301025,278.127930 2250.705811,277.789978 2251.194336,275.112854 
	C2251.433594,272.693298 2251.648193,270.927795 2251.808105,268.458435 
	C2250.772705,259.188782 2253.530273,252.955338 2262.121582,249.719833 
	C2266.493652,248.073334 2268.670166,244.322311 2269.278076,239.678116 
	C2269.767334,235.943985 2270.925293,232.382950 2274.318359,230.348831 
	C2282.348633,225.534668 2289.979248,220.682053 2292.682373,210.649155 
	C2293.700439,206.870224 2297.806641,205.446564 2301.784424,206.333160 
	C2306.686279,207.425735 2310.165039,210.491379 2311.190430,215.525192 
	C2312.128662,220.131042 2308.414062,221.661911 2305.263672,223.613342 
	C2296.378174,229.116806 2296.065918,231.085358 2303.120117,238.702026 
	C2307.549561,239.454254 2310.358643,237.767731 2313.178711,234.534790 
	C2316.093994,232.330353 2315.788086,230.069992 2314.662842,227.857147 
	C2310.563721,219.796280 2315.075195,217.511642 2321.935059,217.357773 
	C2330.214600,217.172058 2332.936768,212.787613 2332.544434,205.132568 
	C2331.841797,191.410614 2343.068604,184.763824 2356.143066,191.850067 
	C2357.603760,193.453705 2358.441895,194.630554 2359.880859,196.234467 
	C2369.358643,200.491760 2372.531494,199.200714 2375.034668,190.782654 
	C2378.778076,178.193466 2389.741455,175.519455 2399.045654,184.926132 
	C2406.609863,192.573975 2409.599365,193.320404 2417.638184,187.584061 
	C2423.898926,183.116455 2427.206787,185.112640 2430.087402,191.888275 
	C2430.906494,193.271011 2431.227051,194.116241 2431.511719,195.645325 
	C2431.695312,197.902756 2431.735107,199.534760 2433.058838,201.449387 
	C2433.671143,202.289215 2433.919189,202.630829 2434.525391,203.503754 
	C2441.248535,206.846008 2444.677002,205.181290 2444.942871,197.331390 
	C2445.207275,189.534668 2448.039795,183.563553 2453.500977,177.605774 
	C2454.544189,175.146301 2455.484131,173.431320 2456.799072,171.049866 
	C2458.147949,154.018387 2473.417725,150.148346 2483.073486,141.662750 
	C2487.312256,137.937744 2494.424561,136.942886 2497.471924,145.918839 
	C2496.601074,149.701523 2493.654297,151.131165 2492.143555,153.630051 
	C2489.895020,157.350571 2487.338623,161.647202 2491.431641,165.151443 
	C2495.737061,168.837631 2500.012207,166.400146 2503.492432,162.831406 
	C2504.650635,161.643799 2505.220459,160.070236 2505.986328,157.858093 
	C2507.161133,155.063339 2507.155273,152.658539 2508.020752,150.520294 
	C2510.282959,144.932068 2515.090088,142.871582 2520.535645,142.217117 
	C2525.988037,141.561813 2527.793701,145.565674 2529.399414,149.802155 
	C2531.656982,155.759048 2535.103271,158.796844 2541.617676,153.211090 
	C2542.733643,151.918213 2543.446533,151.244370 2544.796387,150.162933 
	C2549.824463,148.057068 2548.770020,143.912521 2549.517822,140.594208 
	C2550.874268,134.575409 2553.744629,130.376114 2561.388184,131.548676 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2496.385742,148.571030 
	C2494.137939,141.840729 2489.252930,139.969482 2483.816650,143.555099 
	C2481.928955,144.800064 2480.459961,146.672089 2478.767578,148.222412 
	C2476.836670,149.991104 2475.129883,152.689529 2472.872559,153.295059 
	C2464.191406,155.623886 2460.636719,160.950043 2461.485840,169.703766 
	C2461.542236,170.285034 2460.196045,171.002365 2458.750977,171.828827 
	C2456.538574,171.064911 2455.867188,169.542221 2455.081787,168.097610 
	C2453.776123,165.696259 2452.240479,163.486252 2449.069092,163.854935 
	C2447.241943,164.067352 2446.165039,165.366928 2446.004883,167.196075 
	C2445.725830,170.376907 2446.567139,173.095245 2449.622803,174.678329 
	C2451.373779,175.585281 2453.434814,175.785660 2455.523438,177.512299 
	C2450.700684,184.919754 2447.938721,192.426437 2446.755859,201.366455 
	C2445.561768,210.392502 2439.311035,211.458603 2432.119141,204.693512 
	C2432.950439,203.093002 2433.950684,202.244293 2435.194092,201.767059 
	C2440.471924,199.741287 2443.082764,195.489166 2439.574219,191.121719 
	C2435.770752,186.386902 2434.486328,194.057281 2430.657715,194.186981 
	C2425.105469,194.108322 2426.994385,188.728378 2424.439941,186.986191 
	C2421.531738,186.535156 2420.374756,188.926910 2418.670166,190.335114 
	C2411.698975,196.094498 2403.673096,195.484970 2398.171387,187.979736 
	C2395.103760,183.794449 2391.852051,181.502869 2386.634277,182.014496 
	C2380.654297,182.600830 2379.029785,184.082474 2377.997559,190.452988 
	C2376.216309,201.446808 2369.076904,204.726715 2358.367676,198.650665 
	C2358.415283,197.483337 2358.922119,197.107483 2359.488525,196.811111 
	C2361.921875,195.537781 2365.628906,196.997925 2366.968018,193.467987 
	C2367.496094,192.075745 2366.676758,190.858643 2365.384521,190.358383 
	C2361.284180,188.771225 2360.234375,193.494736 2356.655029,194.198486 
	C2353.290527,192.982117 2351.503906,189.309952 2348.196289,190.424988 
	C2343.869873,191.883331 2339.655518,193.818939 2335.649902,196.017471 
	C2333.843018,197.009308 2333.890625,199.473251 2334.286865,201.472443 
	C2334.605713,203.081024 2335.438477,204.603256 2335.648926,206.215271 
	C2336.773193,214.828934 2332.450195,219.675903 2323.690918,220.041534 
	C2320.851562,220.160049 2317.746826,219.047226 2315.064941,221.449707 
	C2314.497803,224.792389 2317.579346,226.560471 2318.648926,229.194870 
	C2320.176514,232.956223 2318.888672,234.821411 2314.686035,235.920303 
	C2313.439697,235.630600 2312.987061,235.164276 2312.582275,234.647400 
	C2310.708740,232.254669 2310.059814,227.325928 2305.755127,229.243103 
	C2301.586182,231.099777 2304.515625,234.982895 2304.995850,238.024078 
	C2305.151855,239.010117 2305.158447,239.983017 2304.436035,241.472565 
	C2298.100342,241.175262 2295.069092,236.974091 2294.861572,231.834854 
	C2294.683594,227.430664 2298.070312,223.986084 2302.213379,221.954361 
	C2303.995850,221.080261 2305.936768,220.519669 2307.686279,219.591721 
	C2308.460449,219.181152 2309.224365,218.305634 2309.496582,217.477982 
	C2310.254883,215.171448 2306.101807,209.791718 2302.605225,208.606934 
	C2299.512695,207.559082 2295.587402,207.721695 2294.981689,211.026901 
	C2292.845459,222.687332 2284.326172,227.873627 2275.023926,232.658005 
	C2272.322266,234.047531 2271.865967,236.801834 2272.024170,239.567108 
	C2272.401611,246.171906 2268.912109,249.757996 2263.214111,252.487579 
	C2253.641846,257.073242 2253.764160,257.328735 2254.488037,267.550842 
	C2250.126709,270.755646 2243.961182,267.947662 2240.577393,273.645569 
	C2237.472412,273.909729 2235.549561,272.747498 2234.249268,270.616730 
	C2232.828369,268.288086 2230.437988,267.382141 2228.234863,268.164642 
	C2219.686035,271.201202 2213.747803,265.724548 2207.243896,262.136627 
	C2204.350342,260.540405 2201.833740,258.220428 2198.873535,256.795929 
	C2195.056885,254.959457 2192.600098,256.616180 2192.056885,260.854675 
	C2191.050537,268.710449 2192.739746,271.069794 2200.462402,271.959015 
	C2204.176025,272.386627 2207.774170,272.694122 2209.861328,277.267822 
	C2208.196777,279.916748 2205.772705,279.330414 2203.557129,279.622131 
	C2201.158447,279.937988 2198.947998,280.719482 2198.781738,283.574921 
	C2198.649658,285.839355 2200.197510,287.197784 2202.204590,287.770660 
	C2205.033936,288.578156 2206.403564,286.800354 2207.296143,284.460632 
	C2207.761963,283.239716 2208.222168,282.018127 2209.466309,280.454834 
	C2216.473633,281.877045 2214.141846,286.838470 2213.171875,290.621796 
	C2212.198242,294.421417 2205.572266,296.746674 2201.241455,295.397614 
	C2198.357178,294.499176 2195.814941,292.915436 2193.681641,290.692474 
	C2191.606201,288.529633 2189.460205,286.429749 2187.270996,284.381531 
	C2183.887939,281.216370 2180.034912,281.564697 2176.082764,283.069183 
	C2172.207764,284.544250 2171.834961,287.763214 2171.991211,291.275177 
	C2172.065186,292.938049 2172.001465,294.607056 2171.998535,296.273285 
	C2171.991699,300.306091 2172.170410,304.060150 2167.183350,306.055450 
	C2161.346191,308.390900 2156.247314,308.319092 2151.357910,304.227570 
	C2147.554932,301.045258 2145.698242,297.961578 2147.285645,292.224182 
	C2148.750000,286.931915 2150.891357,284.068634 2156.002197,282.960449 
	C2157.939453,282.540375 2159.823730,281.804413 2161.673584,281.065948 
	C2164.477295,279.946655 2166.146973,278.264191 2164.592773,274.935669 
	C2163.895508,273.442932 2163.539062,271.783356 2163.097656,270.180389 
	C2160.972900,262.464203 2161.199707,261.516449 2168.657471,257.781860 
	C2174.410645,254.900787 2178.808105,251.704819 2178.075439,244.243073 
	C2177.441406,237.787140 2177.549561,237.539948 2168.813965,236.002411 
	C2165.595459,233.243835 2168.018555,231.093307 2168.949219,228.791901 
	C2170.093994,225.961121 2169.805664,223.534058 2167.015381,221.944977 
	C2165.202393,220.912445 2163.152588,220.737701 2161.410645,222.133438 
	C2158.997314,224.067230 2160.210938,226.294922 2161.211426,228.394897 
	C2162.201904,230.473404 2163.607910,232.421814 2162.439941,235.464325 
	C2156.208252,234.810303 2153.262695,231.188461 2151.840820,225.478867 
	C2150.018555,218.161682 2149.526855,218.130600 2142.531006,220.134903 
	C2140.643311,220.675751 2138.802246,221.402939 2136.893311,221.843094 
	C2130.144531,223.399384 2130.136963,223.366241 2131.909912,231.252289 
	C2129.138428,234.534348 2126.451172,232.246277 2123.701660,231.699463 
	C2119.680176,230.899597 2114.987549,230.166748 2114.398193,235.585571 
	C2113.870850,240.433151 2118.219727,240.890488 2122.070312,240.721191 
	C2123.710449,240.649078 2125.343994,240.507736 2127.463867,241.549774 
	C2127.861328,245.808990 2124.522217,246.428604 2122.094238,248.013107 
	C2115.792236,252.125916 2115.536865,252.927429 2117.797607,260.183685 
	C2118.291016,261.767578 2118.961182,263.303619 2119.356201,264.909393 
	C2120.318115,268.819702 2122.145752,270.723480 2126.454102,268.883728 
	C2130.382080,267.206329 2134.262207,267.918640 2137.931885,270.008636 
	C2141.746338,272.181091 2143.963623,275.634674 2143.507812,279.804626 
	C2142.957031,284.840668 2139.503906,288.090271 2134.597900,289.458801 
	C2130.495117,290.603302 2126.626709,290.265778 2123.793701,286.578247 
	C2122.790527,285.272644 2121.836670,283.851532 2121.225830,282.335876 
	C2118.720459,276.118622 2115.777344,273.124512 2107.742188,275.131744 
	C2102.180664,276.521027 2095.359375,273.625061 2092.302002,266.763733 
	C2090.999268,263.840210 2089.998535,260.570129 2085.805420,260.003784 
	C2079.956299,259.213928 2073.725830,261.027618 2072.464111,264.391815 
	C2071.474854,267.029205 2075.305664,276.603882 2078.187256,278.686859 
	C2080.266846,280.190063 2082.684570,280.411621 2084.819824,279.365845 
	C2091.080322,276.299561 2094.093262,280.676392 2097.108154,284.618256 
	C2100.445801,288.982361 2100.881836,293.720734 2097.717041,298.515259 
	C2095.476562,301.909302 2092.596924,304.531433 2089.062988,306.587036 
	C2085.641113,308.577332 2084.349121,311.053955 2085.348633,315.634644 
	C2087.150391,323.891937 2081.534912,329.954315 2073.143311,329.628143 
	C2069.420654,329.483490 2065.965088,327.871216 2064.422607,324.019226 
	C2062.512451,319.248688 2064.282227,311.960968 2067.908691,309.451538 
	C2068.970947,308.716339 2070.271729,308.250519 2071.528564,307.885803 
	C2075.827881,306.638336 2078.868408,304.363098 2077.834473,299.379578 
	C2076.947021,295.101196 2075.705078,290.896301 2070.313965,290.068420 
	C2065.408447,289.315186 2058.521484,291.709625 2056.879395,294.852966 
	C2055.836670,296.848938 2056.600342,298.664612 2057.194336,300.588776 
	C2058.439209,304.622742 2057.050537,307.685211 2052.700684,309.876892 
	C2051.117676,309.072174 2050.406494,308.057220 2049.932373,306.837524 
	C2046.490967,297.986237 2046.084595,297.934052 2038.576172,305.634644 
	C2035.240234,305.973572 2034.130615,303.861542 2032.735229,301.994080 
	C2030.312744,298.752502 2027.387451,297.220367 2023.277344,299.249542 
	C2019.844727,300.944153 2013.600952,300.562653 2013.323975,304.172424 
	C2012.917969,309.465546 2015.272583,315.088287 2017.046509,320.370544 
	C2017.719727,322.375122 2020.533813,322.197906 2022.401978,321.479645 
	C2025.909180,320.131134 2029.490845,319.749542 2033.151123,320.061188 
	C2038.861450,320.547363 2041.379761,323.130249 2041.963379,328.812103 
	C2042.716553,336.146057 2041.623291,338.166779 2035.729614,340.335205 
	C2028.248413,343.087677 2027.066284,342.839569 2022.103271,336.749237 
	C2023.782715,334.090424 2026.177246,334.709686 2028.366089,334.436218 
	C2030.725464,334.141449 2032.877563,333.434357 2033.096924,330.574554 
	C2033.210083,329.099304 2032.187378,328.193298 2030.907104,327.740784 
	C2028.513428,326.894867 2026.447266,327.456421 2024.932861,329.546356 
	C2023.771362,331.149445 2023.823730,333.237823 2022.452148,335.474670 
	C2019.234253,335.929504 2018.200317,333.869110 2016.890869,331.874084 
	C2012.669556,325.441742 2005.391113,324.091888 1999.235962,328.535492 
	C1998.226074,329.264496 1997.104980,330.369293 1996.833008,331.493347 
	C1995.949463,335.145325 2003.754272,345.756775 2007.675293,345.907501 
	C2015.617310,346.212830 2020.924561,349.909363 2023.415405,357.347961 
	C2025.305908,362.993683 2023.563843,368.532227 2018.032593,369.388123 
	C2006.938965,371.104736 2007.571777,378.415619 2008.000000,387.119873 
	C2010.840698,394.288330 2005.653442,396.465759 2001.446045,399.870117 
	C1996.354004,401.861847 1993.198730,404.386810 1993.688599,409.715088 
	C1993.777832,410.685028 1993.437622,411.696533 1993.089355,412.633362 
	C1991.082764,418.029541 1987.674805,421.829346 1981.549805,422.139130 
	C1977.563843,422.340729 1974.206909,420.816681 1972.681885,416.977417 
	C1970.514771,411.521759 1971.187012,406.243927 1976.033936,402.567017 
	C1980.609253,399.096344 1983.397949,395.213593 1983.171021,389.206573 
	C1982.978027,384.099670 1981.117676,381.462463 1975.823730,383.031799 
	C1967.733521,385.429993 1962.363159,382.003296 1958.197876,375.440033 
	C1956.951538,373.476074 1955.529663,371.571899 1953.563232,370.260529 
	C1947.914429,366.493408 1942.184814,368.930084 1941.049316,375.667358 
	C1940.498413,378.935669 1941.032471,382.365753 1940.037964,385.574829 
	C1937.989014,392.184967 1932.989990,395.256195 1926.474243,395.304993 
	C1919.973389,395.353668 1915.988525,391.197479 1914.356812,385.262024 
	C1912.726074,379.330231 1911.759033,372.516327 1918.815552,369.654114 
	C1926.417480,366.570709 1928.163940,361.857452 1927.630005,354.210266 
	C1927.107910,346.733551 1931.650879,341.589569 1939.044312,339.944092 
	C1946.174927,338.357147 1952.276733,340.161591 1955.975220,347.135345 
	C1957.671631,350.334290 1958.910767,354.414215 1963.592041,353.744080 
	C1967.069580,353.246246 1972.731445,354.995850 1972.461548,348.715881 
	C1972.256958,343.958893 1970.561279,339.295807 1964.018066,340.052277 
	C1958.630493,340.675079 1953.467041,340.855164 1949.179199,336.416656 
	C1943.002808,330.023376 1942.394897,323.002258 1947.946167,318.085510 
	C1954.527344,312.256531 1965.708374,312.178619 1970.487427,317.944275 
	C1973.801514,321.942444 1974.427368,329.578430 1982.534180,327.127075 
	C1990.084961,324.843811 1986.767456,318.340149 1987.342529,313.548462 
	C1988.161255,306.726959 1991.947021,302.636353 1998.028198,300.441010 
	C2002.230835,298.923859 2004.120605,296.659241 2002.155518,292.204163 
	C2000.621704,288.726654 1999.020508,285.307159 1994.266724,286.257080 
	C1989.251587,287.259247 1989.727783,291.079285 1989.937256,294.868439 
	C1990.285034,301.161804 1989.598633,307.012451 1981.473389,309.023499 
	C1977.354858,306.625793 1979.205444,303.717072 1979.891357,301.009979 
	C1980.738525,297.667175 1981.415283,294.125702 1977.294800,292.782074 
	C1973.055054,291.399567 1971.671021,294.811951 1970.576538,298.040161 
	C1970.156616,299.278717 1969.727173,300.506561 1968.542969,302.137848 
	C1964.315918,303.977875 1962.418457,301.625793 1960.980103,298.895782 
	C1959.405640,295.906982 1957.507690,293.284485 1954.192749,290.798279 
	C1952.960327,286.408234 1955.300659,284.546478 1958.994141,282.928467 
	C1963.316772,282.931244 1966.887573,284.487732 1970.497925,283.092773 
	C1973.122070,282.078827 1976.989014,282.168518 1976.958984,278.190002 
	C1976.934448,274.921173 1974.360229,273.023560 1971.493042,271.766693 
	C1970.268311,271.229889 1968.937256,270.891144 1967.633545,270.964844 
	C1957.024780,271.564850 1948.758789,268.864136 1945.818970,257.091553 
	C1944.901367,253.416840 1940.980713,253.135803 1937.616455,252.688446 
	C1934.133789,252.225311 1930.043457,252.594040 1929.076538,247.105438 
	C1930.948486,243.518433 1934.223877,243.824738 1936.872070,242.827179 
	C1938.916626,242.056961 1940.212402,240.747025 1940.032715,238.523117 
	C1939.865723,236.456909 1938.826416,234.783783 1936.671265,234.257675 
	C1934.444458,233.714020 1932.981201,234.964264 1931.899780,236.733109 
	C1930.540283,238.956741 1930.425781,241.717865 1928.323975,244.313492 
	C1921.243164,242.059341 1919.787109,236.778122 1923.825439,230.312683 
	C1926.009033,226.816833 1929.462280,224.733551 1932.705811,222.410889 
	C1936.035034,220.026749 1936.703735,216.932343 1933.904541,213.934753 
	C1930.814941,210.625961 1926.139893,212.313782 1925.652222,215.153870 
	C1923.619385,226.994415 1916.625854,234.962769 1907.954468,242.329941 
	C1905.926270,244.052887 1906.956299,248.061401 1906.664673,251.032166 
	C1906.234131,255.416870 1905.772583,259.828400 1899.657959,261.056335 
	C1895.763062,259.388763 1896.810913,256.613251 1897.096191,254.106812 
	C1897.412720,251.325684 1897.339111,248.725418 1894.128174,247.712967 
	C1891.627930,246.924698 1889.504761,247.849274 1888.321533,250.122330 
	C1886.887817,252.876801 1887.843262,255.183365 1890.333618,256.883362 
	C1891.413208,257.620239 1892.614136,258.165619 1894.179932,259.412231 
	C1893.030640,268.028778 1889.039185,275.528931 1889.475952,284.256500 
	C1889.666748,288.068085 1885.171143,289.772919 1881.866699,291.394531 
	C1877.650391,293.463562 1874.313843,296.573456 1875.537598,301.492554 
	C1877.639526,309.941315 1873.089233,315.254211 1868.110107,320.851288 
	C1861.618042,328.149109 1862.212891,330.713409 1871.020630,334.703979 
	C1877.146973,337.479736 1883.004883,340.429840 1886.737549,346.401550 
	C1888.406616,349.071838 1890.756104,349.771729 1893.510620,347.891144 
	C1895.148071,346.773224 1897.250122,345.624817 1896.857178,343.364349 
	C1896.239380,339.809296 1893.067383,340.432709 1890.503906,340.100922 
	C1881.798828,338.974182 1875.133423,332.802155 1872.606079,323.996918 
	C1870.719482,317.424744 1873.987671,313.069000 1878.653564,309.438843 
	C1886.571655,303.278076 1894.169678,305.369720 1901.157715,315.379700 
	C1908.724487,326.218689 1910.071045,326.266205 1919.599731,315.570312 
	C1925.177246,313.915100 1929.068115,316.803070 1933.824829,319.090240 
	C1933.392334,327.257446 1931.283325,334.685303 1930.623413,342.498413 
	C1930.089233,348.818909 1923.226318,350.634186 1917.649536,351.738678 
	C1911.579346,352.941010 1909.838501,355.301331 1912.471069,361.300720 
	C1915.134888,367.371918 1916.216553,373.791840 1908.632812,377.657135 
	C1901.204590,381.443207 1893.767700,380.279236 1889.262329,373.114471 
	C1884.510620,365.557922 1879.985596,360.333344 1869.762695,361.731384 
	C1864.167603,362.496582 1861.657471,356.428619 1860.395508,351.532410 
	C1858.885010,345.672241 1856.622681,344.031891 1850.565674,346.664734 
	C1838.295166,351.998230 1835.905884,350.805023 1831.242798,338.567017 
	C1829.455811,333.877380 1827.890991,329.498138 1821.504028,331.840607 
	C1818.585938,332.910828 1814.107300,332.617981 1814.727417,337.474213 
	C1815.491333,343.456635 1818.854980,346.678223 1825.335815,347.225464 
	C1836.788696,348.192535 1840.899658,351.787262 1842.040649,360.406097 
	C1842.828979,366.360870 1840.617798,370.944061 1835.382080,373.752045 
	C1829.920532,376.681122 1825.111938,375.904053 1821.540039,369.584717 
	C1822.536377,366.014374 1825.496460,365.903839 1827.710815,364.684357 
	C1829.632324,363.626190 1830.668335,362.144531 1830.057983,359.895233 
	C1829.665161,358.447296 1828.557251,357.792328 1827.128662,357.807648 
	C1824.514038,357.835632 1824.052246,359.800812 1823.745483,361.804901 
	C1823.547363,363.099304 1823.402344,364.397461 1822.397095,366.132019 
	C1817.935303,368.337891 1815.959473,365.206360 1813.398193,363.234528 
	C1806.836304,358.182922 1800.764893,360.583496 1799.019775,368.841888 
	C1798.677856,370.460205 1798.703003,372.135681 1798.582886,373.786346 
	C1798.044067,381.194489 1794.015015,385.611786 1786.697388,385.936890 
	C1779.295288,386.265839 1773.908936,382.235565 1771.453125,375.399231 
	C1768.944580,368.415710 1773.089355,364.169037 1778.921265,361.161682 
	C1780.980347,360.099945 1783.178223,359.160614 1784.500000,357.145172 
	C1787.313110,352.855042 1785.484497,349.332031 1781.903198,346.939026 
	C1777.922974,344.279510 1775.092896,346.291595 1773.388794,350.339783 
	C1772.051270,353.517181 1772.644287,357.906525 1767.293213,358.947693 
	C1762.962769,357.510925 1763.480103,349.696472 1757.117188,352.710693 
	C1755.236450,353.601624 1753.750610,355.385590 1754.573730,357.495911 
	C1756.563965,362.599030 1761.581909,359.562347 1764.984619,360.997986 
	C1765.288330,361.126099 1765.587158,361.265503 1766.339111,361.958130 
	C1763.348511,371.606171 1751.941528,373.303802 1744.745728,365.775970 
	C1742.658691,363.592743 1741.639771,360.640625 1739.614136,358.414398 
	C1737.539673,356.134369 1734.934326,356.143768 1732.241699,356.990051 
	C1729.455078,357.865906 1728.728638,360.079742 1729.398071,362.545044 
	C1731.720825,371.098663 1726.925293,376.440002 1721.209839,381.452423 
	C1717.912842,384.343903 1714.348877,387.300873 1715.807617,392.357971 
	C1717.417725,397.939697 1722.453613,397.073334 1726.630127,397.270477 
	C1731.734863,397.511444 1735.530273,399.587433 1738.129395,403.987793 
	C1739.143555,405.704742 1740.291382,407.353394 1741.594482,408.875031 
	C1743.911987,411.580963 1746.689575,413.433929 1750.332764,411.973633 
	C1753.817261,410.576874 1753.387207,407.291351 1753.491455,404.273712 
	C1753.925781,391.691040 1755.951660,388.794983 1765.071045,386.516693 
	C1771.525024,384.904327 1776.152832,386.960297 1779.235962,392.745667 
	C1782.245361,398.392731 1784.065796,404.426849 1778.358765,409.123932 
	C1771.389282,414.859955 1767.149902,421.283051 1765.324951,430.510712 
	C1763.467041,439.905945 1751.414307,442.801910 1743.331787,437.109009 
	C1741.113892,435.546997 1739.436646,433.476379 1737.886230,431.307709 
	C1735.862793,428.477692 1733.263550,427.734711 1730.017456,428.801117 
	C1726.625854,429.915222 1725.167358,432.416748 1725.672607,435.734222 
	C1727.090332,445.040375 1722.316772,451.008850 1716.331177,457.535248 
	C1708.554688,466.014282 1704.654297,477.679901 1695.279175,485.147186 
	C1693.988281,486.175385 1692.928467,487.501282 1690.908813,488.866852 
	C1684.507446,490.901367 1680.042847,488.615967 1675.766113,484.027649 
	C1675.412964,483.036713 1675.322144,482.692078 1675.397217,482.388367 
	C1676.631592,477.387634 1681.626709,471.671967 1674.333740,467.847229 
	C1666.888916,463.942780 1664.429077,471.188904 1660.040649,475.530304 
	C1653.774048,476.469910 1649.313354,474.371124 1645.356934,469.603973 
	C1649.160522,462.112274 1652.070190,455.017334 1653.537964,447.015076 
	C1654.489624,441.826508 1659.676880,438.658112 1664.659180,436.400879 
	C1666.807739,435.427429 1669.109741,434.413086 1668.258179,431.378906 
	C1667.439453,428.461304 1666.139038,425.677063 1663.107788,424.499969 
	C1660.117188,423.338531 1656.960205,425.090027 1656.494751,427.358978 
	C1653.920776,439.906464 1645.461304,448.948273 1638.717285,459.041626 
	C1637.863892,460.318756 1637.891235,462.211060 1636.525635,464.187469 
	C1626.794067,465.558411 1619.735474,460.093201 1611.656250,455.877075 
	C1610.551270,451.419281 1613.560059,450.274261 1615.963257,448.679047 
	C1626.885742,441.428711 1626.658936,437.733246 1614.360840,431.071838 
	C1611.889648,427.894623 1613.558350,425.700409 1614.925171,423.456543 
	C1616.213013,421.342255 1616.797241,419.143341 1614.880249,417.146729 
	C1613.629272,415.843567 1611.863281,415.650116 1610.380981,416.671631 
	C1607.615112,418.577576 1608.168823,421.116913 1609.458496,423.645203 
	C1610.509033,425.704407 1611.680786,427.728424 1609.904541,430.595947 
	C1599.532959,430.273590 1594.758545,421.572784 1599.444336,412.969421 
	C1600.910034,410.278229 1603.079224,408.164978 1605.602661,406.521820 
	C1609.914917,403.713928 1612.301147,400.219910 1610.994263,394.810760 
	C1609.436890,388.365143 1604.367798,390.639923 1600.402954,390.505402 
	C1593.822876,390.282104 1589.740723,387.038239 1588.179321,380.794800 
	C1586.615601,374.541199 1588.844727,369.586304 1594.323364,366.319641 
	C1599.943237,362.968933 1605.631958,362.492249 1611.001831,366.999664 
	C1613.585815,369.168640 1615.042480,372.286407 1617.335083,374.701355 
	C1620.118652,377.633606 1623.556519,378.576263 1627.371948,377.370483 
	C1632.251221,375.828461 1629.861938,372.054993 1629.723999,368.980103 
	C1629.472046,363.360687 1628.263062,357.321228 1636.330688,354.939697 
	C1640.429688,356.798767 1639.137817,360.052673 1639.463623,362.788544 
	C1639.747803,365.175232 1640.406372,367.280853 1643.110229,367.872528 
	C1644.096313,368.088348 1645.101562,367.764160 1645.635132,366.900146 
	C1647.092773,364.539795 1645.976685,362.564636 1644.459351,360.747498 
	C1643.204590,359.245056 1641.430176,358.322998 1639.658936,356.387360 
	C1637.996216,352.798340 1640.274170,350.940094 1641.494751,348.662659 
	C1645.476562,341.232513 1643.611938,337.815491 1635.035278,336.830292 
	C1631.440063,336.417267 1627.720337,336.828888 1623.811279,334.497559 
	C1620.790771,331.186127 1619.469116,327.746124 1618.458252,324.225800 
	C1615.875610,315.230591 1618.015381,310.802887 1626.744995,306.883545 
	C1630.366089,305.257812 1634.797852,304.378418 1633.560059,298.782288 
	C1632.327515,293.210510 1628.766602,291.715881 1623.216919,291.964233 
	C1612.718506,292.434052 1606.230713,287.600037 1605.826050,279.838501 
	C1605.620239,275.888855 1606.715698,272.562714 1611.591064,271.019836 
	C1615.328735,272.093536 1615.397827,274.945984 1616.179077,277.400818 
	C1616.946777,279.812958 1618.455078,281.448975 1621.196289,281.154541 
	C1622.608398,281.002869 1623.605347,279.959534 1623.703735,278.544006 
	C1623.903320,275.675232 1621.975342,274.511658 1619.549927,273.934082 
	C1617.654175,273.482635 1615.600952,273.522339 1613.613525,271.496582 
	C1618.011963,262.332428 1626.081177,261.510132 1631.268188,269.951996 
	C1635.237549,276.412476 1639.052490,280.370789 1647.428223,280.393738 
	C1653.820801,280.411255 1659.273315,284.968109 1661.532471,291.480072 
	C1663.740356,297.844513 1660.251709,302.264557 1655.315308,305.849670 
	C1653.162354,307.413361 1650.941406,309.066559 1650.199463,311.778564 
	C1649.327759,314.964813 1649.978027,318.040161 1653.207153,319.352203 
	C1656.580811,320.723053 1658.906372,318.745819 1660.223999,315.626862 
	C1661.010010,313.765930 1661.077515,311.744507 1661.234375,309.756531 
	C1661.444336,307.098297 1661.077026,303.222687 1663.011475,302.205658 
	C1677.690186,294.488586 1673.740967,274.108917 1688.016479,266.108124 
	C1691.804443,263.985168 1690.945801,259.032166 1691.254272,255.076630 
	C1692.015991,245.309601 1697.082031,240.092102 1706.002075,239.753052 
	C1713.131226,239.482086 1719.986694,245.885345 1721.369751,254.163208 
	C1722.586670,261.445465 1717.946045,265.047394 1712.534668,268.207550 
	C1709.259277,270.120361 1704.208374,270.852997 1705.122314,276.199158 
	C1706.094849,281.887726 1710.859375,282.773224 1715.728882,283.334808 
	C1720.312988,283.863434 1725.236816,284.113342 1726.848877,290.466553 
	C1724.643188,294.199890 1721.453125,293.194000 1718.595337,293.405853 
	C1716.519775,293.559692 1714.615356,294.098633 1714.211304,296.487213 
	C1713.967163,297.930237 1714.914185,298.993500 1716.100952,299.678436 
	C1718.423828,301.019226 1720.558960,300.688171 1722.204590,298.538727 
	C1723.602173,296.713226 1723.793335,294.198975 1725.973389,292.020966 
	C1730.052490,289.939789 1731.839600,293.057220 1734.294678,294.497040 
	C1741.485352,298.714233 1745.209595,297.187378 1747.195068,289.146027 
	C1747.974854,285.987854 1747.670166,282.317413 1752.399048,281.004669 
	C1755.638306,281.795990 1756.149414,284.333191 1757.530518,286.120178 
	C1758.832520,287.805084 1760.405396,288.946411 1762.624634,287.907349 
	C1763.570923,287.464386 1763.986816,286.493805 1763.902832,285.453705 
	C1763.744873,283.499420 1762.327148,282.672028 1760.683838,282.144562 
	C1759.113770,281.640625 1757.431641,281.477509 1755.575562,280.010498 
	C1755.598145,272.292938 1760.422852,271.375092 1765.646484,273.081268 
	C1771.418457,274.966583 1774.601685,279.879120 1775.738647,285.768188 
	C1776.838989,291.466858 1774.007446,295.729248 1769.153198,298.001282 
	C1762.852783,300.950073 1760.135986,305.396942 1760.744019,312.216431 
	C1761.419434,319.790741 1757.876099,324.940765 1751.181274,328.153076 
	C1750.281616,328.584747 1749.415405,329.091003 1748.506714,329.501282 
	C1744.268311,331.414856 1745.149536,334.696808 1746.299927,337.963409 
	C1746.930908,339.755157 1747.389282,342.304352 1750.070435,341.557037 
	C1753.263550,340.667023 1755.090698,337.868500 1755.249146,334.825409 
	C1755.658936,326.950256 1758.105957,320.721069 1765.740234,317.038605 
	C1775.009399,312.567596 1780.071045,313.422546 1786.609009,321.524750 
	C1788.485474,323.850098 1789.955566,326.556396 1792.855469,327.812988 
	C1795.409790,328.919769 1798.161987,329.445801 1800.279907,327.228729 
	C1802.048462,325.377441 1801.457031,322.854828 1800.968994,320.553406 
	C1800.312134,317.456299 1798.393921,316.053040 1795.225952,316.352875 
	C1794.229980,316.447113 1793.233521,316.548859 1792.261963,316.771729 
	C1786.290771,318.141785 1780.764282,317.761536 1777.528931,311.713989 
	C1774.267944,305.618774 1774.233276,298.765259 1778.797852,293.867706 
	C1785.125122,287.078552 1789.760986,280.405426 1790.317139,270.604706 
	C1790.654297,264.662445 1796.459839,261.560242 1802.012939,259.477356 
	C1805.243286,258.265778 1808.505249,256.700378 1806.567017,252.263321 
	C1804.903809,248.455963 1801.700073,246.896744 1797.642578,247.345642 
	C1793.056641,247.852966 1792.574097,250.911087 1793.437256,254.638733 
	C1795.273804,262.570221 1793.003052,268.450409 1784.970703,271.323334 
	C1775.792603,274.606049 1768.296387,272.630493 1762.818115,265.545288 
	C1761.039062,263.244324 1759.952271,259.896881 1756.112793,260.677460 
	C1752.686768,261.374023 1751.486450,264.223907 1750.746948,267.227600 
	C1749.859741,270.831299 1748.599854,274.236298 1746.081665,277.041229 
	C1741.864624,281.738800 1736.759766,283.375031 1730.786011,280.982910 
	C1724.569336,278.493500 1721.459106,273.809937 1721.494873,267.026886 
	C1721.528076,260.725311 1724.734985,256.889618 1730.724854,255.824753 
	C1736.862427,254.733612 1737.804810,251.747986 1736.618530,245.949463 
	C1734.855103,237.329056 1738.796143,230.646561 1745.733643,228.226105 
	C1753.798706,225.412186 1759.820068,227.778305 1764.922241,235.823349 
	C1765.812256,237.226486 1766.501953,238.769943 1767.658813,239.983002 
	C1770.750854,243.225220 1774.377197,242.235626 1777.865845,240.994812 
	C1780.150513,240.182144 1780.550171,238.244781 1779.683228,236.088089 
	C1778.197876,232.392746 1775.985352,229.609589 1771.452881,230.630127 
	C1764.959595,232.092102 1759.525879,231.362457 1756.927246,223.542847 
	C1758.626221,219.914627 1761.443726,220.701263 1763.952637,220.615082 
	C1767.173218,220.504440 1769.835571,219.598984 1770.232788,215.896255 
	C1770.506958,213.340775 1769.338623,211.225098 1766.819946,210.678024 
	C1762.775391,209.799469 1760.860474,212.316086 1759.954468,215.863220 
	C1759.552734,217.436157 1759.320435,219.061844 1757.607178,220.697174 
	C1755.229614,221.367844 1753.732544,220.747726 1752.173950,220.108536 
	C1742.436279,216.115036 1740.154907,217.371155 1738.147095,227.707291 
	C1736.061279,238.445755 1729.699463,242.685349 1719.763550,239.954254 
	C1714.915771,238.621719 1711.364014,235.748428 1710.327148,230.733276 
	C1709.324097,225.881546 1710.055176,221.422134 1716.055176,219.115570 
	C1719.668823,220.632828 1719.336426,223.534882 1719.871216,226.080109 
	C1720.313721,228.185562 1721.373535,229.803894 1723.802368,229.806747 
	C1724.863403,229.807983 1725.744995,229.196930 1726.049683,228.163528 
	C1726.718018,225.896530 1725.706909,224.327545 1723.735229,223.279449 
	C1721.984863,222.349045 1719.950562,221.954498 1717.984741,219.998199 
	C1715.781372,215.609283 1719.063965,213.489410 1720.588257,210.726395 
	C1725.130859,202.492279 1722.613525,197.814331 1713.401489,198.472702 
	C1705.548462,199.033936 1699.677002,197.350983 1697.034668,189.216064 
	C1696.524170,187.644409 1695.576904,186.230042 1694.283813,185.152405 
	C1691.981689,183.234100 1689.440063,183.155945 1686.909546,184.587326 
	C1685.071533,185.626968 1683.958374,187.218567 1684.308716,189.481659 
	C1684.703369,192.030350 1686.266357,193.608505 1688.636108,194.408646 
	C1691.811279,195.480774 1695.232178,194.957184 1698.431763,195.784546 
	C1708.755005,198.453888 1712.450073,208.104446 1705.174316,214.941681 
	C1701.636597,213.387802 1701.174438,210.081940 1699.165283,207.968948 
	C1697.229004,205.932648 1694.979858,204.793320 1692.151367,205.707489 
	C1690.422852,206.266083 1689.549683,207.610489 1689.623535,209.449173 
	C1689.728882,212.069412 1691.375000,213.566696 1693.575073,214.568558 
	C1695.648071,215.512604 1697.996460,215.797806 1700.334106,217.744324 
	C1697.767212,227.150467 1689.812744,229.071838 1683.931641,222.297867 
	C1681.971313,220.039948 1680.823608,217.155167 1678.726685,214.976898 
	C1676.829834,213.006546 1674.753540,211.221329 1671.751831,212.415146 
	C1669.919067,213.144073 1669.649414,214.962036 1669.780762,216.631409 
	C1670.025757,219.748245 1671.014160,222.575394 1674.334717,223.706650 
	C1676.260132,224.362640 1678.306641,223.863235 1680.297363,223.925079 
	C1689.098267,224.198456 1692.087646,230.472275 1693.813721,237.579803 
	C1695.240723,243.455551 1692.961548,248.056870 1687.502441,250.841187 
	C1680.955078,254.180511 1673.322998,252.505661 1668.554932,246.777191 
	C1667.698975,245.748810 1667.016479,244.601959 1666.378174,243.429764 
	C1664.774902,240.485046 1663.375977,237.055069 1658.990356,238.484650 
	C1655.232300,239.709656 1652.768799,242.333084 1652.221191,246.369263 
	C1651.775024,249.657318 1651.764771,252.971252 1650.255493,256.093323 
	C1644.804688,267.368164 1635.120483,269.207275 1626.061279,260.590942 
	C1624.114014,258.738831 1622.580933,256.553375 1621.068481,254.359772 
	C1618.941895,251.275604 1616.106567,250.154709 1612.422363,250.830185 
	C1608.356201,251.575745 1607.135742,254.398621 1606.849121,258.019257 
	C1606.531860,262.028076 1606.041382,265.995544 1603.742676,269.466675 
	C1598.456665,277.448456 1590.381226,277.779785 1584.946777,269.529419 
	C1586.902588,265.569733 1590.710083,265.768311 1593.436890,264.059814 
	C1595.224731,262.939697 1596.398926,261.397400 1595.943970,259.143097 
	C1595.666138,257.766479 1594.792358,256.599762 1593.367676,256.537170 
	C1591.025879,256.434296 1589.947632,258.163483 1589.193726,260.091949 
	C1588.475342,261.930084 1588.160400,263.921509 1586.588623,266.112213 
	C1581.953491,268.344360 1580.312134,264.509521 1577.639160,262.899780 
	C1573.224121,260.240784 1568.731323,260.988464 1566.468140,265.321930 
	C1563.922607,270.195618 1567.745605,272.871460 1572.043945,273.577545 
	C1581.371338,275.109833 1589.151855,278.267273 1592.990601,287.929688 
	C1594.328003,291.295807 1598.039185,290.514374 1600.982910,290.021454 
	C1610.312744,288.459137 1615.093750,293.699127 1618.480713,301.349792 
	C1622.060547,309.436127 1617.171997,313.908325 1611.426636,317.761505 
	C1604.710693,322.265564 1602.516235,327.359558 1608.443726,334.793457 
	C1609.057495,336.006317 1609.350830,336.653748 1609.300659,337.301575 
	C1608.052002,353.417206 1608.047241,353.416840 1624.027222,356.005646 
	C1621.249878,365.089142 1610.945801,367.354309 1604.425781,359.707245 
	C1598.660645,352.945221 1593.002319,348.717621 1583.924194,346.472473 
	C1572.596313,343.670898 1571.569092,330.339905 1580.905273,323.073944 
	C1582.745605,321.641663 1584.857300,320.613190 1586.751465,319.255493 
	C1589.549683,317.249786 1590.471558,314.644958 1589.132446,311.424927 
	C1587.778442,308.168793 1585.746704,305.604279 1581.803955,305.728241 
	C1578.376953,305.835938 1575.846558,307.782562 1575.465454,311.029999 
	C1574.381226,320.271912 1570.963745,327.238098 1561.626099,331.129456 
	C1557.095825,333.017395 1559.176025,340.858337 1564.703247,343.778534 
	C1567.726074,345.375519 1571.203979,345.022034 1574.430908,345.758728 
	C1580.902588,347.236176 1585.087769,351.185303 1586.213623,357.772461 
	C1587.154907,363.279144 1586.487061,368.551819 1581.193726,371.872803 
	C1575.555908,375.410095 1569.827637,374.927551 1564.187378,371.700104 
	C1560.658325,369.680756 1558.232056,366.418823 1555.233154,363.803223 
	C1552.824951,361.702698 1550.055298,360.735779 1546.935059,361.965027 
	C1543.835083,363.186249 1543.844604,365.955231 1543.899902,368.677246 
	C1543.927002,370.008301 1544.362549,371.639801 1543.695557,372.616486 
	C1535.219482,385.027924 1529.918579,399.510376 1519.576538,410.617798 
	C1516.496948,413.925262 1511.896729,415.838074 1509.650635,421.102600 
	C1508.862915,422.110443 1508.489868,422.471375 1507.403809,423.161865 
	C1505.660522,423.742340 1504.619751,423.798279 1502.814087,423.440125 
	C1501.140015,422.745026 1500.338257,422.119110 1499.271973,420.707153 
	C1497.605347,417.032257 1499.404297,414.357391 1499.817505,411.497620 
	C1500.527588,406.582520 1499.188843,401.284149 1494.105713,400.521729 
	C1488.696899,399.710480 1489.182861,405.379883 1488.643311,409.127289 
	C1488.362915,411.075989 1488.272339,413.049744 1487.144287,415.514648 
	C1486.087646,416.803345 1485.291260,417.319427 1483.695923,417.857300 
	C1482.050537,418.128387 1481.103638,418.137787 1479.470215,417.934662 
	C1477.459839,417.538727 1476.182251,417.071167 1474.199707,416.723389 
	C1472.253662,416.474030 1470.975464,416.220825 1469.071777,415.822815 
	C1467.221313,415.357147 1466.024292,414.933624 1464.164429,414.556458 
	C1462.724121,414.280304 1461.908203,414.092285 1460.491455,413.724396 
	C1458.294922,413.091827 1456.702759,412.624512 1454.409302,412.406464 
	C1452.931885,412.232880 1452.091309,412.085175 1450.624023,411.758636 
	C1448.723145,411.297333 1447.483276,410.863953 1445.509766,410.607849 
	C1443.468628,410.306488 1442.148193,409.925079 1440.340698,408.880463 
	C1439.605835,408.013611 1439.429321,407.578278 1439.326904,406.443054 
	C1440.666504,403.036316 1443.091553,401.158142 1444.541016,398.596741 
	C1445.876099,396.237244 1447.258911,393.429291 1443.579590,392.171112 
	C1440.555664,391.137054 1438.682007,393.310547 1437.870972,396.099396 
	C1436.959229,399.234039 1438.545898,402.658966 1436.377197,406.291077 
	C1434.956055,407.335480 1433.972412,407.590027 1432.130493,407.504517 
	C1430.837646,407.147430 1430.344482,406.910126 1429.301392,406.052002 
	C1425.466797,396.721741 1426.986694,389.113403 1434.364502,383.213745 
	C1438.837646,379.636810 1440.892090,375.193512 1441.292725,369.586060 
	C1441.912231,360.913025 1447.069458,355.803131 1455.088989,353.390472 
	C1460.315308,351.818146 1465.772949,350.640106 1468.990112,356.800049 
	C1471.855225,362.286316 1473.799683,367.973999 1466.644409,372.806763 
	C1463.677368,372.361908 1462.768311,370.685181 1462.419556,368.634308 
	C1461.849609,365.282349 1460.593018,362.774536 1456.580078,364.296631 
	C1454.355713,365.140320 1452.100830,366.846191 1452.660767,369.345306 
	C1453.710815,374.031281 1457.189331,371.425781 1459.803223,371.056915 
	C1461.143311,370.867828 1462.400879,370.844513 1464.092041,372.040833 
	C1466.218994,376.832123 1462.436768,379.175720 1461.036499,382.368225 
	C1459.525879,385.812012 1458.242920,389.291199 1460.831421,392.716858 
	C1462.149048,394.460815 1464.208130,394.786621 1466.260864,394.223541 
	C1470.800049,392.978485 1471.072510,389.178650 1471.195557,385.462128 
	C1471.428833,378.404633 1472.705811,371.990387 1480.843506,370.005859 
	C1486.099243,368.724182 1490.674805,370.225952 1494.485107,374.130432 
	C1497.503052,377.222870 1500.498047,380.377747 1504.276489,382.575958 
	C1506.738770,384.008453 1509.477905,384.577515 1511.594727,382.238159 
	C1513.925781,379.662231 1512.136353,377.271637 1510.436035,375.169373 
	C1506.583618,370.406189 1501.257080,368.935822 1495.424561,368.445740 
	C1490.583740,368.038940 1487.256104,365.402435 1486.401855,360.556091 
	C1485.579346,355.889404 1486.410034,351.807281 1492.873779,351.240326 
	C1496.551636,353.770142 1496.842529,359.131134 1501.938232,359.023071 
	C1503.854004,358.982452 1506.272583,359.183746 1506.451538,356.482819 
	C1506.576782,354.592896 1504.841431,353.854797 1503.138794,353.473450 
	C1500.274414,352.831970 1497.173828,354.259033 1493.943359,351.947571 
	C1496.519409,342.410309 1507.796631,340.389038 1515.426758,347.501892 
	C1517.614746,349.541565 1518.845459,352.461334 1521.363525,354.185913 
	C1524.067505,356.037781 1527.157593,356.726288 1529.498779,354.087585 
	C1531.729980,351.572754 1529.672974,349.116913 1528.079468,346.990540 
	C1525.671387,343.777069 1522.038330,343.085266 1518.382446,342.565887 
	C1512.750488,341.765778 1508.585083,338.735016 1505.333740,334.220825 
	C1499.525757,326.156891 1500.665039,318.751190 1509.596436,314.467438 
	C1515.923340,311.432953 1518.834839,307.992676 1517.745117,300.772278 
	C1516.891479,295.115295 1520.513672,291.346558 1525.625366,289.425690 
	C1530.271240,287.679962 1535.199097,285.628723 1538.955566,292.025085 
	C1538.256592,295.907806 1535.159180,296.085052 1533.001465,297.438232 
	C1530.864258,298.778595 1529.389893,300.438324 1530.070801,303.133545 
	C1530.420776,304.518585 1531.497803,305.434753 1532.927002,305.490723 
	C1535.748047,305.601135 1537.013306,303.686981 1537.792236,301.335754 
	C1538.413330,299.460785 1538.404907,297.378052 1540.295410,295.380432 
	C1545.044312,294.499023 1546.532715,298.033539 1548.891846,300.185974 
	C1551.979126,303.002838 1555.416138,303.240509 1559.049316,301.558380 
	C1561.871216,300.251831 1562.678345,297.807983 1562.184570,294.916046 
	C1561.511475,290.975128 1559.434692,288.191803 1555.347656,287.282196 
	C1552.424438,286.631592 1549.357666,286.903107 1546.476440,286.013123 
	C1539.995850,284.011322 1536.912842,279.158630 1535.827881,272.836914 
	C1534.804932,266.876068 1536.977295,262.254364 1542.543091,259.774567 
	C1548.266724,257.224396 1551.204712,253.032227 1552.144897,246.897751 
	C1552.637817,243.681229 1553.716797,240.334732 1558.172852,239.120728 
	C1561.643677,240.740021 1561.369995,243.416611 1561.418213,246.010010 
	C1561.462036,248.371185 1561.845215,250.808670 1564.619629,251.289413 
	C1566.887695,251.682419 1568.148804,250.005203 1568.595703,247.934128 
	C1569.207886,245.098206 1568.647705,242.746979 1565.417969,241.889862 
	C1563.865967,241.477997 1562.193726,241.536133 1560.245239,240.223755 
	C1557.406372,235.297165 1560.966797,233.039551 1563.379517,230.564240 
	C1566.855103,226.998611 1567.484009,223.181885 1565.252319,218.830536 
	C1564.046265,216.478912 1562.026123,215.482590 1559.484619,216.067001 
	C1554.847168,217.133392 1552.188110,220.099518 1551.033936,224.764359 
	C1550.082153,228.610855 1551.484131,233.911591 1544.765015,234.867859 
	C1541.234985,232.335876 1541.730225,228.797394 1540.911133,225.716202 
	C1540.041870,222.446747 1539.129150,218.853867 1534.506958,220.777756 
	C1530.415527,222.480637 1529.950928,225.780289 1531.329956,229.739182 
	C1533.159790,234.992874 1538.293335,233.701447 1542.384521,235.936005 
	C1543.565308,238.632645 1543.078125,240.844910 1541.418701,241.944519 
	C1535.828857,245.648529 1535.130249,250.079163 1536.848267,256.469116 
	C1539.029541,264.582764 1532.978516,268.951385 1526.500244,271.239197 
	C1519.830688,273.594574 1517.593872,276.904236 1519.422363,283.882538 
	C1521.032837,290.028503 1518.222290,295.259521 1512.742065,298.184814 
	C1507.047241,301.224579 1504.534912,305.419678 1504.705688,311.794189 
	C1504.924561,319.967926 1500.472412,324.657501 1492.792603,326.859741 
	C1485.142212,329.053528 1480.839966,325.096741 1477.402954,319.110382 
	C1475.049561,315.011536 1471.801636,312.510010 1466.743896,313.663300 
	C1461.806641,314.789093 1461.351807,318.723419 1460.670166,322.834961 
	C1458.737793,334.488556 1452.337158,338.709869 1437.525757,337.761810 
	C1432.629883,336.610382 1431.500977,332.998444 1429.928223,329.717316 
	C1428.531616,326.803650 1426.459717,324.739258 1422.881104,325.787201 
	C1421.116089,326.304077 1420.168457,327.756622 1420.502563,329.608948 
	C1421.079590,332.808319 1422.795044,335.225372 1426.235352,335.561188 
	C1429.532959,335.883026 1432.844727,335.937012 1436.548340,337.755188 
	C1445.864624,351.224457 1444.958862,357.781281 1432.599365,366.184509 
	C1428.783325,368.779022 1426.993408,372.609924 1423.683350,376.351044 
	C1418.353027,377.180573 1416.819946,373.622925 1414.715332,369.776245 
	C1414.322021,368.442108 1414.184204,367.797821 1414.202148,367.151398 
	C1414.576538,353.625977 1411.887695,351.811005 1398.064453,356.987366 
	C1392.751831,357.738129 1389.410156,355.805878 1386.895996,351.112122 
	C1386.372925,347.703888 1387.134644,345.285004 1388.818481,342.392578 
	C1392.596924,339.500427 1395.620850,341.762634 1398.772827,342.416168 
	C1403.398438,343.375214 1408.613892,344.593231 1411.233765,339.428436 
	C1413.957886,334.058014 1410.793335,329.926483 1406.367065,326.766968 
	C1405.554443,326.186890 1404.750366,325.597473 1403.579224,324.342590 
	C1402.274658,320.956390 1403.489624,318.963959 1406.260254,316.988831 
	C1407.528198,316.459412 1408.167969,316.263153 1408.816040,316.272461 
	C1425.750366,316.516479 1427.080444,315.089081 1425.296753,298.295532 
	C1430.526978,295.372772 1432.764404,298.775726 1435.113892,302.062225 
	C1436.499756,304.000916 1436.418945,308.255981 1439.942871,307.046753 
	C1443.666626,305.769043 1443.243774,301.838898 1442.810303,298.516205 
	C1442.553833,296.549164 1441.646973,294.763550 1440.798828,292.211670 
	C1440.290283,287.179382 1442.512817,283.792206 1445.299927,279.890442 
	C1451.295044,278.217651 1455.487061,281.212982 1460.274658,284.151428 
	C1461.534546,288.487366 1458.334351,289.791077 1456.412231,291.845917 
	C1453.981689,294.444824 1452.459595,297.306732 1454.923462,300.574799 
	C1456.704834,302.937317 1459.416016,303.161407 1462.077515,302.274017 
	C1465.662964,301.078552 1467.079346,298.335327 1467.042603,294.676056 
	C1467.010620,291.499969 1465.095703,289.198883 1463.197021,286.075317 
	C1462.427368,282.541199 1463.762085,280.575592 1466.713989,278.768677 
	C1482.378784,277.624847 1483.478149,276.774719 1485.356934,262.303894 
	C1485.966309,257.610809 1488.044922,254.607254 1492.079712,252.161377 
	C1502.253540,245.993866 1502.442627,244.921707 1497.954590,232.217239 
	C1497.259888,228.920776 1497.326904,226.379547 1498.496582,223.199677 
	C1501.037598,219.825912 1504.031006,220.494415 1506.832886,220.794739 
	C1511.943115,221.342453 1516.309204,219.979584 1520.452393,215.832886 
	C1522.632690,214.217987 1524.587280,213.729584 1526.373779,212.880432 
	C1529.447510,211.419418 1533.298340,209.256424 1531.902832,205.785599 
	C1530.076050,201.242523 1526.291626,205.584259 1522.679688,205.731125 
	C1511.238525,203.319534 1504.750732,208.224915 1500.492065,218.401428 
	C1498.114136,219.823151 1496.274536,219.700394 1493.869141,218.405792 
	C1491.333618,216.690186 1491.116211,212.232056 1487.444336,214.202805 
	C1484.438843,215.815887 1484.852783,218.486588 1487.091309,221.574799 
	C1488.541138,224.306259 1489.217407,226.554367 1489.226562,229.667480 
	C1485.398193,235.949661 1481.604736,234.265762 1477.907959,230.376465 
	C1476.776367,229.186066 1476.163330,227.585068 1475.305664,226.176407 
	C1473.476807,223.172623 1471.224243,220.862091 1467.290283,221.948074 
	C1465.606689,222.412872 1464.326416,223.561096 1464.264038,225.428024 
	C1464.132690,229.365402 1466.798218,231.246658 1469.917969,232.722153 
	C1472.770996,234.071442 1476.639282,234.174408 1476.883423,239.240982 
	C1473.927368,243.627045 1469.860107,245.360535 1465.078369,247.204926 
	C1449.569092,243.772034 1446.917603,244.653732 1438.750488,256.158997 
	C1429.302368,255.599564 1423.591431,258.067413 1423.927002,268.575775 
	C1424.052612,272.511841 1420.384277,274.776978 1417.339722,276.872040 
	C1413.221069,279.706177 1409.081177,282.504028 1404.916504,286.414246 
	C1394.460083,286.560394 1386.266357,289.098267 1382.458862,300.227844 
	C1379.860229,301.566681 1377.956787,300.938873 1376.231323,299.863159 
	C1370.544922,296.318085 1368.072510,299.220306 1365.729004,304.313477 
	C1358.553345,319.907501 1348.877686,321.891205 1335.434570,310.820465 
	C1333.332764,309.089661 1331.230347,307.448914 1328.391968,307.452484 
	C1326.336548,307.455048 1324.267212,307.896942 1323.894531,310.396606 
	C1323.610229,312.304382 1324.941284,313.427277 1326.496460,314.233643 
	C1327.698120,314.856720 1329.053589,314.946136 1330.339111,315.281921 
	C1341.830322,318.283173 1347.638184,325.102142 1345.883057,333.482697 
	C1344.100342,341.994141 1334.974121,346.976288 1323.274414,345.101624 
	C1319.475952,342.245636 1319.506470,338.241302 1318.017212,334.961853 
	C1316.526611,331.679657 1314.335205,329.266632 1310.279297,330.314117 
	C1307.429199,331.050171 1305.378418,332.801788 1305.916626,336.021851 
	C1306.520386,339.635681 1308.803833,341.911865 1312.470703,342.674622 
	C1315.393433,343.282562 1318.475952,341.843231 1321.847412,343.865540 
	C1324.246460,346.112396 1325.632690,348.072784 1324.797729,351.507782 
	C1321.833130,354.299072 1318.799438,353.353302 1315.900513,353.135651 
	C1310.489624,352.729523 1306.109009,354.206268 1303.063721,359.889374 
	C1302.328003,360.610840 1302.036011,360.960297 1301.771851,360.940277 
	C1290.867188,360.115143 1284.325439,362.521057 1285.739990,376.116119 
	C1286.475098,383.180725 1273.711548,386.749664 1266.569458,382.210297 
	C1264.295044,380.764771 1262.748169,378.602234 1261.076904,376.548035 
	C1258.651611,373.567261 1256.368896,368.923859 1251.694824,372.387909 
	C1247.822754,375.257416 1250.423950,378.962341 1252.359375,382.058380 
	C1254.114136,384.865112 1256.265747,387.493927 1254.765503,391.823120 
	C1253.979248,392.804932 1253.566406,393.121216 1252.428711,393.759033 
	C1247.958496,395.074493 1244.221313,394.996521 1239.767822,393.689331 
	C1238.634277,393.085205 1238.224365,392.784729 1237.357300,391.896179 
	C1236.149902,389.786407 1235.928589,388.161926 1235.919312,386.484924 
	C1235.897095,382.469208 1236.339355,377.794373 1230.640503,377.573578 
	C1225.073364,377.357910 1225.014282,382.115082 1224.340088,386.021484 
	C1224.170776,387.003296 1223.898926,387.959503 1223.183105,389.481262 
	C1220.666260,392.130951 1217.495361,392.945709 1215.588257,391.244812 
	C1207.149292,383.718628 1203.055420,389.337463 1198.542480,396.550110 
	C1196.655884,397.629181 1195.259521,397.792419 1193.131836,397.346466 
	C1191.024414,396.284363 1190.335938,394.798218 1189.309326,393.602264 
	C1184.381226,387.861328 1182.781372,388.216919 1179.133301,396.404449 
	C1178.770386,397.568420 1178.540894,398.011658 1177.699707,398.906067 
	C1174.580322,400.477905 1172.047119,400.432159 1168.802002,399.133392 
	C1166.403442,397.334991 1165.552368,395.406586 1164.666748,392.620544 
	C1164.074951,387.031464 1165.666016,382.769012 1168.684937,378.226410 
	C1170.013550,377.157837 1170.914795,376.652222 1171.882324,376.685211 
	C1186.621338,377.187286 1186.620972,377.197449 1185.687012,362.130981 
	C1186.352539,358.365112 1188.162598,356.075165 1190.901611,353.556641 
	C1196.194214,351.318451 1201.091431,349.750122 1203.376953,343.674377 
	C1206.666260,341.427734 1209.598999,341.910309 1212.538940,342.611908 
	C1216.436768,343.542084 1220.377075,343.432922 1221.370117,338.859497 
	C1222.355835,334.320251 1219.122192,331.537415 1215.225952,329.808838 
	C1212.478271,328.589752 1209.302612,328.952698 1206.542603,327.778717 
	C1200.636108,325.266357 1197.412109,315.344330 1201.353027,309.896881 
	C1204.693237,305.279816 1209.053223,300.903656 1214.960205,308.072632 
	C1214.723511,310.110809 1213.812988,310.986206 1212.882324,311.910217 
	C1211.403076,313.379059 1208.389160,314.859711 1211.001465,317.220428 
	C1213.078369,319.097412 1215.086914,316.552551 1217.611084,315.225494 
	C1229.562134,315.128143 1239.167847,312.859467 1242.734375,299.933990 
	C1243.677979,296.513794 1247.571167,294.630981 1250.343140,292.280457 
	C1254.290894,288.932922 1255.753418,284.860626 1253.876465,279.872894 
	C1251.997681,274.879578 1247.941406,275.428619 1243.891479,276.041992 
	C1237.422729,277.021790 1234.294312,273.475494 1232.024170,267.965790 
	C1230.174561,263.476898 1228.208984,257.995972 1221.761963,259.256561 
	C1217.787598,260.033630 1216.328491,263.913544 1215.933960,267.692841 
	C1215.270996,274.042267 1218.231079,277.757568 1225.227783,278.938904 
	C1229.251831,283.582520 1223.310669,289.742035 1228.853027,294.395264 
	C1226.565918,302.248627 1222.468262,299.983398 1219.019775,296.318817 
	C1215.688843,292.779053 1213.649292,288.115082 1209.579834,284.153381 
	C1208.207153,281.367889 1208.497192,278.936340 1207.836060,276.710602 
	C1206.854370,273.405579 1205.476440,269.868469 1201.273071,270.594147 
	C1196.614380,271.398407 1197.286987,275.112854 1198.219238,278.509735 
	C1198.660156,280.115814 1199.183350,281.698395 1199.092285,284.074371 
	C1195.112061,289.402802 1192.237793,287.590546 1189.890625,283.288300 
	C1188.622681,280.964203 1188.002441,278.284210 1186.166748,276.268921 
	C1183.020874,272.815460 1179.291626,272.521484 1175.292358,274.515320 
	C1171.230225,276.540558 1169.163940,279.744843 1170.665405,284.301697 
	C1173.425293,292.677002 1170.100830,297.929291 1162.285522,300.615143 
	C1155.434937,302.969421 1153.520386,308.143005 1153.002930,315.220764 
	C1151.035034,317.516479 1149.193970,317.250122 1147.263428,316.385986 
	C1137.232788,311.896210 1137.230347,311.901520 1137.621582,323.495056 
	C1137.190552,326.594299 1136.586182,328.913055 1135.154053,331.698303 
	C1134.280029,332.735718 1133.782593,333.190979 1133.179810,333.396118 
	C1118.443359,338.411011 1118.418701,338.492554 1128.807251,350.001801 
	C1120.611450,356.873077 1115.178101,355.863434 1111.248901,347.166748 
	C1109.418945,343.116486 1107.971802,338.746124 1102.288818,340.210754 
	C1096.987183,341.577148 1095.267090,345.711060 1095.401367,350.821228 
	C1095.515015,355.145752 1096.060425,359.665436 1089.631104,361.064514 
	C1084.039429,359.318024 1087.064819,351.798553 1080.952148,350.470398 
	C1079.135986,355.107819 1084.692139,356.303162 1085.005127,360.393982 
	C1082.899780,367.064209 1081.726685,373.031647 1082.185181,379.475677 
	C1082.645386,385.942413 1079.871460,390.398346 1071.661621,389.576569 
	C1067.384277,387.130859 1068.988159,383.528961 1068.583496,380.457214 
	C1068.268311,378.064392 1067.671265,375.626740 1064.547363,376.142212 
	C1061.641113,376.621735 1061.306030,378.975433 1061.744995,381.443634 
	C1062.196167,383.981659 1063.686401,386.335907 1062.785400,389.682312 
	C1057.953613,393.330322 1054.461792,392.010925 1051.725220,387.683899 
	C1050.846191,386.294159 1050.189087,384.765320 1049.214722,383.436035 
	C1047.092407,380.540588 1044.504883,378.712036 1040.800537,380.488495 
	C1038.297241,381.688965 1037.824585,383.924042 1038.625122,386.352417 
	C1039.739136,389.730652 1041.650024,392.079346 1045.776855,391.741089 
	C1049.226807,391.458252 1053.856934,388.202728 1054.864014,395.518188 
	C1045.475830,401.220795 1044.113647,409.221313 1046.060547,419.265289 
	C1045.720337,420.466614 1045.524536,420.933960 1044.854492,422.007019 
	C1043.526367,423.217133 1042.583252,423.605621 1040.787598,423.746216 
	C1039.550659,423.548676 1039.077759,423.384247 1038.007568,422.782410 
	C1035.275635,419.572449 1035.672363,416.105743 1034.824341,412.980072 
	C1033.991943,409.911530 1032.446655,407.299103 1028.755981,407.885223 
	C1025.352173,408.425873 1023.997559,411.116516 1023.692505,414.285797 
	C1023.317505,418.181458 1025.004272,422.088379 1023.391968,426.664185 
	C1021.420593,429.645874 1019.079285,430.170715 1015.711975,429.640747 
	C1011.256714,427.321289 1011.912903,423.290100 1010.853943,419.994324 
	C1010.077148,417.576752 1009.573364,414.310425 1005.923828,415.492188 
	C1003.101440,416.406067 1003.630432,419.092621 1004.373474,421.314606 
	C1005.411255,424.418030 1006.552490,427.470703 1005.472778,431.527222 
	C1004.296021,434.101135 1002.875671,435.534851 1000.485107,437.076782 
	C997.811707,438.166779 995.797852,438.250427 993.085449,437.416870 
	C988.998352,434.237885 990.622314,430.508118 990.731445,427.035675 
	C990.841064,423.547119 990.130005,420.444794 986.482178,419.022034 
	C984.481750,418.241821 982.540283,418.826508 981.059998,420.292816 
	C978.361389,422.965942 978.511963,426.128906 979.922302,429.356018 
	C980.968018,431.748932 983.005798,433.602264 983.837891,436.904785 
	C983.960876,438.106628 983.953674,438.596313 983.784790,439.808716 
	C983.406738,440.977112 983.190552,441.422852 982.467285,442.413147 
	C975.275452,445.882935 968.263123,447.888672 960.711792,450.447449 
	C958.218506,450.815765 956.532898,451.351746 954.528198,452.888397 
	C952.724915,453.805573 951.425781,454.142670 949.450073,454.537231 
	C945.683411,454.977722 942.792786,455.898071 939.730225,458.200348 
	C938.844299,458.893463 938.477478,459.157990 937.530518,459.781189 
	C936.148132,460.577423 935.325562,460.972900 933.841370,461.575470 
	C930.128479,462.724609 926.986694,463.349670 923.233337,464.373444 
	C920.277710,464.837097 918.058472,465.601257 915.042664,465.409668 
	C908.711975,463.059662 903.390930,461.688416 901.677734,470.763794 
	C901.441467,472.402283 901.104614,473.288727 900.093506,474.630859 
	C897.254211,476.417664 894.804443,476.508972 891.585632,475.893799 
	C889.341980,475.082458 888.101746,474.026398 886.865417,472.953857 
	C884.544250,470.940094 882.022827,469.028351 879.194702,471.855347 
	C876.352173,474.696777 878.624512,477.224915 880.332275,480.399963 
	C879.136658,483.846527 876.682617,484.088959 873.361633,483.889282 
	C867.846985,480.481689 864.543945,475.348541 858.508911,472.523010 
	C858.030457,469.251068 860.379700,468.264130 861.927429,466.587250 
	C865.092163,463.158569 864.440979,459.210846 862.565918,455.438232 
	C860.770630,451.826233 857.696960,449.736816 853.653748,450.546844 
	C849.761108,451.326691 845.789246,452.535980 845.159851,457.585785 
	C844.915405,459.546539 844.379211,461.470642 843.981995,463.412689 
	C842.665833,469.848175 837.115540,474.972534 831.010376,475.281403 
	C826.899780,475.489349 825.371277,472.332367 823.773987,469.416779 
	C821.914246,466.022034 820.570618,462.036377 824.197937,459.469971 
	C827.528992,457.113190 829.771484,453.805298 832.970337,451.430878 
	C837.052185,448.401031 836.188843,444.701477 834.359497,440.734741 
	C832.509827,436.723938 829.393555,435.554596 825.392761,436.167603 
	C823.439148,436.466919 821.576782,437.543427 819.631653,437.681061 
	C814.665833,438.032410 813.627991,441.017578 814.044067,445.211151 
	C814.142578,446.203644 814.092834,447.252838 814.408386,448.174194 
	C815.500977,451.364288 817.224182,455.048798 813.172913,456.932922 
	C809.146118,458.805695 804.813293,461.698303 800.008545,458.630768 
	C796.057678,456.108398 795.761475,452.181976 796.058838,448.025909 
	C796.272217,445.044312 797.619629,443.050507 800.550842,442.141235 
	C802.133850,441.650208 803.699280,441.053040 805.196411,440.343018 
	C811.959778,437.135254 813.136719,434.888794 811.610107,427.863892 
	C811.188232,425.922516 810.360413,424.072754 809.792480,422.159088 
	C807.648315,414.933929 809.151001,412.782196 816.813904,412.035309 
	C826.703430,411.071350 828.278076,411.631012 831.287170,421.176788 
	C833.084900,426.879913 836.583191,429.308502 841.564026,427.829071 
	C852.135681,424.689056 858.867920,428.901794 864.482849,437.333649 
	C867.040833,441.175018 870.654236,443.232544 875.593994,440.238159 
	C878.893982,438.237762 880.478699,435.843933 879.627197,432.061218 
	C879.336243,430.769104 878.713623,429.552124 878.416504,428.260773 
	C876.550049,420.147919 876.520569,419.547272 868.387573,420.170685 
	C860.466736,420.777771 856.143799,417.909698 853.124207,410.642822 
	C850.124451,403.423737 848.504700,403.216064 840.552246,404.799042 
	C832.229065,406.455841 831.514832,406.048859 829.130493,398.289948 
	C826.750732,390.546295 827.938049,387.710602 834.696655,384.738190 
	C838.267578,383.167725 843.497131,383.630280 845.119141,379.857117 
	C846.670471,376.248535 843.421936,372.346741 842.514343,368.519287 
	C840.686462,360.811218 842.105957,358.421417 849.591797,356.063080 
	C849.904053,355.964722 850.259399,356.011383 850.581116,355.934021 
	C855.160645,354.832367 858.299255,351.970337 859.537170,347.529633 
	C860.232300,345.035919 852.743408,337.132050 849.369934,336.228149 
	C839.295471,333.528625 834.986755,337.688507 837.049744,348.122711 
	C838.489685,355.405701 838.135132,356.110229 830.550598,358.753754 
	C818.884949,362.819763 817.657166,365.141815 817.986328,349.093536 
	C818.065552,345.233490 819.893005,343.016998 823.208679,341.395355 
	C826.707520,339.684082 831.517334,339.952606 833.443848,335.849731 
	C835.121887,332.275879 832.842896,328.740875 832.253662,325.176819 
	C831.245056,319.075958 837.855469,312.019897 844.141663,312.119751 
	C846.749023,312.161163 848.619751,313.369995 849.731079,315.633942 
	C851.215149,318.657166 853.171936,321.257416 855.555603,323.654449 
	C859.445740,327.566254 868.269592,329.555481 872.783386,327.249115 
	C875.179443,326.024872 876.351257,323.905121 875.419556,321.477173 
	C874.192749,318.280090 874.131287,314.969116 873.612427,311.701721 
	C872.646851,305.621948 873.568054,303.964447 878.969299,302.172516 
	C880.534790,301.653168 882.255249,301.578430 883.793213,301.002411 
	C891.012878,298.298279 892.236206,297.062775 891.881165,289.374725 
	C891.545288,282.102325 892.626953,276.671661 900.443481,273.522003 
	C908.027283,270.466125 906.304993,263.023193 905.702332,256.883148 
	C904.862366,248.325485 904.564636,248.354660 912.488770,245.550385 
	C920.115845,242.851196 923.267151,237.465607 921.256104,229.040253 
	C920.130127,224.323044 919.037720,221.129730 925.604126,219.568741 
	C936.343262,217.015778 938.898804,217.185898 941.602173,223.580444 
	C945.205383,232.103378 944.745605,234.363953 936.327942,238.668716 
	C930.193115,241.806015 927.096069,245.908691 927.954773,252.869431 
	C928.238220,255.166840 927.887817,257.535187 928.010376,259.861450 
	C928.191833,263.303864 927.035706,265.645599 923.425049,266.445160 
	C922.138000,266.730133 920.924377,267.347382 919.677979,267.815247 
	C912.547607,270.491821 911.259094,272.150513 912.226990,277.404633 
	C913.392517,283.731384 917.770264,287.848755 923.598145,287.952332 
	C925.246643,287.981598 926.944397,287.851105 928.545654,287.477203 
	C935.881226,285.764404 936.707642,284.321381 934.633911,277.146637 
	C934.079834,275.229797 933.471985,273.323639 932.781006,271.452423 
	C931.818787,268.846619 932.471741,266.911926 934.953430,265.629822 
	C937.321106,264.406616 939.646362,263.088165 942.072266,261.993256 
	C949.172607,258.788696 949.610413,259.019989 952.454590,266.469116 
	C953.406982,268.963501 954.574097,271.326141 956.395203,273.364288 
	C960.876892,278.379944 962.977905,278.516907 970.548767,275.658478 
	C975.773804,273.685730 976.293030,269.902893 975.997559,265.291138 
	C975.347961,255.152481 973.063721,253.368759 963.029541,255.357544 
	C955.934204,256.763855 953.288635,255.555237 951.019470,249.870865 
	C948.490723,243.536072 949.777588,239.924118 956.000854,235.980377 
	C961.113403,232.740463 966.154114,229.665634 966.053711,222.353043 
	C965.930847,213.401978 962.124023,209.474747 953.270264,210.030273 
	C951.949646,210.113159 950.631287,210.320663 949.326477,210.552902 
	C940.908386,212.051132 940.620667,211.838867 937.478882,203.403015 
	C936.669312,201.229187 935.487549,199.192230 934.451599,197.104889 
	C933.231262,194.646133 931.372437,193.871231 928.688293,194.705826 
	C925.523376,195.689865 922.324463,196.607788 919.086182,197.302383 
	C913.860168,198.423294 911.647522,196.988617 910.319580,191.945160 
	C908.057922,183.355301 910.960999,178.523575 919.343140,176.473312 
	C924.271912,175.267761 927.850769,176.374557 929.726379,181.393158 
	C930.075134,182.326141 930.590454,183.195557 931.000427,184.107178 
	C934.789062,192.531738 936.018921,193.141068 945.392090,191.215057 
	C953.281860,189.593857 956.217468,190.281342 958.516602,197.677734 
	C961.275146,206.552124 966.657532,208.650726 975.024841,208.142166 
	C981.723328,207.735062 984.918030,210.464493 987.082214,216.327972 
	C989.378357,222.548935 987.864136,225.768600 981.619324,227.717834 
	C980.360596,228.110764 978.906921,227.945312 977.701416,228.430481 
	C974.330811,229.786987 970.512573,230.869766 970.141724,235.412231 
	C969.748108,240.233688 970.864746,244.980743 974.124573,248.382721 
	C978.493835,252.942413 990.177185,247.988678 991.741516,241.132370 
	C992.177734,239.220078 991.941040,237.152634 991.999207,235.155975 
	C992.247742,226.634521 992.245911,226.634430 1001.259827,223.947723 
	C1007.746094,222.014389 1007.746216,222.014343 1012.850464,229.456253 
	C1019.151917,238.643677 1023.023621,239.775955 1032.623901,236.188461 
	C1036.865234,234.603546 1038.499512,232.144379 1037.591553,227.877289 
	C1037.247192,226.258331 1036.468018,224.719559 1036.223755,223.093658 
	C1035.057129,215.327545 1043.321289,208.425293 1050.823120,210.849075 
	C1053.337524,211.661453 1053.939697,214.184967 1055.244263,216.045700 
	C1059.869629,222.642487 1065.255859,227.539459 1074.223999,226.064682 
	C1078.416870,225.375153 1081.129150,227.657593 1082.738037,231.472504 
	C1084.047485,234.577637 1085.925781,237.321381 1088.561401,239.480240 
	C1093.070801,243.173950 1102.340820,242.418945 1105.759033,237.899811 
	C1109.298462,233.220322 1105.854858,229.061447 1104.325073,224.862198 
	C1103.031982,221.312897 1100.370361,219.554138 1096.495728,220.291016 
	C1094.872437,220.599747 1093.339600,221.396271 1091.714722,221.683609 
	C1081.747681,223.446304 1079.406494,221.688629 1077.991943,211.545349 
	C1076.999756,204.430130 1076.402832,204.016541 1069.033691,205.336380 
	C1057.719238,207.362854 1055.697632,206.340836 1051.210449,196.327011 
	C1047.286377,187.569458 1045.999634,186.868912 1037.063965,188.624588 
	C1029.278687,190.154236 1027.316040,189.038406 1024.849854,181.453888 
	C1023.680359,177.857468 1023.085144,174.165756 1026.296021,171.261230 
	C1029.647827,168.229263 1038.467773,167.059143 1041.489380,169.076767 
	C1043.537964,170.444672 1044.355591,172.705017 1045.295898,174.828720 
	C1049.578491,184.501480 1050.630859,185.711533 1060.784424,183.605682 
	C1066.641479,182.390945 1069.451294,183.640198 1071.538940,188.835953 
	C1072.512207,191.258286 1074.390625,193.305328 1075.753662,195.585403 
	C1077.719604,198.874084 1078.551392,203.403336 1084.414795,200.846329 
	C1091.029541,197.961685 1095.524048,193.075638 1094.974976,188.077545 
	C1094.686157,185.446960 1094.623657,182.651794 1093.642944,180.266418 
	C1091.678833,175.489166 1093.944946,173.477997 1098.013306,172.322037 
	C1099.924683,171.778915 1101.928833,171.565552 1103.847046,171.041794 
	C1107.401367,170.071289 1110.978760,168.753860 1113.900269,172.330856 
	C1116.583496,175.616043 1116.985596,182.964630 1114.238647,186.444458 
	C1111.774780,189.565506 1108.750122,192.249893 1105.917603,195.071686 
	C1103.744507,197.236694 1101.916382,199.476761 1102.002075,202.824951 
	C1102.120605,207.452606 1101.102905,212.986618 1106.153442,215.232269 
	C1110.538818,217.182159 1115.186890,214.265961 1119.466431,212.714294 
	C1121.878784,211.839615 1122.285278,208.951614 1121.921143,206.631454 
	C1120.322632,196.444748 1124.659180,190.470398 1134.115845,186.727097 
	C1140.539673,184.184280 1141.700195,178.734207 1138.818115,171.790787 
	C1136.037231,165.090561 1132.443115,163.279007 1125.598267,165.186401 
	C1123.676392,165.722000 1121.771729,166.332993 1119.889404,166.995087 
	C1117.057129,167.991226 1115.435303,166.607971 1114.377808,164.223465 
	C1113.031860,161.188400 1111.739868,158.127670 1110.499512,155.047836 
	C1108.444336,149.944382 1104.340332,149.226013 1099.795166,150.465988 
	C1096.949219,151.242386 1094.312744,152.860168 1091.660645,154.250244 
	C1089.412964,155.428375 1087.947144,157.194855 1089.024292,159.923248 
	C1090.036377,162.487183 1090.063843,165.135620 1089.979126,167.799683 
	C1089.782104,174.007462 1081.185059,181.189758 1075.452271,179.147797 
	C1069.532471,177.039246 1068.041016,170.851639 1066.385498,165.534851 
	C1065.047852,161.239029 1067.719849,158.878387 1071.886475,157.645844 
	C1074.370361,156.911072 1076.464478,154.887238 1078.942505,154.096542 
	C1082.842529,152.852066 1084.216553,150.230591 1083.961060,146.533417 
	C1083.322021,137.284210 1087.776123,131.712143 1095.958496,127.880859 
	C1104.216675,124.014137 1104.379272,122.611244 1101.064453,113.990425 
	C1100.468750,112.441307 1099.990601,110.842957 1099.530762,109.246429 
	C1097.746338,103.051689 1098.200684,102.373055 1104.502441,102.027763 
	C1106.496460,101.918518 1108.519043,102.177597 1110.497192,101.969582 
	C1115.667236,101.425934 1118.559937,103.689331 1119.962402,108.641777 
	C1121.129028,112.761665 1122.231079,117.218391 1127.683350,117.914162 
	C1133.572510,118.665688 1138.890625,117.248749 1143.752930,113.876419 
	C1146.437622,112.014420 1145.894043,109.229790 1145.981689,106.627670 
	C1146.037720,104.964928 1146.296875,103.192970 1145.845703,101.651161 
	C1144.544922,97.205666 1143.795776,93.097694 1149.112915,90.712204 
	C1153.514771,88.737404 1157.993164,90.290657 1162.134766,95.289932 
	C1162.976562,96.306007 1163.547363,97.541756 1164.331909,98.610924 
	C1170.566040,107.105423 1173.651489,107.580933 1182.739990,102.723724 
	C1186.954224,100.471504 1188.477173,97.393433 1187.974243,93.017960 
	C1187.138916,85.748985 1188.875244,80.095078 1196.062134,76.516762 
	C1200.636841,74.239014 1199.918091,69.293114 1200.046631,64.933472 
	C1200.261719,57.631672 1205.427734,51.578796 1212.425659,50.273136 
	C1216.692017,49.477139 1220.250122,50.234245 1222.375122,54.753502 
	C1224.839966,59.995205 1224.762573,64.476837 1220.875732,67.329720 
	C1218.171631,69.314529 1215.678467,71.443085 1213.263062,73.735458 
	C1208.667603,78.097153 1209.411377,83.500580 1210.787109,88.632919 
	C1211.692017,92.008308 1214.691406,93.774109 1218.458984,93.964874 
	C1227.303223,94.412704 1232.458984,90.174988 1231.828491,81.273338 
	C1231.193359,72.306099 1234.296875,66.924530 1242.674683,63.511234 
	C1249.723877,60.639263 1249.490723,60.067150 1248.238770,51.439259 
	C1247.234009,44.513855 1254.753174,37.461590 1261.750610,38.867622 
	C1262.593872,39.037071 1263.619141,39.756191 1264.006104,40.506363 
	C1266.704224,45.735432 1270.125244,50.677029 1271.505005,56.821869 
	C1267.423340,57.849045 1263.864624,58.514053 1260.461304,59.646175 
	C1251.731567,62.550171 1249.235107,67.677116 1252.110474,76.264824 
	C1254.165649,82.402733 1253.250732,84.106514 1246.785889,86.153801 
	C1246.152832,86.354279 1245.495972,86.478737 1244.862427,86.678009 
	C1235.097412,89.749397 1234.279785,90.872429 1233.999512,101.563507 
	C1233.790283,109.547096 1232.222046,112.164192 1226.309692,113.560997 
	C1221.740845,114.640373 1217.645996,114.148438 1215.527466,109.038757 
	C1214.892822,107.508087 1214.102783,106.007248 1213.166260,104.642235 
	C1208.720459,98.162544 1205.799072,97.240837 1198.984619,100.014755 
	C1193.001221,102.450378 1191.193481,105.693062 1192.148804,112.652954 
	C1192.372070,114.278915 1193.057739,115.840317 1193.518188,117.435051 
	C1194.661255,121.394249 1192.970337,123.852356 1189.325684,125.214539 
	C1187.769897,125.795990 1186.131958,126.168320 1184.600708,126.802864 
	C1175.869507,130.420929 1175.035889,131.958115 1176.680664,141.096527 
	C1177.904907,147.898712 1177.515381,148.521957 1170.076416,151.967575 
	C1165.704346,153.992645 1161.271973,155.686188 1157.160889,151.642181 
	C1154.035767,148.567963 1152.954590,139.722778 1155.045288,136.561874 
	C1156.906616,133.747772 1160.305908,133.937119 1162.901855,132.547684 
	C1170.032471,128.731125 1172.299316,124.118523 1170.074829,117.338875 
	C1167.789429,110.373459 1165.657715,109.064430 1158.223999,110.061073 
	C1152.252441,110.861694 1148.410645,114.654007 1148.029053,120.219841 
	C1147.915283,121.878746 1147.830688,123.572433 1148.030029,125.214111 
	C1148.736328,131.034927 1146.777222,134.708176 1140.674316,136.189453 
	C1136.494141,137.204071 1132.298340,138.780167 1132.016357,144.392822 
	C1131.712769,150.435104 1133.748047,155.518921 1137.943481,159.691025 
	C1140.431396,162.164902 1143.392822,161.207581 1146.355591,160.276978 
	C1151.688599,158.601944 1155.885986,158.438431 1158.965698,165.025467 
	C1161.221680,169.850983 1165.381592,174.231064 1172.209717,174.087234 
	C1180.026978,173.922562 1185.216919,170.190369 1183.637451,162.784042 
	C1181.657471,153.499176 1185.667114,149.962036 1193.331299,147.873749 
	C1196.792969,146.930511 1197.968384,144.401489 1197.968750,141.075684 
	C1197.969116,138.409546 1197.963257,135.742981 1198.005615,133.077332 
	C1198.132935,125.061211 1204.671997,119.831337 1212.368774,122.279266 
	C1217.857910,124.025040 1217.752930,130.117767 1219.598877,134.465622 
	C1221.060303,137.907608 1218.311157,139.890305 1215.412354,141.304016 
	C1211.526733,143.198914 1207.635498,145.012482 1204.607788,148.339523 
	C1202.470581,150.687943 1202.327271,152.753098 1203.734131,155.515060 
	C1205.681885,159.339172 1208.699707,161.779709 1212.574463,163.153214 
	C1220.242432,165.871307 1226.821533,160.482056 1225.757690,152.486786 
	C1224.433716,142.537186 1224.433716,142.537231 1233.792847,139.086365 
	C1242.281738,135.956360 1243.551636,133.767014 1242.379761,124.282959 
	C1241.433228,116.624420 1243.260376,114.179222 1250.241821,111.574013 
	C1254.133545,110.121773 1256.625366,111.018227 1258.807617,114.086281 
	C1259.962524,115.709953 1260.898438,117.501900 1262.149902,119.041824 
	C1265.858398,123.604874 1270.105225,126.904282 1276.614868,126.065132 
	C1282.747803,125.274551 1286.315063,128.090561 1288.475952,134.159424 
	C1291.400879,142.373764 1295.878906,143.916870 1304.105347,140.847107 
	C1305.658936,140.267349 1307.090820,139.368988 1308.611206,138.690460 
	C1314.763794,135.944839 1314.742432,135.960968 1316.107178,142.255051 
	C1316.528320,144.197021 1317.263672,146.074539 1317.631104,148.023804 
	C1319.052490,155.566284 1318.138550,157.923889 1310.887207,161.439087 
	C1306.664551,163.486099 1303.757446,166.047882 1302.750122,170.673096 
	C1301.132568,178.101578 1305.353271,184.188324 1312.892334,183.834579 
	C1319.529419,183.523148 1324.412842,185.320435 1328.036255,190.924881 
	C1329.086670,192.549774 1330.778931,193.858017 1332.396851,194.999771 
	C1337.886963,198.874115 1342.524658,198.221619 1345.063354,193.379883 
	C1347.772339,188.213196 1345.712036,180.901855 1340.728394,178.697189 
	C1338.944092,177.907867 1336.842529,177.870621 1334.940186,177.306702 
	C1330.388184,175.957413 1327.620850,172.760315 1326.438843,168.288147 
	C1325.433105,164.482025 1325.806396,161.026352 1329.833496,158.882980 
	C1331.584229,157.951157 1333.152466,156.682129 1334.837524,155.620102 
	C1341.727173,151.277802 1342.732056,148.980011 1341.276367,140.762955 
	C1340.038452,133.774490 1349.541748,124.857201 1356.032959,126.921585 
	C1356.332397,127.016830 1356.724731,127.105759 1356.878784,127.330971 
	C1360.418457,132.507690 1360.507202,138.712631 1361.019897,144.500351 
	C1361.314087,147.822067 1357.264160,149.558243 1353.810913,150.342010 
	C1352.525146,150.633835 1351.343384,151.366928 1350.062500,151.700882 
	C1345.902466,152.785568 1342.466675,154.720673 1342.377075,159.539963 
	C1342.299194,163.730957 1347.533325,169.513489 1352.335449,171.090927 
	C1357.258301,172.708008 1360.737549,170.335876 1363.493652,166.693298 
	C1365.798462,163.646973 1366.317505,159.965561 1365.993286,156.222794 
	C1365.604370,151.730911 1368.076050,149.678024 1371.958862,148.298950 
	C1379.503540,145.619217 1386.280640,145.760040 1391.655762,152.635681 
	C1391.859009,152.895615 1392.118164,153.117371 1392.373657,153.330032 
	C1398.466431,158.402496 1401.964722,158.964554 1405.428101,155.432785 
	C1409.222534,151.563431 1408.738525,142.055695 1404.553345,137.995834 
	C1402.027588,135.545761 1399.146362,135.767899 1396.202759,136.938828 
	C1391.822754,138.681076 1389.333008,137.166290 1387.893799,132.773499 
	C1386.494995,128.503708 1384.695679,124.443130 1390.340576,121.782593 
	C1391.826660,121.082153 1392.993286,119.681549 1394.493408,119.037956 
	C1397.927368,117.564613 1401.096924,117.258560 1401.980103,122.155205 
	C1402.098389,122.810921 1402.097412,123.525314 1402.370972,124.109802 
	C1404.216797,128.051865 1403.724854,133.790436 1410.391479,133.978760 
	C1416.094116,134.139847 1424.466187,129.329300 1426.781372,124.372421 
	C1427.808960,122.172119 1427.634155,119.818794 1428.141479,117.579521 
	C1430.054077,109.138008 1440.404541,105.754364 1446.586670,111.723389 
	C1451.521362,116.487946 1456.350708,120.843010 1463.881836,119.949455 
	C1470.783936,119.130516 1472.304321,116.881554 1470.297974,110.151398 
	C1469.074219,106.046707 1467.807739,101.954811 1466.404419,97.345078 
	C1470.541016,96.056152 1474.262939,94.902245 1477.981201,93.736450 
	C1483.264893,92.079811 1487.001953,89.166809 1485.969604,82.944359 
	C1484.602295,74.704262 1488.233154,70.226532 1495.694336,66.844940 
	C1501.075806,64.405952 1505.618774,59.964157 1502.541626,52.463783 
	C1501.230957,49.269352 1502.460327,46.897583 1506.159302,45.632542 
	C1512.546753,43.448055 1518.461548,42.534451 1523.465820,48.432598 
	C1525.684082,51.047153 1528.618164,52.753155 1531.869629,53.607208 
	C1540.098633,55.768703 1546.998901,50.211784 1545.548096,42.147457 
	C1544.890747,38.492435 1544.289673,35.367256 1547.876709,33.544876 
	C1552.272705,31.311563 1556.963989,28.616865 1562.074829,30.671547 
	C1566.722656,32.540104 1567.258301,41.474762 1563.310181,45.569481 
	C1561.403687,47.546932 1558.963135,48.688564 1556.462524,49.572689 
	C1551.890869,51.189026 1547.833496,52.435379 1549.263306,59.140057 
	C1551.222778,68.329781 1552.337769,70.382317 1559.340942,71.452171 
	C1560.309692,71.600166 1561.322876,71.619431 1562.299561,71.528656 
	C1575.715332,70.281975 1576.793213,68.745522 1573.570679,55.565205 
	C1571.005371,45.072777 1571.005371,45.072826 1580.505981,40.702591 
	C1589.782104,36.435669 1590.731445,32.615444 1583.892090,25.001068 
	C1580.168823,20.856012 1577.897827,15.408856 1572.383057,12.777844 
	C1569.658569,11.478049 1570.021973,8.258216 1570.001709,4.819893 
	C1571.760376,2.464603 1573.920776,3.206416 1576.672485,3.115263 
	C1587.322388,15.677081 1587.323364,15.680200 1603.001343,10.968405 
	C1604.956909,10.380722 1606.890137,10.101522 1609.368408,11.500188 
	C1615.513306,23.950720 1613.729858,30.930084 1602.923828,37.333359 
	C1598.369507,40.032089 1596.989136,43.395054 1599.115845,48.073307 
	C1600.687744,51.531078 1603.024170,54.774555 1607.388062,53.563553 
	C1612.007690,52.281570 1613.154419,48.240280 1612.468262,43.997982 
	C1611.404663,37.421650 1613.596436,33.099491 1619.975342,30.831165 
	C1625.263306,28.950748 1630.097168,26.209658 1628.399170,19.441265 
	C1626.807251,13.096250 1621.394287,13.380763 1616.288208,13.658453 
	C1614.288330,13.767207 1612.304932,13.785290 1610.042847,11.995375 
	C1608.055176,8.676660 1609.136597,6.389799 1611.579834,3.781918 
	C1617.962646,2.678370 1623.710938,3.181202 1630.170532,3.016974 
	C1633.518555,2.748570 1636.108398,4.900609 1639.441162,3.072200 
	C1642.961792,3.049145 1645.798096,2.960311 1649.335693,3.282194 
	C1652.122803,4.850450 1652.955444,7.077260 1653.705200,9.259696 
	C1656.059326,16.111601 1660.692749,19.409664 1668.013184,19.230616 
	C1673.890869,19.086853 1679.494995,19.825787 1681.578979,26.739054 
	C1683.569214,33.341522 1680.333008,37.505135 1675.150513,40.881390 
	C1669.768066,44.387924 1666.766968,49.295727 1666.781982,55.862492 
	C1666.796753,62.377716 1664.054321,67.329720 1658.519165,70.847282 
	C1655.268188,72.913162 1652.715576,75.573265 1654.343018,79.906128 
	C1655.386108,82.683167 1657.547485,84.341057 1660.549683,83.745567 
	C1664.779419,82.906570 1666.667114,79.508911 1666.796997,75.704559 
	C1667.071411,67.665604 1670.684692,62.746864 1678.437012,60.389870 
	C1685.544189,58.229004 1684.722900,53.221558 1682.673584,47.556549 
	C1678.501587,36.023613 1678.840698,35.612133 1691.075195,34.401939 
	C1698.551758,33.662380 1704.022217,31.645033 1702.411255,22.171417 
	C1700.790283,12.639827 1709.669556,9.631262 1715.238037,3.820493 
	C1717.343506,2.964685 1718.849243,3.022723 1721.087891,3.202550 
	C1731.172241,15.486747 1729.945557,23.767904 1717.381470,31.744846 
	C1713.377075,34.287285 1710.562622,37.265995 1711.697998,42.292923 
	C1712.830078,47.305981 1715.847046,51.070049 1721.242676,50.948620 
	C1729.404175,50.764950 1735.267700,54.199127 1739.829102,60.600574 
	C1740.593384,61.673141 1741.567383,62.926147 1742.757080,63.265892 
	C1753.768311,66.410179 1764.500854,69.867668 1772.523926,78.888397 
	C1773.960815,80.503967 1777.175903,79.887802 1778.903076,77.951393 
	C1781.638184,74.885124 1781.373169,71.170204 1780.172607,67.569679 
	C1779.147583,64.494736 1776.785034,61.634705 1773.611694,62.611813 
	C1764.129028,65.531631 1759.379395,61.277668 1756.020752,53.046234 
	C1754.096558,48.330048 1749.911377,47.450039 1745.091675,48.864037 
	C1739.802490,50.415741 1734.106201,51.591515 1731.013794,45.467857 
	C1728.098022,39.694000 1728.130371,32.624943 1733.286255,28.854994 
	C1742.138184,22.382545 1745.092041,13.409473 1748.257568,3.431286 
	C1753.720825,2.935519 1758.491455,3.057094 1764.032227,3.048467 
	C1771.858154,10.812657 1771.470215,14.932561 1763.225708,20.361439 
	C1758.957520,23.171938 1752.281494,24.895823 1754.720703,31.863796 
	C1756.885986,38.048862 1762.431030,41.046055 1769.043457,40.535225 
	C1774.459106,40.116821 1777.944824,42.047607 1780.209473,46.870510 
	C1782.775146,52.334538 1787.095947,54.834213 1793.177124,53.792091 
	C1799.772583,52.661819 1804.963867,54.453190 1808.348145,60.573914 
	C1809.307373,62.308743 1810.795532,63.727482 1812.291504,65.059837 
	C1815.140381,67.597076 1818.340210,69.749863 1822.184937,67.804298 
	C1826.075806,65.835289 1825.939331,62.036602 1825.597534,58.209053 
	C1824.732178,48.520172 1828.044067,44.155556 1837.219971,42.137932 
	C1843.665649,40.720623 1848.123169,43.350002 1851.656128,48.505432 
	C1853.708252,51.500187 1855.613403,54.791603 1859.374146,56.025486 
	C1865.102173,57.904842 1870.568726,54.298031 1870.906982,47.414047 
	C1871.293823,39.545094 1872.996460,33.100304 1880.768433,29.373365 
	C1884.999268,27.344509 1884.907959,22.981403 1885.191528,18.936243 
	C1885.555908,13.739373 1884.020142,8.185583 1888.581177,3.316600 
	C1896.475098,2.980537 1903.627319,3.040058 1911.562866,3.028997 
	C1917.462769,10.321102 1915.770020,22.385406 1908.894897,27.150436 
	C1906.717651,28.659512 1904.170410,29.583879 1902.054688,31.212067 
	C1898.635742,33.842995 1896.682983,37.206684 1897.796509,41.583637 
	C1899.045166,46.491112 1903.134033,47.533684 1907.223145,46.766079 
	C1914.422607,45.414589 1918.532104,48.482483 1921.329224,54.685947 
	C1922.569458,57.436890 1924.749390,59.594841 1927.480103,61.014259 
	C1930.871948,62.777317 1934.482666,63.794590 1937.726807,61.040710 
	C1940.698853,58.518044 1940.195190,55.092651 1938.955688,51.840916 
	C1937.528687,48.096645 1934.975586,45.776360 1930.703491,45.955257 
	C1930.040405,45.983021 1929.375000,46.070168 1928.737061,46.246460 
	C1923.039307,47.820953 1917.694580,49.264542 1915.251709,41.225254 
	C1912.237305,31.305641 1913.037720,24.965015 1920.688721,21.524134 
	C1928.918579,17.822809 1930.078003,10.095491 1934.425171,3.368340 
	C1941.661743,2.959026 1948.175903,3.050786 1955.459229,3.024873 
	C1961.024170,6.377370 1965.455078,10.167510 1972.203491,7.179179 
	C1975.636475,5.658923 1977.523193,8.868303 1978.646729,11.813277 
	C1980.225708,15.951626 1982.418579,19.499338 1986.449463,21.759422 
	C1995.364990,26.758312 1999.672974,24.888882 2001.986572,14.982074 
	C2002.882324,11.146549 2002.903687,7.007555 2006.280029,3.415874 
	C2011.732178,2.942100 2016.494629,3.054116 2022.029663,3.048157 
	C2028.970581,8.524026 2034.973022,14.139588 2044.063110,14.241550 
	C2046.349121,14.267193 2048.591553,16.123562 2049.489990,18.263281 
	C2052.969727,26.552675 2059.690674,27.694124 2067.517334,27.311945 
	C2073.298584,27.029650 2078.135010,28.999434 2079.739014,35.254723 
	C2081.313477,41.394951 2081.087891,47.172535 2075.205566,51.304668 
	C2072.764160,53.019825 2070.118896,54.478210 2068.065918,56.705647 
	C2065.218018,59.795525 2064.774902,63.264900 2067.120850,66.709213 
	C2069.654053,70.429100 2073.442871,71.417625 2077.686523,70.301155 
	C2081.539795,69.287392 2083.409912,66.171791 2082.533203,62.699810 
	C2079.888428,52.227070 2083.117432,45.503613 2093.504150,41.848469 
	C2096.692139,40.726566 2098.424316,37.295879 2097.687744,33.579041 
	C2097.034912,30.284397 2094.425537,28.099264 2091.429688,27.898167 
	C2082.750244,27.315475 2077.165283,22.524446 2071.505371,16.415056 
	C2067.234375,11.805095 2060.732422,10.552918 2053.932129,11.347687 
	C2048.775146,11.950377 2043.238892,11.276164 2047.236206,3.165025 
	C2062.699951,3.030706 2077.365479,3.017154 2092.839844,3.015990 
	C2096.514648,2.974483 2097.781250,4.961308 2098.536377,7.221843 
	C2100.355713,12.668450 2104.024414,15.322077 2109.749756,15.199156 
	C2117.045898,15.042513 2121.549316,18.606575 2123.861328,25.454342 
	C2125.047119,28.966305 2126.687988,32.521660 2131.342773,32.171658 
	C2135.911621,31.828148 2139.746826,29.856934 2141.761963,25.550188 
	C2143.634033,21.549351 2142.897217,17.796341 2139.776123,14.556618 
	C2136.865479,11.535233 2132.598145,8.989247 2136.425293,3.386333 
	C2143.697266,2.959894 2150.253906,3.049525 2157.599365,3.032622 
	C2162.849121,4.046499 2163.002197,8.310995 2164.645264,11.405887 
	C2169.211670,20.007074 2173.051025,22.195099 2182.392578,19.415716 
	C2189.594482,17.272856 2194.016602,18.929560 2196.396484,26.036486 
	C2198.608887,32.643089 2203.167480,36.472771 2210.046387,37.751457 
	C2214.395020,38.559788 2218.289551,40.450558 2221.213867,43.918045 
	C2225.673096,49.205479 2231.131348,52.330605 2238.071289,53.737019 
	C2245.370117,55.216137 2249.434570,62.227894 2247.869629,68.689201 
	C2246.739746,73.354248 2237.143066,79.716728 2232.144287,79.101952 
	C2227.685059,78.553535 2226.341064,75.136475 2225.251953,71.528282 
	C2223.713135,66.429153 2221.293945,61.855675 2215.188477,62.219467 
	C2209.090820,62.582794 2207.126953,67.737106 2206.010010,72.669441 
	C2204.406250,79.751869 2201.857666,85.629669 2195.131592,89.682419 
	C2188.084961,93.928543 2188.230469,99.514450 2194.562988,104.754578 
	C2198.633057,108.122658 2203.628906,108.602371 2208.585205,109.408226 
	C2214.189697,110.319511 2220.107910,111.106621 2220.851807,119.207031 
	C2210.483643,120.731834 2201.346680,123.924416 2193.163330,130.955597 
	C2189.278564,128.817413 2189.700195,124.980240 2188.076416,122.178482 
	C2186.458984,119.388084 2184.286865,117.182983 2180.883789,118.412514 
	C2176.964844,119.828423 2176.749756,123.142242 2177.789307,126.668884 
	C2178.631836,129.527527 2180.602051,131.937927 2181.085938,135.662323 
	C2180.154785,139.543137 2177.392334,140.919724 2174.351562,143.028290 
	C2171.747559,144.132874 2169.778320,144.239014 2167.114258,143.363876 
	C2162.973877,139.500488 2166.763672,137.136963 2167.843506,134.301712 
	C2168.745361,131.933731 2168.808594,129.405487 2166.028076,128.461563 
	C2163.393311,127.567200 2162.837891,130.121994 2162.193848,131.908386 
	C2158.796875,141.331131 2153.488770,148.960220 2143.712646,152.801834 
	C2139.947510,154.281357 2139.097168,157.304840 2140.749512,160.965698 
	C2142.402588,164.628922 2144.817139,167.051102 2149.270996,165.893265 
	C2152.244141,165.120331 2154.513672,163.099991 2157.670898,161.173279 
	C2161.392578,160.025925 2164.175537,160.893875 2167.450195,162.709351 
	C2170.175293,165.837341 2167.877197,168.020126 2167.325684,170.481964 
	C2166.260254,175.237595 2169.195557,178.469086 2173.151611,179.427612 
	C2177.515137,180.484879 2178.212891,176.285156 2178.988525,173.066376 
	C2180.163330,168.191467 2178.948975,161.882568 2187.107422,161.095795 
	C2189.156006,162.428894 2189.479248,164.000885 2189.514160,165.656357 
	C2189.587891,169.147720 2190.524902,172.161270 2194.178467,173.415039 
	C2196.136230,174.086929 2198.171631,173.909317 2199.382080,171.974792 
	C2201.671387,168.315872 2197.848389,166.074768 2197.084473,162.410004 
	C2201.002441,155.615845 2205.181396,157.991486 2209.254150,161.509369 
	C2211.040771,163.052612 2211.738037,165.366592 2212.723389,167.457077 
	C2213.625732,169.370667 2214.869873,170.865921 2217.320557,170.112854 
	C2219.299072,169.504898 2220.982910,168.420929 2221.459717,166.283722 
	C2221.970947,163.992477 2220.360840,162.688858 2218.816895,161.378998 
	C2215.530273,158.590500 2209.272705,159.219177 2209.311035,152.236359 
	C2212.059082,149.037399 2215.317871,147.840897 2219.133301,146.175140 
	C2229.508301,144.382477 2239.774414,144.086395 2246.125977,133.667938 
	C2247.361572,133.111038 2248.068115,132.916077 2248.628662,133.171082 
	C2260.403809,138.525894 2260.400635,138.532990 2261.168945,124.236481 
	C2264.572266,121.209129 2268.749023,120.154785 2271.200195,115.828445 
	C2272.537109,114.951973 2273.416504,114.726463 2275.020020,114.774666 
	C2282.261719,119.427315 2285.502197,110.770020 2291.604492,111.297905 
	C2293.906494,113.665672 2293.308350,115.929970 2292.637939,118.142548 
	C2291.323730,122.483665 2291.732178,126.379044 2296.754150,127.487480 
	C2301.338867,128.499435 2304.095703,125.450127 2305.690918,121.457306 
	C2306.547607,119.314110 2306.137695,116.880844 2307.294678,114.100540 
	C2312.208252,110.629005 2315.670166,113.980484 2319.496826,115.487869 
	C2324.019043,117.269234 2328.676758,119.765129 2333.395996,114.279297 
	C2335.948730,113.088989 2337.806152,113.896683 2339.708008,114.296051 
	C2343.577148,115.108574 2348.161377,116.421104 2350.044189,111.793251 
	C2351.910645,107.205528 2348.916748,103.725975 2344.907715,101.385399 
	C2343.499512,100.563210 2341.914307,100.073990 2339.990723,98.695816 
	C2337.754639,92.198730 2342.956787,90.559494 2346.767090,87.262360 
	C2353.925049,85.543037 2361.056396,87.383148 2367.705078,82.842186 
	C2371.130371,82.193176 2373.491943,83.020073 2376.188965,85.119888 
	C2376.725830,97.166771 2382.956787,103.960655 2393.307617,107.717216 
	C2397.007568,109.060005 2398.659424,112.558884 2400.914307,115.401978 
	C2404.575195,120.017670 2409.232910,121.968452 2415.027100,120.376534 
	C2421.252930,118.665985 2422.785156,113.777252 2423.169922,108.075394 
	C2423.521240,102.874008 2422.479248,97.011864 2428.051514,93.714287 
	C2432.613770,91.014679 2437.619385,90.208572 2442.069336,93.777802 
	C2446.036865,96.959663 2446.593750,110.044258 2443.222656,114.323898 
	C2441.165527,116.935570 2438.178223,118.698593 2436.266357,121.458900 
	C2433.424561,125.562172 2431.568604,130.260757 2435.784912,134.100937 
	C2440.266113,138.182297 2444.470459,134.654770 2448.180664,131.809631 
	C2451.329590,129.394928 2452.118408,125.803337 2452.398926,122.040382 
	C2452.739990,117.470764 2454.986084,114.329742 2459.764648,114.177147 
	C2466.382080,113.965813 2471.329590,117.319153 2474.294189,123.006302 
	C2476.738281,127.695320 2473.333984,130.405777 2469.781738,132.639832 
	C2465.762695,135.167740 2461.696533,137.682800 2462.148682,143.303040 
	C2462.297607,145.155716 2463.768066,146.170288 2465.598877,146.293411 
	C2471.043213,146.659515 2474.029541,143.042252 2476.779053,139.171066 
	C2485.314941,127.152832 2491.296875,126.133072 2503.786133,134.885727 
	C2506.910645,137.075378 2509.909424,139.156250 2513.812256,137.216751 
	C2517.968018,135.151581 2519.373047,131.374115 2518.556641,127.152176 
	C2517.022217,119.219528 2520.449951,114.538284 2527.389404,111.386429 
	C2535.465332,107.718430 2537.496338,98.415878 2543.975098,93.093315 
	C2549.868896,88.251442 2555.241943,85.727524 2561.486328,93.486107 
	C2562.000000,96.777779 2562.000000,99.555557 2562.000000,103.166672 
	C2559.755615,106.603813 2556.531982,107.396935 2553.532715,108.633568 
	C2550.212646,110.002419 2546.309082,111.265785 2546.225342,115.559181 
	C2546.133057,120.289017 2549.536865,123.104782 2553.385986,125.245964 
	C2555.717529,126.542969 2558.538818,125.970695 2561.465332,127.548935 
	C2562.000000,128.888885 2562.000000,129.777786 2562.000000,131.333344 
	C2555.083740,132.985855 2551.131592,136.342941 2551.941162,143.957291 
	C2552.309082,147.419113 2551.634033,150.670532 2546.760254,151.891449 
	C2544.336182,150.663956 2543.848877,148.740128 2543.363037,146.799789 
	C2542.789551,144.509674 2542.148438,142.139191 2539.298828,141.817963 
	C2537.461182,141.610809 2536.057617,142.646240 2535.635742,144.446487 
	C2534.967773,147.296890 2535.811768,149.691879 2538.414795,151.254929 
	C2539.841553,152.111694 2541.564941,152.263641 2543.512939,153.532043 
	C2538.189941,161.511185 2532.538574,161.645020 2528.217773,154.365082 
	C2527.883789,153.802414 2527.723389,153.126556 2527.345947,152.601486 
	C2525.212158,149.633011 2527.361328,143.001740 2520.215820,144.303635 
	C2514.119873,145.414322 2510.926270,148.893814 2509.502686,156.115158 
	C2509.441650,156.425812 2509.219971,156.704895 2508.536621,157.498856 
	C2502.370605,157.438477 2501.444336,150.915375 2496.385742,148.571030 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M442.389465,560.580078 
	C446.444489,552.971252 446.568756,552.985229 447.975952,540.486511 
	C448.487549,535.942810 450.921814,532.814880 454.836029,531.790283 
	C463.684113,529.474182 467.184937,524.079529 466.242767,515.247131 
	C466.091858,513.832520 467.256012,512.934204 469.248108,512.169800 
	C472.850189,514.142456 472.382843,518.039124 474.498566,520.556213 
	C476.735596,523.217468 479.600006,525.581848 482.874786,523.129517 
	C485.910828,520.856018 483.789001,517.780518 482.364990,515.217896 
	C480.676239,512.178772 477.308289,511.165894 474.394470,508.559509 
	C474.407257,502.142059 481.989014,503.295868 483.333191,498.551697 
	C484.537964,494.299591 480.761383,490.295776 482.352203,485.880890 
	C483.558411,482.533356 485.156342,480.007568 489.321503,479.963745 
	C493.404480,479.920868 497.292389,480.285095 500.869354,482.398865 
	C505.625397,485.209351 509.861908,483.657074 513.821228,480.707336 
	C515.549683,479.419586 516.035156,477.426483 515.752502,475.323242 
	C515.420410,472.852325 513.629211,472.102295 511.471161,472.073822 
	C505.172058,471.990814 502.157959,467.681458 499.505737,462.893219 
	C498.129730,460.409027 497.344330,457.749207 499.852875,455.625946 
	C502.388672,453.479614 505.117767,451.548676 508.858032,453.430603 
	C511.297302,454.657959 513.216248,456.418396 515.227417,458.171814 
	C520.354187,462.641724 525.366760,462.861725 531.482483,459.003174 
	C536.205139,456.023560 537.108093,451.561554 535.187378,446.798248 
	C533.028259,441.443573 535.490112,438.272156 539.721375,436.278046 
	C547.680176,432.527313 553.154114,426.950378 555.940857,418.453339 
	C557.314941,414.263489 561.089233,411.505676 564.531677,408.920105 
	C568.721680,405.773041 570.324585,402.488342 568.819092,396.979858 
	C566.772156,389.490204 568.267883,387.306641 575.291382,383.391998 
	C577.035828,382.419739 578.833862,381.538513 580.636963,380.677704 
	C588.249695,377.043365 588.856323,377.187897 593.846558,383.707458 
	C594.852539,385.021759 595.729492,386.451324 596.847839,387.659302 
	C598.542053,389.489288 600.714966,390.261993 603.188171,389.638153 
	C605.621826,389.024323 605.893005,387.008942 605.938782,384.941833 
	C606.002258,382.075989 605.283203,378.930359 602.280212,378.626312 
	C594.270569,377.815460 590.390869,371.527802 585.826050,366.561707 
	C580.316467,360.567841 573.796631,362.012390 567.285645,362.351044 
	C564.900513,362.475128 564.163940,364.554443 564.104858,366.709686 
	C564.022766,369.706207 563.809082,372.721802 564.039734,375.699219 
	C564.447327,380.961548 561.669617,383.680450 557.129822,385.304657 
	C552.801086,386.853363 549.049011,385.288269 546.104187,382.508087 
	C542.719543,379.312714 543.733276,375.233368 545.371338,371.374146 
	C546.438049,368.860992 547.820923,366.353516 550.231262,365.201813 
	C555.298828,362.780426 555.905457,358.741974 556.142761,353.711914 
	C556.675659,342.413025 559.553711,339.783020 569.460022,337.025848 
	C574.639954,335.584198 576.906799,337.504150 578.806396,341.608582 
	C581.333435,347.068451 583.679504,353.121307 589.539307,355.534943 
	C596.489014,358.397552 603.647156,360.792023 610.671326,363.531921 
	C616.782898,365.915924 621.673401,361.380005 621.988220,354.733795 
	C622.164307,351.014709 621.442566,348.405670 616.922424,347.775391 
	C611.715637,347.049347 607.524292,343.840179 605.009827,339.422180 
	C602.450989,334.926178 599.013000,333.696167 594.301636,333.959625 
	C590.648132,334.163971 586.970642,334.093597 583.309448,333.973877 
	C576.836060,333.762177 574.820923,331.982239 574.084473,326.104095 
	C573.293457,319.790314 575.203369,316.289551 581.082458,314.767212 
	C584.237427,313.950287 587.676758,314.285248 590.970886,313.939606 
	C595.893127,313.423126 596.710266,311.888214 594.281494,307.477264 
	C592.361328,303.990051 590.475159,300.415649 588.039001,297.297943 
	C584.789307,293.139130 581.052246,292.844330 578.200562,297.175018 
	C574.714355,302.469421 569.342041,306.282959 566.858398,312.262543 
	C565.319763,315.967133 562.954529,318.195038 558.528992,318.001068 
	C554.326782,317.816833 552.894958,314.555786 551.354004,311.842957 
	C547.510193,305.076050 550.495300,298.369110 557.963928,296.376740 
	C560.189453,295.783020 562.687439,296.040497 564.800049,295.229462 
	C569.155396,293.557312 570.417175,289.915039 568.466064,285.668976 
	C567.778748,284.173096 566.737427,282.831390 566.122498,281.312103 
	C563.065735,273.759430 563.432007,271.794189 568.083557,269.744720 
	C575.640259,266.415283 580.712219,267.708588 584.198975,273.854034 
	C587.708069,280.038910 589.497070,281.232513 595.957764,279.562347 
	C602.082703,277.979004 609.651062,277.969604 610.350098,268.636078 
	C610.609192,265.175873 613.347900,263.269165 616.880066,264.841736 
	C620.225281,266.331085 620.298889,269.411957 619.394226,272.554932 
	C619.303711,272.869324 619.176025,273.248749 618.937988,273.434021 
	C606.972229,282.746155 613.785339,295.338715 611.806641,307.572754 
	C620.253967,305.613647 626.610596,302.019165 633.786499,300.810425 
	C639.003357,299.931671 640.734009,302.224487 641.572632,305.973755 
	C643.065186,312.646851 641.277100,318.523987 635.745483,322.919220 
	C633.932251,324.359985 631.680908,325.372742 630.189392,327.072205 
	C625.501648,332.413422 628.283691,340.392670 635.162842,341.841064 
	C643.382874,343.571777 649.866333,339.141846 649.828552,330.771973 
	C649.797668,323.951263 653.924622,320.297150 658.456421,317.117920 
	C662.785095,314.081085 665.592041,311.202087 666.323853,305.425995 
	C667.530579,295.901459 671.988647,293.802795 681.561401,295.852020 
	C685.252686,296.642151 688.415710,298.325653 691.709839,299.875702 
	C694.130859,301.014954 696.519897,302.109131 699.317688,301.964996 
	C704.278931,301.709412 706.801697,298.870941 705.593018,294.102570 
	C704.784302,290.912109 703.042358,287.970551 701.994080,284.825592 
	C700.481750,280.288330 698.972412,277.199188 692.802246,279.189056 
	C687.899414,280.770264 683.235413,276.965912 682.453857,272.330597 
	C681.908020,269.093323 683.066101,266.219116 685.901489,264.687653 
	C688.375366,263.351471 690.894653,265.072601 691.812927,267.080139 
	C695.952820,276.130615 703.520447,276.790039 711.899170,276.018066 
	C716.026917,275.637726 719.718079,276.360840 722.757263,279.713074 
	C727.572449,285.024231 727.317139,291.030579 721.434692,295.041138 
	C718.429565,297.089966 714.972107,298.472015 711.733521,300.182739 
	C708.983704,301.635254 708.389343,303.558899 709.215454,306.762360 
	C711.717346,316.463684 714.424866,319.227722 724.766541,319.933594 
	C730.506226,320.325378 733.531006,323.317841 736.243347,328.049133 
	C738.591980,332.145874 741.146118,336.955688 747.784668,335.152374 
	C757.173035,332.602112 761.052124,324.815887 756.850098,315.969788 
	C754.935425,311.939056 752.076233,309.593719 747.276672,311.300018 
	C746.024963,311.745056 744.658691,311.902985 743.453491,312.437286 
	C740.181702,313.887909 737.055481,314.737305 734.669861,311.034821 
	C732.608948,307.836365 731.346863,304.668030 733.563477,300.815674 
	C735.976013,296.622803 739.082764,293.354980 743.447510,291.296936 
	C750.268982,288.080475 755.021484,283.611908 754.085144,275.168182 
	C753.732300,271.986511 754.828613,269.143402 758.481995,268.338806 
	C762.392700,267.477478 764.826782,269.383331 766.370300,272.810486 
	C766.780090,273.720184 767.318848,274.570984 767.749084,275.472351 
	C770.776794,281.814636 770.800354,281.876373 764.338684,284.863068 
	C759.737854,286.989624 755.561340,289.132507 753.958618,294.733124 
	C751.769592,302.382599 754.449707,307.898712 762.169189,309.677979 
	C763.766724,310.046204 765.493469,310.083344 767.139587,309.969055 
	C772.140930,309.621674 774.967285,311.448761 776.638367,316.582367 
	C778.301941,321.692719 778.467285,326.179596 773.818604,328.935089 
	C767.177979,332.871246 765.292175,338.195557 765.850464,345.537323 
	C766.270386,351.059082 761.296143,356.026947 755.110962,357.720795 
	C750.364380,359.020691 746.914856,357.253418 743.476196,350.703979 
	C740.639587,345.301208 737.545837,341.083191 730.548767,342.008362 
	C725.073425,342.732300 722.038391,345.807800 722.045715,351.144714 
	C722.053711,356.954742 725.245117,361.460327 730.238586,361.856354 
	C734.192139,362.169861 738.439819,362.508942 742.135437,361.414154 
	C746.965332,359.983276 748.003418,362.479492 748.925415,365.924438 
	C751.327454,374.899078 750.930237,383.089508 742.374207,388.968750 
	C739.063599,391.243591 737.549805,394.368591 738.088501,398.415039 
	C738.579224,402.101074 740.688782,404.560791 744.137207,405.597137 
	C747.841431,406.710297 750.899048,405.036835 752.592651,401.902466 
	C754.143860,399.031403 755.138367,395.762939 755.845886,392.552307 
	C757.420654,385.406189 758.337402,378.081787 768.103516,377.445435 
	C770.610779,377.282043 771.731262,374.755371 771.899658,372.214722 
	C772.099060,369.205170 771.910400,366.282745 770.803528,363.380676 
	C769.120239,358.967041 770.583496,355.932098 774.826233,353.531433 
	C783.855469,348.422455 785.756042,348.670990 790.679688,358.087799 
	C792.395020,361.368591 794.082520,364.527405 796.908936,366.908264 
	C800.169556,369.654755 803.669922,370.565002 808.005554,369.026642 
	C816.237671,366.105743 817.942505,367.266937 819.656494,375.866272 
	C821.183655,383.528137 817.200378,388.088745 809.457214,388.045654 
	C805.113708,388.021484 802.939636,385.819336 801.102417,382.236389 
	C794.576660,369.509644 788.977417,367.998016 777.217590,375.556641 
	C776.155823,376.239044 774.994934,377.197876 774.527527,378.302338 
	C772.022278,384.221039 779.411499,395.551514 785.982544,395.973938 
	C789.606506,396.206940 793.250061,395.673462 796.753296,397.399170 
	C804.771118,401.348785 805.932007,408.622253 799.193848,414.459106 
	C793.147949,419.696259 788.730286,425.496826 789.913330,434.205566 
	C790.467346,438.284271 788.846680,441.503052 784.170776,441.957397 
	C781.571472,442.209991 780.170166,444.129944 778.375549,445.556519 
	C771.463013,451.051575 771.408020,451.161072 773.678589,457.747681 
	C776.067261,464.676605 778.022217,465.750153 785.339905,466.120911 
	C788.968262,466.304718 792.513306,463.228729 795.922546,465.580475 
	C799.399414,467.978790 797.488647,472.432587 799.032593,475.773468 
	C802.709534,483.729706 802.628784,484.010254 795.080872,488.445740 
	C788.922852,492.064484 784.262146,496.073395 786.032654,504.222839 
	C786.778809,507.657227 788.404175,509.777618 791.879578,509.860901 
	C796.511536,509.971954 801.235901,510.734070 805.748840,509.065155 
	C811.345520,506.995392 812.036499,510.329041 812.032715,515.369995 
	C812.360779,516.985046 812.276489,517.748169 811.369324,518.907837 
	C809.670105,520.333557 808.327454,521.232971 806.687256,522.742554 
	C805.220093,523.874268 804.135742,524.471313 802.487061,525.351624 
	C799.959534,526.489014 798.140320,527.592224 795.794006,529.124817 
	C793.826477,529.786560 792.471680,529.783508 790.486023,529.114502 
	C786.270020,525.980347 784.984131,517.471008 779.312317,520.784790 
	C773.210571,524.349792 779.683655,530.040710 780.830444,535.515381 
	C780.852539,536.712891 780.763062,537.193604 780.214355,538.253296 
	C778.473572,539.656982 777.053894,539.980286 774.827942,539.909058 
	C769.611755,538.680603 768.390991,534.732971 766.641113,531.191956 
	C764.906250,527.681274 762.345520,525.203247 758.073608,525.873230 
	C755.008728,526.353882 752.157471,527.586670 751.771240,531.158875 
	C751.426208,534.349976 753.667664,535.907166 756.376831,536.743652 
	C760.131470,537.902832 764.292358,537.837463 768.033691,541.026245 
	C770.193604,549.773438 761.706726,549.811707 757.848938,554.493652 
	C755.999756,555.725525 754.652405,556.314941 752.510498,556.857056 
	C751.314453,556.908325 750.838867,556.842407 749.744263,556.426392 
	C741.583130,550.568237 737.971802,551.518982 734.989746,559.882324 
	C734.344543,561.691956 734.183594,563.665405 732.812500,565.924988 
	C727.348694,568.851379 724.671509,563.853271 720.753357,562.747986 
	C718.234802,562.037537 715.515930,560.581116 713.357544,562.948914 
	C711.068420,565.460144 712.923279,567.906738 714.421997,570.072754 
	C716.120544,572.527527 717.966309,574.873230 717.970032,578.767151 
	C717.522827,581.958740 716.143127,583.923279 714.097717,586.333130 
	C712.921509,587.549561 712.194824,588.184204 710.865601,589.219727 
	C704.809753,592.317749 700.885864,597.769653 693.739502,598.216675 
	C690.049438,593.711975 686.685730,589.909607 680.784668,591.310669 
	C672.940125,593.173157 668.140320,589.578979 664.484924,583.090027 
	C662.729553,579.974121 660.758362,575.981567 656.395813,576.841125 
	C651.993225,577.708496 649.724976,581.977234 649.565491,585.832520 
	C649.191650,594.872009 645.698914,600.691040 636.841187,603.755737 
	C632.177734,605.369141 633.844177,610.591858 633.056213,615.050781 
	C624.684631,616.162659 623.062683,620.881592 624.473633,628.444214 
	C618.291016,632.899902 614.516785,637.598389 614.288879,645.235779 
	C614.034485,653.762939 606.643799,655.173157 600.156860,656.880310 
	C593.360596,658.668762 591.593628,653.614319 589.648071,648.897339 
	C589.139343,647.663818 588.596619,646.435852 587.817810,645.354248 
	C584.541321,640.803833 580.148438,640.473633 575.375488,642.355835 
	C572.514282,643.484131 569.619568,645.090149 570.565063,648.866394 
	C571.780640,653.721252 574.563599,657.058044 580.055237,657.697205 
	C597.316101,659.705994 600.045166,662.318359 604.351074,680.973083 
	C604.161133,683.801514 603.476807,685.680115 601.525330,687.765503 
	C600.488281,688.425537 600.025391,688.597778 598.834839,688.704224 
	C594.312561,685.563538 590.164856,683.060974 585.740906,686.973572 
	C580.987610,691.177307 586.140320,694.655457 587.439941,699.091736 
	C587.875916,701.731384 587.367920,703.511230 585.949463,705.740234 
	C584.332886,707.696167 582.826172,708.761353 580.988647,710.448364 
	C580.086914,711.075012 579.706787,711.286072 578.732300,711.729980 
	C576.803833,712.857727 573.870605,711.911621 574.664062,715.692017 
	C574.865295,718.562927 573.624634,720.228699 571.775757,722.255737 
	C569.794434,724.014587 568.426025,725.472412 567.332703,727.927368 
	C566.564697,729.157776 566.036621,729.797302 564.992249,730.812073 
	C562.949402,732.503845 561.138611,733.562195 560.172241,736.211792 
	C558.979187,738.663147 557.716431,740.307129 555.792114,742.207886 
	C554.153992,743.640076 552.871521,744.563477 551.619751,746.349060 
	C550.691223,747.864624 550.040833,748.860718 549.011597,750.329590 
	C547.865906,751.719299 546.990112,752.543823 545.931274,753.995728 
	C544.949829,755.491211 544.285217,756.482056 543.270264,757.959778 
	C541.858887,759.643250 540.654358,760.707031 539.291809,762.465820 
	C538.366211,763.612427 537.781311,764.231018 536.641602,765.233337 
	C534.944092,766.395386 533.674805,766.813477 531.615234,766.482971 
	C527.811340,764.150391 526.713745,760.437622 524.289612,757.778748 
	C520.962402,754.129333 517.035645,752.571228 513.292664,756.692566 
	C509.534424,760.830627 510.203430,765.260193 514.772095,768.544128 
	C518.426086,771.170715 523.391052,772.332153 524.304504,778.500732 
	C524.449158,780.118164 524.435852,781.044189 524.254272,782.648193 
	C524.037048,783.763611 523.917175,784.199585 523.529419,785.251160 
	C522.439270,787.397827 521.085999,788.567200 520.032715,790.696777 
	C519.487488,791.580872 519.252869,791.920593 518.609192,792.715576 
	C516.780396,794.505920 515.093628,795.610962 514.160522,798.119385 
	C513.731079,799.019714 513.545532,799.376160 513.030396,800.241821 
	C511.672485,802.020996 510.655304,803.298279 509.694214,805.384766 
	C506.669800,810.609314 503.768921,815.157227 500.590027,820.328125 
	C499.242371,821.253052 498.345734,821.504700 496.698730,821.524902 
	C491.753448,820.095581 491.969696,815.853577 490.375488,812.780212 
	C489.127014,810.373474 487.647064,808.108398 484.485901,808.477356 
	C481.899384,808.779236 480.455750,810.639709 479.954193,813.039429 
	C479.357361,815.895203 480.586761,818.179993 482.869293,819.858276 
	C485.530579,821.814819 489.149963,821.819946 492.155884,824.602234 
	C493.125031,825.916321 493.485443,826.769836 493.752502,828.369995 
	C493.756317,829.503723 493.702362,829.953064 493.434631,831.039917 
	C492.180023,833.585876 490.564758,835.134094 489.455200,837.779907 
	C488.665741,839.130798 488.113495,839.840271 486.992859,840.972778 
	C485.322418,842.273682 484.043671,842.795410 481.917542,842.838806 
	C478.206787,841.882996 476.379059,839.402588 474.088531,837.539246 
	C470.866821,834.918335 467.357697,834.097656 464.579071,837.821045 
	C462.045532,841.216064 462.924591,844.815430 465.915771,847.620667 
	C468.525146,850.067810 472.652313,850.576721 474.774719,854.762573 
	C475.699738,857.341125 475.384460,859.195801 474.265015,861.653931 
	C473.443695,863.125061 472.920868,863.932922 471.946899,865.308350 
	C470.275177,867.408997 468.875427,868.699280 466.118713,868.901489 
	C462.362488,867.580994 460.182068,864.597107 456.764648,864.248901 
	C452.403748,863.804626 448.544861,865.212891 447.749939,869.874939 
	C446.974609,874.421753 450.793793,874.987000 454.201447,875.338745 
	C456.809937,875.607910 459.473419,875.600647 462.301941,877.626282 
	C463.214783,888.017273 457.561646,895.225769 451.518921,902.879028 
	C446.045563,904.319336 444.632324,900.711670 442.767395,897.535767 
	C440.229095,893.213135 436.688477,889.936340 431.420074,892.196289 
	C428.095886,893.622314 428.797729,897.233765 429.737579,900.153137 
	C431.567566,905.837402 435.540192,906.804443 440.768250,904.959839 
	C442.989532,904.176086 445.303009,903.940125 448.113220,905.519104 
	C450.354187,913.507874 445.643646,918.570801 441.221802,924.411133 
	C435.931885,926.900085 433.192749,924.277710 430.585907,920.863220 
	C425.738831,914.514465 419.881348,916.967957 414.456635,919.656250 
	C410.382843,921.674988 410.599915,925.562866 412.172150,929.222717 
	C413.860077,933.151855 416.972473,934.406128 421.146942,933.509521 
	C425.901672,932.488281 430.219086,928.877258 436.089478,931.486572 
	C438.457550,935.812073 436.400452,939.074646 435.034485,942.423767 
	C426.613281,963.071472 417.686920,983.522461 410.809692,1004.769897 
	C410.185944,1006.697083 409.244781,1008.441345 407.291351,1010.430176 
	C402.939270,1013.118591 398.588867,1013.607422 394.528748,1014.970642 
	C387.965820,1017.174011 382.909607,1015.804138 379.875977,1009.011414 
	C377.859253,1004.495850 374.640808,1001.219727 369.167053,1001.976807 
	C366.401123,1002.359253 365.401733,1004.652588 365.752686,1007.173462 
	C366.623230,1013.426514 371.403290,1015.440857 376.581757,1015.024353 
	C389.694672,1013.969604 392.107025,1025.362671 398.522705,1033.234619 
	C399.604431,1035.966431 399.173645,1037.854492 397.396667,1040.125732 
	C394.651886,1042.256226 392.012054,1042.393921 389.426971,1042.726196 
	C383.423889,1043.498291 378.297485,1046.024048 377.647675,1052.487305 
	C377.022858,1058.701416 382.364075,1060.322754 387.181946,1061.785156 
	C388.120575,1062.070068 388.996185,1062.515869 390.364502,1063.543091 
	C392.875824,1068.226318 391.376740,1072.139771 389.674103,1076.740967 
	C388.972290,1077.789062 388.634155,1078.160889 387.621399,1078.841553 
	C382.503601,1079.823364 379.492279,1077.236206 376.629364,1074.488037 
	C373.461700,1071.447144 370.007385,1070.317139 365.936005,1072.467896 
	C363.475433,1073.767700 361.583313,1075.691528 361.897400,1078.654541 
	C362.365143,1083.067017 365.482300,1085.407837 369.239716,1087.118896 
	C373.149506,1088.899170 377.568634,1088.935425 382.028381,1091.197510 
	C383.470398,1092.859863 383.815125,1094.246948 383.843384,1096.444824 
	C383.376862,1099.485107 382.620758,1101.747803 382.569305,1104.841553 
	C382.395538,1106.466675 382.213531,1107.377686 381.742340,1108.923828 
	C381.119446,1110.374878 380.649719,1111.132446 379.694641,1112.334473 
	C377.660889,1114.330566 376.968842,1116.096436 377.904968,1118.920654 
	C378.425537,1121.389404 378.518738,1123.238159 378.464417,1125.837646 
	C377.886871,1130.122803 377.039886,1133.583130 375.214874,1137.559692 
	C374.406860,1138.578735 374.015137,1138.929321 372.936035,1139.665527 
	C368.303894,1141.405762 364.349548,1142.692505 359.399475,1141.491943 
	C356.326599,1139.394043 356.272949,1136.631226 358.294556,1135.316650 
	C368.305145,1128.807617 364.060242,1120.616333 361.094788,1111.969971 
	C359.448639,1109.100342 359.363708,1106.308472 357.787048,1104.144531 
	C356.083435,1101.806396 353.713562,1100.844604 350.901825,1101.458130 
	C348.787109,1101.919678 347.489868,1103.372070 347.412262,1105.615356 
	C347.300385,1108.849609 349.444794,1110.196777 352.142334,1111.005859 
	C354.019958,1111.568848 355.975006,1111.911133 358.194580,1113.497803 
	C359.719543,1122.744629 355.515625,1128.668335 347.717743,1133.055664 
	C344.247009,1132.376343 342.917694,1129.731567 340.607758,1128.493896 
	C337.527985,1126.843628 333.940796,1125.599731 332.161011,1129.663574 
	C330.624969,1133.170898 332.971161,1135.992554 336.169037,1137.679077 
	C338.256256,1138.779785 340.737854,1138.172974 343.568542,1139.163330 
	C346.813843,1145.618042 340.811188,1148.016846 338.701904,1152.080444 
	C337.518768,1154.359741 334.828033,1156.707520 336.924072,1159.131226 
	C339.395386,1161.988892 342.370178,1159.700562 344.917542,1158.305298 
	C347.781128,1156.736938 349.751495,1153.776001 353.853516,1152.968750 
	C359.754303,1156.066040 364.694946,1159.482300 369.440674,1164.368408 
	C371.024017,1169.356079 371.266724,1173.566650 368.298981,1178.098145 
	C363.108826,1180.859619 360.308228,1177.974976 357.556915,1174.962891 
	C354.498840,1171.614990 351.045044,1168.907959 346.338074,1171.317261 
	C343.328979,1172.857544 342.839630,1176.028442 343.498352,1179.120728 
	C344.656403,1184.556763 349.103607,1184.989624 353.499084,1185.263672 
	C358.264038,1185.560547 362.778625,1186.254272 365.483826,1191.859131 
	C366.339203,1194.641113 366.301575,1196.691284 364.955933,1199.340576 
	C359.776398,1200.838989 357.285309,1197.404541 354.627594,1194.643066 
	C352.479431,1192.410889 350.470215,1191.904053 347.660980,1193.230469 
	C344.511383,1194.717407 345.025177,1196.804688 345.442963,1199.686157 
	C346.268066,1205.376709 347.564575,1211.733521 338.770020,1213.977783 
	C337.035126,1213.015869 336.671143,1211.826050 336.605927,1210.459717 
	C336.446838,1207.126465 338.399414,1202.097168 332.962708,1201.945190 
	C326.874084,1201.775024 328.421295,1206.943726 328.305817,1211.370117 
	C323.162567,1215.646484 321.741547,1210.388062 319.578796,1208.357056 
	C316.112854,1205.102417 313.133301,1203.467529 308.164642,1205.511475 
	C304.268463,1207.114258 302.414673,1208.928589 301.904114,1213.219360 
	C300.541412,1224.671143 290.940155,1229.546875 281.270233,1223.425903 
	C272.632446,1217.958130 264.774048,1211.344360 254.455658,1208.837769 
	C251.779358,1208.187744 248.681778,1206.027222 247.367325,1203.672852 
	C244.383942,1198.329346 240.004944,1197.707520 234.763016,1197.957764 
	C230.471466,1198.162598 226.124832,1198.522827 223.710114,1193.442749 
	C221.181854,1188.123657 222.667099,1184.007080 227.293884,1180.131592 
	C230.287369,1181.708862 230.063599,1184.807983 231.699539,1186.813721 
	C234.264618,1189.958984 237.568222,1189.531860 240.533188,1187.656494 
	C243.566132,1185.738159 243.383743,1182.600342 242.083801,1179.745483 
	C240.402039,1176.052124 237.579865,1176.658203 234.694504,1178.322998 
	C232.992706,1179.304932 231.327209,1180.382812 228.644775,1180.275391 
	C226.933578,1176.846680 231.414001,1172.671509 228.047668,1170.888428 
	C223.531952,1168.496704 222.742416,1174.338745 220.232788,1176.543457 
	C216.301712,1179.996826 215.725159,1184.336304 215.932632,1189.157349 
	C216.026123,1191.329468 216.693787,1194.053589 213.922363,1195.267944 
	C211.267227,1196.431641 209.662796,1194.340210 207.885391,1192.912476 
	C206.640610,1191.912354 205.563721,1190.449219 203.520004,1191.123413 
	C201.061615,1193.111816 202.403259,1195.997681 201.916565,1198.459839 
	C200.992172,1203.136475 197.938034,1206.165161 193.712738,1207.602783 
	C189.586273,1209.006714 185.924515,1207.465210 183.092056,1204.080933 
	C181.186417,1201.804199 179.088104,1199.682739 177.264923,1197.344482 
	C174.649155,1193.989502 171.257355,1193.195801 167.542252,1194.603638 
	C164.249954,1195.851074 162.038284,1198.448608 162.093689,1202.184937 
	C162.241257,1212.137207 156.082642,1218.600098 149.719116,1224.958618 
	C148.576462,1226.100464 146.849014,1226.678589 146.398560,1228.467529 
	C145.974655,1230.151001 145.927460,1231.933716 147.403320,1233.013184 
	C148.920319,1234.122803 150.463181,1233.642944 151.702820,1232.144531 
	C155.477371,1227.581665 158.877838,1222.604126 165.307343,1220.075928 
	C166.539948,1220.376221 167.003464,1220.822998 167.319855,1221.379761 
	C169.368607,1224.984619 168.569138,1231.048096 175.196579,1230.714600 
	C181.449677,1230.400146 180.689041,1224.415405 183.481644,1220.441650 
	C188.585510,1221.039429 192.359558,1223.512817 195.883240,1227.316040 
	C191.019211,1232.486328 193.451614,1238.505737 192.281891,1244.391968 
	C187.206726,1247.501343 182.794113,1246.080444 178.550797,1243.972778 
	C174.693665,1242.057007 171.041824,1241.345459 166.865524,1244.754028 
	C160.173935,1247.380371 152.586365,1247.865112 152.005829,1257.613892 
	C151.171539,1261.137207 150.727097,1264.029297 149.420563,1267.448730 
	C143.689896,1272.537720 140.570053,1278.268555 138.986237,1285.691772 
	C134.778793,1288.506836 132.483902,1285.596436 129.727341,1283.848999 
	C119.783661,1277.545288 114.939514,1279.843506 114.589844,1291.241821 
	C114.418427,1296.829346 111.601738,1300.505371 107.675880,1303.873169 
	C105.621262,1305.635742 103.942329,1307.824829 104.853493,1310.827393 
	C105.295189,1312.282959 106.608971,1312.863525 108.014412,1312.414795 
	C111.060867,1311.442139 113.210381,1309.485229 113.823921,1306.204224 
	C114.253784,1303.905273 113.738861,1301.541748 114.182480,1299.241699 
	C115.039459,1294.798828 118.086723,1292.203125 122.145546,1291.202026 
	C126.495842,1290.128906 130.088379,1291.360840 130.939758,1297.152588 
	C128.136612,1301.660156 122.265198,1304.694824 127.398788,1310.840820 
	C131.641418,1308.298828 130.519318,1303.529297 133.182739,1299.901611 
	C138.417938,1296.840088 141.980362,1298.054077 144.163803,1302.978638 
	C146.490814,1308.226929 148.982971,1308.082642 151.415588,1303.185425 
	C152.960632,1300.075073 155.193619,1297.743896 158.646286,1295.559326 
	C161.098862,1294.372192 163.042358,1294.636230 164.999771,1294.648071 
	C174.327606,1294.704102 175.014633,1293.508423 170.803741,1283.821533 
	C170.187561,1279.041992 171.012939,1275.270630 174.188019,1271.560913 
	C176.679550,1270.381104 178.629303,1270.784790 180.580460,1270.838745 
	C190.426361,1271.111816 191.344040,1270.223511 192.311325,1259.224365 
	C193.950592,1255.277222 194.053131,1251.613770 195.713135,1247.746582 
	C203.508560,1247.226196 209.525940,1245.345703 211.471375,1236.451050 
	C217.608139,1237.682129 223.027405,1239.472412 227.787689,1233.666748 
	C229.218491,1231.921753 232.344116,1231.566528 235.345154,1230.287354 
	C237.228745,1229.288086 238.425842,1229.742798 239.683380,1230.001221 
	C249.978439,1232.116333 250.927765,1231.461914 253.531769,1220.500366 
	C258.163513,1219.621216 261.067474,1221.271118 262.611359,1225.235107 
	C263.987946,1228.769531 266.616669,1229.806274 270.382538,1230.141724 
	C277.316528,1230.759277 281.171631,1234.780518 281.833191,1241.565674 
	C282.209351,1245.423462 282.930359,1249.839111 277.777740,1251.621460 
	C273.057983,1253.254028 268.330444,1251.640625 265.798767,1247.416626 
	C264.605194,1245.425049 263.695770,1243.261719 262.679718,1241.165527 
	C259.891785,1235.413086 257.337952,1234.369385 251.901718,1237.471924 
	C247.611908,1239.920044 243.594803,1242.392334 243.641327,1248.740234 
	C243.674149,1253.218750 241.266739,1257.666626 240.397934,1262.213989 
	C239.508820,1266.867676 242.499069,1269.084961 246.932785,1267.209961 
	C248.741196,1266.445068 250.242203,1264.983643 252.002960,1264.070190 
	C258.365387,1260.769653 262.027954,1261.665771 265.555969,1267.244873 
	C268.979492,1272.658813 268.365784,1278.646851 264.093689,1281.509399 
	C258.576355,1285.206665 251.633224,1284.737061 248.135681,1280.027588 
	C245.510605,1276.492798 242.800247,1273.246338 238.695267,1271.408813 
	C230.184006,1267.598633 224.490997,1271.006714 224.006317,1280.231812 
	C223.936508,1281.560669 224.101852,1282.919067 223.889099,1284.219849 
	C222.942871,1290.004639 219.894485,1291.802612 214.145248,1290.303711 
	C207.385452,1288.541626 201.937500,1283.944702 195.202774,1281.957642 
	C189.733612,1280.343994 185.900604,1280.658691 184.353043,1284.573364 
	C182.098190,1290.277222 184.657150,1296.552002 190.161697,1297.939453 
	C195.733185,1299.343384 201.077179,1300.923950 204.738586,1305.764282 
	C205.733887,1307.080078 207.226166,1308.316406 207.537704,1309.790649 
	C208.165985,1312.763672 211.408615,1316.094360 207.598938,1318.865234 
	C204.050095,1321.446655 200.120956,1323.487061 195.668152,1320.466553 
	C192.624435,1318.401855 190.010025,1316.106934 188.214767,1312.673096 
	C183.982330,1304.578247 183.778336,1304.446411 174.985275,1305.920776 
	C170.309082,1306.704956 166.019012,1304.176514 160.915756,1304.587036 
	C160.840454,1310.067993 164.681839,1314.105957 164.151657,1319.261475 
	C163.712891,1323.527710 163.135712,1327.357300 158.927856,1329.173950 
	C154.961853,1330.885986 151.392059,1329.976196 147.925201,1327.026489 
	C140.857788,1321.013428 140.643555,1321.120850 134.817703,1328.030396 
	C132.723602,1330.513916 129.574951,1332.231689 128.804184,1335.802124 
	C130.342377,1339.097290 133.395142,1337.669312 135.817017,1338.028198 
	C139.554672,1338.581909 142.982910,1339.697510 145.183853,1342.986328 
	C148.003479,1347.199707 148.551804,1353.400146 146.403717,1355.057495 
	C143.228333,1357.507935 134.980026,1355.668457 132.064957,1351.656006 
	C130.708496,1349.788818 129.753815,1347.615967 128.722565,1345.529541 
	C127.101334,1342.249512 124.853340,1341.820435 122.616577,1344.590698 
	C119.310898,1348.684814 116.544510,1352.943359 111.317680,1355.362427 
	C108.281708,1356.767700 110.416740,1362.764771 114.500298,1363.585327 
	C118.075829,1364.303711 121.666611,1364.819458 125.135132,1366.029419 
	C129.788910,1367.652832 132.424286,1370.726318 131.880585,1375.758423 
	C131.404373,1380.165771 130.202728,1384.367920 125.152870,1385.764404 
	C119.711174,1387.269287 114.663658,1385.649902 111.929008,1381.770020 
	C110.126167,1379.212280 109.830505,1374.354370 105.716103,1375.017822 
	C100.828278,1375.806152 102.477791,1380.668945 101.902710,1384.061890 
	C101.164314,1388.418335 90.276100,1397.602417 85.243797,1397.907959 
	C81.288948,1398.147949 77.261818,1398.420410 73.416718,1396.813599 
	C70.889702,1395.757568 68.166130,1395.753906 65.545547,1396.242432 
	C62.281357,1396.851196 61.054016,1400.707886 63.343327,1403.094849 
	C64.985626,1404.807129 67.270142,1405.477417 69.512833,1406.197144 
	C74.000587,1407.637207 75.292221,1411.547852 75.786026,1415.549438 
	C76.312614,1419.816650 73.246323,1422.134155 69.921173,1423.982788 
	C67.874458,1425.120605 65.664391,1425.638428 63.326241,1426.056763 
	C54.785725,1427.584473 53.772930,1429.289551 56.075996,1437.242676 
	C56.537502,1438.836548 57.326118,1440.357056 57.620564,1441.973755 
	C58.464962,1446.610229 55.357239,1451.293823 51.345661,1451.671021 
	C46.992512,1452.080444 42.218716,1447.815552 42.078751,1443.277954 
	C42.038368,1441.968750 42.123749,1440.564697 42.558266,1439.349731 
	C43.553783,1436.566284 43.898502,1434.020020 40.620358,1432.662720 
	C37.516495,1431.377563 34.786560,1432.273315 32.472332,1434.660522 
	C31.023790,1436.154663 30.151621,1437.875977 30.001625,1439.958862 
	C29.822147,1442.451050 28.936031,1444.944214 26.439064,1445.437378 
	C19.527777,1446.802612 18.082701,1452.343506 16.346640,1457.736694 
	C14.328296,1464.006470 10.748466,1468.236572 2.773655,1467.998535 
	C2.000000,1459.950928 2.000000,1451.901855 2.000000,1442.926392 
	C10.434362,1435.229370 10.434362,1435.229370 2.488459,1426.477417 
	C2.000000,1414.623901 2.000000,1403.247925 2.000000,1390.935913 
	C11.053986,1383.512085 11.053986,1383.512085 2.499393,1378.460815 
	C2.000000,1375.222168 2.000000,1372.444458 2.000000,1368.833252 
	C3.826094,1366.459351 4.448801,1364.092773 5.953530,1362.306396 
	C10.743541,1356.619995 9.703620,1352.124146 2.498590,1348.464600 
	C2.000000,1343.258911 2.000000,1338.517700 2.000000,1332.888306 
	C4.690595,1329.949219 6.003087,1327.718750 2.461652,1324.458008 
	C2.000000,1319.916626 2.000000,1315.833374 2.000000,1310.875000 
	C5.653317,1308.778076 7.128428,1312.008667 9.370749,1313.635864 
	C11.280548,1315.021973 13.312066,1316.542603 15.489843,1314.595581 
	C17.785126,1312.543335 17.257288,1309.801270 16.083557,1307.361938 
	C14.625691,1304.332031 12.184174,1304.289062 9.506986,1305.731567 
	C7.511864,1306.806274 5.720789,1308.337891 2.652238,1308.223999 
	C2.000000,1299.286255 2.000000,1290.572388 2.000000,1280.929321 
	C7.333270,1274.597046 9.536118,1269.016968 2.482567,1262.470215 
	C2.000000,1256.599976 2.000000,1251.199951 2.000000,1244.899902 
	C5.118953,1241.412720 7.615227,1243.859009 10.156992,1245.125244 
	C13.878110,1246.978760 17.235577,1247.147095 19.842287,1243.438232 
	C21.573181,1240.975342 23.549614,1238.022827 21.511705,1235.212280 
	C18.767700,1231.428101 14.950950,1233.314819 11.526516,1234.576904 
	C8.774914,1235.590942 6.353642,1237.766113 2.543242,1236.441162 
	C2.000000,1233.866577 2.000000,1231.733276 2.000000,1228.799927 
	C5.423260,1224.484375 10.509335,1224.359253 14.449173,1221.894653 
	C16.477589,1220.625732 18.634207,1219.279663 17.685522,1216.444214 
	C16.921455,1214.160522 14.747736,1214.082886 12.687961,1214.166260 
	C9.389312,1214.299561 6.016969,1214.999023 2.501821,1212.458740 
	C2.000000,1210.500000 2.000000,1209.000000 2.000000,1206.750000 
	C2.235639,1205.781250 2.494916,1205.582886 2.703308,1205.340698 
	C5.285422,1202.340698 12.119511,1204.701660 11.960641,1198.634277 
	C11.821733,1193.329468 5.988002,1193.525635 2.490785,1190.461914 
	C2.000000,1170.624878 2.000000,1151.249756 2.000000,1130.937256 
	C12.025980,1131.323853 21.280102,1134.127563 27.281713,1143.175171 
	C29.136246,1145.970825 31.068275,1148.816772 34.482189,1149.759644 
	C39.404568,1151.118774 42.067043,1148.256470 43.403709,1144.052734 
	C44.753075,1139.809082 42.160549,1137.869873 38.436317,1137.120850 
	C34.830051,1136.395630 31.140253,1136.781616 27.490515,1136.603516 
	C23.738899,1136.420532 19.598431,1136.074341 17.973927,1132.335205 
	C14.564151,1124.486816 9.241276,1125.837158 2.667919,1128.216064 
	C2.000000,1124.571289 2.000000,1121.142578 1.999995,1116.856934 
	C4.307871,1115.792725 6.719751,1115.941772 8.901969,1115.304321 
	C13.435042,1113.980469 16.526464,1111.290649 16.006271,1105.938721 
	C15.606493,1101.825562 16.505276,1097.972534 18.869843,1094.552368 
	C23.260408,1088.201538 28.667519,1087.285278 34.846420,1092.001587 
	C36.956177,1093.611816 38.801620,1095.519775 41.300373,1096.628296 
	C43.329277,1097.528320 45.129604,1097.763672 46.659515,1095.884766 
	C48.089035,1094.129028 48.126408,1092.149048 46.917229,1090.339722 
	C44.646629,1086.941772 41.073383,1085.021729 37.955074,1082.547241 
	C34.602524,1079.886841 31.385492,1076.594238 33.323246,1071.523193 
	C35.215275,1066.571899 39.286697,1064.673096 44.211060,1064.063110 
	C48.525852,1063.528564 50.780689,1065.956543 52.923908,1069.330933 
	C54.596184,1071.963867 56.874996,1075.537964 60.752056,1071.805176 
	C64.203072,1068.482666 63.946251,1065.158203 60.503548,1061.487183 
	C58.393906,1059.237671 55.668545,1058.020020 53.103794,1056.481934 
	C47.218327,1052.952271 46.588539,1048.468384 50.956753,1042.432617 
	C54.553608,1037.462646 60.336796,1036.380249 64.812790,1040.056885 
	C66.321823,1041.296387 67.232582,1043.239624 68.659248,1044.608521 
	C72.794655,1048.576172 77.450317,1048.805054 82.332092,1045.813843 
	C85.316971,1043.984863 86.104759,1041.419067 85.940025,1038.201538 
	C85.761742,1034.719482 84.140610,1032.515259 80.603294,1032.109497 
	C75.454674,1031.519165 71.394501,1028.407227 66.860374,1026.392578 
	C63.434238,1024.870117 61.378288,1022.427673 62.328671,1018.552124 
	C63.300694,1014.588257 66.054810,1012.497803 70.168083,1012.032776 
	C74.417618,1011.552368 77.864891,1012.986084 81.258644,1015.466492 
	C83.601944,1017.179199 86.704468,1018.998108 88.581612,1014.639587 
	C90.182251,1010.923035 94.487236,1007.009460 89.522652,1003.163391 
	C86.043274,1000.467834 82.601288,998.071350 80.936752,993.794739 
	C79.603310,990.368774 79.827179,987.367249 82.487457,984.608826 
	C84.916397,982.090332 87.527611,981.774963 90.622787,983.228760 
	C92.706871,984.207642 94.948586,984.687805 97.009804,985.919434 
	C104.931038,990.652161 106.264130,990.885925 111.528992,983.122498 
	C117.698532,974.024719 125.577934,966.303528 131.404388,957.012756 
	C134.768250,951.648865 138.386642,946.565430 142.838211,941.983826 
	C146.526093,938.188354 149.728638,933.754517 151.444687,928.671509 
	C153.715942,921.943970 156.348602,915.841370 162.846085,911.818237 
	C166.758499,909.395691 167.199295,904.416382 167.827332,900.227722 
	C169.024170,892.245605 171.603241,885.554199 179.660934,882.051025 
	C184.108810,880.117188 185.877121,875.949158 185.873337,871.450684 
	C185.866592,863.428650 188.954971,858.022522 197.019821,855.965881 
	C202.232407,854.636475 202.218918,850.645020 201.766113,846.444397 
	C200.611771,835.735413 201.398300,833.022339 211.039810,829.832031 
	C218.002472,827.528198 220.506241,823.506592 221.458237,816.505859 
	C222.309387,815.885193 222.613159,815.705322 222.934265,815.665710 
	C225.805527,815.311157 228.596024,820.345947 230.836136,817.059326 
	C233.278763,813.475708 228.799850,811.476318 226.353683,808.561951 
	C226.149307,804.715637 228.569077,803.309753 231.143814,802.633850 
	C236.589859,801.204163 236.403442,797.515076 235.474228,793.283997 
	C234.437531,788.563354 230.814636,783.561279 233.492020,779.141907 
	C235.899460,775.167908 241.674255,775.246094 246.038467,773.755920 
	C251.293610,771.961548 254.109009,769.118713 254.182571,762.900391 
	C254.300278,752.950073 255.502899,751.965088 265.301514,752.123535 
	C270.757416,752.211792 274.998779,750.800903 278.461761,746.597534 
	C280.606995,743.993652 283.409668,742.689880 286.824524,741.705750 
	C293.257172,739.852112 297.463776,734.831848 299.366760,728.546814 
	C300.985535,723.200439 300.696869,717.576965 294.135071,713.979004 
	C290.054230,711.741455 286.209229,708.878296 286.045898,703.422546 
	C285.962006,700.619568 286.373901,697.968323 289.242310,696.678955 
	C291.736359,695.557800 293.772675,696.799561 295.479279,698.565735 
	C296.862946,699.997742 298.194214,701.490173 299.443604,703.040466 
	C304.221771,708.969604 305.391693,709.095276 311.664337,705.525940 
	C317.165833,702.395325 320.559021,698.231628 322.185455,691.837463 
	C324.958282,680.936218 336.885529,677.583679 344.575745,686.045288 
	C349.690125,691.672791 354.732849,690.755798 360.552856,689.891174 
	C364.653290,689.282043 366.359924,686.708069 365.731537,682.843201 
	C365.105103,678.990295 363.437195,675.794006 358.661591,676.063110 
	C358.328918,676.081848 357.953796,675.994995 357.668762,676.118958 
	C347.491089,680.545959 342.200409,675.152283 338.246460,666.657654 
	C335.610382,660.994263 330.836151,658.222107 324.686707,658.057434 
	C321.216888,657.964417 317.993866,657.611450 315.811798,654.548767 
	C313.019653,650.629822 313.280426,646.106384 314.847260,642.133728 
	C316.165924,638.790039 320.098267,640.253723 322.955475,640.021606 
	C328.723633,639.553162 333.377106,641.946167 337.079742,646.138794 
	C340.040436,649.491333 343.653595,650.398132 347.868927,649.939575 
	C352.445892,649.441650 354.995087,646.880188 355.922760,642.425598 
	C358.321472,630.907043 359.826538,629.484985 370.921173,628.040039 
	C372.237579,627.868530 373.602081,628.017700 374.903168,627.786560 
	C379.041229,627.051575 380.234039,624.281189 379.708344,620.456726 
	C379.619049,619.807129 379.443939,619.134460 379.149323,618.553162 
	C371.633240,603.723328 376.379181,598.311035 393.100220,597.958862 
	C394.428833,597.930847 395.759460,597.847412 396.901245,596.491699 
	C397.731628,593.449463 395.342804,591.150146 394.204773,588.498596 
	C391.315704,581.767273 391.952850,577.658752 398.104126,574.162964 
	C404.583832,570.480469 407.250885,566.351746 404.721558,558.745728 
	C403.140625,553.991577 407.122681,548.619263 411.892578,547.145752 
	C416.233917,545.804626 418.845642,548.120239 420.693176,551.638062 
	C423.213654,556.437134 422.619019,560.670837 418.056641,563.782043 
	C414.117737,566.468079 412.393829,569.733948 411.479736,574.289673 
	C409.737518,582.972839 409.835724,583.583252 417.792114,584.882935 
	C424.677643,586.007690 429.529114,583.024475 429.881409,576.925781 
	C430.114136,572.897583 430.458954,569.018433 431.948639,565.224426 
	C432.813049,563.022949 434.266846,562.140808 437.223877,562.024536 
	C439.257690,563.876038 438.495941,565.783447 438.045532,567.662964 
	C437.241119,571.019592 436.764557,574.382751 440.738098,576.017761 
	C443.843628,577.295593 446.654144,576.037048 448.597870,573.566406 
	C451.528229,569.841736 449.442963,566.861450 446.627869,564.206421 
	C445.437653,563.083923 443.981110,562.280457 442.389465,560.580078 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,776.937317 
	C11.769852,778.053589 15.271112,776.198120 18.521557,767.095032 
	C19.750080,763.654480 20.815773,760.154785 21.909019,756.667419 
	C22.303673,755.408508 22.132780,753.471069 22.947483,752.921326 
	C33.018459,746.125122 34.758213,733.457581 43.126286,725.049805 
	C50.221661,717.920776 55.094284,708.606201 63.782166,702.509766 
	C67.260201,700.069214 67.970009,694.959656 67.879128,690.625977 
	C67.787292,686.246582 69.743637,683.920715 73.442467,682.205017 
	C80.530968,678.916992 84.989883,674.384521 84.402069,665.378601 
	C84.014343,659.438232 88.496407,654.668945 94.414062,653.011719 
	C100.306786,651.361511 102.152969,648.144653 102.138817,642.209290 
	C102.113800,631.710632 103.141090,630.821777 113.180946,627.330688 
	C113.809685,627.112061 114.407562,626.804749 115.036079,626.585327 
	C125.702934,622.861206 126.520370,620.700867 120.144630,611.165039 
	C117.794327,607.649841 117.285904,604.547119 119.976341,601.172791 
	C122.793938,597.638916 126.072128,597.706543 129.711563,599.844849 
	C131.430206,600.854553 133.246857,601.729126 135.093216,602.483643 
	C139.721817,604.375305 145.707031,601.669128 147.139252,597.163391 
	C147.735992,595.286133 146.833527,593.955322 145.656082,592.732910 
	C143.344223,590.332764 140.834137,588.106201 138.682190,585.573181 
	C134.835159,581.044983 135.504456,578.104187 141.029373,575.597656 
	C146.404343,573.159119 152.011841,573.329346 157.551300,575.100525 
	C158.776871,575.492432 159.740005,576.649292 160.947205,577.165955 
	C163.566101,578.286621 166.159195,578.305725 168.314880,576.103577 
	C169.847229,574.538269 170.172363,572.584656 169.487808,570.563904 
	C168.493332,567.628235 165.853287,568.240051 163.610809,568.006592 
	C156.119614,567.226868 151.774872,563.261536 150.323120,555.999573 
	C149.756927,553.167419 150.378723,550.752808 152.403122,548.661072 
	C154.263229,546.739014 156.154144,544.907837 158.586166,543.668152 
	C165.081879,540.357239 167.996231,535.400940 165.026382,528.212952 
	C163.231659,523.869141 165.300751,521.204407 168.507843,518.922058 
	C170.944748,517.187866 173.409363,515.457886 176.019241,514.010132 
	C179.495468,512.081787 180.101883,509.308014 179.666962,505.597717 
	C178.631409,496.763580 181.807068,491.498230 189.930542,487.752258 
	C197.193771,484.402954 198.270508,482.848541 196.432098,474.737885 
	C194.895950,467.960754 197.717392,463.126434 203.160660,460.746277 
	C210.527740,457.524902 212.561829,452.723053 212.164780,445.104523 
	C211.642380,435.080841 214.098007,432.922577 223.987778,432.008636 
	C233.608124,431.119629 235.872772,427.546906 231.975143,418.218781 
	C230.236359,414.057434 229.443924,410.670624 233.560349,407.679993 
	C237.380981,404.904205 242.233673,405.399078 246.151123,409.265808 
	C247.780396,410.873962 249.481339,412.739288 250.256744,414.820374 
	C252.512894,420.875549 256.818970,422.713959 262.819122,422.017670 
	C268.061890,421.409332 271.810516,423.557159 274.142975,428.334930 
	C275.654602,431.431335 277.275726,434.854736 274.631622,437.642120 
	C271.879669,440.543152 267.867188,442.363342 263.828766,440.704620 
	C259.240631,438.820129 254.917694,436.227661 250.635880,433.680054 
	C247.418213,431.765656 245.238052,431.571381 243.787323,435.694824 
	C242.396515,439.647980 239.128723,442.017120 235.706009,444.212646 
	C234.055588,445.271362 232.524170,446.641235 231.262787,448.142395 
	C230.188461,449.421082 229.619446,451.189514 231.072952,452.638489 
	C232.235687,453.797699 233.485962,453.081818 234.594833,452.273193 
	C237.276108,450.317932 240.110458,448.537506 242.596405,446.359344 
	C245.117279,444.150635 246.975830,444.515717 249.550568,446.449951 
	C254.413483,450.103088 258.864471,453.791016 259.772980,460.343567 
	C260.372925,464.670624 259.621582,468.339752 255.765076,470.827057 
	C252.083481,473.201630 244.831711,473.230438 241.988754,470.942230 
	C240.954178,470.109528 240.139633,468.992523 239.073288,468.212067 
	C234.079254,464.557129 228.546204,465.645508 226.087357,471.450195 
	C224.166809,475.984131 221.140717,478.917084 217.451385,481.952728 
	C212.742279,485.827515 207.235580,489.538544 207.902512,497.278046 
	C208.502167,504.236603 209.076981,505.346649 215.924484,505.973053 
	C217.579910,506.124481 219.298233,505.881226 220.905151,506.215698 
	C225.935791,507.262787 228.343140,510.528137 227.045990,515.558655 
	C226.103683,519.213135 225.950577,522.761902 226.158600,526.416809 
	C226.239304,527.835022 226.900909,529.042542 228.329926,529.412109 
	C229.701660,529.766846 230.820312,529.181702 231.768860,528.040527 
	C233.680969,525.739990 235.556717,523.369568 237.736832,521.338623 
	C245.161819,514.421387 249.054276,514.869202 253.784073,523.836487 
	C256.092773,528.213623 258.666138,530.786621 263.788513,529.949951 
	C267.115234,529.406555 271.145935,528.989807 271.455780,525.008789 
	C271.739288,521.366028 269.799072,517.878052 265.932861,516.311462 
	C263.778687,515.438660 261.547821,514.732178 259.311768,514.088806 
	C254.042465,512.572571 251.788467,509.051331 251.983383,503.669769 
	C252.116013,500.008087 251.796539,496.318420 252.106232,492.677551 
	C252.562119,487.318054 254.845840,485.357025 259.957886,486.491333 
	C263.551147,487.288696 267.063843,488.320557 270.747772,487.993591 
	C274.954865,487.620117 276.211426,491.156158 278.494080,493.403412 
	C281.040314,495.910187 283.349884,499.463379 287.734131,496.794708 
	C290.362793,495.194550 294.366882,485.771362 293.434174,483.496643 
	C292.440369,481.072784 290.485748,479.731873 287.871735,480.499878 
	C286.342834,480.949097 285.068665,482.216003 283.627136,483.020477 
	C276.330322,487.092743 269.157074,483.948029 266.997803,475.756287 
	C265.579865,470.377075 271.229187,465.094238 277.749634,466.419098 
	C284.146545,467.718872 290.559082,468.992462 296.161896,473.152985 
	C301.980103,477.473450 303.759949,476.684692 306.180115,470.093353 
	C307.787628,465.715240 309.508484,461.454376 312.109924,457.548126 
	C312.961487,456.269470 314.198334,454.527649 312.581482,453.072815 
	C310.695526,451.375916 308.753357,452.485809 307.299438,453.899597 
	C303.670715,457.428162 300.218018,460.573151 294.388397,460.144135 
	C289.067566,459.752625 285.444946,458.042084 283.945404,452.762115 
	C283.854340,452.441528 283.768372,452.119476 283.681244,451.797791 
	C282.528717,447.543060 277.304108,443.100128 281.556824,439.052002 
	C285.827881,434.986511 291.949005,433.173615 298.264893,434.425171 
	C300.450256,434.858215 302.511505,436.536255 304.862366,434.904694 
	C305.744415,431.097656 303.009430,428.601044 301.779266,425.655609 
	C300.734772,423.154602 299.788574,420.721344 300.072174,417.964935 
	C300.733704,411.535095 305.636322,408.855286 311.436523,411.771759 
	C312.325409,412.218719 313.494598,412.556549 313.972626,413.303955 
	C319.642639,422.169678 328.872253,422.006195 337.732849,422.928162 
	C339.106659,423.071075 340.433533,423.450043 341.233673,422.153473 
	C342.015839,420.886108 341.501526,419.561310 340.485596,418.568390 
	C339.777191,417.876068 338.730621,417.488068 338.134796,416.728943 
	C334.083832,411.567841 322.739319,403.726166 316.246979,401.714050 
	C311.056335,400.105316 309.362213,395.827728 312.037811,390.983765 
	C313.001404,389.239197 314.064423,387.549347 315.088623,385.838470 
	C319.808441,377.954193 332.514832,377.303436 338.361298,384.731354 
	C341.057770,388.157257 343.845551,391.491211 347.613342,393.721863 
	C350.143890,395.220001 352.964905,397.019379 355.904968,394.584229 
	C358.270691,392.624695 358.132965,389.917358 357.459106,387.214569 
	C357.298920,386.572021 357.037231,385.948151 356.765717,385.340973 
	C354.845795,381.048279 357.987366,375.481476 354.186615,371.984894 
	C350.503265,368.596313 346.058167,372.683868 341.787170,372.166687 
	C337.780945,371.681549 334.663574,370.501404 332.663177,367.085480 
	C328.699768,360.317596 323.346130,356.187622 315.111328,355.733215 
	C310.163177,355.460205 306.552277,352.382202 304.826141,347.464447 
	C302.734344,341.505096 304.264221,337.570892 309.685303,335.219513 
	C314.988342,332.919373 317.798492,333.587036 320.702972,339.778015 
	C323.941681,346.681488 328.910400,348.795593 335.982300,348.015076 
	C341.413666,347.415649 343.440430,344.266937 341.331207,339.218994 
	C338.846161,333.271637 331.744476,329.299103 325.117889,330.149567 
	C316.907806,331.203247 316.815033,331.252472 312.944275,323.957489 
	C310.307892,318.988861 305.636200,317.148560 300.748993,316.257355 
	C295.635651,315.324982 292.188538,319.737061 293.399597,324.904694 
	C293.778229,326.520203 294.406555,328.075500 294.849091,329.678101 
	C296.713013,336.427856 295.321014,339.460266 289.038910,342.428436 
	C284.375824,344.631653 280.599091,343.232849 277.437653,338.131622 
	C274.662689,333.653961 275.295135,328.435883 280.482361,325.171753 
	C285.266418,322.161255 286.547668,318.433472 285.971649,313.476990 
	C285.413452,308.674164 287.546997,304.342377 288.233185,299.763519 
	C289.389709,292.045868 294.302002,289.995941 301.765320,292.760040 
	C305.949646,294.309723 309.805481,295.856445 311.305176,300.566315 
	C313.477264,307.387787 319.073792,309.937195 325.245392,312.154572 
	C332.274689,314.680084 340.435760,315.179443 344.995880,322.634796 
	C346.102722,324.444366 348.623108,323.956116 350.598511,323.980316 
	C354.264191,324.025269 357.935272,324.119904 361.595703,323.977417 
	C366.152802,323.800049 369.178497,325.229065 370.365692,330.120514 
	C371.690430,335.578491 375.091187,338.057434 381.204132,338.238953 
	C388.328186,338.450500 394.291595,346.513275 393.968170,353.545563 
	C393.794861,357.314392 391.911652,359.856628 388.652740,361.321350 
	C383.134949,363.801361 370.712494,360.103760 367.484894,354.706512 
	C365.259888,350.985779 362.647095,348.369629 358.219849,348.147339 
	C354.030518,347.936981 352.066803,350.491455 353.261536,354.374512 
	C355.191833,360.648224 357.645599,362.449371 365.014709,362.667358 
	C366.859924,362.721924 368.701416,363.152313 369.066162,364.837311 
	C370.218964,370.162750 374.441162,373.093872 377.699310,376.799072 
	C380.873505,380.408722 380.595215,383.922852 377.481995,387.498322 
	C375.243500,390.069122 372.296265,391.628479 369.630707,393.601837 
	C366.688019,395.780457 365.290619,398.754486 366.461334,402.354980 
	C367.271881,404.847687 368.242371,407.533875 371.554718,407.804169 
	C375.454193,408.122375 377.743317,405.702576 379.513336,402.759125 
	C381.762421,399.019043 383.101471,394.839233 383.828369,390.595947 
	C384.377655,387.389648 385.467712,384.468567 388.260712,383.203796 
	C394.451660,380.400208 397.342072,374.198883 398.635223,369.160980 
	C400.677490,361.204468 405.684296,356.570251 411.246429,352.062286 
	C414.723053,349.244507 417.084106,346.509186 415.579132,342.040924 
	C413.955902,337.221680 410.076813,335.526093 405.296173,336.041687 
	C398.292603,336.797028 393.404938,334.076050 389.152588,328.446533 
	C385.606689,323.752289 382.363098,317.759552 373.897766,321.075928 
	C370.143036,322.546875 364.453278,316.385773 362.695282,311.195557 
	C361.124878,306.559143 362.876770,303.707581 366.942322,301.365204 
	C370.410919,299.366730 372.978516,296.178680 375.478424,293.035889 
	C380.014008,287.333832 379.959137,285.720276 375.457367,280.469025 
	C370.648163,274.859161 364.459747,273.469910 357.444336,273.936615 
	C355.239441,274.083282 352.506531,274.752991 351.009583,272.395355 
	C349.111542,269.406128 351.855560,267.497253 353.232941,265.380066 
	C354.493256,263.442780 355.715576,261.359467 357.406799,259.845642 
	C363.394348,254.486130 369.851013,255.517242 374.101929,262.343811 
	C374.978760,263.751923 375.654755,265.291565 376.354034,266.802643 
	C379.850830,274.359406 379.842743,274.363190 387.965424,274.070557 
	C393.058655,273.887085 396.952728,276.511627 397.753784,280.667786 
	C398.630127,285.214539 395.210052,291.187897 390.257263,291.742279 
	C384.568481,292.379120 384.750153,294.307159 385.153015,299.453583 
	C385.762451,307.238861 389.695160,310.788605 396.105560,312.980225 
	C404.062622,315.700592 411.591034,318.653168 416.085297,326.721344 
	C418.368774,330.820648 422.604523,330.214996 426.799927,328.784851 
	C430.904510,327.385620 433.811066,325.888672 434.102814,320.782227 
	C434.561676,312.751404 437.095123,305.388855 441.991394,298.671356 
	C446.946228,291.873474 443.934967,286.472626 435.559723,286.020599 
	C433.897858,285.930908 432.216766,285.873596 430.563080,286.016449 
	C425.374359,286.464661 422.699829,284.136719 421.320496,279.096649 
	C420.027252,274.371216 418.842499,270.011536 422.968658,266.177826 
	C426.842010,262.579102 433.450287,261.777618 438.650421,264.325653 
	C443.745758,266.822357 448.386292,270.019867 452.759735,273.649292 
	C455.566589,275.978668 458.657196,278.717224 462.561584,277.254944 
	C466.979431,275.600464 465.818573,271.251648 465.989105,267.702240 
	C466.053009,266.372131 465.973755,265.035767 466.005524,263.703339 
	C466.192841,255.848328 468.410156,251.738159 472.951843,250.792007 
	C478.866119,249.559921 485.738495,253.927216 488.094788,260.382904 
	C488.425354,261.288574 488.904480,262.140045 489.548645,263.516052 
	C495.362213,260.760956 500.526123,262.713837 505.478058,265.795410 
	C509.694458,268.419281 511.282898,272.646362 509.295380,276.750946 
	C507.336334,280.796722 504.104462,282.566864 499.467133,281.577881 
	C492.673187,280.128967 491.202942,278.624298 489.979462,271.177582 
	C489.722015,269.610443 490.190460,267.606293 488.038574,267.075836 
	C486.151886,266.610809 484.832855,267.977966 483.935364,269.291321 
	C481.805054,272.408752 479.120300,274.673767 475.674683,276.245209 
	C472.862671,277.527710 470.887268,279.847443 469.697174,282.713440 
	C467.068726,289.043243 463.516296,294.036285 456.273010,296.135437 
	C451.549286,297.504395 451.338379,301.624451 453.233429,306.000732 
	C457.895050,316.765961 456.479004,320.333252 445.662201,326.386658 
	C442.676697,328.057434 439.609833,330.023010 440.501740,333.994415 
	C441.178680,337.008575 443.392578,339.890289 446.794739,339.145721 
	C450.413208,338.353790 455.521759,338.202515 455.741180,332.838562 
	C455.942017,327.928802 457.767242,324.924377 462.251801,322.765656 
	C470.470581,318.809540 471.897003,318.847992 476.907684,326.296753 
	C478.777740,329.076752 480.716125,331.710602 483.058563,334.109741 
	C485.818146,336.936127 488.462189,338.413086 492.748138,336.868164 
	C499.249969,334.524475 505.001312,336.521484 510.199249,341.119873 
	C518.241455,348.234528 527.204285,345.992432 530.913757,335.643860 
	C532.392456,331.518677 534.722168,328.095703 536.636719,324.333710 
	C539.015015,319.660522 542.784912,319.993622 546.812317,320.020264 
	C550.689087,320.045898 552.620117,322.165802 551.811646,325.699982 
	C549.902039,334.047638 551.263794,343.869781 540.835815,348.495911 
	C537.236511,350.092743 534.901367,354.032074 536.507263,358.639496 
	C538.761536,365.107025 534.846436,368.634369 530.302307,371.745300 
	C528.694519,372.846008 526.626160,373.255066 524.811646,374.076202 
	C518.619324,376.878235 517.568665,378.984314 518.896423,385.740082 
	C520.468933,393.740967 519.867188,395.595795 515.156677,397.268738 
	C510.195831,399.030579 505.420563,396.828796 502.060974,391.230469 
	C499.214111,386.486664 489.545471,384.031067 484.824799,386.908752 
	C482.351501,388.416473 482.927917,390.534241 483.281433,393.017975 
	C484.474915,401.403137 484.297943,401.407532 476.650482,404.777344 
	C474.517883,405.717041 472.446655,406.797516 470.358398,407.835785 
	C467.333405,409.339844 464.296967,411.052277 461.205658,408.038055 
	C457.707184,404.626770 455.603607,400.609985 456.170441,395.556610 
	C456.377563,393.710052 457.453125,392.342712 459.293152,392.223999 
	C462.510498,392.016510 464.621979,389.345825 467.399567,388.664459 
	C473.309937,387.214508 474.381409,383.330353 474.017120,378.157837 
	C473.441254,369.981812 477.072479,364.195312 484.117371,360.167389 
	C488.786285,357.497986 488.980743,356.297729 484.766327,353.466217 
	C478.629211,349.342926 472.764801,344.491089 464.760559,342.580994 
	C464.031860,348.820496 468.149475,354.347015 464.803955,359.720306 
	C461.686279,364.727661 455.944916,365.254272 451.226410,367.523163 
	C448.826904,368.676910 447.942627,370.679413 448.034576,373.227509 
	C448.189789,377.529114 447.883362,381.787201 448.871796,386.125336 
	C449.948944,390.852753 447.156342,394.234985 442.287170,395.591003 
	C437.286987,396.983490 434.229248,395.558075 431.956451,390.775269 
	C427.639893,381.691437 422.180054,379.655090 415.231476,384.453278 
	C413.043152,385.964355 411.886078,387.692963 413.232788,390.305603 
	C415.912445,395.504181 419.092682,400.708862 425.823944,399.849884 
	C433.526215,398.867065 436.622681,402.549713 438.107361,409.244995 
	C439.340149,414.804382 443.004669,417.768860 448.749939,417.978302 
	C453.435638,418.149170 457.033752,419.867554 459.141449,424.369690 
	C462.460571,431.459259 462.308960,434.619781 455.764465,438.682434 
	C449.931366,442.303436 447.520477,446.519043 447.843872,453.348450 
	C448.152802,459.872406 445.580261,462.394806 439.548950,463.744598 
	C426.668640,466.627106 421.544586,461.638428 422.907471,447.481720 
	C420.522675,445.661224 419.391876,447.993835 417.955933,449.065125 
	C408.402557,456.192657 401.668457,455.944061 393.084259,448.074585 
	C391.366638,446.499939 389.742981,444.815674 387.955902,443.326019 
	C386.580933,442.179810 384.841797,441.864410 383.374908,443.009674 
	C381.920135,444.145508 381.867157,445.964081 382.328918,447.604187 
	C383.673035,452.378357 387.651276,454.677887 391.854065,455.476349 
	C396.694244,456.395996 400.489716,458.315979 403.980011,461.704102 
	C406.840240,464.480560 410.343201,465.932068 414.709595,466.177887 
	C422.014801,466.589111 430.527527,477.492279 429.876678,484.573669 
	C429.222748,491.689178 419.966034,496.391998 413.926514,492.525818 
	C411.996857,491.290558 410.524078,489.356415 408.784332,487.807037 
	C401.823761,481.608063 392.094818,483.124481 389.453705,491.788940 
	C386.947845,500.009583 382.088470,506.509766 377.672974,513.457581 
	C376.606262,515.135986 375.466187,516.843872 374.817871,518.698242 
	C372.623901,524.973999 375.448090,528.100647 382.114075,526.943848 
	C382.762421,526.831360 383.364990,526.443909 384.013367,526.344727 
	C390.874420,525.295654 396.437683,528.271057 397.548920,533.550537 
	C398.540375,538.261047 393.116119,545.690186 387.654205,547.037170 
	C383.471222,548.068665 380.526489,545.594727 378.098267,542.938293 
	C374.664032,539.181213 370.792175,537.676941 365.713715,537.920105 
	C357.653259,538.305969 354.573212,540.181152 354.256317,548.378235 
	C353.984100,555.419250 350.886505,559.878479 344.987366,562.333740 
	C338.942688,564.849487 337.230835,569.138000 338.020081,575.019592 
	C338.807800,580.890015 336.574280,585.363953 332.068237,588.945374 
	C328.292542,591.946289 325.389008,595.787476 324.905151,600.550964 
	C323.917358,610.276428 318.510986,615.390137 309.332214,617.339905 
	C307.774261,617.670837 306.021484,617.987183 304.911682,619.614441 
	C304.393250,621.658691 305.753937,623.319336 306.528259,625.107422 
	C308.192017,628.949463 309.351044,633.053528 306.073212,636.294312 
	C302.275146,640.049377 297.361908,641.188477 292.232330,638.980835 
	C289.188232,637.670715 286.344879,635.894836 283.409119,634.332458 
	C278.714722,631.833984 276.637146,632.713135 276.124146,637.866699 
	C275.697327,642.154297 275.491547,646.491882 279.531677,649.725403 
	C281.308716,651.147705 282.672516,653.171753 283.962769,655.097656 
	C286.102295,658.291138 289.583801,661.420349 285.362610,665.515320 
	C281.947601,668.828247 276.906799,668.956299 272.730957,665.592102 
	C269.888245,663.301819 267.415131,660.540771 264.509430,658.343750 
	C260.652130,655.427185 256.841400,656.574890 253.790558,659.717285 
	C249.823013,663.803894 252.569016,673.631592 258.351471,675.586060 
	C261.157959,676.534607 264.237305,676.769531 266.759705,678.497803 
	C271.652985,681.850769 273.287079,688.396423 270.329376,692.416931 
	C267.288635,696.550171 262.121033,697.135864 257.036102,693.923706 
	C248.029007,688.233887 246.488159,688.259827 239.311310,695.762268 
	C233.136292,702.217407 228.463928,710.057068 220.896088,715.266541 
	C219.031479,716.550049 218.592743,719.167053 218.007431,721.478271 
	C215.666000,730.723755 211.292877,738.777405 203.305420,744.372314 
	C200.416748,746.395752 200.023666,749.099731 199.976288,752.204468 
	C199.875687,758.796631 196.870789,763.589050 190.908447,766.540527 
	C185.926178,769.006836 183.760696,772.289673 184.878799,778.542053 
	C186.089310,785.311096 180.812637,789.840393 175.249252,792.075256 
	C168.778610,794.674500 166.237122,798.499634 165.532471,805.337524 
	C164.911240,811.366089 163.515015,817.541992 156.752060,821.088135 
	C152.659149,823.234314 151.195007,828.490845 150.201874,833.037720 
	C148.740601,839.727844 145.187012,843.239502 138.180450,844.192383 
	C130.352112,845.256958 128.925598,847.983887 130.348587,855.999756 
	C132.554657,868.426636 131.511581,870.835327 119.862617,875.640076 
	C115.692345,877.360229 113.614777,878.987427 115.484703,883.630737 
	C116.077866,885.103577 115.954559,886.906494 115.976807,888.560913 
	C116.116821,898.971924 110.358994,902.465393 101.218964,897.551331 
	C92.006966,892.598450 86.695747,893.818237 81.755028,902.811096 
	C79.118370,907.610229 76.142517,912.185730 71.559853,914.848083 
	C66.644493,917.703735 66.025337,921.531189 65.894951,926.496460 
	C65.650368,935.810547 63.626766,944.327759 53.535778,948.369080 
	C50.373245,949.635620 48.395161,952.351318 47.947273,956.078857 
	C47.211796,962.199768 43.638542,966.350159 38.220798,969.081482 
	C33.166634,971.629700 31.130537,975.731812 31.986851,981.351562 
	C33.183304,989.203552 30.116556,994.743958 23.127167,998.594055 
	C18.439716,1001.176025 16.887243,1005.898804 15.748588,1011.017944 
	C14.226432,1017.861206 12.275549,1024.860718 2.745709,1025.988525 
	C2.000000,983.291565 2.000000,940.583069 2.000000,896.937317 
	C4.000400,893.977600 6.295686,894.876465 8.541191,895.349487 
	C11.323253,895.935547 14.194201,896.258545 14.600635,892.444824 
	C15.036691,888.353149 12.280281,887.418457 8.845890,887.598633 
	C6.860642,887.702759 4.860425,887.957886 2.508126,886.449280 
	C2.000000,849.958191 2.000000,813.916443 2.000000,776.937317 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2431.671875,1671.438721 
	C2433.139893,1677.500244 2437.242920,1676.300903 2440.623047,1675.370728 
	C2444.544678,1674.291626 2448.039795,1672.323364 2447.994629,1667.253784 
	C2447.959717,1663.324219 2447.573975,1659.389282 2450.851562,1656.079956 
	C2455.010498,1651.880859 2456.606934,1651.552612 2460.561523,1655.640381 
	C2461.926514,1657.051147 2463.029541,1658.737183 2464.122803,1660.383667 
	C2466.420166,1663.843384 2464.872803,1665.888184 2461.475830,1667.170776 
	C2461.165039,1667.288086 2460.860107,1667.429565 2460.540771,1667.514404 
	C2456.833252,1668.498779 2451.369385,1667.891602 2450.771729,1672.600220 
	C2450.220703,1676.940552 2451.695801,1681.770996 2454.023193,1685.857788 
	C2456.343506,1689.932983 2459.986084,1692.434204 2464.700195,1691.349976 
	C2469.172852,1690.321045 2472.531494,1687.607056 2472.001221,1682.194824 
	C2471.969238,1681.866455 2471.975342,1681.526489 2472.019287,1681.199341 
	C2472.941162,1674.337402 2474.922363,1671.760498 2478.922607,1672.194824 
	C2482.230469,1672.553955 2483.963379,1675.140747 2486.085938,1677.202271 
	C2488.635498,1679.678467 2486.627197,1682.135986 2486.072266,1685.302856 
	C2486.293213,1688.167236 2485.385254,1690.090942 2484.584961,1692.675049 
	C2484.124268,1694.082397 2483.814209,1694.875610 2483.217285,1696.253906 
	C2481.815674,1699.862305 2481.385742,1702.632202 2485.976562,1703.885010 
	C2489.630615,1703.559692 2492.192871,1702.338501 2494.689209,1699.614868 
	C2497.697266,1697.352295 2499.369629,1694.839111 2501.216797,1691.581543 
	C2503.804932,1689.137939 2506.360840,1687.956177 2509.713379,1686.805420 
	C2522.828125,1690.824097 2524.436523,1697.975708 2514.850586,1706.568115 
	C2512.087646,1709.044922 2509.287842,1711.508179 2510.827881,1715.759399 
	C2511.685059,1718.126343 2513.574463,1719.581055 2516.128906,1719.426880 
	C2520.352051,1719.171875 2522.512207,1716.144409 2523.709717,1712.604858 
	C2525.673340,1706.801514 2527.497803,1701.110229 2535.981445,1701.305908 
	C2538.750732,1701.264893 2540.778320,1701.344116 2543.522949,1702.052856 
	C2546.973877,1703.624756 2547.944336,1705.949097 2547.986328,1709.557007 
	C2547.678223,1711.830444 2547.122070,1713.226929 2546.105957,1715.210205 
	C2543.787109,1718.926636 2540.884766,1721.206177 2538.216309,1724.559692 
	C2537.097900,1726.174072 2536.413086,1727.283569 2535.719727,1729.140137 
	C2535.492432,1739.090698 2531.183594,1745.912964 2523.775635,1751.362427 
	C2520.528076,1753.751587 2518.359131,1757.418335 2520.788574,1761.780151 
	C2522.284668,1764.466064 2524.884766,1765.006226 2527.673584,1764.262939 
	C2532.432617,1762.994263 2535.688965,1759.603516 2534.676758,1754.901367 
	C2532.648193,1745.478149 2535.211182,1739.610229 2544.892822,1737.206055 
	C2547.212158,1736.630249 2548.537842,1734.468628 2548.961914,1731.240601 
	C2548.948242,1728.921875 2549.165527,1727.365479 2549.437500,1724.960571 
	C2551.263428,1718.247314 2555.017334,1716.713379 2561.270996,1719.468018 
	C2562.000000,1734.708496 2562.000000,1749.416992 2562.000000,1765.062744 
	C2561.286377,1766.681763 2560.553223,1767.383301 2559.643799,1767.750610 
	C2556.104980,1769.180298 2551.098877,1769.480713 2551.495850,1774.743042 
	C2551.965820,1780.972534 2557.940430,1777.229492 2561.468262,1779.555420 
	C2562.000000,1788.713745 2562.000000,1797.427612 2562.000000,1807.070679 
	C2558.024658,1812.091797 2557.845215,1816.454712 2561.533691,1821.530273 
	C2562.000000,1826.083374 2562.000000,1830.166626 2562.000000,1835.125000 
	C2557.235840,1839.908691 2553.052734,1835.067383 2547.875488,1835.041992 
	C2539.424316,1835.791016 2539.263672,1839.759644 2543.442139,1845.727173 
	C2544.289062,1846.443115 2544.620117,1846.743164 2545.426758,1847.520264 
	C2549.932129,1853.895386 2556.554443,1847.099731 2561.488281,1851.538086 
	C2562.000000,1859.385864 2562.000000,1866.771606 2562.000000,1875.078735 
	C2553.226318,1879.349365 2549.813965,1878.295044 2546.087891,1868.967773 
	C2543.577881,1862.684692 2540.205078,1859.860107 2533.441406,1860.845337 
	C2529.589355,1861.406616 2526.659180,1863.065186 2527.053223,1866.989990 
	C2528.304199,1879.443481 2521.956787,1886.997803 2511.766113,1892.419189 
	C2510.558350,1893.061768 2509.758301,1894.120239 2509.866211,1896.261353 
	C2510.441406,1900.497925 2512.066162,1903.499512 2514.912354,1906.606689 
	C2518.157715,1911.182007 2520.948242,1910.054077 2524.378174,1906.708740 
	C2525.982666,1905.959351 2526.976318,1905.694946 2528.820801,1905.478149 
	C2539.991455,1908.557739 2543.143555,1918.263550 2536.993408,1930.485962 
	C2533.260986,1933.009399 2529.953369,1934.618652 2525.898926,1936.397949 
	C2519.885498,1938.067383 2521.484375,1941.947998 2521.998535,1945.487549 
	C2522.881592,1951.565063 2521.045410,1956.165283 2514.443848,1957.193115 
	C2507.207031,1958.319824 2502.286621,1954.282959 2499.270020,1948.376831 
	C2496.312012,1942.586060 2498.941162,1938.250732 2504.516846,1935.457642 
	C2508.900635,1933.261475 2514.758057,1931.441895 2512.332031,1924.950073 
	C2510.401855,1919.784424 2505.869629,1917.691772 2499.649414,1920.683350 
	C2498.670166,1921.385498 2498.269287,1921.659180 2497.247559,1922.315552 
	C2493.284180,1924.533569 2493.297852,1927.906250 2492.540771,1931.072388 
	C2489.373779,1944.318237 2479.931885,1947.108398 2469.484863,1937.268311 
	C2468.450195,1935.793091 2467.990479,1934.872437 2467.391113,1933.172363 
	C2466.095459,1928.703247 2463.684326,1926.676147 2459.784180,1927.537842 
	C2451.987061,1929.260132 2445.959961,1927.997437 2443.375977,1919.315063 
	C2441.843262,1914.164917 2443.015137,1910.233276 2447.648682,1907.360962 
	C2454.627686,1903.034546 2461.246338,1902.101807 2467.696777,1909.661621 
	C2471.722412,1914.454956 2475.759277,1916.647461 2481.702637,1913.255005 
	C2484.327637,1911.449097 2483.820068,1909.709351 2482.500977,1907.298462 
	C2481.818359,1905.338623 2481.654541,1903.951904 2481.731934,1901.793091 
	C2482.845703,1895.723633 2486.999756,1893.454590 2491.487549,1892.348633 
	C2497.912354,1890.765503 2499.769287,1886.829468 2499.263672,1880.800293 
	C2498.674561,1873.773315 2500.403320,1867.747192 2507.872803,1863.814453 
	C2510.041748,1862.141602 2511.836426,1861.330688 2514.285645,1860.265015 
	C2518.822021,1859.076660 2519.615967,1856.888062 2517.567383,1853.548340 
	C2514.807861,1849.049438 2511.560547,1845.675903 2505.125977,1848.864136 
	C2504.184814,1849.500854 2503.800049,1849.747437 2502.815430,1850.325928 
	C2497.815674,1852.630615 2498.908203,1856.769897 2498.589355,1860.234985 
	C2498.033447,1866.283813 2494.950195,1870.109741 2489.147461,1871.674438 
	C2483.117676,1873.300537 2478.884766,1870.974487 2475.871826,1865.637939 
	C2473.813965,1861.993042 2472.281494,1857.381470 2465.942139,1858.677002 
	C2464.203369,1859.638306 2463.029541,1860.248047 2461.371094,1861.335815 
	C2458.346924,1863.660645 2456.166748,1865.723511 2458.248535,1869.787354 
	C2459.186523,1870.889648 2459.731201,1871.503540 2460.725586,1872.510620 
	C2462.134521,1873.649536 2463.207520,1874.121338 2465.085938,1874.211914 
	C2466.663330,1874.230835 2467.582275,1874.313965 2469.224365,1874.623047 
	C2479.697266,1876.832031 2480.692383,1885.167725 2481.428711,1892.526001 
	C2482.156250,1899.799194 2470.739990,1904.637451 2463.829834,1900.514404 
	C2461.782959,1899.293213 2460.531250,1897.253052 2458.614746,1894.809326 
	C2457.741943,1893.854614 2457.404053,1893.466919 2456.634277,1892.448486 
	C2454.645020,1887.834595 2452.125000,1884.756714 2447.476562,1885.530518 
	C2441.384277,1886.544556 2436.407471,1886.077026 2433.762451,1879.442871 
	C2430.724365,1871.822510 2431.616211,1865.366333 2438.962646,1859.763306 
	C2439.831787,1857.787109 2440.597900,1856.584473 2441.956055,1854.936523 
	C2446.160645,1851.200073 2445.928955,1847.499146 2443.261963,1843.934814 
	C2440.678955,1840.482788 2437.150146,1840.591675 2433.499756,1842.281372 
	C2425.372314,1846.042847 2420.295898,1843.261475 2417.392334,1834.386963 
	C2416.683105,1833.456299 2416.411865,1833.070557 2415.771484,1832.077271 
	C2412.781250,1826.088257 2407.977051,1826.270142 2403.372559,1827.327271 
	C2398.174805,1828.520630 2398.810547,1833.234253 2398.763184,1837.123535 
	C2398.689941,1843.104492 2397.277344,1848.572998 2391.920166,1851.757690 
	C2385.490234,1855.579834 2383.807617,1861.178955 2384.980225,1867.888062 
	C2386.218506,1874.975342 2384.415039,1879.564331 2376.675781,1880.801514 
	C2370.030273,1881.863770 2367.235352,1885.475220 2368.039795,1892.645996 
	C2368.729248,1898.791138 2355.657471,1910.140259 2349.945312,1908.964844 
	C2344.832031,1907.912476 2344.967041,1902.365845 2341.775391,1898.743652 
	C2337.087646,1894.799194 2332.554932,1894.530029 2327.097656,1897.009644 
	C2323.081543,1900.175537 2323.104004,1904.317139 2322.329834,1908.206055 
	C2321.320312,1913.280640 2318.089600,1916.428101 2313.134521,1917.670654 
	C2307.886963,1918.986694 2304.118896,1916.744141 2301.294922,1912.400757 
	C2299.338135,1909.390869 2298.038086,1905.564331 2293.695557,1905.128906 
	C2288.788818,1904.636841 2284.138428,1905.537231 2281.683594,1910.268188 
	C2279.753906,1913.986694 2285.068604,1923.411377 2289.778076,1924.762451 
	C2293.267334,1925.763550 2297.061523,1925.678223 2300.349609,1927.512573 
	C2304.994873,1930.103882 2308.597412,1933.520630 2307.641602,1939.379395 
	C2306.741699,1944.895386 2302.199219,1946.609375 2297.530518,1947.690308 
	C2292.403809,1948.877197 2287.751465,1947.448608 2285.963867,1942.359375 
	C2282.792236,1933.329224 2277.642822,1929.896362 2267.805420,1931.974609 
	C2262.183105,1933.162476 2256.050537,1924.770996 2254.926758,1916.590820 
	C2254.073975,1910.386841 2258.099121,1908.651978 2262.953125,1907.213257 
	C2269.734131,1905.203247 2274.135010,1901.368164 2272.145752,1893.349609 
	C2271.660645,1891.394409 2271.857910,1889.371094 2273.248047,1886.885498 
	C2275.363770,1884.112915 2277.442383,1882.395508 2279.899414,1881.337158 
	C2288.034424,1877.833130 2292.969482,1873.046997 2290.165283,1863.018433 
	C2288.913818,1858.543213 2292.040771,1854.603638 2296.416748,1852.729736 
	C2302.585938,1850.087646 2307.365967,1852.729004 2311.893555,1857.971924 
	C2312.719238,1858.906372 2313.016846,1859.302490 2313.680664,1860.333618 
	C2315.518555,1866.729614 2319.522461,1868.277466 2324.710205,1866.763672 
	C2328.947510,1865.527100 2331.613770,1862.357544 2330.885742,1857.763184 
	C2330.128662,1852.983521 2328.269775,1848.577148 2322.202393,1848.711792 
	C2314.970459,1848.872070 2310.881348,1844.888184 2307.223877,1839.066650 
	C2301.841064,1830.499756 2295.472412,1829.461060 2288.712891,1835.733887 
	C2288.298584,1836.812988 2288.115967,1837.238525 2287.643066,1838.292725 
	C2286.468750,1848.044800 2283.625000,1855.749512 2275.204102,1861.120117 
	C2270.457031,1864.147339 2269.661865,1869.749023 2271.802979,1875.304932 
	C2273.079346,1878.616943 2275.294678,1881.723633 2273.801514,1886.131592 
	C2272.792236,1887.100464 2272.240723,1887.562744 2271.603271,1887.649902 
	C2256.248779,1889.750000 2256.037109,1889.716187 2253.918457,1905.492554 
	C2253.206543,1910.792236 2249.578125,1912.874023 2245.791992,1914.672241 
	C2239.462891,1917.677612 2235.552002,1921.724731 2236.598877,1929.239014 
	C2236.825684,1930.865967 2236.366699,1932.566895 2235.791504,1934.135498 
	C2233.688477,1939.871338 2224.585693,1945.005615 2219.680908,1943.266968 
	C2215.127441,1941.653076 2209.031738,1927.648682 2211.035156,1923.354858 
	C2212.701416,1919.784302 2216.533203,1920.156860 2219.358154,1918.667358 
	C2223.474121,1916.497070 2231.093262,1916.578857 2227.305664,1907.621582 
	C2226.419434,1906.157959 2225.960693,1905.293945 2225.195801,1903.770020 
	C2222.639893,1900.258789 2219.457031,1900.521118 2216.616943,1901.207031 
	C2210.005615,1902.803955 2204.618408,1902.163574 2202.085693,1894.846802 
	C2199.605225,1887.680908 2199.478516,1881.061646 2206.853516,1876.407715 
	C2207.978271,1875.698120 2209.068359,1874.933105 2210.636719,1873.525269 
	C2212.160889,1872.567993 2213.112793,1872.195923 2214.861816,1871.827393 
	C2225.043213,1871.049927 2224.735840,1880.612671 2230.051514,1885.236328 
	C2233.030273,1886.885742 2235.578857,1887.375977 2238.945801,1887.069092 
	C2243.636719,1886.426514 2245.244385,1883.730713 2245.207520,1880.036743 
	C2245.137695,1873.044189 2248.811768,1868.223511 2254.436035,1863.655762 
	C2255.310303,1862.883423 2255.676025,1862.591919 2256.616699,1861.904419 
	C2264.209961,1856.483887 2259.539307,1850.795166 2257.842285,1845.487671 
	C2257.235352,1843.589844 2254.854248,1843.032104 2252.690186,1843.999146 
	C2247.525146,1846.307373 2242.127930,1848.308472 2240.626465,1854.771118 
	C2239.799072,1858.332520 2238.802734,1861.884644 2236.967041,1865.070435 
	C2232.103516,1873.510254 2223.774902,1874.055542 2219.188721,1865.582153 
	C2215.417480,1858.614136 2212.270752,1853.315308 2202.784180,1856.148804 
	C2197.721680,1857.660889 2194.178467,1853.921387 2192.505615,1848.875977 
	C2190.794189,1843.715210 2189.047119,1838.650879 2193.865967,1834.101807 
	C2196.296875,1831.807007 2199.136719,1830.058105 2201.816650,1828.114624 
	C2205.281006,1825.602661 2205.100830,1822.810791 2203.413330,1819.433838 
	C2201.472656,1815.549927 2198.442627,1814.250610 2194.377686,1815.288696 
	C2190.838623,1816.192627 2187.951172,1818.161865 2188.953857,1822.236816 
	C2191.331299,1831.902710 2186.145996,1837.328857 2178.639404,1841.426514 
	C2174.090088,1843.909912 2171.448242,1847.927490 2171.280762,1852.575562 
	C2170.973389,1861.118530 2166.595215,1865.983276 2158.797852,1869.553223 
	C2158.049316,1870.446533 2157.750977,1870.806641 2156.999512,1871.701904 
	C2154.032471,1875.049683 2154.870117,1878.539795 2154.692627,1881.791504 
	C2154.410645,1886.962769 2153.957031,1892.145386 2147.922607,1893.812134 
	C2141.642822,1895.546631 2135.828369,1894.668091 2132.292725,1888.413574 
	C2128.423584,1881.568848 2123.776611,1879.370483 2116.780762,1885.589355 
	C2116.034180,1886.523315 2115.735352,1886.898315 2114.980469,1887.827637 
	C2112.623291,1897.478638 2114.100098,1899.600098 2122.710938,1898.397705 
	C2128.501221,1897.589355 2133.249268,1898.289185 2136.921631,1903.109253 
	C2141.235352,1908.771362 2140.963135,1915.269653 2136.233887,1919.191284 
	C2131.299072,1923.283081 2122.341064,1923.651978 2119.190430,1918.466797 
	C2113.298828,1908.770752 2105.699463,1904.833374 2094.490723,1906.244507 
	C2090.036133,1906.805298 2086.730713,1903.120850 2083.526123,1900.089722 
	C2076.322266,1893.276001 2070.791992,1894.497803 2066.942871,1903.619263 
	C2066.041748,1905.754150 2065.462891,1908.017578 2064.340576,1910.079224 
	C2061.682617,1914.961914 2058.331055,1919.045288 2052.229980,1919.035889 
	C2048.805176,1919.030640 2046.706909,1916.529053 2046.010986,1913.455811 
	C2044.721191,1907.760010 2042.058960,1901.789673 2047.633789,1896.689087 
	C2049.355225,1895.114014 2051.304443,1893.826050 2053.041016,1892.276123 
	C2056.109863,1889.537354 2057.363770,1886.311401 2055.062744,1882.549683 
	C2052.984375,1879.151855 2049.697510,1878.872070 2046.281982,1880.008789 
	C2042.210083,1881.363770 2041.749512,1884.661987 2042.811401,1888.130249 
	C2045.142334,1895.743652 2042.473877,1900.203125 2034.893799,1902.326050 
	C2028.608765,1904.086304 2022.255493,1906.144775 2018.084839,1898.977783 
	C2014.182617,1892.271973 2014.363281,1885.652832 2020.341431,1879.918579 
	C2021.779663,1878.539062 2023.318604,1877.247559 2024.456665,1875.589966 
	C2026.452148,1872.683472 2027.348389,1869.596436 2025.634277,1866.239258 
	C2024.777466,1864.560791 2023.207886,1863.910767 2021.457275,1864.285278 
	C2017.641724,1865.101562 2014.677490,1866.995850 2013.882690,1871.185669 
	C2013.696777,1872.165527 2013.612793,1873.161743 2013.537842,1874.156494 
	C2013.188721,1878.795166 2010.666626,1881.490112 2006.116821,1882.149536 
	C2002.328003,1882.698730 1998.727661,1882.192627 1996.244873,1878.864624 
	C1993.542236,1875.241943 1993.669067,1871.378174 1996.049072,1867.686279 
	C1998.990112,1863.124268 2001.557739,1858.529419 2000.133301,1852.067871 
	C1999.956665,1850.359741 1999.956909,1849.384521 2000.144531,1847.699463 
	C2000.594727,1845.620361 2001.188721,1844.358276 2002.230225,1842.575928 
	C2003.327393,1840.981445 2004.166260,1840.021973 2005.250610,1838.498535 
	C2005.710083,1837.599365 2005.899048,1837.244141 2006.391113,1836.371338 
	C2006.920776,1835.528076 2007.147583,1835.202393 2007.756226,1834.427490 
	C2008.413452,1833.703979 2008.688599,1833.429565 2009.390869,1832.768555 
	C2010.658325,1831.622070 2011.499634,1830.863037 2012.487183,1829.467285 
	C2013.397217,1827.998901 2014.035034,1827.033325 2015.018311,1825.587524 
	C2016.082642,1824.168823 2016.925537,1823.321533 2017.751221,1821.715576 
	C2018.251587,1820.834351 2018.462280,1820.486206 2019.033203,1819.643188 
	C2020.169556,1818.212158 2021.051270,1817.366333 2022.105347,1815.873779 
	C2023.097534,1814.345703 2023.778442,1813.340210 2024.798584,1811.834717 
	C2025.876831,1810.403931 2026.700562,1809.538452 2027.588501,1807.990967 
	C2028.060181,1807.131958 2028.255249,1806.792603 2028.773682,1805.965820 
	C2030.015747,1804.254150 2031.099121,1803.149780 2032.076416,1801.262329 
	C2032.558838,1800.433350 2032.764404,1800.108887 2033.315674,1799.324951 
	C2034.364502,1797.965454 2035.143433,1797.119629 2035.930176,1795.568726 
	C2036.398438,1794.714111 2036.596191,1794.375977 2037.131592,1793.554199 
	C2038.177124,1792.130615 2039.009155,1791.279785 2039.815186,1789.674316 
	C2040.301758,1788.792358 2040.505859,1788.442993 2041.053833,1787.591187 
	C2042.116455,1786.113281 2042.990967,1785.250122 2043.819946,1783.602539 
	C2044.330078,1782.715210 2044.544922,1782.366577 2045.124268,1781.525146 
	C2047.126221,1779.261841 2048.670654,1777.430420 2049.604736,1774.493286 
	C2049.982666,1773.556763 2050.150879,1773.189087 2050.629395,1772.301270 
	C2051.865234,1770.491333 2053.049805,1769.390625 2054.031494,1767.400879 
	C2054.519043,1766.515259 2054.727539,1766.166138 2055.300049,1765.324707 
	C2057.356934,1763.030151 2058.797852,1761.068115 2059.797363,1758.076050 
	C2060.563232,1756.249023 2061.265625,1755.126343 2062.533936,1753.557251 
	C2063.708008,1752.456299 2064.483154,1751.964600 2066.001953,1751.423828 
	C2067.130371,1751.320312 2067.585449,1751.378662 2068.603271,1751.826416 
	C2070.995850,1754.156250 2072.129883,1756.650635 2074.593750,1758.931885 
	C2076.981934,1761.824829 2078.746582,1764.370850 2081.346191,1767.096924 
	C2083.629639,1770.718994 2086.224854,1769.758179 2088.776367,1768.862427 
	C2096.580078,1766.122437 2101.270020,1768.952026 2104.430664,1776.482544 
	C2106.632812,1781.729858 2109.081055,1788.956543 2117.490967,1781.636108 
	C2119.427002,1777.865845 2119.568115,1774.511475 2118.673340,1770.497559 
	C2117.866455,1768.533081 2117.238770,1767.143433 2114.840332,1766.948486 
	C2112.444824,1767.120117 2110.712646,1767.549316 2108.207031,1768.027588 
	C2096.940430,1765.365356 2095.224365,1761.038940 2099.722656,1747.008789 
	C2102.490234,1743.103760 2106.220947,1741.221924 2108.495117,1737.905640 
	C2111.656982,1733.294922 2111.639160,1728.499268 2108.576416,1723.977173 
	C2106.270020,1720.571899 2102.792480,1721.514160 2099.550537,1722.541016 
	C2094.651855,1724.092529 2092.084229,1726.750488 2092.191406,1732.612427 
	C2092.475830,1748.140015 2087.485107,1751.221069 2072.099609,1745.057129 
	C2070.621826,1743.326172 2070.295898,1741.905151 2070.466309,1739.657715 
	C2073.810791,1733.770508 2077.391846,1728.803345 2079.552246,1722.270386 
	C2079.993896,1721.187744 2080.197754,1720.767090 2080.772949,1719.755493 
	C2088.946289,1708.976929 2093.534424,1697.082397 2099.094727,1684.975586 
	C2099.403320,1683.447266 2099.617188,1682.585571 2100.061035,1681.103027 
	C2100.527100,1679.645996 2100.819824,1678.825562 2101.338135,1677.397827 
	C2101.857666,1675.983521 2102.211426,1675.202271 2102.946289,1673.901123 
	C2105.217041,1671.190063 2107.075195,1668.976074 2107.597656,1665.296387 
	C2107.976318,1663.801147 2108.278320,1662.964355 2108.953613,1661.535156 
	C2115.438965,1650.899780 2119.594238,1640.012695 2123.129883,1628.117188 
	C2123.344971,1625.963379 2123.713867,1624.573364 2124.481689,1622.543945 
	C2127.509521,1618.575806 2128.518311,1614.106079 2132.519043,1610.889282 
	C2144.156250,1606.609741 2144.448730,1605.850708 2137.326660,1598.002563 
	C2136.060303,1591.934326 2138.686523,1587.703369 2142.369141,1583.229492 
	C2145.544922,1581.796631 2148.127686,1582.484619 2150.710205,1582.666382 
	C2153.678711,1582.875366 2157.101807,1583.157104 2158.031494,1579.552246 
	C2159.092773,1575.438232 2155.857178,1573.897217 2152.608887,1572.794067 
	C2151.067383,1572.270630 2149.501221,1571.821411 2147.590332,1570.394531 
	C2144.705811,1564.390991 2147.975342,1559.703613 2149.312988,1553.949219 
	C2153.431885,1541.082153 2154.658691,1528.111816 2161.827637,1516.368408 
	C2163.800781,1517.794556 2165.177002,1519.674316 2166.456055,1521.618042 
	C2171.098633,1528.673462 2170.993896,1530.222778 2165.722412,1537.439209 
	C2164.351074,1539.316650 2162.967529,1541.218018 2161.880615,1543.262817 
	C2159.514404,1547.713745 2162.322754,1556.911011 2166.552002,1559.017944 
	C2169.357422,1560.415527 2179.354248,1557.419800 2181.097900,1554.579590 
	C2182.229492,1552.735962 2182.145020,1550.720825 2181.154053,1548.871460 
	C2180.058105,1546.826050 2178.545654,1544.991089 2177.560059,1542.901489 
	C2175.359863,1538.237183 2175.916992,1537.124390 2180.729248,1536.047485 
	C2183.626953,1535.398682 2186.603760,1534.280396 2189.467773,1534.479736 
	C2194.788574,1534.850098 2198.652832,1537.610229 2200.549561,1543.004761 
	C2202.828857,1549.486938 2207.868408,1552.432251 2214.552734,1551.921387 
	C2220.990723,1551.429199 2226.303467,1552.734375 2229.906982,1558.576050 
	C2230.336670,1559.272217 2231.651855,1559.422241 2233.278320,1559.912720 
	C2238.417480,1559.627319 2242.462891,1561.351440 2247.327148,1562.532471 
	C2249.679199,1563.828003 2251.045166,1565.245850 2253.205078,1566.838623 
	C2259.373535,1574.830078 2265.676025,1580.232422 2276.256592,1577.952881 
	C2281.267334,1576.873291 2284.006348,1580.504272 2284.535889,1585.595459 
	C2285.327637,1593.203003 2282.782959,1599.269043 2276.374268,1603.493652 
	C2272.492188,1606.052734 2269.273438,1608.670654 2272.662598,1614.469849 
	C2273.496582,1615.926514 2273.895508,1616.793213 2274.473145,1618.342529 
	C2275.659180,1622.786499 2278.353027,1623.834473 2281.532959,1622.414429 
	C2285.595215,1620.600342 2288.836182,1617.595337 2289.106445,1612.750366 
	C2289.464111,1606.337769 2290.147705,1600.130615 2295.839844,1595.014160 
	C2298.309814,1593.695557 2300.309082,1593.395996 2303.120361,1593.248535 
	C2308.875488,1593.223022 2313.071777,1594.613159 2315.588379,1600.202759 
	C2316.559570,1602.402710 2316.625488,1604.276978 2318.744873,1605.684570 
	C2320.728760,1606.848877 2322.188965,1607.679810 2323.688477,1609.448608 
	C2324.502441,1614.232300 2327.697754,1614.180054 2330.694580,1613.950317 
	C2335.518799,1613.580811 2338.697266,1615.341431 2341.152344,1619.676392 
	C2343.992188,1624.690430 2348.733887,1626.248535 2354.625244,1626.125488 
	C2366.143311,1625.885254 2366.144287,1626.189575 2369.929443,1636.712524 
	C2370.487061,1638.262817 2371.085449,1639.801147 2371.728516,1641.317993 
	C2373.430420,1645.330688 2376.728271,1647.119873 2380.538574,1645.409790 
	C2387.729004,1642.182251 2391.769775,1645.856934 2395.474854,1651.071899 
	C2395.665283,1651.339966 2395.775146,1651.665771 2395.968506,1651.931152 
	C2402.807861,1661.311279 2404.751221,1661.768921 2414.585938,1656.326538 
	C2420.604248,1652.996216 2420.979492,1653.163086 2423.986328,1661.247681 
	C2426.823486,1664.648560 2428.228516,1668.470581 2431.671875,1671.438721 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2143.497070,716.508911 
	C2151.943115,709.319763 2160.947998,705.554688 2171.482910,705.916870 
	C2174.634277,706.025208 2176.820557,703.959961 2177.042236,701.346741 
	C2177.673828,693.906128 2182.457031,693.517151 2188.100342,693.887817 
	C2189.010986,693.947632 2189.962158,693.386597 2191.447266,692.556274 
	C2194.361084,689.258911 2197.515625,687.696411 2201.342285,686.077637 
	C2203.868896,685.152954 2205.027832,683.670105 2206.063965,681.925842 
	C2212.470459,671.141235 2212.497070,671.157043 2225.220215,673.983765 
	C2227.552246,672.394592 2229.645020,672.176270 2231.392090,672.944031 
	C2239.761230,676.622070 2243.149658,672.149658 2245.517334,664.475708 
	C2248.793701,662.506042 2251.107910,660.591003 2251.935547,656.657104 
	C2254.265625,653.171204 2257.184570,652.276794 2261.336914,653.534363 
	C2264.871094,653.964478 2267.377686,652.598511 2268.432617,650.216125 
	C2272.049072,642.049927 2278.762451,641.274048 2286.318604,641.982849 
	C2287.608887,642.103943 2288.920166,642.000000 2291.110840,642.000000 
	C2295.927246,638.402344 2301.201904,636.624084 2305.384766,632.270691 
	C2311.127686,631.240417 2314.555908,627.111267 2319.223877,625.352173 
	C2322.984375,623.935059 2325.916748,623.358948 2328.805908,627.218933 
	C2331.251465,630.486023 2333.681885,635.197754 2339.059570,633.234253 
	C2344.835693,631.125122 2349.963623,627.354370 2351.553223,621.300598 
	C2352.688721,616.977478 2352.732178,612.701904 2357.851318,611.173828 
	C2363.727539,609.419617 2369.643799,608.976257 2375.301025,611.765259 
	C2378.259521,613.223877 2381.499023,614.751709 2383.627686,617.129089 
	C2388.930176,623.050903 2396.281494,625.576172 2402.612061,629.763611 
	C2404.970215,631.323364 2407.313721,631.943604 2410.056885,632.029175 
	C2413.464600,632.135376 2415.842773,630.978394 2417.025146,627.675598 
	C2418.210205,624.364685 2415.827148,622.725220 2413.780029,621.133667 
	C2411.428467,619.305603 2408.896484,617.678101 2406.312256,616.190857 
	C2404.201904,614.976501 2402.637451,613.423584 2401.647949,611.205994 
	C2399.668213,606.769287 2398.694580,602.205994 2401.706543,597.978760 
	C2403.812988,595.022705 2409.360352,595.324890 2414.599854,598.391785 
	C2417.457275,600.064270 2420.378906,601.794373 2422.789307,604.020691 
	C2425.982666,606.969727 2428.854736,608.568970 2433.419922,606.619080 
	C2437.936035,604.690002 2440.832031,607.390747 2442.809326,611.523010 
	C2444.491455,615.038940 2446.018311,619.539734 2451.486572,616.970581 
	C2455.969971,614.864197 2458.457764,607.802612 2456.665527,603.391541 
	C2455.502930,600.530518 2453.228760,598.535339 2451.434570,596.158997 
	C2448.732422,592.580017 2447.206543,588.572998 2448.391846,584.025513 
	C2448.928955,581.964844 2450.393066,580.540833 2452.627930,580.386658 
	C2454.518555,580.256226 2455.634766,581.510681 2456.417969,583.074158 
	C2456.863770,583.963623 2457.254639,584.880432 2457.674561,585.782837 
	C2462.265869,595.645569 2465.242432,596.200562 2472.450195,588.540405 
	C2472.677979,588.298157 2472.980469,588.101074 2473.137451,587.820862 
	C2479.809570,575.929138 2488.956299,570.453857 2502.793945,575.671265 
	C2506.247559,576.973389 2507.970215,573.891357 2509.391846,571.038208 
	C2512.970215,563.855896 2513.030029,563.934143 2521.212158,565.398376 
	C2523.147217,565.744751 2525.449951,566.377258 2527.078613,565.687012 
	C2533.791260,562.842590 2539.494141,565.712463 2545.021484,568.610291 
	C2549.915527,571.176086 2554.861816,572.478027 2561.159668,572.000000 
	C2562.000000,589.375122 2562.000000,606.750244 2562.000000,625.062683 
	C2559.620117,628.419067 2556.606934,628.148254 2553.611816,627.989441 
	C2544.752441,627.519531 2543.586670,625.522156 2547.897461,618.012207 
	C2548.718994,616.581177 2549.874268,615.316223 2550.254150,613.672852 
	C2550.953613,610.644775 2551.372559,607.253174 2547.718262,606.129456 
	C2543.539795,604.844482 2541.442139,607.732178 2541.134766,611.455200 
	C2540.529053,618.789978 2540.618652,626.362366 2532.790527,630.363892 
	C2527.749268,632.940613 2523.581299,636.828186 2517.899658,639.582764 
	C2510.339355,638.683838 2505.141113,640.513000 2502.817139,648.496094 
	C2491.521973,660.350952 2478.432861,655.908020 2466.774658,653.714600 
	C2464.951904,654.481995 2464.870850,654.983582 2465.469971,655.668457 
	C2467.785889,658.315063 2474.913818,658.092834 2471.935547,663.648315 
	C2469.623779,667.959534 2464.306885,666.616089 2460.040527,665.464905 
	C2458.100830,664.941589 2456.225586,664.069214 2454.726074,662.755371 
	C2448.571533,657.362976 2445.487305,658.277222 2443.875732,666.741272 
	C2442.745361,672.676758 2422.338623,682.823853 2416.215820,681.522278 
	C2411.634521,680.548401 2410.037842,676.802246 2408.397217,673.142029 
	C2406.820068,669.623169 2404.190674,668.210999 2400.403564,668.592773 
	C2397.222656,668.913452 2395.056152,669.840637 2393.767090,673.391663 
	C2389.739014,684.488281 2389.538818,684.408569 2379.778809,677.547241 
	C2378.956055,676.968750 2378.013916,676.652222 2376.419189,677.394348 
	C2376.165039,681.151917 2378.944092,681.790283 2381.868652,682.333496 
	C2388.013672,683.474976 2389.469482,687.365417 2385.191406,691.305725 
	C2380.604004,695.530823 2379.870605,700.000366 2380.360596,705.574280 
	C2380.763184,710.154236 2378.856689,714.043762 2375.206055,716.939026 
	C2373.617188,718.199097 2370.333984,719.710083 2369.943359,718.695557 
	C2366.116943,708.766235 2353.119873,716.093140 2348.499023,706.664551 
	C2346.202148,701.977966 2337.100342,705.072144 2336.005859,711.801758 
	C2334.269287,722.478821 2331.064697,731.658630 2321.979004,738.224915 
	C2319.987793,739.663879 2319.352539,742.642944 2321.476807,744.395813 
	C2324.432861,746.834839 2326.268311,743.997009 2327.868652,741.944824 
	C2329.522217,739.824402 2330.247314,737.192993 2331.289062,734.742615 
	C2333.889404,728.626160 2337.302734,723.643921 2344.933105,723.394348 
	C2351.912354,723.166138 2357.287842,725.225586 2360.323730,732.008728 
	C2363.188965,738.411255 2368.815674,737.725220 2374.085205,736.485413 
	C2379.562256,735.196838 2378.222900,730.655701 2378.014404,726.661865 
	C2377.521484,717.211731 2380.700684,713.447449 2390.177734,711.843872 
	C2399.676270,710.236694 2404.115234,712.874634 2406.726074,721.799072 
	C2407.661865,724.997375 2408.492920,728.242126 2407.680176,732.336182 
	C2407.213623,733.452637 2406.962158,733.871338 2406.151611,734.765137 
	C2397.231445,736.814026 2392.457520,740.782837 2391.687744,750.294495 
	C2391.027100,758.458069 2383.451904,763.815247 2375.687988,764.252380 
	C2367.645264,764.705322 2360.684326,760.466553 2358.135498,753.793030 
	C2357.341797,751.714417 2359.041992,747.317444 2354.489746,748.318909 
	C2350.329346,749.234253 2347.463135,752.188904 2347.440430,756.865723 
	C2347.424805,760.074646 2348.366699,762.881653 2352.117676,763.493103 
	C2354.428467,763.869873 2356.773438,763.352539 2359.101318,763.569092 
	C2365.772461,764.189819 2370.799072,767.225037 2371.735596,774.180237 
	C2372.744385,781.671448 2369.963623,788.136536 2363.447998,792.201477 
	C2357.514893,795.903137 2352.649658,792.528198 2348.213867,788.641724 
	C2345.930664,786.641418 2344.275146,784.122314 2342.922852,781.427124 
	C2341.438232,778.468506 2339.392334,776.538635 2335.818359,777.367554 
	C2327.422607,779.314758 2321.795166,775.093628 2316.930176,769.040039 
	C2315.287598,766.996094 2313.861816,764.363281 2310.763672,764.558960 
	C2308.199219,764.720886 2306.405273,766.379517 2306.098389,768.993530 
	C2305.707520,772.327942 2307.633789,774.248657 2310.778564,773.991089 
	C2320.310547,773.210266 2325.600098,778.426147 2329.283691,786.304688 
	C2330.293701,788.465149 2332.008057,790.105103 2334.157227,791.166138 
	C2337.852295,792.990417 2340.455811,795.388733 2337.959473,799.751770 
	C2335.622803,803.835510 2333.142578,807.857910 2327.170410,806.601257 
	C2316.054199,804.262268 2303.456787,805.295288 2297.629639,791.929871 
	C2296.254639,788.775818 2292.215088,788.094971 2288.915527,787.719971 
	C2280.140625,786.722778 2274.875732,782.271545 2273.645508,773.350769 
	C2273.217773,770.248596 2271.848389,767.651550 2268.526611,765.508667 
	C2265.698242,762.910950 2265.711426,759.657715 2264.169189,757.157776 
	C2262.684570,754.751221 2260.489258,752.847717 2257.692871,753.922791 
	C2254.003906,755.341064 2255.886230,758.184021 2256.915283,760.512512 
	C2257.574707,762.005432 2258.610352,763.320374 2259.363770,765.549683 
	C2259.839844,769.131958 2257.673096,771.163147 2256.950684,773.666809 
	C2254.802002,781.114441 2260.152832,787.627869 2267.746094,786.449890 
	C2272.797852,785.666321 2276.945068,786.531494 2280.564697,790.115295 
	C2281.963623,791.500549 2283.418701,793.705688 2285.469482,793.106323 
	C2293.703857,790.699280 2297.162598,795.552490 2301.305420,801.522644 
	C2307.194336,810.009033 2307.783936,809.599915 2298.144043,815.257324 
	C2306.534912,813.415100 2313.974365,818.274719 2322.257568,817.598328 
	C2330.104980,816.957520 2337.068604,818.520020 2339.771484,827.285034 
	C2342.027100,834.600525 2338.696777,841.780212 2331.074707,846.728333 
	C2323.443115,851.682739 2314.745605,851.925232 2306.103027,852.675110 
	C2294.742432,853.660828 2294.521729,854.664612 2297.720703,865.310425 
	C2299.353271,870.742737 2301.097656,874.983459 2305.807617,878.928711 
	C2312.859619,884.835999 2310.852539,896.299805 2302.629395,902.213440 
	C2299.266357,904.632080 2296.226318,906.510437 2296.333740,911.437744 
	C2296.454590,916.984131 2296.572998,920.966614 2303.897949,917.374084 
	C2309.704590,914.526123 2314.987793,915.677368 2318.507080,921.631775 
	C2322.270264,927.998779 2324.287109,934.460938 2319.207520,941.167297 
	C2316.976807,944.112549 2313.613281,946.014709 2311.550293,949.019836 
	C2308.621826,953.285645 2309.197754,957.304199 2315.036865,957.306274 
	C2323.868652,957.309448 2329.519287,961.354797 2333.276611,968.825806 
	C2334.957520,972.167969 2337.484375,973.812866 2341.274658,973.551147 
	C2351.277344,972.860291 2356.688232,978.322083 2359.486572,987.245789 
	C2360.699951,991.114990 2361.658203,995.582947 2367.335938,993.763733 
	C2370.969727,992.599487 2375.912598,991.941528 2375.271484,986.492004 
	C2374.673340,981.408264 2371.943359,977.900269 2365.981689,978.207092 
	C2358.863770,978.573242 2352.178467,977.208801 2350.090576,969.271118 
	C2347.983398,961.259460 2349.467773,953.924561 2357.511719,949.457642 
	C2361.840820,947.053467 2362.138916,943.480957 2361.171387,939.181519 
	C2360.086914,934.362549 2356.876953,932.869080 2352.407959,932.753845 
	C2347.756348,932.634033 2343.006592,932.770874 2339.406982,928.914490 
	C2333.849609,922.960510 2334.213135,912.786560 2341.660889,909.074768 
	C2350.313232,904.762329 2352.836670,899.207275 2351.724854,890.054443 
	C2350.943359,883.616577 2355.274170,879.582336 2361.643066,878.284729 
	C2363.977295,877.809204 2366.439209,877.919800 2368.032471,880.047058 
	C2369.887695,882.524109 2368.146729,884.365845 2366.559814,886.133850 
	C2365.892334,886.877563 2365.148438,887.567200 2364.628418,888.422668 
	C2362.946289,891.189392 2362.385986,894.123596 2364.520508,896.806396 
	C2366.480225,899.269775 2369.347900,898.963745 2371.886719,897.978699 
	C2377.858398,895.661804 2384.129395,894.777710 2390.378418,893.845459 
	C2396.801025,892.887390 2402.650391,894.102417 2405.341797,900.809509 
	C2407.612793,906.469177 2406.893311,912.252502 2402.328613,916.536804 
	C2397.162109,921.385864 2390.962402,921.616089 2384.710449,918.445618 
	C2381.728516,916.933533 2379.607666,914.146790 2376.600586,912.642883 
	C2374.072021,911.378235 2371.495850,910.973999 2369.104248,912.917236 
	C2367.403076,914.299744 2366.783203,916.286865 2367.326660,918.307678 
	C2368.367432,922.178406 2371.407959,920.751709 2373.918457,920.450439 
	C2382.033936,919.476501 2387.753174,923.188721 2390.476318,930.403442 
	C2393.291748,937.862000 2389.055420,943.337769 2383.050293,947.158691 
	C2378.356934,950.145081 2375.468262,953.185181 2377.286621,959.307190 
	C2379.178711,965.676514 2383.447754,966.183899 2388.942383,965.578491 
	C2394.840332,964.928589 2400.029297,966.540039 2404.312012,971.083618 
	C2409.151611,976.218018 2416.161377,975.063354 2417.769531,968.222961 
	C2421.020264,954.393799 2431.027344,948.086487 2442.839600,943.474609 
	C2447.566895,941.628906 2450.167725,939.439392 2446.022217,934.980835 
	C2442.478271,931.169678 2442.480957,928.303040 2446.632324,925.109314 
	C2450.324707,922.268677 2451.097412,918.094788 2451.707764,913.620544 
	C2453.763428,898.550293 2458.097412,884.413513 2470.170898,873.943970 
	C2471.881348,872.460571 2474.411621,871.392273 2473.905273,868.522766 
	C2473.218994,864.631958 2471.418213,860.634094 2475.422852,857.460999 
	C2482.500000,851.853699 2487.053467,843.045044 2497.995850,842.481201 
	C2508.604492,841.934509 2512.337158,845.347961 2510.055420,856.582703 
	C2512.432617,850.527893 2513.331299,845.373230 2507.276611,841.224426 
	C2503.749023,838.807312 2504.985352,836.084961 2508.033936,834.106018 
	C2510.646484,832.410217 2512.008545,829.850342 2513.794678,827.452026 
	C2518.169678,821.578186 2521.668457,816.971313 2515.315430,809.374268 
	C2512.165039,805.607056 2513.592285,798.364502 2520.552490,795.163574 
	C2524.636475,798.051697 2526.276123,802.111877 2528.828613,805.493958 
	C2529.867432,806.870361 2531.344727,807.931274 2532.887207,806.416260 
	C2534.357422,804.972107 2533.445068,803.382568 2532.306152,802.099609 
	C2529.592529,799.042725 2525.036377,799.114014 2521.744141,795.693359 
	C2524.663574,788.896851 2532.458008,786.945801 2539.908936,792.011353 
	C2545.177002,795.593140 2549.518799,799.959045 2556.601318,799.296082 
	C2558.446045,799.123474 2559.724121,801.480347 2561.494141,803.495117 
	C2562.000000,808.083313 2562.000000,812.166687 2562.000000,817.125000 
	C2560.200684,820.147461 2553.779541,821.638489 2561.498047,825.533264 
	C2562.000000,858.041809 2562.000000,890.083557 2562.000000,923.062683 
	C2557.292236,928.729065 2558.619385,933.837769 2561.527832,939.508118 
	C2562.000000,941.500000 2562.000000,943.000000 2562.000000,945.250000 
	C2552.053467,946.242493 2543.698730,951.474487 2534.768799,954.839905 
	C2531.530029,956.060486 2530.227295,959.590576 2528.500488,962.408264 
	C2525.776367,966.853027 2522.582275,969.420898 2517.058350,966.741760 
	C2515.022705,965.754456 2512.566162,965.638672 2510.304932,965.111511 
	C2501.855713,963.141174 2494.425049,967.516052 2492.045654,975.867493 
	C2490.334473,981.873230 2489.152832,982.840820 2483.286621,981.792297 
	C2480.040771,981.212158 2476.945068,979.833618 2473.747803,978.934326 
	C2466.508301,976.898010 2459.839600,977.122375 2455.135986,984.137573 
	C2453.581299,986.456421 2452.160400,988.010254 2448.725830,987.421875 
	C2442.147217,986.294922 2437.044922,990.113342 2434.444824,995.333435 
	C2432.533447,999.170532 2430.531494,1000.100403 2426.952393,1000.009583 
	C2424.290283,999.942078 2421.623047,1000.017456 2418.958984,1000.066833 
	C2416.841553,1000.106079 2414.520508,1000.634338 2414.374268,1002.971741 
	C2413.971191,1009.411438 2409.091309,1009.659058 2404.588135,1010.830872 
	C2399.066650,1012.267578 2394.238525,1014.763489 2389.931396,1018.863098 
	C2381.794434,1026.607788 2371.575928,1030.513184 2360.545898,1031.933960 
	C2352.541504,1032.965088 2351.501953,1033.988525 2352.986816,1041.960815 
	C2354.564697,1050.430542 2353.840088,1051.156372 2345.559082,1050.282593 
	C2342.600830,1049.970337 2339.578857,1050.125244 2336.593506,1050.248047 
	C2333.316895,1050.383057 2330.385498,1054.720703 2327.481934,1052.600098 
	C2325.107178,1050.865845 2324.461670,1046.883911 2322.774414,1044.062744 
	C2319.681396,1038.890991 2316.353760,1034.175781 2309.723145,1032.669922 
	C2304.329346,1031.444824 2302.781982,1025.848389 2299.985840,1021.847534 
	C2296.723633,1017.179932 2293.925537,1012.157959 2287.281250,1011.832764 
	C2285.775391,1011.759094 2284.688232,1010.785339 2284.964111,1009.284851 
	C2285.301270,1007.450684 2286.799316,1006.327515 2288.615723,1006.739807 
	C2290.528564,1007.174011 2292.313232,1008.187500 2294.140869,1008.978333 
	C2296.883057,1010.164856 2298.545654,1008.478149 2300.129395,1006.705750 
	C2301.849854,1004.780334 2302.415283,1002.602356 2300.833252,1000.351746 
	C2299.478760,998.424866 2297.616455,998.359802 2295.516113,999.187866 
	C2289.948242,1001.382935 2287.790771,998.171509 2286.078125,993.518433 
	C2282.741699,984.454041 2279.428955,975.529846 2269.215576,971.255493 
	C2265.210693,969.579529 2263.271973,965.044617 2264.946533,960.181763 
	C2266.236328,956.435913 2266.454102,952.425354 2268.569092,948.847046 
	C2272.187500,942.725830 2271.410156,940.722107 2265.143066,937.625000 
	C2264.546143,937.330139 2263.955322,936.856262 2263.333496,936.804077 
	C2254.611328,936.072205 2249.293701,931.666809 2247.918213,922.821106 
	C2247.523926,920.283264 2245.494385,919.110901 2243.559326,917.700806 
	C2239.491455,914.736145 2234.933594,912.699646 2230.621826,910.203857 
	C2225.238525,907.087646 2224.435059,903.570251 2228.339844,898.892029 
	C2231.348633,895.287109 2235.541504,892.108704 2233.689941,886.873962 
	C2231.569092,880.875549 2228.235107,875.371521 2221.791992,872.935303 
	C2215.895264,870.705750 2211.926758,866.568237 2208.695801,861.319031 
	C2205.892822,856.765442 2205.302734,852.904907 2209.852051,849.018372 
	C2212.017578,847.168457 2214.727051,845.435425 2215.205566,841.577026 
	C2213.147461,839.465393 2210.749023,840.374695 2208.149414,840.871460 
	C2199.957520,842.436584 2196.729248,840.191528 2194.014648,830.762939 
	C2190.951660,826.300354 2189.735107,821.719299 2187.971924,816.707336 
	C2188.341309,811.019348 2187.773926,806.713867 2181.652100,805.484070 
	C2179.622559,805.076294 2178.696777,803.144775 2178.151367,801.071411 
	C2175.042725,789.250366 2166.212646,780.205750 2162.287354,768.750305 
	C2162.117920,768.256226 2160.468750,768.269165 2158.754395,768.022949 
	C2152.859375,763.679504 2151.167725,756.348328 2144.455078,752.501770 
	C2140.623291,746.858826 2135.199219,742.711792 2136.001465,734.768555 
	C2138.131592,728.255554 2141.110107,722.862061 2143.497070,716.508911 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2267.293457,763.663330 
	C2272.988770,763.577881 2276.444336,764.639404 2276.139404,770.864807 
	C2276.015625,773.396179 2277.295654,775.988525 2277.887451,778.564514 
	C2278.651611,781.891174 2280.612549,783.744324 2284.103027,783.965759 
	C2285.751953,784.070374 2287.380371,784.459778 2289.027100,784.635742 
	C2295.601807,785.338257 2300.576660,788.184814 2303.212891,794.595886 
	C2305.723389,800.702026 2310.571777,802.488037 2316.918213,802.108826 
	C2320.743164,801.880249 2324.923340,800.924072 2328.307373,804.177795 
	C2329.926270,805.734497 2331.420898,804.694031 2332.325684,803.127686 
	C2333.774170,800.619934 2337.078613,799.314758 2337.105225,794.978638 
	C2329.380371,795.481506 2327.503174,789.467773 2324.812988,783.866821 
	C2321.568604,777.112549 2318.901855,776.097351 2311.299805,777.255554 
	C2305.108154,778.198914 2301.351562,774.491211 2302.085205,768.219299 
	C2302.652588,763.367371 2306.724609,761.950989 2310.237305,760.446106 
	C2313.663818,758.978088 2315.749756,761.399475 2317.204590,764.358459 
	C2317.933350,765.841187 2318.762939,767.315552 2319.783691,768.606567 
	C2324.786865,774.934143 2329.238037,776.278076 2337.065674,773.992188 
	C2338.639648,773.532532 2340.229736,773.127991 2342.441406,772.527222 
	C2344.627930,777.223267 2345.288574,782.612976 2349.294434,786.374512 
	C2354.566162,791.325012 2358.623047,792.823303 2362.344971,790.426453 
	C2367.363525,787.194397 2371.038330,777.954285 2369.305420,772.923218 
	C2367.586182,767.931396 2363.070801,765.542969 2356.327637,766.057495 
	C2355.995850,766.082825 2355.637695,766.025391 2355.335205,766.130554 
	C2350.655762,767.757935 2346.589355,768.942383 2344.875488,761.967224 
	C2342.916504,753.993774 2343.656738,750.329224 2350.124268,747.020691 
	C2353.494629,745.296448 2356.684326,742.658386 2360.747314,742.922180 
	C2361.168701,743.976807 2361.691895,744.619446 2361.602783,745.161499 
	C2359.749512,756.441711 2361.943848,759.881042 2372.259521,761.714050 
	C2380.371094,763.155334 2388.178223,757.558228 2389.809082,749.112854 
	C2389.934326,748.464050 2389.906738,747.786865 2389.971680,747.125061 
	C2391.173828,734.884277 2391.276367,734.791077 2405.157715,734.002075 
	C2408.638672,736.173828 2409.472412,739.648804 2411.772705,742.045044 
	C2414.437988,744.821960 2417.469971,745.500183 2420.535889,742.767639 
	C2422.902344,740.658386 2424.329102,737.970703 2422.799805,734.786743 
	C2420.985596,731.009949 2417.882812,730.810974 2414.388428,732.297546 
	C2412.006836,733.310791 2410.041260,735.509460 2406.539062,734.433350 
	C2406.379883,730.252869 2405.093018,726.807434 2404.252686,723.247498 
	C2403.329102,719.334778 2403.158203,714.922241 2398.099365,714.173462 
	C2392.351562,713.322876 2386.634033,714.230286 2381.957520,717.757874 
	C2378.934326,720.038025 2379.975342,723.768860 2380.647705,727.081360 
	C2382.788818,737.631042 2381.231689,739.602112 2370.924561,740.019714 
	C2364.333008,740.286804 2358.845947,740.489258 2357.052734,731.446960 
	C2355.739502,724.825745 2342.450928,723.620056 2337.625732,728.826538 
	C2335.036865,731.619995 2333.922119,735.088501 2332.786621,738.559265 
	C2331.853760,741.409912 2331.024170,744.216370 2328.657715,746.377380 
	C2325.826172,748.963135 2322.901611,751.579041 2319.145996,748.657898 
	C2315.644775,745.934265 2315.701904,739.223450 2318.943359,736.224670 
	C2320.388184,734.888123 2322.300781,734.072327 2323.859863,732.841492 
	C2329.082520,728.718201 2332.437744,723.676758 2332.051270,716.622375 
	C2331.872559,713.358276 2331.616699,710.041016 2334.006592,707.112122 
	C2341.351562,698.110291 2347.599121,698.513367 2353.350098,708.502441 
	C2353.835693,709.345886 2354.537109,710.065247 2355.116943,710.814697 
	C2366.260254,705.916077 2368.933594,707.055298 2369.279541,716.734741 
	C2377.180908,713.557983 2379.693604,710.571228 2377.572510,702.990295 
	C2375.780029,696.585205 2376.677002,692.805115 2382.895996,690.427246 
	C2384.469238,689.825623 2385.960449,688.648315 2385.506836,686.698303 
	C2384.780029,683.570374 2382.579102,685.024475 2380.772705,685.463135 
	C2376.718018,686.447754 2374.329590,684.058533 2372.853516,680.949646 
	C2371.569824,678.245850 2370.918945,674.847290 2373.894287,672.816956 
	C2376.353516,671.138977 2378.935547,672.402344 2381.172607,674.235779 
	C2383.688232,676.297180 2386.361816,678.165344 2389.095459,680.213928 
	C2390.777344,678.027710 2391.959717,674.925049 2390.716797,671.059998 
	C2389.575439,667.510986 2391.509033,666.156311 2394.787354,666.054138 
	C2396.119385,666.012634 2397.459229,666.084045 2398.783691,665.969116 
	C2408.225586,665.150330 2408.224609,665.139221 2411.738770,673.987305 
	C2414.219482,680.233337 2414.856445,680.521606 2421.291748,678.468323 
	C2427.555176,676.469910 2432.374268,671.557922 2439.042969,670.132446 
	C2442.656006,669.360229 2441.937500,665.374268 2441.990234,662.429810 
	C2442.044922,659.387329 2441.910156,656.149109 2445.260986,654.704163 
	C2448.737061,653.205017 2450.860596,655.836304 2452.933350,657.966736 
	C2457.921875,663.093933 2463.610352,665.333069 2471.562500,662.941895 
	C2469.249512,658.887573 2465.116943,660.301025 2462.681641,658.381409 
	C2460.862061,656.947388 2458.102051,656.089783 2458.933105,653.261047 
	C2459.843506,650.161072 2462.766602,649.662537 2465.508789,650.324768 
	C2468.739014,651.104980 2472.197510,651.313293 2475.200928,652.377502 
	C2484.600586,655.708191 2492.770752,653.659363 2501.268066,648.088867 
	C2507.892578,647.199463 2512.992188,645.260681 2515.513428,638.461548 
	C2521.742676,634.341309 2526.947021,629.890198 2533.287842,627.089417 
	C2536.441162,625.696411 2538.082275,622.668335 2537.991455,618.957275 
	C2537.918701,615.978943 2537.857910,612.987427 2538.049072,610.018311 
	C2538.395264,604.642761 2541.547607,601.955322 2547.101074,602.055481 
	C2551.960449,602.143127 2553.200928,604.068237 2554.096191,609.651917 
	C2555.169189,616.344971 2550.809570,619.722900 2545.065186,624.223999 
	C2551.339355,624.946411 2555.904053,625.471985 2561.234375,625.998779 
	C2562.000000,638.708801 2562.000000,651.417603 2562.000000,665.063232 
	C2556.286133,670.869019 2549.301270,667.642822 2542.675049,669.109497 
	C2550.430420,669.516052 2553.892090,674.285522 2555.225586,680.863586 
	C2556.159424,685.470154 2557.307861,689.804810 2561.504639,693.508301 
	C2562.000000,697.428711 2562.000000,700.857422 2562.000000,705.143066 
	C2557.946777,711.266174 2552.870117,713.952881 2546.360107,711.109619 
	C2540.683105,708.629944 2538.954346,703.577393 2539.844238,697.841797 
	C2541.274902,688.618896 2533.064697,687.885498 2528.160400,683.669067 
	C2528.844971,690.135559 2527.869141,695.669983 2524.663330,701.055603 
	C2521.297363,706.710022 2523.235596,712.046753 2527.782959,716.346924 
	C2531.529541,719.889709 2534.176758,723.973206 2535.283447,729.016663 
	C2536.518555,734.646362 2535.019043,739.347229 2529.190186,740.856262 
	C2523.945801,742.214050 2519.353516,739.220154 2518.548340,734.236389 
	C2517.307129,726.555115 2513.375488,722.702820 2506.239746,720.590027 
	C2502.403320,719.454102 2499.021729,716.570312 2498.998047,711.975220 
	C2498.976318,707.807739 2502.048096,705.568665 2505.560303,704.002197 
	C2507.100586,703.315308 2508.564941,702.565674 2509.779053,700.167175 
	C2507.594971,701.973206 2506.033936,703.291321 2504.099365,704.115417 
	C2495.441650,707.803467 2493.335449,706.720886 2488.772705,695.886230 
	C2488.255127,694.657471 2488.886719,696.359680 2488.067627,695.334839 
	C2487.808105,695.010193 2486.882324,695.619873 2485.936035,696.641357 
	C2481.618896,698.753540 2477.978027,697.045898 2473.604736,696.529846 
	C2470.596680,696.302368 2468.626709,697.055115 2469.345703,699.701233 
	C2471.252441,706.718689 2469.051270,714.205811 2472.804932,721.159668 
	C2475.807617,726.722412 2473.941650,732.124146 2467.586182,736.186157 
	C2472.078857,737.183594 2473.965820,740.782959 2476.941895,743.903259 
	C2478.841309,737.108826 2481.449707,730.978210 2489.481934,732.354126 
	C2496.620605,733.576965 2500.166016,738.844543 2500.278564,745.970215 
	C2500.400879,753.717957 2505.917969,759.329651 2508.053467,766.399414 
	C2507.121582,762.567200 2505.209961,758.834290 2507.599609,754.977234 
	C2509.932617,751.212158 2513.855225,750.589783 2517.632568,749.191772 
	C2525.341797,746.338562 2531.870605,741.062073 2539.552979,737.926392 
	C2545.587158,735.463318 2548.850342,736.665039 2550.907959,742.881836 
	C2554.650146,754.187744 2552.585449,760.315125 2543.389404,764.432007 
	C2549.005127,763.900940 2552.760010,766.934448 2553.685303,772.369629 
	C2554.512939,777.231262 2557.736572,776.738037 2561.455322,777.558838 
	C2562.000000,786.049072 2562.000000,794.098206 2562.000000,803.073608 
	C2561.343750,803.892944 2560.552734,803.985352 2560.051758,803.647766 
	C2554.966797,800.218628 2549.957520,797.095520 2546.268311,807.026489 
	C2543.103027,801.150940 2544.954346,794.741577 2538.073242,793.619080 
	C2532.652100,792.734863 2527.364746,789.622437 2522.174805,795.245300 
	C2512.851074,803.529663 2514.432373,810.510376 2527.307617,817.539978 
	C2525.703613,820.581543 2522.185059,821.315552 2519.977783,823.478577 
	C2518.641846,824.787659 2516.005615,825.146973 2516.192627,827.530212 
	C2516.708496,834.113770 2512.538574,836.162170 2506.994141,836.832520 
	C2508.061768,841.651794 2512.418945,838.881409 2514.383789,840.994141 
	C2514.610107,841.492432 2515.172852,842.117981 2515.084717,842.631897 
	C2513.967529,849.151855 2512.842529,855.673401 2511.509521,862.151428 
	C2511.179443,863.756042 2510.019531,865.418030 2508.009033,864.932434 
	C2505.794922,864.397705 2506.281250,862.490723 2506.667236,860.889221 
	C2507.366211,857.988586 2508.333252,855.139404 2508.839355,852.208496 
	C2509.609375,847.746033 2506.660889,843.931885 2502.470215,844.405396 
	C2498.225342,844.885071 2494.010986,845.982788 2489.902344,847.208496 
	C2486.963623,848.085144 2484.445312,849.869202 2484.077393,853.360718 
	C2483.799316,856.001221 2482.419434,857.088379 2479.883057,858.104309 
	C2473.369141,860.713196 2473.436279,861.037231 2476.825195,867.373535 
	C2477.586670,868.797485 2478.566895,870.104370 2480.017578,872.348755 
	C2473.365234,874.142883 2467.768311,876.593994 2467.123779,884.220581 
	C2467.030762,885.322083 2463.845215,886.039978 2462.245850,887.157410 
	C2454.875977,892.305969 2455.033203,894.660706 2462.981689,899.497437 
	C2462.965088,902.392822 2460.210449,901.848022 2458.703613,902.822388 
	C2455.303955,905.020386 2453.248535,908.072632 2454.150879,912.053650 
	C2456.092041,920.617432 2452.193848,926.008362 2445.182861,929.805176 
	C2445.691895,932.607727 2448.438477,931.930542 2449.819092,933.258972 
	C2452.343994,935.688171 2452.247559,938.625366 2451.633301,941.606873 
	C2450.994873,944.703674 2448.641846,945.730530 2445.722412,945.944153 
	C2436.378662,946.627808 2430.183350,952.805298 2424.312500,958.987244 
	C2420.283447,963.229736 2419.756592,968.968811 2421.104248,974.400085 
	C2419.389648,976.221375 2417.795410,975.605835 2416.205078,975.122009 
	C2413.707764,974.362183 2412.265381,974.888000 2412.973633,977.872314 
	C2413.387207,979.614258 2413.582764,981.249939 2411.224854,981.624451 
	C2409.824951,981.846863 2408.559326,981.327820 2407.668457,980.254700 
	C2406.825928,979.240112 2406.031494,978.140259 2405.448242,976.962830 
	C2401.141357,968.271790 2393.765381,966.104614 2385.306641,968.769531 
	C2379.983643,970.446594 2378.039307,968.368774 2376.098877,964.323975 
	C2374.777344,961.568970 2374.594238,958.493835 2373.507080,955.798706 
	C2371.622803,951.128235 2373.642090,949.068176 2377.451416,947.242798 
	C2381.299316,945.399048 2385.209473,943.809875 2387.432129,939.455566 
	C2389.491943,935.419922 2389.867432,931.931091 2387.010498,928.408569 
	C2383.974854,924.665527 2380.414307,921.778137 2375.120361,922.591187 
	C2374.477783,922.689880 2373.880615,923.258789 2373.255859,923.270630 
	C2370.283936,923.326782 2366.455566,927.700012 2364.613525,923.273621 
	C2363.074219,919.575500 2362.766846,914.649414 2365.511475,910.810242 
	C2367.635010,907.839539 2374.173096,906.892639 2377.535156,909.151733 
	C2380.266113,910.986755 2382.340820,913.770752 2384.975586,915.781677 
	C2390.906982,920.308655 2400.177734,918.319336 2402.876465,911.899170 
	C2404.605713,907.785278 2404.962402,903.460327 2402.218506,899.509888 
	C2399.519043,895.623291 2395.112549,894.978271 2391.448242,896.323059 
	C2385.809570,898.392578 2379.640869,897.001465 2374.144775,900.344849 
	C2368.617188,903.707520 2362.652832,902.394470 2360.766846,898.777405 
	C2358.279297,894.007874 2360.517822,887.055969 2365.579590,883.695923 
	C2366.077637,883.365234 2366.403564,882.775513 2366.808594,882.305298 
	C2360.331543,879.345947 2354.922363,881.641052 2354.141113,887.951843 
	C2353.736572,891.217896 2353.583496,894.623962 2354.946777,897.816284 
	C2357.012939,902.653931 2354.349609,905.424744 2350.532227,907.474365 
	C2348.500488,908.565247 2346.093262,908.960815 2344.071533,910.065430 
	C2338.577393,913.067078 2336.923584,916.931580 2338.455566,922.463562 
	C2339.955078,927.878784 2342.374512,929.675110 2348.597168,929.993164 
	C2362.539307,930.705750 2362.206299,930.779602 2365.059570,943.646179 
	C2366.085938,948.273621 2364.413574,949.528076 2360.795898,950.745544 
	C2354.288574,952.935486 2351.439941,957.388062 2351.900635,964.486084 
	C2352.453125,972.998840 2356.780273,976.899231 2365.557129,975.739746 
	C2368.305176,975.376709 2371.441162,972.427490 2373.652832,976.057922 
	C2376.213135,980.260193 2379.307861,984.368896 2379.567139,989.583191 
	C2379.609375,990.433716 2378.989258,991.810364 2378.301025,992.125061 
	C2373.226807,994.445618 2368.470703,997.735291 2362.618652,997.895752 
	C2359.869141,997.971191 2358.337891,996.618896 2358.055908,993.756348 
	C2357.862305,991.789551 2357.479004,989.810486 2356.914551,987.916138 
	C2353.871338,977.703613 2349.825684,974.812073 2339.345459,976.693970 
	C2335.157227,977.446106 2333.521240,976.632141 2331.847900,972.817200 
	C2326.074707,959.654541 2323.993408,958.722717 2309.606934,961.069885 
	C2307.624756,959.506104 2307.424805,957.018005 2306.656738,954.889709 
	C2305.400879,951.409973 2306.140869,948.435364 2309.509766,946.245239 
	C2311.721436,944.807373 2313.828125,943.115479 2315.686523,941.244141 
	C2321.575439,935.315063 2320.595215,924.204224 2313.821289,919.330566 
	C2311.033691,917.325134 2308.202637,918.084167 2305.317627,919.355347 
	C2301.983643,920.824585 2299.000244,923.152161 2295.265869,923.628845 
	C2294.705078,923.700378 2294.072510,923.209595 2292.712402,922.686218 
	C2293.524658,917.797241 2294.729736,912.692871 2292.977783,907.459106 
	C2291.635742,903.449585 2295.291016,902.857422 2298.095459,901.646790 
	C2306.870361,897.858582 2309.306641,891.841614 2306.169678,883.397766 
	C2305.156738,880.671204 2303.846436,878.833618 2300.971436,877.944824 
	C2298.220703,877.094421 2295.210938,876.632568 2292.994141,874.431274 
	C2297.305908,869.998657 2297.305908,869.998657 2294.240234,864.443176 
	C2289.003906,854.953979 2291.416992,850.690491 2302.343262,849.994812 
	C2310.812744,849.455688 2319.507324,849.936340 2327.334473,845.849670 
	C2333.046143,842.867371 2338.205322,839.262451 2337.998779,831.664734 
	C2337.800049,824.352844 2334.430908,820.565247 2327.119629,820.090942 
	C2324.497070,819.920837 2321.825195,820.340576 2319.190430,820.624695 
	C2318.220703,820.729248 2317.282227,821.191162 2316.347168,821.537537 
	C2311.828857,823.210938 2310.508789,815.944458 2307.194336,817.559204 
	C2304.042236,819.094849 2301.199951,820.417725 2297.844238,819.815002 
	C2292.973145,818.940125 2293.677490,814.723999 2292.790771,811.562439 
	C2296.597412,808.594238 2301.143066,811.304504 2304.616943,808.961731 
	C2304.968262,805.570496 2302.396973,806.190002 2300.640137,806.022156 
	C2297.899902,805.760315 2296.113281,805.059692 2297.091064,801.714783 
	C2298.182617,797.979309 2295.563721,796.111816 2292.871582,794.752808 
	C2289.899658,793.252319 2287.862061,795.128296 2286.183105,797.442932 
	C2285.607422,798.236572 2285.063721,799.157593 2282.356689,798.419983 
	C2281.487061,798.124023 2281.976074,795.600525 2280.826660,794.065430 
	C2276.279785,787.993896 2273.545166,787.147339 2266.370605,789.832397 
	C2259.896484,792.255310 2259.896729,792.255310 2257.036133,786.169128 
	C2256.610840,785.264160 2256.179199,784.362305 2255.751221,783.458801 
	C2251.430664,774.339539 2251.430664,774.339478 2257.883057,766.688110 
	C2260.351318,763.466797 2263.294678,762.836304 2267.293457,763.663330 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2211.566895,1873.453125 
	C2211.911377,1877.745361 2208.485352,1878.279419 2206.288086,1880.058350 
	C2202.072510,1883.470825 2202.923340,1896.321655 2207.478760,1899.095337 
	C2209.656738,1900.421387 2211.823242,1899.514526 2214.082764,1899.041870 
	C2218.705811,1898.075073 2223.556396,1896.075684 2227.824219,1901.243896 
	C2226.000244,1904.240234 2223.257080,1903.947021 2220.654541,1904.190796 
	C2217.683105,1904.468872 2215.615234,1905.890015 2215.480957,1909.079956 
	C2215.391357,1911.205566 2216.329102,1913.032959 2218.469727,1913.701782 
	C2221.119141,1914.529541 2222.834229,1912.969360 2224.203369,1910.930420 
	C2225.121582,1909.563599 2225.810547,1908.047974 2227.445068,1906.392700 
	C2233.031006,1910.143555 2233.455566,1914.336548 2228.702637,1917.443237 
	C2225.418945,1919.589600 2221.855713,1921.331665 2217.775879,1922.052612 
	C2211.391602,1923.180664 2211.294434,1923.688110 2213.910645,1929.761719 
	C2214.567383,1931.286255 2215.128662,1932.944824 2216.153809,1934.198120 
	C2218.202637,1936.702515 2216.834473,1942.389893 2222.544434,1941.489014 
	C2229.033447,1940.465576 2233.662354,1935.652222 2233.976562,1929.850098 
	C2234.084473,1927.860352 2234.117432,1925.853027 2233.985840,1923.866943 
	C2233.706787,1919.660522 2235.593018,1917.015503 2239.366699,1915.274292 
	C2241.757812,1914.171143 2243.751221,1912.082520 2246.199707,1911.253906 
	C2250.787354,1909.701782 2251.443848,1907.610352 2250.971436,1902.505981 
	C2249.958008,1891.555176 2254.468750,1885.733398 2262.684814,1884.955811 
	C2265.872314,1884.654175 2269.179199,1885.612793 2273.215820,1885.998657 
	C2274.199219,1888.307007 2274.175293,1890.660034 2274.637451,1892.913086 
	C2276.469727,1901.845215 2272.504395,1907.920044 2263.323975,1909.983887 
	C2255.748291,1911.686768 2255.452148,1912.219360 2258.473145,1918.974121 
	C2259.151367,1920.490601 2259.961670,1921.947632 2260.672363,1923.450195 
	C2264.066895,1930.628784 2264.062012,1930.631104 2271.771973,1929.082031 
	C2279.867920,1927.455444 2282.324463,1928.645630 2285.990723,1936.007690 
	C2286.583008,1937.197388 2287.289551,1938.376953 2287.611084,1939.645386 
	C2288.387695,1942.708618 2289.451660,1945.715210 2293.124268,1945.734741 
	C2297.468506,1945.757812 2302.004395,1944.936523 2304.811279,1941.374634 
	C2307.157715,1938.396851 2306.036377,1935.015991 2303.297607,1932.453735 
	C2300.002930,1929.371216 2296.068604,1928.216064 2291.531006,1927.884888 
	C2284.510010,1927.372925 2277.081299,1916.879395 2278.057617,1909.873901 
	C2278.443604,1907.105103 2280.311279,1906.031494 2282.334961,1904.838013 
	C2290.048828,1900.289185 2299.359619,1900.573120 2302.591797,1909.114990 
	C2304.185303,1913.325439 2306.524658,1916.979248 2312.152588,1915.648804 
	C2317.278809,1914.436768 2319.030762,1912.047119 2320.046143,1904.790039 
	C2320.590576,1900.899536 2320.967041,1896.895020 2325.274902,1894.144409 
	C2326.492920,1894.459839 2326.894043,1894.982666 2327.171875,1895.583130 
	C2328.817139,1899.139160 2325.964355,1905.265381 2332.254395,1906.063721 
	C2338.673584,1906.878296 2338.660156,1900.549072 2341.477539,1896.436035 
	C2348.061035,1897.180176 2346.081543,1903.678711 2349.622070,1907.281616 
	C2354.720947,1905.825439 2358.148193,1900.702271 2363.694824,1899.456055 
	C2366.546143,1898.815186 2366.009033,1895.759277 2365.886719,1893.509644 
	C2365.252930,1881.863647 2366.422119,1880.154297 2376.794678,1878.010498 
	C2383.131836,1876.700684 2383.160156,1876.697021 2382.240479,1869.675049 
	C2381.141602,1861.289062 2381.847900,1853.801758 2390.745117,1849.529419 
	C2396.165283,1846.926758 2396.315430,1841.809204 2396.001709,1836.668945 
	C2395.682617,1831.444092 2396.171387,1826.522217 2402.002197,1824.395264 
	C2407.925781,1822.234741 2413.519287,1824.495850 2417.905762,1831.259766 
	C2415.545166,1834.331299 2413.032227,1832.581177 2410.554688,1832.078857 
	C2407.162842,1831.390869 2404.596924,1832.268677 2403.651123,1835.852783 
	C2402.984619,1838.377563 2403.888428,1840.564331 2406.227783,1841.686768 
	C2409.442871,1843.229492 2411.991211,1841.918213 2413.866699,1839.135376 
	C2415.157715,1837.219849 2415.495850,1834.792725 2417.531738,1832.505859 
	C2418.999512,1832.842773 2420.387207,1833.486694 2420.936279,1834.559937 
	C2425.040039,1842.578247 2425.109375,1842.882935 2432.594971,1839.616211 
	C2437.492432,1837.479004 2441.639160,1837.697510 2445.311768,1841.451904 
	C2448.763428,1844.981079 2448.676758,1849.731445 2444.739746,1855.835449 
	C2442.369629,1854.706421 2441.830811,1852.810669 2441.176025,1850.963135 
	C2440.392822,1848.752930 2439.472412,1846.515503 2436.571533,1846.739380 
	C2434.437256,1846.904175 2432.960449,1848.253540 2432.397217,1850.308838 
	C2431.559082,1853.365601 2433.163574,1855.273804 2435.717529,1856.594238 
	C2437.448242,1857.488892 2439.453125,1857.804321 2441.502197,1859.541992 
	C2441.463623,1861.172729 2441.191895,1862.609375 2440.338135,1863.465576 
	C2438.325439,1865.484253 2434.093506,1865.770386 2434.322754,1869.410278 
	C2434.568115,1873.303833 2435.435303,1877.342773 2436.962891,1880.920532 
	C2438.581055,1884.710938 2442.147461,1883.904785 2445.621582,1883.223145 
	C2452.943115,1881.786743 2454.942871,1883.131958 2457.986328,1891.244141 
	C2455.045166,1893.736694 2452.303223,1891.576294 2449.443604,1891.524658 
	C2446.455566,1891.470703 2444.353760,1892.625366 2443.699707,1895.681519 
	C2443.249512,1897.785767 2443.942383,1899.654297 2445.736572,1900.803101 
	C2448.384766,1902.498901 2450.725098,1901.461792 2452.806885,1899.533691 
	C2454.778076,1897.708130 2455.292236,1894.946045 2457.500977,1892.474365 
	C2460.731689,1892.072388 2462.041992,1893.938232 2463.046875,1896.098755 
	C2464.756592,1899.775513 2467.463135,1900.336182 2471.195801,1899.359985 
	C2479.764160,1897.119019 2480.864502,1895.308350 2477.565186,1887.112793 
	C2475.850342,1882.852783 2475.956299,1876.894897 2468.492920,1876.535400 
	C2469.643311,1869.851318 2473.007324,1863.369995 2464.369873,1858.568726 
	C2464.296143,1855.157104 2465.737305,1853.737671 2468.658936,1854.514404 
	C2473.620850,1855.833618 2476.277344,1859.523438 2478.003418,1864.027588 
	C2479.787109,1868.680786 2482.768555,1870.981201 2487.954834,1869.689941 
	C2493.350586,1868.346313 2495.487305,1865.766235 2496.013916,1860.030518 
	C2496.410156,1855.716187 2494.218506,1850.352905 2501.234131,1848.111328 
	C2504.971924,1852.708008 2501.027344,1860.746826 2509.599854,1863.475220 
	C2509.937988,1864.321533 2509.987793,1864.747559 2509.798096,1864.949463 
	C2502.513672,1872.715210 2502.259277,1872.709351 2502.114502,1884.728027 
	C2502.052734,1889.855591 2500.030762,1892.336548 2495.385498,1894.024658 
	C2491.356689,1895.488892 2485.861816,1894.907349 2484.093018,1901.275146 
	C2479.381836,1905.595825 2472.210938,1905.104980 2468.593750,1911.626709 
	C2467.061523,1911.701294 2465.832764,1911.679565 2465.236572,1911.054321 
	C2462.979248,1908.687500 2461.280273,1905.482422 2457.239502,1906.150635 
	C2453.222656,1906.814819 2449.787354,1908.925659 2446.452881,1911.062988 
	C2443.436035,1912.996704 2444.981201,1915.691406 2445.799316,1918.190308 
	C2446.925049,1921.628052 2447.464600,1925.646729 2452.235352,1925.841675 
	C2454.164551,1925.920654 2456.215576,1925.550293 2458.051514,1924.919434 
	C2463.916504,1922.904175 2467.665771,1924.972900 2469.910645,1931.272705 
	C2462.634277,1932.285156 2454.930908,1931.843384 2450.842041,1940.797852 
	C2445.787109,1942.667847 2441.986816,1938.572388 2437.624756,1939.720215 
	C2435.271729,1940.339233 2432.920654,1941.160034 2432.910400,1943.965698 
	C2432.899414,1946.946289 2435.259766,1947.617310 2437.761963,1947.650391 
	C2442.211670,1947.708984 2446.415527,1947.183594 2449.168945,1942.051758 
	C2456.278809,1940.876953 2464.364746,1946.034912 2469.408691,1936.373535 
	C2471.167236,1936.518311 2472.735840,1936.724487 2473.427002,1937.612915 
	C2475.552979,1940.346069 2477.553223,1942.915771 2481.533691,1941.129761 
	C2485.849609,1939.193481 2489.851807,1936.970703 2489.970459,1931.375977 
	C2490.061035,1927.093140 2489.943115,1922.706299 2495.272461,1920.137207 
	C2497.834961,1921.648804 2498.294434,1923.900391 2498.761963,1926.171143 
	C2499.364014,1929.095703 2500.858398,1931.029541 2504.193115,1930.428711 
	C2505.533936,1930.187012 2506.767578,1929.355957 2507.037598,1928.010010 
	C2507.751221,1924.450195 2504.923340,1923.669556 2502.491211,1922.698608 
	C2501.270264,1922.211182 2500.025146,1921.794312 2498.456055,1920.537842 
	C2502.084229,1915.050049 2507.319824,1915.008179 2512.719971,1919.882202 
	C2517.089600,1923.826050 2517.240723,1929.888550 2512.972900,1933.876465 
	C2510.487305,1936.198975 2507.325928,1937.247925 2504.154053,1938.315552 
	C2500.192871,1939.648804 2499.432373,1942.798950 2500.514404,1946.357544 
	C2502.114990,1951.620850 2509.829346,1955.897949 2514.678467,1954.749268 
	C2519.130615,1953.694702 2520.681396,1951.043457 2519.782471,1946.763916 
	C2518.813232,1942.147461 2515.323975,1937.028442 2523.257812,1934.104736 
	C2525.613525,1935.507812 2525.382568,1937.512207 2525.541748,1939.441650 
	C2525.818848,1942.789307 2526.276123,1946.709473 2530.832520,1945.716675 
	C2534.805420,1944.851074 2534.803223,1941.116211 2534.057617,1937.712524 
	C2533.577637,1935.521729 2532.358887,1933.447144 2533.557617,1930.544189 
	C2536.601318,1928.750122 2538.247803,1926.670898 2537.888916,1923.798950 
	C2537.326904,1919.300293 2536.579590,1914.791504 2535.437988,1910.410156 
	C2534.704346,1907.594482 2531.834473,1908.194458 2528.811035,1908.000977 
	C2527.312256,1907.294312 2526.586426,1906.563965 2526.296387,1905.637817 
	C2521.938721,1891.718384 2521.947754,1891.715576 2508.637695,1898.257812 
	C2505.238037,1895.707153 2505.765137,1893.251587 2508.155029,1891.313721 
	C2510.712646,1889.239624 2513.479492,1887.264771 2516.454590,1885.898682 
	C2522.044922,1883.331665 2524.298584,1879.129150 2524.018066,1873.194458 
	C2523.908447,1870.876831 2523.875244,1868.531982 2524.094971,1866.226929 
	C2524.572021,1861.218628 2527.432129,1858.298340 2532.460938,1858.093628 
	C2544.131104,1857.618164 2545.302734,1858.016846 2548.043701,1867.425171 
	C2549.911133,1873.834717 2553.576172,1877.003784 2561.187500,1876.000000 
	C2562.000000,1876.888916 2562.000000,1877.777832 2562.000000,1879.333374 
	C2558.228271,1882.812134 2556.876953,1887.056519 2554.963379,1891.757080 
	C2550.768799,1894.666870 2547.673584,1892.181396 2544.367188,1890.906860 
	C2541.093994,1889.645020 2536.745361,1886.959229 2534.889648,1891.431274 
	C2533.064453,1895.829468 2536.307861,1899.561768 2540.614990,1901.506104 
	C2543.637939,1902.870605 2548.355469,1901.281860 2548.894775,1907.208374 
	C2548.034912,1908.999634 2546.995361,1909.785278 2546.015137,1910.638916 
	C2543.425781,1912.894287 2542.359619,1915.816895 2545.246582,1918.112183 
	C2548.855469,1920.981323 2550.233887,1917.507202 2551.575928,1914.884766 
	C2552.020264,1914.016602 2552.424805,1913.128906 2553.472168,1911.816895 
	C2557.652832,1909.944580 2559.351562,1912.380981 2561.496094,1915.464844 
	C2562.000000,1918.777832 2562.000000,1921.555542 2562.000000,1925.166748 
	C2561.268311,1926.676514 2560.508057,1927.629395 2559.600342,1927.702637 
	C2548.997559,1928.559570 2543.360840,1933.642456 2543.819336,1944.875732 
	C2543.950928,1948.098633 2542.366699,1951.597656 2539.775146,1953.739746 
	C2532.064209,1960.114136 2533.325928,1966.704712 2538.970703,1974.297119 
	C2539.986084,1977.255371 2539.401367,1979.438354 2538.643066,1981.625610 
	C2537.656250,1984.473389 2536.646484,1987.612549 2539.938965,1989.476440 
	C2543.906494,1991.722046 2545.779053,1988.422607 2547.722900,1985.793823 
	C2548.305908,1985.005249 2548.929199,1984.256348 2550.336182,1983.299561 
	C2556.508545,1983.396240 2557.606201,1987.054932 2557.163574,1992.318359 
	C2545.219482,2003.760254 2534.842529,2002.122070 2526.889160,1988.067261 
	C2525.293945,1985.248169 2523.522217,1984.013550 2520.509277,1985.347046 
	C2518.086426,1986.419556 2515.250732,1987.497192 2515.205811,1990.649414 
	C2515.162354,1993.701294 2517.584717,1996.363892 2520.161133,1995.887085 
	C2530.509033,1993.971680 2535.768799,2000.927979 2542.043945,2006.896118 
	C2548.168213,2012.721069 2551.931396,2011.218018 2553.224121,2003.062378 
	C2553.688965,2000.130005 2553.351562,1997.025513 2555.995117,1994.027344 
	C2557.856445,1992.572876 2559.287354,1992.539307 2561.388184,1993.543701 
	C2562.000000,2000.722534 2562.000000,2007.445190 2562.000000,2015.083862 
	C2559.984863,2018.304810 2557.270508,2019.429810 2554.505127,2020.494751 
	C2550.207275,2022.149536 2546.963623,2024.794434 2547.434326,2029.880859 
	C2547.946289,2035.416260 2552.644043,2034.811646 2556.382568,2035.450317 
	C2558.010254,2035.728394 2559.592285,2036.071533 2561.477051,2037.535156 
	C2562.000000,2039.500000 2562.000000,2041.000000 2562.000000,2043.250000 
	C2555.266357,2047.898193 2553.934814,2052.187500 2561.525879,2057.544434 
	C2562.000000,2059.500000 2562.000000,2061.000000 2562.000000,2063.250000 
	C2558.045166,2068.104492 2555.967285,2072.342285 2561.535645,2077.544922 
	C2562.000000,2082.741211 2562.000000,2087.482178 2562.000000,2093.111816 
	C2559.554443,2096.300537 2557.105469,2094.664307 2554.681885,2093.973389 
	C2550.743652,2092.850586 2546.426270,2091.932129 2544.321045,2096.376465 
	C2542.060059,2101.150391 2545.239258,2104.355469 2549.208252,2106.674072 
	C2550.614014,2107.495361 2552.208496,2107.966309 2554.091309,2109.369141 
	C2556.068115,2115.967773 2550.545898,2116.873779 2546.708496,2119.777344 
	C2541.907715,2120.205322 2539.691406,2115.439209 2534.728516,2116.010498 
	C2531.485107,2113.207275 2534.265381,2110.422119 2534.018555,2107.624268 
	C2533.752197,2104.606934 2533.323730,2101.633545 2530.036865,2100.427979 
	C2527.977295,2099.672607 2526.014160,2100.548828 2524.915039,2102.308105 
	C2523.014648,2105.350586 2524.605225,2107.905762 2526.624023,2110.226074 
	C2527.897705,2111.690186 2529.635498,2112.760498 2530.187500,2115.337891 
	C2525.356689,2119.652100 2522.377197,2118.239502 2520.008057,2113.155029 
	C2514.193359,2100.676025 2511.397461,2098.904541 2498.679932,2100.902588 
	C2494.782715,2101.514893 2493.154541,2100.239746 2491.667236,2097.288330 
	C2490.323975,2094.623779 2488.745850,2092.140869 2486.868408,2089.754395 
	C2482.625000,2084.361084 2473.369629,2085.292725 2468.673828,2088.899902 
	C2465.460938,2091.368164 2466.090576,2094.472656 2466.886230,2097.922852 
	C2468.429932,2104.618164 2466.521240,2108.405273 2461.538330,2109.728760 
	C2456.412598,2111.090332 2449.575928,2107.149658 2448.365967,2101.704102 
	C2447.461670,2097.632080 2447.611328,2093.582764 2452.787598,2092.060547 
	C2453.737793,2091.781006 2454.746338,2091.504150 2455.552979,2090.964844 
	C2459.134521,2088.569580 2463.098145,2086.432373 2461.834961,2080.903809 
	C2460.841064,2076.554688 2457.298584,2075.348633 2453.817627,2074.366943 
	C2448.973145,2073.000732 2443.951904,2075.020264 2441.687012,2078.980225 
	C2440.882812,2080.386475 2440.200195,2082.051270 2440.102539,2083.637451 
	C2439.792969,2088.662842 2436.140137,2090.311035 2432.277832,2091.515625 
	C2429.778320,2092.294922 2426.401367,2092.937988 2424.938477,2090.349609 
	C2423.256836,2087.373779 2420.829346,2083.982910 2423.248291,2080.134033 
	C2423.773926,2079.297607 2424.566895,2078.633789 2425.148193,2077.826660 
	C2433.180420,2066.675049 2432.289062,2061.607422 2420.410400,2052.547363 
	C2420.675293,2046.541748 2424.426270,2048.348877 2427.308838,2049.188232 
	C2433.101562,2050.875000 2436.666260,2055.081055 2438.994873,2060.509766 
	C2440.161377,2063.229492 2441.325195,2066.609131 2445.035400,2065.994385 
	C2448.889893,2065.355225 2455.335449,2067.338867 2455.649902,2061.884277 
	C2455.906982,2057.424805 2452.277588,2051.297119 2446.725342,2051.666748 
	C2435.604248,2052.407471 2430.303955,2046.047119 2426.591553,2037.487915 
	C2424.413574,2032.466553 2420.512451,2033.403809 2416.155273,2032.655029 
	C2415.193359,2025.254761 2417.363770,2017.898804 2413.158691,2010.702881 
	C2417.480469,2006.689209 2420.658447,2008.978271 2423.698242,2011.787842 
	C2425.151367,2013.130737 2426.137695,2014.873047 2427.336914,2016.432983 
	C2429.136719,2018.773926 2431.360107,2019.815796 2434.202393,2018.478149 
	C2436.392822,2017.447388 2438.240967,2015.899536 2437.715576,2013.206421 
	C2437.114502,2010.125000 2434.386963,2009.466187 2431.801758,2008.780640 
	C2426.222900,2007.300903 2419.626221,2007.156738 2419.220215,1998.504150 
	C2421.601074,1996.115967 2423.810303,1996.908447 2426.036865,1997.562256 
	C2428.848877,1998.388184 2432.140869,1999.959961 2433.913086,1996.414673 
	C2435.720947,1992.798950 2433.161865,1990.234375 2430.471436,1988.099854 
	C2429.182861,1987.077393 2427.693115,1986.336426 2425.921387,1984.815186 
	C2424.930176,1983.080322 2424.630127,1981.741699 2425.431641,1980.619751 
	C2431.961914,1971.477051 2431.626709,1968.759399 2422.413330,1961.198242 
	C2419.456055,1957.618042 2421.459473,1954.444458 2421.782715,1951.269775 
	C2422.183105,1947.332275 2421.159912,1943.964478 2417.166260,1942.399292 
	C2414.708496,1941.436279 2412.521729,1942.397217 2411.281494,1944.681763 
	C2409.260498,1948.405029 2410.746826,1951.698730 2413.036865,1954.719604 
	C2414.899170,1957.176147 2418.252686,1957.497803 2420.670166,1960.312012 
	C2419.785645,1967.440308 2416.459717,1973.264282 2415.809570,1979.957153 
	C2415.445068,1983.710571 2412.622314,1986.436157 2407.790039,1987.083496 
	C2403.864746,1985.423706 2404.615479,1982.707886 2405.527832,1980.376465 
	C2407.576172,1975.141479 2406.213867,1971.018188 2401.684570,1966.970947 
	C2399.709473,1963.232788 2401.109863,1959.975830 2401.005859,1956.757690 
	C2400.899170,1953.459351 2400.861328,1949.846680 2396.893555,1948.752930 
	C2393.829834,1947.908203 2390.884033,1949.026489 2389.296875,1951.856323 
	C2387.464844,1955.123169 2388.993896,1958.214844 2390.870361,1960.982544 
	C2392.230469,1962.988525 2394.654297,1963.431519 2397.302490,1964.749268 
	C2399.453125,1966.704590 2399.746094,1968.810181 2398.681396,1970.446045 
	C2394.528564,1976.825928 2397.319092,1981.280273 2402.644531,1985.915649 
	C2402.323486,1993.498047 2398.105957,1991.249512 2394.506836,1989.646851 
	C2391.082520,1988.122314 2389.051025,1984.972900 2386.945312,1981.999023 
	C2385.117432,1979.417725 2382.937500,1977.399048 2379.500000,1979.054443 
	C2377.250488,1980.137939 2375.873047,1982.022583 2376.366455,1984.642822 
	C2377.059814,1988.325195 2380.086914,1988.723267 2383.102783,1989.277832 
	C2387.011719,1989.996582 2392.258789,1988.588745 2392.737305,1995.596802 
	C2389.973633,1998.803345 2386.329346,1998.301147 2383.371094,1999.627930 
	C2377.134033,2002.425293 2375.976807,2008.862671 2382.027832,2011.506348 
	C2390.842529,2015.357788 2398.959717,2019.231689 2404.483154,2027.578857 
	C2406.036621,2029.927002 2410.031250,2029.197144 2413.339355,2030.755005 
	C2416.093018,2037.480469 2412.010254,2044.672485 2416.274414,2051.357910 
	C2409.565674,2054.167969 2407.985107,2053.845215 2406.567627,2048.453857 
	C2405.343262,2043.796265 2404.670654,2038.261108 2398.875244,2038.555420 
	C2393.472900,2038.829956 2391.026855,2043.784790 2389.380371,2048.829102 
	C2387.664795,2054.085205 2384.082275,2058.012207 2379.016846,2060.428711 
	C2372.391602,2063.589355 2367.934326,2062.685059 2365.236328,2056.033447 
	C2361.969238,2047.979370 2356.850586,2044.655884 2348.402100,2045.970825 
	C2344.562988,2046.568359 2342.044678,2044.718628 2340.599365,2041.233154 
	C2339.554932,2038.714600 2337.688721,2036.825195 2335.887695,2034.846313 
	C2332.516357,2031.142090 2329.117188,2029.235474 2323.616211,2030.948975 
	C2317.100098,2032.978882 2314.827637,2031.342896 2312.057861,2025.135010 
	C2311.110840,2023.012695 2310.270020,2020.843018 2309.359863,2018.703979 
	C2307.330566,2013.934326 2304.966797,2011.445312 2298.694580,2013.187378 
	C2288.821289,2015.929688 2286.178955,2014.572632 2280.988281,2005.317871 
	C2278.033936,2000.050659 2274.827881,1997.037476 2268.595703,1997.974365 
	C2261.203857,1999.085449 2256.881348,1995.062378 2253.482422,1989.040894 
	C2249.068604,1981.220459 2248.697266,1981.166016 2240.104736,1983.003784 
	C2237.193115,1983.626587 2234.274170,1985.195923 2232.152832,1980.729492 
	C2232.207275,1979.758179 2232.440674,1979.528931 2232.617432,1979.261963 
	C2234.340576,1976.660034 2241.701660,1977.677368 2238.684570,1972.865967 
	C2235.861816,1968.364624 2232.028809,1972.917603 2228.519775,1975.554810 
	C2222.533936,1973.770996 2217.273193,1971.054077 2210.959229,1971.961914 
	C2204.016357,1972.960083 2201.924561,1975.844360 2203.921875,1982.650024 
	C2206.581055,1991.710815 2206.607178,1992.274536 2216.051270,1991.833618 
	C2224.596191,1991.434937 2228.608643,1997.160278 2232.822754,2002.529541 
	C2235.103516,2005.435059 2234.593994,2008.932739 2230.057861,2010.224487 
	C2229.101318,2010.496948 2228.219971,2011.124268 2227.256348,2011.267578 
	C2217.043457,2012.786133 2212.180908,2017.890381 2213.767578,2028.886719 
	C2214.473877,2033.780884 2210.114502,2037.424561 2205.054688,2037.801392 
	C2199.826172,2038.190674 2197.597656,2034.926270 2195.760986,2030.489258 
	C2193.579590,2025.219971 2195.597900,2022.298950 2200.004395,2020.029419 
	C2200.893066,2019.571655 2201.748291,2019.028687 2202.674072,2018.666504 
	C2214.506104,2014.040771 2212.428955,2008.416870 2208.509766,1997.607178 
	C2206.494873,1992.050903 2201.583496,1994.207275 2197.322998,1995.194458 
	C2189.734131,1996.952759 2185.810059,1994.857178 2183.106445,1988.084229 
	C2180.976074,1982.747925 2181.941895,1980.387451 2187.285889,1977.948730 
	C2187.887207,1977.674194 2188.619629,1977.640137 2189.163330,1977.293823 
	C2192.579346,1975.119629 2198.072998,1975.070312 2197.829590,1969.086060 
	C2197.551270,1962.237427 2193.897949,1957.907227 2186.787842,1955.818115 
	C2186.158447,1955.633057 2185.566650,1955.319702 2184.478760,1954.532959 
	C2189.269775,1947.773682 2195.628174,1947.860107 2200.319092,1954.452881 
	C2202.421875,1957.407837 2203.770752,1960.941895 2207.171875,1962.790649 
	C2209.690918,1964.159790 2212.290283,1964.459595 2214.563232,1962.384277 
	C2216.839600,1960.305786 2216.445557,1957.607056 2215.814697,1954.960327 
	C2215.013184,1951.596313 2212.728760,1951.489624 2209.716064,1951.626099 
	C2195.977295,1952.247925 2194.091309,1951.204590 2190.157227,1938.927979 
	C2188.485596,1933.711304 2186.211182,1931.737793 2180.864014,1933.428589 
	C2172.502197,1936.072876 2165.889893,1933.740356 2161.312500,1926.061035 
	C2160.467773,1924.644165 2159.255859,1923.447754 2157.811279,1922.576782 
	C2155.382812,1921.112549 2152.830078,1920.712402 2150.260254,1922.121948 
	C2148.686279,1922.985352 2147.888428,1924.390137 2148.262207,1926.260254 
	C2148.829590,1929.099731 2150.630615,1932.096069 2153.209229,1931.765625 
	C2169.410645,1929.689453 2172.840088,1943.734253 2180.174805,1953.318237 
	C2179.472168,1955.183350 2179.269287,1956.924561 2178.361084,1957.452637 
	C2174.243652,1959.845947 2173.996338,1962.744141 2176.225098,1966.611816 
	C2178.134277,1969.925537 2179.177490,1973.509888 2175.817139,1976.641968 
	C2172.968994,1979.296387 2164.220459,1980.772461 2161.605225,1979.224609 
	C2159.181152,1977.789795 2155.731201,1969.741089 2156.221924,1966.809326 
	C2156.747559,1963.669556 2159.132324,1962.858887 2161.689453,1961.744141 
	C2170.421875,1957.937744 2171.865723,1954.722778 2168.659912,1947.453735 
	C2165.403320,1940.069824 2160.416504,1938.556641 2152.285400,1941.573242 
	C2146.764404,1943.621582 2147.687012,1947.344482 2148.794434,1951.268311 
	C2151.409180,1960.532959 2151.366699,1960.088135 2142.587158,1962.391846 
	C2137.442627,1963.741699 2133.562988,1964.426758 2131.263916,1958.493896 
	C2129.551025,1954.073730 2130.707275,1950.201050 2135.340820,1946.398804 
	C2136.362305,1945.560669 2137.663086,1945.052368 2138.644043,1944.177368 
	C2141.638428,1941.505859 2145.414307,1938.646729 2143.501709,1934.177124 
	C2141.763916,1930.116211 2140.190674,1925.082520 2134.743896,1924.197876 
	C2129.402344,1923.330444 2125.009033,1925.901489 2121.151123,1929.209106 
	C2119.542725,1930.588013 2120.083984,1932.940796 2120.005127,1934.916016 
	C2119.912598,1937.227905 2120.118896,1939.540527 2118.864502,1941.709839 
	C2116.288818,1946.163574 2108.693115,1950.671631 2105.761719,1949.342163 
	C2103.338867,1948.243408 2099.619873,1938.471313 2100.208252,1934.889893 
	C2100.496338,1933.136475 2101.329346,1931.736084 2102.800537,1930.824463 
	C2104.209717,1929.950928 2105.716309,1929.219849 2107.225342,1928.524780 
	C2114.039307,1925.385864 2116.264404,1922.307373 2114.863281,1917.869629 
	C2113.247314,1912.751099 2106.947754,1908.042969 2101.818115,1908.739502 
	C2098.103271,1909.243896 2094.681641,1910.921509 2094.177734,1915.368164 
	C2093.916260,1917.674805 2093.751709,1920.064575 2094.055664,1922.348755 
	C2094.784180,1927.827881 2091.809082,1930.131958 2087.109131,1931.353760 
	C2082.362061,1932.587769 2078.510010,1931.375488 2075.818115,1927.281860 
	C2073.044434,1923.063721 2073.580566,1919.154053 2077.332031,1915.650635 
	C2079.769775,1913.374023 2082.141602,1911.042114 2081.988281,1907.221069 
	C2081.875000,1904.396484 2081.472168,1901.725830 2078.535156,1900.625977 
	C2075.449707,1899.470703 2072.126709,1899.855469 2070.727051,1903.042236 
	C2067.167236,1911.146240 2061.661621,1917.668823 2055.536377,1923.860107 
	C2053.228271,1926.193115 2053.794189,1929.571899 2054.074219,1932.485474 
	C2054.577148,1937.714355 2052.128662,1940.603760 2047.507446,1942.223999 
	C2044.999756,1943.103516 2042.522583,1944.069336 2040.024658,1944.976807 
	C2035.299072,1946.693481 2031.421143,1946.367676 2029.912842,1940.633057 
	C2029.188721,1937.879395 2027.182007,1936.100708 2025.199463,1934.333374 
	C2021.493896,1931.030273 2017.089966,1931.344116 2012.994019,1932.927368 
	C2009.222412,1934.385498 2008.076172,1937.840576 2007.925293,1941.882568 
	C2007.763550,1946.218628 2009.824219,1951.621460 2002.765869,1953.888916 
	C2000.038452,1952.120972 2000.656860,1949.751709 2000.755737,1947.478149 
	C2000.911255,1943.904175 2000.286621,1940.719971 1996.035400,1940.063232 
	C1993.738525,1939.708374 1990.876953,1939.617065 1989.710449,1941.807251 
	C1987.758911,1945.471680 1990.625854,1947.906006 1993.041870,1950.156738 
	C1994.245361,1951.277832 1995.854736,1951.871216 1997.576660,1953.450684 
	C1997.789307,1958.519897 1992.764771,1961.491211 1994.001221,1967.235352 
	C1991.538940,1970.291382 1989.049561,1968.696655 1986.599731,1968.009033 
	C1982.679688,1966.908813 1978.504395,1966.039062 1975.356079,1969.104980 
	C1971.883545,1972.486328 1974.554688,1976.524536 1975.466431,1980.229248 
	C1975.858765,1981.822876 1976.940186,1983.165894 1977.816895,1985.330078 
	C1976.942627,1990.490601 1975.479126,1994.892456 1975.958130,1999.646729 
	C1976.412720,2004.158325 1974.842773,2007.453613 1969.889648,2008.297729 
	C1969.248901,2008.406860 1968.652100,2008.761841 1968.029053,2008.986572 
	C1955.816650,2013.388184 1955.804321,2013.389526 1957.742554,2026.447754 
	C1958.377930,2030.728394 1957.736938,2034.198853 1953.282349,2036.363403 
	C1946.922119,2039.453857 1944.010132,2038.231323 1941.879517,2031.041504 
	C1939.283325,2022.281006 1939.283325,2022.281006 1928.842773,2022.000000 
	C1927.878052,2014.580078 1930.636963,2007.599121 1931.387573,2000.257080 
	C1931.838257,1995.846802 1937.329712,1994.395996 1941.434692,1993.035156 
	C1945.663208,1991.633423 1946.691040,1989.272095 1946.165405,1984.755371 
	C1944.507446,1970.508423 1944.693604,1970.359253 1957.922729,1963.696777 
	C1961.271973,1962.010010 1962.320801,1960.074219 1961.214111,1956.627319 
	C1960.064941,1953.047852 1958.407837,1949.878418 1954.552734,1947.395996 
	C1953.835693,1946.684692 1953.495850,1946.425903 1953.486328,1946.155151 
	C1953.251099,1939.491089 1948.554199,1926.182373 1944.916260,1921.151611 
	C1946.051636,1917.945190 1947.491089,1915.561890 1948.116821,1912.113281 
	C1948.819336,1910.606812 1949.417847,1909.880493 1950.804443,1908.992432 
	C1954.848145,1908.864990 1956.492310,1911.668945 1958.765259,1913.494629 
	C1961.623779,1915.790283 1964.635986,1916.768433 1967.743408,1914.156738 
	C1970.588013,1911.766235 1971.300659,1908.635376 1969.902832,1905.182617 
	C1968.535034,1901.803955 1966.389404,1898.797607 1964.825928,1894.700439 
	C1964.423462,1893.028198 1964.380371,1892.044556 1964.632812,1890.320190 
	C1965.595703,1887.667236 1966.795044,1886.116333 1969.454712,1885.115845 
	C1979.582520,1892.391113 1992.575684,1890.597778 2002.237793,1897.502075 
	C2004.000488,1898.761841 2007.075073,1899.473511 2008.152588,1896.418335 
	C2009.376709,1892.946655 2007.173096,1890.056885 2004.060303,1889.665771 
	C1993.540161,1888.343628 1988.989258,1880.990601 1985.082275,1871.803589 
	C1984.460815,1869.222900 1984.921021,1867.418457 1985.822754,1865.004639 
	C1987.051514,1862.375366 1988.286621,1860.535522 1989.799072,1858.113403 
	C1990.837524,1856.506592 1991.571045,1855.468628 1992.591309,1853.860840 
	C1993.938599,1851.947021 1995.150024,1850.769775 1997.028076,1849.372314 
	C1998.360962,1848.691528 1999.187378,1848.496460 2000.675537,1848.564453 
	C2005.537354,1855.615356 2004.609619,1862.012695 1999.145264,1867.794312 
	C1996.621460,1870.464600 1995.401733,1873.054199 1997.396973,1876.679932 
	C1999.726807,1880.913696 2003.489136,1880.146118 2007.036865,1879.731812 
	C2010.027710,1879.382324 2012.042969,1877.688721 2010.990234,1874.254395 
	C2010.085205,1871.302124 2009.135986,1868.198364 2011.711792,1865.852783 
	C2014.928101,1862.923828 2018.882202,1861.002075 2023.192749,1860.214600 
	C2026.392090,1859.630127 2028.012695,1861.838501 2029.111450,1864.459717 
	C2031.661987,1870.543823 2030.049683,1876.142700 2023.639893,1880.880737 
	C2020.554688,1883.161377 2018.000610,1885.036743 2017.933594,1889.409912 
	C2017.781250,1899.360474 2022.667725,1903.221313 2032.186890,1900.221558 
	C2032.821045,1900.021729 2033.485474,1899.915283 2034.113892,1899.701172 
	C2042.341675,1896.897461 2042.340454,1896.894287 2039.930542,1888.732422 
	C2037.669312,1881.073730 2038.322632,1879.279175 2044.206543,1876.984985 
	C2050.313232,1874.603882 2055.602783,1875.920898 2058.156982,1880.458496 
	C2061.440430,1886.291382 2060.389160,1890.660645 2054.692627,1894.745728 
	C2053.073730,1895.906860 2051.474609,1897.113525 2049.762695,1898.124268 
	C2046.779663,1899.885864 2045.533325,1902.199097 2046.824707,1905.619141 
	C2047.290649,1906.853271 2047.729004,1908.145508 2047.870605,1909.444824 
	C2048.191162,1912.384033 2047.608765,1916.212402 2051.172852,1917.042236 
	C2055.041504,1917.942993 2058.048096,1915.151367 2060.443848,1912.292603 
	C2062.858398,1909.411621 2063.645996,1905.873047 2064.357666,1902.213623 
	C2065.405029,1896.827515 2068.955322,1893.414795 2074.343018,1892.313965 
	C2078.080566,1891.550171 2081.764648,1891.726318 2083.831055,1895.771973 
	C2087.564941,1903.081787 2093.784668,1904.975708 2101.392090,1904.006104 
	C2107.831787,1903.185181 2113.119629,1904.650879 2116.235107,1911.067017 
	C2117.228271,1913.111938 2118.908936,1914.848633 2120.400635,1916.620850 
	C2123.742188,1920.591187 2128.522949,1920.965088 2133.786377,1918.088989 
	C2137.698242,1915.951050 2138.604980,1912.936035 2137.321045,1908.896606 
	C2135.504639,1903.181396 2131.402344,1899.726807 2126.674805,1900.268311 
	C2125.054443,1900.453979 2123.524170,1901.320068 2121.906738,1901.654663 
	C2117.687012,1902.527954 2113.611816,1902.008179 2111.455811,1897.914917 
	C2109.437012,1894.082397 2108.192871,1889.809692 2113.263428,1886.162842 
	C2115.786133,1887.568726 2116.304199,1889.860352 2117.369629,1891.844971 
	C2118.847168,1894.597778 2121.268066,1895.091675 2124.015869,1894.134888 
	C2125.591064,1893.586182 2127.130859,1892.525269 2126.836182,1890.656860 
	C2126.295166,1887.224487 2123.473389,1887.225830 2120.829102,1887.246582 
	C2118.897461,1887.261597 2116.948486,1887.714233 2114.535156,1886.448486 
	C2120.776855,1876.026489 2127.116943,1875.774902 2133.564697,1885.276733 
	C2135.354492,1887.914062 2135.972900,1891.347168 2140.118896,1892.004272 
	C2148.540771,1893.339600 2151.536377,1890.889526 2152.086182,1882.312988 
	C2152.343750,1878.293335 2150.021240,1873.609131 2155.227051,1870.187988 
	C2158.466553,1872.174316 2158.388428,1875.328369 2159.157715,1878.161377 
	C2160.274170,1882.271851 2162.709229,1884.554565 2167.165039,1883.314209 
	C2170.746826,1882.317383 2173.027100,1879.979980 2172.264160,1876.017090 
	C2171.396484,1871.511353 2168.941895,1868.829834 2163.846924,1870.195557 
	C2161.629883,1870.789917 2159.448242,1871.767944 2156.539062,1870.446045 
	C2156.187988,1867.820312 2157.198486,1866.037354 2159.313232,1865.490967 
	C2165.590088,1863.868164 2168.360352,1860.472290 2168.338623,1853.499634 
	C2168.316895,1846.547363 2172.348389,1841.153809 2178.971191,1837.962646 
	C2185.113770,1835.002808 2189.191406,1831.136475 2186.262939,1823.138794 
	C2185.221191,1820.294189 2184.558105,1815.692749 2189.492676,1813.925293 
	C2193.920898,1812.339233 2198.433105,1810.369019 2202.646240,1813.927734 
	C2206.032959,1816.788330 2208.189941,1820.534424 2207.760010,1825.254883 
	C2207.599365,1827.019653 2206.552490,1828.300781 2205.134521,1829.281616 
	C2203.500000,1830.412109 2201.842529,1831.509399 2200.202637,1832.632080 
	C2192.049072,1838.214722 2191.087402,1842.974487 2196.239502,1851.347900 
	C2198.807373,1855.521240 2202.697021,1854.063354 2206.068848,1853.568726 
	C2214.941650,1852.266968 2214.919189,1852.098633 2218.808350,1859.636230 
	C2219.721924,1861.406128 2220.526123,1863.238525 2221.531738,1864.953491 
	C2225.219238,1871.242065 2230.754150,1871.343018 2234.323486,1864.885742 
	C2236.053955,1861.754761 2236.875732,1858.091187 2237.901123,1854.607544 
	C2239.860840,1847.949585 2247.762939,1840.972900 2254.159668,1840.339355 
	C2256.373291,1840.120117 2257.980225,1841.101074 2259.426758,1842.565186 
	C2264.450195,1847.649536 2264.451904,1857.797119 2258.717285,1863.865234 
	C2255.405029,1861.539429 2256.589111,1858.404663 2256.451416,1855.497803 
	C2256.312012,1852.556030 2255.246094,1850.140869 2251.906006,1850.024780 
	C2248.769775,1849.915771 2247.163330,1852.152710 2246.245605,1854.800903 
	C2245.181152,1857.873779 2246.361328,1859.962769 2249.446045,1860.971313 
	C2251.335449,1861.589111 2253.361328,1861.815186 2255.536865,1863.469238 
	C2255.846436,1866.192749 2254.618164,1867.574463 2252.790283,1868.693970 
	C2248.999023,1871.016235 2247.628418,1874.533569 2247.983887,1878.895142 
	C2248.403320,1884.035156 2246.848389,1888.080322 2240.739746,1889.902954 
	C2237.990723,1888.003174 2239.083984,1885.766602 2239.516113,1883.596436 
	C2240.105713,1880.636841 2239.357666,1878.186157 2236.179443,1877.650635 
	C2232.021484,1876.949707 2231.367432,1879.880737 2231.390137,1883.125122 
	C2231.399414,1884.429565 2231.338867,1885.717896 2230.441406,1887.478760 
	C2224.662354,1887.246582 2224.376221,1882.288208 2222.618896,1878.749146 
	C2221.425537,1876.345093 2220.820801,1873.870117 2216.741211,1874.015625 
	C2213.774170,1871.975464 2214.281006,1869.181519 2213.906250,1866.634033 
	C2213.476807,1863.718018 2211.967773,1861.759155 2208.903564,1861.429932 
	C2206.810791,1861.205200 2204.858398,1861.765259 2204.026611,1863.883057 
	C2202.845215,1866.890381 2204.505615,1868.887695 2206.871826,1870.450073 
	C2208.240234,1871.353760 2209.811035,1871.916870 2211.566895,1873.453125 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,542.937073 
	C4.959023,542.017151 6.674544,539.834595 8.851660,538.330078 
	C15.724962,533.580200 23.890297,536.862732 25.782145,545.072266 
	C26.224560,546.992065 25.896648,549.079773 26.244761,551.032898 
	C26.986965,555.197144 30.146381,556.913025 33.600075,555.549377 
	C38.476814,553.623962 43.226295,551.010803 45.974957,546.018738 
	C49.887539,538.912842 47.662094,533.389587 39.685181,532.178406 
	C34.809845,531.438232 30.816729,529.763672 27.356365,526.362854 
	C25.079565,524.125305 23.881144,521.612061 23.988163,518.373779 
	C24.101963,514.930298 24.112392,511.281982 28.318823,510.444458 
	C32.179115,509.675842 37.652832,508.555634 39.044983,512.990112 
	C42.748470,524.786804 50.405342,526.296082 61.008156,524.174194 
	C66.000702,523.175110 71.482079,524.656555 73.472305,530.142395 
	C75.279251,535.123047 73.919426,539.925232 69.493057,543.590149 
	C67.207558,545.482422 65.127632,547.665466 63.782551,550.457397 
	C61.509960,555.174561 62.120380,558.147217 65.852554,559.556641 
	C70.722336,561.395752 77.088181,559.573181 77.506157,555.513733 
	C78.111649,549.633057 80.649261,544.725586 83.170677,539.680115 
	C84.219513,537.581299 85.261436,535.478333 87.451454,534.306091 
	C92.077698,531.829956 93.343323,527.606445 94.098068,522.758118 
	C95.350883,514.710266 96.244667,513.692810 104.441772,514.160522 
	C111.069290,514.538635 117.513664,512.021851 124.139198,513.595093 
	C126.786385,514.223694 128.334229,512.395813 129.810318,510.405182 
	C133.219162,505.808136 137.900497,502.728638 142.854095,500.023132 
	C148.897812,496.722229 149.846909,489.099640 144.460144,484.631470 
	C141.675095,482.321350 138.299545,480.429382 134.555695,480.190674 
	C131.347168,479.986084 127.420151,478.658691 125.105469,481.553314 
	C122.858688,484.363037 125.559616,487.300568 126.976624,489.756134 
	C129.476242,494.087769 130.468887,498.252106 127.988174,502.914001 
	C125.652992,507.302368 122.701317,508.335449 118.229004,506.065002 
	C109.770515,501.770966 107.666817,491.285858 113.453262,481.879456 
	C114.316643,480.475983 115.769363,479.425323 116.581055,478.001465 
	C120.339157,471.408905 118.098801,464.328156 111.220718,460.587860 
	C108.594627,459.159790 105.859383,457.874176 103.427330,456.163361 
	C100.806358,454.319672 99.513542,451.634613 100.366570,448.314423 
	C101.301643,444.674835 104.180946,444.292938 107.339523,443.973602 
	C119.614319,442.732605 121.874863,438.971405 117.511215,427.052399 
	C116.687401,424.802216 115.539917,422.564636 116.929520,420.400330 
	C118.587181,417.818573 116.427727,412.980713 121.316727,412.442749 
	C125.426208,411.990570 131.336166,417.223846 131.885498,421.530243 
	C132.184311,423.872894 131.410858,426.093506 130.946915,428.382050 
	C129.657349,434.743347 132.550262,437.203766 138.661652,434.451050 
	C142.955322,432.517151 146.643890,432.297333 151.014404,433.881500 
	C154.248520,435.053711 155.400879,437.665558 157.273544,439.933899 
	C161.233734,444.730927 162.856903,444.931061 167.964615,440.952484 
	C172.042786,437.775879 175.850906,435.024841 181.503693,437.353302 
	C184.260345,438.488861 185.798141,436.460266 185.914093,433.631866 
	C185.995941,431.635040 186.122894,429.621643 185.958588,427.638092 
	C185.777451,425.451477 187.029694,422.480530 184.370743,421.357452 
	C181.379944,420.094177 180.737961,423.329987 179.370438,425.010162 
	C176.186615,428.921967 172.454941,428.986053 169.002838,425.777069 
	C165.646439,422.657074 161.358047,420.779816 158.830353,416.424469 
	C156.064987,411.659698 151.856323,408.188416 145.506073,411.156708 
	C142.661697,412.486298 140.191483,411.548889 138.602570,408.980499 
	C137.123322,406.589355 134.625229,405.483246 132.707916,403.663971 
	C127.097992,398.340729 127.059387,393.611786 132.643463,388.493317 
	C137.175598,384.339081 143.910812,385.178833 148.168945,390.328186 
	C150.284500,392.886536 152.557785,395.315704 154.788971,397.776794 
	C157.115601,400.343201 159.407440,402.197144 163.426056,400.611664 
	C167.518951,398.996918 171.286560,399.845398 173.320953,404.494720 
	C174.587357,407.388947 176.736160,408.335907 179.812119,407.092529 
	C184.263016,405.293365 187.444077,405.604828 188.328445,411.468689 
	C188.906967,415.304596 192.304123,417.456512 195.285706,419.603119 
	C197.443542,421.156677 199.863586,422.393127 201.843552,424.137726 
	C207.746689,429.339233 206.743759,433.419006 199.713455,436.511780 
	C196.073410,438.113098 190.982300,436.291473 188.781540,440.145660 
	C186.739456,443.721954 188.623535,447.838684 189.424271,451.778412 
	C190.375656,456.459290 186.498367,461.520477 181.301758,464.351227 
	C176.361023,467.042603 172.397842,466.025208 168.910522,461.915680 
	C168.480774,461.409241 168.003159,460.932281 167.493240,460.506989 
	C165.530640,458.870239 164.069275,455.844513 160.916183,456.983856 
	C158.431107,457.881897 158.017181,460.419495 158.036026,462.867035 
	C158.058975,465.847565 157.742905,468.697876 161.563370,470.199463 
	C165.100433,471.589691 170.146606,471.242096 171.482971,475.885803 
	C173.139633,481.642456 170.759872,487.215057 168.338120,492.135681 
	C165.550369,497.799988 162.831329,503.150940 161.418243,509.520996 
	C159.956253,516.111511 153.933868,519.485229 147.060379,519.908203 
	C142.678680,520.177856 138.592911,520.908203 135.020721,523.320435 
	C134.433060,526.121155 136.110916,527.985168 137.047241,530.047363 
	C140.971191,538.689453 137.892059,544.274292 128.162155,545.914551 
	C125.259369,546.403992 122.148567,545.305359 119.417091,546.971741 
	C117.908340,549.821289 120.473442,551.259644 121.539047,553.119263 
	C123.428596,556.416870 124.177307,559.868347 124.016510,563.643860 
	C123.712784,570.775146 121.837791,572.921570 114.643501,573.987122 
	C105.587051,575.328491 105.251999,575.864197 107.933914,584.741943 
	C108.222549,585.697327 108.557137,586.639404 108.826508,587.599976 
	C111.019379,595.419739 108.207970,600.971985 100.462898,604.140076 
	C91.463905,607.821045 91.463928,607.821106 93.282661,616.767578 
	C95.022598,625.326477 93.387886,628.737793 84.788307,631.939209 
	C80.093819,633.686890 77.208153,636.058899 78.026726,641.308960 
	C79.433807,650.333374 75.251503,656.028198 67.298096,659.323975 
	C62.265839,661.409180 62.017799,665.399658 61.940548,669.970825 
	C61.698303,684.305664 54.747452,688.976318 41.326023,683.559937 
	C37.182728,681.887817 33.678799,682.185181 29.830601,683.769653 
	C27.861773,684.580261 26.050417,685.313721 26.500202,687.877441 
	C26.889011,690.093628 28.450907,691.288452 30.556335,691.719971 
	C33.143028,692.250061 35.797039,692.089600 38.360081,693.174255 
	C42.683472,695.003906 44.561687,698.009033 43.884979,702.593445 
	C43.215191,707.131042 39.603085,710.134460 34.711388,709.877930 
	C32.436493,709.758606 30.209124,708.845703 27.946032,708.358276 
	C25.547901,707.841797 23.228794,708.015991 21.507967,709.987610 
	C19.348278,712.462036 20.321650,715.038696 21.777649,717.355957 
	C23.183258,719.593079 25.416363,721.419434 26.388597,723.793640 
	C27.793695,727.225037 31.326075,730.615051 28.013506,734.780884 
	C25.081577,738.467957 21.036793,738.810669 17.131874,737.304199 
	C12.391541,735.475403 8.029566,736.010803 2.785064,737.899170 
	C2.000000,716.624878 2.000000,695.249756 2.000000,672.937317 
	C5.501287,666.484802 9.896231,661.019958 2.480587,654.458740 
	C2.000000,637.958191 2.000000,621.916382 2.000000,604.937256 
	C9.054976,597.721558 17.296785,592.216736 16.753958,581.079285 
	C12.186337,581.919434 8.268635,585.756958 2.532480,584.440063 
	C2.000000,570.624695 2.000000,557.249451 2.000000,542.937073 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2173.679199,142.608978 
	C2173.872314,138.412766 2177.071533,138.284225 2179.587646,136.510315 
	C2182.975342,133.013092 2187.079834,132.073654 2191.319580,130.072998 
	C2194.148438,129.842102 2195.344727,128.558746 2196.587158,126.848137 
	C2202.849365,118.226669 2207.761230,116.725990 2219.228027,119.902611 
	C2224.272705,116.219109 2233.037109,117.879204 2233.311768,108.409866 
	C2234.076416,104.745636 2235.524658,102.228996 2238.214600,99.609726 
	C2243.246826,96.435127 2247.716797,93.724869 2252.459473,90.138535 
	C2254.234863,89.107765 2255.435547,88.379822 2256.070801,87.203445 
	C2260.745361,78.546593 2267.378906,76.614128 2276.073242,81.108017 
	C2277.854004,82.028336 2279.861572,82.372955 2282.630371,81.823563 
	C2285.844971,81.356895 2288.347412,81.160835 2291.634277,81.173950 
	C2295.487061,81.218468 2298.591797,80.995834 2302.298096,82.166679 
	C2307.502686,85.410011 2306.803955,91.444962 2310.385010,95.002586 
	C2312.595459,97.198402 2314.849854,99.115005 2318.170410,97.655045 
	C2320.866699,96.469643 2322.748535,93.885590 2321.886230,91.323250 
	C2318.023193,79.843079 2323.439453,74.201828 2333.621094,70.899673 
	C2335.408936,70.319771 2336.459473,68.216125 2338.031494,66.076889 
	C2339.955811,63.673271 2340.462646,61.774975 2339.384521,59.393124 
	C2337.190430,54.546455 2339.188477,50.795368 2343.468262,47.236008 
	C2345.367920,46.272896 2346.753662,46.068478 2348.883301,46.145973 
	C2356.544189,47.200729 2361.471680,50.584763 2364.033203,57.451420 
	C2365.291748,60.824547 2367.388184,64.095894 2372.626953,61.319824 
	C2376.385010,59.514668 2379.057373,57.491470 2380.878906,53.588326 
	C2384.520020,49.037682 2385.658203,43.349949 2391.561523,40.626255 
	C2394.148438,39.656727 2396.135986,39.455898 2398.889160,39.336601 
	C2401.126953,39.361023 2402.593262,39.547165 2404.720703,40.104202 
	C2410.131348,42.765205 2413.939453,46.997139 2420.225098,47.758934 
	C2422.432129,48.014355 2423.962402,48.091461 2423.947754,45.228043 
	C2423.484619,40.580940 2421.810059,36.914310 2420.659668,32.382870 
	C2420.953125,25.627647 2426.092529,24.211159 2430.824219,21.412888 
	C2432.387451,20.693146 2433.341064,20.468443 2435.054688,20.340012 
	C2440.389404,21.466259 2445.552246,19.118435 2450.319824,23.047321 
	C2452.737793,25.818380 2453.780762,28.704903 2456.000000,30.770933 
	C2459.353027,33.892143 2462.960693,34.228260 2464.807861,29.781624 
	C2468.692139,20.432968 2473.946289,12.582631 2484.258301,8.587186 
	C2476.969727,5.855851 2470.156250,6.957367 2462.666992,6.926549 
	C2457.471436,7.091921 2453.041504,7.318216 2447.726562,6.960987 
	C2431.955322,7.868631 2417.072510,7.235193 2401.255371,6.942640 
	C2392.214600,7.591807 2384.103271,7.433602 2375.058594,7.063785 
	C2364.803955,7.499057 2355.482178,7.529931 2345.229492,6.983440 
	C2338.702148,7.411759 2333.105469,7.510487 2326.569824,7.024171 
	C2310.545166,7.605816 2295.458252,7.613410 2279.430664,6.994075 
	C2272.849365,7.409457 2267.208008,7.546133 2260.621582,7.036088 
	C2243.916748,7.713459 2228.150391,7.412087 2211.445312,7.112696 
	C2204.235840,7.365366 2197.965088,7.557557 2190.747559,7.042649 
	C2180.332520,7.027318 2170.738037,8.975786 2160.755371,4.618108 
	C2152.614258,4.025267 2145.228271,4.019518 2136.921387,4.021209 
	C2123.357666,9.819495 2110.479736,8.209320 2096.779541,4.642227 
	C2079.958496,4.026991 2063.917236,4.020638 2046.938721,4.022033 
	C2039.428223,8.601865 2032.562988,8.068298 2024.781982,4.614218 
	C2018.599854,4.025322 2013.199829,4.020750 2006.899902,4.025018 
	C2003.692749,6.170794 2000.876709,7.138613 1997.821533,7.180572 
	C1985.031006,7.356238 1972.212891,7.950447 1958.781494,4.642352 
	C1950.612915,4.026159 1943.227661,4.022435 1934.921265,4.028707 
	C1928.095947,8.337737 1921.895630,8.013645 1914.767090,4.626027 
	C1905.949097,4.024892 1897.900879,4.020104 1888.926270,4.024066 
	C1884.226440,7.521096 1879.484985,7.443276 1874.841309,7.456650 
	C1842.947388,7.548512 1811.053345,7.544084 1779.159302,7.459047 
	C1775.182983,7.448446 1771.147583,7.491675 1766.782227,4.648429 
	C1760.597290,4.027308 1755.198364,4.022371 1748.899780,4.026799 
	C1740.076782,8.999051 1731.877075,8.202451 1722.786133,4.622151 
	C1720.500488,4.029530 1719.000610,4.023348 1716.750732,4.025150 
	C1714.968628,4.870856 1713.894287,6.023560 1712.666748,6.123104 
	C1692.276001,7.776630 1671.874756,9.391706 1650.779053,4.649282 
	C1646.568359,4.029950 1643.141479,4.023012 1638.858276,4.025228 
	C1637.223999,4.774992 1636.304565,5.061418 1634.622070,4.462603 
	C1627.277588,4.026383 1620.554932,4.021353 1612.916138,4.024908 
	C1601.375488,9.463233 1590.496704,8.164322 1578.778564,4.654734 
	C1575.866577,4.039672 1573.733154,4.029866 1570.799805,4.038358 
	C1330.800293,4.038190 1091.600708,4.011335 852.401062,4.003439 
	C569.558899,3.994104 286.716766,4.001138 2.937315,4.000538 
	C2.435970,3.384652 0.988612,1.914344 3.000676,1.978936 
	C5.664598,2.064454 8.333333,2.000000 11.000000,2.000000 
	C861.333313,2.000000 1711.666626,2.000000 2562.000000,3.000000 
	C2559.725342,6.340796 2556.756104,6.850186 2553.753418,6.709503 
	C2545.725586,6.333351 2539.957031,7.164772 2536.652588,16.990866 
	C2533.558105,26.191492 2518.701416,26.507713 2512.157715,18.924412 
	C2510.858887,17.419262 2509.688965,15.786424 2508.050293,14.635414 
	C2505.581787,12.901324 2502.906250,10.985174 2499.947021,13.220388 
	C2497.387207,15.153866 2498.375244,18.000284 2499.042969,20.569418 
	C2499.459473,22.171854 2500.081299,23.712599 2500.633301,25.272976 
	C2503.103027,32.253212 2500.845703,36.302345 2493.280762,36.682041 
	C2486.507080,37.022018 2481.974121,39.954517 2480.147461,47.506260 
	C2474.737305,58.218578 2470.725342,60.245449 2459.049072,58.104576 
	C2452.699463,52.509476 2446.904785,47.520306 2437.622559,50.224754 
	C2430.341064,55.420135 2431.495850,64.871162 2425.104980,70.794739 
	C2422.672363,73.160484 2420.330078,74.052177 2416.940918,74.339569 
	C2415.140381,74.276329 2414.144043,74.067848 2412.504395,73.409859 
	C2410.172119,71.963371 2409.079102,70.247772 2407.600098,68.949135 
	C2401.277344,63.396759 2397.489258,64.332428 2394.740967,72.499809 
	C2391.835205,81.135735 2386.495117,86.409988 2376.543945,86.442451 
	C2373.792725,85.379585 2371.585693,84.759171 2368.689209,84.068771 
	C2363.964600,81.150879 2364.879150,72.765503 2357.592773,73.870201 
	C2350.409424,74.959251 2351.727295,82.508057 2348.468262,87.488365 
	C2346.634033,92.009125 2341.900635,92.994110 2340.097168,97.347237 
	C2341.088867,101.534454 2337.742676,102.396248 2335.711670,104.767731 
	C2333.043701,106.881516 2332.406982,109.017052 2333.685547,112.810577 
	C2332.398926,121.625557 2332.449951,120.947098 2325.703613,120.440208 
	C2319.401855,119.966690 2315.508789,114.539970 2308.753906,114.011543 
	C2302.947754,114.917908 2298.218750,112.264717 2292.606934,112.330231 
	C2288.281250,111.999580 2287.602783,115.659523 2285.400391,117.485359 
	C2282.324219,120.035988 2279.269775,121.542938 2276.134766,116.694801 
	C2274.376709,112.628159 2277.081787,109.682610 2276.943115,106.438721 
	C2276.825928,103.697815 2276.494873,101.127373 2273.603516,99.880203 
	C2271.955811,99.169525 2270.300537,99.503609 2268.990234,100.628014 
	C2266.651367,102.634827 2266.883789,105.257736 2267.608154,107.902725 
	C2268.322510,110.510162 2270.224854,112.437378 2271.777344,115.347244 
	C2272.412354,122.068649 2269.292480,124.408539 2262.782227,123.997543 
	C2257.753906,127.149391 2251.996094,128.140182 2248.505615,133.545776 
	C2243.645264,146.960938 2232.407715,146.988907 2220.846436,147.999283 
	C2218.068604,146.455124 2217.734619,144.163040 2217.125732,141.977493 
	C2216.188721,138.613571 2214.531738,135.525497 2210.480957,136.465073 
	C2206.309082,137.432816 2206.844727,141.275757 2206.924072,144.499283 
	C2206.981934,146.861664 2208.242920,148.807861 2209.744141,151.362823 
	C2210.222412,154.225983 2211.325195,155.580139 2213.582520,156.160278 
	C2215.825684,156.736786 2218.041016,157.496033 2220.180176,158.386993 
	C2223.623779,159.821259 2224.965332,162.975220 2225.546875,166.264160 
	C2226.165771,169.765762 2222.776855,170.302460 2220.665527,171.691101 
	C2219.558594,172.419006 2218.302490,172.952576 2217.292725,173.789734 
	C2213.561768,176.883072 2211.995605,174.333633 2210.800537,171.271729 
	C2210.207520,169.752075 2210.307373,167.960449 2209.705566,166.446152 
	C2207.759521,161.549088 2204.651367,158.651810 2198.479736,161.465576 
	C2195.459473,164.649231 2192.559814,164.512878 2188.747559,162.546341 
	C2183.405518,162.360703 2181.916016,165.234680 2182.011719,169.394989 
	C2182.095215,173.025528 2181.948975,176.562576 2180.048096,179.878815 
	C2178.390869,182.769592 2176.196289,184.278915 2172.836182,183.755554 
	C2170.488037,183.389786 2162.584961,174.015015 2162.337646,171.528732 
	C2161.935059,167.481979 2167.280273,168.591339 2167.876953,164.690002 
	C2176.524414,158.812271 2176.769043,151.487228 2173.679199,142.608978 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2478.008789,48.699093 
	C2478.834473,37.500248 2481.762939,34.530991 2491.833252,34.004360 
	C2493.162842,33.934830 2494.503906,34.021923 2495.826904,33.898937 
	C2499.459717,33.561245 2500.264893,31.492489 2499.056396,28.336151 
	C2497.750244,24.924528 2496.500977,21.484861 2495.028320,18.144943 
	C2493.588379,14.879363 2494.474121,12.343299 2496.998779,10.142137 
	C2499.863525,7.644585 2502.920166,7.384862 2506.152100,9.406608 
	C2510.116943,11.886527 2513.964355,14.410982 2515.667725,19.174297 
	C2517.296631,23.729282 2520.358154,24.252428 2524.320801,21.871027 
	C2526.027344,20.845562 2527.812988,19.802961 2529.704102,19.264563 
	C2534.073486,18.020554 2536.664551,15.791494 2536.040039,10.794056 
	C2535.379883,5.512408 2538.154053,3.740388 2543.154541,3.954008 
	C2548.806641,4.195475 2554.477051,4.005856 2561.069824,4.001850 
	C2562.000000,33.375122 2562.000000,62.750244 2562.000000,93.062683 
	C2550.939941,89.458290 2550.949951,89.467766 2542.248779,98.738350 
	C2540.427002,100.679253 2538.699951,102.543121 2537.850098,105.250069 
	C2536.481689,109.609970 2533.249268,112.253983 2529.020264,114.045204 
	C2520.489746,117.658447 2520.564209,117.776535 2521.789307,126.800240 
	C2522.444580,131.626144 2522.092529,136.038254 2517.465332,139.152313 
	C2511.913574,142.888657 2508.385986,142.787949 2503.269287,138.253998 
	C2501.281738,136.492905 2499.534424,134.330887 2497.286377,133.024094 
	C2493.980957,131.102264 2490.132568,132.164734 2486.508301,132.073303 
	C2481.791992,131.954330 2482.177002,136.363968 2480.481934,138.925934 
	C2476.802979,144.486038 2473.425049,150.425430 2465.336670,149.984970 
	C2459.212158,149.651443 2457.265625,146.893005 2458.693359,140.786285 
	C2460.045166,135.004150 2464.049316,132.115143 2469.180420,129.854767 
	C2474.447266,127.534569 2474.572754,125.980057 2470.931641,121.943031 
	C2468.645020,119.407448 2465.895996,117.526077 2462.665527,116.556595 
	C2457.330566,114.955444 2455.124756,116.938004 2455.347168,122.862106 
	C2455.650391,130.944473 2447.091309,139.787842 2439.013184,139.738510 
	C2433.289062,139.703552 2428.831055,133.130493 2430.263916,126.516060 
	C2431.376221,121.380501 2434.635742,117.613014 2438.858643,114.695526 
	C2441.040771,113.188065 2443.998535,112.094856 2443.582031,108.911263 
	C2442.988525,104.375488 2442.526611,99.572044 2440.614014,95.545380 
	C2439.287354,92.752586 2435.156006,93.825974 2432.295654,94.384964 
	C2429.318359,94.966835 2426.408447,96.276726 2426.149170,99.939125 
	C2425.914795,103.252602 2426.022461,106.590782 2425.993896,109.918190 
	C2425.940918,116.137360 2423.708740,121.224716 2417.426025,123.064789 
	C2411.592285,124.773361 2405.555420,125.405609 2400.916504,119.904076 
	C2399.423828,118.133842 2397.444336,116.554512 2396.600342,114.510933 
	C2395.464355,111.759796 2394.138916,110.122688 2391.002686,109.810799 
	C2387.551514,109.467598 2385.125488,106.773926 2382.430908,104.947906 
	C2376.288086,100.785439 2372.034912,95.575653 2375.986328,86.759705 
	C2382.079834,85.559189 2385.661621,80.902397 2390.084229,77.661957 
	C2391.919434,76.317551 2392.034424,74.322403 2391.962158,72.367706 
	C2391.787109,67.616898 2393.406738,63.888119 2398.135010,62.398178 
	C2403.222900,60.794956 2407.010986,63.260212 2410.012207,67.163849 
	C2410.786621,68.171028 2411.235352,69.428459 2411.916992,71.284988 
	C2413.426025,76.014381 2410.143311,77.992767 2408.231445,80.508041 
	C2406.823730,82.360092 2405.028564,84.000557 2404.640869,86.388290 
	C2404.102539,89.705551 2403.839111,93.141258 2406.696289,95.637337 
	C2408.056641,96.825920 2409.833496,96.411690 2411.353516,95.516846 
	C2414.484619,93.673454 2414.449707,90.731171 2414.114746,87.632790 
	C2413.583984,82.720421 2412.305664,77.742706 2415.532715,72.519363 
	C2418.358887,72.073189 2420.660889,71.881004 2423.360840,70.279907 
	C2433.215088,66.317902 2442.451904,67.954941 2447.723145,75.410080 
	C2452.254150,81.818527 2454.773926,79.661697 2457.498779,74.429634 
	C2458.730225,72.065224 2459.281250,69.436394 2460.122559,66.922066 
	C2462.590332,59.549946 2468.293213,56.466923 2475.438721,56.682507 
	C2482.275146,56.888760 2484.641602,62.176910 2485.851318,68.138519 
	C2486.301025,70.354805 2486.059326,72.837372 2487.801025,74.700912 
	C2493.635254,68.606201 2493.589600,65.140480 2486.687744,61.344349 
	C2481.672363,58.585869 2477.664307,55.752499 2478.008789,48.699093 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2346.335449,1113.380615 
	C2345.863037,1118.162720 2342.229980,1118.264404 2339.614014,1119.075317 
	C2330.522949,1121.893921 2325.608398,1127.875732 2326.098145,1137.365479 
	C2326.507568,1145.304565 2319.696289,1144.695190 2315.551270,1146.987915 
	C2311.468262,1149.246094 2307.922363,1147.798828 2305.691650,1143.459961 
	C2303.520996,1139.237793 2298.987305,1137.255005 2296.110352,1133.529419 
	C2293.233398,1129.803589 2291.752686,1126.911865 2293.531250,1121.998169 
	C2295.446777,1116.705933 2299.088867,1114.922363 2303.839600,1114.116089 
	C2305.779541,1113.786865 2307.840088,1114.192505 2309.790039,1113.896362 
	C2313.366699,1113.352905 2317.232910,1112.896851 2319.675293,1109.971680 
	C2322.967285,1106.028442 2327.498047,1103.961060 2331.507568,1101.096436 
	C2335.236328,1098.432495 2338.694824,1095.688965 2341.653320,1091.895630 
	C2346.332764,1085.895630 2352.565430,1081.343506 2361.253418,1080.012085 
	C2369.186279,1083.416626 2375.689209,1084.535278 2379.503906,1074.471680 
	C2384.163818,1071.925903 2388.214111,1069.566528 2392.522461,1067.856445 
	C2396.990234,1066.083008 2400.654053,1063.998047 2402.631348,1059.166016 
	C2404.095459,1055.588623 2407.426025,1054.134888 2411.522461,1053.897827 
	C2416.111816,1053.632324 2420.687256,1052.705322 2425.205078,1051.761719 
	C2428.830566,1051.004517 2432.042480,1049.456177 2434.074707,1045.953125 
	C2435.221436,1043.976440 2437.032959,1042.397339 2438.430908,1040.552734 
	C2447.079834,1029.140015 2460.094238,1024.793335 2472.546875,1019.661987 
	C2480.214355,1016.502380 2488.163574,1014.031311 2494.613525,1008.492188 
	C2495.603271,1007.642395 2496.737305,1006.690125 2497.948730,1006.410278 
	C2512.442627,1003.062195 2525.881104,997.152466 2538.916260,990.119385 
	C2541.039795,988.973694 2542.910889,987.993347 2544.097412,985.828552 
	C2547.628906,979.385254 2553.621094,976.969299 2561.236328,976.014160 
	C2562.000000,982.722595 2562.000000,989.445129 2562.000000,997.083862 
	C2561.532959,998.466309 2561.046631,998.912415 2560.502930,999.281250 
	C2557.690674,1001.188049 2553.115479,1001.346680 2553.364746,1006.304932 
	C2553.606201,1011.101807 2558.403320,1010.871094 2561.500000,1013.536926 
	C2562.000000,1022.713806 2562.000000,1031.427612 2562.000000,1041.070679 
	C2559.781738,1044.106934 2559.557373,1046.471191 2561.544434,1049.531006 
	C2562.000000,1052.133423 2562.000000,1054.266724 2562.000000,1057.200073 
	C2558.081299,1057.817383 2554.084961,1058.625366 2550.555908,1055.731201 
	C2547.881592,1053.537842 2544.959961,1051.877197 2547.071777,1047.713745 
	C2547.503174,1046.863525 2548.014893,1045.461548 2547.631348,1044.882446 
	C2543.893799,1039.239014 2543.570557,1034.559082 2549.312744,1029.535156 
	C2551.418457,1027.692871 2549.559326,1023.587585 2546.135742,1022.502808 
	C2542.889648,1021.474304 2539.650391,1021.752869 2536.798340,1024.268677 
	C2533.877197,1026.845215 2534.441895,1029.493042 2536.134277,1032.255249 
	C2538.811035,1036.624023 2536.132568,1040.670288 2535.202637,1044.669312 
	C2534.505127,1047.669067 2531.676514,1048.118774 2528.669434,1047.300171 
	C2521.798828,1045.429565 2518.130615,1050.224854 2514.978760,1054.815796 
	C2512.326416,1058.678833 2513.921631,1062.855957 2518.927734,1067.894165 
	C2521.703613,1070.687866 2524.167236,1073.800537 2528.712402,1074.192261 
	C2533.531250,1074.607910 2534.172363,1078.308594 2533.895020,1082.300659 
	C2533.701416,1085.088501 2531.677246,1086.246338 2529.439453,1087.090942 
	C2527.115723,1087.967896 2525.681641,1086.578979 2524.500000,1084.836426 
	C2523.009766,1082.637451 2521.413330,1080.493652 2520.118164,1078.182739 
	C2517.839844,1074.117920 2513.690918,1071.005737 2510.010254,1070.760498 
	C2502.646240,1070.270386 2497.820312,1068.742188 2495.865967,1060.694092 
	C2494.985107,1057.067139 2485.395508,1056.414429 2481.592773,1059.819092 
	C2476.694580,1064.204590 2469.542480,1067.824585 2473.637207,1076.912354 
	C2474.950684,1079.827148 2473.082520,1082.802979 2469.532471,1083.698364 
	C2466.328125,1084.506592 2463.097656,1085.589478 2459.843506,1085.730103 
	C2455.592285,1085.913818 2455.474854,1081.352173 2453.335938,1079.056274 
	C2449.900391,1075.368652 2445.585693,1072.006958 2440.463135,1073.137695 
	C2434.785889,1074.390991 2430.032227,1077.788574 2430.026367,1084.733154 
	C2430.021240,1090.623535 2425.775635,1093.261719 2421.675293,1096.224243 
	C2415.551514,1100.648682 2410.144775,1105.440918 2413.610352,1114.384644 
	C2414.712891,1117.230103 2412.951660,1118.744019 2409.920410,1120.132202 
	C2401.304199,1124.078125 2393.539062,1129.237915 2394.014893,1140.451904 
	C2394.174561,1144.217163 2392.162598,1145.743286 2388.914307,1146.627197 
	C2385.089355,1147.667847 2383.724365,1146.692505 2384.695068,1142.975586 
	C2385.446045,1140.099487 2386.705566,1137.355469 2387.752930,1134.557739 
	C2388.916748,1131.448975 2390.270264,1128.398315 2391.225586,1125.227539 
	C2392.417480,1121.270996 2392.851318,1117.356689 2388.775391,1114.481079 
	C2384.752441,1111.642456 2379.215332,1111.114746 2375.671875,1113.635620 
	C2371.634766,1116.507690 2368.726074,1120.287109 2370.339355,1125.488525 
	C2371.488770,1129.192993 2373.639404,1132.587036 2375.306396,1136.043823 
	C2373.783447,1138.014526 2372.326904,1136.922241 2370.809326,1136.380371 
	C2361.145020,1132.929565 2353.756592,1138.594360 2353.923096,1148.914551 
	C2353.980957,1152.503784 2357.442871,1155.957520 2354.818115,1159.448242 
	C2351.959717,1163.249390 2346.860107,1162.105347 2342.983154,1163.882446 
	C2340.514404,1165.013794 2337.077881,1166.989258 2335.479736,1162.612305 
	C2333.707275,1157.758423 2330.324951,1153.014038 2333.070068,1147.491333 
	C2333.885254,1145.850830 2335.984375,1146.192749 2337.556641,1145.789673 
	C2341.918701,1144.671753 2345.210449,1141.964966 2348.251465,1138.785400 
	C2350.414551,1136.523438 2352.008545,1134.500854 2350.704346,1130.930664 
	C2348.070068,1123.719727 2350.448975,1118.399292 2357.843262,1114.727539 
	C2358.240479,1113.639404 2358.480713,1113.278931 2359.224609,1112.495850 
	C2361.205078,1111.116577 2362.757080,1110.221924 2362.907227,1107.514282 
	C2361.750732,1102.378052 2360.143555,1098.337891 2354.323486,1099.583008 
	C2347.044434,1101.140503 2346.964111,1107.056396 2346.335449,1113.380615 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1137.143066 
	C2557.632812,1138.263550 2554.640381,1133.704712 2549.726807,1135.017822 
	C2542.059326,1137.066895 2538.820312,1141.071045 2537.995850,1151.214844 
	C2537.400635,1158.539429 2536.101318,1159.816040 2530.132080,1160.025635 
	C2526.177490,1160.164307 2523.776123,1158.499634 2522.639893,1154.889526 
	C2522.144775,1153.315674 2522.230225,1151.539429 2521.631104,1150.021240 
	C2518.778809,1142.795166 2510.784668,1140.755005 2504.809326,1145.629883 
	C2499.190674,1150.213745 2497.293945,1156.542969 2499.526611,1163.256836 
	C2502.216797,1171.345947 2503.425537,1172.291260 2511.648682,1169.695190 
	C2516.593506,1168.134155 2518.856934,1169.002563 2520.414062,1174.082153 
	C2522.848633,1182.024292 2522.743896,1183.618652 2517.495117,1186.418213 
	C2515.161133,1187.663208 2512.769775,1188.884155 2510.670898,1190.468994 
	C2506.874023,1193.336182 2504.915283,1196.822876 2507.592529,1201.667236 
	C2508.539795,1203.381104 2508.947021,1205.417236 2509.455322,1207.344482 
	C2510.505615,1211.326660 2509.419189,1213.729126 2504.825195,1214.073242 
	C2502.213623,1214.268921 2499.681641,1215.355591 2497.071533,1215.779175 
	C2492.525146,1216.516846 2488.349121,1216.219482 2486.437500,1210.960571 
	C2485.379395,1208.049072 2482.823975,1206.217041 2481.099365,1203.790771 
	C2478.157715,1199.652222 2474.961670,1196.926514 2469.403076,1199.281860 
	C2462.715820,1202.115479 2461.831543,1203.441162 2461.958740,1211.469116 
	C2462.007812,1214.555420 2462.476562,1217.469971 2464.054688,1220.083374 
	C2466.562988,1224.237671 2464.542969,1226.675537 2460.738525,1227.341187 
	C2452.308350,1228.816162 2447.627686,1232.944214 2447.835938,1241.999634 
	C2447.913574,1245.359619 2446.705322,1248.729126 2442.843262,1249.789795 
	C2438.386963,1251.013672 2433.791992,1252.644287 2429.831543,1248.467773 
	C2428.243652,1246.793091 2426.676758,1245.090454 2424.989502,1243.519531 
	C2420.899414,1239.711304 2416.377930,1239.003662 2411.214355,1241.406128 
	C2406.097900,1243.786621 2403.891113,1247.414551 2403.884766,1253.192627 
	C2403.874512,1262.202881 2400.029541,1266.021484 2392.723877,1265.994141 
	C2386.527344,1265.970947 2386.633545,1261.358154 2385.339111,1257.228882 
	C2384.003418,1252.966797 2385.543457,1251.428467 2389.286865,1249.819458 
	C2399.907715,1245.253784 2402.108887,1239.568970 2398.229248,1228.495361 
	C2395.845703,1221.692017 2396.618164,1220.538086 2403.953857,1220.018188 
	C2404.948486,1219.947632 2405.952148,1220.006714 2406.951660,1219.996216 
	C2410.660400,1219.957397 2414.481445,1220.166992 2415.720703,1215.385010 
	C2416.774658,1211.317871 2414.703369,1205.213867 2411.195801,1202.930298 
	C2409.837158,1202.045898 2408.114746,1201.736694 2406.593750,1201.082153 
	C2403.768311,1199.866333 2402.349121,1195.012939 2398.265137,1197.272705 
	C2393.681152,1199.809448 2391.516602,1205.451660 2392.695312,1209.212280 
	C2395.008545,1216.592041 2391.364990,1218.711548 2386.093506,1221.029297 
	C2383.689697,1222.086060 2381.676758,1224.004639 2379.314941,1225.190796 
	C2373.040283,1228.342285 2370.270264,1232.965088 2372.984375,1239.837769 
	C2374.406738,1243.439331 2373.207031,1245.583496 2369.906250,1246.951172 
	C2366.585693,1248.326904 2362.280273,1248.941772 2361.201660,1245.239258 
	C2358.839844,1237.131592 2352.986328,1237.808594 2346.954102,1238.005615 
	C2343.314209,1238.124634 2339.596436,1237.494995 2336.087402,1238.983765 
	C2331.825195,1240.792358 2329.810059,1238.404419 2328.684814,1234.851929 
	C2327.350830,1230.640015 2328.045410,1226.255127 2328.098633,1221.946899 
	C2328.161865,1216.851074 2332.692627,1216.005249 2335.986572,1213.951416 
	C2342.609863,1209.822144 2344.713623,1204.888916 2343.382812,1197.043823 
	C2342.083008,1189.380859 2342.890137,1188.359375 2350.458496,1188.005249 
	C2355.970947,1187.747192 2361.450195,1187.492798 2362.687256,1194.881958 
	C2362.788086,1195.483521 2363.288330,1196.084595 2363.741943,1196.550415 
	C2367.419189,1200.325195 2370.783447,1205.981201 2376.472168,1205.032227 
	C2382.163574,1204.082764 2384.607178,1198.144653 2385.282959,1192.827148 
	C2386.454346,1183.608643 2394.159424,1181.145508 2400.261475,1177.049683 
	C2403.001953,1175.210205 2404.929443,1176.560059 2406.248291,1179.772217 
	C2410.112305,1189.181519 2416.738770,1195.786621 2426.801758,1198.556274 
	C2428.066650,1198.904419 2429.275879,1199.571045 2430.411621,1200.254761 
	C2437.516846,1204.532227 2437.543457,1209.321777 2430.363281,1213.740356 
	C2427.823730,1215.303101 2424.976074,1216.359619 2422.296631,1217.701782 
	C2417.458496,1220.124878 2416.260010,1225.461060 2420.260254,1228.660278 
	C2423.597656,1231.329224 2427.495850,1233.502441 2431.957275,1233.902832 
	C2439.198730,1234.552612 2443.716797,1230.400757 2443.984131,1222.958618 
	C2444.067871,1220.629395 2444.124512,1218.287354 2443.983154,1215.964111 
	C2443.728271,1211.779663 2445.441406,1208.949219 2449.322021,1207.343140 
	C2450.856689,1206.708130 2452.276367,1205.801880 2453.792969,1205.117798 
	C2457.702393,1203.354736 2460.766113,1201.126831 2459.698730,1196.074951 
	C2458.610840,1190.926758 2454.669434,1186.610474 2449.881836,1186.117188 
	C2445.938965,1185.710693 2441.876709,1186.351318 2438.236816,1184.098999 
	C2434.785400,1181.963501 2431.768799,1179.532593 2430.221680,1175.564575 
	C2427.273926,1168.004761 2425.579834,1166.908081 2418.003662,1168.408325 
	C2414.761719,1169.050171 2411.537842,1171.084595 2409.000732,1167.433350 
	C2406.309082,1163.559570 2404.643311,1159.115845 2404.616699,1154.441284 
	C2404.601807,1151.808716 2407.616699,1151.045288 2409.769043,1150.398071 
	C2413.659180,1149.228638 2417.208008,1147.664795 2420.215088,1144.823242 
	C2423.702881,1141.527466 2426.614014,1138.183838 2426.076416,1132.832642 
	C2425.746826,1129.549438 2425.666992,1125.801758 2429.825439,1124.562622 
	C2433.590332,1123.440674 2434.789551,1126.658569 2436.660645,1129.009766 
	C2442.849365,1136.785278 2453.373047,1138.297974 2461.695312,1132.904663 
	C2465.574707,1130.390625 2466.205811,1126.636841 2466.035645,1122.430786 
	C2465.897217,1119.008911 2466.097168,1115.516235 2470.250732,1114.416016 
	C2472.476562,1113.826294 2475.247559,1113.258301 2476.765381,1115.406738 
	C2478.876709,1118.394653 2478.677246,1122.020630 2476.097900,1124.561035 
	C2472.366211,1128.236328 2471.743652,1132.498535 2471.987549,1137.333252 
	C2472.159180,1140.741333 2473.713379,1142.818237 2476.679688,1144.326538 
	C2480.071777,1146.051147 2482.405518,1145.496826 2483.750732,1141.837524 
	C2484.438965,1139.965332 2485.325684,1138.109863 2485.642334,1136.168579 
	C2486.416260,1131.420166 2489.869873,1128.951782 2493.816895,1128.537109 
	C2500.734131,1127.810303 2504.148682,1123.874634 2507.306152,1118.271729 
	C2509.043701,1115.188110 2510.498779,1109.150879 2515.256348,1110.726318 
	C2520.735352,1112.540527 2516.386963,1117.404663 2516.208008,1120.972656 
	C2516.092041,1123.288452 2515.794434,1125.754395 2516.416016,1127.911499 
	C2517.413574,1131.374146 2518.613525,1134.966675 2523.024902,1135.860352 
	C2527.401123,1136.747070 2529.948730,1134.512329 2531.912842,1131.094971 
	C2533.567871,1128.214722 2535.257812,1125.348755 2536.773438,1122.395020 
	C2540.069092,1115.972534 2545.145752,1112.331787 2553.224854,1112.001343 
	C2557.489502,1115.727051 2557.407227,1121.383179 2561.519287,1125.516846 
	C2562.000000,1129.428711 2562.000000,1132.857422 2562.000000,1137.143066 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2562.000000,777.250000 
	C2560.739746,778.369507 2559.386230,778.555237 2558.234619,779.139160 
	C2551.725830,782.439331 2551.741943,782.471802 2551.823730,775.146790 
	C2551.901367,768.162720 2547.622314,765.291138 2540.755371,767.621643 
	C2539.009766,768.214111 2537.479492,770.184326 2534.892334,768.455261 
	C2534.855225,764.221863 2538.674805,763.723999 2541.384033,762.530090 
	C2550.181152,758.653564 2551.426514,756.613159 2549.549316,747.669128 
	C2549.209961,746.052612 2548.603027,744.491943 2548.113037,742.907410 
	C2546.467529,737.582947 2545.346924,737.065674 2540.740479,740.451782 
	C2538.281494,742.259338 2536.083740,744.368652 2532.827148,743.981201 
	C2527.000000,743.287781 2527.104004,749.834595 2523.484131,751.468933 
	C2519.660400,753.195312 2514.779785,750.681641 2511.115723,754.043030 
	C2508.325195,756.602966 2507.071045,759.315613 2509.810303,762.672668 
	C2510.857178,763.955627 2512.246582,765.086121 2512.888916,766.546143 
	C2514.328613,769.817444 2511.828369,771.598511 2509.527100,772.772095 
	C2506.834961,774.145203 2506.496826,771.581909 2505.656250,769.805359 
	C2503.023438,764.240723 2503.329590,757.280701 2497.525146,753.176941 
	C2495.926025,752.046448 2497.269531,750.138428 2497.486084,748.550537 
	C2497.751953,746.599792 2498.057373,744.533081 2497.693359,742.641968 
	C2496.792236,737.960693 2490.843750,733.535583 2486.812012,734.215210 
	C2482.754395,734.899231 2480.300537,738.504272 2479.998291,743.846375 
	C2479.893066,745.708923 2481.633545,747.641663 2479.424805,749.837402 
	C2474.649170,748.363037 2473.432617,743.435913 2470.655273,740.051147 
	C2467.699707,736.448853 2462.307129,739.579468 2459.150146,736.489319 
	C2460.345215,733.274963 2462.674561,734.336670 2464.449219,733.994263 
	C2470.637939,732.800171 2474.339844,727.491943 2470.869385,722.712524 
	C2466.917480,717.270630 2466.839111,712.313293 2467.737061,706.302856 
	C2468.196777,703.225891 2466.377686,699.875671 2466.154785,696.610168 
	C2465.936035,693.413086 2467.333496,691.387451 2471.521484,693.479248 
	C2472.353516,694.548767 2472.651367,695.125488 2472.930420,695.712830 
	C2474.376953,698.757324 2473.932861,703.542786 2478.712158,703.701050 
	C2482.752197,703.834839 2482.873535,699.213928 2485.528809,696.501587 
	C2485.580566,695.095032 2485.122803,694.205688 2484.750488,693.281677 
	C2484.091064,691.644958 2483.819336,689.860168 2485.653076,688.962158 
	C2486.905029,688.349060 2488.103516,689.371826 2489.139893,690.263733 
	C2491.672363,692.443176 2491.737549,695.368286 2492.104736,698.398987 
	C2492.788574,704.042725 2493.775146,704.550781 2499.205566,703.277832 
	C2506.201172,701.638062 2507.406250,700.528809 2510.257568,693.104614 
	C2513.090332,702.126648 2513.066895,702.382385 2506.097168,706.189392 
	C2503.697754,707.500061 2501.027588,708.791931 2500.830078,711.642883 
	C2500.590332,715.107483 2503.615723,716.687256 2506.272217,718.040527 
	C2508.018555,718.930237 2509.957031,719.698425 2511.881592,719.934937 
	C2517.965820,720.682556 2520.667725,723.854553 2520.038574,730.009583 
	C2519.672363,733.594543 2520.770752,736.554443 2524.387207,738.152405 
	C2526.225342,738.964600 2528.029297,740.120850 2529.964111,738.671021 
	C2532.126709,737.050537 2534.472168,735.087097 2533.546387,732.119507 
	C2532.098633,727.478455 2531.156738,722.785767 2526.862061,719.169434 
	C2518.409424,712.051819 2517.941406,706.383179 2524.076660,696.894775 
	C2526.307373,693.445007 2526.284668,690.123108 2525.172119,686.466797 
	C2524.445801,684.081116 2521.966309,682.121521 2523.284424,678.976929 
	C2532.863037,679.322815 2537.234131,688.343018 2544.851318,691.343872 
	C2545.065918,693.598511 2543.011475,694.363892 2542.627930,695.923401 
	C2541.561768,700.259521 2541.170410,704.642517 2545.080322,707.856384 
	C2548.896973,710.993774 2552.975830,710.740723 2557.014404,707.998291 
	C2558.094727,707.264893 2559.346680,706.784485 2561.259766,706.093933 
	C2562.000000,716.044189 2562.000000,726.088379 2562.000000,737.066284 
	C2555.745850,743.356079 2555.856445,749.063904 2561.528809,755.526489 
	C2562.000000,757.500000 2562.000000,759.000000 2562.000000,761.250000 
	C2558.662354,764.726013 2559.052002,767.822754 2561.548340,771.542053 
	C2562.000000,773.500000 2562.000000,775.000000 2562.000000,777.250000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2536.512695,1724.491699 
	C2537.575928,1720.866699 2540.204102,1718.702759 2543.427246,1716.279785 
	C2544.850098,1715.196533 2545.587646,1714.317993 2545.949707,1712.577637 
	C2545.856445,1709.627686 2546.446777,1707.157837 2544.531738,1704.475098 
	C2541.893066,1701.782104 2539.528809,1701.557007 2536.468994,1703.544189 
	C2530.946533,1703.377930 2528.120850,1705.043823 2527.312256,1710.621704 
	C2526.821045,1714.009521 2525.779541,1717.676880 2522.686279,1720.229126 
	C2518.113281,1724.002075 2513.332520,1724.109009 2509.532959,1720.164551 
	C2505.384766,1715.858032 2505.433105,1711.903198 2509.721191,1707.301514 
	C2510.621094,1706.335571 2511.829834,1705.583496 2512.498047,1704.489624 
	C2514.223877,1701.664307 2520.263916,1702.928101 2519.407227,1698.647705 
	C2518.544678,1694.336182 2516.204102,1690.023682 2510.702148,1688.084351 
	C2507.173096,1687.941528 2505.035156,1689.463867 2502.468262,1691.538696 
	C2502.071533,1695.544189 2501.677490,1698.815918 2496.709717,1699.912964 
	C2493.324707,1694.609619 2488.245605,1693.610107 2482.506592,1692.445312 
	C2483.000488,1690.230713 2484.000977,1688.461426 2485.500732,1686.346191 
	C2490.797607,1685.844482 2492.655762,1682.049194 2495.469727,1678.390259 
	C2502.097168,1677.735352 2509.156250,1680.551636 2513.446289,1672.362793 
	C2518.432861,1671.326050 2522.343994,1674.786011 2527.290527,1672.731323 
	C2532.495605,1670.569336 2537.008057,1668.994385 2536.117920,1662.135986 
	C2535.896973,1660.433472 2536.817139,1659.022339 2539.265137,1658.163086 
	C2548.825684,1667.089600 2550.344971,1666.996704 2557.494629,1656.480957 
	C2558.888916,1656.000000 2559.777832,1656.000000 2561.333496,1656.000000 
	C2562.000000,1660.083374 2562.000000,1664.166626 2562.000000,1669.125000 
	C2561.517090,1670.458618 2561.049072,1670.942993 2560.505127,1671.322144 
	C2550.909668,1678.011597 2550.959961,1679.582275 2561.479980,1685.529785 
	C2562.000000,1686.888916 2562.000000,1687.777832 2562.000000,1689.333374 
	C2561.304443,1690.677490 2560.674072,1691.428223 2559.937012,1692.054565 
	C2550.343750,1700.209229 2550.533447,1703.686646 2561.499512,1711.530518 
	C2562.000000,1714.133423 2562.000000,1716.266724 2562.000000,1719.200073 
	C2558.405762,1720.855835 2552.962891,1717.571167 2552.026855,1725.220459 
	C2546.857178,1727.891602 2542.010986,1725.413940 2536.512695,1724.491699 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2556.750000,1994.000000 
	C2555.914062,1990.060303 2555.506592,1986.272705 2550.693848,1984.119141 
	C2544.142334,1985.100220 2542.120117,1980.172729 2538.493164,1976.498535 
	C2534.061523,1973.262817 2532.294434,1969.506958 2531.046875,1964.801392 
	C2529.771973,1959.992310 2530.964111,1956.889893 2534.761719,1954.840698 
	C2540.630371,1951.674194 2541.405029,1946.155151 2541.919434,1940.625732 
	C2543.089600,1928.051514 2544.383301,1926.669434 2557.333740,1926.008301 
	C2558.319092,1925.957886 2559.309082,1926.000610 2561.148438,1926.000000 
	C2562.000000,1932.722534 2562.000000,1939.445190 2562.000000,1947.083862 
	C2560.373535,1950.092407 2557.669189,1950.570679 2555.208252,1952.569824 
	C2554.328125,1953.178955 2553.966309,1953.408081 2553.048340,1953.950439 
	C2548.513916,1956.207520 2547.851074,1958.635010 2551.913086,1962.066406 
	C2553.063721,1962.991821 2553.692627,1963.550537 2554.759277,1964.552490 
	C2556.728516,1967.014648 2559.330811,1967.512939 2561.563721,1969.575439 
	C2562.000000,1977.385864 2562.000000,1984.771606 2562.000000,1993.078735 
	C2560.500000,1994.000000 2559.000000,1994.000000 2556.750000,1994.000000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,199.062729 
	C2556.605713,201.446808 2551.282959,203.452011 2545.822021,199.925201 
	C2542.256104,197.622345 2539.691895,194.987595 2540.048096,190.387680 
	C2540.379150,186.112213 2542.100830,182.805923 2546.163330,180.990280 
	C2546.464600,180.855560 2546.772705,180.735977 2547.072266,180.597427 
	C2556.730957,176.129379 2557.627441,175.070587 2555.260742,165.193268 
	C2553.807617,159.128113 2554.890137,154.936203 2561.280762,152.090622 
	C2562.000000,167.375153 2562.000000,182.750305 2562.000000,199.062729 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000009,1128.500000 
	C3.567476,1126.790161 5.089875,1125.515869 6.710614,1124.382202 
	C12.268015,1120.494873 15.555657,1121.086182 17.985432,1127.591553 
	C20.032362,1133.071899 23.441010,1134.464722 28.657085,1134.049438 
	C31.956379,1133.786865 35.296463,1134.086792 38.614750,1134.000122 
	C42.734837,1133.892700 45.726345,1135.722656 47.370445,1139.358887 
	C48.658588,1142.207764 44.857456,1149.994995 41.338650,1152.174683 
	C37.977623,1154.256714 34.469719,1154.932129 31.234488,1152.043091 
	C29.015802,1150.061890 25.896938,1148.072876 25.244608,1145.552979 
	C23.603041,1139.211792 18.917070,1137.526733 13.712646,1136.232178 
	C9.701200,1135.234253 7.018542,1131.967896 2.640363,1130.286621 
	C2.000000,1130.000000 2.000000,1129.000000 2.000009,1128.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,422.937256 
	C6.566569,422.210052 11.195387,421.371765 15.568831,423.774445 
	C19.391531,425.874603 20.653383,428.738342 19.407978,432.783173 
	C19.022198,434.036072 18.397587,435.223267 17.811731,436.405548 
	C13.503158,445.100281 11.314017,454.415192 9.989594,463.937347 
	C9.437931,467.903625 7.496779,469.853638 2.786513,469.982056 
	C2.000000,454.624847 2.000000,439.249664 2.000000,422.937256 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,358.750000 
	C11.099372,355.890045 16.804361,349.966492 20.356014,341.637939 
	C21.659239,338.581940 22.972183,335.550049 25.792831,333.502930 
	C27.840181,332.017029 30.203573,331.429138 32.264515,332.831879 
	C34.804630,334.560791 33.396889,336.919281 32.418133,339.024841 
	C32.278713,339.324768 32.195595,339.716156 31.958212,339.895752 
	C24.820883,345.295044 25.963596,353.006317 25.936003,360.536011 
	C25.903393,369.434387 20.255070,372.784119 12.215056,368.700714 
	C9.294951,367.217651 6.743969,365.000977 2.734601,364.083801 
	C2.000000,362.500000 2.000000,361.000000 2.000000,358.750000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2548.290527,1908.560059 
	C2547.704346,1905.135010 2546.180176,1903.510742 2543.337891,1904.570801 
	C2540.473145,1905.639282 2538.110107,1905.587158 2536.224121,1903.084839 
	C2533.411865,1899.352783 2530.813477,1895.410522 2530.408203,1890.630493 
	C2530.224609,1888.465942 2531.966309,1886.803467 2534.033203,1886.426758 
	C2537.626221,1885.771973 2541.348877,1885.280884 2544.598877,1887.739868 
	C2547.012695,1889.565918 2549.592529,1891.040283 2553.266113,1891.916260 
	C2555.234619,1891.848999 2556.398438,1892.094971 2558.014404,1892.955444 
	C2559.745850,1894.348999 2560.138184,1895.980469 2561.580566,1897.592285 
	C2562.000000,1903.400024 2562.000000,1908.800049 2562.000000,1915.100098 
	C2558.914795,1916.240112 2557.897949,1912.836182 2554.654297,1912.101074 
	C2551.722412,1911.926514 2550.080322,1910.657349 2548.290527,1908.560059 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2562.000000,453.091797 
	C2558.430908,454.363007 2555.218018,456.176208 2551.462402,456.076141 
	C2544.390869,455.887726 2540.328369,453.127380 2538.496582,446.531433 
	C2536.784668,440.368530 2538.432373,437.888458 2544.759766,435.835510 
	C2549.853760,434.182739 2554.995361,433.830750 2561.125244,434.000000 
	C2562.000000,440.061188 2562.000000,446.122375 2562.000000,453.091797 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,127.078728 
	C2558.827148,128.061844 2555.951172,130.571808 2552.423828,128.282135 
	C2547.465820,125.063728 2542.656494,121.248291 2542.554443,115.334290 
	C2542.443359,108.867546 2548.754395,107.529793 2553.765869,105.825798 
	C2555.949463,105.083275 2558.228027,104.619789 2561.231934,104.014771 
	C2562.000000,111.385818 2562.000000,118.771637 2562.000000,127.078728 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,1050.888306 
	C5.494925,1050.341187 8.376913,1048.589111 11.463017,1047.381470 
	C17.725840,1044.930664 22.016287,1045.913696 23.566669,1049.847046 
	C25.950500,1055.894897 22.673780,1063.905518 16.618176,1065.287109 
	C12.493241,1066.228271 8.058182,1065.810303 2.880886,1066.000000 
	C2.000000,1061.258911 2.000000,1056.517700 2.000000,1050.888306 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2554.724609,2110.501465 
	C2548.538086,2110.569824 2544.418701,2108.854980 2541.813721,2103.647949 
	C2537.893799,2095.812988 2541.700928,2089.981934 2550.551270,2089.896729 
	C2554.633057,2089.857178 2557.068604,2092.845947 2561.250244,2093.902832 
	C2562.000000,2098.741211 2562.000000,2103.482178 2562.000000,2109.111816 
	C2560.015625,2111.635742 2557.854980,2112.120361 2554.724609,2110.501465 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000000,1236.799927 
	C4.919480,1236.067017 6.789048,1233.994629 8.994177,1232.589844 
	C12.166400,1230.568848 15.622458,1229.663208 19.397285,1230.044067 
	C24.505650,1230.559204 26.929678,1233.250854 25.558552,1237.902222 
	C24.547628,1241.331787 22.957327,1244.845337 20.731243,1247.598755 
	C17.823208,1251.195435 13.682705,1250.666870 9.931475,1248.558594 
	C7.665037,1247.284790 6.266589,1244.672119 2.721745,1244.086182 
	C2.000000,1241.866577 2.000000,1239.733276 2.000000,1236.799927 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,2037.083862 
	C2559.354980,2037.999512 2556.709717,2038.028320 2554.065186,2037.991943 
	C2549.785156,2037.933105 2545.165039,2038.573853 2544.100342,2032.509521 
	C2543.074951,2026.670898 2545.157227,2021.300781 2550.080322,2019.132812 
	C2553.358154,2017.689453 2556.984131,2017.036865 2561.227295,2016.015137 
	C2562.000000,2022.722534 2562.000000,2029.445190 2562.000000,2037.083862 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,584.908203 
	C8.245608,581.049377 15.354428,579.999390 21.000360,575.210388 
	C18.459789,586.997070 17.829668,599.652588 2.709469,603.923462 
	C2.000000,597.938782 2.000000,591.877625 2.000000,584.908203 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2562.000000,693.125000 
	C2559.807129,693.350647 2557.625977,692.657593 2555.418213,692.063782 
	C2553.000488,691.413391 2552.220215,689.942749 2553.184082,687.672668 
	C2554.821045,683.816833 2552.281250,680.660828 2551.410400,677.274109 
	C2550.512939,673.786072 2548.172119,671.764160 2544.190918,671.966370 
	C2540.602783,672.148560 2537.135254,671.664490 2534.326416,666.898560 
	C2543.458496,665.153503 2551.860840,666.394287 2561.071533,666.000000 
	C2562.000000,666.888916 2562.000000,667.777771 2562.000000,669.333374 
	C2559.284180,672.805969 2559.500000,675.894897 2561.560059,679.559692 
	C2562.000000,684.083313 2562.000000,688.166687 2562.000000,693.125000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,1212.888306 
	C5.939702,1211.796753 10.000766,1212.679688 13.782454,1211.046265 
	C17.969782,1209.237549 20.022411,1211.359497 21.275234,1214.909668 
	C22.488688,1218.348145 22.392090,1222.028198 18.563660,1223.305176 
	C13.616308,1224.955444 9.250071,1228.632202 2.796231,1227.998291 
	C2.000000,1223.258911 2.000000,1218.517700 2.000000,1212.888306 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2553.884033,2110.680176 
	C2556.133301,2110.000000 2558.266846,2110.000000 2561.200195,2110.000000 
	C2562.000000,2116.061279 2562.000000,2122.122314 2562.000000,2129.091797 
	C2559.866699,2130.000000 2557.733154,2130.000000 2554.799805,2130.000000 
	C2552.002441,2131.269287 2550.490479,2130.188477 2548.503662,2128.484375 
	C2547.379883,2125.792725 2546.759766,2123.585693 2546.069824,2120.689209 
	C2545.386719,2114.240479 2552.186035,2115.145996 2553.884033,2110.680176 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2545.447510,1832.572266 
	C2551.640625,1830.349487 2555.372559,1835.652466 2561.236328,1835.986084 
	C2562.000000,1838.777832 2562.000000,1841.555542 2562.000000,1845.166748 
	C2557.096680,1850.351562 2551.605713,1851.541382 2544.717773,1848.539551 
	C2538.269531,1842.684937 2539.541260,1837.791870 2545.447510,1832.572266 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1591.166748 
	C2559.521973,1591.992554 2557.784912,1593.558350 2555.829590,1594.765137 
	C2552.631592,1596.738403 2549.594482,1596.194092 2546.828125,1593.700806 
	C2543.727783,1590.906372 2543.365234,1587.332031 2544.546387,1583.749390 
	C2545.838135,1579.831543 2549.479980,1579.771606 2552.793457,1580.087646 
	C2555.365234,1580.333130 2557.877441,1581.202393 2561.208008,1581.897217 
	C2562.000000,1584.777832 2562.000000,1587.555542 2562.000000,1591.166748 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000017,1308.500000 
	C3.796788,1306.574829 5.470500,1304.945190 7.419182,1303.772461 
	C10.313130,1302.031250 13.127369,1298.401733 16.875324,1302.337158 
	C20.118559,1305.742798 21.233389,1314.376221 18.672676,1317.103271 
	C16.034857,1319.912354 13.045145,1319.661987 9.709271,1317.909058 
	C6.532447,1316.239502 6.042615,1312.442383 2.605171,1310.317139 
	C2.000000,1310.000000 2.000000,1309.000000 2.000017,1308.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,748.916138 
	C2.329095,748.000488 2.662460,748.035889 2.986639,747.996216 
	C8.682554,747.299072 13.376909,750.017578 14.775280,754.873413 
	C16.172466,759.725159 12.555158,764.147461 8.777880,767.432800 
	C7.365078,768.661621 5.233249,769.063721 2.714636,769.921387 
	C2.000000,763.277405 2.000000,756.554871 2.000000,748.916138 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1711.083862 
	C2553.801758,1711.320923 2551.186035,1709.345459 2550.171875,1703.066895 
	C2549.112305,1696.507324 2551.529785,1693.495239 2561.259033,1690.087646 
	C2562.000000,1696.722534 2562.000000,1703.445190 2562.000000,1711.083862 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,490.916138 
	C6.478532,490.098236 11.433805,488.899170 13.371955,495.015564 
	C15.116189,500.520050 13.102391,504.549530 8.999822,508.028290 
	C7.259485,509.503906 5.847498,511.411835 2.703034,511.920776 
	C2.000000,505.277435 2.000000,498.554840 2.000000,490.916138 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,886.833313 
	C4.315916,886.041260 6.518043,885.619263 8.704956,884.786255 
	C11.634017,883.670715 14.840812,883.448975 16.654747,886.398438 
	C18.817022,889.914429 18.724871,893.960571 16.715881,897.590027 
	C15.448167,899.880188 13.093767,900.190125 10.690304,899.212952 
	C8.271936,898.229736 5.877870,897.186768 2.736580,896.084961 
	C2.000000,893.222229 2.000000,890.444397 2.000000,886.833313 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1779.125000 
	C2560.724609,1780.300903 2559.447266,1780.592896 2558.174316,1780.903687 
	C2550.625000,1782.746338 2548.789307,1782.148682 2548.095215,1777.613159 
	C2547.057617,1770.832031 2549.979492,1766.704590 2556.362549,1766.032471 
	C2557.665283,1765.895142 2558.993652,1766.004395 2561.155273,1766.000000 
	C2562.000000,1770.083374 2562.000000,1774.166626 2562.000000,1779.125000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000000,1190.888306 
	C5.974331,1189.831177 9.953236,1189.970947 12.921004,1193.043335 
	C15.269030,1195.474121 16.569645,1198.500244 15.555243,1201.970947 
	C14.540986,1205.441162 11.661440,1205.967529 8.571602,1205.982666 
	C6.944023,1205.990601 5.316423,1205.994385 2.844417,1206.000000 
	C2.000000,1201.258911 2.000000,1196.517700 2.000000,1190.888306 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,245.083862 
	C2553.933350,244.373825 2552.500488,243.045715 2552.016846,236.746597 
	C2551.407959,228.815903 2552.614746,226.996780 2561.227051,224.014709 
	C2562.000000,230.722580 2562.000000,237.445145 2562.000000,245.083862 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2562.000000,499.091797 
	C2560.024658,499.883453 2557.877686,500.226349 2556.106445,499.563965 
	C2550.854492,497.599579 2549.215088,491.503967 2552.267822,486.653595 
	C2554.274170,483.465973 2556.702637,480.914856 2561.286621,480.078674 
	C2562.000000,486.061188 2562.000000,492.122375 2562.000000,499.091797 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,313.111664 
	C2561.674316,313.999237 2561.346191,314.022736 2561.022949,313.994232 
	C2552.547607,313.248535 2548.473877,310.552277 2548.641113,305.806000 
	C2548.790771,301.558777 2552.401367,299.169830 2561.216797,298.001648 
	C2562.000000,302.741119 2562.000000,307.482208 2562.000000,313.111664 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1013.111694 
	C2560.703857,1013.996460 2559.399170,1014.090027 2558.113281,1013.972900 
	C2551.543213,1013.374084 2550.329590,1012.279907 2550.026611,1006.836853 
	C2549.685303,1000.706238 2551.084717,999.013855 2557.413574,998.039551 
	C2558.364014,997.893311 2559.354736,998.007080 2561.163330,998.000305 
	C2562.000000,1002.741150 2562.000000,1007.482239 2562.000000,1013.111694 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1685.111694 
	C2561.026855,1685.999146 2560.053223,1685.982178 2559.080322,1686.000366 
	C2554.601074,1686.083740 2550.449219,1685.780640 2550.059814,1679.812744 
	C2549.733154,1674.806030 2551.822510,1671.938354 2557.511719,1670.133545 
	C2558.404297,1669.850098 2559.445312,1670.034790 2561.208984,1670.001465 
	C2562.000000,1674.741089 2562.000000,1679.482300 2562.000000,1685.111694 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,1348.908203 
	C5.300163,1348.629028 9.566186,1346.294189 11.592710,1350.835815 
	C13.322222,1354.711792 11.596040,1360.752686 7.971338,1364.099365 
	C6.540791,1365.420044 4.927026,1366.542358 2.698345,1367.877441 
	C2.000000,1361.938843 2.000000,1355.877563 2.000000,1348.908203 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2551.471436,1952.575928 
	C2552.000000,1952.000000 2553.000000,1952.000000 2553.500000,1952.000000 
	C2555.983398,1950.361450 2558.141357,1949.859009 2561.275391,1951.496582 
	C2562.000000,1956.083374 2562.000000,1960.166626 2562.000000,1965.125000 
	C2560.016602,1967.638306 2557.858643,1968.141113 2554.724609,1966.503418 
	C2553.366211,1965.780273 2552.849365,1965.401367 2552.224609,1964.431641 
	C2548.547607,1960.686035 2547.110840,1957.175659 2551.471436,1952.575928 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,1426.888306 
	C5.100893,1425.904297 7.759452,1426.447144 9.689396,1429.390137 
	C14.116986,1436.141479 12.123041,1440.420044 2.794688,1441.997803 
	C2.000000,1437.258911 2.000000,1432.517700 2.000000,1426.888306 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000000,1262.899902 
	C6.541860,1261.841919 9.711359,1263.205444 9.991546,1268.481812 
	C10.270991,1273.744263 10.095373,1278.552734 2.759903,1279.906372 
	C2.000000,1274.599976 2.000000,1269.199951 2.000000,1262.899902 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2.000000,1378.856934 
	C3.292803,1378.002563 4.585675,1377.997681 5.878395,1378.009399 
	C9.190724,1378.039429 12.873676,1378.044922 13.482286,1382.218506 
	C14.099284,1386.449829 11.041568,1388.575439 7.410645,1389.712891 
	C6.215360,1390.087280 4.849691,1389.917847 2.780968,1389.998535 
	C2.000000,1386.571289 2.000000,1383.142578 2.000000,1378.856934 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2562.000000,2057.125000 
	C2560.717529,2057.894043 2559.334961,2058.060303 2558.170410,2057.633057 
	C2554.148438,2056.157227 2551.593994,2053.389404 2552.273193,2048.854736 
	C2552.976318,2044.160400 2556.717773,2043.980347 2561.208740,2044.001831 
	C2562.000000,2048.083252 2562.000000,2052.166748 2562.000000,2057.125000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2.000000,654.899963 
	C10.162573,654.937134 11.305343,656.253967 9.116237,663.417969 
	C8.127763,666.652893 8.053149,670.848877 2.735608,671.903137 
	C2.000000,666.599976 2.000000,661.199951 2.000000,654.899963 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,755.100037 
	C2556.526367,755.198242 2554.233154,751.919250 2553.945557,746.506287 
	C2553.683105,741.560547 2556.132812,739.239868 2561.248047,738.091370 
	C2562.000000,743.400024 2562.000000,748.800049 2562.000000,755.100037 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2562.000000,431.100037 
	C2557.377197,430.182892 2554.364258,427.107269 2554.064453,421.890961 
	C2553.802246,417.325897 2555.270020,414.180023 2561.221191,414.016907 
	C2562.000000,419.400024 2562.000000,424.800049 2562.000000,431.100037 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1125.111694 
	C2554.564209,1124.940796 2553.701416,1119.642578 2554.000000,1112.797607 
	C2556.105469,1111.024048 2558.146240,1109.833618 2561.299805,1110.006348 
	C2562.000000,1114.741089 2562.000000,1119.482300 2562.000000,1125.111694 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2558.619141,1894.441406 
	C2556.896484,1893.653198 2555.792725,1893.306519 2554.344727,1892.479980 
	C2554.458252,1887.103027 2552.062744,1880.670410 2561.219482,1880.016968 
	C2562.000000,1884.083374 2562.000000,1888.166626 2562.000000,1893.125000 
	C2561.227295,1894.756836 2560.306641,1895.050903 2558.619141,1894.441406 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2544.095215,1848.729492 
	C2549.596436,1848.515869 2554.995117,1847.380371 2561.184570,1846.019775 
	C2562.000000,1847.500000 2562.000000,1849.000000 2562.000000,1851.250000 
	C2558.496094,1852.109009 2554.988037,1851.727783 2551.565430,1853.129883 
	C2547.915039,1854.625488 2545.347412,1853.299561 2544.095215,1848.729492 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,2077.125000 
	C2557.488037,2078.486572 2555.019775,2075.999512 2554.465332,2071.964355 
	C2553.869141,2067.625244 2556.915283,2065.502930 2561.289795,2064.083984 
	C2562.000000,2068.083252 2562.000000,2072.166748 2562.000000,2077.125000 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,939.111694 
	C2554.236572,934.635742 2553.824463,930.231201 2561.260742,924.100769 
	C2562.000000,928.741150 2562.000000,933.482239 2562.000000,939.111694 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,825.200012 
	C2560.366211,825.987976 2558.731445,826.013000 2557.099121,825.955017 
	C2554.671143,825.868896 2552.435059,825.408020 2552.279297,822.339417 
	C2552.095703,818.714417 2554.516846,818.071228 2557.398926,818.031189 
	C2558.379150,818.017578 2559.359375,818.010803 2561.169922,818.000488 
	C2562.000000,820.133362 2562.000000,822.266663 2562.000000,825.200012 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1821.125000 
	C2554.164551,1818.047607 2553.750488,1814.177734 2561.261719,1808.099854 
	C2562.000000,1812.083374 2562.000000,1816.166626 2562.000000,1821.125000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1635.143066 
	C2558.242920,1635.699707 2556.231934,1633.727783 2556.057617,1629.904297 
	C2555.911621,1626.704834 2556.503662,1624.124268 2561.233887,1624.025391 
	C2562.000000,1627.428711 2562.000000,1630.857422 2562.000000,1635.143066 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2.000000,1078.856934 
	C9.658432,1081.838989 9.941506,1084.161255 2.719928,1089.906250 
	C2.000000,1086.571289 2.000000,1083.142578 2.000000,1078.856934 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1.999998,1324.799927 
	C3.247774,1324.312866 4.596879,1324.422607 5.720872,1324.983521 
	C7.672208,1325.957397 10.337534,1326.776855 9.355014,1329.791260 
	C8.418678,1332.663818 5.661146,1331.729858 2.764028,1331.997559 
	C2.000000,1329.866577 2.000000,1327.733276 1.999998,1324.799927 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,771.166687 
	C2555.300049,768.285217 2555.011475,766.198730 2561.318848,762.077820 
	C2562.000000,764.777771 2562.000000,767.555603 2562.000000,771.166687 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,679.166687 
	C2556.975830,676.886047 2556.762939,675.438171 2561.286621,670.145325 
	C2562.000000,672.777771 2562.000000,675.555603 2562.000000,679.166687 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1049.200073 
	C2557.037109,1047.398438 2556.890869,1046.574951 2561.313965,1042.131226 
	C2562.000000,1044.133423 2562.000000,1046.266724 2562.000000,1049.200073 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2562.000000,1951.333374 
	C2559.866699,1952.000000 2557.733154,1952.000000 2554.799805,1952.000000 
	C2554.391113,1947.777832 2557.530029,1948.026611 2561.250977,1948.001953 
	C2562.000000,1948.888916 2562.000000,1949.777832 2562.000000,1951.333374 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2554.140625,1966.710449 
	C2556.133301,1966.000000 2558.266846,1966.000000 2561.200195,1966.000000 
	C2562.000000,1966.888916 2562.000000,1967.777832 2562.000000,1969.333374 
	C2559.266602,1969.620483 2555.905762,1971.119263 2554.140625,1966.710449 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2558.091064,1894.635986 
	C2558.888916,1894.000000 2559.777832,1894.000000 2561.333496,1894.000000 
	C2562.000000,1894.888916 2562.000000,1895.777832 2562.000000,1897.333374 
	C2560.198486,1897.831055 2558.637451,1897.325439 2558.091064,1894.635986 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1076.588257,2185.500977 
	C1068.302246,2182.688721 1060.154419,2180.728760 1051.198853,2178.770264 
	C1045.796509,2181.500732 1041.388794,2179.464844 1036.913574,2178.302002 
	C959.868774,2158.284424 887.083679,2127.832275 817.095337,2088.543213 
	C814.333252,2086.937500 812.423096,2085.389648 809.629639,2083.877930 
	C785.885010,2069.619629 762.778625,2055.701660 740.970703,2039.771729 
	C736.445374,2036.466187 731.166321,2033.942993 728.463562,2027.765625 
	C717.669067,2018.719849 707.015564,2010.380127 695.756653,2001.838135 
	C686.510132,1999.897095 680.352844,1995.031372 676.455383,1986.317139 
	C674.863464,1983.161133 672.248596,1982.135986 669.622070,1980.185303 
	C660.313354,1977.698975 654.507935,1972.057739 650.441406,1963.551270 
	C647.636414,1958.715576 643.763672,1955.767944 639.410461,1952.395752 
	C634.999084,1952.161133 632.851135,1949.429321 630.484497,1947.157104 
	C604.089355,1921.815552 579.521240,1894.820435 556.433411,1866.419678 
	C521.738159,1823.740112 491.683868,1777.994019 465.253052,1729.835449 
	C461.870483,1723.672241 456.448395,1717.741211 459.636536,1708.981445 
	C463.053375,1705.807617 466.262329,1706.744873 469.562988,1707.487671 
	C480.599976,1709.971436 491.444916,1713.082642 502.265411,1716.399048 
	C513.614441,1719.877686 525.622803,1719.494751 537.315979,1722.395020 
	C582.075378,1733.496460 627.699280,1740.945923 672.442383,1752.042603 
	C691.596863,1756.793335 711.171570,1757.484741 730.247803,1762.411377 
	C764.287964,1771.202881 798.558777,1779.246948 833.194519,1785.526489 
	C873.949463,1792.915771 913.957886,1803.859253 954.777039,1810.984497 
	C969.406250,1813.537964 983.297058,1820.403442 998.771423,1818.021362 
	C1001.720032,1817.567383 1004.529968,1819.426392 1008.044678,1820.860840 
	C1002.227051,1815.954956 993.803772,1815.793335 991.127930,1807.411377 
	C996.387085,1802.057251 1000.702148,1806.310913 1004.759888,1808.369629 
	C1027.590332,1819.953857 1050.716553,1830.796387 1074.878662,1839.382202 
	C1089.604858,1844.615356 1104.645264,1848.765747 1120.373047,1853.379761 
	C1138.048706,1858.079956 1155.064697,1862.117432 1173.139404,1865.059814 
	C1177.760010,1865.136230 1181.487061,1865.740234 1185.933105,1866.991943 
	C1192.629639,1867.924927 1198.462646,1869.265381 1205.298584,1869.168701 
	C1210.146973,1869.191284 1213.956543,1870.516846 1218.775146,1870.998657 
	C1240.134644,1873.610718 1260.725342,1872.389404 1282.170166,1872.892822 
	C1284.879028,1873.080566 1286.687744,1872.874878 1289.392700,1873.019897 
	C1297.410522,1872.800903 1304.549683,1872.120239 1312.353027,1874.281860 
	C1317.080688,1879.352051 1313.656982,1881.073853 1309.838379,1882.203857 
	C1305.969360,1883.348755 1301.907715,1882.933838 1297.872314,1882.975220 
	C1307.120483,1882.697754 1315.664062,1883.226562 1323.279785,1890.292603 
	C1328.839111,1895.450928 1337.461182,1895.616821 1344.730835,1897.915283 
	C1366.043945,1904.653687 1388.317383,1908.045654 1410.127686,1911.520020 
	C1432.765381,1915.126465 1454.404297,1921.755249 1476.593628,1926.522217 
	C1491.225464,1929.665527 1506.084717,1933.996826 1520.578247,1934.842529 
	C1533.292969,1935.584473 1544.060791,1940.983765 1555.714722,1942.496460 
	C1586.639404,1946.510254 1615.906128,1959.098022 1647.412842,1959.437500 
	C1651.192505,1959.478271 1654.565063,1960.773560 1657.846313,1962.507446 
	C1663.819214,1965.663086 1670.318970,1968.279785 1676.912476,1967.813110 
	C1687.401123,1967.070557 1696.204712,1972.186646 1705.792725,1974.056763 
	C1724.888550,1977.781494 1743.399414,1985.791016 1763.495605,1983.540649 
	C1767.200073,1983.125977 1770.962891,1983.407715 1774.164917,1985.397095 
	C1791.798340,1996.352661 1811.163086,1998.984009 1831.429077,1997.842651 
	C1836.427002,1997.561279 1841.363892,1998.693726 1846.894043,2000.570068 
	C1850.572266,2004.783813 1848.685425,2007.106567 1844.332764,2008.824951 
	C1832.414917,2015.246338 1823.159912,2024.265259 1812.488159,2031.349609 
	C1808.382446,2034.075195 1804.430054,2037.031616 1800.043701,2040.427124 
	C1798.190186,2046.756226 1793.890625,2049.182861 1787.807617,2050.262207 
	C1783.926025,2050.870605 1781.436279,2052.819824 1778.427002,2055.131836 
	C1775.311157,2061.130371 1771.440552,2065.022949 1764.265015,2065.171875 
	C1757.257080,2068.654785 1750.927124,2072.373535 1744.146240,2076.582520 
	C1741.712158,2084.503418 1734.045044,2085.005127 1729.158325,2088.886963 
	C1726.396851,2091.080322 1723.067627,2092.530518 1719.461670,2094.802246 
	C1717.198120,2096.013672 1715.386475,2096.482666 1713.099243,2097.583740 
	C1706.923584,2100.922363 1701.461426,2104.146240 1695.163818,2107.270996 
	C1692.073608,2108.809814 1689.535400,2109.917236 1686.522705,2111.663086 
	C1677.387573,2115.268066 1670.226929,2121.765869 1660.334229,2121.914307 
	C1653.858276,2122.604004 1648.686279,2126.174316 1642.480591,2128.994141 
	C1635.793457,2136.467285 1627.943237,2140.083252 1618.100098,2140.532227 
	C1612.090210,2140.945312 1607.087769,2142.858154 1601.829102,2145.922363 
	C1600.493286,2151.650146 1595.706787,2151.429932 1592.265381,2152.715332 
	C1531.314575,2175.475586 1468.462646,2190.732666 1403.319702,2200.281250 
	C1398.644775,2200.985840 1394.776978,2201.469238 1390.126465,2202.451172 
	C1376.713501,2203.520752 1364.182495,2204.935303 1350.756836,2206.024902 
	C1346.366821,2207.005615 1342.792114,2207.257812 1338.274170,2206.967285 
	C1320.321411,2209.759521 1303.155151,2209.607666 1285.047119,2209.052002 
	C1277.883057,2209.387939 1271.645264,2209.554199 1264.456299,2209.034668 
	C1251.405273,2208.788818 1239.109131,2211.690430 1226.677124,2206.043457 
	C1214.833130,2202.834961 1203.356567,2203.117188 1191.075195,2202.230957 
	C1184.276733,2205.922119 1178.642456,2205.580566 1172.629517,2200.711914 
	C1168.557861,2199.723145 1165.111206,2199.276123 1160.799805,2198.948242 
	C1156.930420,2203.580566 1154.081909,2200.502686 1150.605469,2198.241211 
	C1132.685181,2194.654297 1115.362427,2191.714111 1097.223389,2188.796143 
	C1089.396118,2191.593506 1082.862793,2190.557861 1076.588257,2185.500977 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M991.922546,1806.225952 
	C996.111328,1813.218262 1003.725281,1813.900757 1009.391235,1817.725464 
	C1012.210388,1819.628540 1016.517944,1819.834839 1017.255920,1824.154053 
	C1015.004211,1826.259155 1013.035950,1824.773560 1011.424866,1824.109131 
	C998.161987,1818.639648 983.541870,1823.506714 970.099548,1818.232666 
	C961.854980,1814.997925 952.719788,1814.112915 944.149048,1811.609741 
	C933.268188,1808.432007 921.897705,1808.184814 910.994934,1805.733643 
	C893.962952,1801.904663 876.185059,1800.555908 860.340698,1792.186401 
	C858.886780,1791.418579 856.897095,1790.054321 855.784119,1790.507935 
	C847.199585,1794.005127 839.591309,1789.447388 831.584778,1788.102417 
	C821.491943,1786.406982 811.352295,1785.380737 801.418274,1782.410156 
	C789.833496,1778.946045 778.256531,1774.498901 765.977417,1774.515503 
	C756.937866,1774.527710 749.483765,1769.809448 741.147644,1767.789673 
	C722.176208,1763.192871 702.807983,1761.311890 683.693726,1757.848389 
	C667.877686,1754.982422 652.240723,1750.828369 636.806274,1746.286865 
	C629.377380,1744.101074 621.726318,1743.049072 614.358459,1742.503296 
	C601.913269,1741.581543 590.374268,1737.507812 578.389648,1735.100708 
	C572.598938,1733.937500 566.509460,1733.555054 561.729248,1729.249634 
	C559.900818,1727.602905 557.321106,1728.054199 555.001465,1728.001587 
	C545.008118,1727.774414 535.277222,1726.432373 525.976196,1722.368530 
	C522.443665,1720.825073 518.723572,1719.413330 514.480347,1721.409180 
	C510.613251,1723.228271 506.550629,1721.506592 502.914856,1719.919922 
	C490.443451,1714.477417 476.756592,1713.277222 464.064056,1708.626221 
	C463.332306,1708.358032 462.210358,1709.154541 460.627045,1709.731689 
	C454.466339,1709.944946 453.738251,1705.057129 451.927185,1701.594360 
	C448.776184,1695.570068 445.225983,1689.677612 443.498230,1682.235962 
	C443.015198,1676.767334 440.930786,1672.823608 437.211975,1668.896240 
	C435.626953,1666.793457 434.859802,1665.048828 434.009949,1662.547363 
	C431.468811,1651.010620 427.500244,1640.822998 421.199921,1630.784424 
	C420.115814,1628.795898 419.766510,1627.345703 419.781677,1625.077637 
	C416.804443,1608.685303 409.334412,1594.486328 405.072021,1579.223877 
	C403.028870,1571.907959 400.229340,1564.809326 397.883545,1556.795898 
	C397.329620,1555.133789 396.899200,1554.211182 396.520081,1552.515381 
	C394.620697,1546.388916 393.755157,1540.727417 391.778412,1534.699951 
	C389.649231,1531.429077 389.278381,1528.250244 388.733276,1524.388184 
	C387.852844,1519.486572 386.344391,1515.495239 385.573578,1510.660278 
	C385.051544,1509.124878 384.689728,1508.206787 384.398621,1506.541382 
	C384.251068,1504.960449 384.043915,1504.124146 383.694275,1502.657227 
	C383.158813,1501.111450 382.776733,1500.193237 382.467346,1498.521240 
	C382.300720,1496.951050 382.095795,1496.126221 381.812134,1494.665039 
	C381.291443,1493.109497 380.883972,1492.181519 380.556763,1490.484619 
	C380.112579,1488.243164 380.028259,1486.685913 379.624237,1484.599854 
	C379.156982,1483.709229 378.824097,1483.383301 378.032837,1482.529541 
	C377.401123,1481.648804 377.227783,1481.295776 377.176819,1480.366943 
	C377.874573,1478.302979 378.024353,1476.767944 377.705750,1474.617188 
	C377.238556,1473.102051 376.873016,1472.162109 376.592102,1470.458740 
	C376.128815,1468.240723 376.024323,1466.704834 375.760010,1464.613403 
	C375.300476,1463.081421 374.932251,1462.117554 374.688110,1460.377075 
	C374.011169,1452.803833 372.081665,1446.186401 371.361633,1438.692139 
	C370.854950,1437.091064 370.579285,1436.137939 370.457642,1434.444824 
	C369.629181,1430.943848 370.379120,1427.973999 369.371460,1424.613770 
	C368.883392,1423.700073 368.608612,1423.363037 367.928833,1422.514648 
	C367.375732,1421.594604 367.227600,1421.185913 367.245178,1420.147583 
	C368.129028,1417.413574 368.033203,1415.257202 367.716919,1412.453125 
	C367.612183,1411.812744 366.829315,1411.878662 366.439331,1411.925537 
	C364.986786,1410.982422 364.417084,1409.754150 364.288879,1407.634521 
	C364.952423,1403.097046 366.716827,1399.376831 365.559845,1394.685913 
	C365.105713,1393.063110 364.813507,1392.072754 364.702515,1390.316406 
	C363.259094,1385.613403 364.488556,1381.414673 363.623779,1376.728027 
	C363.192047,1375.050293 362.905792,1374.039307 362.814362,1372.252197 
	C361.866333,1368.762329 361.676270,1366.124268 364.378784,1363.293701 
	C412.795258,1376.132202 461.743622,1383.604736 509.794891,1395.187866 
	C530.349915,1400.142822 551.316895,1404.041382 572.207458,1407.903198 
	C590.750977,1411.331421 609.610413,1414.145264 627.733032,1419.381104 
	C647.919983,1425.213379 668.681274,1428.066040 688.934875,1433.321045 
	C692.662292,1434.288208 696.172729,1433.859741 700.319336,1431.853271 
	C707.992737,1431.782837 707.175049,1437.922241 708.188354,1441.833984 
	C718.906372,1483.207153 733.514709,1523.066040 753.499023,1560.896851 
	C755.361145,1564.421753 756.859558,1568.161133 760.096741,1571.705811 
	C762.996460,1574.716553 764.634827,1577.642212 765.950195,1581.518433 
	C766.696045,1585.047119 767.440674,1587.845703 770.025146,1590.464966 
	C770.663147,1591.247192 770.900696,1591.572144 771.448364,1592.408813 
	C772.476501,1594.325317 773.312500,1595.644409 774.935425,1597.128906 
	C776.478333,1598.783203 777.255981,1600.212646 778.080933,1602.314209 
	C778.719421,1604.002319 779.044006,1605.166260 780.205261,1606.579834 
	C780.785706,1607.390259 781.005798,1607.722778 781.520874,1608.572632 
	C782.525208,1610.512817 783.360352,1611.852783 784.796021,1613.540039 
	C785.380371,1614.401245 785.589355,1614.766846 786.064087,1615.712036 
	C787.453857,1619.067627 788.458252,1621.919678 791.541626,1624.177368 
	C792.289124,1624.917969 792.563904,1625.232666 793.178406,1626.062012 
	C794.288330,1627.962524 795.021301,1629.373901 796.640015,1630.885498 
	C797.919434,1632.172974 798.624329,1633.156006 799.588989,1634.706421 
	C800.532898,1636.276978 801.070435,1637.381958 802.302490,1638.768799 
	C802.941345,1639.579712 803.184143,1639.913940 803.770996,1640.759766 
	C804.766113,1642.324341 805.532043,1643.274902 807.043335,1644.400269 
	C808.510864,1645.677002 809.229126,1646.739258 810.038086,1648.519409 
	C810.819641,1651.339111 812.031311,1653.008545 814.725342,1654.302979 
	C816.370728,1655.514771 817.165894,1656.588623 818.024963,1658.435791 
	C818.892456,1662.302856 820.978333,1664.465088 824.079468,1666.699707 
	C825.506104,1668.147583 826.235901,1669.286499 827.310059,1671.006836 
	C829.528625,1675.250854 832.157410,1678.150757 836.566162,1680.192871 
	C840.319763,1683.172729 842.035522,1687.007935 845.278992,1690.471924 
	C853.160828,1702.234863 863.030518,1711.110107 874.021973,1719.802246 
	C878.080933,1722.325439 880.283875,1725.917969 884.153870,1728.672852 
	C887.284546,1732.162720 889.401733,1735.709106 893.758362,1737.932373 
	C895.526123,1738.930298 896.648438,1739.682495 898.263306,1740.900635 
	C901.368652,1744.225952 903.307922,1747.805908 907.804565,1749.592163 
	C908.793274,1750.062988 909.177307,1750.274414 910.092529,1750.870850 
	C912.239685,1752.616699 913.220947,1754.705200 915.983398,1755.692749 
	C916.939819,1756.178467 917.312866,1756.391113 918.201843,1756.988037 
	C920.283569,1758.730225 921.280884,1760.744751 923.989990,1761.710205 
	C924.926941,1762.184204 925.292175,1762.390747 926.161987,1762.969727 
	C928.195557,1764.643433 929.110352,1766.634521 931.716125,1767.594238 
	C932.627686,1768.026001 932.986450,1768.211304 933.855469,1768.722168 
	C935.633240,1770.021118 936.783936,1771.155273 938.791504,1772.163696 
	C939.697144,1772.689697 940.052002,1772.921265 940.891785,1773.574463 
	C943.190613,1776.528442 945.647461,1778.178589 949.149658,1779.433838 
	C950.136780,1779.817505 950.521423,1779.988403 951.446777,1780.471436 
	C953.303894,1781.704468 954.396973,1782.926147 956.387634,1783.928955 
	C957.271118,1784.397583 957.621338,1784.594849 958.472717,1785.130615 
	C959.951904,1786.181152 960.820374,1787.047363 962.479126,1787.869141 
	C963.382019,1788.388550 963.738220,1788.609253 964.600708,1789.207031 
	C966.954590,1791.338013 968.998535,1792.779053 972.060608,1793.804199 
	C973.058411,1794.241943 973.449646,1794.439209 974.391968,1794.998779 
	C978.953247,1798.799683 983.234375,1801.791626 988.957642,1803.703003 
	C990.450500,1804.333130 991.199219,1804.871582 991.922546,1806.225952 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1849.300537,2002.565674 
	C1839.483521,2002.010498 1830.491455,2000.251831 1821.111816,2001.650757 
	C1815.173340,2002.536499 1808.629761,2000.563599 1802.564575,1999.045288 
	C1797.089722,1997.674683 1791.850464,1995.673706 1786.034180,1995.854004 
	C1782.574219,1995.961426 1779.768555,1994.142822 1777.602661,1991.270264 
	C1774.279175,1986.862671 1769.304321,1984.782959 1764.342529,1986.244873 
	C1752.663574,1989.685303 1742.102295,1985.305786 1731.329102,1982.594482 
	C1725.820190,1981.208008 1720.493530,1979.641479 1714.715576,1979.948975 
	C1706.628296,1980.379028 1700.577271,1974.596924 1693.291748,1972.410278 
	C1689.079834,1971.145874 1685.460571,1970.565796 1680.897217,1971.067261 
	C1672.357666,1972.005493 1663.889160,1969.596436 1656.398438,1965.171631 
	C1653.775391,1963.622314 1651.426025,1961.303223 1648.334229,1962.102661 
	C1640.222778,1964.199829 1632.541016,1961.998779 1624.989380,1959.893311 
	C1612.528198,1956.419312 1599.307251,1956.886841 1587.098999,1952.214233 
	C1585.289185,1951.521851 1583.139282,1951.698486 1581.515259,1950.346924 
	C1577.689331,1947.162476 1573.775635,1946.725464 1568.638184,1947.624146 
	C1558.697998,1949.363281 1549.702515,1944.967041 1541.360840,1940.082520 
	C1537.059570,1937.563965 1533.502075,1935.570068 1528.630249,1938.548706 
	C1522.993652,1941.995117 1517.312988,1938.752686 1512.419312,1936.807007 
	C1505.145020,1933.914673 1497.588379,1933.493042 1490.154541,1932.176880 
	C1486.589478,1931.545654 1482.920532,1931.437012 1479.441406,1930.225464 
	C1467.548584,1926.083374 1455.225708,1923.884155 1442.864258,1921.681274 
	C1437.819214,1920.782227 1432.368530,1920.127197 1428.407593,1915.769653 
	C1426.147827,1913.283447 1422.988647,1914.000122 1419.979736,1914.958374 
	C1414.013550,1916.858521 1408.256592,1916.395386 1402.618164,1913.399902 
	C1395.413940,1909.572144 1387.225098,1909.369263 1379.439453,1908.239746 
	C1365.619019,1906.234741 1352.115112,1903.115356 1338.736572,1899.280029 
	C1334.600952,1898.094604 1330.715332,1895.983276 1326.270752,1895.963257 
	C1322.916016,1895.947998 1320.312622,1894.192017 1318.992676,1891.445312 
	C1316.484253,1886.226318 1312.216064,1885.915771 1307.307129,1885.930420 
	C1300.459351,1885.950684 1293.294922,1887.261353 1287.147583,1882.538208 
	C1288.377197,1878.677979 1291.543579,1880.347656 1293.883179,1880.040405 
	C1300.349365,1879.191528 1307.098267,1881.637207 1313.686768,1877.695923 
	C1314.383057,1874.852783 1316.128418,1874.512939 1318.692139,1874.090332 
	C1332.597046,1877.004028 1345.198242,1873.142700 1357.875732,1871.264282 
	C1373.207764,1868.992554 1388.846802,1868.055298 1404.152832,1861.696655 
	C1405.828003,1860.793701 1406.858521,1860.486572 1408.726562,1860.296143 
	C1420.460083,1861.413330 1430.103271,1856.427490 1440.109863,1853.489014 
	C1463.849854,1846.517578 1487.429932,1839.008057 1510.159180,1827.181763 
	C1512.939697,1825.490845 1515.265625,1824.623901 1518.328491,1823.658569 
	C1530.112793,1819.911865 1540.311279,1814.566528 1550.483643,1807.659912 
	C1552.473267,1806.084961 1554.125366,1805.298584 1556.409790,1804.285889 
	C1559.937622,1803.134766 1562.636353,1801.859619 1565.330811,1799.251953 
	C1570.499756,1796.421509 1575.053589,1793.812500 1580.247192,1791.021240 
	C1582.683716,1789.665405 1584.604858,1788.697510 1586.378418,1786.438965 
	C1593.975220,1780.647095 1602.125122,1776.853638 1609.641479,1770.930420 
	C1612.048828,1769.693359 1614.070923,1769.114380 1616.147461,1767.361694 
	C1617.232788,1766.462891 1617.859375,1765.958862 1618.959229,1765.083252 
	C1620.681396,1763.697510 1621.896973,1762.646484 1623.475220,1761.069214 
	C1626.614624,1758.615479 1629.205200,1756.454468 1632.651855,1754.399292 
	C1635.171997,1753.259888 1636.920898,1752.183594 1638.093384,1749.527832 
	C1639.627197,1747.117065 1641.381226,1745.908813 1643.837402,1744.589600 
	C1645.852417,1743.586060 1647.210083,1742.740601 1648.465576,1740.804932 
	C1650.741089,1737.889893 1653.250000,1736.243530 1656.458008,1734.454834 
	C1661.330200,1732.652588 1664.330811,1729.782959 1666.420410,1724.981323 
	C1675.290039,1717.129028 1681.240479,1706.877319 1693.044678,1702.548462 
	C1698.075073,1703.323853 1702.015747,1705.125122 1701.790894,1709.947144 
	C1701.475708,1716.709106 1705.844971,1718.194824 1710.780396,1719.801392 
	C1732.697632,1726.936401 1755.742065,1728.989868 1777.946655,1734.685181 
	C1808.244385,1742.456299 1839.080811,1747.684570 1869.692627,1753.707642 
	C1900.375122,1759.744629 1930.257324,1769.340454 1961.364746,1773.339844 
	C1979.535400,1775.676025 1996.950439,1781.817749 2014.991577,1785.016357 
	C2022.456665,1786.339844 2028.042114,1788.218628 2032.743042,1778.549438 
	C2037.075928,1769.637329 2039.765747,1778.978516 2042.822632,1782.840698 
	C2043.356689,1784.730347 2043.308716,1785.829346 2042.562988,1787.645508 
	C2042.151855,1788.375000 2041.935059,1789.333862 2041.585449,1789.679443 
	C2040.504272,1791.148682 2039.747192,1792.253906 2038.528687,1793.852295 
	C2038.160400,1794.412109 2037.949097,1795.346802 2037.607910,1795.683105 
	C2036.538818,1797.108765 2035.785645,1798.179565 2034.539673,1799.700195 
	C2034.146362,1800.223755 2034.069092,1800.081543 2034.149902,1800.080322 
	C2032.478760,1801.400879 2032.247559,1803.706787 2030.488525,1805.765991 
	C2030.020630,1806.598633 2029.934937,1806.936523 2029.482910,1807.647705 
	C2028.454834,1809.130981 2027.744751,1810.207520 2026.486572,1811.685791 
	C2025.577148,1813.234741 2025.079590,1814.286621 2024.051025,1815.614990 
	C2022.719238,1817.187256 2021.699585,1818.316284 2020.471924,1819.997192 
	C2020.182495,1820.487183 2019.954102,1821.396851 2019.605225,1821.710205 
	C2018.523071,1823.128784 2017.762085,1824.213623 2016.504639,1825.755859 
	C2015.581909,1827.311890 2015.057861,1828.338501 2013.995361,1829.616089 
	C2012.683960,1830.987915 2011.872192,1832.078857 2010.533936,1833.622559 
	C2010.100464,1834.146729 2010.000977,1834.043579 2010.072388,1834.049683 
	C2009.501343,1834.494263 2008.963135,1835.037842 2008.364014,1836.230713 
	C2008.212646,1836.789062 2008.148315,1837.529663 2007.867188,1837.772949 
	C2006.709839,1839.090576 2005.838379,1840.169067 2004.540283,1841.791382 
	C2003.624268,1843.372925 2003.106934,1844.387207 2002.056763,1845.644165 
	C2000.697998,1847.012207 1999.857422,1848.126099 1998.531006,1849.745850 
	C1997.353394,1851.451660 1996.592773,1852.597778 1995.353149,1853.968140 
	C1993.451050,1854.594849 1993.006714,1855.723755 1992.398682,1857.521729 
	C1991.461914,1860.153320 1990.110718,1861.767944 1988.076172,1863.589355 
	C1985.946289,1866.027466 1983.942505,1867.946655 1983.502930,1871.474609 
	C1982.790649,1872.876465 1982.252563,1873.589966 1981.151245,1874.690430 
	C1978.318604,1876.905273 1975.579102,1878.286621 1974.259033,1881.927002 
	C1973.379883,1883.682129 1972.605835,1884.717651 1971.012695,1885.893799 
	C1969.221313,1887.308350 1967.975098,1888.361694 1966.155029,1889.652588 
	C1963.556030,1893.417603 1959.783936,1895.737061 1958.482544,1900.563843 
	C1957.556030,1903.536987 1956.317871,1905.482544 1953.651611,1907.159912 
	C1945.013794,1911.126221 1940.389893,1918.342896 1934.727417,1925.333740 
	C1934.321289,1926.369873 1934.138672,1926.776123 1933.631592,1927.766235 
	C1931.836304,1930.568359 1929.859863,1932.341064 1927.631348,1934.762817 
	C1924.705322,1937.659302 1922.180542,1940.032715 1919.392578,1943.077393 
	C1916.041626,1946.347656 1913.316528,1949.340088 1909.189575,1951.709717 
	C1902.873901,1954.120239 1899.793579,1959.565430 1894.419678,1963.185181 
	C1892.435791,1966.276611 1889.979980,1967.966797 1887.123535,1970.025879 
	C1882.792236,1972.488525 1880.288330,1976.138672 1876.406006,1979.223145 
	C1875.883789,1979.956909 1875.875000,1980.296021 1875.865479,1981.143799 
	C1875.592896,1982.026123 1875.321167,1982.399902 1874.519043,1983.221436 
	C1865.958374,1987.191895 1859.177979,1992.249390 1853.955566,2000.279053 
	C1852.647339,2002.037354 1851.496948,2002.799194 1849.300537,2002.565674 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M445.493164,1680.282471 
	C448.453766,1691.120605 454.197693,1699.916992 459.425842,1709.610107 
	C463.433380,1722.365479 470.817383,1732.774780 476.984802,1743.741455 
	C503.331421,1790.590454 534.065918,1834.450684 568.375305,1875.786133 
	C586.670532,1897.827881 606.023743,1918.935913 626.550537,1938.944946 
	C630.600830,1942.892944 634.512512,1946.983032 638.630432,1951.569092 
	C638.173584,1954.766113 638.377075,1957.290161 638.930298,1959.991089 
	C641.049438,1970.338257 635.146729,1976.728638 624.622742,1975.783081 
	C623.649170,1975.695679 622.722473,1975.171753 621.748840,1974.975708 
	C620.786743,1974.781860 619.758606,1974.609619 618.729248,1976.374512 
	C623.855896,1980.429565 624.875977,1986.313965 623.852295,1992.730225 
	C622.977600,1998.212402 619.314331,2002.609619 614.679443,2003.445801 
	C609.548218,2004.371582 606.655334,2001.361084 604.545959,1997.178589 
	C603.952332,1996.001465 603.297058,1994.787598 602.402161,1993.844727 
	C600.545105,1991.887939 598.329163,1991.660522 596.155029,1993.329468 
	C594.242249,1994.797852 594.435852,1996.637329 595.366211,1998.671753 
	C596.520081,2001.194946 598.135559,2003.083618 600.681946,2004.359741 
	C603.346619,2005.695068 605.639648,2008.198608 608.403748,2008.821289 
	C614.347778,2010.160034 616.592041,2014.345337 617.382996,2019.402222 
	C618.142334,2024.257812 620.216919,2025.987305 625.178223,2026.201538 
	C630.632019,2026.436646 634.012939,2030.992432 633.142944,2035.307495 
	C631.873779,2041.602661 626.207458,2043.720825 621.017395,2039.934692 
	C617.279724,2037.208252 615.960388,2033.162476 615.114319,2028.727173 
	C607.322754,2029.298950 606.049805,2035.345825 604.369995,2040.484619 
	C602.863586,2045.092896 606.634949,2047.766724 609.631165,2050.395508 
	C610.868713,2051.481445 612.549805,2052.072266 613.751160,2053.187500 
	C618.870300,2057.938232 619.390320,2064.901367 613.586365,2068.625000 
	C607.407166,2072.589355 605.628845,2076.863037 607.970764,2083.409668 
	C608.076904,2083.706299 608.008667,2084.072266 607.993042,2084.404785 
	C607.467957,2095.586182 607.945679,2096.699463 619.362915,2095.961426 
	C624.500549,2095.629395 627.508545,2097.896484 629.193237,2102.549316 
	C630.461426,2106.051514 629.973938,2109.031982 627.229736,2111.650879 
	C624.786743,2113.982422 622.004517,2114.487305 618.944946,2113.306396 
	C616.132263,2112.220947 613.531799,2110.877197 611.963257,2107.993164 
	C609.736755,2103.899658 606.557983,2100.784424 601.508118,2102.540283 
	C596.493103,2104.284180 591.352478,2106.305176 590.193115,2112.599854 
	C589.473450,2116.507324 588.782837,2120.424072 587.916016,2124.300049 
	C586.433044,2130.931396 583.401306,2132.458496 577.266541,2129.638672 
	C571.221313,2126.860107 565.343811,2124.572021 565.294128,2115.745117 
	C565.263123,2110.229736 560.875061,2108.875244 555.847107,2111.451660 
	C554.078857,2112.357666 552.475830,2113.580322 550.756653,2114.588867 
	C543.831909,2118.651123 542.956848,2120.513916 544.398193,2128.302002 
	C546.387634,2139.051514 546.096313,2139.625977 535.217346,2142.077393 
	C530.290649,2143.187744 527.426392,2145.565430 527.990601,2150.969727 
	C528.093811,2151.958008 528.052551,2152.971924 527.981079,2153.966797 
	C527.527466,2160.278320 525.221008,2163.253662 520.319702,2163.902832 
	C515.033264,2164.603516 509.384186,2161.212891 507.286682,2156.605469 
	C505.736542,2153.200439 507.461975,2150.739502 509.076752,2148.318604 
	C511.468140,2144.733643 514.441589,2141.529785 516.747742,2137.897217 
	C518.697083,2134.826660 521.147827,2131.457031 521.392944,2128.075928 
	C521.707153,2123.742920 526.169739,2118.148438 522.002441,2115.448242 
	C518.887268,2113.429688 516.142029,2119.609863 513.047302,2121.891602 
	C506.398865,2126.793457 501.362274,2134.618164 499.915436,2142.418701 
	C499.270111,2145.897949 497.386688,2147.545410 493.921783,2147.948242 
	C488.319580,2148.599854 483.987366,2146.919434 482.053894,2142.817383 
	C480.474396,2139.466309 479.958557,2135.877930 479.852264,2132.150391 
	C479.748932,2128.525146 477.547821,2127.538330 474.401550,2129.100098 
	C472.327209,2130.130127 470.523956,2131.731689 468.416595,2132.664551 
	C462.254608,2135.392334 454.581085,2133.896484 450.962311,2129.471680 
	C445.694397,2123.030518 448.800934,2115.258301 457.467072,2114.231689 
	C462.744171,2113.606201 468.106842,2113.909668 472.908691,2110.828369 
	C473.818176,2106.768799 469.648315,2105.460693 468.279907,2102.608154 
	C466.325134,2098.533691 464.620728,2094.690674 468.407471,2090.688232 
	C472.041107,2086.847656 477.486023,2085.195801 481.951813,2087.106445 
	C484.064209,2088.010498 485.981628,2089.415039 487.894135,2090.728516 
	C489.798279,2092.036133 491.422821,2093.835938 493.451935,2094.862305 
	C502.476532,2099.426758 512.932922,2099.322998 522.183655,2103.412842 
	C523.542175,2104.013672 527.058533,2102.497803 526.982422,2099.501221 
	C526.923279,2097.174805 524.771423,2096.213867 522.713989,2096.144775 
	C518.975647,2096.019043 516.601379,2093.764404 514.320496,2091.304688 
	C512.220459,2089.040039 509.616852,2087.479492 506.823822,2086.460938 
	C499.915955,2083.941895 493.534210,2080.462402 487.275452,2076.669922 
	C484.411011,2074.934326 481.313904,2073.873291 477.808746,2073.975830 
	C470.441162,2074.191650 465.090851,2077.534180 464.457886,2084.754150 
	C463.864716,2091.520752 460.952667,2093.989990 454.779175,2094.808105 
	C448.806244,2095.599854 445.106476,2098.790527 445.868164,2105.590088 
	C446.041473,2107.137207 445.164490,2108.793945 444.812714,2110.409180 
	C443.952850,2114.357666 441.731812,2117.046387 437.634796,2117.693115 
	C433.315155,2118.374756 429.796967,2116.549316 427.007965,2113.431885 
	C425.932709,2112.229980 425.350983,2110.560059 424.650696,2109.053955 
	C421.160553,2101.548096 421.172913,2101.542236 413.045166,2104.441162 
	C407.688507,2106.351807 404.609375,2105.073242 400.806885,2099.359863 
	C397.188324,2093.922852 397.051178,2088.364258 400.497559,2084.654541 
	C401.170227,2083.930420 401.916962,2083.043701 402.794891,2082.777832 
	C411.039337,2080.280029 412.009766,2073.007324 413.569458,2066.272217 
	C416.490051,2053.660156 417.421417,2052.889893 429.771515,2053.898438 
	C432.393463,2054.112549 435.080872,2054.333740 437.579803,2052.936523 
	C441.791565,2050.581299 441.946472,2047.797485 437.943726,2044.986206 
	C427.201477,2037.441650 427.527069,2030.275513 439.360413,2024.635132 
	C443.304352,2022.755127 444.165771,2021.103882 442.834473,2017.103394 
	C441.920349,2014.356567 442.056549,2011.201294 442.047150,2008.227539 
	C442.035889,2004.671753 441.009583,1999.708984 445.516632,1998.865601 
	C450.754791,1997.885376 456.088348,2000.095703 460.128601,2003.728760 
	C463.481384,2006.743896 461.813599,2010.478882 460.043030,2013.818970 
	C458.119598,2017.447021 455.241241,2020.167480 451.688721,2022.186035 
	C448.117859,2024.215088 447.229248,2027.142456 449.386108,2030.557983 
	C451.827148,2034.423218 451.545746,2037.985107 449.269012,2041.736328 
	C448.607666,2042.825928 448.188538,2044.352783 449.746307,2045.222900 
	C451.418579,2046.156982 452.990997,2045.575439 454.205750,2044.286743 
	C454.862396,2043.590088 455.574158,2042.634155 455.644043,2041.746704 
	C456.073578,2036.293579 459.561798,2034.245483 464.365692,2034.100586 
	C469.169342,2033.955933 471.109955,2031.837524 472.300537,2027.090576 
	C474.448944,2018.524536 481.800323,2016.072998 489.181305,2020.715332 
	C490.020721,2021.243286 490.790558,2021.901245 491.524689,2022.573242 
	C494.050873,2024.885864 496.609161,2027.375488 500.127991,2024.368896 
	C502.729950,2022.145630 502.717896,2016.877930 500.131409,2013.349121 
	C498.960266,2011.751343 497.544434,2010.246704 495.976929,2009.041382 
	C490.996155,2005.211548 489.419189,2000.259644 489.887299,1994.106445 
	C490.154938,1990.588379 490.850403,1986.824341 488.747620,1982.922363 
	C484.563690,1982.818481 482.886078,1986.579224 480.286346,1988.765869 
	C478.251770,1990.477295 476.591400,1992.656250 474.478027,1994.246338 
	C470.968781,1996.886719 467.988190,1996.423340 465.171722,1992.656616 
	C460.262878,1986.091797 460.298676,1979.200684 467.237915,1972.066284 
	C471.500946,1967.683350 472.389526,1963.064087 471.985809,1957.575073 
	C471.810455,1955.190552 471.761078,1952.780762 468.660248,1952.285889 
	C466.091675,1951.876099 463.696777,1952.681641 462.736420,1954.998413 
	C460.397644,1960.641113 455.480774,1964.556885 453.030945,1970.037598 
	C451.192535,1974.150146 448.436188,1975.885986 443.798859,1976.164551 
	C437.814148,1976.524048 437.577789,1977.422729 439.503082,1982.910767 
	C443.401459,1994.023560 440.797638,2000.232422 430.617981,2004.096680 
	C423.826843,2006.674438 419.979858,2005.653687 414.991150,1999.553833 
	C413.328735,1997.521362 412.366089,1995.025024 409.422668,1994.200562 
	C399.677917,1991.470703 394.357269,1996.260254 396.419922,2006.193726 
	C397.019867,2009.082764 398.115356,2011.869019 398.981171,2014.694092 
	C402.778351,2016.007568 405.221985,2012.773926 408.393402,2012.216064 
	C416.076965,2010.864136 423.261475,2018.491089 420.991852,2025.729614 
	C419.719727,2029.786499 415.636536,2032.134521 410.653381,2031.173950 
	C407.778839,2030.619873 404.505768,2028.606079 402.769867,2032.137085 
	C401.106903,2035.519775 404.470184,2037.617065 406.601135,2039.478394 
	C410.687042,2043.047241 412.455444,2047.161377 412.100189,2052.662598 
	C411.820679,2056.990723 409.819489,2059.343506 406.093201,2060.884521 
	C396.688751,2064.773438 387.531677,2061.275635 384.328949,2051.699219 
	C382.166748,2045.234131 379.354370,2041.145386 371.725647,2041.890869 
	C366.388794,2042.412354 362.015503,2039.743652 358.905243,2035.454346 
	C357.144836,2033.026611 355.448639,2032.480713 352.281616,2032.690308 
	C338.300690,2033.615845 327.565308,2018.632446 332.519714,2005.641968 
	C334.529602,2000.372070 338.817627,1999.011475 343.410950,2002.578125 
	C346.071472,2004.643799 348.621765,2006.754517 351.937500,2007.528320 
	C352.753479,2007.718628 354.076019,2007.400391 354.603638,2006.812012 
	C355.643707,2005.652466 355.168091,2004.190308 353.947388,2003.444458 
	C351.115906,2001.714355 348.201874,2000.101807 345.232147,1998.620361 
	C341.969147,1996.992554 340.266998,1995.378296 341.185394,1990.923584 
	C342.588409,1984.118164 339.565765,1981.793213 332.945099,1983.474243 
	C330.372986,1984.127563 327.877869,1985.094971 325.367310,1985.975098 
	C324.122192,1986.411743 322.472870,1986.966919 322.896790,1988.563721 
	C325.105621,1996.883789 321.000183,2004.854126 321.823395,2013.190552 
	C322.530609,2020.352539 323.787354,2026.629028 328.966339,2032.204102 
	C336.547913,2040.365601 335.573730,2048.297607 327.078003,2055.375977 
	C321.843903,2059.736816 320.940491,2066.019287 324.593689,2071.819580 
	C325.623932,2073.455322 327.086456,2073.875000 328.786255,2073.920410 
	C331.450867,2073.991455 334.129303,2073.841553 336.780731,2074.052002 
	C342.973755,2074.543457 347.432678,2078.850830 347.960480,2084.646484 
	C348.594635,2091.609375 345.788300,2095.963623 339.310730,2098.066406 
	C332.429474,2100.300537 332.447174,2100.292725 335.408478,2107.294434 
	C335.924103,2108.513672 336.265198,2109.813965 336.607697,2111.097900 
	C337.838379,2115.712402 340.086060,2118.225342 345.595306,2118.183838 
	C353.010925,2118.127930 359.533936,2124.037598 361.329498,2130.946533 
	C362.856323,2136.821289 358.147980,2142.518555 352.037170,2141.883057 
	C346.352051,2141.291748 342.390656,2138.209717 339.519440,2133.146484 
	C334.747192,2124.730957 334.476105,2124.808594 325.486481,2128.230469 
	C317.966858,2131.092773 316.275757,2130.787109 312.932037,2123.608643 
	C309.803864,2116.892822 306.115845,2111.937744 298.017883,2110.698730 
	C293.591492,2110.021484 289.606262,2106.948730 286.329651,2103.395508 
	C281.642700,2098.312744 281.353088,2096.328613 284.259552,2090.097900 
	C286.759552,2084.738770 291.302795,2085.879395 295.464264,2086.340332 
	C298.383911,2086.663818 301.206177,2087.866699 304.126923,2088.692383 
	C305.866608,2090.001465 304.849152,2091.595215 304.568146,2093.167236 
	C303.668060,2098.203613 306.698669,2100.657471 310.895142,2101.694336 
	C313.418762,2102.317627 316.209198,2102.122314 318.855316,2101.939941 
	C326.627197,2101.403809 327.742828,2099.590088 325.174561,2092.210938 
	C324.739655,2090.961426 324.425903,2089.670166 324.034271,2088.405029 
	C322.032349,2081.937744 321.007446,2081.365234 315.034698,2083.542480 
	C313.473663,2084.111572 312.043640,2085.104980 310.453308,2085.514160 
	C307.725372,2086.215820 305.354462,2086.153809 303.956696,2082.811279 
	C301.224731,2076.278564 295.660156,2072.719727 289.541168,2069.726074 
	C285.385315,2067.693115 280.923981,2066.118408 277.597870,2062.604004 
	C273.853638,2058.648193 272.841888,2053.111328 275.472443,2050.059814 
	C277.790833,2047.370117 284.830811,2046.998413 288.466156,2049.765381 
	C291.364838,2051.971924 293.733734,2054.776367 295.966309,2057.735840 
	C300.345215,2063.540527 305.458008,2063.333008 309.277496,2057.060547 
	C313.188843,2050.637207 314.874573,2043.861450 312.161682,2036.198364 
	C310.723114,2032.135376 308.884491,2031.666138 305.587372,2033.297729 
	C304.104950,2034.031250 302.608368,2034.827393 301.325134,2035.853882 
	C298.524414,2038.094238 296.174255,2041.507080 291.879303,2038.609497 
	C288.320435,2036.208618 285.582520,2029.310303 287.487396,2025.395386 
	C290.667755,2018.859375 292.846008,2011.664429 298.471344,2006.536377 
	C301.747101,2003.550293 304.587769,2000.430298 304.138947,1995.461792 
	C303.949493,1993.364868 305.487305,1991.824829 306.742035,1990.234741 
	C308.173462,1988.420654 309.633118,1986.549072 310.621399,1984.482788 
	C312.423065,1980.716064 313.170044,1976.716431 309.814362,1973.386108 
	C307.892731,1971.479248 305.507874,1972.287354 303.305695,1973.393188 
	C299.262817,1975.423462 295.665527,1977.811157 296.220734,1983.094116 
	C296.391113,1984.715210 297.285400,1986.247681 297.601807,1987.868774 
	C298.423615,1992.079468 297.203156,1995.066406 292.542267,1995.951904 
	C290.594727,1996.321899 288.727081,1997.123291 286.776917,1997.466064 
	C281.493042,1998.394653 279.428040,2001.652222 280.029327,2006.720825 
	C280.977264,2014.711426 277.864288,2020.466309 271.898804,2025.876343 
	C267.914612,2029.489502 264.446838,2034.424927 263.919189,2040.481445 
	C263.621490,2043.898560 261.678650,2046.734131 260.119568,2049.652344 
	C256.750061,2055.958984 257.921600,2062.692871 258.357727,2069.253662 
	C258.593597,2072.802490 261.403503,2074.996338 264.978424,2075.863037 
	C266.903931,2076.329590 268.866119,2076.740723 270.702332,2077.457275 
	C273.245056,2078.449463 275.864502,2079.871338 275.642517,2083.021729 
	C275.379059,2086.760742 272.744934,2088.865479 269.246338,2089.766357 
	C262.596558,2091.478271 259.543304,2089.044678 256.795715,2081.932373 
	C255.326752,2078.130127 258.643280,2072.048828 253.050201,2070.702881 
	C249.240005,2069.786133 246.153381,2074.092041 242.838013,2076.184814 
	C239.665543,2078.187500 236.725922,2078.612549 233.610870,2076.347656 
	C230.207886,2073.873291 229.357132,2070.363281 230.307419,2066.574707 
	C231.282379,2062.687988 232.584305,2058.618652 237.553589,2058.167969 
	C241.193985,2057.838135 244.891953,2058.122803 248.526901,2057.759766 
	C251.667969,2057.446045 252.271973,2055.234131 251.007629,2052.688232 
	C250.287094,2051.237061 248.777786,2050.192871 247.958115,2048.772705 
	C245.804886,2045.041626 244.066559,2041.401978 245.398163,2036.633667 
	C246.690643,2032.005371 249.219452,2030.003052 253.746994,2029.547363 
	C254.875519,2029.433960 256.395416,2028.380493 256.861420,2027.359985 
	C258.737823,2023.250122 258.254913,2018.942261 257.228821,2014.673218 
	C256.204926,2010.413086 254.279510,2007.681396 249.144241,2007.736694 
	C244.254364,2007.789673 241.702148,2003.771851 239.391647,2000.071289 
	C237.019135,1996.271362 237.686951,1993.126953 241.917831,1991.061646 
	C243.713989,1990.184814 245.451752,1989.185669 247.262436,1988.341919 
	C251.985687,1986.140747 254.557236,1982.644165 253.988113,1977.271484 
	C253.220886,1970.028564 255.943939,1964.293945 261.353271,1959.619751 
	C264.207031,1957.153931 266.174835,1954.325806 266.053040,1950.180298 
	C265.800781,1941.597534 268.722748,1934.564087 276.843933,1930.482666 
	C279.725220,1929.034668 280.310028,1926.651489 279.576385,1923.765625 
	C279.167664,1922.157959 278.444000,1920.609131 278.202911,1918.983276 
	C276.974396,1910.698486 279.829559,1906.059692 287.851959,1903.059937 
	C294.902222,1900.423584 294.240967,1900.418701 294.299347,1892.822266 
	C294.375641,1882.890991 296.321503,1873.380249 305.372894,1866.915405 
	C307.687103,1865.262573 309.374847,1862.456787 310.785797,1859.872437 
	C313.691162,1854.550659 316.320801,1849.230347 323.093994,1847.796387 
	C325.997101,1847.181885 326.015930,1844.535278 325.913544,1842.134521 
	C325.580383,1834.324707 322.570038,1831.154297 312.523621,1828.549072 
	C313.485901,1824.802368 313.804108,1820.682983 315.557556,1817.309570 
	C319.770508,1809.204346 323.216522,1801.140869 322.192230,1791.669556 
	C321.867645,1788.668335 323.569977,1785.715210 325.678467,1783.586304 
	C334.202972,1774.980225 338.328156,1763.328979 346.273285,1754.286499 
	C349.078339,1751.093872 349.514496,1746.455933 350.135681,1742.111084 
	C351.377747,1733.423828 353.854004,1725.251221 361.354584,1719.535400 
	C363.154816,1718.163574 365.186371,1716.244385 365.728699,1714.208618 
	C369.693695,1699.324829 381.523224,1688.088989 384.704865,1672.888306 
	C384.837860,1672.252808 385.131927,1671.584839 385.537109,1671.082031 
	C395.977692,1658.121338 400.163300,1641.547974 410.236420,1628.346802 
	C412.259186,1625.695923 414.797729,1624.690918 418.425018,1623.614258 
	C419.997986,1623.161011 420.736511,1623.254761 421.575165,1624.304443 
	C422.007416,1626.254272 422.291473,1627.626709 423.060669,1629.521973 
	C426.964813,1639.995361 431.570770,1649.488770 434.905121,1660.180542 
	C433.507477,1664.206665 433.811340,1667.007446 437.949249,1669.145752 
	C441.888275,1672.133789 442.630524,1676.510498 445.493164,1680.282471 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M702.561279,1431.414795 
	C700.284851,1437.781128 695.935669,1438.805786 691.008362,1437.313232 
	C668.794373,1430.584473 645.292542,1429.260132 623.429565,1420.963745 
	C618.568237,1419.119141 613.051636,1418.246338 607.840637,1418.261475 
	C600.652649,1418.282471 593.974121,1416.676025 587.452576,1414.175171 
	C577.080566,1410.197876 565.906677,1410.801392 555.321960,1408.182373 
	C540.859497,1404.603760 525.933594,1402.805420 511.652649,1399.068726 
	C492.389282,1394.028442 472.763458,1390.782227 453.566284,1385.607666 
	C443.980591,1383.024048 433.971436,1382.631958 424.286987,1380.286011 
	C419.764069,1379.190308 415.387421,1377.583618 410.863739,1376.678467 
	C402.433990,1374.991821 394.325409,1372.066895 385.521149,1371.673950 
	C378.372406,1371.354736 371.253540,1369.221436 364.843689,1364.065552 
	C359.771118,1360.470947 362.867340,1355.563965 361.578552,1350.744385 
	C359.934387,1346.595947 360.446930,1342.987427 360.663239,1338.543457 
	C360.563873,1322.519043 361.489227,1307.410767 359.908020,1292.203857 
	C358.913635,1282.640625 363.137817,1272.680420 358.496338,1262.216797 
	C356.646057,1256.059448 357.683746,1250.892700 359.332153,1244.930908 
	C363.153870,1233.676514 361.635437,1222.490967 364.500061,1211.130737 
	C364.076263,1208.026123 364.286194,1205.731567 365.363464,1202.686768 
	C364.469147,1189.605835 370.557220,1178.099243 369.510956,1165.117676 
	C368.936279,1163.462891 368.714264,1162.498779 368.763672,1160.776855 
	C372.442444,1153.722656 371.950470,1146.344604 374.465240,1139.028320 
	C374.025330,1134.554199 375.215973,1130.979736 376.666565,1126.685303 
	C378.937592,1122.304443 376.560791,1116.971680 382.292969,1114.193359 
	C395.505096,1113.792358 407.125946,1118.481689 419.268097,1120.293213 
	C428.659149,1121.694458 438.152161,1123.897339 447.453918,1126.144775 
	C485.601685,1135.361206 524.324219,1141.768311 562.577576,1150.249878 
	C593.721497,1157.155151 624.972656,1163.648560 656.097351,1170.676636 
	C669.681519,1173.744019 683.468811,1176.144897 698.094971,1178.113892 
	C703.530212,1181.412964 700.144348,1186.107910 701.415894,1190.586182 
	C701.676880,1192.282715 701.673218,1193.250488 701.389282,1194.895752 
	C700.114624,1197.904175 698.234802,1200.033936 699.415527,1203.587646 
	C699.579407,1205.128662 699.534180,1206.008789 699.186646,1207.510986 
	C697.601379,1210.321899 696.364014,1212.540161 697.445007,1215.920898 
	C697.583374,1217.458740 697.512817,1218.337402 697.139648,1219.841797 
	C694.333374,1223.954712 694.348206,1227.728882 695.832031,1232.326660 
	C696.308411,1234.912842 696.242004,1236.808350 695.542480,1239.384766 
	C691.857666,1244.884277 692.482178,1250.153809 693.631226,1256.252930 
	C693.702820,1258.117188 693.551636,1259.182861 692.963745,1261.015503 
	C691.780151,1263.239380 691.071533,1264.795044 691.070618,1266.469849 
	C691.053711,1296.639648 689.312744,1326.865723 694.359619,1357.612305 
	C695.513184,1359.841797 695.860901,1361.439453 695.958984,1363.871582 
	C695.246277,1368.440308 694.118896,1372.210327 695.519226,1376.788086 
	C695.953064,1378.377686 696.137817,1379.297485 696.384766,1380.912598 
	C696.638123,1384.357666 696.920837,1387.076782 699.041382,1390.008545 
	C699.574402,1391.643433 699.695251,1392.628174 699.654419,1394.396362 
	C698.205078,1403.594238 701.728882,1411.321655 703.146912,1419.337402 
	C703.836731,1423.237061 705.273621,1426.992432 702.561279,1431.414795 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1283.513306,2206.593506 
	C1301.406982,2204.928223 1318.911133,2205.597900 1337.132568,2203.530762 
	C1339.566040,2205.280762 1339.516968,2207.271973 1339.439087,2209.290039 
	C1339.143188,2216.960693 1341.555420,2221.674561 1350.496338,2219.915527 
	C1355.039917,2219.021729 1358.990234,2220.743408 1362.392822,2223.801758 
	C1363.875488,2225.134521 1365.272339,2226.604492 1367.002930,2227.609863 
	C1370.567261,2229.680664 1373.701050,2228.780273 1375.311646,2225.200439 
	C1377.000366,2221.446777 1373.507690,2220.774170 1371.078125,2220.046143 
	C1361.860840,2217.283691 1355.468750,2210.678223 1349.242676,2203.501221 
	C1362.300781,2200.404541 1375.336304,2200.023438 1389.173950,2198.749023 
	C1391.007324,2205.066895 1393.099609,2209.641357 1400.749268,2209.863037 
	C1406.534790,2210.030518 1410.094971,2214.216309 1412.398315,2219.409912 
	C1413.832764,2222.644287 1415.941162,2225.198242 1420.045654,2223.872314 
	C1422.834961,2222.971436 1424.514526,2220.979004 1424.315063,2217.928711 
	C1424.021240,2213.438721 1420.360962,2213.349609 1417.147095,2212.581543 
	C1409.328735,2210.712891 1401.336792,2208.951172 1401.593994,2197.799561 
	C1415.022705,2194.895020 1428.117310,2192.703613 1441.162598,2190.250977 
	C1492.633301,2180.573486 1543.073364,2167.114258 1592.202393,2148.873047 
	C1594.691406,2147.948975 1597.274658,2147.279053 1600.584351,2146.468262 
	C1604.327271,2153.823486 1605.526733,2154.799805 1611.913696,2153.612549 
	C1615.116943,2153.016846 1618.740234,2150.622803 1620.801514,2154.587646 
	C1622.879028,2158.584229 1625.249878,2162.907959 1623.029907,2167.850586 
	C1621.778442,2170.637207 1620.123291,2173.083252 1617.870605,2175.127441 
	C1615.342285,2177.421875 1613.502319,2180.196533 1612.537476,2183.442871 
	C1610.258911,2191.109375 1612.670898,2194.796387 1620.556274,2195.955566 
	C1629.090454,2197.210449 1634.783936,2202.886963 1635.887573,2211.249268 
	C1636.353271,2214.778809 1635.397583,2217.728760 1632.764038,2220.283203 
	C1630.154663,2222.814453 1627.475586,2225.266113 1625.664307,2228.594238 
	C1623.497681,2232.574707 1625.263672,2235.079834 1628.388672,2236.866211 
	C1632.522949,2239.229736 1636.137573,2236.293213 1639.573364,2234.687256 
	C1642.310547,2233.408447 1642.172363,2230.302490 1641.545166,2227.565918 
	C1641.101807,2225.631592 1640.389404,2223.741211 1640.128662,2221.786865 
	C1639.736328,2218.845947 1640.630371,2216.537109 1643.923584,2215.783447 
	C1644.886963,2215.563477 1645.782593,2215.058594 1646.720215,2214.714111 
	C1658.112671,2210.532959 1660.320312,2211.672119 1663.455322,2223.340820 
	C1665.267578,2230.086182 1663.317993,2232.901611 1656.074097,2233.999268 
	C1648.770264,2235.106445 1647.907104,2236.156250 1647.997559,2243.583740 
	C1648.026245,2245.935059 1648.590210,2248.149170 1649.101562,2250.431396 
	C1650.306641,2255.811523 1653.086670,2258.625244 1658.856567,2258.023193 
	C1663.573853,2257.531250 1667.682617,2258.872314 1669.439331,2263.625488 
	C1671.117676,2268.166504 1669.546753,2272.111084 1665.822021,2275.184570 
	C1665.310425,2275.606689 1664.823975,2276.081299 1664.413696,2276.600830 
	C1662.042358,2279.603271 1657.264038,2281.482178 1658.533691,2286.288330 
	C1660.274536,2292.878662 1660.636475,2300.402344 1668.073120,2304.010986 
	C1670.170532,2305.028809 1672.217407,2306.150146 1674.301636,2307.196045 
	C1677.461670,2308.781982 1678.891357,2311.176758 1677.113770,2314.488037 
	C1675.402588,2317.675537 1670.506714,2318.469971 1667.527954,2316.306152 
	C1664.986328,2314.459961 1663.732666,2311.681152 1662.489990,2308.971680 
	C1660.468506,2304.564453 1657.285645,2303.185791 1652.745728,2304.720703 
	C1649.279053,2305.892822 1645.715332,2306.834961 1642.361816,2308.270020 
	C1637.956177,2310.154541 1636.927368,2313.872803 1639.320435,2317.973145 
	C1643.766846,2325.592285 1650.596069,2328.276123 1659.457275,2325.886475 
	C1666.431885,2324.005615 1667.549194,2324.807861 1667.987305,2332.034180 
	C1668.027588,2332.698486 1668.025269,2333.368164 1667.994263,2334.033203 
	C1667.800171,2338.200684 1669.215454,2343.014404 1663.638672,2345.049072 
	C1658.246460,2347.017090 1654.717529,2345.519043 1650.868408,2340.814209 
	C1646.985596,2336.068604 1641.356689,2332.686768 1634.093872,2335.530762 
	C1629.926514,2337.162842 1626.426270,2335.642578 1624.406616,2331.070801 
	C1623.078491,2328.064209 1621.111328,2325.288574 1619.131104,2322.632568 
	C1615.219727,2317.386475 1610.556274,2316.725586 1605.329956,2320.415039 
	C1601.329224,2323.239258 1600.981323,2327.346680 1604.438721,2332.718262 
	C1607.559570,2337.567627 1612.098633,2339.900879 1617.857544,2340.027588 
	C1620.113525,2340.077148 1623.538574,2339.756104 1623.316772,2342.771973 
	C1623.040161,2346.531738 1623.086914,2350.898438 1619.808716,2353.758301 
	C1617.747925,2355.556396 1615.139648,2356.657959 1612.465576,2354.954834 
	C1610.231934,2353.531982 1607.967896,2352.003418 1606.158936,2350.101562 
	C1602.849731,2346.622070 1598.839233,2345.831055 1594.338989,2345.991943 
	C1585.768555,2346.298584 1583.440308,2349.716553 1585.704956,2358.150635 
	C1586.657837,2361.699219 1590.155518,2365.780518 1585.413818,2368.986572 
	C1580.118164,2372.567383 1574.417847,2375.451904 1567.649536,2373.444824 
	C1565.968628,2372.946533 1564.938721,2371.618408 1564.326538,2369.972168 
	C1563.631714,2368.103271 1563.232666,2366.005371 1562.102905,2364.442383 
	C1559.938843,2361.448975 1561.427856,2356.567627 1557.844849,2354.800781 
	C1554.530518,2353.166504 1551.747803,2356.671631 1548.600220,2357.488770 
	C1542.289429,2359.127930 1538.208618,2356.917236 1536.594116,2350.500977 
	C1535.958374,2347.974609 1536.082153,2345.224854 1536.082764,2342.576904 
	C1536.083862,2337.994141 1538.702393,2336.197998 1543.074097,2335.989014 
	C1550.466797,2335.635498 1555.544312,2338.565674 1557.598511,2346.658936 
	C1559.046387,2352.363525 1562.101685,2352.370361 1566.363159,2351.547607 
	C1567.004639,2351.423828 1567.596436,2351.054443 1568.219849,2350.821045 
	C1577.462402,2347.365479 1579.926025,2338.552734 1574.065918,2330.446777 
	C1571.940674,2327.507080 1569.621948,2328.589355 1567.000488,2329.307373 
	C1559.600464,2331.334717 1553.252075,2329.918457 1548.445312,2323.416260 
	C1545.000732,2318.757080 1545.206421,2314.895264 1549.901245,2311.426758 
	C1553.935913,2308.446289 1558.656006,2306.729980 1563.419800,2305.142090 
	C1567.171387,2303.891846 1568.822632,2301.468018 1566.718506,2297.452637 
	C1565.642212,2295.398438 1564.663574,2293.240234 1564.031860,2291.017578 
	C1562.906738,2287.060303 1560.118286,2285.692383 1556.462158,2286.059814 
	C1548.130981,2286.897705 1541.813232,2285.142822 1537.810669,2276.530518 
	C1535.256470,2271.034668 1527.567261,2270.573975 1521.927612,2274.116699 
	C1518.285522,2276.404541 1516.541626,2283.997803 1518.616333,2288.483398 
	C1519.727783,2290.885498 1521.730835,2291.850830 1524.233276,2291.914551 
	C1527.230713,2291.991211 1530.276489,2292.324707 1533.219727,2291.933350 
	C1539.703369,2291.070068 1543.587524,2295.649658 1545.467896,2301.473145 
	C1546.862915,2305.793457 1544.121460,2311.814453 1540.436035,2313.427490 
	C1535.852905,2315.433350 1528.426758,2313.835205 1526.148071,2310.012451 
	C1523.934937,2306.300537 1522.116577,2302.349121 1520.197266,2298.467041 
	C1518.483032,2295.000000 1516.188721,2293.977539 1512.124023,2294.805664 
	C1501.184448,2297.033691 1501.135254,2296.791504 1495.716919,2287.405762 
	C1492.692017,2282.166016 1488.823730,2280.690918 1482.318726,2282.296387 
	C1477.039551,2283.599365 1475.880859,2285.545166 1476.002930,2292.902344 
	C1476.167725,2302.835693 1478.367554,2304.937012 1487.923462,2302.887451 
	C1492.572632,2301.890381 1495.449585,2303.369629 1498.340576,2306.638428 
	C1501.158081,2309.823730 1501.581787,2313.772461 1502.927612,2317.482666 
	C1504.443359,2321.661377 1503.001709,2323.816162 1499.322754,2325.216797 
	C1498.081787,2325.688965 1496.776855,2325.989990 1495.515991,2326.413330 
	C1486.077148,2329.583496 1485.768555,2329.597900 1486.110107,2339.106445 
	C1486.333008,2345.313721 1485.429565,2349.649414 1478.569458,2352.011963 
	C1473.024414,2353.921387 1469.127808,2358.465088 1470.038452,2365.164795 
	C1471.071533,2372.764893 1468.789185,2378.114990 1460.995728,2380.536621 
	C1454.980469,2382.405518 1456.105713,2387.593994 1455.984741,2392.178223 
	C1455.743652,2401.332031 1450.451416,2406.382812 1441.639404,2405.976074 
	C1437.158569,2405.769043 1433.477295,2401.709229 1432.320068,2395.948730 
	C1431.338013,2391.060791 1434.525879,2389.522949 1438.178833,2388.210449 
	C1440.366211,2387.424561 1442.549194,2386.610352 1444.677246,2385.678955 
	C1452.093018,2382.435303 1452.083618,2382.413818 1449.259521,2374.402344 
	C1446.932861,2367.802002 1447.693970,2364.739990 1452.817139,2360.258057 
	C1453.566284,2359.602783 1454.386230,2359.025146 1455.195679,2358.442871 
	C1467.036011,2349.922363 1467.029663,2349.925781 1463.817627,2336.961426 
	C1462.938477,2333.413086 1461.192505,2331.876221 1457.331299,2333.340088 
	C1452.508789,2335.168701 1447.850830,2339.354980 1442.398804,2336.782715 
	C1437.721436,2334.575684 1435.883057,2329.470215 1433.383301,2325.128906 
	C1431.138672,2321.230469 1426.460083,2320.325439 1422.881592,2320.420654 
	C1415.943237,2320.605225 1412.776489,2316.813721 1409.825439,2311.670166 
	C1405.010498,2303.277588 1401.141724,2302.167480 1393.117676,2306.703369 
	C1389.718994,2308.624512 1387.224609,2311.191406 1388.838013,2315.620117 
	C1389.065918,2316.246338 1389.378052,2316.857666 1389.499390,2317.504150 
	C1391.572388,2328.552246 1391.567139,2328.553223 1403.152100,2326.546387 
	C1409.117798,2325.512939 1413.546265,2328.679199 1415.463623,2335.349121 
	C1417.182251,2341.327637 1415.646484,2344.103027 1409.228027,2346.488037 
	C1407.358887,2347.182373 1405.321167,2347.516113 1403.571899,2348.422607 
	C1398.657593,2350.969482 1396.188965,2349.193359 1395.031006,2344.183350 
	C1394.510620,2341.931641 1393.557495,2339.774170 1392.733032,2337.599609 
	C1391.270142,2333.740723 1388.581299,2331.701172 1384.313843,2332.006348 
	C1374.248291,2332.726318 1366.021240,2330.113281 1361.461914,2320.055420 
	C1360.160278,2317.184082 1357.600830,2318.083984 1355.584106,2319.669678 
	C1351.973145,2322.508057 1350.313354,2326.571289 1349.534668,2330.860596 
	C1348.168945,2338.382080 1343.165405,2342.189941 1336.562988,2344.679199 
	C1331.219360,2346.693848 1327.971191,2345.930664 1325.226318,2341.865967 
	C1321.400879,2336.200928 1321.167969,2329.856201 1324.871582,2326.306885 
	C1326.288940,2324.948486 1328.245117,2324.170166 1329.769287,2322.902832 
	C1334.422974,2319.034424 1338.380981,2315.154785 1338.299561,2308.050049 
	C1338.227417,2301.746582 1340.719971,2295.861084 1346.770508,2292.182129 
	C1349.531250,2290.503418 1352.162598,2288.575439 1352.072266,2284.427979 
	C1351.945312,2278.589844 1350.534790,2276.589600 1344.757935,2276.041016 
	C1343.766357,2275.946777 1342.729980,2275.848145 1341.764893,2276.026367 
	C1333.334839,2277.581055 1327.958862,2273.771484 1324.216064,2266.520020 
	C1321.267700,2260.807617 1316.925293,2257.054932 1309.869141,2257.980469 
	C1304.338257,2258.706055 1301.548828,2254.493652 1298.299927,2251.268311 
	C1295.695312,2248.682617 1293.135742,2247.444580 1289.421143,2249.257080 
	C1285.683105,2251.081055 1283.890381,2253.599365 1283.965088,2257.840088 
	C1284.036621,2261.904297 1285.414307,2264.360596 1289.769043,2263.941895 
	C1298.128418,2263.137451 1304.027100,2265.947021 1306.576904,2274.467529 
	C1307.327759,2276.976318 1309.643555,2277.851318 1312.136475,2277.930176 
	C1314.800171,2278.014893 1317.467407,2277.979492 1320.133179,2278.000732 
	C1330.514282,2278.083252 1333.617920,2281.166504 1333.869019,2291.495850 
	C1333.931396,2294.055908 1333.057373,2296.021240 1330.932007,2297.442383 
	C1328.997070,2298.736328 1327.185425,2300.269775 1325.123535,2301.308838 
	C1318.228516,2304.783691 1316.278564,2310.559814 1316.860107,2317.781250 
	C1317.343872,2323.790039 1315.230591,2326.316895 1308.020142,2328.929199 
	C1302.629028,2330.882324 1299.574341,2329.898682 1296.375366,2324.529785 
	C1294.518677,2321.413574 1292.531494,2318.222656 1292.045166,2314.498535 
	C1291.410767,2309.638916 1288.340576,2309.460449 1284.790894,2310.800293 
	C1282.002075,2311.852783 1279.283691,2313.221924 1276.757446,2314.806396 
	C1273.816162,2316.651367 1272.219849,2318.799805 1273.184692,2323.047852 
	C1274.562256,2329.111816 1272.125977,2332.777832 1267.350220,2333.702393 
	C1264.024780,2334.345947 1260.302856,2334.512451 1258.755249,2330.636963 
	C1257.348755,2327.114502 1257.283569,2323.384521 1260.879272,2320.749756 
	C1261.944336,2319.969238 1263.148682,2319.326416 1264.372925,2318.825439 
	C1268.890869,2316.977539 1270.822388,2314.279541 1267.831055,2309.595947 
	C1265.951050,2306.652100 1265.828857,2303.284180 1265.991943,2299.931152 
	C1266.198975,2295.673584 1264.193481,2293.862061 1260.011353,2293.972412 
	C1258.375366,2294.015381 1256.686646,2293.744873 1255.090332,2293.344482 
	C1242.708496,2290.241699 1240.866699,2284.278320 1249.318481,2274.374756 
	C1250.406616,2273.099365 1252.100586,2272.034668 1251.807861,2270.324463 
	C1250.787598,2264.364258 1251.348022,2258.790283 1253.492432,2253.026123 
	C1254.479248,2250.373535 1251.633179,2248.199463 1248.472534,2248.387207 
	C1246.858521,2248.482910 1245.313477,2249.452148 1243.687744,2249.693115 
	C1235.761230,2250.866943 1230.232422,2246.653809 1232.377075,2239.103271 
	C1235.270996,2228.914307 1231.962524,2220.973877 1227.470703,2212.676270 
	C1226.563232,2210.999756 1226.489624,2208.871826 1226.044189,2206.125732 
	C1238.092163,2205.428711 1250.127563,2205.558105 1263.080566,2205.894043 
	C1271.169678,2213.883301 1273.336914,2213.994385 1283.513306,2206.593506 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M728.186890,2027.863525 
	C745.273987,2038.481201 762.132751,2050.043701 779.212463,2061.270264 
	C789.133911,2067.791504 799.410095,2073.772949 809.976562,2080.489746 
	C811.158752,2087.097168 807.609314,2088.118896 803.199341,2086.144531 
	C797.264709,2083.487305 794.529663,2085.026611 791.898560,2090.927246 
	C786.543091,2102.938232 776.213806,2103.743652 767.851929,2093.558350 
	C765.109314,2090.218018 764.030823,2084.258545 757.756470,2085.640381 
	C751.318787,2087.058350 749.055542,2091.903809 747.958801,2097.969727 
	C746.770325,2104.543213 742.316956,2108.328857 735.760925,2109.471924 
	C728.902161,2110.667236 726.405762,2105.980225 724.314880,2100.789307 
	C721.812744,2094.577393 717.294189,2095.985596 712.721863,2097.802490 
	C708.400696,2099.519531 706.395569,2102.607666 707.702332,2107.241211 
	C709.307739,2112.933838 713.686829,2112.897461 718.122742,2111.602783 
	C725.625671,2109.413086 731.679504,2111.000488 736.900635,2117.003662 
	C740.572937,2121.225830 743.711853,2121.174316 746.534180,2115.336914 
	C754.484375,2098.893555 764.980164,2097.057129 779.270569,2109.121094 
	C780.040039,2109.770996 780.908752,2110.258057 782.762695,2109.829346 
	C782.776245,2102.170166 787.841675,2097.448486 793.706787,2092.937988 
	C798.275452,2089.424316 802.303833,2085.708252 808.749939,2087.507080 
	C811.087036,2088.159424 813.223145,2086.640625 815.782959,2084.982422 
	C831.442078,2092.422852 846.469788,2100.268799 861.557678,2107.997070 
	C921.370911,2138.635254 984.186279,2161.231201 1049.793213,2178.354004 
	C1047.231079,2183.911377 1044.528931,2188.332275 1048.857788,2195.019043 
	C1053.025757,2201.457275 1049.322021,2208.036865 1041.971069,2210.935547 
	C1035.115723,2213.639160 1031.466919,2211.927734 1030.085571,2204.494385 
	C1029.257202,2200.037354 1027.230713,2198.014160 1022.866760,2198.030029 
	C1020.868164,2198.037109 1018.830017,2197.750000 1016.877441,2198.044678 
	C1007.941528,2199.392334 1002.472595,2195.325195 998.622437,2187.533203 
	C995.847168,2181.916748 990.146179,2180.455322 984.362061,2182.922363 
	C981.236450,2184.255371 979.512451,2186.350098 980.358093,2189.932129 
	C980.890259,2192.186035 981.713989,2194.416748 981.891541,2196.697998 
	C982.178101,2200.379639 982.225769,2204.010498 977.736206,2205.806641 
	C973.346741,2207.562256 966.214722,2207.111816 963.740723,2204.182617 
	C961.034241,2200.978271 961.715271,2197.356934 963.169250,2193.837158 
	C965.167419,2189.000000 968.869385,2185.815430 973.284241,2183.187012 
	C976.759216,2181.118164 978.612061,2178.426514 976.086487,2174.117188 
	C972.993103,2168.839355 969.333252,2166.614502 964.808655,2168.972656 
	C959.540466,2171.718506 952.944824,2173.170654 953.423340,2181.915283 
	C953.685913,2186.714111 950.190491,2191.206787 947.243042,2195.262939 
	C945.277954,2197.967529 943.238464,2200.637207 942.385742,2203.917480 
	C940.520874,2211.091309 942.476807,2213.664551 949.806213,2214.007080 
	C952.785278,2214.146240 955.849243,2214.019531 958.710022,2214.703125 
	C961.577148,2215.387451 964.412842,2216.701904 965.595520,2219.903076 
	C967.536072,2225.156250 963.638916,2231.534668 956.583618,2234.643066 
	C950.070190,2237.512695 945.146973,2235.961426 942.347229,2230.125244 
	C942.063416,2229.533447 942.080017,2228.791016 941.771973,2228.218018 
	C940.198303,2225.292725 941.018005,2221.267578 938.396118,2219.045166 
	C935.360718,2216.471924 931.995056,2220.168213 928.912292,2219.567139 
	C924.484558,2218.703125 919.816223,2218.102539 917.408142,2212.952148 
	C914.970398,2207.738281 916.857483,2204.387695 920.285583,2200.532959 
	C926.986511,2192.998291 924.031006,2181.946289 914.476196,2177.930176 
	C911.054749,2176.492188 907.818359,2174.972168 905.221436,2172.239990 
	C899.620361,2166.346680 892.301331,2167.151855 885.281067,2166.451660 
	C885.074158,2167.855469 884.813843,2168.519531 884.913696,2169.124268 
	C885.520996,2172.801270 890.264465,2176.429688 886.286987,2180.083740 
	C881.143433,2184.809082 875.107300,2188.798584 867.864441,2189.148682 
	C864.382629,2189.316895 862.562378,2185.165283 862.890930,2182.644287 
	C863.673462,2176.640137 863.469116,2169.775146 870.678406,2166.561523 
	C873.212646,2165.431641 877.700195,2164.699951 876.929749,2161.265869 
	C875.784485,2156.161865 877.439941,2150.328613 873.591309,2145.933350 
	C870.948120,2142.914551 867.499084,2143.800293 864.339417,2144.937744 
	C861.047852,2146.122803 856.724121,2146.260010 856.231018,2151.078613 
	C855.960754,2153.719727 855.817627,2156.419922 856.047607,2159.055908 
	C856.553772,2164.858154 853.683472,2168.893555 848.931763,2171.116699 
	C844.734863,2173.080566 841.187683,2170.056152 838.403076,2167.237061 
	C834.531311,2163.317139 830.182739,2160.553223 824.810852,2159.348633 
	C818.483154,2157.929443 815.230652,2160.910400 816.212769,2167.292236 
	C817.203674,2173.731445 819.031067,2175.399658 825.756287,2176.005371 
	C837.958252,2177.104492 841.474182,2180.011963 842.964722,2189.936523 
	C843.548340,2193.822510 842.511597,2197.087402 839.856445,2199.855713 
	C838.944702,2200.806152 837.718445,2201.446777 836.739441,2202.341797 
	C826.738586,2211.487061 827.393005,2214.834473 840.113647,2219.766602 
	C848.666199,2223.082275 850.860291,2227.213867 848.798584,2234.707764 
	C847.476013,2239.514893 845.326416,2242.447998 839.868164,2242.018311 
	C834.951477,2241.631348 830.806030,2240.948975 829.733948,2234.770752 
	C828.476440,2227.523682 823.481262,2223.895752 816.229126,2224.079346 
	C809.229492,2224.256104 802.758850,2224.432373 801.200256,2215.237549 
	C800.788025,2212.805176 797.998535,2212.083984 795.510193,2212.053711 
	C792.845520,2212.020996 790.134949,2211.694580 787.524597,2212.063477 
	C781.074097,2212.975098 776.656799,2210.590820 773.785583,2204.782715 
	C771.600586,2200.362793 768.539490,2197.860107 762.895874,2197.828857 
	C750.627502,2197.760742 746.385620,2190.989258 751.522644,2179.484863 
	C754.130920,2173.643311 756.003723,2167.758057 757.152649,2161.567139 
	C758.223511,2155.796631 756.472290,2154.173828 751.020203,2155.388184 
	C745.763062,2156.558838 742.358948,2158.802734 741.210327,2164.860596 
	C739.849365,2172.038574 736.823486,2178.750244 730.080261,2183.049805 
	C726.322266,2185.446045 726.258972,2189.540771 725.826233,2193.659180 
	C724.858093,2202.871582 719.031067,2206.437500 710.282471,2203.683838 
	C707.258850,2202.731934 705.068542,2200.732178 704.312866,2197.538330 
	C703.526428,2194.214355 705.000366,2191.692383 707.515991,2189.704102 
	C710.461426,2187.375977 713.776978,2186.041748 717.603638,2185.900146 
	C721.880249,2185.741943 722.296570,2182.906738 721.532654,2179.577148 
	C719.857300,2172.275146 707.974365,2163.601318 700.525879,2164.066406 
	C697.074036,2164.282227 695.779053,2166.124023 696.291565,2169.327637 
	C696.551392,2170.952148 697.406433,2172.485596 697.632629,2174.110352 
	C698.415100,2179.730713 695.517151,2184.571533 690.199768,2186.827393 
	C684.774902,2189.128906 679.723145,2188.797852 677.045471,2183.620361 
	C672.442200,2174.719482 665.788208,2174.644287 658.032104,2177.081787 
	C653.595093,2178.476318 651.830688,2176.275391 650.632690,2172.793213 
	C648.005188,2165.155518 651.131958,2156.480469 659.295410,2152.844971 
	C665.123535,2150.249512 667.321472,2147.433105 664.818604,2141.548828 
	C663.184021,2137.705811 664.890320,2134.477539 666.397827,2131.092529 
	C669.472656,2124.188477 674.188171,2118.051270 674.305420,2109.812256 
	C674.380676,2104.523926 680.078308,2103.839111 683.935913,2102.486816 
	C687.948364,2101.079834 692.371460,2100.877441 696.584351,2100.000977 
	C702.261658,2098.819824 702.551941,2098.406250 700.286438,2092.792236 
	C699.027039,2089.671143 697.726746,2086.672607 698.008667,2083.210449 
	C698.694275,2074.788574 703.314636,2069.725830 711.435913,2068.118652 
	C715.518127,2067.311035 716.506592,2065.413330 714.916382,2061.873291 
	C710.974182,2053.096924 713.541321,2046.993042 721.560730,2041.752441 
	C725.624634,2039.096802 726.233459,2033.243530 728.186890,2027.863525 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1693.231445,2105.576172 
	C1698.941528,2101.862061 1704.374878,2098.788818 1710.475220,2095.648438 
	C1713.189941,2094.774170 1716.119141,2097.006348 1717.481445,2093.145996 
	C1725.187134,2086.551025 1733.997925,2082.431152 1743.019043,2077.306152 
	C1744.402832,2091.299805 1744.397095,2091.330566 1758.421021,2093.923828 
	C1760.370605,2094.284424 1762.350830,2094.210693 1764.116577,2095.416748 
	C1768.215088,2098.215576 1768.782959,2101.588867 1765.470825,2105.405762 
	C1764.176147,2106.897705 1762.653320,2108.277344 1761.006348,2109.362061 
	C1755.180786,2113.199463 1752.663818,2112.514160 1749.179932,2106.302002 
	C1748.040283,2104.269775 1747.013672,2102.172363 1745.979370,2100.083252 
	C1743.474365,2095.024170 1738.903320,2095.610107 1734.674438,2096.353271 
	C1730.687134,2097.053955 1728.611938,2099.964600 1728.035889,2104.065674 
	C1726.618286,2114.157959 1731.127930,2120.460205 1741.248413,2121.992920 
	C1743.641113,2122.355469 1746.013062,2122.578613 1747.113770,2125.019531 
	C1748.398071,2127.868164 1748.568970,2130.883545 1746.772095,2133.596191 
	C1744.708862,2136.710693 1742.077393,2134.668457 1739.591187,2134.168213 
	C1736.717896,2133.589111 1734.960938,2131.857910 1733.624146,2129.359375 
	C1730.800171,2124.081543 1726.006104,2123.228027 1720.751221,2124.280518 
	C1715.860596,2125.259766 1712.644165,2129.481934 1712.786987,2133.490479 
	C1713.177490,2144.444092 1708.121582,2150.545166 1698.597778,2154.714355 
	C1694.612671,2156.459229 1694.137451,2160.154053 1696.129761,2164.845703 
	C1698.928101,2171.435303 1701.306641,2177.123535 1710.066772,2176.161865 
	C1714.066895,2175.722656 1715.678467,2179.080322 1716.997559,2182.272461 
	C1718.069458,2184.865967 1716.779907,2186.940918 1715.188721,2188.595459 
	C1713.363281,2190.493652 1710.814941,2190.367432 1708.734253,2189.044189 
	C1706.797852,2187.812256 1704.974365,2186.220703 1703.525269,2184.441895 
	C1700.180176,2180.335449 1695.853149,2179.582764 1690.965820,2180.013184 
	C1683.179688,2180.698730 1680.286865,2183.237793 1680.089478,2191.116211 
	C1679.881348,2199.426025 1675.836182,2204.938232 1668.798950,2208.482422 
	C1662.831543,2211.487793 1659.420898,2209.552734 1658.163818,2202.896240 
	C1656.376953,2193.434082 1657.946045,2190.500488 1666.839966,2186.676514 
	C1676.206055,2182.649658 1676.388184,2182.323975 1674.574219,2172.835449 
	C1673.233398,2165.821533 1674.240723,2163.591797 1680.588745,2159.760986 
	C1682.297241,2158.730225 1684.215698,2158.006836 1685.806152,2156.829590 
	C1689.914917,2153.788330 1691.170654,2148.963623 1689.460083,2143.373047 
	C1687.923584,2138.351074 1684.904175,2135.322754 1679.226074,2135.994629 
	C1678.569092,2136.072266 1677.894531,2136.010254 1677.228394,2135.999268 
	C1664.241089,2135.783447 1664.241089,2135.783203 1660.049194,2122.081055 
	C1668.075684,2117.221680 1676.164429,2113.173828 1684.980957,2108.994873 
	C1689.340820,2111.710693 1687.444458,2115.525146 1687.450073,2118.989746 
	C1687.456299,2122.826416 1688.051270,2126.584961 1692.158203,2127.907959 
	C1696.120483,2129.184570 1699.349121,2127.027588 1701.423218,2123.802002 
	C1703.911865,2119.931885 1702.731689,2116.241943 1699.833130,2112.956787 
	C1697.702515,2110.541748 1693.765747,2109.973633 1693.231445,2105.576172 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M568.697144,2210.809326 
	C566.452881,2218.025391 562.357117,2222.216553 555.652222,2224.107666 
	C547.748413,2226.336670 546.647522,2227.661865 548.975830,2235.349609 
	C550.679260,2240.974121 548.774536,2245.145020 546.097656,2249.363525 
	C543.951172,2252.746582 541.417908,2252.313477 539.417114,2248.626709 
	C537.207886,2244.556152 538.304565,2240.147217 537.991333,2235.879883 
	C537.650757,2231.239746 538.712585,2227.643066 543.224426,2225.023682 
	C546.945129,2222.863770 546.978210,2218.176514 547.853455,2214.376953 
	C549.637207,2206.633057 550.880798,2205.255127 558.661011,2204.034668 
	C566.257690,2202.843018 566.673218,2202.686035 564.044983,2195.734863 
	C562.093628,2190.573730 562.303772,2186.177734 565.073608,2181.554443 
	C566.073975,2179.884766 566.441345,2177.821045 567.015625,2175.912598 
	C570.730530,2163.566650 570.280518,2161.817871 558.905212,2155.630127 
	C553.518799,2152.700439 549.784119,2149.419678 549.207642,2142.923828 
	C548.975159,2140.304932 547.210266,2137.399170 549.963867,2135.677734 
	C553.215698,2133.644775 556.745117,2131.446045 561.065857,2133.535889 
	C563.855530,2134.885254 566.074890,2136.850830 568.040833,2139.094971 
	C571.689331,2143.260010 576.369507,2146.238281 581.482361,2147.290039 
	C586.403015,2148.301758 589.890198,2150.919189 593.507385,2153.768066 
	C600.704651,2159.437256 599.739563,2167.970947 591.465149,2171.833984 
	C589.965393,2172.534180 588.364685,2173.014893 586.831116,2173.646729 
	C583.137268,2175.168945 582.238281,2177.410645 583.465027,2181.525635 
	C586.471863,2191.610840 586.251160,2192.238037 595.829529,2191.824463 
	C602.899292,2191.519287 605.928467,2194.983154 608.396118,2200.687744 
	C611.657166,2208.226807 612.036011,2208.537354 619.762878,2205.650635 
	C625.179077,2203.626953 628.561707,2204.364014 631.059998,2209.677246 
	C632.606079,2212.965820 634.658569,2216.020508 636.537720,2219.147461 
	C638.564026,2222.520020 637.836670,2225.659668 635.401184,2228.308594 
	C633.044495,2230.871826 629.775818,2230.458984 627.032959,2229.262207 
	C621.326904,2226.772705 614.992798,2224.923828 613.473999,2217.377441 
	C612.504028,2212.557861 609.222595,2211.973145 605.197632,2213.964844 
	C598.625793,2217.217285 593.742065,2215.319336 590.068726,2209.230957 
	C589.398010,2208.119385 588.280579,2207.266357 587.325012,2206.339600 
	C581.570251,2200.759033 579.385925,2200.719238 572.765137,2205.597412 
	C571.075378,2206.842285 569.905396,2208.327393 568.697144,2210.809326 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1907.586060,1950.587646 
	C1911.842285,1948.615845 1913.642212,1944.854248 1917.524414,1942.750732 
	C1925.690063,1945.835571 1926.933472,1942.091431 1925.994263,1935.060547 
	C1927.032471,1931.789795 1929.155762,1930.251953 1931.778564,1928.419434 
	C1935.106567,1927.925537 1935.943604,1930.054810 1936.223633,1931.873047 
	C1937.422729,1939.662598 1942.934814,1942.812256 1950.109619,1945.435669 
	C1949.833008,1958.655273 1948.613647,1971.095581 1934.860352,1977.323364 
	C1929.329224,1979.828125 1930.230469,1984.462158 1931.137207,1989.219604 
	C1932.411987,1995.908081 1932.246338,2002.037476 1922.617920,2002.458008 
	C1922.204468,1998.676270 1924.182983,1995.777222 1924.047241,1992.307007 
	C1923.870483,1987.786499 1923.162598,1983.254517 1919.042969,1981.036743 
	C1914.724731,1978.712158 1909.987183,1979.755005 1905.718140,1982.188965 
	C1902.726685,1983.894775 1901.426025,1986.267578 1902.914429,1989.656006 
	C1903.448975,1990.872559 1904.064331,1992.053345 1904.615479,1993.262939 
	C1908.728271,2002.285767 1907.947388,2003.941284 1898.611084,2006.022339 
	C1891.527710,2007.601440 1887.278320,2011.333496 1888.277832,2018.156006 
	C1889.733032,2028.090088 1883.873657,2032.553833 1877.295776,2037.276489 
	C1870.169067,2042.393188 1870.220947,2042.465332 1872.507446,2050.823242 
	C1874.333008,2057.496338 1874.162476,2057.847412 1867.894897,2060.289795 
	C1867.276245,2060.530762 1866.654663,2060.764648 1866.028564,2060.985840 
	C1855.232300,2064.796143 1855.232056,2064.795654 1852.315186,2053.922363 
	C1849.735840,2044.307861 1848.703735,2043.679810 1838.529053,2045.533691 
	C1831.033569,2046.899292 1823.014771,2038.796509 1824.184937,2031.036621 
	C1824.444946,2029.312988 1825.128418,2027.498901 1826.759644,2027.052368 
	C1830.875000,2025.926392 1835.076294,2025.010376 1839.300781,2024.430786 
	C1841.461060,2024.134399 1842.863403,2025.941650 1843.820068,2027.781494 
	C1845.353394,2030.730225 1847.029663,2033.627930 1848.274292,2036.697754 
	C1850.070557,2041.127930 1853.262451,2042.669678 1857.749023,2041.928223 
	C1862.471802,2041.147705 1867.014160,2040.037354 1867.978271,2034.222534 
	C1868.141357,2033.239990 1868.414062,2032.268188 1868.492065,2031.280029 
	C1869.179199,2022.559570 1872.603271,2015.881592 1880.945801,2011.764282 
	C1886.034302,2009.253418 1886.447998,2003.864014 1886.000244,1998.653076 
	C1885.543213,1993.335327 1886.728027,1989.079224 1891.831787,1986.012573 
	C1901.334473,1980.303101 1901.203125,1980.084473 1898.096191,1968.767578 
	C1901.126709,1965.578125 1902.707275,1968.355957 1904.611206,1969.983154 
	C1907.018555,1972.040405 1909.752930,1974.066895 1911.965820,1970.272949 
	C1913.774292,1967.172607 1912.140503,1964.568848 1908.981567,1963.073853 
	C1907.490723,1962.368530 1905.859375,1961.989990 1903.833252,1960.707275 
	C1901.191772,1955.825317 1904.689087,1953.712769 1907.586060,1950.587646 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M395.694427,2155.702637 
	C403.628448,2152.416016 406.628876,2147.610596 406.289520,2139.240479 
	C405.912689,2129.947754 417.130219,2124.127686 425.005798,2128.950684 
	C428.490082,2131.084473 430.641327,2134.734131 429.238922,2139.176758 
	C428.253967,2142.297119 427.608246,2145.626953 425.142426,2148.128662 
	C421.091431,2152.238281 423.975433,2157.577393 422.858307,2162.259277 
	C422.366608,2164.319824 424.815338,2165.657715 426.897644,2165.781006 
	C430.523254,2165.995605 433.072998,2167.854248 435.365967,2170.400879 
	C441.527039,2177.243896 441.696686,2182.121582 434.621735,2188.125977 
	C429.958282,2192.083740 427.229919,2195.934570 427.838440,2202.376953 
	C428.376251,2208.071289 425.575745,2212.407959 420.042999,2215.006104 
	C414.646912,2217.540039 411.112213,2214.187500 407.446411,2211.577881 
	C403.274139,2208.607666 402.548523,2203.523682 405.876892,2199.436279 
	C408.573944,2196.124268 411.777069,2193.080566 415.231750,2190.573975 
	C418.151550,2188.455322 420.534546,2186.518066 419.689178,2182.595215 
	C418.780243,2178.377441 415.420807,2178.352783 411.986694,2177.937744 
	C402.148224,2176.748535 394.713470,2166.977539 395.694427,2155.702637 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M459.780640,2250.757568 
	C459.616150,2242.890381 460.266266,2236.118652 463.688293,2229.650146 
	C465.347137,2226.514648 466.096893,2222.853271 466.067474,2219.055420 
	C466.003601,2210.817871 466.102539,2210.731934 457.914917,2207.993896 
	C452.928711,2206.326172 447.775116,2198.637695 448.119019,2193.379395 
	C448.460785,2188.153809 454.092316,2181.677246 459.291504,2180.529785 
	C464.939758,2179.283447 471.437286,2185.757080 472.001526,2193.022461 
	C472.268829,2196.464355 470.957245,2199.536377 470.255005,2202.763916 
	C469.900299,2204.394287 470.060547,2206.218506 471.715759,2207.164551 
	C473.328613,2208.086426 474.956604,2207.562500 476.245087,2206.304443 
	C478.095703,2204.497559 479.356323,2202.196533 482.552765,2201.979980 
	C487.561249,2201.640137 491.677643,2203.410400 493.352051,2207.334717 
	C495.243286,2211.767090 494.328674,2219.806152 490.566620,2222.008789 
	C484.066345,2225.814209 481.105896,2230.683838 481.800720,2238.271729 
	C482.132385,2241.894287 479.337799,2244.267822 476.059357,2245.661377 
	C474.229706,2246.439209 472.283203,2246.957520 470.492889,2247.810059 
	C463.763336,2251.014893 463.476715,2251.251465 465.212677,2258.322754 
	C466.225983,2262.450684 466.007172,2266.127441 464.087189,2269.876953 
	C462.375336,2273.220703 460.886658,2276.514648 456.141541,2275.964844 
	C452.076355,2275.493896 447.089722,2271.416748 446.246368,2267.311768 
	C445.357697,2262.986084 446.566833,2259.318604 450.509583,2257.032715 
	C453.578766,2255.253418 457.771698,2255.377441 459.780640,2250.757568 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M316.633362,1336.826660 
	C318.454590,1335.795654 319.645325,1335.197876 320.821838,1334.573120 
	C329.089111,1330.183594 329.074097,1330.193604 323.210144,1323.174072 
	C322.366333,1322.164062 321.310760,1321.058960 321.076843,1319.857056 
	C319.885498,1313.735840 315.639099,1311.187988 310.157898,1309.669556 
	C308.661499,1309.255127 307.218658,1308.084595 306.117371,1306.916016 
	C303.231384,1303.853882 303.551117,1300.902100 307.160950,1298.589233 
	C313.227448,1294.702393 319.929993,1295.703735 326.512329,1296.688110 
	C328.193726,1296.939575 329.282837,1298.502075 329.708771,1300.209106 
	C331.213776,1306.240723 335.959717,1308.444458 341.218414,1310.051025 
	C344.113373,1310.935425 346.790100,1312.199707 349.115479,1314.180786 
	C356.184601,1320.203369 355.158844,1328.567993 346.717926,1332.512207 
	C344.654694,1333.476318 342.238647,1333.655029 340.047607,1334.383911 
	C337.547455,1335.215454 335.983429,1336.921509 336.980682,1339.679321 
	C338.154785,1342.926270 337.961945,1346.225464 337.958160,1349.548096 
	C337.954376,1352.890381 336.230194,1355.246460 333.558472,1356.909180 
	C330.880463,1358.575806 315.306427,1354.439697 313.227203,1351.644287 
	C310.868530,1348.473145 312.001770,1342.581055 316.633362,1336.826660 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M768.903564,2214.187500 
	C775.221252,2213.035889 778.876343,2215.389893 780.222290,2220.663330 
	C781.938965,2227.389160 785.409851,2231.097900 792.865540,2230.265869 
	C794.683960,2230.062988 796.637329,2231.430664 798.575623,2231.867676 
	C803.260864,2232.925293 804.709778,2236.637695 805.722229,2240.581299 
	C806.822205,2244.865967 803.252441,2246.362305 800.615234,2248.204346 
	C796.983032,2250.741211 793.165466,2250.758545 789.455078,2248.249756 
	C788.636719,2247.696289 787.841309,2247.009033 787.263062,2246.216797 
	C783.339722,2240.841797 779.106567,2239.716064 772.828125,2243.192383 
	C767.265869,2246.272461 767.128357,2245.485352 768.684875,2252.127441 
	C769.916443,2257.382324 765.931824,2260.646240 762.533630,2263.470703 
	C760.354004,2265.281738 757.054321,2265.712158 754.308533,2266.883057 
	C749.405273,2268.973877 745.729492,2266.708252 743.002136,2263.132080 
	C740.392029,2259.709717 742.074585,2252.453613 745.688416,2249.578369 
	C748.333374,2247.473877 751.469238,2246.590820 754.784668,2245.803955 
	C761.594177,2244.187256 761.785461,2243.517334 759.999146,2237.038086 
	C756.811829,2225.477295 758.021790,2222.090576 768.903564,2214.187500 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M903.130859,2184.029785 
	C907.668518,2184.331543 910.008728,2186.460449 911.573303,2189.650635 
	C914.638062,2195.900146 913.955383,2198.314697 908.013306,2201.947998 
	C906.882324,2202.639648 905.711792,2203.340088 904.466003,2203.758057 
	C896.178589,2206.539062 891.045593,2210.660156 893.767578,2220.903076 
	C895.398926,2227.041992 893.539001,2232.954834 885.528564,2234.138428 
	C882.500793,2234.585938 881.811218,2236.649902 882.774780,2239.281494 
	C883.588135,2241.502686 884.119568,2243.726807 883.918518,2246.094238 
	C883.381958,2252.413574 879.363770,2256.268311 872.228699,2257.643555 
	C867.002136,2258.650879 864.218567,2255.815918 861.896057,2251.772217 
	C860.422302,2249.206055 860.374084,2246.872314 861.836914,2244.291260 
	C863.469055,2241.411865 864.517029,2238.151611 867.120667,2235.924072 
	C870.627319,2232.923584 871.996338,2229.331299 872.138550,2224.599121 
	C872.436218,2214.696045 874.768311,2212.081055 884.899475,2210.129639 
	C889.107788,2209.318848 890.038208,2208.013428 888.160583,2204.293457 
	C887.274475,2202.537842 886.494751,2200.628174 886.175659,2198.704102 
	C884.654114,2189.529053 889.058594,2184.269775 898.308838,2184.005859 
	C899.637024,2183.968018 900.967407,2184.005127 903.130859,2184.029785 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M718.014893,2250.268311 
	C715.152039,2254.242676 715.622375,2257.665527 717.955383,2260.885498 
	C719.388794,2262.864014 720.109497,2264.975098 719.936584,2267.389160 
	C719.691650,2270.808350 719.051086,2274.384033 715.396057,2275.483154 
	C711.541931,2276.642334 707.493347,2276.589844 704.325562,2273.196533 
	C701.717896,2270.403320 700.822021,2266.655273 703.196228,2264.137939 
	C710.415649,2256.482666 712.355347,2247.155273 713.503601,2237.297119 
	C713.801270,2234.741943 715.449280,2232.367432 715.957458,2229.807129 
	C716.627441,2226.431641 718.221191,2224.039307 721.741455,2224.154785 
	C729.646667,2224.414062 731.689026,2218.902832 733.374146,2212.929199 
	C733.821716,2211.342529 733.892212,2209.650146 734.330139,2208.059814 
	C735.735962,2202.956299 739.204712,2200.425049 744.432800,2200.030273 
	C749.747437,2199.628662 754.763245,2202.134277 756.960266,2206.382812 
	C757.769958,2207.948730 758.021790,2209.540283 757.286804,2211.145264 
	C754.806091,2216.563232 752.731140,2222.254883 746.487976,2224.777588 
	C741.208313,2226.911377 737.779480,2230.262695 737.758057,2236.683838 
	C737.742188,2241.448730 734.415344,2244.346680 729.858643,2245.804932 
	C726.082214,2247.013428 722.386169,2248.472900 718.014893,2250.268311 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2038.346680,1994.867676 
	C2041.289062,1994.109863 2043.124634,1994.521362 2043.836548,1996.902832 
	C2044.784302,2000.072754 2045.273315,2003.413452 2046.516113,2006.453125 
	C2048.146484,2010.441162 2046.902710,2012.766724 2043.217529,2014.370972 
	C2041.390503,2015.166504 2039.629517,2016.123901 2037.876221,2017.077148 
	C2030.170288,2021.266602 2028.928467,2023.063110 2030.916992,2031.283569 
	C2031.936279,2035.497192 2031.362671,2037.573242 2027.165649,2038.575439 
	C2025.896729,2038.878296 2024.736938,2039.646362 2023.533813,2040.215698 
	C2013.178833,2045.117554 2013.179321,2045.118896 2008.498169,2035.076782 
	C2004.468994,2026.433350 2002.247681,2025.106934 1991.972656,2027.155884 
	C1988.028931,2027.942139 1986.352783,2026.907349 1985.544067,2023.341675 
	C1985.398926,2022.701782 1985.028931,2022.116089 1984.798950,2021.491943 
	C1981.018677,2011.227417 1984.876953,2005.924438 1995.917358,2006.116699 
	C1998.499268,2006.161743 2000.373535,2007.232666 2001.635498,2009.429199 
	C2002.958984,2011.732788 2003.987061,2014.261475 2005.609619,2016.325806 
	C2008.554321,2020.072510 2011.815552,2023.385254 2017.421265,2021.230957 
	C2022.334717,2019.342651 2025.641724,2015.217041 2025.218384,2009.733276 
	C2024.895630,2005.552002 2022.254028,2001.194458 2026.124390,1997.566284 
	C2029.313721,1994.576538 2033.955566,1996.916504 2038.346680,1994.867676 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M775.930664,2298.205566 
	C773.385681,2309.389160 771.095398,2311.650146 762.033386,2309.757324 
	C755.061584,2308.301025 747.774048,2306.185303 743.994080,2299.025391 
	C742.900269,2296.953369 741.407532,2296.476562 739.375183,2295.966797 
	C733.662781,2294.532227 730.082825,2289.750244 730.142944,2284.173828 
	C730.186523,2280.134766 733.262695,2276.611084 737.483765,2276.130127 
	C741.400452,2275.683838 744.823486,2276.403320 745.990906,2280.990234 
	C746.561218,2283.231445 747.381714,2285.411621 747.897339,2287.663330 
	C749.441833,2294.406982 750.938110,2295.162842 756.961304,2291.391846 
	C764.917358,2286.410889 768.987671,2278.527588 771.627686,2269.935791 
	C774.426941,2260.825439 775.074036,2259.729736 780.107056,2260.086670 
	C786.274109,2260.524170 791.223450,2265.339111 791.912659,2271.571777 
	C792.584595,2277.648193 789.591980,2281.770264 782.975342,2283.881592 
	C773.988708,2286.749023 773.497070,2287.688965 775.930664,2298.205566 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1921.655640,2002.479980 
	C1930.144531,1998.311523 1930.214355,1998.170044 1928.523438,1990.675049 
	C1928.160889,1989.068726 1928.235107,1987.298584 1927.588379,1985.833252 
	C1925.234131,1980.499512 1926.205322,1977.226318 1932.303467,1975.455811 
	C1935.330200,1974.576904 1937.971069,1972.157959 1940.606079,1970.193726 
	C1944.217407,1967.501465 1946.662964,1964.076050 1945.988037,1959.232178 
	C1945.357300,1954.705688 1946.695801,1950.834106 1949.855957,1946.739380 
	C1950.794556,1945.300903 1951.717773,1945.011108 1953.384644,1945.565186 
	C1958.190796,1945.850342 1962.232056,1945.850830 1962.318359,1951.743530 
	C1962.332031,1952.677612 1962.961670,1953.605469 1963.318970,1954.531250 
	C1966.953247,1963.943970 1966.954102,1963.943726 1957.239380,1966.558716 
	C1948.383301,1968.942505 1945.856934,1973.748779 1948.387817,1983.970459 
	C1949.087280,1986.795288 1950.421875,1989.462891 1951.571289,1992.481934 
	C1946.485596,1994.240234 1941.819336,1995.719971 1937.258911,1997.474365 
	C1933.927856,1998.755615 1930.968994,2001.044434 1932.723267,2004.967773 
	C1935.727539,2011.686279 1932.883179,2016.283936 1928.126709,2021.291748 
	C1922.752686,2020.963257 1915.896362,2022.214722 1915.999023,2012.781982 
	C1913.832520,2009.367920 1915.153687,2007.221924 1917.476074,2004.571289 
	C1919.103760,2003.653320 1920.207520,2003.306763 1921.655640,2002.479980 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2180.666504,1954.000366 
	C2176.403809,1951.699097 2173.214111,1949.320557 2171.358154,1945.009277 
	C2168.357422,1938.038696 2164.527832,1932.108032 2154.789062,1935.644653 
	C2150.720459,1937.122192 2145.998291,1932.194702 2144.528076,1926.664551 
	C2143.788086,1923.881714 2143.970947,1921.497314 2146.763428,1919.741699 
	C2150.750732,1917.234985 2157.933594,1917.270874 2160.728271,1920.266968 
	C2162.297363,1921.949219 2163.404053,1924.059204 2164.746338,1925.957275 
	C2169.146729,1932.179932 2171.652832,1933.147339 2178.924805,1931.358521 
	C2180.210449,1931.042114 2181.428467,1930.458496 2182.704346,1930.090942 
	C2190.423096,1927.867554 2190.406006,1927.880493 2192.090576,1936.198608 
	C2192.417969,1937.814453 2192.906982,1939.404907 2193.421875,1940.974365 
	C2196.135498,1949.247559 2200.308350,1951.677002 2208.451172,1949.476685 
	C2210.957275,1948.799683 2213.305664,1947.539307 2216.063721,1946.407715 
	C2219.237793,1949.807129 2218.337158,1954.187988 2219.355469,1957.771484 
	C2221.173828,1964.171143 2214.729004,1969.308228 2208.367188,1967.065063 
	C2204.479248,1965.693970 2201.640137,1963.086182 2199.645508,1959.323242 
	C2195.422852,1951.356567 2195.306396,1951.418335 2184.545410,1953.447632 
	C2183.111084,1954.000000 2182.222168,1954.000000 2180.666504,1954.000366 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M246.768219,2104.216553 
	C254.583786,2102.681641 258.593140,2107.170166 262.588135,2111.743652 
	C263.976990,2113.333496 264.666351,2116.432861 267.827179,2114.755859 
	C269.812408,2113.702637 271.708557,2111.298340 273.971893,2113.375977 
	C276.868408,2116.035156 280.806213,2117.654297 282.589996,2121.444580 
	C284.666351,2125.856689 285.312469,2130.967285 282.992401,2134.888428 
	C280.243713,2139.533691 277.860992,2143.094727 279.340790,2149.210449 
	C280.560760,2154.252197 261.204254,2165.224854 256.368347,2162.791260 
	C253.927353,2161.562744 252.335297,2159.401367 252.113495,2156.474854 
	C251.665848,2150.567871 256.945679,2144.558838 263.123352,2144.008057 
	C264.442932,2143.890381 265.811554,2144.056396 267.088409,2143.776367 
	C270.640076,2142.997559 272.442047,2141.016602 270.564972,2137.355225 
	C268.475677,2133.280029 265.438629,2129.645996 265.584259,2124.642334 
	C265.626129,2123.204102 263.967163,2121.958740 262.829376,2122.475098 
	C257.039154,2125.103760 252.518616,2121.187744 247.769211,2119.524658 
	C237.844604,2116.049072 237.452271,2111.302979 246.768219,2104.216553 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M322.858643,2152.303711 
	C330.768951,2148.070068 337.996857,2149.718506 344.174744,2153.788574 
	C348.290833,2156.500732 352.037445,2157.861328 356.901825,2158.163330 
	C368.727448,2158.897461 376.435486,2171.374512 372.388031,2181.835205 
	C370.622375,2186.398682 367.380981,2187.786865 363.171265,2187.921387 
	C358.931702,2188.056885 354.309692,2188.922119 351.923676,2183.762695 
	C350.667023,2181.045410 349.010498,2178.497559 347.918823,2175.721924 
	C345.786896,2170.301270 341.971222,2168.741943 336.800354,2170.774170 
	C332.178925,2172.590332 327.850037,2172.446533 325.442749,2167.971436 
	C322.990906,2163.413086 317.273529,2159.103271 322.858643,2152.303711 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M361.787964,1243.340942 
	C360.660095,1248.906128 360.145294,1253.776733 360.708496,1259.532349 
	C360.987183,1262.511353 361.058746,1264.677246 360.241608,1267.421997 
	C355.324371,1267.708740 351.188629,1268.465942 347.047882,1269.911377 
	C342.322998,1271.560669 338.032257,1273.022949 335.580811,1278.251831 
	C333.652161,1282.365601 328.926025,1282.960571 324.385651,1281.092529 
	C321.241821,1279.799072 319.805908,1277.639160 320.048370,1274.162842 
	C320.331055,1270.110352 322.679504,1268.837158 326.330383,1267.843262 
	C333.752716,1265.822876 335.364380,1264.153564 333.679657,1257.651978 
	C332.043945,1251.339600 333.579529,1246.114624 337.501312,1242.233032 
	C341.831085,1237.947510 346.954010,1233.806763 353.878021,1234.001465 
	C355.531067,1234.047974 357.186584,1234.006226 359.712341,1234.009521 
	C362.636108,1236.634033 361.816040,1239.683960 361.787964,1243.340942 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M628.046753,2284.064941 
	C632.100647,2286.778809 635.009644,2289.196777 632.942078,2294.168701 
	C630.949158,2298.960449 627.483215,2300.222168 622.673218,2300.092041 
	C619.517883,2300.006836 616.061768,2298.988770 612.749023,2301.694336 
	C613.462036,2306.351562 616.064636,2310.655518 616.435059,2315.686279 
	C617.017822,2323.600586 616.677979,2326.637451 609.734558,2328.805176 
	C603.239014,2330.833252 601.400085,2334.469727 601.964661,2340.508789 
	C602.185852,2342.874268 601.450378,2345.074951 600.362610,2347.188232 
	C599.097839,2349.645508 597.656799,2352.093018 594.489624,2351.588379 
	C591.180481,2351.061035 587.938904,2349.776123 586.550232,2346.365234 
	C585.481567,2343.740234 586.166382,2341.198975 588.110413,2338.996338 
	C590.164001,2336.669678 592.940857,2335.519775 595.589722,2334.189941 
	C599.605591,2332.172852 600.312744,2329.521973 598.698730,2325.246826 
	C594.721313,2314.712158 597.453613,2306.432373 607.001099,2300.050537 
	C609.363342,2298.471436 609.484619,2296.637695 610.125000,2294.421631 
	C612.103333,2287.575439 620.044861,2282.830566 628.046753,2284.064941 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M355.021942,2048.757568 
	C360.262146,2051.413818 361.735291,2055.158447 362.586731,2060.189453 
	C364.401611,2070.912842 364.853729,2070.836426 375.455811,2067.894287 
	C383.903290,2065.550049 391.141083,2069.279541 393.396942,2077.138672 
	C394.785797,2081.977539 393.209137,2084.681641 388.349976,2085.917725 
	C379.124481,2088.264648 370.578796,2088.173096 364.638916,2079.157959 
	C363.219940,2077.004395 361.431274,2075.950439 358.875153,2075.989990 
	C354.660034,2076.054932 351.223846,2073.796387 347.845245,2071.787109 
	C343.138367,2068.988037 341.429077,2064.235352 342.633423,2058.989014 
	C344.457031,2051.045166 346.444427,2049.248779 355.021942,2048.757568 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M376.608307,2122.592773 
	C372.232605,2121.445068 368.299408,2122.828613 365.119110,2118.806641 
	C360.969482,2113.558594 356.481445,2108.749023 356.093079,2101.682129 
	C355.725739,2094.998291 361.810730,2091.600830 368.733459,2094.726807 
	C370.472473,2095.512207 372.393463,2096.845947 373.261017,2098.451904 
	C378.112061,2107.431152 386.530914,2111.113037 395.595764,2113.520508 
	C400.948944,2114.942139 402.336700,2118.128418 401.985046,2123.006592 
	C401.425995,2130.761230 394.372833,2134.562012 387.770508,2130.427002 
	C384.139557,2128.153076 380.800354,2125.413574 376.608307,2122.592773 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2416.666504,2052.000000 
	C2415.852539,2051.710449 2415.775635,2051.337402 2415.546631,2051.143799 
	C2409.215820,2045.798828 2408.748535,2039.895508 2413.911621,2032.723145 
	C2414.332764,2031.743896 2414.665283,2031.487915 2415.499023,2031.613647 
	C2417.256592,2031.632446 2418.591064,2031.433960 2419.756592,2030.879517 
	C2425.965088,2027.925903 2426.382568,2027.790161 2427.826660,2033.743896 
	C2428.903809,2038.185303 2431.696045,2041.362305 2434.067627,2044.840698 
	C2436.381836,2048.235107 2439.251465,2050.260010 2444.148926,2048.442627 
	C2449.160645,2046.583130 2453.064697,2048.948242 2455.128174,2054.120605 
	C2455.849121,2055.927246 2457.103760,2057.543945 2458.241943,2059.157471 
	C2462.333008,2064.957764 2461.667236,2066.613525 2454.591553,2067.873047 
	C2453.622559,2068.045410 2452.592529,2068.110840 2451.620605,2067.988525 
	C2447.617432,2067.483643 2443.830566,2071.452393 2440.081299,2069.255371 
	C2436.773438,2067.317383 2437.663574,2062.713623 2435.897461,2059.533936 
	C2432.544922,2053.497314 2427.969238,2050.198975 2420.447754,2051.482422 
	C2419.111084,2052.000000 2418.222168,2052.000000 2416.666504,2052.000000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M591.967529,2281.845947 
	C589.542908,2277.326416 587.557800,2273.520020 587.996399,2268.912109 
	C588.323486,2265.476074 588.813599,2261.665771 592.266785,2260.529297 
	C598.305847,2258.541748 598.101074,2254.077881 598.007812,2249.314941 
	C597.922974,2244.984375 597.387695,2240.540039 602.951782,2238.672119 
	C608.896484,2236.676514 615.700439,2238.093994 619.373535,2242.453857 
	C624.617615,2248.678467 622.566284,2255.457031 614.764038,2257.378662 
	C612.854065,2257.848877 610.820435,2257.837158 608.839600,2257.996094 
	C599.741638,2258.725830 598.616638,2260.694824 602.666382,2269.297119 
	C604.371033,2272.917969 606.160217,2276.375977 606.051147,2280.612549 
	C605.859924,2288.040039 603.689636,2289.489746 596.804260,2286.349609 
	C594.943420,2285.500977 593.352600,2284.357910 591.967529,2281.845947 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M382.643402,2210.121582 
	C387.806244,2211.622314 390.129944,2215.512207 393.322388,2218.340332 
	C395.777802,2220.515381 397.727356,2223.251465 401.231628,2224.117188 
	C405.614044,2225.199463 407.352844,2228.606689 408.549927,2232.691162 
	C409.602600,2236.283203 411.413666,2240.130371 407.586182,2242.608643 
	C403.810364,2245.053223 399.209991,2245.032715 395.458160,2242.140625 
	C392.870422,2240.145996 390.001404,2237.778809 388.762939,2234.925293 
	C386.206451,2229.034424 382.060272,2227.852051 376.203094,2227.771729 
	C370.111145,2227.688477 366.877045,2224.134277 366.130005,2218.717529 
	C365.378632,2213.269287 367.393341,2210.554443 372.880798,2210.085938 
	C375.845551,2209.833008 378.849457,2210.039307 382.643402,2210.121582 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M812.275269,2328.510254 
	C812.570129,2327.461914 812.646729,2327.064941 812.886292,2326.885498 
	C823.373108,2319.025635 823.374817,2319.027832 824.004883,2304.602051 
	C824.308594,2297.647949 826.718384,2293.563965 831.004456,2292.738770 
	C834.779419,2292.011963 841.109924,2295.320557 843.603699,2299.323975 
	C846.970215,2304.728516 846.744080,2309.694580 843.031494,2313.947754 
	C840.782593,2316.523926 837.980713,2318.339355 834.870911,2319.525391 
	C829.940857,2321.405029 827.088257,2324.396973 827.962708,2330.023438 
	C828.112305,2330.985596 827.997498,2332.034424 827.792664,2332.998047 
	C827.032715,2336.573242 824.867798,2338.970459 821.282959,2339.712891 
	C817.360352,2340.525635 815.068481,2338.366943 813.528809,2334.992188 
	C812.688049,2333.149414 811.948242,2331.332520 812.275269,2328.510254 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M174.266693,2178.694336 
	C181.613022,2171.760986 185.981186,2172.248291 188.953934,2180.343018 
	C190.693680,2185.080078 193.372757,2186.014404 197.850403,2186.101562 
	C206.994171,2186.278809 211.666565,2192.311035 209.835556,2200.841797 
	C208.977112,2204.841309 206.625107,2206.732422 202.656326,2205.141357 
	C198.360855,2203.419434 194.096191,2201.521729 190.885941,2197.917725 
	C188.574692,2195.322998 186.299484,2193.248535 182.507690,2196.215576 
	C178.978180,2198.977539 176.863129,2196.557617 176.246262,2193.149658 
	C175.427933,2188.628174 173.165192,2184.307617 174.266693,2178.694336 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1617.728760,2140.997559 
	C1624.704102,2135.653076 1632.759399,2132.970947 1641.223022,2129.508301 
	C1642.282227,2139.926758 1642.880005,2141.348389 1652.802734,2141.734375 
	C1660.101685,2142.018066 1662.667358,2145.745361 1664.191650,2151.706299 
	C1664.831055,2154.206787 1666.617432,2156.819824 1663.652588,2158.875977 
	C1661.231445,2160.555420 1658.830200,2161.880615 1655.397339,2160.875488 
	C1651.233521,2159.656250 1648.209839,2157.712891 1646.830566,2153.522461 
	C1646.314453,2151.954590 1645.988892,2150.257568 1645.155396,2148.873047 
	C1642.881592,2145.096436 1639.921875,2142.895996 1635.293945,2145.358398 
	C1633.548706,2146.286865 1631.720093,2147.256348 1629.814453,2147.647461 
	C1624.489136,2148.739990 1619.795288,2148.138184 1617.728760,2140.997559 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M857.688416,2279.211914 
	C850.515320,2284.912109 846.367310,2285.089355 843.388916,2277.559814 
	C839.553101,2267.862549 832.221924,2266.908203 824.119873,2266.058350 
	C820.722412,2265.701660 817.347656,2265.723633 816.342957,2261.538330 
	C815.551270,2258.240723 816.936890,2255.685791 819.498962,2253.773926 
	C822.739685,2251.355469 826.276367,2251.377930 829.749390,2253.196045 
	C834.706970,2255.791016 835.312988,2263.246094 839.933472,2264.701904 
	C844.105835,2266.015869 849.568481,2263.001221 854.408691,2264.610840 
	C859.772705,2266.394531 860.741943,2270.513428 857.688416,2279.211914 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M334.033752,2240.602783 
	C328.560242,2242.057861 323.496979,2243.953857 320.344940,2238.003906 
	C317.056793,2231.797119 317.220337,2224.289062 320.787354,2220.296875 
	C323.267914,2217.520508 325.950928,2214.772217 330.133850,2217.142822 
	C334.244019,2219.472656 339.897369,2220.125977 340.027130,2226.795898 
	C340.130432,2232.105957 338.545044,2236.518555 334.033752,2240.602783 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M518.718506,2204.874512 
	C516.647827,2195.217285 522.112671,2189.795410 528.343140,2185.290527 
	C533.115112,2181.840332 536.719910,2183.830566 538.041443,2189.719727 
	C538.399719,2191.316162 538.851074,2192.892578 539.184753,2194.493652 
	C540.458069,2200.602783 538.637817,2205.202881 533.877380,2208.003906 
	C528.528564,2211.151123 524.906189,2210.560791 518.718506,2204.874512 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M929.872620,2260.518311 
	C925.542358,2257.124268 925.618835,2253.070557 926.206116,2249.099609 
	C927.321045,2241.561035 931.847412,2238.879883 940.903259,2240.044922 
	C946.300293,2240.739502 948.338928,2244.187256 947.988281,2252.027832 
	C947.667358,2259.206299 944.925049,2261.797119 937.341492,2261.979492 
	C935.032104,2262.035156 932.683411,2262.167236 929.872620,2260.518311 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1978.717529,1985.685059 
	C1975.071045,1985.785278 1972.917114,1984.520142 1972.265625,1981.484619 
	C1971.990234,1980.200806 1971.946533,1978.855591 1971.907471,1977.535034 
	C1971.799316,1973.871338 1967.479492,1969.545654 1972.123535,1966.715332 
	C1976.920898,1963.791748 1982.562866,1962.417969 1988.178467,1965.446411 
	C1989.620605,1966.224121 1991.054199,1967.017456 1993.245850,1967.901855 
	C1994.000000,1970.133423 1994.000000,1972.266724 1994.000000,1975.200073 
	C1996.085083,1978.598267 1994.997681,1980.852661 1992.618896,1983.517090 
	C1987.792725,1984.282715 1983.431885,1983.157715 1978.717529,1985.685059 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M984.603027,2276.123535 
	C987.904297,2275.281738 990.408569,2274.359375 992.979553,2274.101074 
	C996.259460,2273.771729 999.871826,2273.689209 1001.419250,2277.499512 
	C1002.880371,2281.097168 1004.310974,2284.636475 1001.722839,2288.687500 
	C996.386536,2297.040039 984.885376,2297.735840 979.247070,2289.755127 
	C976.757385,2286.231201 978.127808,2282.224609 984.603027,2276.123535 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M991.302368,2220.315918 
	C986.965210,2212.354248 987.375061,2208.157227 992.209717,2205.223145 
	C996.720581,2202.485596 1003.532227,2203.824707 1007.320801,2208.431885 
	C1010.088623,2211.797852 1011.998291,2215.599854 1010.818298,2220.170410 
	C1009.646790,2224.708008 1005.854797,2225.934814 1001.927795,2226.995361 
	C996.373352,2228.495361 994.515869,2224.011963 991.302368,2220.315918 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M663.260864,2213.854980 
	C662.555908,2211.246338 662.060486,2209.286865 662.070251,2207.330322 
	C662.089111,2203.558594 662.754150,2199.910400 666.872864,2198.343506 
	C671.328674,2196.648438 677.734253,2198.353027 680.551270,2201.801025 
	C686.609070,2209.216064 684.528809,2218.475342 676.182922,2220.814697 
	C670.206299,2222.490234 667.194641,2217.934570 663.260864,2213.854980 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M932.859253,2271.896484 
	C933.463257,2274.898193 933.983643,2277.187256 933.944946,2279.466553 
	C933.829773,2286.251465 924.451477,2293.266113 917.952209,2291.431885 
	C916.807495,2291.108643 915.560120,2290.133301 914.945679,2289.108154 
	C910.327576,2281.404053 917.054626,2267.589844 925.907471,2266.389893 
	C929.649841,2265.882324 931.209473,2268.349365 932.859253,2271.896484 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M690.774414,2247.479492 
	C693.572144,2254.565430 691.099976,2259.241455 685.865234,2262.693359 
	C681.970886,2265.261475 678.129822,2264.002686 676.253479,2259.590332 
	C674.832275,2256.248291 673.740234,2252.743652 672.774841,2249.236328 
	C671.698669,2245.326416 670.856873,2241.213135 675.363770,2238.722656 
	C678.933838,2236.749512 685.362000,2238.056396 688.058533,2241.387451 
	C689.249878,2242.859131 689.691650,2244.937744 690.774414,2247.479492 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M192.121033,1244.599121 
	C191.546555,1242.450439 191.214676,1240.853638 190.624008,1239.359253 
	C187.991653,1232.699463 187.964920,1232.710083 195.309357,1228.074341 
	C202.193268,1227.808228 208.356888,1227.689331 211.708405,1235.352783 
	C212.001633,1236.642944 212.023911,1237.286743 211.996582,1237.928589 
	C211.518326,1249.160400 208.468872,1251.318115 196.756561,1248.092041 
	C194.220078,1247.774536 193.095367,1246.669922 192.121033,1244.599121 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M353.801849,2198.906738 
	C354.761566,2205.714355 353.433807,2210.840576 348.340576,2214.722656 
	C346.202728,2216.352051 344.329803,2218.640625 341.374146,2217.382324 
	C338.508942,2216.162598 336.450653,2213.919434 336.162445,2210.617432 
	C335.960571,2208.305176 336.197052,2205.952881 335.970367,2203.644531 
	C335.450439,2198.350586 337.210968,2194.622803 342.512878,2192.818604 
	C348.039429,2190.938232 351.446381,2193.201416 353.801849,2198.906738 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M456.704956,2213.184570 
	C457.687408,2220.881348 454.039886,2227.766113 448.293030,2229.420410 
	C444.114685,2230.623047 439.673859,2230.872559 436.254517,2227.094727 
	C433.456055,2224.002930 433.379517,2220.423584 434.881622,2216.852295 
	C436.435944,2213.156982 442.406830,2209.922119 446.448730,2210.531006 
	C449.710449,2211.021973 452.910187,2211.924316 456.704956,2213.184570 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M975.354370,2319.443359 
	C967.001648,2314.379395 966.040588,2305.430908 972.436035,2299.696045 
	C973.255981,2298.960938 974.336060,2298.432129 975.042053,2298.970459 
	C980.161987,2302.872314 987.375000,2303.968750 990.374634,2310.751221 
	C992.955322,2316.586426 991.509277,2319.422119 985.008911,2319.916260 
	C982.073914,2320.139404 979.095886,2319.796875 975.354370,2319.443359 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M672.310913,2287.480469 
	C667.620483,2287.696777 663.572754,2288.191406 659.770447,2287.441406 
	C654.087769,2286.320801 652.628540,2282.013184 655.619629,2276.982910 
	C658.151917,2272.724365 665.216492,2269.691895 670.050354,2271.077637 
	C673.796875,2272.152100 677.428101,2273.628662 681.633911,2275.110840 
	C679.713318,2280.218750 676.100525,2283.518555 672.310913,2287.480469 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M871.742188,2285.629883 
	C873.751221,2284.319336 875.126831,2283.257568 876.677246,2282.831543 
	C884.058228,2280.803467 887.905884,2283.793213 887.970581,2291.578857 
	C888.000183,2295.138916 888.693176,2299.024658 884.892883,2301.393311 
	C881.098816,2303.758057 876.770569,2305.526611 872.822388,2302.890625 
	C869.094421,2300.401611 868.166199,2295.827148 868.613403,2291.455811 
	C868.800537,2289.625732 870.291260,2287.928955 871.742188,2285.629883 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1837.409180,2073.922363 
	C1841.628540,2069.139893 1846.695312,2067.865723 1851.766113,2066.825439 
	C1854.727539,2068.053223 1853.930054,2070.812256 1854.490479,2072.862305 
	C1857.630615,2084.350098 1855.908936,2087.113525 1844.731934,2089.490234 
	C1840.787354,2090.329102 1838.401001,2089.507568 1837.830200,2085.036865 
	C1837.384277,2081.543457 1834.893188,2078.254395 1837.409180,2073.922363 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M936.720459,2370.881104 
	C936.442932,2361.313721 940.206604,2356.740723 947.880127,2356.062988 
	C951.935242,2355.704834 955.249512,2357.067383 956.995911,2360.704102 
	C958.850647,2364.566162 958.492188,2368.403809 955.231018,2371.661865 
	C949.729614,2377.158203 943.653198,2377.163818 936.720459,2370.881104 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1033.768188,2224.624023 
	C1033.533813,2233.684814 1030.361450,2237.721924 1022.934204,2239.377441 
	C1018.748474,2240.310791 1013.378784,2232.611328 1014.525879,2227.320801 
	C1015.587097,2222.426270 1021.326721,2217.108887 1026.384033,2216.264404 
	C1032.523560,2215.239014 1031.939819,2220.613770 1033.768188,2224.624023 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M388.690948,2149.483887 
	C389.149567,2151.441895 389.850922,2153.089844 389.306030,2153.923584 
	C386.179443,2158.707764 377.004517,2159.487793 371.470978,2155.656982 
	C367.497253,2152.905762 366.699463,2144.858887 369.969299,2140.511719 
	C372.773743,2136.783203 380.324341,2136.944092 383.886536,2141.162109 
	C385.761719,2143.382568 386.891663,2146.232178 388.690948,2149.483887 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M632.822144,2269.026367 
	C631.718933,2265.125732 630.071228,2262.216064 629.962219,2258.797119 
	C629.810608,2254.041504 631.099426,2250.114014 635.829102,2248.501221 
	C640.892578,2246.774658 643.893555,2250.378662 646.454773,2253.854492 
	C649.029297,2257.348145 648.142029,2266.224854 644.698120,2269.664795 
	C641.152954,2273.205811 637.068420,2272.952148 632.822144,2269.026367 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M954.173218,2345.031738 
	C954.086121,2341.930908 953.823303,2339.589355 954.177917,2337.345703 
	C955.080078,2331.635742 959.748962,2327.530273 963.989441,2328.412598 
	C968.084900,2329.264648 972.294373,2336.290039 971.367981,2340.930420 
	C971.049683,2342.524658 970.481018,2344.101318 969.806885,2345.586182 
	C967.988586,2349.591064 965.489441,2353.506104 960.761719,2353.547119 
	C956.355225,2353.585449 955.687500,2349.083008 954.173218,2345.031738 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M904.008545,2246.525391 
	C899.883667,2241.687500 899.407532,2237.325684 902.810425,2232.566650 
	C905.673584,2228.562256 909.375854,2227.214844 913.961426,2228.371094 
	C917.510498,2229.266113 921.856140,2235.453857 921.743530,2238.984375 
	C921.635132,2242.384277 916.588135,2247.346191 912.333862,2247.868408 
	C909.756653,2248.184814 907.069824,2248.332764 904.008545,2246.525391 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M215.604584,1326.387207 
	C213.587433,1323.051270 213.986740,1320.453857 216.663757,1318.949463 
	C220.886520,1316.576172 224.936172,1313.019653 230.324173,1314.464111 
	C233.508789,1315.317749 236.431366,1316.961670 238.490799,1319.746704 
	C240.365189,1322.281494 240.095963,1324.612183 237.846832,1326.772461 
	C231.137817,1333.216309 223.299377,1333.292480 215.604584,1326.387207 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1763.887207,2065.703125 
	C1767.943726,2061.952148 1772.300537,2058.968506 1777.321411,2055.812500 
	C1777.952637,2058.307373 1778.221191,2060.827393 1780.000000,2063.076416 
	C1781.207520,2064.603271 1782.227783,2066.364258 1782.951904,2068.172607 
	C1785.373291,2074.219238 1784.111938,2079.152588 1779.869629,2080.968994 
	C1775.866089,2082.683105 1768.853516,2079.593506 1766.775391,2074.884521 
	C1765.598877,2072.218262 1765.030029,2069.283936 1763.887207,2065.703125 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M904.966187,2387.347168 
	C896.578857,2387.581299 893.395813,2385.998291 892.328125,2381.724609 
	C891.328125,2377.721924 894.431091,2370.810547 897.992371,2369.108154 
	C902.878174,2366.772217 908.640076,2368.271484 910.973511,2372.486084 
	C913.723938,2377.453857 911.713013,2383.034424 904.966187,2387.347168 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M560.068970,2257.828613 
	C559.891785,2254.258057 560.734985,2251.677002 562.492859,2249.679688 
	C565.032471,2246.793701 568.440491,2245.206543 572.260437,2246.517578 
	C575.564392,2247.651367 577.753662,2250.222900 577.896973,2253.928467 
	C577.998596,2256.555664 578.212708,2259.310303 577.573608,2261.802490 
	C576.702332,2265.199463 574.207214,2267.454590 570.537781,2267.873779 
	C567.065918,2268.270264 563.848328,2267.761719 562.171326,2264.146240 
	C561.346558,2262.368164 560.782410,2260.469482 560.068970,2257.828613 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M587.928467,2300.208496 
	C587.227844,2306.004639 586.472046,2311.043945 580.093811,2311.895996 
	C575.189636,2312.551270 571.214417,2309.682129 569.074829,2303.929199 
	C567.788940,2300.471680 566.831482,2296.900391 570.383667,2294.056396 
	C573.688171,2291.410645 580.894653,2291.209473 584.387817,2293.698486 
	C586.324585,2295.078857 587.652527,2296.937988 587.928467,2300.208496 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M650.255615,1963.702881 
	C656.667664,1967.925659 663.048828,1972.940430 668.812012,1979.413086 
	C666.929504,1984.842529 663.903015,1988.145386 657.989136,1988.038574 
	C648.909790,1987.874512 645.135681,1982.874756 647.716370,1974.045776 
	C648.630737,1970.917725 649.348572,1967.732300 650.255615,1963.702881 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M628.598572,2075.159668 
	C629.160400,2073.821777 629.431458,2073.214111 629.741821,2072.627441 
	C631.876770,2068.591064 634.519470,2065.216553 639.788025,2066.378906 
	C644.036621,2067.315918 646.121887,2071.240234 645.993286,2077.468750 
	C645.870056,2083.433838 643.795105,2086.218994 638.474792,2087.561035 
	C632.081543,2089.173584 628.515869,2085.076416 628.598572,2075.159668 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M308.655243,2187.228271 
	C312.482391,2181.015137 317.954834,2178.812988 324.041809,2178.148193 
	C329.701782,2177.530029 332.614594,2181.809082 330.434357,2187.003662 
	C327.784088,2193.318359 322.541077,2196.312500 315.482147,2196.035645 
	C310.040741,2195.822266 307.441559,2193.534912 308.655243,2187.228271 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M657.622803,2100.409180 
	C652.952148,2092.687256 653.252808,2088.392578 658.036072,2085.332031 
	C661.703674,2082.985352 666.838196,2083.686279 669.800720,2086.937988 
	C673.202087,2090.671631 674.890930,2098.931152 672.764465,2101.686279 
	C671.177185,2103.742920 668.891663,2103.962402 666.502075,2103.954834 
	C663.357422,2103.944824 660.807007,2102.417725 657.622803,2100.409180 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M942.774963,2303.169922 
	C941.758667,2301.315430 940.953491,2300.166504 940.670288,2298.900879 
	C938.865173,2290.832520 944.213440,2285.097168 952.217896,2286.414307 
	C956.609924,2287.136719 959.919495,2290.538330 959.870483,2294.279541 
	C959.803894,2299.364990 955.215759,2305.224609 950.588318,2305.857422 
	C947.922668,2306.222412 945.241882,2306.078369 942.774963,2303.169922 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M819.075989,2293.234619 
	C814.550598,2298.059814 809.315979,2298.468750 803.958252,2297.872559 
	C799.112610,2297.333496 797.262573,2294.253662 798.481812,2289.472656 
	C799.976624,2283.611084 804.500793,2279.772705 809.583374,2280.053955 
	C815.224304,2280.365967 817.803345,2283.635498 819.075989,2293.234619 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M665.703613,2234.375488 
	C665.195312,2241.706787 661.432373,2245.291992 655.012512,2245.934326 
	C649.293396,2246.506592 644.675964,2243.484375 644.311401,2239.303223 
	C643.963989,2235.320312 648.678162,2228.969238 652.906982,2228.248535 
	C658.145691,2227.355957 662.964600,2227.986084 665.703613,2234.375488 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1017.441162,2258.527832 
	C1015.461609,2261.721924 1013.441589,2263.887451 1010.893311,2265.477295 
	C1005.635803,2268.757324 1001.317383,2266.814209 1000.126892,2260.689453 
	C998.680664,2253.249512 1005.032227,2245.368896 1012.670349,2244.844971 
	C1015.315979,2244.663330 1016.058289,2246.367676 1016.924622,2248.105957 
	C1018.474304,2251.215332 1018.043213,2254.522217 1017.441162,2258.527832 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M242.037903,2180.609375 
	C243.194427,2174.016357 246.067657,2167.259033 251.467117,2167.422852 
	C257.036591,2167.591553 256.827789,2175.460938 257.840485,2180.320068 
	C259.824188,2189.838379 258.525970,2190.781982 248.914001,2190.040771 
	C243.126801,2189.594482 241.778519,2186.316162 242.037903,2180.609375 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M415.434753,2248.137695 
	C412.743835,2242.669922 414.965515,2239.973145 419.443237,2238.523682 
	C424.320984,2236.944824 431.644501,2239.485107 434.435089,2243.775146 
	C436.594635,2247.095215 436.811371,2250.671387 434.438141,2253.942139 
	C432.621002,2256.446777 425.735046,2257.036133 422.411591,2254.802490 
	C419.982269,2253.169678 418.047455,2250.801025 415.434753,2248.137695 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1992.636230,1984.287109 
	C1992.620117,1981.792847 1993.240112,1979.585571 1993.930054,1976.689209 
	C2000.141724,1978.433228 2006.235718,1978.505737 2012.296875,1975.691040 
	C2015.947388,1973.995850 2018.023071,1974.895752 2017.988892,1979.226196 
	C2017.978394,1980.549438 2018.004517,1981.893799 2018.217651,1983.195068 
	C2019.898682,1993.456909 2017.085083,1997.383911 2006.762451,1999.469238 
	C2002.608032,2000.308594 2001.366211,1997.376953 2000.538086,1994.599976 
	C1999.258545,1990.309692 1997.780640,1986.414795 1992.636230,1984.287109 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M449.259460,2144.192383 
	C450.930542,2144.682617 451.861755,2145.015625 452.744720,2145.447754 
	C455.712280,2146.899902 459.292999,2148.445068 459.108337,2152.130371 
	C458.902313,2156.242676 454.867401,2157.603516 451.593842,2159.075439 
	C448.475830,2160.477539 445.054962,2160.478516 441.929688,2159.539062 
	C438.943146,2158.641113 434.903503,2157.895264 434.824341,2153.841797 
	C434.759033,2150.499268 436.848450,2147.727783 439.999969,2146.021240 
	C442.670349,2144.575439 445.437622,2143.733398 449.259460,2144.192383 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M707.992065,2227.946289 
	C705.823853,2229.039795 704.397949,2229.909424 702.863464,2230.493408 
	C696.088013,2233.070557 687.823608,2227.117920 688.209717,2219.983887 
	C688.334656,2217.676270 689.564941,2216.207275 691.873047,2216.167236 
	C696.486877,2216.087402 701.197571,2215.658936 705.698364,2216.402832 
	C712.287048,2217.491455 713.043701,2221.009766 707.992065,2227.946289 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M245.750549,2134.611084 
	C246.682312,2140.533691 244.151093,2143.498047 239.554382,2145.129883 
	C235.184906,2146.680908 230.729492,2146.569092 227.565338,2143.178223 
	C224.424911,2139.812988 226.211868,2135.811035 227.984894,2132.129395 
	C230.178268,2127.574707 234.207458,2127.859619 238.194305,2128.102295 
	C241.897934,2128.327881 244.111984,2130.647705 245.750549,2134.611084 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M220.454422,2105.736328 
	C216.284546,2104.406494 213.892212,2102.605713 213.973938,2098.468018 
	C214.055145,2094.355469 214.608948,2090.142334 217.387680,2087.331299 
	C219.889191,2084.801025 223.567505,2085.604248 226.523376,2087.752197 
	C230.024811,2090.296631 232.806656,2096.733398 231.573257,2100.044678 
	C229.811768,2104.773438 226.110229,2106.452393 220.454422,2105.736328 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M253.423004,1219.563599 
	C254.670715,1224.268433 258.101379,1229.168823 252.361267,1232.252319 
	C247.246719,1234.999512 241.845428,1235.754639 236.590240,1230.451050 
	C236.247940,1219.683350 239.872650,1215.526489 248.009720,1216.031372 
	C250.303452,1216.173584 251.560394,1217.587158 253.423004,1219.563599 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M183.636673,1219.352295 
	C183.996140,1221.972046 183.871628,1223.952271 184.006622,1225.914551 
	C184.352463,1230.941772 181.367447,1232.968384 177.054047,1233.805298 
	C169.337769,1235.302612 166.525009,1232.962280 166.010574,1224.663330 
	C165.949692,1223.680908 166.000580,1222.691772 165.999207,1220.852783 
	C171.431931,1215.245605 177.116150,1213.838501 183.636673,1219.352295 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M686.591858,2059.955078 
	C688.678589,2071.411865 686.967468,2074.385010 678.469971,2075.531982 
	C673.536804,2076.197510 670.429626,2073.435547 669.983948,2068.428711 
	C669.545105,2063.498779 672.059448,2060.250488 675.668091,2057.637207 
	C679.591553,2054.795898 683.087219,2055.924561 686.591858,2059.955078 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M294.066223,2217.500488 
	C293.926880,2214.040527 294.385437,2211.548584 295.477509,2209.044189 
	C297.405365,2204.623047 300.771698,2203.426025 305.105316,2204.223633 
	C309.546906,2205.041260 312.234802,2208.888184 311.941589,2213.650635 
	C311.677490,2217.941162 308.164398,2221.911133 303.251953,2223.220459 
	C298.739349,2224.423096 295.590637,2222.844971 294.066223,2217.500488 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M479.166595,2175.412109 
	C474.824524,2177.464844 470.413300,2179.981445 467.441650,2176.497559 
	C464.350830,2172.874023 465.459564,2167.546387 466.865784,2163.142578 
	C467.773376,2160.300293 470.213806,2157.811523 473.690857,2158.435791 
	C477.720001,2159.159180 481.441437,2161.124268 483.150299,2165.033447 
	C484.896759,2169.028320 484.617615,2172.905273 479.166595,2175.412109 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M943.416382,2326.983643 
	C937.541321,2332.191895 934.920593,2332.572998 931.355469,2329.336670 
	C927.396240,2325.742676 927.088196,2319.655273 930.631348,2315.039062 
	C932.952820,2312.014893 939.809387,2310.877686 943.194092,2312.958984 
	C945.030273,2314.088135 945.692078,2315.830811 945.920288,2317.888916 
	C946.263245,2320.983643 945.227295,2323.691406 943.416382,2326.983643 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M730.712524,2313.885742 
	C723.160461,2319.972168 720.840088,2320.480225 717.357422,2317.361816 
	C713.601318,2313.998535 713.137268,2308.425293 716.221558,2303.723633 
	C718.505493,2300.242432 724.660339,2298.748535 728.655640,2300.688965 
	C730.630371,2301.647705 731.684326,2303.280273 731.847046,2305.386963 
	C732.050720,2308.025635 732.314331,2310.703369 730.712524,2313.885742 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M957.771973,2272.557861 
	C954.999634,2268.452881 956.857910,2265.383789 958.860352,2262.866699 
	C961.360962,2259.723633 964.685669,2257.204102 969.152710,2258.869873 
	C973.370300,2260.442627 976.309998,2265.689209 975.926270,2270.049072 
	C975.618530,2273.545898 973.849548,2275.697266 970.365906,2275.850098 
	C966.145264,2276.035156 961.643433,2276.984375 957.771973,2272.557861 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M927.914551,2353.880859 
	C924.528015,2359.589111 920.388123,2361.357178 915.797791,2359.514648 
	C911.639954,2357.845703 909.583130,2354.617432 910.111206,2350.082520 
	C910.546936,2346.341064 911.430054,2342.670898 916.070679,2342.144531 
	C920.157837,2341.681152 924.092957,2341.824707 926.182739,2346.429199 
	C927.156128,2348.573975 928.064697,2350.671387 927.914551,2353.880859 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M641.094116,2186.160156 
	C644.203674,2186.117920 646.552673,2185.957031 648.829224,2186.290527 
	C651.964722,2186.749512 652.892273,2189.470215 653.600830,2192.020752 
	C654.361816,2194.760010 653.801880,2197.287109 651.343567,2199.102539 
	C651.076721,2199.299561 650.800903,2199.484375 650.527222,2199.672119 
	C645.294800,2203.258545 635.993469,2202.229492 633.276428,2197.763672 
	C631.477417,2194.806641 633.745178,2191.093750 641.094116,2186.160156 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M531.351807,2274.709473 
	C527.556824,2279.336182 523.720825,2280.605469 518.948547,2277.431396 
	C514.914734,2274.748779 513.302979,2271.197998 514.259338,2266.493164 
	C515.504211,2260.369385 520.878052,2258.003174 526.097412,2261.480469 
	C530.493774,2264.409668 533.092102,2268.382324 531.351807,2274.709473 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M685.313354,2298.520264 
	C685.081726,2291.110107 688.264954,2286.666504 693.663147,2286.115479 
	C696.662781,2285.809082 699.657166,2286.003418 701.281738,2289.278564 
	C702.765442,2292.270020 702.228882,2300.638672 700.044617,2302.447754 
	C697.527893,2304.531982 694.810303,2306.454102 691.119873,2304.551270 
	C688.674988,2303.290527 686.668701,2301.787354 685.313354,2298.520264 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M796.955933,2363.344482 
	C790.961792,2356.852051 797.292603,2354.357422 800.146851,2350.977051 
	C803.052307,2347.535889 807.046997,2347.065186 810.925598,2348.888916 
	C815.730286,2351.147705 814.806213,2360.390869 809.596863,2364.022705 
	C805.517883,2366.866211 801.538086,2366.111816 796.955933,2363.344482 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M903.980469,2299.359863 
	C913.203491,2297.866943 915.933838,2299.250000 917.537415,2305.466797 
	C919.131531,2311.646973 914.136780,2317.135986 908.006775,2315.603760 
	C904.111389,2314.630615 900.311951,2312.770752 898.719543,2308.770752 
	C896.958435,2304.347168 900.969177,2302.376709 903.980469,2299.359863 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M575.889771,2238.331543 
	C573.285034,2227.833496 576.662659,2223.231934 585.374023,2224.044434 
	C589.741455,2224.451904 593.319580,2228.023926 593.642822,2232.299316 
	C593.920044,2235.965576 590.781433,2239.408936 586.141357,2239.859131 
	C582.929810,2240.170898 579.560242,2240.575195 575.889771,2238.331543 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1998.666626,1954.003174 
	C1988.999878,1953.070801 1987.085693,1950.877075 1985.144043,1939.267334 
	C1987.310669,1937.286743 1990.147583,1938.119263 1992.645874,1937.557739 
	C2001.187134,1935.638672 2004.933105,1939.155640 2003.690063,1947.799194 
	C2003.460938,1949.392212 2002.705200,1950.909668 2002.096313,1953.230957 
	C2001.111084,1954.000488 2000.222168,1954.000977 1998.666626,1954.003174 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M540.336792,2181.563477 
	C536.873474,2178.986816 536.109070,2175.898926 535.982300,2172.435303 
	C535.837708,2168.484375 536.640381,2164.587402 540.491211,2163.308350 
	C544.333252,2162.032715 548.314148,2163.495850 551.129272,2166.703857 
	C554.179199,2170.179443 554.143738,2174.267578 550.602051,2177.233887 
	C547.916321,2179.483154 545.282776,2182.481689 540.336792,2181.563477 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M316.019348,2140.155273 
	C318.188599,2148.091309 317.270111,2151.574219 312.720428,2153.298828 
	C308.701324,2154.822510 304.681396,2154.187744 301.574799,2151.281738 
	C299.136749,2149.001221 299.355316,2145.572998 300.901459,2142.963379 
	C303.090302,2139.268555 305.826294,2135.726074 310.980774,2136.189453 
	C313.134491,2136.382812 314.589203,2137.681641 316.019348,2140.155273 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M753.576538,2333.686279 
	C748.369995,2334.525879 744.902405,2332.967773 742.708618,2329.100342 
	C741.117065,2326.294189 738.614929,2323.229492 741.518799,2320.039307 
	C744.032349,2317.278320 747.427246,2315.558594 751.330505,2316.304443 
	C754.907471,2316.988037 757.319031,2319.426025 757.736267,2323.036377 
	C758.182861,2326.901611 759.010620,2331.171143 753.576538,2333.686279 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M189.589325,2290.424316 
	C193.413712,2293.320557 199.393021,2294.910889 196.871719,2300.064453 
	C195.015381,2303.858643 189.865097,2302.000000 186.064850,2301.017090 
	C184.791397,2300.688232 183.532990,2300.226318 182.238052,2300.068848 
	C178.224930,2299.580811 175.355545,2297.613037 174.415512,2293.628906 
	C173.789871,2290.977539 175.649521,2289.405273 177.762238,2288.161377 
	C181.142120,2286.171143 184.440826,2285.145752 187.569962,2288.600098 
	C188.011841,2289.087891 188.533981,2289.502930 189.589325,2290.424316 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M895.483826,2273.954834 
	C887.064026,2272.736816 885.135498,2270.745850 886.147522,2265.176758 
	C886.982910,2260.579590 893.734558,2255.542969 897.888062,2256.418213 
	C902.247803,2257.337158 905.094238,2266.697266 902.142822,2270.616943 
	C900.702637,2272.530029 898.775391,2273.769531 895.483826,2273.954834 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2530.666504,2116.000000 
	C2524.968994,2113.835693 2521.541992,2110.381104 2520.516602,2104.768311 
	C2519.613281,2099.821777 2522.833008,2098.768311 2526.507324,2097.514404 
	C2529.888184,2096.360840 2532.853271,2095.302490 2534.674316,2099.555908 
	C2536.846680,2104.629150 2539.334961,2109.735352 2534.121094,2115.305176 
	C2533.111084,2116.000000 2532.222168,2116.000000 2530.666504,2116.000000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M991.931030,2239.739746 
	C990.916504,2244.405029 990.046265,2248.560791 985.485657,2249.638428 
	C981.853149,2250.496582 978.101929,2250.386230 976.409729,2245.986572 
	C974.757690,2241.691650 976.415222,2235.833252 979.838074,2233.494873 
	C983.536682,2230.968018 988.464294,2231.573975 991.138855,2235.151123 
	C991.840881,2236.089844 991.707275,2237.654053 991.931030,2239.739746 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M200.064484,2122.242188 
	C201.215134,2116.656494 203.977051,2113.738281 209.172623,2114.270508 
	C213.107452,2114.673340 216.171310,2118.845703 215.864548,2122.833008 
	C215.490509,2127.694824 210.611603,2133.748291 207.036102,2133.712891 
	C205.258972,2133.695557 203.835464,2132.820801 202.893021,2131.357910 
	C201.262711,2128.827148 199.896774,2126.174072 200.064484,2122.242188 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M227.417786,1207.388428 
	C227.999496,1209.286499 228.033020,1210.578857 227.994400,1211.869141 
	C227.689896,1222.041504 226.145981,1223.111938 214.704224,1220.310791 
	C213.326782,1219.277954 212.583679,1218.605835 212.027725,1217.799072 
	C208.707687,1212.981689 207.625244,1207.473145 212.312683,1203.588623 
	C217.638519,1199.175171 222.744171,1202.180054 227.417786,1207.388428 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M644.302979,2053.520996 
	C645.233826,2044.244019 648.543884,2040.930054 654.835693,2042.164917 
	C658.818970,2042.946899 661.381836,2045.377563 661.812378,2049.472412 
	C662.211426,2053.268311 660.051758,2056.158203 656.753601,2057.163818 
	C652.391968,2058.494141 647.535950,2059.618408 644.302979,2053.520996 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M558.172241,2293.971680 
	C554.578003,2294.138916 552.311829,2293.114990 550.229553,2291.230469 
	C544.624573,2286.157715 545.944092,2279.358398 553.135010,2276.664551 
	C554.434753,2276.177734 555.683655,2276.190186 556.958191,2276.709229 
	C561.111450,2278.400879 565.053528,2287.786621 563.235107,2292.096924 
	C562.514038,2293.805908 560.628052,2293.860352 558.172241,2293.971680 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M382.229370,2184.910156 
	C383.981384,2183.265869 385.391907,2181.952393 387.082184,2182.934814 
	C392.370972,2186.008545 394.462799,2191.436279 395.568115,2196.865723 
	C396.448212,2201.188477 390.810059,2204.306152 386.710907,2202.296387 
	C380.743225,2199.370605 379.160248,2194.015137 382.229370,2184.910156 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M503.575989,2189.953613 
	C496.037018,2188.967041 492.386566,2185.995361 492.630707,2181.712891 
	C492.849579,2177.874023 497.890686,2173.564697 501.821960,2174.442627 
	C506.097748,2175.397461 510.548981,2177.345459 511.422363,2182.032959 
	C512.309570,2186.794922 508.627747,2188.975830 503.575989,2189.953613 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M670.026184,2031.374023 
	C666.836487,2030.466553 664.449646,2029.422119 662.575562,2027.466187 
	C659.701660,2024.466431 659.116577,2021.189209 661.589478,2017.730103 
	C663.942871,2014.438232 667.146240,2013.177612 671.049194,2014.697021 
	C675.003906,2016.236450 678.012634,2018.703491 677.067749,2023.488037 
	C676.356567,2027.088623 675.022034,2030.488647 670.026184,2031.374023 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M619.585938,2170.326416 
	C625.692261,2173.479492 623.978943,2178.429443 623.612000,2182.806885 
	C623.366394,2185.736084 620.676147,2185.776123 618.329285,2185.986816 
	C611.154175,2186.630371 608.768982,2185.644043 608.114624,2181.599854 
	C607.125610,2175.487549 609.531555,2171.855713 615.850769,2170.124512 
	C616.759460,2169.875732 617.804504,2170.124268 619.585938,2170.326416 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1901.076294,1959.014526 
	C1904.523682,1959.180664 1907.423706,1959.600342 1910.290527,1960.183228 
	C1914.149292,1960.967773 1915.354858,1964.017090 1915.810303,1967.360474 
	C1916.212158,1970.311035 1916.208008,1973.435913 1913.041626,1975.072876 
	C1910.294556,1976.492798 1907.376709,1976.323486 1904.571899,1974.984131 
	C1901.720215,1973.622437 1902.742065,1969.277100 1898.710449,1968.132935 
	C1897.994141,1966.717163 1897.988159,1965.434204 1897.977905,1963.189209 
	C1898.508789,1960.990723 1899.411011,1960.077271 1901.076294,1959.014526 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M850.681458,2209.079102 
	C848.628540,2204.888916 846.080383,2201.187012 850.567932,2197.964844 
	C853.739563,2195.687256 857.209534,2195.152100 860.599854,2197.820068 
	C863.844727,2200.373779 865.204407,2206.424316 863.404541,2210.496826 
	C862.341003,2212.903564 860.453003,2214.149170 857.884033,2213.540283 
	C855.317566,2212.931885 852.931213,2211.754883 850.681458,2209.079102 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M421.746033,1624.058716 
	C421.103607,1624.658447 420.554810,1624.320190 419.644165,1623.656494 
	C412.937286,1604.932373 406.640900,1586.426025 400.409058,1567.898193 
	C399.249725,1564.451416 398.349915,1560.917358 397.545197,1556.739990 
	C398.430328,1556.755981 399.437866,1557.340210 399.721558,1558.171631 
	C407.116364,1579.843994 414.436066,1601.542114 421.746033,1624.058716 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M279.658844,2198.192383 
	C278.395874,2203.537109 276.274445,2206.572754 270.595581,2204.498779 
	C265.774078,2202.738037 262.713776,2199.246338 262.679474,2194.606689 
	C262.658264,2191.742920 264.742706,2190.788818 266.769653,2189.652344 
	C269.586578,2188.072998 272.251312,2187.591553 274.912659,2190.008301 
	C277.185303,2192.072021 278.414337,2194.732422 279.658844,2198.192383 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M517.254395,2294.295654 
	C518.846863,2296.122314 519.990601,2297.515625 519.022034,2299.261230 
	C517.545654,2301.921387 515.479919,2304.254395 512.636108,2305.311768 
	C509.449860,2306.497070 506.020020,2306.707764 503.419952,2303.820312 
	C501.101685,2301.245850 501.551727,2294.166016 504.520905,2291.797852 
	C509.074066,2288.166260 513.160461,2290.013672 517.254395,2294.295654 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M626.681213,2142.470215 
	C635.618225,2139.109131 638.997375,2139.987793 639.855347,2145.310303 
	C640.490662,2149.251465 639.291626,2152.587646 635.821167,2154.751953 
	C633.023132,2156.497070 630.109558,2156.404053 627.521667,2154.250732 
	C623.596497,2150.984619 622.784119,2147.236084 626.681213,2142.470215 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M675.863037,1986.381104 
	C682.260681,1990.560669 688.326721,1995.479370 694.771973,2001.016846 
	C692.671082,2002.465942 690.156677,2003.206787 687.717041,2004.142578 
	C680.179871,2007.034058 674.818237,2003.791870 674.075500,1995.730469 
	C673.802368,1992.765381 673.897095,1989.795044 675.863037,1986.381104 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1172.091553,2200.883057 
	C1177.625732,2200.644043 1183.247192,2201.117920 1189.512451,2201.945557 
	C1190.055176,2206.239014 1190.389648,2210.276611 1187.962158,2213.753906 
	C1184.626343,2218.532471 1179.739868,2218.526611 1177.026978,2213.434082 
	C1175.032349,2209.689697 1173.768311,2205.556152 1172.091553,2200.883057 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M701.320068,2043.122925 
	C694.380615,2045.916748 689.971436,2045.526367 688.634827,2042.065430 
	C687.243286,2038.462036 687.845154,2034.950073 690.949158,2032.190430 
	C694.141785,2029.351929 697.609192,2029.451538 700.913635,2031.652466 
	C705.603455,2034.776245 704.684326,2038.698608 701.320068,2043.122925 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M471.390198,2304.547852 
	C474.411346,2308.309326 475.097076,2311.918945 472.599945,2315.118164 
	C470.642609,2317.625732 467.702118,2317.670410 464.490173,2316.488525 
	C459.025513,2314.478027 457.176239,2312.157959 458.155426,2307.160645 
	C458.988159,2302.910645 461.359161,2301.568604 467.328003,2302.300537 
	C468.543915,2302.449463 469.661133,2303.403564 471.390198,2304.547852 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M304.351257,2259.624512 
	C304.764343,2253.761719 308.447601,2252.022949 312.714355,2250.686768 
	C316.668701,2249.448242 319.027283,2251.534668 320.887054,2254.383545 
	C322.941223,2257.530029 321.121429,2259.950195 318.808380,2262.056396 
	C313.306976,2267.065918 309.952057,2266.661377 304.351257,2259.624512 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M505.730225,2232.236328 
	C503.102356,2227.872070 504.049164,2224.616455 507.232574,2221.996826 
	C510.970734,2218.920410 515.422485,2219.692871 519.582397,2220.526367 
	C521.940857,2220.998779 521.826538,2223.347412 521.161743,2225.432861 
	C519.174377,2231.668213 514.557678,2233.969971 505.730225,2232.236328 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M659.915649,2305.979004 
	C659.310852,2310.269775 657.119019,2311.739258 653.707458,2311.955811 
	C649.620972,2312.215088 646.461182,2310.674072 644.881592,2306.967285 
	C643.584900,2303.924561 647.474731,2298.844238 651.643311,2297.214111 
	C655.936584,2295.535400 657.697632,2298.424316 659.314819,2301.346191 
	C659.908569,2302.419189 659.766663,2303.899658 659.915649,2305.979004 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M328.737488,1212.010742 
	C326.380157,1208.511963 321.226898,1205.313354 326.420288,1201.135376 
	C329.447845,1198.699585 333.186523,1196.673950 337.236145,1199.029419 
	C340.686859,1201.036499 340.147125,1204.572388 339.680695,1207.807739 
	C339.452087,1209.393677 338.707031,1210.905029 338.097229,1213.225098 
	C335.157532,1213.340454 332.316284,1212.681030 328.737488,1212.010742 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M786.641846,2311.248779 
	C788.024109,2309.319092 789.039185,2308.035400 790.186462,2306.883057 
	C792.097351,2304.963867 794.222961,2303.332275 797.086487,2304.878418 
	C800.250732,2306.587158 800.186951,2309.680908 799.851135,2312.626221 
	C799.338440,2317.123779 795.914368,2319.133545 792.247803,2320.785156 
	C789.078369,2322.212646 787.104797,2320.721680 786.382141,2317.771729 
	C785.932983,2315.938477 786.321594,2313.899902 786.641846,2311.248779 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M647.351074,2005.976440 
	C646.556763,2008.861694 645.908752,2011.270142 643.946960,2012.609253 
	C641.329773,2014.395630 638.633972,2017.036011 635.151917,2014.001343 
	C632.375916,2011.582275 631.124207,2008.594849 632.749207,2005.173584 
	C634.435242,2001.624023 637.297668,1999.465454 641.528625,2000.291382 
	C644.334167,2000.839233 646.088074,2002.786499 647.351074,2005.976440 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M177.862671,2217.524170 
	C186.354828,2213.393066 190.934875,2214.822998 191.854538,2221.358154 
	C192.228439,2224.015137 192.112244,2226.614990 189.242371,2228.278320 
	C186.965103,2229.597900 184.915939,2229.600586 182.710220,2228.303955 
	C178.770233,2225.987793 175.786591,2223.204834 177.862671,2217.524170 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M285.884125,2234.366943 
	C290.482819,2235.912109 293.099915,2238.118164 291.348145,2242.716797 
	C290.000122,2246.255615 284.202942,2249.813477 280.959045,2249.245361 
	C276.937286,2248.540771 274.777466,2244.504883 276.907654,2240.874268 
	C278.743591,2237.745361 281.061096,2234.775391 285.884125,2234.366943 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M828.449097,2366.682129 
	C830.239380,2365.058350 831.624634,2363.927490 833.359070,2364.447754 
	C837.050903,2365.554932 837.627747,2369.226807 838.889709,2372.090332 
	C840.587036,2375.942139 838.314758,2380.338867 834.505310,2381.484619 
	C832.395142,2382.118896 830.444763,2381.545654 829.257019,2379.790283 
	C826.621826,2375.895508 824.283020,2371.837402 828.449097,2366.682129 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M441.473633,2288.230469 
	C442.516357,2288.462402 442.851013,2288.532227 443.122925,2288.702393 
	C445.894897,2290.436523 450.943024,2290.821777 448.551880,2295.985840 
	C446.351166,2300.738770 439.223236,2302.345947 435.166412,2299.509277 
	C431.845032,2297.187012 431.264069,2294.457764 433.916504,2291.254150 
	C435.679596,2289.124756 437.863190,2287.857910 441.473633,2288.230469 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M362.485016,2245.099121 
	C361.807190,2251.901123 359.808868,2254.134521 355.576874,2253.858154 
	C352.168091,2253.635498 348.540649,2249.458008 348.346710,2245.516846 
	C348.212616,2242.791748 349.617737,2240.961426 352.117401,2240.401611 
	C356.267151,2239.472656 360.141266,2239.780029 362.485016,2245.099121 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M301.429352,1856.977173 
	C300.132538,1858.547119 299.338623,1859.666260 298.274780,1860.386841 
	C296.072601,1861.878784 293.916290,1861.076660 294.488800,1858.553345 
	C295.452728,1854.304688 296.375824,1850.366577 294.501678,1846.105225 
	C293.653442,1844.176514 294.684265,1842.197632 296.627472,1841.125122 
	C299.025970,1839.801514 301.053955,1841.596191 303.171143,1842.214600 
	C305.832031,1842.991699 305.217743,1844.951294 304.648285,1846.980469 
	C303.766205,1850.123779 303.690674,1853.503296 301.429352,1856.977173 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2228.479980,1976.316895 
	C2229.596191,1968.857788 2232.572021,1966.694336 2238.555664,1968.154175 
	C2242.085205,1969.015259 2243.360596,1971.705444 2243.589355,1974.755371 
	C2243.827393,1977.927979 2241.612793,1979.513916 2238.621826,1979.856201 
	C2236.976562,1980.044312 2235.300781,1979.961670 2232.819336,1980.002930 
	C2230.986572,1978.881104 2229.973145,1977.757446 2228.479980,1976.316895 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M227.977264,1207.223633 
	C224.679504,1208.161011 222.837463,1205.326660 220.182327,1204.151001 
	C215.421768,1202.043213 212.583572,1203.720093 212.025116,1208.831665 
	C211.654007,1212.228516 212.729691,1215.326416 213.898010,1219.220215 
	C208.077744,1219.047485 205.591324,1215.423828 206.115936,1209.633423 
	C206.567154,1204.653076 209.732941,1201.263428 214.659714,1200.219360 
	C221.018188,1198.871826 224.662247,1200.580200 227.977264,1207.223633 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M504.337524,2249.788086 
	C504.948212,2258.281738 499.883820,2263.396484 494.207001,2260.983643 
	C492.001617,2260.046143 490.140259,2258.751221 490.195923,2255.900879 
	C490.241547,2253.564453 491.559021,2252.107422 493.503052,2251.409668 
	C496.821899,2250.218994 499.961823,2247.895020 504.337524,2249.788086 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M359.857666,1268.883545 
	C359.913086,1265.940063 360.151154,1263.874756 360.644958,1261.077271 
	C361.265259,1261.589722 361.949951,1262.834961 361.947052,1264.078613 
	C361.891418,1288.155396 361.755371,1312.232178 361.244995,1336.986816 
	C359.192810,1325.063843 360.744019,1312.392822 359.845581,1298.844849 
	C358.192169,1293.926270 357.888550,1289.878784 359.372620,1284.920898 
	C359.786804,1279.308594 359.913574,1274.535034 359.857666,1268.883545 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1848.415527,2002.842041 
	C1849.580811,2001.736694 1850.520508,2001.191650 1851.675537,2000.126953 
	C1853.329346,1998.666138 1854.537598,1997.332642 1856.984497,1997.040527 
	C1857.744385,1999.741211 1857.992188,2002.406250 1857.927734,2005.063477 
	C1857.844727,2008.484863 1857.201538,2012.054443 1853.665161,2013.408691 
	C1849.991577,2014.815674 1846.399170,2014.173950 1843.827026,2009.506958 
	C1845.055420,2006.946289 1846.622559,2005.174316 1848.415527,2002.842041 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M290.004242,2177.840820 
	C283.786560,2176.797119 283.656097,2172.824707 284.308990,2168.640137 
	C284.789124,2165.563232 286.968170,2164.181641 289.995758,2164.178955 
	C293.023407,2164.176270 295.207520,2165.553955 295.690125,2168.630127 
	C296.346283,2172.812500 296.218536,2176.786865 290.004242,2177.840820 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M853.970825,2346.010254 
	C853.753174,2348.108154 853.787659,2349.510010 853.260254,2350.652832 
	C851.736633,2353.955322 848.803345,2354.430420 845.755737,2353.471924 
	C842.849976,2352.558350 841.814392,2350.055420 842.212891,2347.177490 
	C842.713318,2343.563477 844.960144,2341.175049 848.452148,2340.375000 
	C852.225037,2339.511230 853.979126,2341.467773 853.970825,2346.010254 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M370.026306,1163.526855 
	C374.682220,1171.571289 369.252808,1178.643433 369.655792,1186.057617 
	C369.925964,1191.028564 367.877625,1196.125732 366.326599,1201.544678 
	C365.548676,1201.612549 365.310852,1201.302246 364.774200,1200.488281 
	C364.711761,1197.963623 364.948181,1195.942749 365.102448,1193.159912 
	C363.642517,1187.828247 361.916046,1183.248901 366.249390,1178.586182 
	C368.947632,1174.498657 368.182648,1170.194336 369.156769,1165.404541 
	C369.229645,1164.059937 369.319916,1163.498413 370.026306,1163.526855 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M197.463318,2154.920166 
	C195.316132,2157.235352 194.038528,2160.465332 190.863922,2158.521973 
	C187.838730,2156.669678 187.236282,2150.954590 189.497330,2147.851562 
	C191.569336,2145.008301 194.609222,2142.712891 197.857819,2144.751953 
	C202.078766,2147.401855 199.162766,2151.067139 197.463318,2154.920166 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M653.885376,2119.995117 
	C653.169922,2124.206055 651.461243,2127.074219 647.646484,2127.164551 
	C645.229004,2127.222412 643.669983,2124.981201 642.730469,2122.855713 
	C641.408447,2119.864990 642.102539,2117.135254 644.369019,2114.744873 
	C647.794128,2111.132324 649.814026,2112.078125 653.885376,2119.995117 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M377.656677,1519.698975 
	C376.575317,1522.384033 375.078125,1523.565796 372.948761,1523.822266 
	C369.862457,1524.193848 367.109680,1524.008545 365.395416,1520.682129 
	C363.814362,1517.614380 365.214233,1515.703613 367.326874,1513.839844 
	C370.064728,1511.424316 372.743530,1512.207886 375.477814,1513.899780 
	C377.409119,1515.094727 377.976440,1516.829834 377.656677,1519.698975 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1076.365723,2185.458496 
	C1082.667358,2185.781006 1088.884521,2186.913818 1095.754395,2188.432129 
	C1095.594971,2189.837891 1094.948364,2191.072754 1093.945190,2191.843506 
	C1085.329102,2198.464600 1081.109253,2197.107666 1076.365723,2185.458496 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M362.337280,1243.530640 
	C359.778656,1241.391479 361.131317,1238.359253 360.694641,1234.758789 
	C360.793213,1231.965454 361.002686,1229.916748 361.109009,1227.098877 
	C359.592773,1223.212402 358.939026,1220.108643 361.798553,1216.535767 
	C362.868561,1214.385620 363.312103,1212.756470 364.241760,1210.737183 
	C366.398407,1212.295654 366.181366,1214.683472 365.951019,1216.910645 
	C365.051025,1225.611084 363.976959,1234.293457 362.337280,1243.530640 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M489.848938,2281.999756 
	C489.140564,2286.886719 486.514923,2288.279053 482.648346,2287.696045 
	C480.017822,2287.299561 478.573944,2285.567871 478.236755,2282.998535 
	C477.852905,2280.073975 478.736206,2277.445068 481.679260,2276.572510 
	C485.736328,2275.369385 488.942230,2276.489990 489.848938,2281.999756 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M231.691696,2033.492188 
	C227.191391,2032.488770 225.989822,2029.484497 226.523666,2026.075684 
	C227.004807,2023.003662 229.412796,2021.087036 232.469666,2020.306030 
	C236.110428,2019.375977 238.439011,2021.545532 237.236298,2025.023438 
	C236.189041,2028.052124 235.006836,2031.154175 231.691696,2033.492188 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M218.068344,2171.854004 
	C213.900299,2171.298584 211.727417,2169.459473 212.505112,2165.863525 
	C213.228577,2162.518311 214.896637,2159.617432 219.182556,2160.272949 
	C222.970215,2160.852539 224.861435,2164.541260 223.357803,2168.572754 
	C222.613373,2170.568848 220.932678,2171.570801 218.068344,2171.854004 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M272.767914,2277.051270 
	C269.763092,2275.047607 267.246826,2273.505127 265.151947,2271.518311 
	C263.975983,2270.402832 263.890472,2268.504639 265.257996,2267.139648 
	C267.086151,2265.314941 275.280212,2266.593506 276.849365,2269.386963 
	C278.917084,2273.067871 278.278656,2276.277100 272.767914,2277.051270 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M361.234741,1367.132324 
	C358.563660,1367.976318 356.251953,1368.104980 354.146423,1366.973755 
	C351.919006,1365.776978 348.796539,1365.214722 348.837891,1361.958740 
	C348.875488,1358.999756 351.276733,1357.428589 353.758453,1356.506714 
	C355.227875,1355.960693 356.968140,1356.143799 359.360992,1356.000000 
	C362.830292,1359.123535 361.865570,1362.772461 361.234741,1367.132324 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M189.743469,1702.349854 
	C192.729065,1703.601929 195.756592,1704.067383 195.574493,1707.525757 
	C195.458633,1709.726074 193.962677,1711.106201 191.929764,1711.605103 
	C188.462875,1712.455811 185.414352,1711.350098 183.065002,1708.782104 
	C181.775986,1707.373169 182.204758,1705.509155 183.683044,1704.531738 
	C185.266678,1703.484863 187.213501,1702.987061 189.743469,1702.349854 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1857.959106,1996.553467 
	C1856.141968,1997.890991 1854.648438,1998.702148 1852.522949,1999.560303 
	C1856.243896,1991.097290 1864.072021,1986.534424 1872.594727,1981.924683 
	C1875.738525,1985.332886 1872.378418,1985.945068 1869.829834,1987.505127 
	C1865.467896,1990.460693 1861.875244,1993.243896 1857.959106,1996.553467 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M213.978119,2310.551758 
	C211.586685,2312.065674 209.592529,2312.216064 207.672363,2311.524902 
	C205.412430,2310.711426 203.588501,2309.142090 202.901611,2306.801025 
	C202.495667,2305.417480 203.615875,2304.427246 204.833115,2303.711182 
	C207.259872,2302.284180 209.722900,2301.423340 212.179489,2303.492676 
	C214.194931,2305.190674 216.551071,2306.881836 213.978119,2310.551758 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M611.231445,2129.076904 
	C611.640564,2130.087402 611.735229,2130.412598 611.756836,2130.742432 
	C612.040222,2135.067139 610.646790,2138.384033 605.709106,2137.352783 
	C602.169800,2136.613770 601.331726,2133.149414 602.474182,2130.102295 
	C604.174255,2125.568115 607.270630,2124.998535 611.231445,2129.076904 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M297.058014,2279.611084 
	C302.109680,2277.785889 304.154358,2279.936768 303.446533,2283.960938 
	C302.869019,2287.243652 300.409210,2289.672363 296.587402,2289.500000 
	C295.184814,2289.436768 294.392273,2288.230225 294.226379,2286.845459 
	C293.914551,2284.242188 293.687805,2281.625732 297.058014,2279.611084 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M203.658630,2265.582031 
	C203.432220,2266.610840 203.347534,2266.955811 203.143875,2267.202881 
	C201.117157,2269.660889 199.270157,2273.575684 195.499786,2269.810059 
	C193.151108,2267.464355 193.241776,2263.968750 195.821030,2261.822510 
	C199.726624,2258.572754 202.410889,2260.396973 203.658630,2265.582031 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1787.514771,2050.988037 
	C1789.861084,2046.003418 1794.578369,2044.353882 1799.038818,2041.253174 
	C1799.924194,2044.459595 1800.682251,2048.061035 1797.847412,2050.962402 
	C1794.794800,2054.086426 1791.539551,2055.288818 1787.514771,2050.988037 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M361.033478,1368.466797 
	C360.756042,1364.519897 360.661957,1361.093018 360.351624,1356.833618 
	C360.335022,1354.471802 360.534668,1352.942749 361.073425,1350.720703 
	C366.263397,1353.280151 363.041168,1358.263062 364.088928,1363.148193 
	C363.969177,1366.105103 363.812225,1368.252441 363.332214,1370.937866 
	C361.827423,1371.067017 361.460876,1370.071045 361.033478,1368.466797 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M370.915344,1438.845215 
	C373.754028,1441.805908 375.740234,1450.895874 375.196350,1459.005127 
	C371.467987,1453.355835 371.532135,1446.408691 370.915344,1438.845215 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1902.058594,1958.132324 
	C1900.576660,1959.649780 1899.514771,1960.611206 1898.213257,1961.899902 
	C1897.088379,1962.616577 1896.203125,1963.005859 1894.603760,1963.498535 
	C1896.212769,1957.240112 1900.904785,1953.144287 1907.452637,1950.105713 
	C1907.300415,1953.347290 1904.220703,1954.957275 1902.058594,1958.132324 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M170.814606,2253.770996 
	C164.902176,2251.325439 166.210220,2248.491699 169.583771,2245.693359 
	C171.500488,2244.103271 174.172272,2243.252686 175.274719,2246.032471 
	C176.606216,2249.389648 177.081894,2253.307373 170.814606,2253.770996 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M366.499451,1405.092285 
	C366.576172,1407.254150 366.452362,1408.830444 366.188965,1411.189575 
	C362.175049,1412.087891 358.738892,1411.438354 358.164124,1406.720581 
	C357.732178,1403.175293 358.164642,1400.054932 363.672394,1400.034668 
	C365.862579,1401.199219 365.909973,1402.922485 366.499451,1405.092285 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M228.490891,2284.030762 
	C224.621048,2286.357422 223.088440,2284.429932 222.329346,2281.548096 
	C221.712265,2279.205811 222.111664,2276.900391 224.242233,2275.380127 
	C225.800568,2274.268555 227.371475,2274.646484 228.550613,2276.114502 
	C230.419846,2278.441895 230.217438,2280.947021 228.490891,2284.030762 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M256.087982,2229.713379 
	C256.346222,2226.854736 255.056442,2224.002686 258.116882,2223.130859 
	C260.020355,2222.588623 261.149719,2224.322266 261.525330,2225.901855 
	C262.125092,2228.423828 262.883362,2231.460449 260.221436,2233.084961 
	C258.096558,2234.381836 256.610077,2232.774902 256.087982,2229.713379 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M230.077805,1441.812256 
	C227.341156,1438.655762 228.309555,1436.549194 230.932266,1434.876099 
	C232.144562,1434.102783 233.613190,1434.113403 234.600647,1435.038330 
	C236.532883,1436.848022 236.334946,1439.367920 235.559433,1441.503906 
	C234.570251,1444.228638 232.483978,1443.064453 230.077805,1441.812256 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M391.425476,1534.750977 
	C396.167786,1538.717407 395.995667,1544.977173 396.944763,1551.235107 
	C393.184265,1546.836182 392.463837,1541.052612 391.425476,1534.750977 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M216.270325,1466.488037 
	C214.680435,1468.184814 213.551147,1469.457886 211.812820,1469.594604 
	C209.173645,1469.802246 208.214386,1468.505371 209.142654,1466.047974 
	C210.157898,1463.360229 211.907028,1461.617920 215.084183,1462.305298 
	C217.226715,1462.768677 217.455078,1464.147461 216.270325,1466.488037 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M131.234100,1675.194092 
	C134.400574,1673.998779 137.238815,1673.436401 137.509811,1677.294434 
	C137.689789,1679.856934 135.816895,1681.720459 133.259140,1681.502319 
	C129.434937,1681.175781 129.985397,1678.352417 131.234100,1675.194092 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1150.062744,2198.328125 
	C1152.982910,2196.975342 1155.733276,2198.219238 1159.259644,2198.848145 
	C1160.204590,2202.649658 1158.041748,2204.829834 1154.998779,2205.096924 
	C1151.154419,2205.435059 1151.075562,2201.655762 1150.062744,2198.328125 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M363.176880,1376.825439 
	C367.813385,1379.549072 365.661865,1384.151855 365.241150,1388.973145 
	C361.984497,1385.937866 363.166412,1381.640137 363.176880,1376.825439 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M210.427246,2238.220703 
	C211.941635,2234.969971 213.887512,2233.077148 216.698074,2235.215576 
	C218.595535,2236.658936 217.810944,2238.916016 216.195175,2240.262451 
	C213.872360,2242.197754 211.503357,2242.786133 210.427246,2238.220703 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M385.188629,1510.749268 
	C389.030884,1513.474365 389.036621,1518.099243 389.195923,1523.082764 
	C385.785370,1520.120850 385.822266,1515.645264 385.188629,1510.749268 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1876.541016,1979.525635 
	C1877.214233,1974.784302 1880.211304,1971.579956 1885.788818,1970.184326 
	C1884.353271,1974.226318 1880.933472,1976.993408 1876.541016,1979.525635 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1115.622681,2204.365723 
	C1114.393555,2208.762207 1112.109131,2208.226562 1109.768188,2206.257568 
	C1108.348511,2205.063232 1108.205322,2203.302979 1109.574951,2201.996338 
	C1112.357544,2199.341309 1114.149414,2200.991455 1115.622681,2204.365723 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M361.678406,1216.074707 
	C362.933655,1219.082153 362.573303,1222.091675 361.414154,1225.702393 
	C354.558594,1221.540649 354.550232,1220.388672 361.678406,1216.074707 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M367.092651,1405.135742 
	C365.164185,1404.571655 365.206360,1402.822388 364.678833,1400.621826 
	C364.602448,1398.506226 364.731232,1396.990601 365.128967,1394.764160 
	C369.912201,1396.810547 367.593994,1400.920776 367.092651,1405.135742 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M201.374695,1752.303833 
	C201.277512,1754.401245 200.608231,1755.473999 199.084702,1755.675903 
	C196.989639,1755.953491 194.791336,1755.802612 194.581467,1753.206787 
	C194.364960,1750.528687 196.550293,1750.062378 198.653152,1750.275391 
	C199.536270,1750.364746 200.349960,1751.139526 201.374695,1752.303833 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M359.176025,1284.525635 
	C359.789093,1288.128418 359.918182,1292.174683 359.855469,1297.069702 
	C355.626770,1293.880493 355.249695,1289.568115 359.176025,1284.525635 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M368.898926,1424.739014 
	C373.502930,1425.992188 371.939697,1429.486816 371.015015,1433.207275 
	C368.488861,1431.299927 368.638184,1428.352783 368.898926,1424.739014 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1917.301270,2004.084473 
	C1917.379395,2006.207153 1916.758911,2008.414307 1916.066650,2011.310791 
	C1913.972412,2011.725708 1912.157837,2011.094849 1912.334961,2008.600464 
	C1912.517212,2006.037354 1914.235962,2004.739258 1917.301270,2004.084473 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M155.180573,2280.791504 
	C154.192841,2277.939453 154.742874,2276.324707 157.555634,2276.546875 
	C158.639053,2276.632324 159.398727,2277.405273 159.462906,2278.491455 
	C159.628632,2281.296387 158.020554,2281.840088 155.180573,2280.791504 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M195.450912,2335.669434 
	C193.686630,2337.987549 192.008575,2338.161865 190.721848,2336.124268 
	C190.018494,2335.010254 190.349640,2333.485840 191.582855,2332.879395 
	C193.679749,2331.847900 195.141434,2332.637451 195.450912,2335.669434 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M367.303070,1412.527588 
	C370.569153,1413.613525 370.315643,1416.199585 368.982788,1419.427734 
	C368.217743,1420.269897 367.829987,1420.641724 367.207275,1420.242676 
	C366.979523,1417.395508 366.986755,1415.318970 367.303070,1412.527588 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M216.935822,2056.527832 
	C216.198669,2053.855957 216.789398,2052.339111 219.339035,2052.445312 
	C220.352036,2052.487549 221.188263,2053.096680 221.103638,2054.169189 
	C220.925217,2056.430420 219.601440,2057.391846 216.935822,2056.527832 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M217.005997,1724.804688 
	C216.720322,1727.986572 215.157578,1728.232910 213.248810,1726.915283 
	C212.071014,1726.102173 212.016098,1724.653809 212.879318,1723.627930 
	C214.327179,1721.907104 215.585220,1723.142700 217.005997,1724.804688 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2548.071289,2128.655273 
	C2549.608154,2128.497070 2551.216553,2128.994141 2553.412354,2129.745605 
	C2553.677246,2131.460693 2553.674561,2133.368652 2551.520508,2133.155518 
	C2549.391602,2132.944824 2548.587158,2131.197754 2548.071289,2128.655273 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M379.249481,1484.616943 
	C381.992676,1484.960205 382.352753,1486.698853 380.997070,1489.333984 
	C379.246185,1488.515503 379.016907,1486.896973 379.249481,1484.616943 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M377.306641,1474.667969 
	C380.117432,1475.041870 380.291534,1476.860229 379.025208,1479.480957 
	C378.292267,1480.267212 377.895905,1480.637573 377.247284,1480.234375 
	C376.999725,1478.071777 377.004486,1476.682739 377.306641,1474.667969 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1869.893066,1987.754395 
	C1870.368042,1986.125366 1871.675659,1984.573364 1873.131592,1982.444092 
	C1873.710449,1981.828369 1874.141113,1981.789551 1875.218262,1981.701660 
	C1876.188965,1985.406372 1875.404297,1988.237915 1869.893066,1987.754395 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M375.395416,1464.620605 
	C378.040680,1465.052124 378.334320,1466.781860 377.025574,1469.321777 
	C375.083282,1468.567139 374.990387,1466.920288 375.395416,1464.620605 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M383.293884,1502.527100 
	C385.087158,1502.585205 386.209869,1503.353516 384.806396,1505.507568 
	C383.420837,1505.165894 383.019073,1504.205566 383.293884,1502.527100 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M381.435608,1494.519287 
	C383.174744,1494.631592 384.192505,1495.440674 382.862305,1497.484375 
	C381.526642,1497.120850 381.130859,1496.169067 381.435608,1494.519287 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M366.526184,1419.689941 
	C366.972290,1419.471924 367.792084,1419.671143 368.198792,1419.784668 
	C368.429779,1420.251099 368.254059,1420.604126 367.801086,1421.480225 
	C366.565491,1421.633667 364.413940,1422.086304 366.526184,1419.689941 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M376.545319,1479.681274 
	C376.994995,1479.460815 377.844635,1479.665405 378.266602,1479.781128 
	C378.505951,1480.249268 378.323334,1480.601562 377.857605,1481.477905 
	C376.619354,1481.627319 374.427551,1482.123535 376.545319,1479.681274 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M693.305908,597.999817 
	C699.270447,595.480652 702.920654,590.808899 708.508911,587.834351 
	C709.985107,587.600586 710.700439,587.261475 711.524780,586.078125 
	C713.076050,584.158813 714.387390,582.807739 715.918701,580.929810 
	C720.179199,573.307556 726.242249,568.615967 734.163818,565.075806 
	C738.944214,561.117493 743.153198,557.485535 749.259033,555.780762 
	C750.314270,555.833130 750.675049,555.870605 751.578979,555.939575 
	C752.929688,555.035706 754.206116,555.073792 755.472046,553.994202 
	C759.123718,549.062988 764.653015,547.480042 768.939697,543.186768 
	C769.519348,539.763428 771.636475,539.058350 774.567505,538.555298 
	C776.299194,538.351013 777.360840,538.105408 778.970337,537.807251 
	C780.270264,537.392090 780.742432,536.812988 780.974365,535.390747 
	C781.635498,533.714478 782.537170,532.980042 784.128174,532.192017 
	C785.660889,531.514038 786.730957,531.184143 788.035645,530.118469 
	C788.785156,529.584656 789.102905,529.395935 789.974304,529.176270 
	C791.786865,528.743103 793.045776,528.340759 794.961182,527.849976 
	C797.306885,526.571655 799.152466,525.664490 801.443237,524.339478 
	C802.761902,523.223083 803.647217,522.546082 805.102661,521.809814 
	C806.772705,521.090637 807.753845,520.253418 809.425049,519.298218 
	C810.498657,518.399475 811.012329,517.812988 811.786621,516.702148 
	C812.852661,516.075562 813.657898,515.973328 815.074890,515.833862 
	C817.926086,514.193176 820.312073,512.837036 823.379272,511.285370 
	C826.247986,508.525696 829.291199,507.359985 832.860291,505.831482 
	C837.163452,503.384888 841.062622,501.554871 845.424805,499.226257 
	C847.208984,498.115479 848.425903,497.312500 850.369263,496.390503 
	C851.853455,494.304382 853.788940,495.392914 855.476562,494.348419 
	C855.897949,493.951569 856.086121,493.018799 856.156616,492.548248 
	C860.205566,487.338989 865.793579,485.547424 872.081360,483.817566 
	C875.014099,483.001617 877.266052,482.158844 879.968323,480.747620 
	C882.604797,477.067566 885.978271,476.212097 890.054016,475.462189 
	C892.980652,474.830780 895.255249,474.189148 898.239563,473.502808 
	C901.338074,473.286926 902.127563,470.924103 904.393066,469.524719 
	C905.650574,468.801788 906.406006,468.469788 907.759766,467.991730 
	C909.094910,467.529358 909.855225,467.266052 911.169312,466.766235 
	C912.103943,466.401825 912.483215,466.269501 913.454956,466.034790 
	C916.411072,465.445038 918.600220,464.426453 921.444092,463.479736 
	C924.837830,461.322937 927.953796,460.053131 932.035828,459.431519 
	C933.638672,459.661530 934.434143,459.482544 935.524902,458.393127 
	C935.920288,457.882355 936.416687,457.428528 936.748291,457.484680 
	C940.285583,456.159912 943.515320,454.837891 947.369385,453.312927 
	C949.165527,452.490509 950.368835,451.948730 952.240784,451.418335 
	C954.354126,451.347900 955.432251,450.385864 957.333740,449.604431 
	C964.879028,445.923401 972.137451,443.471191 980.311890,441.498993 
	C981.464966,441.444977 981.869995,441.371185 982.764160,440.920563 
	C983.253296,440.543701 982.896545,439.893402 982.653809,439.612976 
	C983.566650,434.755707 987.151550,435.596222 991.229919,435.940552 
	C993.991577,435.945221 995.947083,435.748749 998.642822,435.590881 
	C1006.729675,430.623444 1015.985901,431.148163 1024.121582,426.654877 
	C1024.898438,425.788452 1025.262085,425.497650 1026.267090,424.952576 
	C1030.841309,424.624878 1034.749878,424.191681 1039.316040,423.832062 
	C1040.901733,423.368652 1041.838867,422.968018 1043.548828,422.609314 
	C1045.435547,422.009766 1046.054810,420.913300 1047.301147,419.554291 
	C1048.547241,418.819641 1049.336548,418.581055 1050.763428,418.386475 
	C1052.559570,418.201630 1053.740601,418.038910 1055.383545,417.237976 
	C1056.707642,416.706787 1057.500366,416.518921 1058.914673,416.328613 
	C1060.712769,416.101074 1061.896973,415.910187 1063.537598,415.090759 
	C1065.239746,414.385559 1066.437622,414.196777 1068.256470,414.175720 
	C1070.402710,414.294098 1071.895508,414.081909 1073.829102,413.089233 
	C1075.146240,412.619873 1075.935913,412.489349 1077.345581,412.459137 
	C1079.525635,412.640808 1081.091919,412.757751 1083.002686,411.440002 
	C1084.281250,410.838928 1085.053711,410.616730 1086.446533,410.436890 
	C1088.613647,410.334412 1090.109741,409.992737 1092.031128,408.942627 
	C1093.741821,408.285278 1094.945190,408.159851 1096.772217,408.249573 
	C1099.302490,408.651215 1101.232544,409.009766 1103.454834,407.265259 
	C1104.766479,406.707062 1105.562500,406.542114 1106.990845,406.499084 
	C1109.535400,406.723572 1111.479126,407.513550 1113.898682,406.084351 
	C1114.766357,405.547607 1115.126709,405.346375 1116.074951,404.925781 
	C1117.493530,404.538116 1118.332397,404.452728 1119.815918,404.490723 
	C1122.226074,404.888794 1123.761108,404.304871 1125.787354,403.028381 
	C1127.650513,402.264740 1128.968750,402.116455 1130.979248,402.236877 
	C1134.218994,403.022552 1136.752563,403.394623 1139.571289,401.081085 
	C1141.780273,400.041565 1143.505005,399.876099 1145.888672,399.948303 
	C1148.135254,400.130524 1149.718872,400.040100 1151.748901,398.963623 
	C1153.090820,398.363708 1153.897827,398.116577 1155.364380,397.841583 
	C1157.289062,397.661682 1158.565308,397.767487 1160.452881,398.035400 
	C1162.640137,398.373230 1164.169556,398.971558 1166.965576,398.497803 
	C1170.980469,398.303040 1173.833374,398.314056 1177.528442,398.485229 
	C1181.485352,396.943176 1185.377686,398.079956 1188.972168,395.627808 
	C1190.024658,395.297821 1190.469360,395.248627 1191.457031,395.593994 
	C1193.521973,396.011414 1195.044067,396.034271 1197.282959,395.779053 
	C1198.891968,394.956451 1199.852661,394.594391 1201.650635,394.412537 
	C1213.474731,396.894104 1224.163208,392.847961 1236.495239,392.172791 
	C1242.103149,391.882141 1246.279541,391.989746 1251.338135,392.267395 
	C1265.791138,389.618866 1279.638672,392.469696 1294.073486,390.219116 
	C1298.799561,389.198547 1302.723755,389.042358 1307.484863,389.727234 
	C1308.814209,390.054504 1309.331787,390.223267 1310.577148,390.736359 
	C1322.794434,393.871368 1334.327515,396.208832 1347.002686,394.245636 
	C1349.789917,393.619843 1351.831299,393.631683 1354.589355,394.216003 
	C1358.997559,396.778381 1362.850830,398.149475 1367.902466,396.155457 
	C1371.388062,395.384796 1374.200439,395.288391 1377.677979,395.943420 
	C1380.693848,396.692444 1382.395752,399.209625 1385.825928,398.338348 
	C1388.510986,397.802795 1390.600830,397.671783 1393.319092,397.988922 
	C1394.317505,398.207031 1394.705444,398.325134 1395.635864,398.691650 
	C1397.489502,399.729095 1398.832275,400.417633 1401.024902,400.228485 
	C1402.844849,400.114471 1404.050537,400.262787 1405.816650,400.830566 
	C1408.492554,402.556030 1410.683838,403.572540 1413.932739,402.325500 
	C1416.279175,401.826752 1418.004517,401.798828 1420.351562,402.250397 
	C1422.495239,402.947052 1423.832886,403.964111 1426.078613,404.251648 
	C1427.477539,404.401550 1428.248291,404.610992 1429.497070,405.258667 
	C1430.348022,405.860748 1430.689575,406.140594 1431.531982,406.853455 
	C1434.089600,408.161530 1436.324219,407.756073 1439.049072,408.419434 
	C1441.293579,408.786652 1442.932983,408.912720 1445.301270,409.439941 
	C1446.866211,409.927277 1447.696533,410.052338 1449.130005,410.376007 
	C1450.740601,410.595917 1451.743042,410.650513 1453.397827,411.099304 
	C1455.543457,411.908081 1457.091675,411.987213 1459.174561,412.371948 
	C1460.732666,412.591675 1461.728149,412.677124 1463.368408,413.160339 
	C1464.854614,413.748016 1465.701172,413.910431 1467.192627,414.139648 
	C1469.436035,414.423645 1471.039062,414.617096 1473.327637,415.251953 
	C1474.853882,415.834778 1475.693970,415.979523 1477.159668,416.256500 
	C1478.772949,416.463043 1479.759766,416.540894 1481.381592,417.019897 
	C1483.274048,417.759705 1484.515381,417.737335 1486.348633,417.037292 
	C1487.835815,416.652832 1488.708008,416.676636 1490.202881,417.104492 
	C1493.737793,419.548798 1497.441528,420.093262 1501.146240,422.159424 
	C1502.792358,422.432678 1503.782349,422.546753 1505.410645,423.064423 
	C1521.502930,425.741699 1536.248413,430.724121 1551.122681,435.223236 
	C1554.904297,436.367096 1558.546509,438.146698 1563.364014,437.910461 
	C1566.004150,437.653625 1567.919556,437.684692 1570.512695,438.130951 
	C1573.752686,439.160828 1576.005493,440.810791 1579.408081,441.299438 
	C1580.974487,441.466278 1581.867065,441.593567 1583.424194,441.882874 
	C1585.415039,442.359497 1586.658447,442.900909 1588.454346,443.847443 
	C1592.405396,447.162598 1596.773804,448.049255 1601.360840,450.063477 
	C1602.360229,450.619019 1602.751465,450.864990 1603.697144,451.535767 
	C1614.689941,458.462311 1626.703979,461.428833 1637.609375,466.688782 
	C1648.027954,471.713898 1659.057983,475.295776 1669.212280,480.744446 
	C1691.928589,492.933624 1715.815430,502.883972 1738.397705,516.836182 
	C1739.999634,517.264709 1740.914551,517.512085 1742.469238,518.077148 
	C1743.527710,518.574219 1743.931763,518.807129 1744.868164,519.483643 
	C1747.283447,522.532410 1749.789307,524.283081 1753.434082,525.550781 
	C1754.459839,525.956299 1754.861694,526.137939 1755.833618,526.650513 
	C1757.812256,527.987488 1759.081787,529.195496 1761.259888,530.246460 
	C1762.210815,530.814758 1762.582153,531.061829 1763.475098,531.733765 
	C1770.797974,538.234680 1779.050049,542.111816 1787.219360,547.296143 
	C1788.245972,547.720276 1788.644897,547.914124 1789.606567,548.455200 
	C1791.571167,549.818237 1792.776245,551.105835 1794.964233,552.167114 
	C1795.930298,552.738892 1796.309204,552.989868 1797.213989,553.687134 
	C1806.405640,561.958984 1816.184448,568.322998 1825.561401,575.205322 
	C1844.349243,588.994568 1862.387573,603.708374 1879.799805,619.171875 
	C1890.328247,628.522217 1890.161743,629.380005 1880.468140,640.477051 
	C1879.130737,642.182312 1878.169189,643.265198 1876.667236,644.849243 
	C1861.604980,654.468933 1851.038452,668.079163 1838.231323,679.170471 
	C1826.965698,688.926941 1815.892334,699.067932 1805.184814,709.527954 
	C1796.863281,717.657043 1794.143188,717.991638 1784.768799,710.292847 
	C1762.379150,691.905029 1739.240234,674.512939 1715.328247,658.204956 
	C1647.988525,612.279297 1574.841553,578.507568 1496.167236,554.825195 
	C1494.432617,554.582947 1493.450195,554.377808 1491.748535,553.901001 
	C1475.019287,548.516357 1458.551758,545.138062 1441.547363,540.858276 
	C1439.789551,540.688477 1438.795288,540.530579 1437.080078,540.138550 
	C1434.438843,539.415100 1432.572021,538.670471 1429.775146,538.606812 
	C1427.973755,538.431213 1426.944702,538.263550 1425.143066,537.855347 
	C1404.858765,534.188477 1385.367432,530.632019 1364.759033,528.771851 
	C1362.731079,528.743652 1361.571899,528.625793 1359.556396,528.179932 
	C1345.780762,527.710571 1333.074585,524.377747 1320.103149,525.276367 
	C1305.442139,526.291992 1291.142822,522.432190 1276.370605,522.974243 
	C1248.099609,524.011719 1219.918945,526.145691 1190.826294,527.942261 
	C1188.819824,528.257385 1187.681641,528.421814 1185.704712,528.602844 
	C1181.139771,528.977905 1177.330933,528.317932 1172.898193,529.777161 
	C1171.083130,530.271057 1170.025635,530.460815 1168.153320,530.654968 
	C1108.763428,538.232300 1051.800537,552.179626 996.125244,574.205322 
	C995.041138,574.921387 994.588745,575.171387 993.422607,575.700684 
	C981.742676,578.494995 971.285706,582.302734 961.052856,588.635986 
	C959.141602,589.760681 957.737122,590.183350 955.587036,590.630310 
	C945.071533,592.968445 936.969116,598.920288 927.403076,603.344360 
	C920.679077,607.049805 914.507812,610.298889 907.670532,613.750671 
	C901.530518,615.867004 896.192932,618.043030 891.249390,622.414978 
	C890.339111,623.096313 889.953369,623.343628 888.949341,623.900085 
	C880.826843,626.893677 874.156921,631.042236 867.342163,636.291382 
	C865.343262,637.720886 863.669739,638.299255 861.476685,639.266113 
	C858.119263,640.619080 855.859253,642.480835 853.127808,644.792480 
	C851.553345,645.933105 850.435852,646.601196 848.824707,647.730408 
	C842.279114,652.152039 836.218201,656.100647 829.747192,660.644653 
	C827.334045,662.222534 825.423767,663.343933 823.227173,665.218750 
	C817.683716,669.294800 812.304565,672.465515 807.088074,677.012756 
	C797.559814,684.343811 788.487000,691.157959 779.066833,698.652405 
	C777.568726,699.299072 776.655090,699.453735 775.028564,699.343750 
	C771.672546,698.256653 769.888489,696.105896 767.311829,693.904053 
	C764.866394,691.653259 762.509644,690.433105 759.838745,688.492249 
	C758.794922,687.300354 758.336487,686.516785 757.693298,685.053467 
	C746.898132,670.544067 735.558655,657.408630 721.746704,645.619141 
	C718.459351,641.140381 715.308044,637.447021 711.181030,633.730225 
	C707.286682,629.809509 703.956055,626.273987 700.762085,621.746521 
	C696.831177,616.687195 691.927246,613.266113 689.270081,607.200439 
	C688.972778,606.109314 688.906372,605.658386 688.900024,604.524353 
	C689.590759,601.573669 690.729370,599.641968 693.305908,597.999817 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M837.987305,290.364380 
	C834.713928,291.684113 832.111450,292.015472 829.405518,292.009033 
	C821.465393,291.990143 818.781982,289.391571 820.181702,281.783539 
	C821.199524,276.251526 823.261047,271.070374 828.544434,267.690643 
	C836.263000,262.753143 836.149841,262.576263 833.771912,254.147812 
	C831.464966,245.970917 831.458191,245.945312 840.183472,243.643188 
	C844.288391,242.560089 848.425049,241.597076 852.492371,240.593201 
	C854.635193,244.298035 855.828979,247.653473 856.006714,251.402664 
	C856.369446,259.052582 855.566895,260.446259 848.516479,263.591370 
	C839.037659,267.819763 837.244263,276.633942 844.299011,284.075745 
	C845.276367,285.106750 846.343445,285.677582 847.715332,285.834839 
	C855.318359,286.706604 862.598145,280.993561 861.801331,273.468048 
	C860.806763,264.076080 864.865356,259.379120 873.153320,256.450195 
	C881.912354,253.354874 881.876343,253.044373 880.314270,244.018066 
	C879.488159,239.244904 880.340393,235.457809 885.176270,233.279831 
	C886.362610,232.745544 887.296997,231.677795 888.412476,230.956100 
	C897.072937,225.352692 897.487671,224.084808 893.793823,214.176727 
	C891.165283,207.126221 890.825562,206.923218 883.158813,207.822266 
	C873.002197,209.013260 871.347900,207.975433 867.775635,198.171783 
	C864.581909,189.407013 864.269897,189.193970 856.823303,190.692429 
	C844.221252,193.228302 844.217346,193.230133 838.967163,181.925049 
	C838.267578,180.418716 837.557983,178.908768 837.007080,177.346161 
	C836.812500,176.794189 837.078491,176.079880 837.178711,174.928726 
	C841.468323,173.996719 845.897766,172.882843 850.384766,172.098648 
	C855.717896,171.166595 859.126099,173.402466 861.258789,178.512634 
	C865.039429,187.571350 865.223633,187.494476 874.308289,186.043427 
	C883.168152,184.628296 883.147827,184.636765 886.765747,193.323807 
	C887.532288,195.164444 888.584656,196.885178 889.368652,198.719604 
	C891.228394,203.071182 894.342773,204.890091 898.939453,203.374634 
	C901.173889,202.637939 903.396545,202.224228 905.731750,201.955460 
	C910.802795,201.371857 913.522949,203.217361 915.239441,208.249710 
	C919.149292,219.712509 919.059509,220.344955 907.177551,224.515427 
	C897.086670,228.057266 896.854797,228.515701 899.947998,238.807816 
	C902.109924,246.001312 902.096619,245.966614 894.735352,248.776657 
	C892.562378,249.606155 890.568787,250.993454 888.349182,251.593124 
	C884.674927,252.585831 883.801453,255.033234 884.001404,258.358612 
	C884.061279,259.353943 883.895752,260.369629 884.016907,261.353394 
	C885.133728,270.418030 883.862976,277.619904 872.882812,279.824890 
	C867.926208,280.820251 865.719971,285.210144 865.924927,290.618866 
	C866.058472,294.145264 866.863342,297.945831 863.631165,300.910217 
	C857.065125,306.932343 851.870728,306.138031 847.352783,298.007751 
	C845.332275,294.371613 844.904968,289.248962 837.987305,290.364380 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M81.829834,480.298950 
	C80.727875,476.739044 79.830742,473.928253 78.733002,470.488953 
	C69.613297,474.341248 62.941422,479.859314 60.302498,489.708557 
	C58.275608,497.273468 55.775322,498.514343 46.179344,497.991028 
	C40.348522,497.673035 37.682167,495.529541 36.349380,490.088776 
	C34.893803,484.146698 37.825657,478.021515 43.603554,475.287994 
	C45.692982,474.299500 47.982021,473.742310 50.130295,472.866425 
	C52.949963,471.716858 56.133362,470.261414 56.938377,467.370697 
	C59.050125,459.787720 63.681789,452.914093 63.880848,444.873566 
	C63.989368,440.490082 65.348633,437.178192 68.574188,434.410889 
	C71.378799,432.004700 73.214890,428.812683 75.436264,425.919525 
	C79.262421,420.936310 87.298958,421.588287 89.090683,427.328094 
	C90.714760,432.530853 92.029312,438.708344 87.112373,443.152130 
	C84.338913,445.658691 83.935974,447.858551 85.311844,450.965088 
	C85.701485,451.844818 86.106514,453.070221 85.794373,453.854462 
	C82.140190,463.035919 84.854462,467.978973 94.887062,469.738129 
	C99.146271,470.485016 102.698341,474.042175 101.664162,479.320709 
	C100.738701,484.044312 96.522903,485.263824 92.579803,485.783447 
	C88.349686,486.340851 83.629280,486.859192 81.829834,480.298950 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M175.480286,397.588287 
	C170.328796,395.254333 172.207809,391.293396 172.421829,387.901978 
	C172.542725,385.985901 173.504684,384.246643 173.042328,382.097687 
	C171.641388,375.586487 169.348816,373.582855 162.724335,374.087341 
	C160.771301,374.236023 158.856537,374.929199 156.932434,375.405945 
	C154.404984,376.032166 152.185837,375.551178 150.955856,373.142242 
	C149.515106,370.320526 149.471268,367.249542 151.141953,364.548950 
	C152.765274,361.924927 155.632339,361.467346 158.228836,362.526886 
	C161.552689,363.883270 164.322327,366.490662 168.366898,366.037933 
	C171.081055,365.734070 173.821976,365.740356 175.193863,362.899078 
	C176.456543,360.283966 176.214005,357.603607 174.227707,355.449921 
	C168.807220,349.572662 164.336243,343.030273 159.849457,336.434753 
	C156.986404,332.226074 151.331543,333.453918 147.012787,332.434753 
	C142.194534,331.297791 136.546219,332.250183 134.560104,326.328186 
	C132.352966,319.747070 138.527512,317.175079 141.762680,313.266022 
	C144.409012,310.068512 147.119110,309.770782 150.062485,313.038666 
	C153.163803,316.481873 157.145004,319.222870 158.849335,323.765747 
	C160.814392,329.003540 164.673004,330.118652 169.906784,330.110840 
	C181.597046,330.093323 184.311203,332.734711 185.923523,344.241608 
	C186.107330,345.553345 185.935028,346.913666 186.102081,348.229309 
	C186.604538,352.186646 188.602158,354.304596 192.849716,353.393616 
	C193.494644,353.255310 194.092056,352.908234 194.731552,352.729736 
	C198.137421,351.779114 202.323837,351.303436 202.947571,355.462738 
	C203.650894,360.152832 199.062057,360.097900 195.807526,359.921844 
	C190.821869,359.652100 187.279449,361.066711 186.296585,366.384277 
	C185.655594,369.852173 185.825653,373.022736 189.656052,374.823883 
	C191.447403,375.666229 193.188751,376.710449 194.752365,377.921844 
	C198.160721,380.562408 198.275528,383.578003 194.740234,386.057129 
	C188.790848,390.229218 183.455139,395.432983 175.480286,397.588287 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M54.957829,360.351715 
	C50.732887,363.960022 51.623814,368.002228 52.993309,371.699127 
	C55.463566,378.367432 50.421585,379.739746 46.358078,381.786774 
	C43.479927,383.236664 40.686981,385.292816 37.632416,381.368744 
	C33.758553,376.392120 32.777321,373.781738 36.794266,368.970825 
	C42.026936,362.703979 45.057739,355.359497 48.828411,348.352631 
	C53.576092,339.530273 58.104424,338.246399 66.427528,343.607574 
	C71.771622,347.049896 77.378815,349.848022 83.308784,352.120178 
	C91.766464,355.360931 94.532669,361.734161 90.098663,369.419250 
	C85.648270,377.132690 81.816833,385.188782 76.801826,392.617279 
	C73.553802,397.428467 68.630241,397.993225 64.018028,399.483490 
	C61.150681,400.409943 59.931423,397.873657 58.985233,395.713562 
	C56.283768,389.546265 57.588078,383.596558 64.281914,379.336853 
	C69.474869,376.032288 70.135658,371.982422 70.067543,366.737549 
	C70.009712,362.283813 68.679382,359.700836 63.775906,360.000488 
	C61.119232,360.162872 58.448757,360.099457 54.957829,360.351715 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M451.751953,226.856369 
	C447.324585,220.975311 440.991302,218.393738 436.326904,213.561813 
	C428.997162,205.968842 428.683472,206.271652 425.047791,193.572800 
	C426.598480,191.336914 429.234924,191.922394 431.354797,191.335510 
	C441.038208,188.654663 443.857819,190.441391 445.953674,200.151047 
	C447.581085,207.690552 447.680054,207.787292 455.748779,207.990616 
	C459.398438,208.082565 463.115051,207.674255 466.686615,208.229858 
	C472.946716,209.203690 475.461914,214.334259 471.232788,218.849884 
	C465.578064,224.887650 463.475433,231.239288 463.753693,239.379929 
	C463.976685,245.903549 457.375702,250.463043 449.520050,249.870483 
	C444.062042,249.458801 438.677734,248.069672 431.649567,246.834000 
	C437.297028,241.947739 440.701660,236.814728 447.219421,235.212723 
	C450.968781,234.291168 452.475647,231.441071 451.751953,226.856369 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M849.312195,222.937958 
	C847.851929,219.547302 846.106262,217.699738 842.919861,218.222672 
	C841.622253,218.435638 840.392029,219.029785 839.103638,219.333481 
	C828.958740,221.724777 828.434509,221.937500 824.436218,212.509857 
	C821.426636,205.413315 816.824768,203.197708 809.690857,203.946442 
	C804.189819,204.523834 798.970520,204.244354 796.797546,197.531143 
	C795.520935,193.587021 796.191345,190.148087 798.830200,187.345230 
	C801.769165,184.223633 805.528320,183.168320 809.759033,184.941513 
	C815.475891,187.337662 818.419739,192.129684 819.871643,197.679947 
	C820.962463,201.849976 822.929016,202.325089 826.330750,200.788651 
	C828.149597,199.967148 829.918030,198.931381 831.824158,198.424789 
	C837.965271,196.792709 841.202454,197.889709 842.994812,204.342026 
	C845.632751,213.838257 850.549683,217.620285 860.607727,216.222427 
	C867.349487,215.285477 870.282410,218.174744 871.595032,223.673752 
	C872.608337,227.918564 870.466309,232.779358 865.347839,234.977676 
	C855.030457,239.408737 853.597107,239.128082 850.844421,229.508972 
	C850.298340,227.600677 850.013733,225.617538 849.312195,222.937958 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M545.206238,252.704559 
	C548.200195,254.922104 550.656250,256.640167 552.914673,258.587494 
	C557.361694,262.422089 556.941101,265.667206 551.791199,268.284882 
	C537.080261,275.762421 528.743774,273.141327 520.130493,258.364014 
	C519.295776,256.931976 518.270447,255.612411 517.395996,254.201920 
	C512.276062,245.943115 512.619019,243.375153 520.521545,237.806534 
	C525.513062,234.289200 528.396912,230.246689 528.241089,223.766113 
	C528.133911,219.311005 531.281189,216.450226 535.935486,216.187607 
	C540.613770,215.923630 541.920105,219.690338 543.364441,223.068604 
	C544.057434,224.689529 543.832275,226.369461 542.802246,227.804901 
	C542.030212,228.880768 541.037109,229.795105 540.185669,230.817322 
	C531.709229,240.993896 532.714600,245.898056 545.206238,252.704559 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M16.831385,407.120819 
	C16.514143,399.696075 21.678076,397.017456 26.501925,394.199341 
	C28.187723,393.214447 30.238100,392.845123 32.132786,392.227814 
	C40.152397,389.615112 40.130020,389.633911 44.386101,396.764160 
	C45.397079,398.457855 46.411392,401.198456 47.790913,401.450500 
	C55.822254,402.918060 56.197598,410.844849 60.173943,415.613434 
	C63.455750,419.549103 62.154495,423.810791 57.965946,426.703461 
	C51.976444,430.839905 37.512955,428.858582 35.048233,422.143372 
	C32.804638,416.030609 28.401661,414.445953 23.899797,411.951050 
	C21.588493,410.670135 18.964622,409.886383 16.831385,407.120819 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M332.402039,291.411713 
	C328.058380,285.950745 323.537567,285.200623 317.787567,287.646820 
	C314.391937,289.091339 310.463562,291.645905 306.764526,287.699493 
	C304.303680,285.074127 300.674072,282.773071 302.934204,278.467804 
	C305.129272,274.286407 305.692230,268.450928 312.237000,268.046661 
	C318.324951,267.670593 323.989044,267.756226 328.448761,273.265106 
	C332.321075,278.048370 337.149567,281.439484 344.065308,278.425232 
	C346.786896,277.239014 349.336487,278.486877 350.586823,281.378418 
	C352.295074,285.329193 354.091431,289.263641 355.446228,293.339264 
	C356.753174,297.270966 353.532043,299.329376 351.250000,301.671265 
	C348.775085,304.211060 346.194366,303.833984 343.079010,302.597412 
	C337.934906,300.555603 336.342499,295.447876 332.402039,291.411713 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M220.822342,263.363922 
	C215.859482,264.473938 213.924561,267.011414 213.995331,271.347687 
	C214.092682,277.312958 213.753479,283.294525 214.068039,289.244415 
	C214.374939,295.049408 211.602097,299.331818 206.833435,301.135712 
	C200.674545,303.465485 197.109406,307.601959 194.359283,313.103088 
	C193.488663,314.844635 192.326630,316.574860 190.902710,317.878571 
	C187.498810,320.995178 184.051437,320.098572 182.334503,315.890686 
	C178.816193,307.267944 180.090561,304.179688 189.344498,299.932037 
	C194.130020,297.735443 197.016876,295.073303 194.787735,289.206848 
	C192.878265,284.181671 195.041107,280.339020 199.271179,277.266663 
	C206.022156,272.363281 212.133133,267.137054 212.602112,257.646240 
	C212.786011,253.924561 215.759995,250.968124 219.945969,250.733337 
	C222.521317,250.588882 224.110748,252.733627 225.113998,254.819885 
	C227.017899,258.778992 224.143295,260.903503 220.822342,263.363922 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M514.057861,325.998840 
	C508.015289,326.537262 503.991486,324.620850 501.974670,319.735870 
	C500.002075,314.958038 496.602234,313.404755 491.759613,313.973053 
	C490.453796,314.126282 489.084595,314.101746 487.786621,313.894775 
	C482.916077,313.118011 478.511841,308.566589 478.070435,303.990814 
	C477.651489,299.648193 480.619476,294.789001 484.905304,292.800781 
	C489.614929,290.615936 492.992706,292.144409 495.886566,297.769836 
	C501.019562,307.747955 501.019562,307.747986 512.336670,304.879974 
	C518.529785,303.310486 523.991211,307.229584 525.749329,314.504852 
	C527.140930,320.263580 524.456482,324.197510 517.863220,325.908356 
	C516.925903,326.151550 515.880676,325.978821 514.057861,325.998840 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M266.692139,381.243805 
	C268.602203,382.653320 270.458069,383.398254 271.077606,384.721893 
	C273.652283,390.222443 277.407806,393.155701 283.668396,394.536621 
	C291.019440,396.158112 293.398010,405.573639 288.476990,410.133728 
	C284.858887,413.486450 274.535583,412.883606 272.520721,408.422699 
	C269.300568,401.293335 264.629120,397.596924 256.751923,397.071777 
	C253.560974,396.859039 250.647141,394.409760 248.898285,391.410675 
	C247.096069,388.320038 244.480362,385.040741 247.784943,381.489685 
	C250.748383,378.305145 253.958450,375.422058 259.024536,377.369873 
	C261.502289,378.322540 264.099579,378.908752 266.692139,381.243805 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M427.096008,230.385681 
	C427.668610,235.054123 424.036316,235.605133 421.832764,237.372787 
	C418.656189,239.921021 417.150574,243.063263 418.663757,247.031250 
	C420.022644,250.594498 420.488495,254.071350 419.069489,257.711639 
	C417.176636,262.567291 412.358185,266.045807 407.634247,265.871307 
	C402.910767,265.696777 397.390594,261.613495 396.243835,257.445831 
	C394.675934,251.747513 396.321320,245.977493 400.365173,243.011124 
	C400.633240,242.814529 400.906891,242.544968 401.210785,242.489517 
	C410.297455,240.831711 413.644745,235.441681 412.146973,226.429138 
	C411.683685,223.641556 413.150879,221.216949 416.232605,220.396408 
	C419.079834,219.638290 421.375854,220.613129 423.498810,222.575378 
	C425.626068,224.541595 425.869476,227.270187 427.096008,230.385681 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M96.012650,308.743713 
	C100.592766,308.542694 104.055222,306.705170 107.613914,303.766235 
	C113.249557,299.112000 116.955017,299.059814 121.015472,302.114594 
	C125.115562,305.199158 126.772636,309.280670 125.857262,314.297882 
	C125.240654,317.677551 119.213280,321.486664 114.116920,321.920410 
	C107.508347,322.482788 98.871361,316.548126 96.012650,308.743713 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M68.330658,511.403992 
	C66.736313,508.064697 65.394508,505.387573 64.524429,502.565033 
	C63.266193,498.483307 64.770554,495.559082 68.697433,493.665497 
	C73.310974,491.440796 78.720741,492.948090 82.589600,497.826447 
	C86.556450,502.828308 86.886581,507.101227 83.582817,511.318176 
	C82.971855,512.098022 82.219215,512.768799 81.516937,513.474915 
	C75.452789,519.572754 74.330147,519.441711 68.330658,511.403992 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M469.447144,439.866699 
	C471.360413,437.877686 472.600861,436.152893 474.282806,435.257355 
	C480.401398,431.999420 486.553040,434.120514 488.952393,440.053833 
	C491.743896,446.957001 488.691589,452.861359 481.064484,455.312134 
	C474.301514,457.485168 469.641541,454.608337 468.230804,447.263550 
	C467.793213,444.985321 467.848419,442.664215 469.447144,439.866699 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M812.385254,228.209808 
	C817.174927,226.794083 821.549866,224.003677 825.220154,227.629028 
	C829.395630,231.753189 828.475891,237.555649 827.617371,242.663651 
	C826.788147,247.597183 815.174988,249.814819 811.564575,246.059113 
	C807.536255,241.868820 807.559082,233.704895 812.385254,228.209808 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M413.403198,514.604004 
	C404.567902,523.539124 398.365204,523.652405 393.886963,515.649048 
	C392.019714,512.312073 391.078064,508.953278 393.717224,505.480835 
	C396.532196,501.777100 402.856659,499.263611 406.883667,500.651550 
	C410.776489,501.993286 414.242706,503.929962 413.970551,508.939240 
	C413.881104,510.586395 413.789612,512.233459 413.403198,514.604004 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M499.965271,408.178650 
	C504.116302,412.720459 505.509155,417.308289 502.445190,422.151703 
	C499.833221,426.280548 496.024872,428.794342 490.794678,427.899109 
	C489.559296,427.687622 488.155823,427.336456 487.249512,426.559723 
	C485.414124,424.986755 485.520966,415.291351 487.181702,412.299805 
	C489.786865,407.607056 493.215332,406.328064 499.965271,408.178650 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M486.455292,222.681595 
	C493.073395,220.151123 497.016785,221.180832 499.441010,225.387390 
	C502.693756,231.031769 502.502319,237.501099 498.978699,241.009872 
	C496.138977,243.837570 491.576111,244.383957 489.437225,241.203537 
	C485.864777,235.891495 481.790100,230.232224 486.455292,222.681595 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M408.383728,303.281677 
	C404.482697,292.466919 406.498688,288.224518 414.720245,288.033905 
	C418.809357,287.939117 421.652252,289.757355 423.327209,293.352356 
	C424.931305,296.795105 424.191132,304.929993 421.946045,306.424805 
	C418.318634,308.840027 414.550568,308.676208 411.055817,305.908630 
	C410.288147,305.300659 409.628143,304.556702 408.383728,303.281677 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M176.502747,860.458862 
	C167.448883,865.711121 161.001892,863.800415 160.099258,856.286743 
	C159.564758,851.837402 161.304504,848.505066 165.414627,846.643372 
	C169.008408,845.015503 177.140244,845.829529 178.555725,848.179871 
	C181.057205,852.333557 180.516312,856.369141 176.502747,860.458862 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M371.853760,556.068909 
	C377.494385,557.192993 379.912262,560.193298 379.975220,565.198669 
	C380.027893,569.388672 377.638550,571.876831 374.322632,573.786926 
	C370.216644,576.152161 365.564941,575.078674 362.139740,571.003540 
	C359.036011,567.310852 359.437317,563.764038 363.322235,559.694031 
	C365.452026,557.462708 367.785645,555.776123 371.853760,556.068909 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M441.484314,560.216797 
	C445.117432,559.804810 448.014465,560.417969 449.921539,563.079346 
	C452.181610,566.233398 455.156067,569.346985 452.858765,573.743347 
	C451.144409,577.024231 444.559265,580.326965 441.055176,579.835388 
	C436.720795,579.227295 433.376465,574.951050 434.317291,570.544739 
	C434.853729,568.032288 436.343048,565.723389 437.701050,562.661438 
	C438.988739,561.478699 439.978668,560.957397 441.484314,560.216797 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M558.693359,228.441681 
	C567.393250,225.173874 572.209106,226.558807 573.649170,232.291901 
	C574.692200,236.444382 573.760315,240.163452 569.915161,242.659775 
	C566.697571,244.748718 558.089172,244.478958 555.816467,242.276260 
	C554.256165,240.763992 553.900513,238.845276 554.232544,236.835999 
	C554.726318,233.847809 556.191772,231.287094 558.693359,228.441681 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M872.470825,483.040100 
	C868.506165,488.018433 862.861145,489.617981 856.933655,492.040588 
	C855.284851,492.057770 854.342651,492.037781 852.694092,492.003601 
	C850.843201,490.616638 850.519531,489.078583 851.527283,486.683533 
	C850.963562,480.560516 853.861450,476.775574 857.682373,472.622681 
	C866.122192,470.707886 869.448853,476.059021 872.470825,483.040100 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M302.019714,368.050781 
	C309.315765,374.910614 308.231140,381.520355 300.064911,384.934387 
	C296.241913,386.532654 292.956787,386.181061 290.162292,383.001556 
	C287.420898,379.882507 287.363159,376.288361 288.915680,372.757050 
	C290.742706,368.601257 295.115601,366.993164 302.019714,368.050781 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M88.347504,400.205444 
	C90.661102,399.464050 92.209129,398.619537 93.819916,398.475128 
	C97.753502,398.122528 101.231041,399.653778 103.118698,403.033875 
	C105.268768,406.883850 101.716599,409.023407 99.555847,411.422729 
	C98.888458,412.163879 98.177345,412.884644 97.396851,413.501648 
	C93.902679,416.263794 87.196060,416.886719 84.333633,414.758057 
	C81.325699,412.521271 81.373718,408.462433 84.688980,403.032135 
	C85.340515,401.964935 86.620384,401.281311 88.347504,400.205444 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M35.276752,434.701599 
	C44.235603,432.117981 46.489071,435.877869 47.640354,440.124237 
	C49.143154,445.667206 46.528870,450.124420 40.578030,452.653076 
	C34.500019,455.235748 30.028624,452.259033 30.016140,445.660217 
	C30.008190,441.458923 31.400196,437.885284 35.276752,434.701599 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M48.010235,996.046265 
	C49.936859,997.406616 51.342300,998.313904 52.431583,999.509216 
	C56.171146,1003.612976 57.050720,1008.926514 54.620968,1011.863403 
	C52.681103,1014.208069 43.619305,1014.903198 40.646828,1012.935425 
	C38.187801,1011.307495 36.718700,1004.265686 38.421963,1000.091309 
	C39.997475,996.229980 42.314404,992.958496 48.010235,996.046265 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M228.348938,484.620453 
	C230.481659,481.299774 233.151672,480.242676 236.257568,480.069153 
	C243.345581,479.673126 247.506378,485.091278 245.064026,491.654999 
	C244.495438,493.183105 243.662674,494.662170 242.708862,495.989471 
	C237.411484,503.361023 234.448624,503.046692 230.387360,494.833801 
	C228.905594,491.837341 227.572220,488.844635 228.348938,484.620453 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M539.106934,411.807373 
	C536.040833,411.763397 533.585266,412.088959 531.529480,411.330627 
	C527.836914,409.968445 525.995422,407.001312 526.008667,402.892334 
	C526.020630,399.198547 527.650391,396.440765 530.816345,394.946686 
	C534.262268,393.320374 537.802734,393.472504 540.948059,396.089447 
	C547.071167,401.183990 546.736877,406.330597 539.106934,411.807373 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M330.232300,616.602417 
	C335.324860,609.921875 338.427734,609.623718 344.767059,614.484131 
	C347.982880,616.949707 349.482971,625.822266 346.886902,628.823181 
	C344.839081,631.190308 342.224548,632.117493 338.974396,630.479858 
	C333.488037,627.715271 330.615082,623.369629 330.232300,616.602417 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M796.426025,343.737946 
	C795.353333,343.485870 795.049988,343.355072 794.739380,343.244507 
	C790.256958,341.649261 787.475281,338.994293 788.041138,333.711853 
	C788.524902,329.196259 791.901367,327.821014 795.296448,326.576416 
	C800.321289,324.734436 803.476929,327.929382 806.145203,331.402222 
	C809.301392,335.510284 808.348389,339.283203 803.750671,342.043915 
	C801.753601,343.243103 799.613708,344.109161 796.426025,343.737946 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M209.497711,772.882507 
	C207.556992,765.624573 213.080231,764.689758 216.969193,762.737183 
	C220.298050,761.065796 222.552536,763.545105 224.662506,765.701965 
	C228.354187,769.475769 230.268295,775.878784 228.414917,778.112915 
	C226.769012,780.096924 218.541718,780.885986 215.106934,779.259766 
	C212.620407,778.082520 210.958176,776.027161 209.497711,772.882507 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M473.362885,508.088562 
	C481.969482,507.461029 485.054169,512.862427 487.358093,519.100525 
	C488.196381,521.370300 488.398346,523.795227 486.240387,525.501892 
	C484.117737,527.180725 481.807129,528.226379 478.849701,527.338501 
	C472.959991,525.570374 470.542023,521.996765 469.997437,512.806274 
	C470.167786,510.197723 470.674133,508.636230 473.362885,508.088562 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M157.445435,303.638580 
	C150.111710,305.817474 148.724060,305.081268 148.037491,299.677795 
	C147.437683,294.957153 149.093735,291.311554 152.715881,288.298553 
	C157.504486,284.315277 160.612305,283.670227 163.036514,286.461029 
	C166.753128,290.739685 166.827240,295.993561 162.970474,299.832306 
	C161.589218,301.207092 159.702774,302.074280 157.445435,303.638580 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M431.428711,533.745178 
	C425.406982,534.332947 421.296722,532.637939 420.358917,527.061584 
	C419.653320,522.865845 425.911499,515.809082 430.568481,514.904297 
	C434.834198,514.075623 436.858459,517.071838 437.585052,520.260864 
	C438.817810,525.671265 438.341003,530.912537 431.428711,533.745178 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M353.595581,601.660645 
	C346.380280,598.599670 344.886780,596.103638 346.241974,590.731262 
	C347.345795,586.355347 350.697937,584.053223 355.938049,584.016968 
	C359.035065,583.995544 362.220734,584.179749 363.399414,587.601562 
	C364.507385,590.818054 364.414276,594.129395 361.912659,596.948914 
	C359.853363,599.269958 357.152802,600.484619 353.595581,601.660645 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M813.961670,317.868164 
	C807.688354,316.564514 805.792542,312.813416 806.005188,307.521698 
	C806.115540,304.774567 806.289917,301.988007 809.211060,300.793579 
	C812.429626,299.477509 815.781250,299.447784 818.602661,301.839203 
	C821.469604,304.269226 823.881165,307.436523 823.549011,311.197754 
	C823.116699,316.093994 818.515137,316.711884 813.961670,317.868164 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M407.980835,190.628265 
	C406.156189,188.598358 404.687592,187.158325 403.824524,185.417999 
	C401.377472,180.483658 402.588623,176.784149 407.034882,174.746246 
	C411.278961,172.801010 415.787018,174.224991 418.080750,178.324127 
	C420.127960,181.982635 421.255829,186.038376 418.651642,189.614426 
	C416.127808,193.080154 412.229279,192.327789 407.980835,190.628265 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M514.082764,430.063995 
	C517.641052,424.176392 521.050598,422.810059 525.177979,424.840698 
	C529.379211,426.907684 533.066650,434.658508 531.483948,438.381897 
	C530.061523,441.728333 527.111267,442.595154 524.027588,441.592285 
	C518.846313,439.907227 513.985840,437.571350 514.082764,430.063995 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M454.768066,475.005005 
	C455.220978,464.229614 458.271515,461.576172 465.801849,463.610107 
	C470.497955,464.878510 472.392914,467.461212 471.914215,472.089905 
	C471.435455,476.719208 468.130432,479.687012 463.422455,479.968109 
	C459.756073,480.187012 457.131500,478.583710 454.768066,475.005005 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M455.629578,496.206299 
	C452.339905,505.518066 449.634857,507.303467 442.168732,505.928070 
	C438.096344,505.177887 435.899109,501.904480 437.068542,498.131073 
	C438.489563,493.545990 442.048889,491.323364 446.420715,490.280212 
	C450.955444,489.198212 454.133606,490.818268 455.629578,496.206299 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M820.980530,486.270782 
	C827.090881,495.410095 826.870850,497.714661 820.596741,500.664612 
	C816.961426,502.373901 813.680847,502.471649 810.605469,499.485687 
	C807.907410,496.866089 807.561157,493.689545 808.380981,490.344177 
	C809.395630,486.203583 812.813110,485.997467 816.237366,486.015381 
	C817.557739,486.022308 818.877808,486.071960 820.980530,486.270782 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M586.475952,259.715057 
	C582.374573,258.356018 582.066101,255.164169 581.216187,252.427917 
	C579.617065,247.279266 582.098938,242.952225 586.892029,242.205032 
	C591.062500,241.554901 595.146118,244.799698 595.890015,249.354736 
	C596.791138,254.872437 594.639282,257.484711 586.475952,259.715057 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M37.989010,1029.643555 
	C37.905769,1031.460449 38.107380,1032.589844 37.695705,1033.412354 
	C35.646160,1037.507080 29.305584,1040.415649 26.419161,1038.729248 
	C24.119820,1037.385864 22.953041,1029.330078 24.529543,1025.683105 
	C25.953932,1022.388062 32.091648,1020.685730 35.853573,1022.656128 
	C38.404034,1023.991943 37.812466,1026.572266 37.989010,1029.643555 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M95.999542,308.000610 
	C89.428131,308.915466 85.459114,305.774139 82.980598,299.940338 
	C81.264145,295.900208 83.306549,292.934082 85.441711,290.022614 
	C86.711227,288.291565 88.779083,287.719849 90.739754,288.665924 
	C93.892593,290.187347 95.900009,292.691620 95.948296,296.389160 
	C95.991219,299.676544 95.984711,302.964539 96.000465,307.125519 
	C96.000916,307.998779 96.000000,308.000000 95.999542,308.000610 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M573.154785,216.477066 
	C570.970520,215.315369 570.055176,213.977371 569.304626,212.454865 
	C567.896484,209.598251 567.245850,206.602112 569.541931,204.076569 
	C572.391541,200.942093 576.333984,201.758896 579.856689,202.412430 
	C583.214172,203.035309 584.548645,206.176346 585.210510,209.037415 
	C586.141357,213.061142 581.460327,216.102097 573.154785,216.477066 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1402.055298,105.289597 
	C1402.633179,95.122826 1405.495850,92.468727 1412.996826,94.184860 
	C1414.697876,94.574020 1416.209473,95.233292 1416.979492,96.781143 
	C1418.670044,100.179703 1418.275757,103.449570 1414.849365,105.351570 
	C1411.505737,107.207565 1408.371216,110.166122 1404.033325,109.236717 
	C1402.551270,108.919189 1402.340210,107.401161 1402.055298,105.289597 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M86.250107,918.538696 
	C87.121552,916.324951 87.579224,914.560181 88.698586,913.483215 
	C91.387581,910.895996 94.421921,908.844666 98.290192,911.555176 
	C101.732803,913.967468 103.117516,919.513245 101.145485,923.021179 
	C99.612602,925.747864 97.022049,926.190430 94.321785,925.886536 
	C90.284866,925.432251 86.308556,924.663452 86.250107,918.538696 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M112.632523,931.302612 
	C114.518867,928.434021 116.173729,926.321899 119.159637,926.297913 
	C123.445206,926.263489 127.890778,930.297729 127.855881,934.071594 
	C127.819733,937.981140 124.634621,941.328064 120.394867,941.911560 
	C115.238831,942.621277 112.968315,940.763794 112.079506,934.956482 
	C111.935097,934.013184 112.232086,933.002197 112.632523,931.302612 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M27.916925,477.712585 
	C26.247736,482.918060 23.102264,484.487213 18.641739,483.158234 
	C15.399309,482.192169 12.004489,476.651825 12.298170,472.975739 
	C12.505244,470.383698 14.048315,468.898590 16.546242,468.253815 
	C22.234184,466.785645 25.495308,469.244324 27.916925,477.712585 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M527.694946,297.937561 
	C522.515869,297.945923 519.787354,295.950714 520.215881,291.361816 
	C520.595764,287.293732 523.269897,284.828918 527.286133,284.148315 
	C531.203369,283.484528 534.503967,284.676422 536.736877,288.133667 
	C538.035767,290.144928 537.068359,291.943726 535.991211,293.645569 
	C534.257446,296.384918 531.507568,297.407898 527.694946,297.937561 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M237.997650,747.720032 
	C236.152267,748.653137 234.916214,749.604431 233.710571,749.567383 
	C228.276047,749.400146 224.202774,746.254639 224.313080,742.628601 
	C224.428543,738.832336 229.200562,734.205017 232.929016,734.273926 
	C236.693192,734.343567 239.785278,738.354980 239.855209,743.616882 
	C239.871368,744.833313 239.054504,746.060791 237.997650,747.720032 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M636.597595,247.421066 
	C632.147339,248.328903 628.687195,248.062180 626.001038,244.864883 
	C624.130310,242.638092 623.578491,240.145096 624.597534,237.505081 
	C625.711304,234.619598 628.277527,234.121994 631.079041,234.014542 
	C635.706665,233.837067 638.475647,236.799072 640.608337,240.086823 
	C642.893066,243.608994 639.514648,245.282394 636.597595,247.421066 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M108.802948,955.503296 
	C109.978951,956.233582 110.682594,956.508240 111.004837,957.022034 
	C114.690529,962.899414 114.720085,967.003357 111.164909,969.088501 
	C107.726295,971.105286 102.646683,968.963623 99.536217,964.341125 
	C97.489082,961.298950 97.886406,958.713867 100.875603,956.764893 
	C103.025734,955.362976 105.296448,953.709045 108.802948,955.503296 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M611.208374,218.783508 
	C614.532104,227.497665 613.465332,229.729446 606.593140,229.978149 
	C600.977783,230.181381 598.223083,228.264038 598.158630,224.107513 
	C598.091614,219.794128 601.609497,216.364502 606.432495,216.159317 
	C608.160156,216.085800 609.588013,216.919464 611.208374,218.783508 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M73.475388,950.301819 
	C69.985481,946.969299 68.911156,943.697021 71.419167,940.181763 
	C73.158630,937.743896 75.985550,937.528442 78.539856,938.621765 
	C82.601166,940.360229 84.368195,943.669678 83.930862,948.106689 
	C83.392952,953.564209 81.483223,954.085693 73.475388,950.301819 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M147.538742,875.755981 
	C154.928162,871.117004 158.571640,871.543518 159.691345,876.661011 
	C160.339691,879.624207 160.441650,882.850464 157.523468,884.792542 
	C154.877289,886.553467 151.697861,886.619080 148.978302,885.066040 
	C145.408203,883.027161 145.572205,879.754700 147.538742,875.755981 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M66.145752,970.120117 
	C67.348778,970.835510 67.918365,971.187317 68.420464,971.617737 
	C71.134888,973.944580 73.342438,976.952087 71.034348,980.221985 
	C68.850227,983.316162 64.863441,982.382935 61.801685,981.419373 
	C58.541748,980.393372 55.463848,977.907593 56.536285,974.088440 
	C57.697109,969.954529 60.470512,966.978149 66.145752,970.120117 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M78.207291,312.061096 
	C82.116890,312.162079 85.585083,312.601410 85.161629,316.633331 
	C84.822365,319.863617 83.139648,323.331146 79.202950,323.687408 
	C75.742393,324.000580 71.120888,325.766632 69.060364,322.179779 
	C66.685875,318.046387 71.349770,315.946014 73.837173,313.560638 
	C74.707603,312.725922 76.220001,312.560638 78.207291,312.061096 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M557.909119,194.043045 
	C554.907715,202.032516 550.562561,203.795731 546.868042,199.330002 
	C543.893677,195.734756 543.541626,191.615860 546.027466,189.495056 
	C549.682373,186.376846 554.048950,187.762680 557.909119,194.043045 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M58.203384,281.622131 
	C56.408188,280.714996 55.184628,280.082977 54.323906,279.124969 
	C51.521351,276.005554 50.960648,272.593384 54.141373,269.457916 
	C56.613777,267.020691 61.061832,267.879883 63.851768,270.965515 
	C67.140869,274.603149 65.790688,277.626831 62.502140,280.223206 
	C61.523754,280.995667 60.139473,281.254028 58.203384,281.622131 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M225.393555,808.320190 
	C228.989731,807.974976 232.345291,808.005432 233.307648,811.373108 
	C234.177383,814.416565 237.717041,818.108215 233.331421,820.901489 
	C229.869949,823.106079 226.495071,822.125732 224.229919,818.432007 
	C223.892975,817.882507 223.484482,817.376831 222.553314,816.425415 
	C221.924210,813.167419 222.068207,810.417236 225.393555,808.320190 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M229.894272,307.914154 
	C223.439682,305.521210 221.134811,302.482422 222.750275,299.219849 
	C224.570999,295.542755 228.007370,295.802521 231.318466,296.284210 
	C233.872650,296.655762 235.413956,298.316925 235.735062,300.864594 
	C236.218933,304.703766 234.674988,307.206421 229.894272,307.914154 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M198.755264,792.222412 
	C200.175125,792.083008 200.829422,792.048218 201.482346,792.065674 
	C205.301590,792.167603 207.709503,793.825317 207.805115,797.926270 
	C207.881668,801.209656 205.442276,802.382263 202.967041,803.318359 
	C199.572144,804.602051 197.258484,802.671631 195.507080,800.153809 
	C193.060165,796.636169 194.321426,794.050720 198.755264,792.222412 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M132.272125,906.591309 
	C133.420273,903.537109 135.035019,901.932251 137.660110,902.418030 
	C140.616653,902.965149 143.437622,904.112793 143.826447,907.656372 
	C144.069260,909.869019 144.363266,912.513123 141.586792,913.455200 
	C138.712479,914.430420 135.760956,914.368774 133.457062,911.921631 
	C132.281158,910.672729 132.096008,909.024719 132.272125,906.591309 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M303.914551,671.393372 
	C307.537842,669.674072 310.322052,669.431519 312.259033,672.794312 
	C313.301208,674.603638 314.023071,676.421936 312.435608,678.305786 
	C310.140839,681.028931 307.616882,683.193970 303.949188,680.624695 
	C300.221588,678.013428 299.311035,675.058838 303.914551,671.393372 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M276.044312,735.828125 
	C269.654999,732.179077 269.040344,730.144653 272.487091,726.648254 
	C274.741638,724.361206 277.544830,723.041260 280.327057,724.927795 
	C282.911591,726.680298 282.000549,729.554077 280.878815,732.009033 
	C280.057556,733.806458 279.038574,735.477295 276.044312,735.828125 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M104.935150,376.771484 
	C106.504288,374.861359 107.933434,374.186188 109.691330,374.155243 
	C113.547577,374.087311 114.651688,376.974548 115.564644,379.820374 
	C116.171852,381.713135 116.341187,384.049255 114.295044,385.146088 
	C111.541367,386.622284 109.235252,384.586548 106.994911,383.313751 
	C104.754944,382.041107 103.843636,380.018646 104.935150,376.771484 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M189.176437,827.238647 
	C187.419113,831.612427 185.301071,832.403687 182.343933,829.232056 
	C180.517578,827.273071 179.606171,825.011108 182.232330,823.351501 
	C185.865005,821.055786 188.553558,822.080139 189.176437,827.238647 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M845.329468,498.894775 
	C843.833191,503.626587 839.156433,504.301361 834.263672,505.754395 
	C836.331787,501.946686 840.726257,500.777557 845.329468,498.894775 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M49.570122,303.455750 
	C47.633877,306.124786 46.253880,305.158203 45.117252,303.349274 
	C44.582287,302.497833 44.638474,301.440125 45.563984,300.918549 
	C47.707497,299.710632 49.034065,300.598297 49.570122,303.455750 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M823.360779,510.929840 
	C822.981262,514.466187 819.933838,515.048279 816.359253,515.817566 
	C817.153442,512.895081 820.029175,512.016479 823.360779,510.929840 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M851.337708,486.107849 
	C851.997314,487.497528 851.997131,488.995087 851.992310,491.240997 
	C847.649231,490.950073 846.790344,489.121307 851.337708,486.107849 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M855.313782,493.923950 
	C855.171265,495.526520 853.769348,495.958588 851.654236,496.200073 
	C851.709412,494.565369 853.271729,494.310760 855.313782,493.923950 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1495.764893,553.990356 
	C1510.209351,555.798828 1523.531006,561.009460 1536.951050,565.755371 
	C1627.951294,597.937622 1710.313599,645.225769 1784.015381,707.574280 
	C1795.054688,716.912903 1794.917969,716.742920 1805.280640,707.146667 
	C1828.220093,685.903687 1851.321899,664.835938 1875.017822,643.470581 
	C1878.039062,644.524597 1878.066040,646.974304 1878.666504,649.151184 
	C1879.271118,651.343445 1879.592651,653.868103 1882.717163,653.844788 
	C1884.146362,653.834167 1885.142578,652.950562 1885.802734,651.730774 
	C1887.027832,649.466980 1886.764771,647.286011 1885.225220,645.292053 
	C1883.781982,643.422974 1881.476807,642.674683 1879.261108,640.698425 
	C1880.024902,635.177246 1888.513672,633.906921 1886.604370,628.585693 
	C1885.102661,624.400330 1879.988647,621.399109 1876.237549,618.151001 
	C1853.568115,598.521179 1829.997070,580.032837 1805.572754,562.631714 
	C1802.325317,560.317993 1799.187378,557.850220 1795.688477,554.855652 
	C1796.707397,551.122742 1797.312744,547.742981 1799.081909,543.988037 
	C1801.955566,541.272095 1804.947632,540.486328 1808.737061,539.651306 
	C1815.031982,538.921814 1819.474365,541.014771 1823.738525,545.419800 
	C1826.168701,547.166077 1827.946777,548.645447 1830.151978,549.351257 
	C1837.072998,551.566162 1839.396973,549.462952 1839.211182,540.441345 
	C1838.215820,534.759949 1833.785522,529.565002 1840.614136,524.660767 
	C1847.815918,523.392700 1853.432373,521.321228 1854.494385,512.843506 
	C1857.533081,508.566162 1861.757202,506.285614 1864.462158,501.668793 
	C1868.044556,497.045776 1868.655884,492.005585 1870.339844,486.621460 
	C1872.145874,482.996521 1874.487183,480.599243 1876.903076,477.369446 
	C1884.773193,471.151855 1888.839844,463.179352 1893.097412,454.471039 
	C1898.714722,451.630371 1903.646240,450.791931 1908.594971,454.266083 
	C1915.854492,459.362671 1916.434814,463.563690 1910.284668,471.720551 
	C1908.835938,473.184082 1907.766724,473.951996 1906.780884,474.817413 
	C1904.677002,476.664490 1903.145020,478.748840 1904.708252,481.653717 
	C1905.534180,483.188507 1906.929688,484.077087 1908.749878,483.881744 
	C1911.478760,483.588776 1912.514648,481.560669 1913.213989,479.271088 
	C1913.501343,478.329926 1913.629639,477.348755 1913.837646,475.645813 
	C1912.992798,465.754700 1918.055908,460.748840 1925.865234,457.565918 
	C1929.156250,456.224579 1932.298950,455.361481 1933.214478,450.624969 
	C1935.814575,437.173828 1941.467041,434.030334 1955.636475,437.808655 
	C1959.918335,442.889435 1964.771729,445.372101 1971.276367,446.266418 
	C1978.603760,449.339508 1981.258179,455.352539 1984.014526,461.419373 
	C1985.999512,465.788177 1989.813599,468.219543 1994.472412,466.717865 
	C1999.328125,465.152710 2001.883179,461.522522 1999.237549,455.521118 
	C1996.693237,451.863922 1993.514648,450.515900 1989.269165,449.602722 
	C1982.704346,447.715210 1979.213135,443.337250 1976.414917,438.341461 
	C1971.646484,429.827911 1973.582642,424.739716 1982.949097,422.127960 
	C1989.083008,420.417633 1992.937988,416.719238 1993.733154,410.672089 
	C1994.332397,406.116058 1996.207397,402.538666 1999.489990,398.587982 
	C2003.444214,395.860443 2006.580322,393.440033 2007.931030,388.668457 
	C2011.051636,388.243958 2013.929199,387.473083 2016.337769,385.732208 
	C2019.919067,383.143768 2023.249878,381.407471 2027.944702,383.433197 
	C2030.769165,384.651917 2031.818604,382.063782 2031.979980,378.743164 
	C2038.242920,376.983643 2045.569336,378.358734 2049.342773,370.220337 
	C2052.711182,370.010376 2055.265137,369.852264 2056.147949,366.513580 
	C2056.783936,364.109222 2058.364014,362.500732 2060.925781,362.221375 
	C2063.174805,361.976074 2065.741943,361.470490 2067.168457,363.770386 
	C2068.473145,365.873718 2067.954834,368.146240 2066.511230,370.194336 
	C2064.944092,372.417877 2062.487061,373.461456 2060.430664,375.042877 
	C2057.595459,377.223236 2058.221924,379.430756 2061.415039,381.698975 
	C2064.760742,385.253632 2065.135986,388.794800 2062.644531,393.303040 
	C2059.433350,394.304260 2057.033447,391.357330 2054.615723,393.069977 
	C2051.225586,395.471436 2047.864258,398.109619 2045.178589,401.237091 
	C2043.527588,403.159607 2045.807983,405.355408 2047.479004,407.615540 
	C2049.674561,409.565674 2049.152344,411.648193 2049.433105,413.589539 
	C2050.499756,420.964081 2051.797363,421.360687 2059.413086,416.357361 
	C2063.717529,416.639099 2067.240479,418.537567 2070.762939,414.539856 
	C2074.147949,410.698120 2077.948242,411.397919 2081.775879,415.199860 
	C2085.841309,419.237854 2086.398682,418.765778 2087.997314,410.770020 
	C2091.833984,407.344238 2095.374023,408.906464 2099.446777,411.379791 
	C2100.346680,414.420502 2099.354736,417.875488 2103.933105,416.981201 
	C2106.204834,416.537445 2108.506836,416.243927 2110.770020,415.763641 
	C2112.097900,415.481781 2113.695801,414.736298 2113.486328,413.317963 
	C2112.534912,406.874268 2113.348633,399.903198 2110.193359,394.138062 
	C2108.252441,390.591888 2102.933838,391.700378 2099.241211,390.351013 
	C2097.166260,389.592773 2094.632080,389.915894 2092.317871,390.026367 
	C2087.877686,390.238251 2084.344727,388.715240 2082.608154,384.560242 
	C2080.704102,380.003479 2083.884033,377.917725 2087.377441,376.208588 
	C2089.813477,375.016876 2089.516113,373.194855 2088.254883,370.608521 
	C2087.376709,365.102386 2089.517822,360.090332 2087.694824,354.627502 
	C2088.941895,349.845123 2094.466064,351.035004 2095.893799,346.662109 
	C2096.582031,345.252167 2097.291748,344.661194 2098.810547,344.042908 
	C2103.804443,343.159760 2108.320557,342.909485 2111.555664,338.245056 
	C2112.225830,337.348206 2112.528809,337.014679 2113.416016,336.340576 
	C2117.295654,335.874817 2120.399414,336.680817 2123.601807,337.433472 
	C2129.469727,338.812805 2135.183350,338.178894 2139.854736,332.727631 
	C2150.155029,325.516052 2150.155029,325.516052 2143.777832,314.648773 
	C2147.477783,307.908630 2151.007568,310.871155 2153.940186,314.291351 
	C2156.385498,317.142914 2158.703125,319.078125 2162.208496,316.520264 
	C2165.408691,314.185486 2168.783691,312.736176 2172.081543,315.514099 
	C2175.980713,318.798737 2181.356445,321.087280 2181.850098,327.221008 
	C2182.058838,329.816345 2182.454346,332.486694 2180.544922,335.476379 
	C2174.795166,337.054474 2168.239502,334.280457 2164.561523,341.625458 
	C2163.004883,342.005768 2161.797852,341.642944 2161.047363,342.074341 
	C2153.685303,346.307098 2145.656982,347.410095 2136.681152,347.701080 
	C2134.747559,348.768555 2133.538330,348.423706 2132.281006,347.944885 
	C2129.111816,346.738007 2125.546387,342.978241 2122.650879,346.971558 
	C2120.084473,350.510956 2124.320557,353.462036 2125.849121,357.313171 
	C2126.250000,362.754333 2120.859863,364.401398 2120.074707,369.312805 
	C2119.132324,370.988495 2118.041992,371.619781 2116.860352,372.194183 
	C2108.046387,376.479156 2107.903320,377.593384 2115.547119,385.493530 
	C2116.182861,387.305908 2116.140625,389.668671 2116.581543,389.762665 
	C2123.847412,391.310974 2126.410156,398.987885 2133.296387,401.917786 
	C2140.253906,399.067413 2146.639893,396.219879 2143.680176,386.620819 
	C2148.099854,381.629639 2152.067383,377.231964 2159.036621,377.973053 
	C2162.944092,378.388641 2164.206055,380.184753 2163.683105,383.850739 
	C2162.083984,395.060791 2152.307373,405.787537 2140.863525,407.845093 
	C2137.106689,408.520599 2134.894775,410.183777 2132.561523,413.566742 
	C2130.841553,415.202637 2129.431152,415.893433 2127.815430,416.325775 
	C2124.821045,417.127014 2120.605713,416.916473 2120.937012,421.517731 
	C2121.229004,425.573334 2124.670898,426.348755 2128.142578,426.492523 
	C2129.118896,426.532959 2130.071045,426.730774 2131.488525,427.556732 
	C2131.536865,431.586945 2133.517822,434.187897 2135.333252,436.990875 
	C2137.728516,440.688934 2139.368164,444.636993 2136.143799,448.869110 
	C2134.930176,450.462189 2133.702637,452.443420 2136.587158,453.531311 
	C2138.520020,454.260193 2140.582764,453.962677 2141.508789,451.651550 
	C2142.113281,450.142731 2142.469971,448.534576 2143.468750,446.485474 
	C2147.414795,444.529327 2150.098145,445.515839 2152.102539,449.220673 
	C2150.401123,452.976440 2143.258301,454.157928 2147.500977,458.716461 
	C2150.776611,462.236328 2153.397949,456.781677 2156.183350,455.073975 
	C2160.575195,452.381256 2164.634766,448.832306 2171.197754,450.000122 
	C2174.893066,452.597534 2176.703125,456.112793 2179.735352,459.409607 
	C2180.026367,462.648956 2179.773193,465.958008 2182.633545,466.875824 
	C2187.708008,468.504028 2190.730469,471.901520 2193.628906,476.049652 
	C2195.308838,478.453888 2198.084961,478.884979 2199.882812,474.677612 
	C2203.252930,471.239594 2206.794678,470.862549 2211.302979,473.356812 
	C2212.078857,475.641724 2211.486084,478.009857 2212.346191,478.803925 
	C2217.678955,483.726593 2218.374268,489.931244 2218.318359,496.599396 
	C2218.299316,498.910065 2220.342041,499.669220 2222.491699,499.909729 
	C2229.167480,500.656586 2235.443115,498.210388 2241.860107,497.195282 
	C2244.691895,496.747345 2244.183105,493.759430 2240.708984,492.137878 
	C2238.893066,484.539520 2235.020752,480.315338 2226.514404,480.456116 
	C2226.514160,476.367462 2224.010498,473.858948 2222.780029,470.835693 
	C2220.569336,465.404907 2217.492432,459.673462 2223.898193,453.546417 
	C2217.144775,451.681610 2210.978271,449.841797 2210.382812,442.144470 
	C2210.234131,440.224487 2210.798096,438.944061 2213.303467,438.129089 
	C2222.560547,446.589020 2222.628174,446.573517 2227.536621,434.504883 
	C2234.133301,431.837524 2232.106201,425.762146 2233.983887,420.776062 
	C2236.554688,417.416351 2239.484375,417.427551 2243.302246,419.378784 
	C2243.660889,424.406860 2249.628418,423.780579 2250.102783,428.182281 
	C2250.895996,435.540375 2249.805176,438.712463 2243.062012,442.451904 
	C2235.314941,446.747986 2232.295410,452.598816 2234.757568,459.107574 
	C2235.784180,461.820679 2236.942627,465.035645 2241.546143,462.513977 
	C2246.546387,459.379852 2252.398682,461.711731 2257.344238,458.060974 
	C2261.970947,457.705170 2263.394287,455.378418 2264.101807,451.606110 
	C2265.068604,446.450775 2267.988525,444.992676 2273.095215,446.214050 
	C2277.501221,447.267853 2277.849609,449.392548 2276.616699,455.417236 
	C2275.892090,458.957581 2271.905029,461.108459 2273.516113,465.578613 
	C2277.392578,468.369293 2272.782471,475.047516 2278.310547,475.469788 
	C2283.237061,475.846130 2282.707520,469.818146 2285.540039,466.501465 
	C2286.937988,466.301178 2288.310547,466.306915 2288.744629,466.948029 
	C2291.937744,471.664581 2294.875244,472.622406 2298.208496,467.027832 
	C2299.220459,465.329193 2301.139160,464.079834 2303.250000,464.194580 
	C2308.658447,464.488586 2312.536377,462.816895 2315.782959,458.002563 
	C2317.978516,454.746735 2322.440674,455.255188 2325.802490,457.302551 
	C2329.273926,459.416656 2331.092773,462.539551 2328.636475,466.561249 
	C2325.875244,471.081818 2326.177490,474.345032 2331.381104,476.950867 
	C2335.369385,478.948212 2336.543457,482.770599 2335.801758,487.177765 
	C2335.087402,491.423218 2331.531982,492.150696 2328.388184,492.733887 
	C2321.642822,493.985260 2317.509277,497.036987 2317.950195,504.553741 
	C2318.282227,510.209381 2315.006592,512.184631 2309.790771,512.010254 
	C2306.463867,511.898987 2303.130127,511.996216 2298.899658,512.000000 
	C2294.792725,514.521973 2291.808594,513.748840 2288.466064,510.692261 
	C2287.559570,506.421906 2285.619629,505.669952 2282.411133,506.851288 
	C2277.850586,508.530457 2274.937256,512.229309 2271.560791,515.377502 
	C2269.833496,516.987915 2266.953857,519.190002 2265.627686,517.035339 
	C2259.943359,507.798676 2258.608887,516.318787 2255.975830,519.130554 
	C2255.117188,520.047668 2254.751709,521.426453 2254.080322,523.297058 
	C2249.664551,527.338745 2244.176758,528.060303 2238.706055,530.212158 
	C2234.873535,529.728943 2231.354492,530.204224 2229.602051,532.414062 
	C2224.493896,538.856567 2216.551758,541.169861 2210.722168,546.385132 
	C2207.728027,549.063782 2205.104492,550.766785 2201.029785,548.533203 
	C2196.459229,546.028015 2193.259521,542.301880 2194.761475,537.355103 
	C2196.127441,532.856934 2194.720703,530.771423 2191.678467,528.101868 
	C2189.791260,526.445740 2189.108643,523.490601 2187.574219,521.340576 
	C2185.495605,518.428040 2183.566650,514.825134 2178.434570,517.486816 
	C2172.629883,521.756287 2169.928467,526.254517 2173.968262,533.308838 
	C2174.869385,541.758423 2174.962402,542.260681 2181.493896,541.051086 
	C2187.253662,539.984436 2189.028320,543.947266 2191.266602,547.329224 
	C2192.508301,549.205505 2191.460938,551.309082 2189.120605,551.829529 
	C2182.424561,553.318604 2176.786377,558.124878 2168.797363,557.998230 
	C2167.767334,557.774902 2167.517578,557.564941 2167.304932,557.322388 
	C2164.636475,554.278809 2164.556885,546.842529 2158.254395,549.820007 
	C2152.398926,552.586304 2158.848145,557.013245 2158.281982,561.379639 
	C2155.970215,565.501831 2152.946777,568.456177 2152.070312,573.317383 
	C2151.280273,574.739990 2150.211670,575.473206 2149.402832,575.100647 
	C2140.808838,571.143311 2137.676758,576.624878 2134.562988,583.600891 
	C2130.100098,583.334717 2128.425049,586.312500 2126.020264,588.488281 
	C2121.635010,592.455933 2120.739258,591.491394 2115.529053,587.889709 
	C2108.397217,582.959900 2106.815918,577.189758 2109.983643,568.779358 
	C2110.247314,567.781433 2110.477295,567.538025 2110.744873,567.348328 
	C2113.353516,565.500916 2117.677490,567.309570 2119.286133,563.440552 
	C2119.891846,561.983948 2118.980469,560.813965 2117.657471,560.302246 
	C2113.476074,558.684937 2112.297363,563.374512 2108.672363,564.192261 
	C2105.637939,562.693237 2106.266357,558.599670 2103.061279,558.296082 
	C2098.489258,557.863037 2093.848389,557.394531 2089.330811,558.723633 
	C2088.066895,559.095642 2087.074707,560.096924 2087.047607,561.591370 
	C2087.015381,563.355652 2088.477539,563.466736 2089.696289,563.905640 
	C2096.543701,566.372253 2097.489746,567.865784 2094.744629,574.160278 
	C2092.392822,579.552734 2090.292725,585.202759 2085.706543,589.338257 
	C2083.994141,590.882324 2082.287598,592.582458 2082.140137,595.076904 
	C2081.921143,598.783508 2080.285400,600.941895 2076.614258,602.284790 
	C2072.907471,603.640747 2075.057617,605.730835 2077.415771,607.694580 
	C2080.606934,613.181946 2077.351318,615.837830 2072.787598,618.134644 
	C2068.423340,618.374268 2063.027100,616.538025 2065.590088,623.898865 
	C2066.640137,626.914490 2065.873535,630.062317 2062.479736,631.387634 
	C2059.414062,632.584900 2056.565186,631.865967 2054.605713,628.966125 
	C2053.508301,627.341980 2052.774658,625.382202 2050.473389,624.932373 
	C2047.684814,625.317200 2048.273193,627.771851 2047.763916,629.531799 
	C2046.770142,632.964844 2044.122925,636.652893 2041.464111,636.693909 
	C2030.071655,636.869446 2019.364258,647.703918 2007.160278,637.921936 
	C2004.639771,649.027466 1997.146118,652.973267 1987.628662,654.433838 
	C1981.406006,655.388672 1975.406860,660.335327 1968.867065,654.940674 
	C1967.528198,653.836243 1965.302856,655.282715 1964.944702,656.890076 
	C1964.016968,661.054565 1961.951660,664.984802 1962.225342,669.409119 
	C1962.843140,679.395020 1961.983154,680.792175 1953.196289,683.908936 
	C1951.950439,684.350891 1950.621582,684.558777 1948.472656,685.184937 
	C1943.310425,684.855591 1941.177002,680.996643 1937.300293,678.576050 
	C1936.406128,678.003906 1936.059326,677.767212 1935.204224,677.189087 
	C1932.644409,675.348694 1931.128662,676.135864 1929.470947,678.478760 
	C1927.099121,681.348511 1924.619873,683.104004 1921.455322,685.028015 
	C1918.717163,686.600952 1916.499878,687.800354 1914.699707,690.500854 
	C1914.127075,691.396484 1913.883911,691.747925 1913.245850,692.609009 
	C1912.288208,693.771729 1911.697876,694.398682 1910.599854,695.433716 
	C1908.132568,697.482849 1905.940796,698.815125 1903.385864,700.714905 
	C1900.772461,702.363037 1898.787354,703.773010 1897.254272,706.556152 
	C1894.540161,710.139526 1891.571777,712.500977 1887.764404,714.833557 
	C1885.862061,716.056885 1884.573608,717.047485 1883.162720,718.835571 
	C1880.306519,722.284058 1877.380371,724.694946 1873.502686,726.929321 
	C1870.750366,728.391357 1868.778320,729.803223 1867.222900,732.610535 
	C1864.938843,735.580688 1862.690796,737.656799 1859.413086,739.557495 
	C1855.757568,740.932129 1853.450073,742.895813 1851.450195,746.237488 
	C1848.988525,749.035034 1846.537964,750.857361 1843.645508,753.140625 
	C1839.995605,754.880981 1837.316406,756.768555 1835.366943,760.455444 
	C1833.065552,763.488831 1830.784790,765.598999 1827.476318,767.539429 
	C1823.903076,768.930786 1821.528320,770.739685 1819.623291,774.109009 
	C1816.839966,777.841736 1813.415527,779.823059 1809.788574,782.548889 
	C1807.954346,783.925049 1806.651733,784.946777 1805.227539,786.754395 
	C1802.337158,790.125488 1799.711792,792.871460 1795.943970,795.279541 
	C1793.964966,796.365845 1792.567139,797.194214 1791.107544,798.966309 
	C1788.152954,802.442261 1785.133789,804.867493 1781.170410,807.166382 
	C1777.824341,808.905884 1775.498901,810.807373 1773.596436,814.128906 
	C1771.861572,816.445984 1770.194214,817.868530 1767.736816,819.344604 
	C1764.810547,820.583740 1762.723022,821.854858 1761.146118,824.759827 
	C1757.368530,829.655518 1753.029053,832.948486 1748.000488,836.450195 
	C1746.103271,837.869324 1744.705322,838.864014 1743.237793,840.765381 
	C1740.435303,844.131287 1737.619385,846.473511 1733.890625,848.740051 
	C1731.927368,849.983521 1730.588379,850.962646 1729.157715,852.781738 
	C1726.869507,855.561462 1724.700317,857.596313 1722.171387,860.174988 
	C1721.089478,861.205872 1720.432617,861.748047 1719.234619,862.624146 
	C1718.360596,863.202942 1718.002197,863.417053 1717.101807,863.931641 
	C1715.453613,864.784912 1714.472046,865.505371 1713.216553,866.883789 
	C1710.811157,869.588501 1708.651611,871.659424 1706.098389,874.252686 
	C1705.000977,875.291931 1704.333984,875.837402 1703.108887,876.704956 
	C1702.210815,877.265198 1701.841431,877.467102 1700.908447,877.936768 
	C1698.325562,878.826660 1696.791138,880.050720 1695.418457,882.409424 
	C1693.877808,884.575684 1692.616333,886.179138 1690.676025,887.929138 
	C1689.595825,889.101257 1688.375000,887.382751 1688.340454,889.078369 
	C1689.123291,889.518066 1689.452637,889.688354 1690.256592,890.200562 
	C1691.043457,890.803955 1691.355957,891.065369 1692.135376,891.749512 
	C1697.520386,897.377808 1703.244507,901.835205 1707.544922,908.502319 
	C1708.946045,912.057495 1710.716919,914.453247 1714.100830,916.338135 
	C1717.437988,918.876221 1719.890991,921.386719 1722.519897,924.616882 
	C1723.980957,926.851074 1724.611450,928.864929 1726.680664,930.643188 
	C1729.294312,932.976746 1730.977905,935.282288 1732.786499,938.252930 
	C1733.952026,940.101868 1734.879761,941.373779 1736.536865,942.823242 
	C1737.860840,944.096313 1738.583618,945.083191 1739.573730,946.639893 
	C1740.543335,948.206604 1741.104614,949.307861 1742.470459,950.594727 
	C1743.789795,951.953491 1744.529419,952.974182 1745.543823,954.573120 
	C1746.526733,956.165344 1747.083008,957.289612 1748.465942,958.590332 
	C1749.790161,959.954041 1750.531372,960.977173 1751.539185,962.581909 
	C1752.502075,964.175720 1753.019165,965.310242 1754.258057,966.709290 
	C1754.883179,967.523926 1755.117798,967.861145 1755.670166,968.723755 
	C1756.745850,970.706055 1757.657715,972.054077 1759.230957,973.711182 
	C1764.190674,979.607971 1767.770630,985.656555 1771.525879,992.378662 
	C1772.790283,995.407532 1773.688110,997.880432 1775.970947,1000.330261 
	C1776.658691,1001.173645 1776.915039,1001.523621 1777.509033,1002.422852 
	C1778.492432,1004.051086 1778.978638,1005.229431 1780.229980,1006.654175 
	C1780.849243,1007.473755 1781.081177,1007.811279 1781.623779,1008.672852 
	C1782.667480,1010.631165 1783.529297,1011.981018 1784.900635,1013.729858 
	C1785.599243,1014.982361 1785.906860,1015.744812 1786.329590,1017.127747 
	C1786.973389,1020.742004 1788.636108,1023.080872 1791.167480,1025.689941 
	C1794.170532,1030.196411 1796.122192,1034.504517 1798.369629,1039.489746 
	C1817.211060,1080.048462 1833.060425,1120.898315 1843.484009,1164.511963 
	C1844.025269,1166.188110 1844.248047,1167.164551 1844.526978,1168.883301 
	C1844.836914,1173.979492 1846.348999,1178.067871 1847.533936,1182.952637 
	C1848.098755,1185.007935 1848.284912,1186.409058 1848.526855,1188.500000 
	C1848.748413,1190.981079 1848.693970,1192.802002 1849.486816,1195.184448 
	C1849.890259,1196.705811 1850.073364,1197.586548 1850.333496,1199.140137 
	C1850.693726,1201.582397 1850.767090,1203.391113 1851.611328,1205.757324 
	C1852.040649,1207.326904 1852.225586,1208.243652 1852.461792,1209.878906 
	C1852.810425,1213.460083 1852.520142,1216.401489 1853.871948,1219.886230 
	C1854.333008,1221.617432 1854.506714,1222.634033 1854.675537,1224.456543 
	C1854.940796,1235.541870 1857.115845,1245.652588 1857.845947,1256.708496 
	C1859.147217,1260.813232 1859.935913,1264.168823 1859.775635,1268.551025 
	C1857.883057,1288.651245 1859.349243,1307.914307 1858.894409,1328.041992 
	C1859.154175,1331.879150 1858.855347,1334.802856 1858.441162,1338.575195 
	C1856.272583,1344.735718 1856.915405,1350.292358 1856.845459,1356.588135 
	C1857.200195,1363.215698 1856.368652,1368.903320 1854.723633,1375.238037 
	C1854.119263,1377.780640 1853.526123,1379.580322 1853.890137,1382.180420 
	C1854.223267,1384.697632 1854.206665,1386.523682 1853.570557,1388.975830 
	C1852.111450,1391.880981 1850.412109,1393.966675 1850.468994,1397.431885 
	C1850.299316,1398.981812 1850.155273,1399.865479 1849.836670,1401.412598 
	C1849.236084,1403.859131 1848.635254,1405.610352 1848.636108,1408.199463 
	C1848.501343,1410.384888 1848.288208,1411.838501 1847.887695,1414.032471 
	C1838.363281,1457.230591 1825.577515,1498.565674 1807.199951,1538.844238 
	C1806.846924,1540.997925 1806.476807,1542.388916 1805.841553,1544.418457 
	C1804.942383,1546.703857 1803.695801,1548.001465 1802.746582,1550.192139 
	C1802.283813,1551.595459 1801.969971,1552.378052 1801.329346,1553.705078 
	C1800.174194,1555.674316 1798.965576,1556.886597 1798.367676,1559.182007 
	C1795.971558,1565.212158 1792.578247,1569.989380 1789.599854,1575.756836 
	C1786.311646,1579.244873 1784.148193,1582.633179 1782.593506,1587.163330 
	C1782.202637,1588.185913 1782.025513,1588.582642 1781.525513,1589.536133 
	C1780.274048,1591.462646 1778.989990,1592.579346 1778.075806,1594.703735 
	C1777.153198,1596.803955 1776.393311,1598.292114 1775.149780,1600.236206 
	C1773.086548,1602.593994 1771.449097,1604.475098 1770.438232,1607.516846 
	C1770.039429,1608.494141 1769.860962,1608.877686 1769.356934,1609.805908 
	C1768.051514,1611.706177 1766.841187,1612.900391 1765.868408,1615.037598 
	C1762.874146,1620.674194 1759.238403,1625.087524 1755.383057,1630.161255 
	C1752.437988,1633.198608 1750.112061,1635.871216 1748.115845,1639.633301 
	C1747.151123,1641.369385 1746.420898,1642.468384 1745.260986,1644.062134 
	C1743.038452,1646.330444 1740.811646,1647.755249 1739.818359,1651.024658 
	C1727.889648,1668.503174 1713.797363,1683.316284 1700.098022,1698.455566 
	C1698.124878,1700.636108 1696.011597,1702.818848 1692.178223,1703.543701 
	C1683.913696,1710.978149 1676.315674,1718.187134 1668.436279,1726.016846 
	C1664.461914,1728.882324 1661.910767,1732.399414 1658.135498,1735.497070 
	C1654.716431,1736.905029 1652.899780,1739.345581 1650.367676,1741.783203 
	C1648.801270,1743.174561 1647.729736,1744.265991 1646.081421,1745.546997 
	C1643.462891,1746.354858 1642.180542,1748.045898 1640.390625,1749.951538 
	C1638.012451,1751.786133 1636.413818,1753.676147 1633.991699,1755.514893 
	C1630.319946,1757.496338 1628.455566,1760.900269 1624.467773,1762.570068 
	C1622.902832,1763.575439 1621.890869,1764.206909 1620.655762,1765.531494 
	C1619.771851,1766.443970 1619.271362,1766.895874 1618.383057,1767.672241 
	C1616.423828,1769.412598 1614.222900,1769.761963 1612.117920,1771.501953 
	C1604.419800,1777.472900 1596.576782,1782.077271 1588.362793,1787.285156 
	C1586.581177,1789.375366 1584.377686,1789.650146 1582.540527,1791.552246 
	C1576.914429,1794.303101 1572.718872,1798.479980 1566.571533,1800.635498 
	C1563.379883,1802.129150 1560.958618,1803.482910 1558.083984,1805.454712 
	C1555.929321,1806.531860 1554.371460,1807.252197 1552.397461,1808.473633 
	C1541.458252,1814.474487 1530.490479,1819.109985 1519.626465,1825.483643 
	C1516.485718,1825.213623 1514.948242,1827.463867 1512.277832,1828.252441 
	C1479.240723,1842.221191 1446.210815,1854.307617 1411.039307,1862.452026 
	C1409.276855,1862.714233 1408.265137,1862.769653 1406.601318,1863.234375 
	C1383.428955,1868.763306 1360.641235,1872.309937 1336.990234,1875.330566 
	C1332.963501,1875.070679 1332.245117,1872.323608 1331.066650,1869.972168 
	C1329.726562,1867.298096 1328.410889,1863.929810 1324.793457,1864.624512 
	C1320.349731,1865.477783 1321.106567,1869.424927 1321.277588,1873.432129 
	C1321.227539,1874.592773 1321.147339,1875.053711 1320.703857,1876.115234 
	C1318.738647,1876.633057 1317.136841,1876.550537 1314.769775,1876.739380 
	C1306.616211,1875.680420 1299.219360,1877.204102 1290.914062,1876.789062 
	C1286.349854,1871.706787 1288.422241,1868.035156 1292.619263,1864.871460 
	C1294.987671,1863.086182 1297.688477,1861.726685 1299.695190,1859.481567 
	C1301.548218,1857.408325 1302.776489,1855.097900 1301.340576,1852.297974 
	C1300.323853,1850.315186 1298.504639,1849.549438 1296.370728,1849.870117 
	C1293.338135,1850.325806 1291.597656,1852.479614 1291.351807,1855.255859 
	C1290.703003,1862.579346 1289.546265,1869.650146 1284.336304,1876.148926 
	C1262.511108,1877.754761 1241.057861,1877.094482 1218.831299,1874.558350 
	C1213.073364,1867.777954 1217.009766,1862.991577 1221.449341,1858.748291 
	C1225.364624,1855.006348 1229.025391,1851.289429 1230.300659,1845.833252 
	C1230.607300,1844.521118 1230.848145,1843.051392 1229.855469,1842.042725 
	C1228.396362,1840.559570 1226.792603,1841.564331 1225.364990,1842.321411 
	C1222.341553,1843.924683 1218.800293,1846.097168 1219.578491,1849.673462 
	C1222.112793,1861.320923 1214.783936,1866.603760 1206.308594,1872.242188 
	C1199.751099,1873.283447 1193.649658,1872.069946 1186.774414,1870.574951 
	C1184.964478,1856.430054 1191.026978,1846.668457 1203.131958,1842.950073 
	C1206.140015,1842.026001 1209.321045,1841.183350 1208.635986,1837.234497 
	C1207.784668,1832.326416 1206.763916,1827.217041 1200.948486,1825.465332 
	C1198.667847,1824.778564 1196.290283,1825.006470 1194.016724,1825.482788 
	C1186.761353,1827.002319 1182.654663,1823.768188 1180.472656,1817.065430 
	C1179.358765,1813.643677 1178.427979,1809.570557 1173.283569,1810.601318 
	C1168.576416,1811.544312 1165.149658,1814.230347 1165.101196,1819.266846 
	C1165.021362,1827.549683 1162.007202,1833.975342 1155.204224,1838.858521 
	C1151.673950,1841.392456 1150.231323,1845.267456 1152.064697,1849.482300 
	C1154.082031,1854.120605 1158.191162,1853.637207 1162.338989,1853.177856 
	C1173.948853,1851.892456 1176.847412,1855.246948 1174.408936,1867.883667 
	C1156.021729,1866.644653 1138.677979,1861.841675 1120.623535,1857.022827 
	C1117.345581,1849.941284 1114.196411,1844.436035 1105.697144,1843.470703 
	C1100.700317,1842.903076 1098.272705,1838.040161 1098.295288,1832.907471 
	C1098.314453,1828.567749 1100.526733,1825.264038 1104.605713,1823.540283 
	C1109.505127,1821.469849 1112.846924,1824.369995 1116.061646,1827.430786 
	C1118.469116,1829.723145 1120.136475,1832.759033 1122.972656,1834.601929 
	C1126.183228,1836.688354 1129.389648,1835.810913 1132.389893,1834.055054 
	C1134.651123,1832.731934 1135.620361,1830.702393 1134.543091,1828.121094 
	C1133.128174,1824.730347 1130.103638,1824.314697 1127.023560,1824.509033 
	C1117.921875,1825.083984 1112.592529,1820.791748 1110.340942,1812.135864 
	C1107.791626,1802.334595 1109.479370,1797.750977 1119.002197,1791.426270 
	C1123.028076,1788.752563 1125.573364,1785.638794 1124.546753,1780.754028 
	C1122.665771,1771.803101 1127.234131,1767.511963 1135.178833,1765.965210 
	C1142.691284,1764.502686 1145.307129,1760.868286 1142.840210,1753.284912 
	C1140.947632,1747.466797 1143.788330,1743.686157 1149.598022,1742.083252 
	C1156.697998,1740.124268 1164.526245,1743.580322 1167.101562,1750.078003 
	C1169.188843,1755.344238 1168.286255,1759.896729 1163.065308,1762.983032 
	C1161.628296,1763.832397 1160.082642,1764.461426 1158.568604,1765.152832 
	C1155.662964,1766.479736 1153.338867,1768.318359 1153.665405,1771.886841 
	C1154.014160,1775.698608 1156.441284,1778.432007 1160.013184,1778.536743 
	C1169.032349,1778.801758 1173.580444,1784.214355 1177.271484,1791.468140 
	C1179.028931,1794.922241 1181.300537,1799.034424 1186.347168,1797.505615 
	C1191.136963,1796.054688 1195.819824,1794.093994 1197.121094,1788.276978 
	C1198.635986,1781.504272 1199.234497,1773.660400 1207.866577,1772.036621 
	C1216.350708,1770.440918 1220.129517,1776.974976 1224.023926,1782.950073 
	C1226.285645,1786.420410 1229.741943,1787.341675 1233.686035,1786.209839 
	C1237.795898,1785.030396 1239.815674,1782.087402 1239.460693,1777.978149 
	C1238.674805,1768.878906 1243.064941,1762.799561 1250.234009,1758.053833 
	C1252.964600,1756.246216 1256.321533,1754.474487 1254.604370,1750.226685 
	C1252.952393,1746.140137 1249.811646,1743.473145 1245.324097,1744.172852 
	C1238.896973,1745.175049 1232.865112,1746.825684 1229.432861,1738.686890 
	C1225.848633,1730.187622 1228.813354,1723.894653 1234.867920,1718.152710 
	C1236.554077,1716.553711 1238.189209,1714.846436 1239.159424,1712.677734 
	C1240.721436,1709.186401 1240.275391,1705.811890 1236.896240,1703.967529 
	C1233.231445,1701.967285 1231.422852,1705.140747 1230.100952,1707.821655 
	C1226.983032,1714.144897 1223.692993,1720.293579 1217.730347,1724.464966 
	C1209.263550,1730.388428 1202.989624,1727.718872 1201.599976,1717.477051 
	C1200.624268,1710.286133 1201.457397,1703.495117 1207.041870,1698.061646 
	C1208.469971,1696.672119 1209.794678,1695.148071 1210.815918,1693.419800 
	C1212.033447,1691.359863 1213.296265,1688.812622 1211.222412,1687.038574 
	C1208.833130,1684.994507 1206.143921,1686.637451 1203.932495,1688.172607 
	C1201.526855,1689.842407 1200.954102,1692.533203 1200.772827,1695.225098 
	C1200.272583,1702.656006 1196.328125,1707.539551 1189.768677,1710.616455 
	C1185.898926,1712.431274 1182.749512,1714.868652 1183.995972,1719.791992 
	C1185.171021,1724.433838 1188.343506,1727.779663 1193.061768,1727.846191 
	C1202.360596,1727.977417 1207.864502,1732.494263 1211.148804,1740.808472 
	C1213.415527,1746.546509 1218.444336,1745.766479 1223.101929,1744.950562 
	C1230.171753,1743.712158 1236.729736,1743.472900 1239.111328,1752.188354 
	C1240.992920,1759.073486 1236.651245,1767.414795 1229.972900,1770.327515 
	C1222.614014,1773.537231 1217.147095,1771.822388 1212.590454,1763.661743 
	C1209.707764,1758.498779 1206.866455,1755.166748 1200.275879,1756.179565 
	C1194.265503,1757.103271 1190.204224,1753.383667 1187.374268,1748.487793 
	C1183.677246,1742.091797 1178.642700,1737.715088 1171.187500,1736.321289 
	C1166.748413,1735.491211 1163.783813,1732.003296 1160.146118,1729.713867 
	C1150.863403,1723.871582 1143.743408,1727.415771 1143.855835,1738.135986 
	C1143.924438,1744.682983 1140.569946,1747.890137 1135.208496,1750.008301 
	C1128.030273,1752.844238 1120.417847,1754.364990 1114.870239,1747.787109 
	C1109.727417,1741.689453 1105.643066,1737.493286 1096.135498,1738.594238 
	C1088.654541,1739.460449 1088.386475,1730.003906 1086.824585,1724.103638 
	C1084.771973,1716.350220 1088.465454,1711.337280 1095.339600,1708.155640 
	C1097.933960,1706.955078 1101.744995,1706.732300 1101.533325,1702.742554 
	C1101.332642,1698.957886 1099.587402,1695.686035 1095.993530,1693.841309 
	C1094.185181,1692.913208 1092.113770,1692.997070 1090.159180,1692.622437 
	C1077.746094,1690.243774 1072.771851,1677.909058 1080.054199,1667.639771 
	C1081.018921,1666.279541 1082.185425,1665.084229 1083.289185,1663.837280 
	C1093.042236,1652.821411 1091.777588,1648.490356 1077.596802,1644.295532 
	C1067.517700,1641.314209 1064.309814,1631.958618 1071.576172,1624.335449 
	C1076.448853,1619.223145 1079.362915,1613.974731 1080.202637,1607.017212 
	C1080.843140,1601.710449 1083.383179,1596.974365 1086.879395,1592.722168 
	C1092.555176,1585.818848 1092.179077,1583.736694 1084.736572,1578.584961 
	C1081.725220,1576.500732 1078.532593,1574.718140 1076.187744,1571.784058 
	C1069.795532,1563.785400 1070.855469,1558.273438 1080.689209,1552.273438 
	C1084.081787,1551.528198 1086.799194,1551.736328 1088.984497,1553.257080 
	C1099.163940,1560.340332 1110.689697,1565.307129 1120.716553,1573.827271 
	C1123.161133,1576.276978 1121.139282,1583.858276 1128.504272,1578.945801 
	C1144.220581,1582.755493 1158.050781,1589.767212 1172.503418,1596.955933 
	C1173.517456,1608.649536 1177.537964,1615.549805 1190.481812,1614.997314 
	C1196.108887,1614.757202 1199.381836,1620.337646 1201.135986,1625.621216 
	C1202.945068,1631.070557 1199.836914,1634.528564 1195.605347,1637.147461 
	C1190.925903,1640.043579 1188.540527,1644.071411 1188.838379,1649.583008 
	C1189.013916,1652.832764 1188.392334,1656.675293 1192.429932,1658.060059 
	C1195.980591,1659.277710 1198.856934,1657.268311 1201.390869,1654.962280 
	C1203.163208,1653.349121 1204.598267,1651.294434 1204.646362,1648.943237 
	C1204.847656,1639.107300 1206.086426,1630.087158 1214.586304,1623.104126 
	C1218.391602,1619.978027 1213.039307,1614.137207 1216.121338,1609.224365 
	C1227.605225,1606.234253 1238.005127,1608.378052 1248.756592,1612.717285 
	C1251.993164,1618.545654 1255.401978,1619.395874 1260.130371,1614.340332 
	C1264.160889,1611.182373 1268.075928,1611.004883 1272.845581,1612.427246 
	C1277.602539,1616.384888 1276.950073,1621.734375 1278.284790,1626.342773 
	C1279.473145,1630.445557 1281.373291,1632.859497 1285.967896,1631.385986 
	C1290.715820,1629.863281 1290.590088,1626.570068 1289.009644,1622.755005 
	C1287.781494,1619.790405 1285.718018,1616.916992 1288.335449,1613.022217 
	C1298.130249,1609.500610 1307.747681,1609.299927 1318.015869,1608.620361 
	C1320.491943,1609.497681 1321.261353,1610.924683 1321.039062,1612.667847 
	C1320.408081,1617.613037 1323.187012,1618.977173 1327.401367,1619.125000 
	C1331.364868,1619.263794 1334.635132,1618.560181 1335.263306,1613.799683 
	C1335.519897,1611.855835 1335.839478,1609.911133 1337.078735,1607.464844 
	C1344.672363,1601.734009 1352.940796,1600.439941 1362.177246,1600.263550 
	C1363.497925,1600.784180 1364.087646,1601.126831 1364.483398,1601.647583 
	C1366.899780,1604.828369 1367.563599,1610.385376 1373.764771,1608.364868 
	C1379.544189,1606.481812 1377.581787,1601.382202 1378.580688,1596.746338 
	C1382.213989,1590.941040 1388.158569,1590.184448 1393.175415,1587.932617 
	C1418.214111,1576.693359 1442.690796,1564.509399 1464.710205,1546.647705 
	C1465.586426,1545.869019 1465.947266,1545.573608 1466.869385,1544.871582 
	C1470.288574,1542.999756 1472.594238,1540.911743 1474.886963,1537.777466 
	C1475.731689,1537.005737 1476.100830,1536.729370 1477.071045,1536.107422 
	C1490.548584,1526.504639 1501.113770,1514.887085 1511.544189,1502.227173 
	C1512.412231,1500.369751 1513.180542,1499.255371 1514.514160,1497.733398 
	C1516.994141,1495.659424 1519.226074,1494.247314 1520.251953,1490.908691 
	C1521.677979,1488.150024 1523.249268,1486.348877 1525.459839,1484.094727 
	C1543.041504,1464.040283 1555.003174,1441.398560 1564.664185,1417.670776 
	C1581.626221,1376.011353 1590.513306,1332.542236 1588.889648,1287.452271 
	C1588.078003,1264.909424 1583.649048,1242.682495 1578.272705,1220.743774 
	C1571.350220,1192.495972 1559.969849,1166.087524 1544.474854,1140.645264 
	C1543.653320,1139.706177 1543.348145,1139.319092 1542.670654,1138.309814 
	C1538.466309,1128.897705 1532.970947,1121.245850 1525.835938,1113.939331 
	C1523.691650,1112.037842 1522.276001,1110.377319 1520.749023,1107.985596 
	C1519.641113,1105.972290 1518.849121,1104.512817 1517.292480,1102.806030 
	C1516.122070,1101.300049 1515.476074,1100.199219 1514.454102,1098.565186 
	C1509.803833,1091.228882 1503.451538,1086.273315 1497.760010,1079.852051 
	C1494.315552,1076.797119 1491.537598,1073.984253 1487.813965,1071.254639 
	C1484.292847,1067.145752 1481.542969,1063.200562 1476.778320,1060.325439 
	C1475.836304,1059.724487 1475.466187,1059.468628 1474.561890,1058.792725 
	C1469.109863,1053.572144 1464.212769,1048.743774 1456.945557,1045.905762 
	C1455.845581,1045.342651 1455.414185,1045.085327 1454.385986,1044.349854 
	C1434.635986,1028.544922 1412.942749,1017.739075 1390.305664,1008.785767 
	C1352.812256,993.956848 1313.921143,986.199890 1273.492065,986.752075 
	C1270.830566,986.788391 1268.152222,986.776428 1264.903076,985.497437 
	C1259.235962,979.197876 1258.132080,973.356934 1264.922363,967.931946 
	C1273.915649,960.746887 1281.253174,960.496277 1287.658203,967.166504 
	C1289.716309,969.309875 1291.343994,972.284241 1294.990234,970.868286 
	C1297.024414,970.078369 1297.895752,968.161560 1297.632568,965.980652 
	C1297.182129,962.246399 1294.320190,961.398132 1291.234619,960.813904 
	C1283.808228,959.407532 1277.506592,956.517334 1275.700439,947.778931 
	C1288.042603,942.558838 1299.897339,946.828125 1311.524170,948.153320 
	C1349.964844,952.534851 1386.190186,964.466370 1420.297607,982.846985 
	C1431.185669,988.714600 1431.756470,988.549866 1438.891602,978.458801 
	C1458.685669,950.464539 1470.144531,919.236145 1474.965454,885.355713 
	C1479.216675,855.479370 1476.643188,826.308167 1467.477905,797.625549 
	C1466.266357,793.833740 1465.168091,789.937378 1466.611572,785.165527 
	C1474.953857,782.606995 1481.051147,779.112915 1483.197754,770.048340 
	C1484.228760,765.694885 1489.872803,765.012329 1493.624634,762.965637 
	C1498.451172,760.332581 1503.026001,757.436401 1502.217041,750.886414 
	C1501.551392,745.495483 1502.063110,740.759827 1508.031250,738.662598 
	C1512.786987,736.991516 1517.378784,737.392029 1520.952148,741.214050 
	C1525.359131,745.927734 1525.187866,751.352783 1522.741211,757.011597 
	C1521.199707,760.577026 1516.093994,763.411682 1520.067383,768.306641 
	C1522.914795,768.276978 1523.455322,766.038452 1523.856812,764.250488 
	C1525.284180,757.893372 1528.812134,753.671143 1534.938477,751.193237 
	C1539.866943,749.199829 1543.473022,745.717651 1542.418335,739.683228 
	C1541.378784,733.735901 1536.689453,732.924622 1531.819824,732.757019 
	C1526.355957,732.568970 1522.085327,730.476929 1519.783325,725.372375 
	C1517.680664,720.709351 1513.112793,715.252502 1519.098145,711.145813 
	C1524.227539,707.626465 1530.626831,708.418762 1535.918335,712.479675 
	C1538.322388,714.324707 1539.508789,717.264221 1541.607056,719.408630 
	C1545.834717,723.728760 1550.093506,722.019165 1554.209229,719.289124 
	C1558.161133,716.667969 1558.900391,713.037354 1556.893555,708.833679 
	C1554.502319,703.824707 1550.786621,705.251953 1546.703125,706.421997 
	C1538.064819,708.897156 1534.365845,706.470764 1531.492920,697.149841 
	C1528.317139,686.846313 1529.474243,684.049316 1539.205322,680.900757 
	C1545.661133,678.812012 1548.654297,675.127869 1547.135254,668.245728 
	C1545.701172,661.748535 1541.297729,661.006470 1535.712402,661.898315 
	C1530.735596,662.692810 1525.745850,663.277893 1522.105713,658.348755 
	C1517.428345,652.015686 1517.157959,644.654785 1521.687622,641.275757 
	C1527.662476,636.818665 1539.857056,636.878967 1543.901978,641.510864 
	C1545.867798,643.761719 1547.038574,646.614990 1549.066650,648.852966 
	C1552.316528,652.439209 1556.072754,652.144348 1559.985962,650.241089 
	C1563.864380,648.354736 1565.105347,645.188721 1564.023071,641.115479 
	C1562.911133,636.931152 1560.665771,633.110901 1555.873535,634.002380 
	C1545.335449,635.962646 1539.567627,630.990601 1535.737671,622.002563 
	C1533.557861,616.886902 1529.358521,616.114807 1524.127686,616.736084 
	C1515.607544,617.748047 1509.550537,612.351624 1508.854614,603.991333 
	C1508.436646,598.969727 1511.508057,596.729187 1515.602295,595.457642 
	C1521.135010,593.739319 1526.746582,592.363281 1531.091431,598.002441 
	C1532.922852,600.379578 1533.794067,603.367310 1535.750488,605.671448 
	C1538.629272,609.061829 1542.152588,610.585938 1546.369019,608.441101 
	C1550.734009,606.220886 1551.128296,602.346130 1549.842896,598.145447 
	C1548.520264,593.823853 1545.680054,590.668518 1541.004272,592.312683 
	C1531.185913,595.764893 1526.483643,591.754395 1524.728760,582.435303 
	C1523.471191,575.757080 1519.450806,575.290833 1513.600464,576.602905 
	C1503.846191,578.790527 1502.147217,577.755371 1501.470947,568.002808 
	C1501.084717,562.433655 1497.104492,559.225891 1495.764893,553.990356 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M1719.456543,860.038147 
	C1721.463501,856.493103 1724.318359,854.579041 1727.520020,852.164673 
	C1729.036133,850.997803 1729.974121,850.091919 1731.511963,848.878540 
	C1734.934204,845.760437 1737.843018,843.044556 1741.374390,840.081299 
	C1742.992798,838.960449 1743.969849,838.065491 1745.495361,836.791748 
	C1749.576538,831.581970 1754.569214,828.347412 1759.624023,824.258911 
	C1761.664673,822.371704 1763.142578,820.786682 1765.461182,819.146057 
	C1767.554199,817.288574 1769.110718,815.800232 1771.279297,814.096375 
	C1774.382080,811.854004 1776.418823,809.327271 1779.571045,807.012695 
	C1782.391846,803.186401 1785.811035,801.000366 1789.511230,798.204590 
	C1791.024048,797.021118 1791.952393,796.121826 1793.468262,794.906006 
	C1796.897583,791.793274 1799.821045,789.083618 1803.368652,786.154724 
	C1804.978882,785.007629 1805.963501,784.078125 1807.532959,782.787659 
	C1809.900635,778.626221 1813.843994,777.128723 1817.191406,774.098694 
	C1820.361938,771.935974 1822.360840,769.397949 1825.441284,767.044250 
	C1828.191406,764.537415 1830.397827,762.443726 1833.203247,760.096924 
	C1836.354614,757.947510 1838.331543,755.409363 1841.424072,753.103271 
	C1843.684814,750.048767 1846.132568,748.161682 1849.246582,746.097412 
	C1852.349121,743.891724 1854.370728,741.405945 1857.432983,739.056946 
	C1860.234863,736.549072 1862.494141,734.450378 1865.373535,732.125488 
	C1867.675659,730.384155 1869.219849,728.718018 1871.545532,726.903137 
	C1874.291992,723.064148 1877.832642,721.062622 1881.356445,718.145752 
	C1882.967773,717.010315 1883.947754,716.097595 1885.525757,714.853027 
	C1888.228149,711.021484 1891.659424,708.925903 1895.223267,706.082458 
	C1897.670288,704.446045 1899.205322,702.714355 1901.532471,700.837524 
	C1903.422119,697.523193 1906.131348,696.060669 1909.109741,694.024902 
	C1910.320801,693.551147 1910.847290,693.186707 1911.587402,692.327515 
	C1911.875366,691.940002 1911.944458,691.936218 1911.943970,691.901733 
	C1914.387939,689.817871 1916.432617,687.330811 1919.556396,685.018188 
	C1921.600098,681.805481 1924.439941,680.401794 1927.265625,678.106445 
	C1929.899048,676.262024 1931.743408,674.226807 1935.428345,675.444214 
	C1936.097656,675.847961 1936.040283,675.948059 1936.094116,675.927307 
	C1940.416382,681.405151 1946.482422,685.170349 1950.957275,691.422119 
	C1951.354004,691.991760 1952.072876,692.536987 1952.209595,692.966919 
	C1952.465088,693.744385 1952.583984,694.091919 1953.213867,694.644775 
	C1953.724976,694.850098 1954.657837,694.901123 1955.125000,694.909424 
	C1958.509033,695.476379 1959.781860,697.844604 1961.522949,700.577332 
	C1962.677490,702.902588 1963.459106,704.738159 1965.952637,705.878296 
	C1967.421631,706.778198 1968.251831,707.539062 1969.210205,708.923218 
	C1969.823975,709.991150 1970.147217,710.606323 1970.685425,711.672729 
	C1970.907593,712.120239 1971.405396,712.979187 1971.796265,713.285156 
	C1972.173218,713.963562 1972.159302,714.335999 1972.154663,715.267273 
	C1973.544556,717.669495 1975.283691,719.197815 1977.150391,721.531006 
	C1980.341431,723.648621 1981.650879,726.528076 1983.851807,729.424438 
	C1984.969116,730.957336 1985.834595,731.899475 1986.980469,733.443726 
	C1988.185669,734.824585 1989.012329,735.689453 1990.026489,737.128540 
	C1991.381714,739.591125 1993.114990,740.970154 1994.865967,743.175171 
	C1996.372437,744.995178 1997.613525,746.212280 1999.443604,747.708862 
	C2000.279541,748.242493 2000.526367,748.496643 2001.120117,749.153076 
	C2002.072998,750.421448 2002.619507,751.328674 2003.621826,752.567261 
	C2004.443726,753.518250 2004.884155,754.089111 2005.607544,755.131592 
	C2006.537842,756.487366 2007.127686,757.416199 2008.350830,758.563293 
	C2009.295532,759.509583 2009.756226,760.119263 2010.305298,761.340088 
	C2011.056030,763.209717 2011.647949,764.521484 2012.311401,766.379639 
	C2012.360107,767.852234 2012.682739,768.636292 2013.982178,769.497559 
	C2015.264893,769.896912 2015.723022,770.297852 2016.063232,771.383545 
	C2016.941772,772.955383 2018.003662,773.709412 2019.891479,774.452454 
	C2021.985229,775.758850 2023.204834,777.051880 2024.699341,778.984863 
	C2025.257324,779.912964 2025.445312,780.300110 2025.847534,781.286255 
	C2026.604614,784.286560 2027.247314,786.633118 2029.910156,788.545776 
	C2030.612427,789.291809 2030.873413,789.608704 2031.479248,790.433167 
	C2032.498291,791.946472 2032.998291,793.073242 2034.290771,794.386230 
	C2034.908813,795.186523 2035.133423,795.523315 2035.418335,796.464478 
	C2035.756592,798.078430 2036.034546,799.088135 2036.371948,800.623291 
	C2037.148682,803.404907 2038.980713,804.663879 2041.308838,806.308960 
	C2042.174194,806.934265 2042.482544,807.228088 2043.160889,808.031433 
	C2044.182373,809.577820 2044.698364,810.694275 2045.906494,812.779541 
	C2046.726807,815.534851 2047.028442,817.219666 2047.703125,819.440430 
	C2048.951660,820.920044 2049.814697,821.874084 2050.937012,823.448547 
	C2051.552002,824.221924 2051.796631,824.468750 2052.188965,825.215698 
	C2053.108643,827.199036 2054.368164,828.200867 2056.192871,829.500488 
	C2057.864746,831.579468 2059.090088,833.249146 2061.134766,835.076294 
	C2063.415771,837.548706 2064.656982,839.909119 2065.970703,843.001526 
	C2067.929688,848.629944 2072.339600,852.433716 2073.086670,858.563538 
	C2071.336182,863.896484 2077.925293,864.747131 2077.938477,869.334290 
	C2078.024658,870.050415 2077.250000,870.673157 2077.250000,870.673157 
	C2077.250000,870.673157 2077.872803,871.447144 2078.363281,871.528198 
	C2078.853760,871.609314 2079.572510,871.514709 2079.921875,871.417969 
	C2082.583008,872.349060 2083.644287,874.271606 2084.040527,877.324341 
	C2086.104248,885.923767 2090.291992,892.877808 2094.221924,900.687683 
	C2094.344482,902.059875 2094.604980,902.633362 2095.357666,903.498169 
	C2097.153809,905.472717 2098.078369,907.368042 2098.507324,910.126038 
	C2098.316650,911.678772 2098.562256,912.479492 2099.744141,913.513062 
	C2102.570068,916.004211 2103.342041,918.919861 2104.382324,922.345337 
	C2104.356689,923.792542 2104.578125,924.511780 2105.527832,925.529785 
	C2109.073486,930.651855 2111.496826,935.688904 2112.712158,941.913452 
	C2112.348145,943.641968 2112.580811,944.532837 2114.054443,945.491455 
	C2117.417480,949.417175 2118.968750,953.623474 2120.330566,958.603577 
	C2139.747559,1007.070496 2155.565918,1055.971924 2166.366211,1107.260010 
	C2166.862305,1108.949463 2167.202881,1109.864746 2167.460205,1111.518433 
	C2168.162109,1117.112793 2170.128174,1121.728516 2170.500977,1127.352539 
	C2170.992920,1128.931763 2171.300537,1129.864380 2171.504883,1131.536743 
	C2175.152588,1150.006714 2177.413574,1167.979980 2180.160400,1185.874146 
	C2180.514648,1188.180664 2181.195557,1190.402222 2183.018066,1193.058838 
	C2183.979736,1195.440430 2184.152588,1197.127075 2184.007080,1199.701660 
	C2181.723389,1212.470337 2185.658447,1224.378052 2183.669678,1237.103516 
	C2182.431885,1240.020752 2180.681152,1241.572876 2179.807617,1243.834839 
	C2175.527832,1254.917603 2172.000732,1256.659912 2160.179443,1253.818848 
	C2106.215576,1240.849609 2051.643066,1230.677124 1997.473755,1218.617920 
	C1954.706543,1209.096924 1911.801147,1199.874146 1868.701782,1191.764404 
	C1859.632568,1190.057861 1850.998657,1188.048340 1849.985840,1176.156250 
	C1849.696045,1172.754517 1846.729614,1169.695557 1844.194092,1166.019043 
	C1836.692383,1146.718750 1832.833740,1127.079468 1825.952881,1108.359497 
	C1817.566895,1085.544312 1808.546387,1063.018555 1797.079224,1040.693848 
	C1793.811157,1036.250732 1791.838989,1031.979492 1789.822144,1026.977783 
	C1788.171265,1024.023193 1786.824951,1021.649475 1785.246338,1018.621033 
	C1784.484375,1017.384094 1784.046997,1016.747803 1783.517090,1015.533142 
	C1783.271606,1013.295532 1782.039185,1012.242737 1780.831177,1010.516907 
	C1780.473389,1010.058655 1779.838013,1009.370056 1779.740601,1008.911865 
	C1779.086670,1007.241394 1778.206909,1006.238586 1777.126465,1004.577759 
	C1776.531128,1003.761353 1776.298462,1003.498230 1775.930908,1002.725891 
	C1774.096313,1000.033569 1772.861084,997.561829 1771.062012,994.630310 
	C1766.498413,987.878784 1762.310303,981.704041 1757.950195,974.864746 
	C1757.041382,973.130859 1756.176025,972.158936 1755.048706,970.571594 
	C1754.672852,970.042603 1753.962524,969.346069 1753.818359,968.869995 
	C1753.066650,967.194031 1752.168335,966.199402 1750.968018,964.602417 
	C1749.757568,963.146057 1748.952393,962.219177 1747.975220,960.697144 
	C1747.027710,959.093628 1746.178955,958.142578 1745.087646,956.574707 
	C1743.893188,955.137451 1743.060669,954.223572 1742.017822,952.724731 
	C1741.028931,951.097412 1740.155151,950.130798 1738.986816,948.567566 
	C1737.774780,947.160522 1736.952637,946.273865 1735.933105,944.811279 
	C1734.992676,943.101135 1734.089478,942.092712 1732.800049,940.528687 
	C1729.652466,938.366272 1728.322754,935.497681 1726.112793,932.587891 
	C1724.321045,930.551025 1723.637329,928.546997 1721.906860,926.636414 
	C1718.999023,924.005310 1716.666870,921.593811 1714.110474,918.589661 
	C1711.814087,915.656067 1709.417358,913.616333 1707.113525,910.582520 
	C1701.248657,904.513306 1695.777954,898.986206 1690.017700,892.856567 
	C1689.521851,891.646240 1689.179688,891.128113 1688.289307,890.474792 
	C1687.876953,890.249939 1687.759521,890.197021 1687.745117,890.134216 
	C1687.544922,889.533264 1687.358887,888.995056 1687.545654,887.688416 
	C1689.531982,885.356140 1691.145874,883.792297 1693.286865,881.999390 
	C1695.671021,880.447449 1697.195801,878.749512 1699.410767,876.804077 
	C1699.914185,876.345764 1700.390503,875.716980 1700.768799,875.605835 
	C1701.990356,875.545349 1702.699219,875.261414 1703.434937,874.058167 
	C1705.508545,870.587524 1708.227661,868.527466 1711.451660,866.132996 
	C1712.989624,865.000610 1713.930176,864.107056 1715.403320,862.835449 
	C1715.892700,862.409851 1716.401001,861.761353 1716.795166,861.641296 
	C1718.026978,861.538940 1718.727905,861.237976 1719.456543,860.038147 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1753.494019,1630.277344 
	C1755.895142,1624.051270 1760.412231,1619.947266 1763.994995,1614.449707 
	C1765.357178,1612.876221 1766.200806,1611.759399 1767.408447,1610.050049 
	C1767.743164,1609.435303 1767.906860,1608.584351 1768.220581,1608.285522 
	C1770.292969,1605.677979 1771.449829,1602.992310 1773.470703,1600.116455 
	C1773.886230,1597.741943 1774.894165,1596.309326 1776.416992,1594.446045 
	C1777.552124,1592.878784 1778.249146,1591.786987 1779.465332,1590.264893 
	C1779.915894,1589.411743 1779.981079,1589.080078 1780.380859,1588.367554 
	C1783.125122,1584.372559 1784.633179,1580.249146 1787.450928,1576.119141 
	C1789.351074,1569.511353 1792.999512,1564.489502 1796.374512,1558.545654 
	C1797.607178,1556.675049 1798.433350,1555.396851 1799.455566,1553.593018 
	C1799.773071,1552.316040 1799.928955,1551.586670 1800.451416,1550.423584 
	C1801.608398,1548.673950 1802.438232,1547.383301 1803.440186,1545.552002 
	C1803.919678,1543.672729 1804.251587,1542.349609 1805.046387,1540.512451 
	C1823.622437,1500.084473 1837.368652,1458.737915 1846.483887,1415.068848 
	C1846.803711,1412.714600 1846.899658,1411.089966 1847.400024,1408.748047 
	C1848.122437,1406.941650 1848.739502,1406.063599 1850.443848,1405.178101 
	C1857.465332,1405.376221 1854.636597,1412.183838 1858.477417,1415.048462 
	C1868.337280,1403.856201 1879.583984,1403.378906 1891.695068,1411.440674 
	C1893.632446,1412.730103 1895.922852,1413.492920 1898.229858,1413.803467 
	C1935.367188,1418.801514 1970.983154,1431.347046 2007.898804,1436.677002 
	C2024.442017,1439.065552 2040.282104,1446.906860 2057.597168,1444.182495 
	C2060.196777,1443.773560 2062.866699,1444.880249 2065.307617,1445.959595 
	C2089.458496,1456.637451 2115.987793,1458.501953 2140.899414,1466.363647 
	C2143.102783,1467.058960 2145.508301,1466.929688 2147.837891,1466.995972 
	C2163.400391,1467.438599 2165.186279,1465.942383 2168.738281,1451.029419 
	C2170.593506,1443.239380 2171.034668,1435.227051 2172.890137,1427.466187 
	C2173.760010,1423.827881 2173.506592,1418.971802 2180.162598,1419.736084 
	C2183.923584,1426.116577 2183.130859,1431.598877 2178.389160,1437.350952 
	C2176.810547,1443.381348 2175.848145,1448.765381 2174.909180,1454.959106 
	C2176.928467,1459.714722 2177.435547,1463.585327 2173.481934,1467.408691 
	C2170.942139,1475.171021 2169.269287,1482.798218 2167.635742,1491.210205 
	C2169.761963,1494.227051 2170.035156,1496.649414 2167.441162,1499.338745 
	C2163.947266,1504.169067 2163.772461,1509.543823 2162.444824,1515.246094 
	C2158.773438,1524.448853 2157.294434,1533.659302 2154.676025,1542.536865 
	C2153.648438,1546.020142 2152.439697,1549.450195 2150.767334,1553.481323 
	C2143.955322,1577.088501 2137.205811,1599.951538 2126.632568,1622.300293 
	C2126.133789,1624.335938 2125.859863,1625.640259 2125.172852,1627.478027 
	C2120.749268,1639.316895 2115.910645,1650.278198 2110.591797,1661.808838 
	C2110.020996,1663.275757 2109.834473,1664.133789 2109.213135,1665.496582 
	C2107.737793,1668.769287 2106.247070,1671.304199 2104.562012,1674.433105 
	C2104.253174,1675.786377 2104.112793,1676.532104 2103.616211,1677.733398 
	C2103.104248,1678.553711 2102.948486,1678.918701 2102.450195,1679.770752 
	C2101.880859,1681.154663 2101.653564,1682.051270 2100.959717,1683.472900 
	C2095.237793,1696.017456 2089.301270,1707.697510 2082.543457,1719.743408 
	C2082.132324,1720.313965 2081.981934,1721.269409 2081.660645,1721.630737 
	C2078.086914,1726.849365 2076.171143,1732.442993 2072.552490,1737.865723 
	C2071.889160,1739.739990 2071.585449,1741.045532 2071.181152,1743.018799 
	C2071.630859,1745.631348 2070.527588,1746.989380 2068.958984,1748.787476 
	C2067.059326,1750.098145 2065.553467,1750.886108 2064.276855,1752.877441 
	C2063.234619,1754.512451 2062.687012,1755.767090 2061.636475,1757.503540 
	C2059.789307,1760.394043 2058.571289,1762.876709 2056.516846,1765.660522 
	C2056.012695,1766.536377 2055.940674,1766.874268 2055.516357,1767.592407 
	C2054.476074,1769.117310 2053.749023,1770.235474 2052.525391,1771.822266 
	C2052.149170,1772.373291 2051.961914,1773.306519 2051.631836,1773.649414 
	C2049.782715,1776.317505 2048.608398,1778.853638 2046.511230,1781.631348 
	C2045.983643,1782.504150 2045.899414,1782.841797 2045.445312,1783.547852 
	C2044.520386,1784.601685 2043.802979,1784.917603 2042.461182,1784.436035 
	C2037.208740,1784.265991 2039.091064,1778.601685 2036.370728,1777.311646 
	C2034.753418,1777.320557 2034.374023,1778.302979 2034.242798,1779.274780 
	C2032.839233,1789.663330 2029.918091,1792.364746 2020.159668,1789.477783 
	C2010.864624,1786.727661 2001.088745,1786.360596 1992.037720,1783.432373 
	C1978.365479,1779.009277 1964.369995,1776.424316 1950.292969,1774.607300 
	C1933.432129,1772.431030 1917.627563,1766.079102 1900.969971,1763.411621 
	C1874.507812,1759.174072 1848.841553,1751.178589 1822.202759,1747.501343 
	C1811.986816,1746.091309 1801.489136,1743.999878 1791.373901,1740.443970 
	C1781.500244,1736.972900 1770.629150,1736.453003 1760.343262,1734.015747 
	C1741.712891,1729.601685 1722.200195,1728.799072 1704.514160,1720.481567 
	C1702.182983,1719.385254 1699.108643,1720.893555 1697.092529,1718.513794 
	C1701.038452,1708.226318 1701.038452,1708.226318 1692.217529,1704.072266 
	C1707.375732,1686.535767 1723.247803,1669.309448 1738.278809,1650.432129 
	C1739.999634,1648.055664 1741.579834,1646.445557 1743.463257,1644.214844 
	C1744.367798,1642.658203 1744.884644,1641.653809 1745.915283,1640.383423 
	C1748.925415,1637.199951 1751.097168,1634.050537 1753.494019,1630.277344 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M2179.688477,1420.005005 
	C2173.576904,1424.314941 2174.941406,1431.063110 2174.475098,1436.381714 
	C2173.683838,1445.404907 2169.680664,1453.704468 2169.757812,1462.787842 
	C2169.784180,1465.865234 2167.405273,1467.208496 2164.647217,1468.120972 
	C2155.851074,1471.031006 2146.851807,1470.980957 2138.091797,1468.878540 
	C2126.506836,1466.098022 2114.846924,1463.640137 2103.617188,1459.224731 
	C2097.333496,1456.754028 2090.011963,1456.555054 2083.110107,1456.152710 
	C2078.282715,1455.871460 2074.373535,1454.972534 2070.360352,1451.839966 
	C2065.157959,1447.779053 2059.224609,1445.808838 2051.845947,1447.407349 
	C2044.432007,1449.013672 2036.747559,1447.109009 2029.962036,1443.156860 
	C2026.419556,1441.093628 2023.036743,1439.255981 2018.769043,1441.366089 
	C2016.647217,1442.415161 2014.140503,1442.270874 2011.893188,1441.599243 
	C1994.094604,1436.278687 1975.812012,1433.296509 1957.652832,1429.604736 
	C1946.411011,1427.319092 1935.485718,1423.158081 1923.925171,1421.992432 
	C1921.039551,1421.701538 1919.142700,1419.835693 1916.869507,1418.517578 
	C1913.939209,1416.818481 1911.130249,1415.914307 1907.450317,1417.056519 
	C1900.317139,1419.270386 1893.127808,1417.415405 1888.002563,1412.642700 
	C1880.880493,1406.010620 1873.656860,1409.976074 1866.430420,1410.624634 
	C1864.083008,1410.835571 1864.130737,1413.557861 1863.959595,1415.520020 
	C1863.528442,1420.464844 1860.021606,1420.310791 1856.643066,1419.679321 
	C1853.110107,1419.019043 1851.629150,1416.619141 1852.651367,1413.035645 
	C1853.360718,1410.549927 1855.119629,1407.951172 1850.766846,1406.121338 
	C1849.373657,1405.378296 1848.918213,1404.632324 1848.862793,1403.054932 
	C1849.004150,1401.374146 1849.027588,1400.358765 1849.411377,1398.661011 
	C1850.167603,1395.426147 1849.656006,1392.709229 1851.356445,1389.735840 
	C1851.598389,1387.162598 1851.638672,1385.210693 1851.932129,1382.565552 
	C1852.132568,1381.056885 1852.169189,1380.244995 1852.443970,1378.846558 
	C1851.861572,1371.888306 1854.338989,1365.852783 1854.877197,1358.783691 
	C1856.876587,1352.619873 1855.402344,1347.046875 1856.490723,1340.971924 
	C1856.733521,1337.405151 1856.782959,1334.496948 1857.167969,1330.780518 
	C1858.510986,1309.869385 1857.927368,1289.757935 1857.689453,1268.771973 
	C1857.156738,1264.961060 1856.760376,1262.027344 1856.536987,1258.369507 
	C1856.321045,1246.859619 1854.329712,1236.229248 1853.333008,1224.747559 
	C1852.837036,1223.068726 1852.598022,1222.119629 1852.489380,1220.439209 
	C1851.654785,1216.943970 1852.310669,1214.004395 1851.533447,1210.611816 
	C1851.054443,1209.077271 1850.739380,1208.133301 1850.520142,1206.439819 
	C1850.112549,1204.222778 1850.022705,1202.687622 1849.794189,1200.592773 
	C1849.378906,1199.051758 1849.042969,1198.080444 1848.810181,1196.336426 
	C1848.181763,1194.183838 1848.022949,1192.671509 1847.821045,1190.586670 
	C1847.300781,1188.456909 1846.852417,1186.892944 1846.502197,1184.508789 
	C1846.105225,1179.459351 1844.168579,1175.548950 1843.757812,1170.649414 
	C1843.268066,1169.109131 1842.875732,1168.198853 1842.541260,1166.535156 
	C1842.740234,1165.393066 1842.881592,1165.004272 1843.554565,1164.294922 
	C1849.960449,1167.573608 1854.238403,1172.247314 1853.982666,1179.644531 
	C1853.844116,1183.656128 1855.379517,1185.444824 1859.470337,1186.348389 
	C1866.591431,1187.920898 1873.981567,1188.666260 1880.855591,1190.521729 
	C1895.568359,1194.493164 1910.586792,1196.891113 1925.349487,1200.534912 
	C1944.936768,1205.369507 1964.766602,1209.660767 1984.561279,1213.148315 
	C2002.917969,1216.382202 2020.639648,1221.819946 2038.854614,1225.194946 
	C2058.403809,1228.816895 2077.696533,1233.726074 2097.181152,1237.315063 
	C2109.902100,1239.658203 2122.522705,1242.240845 2135.002930,1245.470337 
	C2144.273193,1247.869263 2154.136963,1247.344849 2163.044434,1251.650146 
	C2165.219971,1252.701782 2168.296875,1251.892456 2170.959229,1251.933594 
	C2174.230957,1251.984131 2175.855713,1250.356201 2175.939941,1247.097900 
	C2176.035400,1243.425171 2175.737793,1239.531250 2181.229004,1238.101929 
	C2188.074219,1239.203247 2186.120361,1244.356445 2186.713867,1248.060059 
	C2187.567627,1253.389893 2185.590820,1259.074341 2189.078125,1264.936401 
	C2190.346191,1267.976196 2190.511963,1270.320679 2190.193359,1273.585938 
	C2187.764404,1290.775146 2188.898926,1307.134399 2189.619385,1324.328613 
	C2190.203125,1326.922363 2190.123291,1328.666016 2189.563721,1331.234375 
	C2185.164795,1345.293091 2185.593262,1359.147339 2184.266602,1372.720703 
	C2183.576416,1379.779663 2180.161133,1386.767334 2182.911377,1394.877197 
	C2183.284668,1396.211914 2183.432373,1396.747437 2183.604492,1398.116943 
	C2183.491699,1399.489624 2183.354492,1400.028442 2182.795410,1401.286133 
	C2182.127930,1402.345459 2181.882568,1402.685547 2181.247559,1403.520020 
	C2179.598877,1407.992798 2179.634521,1411.979492 2180.974609,1416.647705 
	C2181.166504,1418.292480 2180.897705,1419.187378 2179.688477,1420.005005 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2181.583496,1201.039917 
	C2181.424561,1198.669067 2181.453613,1197.088623 2181.183105,1194.770020 
	C2180.102051,1191.862915 2179.938232,1189.662354 2181.001953,1186.715820 
	C2191.253662,1186.983032 2199.613525,1184.899170 2206.435547,1176.864258 
	C2211.372070,1171.049683 2219.463135,1170.578979 2226.340088,1168.354004 
	C2238.521484,1164.412598 2248.001709,1157.267212 2254.750000,1146.440918 
	C2255.452148,1145.314331 2255.915527,1144.036255 2256.640869,1142.927246 
	C2261.923096,1134.853027 2271.496826,1131.488525 2280.665283,1134.217773 
	C2283.610107,1135.094604 2283.987305,1137.215698 2283.935547,1139.600220 
	C2283.844482,1143.803955 2285.165283,1147.500977 2287.829346,1150.639648 
	C2290.662598,1153.978149 2293.343262,1156.559326 2298.837646,1154.946777 
	C2305.788330,1152.907104 2307.583740,1154.921265 2307.986816,1162.333130 
	C2308.022949,1162.997070 2307.994629,1163.664551 2307.999512,1164.330322 
	C2308.058350,1172.234131 2302.752686,1176.810913 2295.020996,1175.604492 
	C2292.481689,1175.208252 2292.317139,1173.086670 2291.507568,1171.324951 
	C2290.136475,1168.340210 2289.156006,1164.574219 2285.194092,1164.320068 
	C2279.633789,1163.963623 2273.899658,1162.799683 2268.606201,1165.897827 
	C2266.194092,1167.309448 2265.953125,1169.587769 2266.029785,1171.951172 
	C2266.307129,1180.489014 2260.807373,1184.276733 2253.890625,1187.018311 
	C2250.832275,1188.230469 2248.838135,1187.721680 2247.825439,1184.299072 
	C2246.669434,1180.392212 2244.525635,1177.035522 2241.332520,1174.437622 
	C2237.942627,1171.679810 2231.683105,1171.090698 2228.241699,1173.210571 
	C2224.277344,1175.652710 2223.672852,1179.487061 2224.053711,1183.679810 
	C2224.854492,1192.497192 2229.998291,1196.580322 2238.640869,1194.666626 
	C2243.828125,1193.517944 2247.046631,1194.587158 2248.294189,1200.072998 
	C2249.844482,1206.889648 2255.496094,1209.441406 2261.197266,1211.311768 
	C2270.312256,1214.302246 2277.134521,1207.904175 2275.147949,1198.488037 
	C2274.117188,1193.601929 2272.207764,1188.644531 2276.984863,1184.692139 
	C2285.895020,1177.319824 2291.353271,1178.593872 2295.510010,1189.620361 
	C2298.216797,1196.801147 2302.430420,1200.612549 2310.311035,1200.051147 
	C2313.588135,1199.817627 2316.961670,1199.668335 2319.330322,1202.935181 
	C2322.030273,1206.659424 2322.829834,1212.502563 2320.702637,1215.072144 
	C2317.769775,1218.615601 2309.278076,1219.203369 2305.061279,1215.833252 
	C2302.214844,1213.558350 2299.911377,1210.613525 2297.123047,1208.254761 
	C2291.027100,1203.098022 2282.672607,1203.805786 2277.688721,1209.781738 
	C2275.268066,1212.684082 2275.999756,1215.955078 2276.704346,1219.272705 
	C2278.971924,1229.949219 2278.343994,1231.048828 2268.270996,1234.236572 
	C2264.315186,1235.488281 2261.250488,1237.535889 2259.130615,1241.341064 
	C2255.398438,1248.040161 2250.210693,1251.987061 2241.917480,1249.046509 
	C2237.726807,1247.560791 2236.201904,1251.134644 2234.134277,1253.673218 
	C2229.805176,1258.988281 2228.149658,1258.811035 2226.140869,1252.003174 
	C2225.020752,1248.208008 2223.275879,1246.484863 2219.483887,1245.862549 
	C2213.962402,1244.956299 2211.909180,1241.131348 2211.980469,1235.781372 
	C2212.038330,1231.458862 2212.206055,1227.090332 2211.679932,1222.821655 
	C2211.215332,1219.050293 2207.177002,1216.808228 2205.457275,1219.118042 
	C2200.437256,1225.861328 2193.561279,1223.547852 2186.280762,1223.998047 
	C2181.815186,1216.989258 2182.007324,1209.375122 2181.583496,1201.039917 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1968.484131,711.947205 
	C1967.727905,710.447998 1967.139893,709.488831 1966.028564,708.289368 
	C1964.202881,706.189392 1962.601318,704.593750 1960.558594,702.484253 
	C1958.682251,700.024170 1957.276367,698.052185 1955.731201,695.499023 
	C1955.399292,690.251709 1958.074707,687.913940 1961.992432,685.901978 
	C1969.949341,681.815918 1969.924805,681.601929 1968.669434,673.214905 
	C1967.869629,667.870972 1970.133789,664.250549 1974.605957,661.775085 
	C1979.780029,658.911072 1986.030396,659.237488 1989.474121,662.679260 
	C1990.859131,664.063599 1991.814697,665.885559 1992.923950,667.536255 
	C1995.439331,671.279297 1998.971680,672.770935 2003.286621,671.722534 
	C2007.703369,670.649170 2009.907471,667.574890 2009.983887,663.002563 
	C2010.006226,661.672363 2009.954956,660.317017 2010.188232,659.018311 
	C2011.240723,653.159119 2014.730225,649.537964 2020.532471,648.245850 
	C2027.916870,646.601440 2032.879395,648.005737 2035.821289,654.133850 
	C2038.677002,660.082642 2042.355225,662.726257 2048.996094,662.086426 
	C2057.445557,661.272278 2061.293457,667.496887 2064.718750,673.705261 
	C2066.443359,676.830933 2066.807373,680.962402 2072.141357,679.670410 
	C2078.343750,678.167969 2081.894775,674.825500 2081.932617,669.166504 
	C2081.970947,663.434937 2081.888428,658.077820 2087.020264,653.824097 
	C2092.962158,648.898682 2097.075684,648.507568 2102.644775,653.690002 
	C2104.102051,655.046265 2105.512451,656.495117 2106.711426,658.077942 
	C2108.839600,660.887390 2107.891602,666.283630 2112.080811,666.881958 
	C2114.974854,667.295227 2118.375977,665.254456 2121.335449,663.855225 
	C2125.933350,661.681396 2128.499512,663.115112 2130.979980,667.367859 
	C2133.156982,671.100098 2135.633301,674.682373 2137.178467,678.715637 
	C2138.850830,683.081665 2137.934814,686.596313 2132.866943,688.029846 
	C2131.909912,688.300537 2131.006348,688.771790 2130.043457,689.008850 
	C2120.615723,691.330017 2115.984131,696.780823 2117.949707,706.891968 
	C2118.747803,710.998169 2116.924805,713.916870 2112.990479,715.580811 
	C2111.481445,716.219055 2110.234863,717.460266 2108.743164,718.158936 
	C2103.617676,720.559570 2101.279541,724.340454 2101.930908,730.119507 
	C2102.260742,733.046143 2102.131592,735.991333 2100.193848,738.699036 
	C2093.841797,747.574768 2084.571045,747.103149 2078.934570,737.394958 
	C2077.032959,734.120361 2077.524170,729.190735 2072.479248,728.153809 
	C2068.650879,727.367004 2065.234131,729.168457 2061.865723,730.382324 
	C2057.388672,731.995850 2054.811035,731.208435 2054.001953,726.274780 
	C2053.734863,724.645569 2053.187988,723.063904 2052.810791,721.450806 
	C2050.780273,712.770813 2052.243652,709.100342 2058.626221,706.812866 
	C2066.202393,704.097656 2073.825684,707.261475 2077.082275,714.142090 
	C2078.275879,716.664185 2076.881592,720.965820 2080.877930,721.538513 
	C2085.637451,722.220520 2090.166992,720.280884 2093.919189,717.598206 
	C2098.143311,714.578003 2096.020508,706.676147 2090.541260,704.709717 
	C2088.433838,703.953308 2085.906006,703.776794 2083.668945,704.076965 
	C2075.241455,705.207703 2070.462891,701.129089 2067.842773,693.635864 
	C2067.187988,691.763306 2066.362549,689.914124 2066.003906,687.982056 
	C2065.333008,684.366699 2063.307617,683.764221 2060.230225,684.930725 
	C2059.918945,685.048828 2059.615967,685.199463 2059.295654,685.282532 
	C2054.851807,686.434082 2050.494141,689.400024 2045.805786,687.441406 
	C2040.764648,685.335449 2041.424561,679.676941 2039.619385,675.563599 
	C2037.273926,670.219055 2035.552612,669.320374 2029.436646,670.468628 
	C2016.980347,672.807373 2016.839844,672.851501 2020.600464,684.806946 
	C2022.012329,689.295105 2022.959106,693.131409 2017.948120,695.996094 
	C2012.505249,699.107605 2004.775269,698.819519 2001.531982,694.917480 
	C1999.415527,692.371094 1997.699585,689.495605 1995.737549,686.816406 
	C1992.652832,682.604065 1988.391724,681.338196 1983.399902,682.110229 
	C1977.352783,683.045410 1974.441284,686.091919 1976.528564,691.665771 
	C1979.549438,699.733093 1976.336670,705.888916 1972.475586,712.966309 
	C1972.187134,713.591187 1971.337402,713.687134 1970.910400,713.707764 
	C1969.753052,713.491577 1969.136963,713.086426 1968.484131,711.947205 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2295.587402,1595.452148 
	C2293.521729,1601.747070 2291.333252,1607.400391 2291.753906,1614.014648 
	C2292.038818,1618.492065 2285.308105,1625.146729 2280.995117,1625.786255 
	C2277.225098,1626.345215 2273.521240,1626.185791 2272.100098,1620.738281 
	C2274.078613,1617.806152 2277.053467,1618.833496 2279.481201,1617.917236 
	C2282.577637,1616.748535 2284.442871,1614.591553 2284.213379,1611.153809 
	C2284.094971,1609.381104 2283.052734,1607.979492 2281.197510,1607.699951 
	C2278.044922,1607.225220 2276.335205,1609.220581 2275.021484,1611.693970 
	C2274.400146,1612.863770 2273.855469,1614.074707 2272.534912,1615.575562 
	C2266.855225,1611.694458 2266.449219,1606.965332 2271.149902,1603.593750 
	C2273.557373,1601.866821 2276.392822,1600.787720 2278.479248,1598.525757 
	C2281.587402,1595.156494 2283.250244,1586.793091 2281.595703,1582.699585 
	C2280.454102,1579.874756 2277.803467,1579.429810 2275.821533,1580.220825 
	C2263.964600,1584.953125 2257.913818,1577.985962 2252.304688,1568.606689 
	C2250.916260,1566.950439 2249.877930,1565.855347 2248.395508,1564.404541 
	C2243.409424,1564.092041 2238.780273,1564.361572 2234.456055,1560.571533 
	C2233.898682,1559.342773 2233.883301,1558.657959 2233.682129,1558.032959 
	C2232.467773,1554.261597 2230.371094,1550.332397 2234.544189,1547.119019 
	C2237.749268,1544.651001 2245.972412,1546.054443 2249.383545,1549.416260 
	C2249.849365,1549.875488 2250.080566,1550.571899 2250.543945,1551.035034 
	C2252.818848,1553.310669 2253.589355,1557.678589 2257.419678,1557.666870 
	C2262.019775,1557.652832 2266.519287,1556.147461 2270.826904,1554.415161 
	C2272.863281,1553.596313 2273.821045,1551.901367 2273.918457,1549.710449 
	C2273.992188,1548.048950 2273.905029,1546.348511 2274.233887,1544.735596 
	C2275.424805,1538.894043 2280.351318,1532.966797 2285.022949,1532.867188 
	C2290.529785,1532.749878 2295.338867,1534.779785 2298.127686,1540.197388 
	C2299.410645,1542.689819 2300.215820,1546.648193 2304.217529,1545.442017 
	C2308.360840,1544.193237 2314.056641,1544.219971 2313.985352,1536.760498 
	C2320.705566,1533.290039 2322.023193,1541.716919 2327.695801,1542.763184 
	C2330.696045,1545.884888 2330.451660,1549.327637 2330.845459,1552.577148 
	C2331.339600,1556.656982 2333.410156,1558.476807 2337.590820,1557.639160 
	C2341.965332,1556.762695 2342.458496,1553.930420 2341.679932,1550.172852 
	C2340.896973,1546.393921 2338.779297,1543.559937 2335.556396,1540.495728 
	C2334.003662,1534.911987 2336.456055,1531.025513 2339.500732,1526.583618 
	C2340.000000,1526.000000 2341.000000,1526.000000 2341.500000,1526.000000 
	C2343.251709,1525.868896 2344.344727,1526.261230 2345.665039,1527.504639 
	C2346.307373,1530.165039 2347.130615,1532.078613 2349.704346,1531.594238 
	C2352.667969,1531.036377 2355.397705,1529.776611 2357.152588,1527.079712 
	C2357.331787,1526.803833 2357.525635,1526.489990 2357.563232,1526.175903 
	C2358.192627,1520.891846 2358.467041,1515.480103 2363.694092,1512.189819 
	C2368.889648,1508.919678 2374.671387,1510.301636 2381.121582,1510.000000 
	C2385.949219,1513.490356 2387.009766,1517.674072 2384.511230,1523.294800 
	C2381.206787,1525.494385 2378.892334,1527.409180 2378.064453,1531.343018 
	C2376.052734,1535.942749 2372.635498,1538.941406 2370.457764,1543.515137 
	C2369.251465,1554.797363 2365.979736,1558.422729 2355.257080,1559.927124 
	C2352.080811,1560.372803 2348.293701,1559.434692 2348.030029,1565.212158 
	C2329.900879,1571.596558 2325.901855,1588.913940 2317.129883,1603.245117 
	C2316.261719,1604.124146 2315.822754,1604.378174 2314.691895,1604.316040 
	C2313.336182,1599.038452 2311.402100,1595.424561 2304.758301,1595.998535 
	C2301.956543,1593.915161 2303.032715,1591.645630 2303.669678,1589.454346 
	C2304.948242,1585.056396 2304.324219,1581.413818 2299.562988,1579.700439 
	C2296.205566,1578.492310 2292.666260,1578.601440 2290.579102,1581.852295 
	C2287.889404,1586.041382 2288.426514,1590.091797 2292.720947,1593.187012 
	C2293.530273,1593.770508 2294.389893,1594.284546 2295.587402,1595.452148 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2187.516113,1275.170654 
	C2187.370850,1272.066772 2187.455811,1269.820557 2187.237305,1266.779785 
	C2185.240967,1258.607178 2186.049072,1251.163452 2186.709961,1242.873779 
	C2189.327148,1242.180176 2192.404541,1241.376709 2193.275879,1243.990601 
	C2195.187500,1249.726562 2199.388672,1249.991455 2204.346436,1250.083008 
	C2213.275879,1250.248169 2216.077393,1254.413940 2213.346680,1262.892334 
	C2212.420654,1265.767090 2210.912842,1268.388550 2208.578125,1270.387695 
	C2202.704590,1275.417114 2198.936523,1281.366089 2199.947021,1289.494385 
	C2199.987305,1289.818970 2199.916504,1290.157349 2199.898926,1290.489258 
	C2199.720459,1293.875366 2196.108643,1297.517578 2200.180664,1300.570923 
	C2203.233887,1302.860229 2205.294189,1300.024414 2206.747803,1298.084106 
	C2209.336182,1294.628906 2216.511719,1292.762451 2211.464600,1286.206543 
	C2209.911621,1284.189331 2209.382568,1281.668213 2210.863037,1279.692383 
	C2212.798096,1277.109009 2215.607422,1278.043335 2218.137695,1279.138062 
	C2219.358398,1279.666260 2220.539062,1280.286621 2221.756348,1280.823364 
	C2226.067139,1282.723877 2228.423096,1281.293457 2229.982422,1276.824585 
	C2232.804688,1268.737183 2233.408447,1268.535400 2240.624756,1273.698853 
	C2244.409668,1276.406860 2248.626953,1276.001343 2252.227539,1277.291748 
	C2254.585938,1274.988525 2253.260498,1273.121826 2252.812256,1271.265869 
	C2252.237061,1268.883667 2253.470459,1267.407837 2255.472656,1266.586304 
	C2257.106201,1265.915894 2258.749512,1266.275513 2260.079834,1267.517944 
	C2261.701172,1269.032104 2262.105713,1270.827759 2261.295654,1272.928711 
	C2258.200195,1280.957397 2258.209961,1280.961182 2264.539062,1286.307861 
	C2268.750244,1289.865356 2268.768555,1290.746460 2264.691406,1294.718994 
	C2263.503906,1295.875854 2261.903320,1296.806641 2261.172363,1298.198608 
	C2258.406738,1303.465454 2255.881836,1299.118286 2252.633057,1298.096191 
	C2250.872314,1297.229614 2250.311279,1296.072510 2249.633301,1294.258301 
	C2249.056641,1292.479614 2248.490479,1291.458862 2246.604736,1290.934326 
	C2242.662109,1290.743896 2239.092041,1290.422607 2237.609131,1294.292358 
	C2236.173828,1298.036987 2237.553711,1301.388672 2240.171875,1304.196411 
	C2241.730957,1305.868408 2243.593994,1307.248535 2245.519043,1309.522705 
	C2249.160156,1312.220703 2252.799316,1313.862549 2254.093506,1318.076782 
	C2254.940186,1320.833618 2257.302490,1323.536377 2253.698242,1325.928589 
	C2250.458008,1328.079224 2247.093750,1328.901001 2243.575195,1326.362061 
	C2241.053955,1324.542603 2240.003906,1321.644897 2238.204834,1319.299561 
	C2234.785156,1314.841919 2230.904297,1313.167358 2225.367188,1315.786133 
	C2222.388672,1317.194946 2219.359863,1318.374023 2216.590576,1320.251587 
	C2213.297119,1322.484497 2210.924072,1324.857910 2212.669189,1329.191284 
	C2214.417480,1333.531860 2212.222900,1335.434937 2208.260742,1335.939331 
	C2204.663086,1336.397339 2201.400879,1338.525024 2196.812744,1337.997803 
	C2193.479004,1337.613892 2191.963135,1335.430908 2189.205566,1334.217896 
	C2188.331787,1333.698364 2187.997803,1333.463013 2187.283936,1332.747070 
	C2187.154785,1330.612061 2187.405518,1328.957642 2187.434082,1326.483887 
	C2188.809570,1309.134521 2187.862793,1292.577026 2187.516113,1275.170654 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2270.087402,1262.716797 
	C2271.592773,1258.069214 2275.492676,1258.235474 2278.341064,1256.789917 
	C2284.997070,1253.411865 2289.368164,1248.465088 2290.022217,1240.688477 
	C2290.279053,1237.634644 2288.593994,1233.161133 2293.281982,1232.435913 
	C2298.044678,1231.699097 2303.281494,1230.528320 2307.478027,1234.613770 
	C2307.715820,1234.845337 2308.036377,1235.057617 2308.146729,1235.344849 
	C2311.422852,1243.872559 2317.271729,1245.911743 2325.554443,1242.546631 
	C2328.036377,1241.538208 2330.083252,1242.948853 2331.431152,1245.119019 
	C2332.306152,1246.528198 2333.009277,1248.045044 2333.778809,1249.519165 
	C2339.297363,1260.089844 2339.307373,1260.165405 2351.760742,1258.376343 
	C2356.092285,1257.754150 2357.729736,1259.373535 2358.043457,1263.664917 
	C2358.767334,1273.558960 2355.824463,1277.104736 2347.687012,1275.978271 
	C2343.660156,1275.420898 2342.444092,1272.453125 2340.747314,1269.590332 
	C2335.915527,1261.438599 2331.022705,1259.917969 2322.566895,1263.749756 
	C2315.703857,1266.859619 2314.769287,1269.014771 2317.167725,1276.201416 
	C2319.867432,1284.290649 2319.867432,1284.290527 2311.811035,1287.078003 
	C2303.693115,1289.886475 2303.714600,1289.868408 2298.124756,1283.268066 
	C2296.838135,1281.748901 2295.423584,1280.317505 2293.939941,1278.989136 
	C2287.137451,1272.899048 2283.569336,1272.812744 2276.545166,1278.526489 
	C2275.516113,1279.363403 2274.667480,1280.420166 2273.646729,1281.268799 
	C2272.417969,1282.290283 2271.237305,1283.814087 2269.349854,1282.699707 
	C2268.048828,1281.931519 2268.056885,1280.489502 2268.043945,1279.177124 
	C2267.991211,1273.872192 2267.469482,1268.507202 2270.087402,1262.716797 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2143.540527,752.536255 
	C2148.540527,751.561523 2151.688232,753.699890 2153.702148,757.545532 
	C2155.235596,760.473633 2156.472656,763.556763 2157.920898,767.285461 
	C2157.005859,774.835510 2154.485596,780.147644 2146.313721,780.126709 
	C2143.490967,780.119507 2142.161377,781.832092 2142.083984,784.583435 
	C2142.055908,785.580261 2141.844482,786.613770 2142.032715,787.568115 
	C2143.727051,796.157654 2139.281982,800.938049 2131.719727,802.947998 
	C2125.545166,804.589172 2123.433594,807.396240 2125.788818,813.603210 
	C2126.559082,815.633301 2126.187256,818.253113 2125.830566,820.523438 
	C2124.973145,825.976501 2116.814453,832.456177 2112.166016,831.627930 
	C2107.992188,830.884399 2101.996582,822.599365 2102.098633,817.857422 
	C2102.153809,815.292358 2103.400391,813.399719 2105.274902,811.922791 
	C2107.093018,810.490295 2108.954102,808.973938 2111.041992,808.048035 
	C2117.848877,805.029297 2120.988770,800.557251 2120.223877,792.580444 
	C2119.539551,785.442444 2122.844727,782.291748 2130.194824,779.985168 
	C2137.094727,777.819824 2137.094971,777.819763 2134.803955,771.163269 
	C2131.787842,762.399353 2134.148438,757.239502 2143.540527,752.536255 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2045.560181,786.622314 
	C2051.360107,782.174500 2055.815918,777.087708 2062.268311,774.769836 
	C2065.775879,773.509827 2066.427490,770.871704 2064.841553,767.536316 
	C2064.278320,766.351746 2064.079102,764.998596 2063.663818,763.738831 
	C2060.857178,755.224976 2060.853027,755.226318 2051.576660,755.955566 
	C2041.118408,756.777649 2037.073364,752.889587 2038.029175,742.933960 
	C2038.479614,738.242432 2043.155640,733.718506 2048.727051,732.845093 
	C2053.075928,732.163391 2055.400635,734.889221 2057.160645,738.337036 
	C2058.066650,740.112183 2058.939209,741.905212 2059.876221,743.663696 
	C2062.088867,747.815735 2064.696289,750.795471 2070.137939,748.393066 
	C2071.827393,747.647217 2074.116699,747.828918 2076.042969,748.137695 
	C2080.372070,748.831543 2084.600830,749.924011 2085.822021,755.105835 
	C2087.246094,761.148560 2085.779053,766.370178 2081.167725,769.198181 
	C2077.254883,771.597717 2072.951416,773.359863 2068.474365,775.575378 
	C2069.477539,778.847595 2070.604004,781.943420 2071.369385,785.126038 
	C2073.944824,795.832092 2066.626709,803.583740 2055.844727,801.992981 
	C2049.463623,801.051514 2049.360596,795.121155 2046.292725,790.651245 
	C2045.239136,789.229919 2044.946289,788.310547 2045.560181,786.622314 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2143.440918,715.588135 
	C2144.499512,722.855103 2143.262695,729.035095 2136.625488,733.678284 
	C2131.944336,733.775391 2129.514160,735.340759 2130.123291,739.748718 
	C2130.437500,742.022278 2131.319092,744.212952 2131.707275,746.481628 
	C2133.004150,754.067627 2129.622559,759.446899 2122.260010,761.577454 
	C2120.298340,762.145203 2118.190918,762.216248 2116.500732,760.978333 
	C2111.796631,757.532532 2108.162109,753.280640 2108.068604,747.074951 
	C2107.980469,741.211914 2111.971191,738.331238 2116.660156,736.101746 
	C2124.658936,732.298096 2124.909180,732.087036 2123.092529,724.432312 
	C2122.153320,720.474609 2120.781982,716.548035 2124.284668,713.327271 
	C2127.432617,710.433167 2137.126953,710.343384 2140.951172,712.920715 
	C2141.742188,713.453735 2142.245850,714.413208 2143.440918,715.588135 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2065.408936,844.522522 
	C2062.550781,842.179749 2061.583984,839.531982 2060.182373,836.423523 
	C2058.833496,834.472351 2058.539795,832.976929 2059.513672,830.647583 
	C2061.575928,826.278076 2065.331055,825.010376 2068.360352,823.252258 
	C2073.697510,820.154785 2079.681152,821.838135 2081.367676,827.787048 
	C2083.528076,835.408875 2088.176758,836.755676 2094.734863,835.988220 
	C2100.461914,835.317932 2104.403320,838.126648 2107.018311,842.722290 
	C2109.576660,847.218079 2106.693359,851.144531 2104.469971,854.729004 
	C2100.045410,861.861694 2093.274658,861.574890 2089.179443,854.302307 
	C2088.202881,852.567810 2087.386475,850.744019 2086.464844,848.977661 
	C2082.476807,841.334534 2082.472656,841.336670 2072.691406,843.695984 
	C2070.218262,845.571167 2068.227539,845.977966 2065.408936,844.522522 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2149.627197,652.050354 
	C2148.273926,658.939270 2143.524170,661.870239 2138.095459,661.356079 
	C2132.723633,660.847168 2128.473389,657.418396 2127.788330,650.966614 
	C2127.177490,645.216614 2123.252441,643.698120 2117.827393,643.895935 
	C2113.014648,644.071350 2107.916504,645.142334 2103.789795,640.851196 
	C2099.353027,636.237549 2098.886230,631.103882 2103.122559,626.892456 
	C2108.854248,621.194458 2114.957275,621.059021 2119.173096,626.664368 
	C2120.960693,629.041382 2122.598633,631.558105 2124.054932,634.151367 
	C2126.411133,638.346680 2129.769531,640.372681 2134.644775,640.019470 
	C2142.852783,639.424683 2147.886719,643.152100 2149.627197,652.050354 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2316.056885,1604.576050 
	C2315.434570,1596.193604 2317.230957,1589.585083 2324.742188,1585.507446 
	C2327.857178,1583.816284 2328.981201,1580.528931 2329.789062,1577.271606 
	C2332.516846,1566.272339 2332.589111,1566.186646 2343.294922,1566.002319 
	C2344.288818,1565.985229 2345.283203,1566.000000 2347.138672,1566.000000 
	C2349.051270,1574.247192 2346.908691,1580.789673 2338.857666,1584.754883 
	C2333.466309,1587.410400 2333.554443,1592.717896 2334.064209,1597.682495 
	C2334.753906,1604.402100 2331.993408,1608.342163 2324.750000,1609.911621 
	C2322.391846,1609.502808 2320.783447,1609.005493 2318.587646,1608.254150 
	C2317.148193,1607.198486 2316.431152,1606.307495 2316.056885,1604.576050 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2166.753906,1107.255615 
	C2160.977783,1099.893066 2160.424561,1090.166870 2158.267334,1081.024048 
	C2151.716064,1053.257324 2143.292236,1026.093872 2133.771973,999.214905 
	C2129.248535,986.444397 2123.448486,974.123291 2120.233887,960.107483 
	C2120.334473,959.289490 2121.215088,959.334106 2121.655762,959.319580 
	C2122.487061,959.358398 2122.877930,959.411743 2122.989746,959.986755 
	C2128.143555,975.524292 2133.873047,990.440857 2138.949951,1005.576355 
	C2150.063477,1038.709351 2160.687500,1071.997559 2166.753906,1107.255615 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2262.103516,653.203369 
	C2259.158447,654.657654 2256.316650,655.317810 2252.737549,655.989014 
	C2245.413574,654.670288 2238.755859,648.365540 2238.145508,642.854004 
	C2237.873535,640.398132 2238.619141,638.232239 2240.507324,636.666931 
	C2242.266113,635.208862 2244.308350,634.095154 2246.084961,632.655884 
	C2249.100586,630.213074 2252.253906,625.939636 2256.174072,628.914368 
	C2259.838379,631.694824 2263.826416,635.207214 2264.011230,640.832214 
	C2264.143066,644.839905 2263.742920,648.695007 2262.103516,653.203369 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2075.725586,799.478394 
	C2078.863770,795.673157 2081.982178,793.716064 2086.483643,793.953979 
	C2094.687988,794.387695 2098.392334,798.707275 2097.987793,807.970947 
	C2097.720947,814.090027 2092.633301,818.176636 2085.797607,817.891235 
	C2082.818848,817.766907 2080.654785,816.188721 2079.266113,813.894165 
	C2076.722900,809.691650 2074.088379,805.394287 2075.725586,799.478394 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2528.776855,185.307098 
	C2523.315430,186.509659 2518.837402,186.024246 2514.776611,183.254257 
	C2508.172607,178.749405 2508.071777,171.477127 2514.543213,166.888031 
	C2519.864746,163.114410 2527.806641,162.927536 2530.972900,166.501297 
	C2535.410156,171.509415 2534.836182,178.804047 2528.776855,185.307098 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2339.314941,1525.925781 
	C2341.097412,1530.902222 2338.053955,1534.542847 2336.089844,1539.269775 
	C2334.612061,1542.774048 2332.264648,1544.145508 2328.642578,1544.296387 
	C2320.899170,1546.122070 2319.562988,1538.883179 2314.698730,1536.119385 
	C2314.000000,1533.222168 2314.000000,1530.444458 2314.000000,1526.833252 
	C2314.942383,1523.925171 2316.707031,1522.876587 2319.379395,1522.093262 
	C2320.888916,1521.999268 2321.777832,1521.998413 2323.333496,1521.996338 
	C2325.372559,1520.843750 2326.913086,1520.518677 2329.314209,1521.525391 
	C2333.575439,1521.716797 2335.415283,1525.322510 2339.314941,1525.925781 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2047.874023,701.965210 
	C2046.158325,710.178040 2039.758545,711.000854 2034.006958,711.689026 
	C2028.900024,712.300171 2026.815430,707.756042 2024.979126,703.786255 
	C2023.231934,700.009216 2024.078369,696.765259 2027.160034,693.954468 
	C2035.253052,686.572815 2043.174316,689.320435 2047.874023,701.965210 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2072.082520,618.711914 
	C2074.479736,615.469727 2076.619873,612.709534 2077.930176,608.670288 
	C2080.303711,608.001160 2082.610840,607.922546 2084.910400,608.019043 
	C2090.594482,608.257446 2094.906494,611.887695 2095.853271,617.130493 
	C2096.732422,621.996338 2094.761475,625.449463 2089.548828,628.175781 
	C2084.242920,630.950867 2080.092529,630.445801 2076.316162,626.036133 
	C2074.652588,624.093506 2072.684814,622.162598 2072.082520,618.711914 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2145.968750,627.942810 
	C2143.274414,624.044922 2140.093018,620.517761 2143.208496,616.646240 
	C2146.205566,612.921692 2151.125488,611.581970 2155.748291,612.449585 
	C2160.315674,613.306763 2164.552490,615.619812 2165.790039,620.864502 
	C2166.924072,625.669128 2164.899658,629.301208 2159.739990,632.084106 
	C2154.141846,635.103455 2152.155518,634.589966 2145.968750,627.942810 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2524.218994,214.770630 
	C2528.981689,208.306808 2532.273438,206.862930 2536.626953,208.593323 
	C2541.323975,210.460266 2546.478271,218.517624 2545.829102,222.978241 
	C2544.901367,229.350937 2535.841309,232.475189 2529.736328,228.410080 
	C2525.181396,225.377197 2523.142822,221.089050 2524.218994,214.770630 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2553.916748,251.409531 
	C2559.526123,257.607147 2556.657227,263.108734 2553.537842,268.111572 
	C2550.847412,272.426544 2543.809082,273.202972 2540.453857,270.265015 
	C2535.261475,265.718323 2534.411133,257.686432 2538.689453,253.737686 
	C2542.986572,249.771576 2547.882080,248.975174 2553.916748,251.409531 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2410.237305,288.370483 
	C2411.860352,287.777039 2412.782471,287.424835 2413.727051,287.151978 
	C2418.705811,285.713959 2421.854248,288.697235 2424.610840,292.009094 
	C2427.309326,295.251038 2424.617920,298.139038 2423.474854,301.109985 
	C2421.903809,305.192017 2418.428223,306.931396 2414.785645,308.575287 
	C2412.321289,309.687378 2409.707520,310.810883 2407.360840,308.965881 
	C2404.599121,306.794250 2403.346191,303.524109 2404.409912,300.150024 
	C2405.668213,296.159363 2406.083740,291.688660 2410.237305,288.370483 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2356.029785,533.358765 
	C2351.674561,531.718628 2349.960938,528.494568 2348.705078,525.042603 
	C2347.015381,520.400024 2348.706543,516.088623 2352.239502,513.533752 
	C2355.201172,511.392059 2359.045654,509.140137 2363.277100,510.918365 
	C2366.569092,512.301880 2370.157959,518.833618 2369.887451,522.485657 
	C2369.728516,524.628967 2368.793457,526.345398 2366.966309,527.375061 
	C2363.523682,529.314819 2360.692627,532.296326 2356.029785,533.358765 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2495.282227,148.086121 
	C2502.679932,147.399063 2505.147705,151.857498 2507.474609,157.557434 
	C2507.959717,158.986420 2508.169434,160.067703 2507.839355,160.946274 
	C2505.306152,167.692444 2497.009521,171.829788 2491.218994,169.326630 
	C2485.699707,166.940765 2484.665283,160.446335 2488.688477,153.074905 
	C2489.987793,150.694717 2491.787842,148.825134 2495.282227,148.086121 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2319.543457,1521.470215 
	C2319.070312,1524.076660 2317.618652,1525.519165 2314.640137,1525.942139 
	C2311.504883,1522.422852 2308.383789,1523.100098 2304.561523,1523.729614 
	C2296.618164,1525.037842 2292.468994,1521.781738 2292.035889,1515.122559 
	C2291.662842,1509.385986 2294.054199,1506.628784 2299.871582,1506.087646 
	C2305.771240,1505.538940 2311.902100,1508.852539 2313.609619,1514.863525 
	C2314.579102,1518.276001 2316.246338,1519.825806 2319.543457,1521.470215 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2467.476074,262.457672 
	C2463.048828,254.774490 2463.622559,251.809860 2469.586670,248.239029 
	C2475.412109,244.751266 2479.619873,245.508072 2483.208008,250.689148 
	C2486.951172,256.094116 2486.312012,263.395294 2481.807129,266.690582 
	C2478.310547,269.248383 2473.907959,268.071899 2467.476074,262.457672 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2324.106689,267.428925 
	C2329.297852,272.166718 2330.951416,276.984344 2327.978271,282.983551 
	C2326.067139,286.839447 2322.873535,288.026123 2319.035156,287.785675 
	C2314.185791,287.481842 2308.128662,280.155548 2308.246094,275.085602 
	C2308.333740,271.291473 2313.720947,266.497009 2318.678711,266.111145 
	C2320.249268,265.988922 2321.881836,266.662262 2324.106689,267.428925 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2402.882812,554.545166 
	C2404.425049,551.576477 2405.374268,548.989807 2407.080566,547.079773 
	C2410.099121,543.700806 2416.668945,543.030396 2419.801758,545.321228 
	C2424.091797,548.458374 2424.976318,555.534363 2421.698975,560.494873 
	C2418.648926,565.111389 2413.593262,566.617310 2408.950928,564.444214 
	C2404.991211,562.590515 2402.957275,559.523987 2402.882812,554.545166 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2076.513672,639.828064 
	C2080.095215,646.764893 2076.119385,651.291138 2072.751953,655.666443 
	C2070.204102,658.976685 2065.927979,658.662720 2061.102295,655.448181 
	C2057.598633,653.114258 2055.013672,650.532898 2057.165283,645.622803 
	C2060.767578,637.402771 2068.443359,634.642151 2076.513672,639.828064 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1983.281860,707.611389 
	C1990.006470,701.415833 1992.826538,701.109375 1998.118774,705.360962 
	C2001.846558,708.355957 2003.486450,716.713501 2001.170166,720.913147 
	C1999.024902,724.802673 1990.846680,725.471436 1986.971191,721.699768 
	C1983.271118,718.098694 1980.758301,713.813232 1983.281860,707.611389 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2171.963867,586.017822 
	C2180.509277,588.309387 2182.556396,590.640198 2181.906982,596.414368 
	C2181.301758,601.800049 2177.080322,605.875122 2172.113770,605.868713 
	C2168.001221,605.863403 2160.857666,600.471497 2160.149902,596.838196 
	C2159.120117,591.552734 2161.158203,588.838318 2168.191406,586.324951 
	C2169.098389,586.000732 2170.160645,586.109802 2171.963867,586.017822 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2192.591309,638.969727 
	C2191.734375,641.175049 2191.435547,642.911804 2190.496338,644.170959 
	C2186.027832,650.163025 2180.009521,651.796082 2176.415039,648.193054 
	C2171.593994,643.360474 2170.889160,636.191223 2174.849121,632.266968 
	C2180.541260,626.626282 2186.806396,626.878540 2191.823975,632.877441 
	C2193.214600,634.539917 2193.849365,636.223389 2192.591309,638.969727 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2325.941406,533.749756 
	C2325.747559,536.236084 2325.112061,537.768433 2323.873779,538.955322 
	C2320.946045,541.761475 2317.558105,544.845703 2313.434326,543.254517 
	C2308.612305,541.393799 2305.582764,537.038269 2304.459229,531.958191 
	C2303.587402,528.015503 2306.745117,525.965332 2309.625977,524.264526 
	C2313.173584,522.170166 2316.947998,520.678101 2320.698242,523.883850 
	C2323.494873,526.274658 2326.286377,528.746765 2325.941406,533.749756 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2448.152832,508.557312 
	C2442.574463,511.205566 2439.082764,509.220642 2436.781494,504.876831 
	C2434.738037,501.019714 2436.052979,494.883850 2439.161865,491.991302 
	C2442.936035,488.479889 2449.645020,486.962555 2453.008789,488.859741 
	C2456.124268,490.616882 2457.384277,497.542847 2454.841064,501.517944 
	C2453.258301,503.992096 2450.826172,505.922913 2448.152832,508.557312 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2438.446533,517.826111 
	C2439.915527,520.481140 2441.341553,522.499512 2441.678467,524.685669 
	C2442.270996,528.535583 2442.941162,532.663025 2438.117188,534.870544 
	C2433.316650,537.067383 2428.625000,536.086060 2424.829102,531.776794 
	C2421.569580,528.076538 2421.106445,523.257996 2423.603516,519.027771 
	C2426.071289,514.846985 2429.392578,513.663757 2434.475830,515.337402 
	C2435.700439,515.740601 2436.771484,516.609985 2438.446533,517.826111 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2305.998535,631.218628 
	C2304.737305,638.977905 2299.504150,640.972900 2292.740234,641.987915 
	C2291.702881,641.062561 2291.661621,639.903259 2291.070312,639.221069 
	C2283.155029,630.090881 2286.271729,621.516357 2298.423096,618.892456 
	C2300.786621,618.382141 2302.235107,619.255676 2303.394531,621.048157 
	C2305.237061,623.897034 2306.284180,626.987732 2305.998535,631.218628 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2183.085938,1402.018799 
	C2182.291992,1401.639526 2182.210938,1401.273804 2182.321777,1400.380005 
	C2182.872314,1399.118042 2182.936523,1398.353516 2182.579346,1396.987427 
	C2182.180176,1395.179077 2182.350830,1394.003418 2183.333740,1392.442627 
	C2188.363525,1392.014526 2192.989746,1391.783691 2197.576904,1392.107788 
	C2202.451660,1392.452148 2207.560303,1397.156128 2207.834229,1401.260498 
	C2208.182129,1406.475220 2204.443359,1408.649902 2200.528809,1410.711548 
	C2197.266357,1412.429810 2195.197510,1411.520020 2193.085449,1408.588135 
	C2190.825195,1405.449951 2188.400879,1402.063965 2183.085938,1402.018799 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2464.588867,460.596100 
	C2467.002930,462.459167 2469.021973,463.785309 2470.282959,465.629852 
	C2473.859863,470.862457 2472.243652,476.354858 2466.440186,479.733887 
	C2461.735840,482.472992 2457.086914,481.079437 2454.050781,476.014313 
	C2453.882812,475.733765 2453.771729,475.419830 2453.622803,475.127167 
	C2448.741943,465.520569 2452.501221,460.067169 2464.588867,460.596100 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2205.269531,617.164246 
	C2201.332031,619.160706 2198.327881,621.477783 2194.581055,621.840515 
	C2192.302734,622.061035 2189.199951,622.396118 2188.649902,619.612610 
	C2187.700684,614.808411 2186.672363,609.682068 2190.006836,605.226013 
	C2193.040771,601.171387 2198.915771,599.446472 2202.175781,601.446228 
	C2207.853027,604.928894 2208.835449,608.944519 2205.269531,617.164246 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2326.950195,255.408386 
	C2323.513916,250.747864 2324.224121,246.859512 2326.567871,242.746536 
	C2330.729980,235.441940 2333.636963,234.744385 2339.396484,240.479584 
	C2342.787109,243.855896 2348.272949,247.014664 2345.063721,252.866440 
	C2342.148926,258.181458 2336.409180,258.452667 2330.916992,257.737640 
	C2329.697754,257.578888 2328.582764,256.621399 2326.950195,255.408386 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2465.126465,223.806351 
	C2461.076172,223.711609 2457.578369,224.963028 2454.723633,222.483688 
	C2451.646973,219.811813 2451.818848,213.112045 2454.976807,208.598236 
	C2457.437744,205.080872 2462.896484,203.352798 2466.271484,205.605347 
	C2469.680176,207.880249 2474.198975,209.288040 2474.054199,214.976273 
	C2473.910645,220.609299 2470.088623,222.147186 2465.126465,223.806351 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2514.009033,422.303223 
	C2519.752441,418.495789 2524.280273,420.414917 2528.385986,423.674042 
	C2531.589844,426.217346 2534.314453,429.725372 2533.399170,433.910675 
	C2532.411377,438.426239 2527.962402,439.450256 2523.957520,439.855133 
	C2519.325928,440.323425 2515.347412,438.777802 2513.256104,434.225494 
	C2511.515625,430.436707 2511.265137,426.563995 2514.009033,422.303223 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2344.433838,301.954529 
	C2341.145752,301.785370 2339.462158,300.229034 2337.685791,298.690979 
	C2334.302979,295.761536 2333.037109,292.036255 2334.478271,287.984772 
	C2335.979248,283.765839 2339.980713,282.188354 2344.061035,282.258484 
	C2348.088379,282.327698 2351.742920,283.906555 2353.713379,288.022919 
	C2357.421143,295.767273 2354.539551,300.569489 2344.433838,301.954529 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2526.663574,299.209351 
	C2525.071533,297.901611 2523.971436,297.100067 2523.150391,296.075134 
	C2519.156982,291.089630 2518.931396,286.401611 2522.407715,282.750824 
	C2525.471680,279.533203 2532.434082,278.926910 2536.214844,281.548340 
	C2540.250000,284.346008 2541.437256,291.267700 2538.683105,295.937073 
	C2536.025635,300.441772 2533.138672,301.372650 2526.663574,299.209351 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2384.844482,1524.000000 
	C2384.727539,1519.640625 2382.442871,1515.758057 2382.016846,1510.789307 
	C2382.351318,1505.391357 2385.188721,1503.907959 2389.393311,1504.039429 
	C2396.137695,1504.250610 2402.839111,1510.573730 2403.324219,1517.252075 
	C2403.495361,1519.605957 2402.065186,1520.865845 2400.127441,1521.657715 
	C2395.501465,1523.547852 2390.694092,1524.405151 2384.844482,1524.000000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2500.430176,211.271103 
	C2497.684326,208.231079 2497.856201,205.205063 2498.087891,202.264084 
	C2498.517822,196.806290 2501.761230,192.932831 2506.121826,192.367432 
	C2509.678223,191.906311 2516.066162,195.627441 2517.299316,199.226303 
	C2518.901123,203.900940 2516.988281,207.460068 2513.248779,210.357819 
	C2509.410156,213.332458 2505.617432,215.851593 2500.430176,211.271103 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2021.381592,739.772339 
	C2014.860718,739.983459 2012.597046,735.804626 2010.901611,731.406860 
	C2009.579590,727.977417 2008.795044,724.211121 2012.861694,721.710693 
	C2016.580566,719.424133 2020.153076,717.328735 2024.738647,720.323669 
	C2031.812378,724.943848 2032.735229,730.388245 2026.843140,736.097107 
	C2025.439331,737.457214 2023.705811,738.477234 2021.381592,739.772339 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2485.398926,236.364960 
	C2481.421387,232.296524 2481.026367,228.265411 2483.323242,224.098297 
	C2486.242676,218.802628 2493.504150,216.389008 2497.591553,219.120682 
	C2501.574463,221.782578 2502.840088,228.496063 2500.271729,233.339401 
	C2496.970215,239.566422 2492.607666,240.653015 2485.398926,236.364960 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2499.780273,484.680511 
	C2500.058105,488.125427 2499.953857,490.587158 2497.286133,492.352814 
	C2494.279053,494.343109 2491.559326,496.820709 2487.910156,497.583008 
	C2487.014893,497.770050 2485.928955,497.575317 2485.053467,497.237762 
	C2480.226807,495.376740 2478.340576,487.537933 2481.254883,481.710999 
	C2483.844238,476.533447 2488.283936,475.145233 2493.534668,477.802856 
	C2496.261230,479.182861 2498.479736,481.017822 2499.780273,484.680511 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2394.038574,512.055420 
	C2392.790527,503.925934 2394.070801,500.383972 2398.201904,499.030518 
	C2402.154053,497.735748 2408.947266,500.911743 2411.618164,505.303162 
	C2414.146484,509.460144 2413.308838,513.920227 2409.314697,517.564392 
	C2404.482178,521.973572 2399.804443,520.461792 2394.038574,512.055420 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2223.931641,584.198608 
	C2221.539062,592.153442 2215.552979,595.688049 2209.140381,593.751526 
	C2204.987549,592.497498 2201.961182,584.484497 2204.561523,580.201843 
	C2206.897461,576.354675 2211.192871,574.869324 2215.470215,574.208801 
	C2219.449951,573.594116 2221.406006,576.391663 2222.728760,579.643677 
	C2223.220947,580.853638 2223.516602,582.143555 2223.931641,584.198608 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2024.453979,780.541992 
	C2022.628540,778.953491 2021.427246,777.845825 2019.740723,776.348633 
	C2018.871094,775.292725 2018.605225,774.581055 2018.522461,773.263428 
	C2020.560303,771.855713 2021.239258,770.076294 2022.216797,768.340088 
	C2025.626831,762.283386 2033.057129,759.972412 2037.708862,763.264587 
	C2042.521606,766.670837 2042.710571,772.484680 2038.104736,778.736450 
	C2037.348022,779.763489 2036.199463,780.501953 2034.616089,781.686890 
	C2030.814087,783.609070 2027.880859,782.912537 2024.453979,780.541992 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2404.128418,588.558594 
	C2395.442627,590.109253 2391.866699,588.734253 2390.350342,583.970764 
	C2388.943848,579.552612 2391.405518,573.968201 2396.096924,571.332886 
	C2399.485107,569.429688 2403.383545,569.005737 2406.522217,571.091309 
	C2410.214844,573.545105 2410.519287,577.828674 2409.620117,581.915588 
	C2409.023193,584.630005 2406.690186,586.266724 2404.128418,588.558594 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2360.736816,254.214142 
	C2368.375000,255.206177 2370.713135,257.132202 2371.760010,262.529602 
	C2372.691895,267.333862 2370.689941,271.650299 2366.748047,273.336365 
	C2362.802246,275.024139 2355.185547,273.150482 2353.211914,269.580444 
	C2351.114502,265.787048 2351.404053,261.914734 2354.518311,258.572723 
	C2356.102295,256.872833 2357.681396,255.151093 2360.736816,254.214142 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2142.038574,699.946899 
	C2139.555908,691.223328 2141.543457,687.024719 2148.510498,684.838867 
	C2153.566162,683.252686 2159.635986,687.096436 2161.311035,692.846802 
	C2161.800293,694.526917 2161.828613,696.070801 2160.904785,697.567200 
	C2157.112305,703.711121 2148.864990,705.075745 2142.038574,699.946899 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2443.566895,1631.468140 
	C2451.450684,1626.949585 2454.743652,1627.118164 2457.739502,1631.615723 
	C2460.898193,1636.357666 2460.693848,1642.303711 2457.274902,1645.143677 
	C2453.728516,1648.089355 2447.305176,1648.885498 2444.283691,1646.754028 
	C2440.086182,1643.792725 2439.600342,1638.149658 2443.566895,1631.468140 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2367.092285,588.684631 
	C2367.003662,597.762512 2360.587158,600.869080 2354.178711,603.462646 
	C2350.805908,604.827637 2346.780273,600.932922 2346.099121,596.597107 
	C2345.129150,590.421997 2350.441650,584.428894 2357.161133,584.001099 
	C2361.059570,583.752747 2364.397705,584.647278 2367.092285,588.684631 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2413.587891,232.552216 
	C2409.107422,225.021805 2410.359131,219.714706 2416.886475,216.864670 
	C2420.395996,215.332275 2423.969727,215.475906 2427.053223,218.210022 
	C2430.842041,221.569397 2430.547363,225.976791 2429.461426,230.131821 
	C2428.587158,233.475922 2425.919922,235.580307 2422.202393,235.923126 
	C2419.062988,236.212662 2416.314209,235.501389 2413.587891,232.552216 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2446.311279,249.941971 
	C2438.537354,246.982132 2437.073975,245.079834 2438.246582,240.477310 
	C2439.356201,236.123047 2446.652832,229.922516 2450.391602,230.142029 
	C2454.970459,230.410873 2456.303223,234.015656 2457.412109,237.434341 
	C2458.709961,241.436661 2458.201416,245.239777 2454.629150,248.182129 
	C2452.375000,250.038574 2449.769287,249.990616 2446.311279,249.941971 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2447.255615,459.206451 
	C2440.101807,467.801147 2433.259766,468.431824 2428.500244,461.620972 
	C2424.329590,455.652740 2427.396729,448.866791 2434.638428,448.040985 
	C2443.333252,447.049438 2445.490967,448.796967 2447.255615,459.206451 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2223.804199,564.525513 
	C2215.922607,555.961853 2216.189209,553.313965 2224.794922,548.175232 
	C2230.313965,544.879700 2233.853271,545.632935 2237.315918,550.840088 
	C2240.477051,555.593933 2239.577148,560.382324 2234.649170,563.548401 
	C2231.544434,565.543030 2228.171875,566.996826 2223.804199,564.525513 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2451.266113,534.754395 
	C2461.478516,530.606995 2465.147217,531.575378 2467.911865,538.978943 
	C2469.223389,542.490967 2471.867432,546.453186 2466.703369,549.424866 
	C2461.124512,552.635193 2457.265137,552.445007 2453.312256,548.238647 
	C2449.813477,544.515808 2446.427002,540.604980 2451.266113,534.754395 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2454.914062,291.317993 
	C2448.633057,281.982697 2450.662842,275.210052 2459.358887,274.132751 
	C2462.817627,273.704285 2465.962891,274.233368 2467.834473,277.776184 
	C2469.937256,281.756866 2471.219727,285.829315 2468.590576,289.972504 
	C2466.412842,293.404419 2463.183838,294.755829 2459.163086,293.390076 
	C2457.916748,292.966766 2456.754639,292.296143 2454.914062,291.317993 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2245.377441,663.683289 
	C2245.926758,679.315552 2244.927002,680.023926 2230.299561,675.120850 
	C2229.370850,674.809631 2228.443359,674.496033 2226.757568,674.091797 
	C2226.000000,673.668518 2225.971924,673.334229 2226.004395,673.005920 
	C2226.468506,668.316284 2224.237061,662.775574 2230.323730,659.889221 
	C2236.115723,657.142761 2240.395752,660.342651 2245.377441,663.683289 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2161.533203,674.699097 
	C2156.379883,670.255920 2154.690674,665.579285 2156.579346,661.638367 
	C2158.314453,658.018005 2161.697754,656.143616 2165.449219,656.450500 
	C2169.999512,656.822693 2173.341064,659.589050 2174.979004,664.069336 
	C2177.725098,671.581055 2172.162109,676.382874 2161.533203,674.699097 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2551.783203,335.318451 
	C2550.683105,338.635468 2548.753418,340.458496 2546.707520,342.090637 
	C2542.970215,345.071930 2539.494873,344.270966 2536.163574,341.160980 
	C2533.054932,338.258850 2531.018066,335.406982 2533.518311,330.896729 
	C2536.114990,326.212250 2541.825684,321.408661 2544.779297,322.850250 
	C2549.412842,325.111450 2552.677002,328.751160 2551.783203,335.318451 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2360.711914,1169.181641 
	C2359.864502,1165.093994 2360.216797,1162.367920 2364.419922,1162.094360 
	C2365.406738,1162.030151 2366.397949,1162.038696 2367.386719,1162.002441 
	C2377.446777,1161.634521 2380.250244,1165.167236 2377.787354,1175.111450 
	C2376.655518,1179.681519 2373.066895,1182.184570 2368.294922,1181.943848 
	C2363.656494,1181.709961 2362.111816,1178.982788 2361.942871,1174.784058 
	C2361.877930,1173.168335 2361.322510,1171.572510 2360.711914,1169.181641 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2310.789551,615.403687 
	C2308.376953,615.911133 2306.297119,616.228638 2305.383301,614.813965 
	C2302.864258,610.915833 2303.708496,606.398438 2304.385742,602.243286 
	C2305.373779,596.182129 2309.164551,593.301514 2313.819092,594.324158 
	C2317.697754,595.176331 2320.323730,597.569702 2321.476074,601.394958 
	C2322.657959,605.319580 2321.405518,608.790588 2318.496338,611.316162 
	C2316.541260,613.013245 2313.879150,613.895508 2310.789551,615.403687 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2401.875977,333.928467 
	C2399.061035,333.987091 2397.113037,333.692139 2395.520020,332.297089 
	C2392.234863,329.420135 2388.774170,326.566864 2390.577148,321.420624 
	C2391.778564,317.991760 2397.767822,314.215149 2401.737549,314.116638 
	C2405.278564,314.028778 2407.105713,316.112762 2408.460205,319.018372 
	C2410.232666,322.821259 2410.922607,326.607361 2408.366455,330.307892 
	C2407.010254,332.271271 2405.149414,333.633484 2401.875977,333.928467 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2167.930176,809.862793 
	C2163.770020,818.012756 2159.010010,819.862122 2153.088135,816.432190 
	C2149.589600,814.406128 2147.853271,811.240173 2148.202148,807.372681 
	C2148.596436,803.001465 2151.875732,800.361267 2155.482666,798.633362 
	C2158.903564,796.994629 2161.798828,798.760071 2164.313477,801.300110 
	C2166.486084,803.494690 2168.226562,805.786560 2167.930176,809.862793 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2275.213135,553.272278 
	C2269.621826,554.349304 2267.311523,550.708740 2265.165527,547.552673 
	C2262.571045,543.737122 2263.923584,538.739624 2267.558838,536.288940 
	C2272.246826,533.128540 2278.244629,533.288025 2281.094482,536.648743 
	C2284.519531,540.687683 2284.879395,545.688965 2281.583496,549.158569 
	C2280.048828,550.774170 2277.823975,551.734192 2275.213135,553.272278 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2381.826172,486.250427 
	C2386.693115,488.861877 2389.520020,492.178741 2387.098145,497.032776 
	C2384.884033,501.469635 2380.621826,503.734344 2375.672852,503.788239 
	C2372.209717,503.825958 2369.422607,502.080383 2367.532227,498.925476 
	C2365.594238,495.691193 2367.267578,493.145905 2368.839600,490.650604 
	C2372.148438,485.398682 2374.517334,484.587738 2381.826172,486.250427 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2067.751953,342.649292 
	C2066.610596,352.077240 2064.088867,354.491211 2056.882324,353.969879 
	C2051.455566,353.577332 2045.865356,347.610382 2046.318726,342.694244 
	C2046.614990,339.479858 2052.767334,335.577454 2057.546875,336.489929 
	C2061.240723,337.195099 2065.710938,337.404694 2067.751953,342.649292 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2380.534668,229.351898 
	C2384.972656,232.519989 2386.982666,235.839294 2384.648926,240.641464 
	C2382.982178,244.071365 2375.515869,249.389145 2372.238770,249.331375 
	C2370.332764,249.297745 2369.307129,248.072479 2368.417725,246.660324 
	C2365.979492,242.789291 2365.166504,238.847565 2367.719238,234.638107 
	C2370.530762,230.002625 2374.156494,227.297989 2380.534668,229.351898 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2396.808105,259.350983 
	C2393.364746,254.372238 2394.627441,250.419693 2398.187500,247.347321 
	C2400.895508,245.010498 2404.095459,243.233765 2408.152832,245.060593 
	C2412.100830,246.838318 2415.073975,249.583939 2415.206299,253.793747 
	C2415.323242,257.511505 2412.997070,260.436493 2409.417725,262.303040 
	C2404.595947,264.817383 2400.579834,264.418396 2396.808105,259.350983 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2470.557129,1659.511475 
	C2465.700195,1651.277832 2466.414795,1647.265869 2472.575439,1644.822510 
	C2477.083496,1643.034668 2482.273682,1643.922852 2484.243896,1646.819336 
	C2486.813721,1650.597046 2486.609863,1657.974731 2483.860596,1660.696655 
	C2480.230469,1664.290527 2476.656250,1664.107422 2470.557129,1659.511475 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2360.425049,1113.563232 
	C2359.666748,1113.996216 2359.333252,1113.997192 2358.500000,1113.999146 
	C2354.571289,1113.999512 2351.142578,1113.998901 2346.856934,1113.996704 
	C2343.489502,1108.917725 2342.498535,1104.004150 2347.488770,1099.702148 
	C2355.461914,1092.828857 2361.879150,1095.206299 2365.910156,1107.248291 
	C2364.271484,1109.695312 2362.568359,1111.420776 2360.425049,1113.563232 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2340.930664,559.201172 
	C2337.282471,556.784119 2335.939941,554.024841 2335.972412,550.355530 
	C2336.022705,544.651123 2339.487793,540.479919 2344.709473,540.276123 
	C2349.567383,540.086548 2356.063721,546.556824 2355.695801,551.239685 
	C2355.493164,553.820068 2353.775391,555.485168 2351.852539,556.789246 
	C2348.805664,558.855835 2345.586670,560.677612 2340.930664,559.201172 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2323.928955,1174.044434 
	C2326.831543,1172.279297 2329.029541,1170.791870 2331.329102,1169.483643 
	C2332.124756,1169.031250 2333.173584,1169.024048 2334.826172,1168.651245 
	C2335.834717,1173.518066 2336.916260,1178.205566 2337.708984,1182.941406 
	C2337.902344,1184.097412 2337.473877,1185.654175 2336.765137,1186.604004 
	C2335.216553,1188.678345 2322.518799,1190.120605 2320.793701,1188.638550 
	C2316.711670,1185.131592 2317.587158,1180.083740 2323.928955,1174.044434 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2247.400879,607.525085 
	C2242.503174,611.316467 2238.659424,610.310425 2235.610352,606.306335 
	C2233.204834,603.147095 2230.894775,599.768127 2233.363525,595.403748 
	C2235.594238,591.460510 2239.052002,590.138245 2243.313965,590.033630 
	C2247.288574,589.936096 2249.181885,592.330933 2250.758301,595.540955 
	C2253.069092,600.247009 2251.625977,603.854187 2247.400879,607.525085 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2423.389160,474.244690 
	C2429.120605,476.625305 2430.952637,480.573395 2429.617676,485.652435 
	C2428.435059,490.152039 2424.301514,491.170929 2420.398926,491.851593 
	C2415.521484,492.702209 2412.403564,490.136444 2410.018311,486.064728 
	C2407.983643,482.590912 2408.416748,479.904022 2411.626221,477.569489 
	C2414.904053,475.185272 2418.424561,473.592560 2423.389160,474.244690 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2395.427246,274.580688 
	C2397.998291,277.278687 2398.239746,279.930603 2397.859619,282.609192 
	C2397.197266,287.276154 2391.706299,292.115265 2387.578125,291.871643 
	C2383.536377,291.633057 2378.447021,285.904114 2378.296875,281.424377 
	C2378.178711,277.892975 2383.125977,272.725067 2387.401367,272.137268 
	C2390.082275,271.768677 2392.732422,272.005829 2395.427246,274.580688 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2136.058838,254.287811 
	C2136.854492,248.651291 2139.500977,244.888535 2143.252197,241.949814 
	C2146.910400,239.083969 2151.867920,239.345917 2155.102295,242.251434 
	C2162.612061,248.997375 2161.131348,259.765991 2152.119629,263.942291 
	C2143.181152,268.084686 2138.850098,265.695557 2136.058838,254.287811 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2251.594971,1291.605103 
	C2252.000000,1293.500000 2252.000000,1295.000000 2252.000000,1297.250000 
	C2252.250977,1302.753906 2246.861084,1304.401611 2246.074707,1309.312744 
	C2238.937744,1309.016846 2234.881836,1305.013062 2234.072021,1297.913452 
	C2233.263184,1290.823608 2235.153320,1288.617920 2242.384766,1288.023926 
	C2243.680420,1287.917358 2244.991699,1288.002930 2247.147949,1288.000000 
	C2249.050049,1289.083252 2250.126465,1290.140259 2251.594971,1291.605103 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2173.456543,1467.666748 
	C2173.132324,1464.041504 2173.649658,1460.539307 2174.549805,1456.402832 
	C2176.585938,1455.974243 2178.501465,1456.091675 2179.378906,1457.579712 
	C2182.439209,1462.770874 2186.892334,1464.604858 2192.747803,1464.075317 
	C2195.910889,1463.789307 2198.807129,1464.757935 2199.621826,1468.355713 
	C2200.292725,1471.317749 2200.537598,1474.537842 2197.809082,1476.600220 
	C2194.746094,1478.915161 2191.848633,1477.623047 2188.674561,1475.888794 
	C2183.845947,1473.250366 2180.682861,1467.608521 2173.456543,1467.666748 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2513.173096,492.721802 
	C2516.848877,491.894867 2519.699707,491.728455 2522.421875,493.603363 
	C2527.768799,497.285736 2528.859619,500.933472 2525.896240,506.123413 
	C2522.865479,511.431671 2518.830811,513.187012 2514.574707,511.049164 
	C2509.291016,508.395050 2507.045166,503.204346 2509.182861,497.910614 
	C2509.897705,496.139893 2511.354736,494.668884 2513.173096,492.721802 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2249.565430,567.736938 
	C2253.020508,563.488098 2257.083008,563.571045 2261.031250,564.262207 
	C2265.818115,565.100220 2268.345703,570.428589 2266.461914,574.951599 
	C2264.407471,579.883118 2258.067139,584.351013 2254.197510,583.593811 
	C2249.840576,582.741272 2247.776611,576.612183 2249.565430,567.736938 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2226.665283,635.958435 
	C2221.741943,635.620972 2219.258057,632.789917 2217.269531,629.754639 
	C2214.412598,625.393127 2216.306152,619.135010 2220.762939,616.885742 
	C2225.649902,614.419373 2230.459717,616.465332 2232.863525,621.830566 
	C2234.150635,624.703552 2233.895996,627.663208 2233.978516,630.640381 
	C2234.106689,635.266052 2231.259766,636.167969 2226.665283,635.958435 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2412.249023,1618.944946 
	C2413.630615,1617.111328 2414.716064,1615.788940 2416.109131,1615.031982 
	C2419.847900,1613.000122 2423.852783,1610.082520 2427.589111,1614.802490 
	C2430.268799,1618.187622 2432.511719,1622.092773 2430.515625,1626.586304 
	C2428.695068,1630.683594 2425.025146,1632.210205 2420.698730,1631.748901 
	C2415.395264,1631.183472 2412.763672,1628.006714 2412.033447,1621.698853 
	C2411.958252,1621.048340 2412.068604,1620.376221 2412.249023,1618.944946 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2282.745850,578.209595 
	C2290.965820,579.245850 2293.942383,581.557983 2293.870605,586.129639 
	C2293.804443,590.335876 2288.518799,596.659546 2284.146973,597.634583 
	C2281.404785,598.245972 2278.725830,598.024597 2277.023682,595.465576 
	C2275.197998,592.720337 2273.254639,589.905212 2274.920166,586.279419 
	C2276.471680,582.901489 2278.253174,579.764893 2282.745850,578.209595 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2201.998535,685.203491 
	C2200.124268,689.411621 2197.718262,692.062012 2192.705566,691.992065 
	C2190.225342,690.545898 2188.328857,689.214844 2186.705078,687.608154 
	C2184.419189,685.346497 2180.872803,683.152283 2182.685791,679.379639 
	C2184.549805,675.500732 2187.497559,672.304382 2192.475098,672.015503 
	C2196.802246,671.764404 2199.184326,673.921570 2200.806641,677.637634 
	C2201.770508,679.845947 2202.006348,682.079895 2201.998535,685.203491 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2362.082031,560.141479 
	C2366.040283,553.487061 2371.055664,552.467041 2376.612305,556.390808 
	C2380.517090,559.148193 2381.338135,566.476318 2378.200439,570.564026 
	C2374.350830,575.579224 2367.821533,575.007935 2364.686523,569.309021 
	C2363.260986,566.718079 2361.844971,564.072693 2362.082031,560.141479 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2140.557129,845.745850 
	C2135.968994,843.367371 2132.595703,840.809753 2132.044922,835.912659 
	C2131.393799,830.123291 2133.718994,826.903198 2139.270508,826.120178 
	C2144.502441,825.382324 2148.700439,828.117371 2149.808594,832.986023 
	C2151.371582,839.852966 2149.182861,843.180908 2140.557129,845.745850 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2487.194336,191.348297 
	C2480.347656,196.926544 2478.643799,197.088165 2474.206055,193.156769 
	C2470.157471,189.570099 2468.797607,184.573776 2470.865479,180.883484 
	C2472.580566,177.822952 2478.751709,175.338959 2482.108154,176.358215 
	C2486.272949,177.622986 2489.468750,183.064117 2488.844971,188.069275 
	C2488.729492,188.994827 2488.028076,189.847427 2487.194336,191.348297 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2425.402588,260.927246 
	C2428.334229,260.376221 2430.685547,259.874969 2432.890137,260.245209 
	C2437.165527,260.963165 2441.817871,266.862030 2441.743652,270.903870 
	C2441.684814,274.087372 2436.882324,278.992432 2432.977783,279.195709 
	C2428.167480,279.446228 2425.197754,276.631897 2423.210693,272.384064 
	C2421.286621,268.271881 2422.143066,264.746643 2425.402588,260.927246 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2259.604980,613.607849 
	C2268.336670,605.778687 2275.310547,606.657837 2278.611816,615.357178 
	C2279.943359,618.866882 2278.117432,623.890869 2274.722900,625.287537 
	C2270.743896,626.924744 2266.913574,625.857178 2263.491699,623.647156 
	C2260.145508,621.486023 2256.667969,619.143188 2259.604980,613.607849 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2217.718750,648.830078 
	C2220.970947,658.224731 2220.491943,660.884949 2215.786377,663.003662 
	C2211.101562,665.113159 2205.913818,663.864380 2203.403320,660.023071 
	C2201.072754,656.457092 2201.580811,649.700500 2204.373535,647.120911 
	C2208.236572,643.552551 2211.468018,643.836853 2217.718750,648.830078 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2399.473633,202.637054 
	C2401.424316,204.768295 2401.894043,206.629211 2401.972168,208.675323 
	C2402.232178,215.479340 2398.926514,220.023605 2393.769531,219.866287 
	C2388.765137,219.713638 2383.588135,213.420288 2384.073242,208.079453 
	C2384.597656,202.307892 2388.694336,199.430450 2395.440918,200.323410 
	C2396.653076,200.483856 2397.756592,201.463898 2399.473633,202.637054 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2136.035645,602.198608 
	C2138.691895,611.649597 2137.943115,613.956238 2132.274170,615.593872 
	C2127.234863,617.049561 2122.027588,615.723022 2119.615967,612.331909 
	C2117.408203,609.227356 2117.662354,606.230957 2119.908203,603.203308 
	C2123.442871,598.438538 2127.407959,596.944519 2132.857666,598.830811 
	C2133.971436,599.216248 2134.748047,600.574768 2136.035645,602.198608 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2096.720703,783.600220 
	C2092.143311,776.160583 2092.454346,771.177734 2097.074219,768.763855 
	C2102.306641,766.029968 2109.090820,768.674561 2112.178467,774.326904 
	C2113.921143,777.517090 2113.597412,780.064453 2110.731934,782.095642 
	C2106.630371,785.002747 2102.424072,787.964111 2096.720703,783.600220 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2513.918457,1671.291992 
	C2511.861572,1682.105469 2506.549072,1684.219360 2496.636719,1678.327637 
	C2496.006348,1675.728516 2496.065186,1673.455688 2496.007568,1671.185791 
	C2495.905518,1667.158813 2497.760010,1664.228882 2501.313721,1662.665771 
	C2505.192627,1660.959717 2508.162109,1662.950806 2510.746582,1665.751221 
	C2512.070068,1667.185303 2513.482666,1668.540039 2513.918457,1671.291992 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2322.531982,568.630737 
	C2332.012939,564.824036 2336.704102,566.929382 2337.775635,574.650513 
	C2338.480469,579.729187 2334.603516,585.074097 2329.803955,585.640381 
	C2324.908447,586.218140 2320.280518,582.030762 2320.033447,576.719299 
	C2319.908691,574.036011 2319.969971,571.356323 2322.531982,568.630737 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2106.650879,315.083679 
	C2102.334961,303.856018 2107.903809,294.718353 2118.510254,294.294403 
	C2124.956787,294.036713 2132.137695,305.208221 2129.146240,311.108948 
	C2126.739746,315.855438 2122.192383,317.748505 2117.364990,319.295197 
	C2112.881836,320.731659 2109.688721,319.262085 2106.650879,315.083679 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2394.372559,349.596191 
	C2394.987793,356.608948 2390.386963,361.974945 2384.929199,361.742676 
	C2380.869629,361.569916 2374.319092,355.087463 2374.293945,351.217804 
	C2374.270752,347.662231 2378.050293,344.278259 2382.410645,344.070862 
	C2387.019775,343.851593 2390.700195,345.902344 2394.372559,349.596191 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2528.704590,468.386902 
	C2533.333740,465.296326 2537.502686,464.670532 2540.908691,468.572571 
	C2543.046875,471.021790 2544.693115,474.064240 2543.085938,477.708527 
	C2541.529297,481.238739 2539.629883,483.966309 2535.151855,484.034302 
	C2530.877930,484.099182 2527.121826,483.399017 2524.981934,479.338837 
	C2522.670898,474.953156 2524.994385,471.758392 2528.704590,468.386902 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2434.396729,575.256165 
	C2430.914062,565.651855 2435.208740,558.935669 2444.336670,558.336304 
	C2448.164307,558.084900 2452.927490,564.397095 2451.476318,568.310364 
	C2450.172852,571.826111 2447.204102,574.134216 2443.972656,575.975708 
	C2440.930420,577.709351 2437.884766,578.825928 2434.396729,575.256165 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2476.108887,561.821533 
	C2473.431885,556.871399 2473.025146,553.011780 2477.906738,550.090881 
	C2482.460938,547.366028 2487.406738,547.456238 2490.723145,550.839355 
	C2493.405518,553.575806 2494.942627,556.974304 2493.271240,560.773010 
	C2491.660400,564.433167 2488.617188,566.171265 2484.494629,565.965881 
	C2481.358154,565.809570 2478.738525,564.647827 2476.108887,561.821533 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2510.843262,250.940247 
	C2510.339844,249.561935 2510.124023,248.909317 2510.121582,248.255875 
	C2510.093506,240.908218 2511.971436,237.189102 2516.410400,236.330612 
	C2522.102051,235.229858 2524.859375,239.418869 2527.461182,243.202225 
	C2530.708252,247.923798 2528.979736,252.692459 2523.462646,253.626755 
	C2519.384277,254.317398 2514.812256,255.299820 2510.843262,250.940247 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2340.178711,354.362732 
	C2350.096924,358.217377 2352.386719,363.594055 2347.426758,369.502869 
	C2343.218750,374.515808 2338.625977,375.281647 2334.763916,371.614319 
	C2331.136475,368.169739 2330.733154,360.801758 2334.276611,357.306274 
	C2335.618652,355.982452 2337.688232,355.395844 2340.178711,354.362732 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2114.915527,882.731018 
	C2119.785889,885.814331 2120.993652,889.800720 2119.440430,894.253418 
	C2118.107422,898.074524 2114.357178,899.402893 2110.732910,899.763428 
	C2106.461914,900.188232 2103.206543,898.134033 2101.149658,894.200500 
	C2098.928467,889.953247 2101.588379,887.493896 2104.172363,884.826599 
	C2107.049805,881.856384 2110.481689,881.647156 2114.915527,882.731018 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2178.205322,564.841003 
	C2180.978516,559.614502 2184.619629,557.275330 2189.882568,559.036499 
	C2194.855225,560.700562 2196.826904,564.195496 2195.826416,569.048767 
	C2194.998535,573.064392 2189.516113,577.893738 2185.745361,577.262207 
	C2181.638428,576.574402 2178.131348,574.642029 2178.054199,569.609924 
	C2178.033691,568.281128 2178.069336,566.951599 2178.205322,564.841003 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2426.225586,330.307220 
	C2431.218262,329.604523 2433.732910,332.357635 2435.969482,335.169067 
	C2439.520020,339.632050 2438.055176,344.660400 2432.416260,348.360809 
	C2428.752197,350.765289 2424.329590,349.426666 2421.691895,345.114471 
	C2418.420410,339.766327 2419.790771,334.436371 2426.225586,330.307220 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2193.235840,1345.511963 
	C2196.680420,1348.877197 2199.124512,1351.944214 2200.693359,1355.572510 
	C2203.707520,1362.543213 2202.085449,1365.866089 2194.777588,1367.899658 
	C2192.264893,1368.598633 2189.725098,1369.199585 2186.409180,1369.920288 
	C2181.440430,1362.310913 2187.091797,1355.004395 2186.929443,1346.670410 
	C2188.906250,1344.614380 2190.622559,1344.425903 2193.235840,1345.511963 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2160.524414,415.518707 
	C2157.438965,412.356323 2154.350830,409.702698 2157.592773,405.725220 
	C2160.134277,402.606812 2163.239502,400.006531 2167.726562,401.024017 
	C2171.784668,401.944214 2175.551270,406.924072 2175.885498,411.295959 
	C2176.237305,415.897949 2173.055664,417.559875 2169.617188,419.122223 
	C2165.711182,420.897125 2163.423096,418.392700 2160.524414,415.518707 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2225.464111,292.594849 
	C2231.761719,291.464081 2236.832275,291.624207 2239.070312,298.218384 
	C2240.087891,301.217590 2240.633545,304.216125 2238.015869,306.455658 
	C2235.532959,308.579773 2232.731934,310.373322 2229.024414,309.385986 
	C2221.040771,307.259705 2219.266113,300.550049 2225.464111,292.594849 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2497.307861,280.269714 
	C2494.319092,277.497375 2493.882568,274.626343 2494.011230,271.517975 
	C2494.257324,265.585114 2497.421143,262.983612 2503.077393,264.191528 
	C2508.001221,265.243011 2510.019043,269.188660 2511.395508,273.310547 
	C2512.865723,277.712830 2509.137451,279.896637 2506.487061,282.258759 
	C2503.174316,285.211212 2500.383301,283.409454 2497.307861,280.269714 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2188.383545,1345.266357 
	C2186.962646,1353.436768 2186.156250,1360.865845 2185.485352,1369.145020 
	C2184.898438,1376.776489 2184.175781,1383.557983 2183.603516,1391.170288 
	C2183.536865,1393.203613 2183.319092,1394.405884 2183.385742,1396.161377 
	C2183.525879,1397.329590 2183.381592,1397.944702 2182.347656,1398.232910 
	C2178.712891,1393.626343 2179.668457,1388.785400 2180.214600,1384.383301 
	C2182.199219,1368.377441 2183.845459,1352.367676 2184.037598,1336.229736 
	C2184.054199,1334.839600 2184.469727,1333.656738 2186.222900,1332.502686 
	C2186.904053,1332.266479 2187.700928,1332.097046 2188.086426,1331.965332 
	C2191.251465,1335.956055 2191.630127,1340.178101 2188.383545,1345.266357 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2507.986084,1590.025879 
	C2515.083984,1591.990845 2518.891602,1597.453369 2517.380371,1602.721558 
	C2516.530029,1605.685791 2514.833496,1607.855103 2511.191650,1608.006714 
	C2506.544434,1608.200073 2502.653076,1607.195679 2500.645508,1602.618286 
	C2498.357178,1597.400757 2500.857666,1592.734985 2507.986084,1590.025879 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2374.067627,1562.218750 
	C2374.333740,1558.933960 2375.670654,1557.060913 2377.619629,1555.682007 
	C2381.652344,1552.828491 2387.118408,1553.582886 2390.097168,1557.288574 
	C2393.064209,1560.979614 2392.566895,1566.714966 2389.009521,1569.834351 
	C2385.432129,1572.971558 2379.988037,1572.723511 2376.441895,1569.297485 
	C2374.649414,1567.565796 2373.972656,1565.440430 2374.067627,1562.218750 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2463.421875,334.065613 
	C2461.903564,329.614044 2460.439453,325.319977 2464.047119,322.514526 
	C2466.849365,320.335602 2470.043213,316.843719 2474.540771,319.729065 
	C2478.737305,322.421417 2480.808105,326.877075 2479.474854,330.535950 
	C2477.839355,335.023010 2472.160400,338.591339 2467.836670,337.484161 
	C2466.379395,337.110992 2465.196777,335.664612 2463.421875,334.065613 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2134.370117,584.652954 
	C2134.048828,583.004028 2133.947998,581.973694 2134.168701,581.017334 
	C2137.148193,568.096252 2138.651611,567.441956 2151.254639,573.905884 
	C2151.999756,574.655945 2152.025635,575.310730 2151.995605,575.962830 
	C2151.453369,587.716187 2145.448730,590.965759 2134.370117,584.652954 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2472.844238,504.727539 
	C2481.620117,506.371643 2484.873047,513.611511 2480.550049,520.061523 
	C2478.546387,523.050964 2475.695801,524.152893 2472.093994,523.928162 
	C2468.004150,523.672974 2467.830322,520.287415 2466.959229,517.683167 
	C2464.805908,511.245575 2465.643066,509.459229 2472.844238,504.727539 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2316.738281,388.747162 
	C2317.860596,386.649292 2318.395264,384.847351 2319.601074,383.901276 
	C2322.665771,381.497131 2325.860596,378.622589 2330.191162,381.487213 
	C2333.425293,383.626343 2335.203369,389.108490 2333.687012,393.055145 
	C2332.068604,397.267303 2327.801758,399.304047 2324.279541,399.020660 
	C2319.498047,398.635925 2316.296875,394.906250 2316.738281,388.747162 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2186.881348,1241.225342 
	C2187.210693,1249.416992 2187.348633,1256.819214 2187.210205,1265.103271 
	C2183.126709,1264.620850 2184.199707,1261.325928 2184.007812,1258.546509 
	C2183.562988,1252.100952 2184.938477,1245.573608 2182.564941,1238.590332 
	C2181.719238,1229.426636 2182.651367,1220.843018 2180.277588,1212.325562 
	C2179.349121,1208.993164 2180.357178,1205.121094 2180.939209,1200.872070 
	C2184.952393,1207.259399 2182.863037,1215.172363 2185.154053,1223.207520 
	C2184.417725,1229.588135 2186.402588,1234.943726 2186.881348,1241.225342 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2128.000000,242.000610 
	C2125.431396,242.641861 2122.894775,243.573685 2120.287109,243.862503 
	C2114.858887,244.463745 2110.299072,240.372971 2110.290039,235.225540 
	C2110.283203,231.339752 2114.326660,228.539215 2119.461670,227.914719 
	C2123.988037,227.364227 2126.830566,230.529602 2131.250732,231.903687 
	C2132.000000,232.889328 2132.000000,233.778061 2132.000000,235.333328 
	C2131.830078,238.244400 2130.278320,239.642426 2128.430664,241.561798 
	C2128.000000,242.000610 2128.000000,242.000000 2128.000000,242.000610 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2181.214844,1185.208740 
	C2181.431152,1188.169189 2181.402100,1190.328979 2181.128174,1193.260254 
	C2179.627686,1193.492310 2178.408447,1192.805664 2178.241943,1191.322998 
	C2176.210449,1173.228638 2173.893555,1155.180786 2170.091309,1137.351196 
	C2169.830566,1136.128296 2170.349854,1134.739014 2170.954102,1132.851807 
	C2176.440430,1143.575806 2176.278076,1155.946167 2178.650879,1167.793091 
	C2179.747070,1173.266602 2180.216064,1178.865845 2181.214844,1185.208740 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2430.174805,1589.792969 
	C2437.559082,1584.686646 2441.571045,1585.163818 2445.347900,1590.890747 
	C2448.071289,1595.020386 2447.797607,1598.574463 2444.536621,1601.421997 
	C2440.968506,1604.538086 2436.077881,1604.847900 2432.934082,1601.702881 
	C2429.888184,1598.655762 2426.986084,1595.268066 2430.174805,1589.792969 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2322.810059,325.353333 
	C2321.811768,323.216858 2320.560547,321.611359 2320.740234,320.186371 
	C2321.304688,315.713043 2323.474365,311.628174 2328.014648,310.554901 
	C2332.663086,309.455963 2335.058350,313.627136 2337.078613,316.888855 
	C2339.390625,320.621674 2337.876709,325.922028 2334.349121,328.359070 
	C2329.842773,331.472595 2326.290771,329.719025 2322.810059,325.353333 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2281.753418,289.501495 
	C2279.882324,295.068481 2276.826416,298.509857 2271.365723,297.348816 
	C2267.900146,296.612030 2264.477295,294.860291 2264.062500,290.342255 
	C2263.694824,286.332062 2264.916748,283.005646 2268.451904,281.119354 
	C2271.841797,279.310547 2275.463867,279.359070 2278.670410,281.884857 
	C2280.859863,283.609406 2282.129639,285.837891 2281.753418,289.501495 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2448.061035,320.460327 
	C2446.194580,321.294342 2444.936523,321.834015 2443.656250,321.892975 
	C2439.851074,322.068207 2436.044434,321.426239 2434.504883,317.494141 
	C2432.862793,313.301178 2434.859375,309.878021 2438.039307,306.938049 
	C2441.044678,304.159088 2444.232422,302.969177 2447.870117,305.303558 
	C2451.263672,307.481262 2452.825195,310.680023 2451.417236,314.695648 
	C2450.770020,316.541260 2449.594727,318.201813 2448.061035,320.460327 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2278.797119,326.667908 
	C2281.656006,322.923553 2284.683105,320.966217 2288.680176,322.674713 
	C2291.927002,324.062439 2293.698242,326.705627 2293.991943,330.430298 
	C2294.501953,336.900452 2292.651855,339.578156 2286.976562,339.968384 
	C2280.416992,340.419403 2276.730225,337.225220 2276.845947,330.921814 
	C2276.868408,329.701996 2277.851318,328.499786 2278.797119,326.667908 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2311.119629,305.456238 
	C2309.837646,307.798401 2309.011230,309.636841 2307.739258,311.083282 
	C2305.033936,314.159576 2301.708008,314.886017 2298.073242,312.694305 
	C2294.499023,310.539093 2292.966309,305.441833 2294.569580,301.425323 
	C2295.921143,298.039429 2301.995117,293.679077 2304.618896,294.760681 
	C2308.900391,296.525757 2310.825928,300.282104 2311.119629,305.456238 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2464.247314,1619.933350 
	C2457.190430,1618.909546 2457.128906,1613.488037 2456.928955,1609.239502 
	C2456.787354,1606.234009 2458.879639,1602.872070 2462.832764,1602.210571 
	C2466.703857,1601.562744 2470.142334,1602.321655 2472.439941,1605.780151 
	C2474.655518,1609.115601 2474.662354,1612.667114 2472.562988,1616.029419 
	C2470.880371,1618.724609 2468.310303,1620.120728 2464.247314,1619.933350 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2152.678223,449.889648 
	C2150.429199,447.487518 2147.244873,448.131042 2144.604492,446.263855 
	C2144.055664,443.054840 2143.906494,440.087982 2144.214844,437.169556 
	C2144.678955,432.782715 2148.327148,431.389648 2151.783203,430.519470 
	C2156.091553,429.434723 2158.159668,433.134186 2160.452881,435.769318 
	C2162.902588,438.583954 2161.805420,441.350586 2159.365723,443.520386 
	C2157.186279,445.458740 2156.425781,448.730591 2152.678223,449.889648 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2359.480469,1584.034668 
	C2361.486816,1582.830078 2362.945557,1582.049438 2364.501953,1581.635742 
	C2369.605225,1580.279785 2373.841553,1583.072876 2375.093994,1588.488281 
	C2376.020508,1592.496094 2371.464844,1599.234619 2367.542480,1599.657349 
	C2364.037598,1600.035156 2358.546143,1595.328979 2358.097412,1591.347168 
	C2357.842529,1589.084106 2357.811279,1586.750854 2359.480469,1584.034668 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2515.648926,458.185120 
	C2515.090820,460.749725 2514.708252,462.756256 2513.698975,464.370972 
	C2511.704834,467.561401 2508.625000,470.348389 2504.887451,468.895050 
	C2501.340088,467.515686 2498.094727,464.557739 2498.177979,460.027557 
	C2498.268555,455.133423 2501.768066,452.276001 2505.688721,450.590851 
	C2509.575439,448.920258 2512.646729,450.865356 2514.327393,454.765778 
	C2514.716064,455.667389 2515.135986,456.555450 2515.648926,458.185120 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2557.380615,1655.684082 
	C2557.859619,1659.238892 2558.491211,1662.580322 2555.409424,1665.116333 
	C2549.063477,1670.338379 2543.369629,1668.328247 2540.013184,1658.758911 
	C2544.565674,1647.956421 2547.338867,1647.520996 2557.380615,1655.684082 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2324.280518,504.461670 
	C2330.862549,496.319092 2338.920898,496.263062 2342.677979,503.525574 
	C2344.263672,506.590515 2343.999756,509.102539 2341.116211,511.307098 
	C2334.072998,516.692078 2327.043457,514.211487 2324.280518,504.461670 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2383.122314,530.722412 
	C2385.154053,530.280151 2386.477783,530.008301 2387.778320,530.092224 
	C2392.497559,530.396973 2396.508301,532.453918 2397.166992,537.296509 
	C2397.722168,541.379028 2393.955078,543.848877 2390.719971,545.173401 
	C2387.108887,546.651794 2382.480713,547.362427 2379.666504,543.874756 
	C2376.652588,540.139771 2377.363770,535.841003 2380.868652,532.305908 
	C2381.330566,531.839966 2381.889404,531.470398 2383.122314,530.722412 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2530.771484,1620.745972 
	C2527.065674,1611.779785 2527.216797,1609.532837 2531.570557,1607.381470 
	C2535.681885,1605.350220 2539.771240,1605.128906 2543.428467,1608.576416 
	C2546.158936,1611.150391 2546.547119,1614.380127 2545.537354,1617.666016 
	C2544.582520,1620.772339 2538.068604,1623.484253 2533.829590,1622.768311 
	C2532.921875,1622.614868 2532.123535,1621.814819 2530.771484,1620.745972 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2282.064453,259.580750 
	C2284.401367,252.591522 2289.437744,250.162003 2294.684814,252.689697 
	C2298.357666,254.459076 2301.341797,262.121277 2299.539307,265.752563 
	C2298.269043,268.312317 2295.702393,270.214294 2293.072510,269.104736 
	C2288.727539,267.271637 2283.018799,266.665283 2282.064453,259.580750 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2219.395508,393.383667 
	C2219.363037,402.759033 2219.030029,403.280762 2213.416504,403.948761 
	C2206.204590,404.806976 2202.613037,402.879974 2200.795166,397.407196 
	C2199.969238,394.920868 2200.036377,392.274750 2202.386230,391.364899 
	C2205.987793,389.970520 2209.929199,389.283783 2213.789551,388.788788 
	C2216.380859,388.456512 2217.708252,390.820801 2219.395508,393.383667 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2307.528564,352.502319 
	C2302.701660,347.984100 2303.854736,344.485504 2307.989258,341.272217 
	C2312.536621,337.738464 2317.281738,337.357391 2320.559570,340.690643 
	C2323.181396,343.356689 2325.177979,346.464569 2322.404297,350.364380 
	C2319.052246,355.077850 2313.774902,356.087555 2307.528564,352.502319 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2389.682129,1599.590088 
	C2393.604736,1597.293945 2396.713135,1598.060913 2399.621582,1600.005127 
	C2403.333252,1602.486206 2404.576172,1606.628418 2402.752930,1610.291260 
	C2400.772217,1614.269897 2397.549072,1616.515015 2393.126709,1615.299683 
	C2389.193115,1614.218750 2385.834473,1612.120239 2385.995117,1607.071411 
	C2386.085205,1604.237793 2386.936035,1601.917480 2389.682129,1599.590088 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2163.751953,879.433167 
	C2162.432373,881.764587 2161.445312,883.562866 2160.011719,884.872559 
	C2156.015381,888.523438 2152.421143,888.833313 2149.510498,886.082397 
	C2146.350830,883.095947 2145.248291,877.457214 2147.188232,874.204346 
	C2149.586426,870.182861 2153.599854,869.163757 2158.452148,871.278687 
	C2161.717529,872.701965 2164.208496,874.641663 2163.751953,879.433167 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2453.510498,364.702759 
	C2451.752197,363.657135 2450.456787,363.125488 2449.600586,362.191528 
	C2446.317627,358.609955 2445.651123,354.740173 2448.858887,350.693359 
	C2451.584229,347.255035 2455.258789,347.391998 2458.725586,348.752533 
	C2462.411865,350.199127 2464.271240,353.311005 2463.935303,357.409027 
	C2463.538330,362.250458 2461.391113,365.516541 2456.046387,365.602325 
	C2455.426025,365.612274 2454.799072,365.231476 2453.510498,364.702759 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2100.742432,411.899170 
	C2096.338379,412.355957 2092.888916,411.487427 2088.757324,410.090973 
	C2088.021729,408.018951 2087.914307,406.027466 2088.091553,404.061615 
	C2088.499512,399.534485 2091.071533,396.810425 2095.522217,396.131409 
	C2099.907715,395.462311 2103.677002,397.021454 2105.191650,401.224060 
	C2106.680664,405.356354 2107.104004,409.824249 2100.742432,411.899170 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2377.311523,315.740417 
	C2375.525879,315.921082 2374.524414,316.083649 2373.560791,315.957642 
	C2366.376221,315.018250 2362.690674,310.710693 2364.230957,305.130310 
	C2365.266113,301.379028 2371.145264,298.940826 2375.810547,300.328003 
	C2381.102051,301.901367 2383.366943,307.239380 2380.990967,313.098999 
	C2380.566895,314.145844 2379.098877,314.769592 2377.311523,315.740417 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2546.268555,525.847717 
	C2539.897217,524.227295 2536.211914,520.902710 2536.073975,514.732300 
	C2535.973877,510.251801 2538.393066,508.093384 2542.831299,508.034607 
	C2546.963867,507.979889 2551.432373,507.966797 2551.734619,513.423828 
	C2551.988281,517.999268 2554.090820,523.788330 2546.268555,525.847717 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2193.912598,305.959717 
	C2195.645020,309.026825 2196.240723,311.406403 2194.897461,314.103271 
	C2192.999023,317.913940 2188.632080,320.470917 2185.391113,319.437469 
	C2181.538574,318.208984 2177.401123,312.202515 2178.281982,308.697693 
	C2179.371094,304.362732 2182.317627,302.129456 2186.850342,302.032104 
	C2189.665039,301.971680 2192.039307,302.721649 2193.912598,305.959717 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2307.308105,564.777466 
	C2304.659180,567.986694 2301.900146,569.753784 2298.400635,569.627563 
	C2294.389160,569.482910 2290.373047,565.837158 2290.139160,562.456665 
	C2289.887451,558.819275 2294.575439,552.590210 2298.251221,552.476196 
	C2302.382080,552.348083 2306.125977,553.940369 2307.577881,558.226685 
	C2308.172363,559.981384 2307.652588,562.113525 2307.308105,564.777466 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2049.656738,369.365509 
	C2049.866211,370.304443 2049.723389,370.605347 2049.599854,370.913879 
	C2044.817139,382.856049 2044.817261,382.856110 2032.707275,378.077209 
	C2032.000000,377.029877 2031.983521,376.059387 2032.002808,375.089661 
	C2032.227783,363.764954 2036.381958,361.191681 2046.380249,366.266266 
	C2047.489380,366.829224 2048.342041,367.897217 2049.656738,369.365509 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2492.224854,526.737366 
	C2494.325195,521.391052 2497.815186,519.394897 2502.681152,520.154968 
	C2506.708496,520.784058 2509.341797,523.264709 2509.792725,527.323853 
	C2510.261963,531.550293 2507.691406,534.237549 2504.000000,535.584961 
	C2497.402344,537.993103 2493.370117,535.159119 2492.224854,526.737366 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2187.217285,816.001587 
	C2191.898926,819.228821 2194.982178,822.851196 2194.000000,829.217590 
	C2190.217773,829.352295 2188.250732,834.824463 2184.138916,832.961548 
	C2180.174072,831.165344 2176.305664,829.155823 2176.156982,824.016235 
	C2176.026855,819.532532 2179.040283,817.262573 2187.217285,816.001587 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2456.254395,177.413605 
	C2454.668213,178.000000 2453.297852,177.792450 2452.011230,178.032501 
	C2445.720215,179.206116 2443.994385,175.427338 2443.058838,170.296555 
	C2442.129883,165.203476 2443.291748,161.277740 2446.791748,160.359863 
	C2451.143799,159.218430 2454.820557,160.619370 2456.939209,164.633850 
	C2457.812012,166.287659 2457.674805,168.474518 2457.998535,171.210052 
	C2457.502930,173.609451 2457.005859,175.217728 2456.254395,177.413605 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2268.456543,367.080872 
	C2263.466064,365.259949 2261.450928,362.283112 2262.091064,357.668762 
	C2262.652100,353.624908 2264.937988,350.849121 2268.915527,350.285431 
	C2273.181396,349.680969 2276.614746,351.529205 2278.645020,355.509674 
	C2280.514404,359.174744 2278.373535,361.923279 2276.184570,364.329865 
	C2274.420410,366.269379 2271.976318,367.466034 2268.456543,367.080872 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2402.229492,1581.332275 
	C2401.174805,1574.775269 2404.562012,1572.019531 2409.404053,1570.520386 
	C2412.866211,1569.448364 2415.047363,1571.736694 2416.840332,1574.172852 
	C2419.360596,1577.597412 2420.661865,1580.921143 2416.582275,1584.512573 
	C2412.230469,1588.343384 2409.540039,1589.068604 2405.285889,1585.993896 
	C2404.030273,1585.086426 2403.322510,1583.420410 2402.229492,1581.332275 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2379.353516,1073.665405 
	C2380.344238,1078.839722 2379.697510,1083.427124 2374.533691,1085.368530 
	C2369.705811,1087.183472 2365.580811,1085.654541 2362.330811,1080.637207 
	C2364.240967,1069.248413 2368.776367,1067.437866 2379.353516,1073.665405 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2511.636230,309.279907 
	C2513.601074,308.662262 2514.917480,308.081390 2516.173828,308.191040 
	C2520.783936,308.593597 2523.375732,311.334991 2523.878174,315.850922 
	C2524.220703,318.932251 2523.947510,322.269287 2520.444824,323.315552 
	C2516.250244,324.568451 2511.925537,324.834656 2508.360596,321.250702 
	C2504.973877,317.846161 2506.341553,314.616089 2508.625000,311.453552 
	C2509.179688,310.685333 2510.169922,310.231812 2511.636230,309.279907 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2481.075928,292.804718 
	C2492.108887,292.377411 2496.632080,297.825348 2492.951904,305.885254 
	C2491.112305,309.914368 2487.998291,310.950592 2484.196777,308.798706 
	C2478.147217,305.374298 2477.006104,300.719269 2481.075928,292.804718 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2473.479492,407.015808 
	C2468.536621,410.635345 2464.565674,409.444519 2461.377686,405.874908 
	C2459.193115,403.428955 2457.363770,400.429382 2459.684570,396.844971 
	C2461.654541,393.802368 2464.400879,391.774353 2467.958740,392.500366 
	C2471.510010,393.225006 2475.157715,394.645813 2475.806641,399.076447 
	C2476.196533,401.741058 2476.205078,404.426453 2473.479492,407.015808 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2203.864258,427.995300 
	C2203.384277,432.034668 2201.442627,434.350281 2198.503174,435.369202 
	C2194.472168,436.766479 2190.622314,436.224274 2187.793213,432.551544 
	C2185.477051,429.544495 2185.472412,426.466736 2187.786865,423.455688 
	C2190.612549,419.779602 2194.462158,419.233917 2198.493896,420.626801 
	C2201.433594,421.642487 2203.377930,423.957062 2203.864258,427.995300 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2287.362793,510.330139 
	C2290.841553,510.658630 2293.683350,511.318512 2297.262451,511.989197 
	C2297.991943,514.315796 2297.940186,516.632507 2297.985107,518.947266 
	C2298.065430,523.092224 2296.032715,525.995544 2292.367188,527.458496 
	C2289.337402,528.667542 2286.557129,527.618530 2284.314209,525.183838 
	C2281.490967,522.119385 2281.350342,518.537292 2282.818604,515.030212 
	C2283.531982,513.327271 2285.387207,512.102661 2287.362793,510.330139 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2094.311523,586.790100 
	C2097.697510,583.279236 2100.544922,580.261047 2104.877441,584.025146 
	C2108.356689,587.048157 2108.861084,590.908569 2107.209473,594.834778 
	C2105.462646,598.987915 2101.838379,600.505920 2097.439697,599.864685 
	C2092.081299,599.083679 2091.163574,595.834961 2094.311523,586.790100 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2062.425293,394.549530 
	C2062.000000,390.571899 2062.000000,387.143829 2062.000000,382.859070 
	C2063.578613,381.577179 2065.178955,381.218018 2066.731934,380.713684 
	C2070.647461,379.442078 2073.722412,380.098114 2075.961426,383.937439 
	C2078.000488,387.433716 2078.427002,390.781311 2075.759033,393.979797 
	C2073.308594,396.917419 2070.290283,398.780884 2066.270996,397.038910 
	C2065.075439,396.520691 2063.987793,395.752655 2062.425293,394.549530 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2127.564941,871.741821 
	C2122.125732,871.991150 2119.325439,869.501831 2118.290527,865.193604 
	C2117.495117,861.882019 2119.198486,859.600403 2122.133545,857.955933 
	C2126.960205,855.251465 2132.717285,855.387329 2134.870117,858.476379 
	C2137.643311,862.455322 2135.234619,867.291321 2127.564941,871.741821 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2197.073730,858.693359 
	C2200.565186,860.182068 2203.254639,861.585632 2204.812500,864.293640 
	C2206.388428,867.033569 2206.833008,870.181335 2204.858398,872.729309 
	C2202.701172,875.512634 2199.349365,876.697571 2195.924316,875.528442 
	C2191.682861,874.080627 2189.851074,870.737244 2189.997314,866.223267 
	C2190.135986,861.941040 2190.507080,857.996033 2197.073730,858.693359 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2419.003418,402.854980 
	C2427.967041,402.380768 2430.594238,404.292480 2431.253418,410.873627 
	C2431.654053,414.871460 2428.661133,419.294983 2425.079102,419.764740 
	C2420.821289,420.323151 2417.839111,418.080536 2416.660156,414.367889 
	C2415.476562,410.638702 2414.998291,406.533417 2419.003418,402.854980 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2162.750000,235.999115 
	C2162.044434,232.657440 2159.489746,230.830948 2157.732422,228.498566 
	C2155.508545,225.546967 2155.045898,222.168228 2158.041504,219.668777 
	C2161.374756,216.887650 2165.757812,217.164398 2169.179932,219.103119 
	C2172.290771,220.865402 2174.543213,224.260010 2172.656738,228.277542 
	C2171.572998,230.585190 2169.727295,232.534943 2168.112305,235.322601 
	C2166.500000,235.999405 2165.000000,235.999420 2162.750000,235.999115 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2354.464600,328.297485 
	C2358.300537,327.823517 2361.183594,328.113586 2363.458984,330.531525 
	C2365.674561,332.885651 2368.982178,334.933380 2367.258545,338.839661 
	C2365.654785,342.474640 2362.582520,344.182190 2358.463867,343.969147 
	C2354.306396,343.754059 2351.447510,341.626038 2350.428467,337.817322 
	C2349.472412,334.243683 2349.475098,330.479919 2354.464600,328.297485 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2258.080566,393.913879 
	C2250.947021,395.073303 2247.688965,393.511749 2246.793457,389.143921 
	C2246.027832,385.409241 2249.713379,380.591736 2254.344238,378.872711 
	C2258.772217,377.229034 2261.465820,379.548187 2263.118652,382.962067 
	C2265.465332,387.809662 2262.608643,391.028168 2258.080566,393.913879 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2172.595215,858.645020 
	C2170.628906,859.198059 2169.199707,859.877930 2168.078613,859.539246 
	C2164.243896,858.380493 2160.120117,857.122498 2160.188477,851.975159 
	C2160.244385,847.767029 2162.795166,845.184570 2166.727783,844.274780 
	C2171.027588,843.280334 2174.840820,844.514709 2176.938721,848.569336 
	C2179.179932,852.900757 2177.707764,856.266907 2172.595215,858.645020 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2496.882812,1618.714844 
	C2502.063965,1625.878296 2501.980225,1629.611694 2497.225586,1633.235718 
	C2493.510986,1636.067017 2489.591797,1635.857544 2486.693359,1632.672852 
	C2483.539551,1629.207764 2483.568115,1625.890869 2486.809570,1622.239502 
	C2489.311768,1619.420898 2492.085938,1617.232422 2496.882812,1618.714844 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2346.445801,413.293152 
	C2343.120117,404.360413 2343.982178,400.885345 2349.311035,400.186371 
	C2353.822266,399.594604 2357.792725,400.767822 2360.407959,404.995239 
	C2362.175781,407.852875 2361.044678,409.872833 2359.034180,411.978729 
	C2355.449463,415.733185 2351.703369,417.703827 2346.445801,413.293152 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2198.296387,361.930908 
	C2196.272705,361.437439 2194.806396,361.256714 2193.876221,360.454437 
	C2189.955322,357.073425 2188.850830,352.566925 2190.843262,349.008881 
	C2192.632324,345.813446 2195.713135,345.704926 2198.686279,346.190887 
	C2203.143799,346.919495 2205.640869,349.755646 2205.925293,354.341339 
	C2206.223877,359.160858 2204.222412,361.970184 2198.296387,361.930908 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2143.282715,314.085876 
	C2144.701172,314.676544 2145.300781,315.530212 2146.120361,316.002167 
	C2150.170166,318.334167 2152.917236,321.551117 2151.781250,326.414001 
	C2150.541992,331.720276 2145.986084,331.912933 2140.803223,331.997040 
	C2139.267334,330.523041 2138.450928,329.082001 2137.815918,327.565094 
	C2134.765137,320.277649 2135.094727,319.391388 2143.282715,314.085876 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2150.654297,358.854370 
	C2154.770996,356.111176 2158.042236,355.839508 2160.502197,359.841522 
	C2162.786133,363.557281 2162.738037,367.363007 2159.976318,370.818024 
	C2157.399658,374.041626 2154.064697,374.656982 2150.259277,373.052429 
	C2146.625000,371.520142 2145.178711,368.901978 2146.641602,365.203308 
	C2147.470215,363.108887 2148.891602,361.248962 2150.654297,358.854370 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2113.917969,335.269104 
	C2114.000000,336.000000 2114.000000,337.000000 2114.000000,337.500000 
	C2109.873291,340.768982 2108.096924,337.221741 2105.924072,334.930634 
	C2104.074463,332.980164 2102.218994,330.441132 2099.288086,332.368469 
	C2096.178223,334.413544 2098.153564,337.038605 2099.409668,339.338135 
	C2100.368408,341.093567 2101.435547,342.789093 2100.434082,345.463959 
	C2099.111084,345.999298 2098.222168,345.999847 2096.666504,346.000793 
	C2090.609863,341.328064 2088.182861,333.416870 2090.458008,327.855072 
	C2091.421143,325.499847 2093.278564,324.505829 2095.744385,324.065979 
	C2105.604736,322.307159 2109.200195,324.336823 2113.917969,335.269104 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2257.928711,323.863098 
	C2255.059082,323.630707 2253.417725,322.537964 2252.164551,320.954437 
	C2249.526855,317.620941 2249.200439,311.030975 2251.479004,309.073730 
	C2254.096680,306.825317 2261.487549,308.114075 2264.058350,311.267303 
	C2267.044434,314.929962 2266.546875,318.499756 2262.264404,322.366852 
	C2261.361572,323.182068 2259.905518,323.384918 2257.928711,323.863098 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2393.297363,402.595612 
	C2391.366699,401.218475 2389.567627,400.429565 2388.965088,399.098724 
	C2387.189209,395.177063 2387.560303,391.356232 2390.907959,388.205414 
	C2393.487549,385.777710 2396.223633,385.482300 2398.824707,387.989197 
	C2401.368896,390.441193 2405.036621,392.611084 2403.280273,397.052032 
	C2401.667969,401.129517 2399.912109,405.476624 2393.297363,402.595612 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2267.699219,422.066284 
	C2273.806396,422.925079 2274.372559,426.714142 2273.779541,430.928406 
	C2273.277100,434.496094 2270.977783,436.827240 2267.499023,437.677246 
	C2263.788086,438.583923 2261.074707,436.710358 2259.220459,433.749115 
	C2255.928223,428.491699 2259.305176,423.427124 2267.699219,422.066284 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2126.719238,357.920654 
	C2123.769531,356.747192 2120.921875,356.121429 2120.161621,353.223419 
	C2119.308594,349.971741 2116.209473,346.408508 2120.204102,343.433014 
	C2123.340576,341.096924 2126.996094,341.382141 2130.266113,343.555878 
	C2131.882568,344.630280 2133.253662,346.074249 2135.367676,347.675507 
	C2136.672363,354.348297 2132.350342,356.350800 2126.719238,357.920654 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2517.372803,1569.382568 
	C2519.920898,1565.003662 2521.812256,1560.672485 2527.528320,1563.809326 
	C2531.875244,1566.194702 2533.244873,1570.669800 2531.040283,1575.713013 
	C2529.044678,1580.278564 2522.983398,1581.690308 2519.596191,1578.085449 
	C2517.608643,1575.970581 2515.755859,1573.387085 2517.372803,1569.382568 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2483.484375,1591.108643 
	C2481.243896,1590.921509 2479.551514,1590.733154 2478.170410,1589.976807 
	C2474.965332,1588.221802 2471.378662,1586.150757 2472.588623,1581.790649 
	C2473.680908,1577.854248 2477.620605,1576.791138 2481.198975,1576.203613 
	C2484.917969,1575.592896 2487.613281,1577.751343 2489.105957,1580.904541 
	C2490.916504,1584.728760 2489.872314,1587.949585 2485.938477,1589.962891 
	C2485.352539,1590.262573 2484.762207,1590.554077 2483.484375,1591.108643 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2228.741211,362.742798 
	C2233.428223,361.712646 2236.269775,363.919128 2237.061035,367.203674 
	C2237.979248,371.018005 2235.206787,374.067139 2232.299805,376.367096 
	C2229.445312,378.625488 2225.977783,378.718628 2222.945801,377.037079 
	C2219.385986,375.062653 2219.399658,371.663055 2221.120850,368.414978 
	C2222.574951,365.671326 2225.285889,364.243195 2228.741211,362.742798 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2143.170654,386.000305 
	C2144.133789,386.298431 2144.260010,386.600647 2144.402832,386.894745 
	C2149.935303,398.278717 2148.218994,401.229797 2134.808350,401.998962 
	C2133.712402,400.757538 2133.447510,399.510406 2133.133057,398.276001 
	C2130.634521,388.467438 2131.978760,386.671936 2143.170654,386.000305 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2216.468994,337.657715 
	C2213.174805,336.540894 2211.358398,334.592438 2209.758301,332.510529 
	C2207.165527,329.136993 2207.628662,325.879913 2210.385742,322.699188 
	C2213.381348,319.242859 2216.277588,320.936401 2219.135498,322.697723 
	C2222.455811,324.743958 2224.300049,327.615601 2223.943359,331.736938 
	C2223.579102,335.948944 2220.520996,336.931427 2216.468994,337.657715 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2287.269531,409.171844 
	C2283.723633,411.066956 2280.906494,413.021881 2277.558594,410.363251 
	C2274.323242,407.794098 2273.523438,404.495270 2274.270996,400.673340 
	C2274.971680,397.090149 2277.593262,396.132812 2280.847412,396.030182 
	C2284.972656,395.900085 2287.849854,397.859528 2289.397949,401.484589 
	C2290.496094,404.055786 2290.049561,406.661835 2287.269531,409.171844 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2158.701660,561.992126 
	C2156.786865,560.427734 2155.665771,558.772400 2154.339355,557.302002 
	C2152.103271,554.823181 2151.297363,552.036377 2152.846436,549.058533 
	C2154.756836,545.385986 2158.404785,546.018433 2161.698730,546.083130 
	C2165.142822,546.150696 2167.401855,547.783997 2167.844727,551.338318 
	C2168.049316,552.982178 2167.957275,554.663086 2168.000000,557.163574 
	C2165.133545,559.326172 2163.096924,562.442505 2158.701660,561.992126 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2225.925781,480.703735 
	C2227.292969,479.903564 2228.619629,479.957275 2229.873779,479.681702 
	C2240.040527,477.447632 2242.823242,480.364166 2240.083740,491.270630 
	C2239.039062,492.172089 2238.067627,492.301086 2237.118896,492.525513 
	C2227.725342,494.747284 2223.993896,491.069794 2225.925781,480.703735 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2430.000000,194.666641 
	C2430.689941,192.907104 2431.579590,191.890472 2432.030273,190.706833 
	C2433.146729,187.773956 2434.680176,184.708984 2438.012207,184.888962 
	C2442.039307,185.106491 2442.843994,189.169846 2443.640625,192.239014 
	C2445.495117,199.384949 2442.056396,203.226181 2432.820557,204.000458 
	C2432.000000,203.667480 2432.000000,203.333740 2432.000000,202.499390 
	C2431.117188,201.219009 2430.426758,200.311554 2430.056152,198.577957 
	C2430.000000,197.111954 2430.000000,196.222748 2430.000000,194.666641 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2303.833984,373.035461 
	C2303.860840,377.708344 2304.883301,382.215210 2299.594482,383.622772 
	C2296.202881,384.525452 2293.071045,384.137085 2291.242920,380.334625 
	C2289.133301,375.946472 2289.676514,371.050262 2292.997070,368.658234 
	C2296.331543,366.255890 2299.642090,365.605682 2302.358154,369.626526 
	C2302.906494,370.438477 2303.277100,371.370758 2303.833984,373.035461 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2544.224609,153.568970 
	C2535.989014,155.624023 2532.837402,153.612045 2532.082764,146.392776 
	C2531.547119,141.264877 2533.490967,138.540115 2538.004883,138.091812 
	C2542.851318,137.610489 2545.188232,139.396942 2545.898438,144.421036 
	C2546.170654,146.346954 2545.979736,148.338348 2546.000000,151.149933 
	C2545.366455,152.220093 2544.849609,152.599197 2544.224609,153.568970 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2432.577148,386.498901 
	C2432.192139,384.094666 2431.973145,382.437012 2432.039795,380.790863 
	C2432.129639,378.567017 2431.452881,375.897522 2434.149658,374.679840 
	C2437.409668,373.207794 2439.785889,375.020599 2442.112061,377.108795 
	C2445.047119,379.743652 2446.545898,382.803253 2445.808594,386.803833 
	C2445.307861,389.520233 2443.169434,390.526978 2440.988525,391.294189 
	C2436.999512,392.697479 2434.869873,390.027191 2432.577148,386.498901 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2116.427979,385.442078 
	C2110.767090,386.084839 2106.698730,384.215912 2106.415283,378.491730 
	C2106.157959,373.292114 2110.468262,370.519379 2119.188477,370.000366 
	C2123.162109,379.220093 2123.139648,379.327148 2116.427979,385.442078 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2243.677734,351.664185 
	C2240.022705,351.547302 2238.296875,349.426819 2236.583252,347.470795 
	C2233.399658,343.836609 2233.585205,341.112915 2236.955811,338.184174 
	C2240.274658,335.300476 2245.166016,335.393402 2248.597412,338.691071 
	C2251.540283,341.519104 2252.783936,344.702667 2249.019531,347.930450 
	C2247.532471,349.205597 2245.938965,350.356201 2243.677734,351.664185 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2461.937744,1566.396729 
	C2461.921875,1570.482300 2460.843994,1573.073975 2457.223633,1573.756470 
	C2452.878418,1574.575684 2449.197021,1573.412964 2447.033691,1569.402344 
	C2445.254883,1566.105713 2445.783447,1563.027344 2448.977295,1560.627930 
	C2452.802490,1557.754395 2456.370117,1558.412842 2459.817627,1561.260864 
	C2461.168701,1562.377075 2461.760254,1563.901367 2461.937744,1566.396729 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2132.000000,427.123779 
	C2123.131592,430.227905 2121.000000,429.606567 2118.002197,423.917938 
	C2115.761963,419.666107 2116.927490,416.016846 2121.549805,414.665131 
	C2124.310791,413.857666 2127.403564,414.184326 2131.173584,414.001221 
	C2132.000000,418.083801 2132.000000,422.166382 2132.000000,427.123779 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2482.369141,452.372070 
	C2480.190918,453.183838 2478.532227,454.005249 2477.075195,453.735565 
	C2473.244141,453.026367 2469.914551,450.691315 2470.531494,446.608887 
	C2471.093994,442.885925 2473.305176,439.198700 2477.614990,438.163910 
	C2482.531494,436.983490 2485.836182,439.834442 2485.971436,444.954315 
	C2486.045410,447.760742 2485.070312,450.045929 2482.369141,452.372070 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2180.743652,459.912506 
	C2175.034180,459.308258 2172.335693,456.496643 2172.010742,450.729309 
	C2172.482422,449.569916 2173.121338,449.228241 2173.421875,448.695587 
	C2175.379150,445.228485 2178.076904,443.059509 2182.182861,444.486847 
	C2185.444336,445.620575 2187.465820,448.057281 2187.933838,451.682892 
	C2188.579102,456.680054 2185.690674,458.738373 2180.743652,459.912506 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2493.424805,339.905090 
	C2499.610840,335.780121 2501.776611,335.874298 2504.441406,339.744354 
	C2506.820801,343.200104 2506.516113,350.482635 2503.902344,352.619324 
	C2500.965332,355.020294 2493.954102,352.442505 2492.487305,348.199646 
	C2491.620605,345.692322 2491.732666,343.015320 2493.424805,339.905090 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2164.097168,342.730774 
	C2165.965332,332.330414 2169.022461,330.970276 2179.371582,335.720459 
	C2179.341797,343.901550 2177.548340,346.565887 2171.967041,347.656891 
	C2168.286865,348.376282 2165.342773,347.530487 2164.097168,342.730774 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2210.000000,279.499084 
	C2209.940918,282.310730 2210.042236,284.640961 2209.782227,286.930084 
	C2209.438232,289.957123 2207.549072,291.593903 2204.504395,291.840698 
	C2200.219238,292.187988 2198.028076,289.067261 2195.624512,286.378265 
	C2193.628662,284.145660 2194.789551,281.958832 2196.204346,280.094177 
	C2198.318604,277.307953 2201.112793,275.695007 2204.785889,276.569214 
	C2206.063965,276.873383 2207.288086,277.403412 2209.268555,277.915161 
	C2210.000000,278.000000 2210.000000,278.999390 2210.000000,279.499084 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2179.129883,1420.806152 
	C2179.194092,1419.040527 2179.424072,1418.093018 2179.507812,1416.421631 
	C2179.361816,1415.697754 2180.074951,1415.279541 2180.476074,1415.379028 
	C2184.656494,1418.877686 2186.953369,1423.473511 2190.978516,1426.858154 
	C2195.117920,1430.338623 2193.975830,1433.417725 2188.728027,1435.420654 
	C2185.714844,1436.571045 2182.480713,1437.142700 2178.559570,1437.985962 
	C2178.280762,1432.539551 2178.788086,1427.081909 2179.129883,1420.806152 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2432.730469,1671.909668 
	C2425.914551,1672.387573 2424.551270,1668.342285 2424.014160,1662.754150 
	C2427.030273,1662.082520 2428.175537,1659.186646 2430.379150,1657.959961 
	C2432.683594,1656.677246 2435.002441,1655.371460 2437.600098,1657.184937 
	C2440.087891,1658.921509 2440.123291,1661.586914 2439.902100,1664.194092 
	C2439.562500,1668.194458 2437.182617,1670.607056 2432.730469,1671.909668 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2344.736572,620.348145 
	C2342.226074,624.327637 2339.299561,626.592224 2335.302490,625.260620 
	C2332.446777,624.309082 2330.167480,622.045471 2330.345459,618.555359 
	C2330.524902,615.036682 2336.562988,609.979004 2340.237549,610.157776 
	C2343.783691,610.330322 2345.736328,612.264099 2345.812500,615.807129 
	C2345.839600,617.087402 2345.343994,618.378967 2344.736572,620.348145 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2304.736572,241.996841 
	C2303.930176,239.932556 2303.010010,238.255981 2301.775879,236.640854 
	C2299.520020,233.688004 2299.355957,230.562546 2301.685791,227.588486 
	C2303.100342,225.783020 2304.706787,223.900284 2307.448730,224.905533 
	C2310.999512,226.207169 2314.089111,227.979843 2313.963623,232.483063 
	C2313.945312,233.139816 2313.984131,233.798157 2313.998291,235.227570 
	C2312.454834,239.842606 2310.281006,242.792114 2304.736572,241.996841 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2244.538086,419.496643 
	C2241.222168,419.999237 2238.444336,419.999664 2234.833252,420.000671 
	C2229.639404,417.636292 2228.935059,414.101379 2231.336670,410.103027 
	C2233.136230,407.107452 2236.016113,405.303711 2239.685791,406.368073 
	C2243.497559,407.473663 2245.827393,410.129028 2245.892334,414.240875 
	C2245.917480,415.820709 2245.365479,417.409698 2244.538086,419.496643 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2379.781494,1624.081055 
	C2386.533936,1625.224121 2386.643066,1629.656738 2385.521729,1633.948608 
	C2384.556641,1637.642944 2381.691650,1640.253174 2377.474854,1639.725342 
	C2373.429443,1639.219116 2372.564209,1635.714355 2372.157715,1632.440063 
	C2371.540771,1627.470825 2373.213623,1624.013428 2379.781494,1624.081055 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2344.880371,1610.906372 
	C2353.458008,1606.871582 2358.627686,1608.618164 2359.835449,1615.143799 
	C2360.696533,1619.796143 2358.959473,1621.861450 2354.096680,1621.968018 
	C2347.374512,1622.115112 2345.188477,1619.752563 2344.880371,1610.906372 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2352.177490,484.539368 
	C2347.522461,486.588318 2344.230225,485.242676 2342.519531,481.561462 
	C2341.252930,478.836121 2341.790527,475.713470 2343.952393,473.203339 
	C2346.060547,470.755768 2348.636230,469.535217 2351.868408,470.339020 
	C2356.139893,471.401367 2358.090576,475.274292 2356.212158,479.320404 
	C2355.401367,481.067169 2353.938232,482.511200 2352.177490,484.539368 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2257.981445,457.209412 
	C2254.677979,464.679504 2249.519775,464.969391 2242.737549,462.085571 
	C2242.003906,460.700378 2242.040039,459.402374 2242.005859,458.106201 
	C2241.891113,453.735443 2243.010742,450.317169 2248.206543,450.078949 
	C2252.957031,449.861145 2257.651123,449.782745 2257.981445,457.209412 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2404.783447,1655.135010 
	C2402.302246,1653.312134 2400.538086,1651.761475 2400.244873,1649.298340 
	C2399.850586,1645.986084 2399.519287,1642.437134 2403.280029,1640.782715 
	C2406.019531,1639.577637 2409.220703,1639.136841 2411.451904,1641.774902 
	C2413.911865,1644.683716 2415.052246,1648.181274 2412.772217,1651.746460 
	C2411.141113,1654.296631 2408.979248,1656.358643 2404.783447,1655.135010 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2059.913086,415.280426 
	C2058.528320,422.839630 2056.873535,424.583618 2052.647949,423.748474 
	C2048.446289,422.918060 2045.790527,419.047668 2046.336426,414.175171 
	C2046.514526,412.585052 2047.305664,411.063599 2047.908203,408.755981 
	C2053.361084,407.629456 2057.975830,408.603455 2059.913086,415.280426 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2418.934082,370.795990 
	C2415.981445,373.236969 2413.267822,374.169647 2410.154785,373.937042 
	C2407.264648,373.721008 2405.042725,372.664337 2404.355225,369.615204 
	C2403.721191,366.805725 2404.360840,364.325287 2406.916748,362.742035 
	C2409.716309,361.007874 2412.505127,359.351715 2416.087646,361.073364 
	C2420.296143,363.095703 2420.453613,366.357666 2418.934082,370.795990 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2540.889648,411.209290 
	C2531.253906,411.539337 2528.439941,408.949066 2530.772461,402.778015 
	C2532.153076,399.125549 2534.654785,395.988983 2538.816162,396.934479 
	C2542.200928,397.703552 2543.958984,400.856720 2543.958252,404.607574 
	C2543.958008,407.007690 2543.656494,409.243744 2540.889648,411.209290 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2011.185059,761.907837 
	C2009.800415,761.481201 2009.136841,761.064453 2007.987427,760.305298 
	C2006.694092,758.886108 2005.854980,757.834656 2004.584229,756.268433 
	C2004.187378,755.073853 2003.942017,754.536316 2003.050415,753.906860 
	C2001.299316,753.293396 2001.072510,752.133911 2000.427612,750.556152 
	C2000.021484,749.768433 2000.013428,749.412354 2000.019043,748.522339 
	C2010.610596,745.216492 2013.108765,745.972412 2016.421387,752.947388 
	C2018.894287,758.154236 2018.560059,758.818054 2011.185059,761.907837 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2238.089355,530.744263 
	C2241.725586,525.412231 2246.462646,523.253723 2253.204590,524.000061 
	C2253.993652,525.650513 2254.013428,527.301575 2253.975830,528.951355 
	C2253.862793,533.921875 2251.416992,537.014709 2246.480225,537.879456 
	C2241.467041,538.757629 2239.262451,535.807495 2238.089355,530.744263 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2529.757812,367.649231 
	C2527.342285,367.953094 2525.565186,367.985504 2524.327148,366.837097 
	C2521.586670,364.295074 2517.146240,362.447754 2518.842285,357.528381 
	C2519.809570,354.723114 2527.137451,353.114410 2530.439209,354.548676 
	C2534.027588,356.107422 2534.979492,360.363831 2532.733643,365.626587 
	C2532.397949,366.413116 2531.273193,366.863007 2529.757812,367.649231 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2212.596191,473.688416 
	C2208.571289,474.000397 2205.142578,473.999573 2200.856934,473.998169 
	C2199.713379,472.738800 2199.566650,471.426880 2199.113037,470.231506 
	C2197.849854,466.903076 2199.091309,463.989105 2201.859131,462.827728 
	C2205.411865,461.336975 2209.735352,460.800598 2212.652344,464.263092 
	C2214.842773,466.863373 2217.526855,470.093262 2212.596191,473.688416 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2038.043823,306.594421 
	C2038.046509,304.071899 2037.913086,302.079468 2039.067993,300.390167 
	C2040.999390,297.565521 2043.472900,295.595123 2047.149780,296.244843 
	C2051.195557,296.959717 2051.988037,299.981445 2051.984863,303.475739 
	C2051.983398,305.089203 2051.994385,306.702698 2052.000000,309.158081 
	C2051.666748,310.000183 2051.333252,310.000366 2050.500000,310.000916 
	C2047.374634,312.043640 2044.581299,312.755005 2040.743164,310.538452 
	C2039.364258,309.062897 2038.728394,308.124634 2038.043823,306.594421 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2174.771484,533.983765 
	C2165.595703,525.327209 2166.128174,521.932068 2177.252930,518.012146 
	C2178.983154,520.465881 2181.567383,522.041565 2181.842041,524.900574 
	C2182.302490,529.700317 2181.655762,533.733459 2174.771484,533.983765 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2087.239990,354.013306 
	C2091.939453,358.757324 2093.960693,363.597382 2088.318115,369.377106 
	C2080.995605,369.253967 2078.421143,367.593414 2078.215820,363.014893 
	C2077.966309,357.450836 2081.056885,354.571411 2087.239990,354.013306 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2227.190918,434.001221 
	C2227.996582,435.947357 2227.994385,437.893494 2227.989502,439.839630 
	C2227.980957,443.191986 2227.807861,446.535034 2223.761963,447.597626 
	C2219.646729,448.678436 2216.881348,446.549805 2214.926270,443.242737 
	C2214.305664,442.192780 2214.309326,440.773773 2214.013672,438.761841 
	C2216.750732,432.404510 2221.954102,434.404175 2227.190918,434.001221 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2336.321777,441.909241 
	C2333.282471,441.626160 2332.115234,440.088715 2331.240479,438.250641 
	C2329.716553,435.048584 2329.289795,431.874908 2332.310791,429.292755 
	C2334.681885,427.266052 2340.520996,427.584686 2342.314941,429.938873 
	C2344.749756,433.134827 2344.679932,436.661163 2342.436279,439.959442 
	C2341.219482,441.747894 2339.127686,441.903168 2336.321777,441.909241 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2447.664551,1092.526855 
	C2452.458008,1098.755127 2447.265137,1104.164429 2447.279297,1109.905762 
	C2447.282959,1111.413086 2444.996338,1111.438843 2444.134033,1110.462280 
	C2442.629395,1108.759155 2441.393555,1106.745972 2440.374512,1104.698853 
	C2436.204834,1096.322510 2437.212158,1094.481445 2447.664551,1092.526855 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2167.287842,1499.573364 
	C2166.667480,1497.410645 2166.889648,1495.411621 2167.393066,1492.703735 
	C2172.159424,1491.957397 2175.281006,1496.999878 2180.663086,1494.947266 
	C2182.547852,1494.228394 2185.160156,1497.466675 2185.600830,1500.282349 
	C2186.190430,1504.050537 2183.239014,1505.293213 2180.539795,1506.671509 
	C2177.649902,1508.147339 2176.211914,1506.538330 2175.157715,1504.235596 
	C2173.762695,1501.188354 2171.431152,1499.739624 2167.287842,1499.573364 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2523.715820,1649.656738 
	C2520.080322,1650.179077 2517.900146,1648.955811 2516.024902,1646.895630 
	C2513.621338,1644.255493 2514.063232,1641.625488 2515.721680,1638.806030 
	C2517.612793,1635.590698 2520.539307,1635.774780 2523.494141,1636.328979 
	C2526.520020,1636.896606 2527.741455,1639.096069 2527.912354,1642.013184 
	C2528.094482,1645.117432 2527.699707,1647.944824 2523.715820,1649.656738 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2289.714355,452.431885 
	C2285.132568,445.112457 2285.518799,441.519165 2290.522461,440.335327 
	C2293.436035,439.645935 2296.603516,439.536835 2298.664551,442.256409 
	C2300.668457,444.900818 2300.049805,447.795380 2298.598877,450.597260 
	C2296.646240,454.368073 2293.751221,454.512146 2289.714355,452.431885 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2285.143066,466.000793 
	C2285.685303,470.342377 2287.369385,475.355377 2281.934814,477.966980 
	C2279.609131,479.084503 2277.331299,480.657684 2274.662109,478.980011 
	C2272.073242,477.352905 2271.781738,474.807770 2272.327148,472.127136 
	C2272.647461,470.554230 2273.307861,469.050537 2273.907715,466.758453 
	C2277.428711,466.000946 2280.857422,466.000671 2285.143066,466.000793 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2108.047119,564.592041 
	C2108.687012,562.933044 2109.645264,561.951599 2110.013184,560.784058 
	C2111.395020,556.397583 2114.511230,555.267639 2118.420166,556.580505 
	C2121.271729,557.538269 2123.793945,559.721741 2123.630615,562.995300 
	C2123.409668,567.422791 2119.612305,568.603638 2116.073730,569.283508 
	C2114.643311,569.558411 2112.969482,568.565552 2110.703125,568.074768 
	C2109.364746,567.061401 2108.729736,566.122803 2108.047119,564.592041 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2240.086914,274.708557 
	C2241.805176,265.232300 2242.426514,264.924805 2253.245117,267.908173 
	C2254.000000,270.133331 2254.000000,272.266693 2254.000000,275.200012 
	C2252.510254,277.396637 2251.198975,279.018494 2248.607178,279.894470 
	C2244.454346,280.072632 2241.184082,279.676300 2240.086914,274.708557 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2356.047363,194.591492 
	C2357.471436,193.002335 2357.821289,191.386108 2358.397705,189.851486 
	C2359.663086,186.482712 2362.373779,185.628983 2365.572754,186.327240 
	C2369.352295,187.152283 2370.597412,190.358612 2371.263672,193.593445 
	C2371.730225,195.859726 2369.678467,196.856216 2368.000977,197.963882 
	C2365.085449,199.889069 2362.259766,197.833405 2358.700928,198.006561 
	C2357.364990,197.060760 2356.729980,196.122147 2356.047363,194.591492 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2370.739990,1544.011841 
	C2369.419678,1538.571045 2369.862305,1533.738037 2377.322021,1532.299805 
	C2381.936768,1531.841187 2384.945312,1533.135010 2383.599609,1537.631226 
	C2382.564209,1541.091064 2382.104980,1545.967163 2376.295410,1545.030640 
	C2374.678223,1544.769897 2373.084473,1544.363403 2370.739990,1544.011841 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2023.828369,780.670532 
	C2026.838989,780.006165 2029.886230,779.701233 2033.314697,781.699158 
	C2035.490356,788.420654 2040.731812,785.125122 2045.181396,786.001587 
	C2046.000000,786.890808 2046.000000,787.779114 2046.000000,789.333740 
	C2041.966553,790.601440 2039.858521,794.460754 2035.860107,796.418030 
	C2035.091553,796.909790 2034.704590,796.750854 2033.744873,796.335022 
	C2032.547119,794.956604 2031.864990,793.872681 2030.687500,792.347534 
	C2030.186035,791.470764 2030.057861,791.115417 2029.516113,790.372742 
	C2027.783936,787.720703 2025.969482,785.775208 2024.368164,782.939575 
	C2023.866333,782.091431 2023.846802,781.685669 2023.828369,780.670532 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2346.774414,1527.973022 
	C2344.896240,1527.653564 2343.792480,1527.307129 2342.344238,1526.480225 
	C2342.006836,1525.019531 2342.002686,1524.038940 2342.022949,1523.058716 
	C2342.087402,1519.926392 2342.703613,1517.057617 2346.400146,1516.429199 
	C2349.083984,1515.972900 2351.039795,1517.529785 2351.521484,1519.924438 
	C2352.214844,1523.373169 2353.190186,1527.434082 2346.774414,1527.973022 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2456.893555,1683.194580 
	C2456.504639,1681.574951 2456.131592,1680.418701 2456.522461,1679.651489 
	C2457.869141,1677.008789 2459.505615,1673.779785 2463.051758,1675.082153 
	C2466.431152,1676.323364 2466.670654,1679.817261 2465.256348,1682.673706 
	C2463.376709,1686.470093 2460.414062,1686.781860 2456.893555,1683.194580 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2188.549072,1346.003296 
	C2186.976074,1341.842651 2187.635010,1337.696289 2188.200684,1332.689453 
	C2192.143311,1331.583130 2194.147217,1333.687256 2195.726074,1337.388916 
	C2195.379883,1340.207153 2194.759766,1342.414307 2194.069824,1345.310791 
	C2192.443115,1345.999634 2190.885986,1345.999268 2188.549072,1346.003296 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1951.313965,691.359741 
	C1944.523926,688.922485 1939.860718,683.617310 1936.167236,676.599121 
	C1940.665527,677.726440 1942.903320,682.167969 1947.091309,685.231567 
	C1948.834106,687.239197 1950.054077,688.983459 1951.313965,691.359741 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2064.717773,844.682251 
	C2066.729980,843.979553 2068.644287,843.989685 2071.279297,843.999878 
	C2070.939209,848.859558 2074.478760,853.092773 2073.706543,858.477539 
	C2069.313721,855.317932 2067.374512,850.091003 2064.717773,844.682251 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2084.674805,877.894531 
	C2081.939453,876.798401 2081.330811,874.609924 2080.328857,871.984680 
	C2082.510010,868.099426 2085.565674,866.488403 2088.326904,869.955994 
	C2091.028564,873.348450 2088.532715,875.981079 2084.674805,877.894531 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2173.339111,1015.262695 
	C2173.889893,1018.570129 2174.468506,1021.719788 2170.407471,1021.493713 
	C2167.283203,1021.319824 2165.602295,1018.851685 2166.534424,1015.926147 
	C2167.687012,1012.308960 2170.113281,1011.341797 2173.339111,1015.262695 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2170.918945,1127.258057 
	C2166.682129,1123.837769 2167.137695,1118.419189 2166.958496,1112.777344 
	C2170.303955,1116.568604 2170.515137,1121.599243 2170.918945,1127.258057 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2042.640503,810.276489 
	C2042.163818,809.393921 2042.059326,809.060547 2041.572754,808.368774 
	C2040.768677,807.206970 2040.457764,806.363525 2040.345703,804.799927 
	C2050.135986,804.935974 2050.966309,805.993408 2047.121826,813.702026 
	C2046.425293,813.850037 2045.799805,814.059387 2045.475098,814.116821 
	C2044.533936,812.996704 2043.846313,811.864685 2042.640503,810.276489 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2180.833496,1414.656494 
	C2180.877197,1415.478516 2180.125244,1415.625488 2179.743652,1415.661621 
	C2177.341797,1411.911743 2176.944092,1408.171265 2180.266602,1404.266357 
	C2182.031982,1407.295898 2180.787354,1410.560913 2180.833496,1414.656494 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2040.077515,310.682281 
	C2042.777832,310.000824 2045.555664,310.000458 2049.166748,310.000671 
	C2046.283813,316.700043 2044.199341,316.988434 2040.077515,310.682281 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2040.080566,803.827026 
	C2040.670898,804.978027 2040.925293,805.830200 2041.185059,807.346313 
	C2038.095215,807.499023 2036.379639,805.743286 2036.346680,801.847412 
	C2036.808105,801.307251 2037.184814,801.465759 2038.025635,801.925049 
	C2038.880493,802.686462 2039.298828,803.120544 2040.080566,803.827026 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2059.443848,829.759155 
	C2060.013428,831.435303 2060.027100,832.871155 2060.062500,835.023560 
	C2057.021240,835.663940 2056.431641,833.382385 2055.468262,830.484741 
	C2055.004639,829.571289 2054.974121,829.221130 2055.265137,828.453125 
	C2056.687012,828.529724 2057.787354,829.024292 2059.443848,829.759155 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2128.643066,241.935410 
	C2128.029541,239.708069 2128.890137,237.852829 2131.426758,236.289032 
	C2135.418457,239.955429 2131.959961,240.731506 2128.643066,241.935410 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1977.496704,721.450989 
	C1974.633545,721.698792 1972.693115,720.214417 1972.169434,716.493042 
	C1974.746216,716.623596 1976.162964,718.639832 1977.496704,721.450989 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2248.385498,280.467407 
	C2248.929688,277.922363 2250.381348,276.480011 2253.359863,276.057617 
	C2253.539551,279.004028 2253.087402,282.016846 2248.385498,280.467407 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1995.633545,743.874756 
	C1992.098633,743.617737 1990.604980,741.862305 1990.196777,738.351318 
	C1991.360474,738.480835 1992.506714,739.259033 1994.144043,740.247803 
	C1996.045044,740.337952 1996.893555,740.970642 1997.159058,743.266296 
	C1996.803711,744.107788 1996.469727,744.039551 1995.633545,743.874756 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2123.409180,960.359924 
	C2122.710205,960.508362 2122.133545,960.047668 2122.114990,959.676392 
	C2122.408447,957.595581 2123.140137,956.246094 2125.136230,956.353027 
	C2126.121094,956.405823 2127.014893,957.067871 2126.920166,958.091797 
	C2126.775391,959.652466 2125.305420,959.835449 2123.409180,960.359924 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2329.892090,1521.335205 
	C2328.500000,1521.996338 2327.000000,1521.997437 2324.750000,1521.996826 
	C2325.041504,1517.669800 2326.866943,1516.779663 2329.892090,1521.335205 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2018.189941,772.553467 
	C2018.839111,773.410217 2019.073242,774.124451 2019.281372,775.398926 
	C2017.529175,775.716309 2016.417725,774.822021 2016.145508,772.439148 
	C2016.748291,771.849426 2017.293701,772.037415 2018.189941,772.553467 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1987.327148,733.403870 
	C1985.667603,733.766418 1984.500610,732.960266 1984.107666,730.625610 
	C1985.711426,730.328369 1986.586182,731.492981 1987.327148,733.403870 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M2055.186523,827.714844 
	C2055.586670,828.035156 2055.388916,829.002502 2055.212158,829.462036 
	C2053.332520,829.608154 2052.387207,828.598999 2052.282715,826.291260 
	C2053.153076,826.275391 2053.969727,826.834961 2055.186523,827.714844 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2051.318848,823.393616 
	C2049.610596,823.751099 2048.469727,822.907166 2048.113525,820.561157 
	C2049.982422,819.979004 2050.650391,821.402710 2051.318848,823.393616 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1997.646240,743.900330 
	C1996.466675,743.419128 1995.795410,742.662354 1994.879517,741.182007 
	C1999.104858,740.370056 1999.104858,740.370056 1997.646240,743.900330 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2429.559082,198.351440 
	C2430.635010,198.939133 2431.270264,199.877075 2431.952637,201.406891 
	C2430.213379,201.621750 2427.907715,201.698364 2429.559082,198.351440 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2042.835205,797.909546 
	C2043.612793,796.484619 2044.396851,796.470459 2045.090820,797.484131 
	C2045.236084,797.696411 2045.231079,798.189087 2045.080566,798.396484 
	C2044.359497,799.389282 2043.576050,799.352539 2042.835205,797.909546 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M2038.295654,801.737793 
	C2038.489624,802.225952 2038.562378,802.161316 2038.597778,802.190796 
	C2039.495117,801.698547 2040.030518,800.662048 2039.296021,800.114868 
	C2038.137207,799.251648 2038.192139,800.509155 2038.295654,801.737793 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2095.657959,903.366577 
	C2095.218262,903.388977 2094.791260,902.895569 2094.326416,901.897827 
	C2094.749512,901.879272 2095.209961,902.365051 2095.657959,903.366577 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2100.225098,913.227478 
	C2099.716553,913.266724 2099.123779,912.673279 2098.486084,911.422119 
	C2099.007812,911.374573 2099.574463,911.984680 2100.225098,913.227478 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2105.931152,925.335571 
	C2105.457764,925.346008 2104.955078,924.766418 2104.422363,923.587952 
	C2104.895508,923.574585 2105.398682,924.160095 2105.931152,925.335571 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2014.417725,769.129150 
	C2013.939819,769.220276 2013.266724,768.723206 2012.488159,767.576050 
	C2012.995972,767.464294 2013.609253,768.002563 2014.417725,769.129150 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2114.617920,945.060181 
	C2114.066162,945.153137 2113.366211,944.593933 2112.621094,943.326294 
	C2113.207031,943.214600 2113.838623,943.811279 2114.617920,945.060181 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1953.502319,694.371094 
	C1952.890991,695.286377 1952.432373,694.985535 1952.306885,693.752441 
	C1952.657471,693.561951 1952.968506,693.726990 1953.502319,694.371094 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2078.774414,871.151489 
	C2078.106934,871.591553 2077.133789,871.877258 2077.705566,870.283691 
	C2078.024658,870.050415 2078.695312,870.693665 2078.774414,871.151489 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1908.326416,472.626892 
	C1908.052368,471.672180 1908.145264,471.346283 1908.151001,471.018860 
	C1908.216797,467.268585 1916.011108,467.001831 1912.304932,461.440491 
	C1907.992432,454.969391 1903.851196,453.457001 1894.742432,455.910370 
	C1891.428467,452.978577 1892.540527,450.393250 1895.201172,448.329590 
	C1898.652954,445.652496 1902.534912,445.383331 1906.498657,447.197021 
	C1910.147583,448.866791 1912.811401,452.148499 1916.610474,453.555115 
	C1919.529053,454.635712 1923.051392,455.413208 1924.576172,452.080200 
	C1926.277222,448.361969 1922.718018,447.004272 1920.031372,445.721466 
	C1904.333374,438.226013 1902.866943,429.729309 1915.282715,417.445709 
	C1918.745239,414.019989 1921.750488,410.504059 1919.847534,405.225525 
	C1917.947632,399.956024 1913.461670,398.652740 1908.555786,398.842255 
	C1901.610596,399.110535 1896.460449,396.698181 1892.623657,390.704346 
	C1890.164185,386.862152 1886.231445,384.715179 1881.407593,386.192841 
	C1876.527588,387.687653 1874.923706,391.696503 1874.807861,396.308258 
	C1874.618164,403.852570 1870.915161,408.801331 1864.147949,411.707153 
	C1857.213013,414.684906 1857.518921,418.961395 1861.664185,424.250214 
	C1864.182861,427.463837 1867.223145,429.822449 1870.660645,431.980530 
	C1880.964600,438.449402 1881.963135,443.853821 1875.151489,454.001709 
	C1868.789185,463.480194 1869.262695,468.364258 1877.677368,477.361755 
	C1877.975098,481.500153 1875.695679,483.534393 1872.589478,485.707153 
	C1871.041992,486.483276 1870.038574,486.445709 1869.169189,485.921173 
	C1863.952759,482.773895 1859.138428,483.477905 1856.466797,488.860229 
	C1853.652466,494.529633 1858.097656,497.261841 1862.529053,499.430939 
	C1863.427490,499.870667 1864.310181,500.334930 1865.563965,501.458069 
	C1865.197021,507.099823 1861.881592,509.997681 1856.686401,511.925079 
	C1848.600220,513.255005 1844.097778,517.429260 1842.467163,525.483887 
	C1838.727661,527.547791 1837.655518,529.756836 1839.565918,533.156616 
	C1840.525269,534.864014 1841.102417,536.786194 1841.926147,539.305725 
	C1835.863770,541.187378 1828.104248,538.577942 1824.574463,547.602478 
	C1822.319702,547.798401 1820.808838,547.251282 1819.930176,545.688293 
	C1818.043457,542.332031 1814.933594,541.835388 1810.757080,541.999878 
	C1809.076172,540.938049 1808.734375,539.732788 1808.909058,538.325134 
	C1810.649414,524.305603 1810.621948,524.025818 1797.561157,520.349792 
	C1790.468628,518.353455 1787.738647,512.741943 1785.429932,506.847595 
	C1783.523071,501.979156 1787.201538,500.538696 1790.977905,499.370819 
	C1796.300537,497.724792 1803.156494,496.861084 1801.530029,488.923767 
	C1800.164795,482.260986 1796.071655,478.125610 1788.216553,477.947266 
	C1779.027222,477.738678 1772.967773,470.595428 1773.843018,462.520477 
	C1774.507324,456.391296 1785.094604,449.494904 1792.357056,450.442993 
	C1798.773315,451.280609 1798.183716,456.783295 1799.424438,461.048187 
	C1801.954834,469.746582 1806.191895,472.233337 1813.003174,469.070221 
	C1817.166260,467.136932 1819.257812,463.989807 1818.259033,459.469666 
	C1816.424561,451.168610 1818.911865,445.190002 1826.735474,441.414124 
	C1830.964966,439.372894 1833.626343,436.002747 1832.510376,430.961487 
	C1831.308350,425.530792 1826.838867,424.859131 1822.377930,424.887787 
	C1815.498169,424.931976 1810.213013,423.038086 1807.114258,416.136047 
	C1802.462158,405.774048 1803.208130,402.972229 1813.669556,397.925842 
	C1819.058716,395.326263 1822.868774,392.125519 1819.365601,385.558075 
	C1816.170898,379.569092 1811.568115,380.426910 1806.657959,383.112335 
	C1802.818848,385.211975 1803.736328,388.272461 1804.472168,391.733368 
	C1806.736572,402.385956 1805.909546,404.629364 1795.354614,407.965454 
	C1787.321655,410.504333 1787.044434,414.454315 1789.603149,421.229797 
	C1793.304688,431.032013 1792.448853,432.269043 1782.417480,435.161865 
	C1775.147095,437.258453 1768.770142,439.473206 1773.135986,449.422333 
	C1774.903809,453.451080 1773.391724,457.637054 1768.951172,459.333588 
	C1763.485107,461.422028 1757.835571,461.708740 1752.881348,457.721619 
	C1750.795898,456.043152 1749.579834,453.564514 1747.972900,451.446411 
	C1745.283325,447.901062 1742.422607,444.459381 1737.285034,445.847015 
	C1732.146973,447.234802 1727.697754,450.194092 1727.357422,455.789185 
	C1726.830322,464.450562 1722.823120,470.830200 1716.681030,476.412903 
	C1713.572388,479.238556 1711.617188,482.672668 1713.507568,487.090454 
	C1715.534546,491.827209 1719.478271,492.717163 1724.155518,492.717438 
	C1737.454590,492.718262 1741.204712,498.984802 1735.162354,512.251038 
	C1733.960571,512.998230 1733.214355,513.445007 1732.694336,513.222168 
	C1717.573608,506.742279 1702.976929,499.301300 1689.844727,488.746735 
	C1692.208374,484.708282 1694.433594,481.550781 1697.586304,478.919739 
	C1702.164673,475.098938 1705.795044,470.202026 1707.967896,464.645203 
	C1709.990845,459.471527 1712.836914,455.224701 1717.496582,452.270752 
	C1723.057007,448.745911 1723.955078,443.607666 1722.883423,437.655701 
	C1721.250610,428.587402 1726.598389,422.996796 1735.534180,424.373108 
	C1738.769531,424.871429 1739.130127,427.645630 1740.379028,429.994965 
	C1744.838135,438.382538 1753.481812,440.192841 1760.307617,434.457947 
	C1762.124146,432.931793 1764.182251,431.106720 1763.763794,428.695709 
	C1761.952637,418.261383 1768.652588,412.921600 1775.929565,408.113586 
	C1780.119751,405.345154 1780.531128,402.179230 1778.926147,397.888977 
	C1775.045044,387.513885 1768.043213,385.340698 1758.848877,391.695465 
	C1757.017578,392.961212 1756.036621,394.491608 1756.082764,396.626465 
	C1756.154297,399.937134 1755.717896,403.439301 1756.656006,406.505737 
	C1757.873901,410.487183 1756.864136,413.273376 1753.525513,414.826599 
	C1749.505981,416.696533 1745.186890,417.061157 1741.366455,413.917816 
	C1740.872681,413.511658 1740.478516,412.897064 1740.224976,412.299744 
	C1736.147583,402.694763 1729.502808,397.844147 1718.591309,399.827698 
	C1714.975464,400.485016 1713.138062,397.350281 1712.547363,394.367920 
	C1711.723389,390.207153 1710.606323,385.497253 1715.165771,382.609528 
	C1718.316895,380.613800 1720.753052,377.932343 1723.506104,375.546875 
	C1727.848022,371.784454 1728.845093,367.827271 1726.311157,362.323029 
	C1723.459717,356.129608 1724.264282,355.316742 1731.005737,353.991211 
	C1732.947510,353.609375 1734.895142,353.217865 1736.796021,352.675903 
	C1739.531738,351.895813 1741.254150,352.670898 1742.103516,355.491852 
	C1742.579102,357.071289 1743.300293,358.594147 1744.053345,360.069733 
	C1748.905029,369.576660 1756.934082,370.819336 1765.862549,362.727509 
	C1765.241943,361.232727 1764.968140,360.321045 1765.588745,358.633240 
	C1770.270264,357.520477 1769.679932,354.257721 1770.069458,351.301025 
	C1770.912598,344.902161 1773.312866,342.395813 1778.334351,342.063751 
	C1782.922485,341.760345 1787.836792,345.876678 1789.531250,351.622467 
	C1790.898193,356.258453 1788.449829,359.238678 1784.802734,361.498962 
	C1783.403931,362.365906 1781.838013,362.970917 1780.326660,363.647034 
	C1774.327515,366.330994 1771.954712,369.504181 1772.933960,373.575928 
	C1774.288208,379.205566 1781.749146,384.525330 1787.265991,383.794861 
	C1792.798950,383.062256 1795.662720,379.787628 1795.977417,373.716553 
	C1796.080322,371.731812 1796.140869,369.727020 1795.985229,367.749939 
	C1795.417236,360.529846 1801.400635,359.436981 1805.944702,357.114410 
	C1810.752563,354.656982 1813.376343,357.915955 1815.614990,361.384247 
	C1816.903198,363.380493 1818.041016,365.352997 1821.302246,365.919006 
	C1822.255859,366.335175 1822.511841,366.667877 1822.384033,367.499695 
	C1828.366455,374.168243 1829.723389,374.566895 1834.539185,371.682434 
	C1839.298096,368.832062 1840.895020,365.141113 1839.646606,359.877686 
	C1838.096802,353.343903 1834.892822,350.311798 1829.167969,350.016479 
	C1827.838867,349.947876 1826.485229,349.858734 1825.173828,350.023956 
	C1818.667236,350.843597 1814.889038,348.699066 1812.649658,341.879944 
	C1809.393921,331.965729 1808.785889,332.168060 1819.497803,329.760254 
	C1820.144043,329.614990 1820.771240,329.384583 1821.406250,329.190216 
	C1829.531128,326.702972 1830.637939,327.197205 1833.255005,334.828064 
	C1833.788330,336.382904 1833.804077,338.109558 1834.277100,339.691681 
	C1836.756470,347.985168 1839.369507,349.112152 1847.281006,345.365448 
	C1849.086548,344.510406 1850.833740,343.532043 1852.640381,342.679352 
	C1860.518555,338.960815 1860.607178,338.957001 1862.015991,348.046814 
	C1862.438110,350.770630 1863.723145,353.051422 1864.738281,355.498627 
	C1866.469360,359.671967 1869.685547,360.641724 1873.682983,359.673523 
	C1876.894165,358.895691 1880.019165,357.214050 1883.395752,358.437408 
	C1887.277832,359.844025 1885.316284,364.521606 1887.836182,366.863586 
	C1889.015137,367.959412 1889.619263,369.652344 1890.585083,371.002289 
	C1895.247803,377.519531 1901.460449,379.007294 1908.679688,375.322174 
	C1912.412598,373.416626 1912.527222,369.879272 1911.656494,366.654999 
	C1910.715088,363.169006 1908.720703,359.980865 1907.381592,356.585541 
	C1905.488037,351.784454 1906.052246,350.451233 1911.125000,350.159332 
	C1915.233765,349.922882 1919.010254,348.801849 1922.701660,347.406860 
	C1928.443848,345.236908 1929.682739,343.050049 1928.476196,336.747864 
	C1927.278442,330.491760 1927.522461,325.039520 1933.854736,320.728180 
	C1934.499268,319.256805 1935.113892,318.627991 1936.433594,317.816925 
	C1941.576050,315.293396 1941.640991,312.128113 1938.652100,307.748474 
	C1937.679810,305.279053 1937.496948,303.361908 1937.574463,300.654663 
	C1938.122314,296.645508 1940.041504,294.244751 1942.892700,291.548950 
	C1946.334961,289.531616 1949.343140,289.085449 1953.254150,289.808502 
	C1958.061279,289.920044 1961.991089,289.678711 1962.332397,295.584930 
	C1962.477539,298.096863 1963.726196,300.673523 1967.282959,301.871002 
	C1968.646484,302.422882 1969.199341,302.940369 1969.958008,304.024658 
	C1970.966919,305.375854 1971.878662,305.864624 1973.605957,305.931580 
	C1975.913208,305.905701 1977.577515,306.087219 1979.517578,307.553925 
	C1986.534668,304.716858 1988.443359,301.764435 1987.625977,296.024780 
	C1987.487549,295.053589 1986.920654,294.149323 1986.727417,293.179108 
	C1985.334229,286.185822 1985.672852,285.552643 1991.553223,283.772125 
	C2000.263916,281.134613 2000.970703,281.401978 2003.845093,288.438171 
	C2004.849609,290.897156 2005.812866,293.373688 2006.855225,295.816528 
	C2008.364990,299.354980 2007.627808,301.102753 2003.474243,302.056976 
	C1990.736938,304.983124 1988.850098,307.881256 1990.124023,320.702911 
	C1990.870972,328.220947 1990.875977,328.239838 1984.090942,329.989075 
	C1974.748413,332.397675 1974.321045,332.643250 1971.603149,325.867065 
	C1967.334839,315.225830 1961.635376,313.332581 1951.554443,318.461700 
	C1945.693237,321.443817 1944.721191,326.009125 1948.482422,331.481476 
	C1952.266235,336.986389 1956.736938,339.233337 1963.655640,337.275055 
	C1971.605957,335.024872 1971.918091,335.600739 1974.332153,344.046051 
	C1975.320801,347.504791 1977.197754,350.751984 1976.932861,354.885529 
	C1972.053345,357.105713 1966.437012,355.327179 1961.510498,357.603149 
	C1959.272583,358.637115 1956.936401,357.624664 1956.030518,354.814240 
	C1955.418701,352.916138 1954.786133,351.017059 1954.021240,349.177338 
	C1951.319458,342.677368 1947.194214,340.685120 1939.546997,342.100128 
	C1934.351685,343.061432 1930.427002,347.650299 1930.031616,353.305176 
	C1929.938843,354.630066 1930.218262,355.998718 1930.003662,357.293793 
	C1929.462891,360.556702 1933.613525,363.901855 1930.644775,366.675293 
	C1928.344849,368.823853 1924.799561,369.640869 1921.805176,371.044250 
	C1916.140015,373.699371 1914.516968,377.929810 1916.571533,384.698792 
	C1918.255737,390.247711 1922.712891,393.760651 1927.336670,393.183319 
	C1933.970459,392.355011 1937.554688,388.701660 1937.971558,382.217590 
	C1938.099609,380.227478 1937.965576,378.221863 1938.007568,376.224548 
	C1938.097534,371.949432 1937.380127,367.569183 1943.375610,366.003540 
	C1950.960449,364.022858 1953.858643,364.523590 1958.052979,370.148865 
	C1958.448975,370.680176 1958.721313,371.302277 1959.101318,371.847260 
	C1966.326050,382.209473 1966.327515,382.208405 1978.169189,379.630371 
	C1985.745239,377.980988 1985.761841,377.980530 1985.988037,385.929138 
	C1986.054321,388.258423 1985.826294,390.606476 1986.032227,392.919281 
	C1986.472656,397.865784 1984.613770,401.244476 1979.904663,403.075317 
	C1976.207764,404.512604 1973.745972,406.905334 1973.993774,411.303070 
	C1974.162354,414.296753 1973.720947,417.635498 1977.078003,419.117401 
	C1980.637573,420.688782 1984.297485,420.575531 1987.233765,417.585205 
	C1989.576782,415.199280 1992.011841,412.467010 1991.175903,408.893402 
	C1989.640259,402.329987 1993.330322,399.809052 1999.290527,398.078918 
	C1999.773926,404.337006 1995.823853,409.528168 1994.673462,415.735107 
	C1993.760864,420.659607 1988.529419,422.837128 1983.398682,424.174408 
	C1975.441528,426.248352 1974.145508,429.350189 1978.238770,436.232025 
	C1980.870850,440.656982 1983.101440,445.824310 1989.560181,447.476318 
	C1990.757812,449.178864 1990.603516,450.426117 1990.301025,451.698730 
	C1989.624878,454.543304 1988.591187,457.778564 1991.907349,459.443390 
	C1996.379517,461.688629 1996.981201,457.040100 1999.459229,454.429230 
	C2003.523438,454.375854 2004.494751,456.691895 2003.671143,459.629913 
	C2002.397827,464.172760 2000.434937,468.415710 1995.256958,469.763458 
	C1988.458252,471.533051 1983.520996,468.975586 1980.834473,461.121094 
	C1979.149048,456.193817 1976.797974,452.213013 1972.321777,448.611572 
	C1971.433838,447.136261 1971.306274,446.175232 1971.492188,445.188721 
	C1972.102173,441.950592 1973.253174,438.452759 1969.596069,436.315704 
	C1965.987793,434.207306 1963.427002,436.913025 1960.812012,438.864624 
	C1959.744141,439.661560 1958.599487,440.278137 1956.639404,440.265015 
	C1950.061523,435.985718 1944.484131,439.626587 1938.916504,441.045715 
	C1936.437866,441.677490 1935.672852,444.545288 1936.113647,446.873260 
	C1937.716675,455.339355 1933.457642,459.060547 1925.822388,460.336975 
	C1925.507568,460.389587 1925.218750,460.606049 1924.921875,460.754395 
	C1916.924805,464.751068 1916.082642,466.274872 1916.484863,475.569153 
	C1912.672485,477.435913 1910.753540,475.102417 1908.326416,472.626892 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1614.129150,271.298187 
	C1607.943115,272.609528 1607.471802,276.815125 1608.302124,281.408508 
	C1609.117920,285.921204 1614.552734,290.107880 1619.155396,289.880188 
	C1621.411255,289.768585 1623.625244,288.879395 1625.865967,288.376526 
	C1630.308350,287.379486 1632.933960,288.489563 1634.929688,293.283539 
	C1639.754639,304.873322 1639.386597,306.302551 1627.218994,309.826233 
	C1620.415771,311.796387 1618.554199,315.087372 1620.415649,322.213531 
	C1621.327026,325.701996 1624.005737,328.593964 1623.505249,333.751678 
	C1620.530884,336.689606 1617.502319,336.484009 1614.084473,337.565125 
	C1611.881348,337.863831 1610.454102,337.676666 1608.563721,336.470703 
	C1601.596558,334.540344 1602.302490,328.598358 1600.765259,324.186920 
	C1600.170654,322.480530 1602.006470,321.317657 1603.378052,320.344299 
	C1606.887695,317.853333 1610.405884,315.373596 1613.885376,312.841003 
	C1617.628052,310.116882 1618.465698,307.032562 1616.355347,302.514221 
	C1611.781006,292.720612 1609.596069,291.299164 1598.811279,293.453369 
	C1594.061035,294.402191 1590.697388,294.371704 1589.523926,288.114319 
	C1588.336792,281.784790 1584.322998,277.551575 1576.936035,277.726715 
	C1574.377319,277.787384 1571.812622,276.244659 1569.210083,276.082367 
	C1563.975952,275.755920 1562.641968,272.286621 1562.111206,268.064026 
	C1561.512573,263.300781 1564.115723,261.436676 1568.315186,259.407745 
	C1576.627197,255.391724 1580.205444,261.051575 1585.293213,265.878479 
	C1586.255859,266.335175 1586.511841,266.667877 1586.384033,267.499695 
	C1586.257812,271.453857 1587.928345,273.809387 1591.535889,273.826660 
	C1595.751953,273.846893 1599.257080,272.065399 1601.683716,268.479187 
	C1604.282959,264.638306 1604.238770,260.262177 1603.963135,255.934448 
	C1603.634888,250.784027 1605.043823,248.373901 1610.964233,247.703827 
	C1617.221436,246.995651 1621.942383,246.605804 1624.078247,253.860352 
	C1624.600830,255.635544 1626.230103,257.222992 1627.661133,258.565826 
	C1631.369873,262.046082 1635.390015,265.295349 1640.947510,263.213531 
	C1645.325317,261.573578 1649.489990,252.932327 1648.851685,247.615326 
	C1648.021118,240.696976 1656.986084,232.636246 1663.628174,234.314163 
	C1666.723267,235.096069 1667.225708,237.545364 1668.115723,240.203979 
	C1671.277588,249.647385 1678.286011,252.534103 1686.839722,248.567535 
	C1690.724854,246.765854 1692.409180,244.011749 1691.911987,239.860229 
	C1691.380005,235.417694 1689.226196,231.568497 1686.611694,228.168625 
	C1684.195801,225.027039 1680.716431,225.991135 1677.426147,227.181458 
	C1674.043457,228.405090 1670.440063,228.585083 1668.807861,224.780670 
	C1666.882812,220.293549 1664.287109,215.517456 1667.176392,210.498291 
	C1669.052490,207.239288 1675.479126,206.910782 1678.772583,210.089020 
	C1681.124756,212.359055 1682.940308,215.253754 1684.702148,218.054092 
	C1689.627686,225.882568 1691.771484,226.127335 1699.865967,218.721771 
	C1700.225464,216.221222 1701.330200,215.097549 1703.401001,214.125214 
	C1708.295532,213.431183 1708.535400,210.439240 1707.429321,207.374832 
	C1705.831787,202.948471 1703.724609,198.608109 1698.158936,198.116135 
	C1695.188599,197.853561 1692.170288,198.160141 1689.193481,197.940445 
	C1684.062988,197.561783 1680.799805,194.230148 1680.182861,189.139694 
	C1679.556152,183.969406 1683.091797,182.087799 1686.986816,180.713776 
	C1692.457886,178.783737 1695.935303,180.221848 1698.517456,185.174088 
	C1698.976318,186.054382 1699.524536,186.961227 1699.682617,187.913712 
	C1701.108765,196.514084 1705.074463,196.969299 1713.894287,195.493713 
	C1718.094360,194.791000 1721.605103,193.602325 1724.446167,197.749985 
	C1726.768188,201.139694 1726.482422,208.105927 1723.864746,211.934006 
	C1722.208130,214.356689 1718.663208,215.156570 1718.088623,219.287659 
	C1712.451660,221.280945 1711.673462,225.486649 1712.439087,230.020096 
	C1713.171509,234.357025 1716.303467,236.819290 1720.584717,237.772156 
	C1730.998047,240.089722 1735.303833,236.448135 1734.839722,225.501007 
	C1734.632568,220.614868 1736.858032,216.825150 1740.906860,215.011200 
	C1744.757446,213.286102 1749.351196,212.511551 1752.548584,217.044128 
	C1753.538818,218.447784 1754.844116,219.424973 1757.274170,219.906097 
	C1758.256226,220.334457 1758.512329,220.667679 1758.384277,221.500763 
	C1761.592407,229.208694 1763.527466,230.207596 1769.790405,228.086899 
	C1777.485718,225.481171 1777.527954,225.459000 1781.251099,232.541168 
	C1782.640015,235.183472 1783.825806,237.937271 1784.992920,240.687393 
	C1785.212158,241.203949 1784.904419,241.943985 1784.794922,243.023514 
	C1780.679565,244.729568 1775.832642,243.769485 1771.536621,245.623352 
	C1769.253662,246.608612 1766.963989,245.565018 1765.692383,243.127365 
	C1764.769653,241.358078 1763.836548,239.594101 1762.910889,237.826263 
	C1759.065552,230.482208 1751.939941,227.634949 1745.128418,230.721848 
	C1739.555054,233.247604 1737.261841,240.733215 1739.901733,247.782928 
	C1742.839844,255.629410 1742.099243,257.000916 1733.946411,257.970123 
	C1729.197388,258.534760 1724.500977,258.675690 1723.981445,265.207977 
	C1723.421753,272.243011 1725.409424,276.089172 1731.569336,278.723724 
	C1736.864258,280.988312 1740.597046,279.862427 1744.566284,274.932251 
	C1746.708008,272.271881 1748.377686,269.500275 1748.016235,265.890717 
	C1747.459717,260.329803 1751.886475,258.523529 1755.593018,256.599396 
	C1758.114746,255.290390 1760.826172,256.014801 1762.351074,258.927734 
	C1762.813965,259.811707 1763.299805,260.684113 1763.793213,261.551544 
	C1768.696777,270.170532 1773.444092,272.032440 1783.342163,269.224182 
	C1790.839233,267.097168 1792.781250,263.491150 1791.040771,255.940323 
	C1790.298218,252.718842 1786.562378,249.205811 1790.519043,246.058746 
	C1794.470703,242.915787 1799.404419,243.656799 1803.982422,244.473007 
	C1806.699585,244.957458 1811.772949,253.581223 1811.640015,256.639618 
	C1811.577759,258.071289 1810.975830,259.177032 1809.563965,259.685730 
	C1807.375977,260.474091 1805.169922,261.211609 1802.984741,262.007294 
	C1793.382202,265.504089 1791.892700,267.104492 1792.122437,277.126831 
	C1792.267944,283.480835 1790.376221,287.773956 1784.662476,290.973267 
	C1780.071655,293.543793 1778.086670,298.261230 1778.005737,303.637878 
	C1777.869019,312.715485 1781.962524,316.026398 1791.044312,314.122803 
	C1792.342773,313.850647 1793.661011,313.672821 1794.957520,313.392303 
	C1802.146362,311.836945 1803.071411,312.443726 1803.978027,319.417419 
	C1804.063232,320.073792 1804.088989,320.753632 1804.024780,321.411102 
	C1803.685791,324.885101 1808.070068,329.371246 1801.963379,331.612427 
	C1796.567261,333.592834 1789.874390,331.659363 1786.792236,327.259277 
	C1785.844849,325.906708 1785.264893,324.302643 1784.390381,322.892090 
	C1780.290405,316.278320 1776.410400,315.099701 1769.494019,318.225677 
	C1762.136230,321.551178 1755.495117,325.080292 1759.171021,335.313995 
	C1760.059570,337.787445 1751.103027,347.246246 1748.354736,347.273987 
	C1745.476074,347.303131 1744.089600,345.136536 1744.199951,342.657532 
	C1744.402344,338.107666 1741.747559,334.467438 1740.571533,329.653229 
	C1744.346191,327.305511 1749.155518,327.078827 1752.839966,324.282074 
	C1756.288940,321.664154 1758.607300,319.018951 1758.047363,314.422180 
	C1757.767944,312.126862 1758.154785,309.756836 1757.970825,307.442047 
	C1757.545044,302.087860 1759.205200,298.680328 1764.972778,297.224243 
	C1769.135620,296.173309 1773.406860,293.819672 1773.760864,288.770966 
	C1774.171997,282.907745 1770.557739,278.672150 1766.120850,275.527649 
	C1761.914795,272.546722 1758.736206,275.008545 1756.118164,279.308716 
	C1755.868164,280.691742 1755.520020,281.256500 1754.492676,281.854797 
	C1749.809326,282.534576 1749.999512,285.685883 1750.008423,288.711029 
	C1750.020996,293.001923 1750.636719,297.442993 1745.115479,299.311554 
	C1739.603638,301.177032 1735.041992,299.877991 1730.313965,294.741730 
	C1729.451416,293.804657 1728.372681,293.066437 1726.696899,292.117615 
	C1724.169189,285.614655 1718.937622,286.009399 1713.955933,286.014832 
	C1709.907959,286.019257 1706.295532,285.992950 1703.746826,281.639984 
	C1698.622925,272.889099 1699.024292,270.927307 1708.361938,266.886292 
	C1708.969116,266.623505 1709.595703,266.395142 1710.229858,266.206512 
	C1714.987305,264.791412 1719.624512,261.913544 1719.410278,257.050262 
	C1719.169189,251.573029 1716.498291,245.835602 1711.185669,242.988312 
	C1705.792725,240.097992 1700.944946,243.298889 1696.348755,246.069702 
	C1694.399536,247.244751 1694.047852,249.182953 1694.035889,251.245117 
	C1694.018555,254.235428 1693.817017,257.240601 1694.044189,260.212646 
	C1694.383423,264.654541 1692.909668,267.498932 1688.770508,269.793762 
	C1680.922852,274.144562 1675.956543,280.366730 1679.012695,290.195068 
	C1680.070679,293.597046 1678.059570,295.195160 1675.186523,295.902405 
	C1666.177124,298.120270 1662.735718,303.855652 1663.939575,312.875671 
	C1664.239746,315.125702 1664.392090,317.671936 1662.757568,319.575989 
	C1660.262451,322.482330 1657.000244,324.111206 1653.108276,323.786591 
	C1649.065186,323.449371 1647.765503,320.088623 1646.728271,316.963074 
	C1645.551025,313.415283 1645.122681,309.639252 1648.625244,306.962341 
	C1651.253052,304.953918 1654.273438,303.454224 1656.871826,301.413391 
	C1660.472290,298.585693 1661.622192,293.089020 1658.426880,290.028778 
	C1654.093628,285.878784 1649.873169,280.012634 1642.319702,282.922028 
	C1636.863770,285.023468 1634.270996,282.043762 1632.256104,277.774933 
	C1631.693848,276.583923 1631.490356,275.225494 1630.944702,274.024597 
	C1626.698120,264.676941 1621.426392,263.993500 1614.129150,271.298187 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1148.819092,402.234161 
	C1145.955811,402.484161 1143.720947,402.621552 1140.738281,403.155212 
	C1138.103149,403.916626 1136.209839,404.042084 1133.649170,403.466003 
	C1127.100952,398.697205 1122.093140,402.422607 1116.433350,405.366638 
	C1115.909546,405.781433 1116.084106,406.430267 1116.141357,406.761292 
	C1114.285645,407.790985 1112.330200,408.057098 1109.626831,407.418365 
	C1104.634399,405.221863 1103.117310,400.978729 1100.826904,397.358185 
	C1098.979248,394.437561 1098.484375,389.815491 1093.484253,390.517090 
	C1089.286621,391.106049 1087.539307,394.381012 1086.447876,398.081848 
	C1085.974243,399.688110 1085.316406,401.210693 1083.708008,402.987671 
	C1082.658936,403.862061 1082.074463,404.175568 1081.511719,404.522156 
	C1070.231689,411.468872 1070.232788,411.470703 1060.119019,399.508057 
	C1057.490479,399.468018 1055.776978,398.900635 1054.262207,396.653229 
	C1053.658936,392.924255 1052.260376,392.004181 1049.287598,393.356171 
	C1046.394897,394.671753 1043.370728,397.420563 1040.145142,394.599854 
	C1037.090332,391.928619 1035.716187,387.999756 1034.499634,384.243683 
	C1033.517944,381.212463 1035.580322,379.339783 1038.120972,377.978485 
	C1041.851807,375.979462 1045.497681,374.916077 1049.114868,378.233215 
	C1051.398315,380.327240 1052.885376,382.986267 1053.638916,385.840240 
	C1054.651855,389.677094 1057.263794,390.125061 1061.225830,389.997223 
	C1063.848022,388.111572 1065.716797,386.271332 1069.367310,387.546509 
	C1079.940796,387.141052 1080.985107,385.966888 1079.152466,376.549988 
	C1078.010742,370.683746 1079.162842,365.599701 1083.569092,360.576843 
	C1084.759521,359.214111 1085.677612,358.918274 1087.377197,359.557678 
	C1092.685425,359.480225 1094.187134,357.288666 1092.573730,352.591064 
	C1090.472900,346.474182 1092.906006,341.704498 1098.060425,338.209290 
	C1104.638916,333.748322 1111.068359,335.968872 1113.495483,343.472565 
	C1116.453369,352.617096 1116.453491,352.617065 1127.444336,350.559204 
	C1134.576172,345.821564 1133.332275,339.287415 1133.550049,332.527649 
	C1134.144775,329.626770 1133.554077,327.158447 1135.465088,324.475800 
	C1144.706909,317.576202 1150.880981,318.050873 1157.526123,325.709717 
	C1159.692505,328.206696 1161.142334,331.388580 1164.092041,333.125366 
	C1167.253540,334.986816 1170.975342,335.364288 1172.990967,332.080933 
	C1175.306030,328.309998 1172.034180,326.046234 1169.048828,324.390900 
	C1166.368896,322.904877 1163.284180,322.965515 1160.320801,322.599609 
	C1156.645996,322.145874 1152.926880,321.698883 1151.786865,316.673767 
	C1149.410278,305.649323 1151.525269,301.613739 1161.413940,298.036255 
	C1169.344727,295.167053 1170.380127,293.079437 1167.958984,284.839752 
	C1166.061401,278.381195 1168.854614,273.086853 1175.497070,270.551636 
	C1181.172241,268.385620 1186.779419,270.496368 1189.931396,275.928070 
	C1191.292603,278.273743 1191.701904,280.881409 1192.379028,283.446259 
	C1193.032593,285.922272 1194.976440,286.089813 1197.543335,284.513031 
	C1200.747070,280.177887 1204.326782,279.185455 1209.344971,281.429138 
	C1215.449463,284.031921 1217.447632,288.935272 1219.906250,293.577423 
	C1221.669556,296.906616 1223.905273,300.267731 1227.881226,294.685181 
	C1232.969482,289.239349 1234.651123,284.729980 1226.491943,280.473267 
	C1217.413330,281.755707 1213.986938,279.405243 1212.552856,270.778900 
	C1211.476685,264.305511 1217.308960,255.079193 1223.072144,254.757660 
	C1227.698853,254.499527 1230.892578,258.473877 1232.041626,261.615479 
	C1235.346802,270.653168 1238.984619,277.199707 1250.223999,272.266022 
	C1252.011597,271.481354 1253.940918,273.096893 1255.157227,274.900635 
	C1259.969360,282.036774 1258.874268,289.846558 1251.571533,294.892975 
	C1247.589966,297.644287 1244.373291,300.556885 1242.534912,305.094574 
	C1237.965210,316.373322 1231.821655,319.263306 1218.760132,316.091492 
	C1216.078247,314.932098 1215.226196,313.029419 1214.138672,310.599121 
	C1213.688477,307.183777 1212.218018,305.571564 1209.374634,306.576263 
	C1206.309204,307.659424 1203.142578,308.820221 1202.214844,312.663300 
	C1200.602417,319.343842 1205.140259,326.342743 1211.909424,325.782867 
	C1218.697876,325.221436 1221.168335,329.817749 1224.402588,333.748077 
	C1226.796631,336.657349 1226.602173,340.047363 1224.006592,342.743744 
	C1221.302979,345.552246 1218.177612,348.839691 1213.849487,346.446625 
	C1211.137451,344.947113 1208.618042,343.795105 1204.769531,344.001160 
	C1193.235229,341.153503 1193.235229,341.153503 1192.335693,353.411194 
	C1192.238159,357.085938 1188.834595,358.100739 1188.100830,361.343445 
	C1181.475952,366.032471 1174.060059,369.055420 1170.489014,377.497742 
	C1168.722290,382.180115 1167.444702,386.361450 1166.083496,391.270203 
	C1163.437866,394.902283 1159.271484,395.696960 1156.461914,399.329285 
	C1155.084717,400.192413 1154.176147,400.619049 1152.627197,401.443024 
	C1151.138306,401.915863 1150.291870,402.008759 1148.819092,402.234161 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2292.520264,83.516891 
	C2289.222168,84.000275 2286.444336,84.000847 2282.833252,84.001556 
	C2277.314209,83.434402 2273.707031,80.437981 2269.620605,78.517143 
	C2261.868164,74.873062 2259.248047,76.276329 2257.780518,84.884865 
	C2257.384521,87.207893 2256.285156,89.152008 2254.471680,91.505280 
	C2249.729980,94.513908 2246.670166,98.970894 2240.692871,99.928223 
	C2234.435303,99.369682 2231.266846,95.733215 2229.030518,91.069847 
	C2227.493408,87.864769 2226.891846,83.653343 2221.605957,85.402611 
	C2217.849854,86.645561 2214.931641,88.611046 2215.478027,93.130005 
	C2216.005127,97.490494 2216.846680,101.822205 2222.162842,102.937302 
	C2226.593506,103.866623 2231.580566,102.999863 2235.508789,107.516792 
	C2234.057129,119.935997 2234.057129,119.935997 2220.863281,120.000046 
	C2219.109375,113.511383 2214.027588,112.488983 2208.991211,112.135788 
	C2204.977783,111.854332 2201.115967,111.453125 2197.283447,110.128090 
	C2192.127197,108.345451 2189.055908,104.599075 2187.062012,99.872581 
	C2184.701904,94.277466 2185.566406,91.008804 2191.128174,88.575874 
	C2198.177490,85.492279 2202.764160,81.317719 2202.730957,73.061943 
	C2202.722168,70.860504 2203.974854,68.598000 2204.876709,66.459961 
	C2207.030518,61.354542 2211.739746,57.957397 2216.172852,58.127895 
	C2220.451172,58.292439 2226.328125,63.258400 2227.640625,67.970398 
	C2227.992188,69.231819 2227.793701,70.638145 2228.072510,71.929466 
	C2229.319824,77.708046 2231.044434,78.526299 2236.297363,75.776329 
	C2237.759766,75.010689 2238.933105,73.485085 2240.448486,73.067078 
	C2245.275146,71.735733 2246.983643,68.710213 2245.632324,64.106110 
	C2244.378662,59.836468 2242.586182,55.702656 2237.005859,56.051128 
	C2229.447998,56.523098 2224.240967,52.342384 2220.215576,46.910122 
	C2217.138428,42.757851 2213.248291,40.673363 2208.592529,40.191509 
	C2200.111572,39.313732 2195.761230,34.640942 2193.722900,26.669670 
	C2192.039795,20.087990 2190.176270,18.849220 2184.812988,21.811195 
	C2173.644531,27.979242 2163.934082,20.797358 2161.164551,10.371232 
	C2160.740723,8.776549 2160.404785,7.158536 2160.014160,4.791150 
	C2169.378662,4.026091 2178.757080,4.021165 2189.067871,4.026327 
	C2196.816650,14.297396 2199.897705,14.457481 2209.525879,4.529793 
	C2226.041748,4.029292 2242.083740,4.025289 2259.062744,4.032602 
	C2264.514160,10.235482 2266.383301,16.705788 2260.657715,23.046593 
	C2256.446777,27.710075 2247.113037,27.739805 2240.100342,23.729906 
	C2236.613281,21.735928 2234.149414,18.266687 2230.427002,16.712250 
	C2226.412354,15.035849 2221.994385,14.981714 2220.181641,19.536657 
	C2218.360352,24.112780 2221.346680,27.891903 2225.758057,28.288605 
	C2236.651855,29.268234 2245.710449,32.622429 2251.715088,42.498421 
	C2253.245850,45.015945 2256.571533,43.970707 2259.114990,42.978481 
	C2262.122314,41.805225 2261.255615,39.484520 2260.960449,37.103451 
	C2259.288818,23.618855 2260.404297,21.130869 2273.594727,15.336528 
	C2279.358398,12.804688 2275.578369,8.366112 2277.560547,4.592086 
	C2293.375244,4.030221 2308.750244,4.024916 2325.062744,4.030658 
	C2329.708496,7.768929 2333.324463,11.534311 2335.223389,16.623672 
	C2336.104248,18.984549 2336.817871,22.207954 2340.492920,20.889526 
	C2343.690674,19.742290 2344.698486,17.008007 2344.244629,13.711666 
	C2343.849121,10.839846 2342.034424,8.152504 2343.559570,4.561861 
	C2353.378662,4.028254 2362.757080,4.020751 2373.067871,4.022005 
	C2378.436279,9.917229 2376.943604,15.836888 2372.144287,19.919870 
	C2364.638916,26.305408 2367.322754,30.068249 2373.482910,35.227146 
	C2378.698242,39.595081 2385.953857,43.745502 2382.467285,53.442883 
	C2382.192139,58.580753 2380.866211,61.922974 2374.751465,61.989159 
	C2366.326172,66.135735 2363.428223,60.457016 2362.432617,55.084377 
	C2361.105225,47.920700 2357.288818,46.908669 2350.701416,47.995098 
	C2348.500000,48.002068 2347.000000,48.001961 2344.750000,48.002052 
	C2337.047607,51.041351 2334.722656,45.774254 2331.983887,41.288258 
	C2330.458496,38.790131 2329.425049,35.428932 2325.596680,36.160252 
	C2322.122314,36.823959 2321.194092,39.985096 2320.615234,42.919716 
	C2319.010254,51.057266 2316.520752,58.192608 2307.222168,60.767429 
	C2300.336426,62.674202 2294.836426,61.465309 2290.410400,55.816303 
	C2289.183594,54.250301 2288.233398,52.491985 2287.022217,50.911903 
	C2284.955811,48.216007 2282.274414,47.364727 2279.109375,48.465343 
	C2277.061035,49.177608 2275.841797,50.651924 2276.155762,53.016380 
	C2276.605713,56.404541 2278.555420,58.373989 2281.876465,58.967999 
	C2285.453613,59.607819 2289.145020,59.778442 2292.425781,61.590454 
	C2296.981445,64.106598 2300.624512,67.534927 2301.103027,72.947884 
	C2301.601318,78.582008 2297.308838,80.923332 2292.520264,83.516891 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1422.644043,405.744324 
	C1420.039673,404.245911 1417.741211,404.294800 1414.643555,404.225952 
	C1412.903442,404.005371 1412.131958,403.510406 1411.184082,402.180115 
	C1409.915039,396.455017 1413.434082,393.041718 1415.939453,388.550598 
	C1416.811401,387.298065 1417.353271,386.626862 1418.324219,385.510925 
	C1419.437378,384.065887 1420.010742,383.032471 1420.112549,381.173035 
	C1420.157471,379.262726 1420.410400,378.029388 1421.535889,376.451569 
	C1423.656250,369.520050 1427.570923,365.185791 1433.591675,362.085419 
	C1440.128540,358.719116 1441.502319,354.703796 1439.512207,347.704437 
	C1438.712158,344.890381 1437.312012,342.246918 1436.092529,338.763519 
	C1435.650391,337.667572 1435.300781,337.333893 1435.475586,336.499756 
	C1440.593384,335.812622 1445.122314,336.273834 1449.664795,334.298187 
	C1455.523315,331.750122 1458.483276,328.371490 1458.159180,321.524414 
	C1457.753540,312.952118 1458.992676,311.890411 1465.903320,310.368774 
	C1472.975098,308.811707 1476.193848,309.929199 1479.356812,316.934296 
	C1484.420166,328.148499 1488.909302,325.670929 1496.666382,322.618103 
	C1500.572266,321.080811 1502.251465,318.229248 1502.015015,314.068329 
	C1501.883423,311.753204 1502.115234,309.417236 1501.979370,307.102600 
	C1501.695923,302.272888 1503.168579,299.374908 1508.295288,297.446503 
	C1517.629883,293.935333 1518.786377,290.392395 1515.860352,280.464630 
	C1513.629395,272.895386 1513.996704,272.193329 1521.396362,270.078064 
	C1522.978149,269.625885 1524.661377,269.441772 1526.164429,268.814514 
	C1534.490967,265.339355 1536.396851,260.956848 1533.226807,252.653366 
	C1532.412476,250.520538 1531.368896,248.475281 1530.400757,246.323624 
	C1533.666504,242.240372 1540.518677,243.292526 1541.913452,236.708344 
	C1542.131104,235.307938 1542.479980,234.743668 1543.507324,234.145721 
	C1548.914429,233.292679 1547.745850,229.437332 1548.012695,226.294617 
	C1548.699707,218.204788 1551.197998,215.070755 1558.736816,212.754211 
	C1563.727417,211.220688 1565.964844,212.275406 1568.018311,217.129349 
	C1571.347046,224.997543 1570.709595,227.684967 1564.186157,233.109375 
	C1562.386230,234.605988 1560.646606,236.129272 1560.081787,239.291992 
	C1554.967285,240.634979 1554.401001,245.450272 1554.558105,248.326340 
	C1554.968140,255.829590 1550.897583,258.825226 1545.053833,261.609802 
	C1536.321533,265.770874 1535.698608,276.496979 1543.474487,282.263916 
	C1547.065186,284.927002 1551.185181,284.024872 1555.074585,283.911133 
	C1559.325073,283.786926 1561.831665,285.428009 1563.677246,289.188995 
	C1566.827271,295.608704 1566.899292,301.462830 1563.400879,303.690582 
	C1556.667236,307.978455 1549.132568,306.368286 1544.810181,299.649384 
	C1543.903809,298.240265 1543.164795,296.752350 1540.701050,296.117676 
	C1539.312744,295.856964 1538.736694,295.528015 1538.144043,294.491364 
	C1537.699341,292.303558 1537.209473,290.708008 1535.244507,290.294983 
	C1526.172119,288.388031 1518.792236,295.406982 1520.420654,304.370331 
	C1521.798096,311.952209 1521.782104,311.913361 1514.171509,315.015533 
	C1512.018555,315.893097 1509.989014,317.072540 1507.901367,318.110565 
	C1503.815308,320.142181 1503.483765,323.776886 1504.307373,327.524109 
	C1505.594116,333.378235 1513.261963,340.310577 1519.494019,339.777069 
	C1528.788818,338.981415 1531.199463,345.665802 1534.688721,351.559235 
	C1535.866577,353.548645 1535.499023,355.373169 1533.667114,356.838959 
	C1527.423218,361.834381 1520.016724,360.301361 1516.062012,353.199768 
	C1510.978149,344.070465 1503.188354,343.116455 1494.139893,351.265442 
	C1489.383423,352.422180 1487.538574,355.122742 1488.288940,359.481110 
	C1489.070801,364.023468 1491.751099,366.602356 1496.622070,365.973450 
	C1505.023926,364.888672 1510.391968,369.630829 1514.679565,375.762360 
	C1516.354126,378.157135 1519.335571,381.223694 1515.908447,384.583008 
	C1513.107300,387.328674 1505.655396,388.353271 1503.191284,385.915283 
	C1499.903687,382.662659 1495.680664,380.429169 1493.076172,376.453888 
	C1489.778320,371.420471 1484.734131,371.051331 1479.800049,372.567505 
	C1474.457886,374.209137 1473.671753,378.963837 1473.984009,383.941620 
	C1474.087646,385.594513 1474.059814,387.262604 1473.983032,388.918701 
	C1473.668823,395.694855 1470.025635,398.660065 1462.948486,397.949982 
	C1458.230103,397.476624 1455.740601,393.650696 1456.053589,387.821320 
	C1456.379761,381.748505 1461.064331,378.133392 1463.909912,372.716187 
	C1467.687988,371.667694 1469.517090,368.962677 1469.208984,365.966797 
	C1468.816528,362.149658 1467.873657,358.140991 1464.918945,355.174713 
	C1464.499146,354.753296 1463.776733,354.535248 1463.158447,354.424438 
	C1454.670166,352.902618 1444.016113,361.196014 1444.178345,370.070923 
	C1444.306763,377.095001 1442.453491,381.944916 1436.011475,385.391693 
	C1428.443359,389.441101 1430.018066,397.069855 1430.005859,404.743530 
	C1429.073486,405.737305 1428.140503,405.893646 1426.508057,406.187622 
	C1424.965698,406.165314 1424.121704,406.010956 1422.644043,405.744324 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1584.282471,444.971893 
	C1583.181030,445.512360 1582.209106,445.383392 1580.618774,444.839996 
	C1577.454224,436.907562 1577.231323,428.957977 1575.993042,421.218536 
	C1575.128662,415.816833 1579.903198,413.295197 1584.031860,410.905548 
	C1587.719238,408.771423 1592.439819,407.021362 1591.420166,401.518921 
	C1590.344604,395.715393 1585.446899,394.828247 1580.605713,394.839874 
	C1574.432617,394.854706 1569.667725,392.524200 1566.121826,387.515625 
	C1565.355103,386.432678 1564.359253,385.518890 1563.364014,384.632477 
	C1560.374390,381.969666 1557.075562,380.718719 1553.389404,383.089539 
	C1550.267334,385.097504 1548.968262,388.073822 1550.089355,391.711914 
	C1551.411499,396.002411 1554.881714,397.198700 1558.800537,396.576324 
	C1565.997192,395.433350 1571.490845,397.134491 1573.590820,404.732422 
	C1575.446899,411.448120 1574.770874,417.793945 1567.304199,420.494110 
	C1561.049805,422.755859 1558.837646,427.400238 1557.046875,433.717316 
	C1556.203003,434.658783 1555.787964,434.965790 1554.639648,435.536194 
	C1549.020996,436.320923 1544.792114,434.135162 1539.879395,432.028198 
	C1537.115967,426.529572 1540.828369,424.363251 1543.953125,421.976929 
	C1547.392944,419.349945 1549.596191,416.319031 1547.371582,411.866058 
	C1545.924561,408.969543 1543.556152,407.089447 1540.212891,407.893463 
	C1535.190186,409.101257 1533.791016,413.081482 1533.697632,417.693573 
	C1533.631592,420.946533 1534.695679,424.251099 1532.759888,427.990723 
	C1530.051636,430.147491 1527.837646,429.179108 1524.979736,428.122070 
	C1522.450684,426.763275 1520.630859,425.443756 1517.558350,425.848206 
	C1513.986694,425.807587 1511.642456,424.088654 1508.502075,422.788666 
	C1507.271729,416.664429 1509.099609,412.657501 1514.742065,410.503021 
	C1517.170532,409.575714 1519.139771,407.510803 1521.494995,406.310699 
	C1524.932983,404.558929 1526.552246,401.773407 1525.917236,398.176147 
	C1524.755615,391.597717 1527.758789,387.295166 1532.966797,384.143585 
	C1540.059204,379.851685 1543.219849,374.195526 1540.390015,365.852509 
	C1539.417236,362.984650 1540.707275,360.763367 1543.511108,359.335358 
	C1547.584595,357.260681 1553.982056,357.466614 1556.650024,360.160858 
	C1557.798584,361.320831 1558.442383,362.963745 1559.492432,364.241913 
	C1561.615723,366.826508 1564.017700,369.047272 1567.118652,370.547821 
	C1572.186768,373.000214 1576.962158,372.355804 1581.201782,369.088470 
	C1585.669434,365.645355 1584.603760,360.377014 1583.442505,356.141815 
	C1582.189819,351.572632 1578.583984,348.231323 1573.198364,348.042480 
	C1570.868530,347.960815 1568.508789,348.190430 1566.208740,347.905914 
	C1560.531372,347.203613 1553.205811,336.542145 1554.791626,331.296631 
	C1555.431152,329.181122 1557.312378,328.333313 1559.426392,328.065918 
	C1568.878906,326.870270 1572.092529,320.982910 1572.106812,312.069275 
	C1572.116333,306.141968 1574.624146,303.601807 1580.029419,302.329895 
	C1585.456055,301.052917 1587.996216,302.400665 1591.084717,308.170471 
	C1596.100342,317.540405 1594.323242,319.858582 1586.564331,322.726807 
	C1585.633789,323.070831 1584.747681,323.570343 1583.896851,324.089355 
	C1577.440918,328.027191 1575.450928,331.369995 1576.930786,335.722809 
	C1579.303345,342.701447 1584.946899,346.481018 1592.008911,344.855255 
	C1596.672607,343.781616 1598.906006,345.146423 1600.184448,349.451874 
	C1600.641113,350.990295 1601.717285,352.364380 1602.607300,353.751434 
	C1608.777588,363.367798 1613.753296,364.224976 1624.022949,356.102905 
	C1625.482178,352.304230 1627.770874,349.958710 1624.839355,346.503906 
	C1623.478638,344.362976 1622.737183,342.663971 1622.123047,340.130005 
	C1621.919922,337.881683 1622.216553,336.451416 1623.524414,334.576721 
	C1628.323975,334.001221 1632.647949,334.013245 1636.971924,334.000427 
	C1640.715576,333.989319 1644.184814,334.036987 1645.916626,338.512665 
	C1647.637939,342.961273 1647.718384,346.849487 1644.252319,350.413574 
	C1642.895874,351.808350 1640.736816,352.437897 1640.112549,355.317810 
	C1639.666992,356.254120 1639.333984,356.510712 1638.500488,356.383667 
	C1633.979858,356.319977 1632.375854,358.622681 1631.972168,362.522064 
	C1631.402466,368.024994 1633.365601,372.890869 1635.677612,378.132751 
	C1631.756592,380.963379 1627.177734,380.976501 1623.322510,381.423096 
	C1617.844971,382.057709 1614.456543,377.835236 1612.397461,372.881653 
	C1608.911621,364.496216 1601.181274,364.310669 1594.215210,369.145538 
	C1589.992432,372.076355 1589.013306,376.329468 1590.846313,381.503479 
	C1592.497681,386.164490 1595.545776,388.145721 1600.652954,388.125031 
	C1604.479614,388.109497 1608.259888,384.192139 1612.013550,387.616821 
	C1615.661133,390.944702 1613.044067,395.961304 1614.883301,399.904053 
	C1616.368896,403.088531 1614.220825,404.768158 1611.681152,406.125824 
	C1609.057251,407.528534 1606.339966,408.730652 1604.121948,410.863434 
	C1597.097534,417.618073 1598.974365,426.028839 1609.237183,429.986084 
	C1610.770996,429.239532 1611.691162,428.944946 1613.380249,429.557434 
	C1615.984131,430.111816 1618.074585,429.862335 1619.932373,430.406647 
	C1625.279785,431.973572 1626.438843,436.874512 1627.199585,441.354370 
	C1627.815918,444.983459 1625.330322,447.234283 1621.672241,448.467133 
	C1618.593994,449.504517 1615.810913,451.417023 1612.447754,453.469238 
	C1610.728516,455.216339 1609.393677,455.114990 1607.604980,453.602325 
	C1606.382935,447.351807 1605.580078,441.277344 1599.304688,439.222473 
	C1593.522095,437.329041 1588.162109,439.044159 1584.282471,444.971893 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1766.011963,4.792629 
	C1806.039185,4.025253 1846.082275,4.018260 1887.062744,4.022041 
	C1887.998779,10.350001 1887.848999,16.671778 1888.044067,22.982891 
	C1888.195435,27.880863 1886.927856,31.230654 1881.544067,32.489807 
	C1875.956543,33.796646 1873.169434,37.550957 1873.975464,43.549583 
	C1874.151001,44.855850 1874.021240,46.206371 1873.996094,47.535843 
	C1873.831177,56.253304 1873.498413,56.728786 1866.080078,58.957283 
	C1858.784668,61.148815 1856.490967,60.311493 1851.887817,53.761494 
	C1851.315552,52.947132 1850.785400,52.103294 1850.220703,51.283447 
	C1844.352539,42.762718 1841.472412,42.187428 1832.167847,46.840393 
	C1827.641479,49.103916 1825.280273,51.227467 1828.157837,56.774456 
	C1830.713013,61.699848 1828.598022,69.013802 1825.196899,71.077538 
	C1821.549683,73.290565 1815.085571,71.851212 1810.787109,67.748299 
	C1808.867676,65.916283 1806.264160,64.202911 1805.461914,61.913357 
	C1803.269653,55.655468 1798.990723,55.386375 1793.625732,56.398033 
	C1784.906128,58.042252 1781.021240,56.437550 1778.093018,48.688728 
	C1776.155151,43.560165 1773.947266,42.495445 1768.564087,43.672550 
	C1762.308838,45.040306 1753.303711,39.003490 1750.802002,33.056625 
	C1749.010742,28.798555 1750.582764,25.168020 1753.855347,22.400068 
	C1755.592407,20.930885 1757.911255,20.159109 1759.940674,19.024651 
	C1768.920166,14.005390 1768.371948,17.041140 1766.011963,4.792629 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1356.816406,397.576660 
	C1353.967529,396.259735 1351.684204,396.232208 1348.542114,396.444763 
	C1335.582153,396.246155 1323.642822,393.778900 1310.687744,393.313599 
	C1309.861206,393.045593 1309.918335,392.378265 1310.008911,392.055847 
	C1308.198364,390.161621 1307.568115,387.947357 1307.082153,385.678375 
	C1306.223389,381.669006 1304.203857,379.024994 1299.674805,379.460785 
	C1295.491821,379.863281 1291.991333,381.198090 1290.908081,385.936951 
	C1290.332764,388.453217 1290.068604,391.216370 1286.649170,392.863556 
	C1275.606445,392.806915 1265.357056,393.290314 1254.549438,392.018555 
	C1254.575073,386.570038 1250.199585,384.665222 1248.246948,381.400024 
	C1243.880249,374.098083 1246.280640,368.418121 1254.633911,366.808350 
	C1257.028320,366.346924 1258.378052,367.467468 1259.525635,369.205170 
	C1261.340698,371.953735 1263.066406,374.762268 1264.916260,377.486877 
	C1266.882202,380.382568 1269.470093,382.056122 1273.186035,381.992737 
	C1281.556641,381.849915 1284.923950,378.030609 1283.901489,369.542847 
	C1282.526489,358.128235 1284.524536,356.299408 1295.581421,358.852753 
	C1297.178589,359.221588 1298.775635,359.591675 1301.186279,359.981201 
	C1303.578125,360.578583 1304.747559,361.708313 1305.787720,362.950958 
	C1309.255981,367.094055 1313.064697,368.979034 1318.535278,366.287079 
	C1324.353027,363.424286 1325.308594,359.003723 1323.930176,352.685791 
	C1323.379883,349.791992 1322.759766,347.585175 1322.069824,344.689209 
	C1325.309570,343.901276 1328.708862,344.251221 1331.910400,343.611542 
	C1338.838257,342.227234 1344.535400,335.381134 1343.920166,329.831055 
	C1343.222412,323.534363 1337.590820,318.411194 1330.142822,318.117645 
	C1325.893555,317.950134 1322.641602,317.285431 1320.096558,313.339569 
	C1317.892212,309.922028 1318.811646,307.808685 1321.473755,305.760651 
	C1325.070312,302.993530 1331.530762,303.297791 1335.297119,306.451385 
	C1336.806152,307.714844 1338.018311,309.334991 1339.351440,310.805389 
	C1346.085083,318.231995 1358.001709,316.352600 1361.910278,307.232941 
	C1362.169312,306.629028 1362.233521,305.944305 1362.462402,305.324432 
	C1367.604126,291.399200 1369.051270,290.956787 1381.301880,299.879242 
	C1385.457764,305.616821 1381.136475,307.521423 1377.348389,309.542572 
	C1373.211426,311.749695 1368.826660,313.771637 1369.468750,319.563354 
	C1370.172363,325.912354 1374.722778,328.138306 1380.292969,329.237000 
	C1386.611206,330.483215 1391.581055,333.091248 1390.446533,341.406372 
	C1390.074463,344.359253 1389.881348,346.661224 1388.281006,349.361755 
	C1386.463379,351.705933 1384.449951,352.220886 1381.478149,352.261414 
	C1378.637817,351.933716 1376.749390,351.151489 1374.255859,349.901917 
	C1370.585449,347.568542 1368.274292,344.776062 1365.559204,342.440704 
	C1362.119263,339.481720 1358.192505,337.658112 1353.934570,340.035065 
	C1349.477905,342.523010 1351.107666,346.760406 1351.980225,350.553131 
	C1352.418579,352.458344 1352.994995,354.332062 1353.125488,357.011658 
	C1352.854614,359.166595 1352.257202,360.458649 1350.949707,362.170868 
	C1349.079712,363.667694 1347.474731,364.066406 1345.857178,364.482971 
	C1332.023560,368.045685 1331.091309,371.032745 1340.857178,382.558868 
	C1347.838501,386.836060 1356.785889,385.324951 1362.087891,393.116577 
	C1362.555664,394.254944 1362.611572,394.760437 1362.313599,395.947815 
	C1360.657349,397.626709 1359.161743,397.844025 1356.816406,397.576660 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1930.149048,245.334290 
	C1930.546021,250.175537 1933.689819,250.136688 1936.712036,249.970078 
	C1948.193237,249.337143 1947.154175,250.233200 1950.010254,260.008667 
	C1951.868408,266.368073 1953.636963,267.703888 1960.596191,267.974243 
	C1963.898071,268.102478 1967.208130,268.005493 1970.514526,268.027588 
	C1972.534668,268.041077 1974.594482,268.168732 1975.773315,270.114563 
	C1977.912720,273.645935 1982.924683,275.873047 1981.631714,280.949738 
	C1980.472900,285.500488 1975.586670,284.238708 1972.458496,285.373474 
	C1968.940186,286.649750 1964.565430,290.522491 1960.556763,284.415070 
	C1957.546875,282.377869 1956.187134,279.861633 1954.244873,276.922852 
	C1951.990234,272.635864 1948.532715,272.366577 1945.253052,273.056915 
	C1938.444214,274.489990 1933.707275,272.118805 1930.071289,266.405334 
	C1927.323975,262.088440 1924.004883,258.007812 1917.999146,259.908478 
	C1912.385132,261.685181 1910.705200,266.395905 1910.744995,271.730743 
	C1910.793091,278.189728 1907.795654,282.239990 1901.995972,284.843140 
	C1897.413330,286.899902 1894.581177,290.468323 1895.282715,295.898132 
	C1896.048096,301.822174 1900.457764,302.981201 1905.369629,303.513580 
	C1909.746948,303.988068 1913.733154,305.573700 1917.923828,308.548523 
	C1919.902832,310.605804 1920.634277,312.446320 1920.304688,315.287109 
	C1920.007080,318.701538 1920.030029,321.497742 1917.350708,323.098236 
	C1914.220703,324.967865 1911.118286,327.142639 1907.435181,327.614319 
	C1904.217773,328.026337 1902.698730,325.748505 1901.993652,322.906158 
	C1900.730347,317.813629 1897.515747,314.028503 1893.665894,310.750977 
	C1889.199341,306.948486 1884.990112,307.318970 1879.386475,311.758179 
	C1873.965210,316.052643 1872.869385,319.199371 1875.417236,324.584747 
	C1876.685791,327.266479 1878.576904,329.648071 1880.104736,332.214020 
	C1882.767456,336.685669 1886.183105,339.226562 1891.658203,337.173096 
	C1895.450562,335.750702 1898.153198,337.545929 1900.082397,340.570312 
	C1902.055542,343.663422 1903.120605,346.700928 1898.125977,348.290710 
	C1896.618774,348.770447 1895.362915,350.056091 1894.008423,350.996582 
	C1888.719727,354.668427 1888.433960,354.822479 1885.507812,349.220093 
	C1881.594238,341.727234 1874.622192,338.835083 1867.398682,336.218994 
	C1859.233765,333.262054 1857.780151,327.933716 1863.594116,321.446594 
	C1865.147827,319.712891 1866.776978,318.021698 1868.537109,316.502960 
	C1872.933105,312.709961 1874.872559,308.791840 1872.711914,302.535400 
	C1870.465698,296.031494 1872.587891,292.962097 1878.800903,289.653473 
	C1888.817017,284.319489 1889.082275,284.262268 1886.900391,274.145264 
	C1886.046875,270.187927 1886.711426,267.733276 1890.189575,265.901642 
	C1892.017334,264.939148 1893.413818,263.559784 1893.916992,260.710327 
	C1894.797729,259.302551 1895.719727,259.011902 1897.385254,259.565186 
	C1902.001221,259.666565 1903.900146,257.398315 1903.957886,253.477234 
	C1903.996948,250.825256 1904.217529,248.149460 1903.953125,245.525009 
	C1903.413086,240.163345 1905.385376,236.400238 1910.555054,234.754501 
	C1918.006470,232.382416 1921.135132,227.661362 1920.095215,219.755081 
	C1919.300781,213.715591 1923.588623,210.813522 1928.467407,208.903351 
	C1933.518433,206.925751 1935.685181,208.427429 1938.554321,215.172134 
	C1940.280518,219.229996 1940.932495,222.154587 1935.535278,224.575531 
	C1925.163818,229.227661 1923.149292,232.833206 1924.189941,240.762817 
	C1924.384644,242.246078 1925.281860,243.089340 1927.268799,243.840775 
	C1928.935425,243.639664 1929.701416,243.862183 1930.149048,245.334290 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1403.483521,286.626709 
	C1403.929443,280.857971 1408.472290,279.586121 1411.645752,277.674377 
	C1418.230347,273.707520 1423.048340,269.768280 1422.350830,260.629364 
	C1421.777710,253.118118 1427.928345,251.395615 1437.300781,255.921936 
	C1451.941406,264.889923 1456.701538,263.172546 1463.504883,246.490295 
	C1467.502441,243.966858 1470.457275,240.948990 1475.315308,240.069962 
	C1483.841553,243.371307 1487.000977,251.897202 1480.899292,255.241013 
	C1470.793579,260.778931 1469.173462,269.048462 1468.480957,279.390289 
	C1465.924316,280.929535 1464.480835,282.379578 1464.057617,285.357483 
	C1463.204468,286.701080 1462.278198,286.999725 1460.610840,286.446228 
	C1456.359497,282.865967 1450.614746,284.344910 1446.708008,280.127197 
	C1443.439331,278.974030 1442.460205,276.188660 1440.281250,274.780762 
	C1436.343994,272.236603 1431.868042,271.554443 1428.726929,275.273895 
	C1425.176147,279.478363 1428.352173,283.128357 1431.459839,286.254272 
	C1434.095215,288.905151 1438.076782,288.940552 1441.495361,291.533386 
	C1448.347412,295.984009 1446.345581,301.878845 1444.949585,307.174896 
	C1444.196655,310.031860 1441.383545,311.935608 1437.939819,311.795135 
	C1434.142700,311.640289 1434.157959,308.822754 1433.955566,306.107056 
	C1433.647461,301.972504 1431.309937,299.450470 1426.734009,298.094116 
	C1424.815308,298.615326 1426.513306,298.350677 1425.245483,298.576904 
	C1414.990723,300.406708 1410.108765,306.942169 1408.478271,317.422058 
	C1405.924561,318.929657 1404.480713,320.379547 1404.057617,323.357483 
	C1391.526855,330.634277 1382.152832,325.252930 1382.063110,311.455597 
	C1382.038940,307.730072 1383.455688,304.743683 1386.980835,303.663086 
	C1395.403809,301.081024 1399.754028,294.779419 1403.483521,286.626709 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1650.011230,4.800928 
	C1671.372192,4.028136 1692.749146,4.019382 1715.063477,4.021881 
	C1715.727539,8.732122 1712.141724,10.601606 1708.757568,12.789422 
	C1705.891724,14.641995 1703.921997,16.915247 1704.506348,20.984148 
	C1706.416992,34.290192 1706.063721,34.362087 1693.378662,37.377556 
	C1689.885376,38.208015 1686.885132,36.842621 1683.681152,36.842533 
	C1680.882812,39.471611 1683.118286,41.765369 1684.063354,44.063519 
	C1685.197144,46.820183 1686.874268,49.408154 1687.635254,52.251381 
	C1689.036011,57.485886 1687.468750,60.088902 1682.296753,62.158543 
	C1680.452271,62.896702 1678.571899,63.601116 1676.646973,64.071526 
	C1671.658936,65.290474 1669.388428,68.291862 1669.990723,73.459389 
	C1670.565918,78.395363 1669.332397,82.623756 1665.161865,85.770981 
	C1660.825195,89.043472 1655.372803,88.290222 1652.112427,83.824173 
	C1648.910645,79.438400 1649.374756,73.361076 1653.259644,70.493919 
	C1654.580933,69.518723 1656.158813,68.881775 1657.645142,68.141678 
	C1661.887695,66.029030 1664.635742,62.824249 1663.942505,57.889080 
	C1662.533813,47.860226 1667.118896,41.337543 1675.716553,37.187801 
	C1680.378418,34.937679 1680.636963,31.339453 1679.353394,27.196486 
	C1678.413452,24.163069 1676.603271,21.880405 1672.945068,22.039427 
	C1671.951416,22.082623 1670.931396,21.875999 1669.959961,22.023703 
	C1656.901489,24.009163 1651.795532,17.312021 1650.011230,4.800928 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2009.377197,253.556854 
	C2019.659546,254.369965 2019.659546,254.369965 2021.264893,264.646576 
	C2022.001221,269.359009 2019.393433,272.474731 2014.112915,275.008881 
	C2008.248901,277.823059 2006.934814,271.797028 2002.686035,270.115173 
	C2000.876099,269.388062 2000.289307,268.389740 1999.988037,266.597015 
	C1998.400635,259.268005 1994.218506,255.608017 1987.226562,256.066010 
	C1981.003418,256.473663 1976.496582,254.779480 1973.210449,248.967896 
	C1970.464478,244.111435 1965.450317,240.683716 1959.821411,242.603043 
	C1953.977661,244.595566 1951.497681,242.485962 1948.621338,237.982010 
	C1942.553345,228.480209 1942.336792,228.634445 1952.691162,223.009872 
	C1953.189209,222.739319 1953.400879,221.941315 1953.872925,220.695099 
	C1954.214600,218.795670 1954.942139,217.909760 1956.211792,216.734985 
	C1957.397339,215.602951 1957.983154,214.745255 1957.951050,213.042725 
	C1957.471069,210.020294 1956.474487,207.720261 1956.003174,204.641388 
	C1953.947510,200.051682 1950.239380,198.549988 1946.237183,198.097244 
	C1942.311646,197.653168 1940.454346,195.317871 1939.121338,192.101181 
	C1937.926025,189.216583 1937.088501,186.232315 1940.290039,184.140625 
	C1943.442261,182.081085 1946.856934,180.502136 1949.967163,184.301498 
	C1951.243408,185.860596 1952.441040,187.417404 1955.283447,187.909668 
	C1956.255859,188.334244 1956.511841,188.667282 1956.384033,189.499847 
	C1959.542725,194.716599 1964.210938,196.094849 1969.930420,195.067322 
	C1977.253784,193.751663 1980.124146,194.588058 1981.047119,200.970520 
	C1982.292236,209.579193 1988.202637,211.335022 1994.648804,213.179382 
	C1996.536499,213.719437 1998.569214,213.947876 2000.538818,213.966599 
	C2005.056396,214.009537 2008.585693,215.778824 2009.492676,220.280960 
	C2010.280273,224.190445 2007.267456,226.689392 2003.983276,227.502121 
	C1999.834595,228.528809 1995.219604,229.178421 1992.899414,223.810196 
	C1992.373657,222.593719 1991.755005,221.377060 1990.962769,220.323074 
	C1987.395874,215.577698 1982.307129,213.508301 1978.120605,214.992828 
	C1972.497925,216.986633 1967.953247,222.555130 1968.045410,227.337845 
	C1968.153931,232.963287 1971.205933,237.960205 1976.971069,239.158401 
	C1984.671021,240.758743 1990.394897,243.876221 1993.983765,251.301147 
	C1995.978271,255.427475 2000.228271,257.123047 2005.524658,254.527863 
	C2006.760254,253.212570 2007.678345,252.917816 2009.377197,253.556854 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1722.100342,4.807900 
	C1730.049316,4.027847 1738.098389,4.019984 1747.073730,4.024143 
	C1748.000000,6.035081 1747.778198,8.063481 1748.039307,10.027683 
	C1749.044067,17.585321 1745.985352,22.759632 1739.390503,26.392780 
	C1733.583374,29.591969 1730.995239,34.629585 1732.017700,41.415329 
	C1732.806519,46.650841 1734.960571,48.510078 1740.026245,47.610264 
	C1741.645264,47.322697 1743.174683,46.556473 1744.763672,46.070251 
	C1753.446289,43.413506 1754.672119,43.909760 1758.887207,51.811096 
	C1759.670410,53.279545 1760.645264,54.726749 1761.039917,56.306618 
	C1762.289917,61.310883 1764.524780,62.553131 1769.631958,60.327972 
	C1777.888550,56.730701 1783.628906,60.805531 1783.917969,70.054306 
	C1784.037720,73.884308 1785.131592,78.127632 1781.282959,81.178123 
	C1777.264038,84.363625 1770.290161,83.453247 1766.054077,78.868774 
	C1764.718750,77.423500 1763.940918,75.475128 1762.671143,73.954712 
	C1759.893799,70.629189 1757.465576,67.753181 1751.856201,69.471771 
	C1745.699829,71.357941 1740.658325,66.981766 1737.602417,62.282780 
	C1733.255249,55.598038 1727.913940,53.257645 1720.170288,53.838970 
	C1714.472900,54.266666 1709.368164,48.945927 1708.147339,42.827358 
	C1706.908569,36.618805 1708.753784,32.898445 1714.643433,29.729559 
	C1726.007202,23.615324 1726.037109,23.610060 1723.863525,11.312099 
	C1723.519287,9.364266 1722.765015,7.488929 1722.100342,4.807900 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2024.083008,4.755236 
	C2030.722778,4.023442 2037.445679,4.016989 2045.085205,4.020158 
	C2046.743286,9.231460 2049.302734,10.585939 2054.406250,8.860047 
	C2061.850098,6.342775 2074.436279,11.443752 2077.725098,18.661533 
	C2079.601562,22.779982 2082.057373,24.071938 2086.113281,24.036987 
	C2088.415039,24.017153 2090.869873,24.026287 2092.993164,24.771027 
	C2097.123535,26.219854 2101.098145,28.243649 2101.844727,33.273220 
	C2102.434082,37.242390 2098.671143,43.358582 2094.540283,45.497265 
	C2094.249023,45.648170 2093.905518,45.696106 2093.604980,45.832493 
	C2084.079346,50.153084 2084.147949,50.143471 2085.704346,60.512730 
	C2086.355957,64.854767 2086.753418,69.470428 2082.373291,72.236710 
	C2077.843018,75.097580 2072.685547,74.993500 2068.147461,72.562073 
	C2063.838379,70.253433 2061.788574,66.314774 2061.898438,60.968899 
	C2062.034424,54.381142 2067.613037,53.221970 2071.387451,50.490028 
	C2077.509766,46.058834 2079.527100,42.222839 2077.582764,35.800537 
	C2076.548340,32.383724 2074.698975,29.870592 2070.556152,30.002741 
	C2066.564453,30.130066 2062.561768,29.896126 2058.570068,30.023207 
	C2054.100098,30.165514 2050.859375,29.015728 2049.696533,24.044603 
	C2048.280273,17.990017 2044.360962,15.505307 2037.967407,15.885534 
	C2030.751953,16.314644 2026.013672,12.603401 2024.083008,4.755236 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1660.259155,374.898804 
	C1658.104858,377.404602 1657.699951,379.755188 1658.056396,382.058502 
	C1659.158325,389.177094 1656.190063,394.508362 1650.538574,398.179199 
	C1645.038208,401.751862 1643.460205,406.640686 1644.008789,412.677490 
	C1644.498779,418.071045 1642.639648,421.296722 1636.948486,422.808502 
	C1632.747192,423.924530 1630.058228,423.734802 1627.814209,419.753632 
	C1625.867310,416.299438 1623.277466,413.212738 1621.232910,409.806976 
	C1619.501465,406.922821 1620.202881,405.034180 1623.798462,404.039886 
	C1636.990112,400.392059 1637.425659,400.123535 1637.849121,386.740082 
	C1638.006104,381.782349 1640.450195,379.839874 1644.206787,377.838287 
	C1654.715210,372.239166 1655.208618,371.522552 1652.814331,359.925903 
	C1651.845215,355.232361 1653.592529,353.123291 1657.312622,351.403259 
	C1665.276489,347.721130 1671.685913,349.699524 1674.714600,357.462921 
	C1677.209473,363.857697 1680.918457,366.632507 1688.167358,366.188110 
	C1698.176636,365.574524 1699.305542,366.986053 1702.722046,375.896027 
	C1703.587524,378.153320 1703.112549,379.688812 1701.633301,381.245117 
	C1697.162842,385.948730 1686.589478,385.031189 1683.078369,379.631470 
	C1682.897705,379.353760 1682.756470,379.050537 1682.595337,378.760071 
	C1675.053345,365.171997 1674.455566,365.026276 1661.543335,373.658417 
	C1661.269775,373.841309 1661.042603,374.093872 1660.259155,374.898804 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1708.503296,320.383026 
	C1706.533936,313.885803 1701.597412,314.264648 1696.919800,313.965973 
	C1694.072632,313.784210 1690.429321,315.219879 1688.722656,311.955750 
	C1686.585449,307.868500 1684.963379,303.448822 1684.522705,298.776154 
	C1684.454834,298.057159 1685.388794,297.022583 1686.118042,296.484741 
	C1691.726440,292.348633 1700.470947,293.311890 1704.466187,299.024139 
	C1709.059204,305.591125 1715.709717,308.403809 1722.962158,309.734528 
	C1729.731812,310.976715 1733.186890,315.597443 1736.218506,320.753967 
	C1738.546265,324.713074 1737.381836,326.717712 1732.798096,327.838257 
	C1730.558105,328.385834 1728.127686,328.340637 1726.006104,329.148651 
	C1720.961182,331.070099 1717.531860,334.343750 1717.977417,340.365021 
	C1718.148926,342.683746 1718.100830,345.032471 1717.970337,347.357269 
	C1717.546265,354.908417 1710.178101,358.648071 1703.808838,354.449677 
	C1701.307373,352.800751 1699.295288,350.524078 1697.884521,347.796051 
	C1694.860962,341.949432 1690.524780,339.310791 1683.494629,339.816193 
	C1674.868164,340.436340 1671.571289,336.992767 1670.533203,328.611633 
	C1670.367676,327.275055 1670.169800,325.438904 1671.524048,325.091339 
	C1675.649902,324.032562 1679.869629,322.980804 1684.092529,322.785858 
	C1686.895142,322.656464 1688.494751,325.431030 1689.851196,327.774933 
	C1690.184326,328.350708 1690.430298,328.977142 1690.766602,329.550812 
	C1696.199951,338.823883 1705.839355,340.206116 1713.725342,332.849457 
	C1717.148926,329.655426 1716.533203,326.288818 1710.710938,320.127533 
	C1709.667236,320.256012 1709.334473,320.511993 1708.503296,320.383026 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1858.500244,224.384247 
	C1852.336792,226.887009 1849.800659,231.239456 1851.185059,236.116165 
	C1851.723999,238.014709 1852.954468,239.712860 1853.532593,241.605347 
	C1854.551147,244.939392 1853.453735,247.511765 1850.113892,248.832184 
	C1847.647949,249.807159 1845.154541,250.747681 1842.608276,251.476120 
	C1839.333740,252.412949 1836.775391,251.849258 1835.723877,247.976273 
	C1834.944580,245.105621 1833.919678,242.266693 1832.676514,239.564484 
	C1830.330811,234.466354 1825.552002,230.805023 1820.933838,232.421204 
	C1813.585449,234.992783 1808.861328,231.933105 1804.095459,227.379471 
	C1803.424927,226.738754 1802.317871,226.554947 1800.706421,226.078918 
	C1799.743896,225.665146 1799.487793,225.332108 1799.615845,224.499542 
	C1798.771851,217.780060 1794.908447,216.306396 1789.024048,217.285995 
	C1781.387817,218.557220 1775.308350,212.295670 1776.117065,204.456482 
	C1776.253052,203.138733 1776.315918,201.593613 1777.681885,200.995819 
	C1782.134033,199.047577 1786.856201,200.315018 1791.455688,200.072617 
	C1794.284790,199.923508 1795.286133,201.834167 1796.359497,204.130203 
	C1799.544678,210.944107 1805.787109,213.562805 1812.631958,213.806885 
	C1820.126465,214.074127 1823.992432,217.637222 1826.465698,224.326797 
	C1829.110229,231.479736 1832.044189,232.978531 1838.430420,231.913956 
	C1844.493774,230.903229 1850.577515,225.616135 1849.791626,220.251602 
	C1847.880859,207.210449 1856.175415,203.655228 1865.943726,200.822723 
	C1869.985840,211.382156 1869.181641,214.405579 1860.127930,223.282715 
	C1859.666870,224.255554 1859.333618,224.511719 1858.500244,224.384247 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1573.493408,183.655640 
	C1581.602539,180.523392 1582.587646,179.045532 1581.736572,172.394241 
	C1580.812378,165.173370 1580.816772,165.193237 1588.241821,163.606155 
	C1589.533081,163.330170 1590.744751,162.617569 1592.039551,162.433792 
	C1595.581055,161.931168 1597.731689,164.153580 1599.094604,166.895477 
	C1600.463623,169.649841 1600.653320,172.670074 1598.514648,175.323441 
	C1598.110352,175.825211 1597.522949,176.304108 1596.923218,176.505386 
	C1585.794434,180.241028 1583.815308,189.616730 1581.849854,199.562653 
	C1580.451782,206.636932 1572.526245,208.136002 1567.466431,202.908859 
	C1565.848877,201.237762 1564.300537,199.497559 1562.761475,197.752899 
	C1559.577148,194.142899 1556.078247,191.844574 1550.793579,191.800125 
	C1544.961426,191.751099 1536.815796,183.008484 1536.331787,177.476944 
	C1536.133911,175.216080 1537.300171,173.669342 1539.109863,172.578979 
	C1541.399536,171.199417 1543.934082,170.555664 1546.519775,169.836792 
	C1553.952881,167.770218 1556.533203,163.364929 1554.840698,155.803238 
	C1554.151001,152.722198 1553.718750,150.002426 1555.829346,147.334747 
	C1558.741821,143.653610 1565.510254,141.088760 1568.152344,142.776871 
	C1570.788208,144.460999 1570.963501,154.952255 1568.075317,158.634964 
	C1565.828613,161.499634 1562.948975,163.858337 1560.521118,166.593231 
	C1557.869507,169.580139 1556.439087,172.728897 1561.300781,175.867523 
	C1562.713623,176.521347 1563.298706,177.159607 1563.991943,178.523468 
	C1564.825806,180.612518 1565.247681,182.221542 1567.561768,182.994690 
	C1569.763184,183.162674 1571.386108,182.994446 1573.493408,183.655640 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1913.889160,4.834218 
	C1920.059448,4.024090 1926.121582,4.018500 1933.091797,4.025805 
	C1934.807617,13.814472 1931.392090,21.039616 1921.430786,23.843075 
	C1916.370605,25.267174 1915.692383,28.707001 1916.179688,33.035767 
	C1916.253052,33.689037 1916.309082,34.430779 1916.647949,34.953472 
	C1918.668457,38.070328 1916.445068,42.863506 1919.783691,45.014244 
	C1923.020752,47.099327 1925.877075,43.534405 1928.956665,42.661690 
	C1933.684570,41.321880 1937.850220,42.500366 1940.091064,46.761608 
	C1942.647827,51.623833 1945.645020,56.744217 1941.692139,62.554085 
	C1938.596924,67.103310 1934.068848,66.602783 1930.056030,65.535240 
	C1924.093018,63.948795 1919.412231,60.339924 1917.655396,53.842644 
	C1916.540161,49.717674 1914.213257,47.586662 1909.626709,49.704273 
	C1908.506958,50.221256 1907.007935,49.903259 1905.685181,49.995846 
	C1901.104736,50.316460 1897.002319,49.536945 1894.772095,44.912880 
	C1892.681396,40.577995 1894.162354,33.692581 1897.913574,30.286804 
	C1899.134399,29.178415 1900.462280,27.738956 1901.941895,27.437950 
	C1911.051392,25.584793 1913.115723,19.589809 1912.230713,11.339808 
	C1912.035034,9.515873 1913.227661,7.543025 1913.889160,4.834218 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1403.248779,285.908997 
	C1404.679565,297.025208 1398.921875,303.383484 1388.771484,305.805695 
	C1383.478882,307.068695 1383.531006,309.883545 1384.983032,313.767059 
	C1385.674072,315.615387 1386.979614,317.287262 1387.398071,319.174042 
	C1388.561523,324.419403 1390.989136,326.634674 1396.501465,324.327209 
	C1398.209717,323.612122 1400.411377,324.075165 1403.193604,323.998199 
	C1411.641968,325.584137 1415.277100,329.432648 1415.651001,336.332306 
	C1415.910400,341.120667 1412.412354,345.348114 1407.567383,345.934662 
	C1401.785645,346.634644 1396.362671,345.631500 1390.761719,342.100708 
	C1389.053833,335.032867 1385.591553,331.582916 1378.037231,331.774048 
	C1372.204102,331.921631 1368.201294,328.252686 1366.506226,322.520752 
	C1364.530762,315.841064 1366.401611,312.403595 1372.404663,308.622101 
	C1375.719238,306.534241 1381.641724,307.617859 1381.979980,300.746399 
	C1382.928467,287.606171 1390.453125,282.399536 1403.248779,285.908997 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1978.640625,92.760010 
	C1976.131470,87.944305 1977.657593,82.065636 1974.125977,79.192841 
	C1970.522461,76.261375 1965.118286,77.935699 1960.558472,78.108414 
	C1954.578857,78.334908 1952.275879,74.306343 1950.512573,70.074265 
	C1948.746948,65.836357 1950.718750,62.520546 1954.692383,60.127575 
	C1961.305176,56.145065 1965.554565,50.894882 1964.162476,42.364117 
	C1963.614868,39.008602 1965.672363,35.934864 1967.849731,33.362431 
	C1971.283936,29.305220 1974.952271,28.917250 1979.114136,32.291172 
	C1981.159790,33.949497 1983.165649,35.864620 1984.575684,38.058174 
	C1988.063477,43.483780 1986.075684,49.254555 1980.125854,51.669224 
	C1977.976440,52.541542 1975.742554,53.211479 1973.530518,53.921707 
	C1971.851685,54.460720 1970.460205,55.315041 1970.242798,57.204983 
	C1969.477783,63.856232 1973.083374,69.379784 1975.813477,74.798988 
	C1977.175781,77.503372 1981.999146,75.807205 1985.257568,75.978455 
	C1993.979736,76.436852 1997.983887,79.494408 2000.741943,87.456963 
	C2001.667725,90.130035 2001.177856,91.822983 1998.975342,93.421104 
	C1993.742920,97.218002 1984.713013,97.288712 1978.640625,92.760010 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1246.932373,137.357605 
	C1250.830566,133.936676 1255.438232,133.734665 1259.142578,131.488632 
	C1262.008301,129.751099 1264.199097,130.942413 1266.041016,133.244537 
	C1270.406982,138.701416 1268.057373,148.368790 1262.333740,152.046921 
	C1258.981812,154.200989 1252.897583,151.969360 1252.134399,158.163544 
	C1251.623291,162.311646 1253.918945,165.849228 1254.869019,169.681259 
	C1255.266846,171.286041 1255.734375,172.874802 1256.090454,174.488434 
	C1256.747437,177.465210 1258.578003,178.128860 1261.272461,177.246262 
	C1263.163452,176.626785 1265.036987,175.926559 1266.965088,175.452713 
	C1271.872925,174.246628 1276.217407,176.136185 1277.619507,179.973648 
	C1279.382812,184.799515 1277.317261,191.007721 1273.254761,193.092911 
	C1269.327148,195.108871 1261.977295,194.371811 1260.746216,190.787552 
	C1257.591919,181.602661 1250.727783,181.724091 1243.112305,181.906113 
	C1236.166016,182.072113 1232.340698,178.277740 1230.456177,170.535782 
	C1229.242188,165.548721 1230.938965,162.875534 1237.718384,159.159714 
	C1238.882568,158.521652 1240.109253,157.998108 1241.278076,157.368057 
	C1248.183228,153.645660 1248.924316,152.271606 1247.212036,144.771881 
	C1246.693237,142.499557 1245.749634,140.361649 1246.932373,137.357605 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1468.730713,280.084473 
	C1468.028809,277.011932 1467.561035,274.150696 1466.819092,271.210449 
	C1464.945679,263.786560 1466.197510,261.448486 1473.013672,257.527039 
	C1473.300781,257.361847 1473.601074,257.219696 1473.890991,257.059387 
	C1483.640259,251.668976 1483.687988,251.436050 1476.621826,240.336792 
	C1475.730957,237.132263 1474.009888,235.934341 1471.289673,236.037811 
	C1467.130615,236.196014 1464.440918,234.000687 1462.384644,230.685883 
	C1459.317993,225.742004 1459.780151,222.171936 1463.865845,219.455338 
	C1467.871094,216.792267 1473.496460,217.623169 1476.277710,221.629105 
	C1477.566528,223.485336 1478.120361,225.844742 1479.057373,227.953766 
	C1480.684570,231.616150 1483.245483,232.953278 1487.523438,230.529510 
	C1491.841797,227.305664 1495.307495,228.835129 1499.360229,231.478317 
	C1507.091064,243.305374 1505.631836,248.842773 1493.473755,254.320557 
	C1489.071899,256.303833 1487.685791,259.137329 1487.954712,263.614685 
	C1488.253052,268.580536 1488.427490,273.461334 1483.857544,277.228668 
	C1479.434204,280.875153 1475.064575,283.088257 1468.730713,280.084473 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1819.349854,276.781128 
	C1820.493042,272.919769 1819.302368,270.125336 1817.756348,267.562622 
	C1814.917480,262.856812 1816.779541,260.157501 1821.263306,258.347687 
	C1821.570923,258.223541 1821.853149,258.030670 1822.166382,257.927643 
	C1826.313965,256.562958 1830.014648,251.772888 1834.856079,255.546906 
	C1837.423950,257.548523 1836.191040,270.135651 1833.426758,273.440094 
	C1831.942017,275.215088 1830.382080,277.130890 1828.440552,278.282440 
	C1822.295044,281.927155 1821.438477,287.574860 1822.080811,293.822235 
	C1822.842896,301.233856 1825.234131,302.984894 1832.823730,302.196411 
	C1835.798218,301.887360 1838.796875,301.686371 1841.656494,302.934113 
	C1846.182495,304.909058 1847.938721,308.556885 1847.936401,313.286865 
	C1847.933960,318.630341 1843.249878,319.163147 1839.917725,320.930267 
	C1835.661987,323.187286 1833.078369,320.415283 1830.806519,317.328247 
	C1829.825928,315.996124 1828.877197,314.609497 1828.140381,313.134521 
	C1825.015869,306.879974 1820.520386,304.277985 1813.588745,307.125702 
	C1808.643311,309.157318 1805.385010,307.202515 1803.216064,302.494995 
	C1801.278931,298.290680 1799.130737,294.203491 1798.790405,289.125092 
	C1805.879272,285.794342 1814.498779,285.050079 1819.349854,276.781128 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1275.517578,219.495865 
	C1277.494629,217.552521 1279.178467,216.665207 1281.088501,215.915970 
	C1288.753418,212.909485 1288.720703,212.826508 1288.055298,203.976318 
	C1287.552368,197.290192 1289.503906,194.146622 1295.342896,191.335953 
	C1299.669434,189.253326 1302.954346,189.791183 1305.364136,194.160492 
	C1305.999634,195.312775 1307.072754,196.232315 1307.657959,197.402252 
	C1310.674683,203.432205 1315.348999,205.434814 1321.649536,203.091003 
	C1325.962646,201.486588 1328.427124,202.677902 1330.073486,207.042496 
	C1332.635864,213.835556 1332.288330,217.605850 1328.282593,220.483841 
	C1326.112427,222.043167 1324.027832,221.952835 1321.764526,220.812454 
	C1319.938354,219.892258 1318.434692,218.690125 1317.405640,216.888153 
	C1313.805298,210.584656 1308.541504,210.076080 1302.210571,212.227753 
	C1295.885864,214.377335 1294.063599,215.833649 1294.132690,222.800934 
	C1294.207153,230.321930 1290.382568,235.350250 1285.140991,239.685272 
	C1280.525757,243.502319 1277.027222,242.665054 1273.775391,237.452835 
	C1268.731445,229.367783 1268.885620,227.137573 1275.517578,219.495865 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1689.651001,453.718811 
	C1682.232300,453.037628 1677.343750,448.491699 1676.461182,442.309601 
	C1676.206543,440.525513 1676.594116,439.000854 1678.536621,438.381073 
	C1680.733154,437.680237 1683.035278,437.243011 1685.143799,436.344543 
	C1694.975708,432.155243 1696.671753,428.623230 1693.826172,418.735199 
	C1691.890381,412.007660 1689.628418,410.615936 1682.329102,411.573944 
	C1680.692749,411.788727 1679.036377,411.851624 1677.388794,411.978119 
	C1671.868042,412.402039 1669.740845,408.623962 1668.486084,404.314270 
	C1667.415649,400.637817 1667.725220,397.324005 1671.830200,395.014038 
	C1677.880493,391.609467 1679.872925,391.371582 1684.214966,395.266907 
	C1685.692261,396.592285 1687.439087,397.890747 1688.290894,399.588776 
	C1690.869385,404.728455 1694.810791,406.655365 1700.415161,406.040314 
	C1705.445312,405.488312 1709.751587,406.819000 1711.625488,412.109436 
	C1713.647827,417.819153 1711.605469,424.378082 1706.865601,427.578949 
	C1701.323853,431.321381 1697.491943,436.205048 1698.111206,443.109039 
	C1698.660767,449.234772 1696.307617,452.499969 1689.651001,453.718811 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2031.565063,212.615173 
	C2028.492188,201.649078 2028.447144,201.618347 2019.219116,203.295074 
	C2012.064941,204.595001 2005.301636,198.139877 2006.359863,191.000824 
	C2006.569458,189.586121 2007.375244,188.632767 2008.771973,188.171295 
	C2010.975098,187.443527 2013.140137,186.593033 2015.361694,185.930252 
	C2021.876221,183.986908 2021.884033,184.013138 2024.090454,190.823563 
	C2026.455322,198.123093 2030.783691,200.900208 2038.274536,199.924347 
	C2045.526367,198.979599 2049.569092,194.747314 2049.981934,187.604599 
	C2050.077637,185.948837 2050.007324,184.284119 2050.046143,182.624298 
	C2050.143311,178.483978 2052.267822,175.685654 2056.087891,174.420441 
	C2059.193115,173.391953 2062.263428,174.438889 2064.334961,176.682739 
	C2067.108398,179.687332 2067.259277,184.552032 2065.032715,186.840408 
	C2057.921143,194.149765 2053.932373,202.572021 2051.026367,212.251541 
	C2049.306396,217.980225 2042.367676,218.715179 2032.770264,216.095703 
	C2031.301025,215.204483 2031.010986,214.281677 2031.565063,212.615173 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2096.001709,4.833590 
	C2108.708740,4.025559 2121.417725,4.017774 2135.063232,4.019320 
	C2135.662598,7.426100 2137.322998,9.320068 2140.152588,11.201833 
	C2148.913086,17.027939 2148.034912,28.686539 2138.645264,33.394817 
	C2136.584229,34.428272 2134.292725,35.083424 2132.039307,35.634659 
	C2127.603271,36.719818 2124.108398,35.652035 2122.575195,30.859627 
	C2122.169678,29.591921 2121.858398,28.292225 2121.413086,27.039337 
	C2118.286865,18.241343 2118.279297,18.244057 2108.713623,18.000149 
	C2098.773682,17.746702 2097.697021,16.699308 2096.001709,4.833590 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1379.360596,350.404236 
	C1382.133423,350.001953 1384.266724,350.001465 1387.200073,350.001099 
	C1389.718750,353.664490 1393.208496,354.718109 1397.315918,355.931274 
	C1402.436279,362.009399 1402.155640,369.376099 1396.712036,372.773895 
	C1386.975342,378.851349 1386.005249,387.507629 1385.082764,397.757263 
	C1383.778931,399.161377 1382.794189,399.603149 1380.863403,399.805481 
	C1376.721924,398.100281 1373.074463,398.458130 1368.636230,398.332031 
	C1366.139160,398.000641 1364.390137,398.072174 1362.433350,396.770599 
	C1361.991577,395.932251 1361.995483,395.544617 1361.997314,394.575439 
	C1357.151611,386.905853 1360.595581,381.435028 1366.584106,378.287872 
	C1373.523926,374.640808 1375.089722,370.002655 1373.101318,363.038544 
	C1371.520874,357.503265 1373.189575,353.202423 1379.360596,350.404236 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1610.000000,12.905493 
	C1614.877930,12.514929 1619.221680,8.856721 1624.588257,11.027688 
	C1629.733887,13.109322 1631.815186,16.208761 1632.022217,21.405783 
	C1632.215332,26.250668 1630.593872,29.840195 1625.944946,31.697205 
	C1624.099243,32.434418 1622.230225,33.194229 1620.300659,33.624641 
	C1614.881592,34.833447 1613.067139,37.694969 1615.317627,43.024979 
	C1616.367310,45.510830 1616.374390,48.254192 1615.304565,50.809006 
	C1611.829102,59.108105 1603.279297,60.340824 1598.146118,52.912949 
	C1590.960693,42.515610 1594.606323,35.114880 1603.646851,34.071480 
	C1608.875366,33.468037 1610.107666,30.289211 1610.009277,25.769861 
	C1609.922485,21.785519 1609.996826,17.797668 1610.000000,12.905493 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1776.046143,117.547318 
	C1775.915161,112.929138 1776.262207,109.632591 1780.755737,107.998421 
	C1786.592896,105.875641 1792.594482,106.482582 1796.614014,110.190369 
	C1802.193481,115.336945 1808.205688,118.759125 1815.309937,120.833000 
	C1816.824829,121.275200 1818.277954,122.376717 1819.439087,123.504555 
	C1824.273926,128.201355 1825.155029,132.893616 1822.106567,136.690216 
	C1818.788330,140.822800 1811.588379,141.333176 1806.825195,137.679871 
	C1805.515137,136.675110 1804.377197,135.430176 1803.235962,134.223816 
	C1799.407227,130.177017 1794.938232,127.656799 1789.160278,127.993248 
	C1782.150391,128.401443 1777.911255,124.988533 1776.046143,117.547318 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1158.437622,228.697220 
	C1161.849854,225.750153 1165.102539,224.394409 1168.838745,223.823380 
	C1172.874390,223.206558 1174.544922,220.613174 1173.201172,216.633133 
	C1172.446167,214.396851 1172.041138,212.179504 1171.991821,209.832199 
	C1171.818848,201.595200 1174.464844,198.364334 1181.794189,198.012222 
	C1188.474365,197.691269 1193.500732,202.428406 1193.861328,209.379883 
	C1193.969482,211.466263 1193.512451,213.387482 1191.825195,214.727631 
	C1190.534668,215.752655 1189.183960,216.981201 1187.663452,217.392044 
	C1178.203613,219.948181 1177.130615,226.896423 1177.958374,235.068710 
	C1178.262329,238.070480 1177.819092,240.921616 1175.544434,243.366119 
	C1168.828857,250.582916 1160.268799,248.931320 1156.905029,239.620178 
	C1155.613403,236.044739 1155.351440,232.499557 1158.437622,228.697220 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1275.433838,256.523926 
	C1272.646729,260.929108 1269.446533,263.760895 1265.226685,265.237061 
	C1259.090576,267.383606 1255.415283,266.086914 1253.001221,259.812836 
	C1250.575928,253.508774 1246.700684,251.435074 1240.062012,251.840851 
	C1232.529419,252.301239 1229.524902,250.109100 1228.264648,245.394257 
	C1226.946289,240.461456 1228.736572,235.151260 1232.421509,233.065033 
	C1235.952148,231.066238 1242.131836,231.744293 1245.467651,234.573486 
	C1246.474243,235.427231 1247.860962,236.324829 1248.157593,237.444916 
	C1250.254761,245.362030 1255.032349,247.160202 1262.242310,244.086594 
	C1262.809814,243.844681 1263.557617,244.035110 1264.220825,244.007233 
	C1274.736694,243.565155 1275.869629,244.724106 1275.433838,256.523926 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2084.425781,221.622955 
	C2083.421631,222.792221 2082.520752,223.509293 2082.314209,224.389404 
	C2080.063232,233.978958 2078.774658,234.943207 2069.054688,233.971710 
	C2064.256348,233.492111 2058.526855,226.815018 2058.331055,221.461823 
	C2058.231445,218.734207 2059.680176,217.106567 2062.160889,216.347839 
	C2064.369141,215.672470 2066.716797,215.366852 2068.831055,214.485703 
	C2077.615479,210.824890 2079.583984,206.261017 2076.529541,197.154648 
	C2074.213379,190.249390 2074.212646,190.225601 2081.600342,190.014572 
	C2084.259033,189.938614 2086.927734,189.894867 2089.581543,190.033859 
	C2095.014893,190.318420 2099.784424,196.126419 2099.235107,201.494675 
	C2099.024658,203.549179 2097.381104,204.045807 2096.056641,204.943710 
	C2093.385254,206.754593 2089.621094,207.059845 2088.113281,211.313812 
	C2087.933105,212.751633 2087.726074,213.461960 2087.055664,214.583008 
	C2086.189453,215.962051 2085.740234,216.926208 2085.573730,218.568192 
	C2085.444580,219.874039 2085.208496,220.579727 2084.425781,221.622955 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M941.698059,284.512634 
	C950.628845,282.840332 957.699890,283.998016 961.267944,292.753723 
	C963.747559,298.838348 969.005188,298.282837 973.939148,297.934479 
	C979.991211,297.507233 984.455750,299.531952 986.560974,305.322144 
	C987.853882,308.877899 992.816040,312.434692 986.981689,316.448853 
	C979.952515,321.285156 972.323792,321.144775 968.137512,315.810669 
	C967.326965,314.777863 966.657471,313.571442 966.189331,312.343506 
	C963.867615,306.253387 959.460449,303.986389 953.026001,303.885681 
	C945.199463,303.763214 938.114563,294.046997 939.522278,286.089600 
	C939.611450,285.585815 940.464233,285.217102 941.698059,284.512634 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2022.770996,68.779915 
	C2032.864258,62.208885 2040.431519,63.580227 2045.384033,73.145844 
	C2048.063721,78.321335 2051.183838,80.853493 2056.975098,80.063950 
	C2059.355469,79.739433 2061.552979,80.720657 2063.610107,81.877365 
	C2067.729980,84.193871 2069.201660,88.640411 2067.282227,92.901276 
	C2063.836914,100.549980 2053.083008,102.175331 2048.876221,95.047951 
	C2044.842896,88.214317 2040.184448,85.411179 2032.116333,85.763290 
	C2022.775146,86.170952 2018.932739,78.956123 2022.770996,68.779915 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2033.527100,41.749756 
	C2029.088013,38.738426 2025.394897,40.959183 2021.543945,41.673943 
	C2013.113647,43.238724 2004.951416,35.148403 2006.433105,26.850578 
	C2006.592163,25.960037 2007.205444,25.024927 2007.865234,24.368818 
	C2015.019897,17.251539 2028.060791,18.610901 2031.308594,27.781485 
	C2033.923584,35.165398 2038.117310,36.344959 2044.733887,36.110081 
	C2051.382324,35.874058 2057.229736,41.821304 2057.661377,48.328930 
	C2057.987793,53.249012 2052.374512,57.085373 2047.074585,55.346878 
	C2040.602539,53.223843 2036.869629,48.187954 2033.527100,41.749756 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1564.610107,94.919868 
	C1566.694580,93.698677 1568.087646,92.694786 1569.642456,92.212097 
	C1576.475708,90.090668 1578.416016,85.496979 1578.155273,78.567039 
	C1577.793945,68.962662 1587.227173,64.187157 1595.697021,69.187363 
	C1600.431519,71.982399 1601.481812,78.287315 1597.885254,82.962540 
	C1595.398682,86.194786 1592.128418,88.539169 1588.229492,89.624535 
	C1583.690430,90.888130 1581.411499,92.787888 1582.907349,98.103851 
	C1584.561279,103.981346 1582.690063,109.444725 1577.535278,112.805580 
	C1574.007690,115.105492 1569.680054,114.852455 1566.658325,111.416336 
	C1562.548950,106.743416 1559.794189,101.561707 1564.610107,94.919868 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1719.183228,82.374847 
	C1717.541382,78.962601 1715.475830,77.625725 1712.411499,78.284447 
	C1710.147095,78.771202 1707.938965,79.640251 1705.655884,79.897614 
	C1695.838501,81.004280 1691.136353,76.115196 1692.059326,66.072632 
	C1692.291870,63.541691 1693.151489,61.352531 1695.584351,60.545631 
	C1698.711060,59.508575 1701.740234,58.178688 1705.168213,57.950325 
	C1710.241211,57.612373 1713.463867,59.620140 1715.102173,64.353554 
	C1715.862793,66.551010 1716.812500,68.702339 1717.354126,70.952171 
	C1718.470947,75.590820 1721.289307,77.000595 1725.462158,75.140892 
	C1731.258545,72.557663 1735.094604,75.236412 1738.281250,79.564064 
	C1741.137207,83.442802 1740.533813,88.506073 1737.209961,91.207893 
	C1733.121094,94.531555 1729.882446,94.467644 1725.792236,90.727531 
	C1723.345825,88.490738 1720.841187,86.239281 1719.183228,82.374847 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1581.312500,233.715302 
	C1587.889038,228.873505 1590.893677,223.582092 1590.227783,215.668121 
	C1589.653442,208.843781 1599.342896,200.383698 1605.835449,200.668045 
	C1607.744873,200.751678 1608.683472,202.061127 1609.659912,203.425018 
	C1612.081787,206.807678 1611.841431,211.001816 1613.127930,214.735367 
	C1613.768188,216.593674 1612.264160,217.712967 1610.808105,218.623276 
	C1608.289185,220.197906 1605.906616,222.048386 1603.248413,223.330215 
	C1598.252075,225.739624 1595.835449,229.240936 1595.888428,235.035690 
	C1595.959473,242.794724 1590.353882,249.355453 1583.056519,251.083313 
	C1580.023438,251.801468 1578.550903,249.792831 1578.319580,247.390747 
	C1577.883545,242.863235 1576.830078,238.057175 1581.312500,233.715302 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1384.329468,399.342651 
	C1383.796021,394.840332 1384.829224,390.700134 1383.245972,386.975067 
	C1381.040771,381.786163 1383.163940,378.082184 1387.515747,376.457886 
	C1396.653687,373.047089 1399.296509,366.633545 1397.996826,356.853882 
	C1400.942627,352.374481 1408.864868,349.762207 1412.023438,351.374268 
	C1417.196899,354.014740 1418.443848,358.553650 1416.089966,367.251953 
	C1414.163696,370.338562 1411.477295,371.149384 1408.159302,372.211823 
	C1404.037964,373.058960 1403.192139,374.837860 1405.427246,378.490051 
	C1406.482544,381.512970 1406.490845,383.920227 1405.874756,387.068604 
	C1403.718750,392.453583 1399.909668,395.794739 1396.382935,400.179779 
	C1392.940918,400.470184 1390.147339,400.387390 1386.529297,400.456482 
	C1385.352417,400.370453 1385.000366,400.132538 1384.329468,399.342651 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1776.090820,179.281921 
	C1765.442871,183.572937 1765.081299,183.690506 1768.319336,193.648956 
	C1769.950317,198.665131 1768.716675,201.225906 1764.156860,202.858994 
	C1761.970337,203.642059 1759.749023,204.330383 1757.576904,205.150482 
	C1754.323486,206.378845 1752.885742,204.985260 1751.661865,201.954712 
	C1748.074341,193.071640 1749.310669,187.852142 1757.669922,183.299866 
	C1763.577759,180.082626 1765.277344,174.363647 1765.486328,169.144882 
	C1765.783203,161.733841 1770.471558,159.739502 1775.567505,157.238297 
	C1779.246094,155.432739 1781.973389,156.257874 1783.869141,159.851685 
	C1784.799805,161.616089 1785.587280,163.458862 1786.570068,165.192245 
	C1788.705933,168.959412 1787.582275,171.461792 1783.739868,173.062073 
	C1780.789062,174.291016 1776.967651,174.352844 1776.090820,179.281921 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2420.878418,164.891083 
	C2417.384277,167.957901 2417.530762,171.355942 2418.578369,174.524155 
	C2419.490479,177.283630 2419.012207,179.615372 2418.251465,182.208176 
	C2417.025635,186.386536 2414.839844,189.360641 2410.256836,189.908768 
	C2406.698242,190.334381 2403.562012,189.374725 2401.612793,186.239838 
	C2399.145996,182.273132 2399.265625,178.064484 2401.427246,173.990891 
	C2402.029785,172.855164 2402.955811,171.585434 2404.057617,171.068283 
	C2413.434570,166.667557 2415.050049,158.816101 2414.078369,149.589005 
	C2413.698975,145.986145 2415.552002,143.985809 2419.326660,144.042007 
	C2421.646240,144.076538 2423.986328,143.891846 2426.282471,144.134415 
	C2431.816406,144.719101 2434.157715,148.992432 2435.398193,153.477402 
	C2436.742676,158.339096 2432.783447,160.594437 2429.127441,162.293442 
	C2426.770996,163.388458 2424.091553,163.788147 2420.878418,164.891083 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1848.429565,278.647980 
	C1851.160400,275.521301 1853.886841,273.488525 1857.114624,272.640808 
	C1862.519043,271.221497 1862.327393,267.610352 1861.524536,263.360382 
	C1860.640991,258.683441 1855.616821,253.825073 1859.493286,249.499680 
	C1862.312622,246.353851 1868.210693,247.527832 1872.306030,245.061111 
	C1875.105225,243.375183 1877.350220,244.415176 1878.000488,247.992065 
	C1878.531128,250.910385 1879.503784,253.757339 1879.908936,256.687317 
	C1880.497070,260.941895 1879.499634,264.540680 1875.101562,266.561951 
	C1873.322266,267.379547 1871.951050,269.187927 1870.141113,269.816742 
	C1864.099243,271.915680 1863.073730,276.382751 1864.362427,281.737518 
	C1865.227295,285.331726 1867.227417,289.118164 1862.104858,290.767822 
	C1858.330688,291.983185 1854.515381,295.532074 1850.258789,291.285706 
	C1846.642578,287.678284 1844.204224,284.104706 1848.429565,278.647980 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1190.484131,244.569183 
	C1202.307739,237.426666 1202.307739,237.426666 1199.291382,224.789902 
	C1197.352905,216.668823 1197.999268,215.443527 1205.374268,213.257965 
	C1211.228882,211.522949 1218.103394,214.906860 1219.726685,220.322815 
	C1221.572998,226.483032 1219.887329,231.465744 1213.721191,233.953751 
	C1206.255981,236.965912 1202.426147,241.446167 1203.963257,249.698013 
	C1204.140381,250.649323 1203.991211,251.689041 1203.850342,252.667175 
	C1203.165283,257.422882 1200.531006,260.587708 1195.824219,261.637421 
	C1193.267578,262.207611 1190.358765,262.658386 1188.476196,260.154510 
	C1185.686523,256.444122 1184.968384,252.327805 1187.338623,248.093109 
	C1187.970215,246.964920 1189.052124,246.088852 1190.484131,244.569183 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1635.874878,464.795288 
	C1635.072876,456.490570 1636.601074,450.181335 1644.362183,446.969147 
	C1649.088013,445.013214 1650.382690,441.310699 1650.031128,436.544800 
	C1649.605713,430.779480 1652.268433,426.288910 1656.454590,422.644745 
	C1660.964844,418.718567 1664.963867,419.135590 1667.914917,424.104279 
	C1670.224731,427.993378 1671.975464,432.214478 1674.338867,437.030426 
	C1668.114624,437.906036 1663.110352,438.644836 1659.580444,442.495483 
	C1656.205444,446.177521 1652.320190,450.220001 1654.420410,455.603180 
	C1656.809937,461.727966 1654.788696,464.075684 1648.914185,464.821777 
	C1648.110229,464.923889 1647.438477,466.066193 1646.352295,467.362396 
	C1641.853394,470.339630 1638.930664,467.454651 1635.874878,464.795288 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1677.499634,133.616638 
	C1681.901245,133.555603 1684.162842,135.482620 1685.405273,139.013367 
	C1686.274536,141.483948 1686.980225,144.074280 1688.259033,146.327209 
	C1692.674316,154.105789 1697.045410,155.423431 1705.279541,151.792282 
	C1710.631226,149.432266 1711.849121,149.880219 1714.044678,155.306030 
	C1714.904541,157.430679 1715.538940,159.650162 1716.212036,161.846054 
	C1718.214844,168.380234 1718.202637,168.383987 1710.483887,171.467819 
	C1709.239990,172.786896 1708.321777,173.081970 1706.622559,172.442352 
	C1702.676880,171.905914 1699.742432,170.120743 1699.058960,167.310150 
	C1697.808472,162.168915 1693.618530,160.259369 1690.330200,157.186386 
	C1687.055664,154.126221 1683.428467,153.161606 1679.459717,154.550461 
	C1674.311035,156.352203 1671.232788,154.308014 1669.075684,149.947601 
	C1667.006226,145.764618 1668.221924,142.322815 1671.703369,139.470078 
	C1673.194580,138.248215 1675.232056,137.554047 1675.884888,134.691010 
	C1676.333130,133.745834 1676.666138,133.489243 1677.499634,133.616638 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M894.030273,374.976746 
	C897.211670,367.786560 902.363831,365.179657 906.942017,367.600616 
	C912.003845,370.277283 913.934937,379.107117 910.380676,384.280121 
	C908.495422,387.024048 906.086365,389.705475 902.787720,390.439606 
	C896.385620,391.864380 895.839355,396.143738 895.905884,401.580444 
	C896.010193,410.105408 895.262634,410.877106 889.019836,412.578674 
	C883.288574,414.140808 879.751038,411.398804 876.976257,403.993988 
	C874.974915,398.653137 878.094849,395.769897 882.086365,395.220825 
	C894.402771,393.526550 895.109558,385.394562 894.030273,374.976746 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1958.015381,4.804732 
	C1973.373901,4.023627 1988.749634,4.017373 2005.062744,4.022488 
	C2006.918213,10.419919 2004.015503,16.326630 2003.628418,22.596230 
	C2003.378540,26.642887 1998.482910,28.522549 1993.346558,27.484911 
	C1982.443604,25.282331 1978.568604,21.483553 1974.804443,8.869462 
	C1970.321655,9.552550 1966.213257,13.812382 1961.193726,11.298773 
	C1958.805664,10.102891 1958.106812,8.026950 1958.015381,4.804732 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1313.499512,253.615936 
	C1320.183716,253.415344 1322.671265,249.978363 1322.040894,243.890045 
	C1321.802612,241.588882 1322.063965,239.238602 1322.050049,236.911011 
	C1322.024902,232.702377 1324.903931,231.132690 1328.304321,230.352448 
	C1331.714600,229.569901 1334.787231,229.848969 1336.780884,233.574112 
	C1341.331055,242.076431 1340.276489,242.902298 1334.087158,246.073959 
	C1323.259644,251.622421 1323.487427,251.848785 1325.548218,263.744690 
	C1326.213989,267.588104 1327.421997,272.203949 1323.371826,274.741516 
	C1319.593506,277.108856 1314.959229,276.618744 1310.838257,275.078522 
	C1307.292480,273.753235 1304.109741,267.259552 1304.065186,263.536865 
	C1304.000854,258.154022 1310.199829,259.050995 1311.870605,254.705444 
	C1312.333008,253.745377 1312.666016,253.488937 1313.499512,253.615936 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1751.207275,161.320663 
	C1741.786621,165.607651 1741.001221,166.859467 1743.028320,175.864975 
	C1743.791382,179.255157 1744.976440,183.024292 1741.374268,184.714310 
	C1737.664062,186.454941 1733.480957,188.389145 1729.084351,187.118393 
	C1727.005859,186.517654 1726.200684,184.458389 1726.116577,182.351730 
	C1725.886108,176.586044 1728.012329,172.354630 1733.254517,169.256821 
	C1740.058594,165.236023 1740.597900,163.066116 1738.767944,155.375229 
	C1738.538330,154.410263 1738.028198,153.426849 1738.105225,152.489639 
	C1738.367432,149.306412 1734.670898,146.330521 1737.474487,143.114456 
	C1739.054321,141.302048 1748.958374,141.505280 1751.857422,143.306900 
	C1756.069336,145.924362 1758.348755,149.977219 1759.096924,154.692627 
	C1759.967163,160.176727 1754.828003,159.482422 1751.207275,161.320663 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1339.869385,272.038177 
	C1341.876587,270.757080 1343.155640,269.682800 1344.578857,268.856384 
	C1349.627319,265.924805 1352.610352,262.360229 1350.417480,255.924377 
	C1349.375122,252.865433 1349.230103,248.961441 1352.802368,247.082993 
	C1356.094604,245.351898 1360.273071,244.788254 1363.051147,247.493729 
	C1365.789185,250.160294 1368.024658,253.825363 1367.455444,258.106110 
	C1367.169312,260.258667 1365.312256,261.168060 1363.279541,261.803650 
	C1353.123657,264.979248 1350.874268,268.501709 1352.089111,278.619720 
	C1352.461792,281.722656 1355.583008,285.082275 1352.416260,287.919189 
	C1348.637939,291.303925 1343.414185,291.742096 1338.707642,293.123291 
	C1338.047729,293.316956 1336.744385,292.579163 1336.259399,291.900604 
	C1333.469727,287.996735 1333.049072,283.214203 1332.520752,278.748657 
	C1332.045166,274.728363 1336.524780,274.078430 1339.869385,272.038177 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2158.476318,161.447845 
	C2156.416992,167.929474 2151.078857,168.711853 2146.444092,169.718399 
	C2142.364258,170.604370 2138.633545,165.853333 2136.570557,158.909790 
	C2135.221680,154.370514 2137.165771,151.674454 2141.201660,150.598312 
	C2152.589844,147.561569 2157.863037,139.424347 2159.985352,128.640213 
	C2160.497559,126.038857 2161.254395,124.313019 2164.171631,124.102295 
	C2167.110352,123.889984 2169.253662,124.746147 2170.677246,127.525925 
	C2173.133057,132.321228 2172.184326,135.364487 2166.139648,141.280487 
	C2164.088623,148.460358 2160.814453,154.414352 2158.476318,161.447845 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1520.088379,179.286667 
	C1515.307495,180.578812 1514.905029,184.524246 1513.757812,187.912903 
	C1511.873779,193.477432 1508.468628,197.764786 1503.114502,200.376038 
	C1501.232056,201.294098 1499.538086,201.810226 1497.944458,199.648911 
	C1494.618652,195.138306 1495.653931,187.365845 1500.260376,183.916046 
	C1502.108276,182.532043 1504.061890,181.286789 1505.989258,180.011429 
	C1511.178467,176.577698 1515.333740,173.220703 1512.487305,165.581009 
	C1510.552002,160.386841 1517.291382,153.828903 1522.876953,154.316879 
	C1524.741821,154.479797 1525.767212,155.724380 1526.543335,157.250473 
	C1527.892334,159.903549 1529.170410,162.594147 1530.577271,165.215881 
	C1532.628906,169.038757 1531.705200,171.213959 1527.419434,172.536789 
	C1524.355347,173.482590 1521.018677,174.692459 1520.088379,179.286667 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1856.291016,167.759064 
	C1857.689331,171.960175 1859.685303,174.265060 1863.733887,174.009888 
	C1866.047485,173.864075 1868.380737,173.934845 1870.701538,174.014297 
	C1878.946411,174.296494 1883.219116,181.993103 1879.131958,189.153000 
	C1876.636719,193.524628 1870.167236,194.751282 1866.457031,191.302429 
	C1864.549316,189.529160 1863.050781,187.277618 1861.544067,185.118866 
	C1858.330444,180.514679 1854.545654,177.230972 1848.377075,177.940277 
	C1845.744141,178.243027 1842.908691,178.116150 1841.156738,175.608902 
	C1839.252075,172.882919 1836.996826,169.818619 1838.533325,166.461731 
	C1840.759644,161.598022 1846.149170,161.442734 1850.448975,160.542847 
	C1854.741333,159.644516 1855.770752,163.421783 1856.291016,167.759064 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2244.244385,236.365509 
	C2250.341309,228.677612 2247.956543,222.302048 2241.995361,215.973343 
	C2247.556641,212.702271 2252.805420,214.010696 2257.826904,214.482758 
	C2260.358887,214.720749 2261.689453,216.984482 2261.848633,219.516891 
	C2262.268555,226.188065 2263.027100,232.839020 2255.205078,236.573868 
	C2250.917480,238.621063 2248.568359,242.837097 2246.368164,247.038605 
	C2244.227295,251.126556 2241.715576,256.053894 2236.417236,255.447769 
	C2230.734375,254.797684 2229.540527,248.884018 2227.393066,244.502350 
	C2225.909912,241.475342 2227.477783,240.077637 2230.413086,240.087677 
	C2235.114746,240.103775 2239.727539,239.969360 2244.244385,236.365509 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2091.888916,114.683357 
	C2095.286133,114.037422 2097.977295,113.366180 2097.956055,109.232468 
	C2097.939209,105.928665 2097.823975,102.611610 2098.064209,99.323227 
	C2098.503418,93.311256 2100.866211,91.528702 2107.235840,92.047966 
	C2112.613770,92.486397 2114.428223,94.749100 2113.816895,100.754662 
	C2113.620361,102.685158 2112.756348,104.547691 2112.098633,107.220200 
	C2112.355713,108.933197 2112.133545,109.699417 2110.666260,110.148499 
	C2100.758057,114.100403 2100.280273,114.963593 2101.743652,124.484398 
	C2101.944092,125.786667 2102.040039,127.132240 2101.961182,128.444382 
	C2101.809570,130.970627 2102.803223,134.278976 2099.579346,135.345734 
	C2096.147461,136.481400 2091.896973,137.266785 2089.149414,134.669586 
	C2086.365723,132.038025 2084.585693,128.223343 2082.808594,124.703430 
	C2082.014893,123.131393 2083.478027,121.669464 2084.911377,120.654335 
	C2087.269775,118.984032 2090.653076,118.636299 2091.888916,114.683357 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1433.520264,232.379089 
	C1428.097900,223.284866 1428.041992,223.016983 1418.232056,225.065796 
	C1414.595581,225.825272 1412.495239,225.283218 1411.069458,221.973679 
	C1409.808105,219.045731 1409.264893,215.955139 1411.874268,213.686081 
	C1414.593872,211.320953 1417.760498,208.874237 1421.690796,211.176849 
	C1423.365845,212.158173 1425.203491,213.567535 1425.986938,215.241180 
	C1429.120117,221.935257 1434.715088,222.479752 1440.984131,222.041672 
	C1443.623169,221.857254 1446.348999,221.809097 1448.937500,222.260529 
	C1452.925293,222.955978 1455.293823,225.540649 1455.906372,229.644012 
	C1456.490234,233.554886 1454.560547,235.694519 1451.241943,237.449127 
	C1443.223145,241.688812 1439.600098,240.864502 1433.520264,232.379089 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1639.645630,164.005905 
	C1630.132935,163.550430 1626.791626,161.523560 1624.878540,155.544785 
	C1623.597534,151.540817 1624.952271,149.126007 1629.003540,148.192230 
	C1634.568359,146.909592 1639.182861,148.206406 1641.571167,153.652695 
	C1645.267822,162.083267 1651.394775,164.734711 1659.891357,164.034088 
	C1663.012695,163.776688 1665.744873,164.491165 1667.659424,167.415451 
	C1670.414673,171.623657 1670.749023,177.443878 1668.100220,179.316788 
	C1663.119019,182.838943 1656.185547,182.193787 1653.059204,177.608292 
	C1651.198120,174.878586 1649.784302,171.816162 1648.396362,168.798904 
	C1646.800781,165.330200 1644.207764,163.796432 1639.645630,164.005905 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1635.260376,463.906219 
	C1638.257446,466.615936 1641.739746,466.546021 1645.303223,467.923523 
	C1649.510498,471.386078 1653.694214,473.364502 1659.265381,473.987610 
	C1665.634521,475.157562 1671.627197,475.470703 1675.787842,481.307434 
	C1679.515869,485.388367 1683.696289,487.367889 1689.265381,487.986938 
	C1693.562744,492.651337 1699.204590,494.130463 1704.035522,496.586487 
	C1713.657959,501.478455 1722.342896,508.114105 1733.284668,511.920685 
	C1737.421021,512.592529 1740.103638,514.030151 1740.342651,518.442871 
	C1737.498657,519.055237 1735.592407,517.581848 1733.609253,516.431458 
	C1692.097168,492.349426 1648.952759,471.690002 1604.124268,454.549133 
	C1603.513184,454.315460 1602.976685,453.886780 1602.016724,453.003021 
	C1602.878540,450.743744 1604.582764,450.524658 1607.245850,451.491364 
	C1608.938354,452.636261 1609.876587,453.270050 1611.406616,453.950134 
	C1619.511230,457.272705 1627.024048,460.549011 1635.260376,463.906219 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1151.299805,315.913391 
	C1154.434814,321.124146 1159.153198,319.795441 1163.325806,320.003632 
	C1171.319824,320.402527 1175.381714,322.997955 1177.299927,328.867401 
	C1178.527954,332.625000 1177.769409,334.954376 1173.603638,336.466736 
	C1165.713257,339.331451 1163.372925,338.750854 1158.063354,331.082855 
	C1150.908813,320.750244 1149.721924,320.328583 1136.779297,323.899841 
	C1135.726685,320.186096 1132.906860,316.745972 1134.761475,312.571930 
	C1136.683472,308.246338 1139.045898,307.405670 1143.235107,309.689056 
	C1146.138672,311.271637 1146.866089,315.339233 1151.299805,315.913391 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1961.301025,116.480835 
	C1960.280029,108.340233 1964.462158,102.123611 1971.207764,100.562416 
	C1976.185547,99.410370 1981.283691,102.807823 1983.477905,109.566803 
	C1984.520386,112.777885 1987.847168,116.734825 1984.551025,119.670670 
	C1980.632690,123.160416 1975.378418,124.958778 1969.898315,123.578362 
	C1966.362061,122.687553 1963.091187,120.975403 1961.301025,116.480835 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1463.352661,245.662781 
	C1463.719360,259.843597 1459.551025,264.390686 1447.932129,264.051880 
	C1443.099976,263.910980 1439.750732,262.174774 1438.093506,256.741486 
	C1440.487671,243.431152 1451.563354,238.643906 1463.352661,245.662781 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1883.724854,55.208855 
	C1894.109009,53.726940 1898.289307,56.341301 1900.566650,64.975174 
	C1901.835205,69.784821 1900.226562,73.604652 1896.057495,75.682053 
	C1889.780762,78.809578 1882.437500,75.914223 1877.623901,68.413872 
	C1874.899902,64.169487 1876.143799,61.211704 1883.724854,55.208855 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M918.360962,310.412415 
	C916.977173,311.931854 916.161377,313.052460 915.080872,313.779755 
	C905.023376,320.549408 899.208740,318.309143 896.535522,306.702057 
	C895.068176,300.330933 896.693481,297.045959 902.374329,294.900787 
	C909.066528,292.373718 914.112183,293.823303 916.599670,299.498505 
	C918.005493,302.705780 920.067444,305.971405 918.360962,310.412415 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1151.061768,183.345459 
	C1159.554688,182.122543 1166.654297,186.897446 1167.577026,193.853851 
	C1168.057617,197.477112 1166.421753,200.385406 1163.317871,202.116348 
	C1161.042358,203.385330 1158.485596,204.235260 1155.964722,204.961731 
	C1150.056641,206.664291 1148.116699,205.663315 1146.356201,200.013809 
	C1145.476685,197.191635 1144.861450,194.279724 1144.254517,191.381622 
	C1143.223999,186.459900 1145.171997,183.768799 1151.061768,183.345459 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1323.206299,351.895813 
	C1327.198608,355.273651 1329.287109,358.932465 1326.902832,363.500031 
	C1325.370605,366.435425 1313.821777,372.390656 1311.436401,371.203003 
	C1307.265503,369.126312 1303.884766,365.943939 1302.076172,360.693298 
	C1300.937256,354.266388 1303.988037,351.770264 1309.108521,350.564514 
	C1313.739136,349.474060 1318.097778,350.091125 1323.206299,351.895813 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1541.928955,117.879608 
	C1540.094482,125.093620 1534.922363,126.175934 1529.479126,125.793793 
	C1524.622925,125.452873 1520.836670,122.832581 1519.048462,117.953583 
	C1517.469727,113.645897 1517.248169,109.563347 1521.004639,106.179222 
	C1523.968262,103.509354 1530.527588,102.798904 1533.915039,105.445648 
	C1537.701294,108.404045 1542.170898,111.236275 1541.928955,117.879608 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1053.273071,396.080658 
	C1055.575195,396.629608 1057.150391,397.260437 1059.362793,397.945648 
	C1063.866577,402.436340 1065.336548,408.566193 1070.419678,412.983063 
	C1070.730957,414.089142 1070.758423,414.555389 1070.476807,415.650452 
	C1068.564575,416.489777 1066.961426,416.700256 1064.676025,417.360657 
	C1063.148804,417.905670 1062.311279,418.046295 1060.871094,418.413696 
	C1059.269653,418.689362 1058.277588,418.777435 1056.646362,419.265686 
	C1055.163818,419.818970 1054.327271,420.004303 1052.887207,420.421021 
	C1051.275391,420.731598 1050.273193,420.838623 1048.629395,421.361542 
	C1047.181274,421.824585 1046.385376,421.752899 1045.054321,421.306519 
	C1044.141479,418.439240 1043.936646,415.792633 1043.379395,413.222412 
	C1040.999756,402.244781 1041.543701,401.167175 1053.273071,396.080658 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1055.839355,254.036163 
	C1051.319946,256.285706 1047.412964,257.222931 1044.687622,252.935974 
	C1041.499390,247.920731 1038.288574,242.503555 1040.608521,236.321640 
	C1042.531006,231.198746 1053.820068,230.660355 1057.998291,235.143448 
	C1063.618774,241.173965 1063.130371,247.376862 1055.839355,254.036163 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1070.270508,265.701660 
	C1069.770386,263.343231 1069.298584,261.754517 1069.106934,260.132660 
	C1068.431274,254.416367 1071.685425,250.535294 1079.410400,247.929443 
	C1082.102417,247.021439 1084.930664,245.263458 1087.231689,248.907272 
	C1090.497314,254.078568 1090.944458,263.425537 1087.893433,266.678894 
	C1081.428467,273.572479 1075.251831,273.493713 1070.270508,265.701660 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1229.233154,186.209320 
	C1233.898438,187.813629 1234.578247,191.711349 1236.356201,194.788635 
	C1238.656372,198.769806 1236.844604,202.246552 1233.937744,204.371567 
	C1230.834595,206.640015 1226.875488,207.827255 1223.170654,209.152908 
	C1220.489990,210.112091 1218.840698,208.026016 1217.488892,206.168839 
	C1211.621826,198.108154 1214.219604,189.666870 1223.571899,186.506775 
	C1225.079712,185.997284 1226.830444,186.206543 1229.233154,186.209320 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1447.275391,172.634735 
	C1450.545776,171.685379 1453.078979,170.894806 1455.670776,170.436386 
	C1461.201904,169.458084 1462.849121,170.858292 1464.967651,177.971756 
	C1467.111206,185.169067 1466.255371,188.978668 1461.904663,190.923462 
	C1458.380493,192.498795 1454.800659,192.465698 1451.387573,190.567566 
	C1447.483154,188.396149 1445.126831,184.620651 1442.940918,181.043137 
	C1440.687256,177.355209 1443.911743,175.027985 1447.275391,172.634735 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2156.081543,64.241669 
	C2158.341797,72.856308 2157.137939,75.423889 2149.913574,78.784744 
	C2145.989014,80.610489 2140.943848,78.660599 2138.164307,74.243988 
	C2135.005615,69.224800 2135.228271,61.878315 2138.641113,58.518513 
	C2141.737061,55.470661 2146.720947,54.945827 2150.412109,57.748566 
	C2152.473389,59.313774 2153.990967,61.595013 2156.081543,64.241669 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1499.565063,218.615875 
	C1502.223999,204.691940 1508.458618,200.377823 1521.248657,203.908478 
	C1525.193481,207.187820 1524.954468,210.751801 1522.576416,215.244293 
	C1521.153320,222.406677 1516.123413,223.180023 1511.171143,223.950775 
	C1507.799805,224.475464 1504.680908,223.276169 1500.784058,222.100952 
	C1499.301025,221.205551 1499.010986,220.282608 1499.565063,218.615875 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1442.083740,291.286377 
	C1436.031006,292.764130 1431.098022,291.214020 1427.200317,286.266479 
	C1423.397095,281.438812 1422.733521,275.058594 1426.236450,272.161621 
	C1430.331787,268.774658 1440.379150,269.232635 1443.385742,273.158844 
	C1444.546753,274.675140 1445.033081,276.708191 1445.915771,279.252930 
	C1447.000244,284.350342 1443.212036,286.964966 1442.083740,291.286377 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2368.082031,167.952576 
	C2369.851807,160.960297 2376.171143,155.031738 2381.419434,154.618042 
	C2385.149658,154.324020 2390.945801,158.542465 2391.687500,162.573822 
	C2392.483154,166.900879 2392.490723,170.885696 2387.418945,173.408951 
	C2380.232910,176.984070 2372.752441,175.466843 2368.082031,167.952576 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1508.059814,71.735809 
	C1509.080078,63.083092 1511.736328,59.737625 1516.603027,60.119781 
	C1521.473999,60.502262 1529.262939,67.724785 1529.660034,72.227150 
	C1529.990112,75.969917 1523.950195,82.113350 1518.565674,83.511734 
	C1513.746582,84.763321 1511.861694,83.482361 1509.535278,77.253227 
	C1508.962158,75.718658 1508.571655,74.115929 1508.059814,71.735809 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1408.756348,318.092377 
	C1408.000000,316.698456 1407.998413,315.396881 1408.000122,314.095337 
	C1408.018799,299.622833 1409.423828,298.236359 1425.153076,298.002563 
	C1426.202271,298.971100 1426.106323,300.175934 1426.656128,300.866821 
	C1429.807251,304.826080 1431.591675,309.120331 1428.005615,313.446167 
	C1424.303833,317.911774 1419.452759,320.643463 1413.264526,319.438049 
	C1411.981201,319.188019 1410.761597,318.611053 1408.756348,318.092377 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1939.805420,30.232264 
	C1936.638184,24.145452 1939.186890,20.730383 1943.727783,18.193560 
	C1947.909668,15.857198 1952.480469,14.607121 1956.831055,17.259605 
	C1960.741943,19.644085 1961.134277,29.218838 1957.950439,33.702694 
	C1954.924805,37.963490 1948.224609,39.346302 1943.861938,36.501877 
	C1941.877930,35.208370 1940.510864,33.357662 1939.805420,30.232264 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2051.916748,123.838806 
	C2050.178467,125.409271 2048.906494,126.499702 2047.455566,127.238548 
	C2038.328857,131.885544 2030.786011,127.659798 2030.356934,117.586906 
	C2030.170532,113.213707 2033.531006,111.344780 2036.814819,109.671082 
	C2040.874146,107.602043 2045.221802,106.684166 2048.822754,110.126495 
	C2052.458496,113.601730 2055.601318,117.665314 2051.916748,123.838806 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1992.129883,58.102448 
	C1992.661011,55.754765 1992.958252,54.049381 1993.784302,52.658001 
	C1996.958618,47.311329 2002.829468,44.808270 2007.082397,46.795883 
	C2011.394165,48.811039 2014.969116,56.515171 2013.740723,61.333900 
	C2012.838501,64.873085 2010.562866,67.434013 2006.934326,67.718414 
	C2002.784058,68.043724 1998.043579,69.494576 1994.925293,65.211601 
	C1993.600708,63.392296 1993.044556,61.013531 1992.129883,58.102448 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1992.738770,120.758400 
	C1997.066406,117.827217 2000.600708,117.964317 2004.528076,120.198967 
	C2009.147461,122.827423 2010.120483,127.350006 2011.527344,131.730774 
	C2011.954224,133.059708 2011.480835,134.312546 2010.514771,135.367523 
	C2006.810547,139.412781 1996.100342,140.534241 1992.314941,137.257553 
	C1986.694336,132.392487 1986.637695,128.222931 1992.738770,120.758400 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1691.428711,105.956924 
	C1681.549194,105.469902 1678.625244,103.593613 1678.078003,97.944351 
	C1677.498657,91.964340 1681.778198,85.851822 1687.572632,84.429688 
	C1689.554565,83.943245 1691.799561,83.625931 1693.312988,85.037933 
	C1697.051392,88.526169 1699.511719,93.023109 1699.726685,98.081833 
	C1699.922729,102.694107 1696.686890,105.154388 1691.428711,105.956924 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1616.091797,82.074806 
	C1620.588623,81.698219 1623.106445,83.790054 1625.277100,86.360718 
	C1628.291260,89.930397 1631.151611,93.715019 1629.245972,98.775124 
	C1628.135986,101.722046 1619.359253,104.671562 1615.085327,103.828445 
	C1611.513184,103.123749 1609.266357,100.917145 1608.284424,97.484398 
	C1606.534668,91.368439 1608.933838,86.204292 1616.091797,82.074806 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2031.017212,275.416046 
	C2032.436523,274.434143 2033.372070,274.084015 2034.287476,273.688049 
	C2046.340454,268.475281 2050.653564,271.337006 2051.285645,284.802246 
	C2051.397217,287.174408 2050.437500,288.760101 2048.534668,289.608276 
	C2045.203125,291.093170 2041.788452,292.452759 2038.299194,293.501251 
	C2035.761108,294.263947 2033.250610,293.135498 2032.741943,290.587463 
	C2031.783325,285.785217 2028.902710,281.222809 2031.017212,275.416046 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1027.219238,274.502655 
	C1025.490601,269.981812 1025.562988,266.418701 1029.588989,264.344940 
	C1033.661499,262.247192 1037.895874,259.621216 1042.665771,260.767151 
	C1046.599243,261.712097 1049.857666,273.641510 1046.900879,276.639618 
	C1043.412598,280.176941 1038.747192,282.954010 1033.834351,283.080841 
	C1029.745728,283.186340 1028.364990,278.901733 1027.219238,274.502655 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1641.494873,55.145061 
	C1643.619995,58.766804 1644.077881,61.958073 1644.008667,65.370422 
	C1643.928345,69.329361 1641.646606,71.285385 1638.406616,72.763939 
	C1635.124878,74.261574 1631.960571,74.587387 1629.149658,71.982407 
	C1625.764282,68.844887 1621.775269,65.642761 1623.066650,60.369053 
	C1624.360962,55.082737 1628.425903,52.452259 1633.686279,51.035809 
	C1637.536499,49.999031 1639.166626,52.213375 1641.494873,55.145061 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1002.722412,279.563232 
	C1004.487976,283.637115 1004.270020,286.785400 1001.466187,289.389435 
	C998.239258,292.386536 994.353210,294.294556 990.103821,295.223083 
	C989.131836,295.435425 987.478760,294.449585 986.751404,293.530670 
	C983.583130,289.527740 981.195740,284.875458 982.573853,279.788239 
	C983.805054,275.243408 988.139282,273.235992 992.467712,272.326080 
	C997.701904,271.225677 1000.313660,274.810883 1002.722412,279.563232 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1887.384521,215.564743 
	C1890.207153,215.379608 1892.414429,214.759811 1895.310791,214.070007 
	C1896.196533,218.267776 1896.105103,222.575516 1896.689697,226.789474 
	C1897.086670,229.650848 1899.404297,233.102158 1896.401367,234.967789 
	C1892.293823,237.519730 1887.502319,239.167755 1882.505249,239.432449 
	C1880.985840,239.512939 1880.577515,237.933105 1879.985107,236.752411 
	C1876.468140,229.743973 1877.506226,224.311844 1883.870483,216.714447 
	C1884.794189,215.301636 1885.717163,215.011292 1887.384521,215.564743 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2159.042480,212.616043 
	C2154.695312,214.548523 2151.996338,213.620422 2150.087646,210.093887 
	C2147.896973,206.046753 2145.543457,202.087570 2143.376953,198.028061 
	C2141.585693,194.671616 2143.674561,192.699402 2146.494629,192.369080 
	C2150.708984,191.875397 2155.038818,192.066055 2159.295166,192.342575 
	C2161.832520,192.507446 2163.431885,194.350693 2163.743408,196.911652 
	C2164.101318,199.854279 2164.578125,202.720901 2165.478516,205.581299 
	C2167.038574,210.535889 2163.953125,212.011032 2159.042480,212.616043 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1294.619629,147.981094 
	C1297.481812,155.062881 1295.653931,160.165741 1290.494263,164.561050 
	C1284.499878,169.667343 1280.947510,169.194504 1277.180054,162.333069 
	C1273.882324,156.326691 1273.834717,153.302429 1277.671265,149.781921 
	C1280.628662,147.068329 1284.358765,145.419769 1288.234619,144.409180 
	C1290.836060,143.730881 1292.553955,145.611908 1294.619629,147.981094 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1415.506836,182.397186 
	C1418.077393,186.471146 1420.283569,190.211288 1421.660034,194.235291 
	C1422.616211,197.030029 1425.338989,200.354538 1421.221436,203.140045 
	C1416.272095,206.488358 1409.866211,206.616974 1406.461792,203.331726 
	C1397.866943,195.037949 1401.365112,186.153564 1415.506836,182.397186 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2095.686279,69.225693 
	C2098.570801,67.926498 2100.891357,67.731949 2103.158936,68.229515 
	C2107.588867,69.201630 2111.989990,74.328789 2111.641846,77.851471 
	C2111.193115,82.393600 2106.652344,87.209686 2102.131836,87.937759 
	C2094.716064,89.132187 2090.653809,87.070625 2088.716064,81.187653 
	C2086.705078,75.082237 2090.194824,71.980408 2095.686279,69.225693 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1106.050415,136.085449 
	C1105.393311,134.183701 1104.446655,132.751633 1104.775879,131.731262 
	C1106.167358,127.419609 1113.596436,123.712685 1119.526001,124.055138 
	C1124.021362,124.314751 1128.648804,128.736984 1129.576294,133.552521 
	C1130.073242,136.133301 1129.036011,138.067169 1127.186646,139.647980 
	C1123.132568,143.113312 1117.901978,142.600418 1113.194580,143.054794 
	C1109.714844,143.390671 1107.760132,139.844910 1106.050415,136.085449 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2126.808594,47.573784 
	C2128.165527,56.976837 2126.640381,60.133739 2120.734619,61.471478 
	C2116.333496,62.468369 2108.066406,57.277515 2106.499023,52.381157 
	C2105.632812,49.675491 2105.940674,47.042103 2108.337402,45.142960 
	C2109.895020,43.908493 2111.539551,42.715828 2113.306641,41.824791 
	C2121.836670,37.524075 2124.796387,36.982155 2126.808594,47.573784 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2158.729004,162.083725 
	C2157.129639,154.460831 2158.938477,147.857285 2165.380127,142.327164 
	C2168.133301,141.998581 2170.266846,141.999008 2173.200195,141.998810 
	C2174.723145,143.449570 2175.449463,144.899490 2176.169189,146.352631 
	C2181.283203,156.678757 2180.459961,158.813690 2168.713867,163.923615 
	C2164.942627,164.367813 2162.260010,162.989441 2158.729004,162.083725 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1054.008057,287.754211 
	C1054.067261,283.955231 1053.592407,280.552521 1056.850586,279.005493 
	C1060.406128,277.317230 1064.103760,275.655121 1068.272583,276.133942 
	C1070.059814,276.339203 1071.357544,277.228241 1072.210571,278.785004 
	C1074.777588,283.469391 1075.292847,288.777374 1072.809692,293.106781 
	C1070.355103,297.386200 1064.638428,297.533752 1060.295288,297.332062 
	C1055.844849,297.125427 1053.965820,293.071198 1054.008057,287.754211 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1148.672607,273.146057 
	C1146.781372,272.335541 1145.577881,271.768555 1144.383301,271.183167 
	C1140.485596,269.273163 1137.893188,266.404144 1138.463745,261.809662 
	C1139.014648,257.371582 1142.859253,254.275391 1148.736938,254.155182 
	C1152.762573,254.072861 1157.536133,252.234787 1160.457275,257.169769 
	C1163.363037,262.078979 1161.427734,269.000275 1156.046509,271.592560 
	C1154.005493,272.575745 1151.602417,272.807098 1148.672607,273.146057 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1013.788818,329.185059 
	C1011.269470,335.471008 1006.987549,337.072083 1001.535156,335.413269 
	C997.286682,334.120758 991.989197,326.175110 992.747070,322.072937 
	C993.662354,317.118378 998.058289,315.587311 1002.127747,314.390228 
	C1006.308167,313.160553 1010.653198,315.687256 1012.755737,319.687317 
	C1014.222473,322.477692 1013.987488,325.431335 1013.788818,329.185059 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2022.097168,94.504364 
	C2024.352051,98.208763 2023.919678,101.572418 2023.989258,104.872368 
	C2024.076660,109.021225 2022.093628,111.981133 2018.417969,113.446251 
	C2014.389160,115.052162 2011.497314,112.666138 2008.882446,109.865601 
	C2001.646484,102.115402 2002.945557,94.506981 2011.972046,91.014366 
	C2016.112915,89.412148 2018.971313,91.125282 2022.097168,94.504364 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1636.126709,38.182487 
	C1637.304077,30.760731 1643.433472,29.245829 1648.071655,26.515722 
	C1650.777466,24.923050 1653.849121,26.457790 1655.661621,29.429031 
	C1658.086670,33.404636 1658.581909,37.289265 1656.220703,41.617054 
	C1653.708862,46.221233 1650.261230,48.270416 1644.962158,48.047565 
	C1638.886963,47.792091 1637.449951,43.558136 1636.126709,38.182487 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1926.043823,85.825790 
	C1919.471924,91.841454 1912.192749,91.970001 1907.978882,86.803680 
	C1904.843262,82.959206 1905.284546,75.597946 1908.847656,72.312576 
	C1912.862061,68.611389 1920.945312,69.451347 1924.797241,74.300964 
	C1927.309937,77.464668 1929.095703,81.077438 1926.043823,85.825790 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M947.456543,411.212158 
	C947.694397,403.219055 953.552795,396.644531 959.624146,396.699036 
	C960.544312,396.707275 961.560547,397.138367 962.359070,397.646271 
	C965.738586,399.795807 967.498108,409.549500 965.448425,414.352875 
	C963.834412,418.135101 957.044373,420.879669 952.509705,419.735962 
	C948.284180,418.670166 948.172546,415.221497 947.456543,411.212158 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2073.448730,145.124603 
	C2069.182617,145.292099 2066.521973,143.347443 2064.068359,141.029266 
	C2059.619873,136.826614 2058.643555,131.322998 2061.681885,127.781273 
	C2065.548340,123.274200 2073.312256,122.849739 2077.853760,126.897392 
	C2082.987549,131.472900 2083.572021,137.059341 2079.135742,141.657059 
	C2077.797119,143.044479 2075.820068,143.815994 2073.448730,145.124603 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1920.730347,316.088989 
	C1919.369629,314.423859 1918.739258,312.848969 1918.054443,310.637024 
	C1917.702026,305.678162 1920.516602,302.844391 1923.438965,299.314392 
	C1927.054688,297.061584 1930.313965,296.047150 1934.616089,296.309326 
	C1936.816650,296.897064 1937.952393,297.827057 1939.467285,299.484436 
	C1939.996704,302.133911 1939.998291,304.266602 1940.000000,307.199036 
	C1943.199585,311.866455 1941.474854,315.318604 1938.547852,319.356659 
	C1937.111084,319.998535 1936.222168,319.999237 1934.666626,320.000610 
	C1929.098389,321.095306 1925.457153,318.054565 1920.730347,316.088989 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1623.497925,339.507812 
	C1624.630493,341.575775 1625.260986,343.150330 1625.945801,345.361816 
	C1628.803223,349.256134 1626.932739,352.013184 1624.530518,355.384460 
	C1624.000000,355.998779 1624.000000,356.000000 1624.000000,356.000000 
	C1620.482544,356.181427 1617.412720,358.666229 1613.594727,357.638794 
	C1606.278687,355.670013 1603.059570,349.219727 1606.016846,341.952179 
	C1606.625610,340.456238 1607.228394,338.957886 1607.916992,336.732117 
	C1609.500000,336.002869 1611.000000,336.002075 1613.250000,336.001465 
	C1617.354126,335.944427 1620.645264,336.075012 1623.497925,339.507812 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2358.239502,125.441345 
	C2357.981201,121.618378 2357.716797,118.276428 2361.063477,116.861565 
	C2364.037354,115.604347 2367.024658,113.786079 2370.542480,114.496719 
	C2376.439453,115.687920 2381.105225,123.089867 2379.803223,129.066895 
	C2379.342773,131.180389 2378.238281,132.665405 2376.235107,133.492432 
	C2369.467041,136.286804 2362.159180,133.319092 2358.239502,125.441345 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1188.023193,180.202698 
	C1190.144287,173.932785 1195.404663,169.925354 1200.183838,170.127075 
	C1204.057617,170.290588 1208.087769,174.337387 1209.488770,179.323395 
	C1210.640137,183.421143 1209.318848,186.675354 1205.787109,188.659042 
	C1201.507690,191.062714 1196.607056,190.634644 1192.254395,189.326874 
	C1188.824829,188.296432 1188.157837,184.464462 1188.023193,180.202698 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2322.043945,127.336731 
	C2324.622314,126.595856 2326.568604,126.000969 2328.490723,126.071617 
	C2334.932617,126.308388 2339.266846,129.562210 2339.366943,133.944824 
	C2339.462402,138.127991 2334.241943,144.715302 2330.079834,145.663940 
	C2325.759766,146.648514 2318.111328,143.015671 2316.808594,138.973709 
	C2315.250244,134.137482 2318.479492,130.953995 2322.043945,127.336731 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1143.840210,208.406708 
	C1148.507812,210.439362 1148.471313,214.595795 1149.520508,217.912048 
	C1150.642090,221.457748 1150.509766,225.298340 1146.611694,227.597794 
	C1142.729492,229.887863 1138.589844,231.225311 1134.339722,228.817871 
	C1130.121826,226.428757 1129.249878,221.967316 1128.776123,217.688126 
	C1128.554077,215.680573 1130.559692,214.109573 1132.259033,213.120682 
	C1135.685791,211.126541 1139.030762,208.854126 1143.840210,208.406708 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1770.316406,134.054169 
	C1779.151855,135.195633 1782.885376,139.275436 1781.295532,145.132339 
	C1779.484253,151.805298 1773.113403,155.511551 1766.637085,153.752045 
	C1762.399658,152.600800 1761.181885,149.052872 1760.337891,145.519485 
	C1759.550171,142.222321 1759.589722,138.687012 1763.089722,136.676773 
	C1765.070801,135.538925 1767.357788,134.933899 1770.316406,134.054169 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1436.104492,160.517914 
	C1437.516357,162.983200 1437.914062,164.899734 1437.987671,166.939392 
	C1438.147949,171.377350 1438.411011,175.735931 1432.828857,177.422882 
	C1428.232422,178.811935 1422.669678,177.518616 1420.216064,173.880630 
	C1417.628418,170.044006 1416.874146,165.870819 1419.590088,161.731583 
	C1422.308350,157.588913 1428.096680,155.677521 1432.572876,157.447571 
	C1433.749878,157.912949 1434.674683,159.015823 1436.104492,160.517914 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1578.001709,4.826863 
	C1588.709839,4.036740 1599.419800,4.024002 1611.064819,4.022382 
	C1611.379761,6.230726 1610.759399,8.427953 1610.069580,11.312399 
	C1610.000000,11.999619 1610.000000,12.000000 1610.000000,12.000191 
	C1605.454346,11.696197 1601.913940,13.943079 1598.373169,16.391850 
	C1593.044800,20.076767 1588.410400,16.100229 1583.620239,14.692136 
	C1579.224854,13.400104 1577.574951,10.057828 1578.001709,4.826863 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1806.734985,99.363800 
	C1798.812012,101.563858 1795.222534,96.438789 1791.326050,91.992882 
	C1790.171021,90.675125 1790.009155,89.007774 1790.562500,87.345261 
	C1791.916870,83.277054 1799.719116,79.296471 1804.669800,80.117691 
	C1808.836792,80.808929 1813.786011,86.440308 1813.682739,90.689278 
	C1813.581665,94.851845 1810.139648,96.727974 1806.734985,99.363800 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1955.391113,275.436584 
	C1958.282837,277.650421 1959.152222,280.119568 1959.933350,283.337921 
	C1957.649292,285.040619 1955.996948,286.856506 1954.267212,289.442261 
	C1951.708862,292.893433 1948.458496,291.734192 1944.772827,292.001099 
	C1942.698730,293.124817 1941.202515,293.632202 1938.696289,293.168365 
	C1934.640259,290.414307 1932.672974,287.225037 1932.774902,282.192749 
	C1939.238037,271.399231 1944.745728,269.760681 1955.391113,275.436584 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1910.610596,166.446274 
	C1909.852661,163.828293 1908.613647,162.472992 1906.858521,161.299301 
	C1904.246338,159.552505 1903.019165,156.735550 1902.354004,153.851532 
	C1901.135498,148.568741 1905.085449,143.132706 1910.481079,142.248062 
	C1915.113159,141.488602 1920.706787,145.872894 1921.844116,151.154541 
	C1923.133301,157.141220 1921.595215,159.875809 1914.156616,165.271271 
	C1913.204102,166.701660 1912.277832,167.000015 1910.610596,166.446274 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1818.614746,168.435211 
	C1810.114746,167.025360 1810.114868,167.025360 1810.003906,160.171432 
	C1809.866089,151.655655 1812.384277,147.070358 1818.398438,144.887070 
	C1823.174927,143.153030 1826.185791,144.489609 1827.418579,149.466873 
	C1828.462036,153.679306 1828.881226,158.032959 1825.362305,161.608261 
	C1823.968140,163.024658 1822.554077,164.456161 1822.084229,167.269043 
	C1821.202271,168.697342 1820.280518,168.988220 1818.614746,168.435211 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2020.602783,246.451752 
	C2020.198120,242.394043 2019.911621,239.089645 2020.054565,235.803940 
	C2020.294800,230.278397 2022.971680,227.241348 2028.176758,226.354095 
	C2029.438965,226.138947 2030.952759,226.010452 2032.059082,226.500534 
	C2038.299072,229.264847 2035.329224,235.870926 2037.541260,240.419876 
	C2039.111084,243.648346 2036.607300,246.375244 2033.443359,247.040497 
	C2029.362915,247.898422 2025.122070,252.583817 2020.602783,246.451752 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1513.759277,101.378090 
	C1512.152222,105.803726 1509.052856,107.626282 1505.660278,109.090256 
	C1501.842041,110.737946 1498.466064,110.001900 1495.939941,106.731651 
	C1493.292114,103.304085 1490.797607,99.609871 1492.817261,94.979675 
	C1495.500244,88.828461 1507.490112,87.692322 1511.451538,93.235474 
	C1512.972046,95.362923 1514.120117,97.813927 1513.759277,101.378090 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M888.584961,324.245697 
	C891.356934,324.147247 893.431519,323.792389 895.266724,324.301178 
	C900.929382,325.871185 901.569641,331.402832 903.447327,335.748810 
	C904.594910,338.404877 902.318359,340.166046 900.047913,340.813385 
	C895.244080,342.183105 890.591797,346.207794 885.272705,342.081635 
	C881.969238,339.519104 882.118408,335.937775 881.949036,332.272644 
	C881.745850,327.876801 883.882812,325.569824 888.584961,324.245697 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1109.107178,285.309753 
	C1101.632446,285.821136 1101.071777,280.890961 1099.475342,275.941315 
	C1098.033447,271.470673 1099.612915,269.018280 1102.539185,266.550995 
	C1107.211304,262.611542 1112.656494,263.088196 1116.480835,267.695557 
	C1120.955078,273.085846 1120.807129,276.605927 1115.585327,281.287323 
	C1113.895386,282.802399 1111.744629,283.803650 1109.107178,285.309753 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1276.258789,311.995850 
	C1277.708130,311.930817 1278.372925,311.908112 1279.030396,311.827362 
	C1282.128052,311.446991 1285.588501,308.366272 1288.216919,311.895264 
	C1290.776978,315.332733 1292.245239,319.526703 1291.858032,323.985870 
	C1291.562988,327.383209 1285.011597,331.783539 1280.395996,331.845825 
	C1275.661377,331.909698 1273.982666,329.063202 1274.036987,324.807037 
	C1274.076050,321.745850 1273.309692,319.095062 1271.726685,316.364777 
	C1269.374146,312.307098 1272.697998,312.183441 1276.258789,311.995850 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1823.943115,190.062836 
	C1825.355713,189.794083 1825.998413,189.647278 1826.640503,189.497147 
	C1830.067261,188.696030 1833.747925,185.335297 1836.800415,187.492233 
	C1840.522339,190.122238 1841.601074,195.207275 1843.428345,199.426315 
	C1843.950562,200.632278 1843.678101,201.974915 1842.616577,203.034531 
	C1839.840820,205.805222 1830.164795,207.237686 1826.555176,204.921158 
	C1822.570923,202.364136 1819.254517,199.110001 1820.144043,193.613678 
	C1820.439331,191.789642 1821.387085,190.641556 1823.943115,190.062836 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1934.207642,99.238724 
	C1934.712402,89.979416 1937.834961,87.176849 1945.647339,88.056320 
	C1951.588379,88.725128 1954.398071,92.675301 1954.002930,99.283127 
	C1953.754150,103.443855 1951.800171,106.553581 1947.999268,107.483978 
	C1943.903931,108.486465 1939.276855,109.190742 1936.399780,104.555107 
	C1935.534180,103.160454 1935.009888,101.554008 1934.207642,99.238724 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2180.931152,49.062668 
	C2190.002441,43.947506 2192.995850,43.948059 2197.376221,48.482204 
	C2200.315674,51.524658 2200.868896,54.801090 2198.379395,58.361286 
	C2197.811768,59.173019 2197.062256,59.858685 2196.388672,60.595100 
	C2191.655518,65.769791 2188.187744,67.041214 2184.436768,64.981148 
	C2179.482666,62.260269 2177.908203,56.231850 2180.931152,49.062668 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1132.370605,256.172546 
	C1121.988403,261.624481 1119.915405,261.338013 1115.265137,254.000259 
	C1112.955566,250.356094 1110.217407,246.583145 1114.658813,242.467972 
	C1117.957642,239.411484 1124.653809,238.913666 1128.530884,241.785233 
	C1133.244385,245.276260 1135.658813,249.655197 1132.370605,256.172546 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1656.191162,206.583832 
	C1647.319702,211.596024 1641.978027,210.797989 1637.708984,204.489441 
	C1634.210449,199.319550 1635.754639,194.183578 1641.501587,191.875839 
	C1650.491943,188.265717 1653.045410,189.359833 1655.779663,198.457703 
	C1656.496704,200.843170 1658.412720,203.250610 1656.191162,206.583832 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2109.910156,110.751625 
	C2110.633301,109.779022 2111.150146,109.399963 2111.775391,108.430649 
	C2116.892578,107.663010 2121.633789,108.291748 2123.368408,113.614365 
	C2125.225342,119.311630 2123.725830,124.655830 2119.689209,129.182755 
	C2117.217041,131.955292 2114.040039,132.587677 2110.685791,131.591507 
	C2107.376709,130.608887 2106.686768,127.530632 2106.118652,124.588562 
	C2105.159912,119.621574 2108.642578,115.883011 2109.910156,110.751625 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1983.843750,367.837921 
	C1981.470947,364.142426 1980.970947,360.460022 1983.670288,358.104034 
	C1987.123535,355.089813 1991.768799,353.780518 1996.291870,352.788849 
	C1996.970459,352.640045 1997.994995,353.625580 1998.711914,354.254639 
	C1999.179321,354.664734 1999.398560,355.369568 1999.696899,355.958588 
	C2005.230591,366.885193 2002.429199,372.317291 1989.908936,374.889557 
	C1984.126099,376.077637 1987.217285,369.710480 1983.843750,367.837921 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1622.208008,233.612091 
	C1621.543701,231.597031 1620.970947,230.380768 1620.707397,229.100830 
	C1619.354492,222.531189 1620.241333,220.427490 1624.941284,218.706833 
	C1630.519043,216.664764 1634.610352,218.024094 1637.438354,222.864334 
	C1637.604248,223.148224 1637.787720,223.440842 1637.866211,223.753754 
	C1638.752563,227.289017 1643.608154,230.273758 1640.009888,234.393570 
	C1636.309937,238.629471 1627.629883,238.386093 1622.208008,233.612091 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2092.483154,180.823425 
	C2087.950439,186.648361 2082.856934,186.978592 2077.082520,184.509552 
	C2073.168945,182.836090 2071.633789,179.980057 2072.074707,175.879105 
	C2072.510498,171.828262 2076.784668,166.941788 2080.837646,166.234009 
	C2084.634766,165.570938 2088.233398,166.002472 2089.977539,170.146744 
	C2091.327637,173.354660 2094.508057,176.083511 2092.483154,180.823425 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1909.692993,166.698105 
	C1910.888916,165.998978 1911.777832,165.999176 1913.333374,165.999084 
	C1917.117188,165.740952 1920.181274,166.436188 1922.448486,168.386154 
	C1926.191772,171.605667 1930.720459,175.499084 1929.463013,180.651642 
	C1928.183472,185.894608 1921.924438,184.672913 1917.727905,185.827225 
	C1914.914551,186.601059 1912.709595,185.145981 1911.241943,182.441147 
	C1908.630981,177.629395 1906.480347,172.850784 1909.692993,166.698105 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1533.683594,315.238281 
	C1539.292358,313.778992 1544.022217,312.404510 1547.248779,318.362732 
	C1551.318970,325.879120 1550.792725,327.761597 1542.600464,330.807007 
	C1542.291626,330.921783 1541.995361,331.071442 1541.696167,331.210938 
	C1537.520630,333.157349 1533.352661,336.111176 1529.953613,329.892120 
	C1526.839844,324.195068 1527.495728,320.430969 1533.683594,315.238281 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2131.197754,105.801788 
	C2126.421387,106.324287 2123.400635,105.148300 2121.599609,101.182243 
	C2119.719727,97.042450 2119.173340,92.836845 2120.975098,88.730362 
	C2123.066162,83.964417 2128.308105,82.817894 2132.608154,85.783226 
	C2141.597900,91.982574 2141.380371,98.743156 2131.197754,105.801788 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1733.809082,121.673843 
	C1737.738770,119.782555 1741.038208,118.122391 1744.766724,118.066147 
	C1750.162598,117.984741 1753.890503,122.382904 1753.952515,128.763214 
	C1753.998657,133.515884 1750.023071,137.835297 1745.224121,137.667511 
	C1741.030518,137.520905 1737.905151,134.925751 1735.046509,132.035492 
	C1732.181152,129.138657 1731.042725,126.004028 1733.809082,121.673843 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2291.917480,112.725945 
	C2297.207275,109.161560 2302.171143,108.996948 2307.361816,113.669846 
	C2309.481934,118.554924 2309.761230,122.855644 2306.157471,126.765495 
	C2302.088623,131.180161 2297.540771,132.260544 2293.163086,129.528793 
	C2287.958984,126.281258 2287.472656,124.067871 2290.406006,117.117485 
	C2290.915527,115.909897 2291.360352,114.675079 2291.917480,112.725945 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1651.754883,101.296967 
	C1655.599854,105.405884 1656.151123,109.105843 1653.259399,113.344406 
	C1650.459595,117.448143 1646.638306,118.464867 1642.096802,117.922729 
	C1637.987549,117.432198 1631.608032,108.708954 1632.422852,104.703072 
	C1632.970825,102.008560 1635.307373,101.063080 1637.486938,100.599297 
	C1642.001099,99.638748 1646.600098,99.466751 1651.754883,101.296967 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2363.989746,148.127060 
	C2364.324219,154.036118 2362.891846,158.264954 2357.498047,159.638672 
	C2353.490967,160.659195 2349.525391,159.907623 2346.858154,156.343872 
	C2345.011475,153.876297 2345.743408,145.678101 2348.016602,143.241714 
	C2351.002441,140.041428 2354.662598,137.284531 2359.228760,138.479950 
	C2363.369873,139.564224 2363.740234,143.617050 2363.989746,148.127060 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M992.040100,435.334137 
	C989.831726,438.503510 986.618408,438.232971 983.156616,439.295959 
	C982.190125,436.468109 980.212646,434.836914 978.439453,432.808716 
	C974.253784,428.020874 975.002380,420.030975 979.684509,417.301239 
	C982.111389,415.886292 984.770752,413.246521 987.824341,415.313354 
	C991.096924,417.528381 994.371765,420.240845 993.896973,424.859589 
	C993.562744,428.111023 992.681213,431.306244 992.040100,435.334137 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1547.182373,76.270393 
	C1551.409058,78.881996 1552.215576,83.005203 1554.160767,86.408386 
	C1555.924927,89.494751 1556.921265,92.707695 1553.256348,95.138512 
	C1549.890381,97.370865 1546.322754,99.193054 1542.169556,96.804146 
	C1537.513306,94.125877 1534.963989,88.564278 1536.171875,83.200882 
	C1537.397949,77.757851 1541.062866,75.653908 1547.182373,76.270393 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1403.957275,225.491028 
	C1403.079468,232.530640 1397.327148,232.918381 1393.174561,235.154984 
	C1391.972778,235.802307 1390.685181,235.154160 1389.603760,234.219742 
	C1386.024292,231.126938 1383.932251,222.779205 1385.505249,218.998093 
	C1387.609741,213.939743 1391.729004,213.597870 1396.165283,214.121277 
	C1401.305420,214.727753 1402.792725,216.900574 1403.957275,225.491028 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2294.956787,175.250076 
	C2292.067139,176.319946 2289.881836,177.154358 2287.625977,177.691788 
	C2285.231445,178.262207 2282.450195,178.042160 2281.363770,175.794830 
	C2278.698242,170.280838 2273.599609,165.951950 2272.593750,158.331329 
	C2278.090576,159.890167 2282.983398,159.902084 2287.874512,160.089493 
	C2295.284668,160.373428 2298.645020,167.055450 2294.956787,175.250076 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1707.553711,118.230568 
	C1706.710693,115.975937 1706.256226,114.389557 1706.040161,112.771355 
	C1705.367920,107.737427 1707.633789,104.535545 1712.354248,102.903091 
	C1717.267944,101.203857 1720.754395,103.878822 1723.741577,107.023056 
	C1727.108032,110.566933 1726.530151,114.982338 1724.964233,119.141304 
	C1724.210938,121.141586 1722.141968,121.865166 1720.042236,121.898827 
	C1715.787109,121.967072 1711.296387,122.870041 1707.553711,118.230568 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2400.602295,130.595734 
	C2401.598877,131.083908 2401.902588,131.241302 2402.134033,131.471436 
	C2405.439453,134.758209 2409.462402,138.374283 2406.784424,143.294052 
	C2404.396729,147.680695 2399.304932,148.226654 2394.470947,147.962280 
	C2388.787598,147.651459 2386.899902,143.768555 2385.329346,139.049301 
	C2384.119141,135.413452 2385.242676,133.521927 2388.306885,131.844040 
	C2392.019043,129.811462 2395.880127,129.758606 2400.602295,130.595734 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1015.014404,290.586060 
	C1020.320435,287.958008 1025.070557,286.062317 1029.219116,290.897430 
	C1033.086670,295.405121 1032.725464,300.572327 1028.645386,304.188629 
	C1023.613892,308.648254 1018.256348,309.059357 1014.398010,305.281891 
	C1009.618286,300.602417 1009.607788,296.740173 1015.014404,290.586060 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1490.713989,419.400330 
	C1489.095825,418.852081 1488.182007,418.533661 1486.536621,418.274445 
	C1485.805176,418.333679 1485.329590,417.589813 1485.494141,417.180115 
	C1485.783081,412.821686 1485.916748,408.873169 1486.029907,404.924133 
	C1486.158569,400.433228 1488.281982,397.289337 1492.681519,396.324127 
	C1497.130371,395.348022 1498.209595,398.862854 1500.549438,401.834564 
	C1505.519287,408.146179 1502.659546,413.220734 1500.009521,419.526733 
	C1496.982544,421.985687 1494.293457,419.615265 1490.713989,419.400330 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M910.911377,429.801758 
	C903.058960,423.035614 902.353088,419.322754 906.907532,414.090454 
	C910.049500,410.480713 913.821960,409.025024 918.358643,410.550446 
	C922.018616,411.781128 924.472961,418.054596 923.969238,423.312286 
	C923.470093,428.522430 919.726990,429.407349 915.650940,429.915985 
	C914.355530,430.077667 913.021545,429.930664 910.911377,429.801758 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M952.066040,336.265625 
	C956.820740,326.674316 962.510742,325.470123 968.750305,331.712158 
	C971.922913,334.886139 972.857178,338.512848 971.374268,342.485107 
	C969.997559,346.172882 966.962036,347.892548 962.882935,348.029938 
	C958.542480,348.176178 955.007263,347.235046 953.460754,342.720215 
	C952.832458,340.885895 952.502686,338.949310 952.066040,336.265625 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1617.613892,138.502609 
	C1617.997559,137.013992 1618.009033,136.026062 1618.000610,135.038315 
	C1617.965454,130.929321 1618.080933,127.049088 1623.454590,126.089302 
	C1629.970093,124.925575 1635.895264,126.761055 1638.412598,131.076248 
	C1639.994263,133.787537 1640.870483,136.827332 1638.855957,139.436874 
	C1636.058960,143.060013 1631.965332,144.186813 1627.415405,143.927643 
	C1624.215576,143.745361 1622.464478,140.708435 1618.742554,140.095428 
	C1617.744263,139.668610 1617.488403,139.335999 1617.613892,138.502609 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1495.790405,124.752693 
	C1496.038940,127.864265 1495.926880,130.141068 1494.770142,132.284470 
	C1491.361694,138.599289 1486.255737,139.384232 1481.281128,134.197220 
	C1479.926758,132.785019 1478.742676,131.134033 1477.801147,129.416779 
	C1475.763916,125.701576 1474.787231,121.969948 1478.822388,118.763962 
	C1483.036011,115.416206 1487.476562,115.270309 1491.437988,118.554543 
	C1493.218018,120.030220 1494.865845,121.697067 1495.790405,124.752693 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2333.481445,104.742401 
	C2334.885010,101.401886 2337.352783,100.483681 2339.646484,98.501991 
	C2346.549561,97.094002 2350.635742,100.148232 2352.947266,106.054871 
	C2355.735352,113.180656 2352.979980,117.355385 2345.221191,117.997276 
	C2341.388916,118.314316 2338.099365,117.357193 2334.660889,114.345871 
	C2334.000000,114.001350 2334.000000,114.000000 2334.000000,114.000435 
	C2331.883301,111.378647 2331.701904,108.520599 2333.481445,104.742401 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1303.434204,284.346069 
	C1304.660767,284.968201 1305.292969,285.316864 1305.622803,285.851959 
	C1312.844727,297.572052 1310.099731,303.439453 1296.485474,305.539001 
	C1294.185913,305.893616 1292.774292,304.946625 1291.624634,303.038452 
	C1288.262695,297.458893 1289.815918,289.854950 1295.247314,286.485443 
	C1297.485107,285.097137 1299.870239,283.822052 1303.434204,284.346069 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M865.207947,380.750549 
	C866.523376,383.131622 867.617920,384.840088 868.270325,386.703339 
	C869.280579,389.588257 873.006042,392.062775 870.170776,395.623993 
	C867.964844,398.394928 860.034973,400.671509 857.335327,399.352905 
	C853.127502,397.297668 850.705078,393.531555 850.370667,389.102600 
	C849.832642,381.977020 857.146362,377.639252 865.207947,380.750549 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1973.339355,165.115723 
	C1973.781860,168.217880 1972.703857,169.638596 1970.334595,169.839294 
	C1968.041260,170.033539 1965.711182,169.865295 1963.432129,170.142670 
	C1955.561768,171.100464 1955.517334,171.165848 1953.011597,164.107254 
	C1951.915527,161.019745 1948.143433,157.685638 1953.121948,154.774109 
	C1959.273071,151.176727 1965.045166,152.009033 1968.434692,156.861588 
	C1970.122681,159.278275 1971.553711,161.874451 1973.339355,165.115723 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2001.594971,184.459351 
	C1998.266846,189.961502 1992.717651,188.123840 1988.247192,189.408844 
	C1985.947510,190.069870 1984.460571,187.153351 1983.574829,184.980682 
	C1981.846313,180.740555 1980.258423,176.443146 1978.621216,172.192764 
	C1989.227783,167.957245 1992.804932,168.932556 1998.392700,177.565552 
	C1999.638428,179.490158 2000.517700,181.651886 2001.594971,184.459351 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2063.461914,261.754028 
	C2052.104004,264.410889 2049.605469,263.121460 2045.588989,253.081146 
	C2043.472412,247.789474 2044.171143,246.419357 2049.564209,246.064911 
	C2052.866455,245.847885 2056.197510,246.003906 2059.513672,246.072372 
	C2064.250732,246.170166 2064.952393,250.300110 2066.623535,253.388260 
	C2068.498535,256.852722 2068.103760,259.764130 2063.461914,261.754028 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2150.795166,43.052624 
	C2149.833984,39.986626 2150.189941,37.777016 2151.250488,35.577522 
	C2153.711182,30.474438 2159.886719,26.979084 2164.104736,28.411692 
	C2168.246582,29.818390 2171.331299,38.163620 2169.706055,43.169033 
	C2168.862793,45.766392 2166.778076,46.882164 2164.568359,47.399830 
	C2159.538818,48.578026 2154.573486,48.802937 2150.795166,43.052624 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1459.549194,286.528320 
	C1460.888916,285.998749 1461.777832,285.998688 1463.333374,285.998108 
	C1466.897705,286.209869 1469.245728,287.459442 1469.682495,290.450836 
	C1470.198486,293.985565 1470.742432,297.717163 1469.074097,301.083282 
	C1467.132446,305.000885 1459.266602,307.187225 1455.047363,305.247772 
	C1450.872314,303.328674 1449.297607,299.199097 1450.791382,294.558380 
	C1452.128540,290.404388 1455.088257,288.182709 1459.549194,286.528320 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2319.873535,162.047012 
	C2319.726318,163.463806 2319.647705,164.132309 2319.429443,164.751526 
	C2317.816406,169.328308 2314.556641,171.910065 2309.718506,171.814713 
	C2305.025146,171.722214 2303.125000,168.013931 2301.231689,164.409851 
	C2298.923828,160.016479 2301.357910,156.707550 2303.726562,153.528687 
	C2306.230957,150.167389 2309.235352,149.099472 2313.093018,151.999924 
	C2316.361816,154.457596 2319.414551,156.860687 2319.873535,162.047012 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1605.122314,129.272385 
	C1602.095581,130.020416 1599.775635,130.322800 1597.571533,129.451752 
	C1593.389404,127.798935 1589.446045,121.047737 1590.483765,117.543457 
	C1591.625977,113.686363 1599.255371,109.360497 1603.420776,110.273415 
	C1606.593628,110.968781 1609.101562,113.082870 1609.492188,116.057365 
	C1610.098022,120.667564 1612.033569,126.087822 1605.122314,129.272385 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1029.633057,426.241821 
	C1028.538452,426.580505 1027.991821,426.621582 1026.716309,427.043457 
	C1025.135864,427.604492 1024.279419,427.631592 1022.833984,427.225555 
	C1022.270020,422.919678 1021.074219,419.116058 1020.312744,415.215881 
	C1019.361877,410.346222 1022.646362,406.803101 1026.285889,404.633179 
	C1029.140869,402.931122 1032.746460,403.831024 1035.401855,406.541107 
	C1037.133911,408.308594 1037.975952,410.353302 1037.968628,412.803162 
	C1037.960571,415.462860 1037.993286,418.122711 1038.015747,421.679596 
	C1036.123047,425.361969 1033.082397,425.491028 1029.633057,426.241821 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1263.192871,212.504181 
	C1261.929443,219.709824 1258.044556,223.692993 1253.558716,223.384171 
	C1249.434204,223.100204 1242.583130,215.031586 1242.685791,210.371231 
	C1242.753540,207.290848 1245.003540,205.647385 1247.500488,204.604401 
	C1254.174072,201.816895 1259.910889,204.563873 1263.192871,212.504181 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2348.769775,88.015732 
	C2348.050537,85.061226 2347.653564,82.026497 2348.251221,79.202309 
	C2349.274902,74.365868 2352.563232,71.280312 2357.410645,70.116028 
	C2362.335693,68.933052 2364.301270,72.679184 2366.598145,75.841743 
	C2368.052002,77.843437 2367.965088,80.137527 2367.998535,83.210785 
	C2363.046387,90.837242 2356.398926,89.918663 2348.769775,88.015732 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M943.410095,445.745178 
	C935.312927,444.829071 931.877014,441.225555 932.047791,434.802277 
	C932.162048,430.503906 938.833008,424.532501 943.637634,424.711914 
	C947.087402,424.840759 949.201660,427.411377 949.609985,430.348450 
	C950.421021,436.181091 951.342468,442.431793 943.410095,445.745178 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M907.766235,449.295166 
	C905.470764,455.291229 901.245300,456.485962 896.183350,455.935120 
	C891.794922,455.457550 886.943909,451.017059 886.747864,446.920319 
	C886.530334,442.372833 890.261353,440.821014 893.562439,439.340942 
	C902.416626,435.371033 906.486145,438.030945 907.766235,449.295166 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1000.269653,255.654755 
	C1000.151489,254.240814 1000.000122,253.520737 1000.214050,252.933731 
	C1001.871460,248.385239 1004.447632,244.529099 1009.790161,244.461090 
	C1013.109497,244.418854 1019.322510,252.019348 1019.589172,256.013519 
	C1019.951721,261.443481 1015.640808,263.171143 1011.782898,264.991486 
	C1008.464722,266.557129 1005.328857,266.497559 1003.411499,262.650146 
	C1002.381897,260.583984 1001.405884,258.491089 1000.269653,255.654755 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2149.333740,141.132751 
	C2148.016113,142.710419 2147.229248,143.873123 2146.142334,144.564392 
	C2142.523438,146.866104 2138.879883,149.796234 2134.652100,145.529129 
	C2131.498779,142.346481 2130.945068,135.460785 2133.600098,131.715027 
	C2136.127930,128.149353 2142.845459,126.720207 2147.153809,128.831665 
	C2151.412109,130.918655 2152.040771,133.769730 2149.333740,141.132751 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1834.899780,74.811630 
	C1836.532227,72.728256 1837.727173,71.102379 1839.257935,69.906364 
	C1845.153198,65.300552 1846.514526,65.435722 1851.653931,70.659088 
	C1856.639282,75.726219 1857.207886,79.541512 1853.539429,83.312248 
	C1849.517700,87.446304 1841.646729,87.106979 1837.730957,82.507088 
	C1836.030762,80.509926 1834.666992,78.248985 1834.899780,74.811630 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2089.550781,143.921036 
	C2099.756104,138.437134 2104.712646,140.310577 2105.893066,149.309097 
	C2106.658447,155.145432 2101.462402,161.340286 2095.540527,161.667404 
	C2093.302734,161.791016 2091.474854,160.852341 2090.757568,158.842026 
	C2089.112549,154.230148 2086.497803,149.656555 2089.550781,143.921036 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2192.000000,129.197144 
	C2189.828369,134.334229 2186.416260,136.492859 2180.745361,136.001648 
	C2178.448242,133.521011 2176.616699,131.168152 2175.399902,128.531494 
	C2172.318359,121.853577 2174.017090,117.269287 2180.087402,115.019356 
	C2184.583252,113.352974 2190.001953,116.726265 2191.689209,122.544807 
	C2192.218750,124.370499 2191.919678,126.436455 2192.000000,129.197144 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M921.270630,338.899048 
	C925.333618,341.595276 926.118774,344.934601 926.051941,348.831360 
	C925.991699,352.339905 925.744019,355.522491 921.877380,356.957092 
	C917.936462,358.419281 914.023621,358.851837 910.767456,355.567017 
	C908.172546,352.949249 905.955200,349.929169 906.522034,345.957855 
	C906.683167,344.829102 907.733459,343.420624 908.761658,342.895172 
	C912.511047,340.979218 915.831604,337.742981 921.270630,338.899048 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1041.725586,307.307129 
	C1051.765991,301.882477 1058.291260,305.422119 1057.949829,315.284943 
	C1057.707397,322.287109 1050.477539,326.371124 1044.402710,322.937317 
	C1039.620361,320.234161 1038.210815,313.617706 1041.725586,307.307129 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1857.895264,224.797913 
	C1858.333374,224.000412 1858.666626,224.000198 1859.500000,223.999695 
	C1862.318970,224.057007 1864.687256,223.834885 1866.945923,224.233673 
	C1870.964478,224.943237 1873.469849,227.561020 1873.848022,231.621124 
	C1874.181274,235.199814 1874.688110,239.078171 1870.835815,241.445251 
	C1867.312500,243.610291 1863.703735,244.939697 1859.615234,242.723297 
	C1857.376587,241.509766 1856.166260,239.899094 1856.015625,237.270172 
	C1855.783936,233.226059 1856.247070,229.342682 1857.895264,224.797913 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1965.929688,138.117355 
	C1963.881348,145.865631 1959.770264,150.066238 1955.079834,149.225677 
	C1951.187500,148.528198 1947.454224,147.014725 1946.403320,142.337585 
	C1945.431396,138.011749 1946.402954,134.846634 1950.445557,132.313828 
	C1954.496216,129.775909 1958.273560,129.006866 1962.339233,131.668243 
	C1964.317261,132.962982 1965.637451,134.865585 1965.929688,138.117355 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2015.378418,142.871124 
	C2013.900146,138.859085 2015.473267,137.044022 2018.484619,136.294128 
	C2021.035400,135.658951 2023.677124,135.398697 2026.262817,134.892181 
	C2032.155273,133.737915 2034.532959,135.078278 2035.712158,140.297974 
	C2036.967285,145.853790 2034.233765,150.593521 2029.079834,151.797974 
	C2022.520630,153.330841 2019.238770,151.324326 2015.378418,142.871124 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1824.256226,96.051819 
	C1827.646240,94.030426 1830.458984,93.610062 1833.489624,94.841087 
	C1838.107056,96.716530 1841.119995,102.545387 1839.729248,107.075462 
	C1838.694824,110.445221 1830.678467,114.525085 1827.308716,113.396751 
	C1822.890015,111.917175 1819.291626,105.915916 1820.546265,101.493912 
	C1821.063843,99.670288 1822.549194,98.121269 1824.256226,96.051819 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1322.000000,343.190369 
	C1319.772705,344.600586 1317.578247,345.422668 1315.311768,345.760284 
	C1308.520630,346.772034 1302.035889,341.020355 1302.145508,334.274384 
	C1302.224609,329.414551 1306.572388,329.073517 1309.531006,327.300110 
	C1312.534058,325.500000 1315.196411,326.158112 1317.547607,328.654724 
	C1321.203979,332.537323 1322.400879,337.194092 1322.000000,343.190369 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1404.455566,388.689148 
	C1403.999512,385.222229 1403.999023,382.444427 1403.996826,378.833313 
	C1401.832764,375.368591 1403.152710,373.223053 1405.475830,370.573395 
	C1408.841675,369.342102 1411.683228,368.681793 1415.262451,368.010742 
	C1417.659790,370.425018 1419.319580,372.850037 1421.489746,375.637817 
	C1422.000000,377.500427 1422.000000,379.000275 1422.000000,381.250061 
	C1421.956299,383.190979 1421.593140,384.265259 1420.416626,385.597351 
	C1419.780029,386.633453 1419.401001,387.150360 1418.431641,387.775360 
	C1414.029785,392.189514 1409.735596,393.301971 1404.455566,388.689148 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1678.085449,133.283981 
	C1677.666626,134.000824 1677.333374,134.001038 1676.500000,134.001846 
	C1671.168091,133.884720 1665.960571,135.069717 1663.423340,128.869156 
	C1661.422363,123.979103 1662.039062,119.390678 1665.782471,116.358208 
	C1669.179688,113.606018 1673.720093,113.845589 1677.525635,116.977631 
	C1681.335815,120.113480 1682.204590,124.472725 1679.930298,129.076935 
	C1679.353149,130.245026 1678.757812,131.404114 1678.085449,133.283981 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1929.420654,170.123840 
	C1926.801636,164.508606 1928.820557,161.489716 1933.419434,159.290878 
	C1937.509033,157.335617 1941.266357,157.852112 1944.443970,160.619583 
	C1947.961670,163.683380 1948.855591,167.963013 1947.451416,172.352676 
	C1945.764771,177.625137 1940.050781,179.463028 1935.520874,176.225128 
	C1933.409668,174.716156 1931.741455,172.587494 1929.420654,170.123840 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1888.722900,169.354828 
	C1885.114258,170.080765 1882.579834,169.831573 1882.136719,166.190079 
	C1881.936768,164.546936 1882.083130,162.857620 1881.837036,161.224731 
	C1880.548950,152.675858 1880.478638,152.525436 1888.000732,150.371918 
	C1890.337891,149.702805 1893.174683,147.140274 1895.348389,149.729584 
	C1897.866699,152.729385 1899.958374,156.281845 1899.812866,160.526489 
	C1899.750610,162.340042 1898.570190,163.478531 1897.061279,164.372833 
	C1894.496338,165.893082 1891.977539,167.491089 1888.722900,169.354828 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M865.169312,355.077942 
	C868.480591,352.352692 871.687439,351.888062 875.094238,351.989471 
	C880.757874,352.158081 883.114746,354.044952 883.872070,359.219574 
	C884.668579,364.661682 881.778442,368.400513 875.762146,369.710876 
	C870.444153,370.869171 867.772644,369.471680 865.849182,364.298187 
	C864.825073,361.543793 863.324829,358.794678 865.169312,355.077942 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1565.730225,126.638336 
	C1565.540039,136.045502 1562.902710,140.019943 1556.400024,141.549881 
	C1553.267578,142.286911 1550.397461,142.000595 1548.724854,138.719986 
	C1546.847412,135.037735 1548.078491,127.034706 1550.822388,124.801476 
	C1555.498901,120.995300 1560.194336,121.325256 1565.730225,126.638336 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1617.245972,137.904144 
	C1617.995117,138.001831 1617.998291,139.001511 1617.999146,139.501373 
	C1617.695557,149.480499 1614.294067,153.183899 1607.124023,151.842316 
	C1603.216064,151.111099 1596.492920,142.525711 1596.773438,138.554016 
	C1596.946045,136.110001 1599.037964,135.478577 1600.798584,134.772171 
	C1606.640991,132.428101 1611.619263,134.942017 1617.245972,137.904144 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1086.847656,311.711182 
	C1083.640991,309.990326 1082.489380,307.610718 1082.188599,304.901398 
	C1081.575195,299.373474 1087.213013,293.179749 1093.161377,292.656830 
	C1097.014282,292.318115 1102.182983,299.331451 1101.877808,304.376373 
	C1101.720337,306.982056 1100.307129,308.593079 1098.183472,309.872772 
	C1094.891357,311.856537 1091.342163,312.262451 1086.847656,311.711182 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1725.462524,127.856720 
	C1726.610596,128.682770 1727.286011,129.054199 1727.516602,129.610107 
	C1729.121216,133.477951 1735.708252,136.346191 1731.775757,141.149399 
	C1728.609375,145.016541 1713.766479,141.323349 1711.582886,137.029053 
	C1708.168579,130.314423 1710.631104,126.182442 1718.129028,126.014816 
	C1720.474976,125.962372 1722.726562,126.269012 1725.462524,127.856720 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1888.065186,175.971252 
	C1896.818359,168.393478 1901.301270,169.038116 1904.796631,177.816711 
	C1906.295288,181.580734 1907.380127,185.476349 1903.035034,188.328033 
	C1899.069092,190.930908 1893.387207,190.576843 1890.369751,187.169830 
	C1887.761963,184.225464 1885.092163,181.012207 1888.065186,175.971252 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2070.567871,102.044983 
	C2071.836914,104.767242 2072.809326,106.877441 2073.349609,109.092987 
	C2075.240479,116.846535 2070.801758,122.200394 2063.002197,121.703201 
	C2059.379150,121.472237 2058.179443,118.603485 2057.060547,115.878426 
	C2055.637451,112.413277 2054.757080,108.317627 2057.899170,105.805145 
	C2061.241455,103.132309 2064.813721,99.447906 2070.567871,102.044983 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1758.217651,92.068787 
	C1761.042114,91.979691 1762.936401,92.475632 1764.733398,93.429344 
	C1771.144165,96.831871 1771.702515,102.123657 1766.102905,106.647110 
	C1765.590576,107.060829 1765.001709,107.380226 1764.445068,107.738251 
	C1757.605835,112.138039 1754.952515,112.344498 1752.423218,108.675232 
	C1748.574951,103.092598 1749.360474,97.189896 1754.628052,93.002617 
	C1755.346680,92.431282 1756.484985,92.387970 1758.217651,92.068787 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M980.246948,355.406189 
	C980.013428,352.325989 979.911316,350.049194 981.342468,347.994324 
	C984.772400,343.069580 992.597961,340.588745 995.931824,343.428802 
	C998.947937,345.998291 998.846191,355.597107 995.766235,359.056549 
	C992.177795,363.087036 986.804138,362.980377 981.927979,358.677246 
	C981.227051,358.058655 980.893738,357.023529 980.246948,355.406189 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1841.718384,138.065948 
	C1850.714722,143.032425 1852.157104,148.620026 1846.689819,154.274216 
	C1843.053589,158.035019 1837.462036,159.151260 1834.310181,156.745834 
	C1831.217529,154.385452 1831.025757,144.836777 1834.021851,141.171371 
	C1835.796631,139.000153 1838.095093,137.919464 1841.718384,138.065948 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1544.000000,233.150146 
	C1543.780029,234.635239 1543.401001,235.151993 1542.431519,235.776733 
	C1532.036133,238.473328 1529.443359,236.679047 1527.113403,226.436569 
	C1526.496216,223.723297 1526.773193,221.750351 1529.176392,220.556412 
	C1532.579102,218.865906 1535.355347,214.350983 1539.773438,216.695114 
	C1543.251343,218.540405 1543.314087,222.787018 1543.888428,226.321915 
	C1544.204712,228.268753 1543.980469,230.303391 1544.000000,233.150146 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1869.793945,136.667572 
	C1869.400513,140.990524 1874.451172,144.839432 1869.420166,148.199158 
	C1865.914429,150.540222 1862.661499,154.720032 1858.139648,153.199234 
	C1853.796143,151.738480 1854.230591,146.854599 1853.808472,142.932953 
	C1853.634644,141.318451 1853.101196,139.742630 1852.605591,137.607239 
	C1856.549194,136.052536 1860.403931,134.492661 1864.289551,133.014313 
	C1867.144775,131.927994 1868.604004,133.587738 1869.793945,136.667572 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1803.118530,193.281403 
	C1796.661499,194.017517 1795.859497,190.187851 1796.067505,185.926071 
	C1796.276611,181.636795 1794.261963,176.258545 1800.531494,174.324173 
	C1805.569214,172.769882 1809.261597,175.007874 1812.765259,181.616104 
	C1813.817627,183.601364 1814.610107,185.724548 1815.727661,188.250229 
	C1811.488403,189.948364 1807.670044,191.477905 1803.118530,193.281403 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1143.745605,288.620514 
	C1142.765015,297.149445 1141.003174,299.472107 1135.914307,299.924713 
	C1131.744995,300.295532 1126.240356,296.410828 1124.453247,291.836639 
	C1122.482544,286.792297 1125.218994,282.415009 1130.750000,282.075439 
	C1135.972290,281.754883 1140.708618,282.811981 1143.745605,288.620514 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1838.131714,133.968842 
	C1830.934570,133.017242 1826.524170,128.635132 1826.171143,122.883179 
	C1826.042603,120.788513 1826.551636,119.032684 1828.787476,118.170937 
	C1830.925293,117.346954 1832.981567,116.309616 1835.124878,115.501854 
	C1841.228149,113.201698 1843.477539,114.644012 1843.936646,121.346039 
	C1844.137573,124.279602 1844.015869,127.252785 1843.809814,130.191788 
	C1843.606689,133.087891 1841.481079,133.847000 1838.131714,133.968842 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1914.080566,196.296692 
	C1917.321655,189.678986 1921.953979,186.657501 1928.726562,188.617081 
	C1934.121582,190.177948 1936.187012,197.356293 1932.264648,201.386780 
	C1929.235474,204.499435 1925.546143,207.022308 1920.738281,205.748795 
	C1916.369263,204.591507 1914.083130,201.662857 1914.080566,196.296692 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2092.000000,114.001068 
	C2082.921875,116.272331 2081.353027,115.642876 2077.904785,109.885490 
	C2075.205322,105.377747 2076.371582,101.509758 2079.405029,98.122047 
	C2081.582031,95.691055 2084.477539,93.581444 2088.154297,95.208015 
	C2092.702881,97.220131 2094.208496,101.155602 2093.869629,105.773483 
	C2093.704102,108.029701 2092.777100,110.230064 2092.097412,113.228462 
	C2092.000000,114.001221 2092.000000,114.000000 2092.000000,114.001068 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1956.789795,190.016632 
	C1956.000000,189.999390 1956.000000,189.000290 1956.000000,188.500763 
	C1955.549194,183.482849 1956.672485,179.682678 1960.354370,176.628021 
	C1964.128174,173.497223 1968.042358,173.012589 1972.096558,175.503052 
	C1975.990845,177.895340 1976.839111,181.861206 1975.556763,185.889801 
	C1974.187134,190.192612 1970.158691,191.586563 1966.168457,191.728867 
	C1963.329224,191.830124 1960.444092,190.644913 1956.789795,190.016632 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2044.138916,162.116867 
	C2045.052734,155.713654 2048.355713,152.656311 2053.998291,152.075455 
	C2058.020508,151.661377 2061.154541,153.178253 2063.032227,156.698563 
	C2065.060303,160.499893 2063.437012,163.559799 2060.638916,166.358612 
	C2054.401123,172.597855 2048.069580,171.312271 2044.138916,162.116867 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1672.339844,167.783051 
	C1672.405762,164.098251 1674.505005,162.343521 1676.476562,160.637375 
	C1680.974487,156.745285 1684.838379,157.291641 1689.184326,162.232574 
	C1693.209961,166.809326 1692.755127,171.136414 1687.857544,174.856400 
	C1682.494507,178.929947 1678.953491,178.706512 1675.147461,173.774139 
	C1673.961914,172.237854 1673.327148,170.276611 1672.339844,167.783051 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1848.177246,117.040718 
	C1850.760498,111.711853 1854.410767,109.343727 1859.578003,110.959740 
	C1864.473267,112.490677 1867.159546,118.556038 1865.267700,122.953957 
	C1863.038330,128.136444 1855.754517,131.611115 1851.408447,129.332977 
	C1846.454224,126.735954 1848.395996,121.907928 1848.177246,117.040718 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1595.757202,148.507477 
	C1595.794189,154.352783 1593.108765,157.193542 1588.187866,157.892975 
	C1584.657593,158.394775 1581.597290,157.309250 1579.596924,154.239929 
	C1577.047119,150.328140 1577.218384,145.814560 1578.849121,141.931259 
	C1580.158447,138.812958 1583.559082,137.565643 1587.256836,138.747742 
	C1591.756592,140.186264 1594.269897,143.420486 1595.757202,148.507477 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M981.329468,377.261322 
	C981.948608,381.595032 983.128479,385.567108 980.058228,388.357483 
	C977.416931,390.757965 974.231995,393.051056 970.225220,390.837097 
	C966.526184,388.793213 963.127258,381.526245 964.427246,377.961853 
	C965.793640,374.215210 968.543396,372.151703 972.716125,372.015015 
	C976.445007,371.892853 979.038025,373.564911 981.329468,377.261322 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1645.642944,215.304626 
	C1649.177124,213.723297 1652.164795,213.703613 1655.054443,214.256409 
	C1658.981201,215.007584 1661.280396,217.581467 1661.904663,221.594055 
	C1662.589111,225.995346 1660.302979,228.365280 1656.426880,229.592819 
	C1652.415527,230.863235 1648.351929,232.823669 1644.705811,228.674637 
	C1641.472046,224.994629 1641.488037,221.224503 1645.642944,215.304626 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M920.674988,389.166595 
	C922.425964,387.112000 923.702698,385.509521 925.331543,384.446594 
	C928.909973,382.111450 932.575500,380.950409 935.908325,385.055603 
	C938.483643,388.227844 938.848633,394.736877 936.498413,398.155396 
	C933.852173,402.004486 929.830383,403.079285 925.950317,401.462494 
	C921.135315,399.456146 919.743469,394.937103 920.674988,389.166595 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1645.917236,183.818893 
	C1636.218384,189.830139 1630.720703,187.820541 1630.020630,178.806671 
	C1629.498535,172.084137 1631.602905,169.228226 1637.650391,168.452087 
	C1641.371338,167.974533 1646.678833,172.165833 1647.722534,176.500977 
	C1648.302368,178.909546 1647.530396,181.101105 1645.917236,183.818893 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1436.840454,149.074127 
	C1432.781616,140.215271 1433.440308,136.496475 1438.892334,132.192581 
	C1442.068359,129.685333 1445.669067,128.820847 1448.843994,131.278214 
	C1451.874756,133.623962 1452.586304,137.266739 1451.312134,141.132858 
	C1449.361328,147.052719 1446.155396,149.045898 1436.840454,149.074127 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1506.175049,140.981415 
	C1507.349854,137.239700 1509.513062,135.364548 1512.208862,133.929291 
	C1518.584717,130.534760 1524.151245,133.998993 1523.955933,141.283844 
	C1523.822021,146.283310 1519.115479,151.382507 1514.134766,151.924545 
	C1508.279663,152.561768 1506.621948,150.477036 1506.175049,140.981415 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1879.212402,86.443398 
	C1882.628784,91.848289 1881.298828,95.849846 1877.272705,99.156151 
	C1874.187622,101.689682 1870.840820,102.042641 1867.353638,99.638939 
	C1862.931885,96.591248 1860.810913,90.197884 1863.257446,86.895714 
	C1867.397461,81.307747 1873.314697,80.886017 1879.212402,86.443398 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1170.718506,378.079041 
	C1170.387451,367.445465 1176.329346,362.605377 1187.210571,362.015564 
	C1188.058105,364.591003 1187.843994,367.201691 1188.873901,369.700928 
	C1190.180176,372.870819 1190.981934,376.489777 1187.741699,378.559906 
	C1184.617920,380.555695 1180.965454,382.591431 1176.825195,380.399200 
	C1175.113647,379.492950 1173.237915,378.896637 1170.718506,378.079041 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1023.443237,344.775330 
	C1022.192810,338.593079 1024.317017,334.822845 1029.924438,334.182739 
	C1034.000366,333.717529 1038.718384,332.734406 1041.013672,338.167542 
	C1043.168457,343.267761 1041.987915,346.817535 1036.891724,349.564056 
	C1029.932007,353.314911 1028.272461,352.795166 1023.443237,344.775330 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1491.905518,158.007523 
	C1488.528931,159.849335 1485.972412,159.920120 1484.702637,156.651245 
	C1483.632446,153.895966 1483.043945,150.933960 1482.441895,148.022202 
	C1481.889282,145.348831 1483.223877,143.428452 1485.641357,142.524445 
	C1488.106201,141.602722 1490.710449,141.054367 1493.253418,140.341705 
	C1495.308594,139.765747 1497.865356,137.080093 1499.334229,140.000809 
	C1500.843750,143.002579 1503.568726,146.608994 1500.471558,150.165421 
	C1498.090942,152.899017 1495.216797,155.202789 1491.905518,158.007523 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1654.549805,159.748093 
	C1652.458252,158.660110 1651.037354,157.800995 1649.799927,156.729813 
	C1646.164917,153.582932 1644.347900,149.480682 1647.185791,145.338364 
	C1649.904907,141.369339 1654.707520,141.503662 1659.036133,142.341019 
	C1662.045410,142.923172 1666.489868,150.588074 1665.545898,153.657303 
	C1664.038208,158.559952 1659.748169,159.486328 1654.549805,159.748093 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1269.797119,270.009033 
	C1276.721924,271.823822 1279.710571,275.016876 1279.880127,279.683868 
	C1280.030640,283.822754 1277.252563,285.486572 1274.088623,286.889587 
	C1271.182373,288.178345 1267.930298,288.880554 1265.789917,286.185608 
	C1262.948120,282.607605 1259.645508,278.646362 1260.690918,273.713593 
	C1261.572510,269.552826 1265.667603,270.079315 1269.797119,270.009033 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M936.233276,367.424377 
	C936.451660,365.077911 936.618469,363.427856 937.148010,361.903900 
	C938.625305,357.652344 941.532898,355.448700 946.200928,356.089600 
	C950.700012,356.707275 953.216614,359.324860 953.918091,363.769226 
	C954.680054,368.596619 953.030151,371.781830 948.360718,373.957214 
	C944.020569,375.979156 940.798096,375.499847 938.068665,371.722046 
	C937.311157,370.673553 936.911255,369.366669 936.233276,367.424377 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1376.949585,257.216675 
	C1370.407227,249.689682 1370.609497,244.549103 1377.177979,240.556992 
	C1380.229004,238.702667 1383.605835,236.511871 1387.210571,239.439896 
	C1390.358276,241.996750 1391.051880,248.652954 1388.383789,252.251053 
	C1385.789551,255.749405 1382.803467,259.009735 1376.949585,257.216675 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1676.627319,481.682953 
	C1670.948975,479.699188 1665.893066,477.394012 1660.418579,474.544769 
	C1660.750732,469.249847 1661.679932,464.652405 1667.886230,464.351532 
	C1672.091919,464.147644 1676.643433,462.609070 1679.483643,467.479828 
	C1682.602661,472.828735 1682.112915,475.909668 1676.627319,481.682953 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1500.845215,178.520996 
	C1493.584839,177.718277 1489.731567,174.109024 1490.119995,169.409348 
	C1490.464600,165.238281 1497.980713,158.410812 1501.941772,158.670517 
	C1506.117065,158.944305 1509.537354,167.959244 1507.249634,172.926437 
	C1506.094971,175.433472 1503.986450,177.063049 1500.845215,178.520996 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1617.514404,171.747467 
	C1614.802124,171.660461 1612.640503,171.910385 1610.970215,171.120926 
	C1606.038330,168.789627 1603.245361,163.847305 1604.367310,160.158218 
	C1605.826660,155.359161 1610.483521,155.589264 1614.031128,154.522797 
	C1617.101074,153.599915 1622.368408,157.897858 1623.520630,161.740936 
	C1624.986572,166.630432 1623.426636,170.118912 1617.514404,171.747467 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1888.096924,215.228729 
	C1887.111084,215.999786 1886.222168,216.000198 1884.666626,216.000916 
	C1874.763916,215.703522 1872.045410,213.680939 1872.043091,207.105301 
	C1872.041260,201.931442 1875.331299,198.364243 1880.383301,198.062286 
	C1885.934692,197.730469 1889.696899,201.237381 1889.987061,206.849106 
	C1890.129028,209.595276 1888.823242,211.931473 1888.096924,215.228729 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2210.701660,151.994141 
	C2206.769287,152.023468 2204.031982,151.433502 2204.052002,147.313705 
	C2204.061523,145.347809 2203.957031,143.379852 2204.013428,141.415985 
	C2204.181641,135.542999 2206.333984,132.591705 2210.571777,132.314331 
	C2214.839355,132.035019 2219.287842,135.801056 2219.910156,140.437683 
	C2220.169678,142.371185 2219.983643,144.364471 2220.000000,147.164978 
	C2217.134521,149.328201 2215.096924,152.442490 2210.701660,151.994141 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1400.170410,263.007935 
	C1401.324219,260.143982 1402.097046,257.876404 1403.489868,256.092926 
	C1405.341064,253.722870 1408.093628,253.609100 1410.736694,254.710526 
	C1413.771362,255.975098 1417.983765,264.707397 1417.003662,267.369995 
	C1415.290161,272.024933 1407.254517,275.645691 1402.749023,273.525269 
	C1398.300293,271.431549 1400.576416,267.173187 1400.170410,263.007935 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M928.662842,314.903748 
	C939.007568,310.656250 943.779846,312.941620 943.975464,321.456635 
	C944.111755,327.386780 941.345154,329.852295 934.414734,329.976898 
	C927.969055,330.092834 926.103943,328.275970 926.021240,321.815918 
	C925.990967,319.449951 926.168152,317.154480 928.662842,314.903748 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2291.789062,142.737106 
	C2292.380859,148.407715 2290.618164,152.098969 2285.770264,153.614990 
	C2281.545166,154.936310 2278.956787,152.027679 2276.393066,149.319809 
	C2273.037109,145.774811 2273.771729,142.075363 2275.907471,138.318436 
	C2278.544922,133.679550 2282.374268,132.731186 2286.638428,135.878220 
	C2288.768799,137.450760 2290.698486,139.352509 2291.789062,142.737106 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2005.274170,178.242035 
	C2000.596436,169.553970 2001.321167,166.062180 2007.619995,163.230164 
	C2010.897827,161.756378 2013.939453,161.548203 2016.867432,164.006546 
	C2019.721680,166.402908 2020.366577,169.504761 2019.824219,172.962494 
	C2019.251343,176.614548 2016.542114,178.431229 2013.625122,180.188217 
	C2010.471436,182.087860 2008.018555,181.394135 2005.274170,178.242035 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2181.921875,80.163437 
	C2181.040039,87.968506 2178.322998,91.466339 2173.887695,91.381134 
	C2169.761475,91.301872 2163.449707,85.370621 2162.737305,81.054115 
	C2162.424072,79.154144 2163.333496,77.908325 2164.459717,76.643936 
	C2167.293457,73.463036 2171.073730,74.039352 2174.708252,74.020973 
	C2178.433350,74.002129 2181.247070,75.207092 2181.921875,80.163437 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1617.595947,193.718048 
	C1609.605225,193.085205 1610.946655,187.005630 1610.182617,182.592636 
	C1609.521973,178.776688 1612.101807,176.846359 1615.741089,175.758881 
	C1621.336060,174.087051 1624.270752,175.499374 1626.835449,181.803787 
	C1629.122437,187.425125 1628.113892,189.655792 1622.067383,192.233826 
	C1620.862183,192.747620 1619.606445,193.142654 1617.595947,193.718048 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1537.842529,150.144226 
	C1540.587646,148.807770 1542.628784,147.751511 1544.740845,146.863754 
	C1546.058960,146.309738 1547.273438,146.795517 1548.307861,147.754242 
	C1551.792725,150.983383 1552.627808,159.930298 1549.733032,163.117538 
	C1546.577515,166.591705 1540.929810,167.032196 1537.277344,164.088989 
	C1533.134766,160.750870 1533.103638,156.845032 1537.842529,150.144226 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1922.497070,129.421005 
	C1918.925415,125.154533 1919.792480,121.433830 1922.258423,118.009827 
	C1925.962280,112.866524 1931.832153,113.222427 1935.070190,118.615257 
	C1935.402954,119.169212 1935.678833,119.794266 1935.816528,120.422455 
	C1936.685303,124.387047 1939.976074,128.386597 1936.063232,132.356049 
	C1933.272339,135.187317 1928.863770,134.294220 1922.497070,129.421005 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2010.125488,253.293030 
	C2009.111084,253.999008 2008.222168,253.999237 2006.666626,253.999435 
	C2004.229004,252.533051 2002.284546,251.229935 2000.721436,249.568054 
	C1996.892700,245.497375 1997.033936,239.803406 2000.853149,236.302628 
	C2004.074463,233.349930 2009.307495,233.170929 2012.706543,235.897430 
	C2016.798462,239.179733 2017.200195,244.565536 2013.483032,248.980270 
	C2012.452393,250.204453 2010.750610,250.853546 2010.125488,253.293030 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1133.163574,331.998260 
	C1134.558838,333.901764 1135.096436,335.812469 1135.680298,337.708954 
	C1138.167114,345.785736 1138.172119,345.784210 1128.712646,349.923096 
	C1127.526489,349.566650 1127.126465,348.945343 1126.568115,348.724396 
	C1119.840820,346.062012 1117.509766,343.377930 1118.190308,338.955658 
	C1118.867188,334.556671 1122.362305,332.381500 1129.398193,332.007935 
	C1130.371948,331.956238 1131.350708,331.999573 1133.163574,331.998260 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1857.663574,263.597137 
	C1855.296631,268.656799 1851.725952,271.477448 1847.245850,273.237244 
	C1844.760620,274.213409 1842.641357,273.672150 1841.119263,271.476166 
	C1838.477783,267.664856 1840.089966,258.593170 1843.763916,256.201996 
	C1849.013428,252.785370 1852.929565,253.891403 1856.904297,260.029022 
	C1857.419189,260.824036 1857.484985,261.909790 1857.663574,263.597137 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2272.666504,116.000938 
	C2265.419678,112.727325 2262.526367,107.244469 2264.210449,101.269012 
	C2265.294922,97.421898 2268.459473,96.592094 2271.789795,96.123360 
	C2275.060791,95.662949 2277.656982,96.706764 2278.883545,100.007225 
	C2280.843994,105.283356 2280.774658,110.290054 2276.345215,115.339966 
	C2275.111084,116.000725 2274.222168,116.000542 2272.666504,116.000938 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1874.668213,137.991302 
	C1876.439087,134.916885 1877.880371,132.182281 1880.052002,130.282654 
	C1883.634277,127.148842 1889.351929,127.317413 1891.747437,130.072495 
	C1894.677490,133.442459 1894.530396,138.785599 1891.393066,142.934647 
	C1888.814697,146.344574 1883.865234,147.150864 1879.906250,144.527145 
	C1877.717285,143.076355 1875.778931,141.216080 1874.668213,137.991302 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1469.836792,146.022308 
	C1477.389404,148.024429 1480.532227,151.820953 1479.477173,156.673492 
	C1478.408936,161.587845 1474.985474,164.291550 1470.256348,163.929199 
	C1465.660034,163.576996 1462.993042,161.032211 1462.134277,156.580109 
	C1460.992798,150.663071 1462.565796,148.296234 1469.836792,146.022308 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1697.720947,130.345123 
	C1700.455933,131.563385 1702.794189,132.334961 1704.366943,133.883804 
	C1708.322144,137.778961 1708.956665,143.278641 1706.240601,146.329193 
	C1703.130127,149.822754 1698.281006,150.438766 1694.860962,147.774979 
	C1689.934082,143.937576 1688.521118,138.501801 1691.430298,133.954132 
	C1692.693237,131.980057 1694.442505,130.458435 1697.720947,130.345123 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2040.244629,143.455887 
	C2039.526978,138.229706 2041.065918,135.083298 2045.399292,133.312500 
	C2048.267578,132.140366 2051.284912,131.091064 2053.709961,133.361221 
	C2056.836426,136.287918 2058.705322,140.160278 2059.198242,144.517151 
	C2059.257568,145.041473 2058.784668,145.849167 2058.314941,146.174637 
	C2054.711426,148.672913 2050.377930,149.018372 2046.273682,149.709076 
	C2042.543335,150.336884 2041.539062,146.956512 2040.244629,143.455887 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1016.625244,360.236816 
	C1024.130737,360.289490 1025.082153,365.403839 1025.889526,370.393097 
	C1026.582520,374.675598 1024.112549,377.085541 1020.414307,378.803986 
	C1017.206726,380.294434 1014.545654,379.867859 1012.397339,377.234924 
	C1010.121887,374.446136 1007.446594,371.661438 1009.311096,367.492432 
	C1010.705078,364.375610 1012.556519,361.698700 1016.625244,360.236816 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1076.442871,320.059082 
	C1083.471191,322.403137 1085.005981,324.809418 1083.860840,330.625488 
	C1082.998657,335.004547 1080.371460,337.532501 1075.848755,337.925262 
	C1071.106201,338.337097 1067.840088,335.854614 1066.612427,330.926849 
	C1065.537720,326.613770 1067.745117,323.963318 1076.442871,320.059082 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2148.757568,113.264359 
	C2147.926025,110.450813 2148.567871,108.564690 2149.705566,106.874031 
	C2152.973633,102.017769 2158.545654,100.707542 2162.539062,103.775810 
	C2166.243408,106.622032 2167.357422,114.157776 2164.537109,117.290192 
	C2161.490234,120.674187 2154.778076,120.823463 2151.029297,117.412743 
	C2150.097900,116.565147 2149.692871,115.138794 2148.757568,113.264359 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2040.364746,231.806549 
	C2040.446411,228.637619 2041.454346,226.484741 2042.921265,224.714310 
	C2046.223267,220.728867 2051.662598,221.088165 2054.558350,225.327957 
	C2055.115723,226.144028 2055.550293,227.054169 2055.964355,227.956253 
	C2057.631836,231.589569 2059.673096,235.466980 2056.307617,238.972260 
	C2053.673828,241.715652 2044.993408,239.772476 2042.204102,236.143723 
	C2041.415039,235.117233 2041.039917,233.772461 2040.364746,231.806549 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1894.329346,117.174271 
	C1892.447876,115.020058 1892.019653,113.138596 1892.030151,111.113182 
	C1892.047363,107.826218 1891.594238,104.061852 1895.499756,102.722595 
	C1899.255371,101.434792 1903.273438,101.206078 1906.741333,103.941689 
	C1910.555542,106.950493 1911.214844,111.764160 1907.650024,115.042702 
	C1904.130859,118.279358 1900.231934,122.199028 1894.329346,117.174271 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1605.722046,188.434875 
	C1606.189087,192.085938 1604.768311,194.185928 1602.850586,196.142624 
	C1599.127686,199.941254 1593.755005,201.166092 1590.485107,198.858673 
	C1587.646118,196.855515 1587.001709,189.344620 1589.394165,186.142914 
	C1592.306519,182.245041 1598.480469,181.060577 1602.562378,183.875458 
	C1603.835571,184.753510 1604.586426,186.389175 1605.722046,188.434875 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1801.037842,169.220398 
	C1796.728394,170.548752 1793.963379,169.247559 1791.644775,166.472610 
	C1787.948120,162.048691 1787.036499,156.660110 1789.616943,153.905869 
	C1791.726929,151.653870 1798.468994,151.249969 1801.720581,153.180756 
	C1805.712280,155.550995 1807.165894,160.405945 1805.011108,165.281281 
	C1804.389160,166.688095 1802.849487,167.689301 1801.037842,169.220398 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1904.148193,139.844116 
	C1897.275513,138.659561 1897.495239,134.196411 1898.513062,129.800980 
	C1899.374512,126.081390 1905.484741,122.268425 1909.653198,122.747307 
	C1913.975342,123.243835 1915.335938,126.474350 1916.118896,130.413422 
	C1917.388672,136.801178 1917.581421,136.732620 1910.697266,138.227310 
	C1908.756348,138.648666 1906.864014,139.294083 1904.148193,139.844116 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1463.459351,213.318832 
	C1459.342773,214.831177 1455.705566,218.572327 1453.836182,211.479660 
	C1451.549805,202.803680 1451.866089,200.289902 1457.335083,198.545624 
	C1463.358887,196.624435 1468.894653,199.763977 1471.079956,206.374710 
	C1473.404541,213.406845 1466.830444,211.156372 1463.459351,213.318832 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2310.356934,205.748260 
	C2310.511963,201.676453 2312.984375,199.773071 2315.260986,197.960358 
	C2319.130859,194.878845 2322.357910,195.632126 2326.578857,199.527206 
	C2330.125244,202.799530 2330.355225,206.061493 2327.952393,210.070984 
	C2325.354492,214.405899 2321.911377,214.647858 2317.774414,212.826859 
	C2314.680664,211.464981 2311.949219,209.694061 2310.356934,205.748260 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2337.753174,185.939209 
	C2328.121338,184.806366 2325.020508,181.950546 2326.879150,176.524139 
	C2328.260742,172.491684 2330.625977,169.684601 2335.523682,170.018845 
	C2340.899902,170.385773 2345.285156,173.317245 2345.880127,177.427963 
	C2346.689209,183.020248 2343.302734,185.062363 2337.753174,185.939209 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2084.548340,222.413696 
	C2084.000000,221.110657 2084.000000,220.221909 2084.000000,218.666595 
	C2084.043945,216.808899 2084.407227,215.734406 2085.583496,214.401657 
	C2086.219971,213.365295 2086.598877,212.848328 2087.568359,212.223022 
	C2093.413330,211.755646 2098.639160,211.679977 2101.776855,217.495438 
	C2103.585693,220.848160 2103.837402,223.462387 2100.793945,226.288895 
	C2097.628906,229.228638 2094.520020,231.281876 2090.227783,228.812851 
	C2087.833252,227.435318 2086.619873,224.984756 2084.548340,222.413696 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1999.257446,265.905457 
	C2000.635254,266.938232 2001.270386,267.876495 2001.952759,269.406799 
	C2001.266846,275.857391 1997.068970,278.763702 1992.046021,279.157440 
	C1987.472290,279.515991 1984.443726,275.918488 1982.873657,271.576050 
	C1980.590454,265.260895 1983.998901,261.230377 1990.639771,262.052704 
	C1993.781006,262.441650 1995.549072,265.298492 1999.257446,265.905457 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1434.460693,216.095642 
	C1433.320557,215.246918 1432.657837,214.856766 1432.430298,214.291443 
	C1431.051880,210.866058 1426.665405,207.909134 1429.952515,203.674454 
	C1432.194336,200.786209 1442.681030,201.467361 1445.912354,204.272034 
	C1448.943604,206.903015 1448.110596,210.334534 1447.618286,213.526352 
	C1447.144775,216.595505 1444.781250,217.755310 1441.835205,217.926590 
	C1439.455200,218.064941 1437.210815,217.698120 1434.460693,216.095642 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2134.787598,163.712036 
	C2136.657715,169.269562 2136.090576,173.020538 2130.107422,173.916916 
	C2124.183105,174.804550 2119.476318,172.231842 2118.257080,167.433823 
	C2116.987793,162.439423 2119.442627,158.343048 2124.668457,156.784683 
	C2130.312988,155.101486 2132.275879,159.231354 2134.787598,163.712036 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1817.903564,168.769104 
	C1818.887817,168.000015 1819.775757,167.999420 1821.329346,167.998184 
	C1823.953613,168.108780 1826.056274,167.801071 1827.841309,168.415817 
	C1831.941772,169.827805 1834.440552,172.712524 1833.726074,177.362564 
	C1833.108643,181.381256 1827.464478,186.037643 1824.001709,185.615982 
	C1819.072266,185.015732 1815.760010,181.236099 1816.133057,176.152634 
	C1816.296997,173.918716 1817.225708,171.740891 1817.903564,168.769104 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1733.931763,160.216309 
	C1732.155396,164.793274 1729.031494,166.637344 1725.214111,165.179459 
	C1721.860596,163.898682 1719.231201,161.121506 1718.245850,157.372772 
	C1717.119385,153.086746 1719.453125,147.742538 1723.201416,146.722900 
	C1727.530273,145.545380 1730.769775,147.864304 1733.387939,151.044769 
	C1735.535522,153.653229 1734.736328,156.604843 1733.931763,160.216309 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2102.265137,248.031860 
	C2093.335449,250.019775 2090.933838,248.869217 2090.108643,242.646683 
	C2089.368408,237.062546 2093.301514,232.552795 2099.250977,232.133057 
	C2104.375244,231.771530 2106.249023,235.413376 2107.319092,239.288010 
	C2108.367188,243.083710 2109.362793,247.490875 2102.265137,248.031860 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2031.325684,211.888489 
	C2032.000000,212.888626 2032.000000,213.777267 2032.000000,215.332336 
	C2027.527710,224.937714 2019.877197,226.681839 2014.764893,220.025604 
	C2012.572266,217.170807 2011.103760,214.547058 2013.886108,211.217773 
	C2016.909180,207.600449 2021.761108,205.881638 2025.128540,207.742554 
	C2027.108032,208.836533 2028.819336,210.415909 2031.325684,211.888489 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2000.686890,208.585327 
	C1996.889648,210.332520 1994.141724,208.450241 1991.552124,207.430786 
	C1986.803955,205.561462 1984.894165,200.755035 1986.768188,197.066528 
	C1988.646851,193.368744 1994.576782,191.680435 1998.748535,193.383331 
	C2002.488770,194.910110 2004.389648,197.882584 2005.455811,201.421356 
	C2006.527588,204.979019 2004.277588,206.916885 2000.686890,208.585327 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1968.410400,306.407043 
	C1968.000000,305.111053 1968.000000,304.222870 1968.000000,302.668549 
	C1968.051025,299.715759 1967.808105,297.374603 1968.219238,295.154633 
	C1968.906982,291.441132 1973.361206,288.257263 1976.776733,288.659546 
	C1981.242798,289.185577 1984.000366,292.958649 1984.021973,297.673828 
	C1984.038818,301.329376 1980.837036,303.317230 1980.093384,307.261169 
	C1977.866577,308.000397 1975.733276,308.000793 1972.799927,308.001221 
	C1970.809570,307.955963 1969.740479,307.585663 1968.410400,306.407043 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1705.910645,172.727722 
	C1706.888916,171.999863 1707.777832,171.999741 1709.333374,171.999512 
	C1711.788330,174.572830 1714.996094,175.020752 1717.264893,176.841766 
	C1720.127075,179.139038 1720.883667,184.522644 1718.934692,187.520676 
	C1716.921387,190.617706 1712.102417,191.886536 1708.596313,190.242737 
	C1701.331299,186.836639 1700.689575,182.953964 1705.910645,172.727722 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2233.180664,162.624390 
	C2227.936279,158.271957 2230.340088,154.470612 2233.090576,151.083664 
	C2235.562744,148.039230 2241.964600,147.030762 2244.968506,148.866257 
	C2248.852295,151.239395 2248.357422,155.001282 2247.427002,158.552841 
	C2246.098389,163.626038 2241.973877,166.230591 2237.073486,165.207458 
	C2235.886719,164.959686 2234.890869,163.796432 2233.180664,162.624390 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2066.322998,284.405029 
	C2056.529053,285.952301 2051.869629,280.857239 2054.237305,272.492004 
	C2055.180420,269.160156 2057.775635,267.796082 2060.613037,266.952148 
	C2063.914795,265.970062 2066.420654,267.790222 2068.006348,270.459839 
	C2070.759033,275.093201 2071.227539,279.744446 2066.322998,284.405029 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1344.094482,236.079437 
	C1343.040771,228.860855 1344.770752,226.620926 1351.712646,225.149567 
	C1356.257935,224.186188 1360.164795,226.593582 1361.391113,231.113724 
	C1362.460449,235.054596 1359.801880,239.715942 1355.456055,241.131424 
	C1350.637329,242.700928 1347.313965,240.164078 1344.094482,236.079437 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1328.126465,260.076965 
	C1328.290894,256.791443 1329.880859,255.091248 1331.570068,253.473541 
	C1335.847900,249.376801 1339.274658,248.962112 1342.914917,252.058472 
	C1346.635986,255.223602 1346.871826,260.559509 1343.464355,264.492767 
	C1340.165527,268.300568 1334.929810,268.929260 1331.049194,265.864227 
	C1329.462524,264.611023 1328.337402,262.958252 1328.126465,260.076965 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1371.358765,198.057678 
	C1377.502075,199.605759 1378.594116,203.744278 1377.430908,208.202835 
	C1376.448364,211.968933 1373.248901,213.860947 1369.097900,214.004822 
	C1363.315308,214.205261 1360.544800,211.873016 1360.091187,206.002914 
	C1359.684814,200.743439 1361.337524,198.953400 1367.558838,198.038300 
	C1368.531006,197.895294 1369.542114,198.017883 1371.358765,198.057678 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1669.312256,203.764893 
	C1664.794556,204.391724 1662.070557,203.104370 1660.845825,199.392487 
	C1659.685181,195.874817 1659.298096,192.222626 1661.010376,188.855148 
	C1662.623047,185.683563 1665.856812,185.789093 1668.824341,186.195709 
	C1672.424683,186.689026 1674.846924,188.962082 1675.656982,192.417130 
	C1676.855713,197.530136 1675.075195,201.440216 1669.312256,203.764893 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1392.573975,178.730804 
	C1391.768433,180.249283 1391.379883,181.184418 1390.778442,181.952881 
	C1388.078003,185.402985 1384.740112,187.278290 1380.493042,184.924026 
	C1376.547241,182.736694 1375.374268,179.047989 1376.250488,174.761826 
	C1376.964355,171.269684 1382.111694,167.659988 1386.163696,168.199753 
	C1391.808716,168.951691 1393.740967,172.669525 1392.573975,178.730804 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2104.472168,199.303467 
	C2103.343750,197.549667 2102.433350,196.424576 2102.275635,195.202377 
	C2101.234863,187.133911 2103.327881,185.108734 2111.483887,186.045090 
	C2116.559570,186.627808 2119.877197,189.795837 2119.855957,194.039780 
	C2119.833008,198.637222 2115.892334,201.937347 2110.431641,201.940277 
	C2108.370117,201.941391 2106.560547,201.295181 2104.472168,199.303467 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1222.706543,390.653442 
	C1222.007812,387.688812 1221.919312,385.389709 1222.020386,383.098938 
	C1222.306763,376.608307 1225.665283,373.551025 1231.827393,374.070038 
	C1237.090454,374.513336 1239.582642,378.309448 1238.718018,384.622955 
	C1238.541382,385.912994 1238.243652,387.186432 1237.973145,389.213867 
	C1233.400391,393.645081 1228.481567,393.334167 1222.706543,390.653442 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1999.609375,145.185822 
	C2002.626587,144.604095 2004.894165,144.129578 2007.168335,144.096405 
	C2011.885620,144.027527 2013.292358,147.486603 2013.776489,151.236176 
	C2014.278442,155.123413 2012.180298,157.085358 2008.301147,158.034790 
	C2001.587158,159.678070 1998.613403,159.099731 1995.604492,154.320465 
	C1992.923340,150.062012 1993.438721,146.833527 1999.609375,145.185822 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2204.083496,234.384003 
	C2206.458008,228.409897 2211.311768,228.385376 2215.819580,228.140305 
	C2221.262451,227.844376 2221.866455,232.409393 2222.935303,236.179001 
	C2224.138916,240.422501 2220.057129,239.692383 2218.134766,240.956680 
	C2217.311035,241.498413 2216.364746,241.870987 2215.442871,242.243576 
	C2207.414551,245.488983 2205.414795,244.247986 2204.083496,234.384003 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1314.090210,253.268738 
	C1313.666626,253.999802 1313.333374,254.000198 1312.500000,254.001221 
	C1306.954102,254.449417 1303.984985,251.734772 1301.780884,247.557175 
	C1300.059814,244.295349 1299.527954,241.369858 1302.558105,238.549438 
	C1305.944458,235.397568 1309.821289,235.120773 1313.596069,237.176697 
	C1317.091187,239.080246 1318.910156,242.338699 1317.442627,246.437729 
	C1316.673828,248.585266 1315.287720,250.511795 1314.090210,253.268738 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1299.500366,266.650574 
	C1302.627075,270.823151 1303.118164,274.786102 1300.210449,278.137054 
	C1297.822021,280.889587 1294.197998,282.955139 1290.448486,281.464569 
	C1285.799438,279.616425 1285.514771,274.529633 1284.893799,270.537628 
	C1284.245117,266.367126 1288.691772,265.685150 1291.599365,264.509735 
	C1294.191528,263.461853 1296.813232,264.098663 1299.500366,266.650574 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1703.985840,213.240585 
	C1703.019287,215.171494 1702.038574,216.340530 1700.528931,217.755402 
	C1698.015259,217.978790 1696.018555,218.088165 1694.048340,217.907379 
	C1689.506836,217.490616 1686.752441,214.903076 1686.149780,210.431229 
	C1685.745605,207.433853 1685.863892,204.196259 1689.240723,202.780746 
	C1693.226318,201.110092 1697.126709,201.944550 1700.421631,204.587387 
	C1702.836914,206.524582 1703.906616,209.343292 1703.985840,213.240585 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2022.453491,294.709229 
	C2016.371582,297.191986 2012.431641,295.196320 2010.524292,290.151031 
	C2009.129395,286.461273 2010.598755,282.869354 2013.936401,280.542297 
	C2018.318481,277.486877 2022.492920,278.448975 2025.929077,283.048035 
	C2029.209106,287.438049 2028.757568,289.272034 2022.453491,294.709229 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1520.000000,179.999237 
	C1523.205933,180.148209 1525.946655,177.044312 1529.471924,178.903976 
	C1533.784180,181.178802 1536.005737,185.491928 1534.382446,189.128128 
	C1531.815308,194.878281 1526.565308,197.548477 1521.700684,195.528610 
	C1519.338501,194.547791 1518.348511,192.655457 1518.059326,190.152130 
	C1517.701782,187.056137 1518.990601,184.370270 1519.901611,180.776642 
	C1520.000000,179.999390 1520.000000,180.000000 1520.000000,179.999237 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1435.461914,335.529175 
	C1436.000000,336.332916 1436.000000,336.666595 1436.000000,337.500732 
	C1434.024048,338.018951 1432.031616,337.878204 1430.074951,338.081573 
	C1421.037476,339.020966 1421.061401,338.965363 1417.699463,331.452911 
	C1416.192871,328.086151 1415.370483,325.320953 1419.562378,323.290161 
	C1424.524170,320.886414 1429.594849,321.724243 1431.538696,325.823334 
	C1432.937744,328.773560 1433.814209,331.971619 1435.461914,335.529175 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M993.343384,400.569702 
	C992.928833,392.145355 995.925537,388.478729 1002.467834,388.316345 
	C1006.575928,388.214355 1010.537231,392.708008 1009.789734,396.934113 
	C1009.039795,401.173706 1005.998230,403.931610 1002.329529,405.419159 
	C998.399536,407.012726 995.356567,405.154480 993.343384,400.569702 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1032.059082,363.700439 
	C1031.799805,357.362061 1035.836304,355.672150 1040.043335,354.376617 
	C1044.150757,353.111725 1046.110107,355.827606 1047.522461,359.058472 
	C1048.796753,361.973267 1051.332275,364.870758 1048.367432,368.133148 
	C1045.004395,371.833832 1036.032471,371.344818 1032.929810,367.281586 
	C1032.374634,366.554688 1032.351929,365.421417 1032.059082,363.700439 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2266.053955,183.974365 
	C2260.238525,181.956757 2256.225342,177.468735 2256.708496,173.766693 
	C2257.093018,170.818100 2258.354004,167.969040 2261.343018,166.674072 
	C2264.361816,165.366302 2267.040283,166.267853 2269.419434,168.517532 
	C2275.878418,174.625275 2274.917969,180.530243 2266.053955,183.974365 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1874.415405,108.715782 
	C1881.077637,106.115807 1883.052368,106.814346 1884.754028,111.637703 
	C1886.313232,116.056839 1879.009155,127.479485 1874.331543,127.762344 
	C1871.437378,127.937355 1870.229004,126.199295 1870.063354,123.437584 
	C1869.753296,118.270103 1871.307007,113.636147 1874.415405,108.715782 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1736.063721,333.498352 
	C1739.303345,337.375336 1740.424316,340.850342 1737.585693,344.791260 
	C1735.364136,347.875641 1732.961304,350.576385 1728.695190,349.721588 
	C1724.402466,348.861450 1722.978882,345.213501 1722.475952,341.673462 
	C1721.913330,337.713135 1724.320435,334.866150 1727.911011,333.124756 
	C1730.434570,331.900879 1732.948608,331.661255 1736.063721,333.498352 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1958.407715,217.589462 
	C1957.010498,218.521240 1956.020874,219.042465 1954.515625,219.782455 
	C1953.333618,219.998108 1952.656738,220.070145 1952.002319,219.980225 
	C1945.387451,219.071503 1942.328003,216.682648 1942.137817,212.317230 
	C1941.932129,207.598145 1945.331055,204.831055 1952.372803,204.015625 
	C1953.030640,203.939438 1953.704590,204.002197 1955.185547,204.000092 
	C1959.824707,205.670349 1960.151978,208.982544 1959.999512,213.259644 
	C1959.955688,215.189758 1959.585938,216.259018 1958.407715,217.589462 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1052.074463,357.760864 
	C1052.005127,351.008179 1055.737183,349.853638 1060.670776,350.002258 
	C1064.374512,350.113861 1067.212158,351.165100 1067.854858,355.315826 
	C1068.585938,360.037598 1067.610107,363.713654 1062.628784,365.770264 
	C1056.928833,368.123627 1054.674316,370.326355 1052.074463,357.760864 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1576.098389,118.148407 
	C1579.482544,116.098137 1582.532593,115.136398 1584.641357,118.173004 
	C1587.016357,121.592949 1590.636475,125.491547 1589.156372,129.583435 
	C1587.817139,133.285568 1582.987793,133.983688 1579.020630,133.732239 
	C1575.060303,133.481232 1571.942627,129.503433 1572.146484,125.492935 
	C1572.285645,122.755234 1573.590576,120.497398 1576.098389,118.148407 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1314.333130,282.035156 
	C1318.378784,279.739227 1321.968140,279.219696 1325.425537,281.051758 
	C1328.558716,282.711975 1330.127686,285.535645 1329.975098,289.248383 
	C1329.856934,292.124786 1329.084351,294.788544 1326.116699,295.477173 
	C1322.620972,296.288300 1318.272827,297.323120 1315.885254,294.072510 
	C1313.552368,290.896301 1310.622192,287.008667 1314.333130,282.035156 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1253.467651,321.850220 
	C1257.483154,316.538177 1261.607666,318.583832 1265.536743,320.412354 
	C1269.115967,322.078217 1268.071899,325.570496 1267.822754,328.353394 
	C1267.422241,332.827362 1263.913330,335.981171 1259.960571,335.827759 
	C1255.760132,335.664703 1253.249390,333.185364 1252.271118,329.269226 
	C1251.704346,327.000671 1251.851807,324.641266 1253.467651,321.850220 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1979.080811,128.702881 
	C1987.459717,135.424149 1988.041260,140.566040 1981.515991,144.179504 
	C1976.964722,146.699875 1972.907715,146.349731 1970.974731,143.269989 
	C1968.933594,140.017853 1969.984619,131.880646 1972.820068,129.790695 
	C1974.432739,128.601974 1976.296143,127.982491 1979.080811,128.702881 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1438.136719,197.934601 
	C1433.682739,197.211044 1430.496338,195.587997 1427.969971,192.797348 
	C1426.012085,190.634430 1425.567993,188.060623 1426.635620,185.420471 
	C1427.802734,182.534363 1430.395996,181.989456 1433.199219,182.045670 
	C1437.994751,182.141830 1445.371216,188.852264 1445.296509,193.465530 
	C1445.231323,197.492661 1442.035400,197.861710 1438.136719,197.934601 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1474.217529,199.227600 
	C1473.671753,193.313797 1475.372314,190.119888 1481.140747,189.974365 
	C1485.469116,189.865189 1489.311768,190.742340 1491.103516,194.946716 
	C1492.809937,198.950760 1490.574341,202.020859 1487.301025,204.155731 
	C1483.593872,206.573532 1479.806030,206.854630 1476.511230,203.306763 
	C1475.630005,202.357849 1475.058960,201.120911 1474.217529,199.227600 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1896.766357,213.905090 
	C1896.436646,210.569733 1894.375610,207.622055 1894.116089,204.343216 
	C1893.805664,200.422012 1894.467407,197.065613 1899.217407,196.144760 
	C1904.863037,195.050293 1908.534302,197.133530 1909.707397,202.316849 
	C1910.822876,207.245087 1909.407837,210.347565 1905.161987,211.778412 
	C1902.673340,212.617126 1900.079468,213.143372 1896.766357,213.905090 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1414.131470,238.040253 
	C1414.381592,236.307312 1414.439209,235.230530 1414.928223,234.411362 
	C1418.282593,228.793655 1422.290527,226.998642 1426.007812,229.330750 
	C1429.666748,231.626205 1431.464966,238.763458 1429.214355,242.790985 
	C1426.953857,246.835983 1423.123291,246.479324 1419.572266,245.372635 
	C1416.595459,244.444962 1414.650391,242.080444 1414.131470,238.040253 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1758.754883,222.092056 
	C1758.000000,222.000610 1758.000000,221.000900 1758.000000,220.501068 
	C1757.868164,216.671768 1754.684937,213.084610 1758.946167,210.130447 
	C1762.191406,207.880737 1765.281860,204.963745 1769.532837,207.940964 
	C1773.124512,210.456497 1774.624390,214.011459 1773.532593,218.247101 
	C1772.491699,222.284500 1768.370483,224.239777 1763.244995,223.425079 
	C1761.966431,223.221832 1760.753052,222.608398 1758.754883,222.092056 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1688.452637,125.347672 
	C1682.895630,115.933960 1684.633789,110.933601 1693.042603,110.158432 
	C1698.055298,109.696342 1703.531494,117.243317 1701.542847,121.873093 
	C1700.172485,125.063545 1694.143921,126.974869 1688.452637,125.347672 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1776.000000,179.999313 
	C1777.880005,179.469910 1779.737305,178.833435 1781.644531,178.434845 
	C1785.663086,177.594971 1788.785645,178.436935 1789.818726,183.044434 
	C1791.141602,188.944199 1788.346069,194.644943 1783.531860,195.705536 
	C1779.823486,196.522522 1775.533203,193.850677 1774.369873,190.049973 
	C1773.419922,186.946213 1775.094360,184.314102 1775.908447,180.753662 
	C1776.000000,179.998779 1776.000000,180.000000 1776.000000,179.999313 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1298.485718,321.356750 
	C1295.562622,313.506256 1297.514038,309.168030 1303.923950,307.079681 
	C1307.375244,305.955292 1309.790649,307.489258 1311.673828,309.925018 
	C1313.286987,312.011749 1314.518188,314.411621 1313.132324,317.283783 
	C1310.912720,321.883423 1305.093628,323.824371 1298.485718,321.356750 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2096.240723,263.325348 
	C2097.271240,255.149765 2098.724609,253.586304 2103.964844,254.068085 
	C2108.472656,254.482544 2113.651855,259.804810 2113.279541,264.091187 
	C2113.004883,267.255981 2111.405029,269.629761 2107.734619,269.949829 
	C2102.680664,270.390594 2098.536621,269.241821 2096.240723,263.325348 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1528.496582,262.182495 
	C1526.989380,263.631287 1526.079468,264.766266 1524.910034,265.198120 
	C1520.899780,266.678955 1517.135864,266.369720 1514.074951,262.941772 
	C1512.076172,260.703552 1511.502930,258.310272 1513.475342,255.813202 
	C1516.204712,252.357910 1519.204102,249.371475 1524.229980,250.082565 
	C1529.354492,250.807617 1530.230713,252.836716 1528.496582,262.182495 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2176.088379,203.858215 
	C2174.848145,202.676041 2174.142822,201.951920 2173.680664,201.096527 
	C2171.835693,197.682739 2170.901611,194.183258 2174.396729,191.259613 
	C2177.169922,188.939911 2184.500977,189.777130 2187.311279,192.475235 
	C2191.281738,196.287140 2190.711670,201.050064 2185.972656,203.956284 
	C2182.933594,205.819962 2179.889648,206.472244 2176.088379,203.858215 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1731.437988,197.279633 
	C1733.728149,191.933060 1737.526978,191.445221 1741.753052,192.390442 
	C1744.828003,193.078140 1745.864258,195.479752 1745.929321,198.409225 
	C1746.023560,202.640823 1744.749512,206.432007 1741.308472,208.945953 
	C1737.813354,211.499405 1733.135132,209.831192 1732.106201,205.679733 
	C1731.493042,203.205795 1729.715942,200.750046 1731.437988,197.279633 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2206.053955,221.912231 
	C2199.282715,217.756241 2198.155762,211.284531 2202.449463,206.642838 
	C2205.965820,202.841171 2209.064209,205.280273 2211.941406,207.281616 
	C2216.239014,210.271027 2217.076416,214.587173 2214.429199,218.270370 
	C2212.583496,220.838409 2210.072266,222.148331 2206.053955,221.912231 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2303.628662,189.917572 
	C2302.878418,192.536713 2302.384033,194.476776 2301.579102,196.278305 
	C2300.112793,199.560425 2297.639648,200.371841 2294.261230,199.090149 
	C2290.166992,197.536911 2285.889404,192.676941 2286.720215,189.661316 
	C2287.911621,185.337631 2291.786133,183.399200 2295.592041,182.583328 
	C2300.355957,181.562057 2302.716797,184.863876 2303.628662,189.917572 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1552.612549,341.338318 
	C1552.945923,349.267609 1550.364258,352.271942 1544.433716,351.942139 
	C1540.288696,351.711609 1536.419067,347.632568 1536.306152,343.374908 
	C1536.209961,339.745453 1539.918701,336.384094 1544.305664,336.052612 
	C1548.031494,335.771057 1550.796997,337.071960 1552.612549,341.338318 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1853.002686,107.345825 
	C1849.457275,108.200264 1846.998169,107.883522 1845.575195,104.921776 
	C1844.135864,101.926056 1842.629883,98.797531 1842.809204,95.511497 
	C1842.992065,92.163055 1851.582153,89.528831 1854.531128,91.817429 
	C1857.518921,94.136002 1859.530762,97.342636 1859.622314,101.124008 
	C1859.710083,104.746323 1856.367676,105.744492 1853.002686,107.345825 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1004.676025,432.722717 
	C1004.078369,428.765808 1003.878967,425.343445 1001.505798,422.122467 
	C999.059875,418.802704 999.439697,415.312347 1003.001892,412.619354 
	C1007.235962,409.418457 1009.861877,410.141571 1012.417358,414.863861 
	C1014.599548,418.896454 1013.714844,423.242828 1014.272583,428.363342 
	C1012.050110,432.210632 1008.553833,432.299255 1004.676025,432.722717 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2044.573975,192.097443 
	C2041.712402,195.550903 2039.001099,196.624908 2035.433838,194.659439 
	C2032.259277,192.910385 2030.457886,190.302032 2030.322266,186.792084 
	C2030.177368,183.039505 2033.918213,178.575256 2037.156372,178.168411 
	C2041.319336,177.645401 2045.097046,180.818146 2045.877075,185.705688 
	C2046.188110,187.653702 2046.025391,189.657700 2044.573975,192.097443 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2240.943115,201.639069 
	C2241.583496,195.758621 2244.792969,192.568848 2249.913574,192.499359 
	C2254.918701,192.431458 2258.376221,197.035507 2257.912598,201.918961 
	C2257.456787,206.721222 2254.617188,208.368149 2248.520020,208.019867 
	C2244.562988,207.793823 2242.590332,205.581528 2240.943115,201.639069 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1898.071289,259.310669 
	C1897.112183,260.000397 1896.224243,260.000824 1894.670654,260.001831 
	C1886.858276,259.252411 1884.137085,257.084930 1884.135986,252.141876 
	C1884.135132,248.242203 1887.213989,244.799988 1891.323364,244.106033 
	C1897.908325,242.994080 1901.856934,247.541443 1899.918335,254.073898 
	C1899.457031,255.628494 1898.741211,257.107574 1898.071289,259.310669 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1210.264893,281.381744 
	C1206.338135,281.642517 1202.889038,282.513031 1198.757324,283.908752 
	C1196.762695,281.315765 1195.185913,278.728577 1194.373047,275.920227 
	C1193.331299,272.321564 1194.905884,269.716705 1198.281860,267.840637 
	C1201.785767,265.893402 1205.007446,266.397003 1207.069092,269.274994 
	C1209.411133,272.544464 1212.949341,275.886230 1210.264893,281.381744 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1439.492676,317.818542 
	C1447.125000,312.900146 1449.649780,313.286163 1452.494507,319.111847 
	C1455.160034,324.570496 1454.029907,328.217529 1448.984253,330.440582 
	C1444.590332,332.376526 1439.366211,329.899567 1438.247681,325.170868 
	C1437.714478,322.916412 1437.863281,320.580200 1439.492676,317.818542 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1799.247314,223.908920 
	C1800.000000,224.000000 1800.000000,224.999115 1800.000000,225.498642 
	C1800.096558,226.645584 1800.142944,227.305298 1800.297607,227.938522 
	C1802.020874,234.987549 1801.341309,236.975021 1796.886841,237.835297 
	C1791.495239,238.876526 1785.583008,235.418793 1784.493774,230.587357 
	C1783.668945,226.927704 1786.729126,222.947220 1790.905884,222.178696 
	C1793.678223,221.668564 1795.970947,223.249496 1799.247314,223.908920 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1574.086182,183.281616 
	C1572.424805,184.630524 1570.849609,185.261002 1568.637207,185.945435 
	C1566.302734,184.268677 1564.577271,182.566101 1562.432861,180.425278 
	C1561.999268,179.112442 1561.998657,178.223663 1561.996582,176.668365 
	C1562.015747,175.339905 1562.010254,174.675949 1562.061401,174.016388 
	C1562.382812,169.872543 1564.699097,167.289902 1568.603638,166.302917 
	C1571.421875,165.590576 1573.818359,166.578140 1575.443970,169.113388 
	C1577.753418,172.715286 1578.944336,176.265488 1575.375854,179.883392 
	C1574.731445,180.536713 1574.561401,181.657990 1574.086182,183.281616 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1270.128662,343.436584 
	C1272.118774,345.341400 1273.834106,346.587830 1274.765625,348.268707 
	C1277.044800,352.381561 1276.180054,355.189178 1271.719116,356.927185 
	C1268.877319,358.034393 1265.538330,360.947968 1262.593872,358.141693 
	C1259.183228,354.891113 1259.229980,350.125275 1260.524414,345.984283 
	C1261.907715,341.558807 1265.631836,341.417389 1270.128662,343.436584 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1778.392334,336.680969 
	C1768.363037,338.256714 1766.529175,337.343109 1766.047241,331.260559 
	C1765.625000,325.930359 1767.984985,322.783112 1772.846191,322.193481 
	C1777.228027,321.661987 1781.278931,324.827515 1781.866333,329.471588 
	C1782.207153,332.166138 1782.015137,334.836548 1778.392334,336.680969 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1866.484375,303.102844 
	C1866.129761,311.424438 1864.014771,314.290771 1859.368652,313.865601 
	C1855.368774,313.499573 1850.407959,307.736572 1850.337036,303.347321 
	C1850.293335,300.649567 1851.764893,298.773895 1854.238037,298.404907 
	C1858.781128,297.727203 1863.623535,296.865387 1866.484375,303.102844 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1113.252563,315.661682 
	C1115.494141,311.930115 1117.957886,309.810272 1121.794678,311.073090 
	C1124.327881,311.906799 1126.708374,313.173096 1127.673706,316.032135 
	C1129.291992,320.825226 1126.983521,325.182953 1121.799316,327.025757 
	C1117.360107,328.603699 1113.610107,326.446106 1112.304565,321.177765 
	C1111.938965,319.702759 1112.677124,317.954315 1113.252563,315.661682 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1777.967285,265.855774 
	C1774.476929,265.369934 1771.936890,264.463531 1770.567505,261.949646 
	C1768.886719,258.864075 1770.249756,252.592667 1772.721069,251.011993 
	C1776.412476,248.650909 1782.595215,250.343781 1784.903564,254.347656 
	C1787.170288,258.279510 1785.981812,262.292419 1781.609741,265.040558 
	C1780.808716,265.544128 1779.724731,265.597748 1777.967285,265.855774 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1991.575928,159.874512 
	C1984.975342,165.204788 1981.782959,165.072571 1977.108643,160.079926 
	C1974.420532,157.208847 1972.514526,154.108536 1975.686157,150.540771 
	C1978.595093,147.268631 1984.013672,147.317657 1987.303467,150.471558 
	C1989.749023,152.816208 1991.290771,155.711548 1991.575928,159.874512 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1523.427734,376.873596 
	C1519.306885,372.392883 1519.320312,368.751404 1523.775146,365.544678 
	C1527.389282,362.943085 1532.697510,363.592926 1535.243164,366.832764 
	C1538.097290,370.465240 1537.975220,374.281189 1534.903442,377.471771 
	C1531.484985,381.022461 1527.551147,381.400238 1523.427734,376.873596 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2187.917236,162.722473 
	C2190.777832,161.999054 2193.555664,161.998703 2197.166748,161.997986 
	C2198.201904,162.261597 2198.352783,162.600616 2198.613525,162.778305 
	C2202.380615,165.346680 2205.946533,168.357117 2202.909180,173.263947 
	C2200.983643,176.374420 2197.722900,178.310989 2193.514893,176.715088 
	C2188.042969,174.639755 2186.134766,171.299774 2187.288818,165.357620 
	C2187.414795,164.709427 2187.649902,164.082397 2187.917236,162.722473 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2248.535645,134.397141 
	C2249.830078,125.037148 2250.348633,124.618439 2261.192871,123.999283 
	C2262.303711,125.273361 2262.607910,126.547165 2262.910889,127.821327 
	C2264.458252,134.332092 2263.223145,138.351456 2258.736572,140.500854 
	C2252.805420,143.342438 2251.699951,137.713242 2248.535645,134.397141 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2285.182373,213.053284 
	C2286.510742,218.336075 2286.093018,222.250839 2281.097168,224.436096 
	C2278.274902,225.670593 2275.514404,226.715210 2272.662354,224.937668 
	C2269.638916,223.053436 2269.757080,219.927338 2270.234375,216.977280 
	C2270.812988,213.399063 2273.133301,211.051117 2276.641357,210.302139 
	C2279.580322,209.674622 2282.580811,209.702438 2285.182373,213.053284 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1908.042969,215.261871 
	C1913.049561,216.212769 1916.165527,217.938080 1916.023682,223.140335 
	C1915.916992,227.054367 1913.956055,229.214035 1910.617676,230.644974 
	C1907.772339,231.864670 1904.803101,233.043503 1902.457153,230.140717 
	C1900.037720,227.147018 1898.892944,223.617432 1901.357056,220.055313 
	C1902.845703,217.903519 1904.513062,215.742203 1908.042969,215.261871 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1748.568481,320.253021 
	C1743.109619,319.955902 1737.103638,315.506470 1736.417236,312.103119 
	C1736.351807,311.779144 1736.271851,311.432190 1736.321289,311.115021 
	C1736.895386,307.429230 1740.356812,307.129456 1742.798950,305.653320 
	C1745.600220,303.960236 1748.364624,303.576141 1750.980835,306.093689 
	C1752.999390,308.036102 1754.509521,310.132172 1753.302734,313.106384 
	C1752.300659,315.575989 1751.162842,317.975189 1748.568481,320.253021 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1930.844116,246.000290 
	C1929.779785,245.367249 1929.400757,244.850388 1928.431396,244.225311 
	C1928.021729,242.004791 1927.801758,239.970535 1928.111816,238.020584 
	C1928.925659,232.902618 1932.501099,229.728668 1936.660400,230.145096 
	C1940.503052,230.529846 1944.359131,236.205948 1943.834595,240.707199 
	C1943.534058,243.284286 1942.217651,245.215225 1939.641479,245.616562 
	C1937.033813,246.022827 1934.342773,245.894272 1930.844116,246.000290 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2036.955811,252.738693 
	C2040.902832,255.376068 2042.957642,258.366882 2041.443481,262.395111 
	C2040.211548,265.672272 2037.653931,267.767487 2033.890747,267.932831 
	C2030.734009,268.071533 2027.629883,267.698608 2026.535278,264.255646 
	C2025.507812,261.023926 2025.637207,257.721466 2028.197632,254.932739 
	C2030.432739,252.498489 2033.060669,251.611786 2036.955811,252.738693 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2216.223145,184.656952 
	C2216.822998,183.061569 2217.129883,182.007477 2217.825684,181.397507 
	C2220.116699,179.388977 2221.693359,175.049713 2225.662842,177.293655 
	C2229.018066,179.190231 2232.245850,181.962494 2231.827637,186.600342 
	C2231.498535,190.254639 2229.226074,192.701859 2225.819824,193.588791 
	C2221.227051,194.784653 2218.343750,192.191742 2216.474854,188.304382 
	C2216.073975,187.470718 2216.216064,186.376068 2216.223145,184.656952 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1828.752930,294.806641 
	C1828.311646,291.802368 1827.862183,289.460968 1828.220947,287.250702 
	C1828.848877,283.381348 1831.097290,280.411896 1835.289185,280.421661 
	C1838.547119,280.429260 1840.838135,282.971436 1841.472412,285.918579 
	C1842.268433,289.616760 1843.386230,293.870361 1838.875488,296.400543 
	C1835.461304,298.315613 1832.091309,298.863068 1828.752930,294.806641 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2073.939697,203.737030 
	C2072.844482,209.581406 2069.295166,211.636490 2064.612793,210.966949 
	C2061.826904,210.568588 2058.892090,209.058853 2058.355713,205.515045 
	C2057.852783,202.193207 2062.222900,195.424164 2065.508789,194.523834 
	C2069.018066,193.562439 2071.161133,195.750458 2072.761963,198.307510 
	C2073.574219,199.604935 2073.590576,201.400513 2073.939697,203.737030 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1557.145264,207.700363 
	C1546.798584,211.286880 1544.813477,210.540817 1542.816406,203.653000 
	C1541.660400,199.665558 1542.895142,197.442581 1546.714111,196.051407 
	C1550.950439,194.508194 1554.386475,195.426910 1557.469727,198.549805 
	C1560.272095,201.388107 1560.552002,204.215759 1557.145264,207.700363 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1566.574585,354.566895 
	C1573.729736,351.783997 1576.858643,352.296387 1578.890137,356.450043 
	C1580.573608,359.892303 1581.028320,363.736603 1577.810425,366.506592 
	C1575.066895,368.868134 1571.550171,368.498199 1568.438843,366.903015 
	C1564.320679,364.791626 1563.785645,361.726196 1566.574585,354.566895 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1822.948364,253.263901 
	C1819.925171,254.097534 1817.726685,253.997650 1815.720703,252.460953 
	C1811.857300,249.501205 1811.096802,245.387161 1813.520752,241.168228 
	C1815.888916,237.046570 1819.459106,237.472809 1822.945068,238.823410 
	C1827.281982,240.503754 1828.939331,244.989120 1826.954346,249.385696 
	C1826.323853,250.782425 1824.771484,251.763000 1822.948364,253.263901 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2114.015137,170.163788 
	C2115.652344,173.578354 2117.351562,176.845810 2114.345215,178.855362 
	C2110.995850,181.094040 2106.649170,180.671036 2103.052246,179.062683 
	C2099.906738,177.656082 2098.623291,174.335953 2098.441406,170.938309 
	C2098.344727,169.131531 2099.870117,168.080902 2101.423096,167.420944 
	C2105.911377,165.513428 2110.257568,164.681320 2114.015137,170.163788 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1716.397949,414.011414 
	C1716.253296,411.084717 1717.453247,409.504913 1718.967529,408.163605 
	C1723.620972,404.041199 1727.930298,403.218140 1730.379517,405.906830 
	C1732.613403,408.358826 1732.599854,415.619415 1730.356812,418.048218 
	C1727.466431,421.178253 1721.155518,420.465454 1717.407837,416.531128 
	C1716.973389,416.075073 1716.817871,415.353241 1716.397949,414.011414 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1106.136475,298.181580 
	C1110.916382,289.571472 1116.290771,288.098450 1120.289551,293.519714 
	C1122.860352,297.004974 1122.492065,301.818542 1119.483887,304.049469 
	C1115.868530,306.730743 1110.645996,306.590332 1108.016235,303.445648 
	C1107.024536,302.259613 1106.750732,300.473358 1106.136475,298.181580 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1436.642578,406.638031 
	C1436.132080,403.680115 1435.227173,401.229767 1434.605347,398.678619 
	C1433.640015,394.718811 1435.549438,391.627625 1438.983398,389.669403 
	C1441.930420,387.988831 1445.129395,386.747162 1447.780640,390.150848 
	C1449.991455,392.988953 1450.827026,396.174805 1447.847778,398.982361 
	C1445.272705,401.408997 1444.121704,405.326752 1439.453369,406.575531 
	C1438.231445,406.846375 1437.761108,406.884552 1436.642578,406.638031 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1507.492676,422.552124 
	C1510.572144,423.053436 1513.141357,423.811554 1516.380127,424.490997 
	C1519.018188,425.099182 1521.233276,423.994934 1523.556641,425.897003 
	C1525.833496,428.152832 1528.199341,428.284424 1531.114014,428.809113 
	C1534.435669,427.729889 1536.979492,427.485626 1539.468750,430.355713 
	C1543.339355,433.197784 1547.326782,434.309052 1552.116089,434.617889 
	C1556.909912,435.306488 1562.070068,433.717804 1564.231689,439.688843 
	C1562.831665,441.482910 1561.617676,441.621948 1560.273315,441.129608 
	C1544.175415,435.233673 1527.574097,431.037292 1511.066650,426.519897 
	C1509.523682,426.097656 1508.098145,425.245880 1506.333496,424.030823 
	C1506.360107,423.248352 1506.671143,423.028625 1507.492676,422.552124 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1941.641479,148.353729 
	C1940.709106,154.834824 1935.475586,154.408569 1931.655884,155.466599 
	C1928.328491,156.388214 1927.108521,152.925812 1926.562744,150.528152 
	C1925.895996,147.599197 1922.505981,144.187881 1926.230103,141.477432 
	C1929.753906,138.912903 1933.805542,139.239029 1937.135376,142.316742 
	C1938.807617,143.862274 1940.086914,145.832870 1941.641479,148.353729 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1840.949463,225.182831 
	C1837.941406,226.038345 1835.513794,226.470001 1833.408936,225.312698 
	C1829.932983,223.401642 1827.930420,220.073456 1828.540405,216.264191 
	C1829.219849,212.020950 1833.278076,210.549515 1836.851685,210.456650 
	C1840.999023,210.348877 1843.300415,213.523895 1843.859985,217.537262 
	C1844.231201,220.200165 1844.048584,222.892593 1840.949463,225.182831 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1609.136230,310.873718 
	C1603.015747,313.393646 1599.158936,312.042389 1596.870850,307.281799 
	C1594.972412,303.332001 1596.474854,299.862823 1600.742676,297.656158 
	C1604.811890,295.552246 1607.613770,297.208069 1610.015625,300.373657 
	C1612.597168,303.776245 1611.922729,307.102112 1609.136230,310.873718 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1642.618896,247.348404 
	C1644.998291,252.366684 1642.616577,255.046951 1639.265137,257.049713 
	C1636.807861,258.518066 1634.163940,258.203827 1631.779541,256.484253 
	C1628.792114,254.329712 1627.739258,251.407394 1628.098022,247.793457 
	C1628.423584,244.515778 1630.874634,243.363541 1633.391357,242.555862 
	C1637.464966,241.248505 1640.540527,242.652740 1642.618896,247.348404 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2070.743652,251.260696 
	C2067.437012,246.466187 2068.552734,243.187943 2072.775879,240.877426 
	C2076.378174,238.906754 2081.288574,239.901093 2083.381104,243.089020 
	C2084.986816,245.535614 2086.772217,248.271637 2083.840332,251.060120 
	C2081.078369,253.686935 2078.738281,257.728210 2073.955566,254.617569 
	C2072.877441,253.916214 2072.068848,252.800537 2070.743652,251.260696 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1695.134033,388.621124 
	C1698.149292,387.984802 1700.515991,387.594330 1702.633545,388.656952 
	C1705.683350,390.187225 1708.322510,392.346313 1707.494019,396.262878 
	C1706.637573,400.311676 1704.033569,402.066101 1699.695557,402.073517 
	C1694.941040,402.081665 1692.548096,399.696228 1690.915039,395.689117 
	C1689.388428,391.942963 1691.413818,390.223602 1695.134033,388.621124 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2159.925049,286.626099 
	C2168.339355,291.504700 2169.226562,294.594330 2164.456543,300.318909 
	C2162.509766,302.655273 2160.269287,304.885132 2156.904053,303.153809 
	C2153.794434,301.554077 2151.702637,298.975616 2152.162598,295.230621 
	C2152.686035,290.966949 2154.964600,287.945099 2159.925049,286.626099 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2226.200928,200.348328 
	C2233.770020,201.128799 2235.762695,207.171021 2239.783691,211.734116 
	C2236.463623,215.346161 2232.054443,214.461105 2228.600586,215.011276 
	C2223.979736,215.747314 2222.439453,210.979233 2220.884033,207.441742 
	C2218.921143,202.977646 2222.460693,201.815674 2226.200928,200.348328 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1707.259766,319.910828 
	C1708.004883,319.998077 1709.002441,319.998962 1709.501221,319.999481 
	C1709.723511,324.460693 1711.311646,329.518951 1705.660034,332.150024 
	C1702.830444,333.467255 1700.250122,334.609741 1697.385254,332.220032 
	C1694.176880,329.543793 1693.175415,326.111633 1694.500000,322.407349 
	C1695.608398,319.307526 1698.577881,318.148529 1701.776978,318.404053 
	C1703.383789,318.532410 1704.937012,319.329132 1707.259766,319.910828 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2183.625977,266.151886 
	C2183.360107,268.168365 2183.192627,269.547852 2182.560059,270.663696 
	C2179.418213,276.205780 2175.628174,277.378784 2171.475342,274.238403 
	C2167.544678,271.266113 2166.999756,266.561951 2170.170166,262.971375 
	C2173.519531,259.178680 2178.299805,259.039337 2182.167969,262.747162 
	C2182.841797,263.392975 2183.073975,264.499603 2183.625977,266.151886 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1358.487061,270.664673 
	C1362.352539,267.507355 1366.137817,266.757599 1368.641357,270.431366 
	C1370.511230,273.175323 1372.885254,276.748627 1370.211182,280.517853 
	C1367.769043,283.960144 1364.202515,284.602448 1360.401001,283.642761 
	C1355.831177,282.489136 1355.249146,279.205841 1358.487061,270.664673 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1765.997803,357.211914 
	C1766.000000,358.890533 1766.000000,359.778595 1766.000000,361.332733 
	C1763.782349,362.596222 1761.597168,363.449493 1759.339966,363.735657 
	C1755.161499,364.265472 1750.918091,361.294098 1750.367676,357.770905 
	C1749.848633,354.448425 1754.890381,348.686798 1758.952393,348.232025 
	C1763.446045,347.728943 1765.762329,349.956024 1765.948853,354.442047 
	C1765.976196,355.101349 1765.980591,355.761597 1765.997803,357.211914 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1838.062256,333.621307 
	C1838.078613,326.961548 1841.705566,325.562683 1846.647583,326.157318 
	C1850.250732,326.590851 1852.965698,328.727112 1853.534180,332.284637 
	C1854.219604,336.572754 1850.539917,338.668854 1847.736938,340.776031 
	C1844.730347,343.036377 1842.169434,341.234589 1840.020142,338.854828 
	C1838.878540,337.590820 1838.226929,336.109924 1838.062256,333.621307 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1283.552246,349.204773 
	C1279.418213,345.134216 1280.515503,341.543060 1283.291260,338.178650 
	C1285.482910,335.522186 1288.650391,335.609009 1291.557861,336.340546 
	C1294.977539,337.200897 1297.668091,339.441467 1297.601562,343.226837 
	C1297.543335,346.535583 1295.029175,348.750885 1292.052612,349.490723 
	C1289.578125,350.105774 1286.827393,349.608795 1283.552246,349.204773 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1221.255127,389.987000 
	C1226.733521,389.982819 1231.457153,389.981537 1237.062744,389.970215 
	C1237.944702,389.960205 1237.963013,390.867737 1237.944824,391.321136 
	C1237.926636,391.774536 1238.073486,392.452606 1238.115234,392.796997 
	C1226.730713,393.753632 1215.475830,396.287384 1203.140625,396.363159 
	C1201.330688,396.346466 1200.366577,396.155731 1198.701172,395.733002 
	C1198.255737,392.789307 1199.557983,390.468536 1201.041382,388.325592 
	C1205.644043,381.676575 1207.959717,381.354645 1213.560669,387.305786 
	C1215.679321,389.556946 1217.833862,390.015839 1221.255127,389.987000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1616.270386,204.484741 
	C1622.735596,196.393250 1627.019287,196.230896 1630.500854,203.014511 
	C1632.262329,206.446716 1632.003296,209.258575 1629.071777,211.788528 
	C1625.884888,214.538742 1622.597290,214.706940 1619.285034,212.079926 
	C1617.111084,210.355682 1615.862671,208.133408 1616.270386,204.484741 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1560.000000,239.999084 
	C1561.600464,239.571655 1563.208374,239.171143 1564.799927,238.713623 
	C1568.983276,237.511032 1571.269531,239.365829 1571.831299,243.377808 
	C1572.455566,247.834396 1572.115601,252.113388 1567.743286,254.848083 
	C1565.452393,256.280975 1563.382080,255.789078 1561.329468,254.175690 
	C1556.555298,250.423035 1558.144653,245.984131 1559.909180,240.750671 
	C1560.000000,239.998779 1560.000000,240.000000 1560.000000,239.999084 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1721.726807,369.528809 
	C1720.812378,372.171143 1719.550415,373.722656 1717.840698,374.737061 
	C1714.181763,376.908142 1710.888062,376.078674 1708.167725,372.992615 
	C1705.387695,369.838745 1705.327026,366.503143 1707.964355,363.201752 
	C1710.699463,359.777985 1713.847900,359.716492 1717.543823,361.766876 
	C1720.417969,363.361359 1722.143799,365.371796 1721.726807,369.528809 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1753.145874,249.799957 
	C1745.014404,248.638245 1743.075684,246.503876 1744.171387,240.973282 
	C1744.803101,237.785034 1746.714233,235.505249 1749.663818,234.574188 
	C1752.828491,233.575256 1755.462158,235.342224 1757.473022,237.610840 
	C1759.628052,240.042191 1759.952271,242.800552 1758.105347,245.751648 
	C1757.026367,247.475876 1755.925903,249.017197 1753.145874,249.799957 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1464.000000,372.000610 
	C1461.084351,371.902557 1459.297974,374.238098 1456.912598,375.257904 
	C1453.782227,376.596313 1451.163818,376.011688 1449.438599,372.693481 
	C1447.508545,368.981323 1449.437988,366.111115 1451.726807,363.807983 
	C1454.308472,361.210358 1457.801147,359.057526 1461.560547,360.518036 
	C1464.981812,361.847198 1466.272095,364.929535 1464.697510,368.672455 
	C1464.443115,369.277100 1464.331421,369.941772 1464.076904,371.289948 
	C1464.000000,372.001221 1464.000000,372.000000 1464.000000,372.000610 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2116.583496,206.472580 
	C2120.936035,203.128159 2123.985107,203.721130 2125.631348,208.219772 
	C2127.281738,212.729843 2124.688232,218.946899 2120.774170,219.662491 
	C2117.292480,220.299042 2113.204102,221.016556 2111.002197,217.112442 
	C2107.887939,211.590454 2113.181641,209.804443 2116.583496,206.472580 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1698.334473,254.504944 
	C1699.583984,252.206436 1700.554688,250.439545 1701.960083,249.144775 
	C1706.029053,245.396576 1708.835083,245.448318 1711.879272,249.021500 
	C1714.769531,252.414047 1714.573364,256.353546 1711.357788,259.492920 
	C1708.014771,262.756714 1703.165649,262.964478 1700.163574,259.674103 
	C1699.140625,258.552856 1698.869019,256.745911 1698.334473,254.504944 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1803.642456,267.581329 
	C1808.793701,264.832825 1810.754272,267.694580 1812.573120,271.184113 
	C1814.121338,274.154449 1814.077515,276.719727 1811.670532,279.240631 
	C1808.799194,282.247772 1805.290771,282.617310 1801.708008,281.445251 
	C1798.320557,280.337158 1797.664307,277.370178 1798.350098,274.192291 
	C1798.937500,271.471161 1801.208618,269.886322 1803.642456,267.581329 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1792.615967,346.694244 
	C1791.755493,342.398254 1792.380737,339.302704 1796.432373,338.338043 
	C1799.734009,337.551910 1802.947266,337.875244 1805.473145,340.614838 
	C1808.262451,343.639923 1808.999146,346.897858 1806.266602,350.268799 
	C1803.545898,353.625244 1799.597778,353.906525 1796.150146,351.052917 
	C1794.909790,350.026428 1793.980469,348.624359 1792.615967,346.694244 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2153.688965,172.365601 
	C2161.057861,178.433594 2161.616211,182.268021 2156.373291,185.742783 
	C2151.868408,188.728378 2147.792236,188.041565 2145.251953,183.868973 
	C2142.910156,180.022232 2143.811523,176.826370 2148.315918,173.966522 
	C2149.672119,173.105469 2151.385986,172.807907 2153.688965,172.365601 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1253.367920,354.009583 
	C1249.251953,362.174316 1246.074463,363.689911 1241.563599,360.289764 
	C1238.996826,358.354980 1237.535645,355.823700 1238.305786,352.514313 
	C1239.041138,349.353729 1241.119629,347.220856 1244.208130,346.385681 
	C1247.454468,345.507874 1250.114746,346.568420 1251.736328,349.653168 
	C1252.352417,350.825043 1252.829102,352.070312 1253.367920,354.009583 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1811.716064,324.438782 
	C1806.748169,316.400085 1807.276367,314.355194 1813.568237,311.805237 
	C1817.562134,310.186554 1820.664062,310.513062 1822.906616,314.376068 
	C1824.998169,317.978851 1823.693115,322.321472 1819.894653,324.726044 
	C1817.419067,326.293304 1814.886719,326.246521 1811.716064,324.438782 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2176.649414,214.192368 
	C2179.666016,210.957870 2183.180420,212.270905 2186.310547,211.683609 
	C2191.120605,210.781067 2192.875732,212.615372 2191.774170,217.025574 
	C2191.396729,218.536850 2190.655762,220.208649 2189.550293,221.235748 
	C2187.035889,223.571579 2185.344482,227.978485 2181.175537,227.016251 
	C2177.205566,226.099884 2178.409180,221.598679 2177.306641,218.696152 
	C2176.850830,217.495773 2176.685791,216.184998 2176.649414,214.192368 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1070.093750,387.239502 
	C1067.792847,388.620026 1065.585571,389.240051 1062.689209,389.930054 
	C1062.069214,387.121124 1059.775513,385.332672 1058.786987,382.960327 
	C1057.617188,380.152985 1057.192017,376.980255 1059.597168,374.672791 
	C1061.757690,372.600189 1064.736206,371.190155 1067.739746,372.556946 
	C1071.098999,374.085602 1072.062622,377.386902 1071.785767,380.826324 
	C1071.631592,382.741028 1070.744263,384.596680 1070.093750,387.239502 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1537.216919,294.000977 
	C1538.633423,294.218658 1539.150391,294.597443 1539.775391,295.566620 
	C1540.578491,299.687622 1542.725098,303.286926 1538.491943,306.668915 
	C1534.116699,310.164398 1531.626343,310.721710 1528.412842,307.281647 
	C1525.094727,303.729553 1525.397339,299.360657 1529.062500,296.052307 
	C1531.219360,294.105347 1533.779785,293.972382 1537.216919,294.000977 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1602.062744,234.217621 
	C1602.238525,232.803131 1602.253174,232.088852 1602.554565,231.528687 
	C1604.185059,228.497177 1606.216797,225.549744 1610.158081,226.549316 
	C1613.823608,227.478928 1614.773804,231.084335 1615.658813,234.245590 
	C1616.692505,237.938095 1614.888794,240.756226 1611.892334,242.695175 
	C1609.095337,244.505142 1606.850830,242.395203 1604.651733,241.070282 
	C1602.412842,239.721283 1602.004395,237.407440 1602.062744,234.217621 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1506.174805,278.151550 
	C1511.710449,281.700531 1513.518921,287.296753 1511.022705,291.176697 
	C1508.848755,294.555542 1505.432007,294.471680 1502.229004,293.461395 
	C1499.005981,292.444824 1497.121338,286.690369 1498.683105,283.274231 
	C1499.973389,280.452484 1502.135376,278.519104 1506.174805,278.151550 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1528.167480,142.979492 
	C1527.922241,138.558640 1527.714355,134.920425 1530.933350,132.190842 
	C1533.447632,130.058945 1536.210327,129.311020 1539.122070,130.951797 
	C1542.249146,132.713959 1542.291504,135.679581 1541.430054,138.754181 
	C1540.248291,142.971710 1536.792725,145.117584 1533.302856,146.902878 
	C1530.495728,148.338867 1529.212524,146.003876 1528.167480,142.979492 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1683.007080,285.403717 
	C1682.423584,282.251160 1683.689697,280.223297 1685.038330,278.396332 
	C1687.026123,275.703644 1689.277344,273.052734 1693.266724,274.891663 
	C1696.747559,276.496155 1698.901001,281.291748 1697.736938,284.974152 
	C1696.538452,288.764984 1693.344482,289.611359 1689.926758,289.848785 
	C1686.952881,290.055420 1685.052612,288.155975 1683.007080,285.403717 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1614.120972,429.304077 
	C1613.111084,429.999176 1612.222168,429.999573 1610.666626,430.000000 
	C1610.016602,427.363098 1607.703735,426.223572 1606.468018,424.379883 
	C1603.658936,420.189178 1604.181152,417.000488 1608.022095,414.215759 
	C1611.284302,411.850555 1614.596680,411.285004 1617.595703,414.740356 
	C1620.613892,418.217560 1621.017090,421.720428 1617.435059,425.055542 
	C1616.254028,426.155121 1614.723145,426.895020 1614.120972,429.304077 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1256.388306,298.330353 
	C1259.817993,297.999390 1262.520630,297.736450 1264.099365,300.558197 
	C1265.528564,303.112701 1267.276367,305.556580 1267.535767,308.594208 
	C1267.660156,310.047638 1266.823120,311.167938 1265.508667,311.562622 
	C1264.282227,311.930908 1262.903931,312.073975 1261.629517,311.945862 
	C1258.547119,311.635956 1254.312500,313.478241 1252.819214,309.703857 
	C1251.285034,305.826477 1250.733276,301.247986 1256.388306,298.330353 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1192.823486,354.001343 
	C1191.360107,352.139771 1190.309326,350.307343 1190.169434,348.407806 
	C1189.908936,344.871613 1189.053467,340.712769 1193.241699,338.767120 
	C1197.842651,336.629730 1200.704468,339.373749 1203.439819,343.568542 
	C1203.218262,353.344330 1203.218262,353.344330 1192.823486,354.001343 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2190.456055,232.290695 
	C2197.695557,235.208115 2199.318115,238.815292 2196.867432,244.141190 
	C2195.360352,247.416962 2192.839355,248.258530 2189.568848,247.888535 
	C2186.040771,247.489410 2184.362549,245.462753 2184.068115,241.985870 
	C2183.681641,237.424973 2185.671631,234.355331 2190.456055,232.290695 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1986.567871,225.267639 
	C1985.928955,233.744171 1983.744263,236.589600 1979.046265,235.788498 
	C1975.447144,235.174759 1972.744019,232.988037 1972.437744,229.313141 
	C1972.141357,225.755157 1974.223633,223.080399 1977.442139,221.361267 
	C1981.651489,219.112946 1984.398804,220.600052 1986.567871,225.267639 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1726.000000,291.999390 
	C1725.992798,293.639862 1726.150391,295.301453 1725.949219,296.918396 
	C1725.163452,303.232422 1720.315063,305.989197 1714.854980,303.109650 
	C1711.786011,301.491089 1709.612671,298.933533 1710.283447,295.167084 
	C1710.908936,291.655243 1713.985474,290.873077 1716.884399,290.202087 
	C1719.620483,289.568878 1721.955933,291.227997 1725.240967,291.905884 
	C1726.000000,291.998779 1726.000000,292.000000 1726.000000,291.999390 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1633.991821,314.021973 
	C1639.664185,314.055359 1642.581543,316.217529 1641.651733,321.329620 
	C1640.933960,325.275574 1638.185059,327.791565 1634.012573,327.800079 
	C1629.836914,327.808624 1627.084839,325.294739 1626.355103,321.352936 
	C1625.409424,316.245209 1628.318848,314.071625 1633.991821,314.021973 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1859.258545,195.005096 
	C1854.109009,199.563568 1851.304443,199.833206 1848.137695,196.701981 
	C1845.409668,194.004547 1845.096436,186.442612 1847.706787,183.809067 
	C1850.033813,181.461456 1852.572876,181.872421 1854.744995,183.951370 
	C1857.665649,186.746765 1859.995117,189.941101 1859.258545,195.005096 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1663.355713,409.779175 
	C1662.711060,412.448792 1661.318970,413.849670 1659.691040,414.961456 
	C1654.963013,418.190430 1652.135132,417.980347 1649.595337,414.346466 
	C1647.377808,411.173706 1647.857422,406.104767 1650.619995,403.516296 
	C1653.219482,401.080902 1658.182617,401.530457 1661.089111,404.731415 
	C1662.145264,405.894684 1662.602539,407.601776 1663.355713,409.779175 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1784.056152,300.396545 
	C1784.635742,295.571899 1787.042969,293.713348 1790.958252,294.252106 
	C1794.579102,294.750397 1796.906738,297.090759 1797.703735,300.635742 
	C1798.554077,304.417664 1796.557251,307.114410 1793.546021,308.909943 
	C1788.581909,311.869812 1785.239136,309.093842 1784.056152,300.396545 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1499.326416,217.995483 
	C1500.000000,218.889359 1500.000000,219.778122 1500.000000,221.333435 
	C1500.000000,224.777786 1500.000000,227.555557 1500.000000,231.166672 
	C1496.338745,232.355408 1492.889282,231.486969 1488.757324,230.093781 
	C1487.024780,227.896332 1485.832275,225.855637 1486.006104,222.701447 
	C1483.946777,215.763916 1487.319214,214.563431 1493.239502,215.511093 
	C1495.085815,217.750900 1496.819824,217.986160 1499.326416,217.995483 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1583.429199,211.065338 
	C1586.707764,214.253311 1586.111938,217.678146 1585.779175,220.931168 
	C1585.445679,224.192322 1583.280884,226.341095 1580.334473,227.461258 
	C1578.267090,228.247223 1576.083984,227.496246 1575.195801,225.564056 
	C1573.861206,222.660828 1571.327881,219.419342 1573.324829,216.300140 
	C1575.357300,213.125320 1577.756348,209.334915 1583.429199,211.065338 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1494.000000,351.999390 
	C1496.890747,351.347717 1499.754761,350.355743 1502.678589,350.124969 
	C1507.135986,349.773132 1510.371338,352.608765 1511.167847,356.798828 
	C1511.528442,358.695404 1510.901245,360.223694 1509.299194,360.941528 
	C1505.195435,362.780212 1500.747192,362.543610 1496.648071,361.415710 
	C1492.837036,360.367035 1494.373413,356.485138 1494.000732,352.850616 
	C1494.000000,351.998779 1494.000000,352.000000 1494.000000,351.999390 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2211.641357,192.315613 
	C2207.862793,198.258194 2204.065430,199.359100 2199.831543,196.520966 
	C2195.351074,193.517441 2195.226807,189.655762 2199.501953,186.288071 
	C2206.723633,180.599365 2207.780762,181.061218 2211.641357,192.315613 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2217.065918,263.265472 
	C2215.620117,262.284882 2214.810547,261.702759 2214.154297,260.981201 
	C2211.946289,258.554413 2211.357178,255.758041 2212.961426,252.849915 
	C2214.691406,249.714188 2217.819824,249.792725 2220.776611,250.184189 
	C2224.365234,250.659271 2226.685059,252.913345 2227.635986,256.355591 
	C2228.305908,258.780304 2227.623779,260.834290 2225.283936,262.222900 
	C2222.922363,263.624268 2220.485107,264.278900 2217.065918,263.265472 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1586.814331,267.998840 
	C1586.000000,267.998779 1586.000000,267.000580 1586.000000,266.501526 
	C1586.050659,263.708191 1585.870483,261.379669 1586.204834,259.127563 
	C1586.733032,255.570496 1588.880737,252.905075 1592.450928,252.449051 
	C1596.291382,251.958496 1598.484985,254.791626 1599.566528,258.022583 
	C1600.754761,261.573029 1599.034302,264.355194 1596.169067,266.518890 
	C1593.560669,268.488617 1590.533813,267.848724 1586.814331,267.998840 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M959.500061,437.149200 
	C955.707825,432.864960 955.050598,429.124603 959.503601,425.738770 
	C962.484924,423.471985 965.548401,423.474609 968.510864,425.769440 
	C971.011780,427.706665 972.407593,430.190033 971.680969,433.464386 
	C970.890564,437.026306 968.231628,437.969910 965.031006,437.946533 
	C963.403931,437.934662 961.778564,437.701813 959.500061,437.149200 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1687.367432,468.843292 
	C1686.171753,463.911530 1687.457031,460.887299 1691.995239,460.139435 
	C1696.042114,459.472534 1699.279907,461.115204 1701.029175,464.826569 
	C1702.292480,467.507080 1698.443726,474.078522 1694.920410,475.238953 
	C1689.877319,476.899963 1688.563721,473.365662 1687.367432,468.843292 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1028.976807,327.255646 
	C1022.818665,328.982391 1020.290894,325.766083 1018.859253,321.279633 
	C1017.838623,318.081268 1020.358826,316.352753 1022.518005,314.981079 
	C1024.892212,313.472687 1027.431030,311.174042 1030.548462,313.752777 
	C1033.700806,316.360504 1034.990356,319.547729 1032.989136,323.348145 
	C1032.255981,324.740448 1030.788330,325.745880 1028.976807,327.255646 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1670.035522,374.129791 
	C1672.490234,374.328308 1673.965088,375.031952 1675.104858,376.267303 
	C1678.477173,379.922028 1678.751831,384.196381 1675.833374,386.580933 
	C1673.045776,388.858459 1666.321899,388.375854 1664.136963,385.741394 
	C1661.299072,382.319672 1661.705322,379.235352 1665.733032,375.627197 
	C1666.636108,374.818207 1668.078125,374.610870 1670.035522,374.129791 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2022.000000,336.000000 
	C2020.262207,327.448395 2023.397827,323.075928 2030.496460,324.069214 
	C2033.776001,324.528107 2036.526855,326.283112 2037.138062,329.279968 
	C2037.883423,332.933685 2035.200439,335.237000 2032.052002,336.957275 
	C2028.903931,338.677246 2026.280518,336.859863 2022.731934,336.085632 
	C2022.000000,336.001221 2022.000000,336.000000 2022.000000,336.000000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1522.784180,215.999359 
	C1522.003296,212.572006 1522.001709,209.142792 1522.000000,204.856567 
	C1524.692627,202.761627 1527.283936,201.161484 1530.102295,200.372559 
	C1534.106567,199.251587 1536.248169,201.453171 1535.928955,205.787338 
	C1535.519531,211.347702 1531.529175,214.642426 1522.784180,215.999359 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1582.511963,294.196472 
	C1579.188232,298.028809 1576.169067,298.936005 1572.708008,295.600677 
	C1569.687378,292.689758 1569.249512,289.093353 1570.661621,285.542908 
	C1572.181519,281.721802 1575.678711,281.192047 1578.973633,282.865753 
	C1583.327148,285.077148 1585.206787,288.684021 1582.511963,294.196472 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1637.908447,356.755249 
	C1638.333374,355.999573 1638.666626,355.999176 1639.500000,355.998169 
	C1644.670776,355.502686 1647.381104,357.847260 1648.965820,362.020691 
	C1650.077637,364.949036 1650.592651,367.765594 1648.182617,370.276733 
	C1646.374756,372.160431 1643.973267,372.318878 1641.764771,371.507843 
	C1638.870117,370.444885 1636.823120,368.335815 1636.191895,365.128296 
	C1635.645264,362.349701 1637.241943,360.042114 1637.908447,356.755249 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M988.264526,379.413422 
	C988.234314,376.996613 987.919312,375.153870 988.561401,373.748322 
	C990.216858,370.124451 996.007751,367.152679 998.300049,368.753693 
	C1001.223083,370.795227 1002.362366,373.963348 1001.693542,377.517181 
	C1000.951111,381.462372 996.935486,384.232300 992.818726,383.750122 
	C990.655457,383.496735 989.247803,382.160583 988.264526,379.413422 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1555.811646,270.859009 
	C1556.039185,275.011200 1555.953125,278.360016 1551.907227,279.577545 
	C1549.169312,280.401459 1546.783569,279.579102 1544.727905,277.592377 
	C1541.467407,274.441284 1541.216797,270.060150 1544.201538,267.212280 
	C1547.507568,264.058105 1550.641602,264.117188 1554.277466,267.551941 
	C1554.951416,268.188507 1555.235718,269.237701 1555.811646,270.859009 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1750.562622,178.922729 
	C1747.310669,175.728333 1747.763550,172.298080 1748.260498,169.085358 
	C1748.899170,164.956604 1753.486450,162.595535 1757.428955,164.400436 
	C1760.815796,165.951050 1762.424927,168.800400 1760.630493,172.492905 
	C1758.744751,176.373276 1756.844727,180.509155 1750.562622,178.922729 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2090.823730,284.680115 
	C2093.912842,286.827209 2096.359375,288.746460 2095.543945,292.233490 
	C2094.648926,296.060516 2092.137695,298.618591 2088.300049,299.498749 
	C2084.870117,300.285309 2083.567871,297.636963 2082.793945,295.119965 
	C2081.607178,291.261414 2080.907471,287.159607 2085.344238,284.749542 
	C2086.628662,284.051880 2088.516113,284.464355 2090.823730,284.680115 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1487.519531,318.298462 
	C1486.162598,316.770691 1485.056396,315.833527 1484.681885,314.662445 
	C1483.373413,310.570343 1483.523315,306.899445 1488.296387,304.941437 
	C1492.660400,303.151245 1495.222778,305.559113 1497.107300,308.862518 
	C1499.076172,312.313477 1497.500977,316.481262 1493.638306,318.912872 
	C1491.807129,320.065704 1489.923950,319.934601 1487.519531,318.298462 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1614.000000,271.999390 
	C1621.975464,270.316620 1625.029785,271.348450 1627.063477,276.252991 
	C1628.227051,279.058899 1627.891846,281.497040 1625.281372,283.123291 
	C1622.867065,284.627441 1620.395752,286.770844 1617.304443,284.180359 
	C1613.844971,281.281403 1610.937378,278.281067 1613.929199,272.689270 
	C1614.000000,271.998779 1614.000000,272.000000 1614.000000,271.999390 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M890.395752,474.724670 
	C888.361633,478.268829 885.007751,479.159393 881.081055,480.199249 
	C877.921631,479.802734 874.668396,480.378113 874.274414,476.731750 
	C873.855042,472.849670 875.526001,469.774109 878.926758,467.634979 
	C881.614502,465.944305 883.912781,466.735046 886.200439,468.363037 
	C888.174133,469.767639 888.910645,472.022614 890.395752,474.724670 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1868.091309,156.091110 
	C1874.668091,158.540924 1876.830444,161.680176 1875.623413,165.827576 
	C1874.654663,169.156265 1870.900757,170.763382 1866.695801,169.759872 
	C1863.701904,169.045349 1862.304810,167.112000 1862.105103,164.172928 
	C1861.836060,160.214920 1862.604736,156.902191 1868.091309,156.091110 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1802.383301,203.791595 
	C1807.268555,194.369415 1811.463867,193.798019 1816.081909,201.072754 
	C1817.378540,203.115616 1818.400513,205.031815 1816.971680,207.359726 
	C1815.600708,209.593079 1813.376709,209.903259 1811.019287,209.973206 
	C1806.925171,210.094635 1804.296631,207.987167 1802.383301,203.791595 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1202.508057,360.257690 
	C1204.538574,360.349426 1206.053955,360.213562 1207.071045,360.860809 
	C1212.000732,363.998077 1212.915894,366.981903 1210.309326,370.469513 
	C1207.362549,374.411926 1202.748413,375.012787 1199.073486,371.932800 
	C1195.466431,368.909698 1195.475342,366.253387 1199.259033,361.950745 
	C1199.880859,361.243622 1200.917969,360.901703 1202.508057,360.257690 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2009.023193,319.232574 
	C2007.414551,321.151825 2005.939697,321.922455 2004.238037,321.888641 
	C2000.792236,321.820129 1996.451416,323.081757 1996.122559,317.442261 
	C1995.911743,313.822906 1995.528809,309.943542 2000.114502,308.433563 
	C2003.753906,307.235138 2007.696289,309.338409 2009.450684,313.729462 
	C2010.004150,315.115021 2009.472534,316.934174 2009.023193,319.232574 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1665.733398,334.575562 
	C1665.773560,336.991669 1666.109253,338.843842 1665.460815,340.238708 
	C1663.875000,343.651001 1661.570312,347.027435 1657.152466,345.152466 
	C1653.923218,343.781982 1652.403076,340.527802 1652.803101,336.943542 
	C1653.281982,332.651367 1657.055786,329.758179 1661.174316,330.246582 
	C1663.331421,330.502380 1664.750366,331.826660 1665.733398,334.575562 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2266.936035,204.087997 
	C2267.808350,200.995071 2268.645752,198.461624 2269.989014,196.233261 
	C2273.050049,191.154755 2275.711426,190.898911 2280.084473,195.160309 
	C2281.908691,196.937958 2284.406494,198.657394 2283.361328,201.765518 
	C2282.385742,204.666077 2279.581543,203.848938 2277.430908,204.064804 
	C2274.008789,204.408295 2270.764404,207.556641 2266.936035,204.087997 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1556.197144,321.944641 
	C1553.544434,319.318726 1551.653931,317.010925 1553.255371,313.724731 
	C1554.137451,311.915070 1555.262085,310.233704 1557.540894,310.166351 
	C1560.728638,310.072021 1564.066772,309.229370 1566.309326,312.824249 
	C1568.268433,315.964600 1566.938721,318.485962 1565.342896,320.996307 
	C1563.067871,324.575378 1560.039307,324.226868 1556.197144,321.944641 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1822.831543,367.998810 
	C1822.000000,367.998779 1822.000000,367.000580 1822.000000,366.501526 
	C1821.694580,364.720825 1821.546509,363.374969 1821.054443,362.169525 
	C1819.526855,358.427612 1820.258423,355.644592 1824.293579,354.323395 
	C1828.196655,353.045441 1832.383545,354.718842 1833.577026,357.855499 
	C1835.121460,361.914612 1833.435303,366.408417 1829.578491,367.604156 
	C1827.742310,368.173340 1825.643066,367.893860 1822.831543,367.998810 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1881.967896,277.974182 
	C1881.868042,279.784363 1881.942627,280.837280 1881.626587,281.755890 
	C1880.064453,286.297821 1876.338989,286.586761 1872.644043,285.546570 
	C1869.397705,284.632660 1868.034180,281.573517 1868.478027,278.441071 
	C1868.993774,274.800751 1871.679688,272.683105 1875.302002,272.175415 
	C1879.030273,271.652893 1882.043701,272.422485 1881.967896,277.974182 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1714.096436,435.404541 
	C1716.819702,437.714966 1718.239624,439.668976 1716.586670,442.708527 
	C1715.022217,445.585632 1712.638428,447.255646 1709.571777,447.610809 
	C1706.110840,448.011688 1704.111084,445.576294 1702.721924,442.842499 
	C1701.483154,440.405060 1702.759521,438.409180 1704.473145,436.643555 
	C1707.095825,433.941620 1710.092163,433.371246 1714.096436,435.404541 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1718.000000,219.999390 
	C1719.660767,220.006958 1721.343140,219.845444 1722.978394,220.054031 
	C1728.693115,220.782974 1730.708374,223.343643 1729.893677,228.557251 
	C1729.258667,232.620941 1726.766968,234.269836 1722.866821,233.748840 
	C1718.494995,233.164856 1716.195312,229.431686 1716.917969,224.293488 
	C1717.054077,223.325699 1717.518433,222.404099 1717.915771,220.730286 
	C1718.000000,219.999390 1718.000000,220.000000 1718.000000,219.999390 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1640.258301,295.488617 
	C1640.030640,290.841919 1641.707520,288.416046 1645.740112,288.117981 
	C1649.166016,287.864838 1652.482178,288.143768 1653.603149,292.229919 
	C1654.615967,295.921692 1652.916870,298.702576 1649.952881,300.605713 
	C1646.796509,302.632324 1643.744751,302.632629 1641.615112,298.933075 
	C1641.127075,298.085693 1640.788086,297.152588 1640.258301,295.488617 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1734.495850,275.740509 
	C1727.451294,270.234802 1726.697998,268.012787 1730.488770,265.045959 
	C1733.122192,262.984924 1736.039185,261.575653 1739.495239,263.753998 
	C1741.481689,265.006104 1743.978638,266.100433 1743.239136,268.804321 
	C1742.174438,272.697174 1740.336914,276.289795 1734.495850,275.740509 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1514.759766,243.818756 
	C1511.511719,243.842575 1509.387329,242.957169 1508.511475,240.468613 
	C1507.640625,237.994385 1506.409058,235.391846 1506.503174,232.889511 
	C1506.669556,228.467133 1513.103394,227.473801 1519.651123,231.366272 
	C1522.817383,237.537796 1519.535522,240.728912 1514.759766,243.818756 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1788.579590,378.231384 
	C1786.047241,380.035583 1784.184814,379.238586 1782.514160,378.168091 
	C1779.607910,376.305695 1775.460449,374.936188 1777.319092,370.182129 
	C1778.615112,366.867065 1784.208618,365.041840 1787.575317,366.388824 
	C1791.027466,367.769928 1792.101685,371.400848 1790.415405,376.289703 
	C1790.217773,376.862457 1789.571777,377.280548 1788.579590,378.231384 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1225.914551,280.708740 
	C1230.153320,280.109924 1234.952393,279.279694 1235.811646,285.244049 
	C1236.488770,289.944458 1235.386719,293.746216 1228.780273,293.985565 
	C1221.151733,290.715485 1221.122803,290.637604 1224.180664,284.765564 
	C1224.755493,283.661743 1225.283081,282.533325 1225.914551,280.708740 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2013.463257,352.267700 
	C2015.080078,352.917358 2016.016846,353.325378 2016.755615,353.962799 
	C2019.879395,356.657471 2021.051270,359.937195 2018.750488,363.635345 
	C2017.391846,365.819061 2014.940308,366.329071 2012.549927,365.673370 
	C2008.665527,364.607910 2006.168945,362.074493 2006.195312,357.871307 
	C2006.221313,353.736145 2008.758057,352.046082 2013.463257,352.267700 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1754.015747,282.776245 
	C1754.219849,281.365204 1754.598755,280.848358 1755.568359,280.223480 
	C1759.298706,279.868073 1762.728271,276.832306 1765.821533,280.877075 
	C1768.308716,284.129211 1768.578003,288.266174 1765.954468,290.517670 
	C1763.079468,292.984924 1758.067017,292.328522 1755.710205,289.081940 
	C1754.537231,287.466095 1754.035156,285.565643 1754.015747,282.776245 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1342.230225,303.346802 
	C1341.627441,298.874725 1342.728760,296.107086 1346.596680,294.907623 
	C1349.208862,294.097565 1351.489990,295.251617 1352.722168,297.069489 
	C1354.895020,300.274658 1354.598511,304.076965 1352.859741,307.419830 
	C1351.674561,309.698395 1349.346436,310.358307 1346.884521,309.144562 
	C1344.732788,308.083832 1343.263306,306.329346 1342.230225,303.346802 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1602.100098,370.138245 
	C1608.353027,374.030334 1609.211426,376.872528 1606.064453,380.750397 
	C1603.363525,384.078491 1598.961182,385.043640 1596.692871,382.443268 
	C1594.151001,379.529358 1592.978271,376.195374 1596.279785,372.846039 
	C1597.690918,371.414551 1599.243286,370.273987 1602.100098,370.138245 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1053.766724,330.145050 
	C1059.353027,330.828278 1061.418457,334.440399 1061.092285,338.455872 
	C1060.817505,341.835815 1057.621216,343.861084 1053.896729,343.833466 
	C1050.388794,343.807434 1048.421753,341.869873 1048.125488,338.426025 
	C1047.794678,334.580078 1048.297363,331.103088 1053.766724,330.145050 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1682.436279,358.198364 
	C1681.820190,357.309540 1681.546021,357.036316 1681.514038,356.737213 
	C1680.851807,350.541321 1683.034790,346.428436 1687.025391,346.299347 
	C1690.613525,346.183258 1693.865479,349.341309 1693.943237,353.017242 
	C1694.054932,358.307068 1691.643677,360.051147 1684.623047,359.654297 
	C1684.031494,359.620880 1683.467651,359.097595 1682.436279,358.198364 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1674.435791,243.303284 
	C1671.523926,235.111771 1673.542603,231.167389 1679.292847,232.242233 
	C1682.981812,232.931763 1686.196899,236.845612 1685.610474,239.932709 
	C1684.791016,244.245285 1680.716309,245.743027 1674.435791,243.303284 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1667.843994,444.448578 
	C1671.341797,445.951874 1672.068726,448.357666 1671.951660,451.119019 
	C1671.845459,453.619843 1672.569824,456.681366 1669.132202,457.587616 
	C1666.206177,458.359009 1663.029541,458.401672 1661.228149,455.492065 
	C1659.423218,452.576813 1659.108276,449.255035 1661.781372,446.532257 
	C1663.142456,445.145905 1665.020508,444.371582 1667.843994,444.448578 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2070.974609,312.855042 
	C2078.742432,313.172180 2081.275635,315.841766 2079.738037,320.992462 
	C2078.732422,324.360718 2075.947754,325.533112 2072.949219,325.598419 
	C2069.849854,325.665924 2068.376221,323.366119 2068.118652,320.437103 
	C2067.885254,317.785889 2067.959717,315.155701 2070.974609,312.855042 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2118.561279,152.649796 
	C2112.268799,152.483139 2111.364502,151.402786 2112.082764,146.094833 
	C2112.716309,141.409714 2116.011230,139.014206 2120.518311,140.203720 
	C2125.225342,141.446030 2124.098145,145.125580 2123.433838,148.305832 
	C2122.999268,150.386246 2121.108154,151.436218 2118.561279,152.649796 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1630.529419,386.844116 
	C1634.095581,394.569733 1632.327393,398.314850 1626.182251,397.934784 
	C1622.739136,397.721863 1620.481323,396.184937 1620.196411,392.613068 
	C1619.923706,389.194733 1621.400391,386.765198 1624.970459,386.246124 
	C1626.566772,386.014069 1628.245361,386.348328 1630.529419,386.844116 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M870.792725,451.056091 
	C872.267700,449.036926 873.664673,448.201782 875.425537,448.158051 
	C879.658264,448.052856 882.488037,450.240723 883.498718,454.141327 
	C884.308533,457.266724 882.237854,459.053436 879.281921,459.768494 
	C874.706665,460.875244 871.775391,459.296143 870.217224,454.690033 
	C869.926636,453.830994 870.344971,452.732178 870.792725,451.056091 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1965.846191,326.070618 
	C1965.593506,328.568756 1964.941528,330.215668 1963.353394,330.925537 
	C1959.829956,332.500488 1956.129639,332.951843 1953.325562,329.695435 
	C1951.185547,327.209991 1952.430176,324.735382 1954.480225,322.658386 
	C1957.755493,319.339996 1961.044678,319.235992 1964.859009,322.541992 
	C1965.501709,323.099030 1965.536987,324.356873 1965.846191,326.070618 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1490.225342,388.278625 
	C1487.897217,389.941467 1485.792236,390.447205 1484.073975,389.397949 
	C1480.637939,387.299805 1479.536865,383.866974 1480.424438,380.040558 
	C1480.991333,377.596405 1482.827271,375.934662 1485.477905,376.413940 
	C1489.049561,377.059723 1491.138916,379.504242 1491.794067,383.053192 
	C1492.099121,384.705444 1491.713135,386.304871 1490.225342,388.278625 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1243.731445,256.353943 
	C1247.658447,258.186890 1249.397827,261.070953 1249.209351,264.514618 
	C1249.081055,266.854950 1246.899902,268.495880 1244.678955,269.377502 
	C1242.157715,270.378357 1240.058838,269.369873 1238.768311,267.145142 
	C1237.492432,264.945282 1235.431763,262.700287 1237.416626,259.909454 
	C1238.777588,257.995850 1240.453613,256.387695 1243.731445,256.353943 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1191.984985,395.231018 
	C1191.660767,396.252045 1191.321411,396.515533 1190.478760,397.181610 
	C1186.897339,398.068939 1183.818970,398.167664 1180.060791,397.219177 
	C1175.625488,394.697388 1175.503784,391.979004 1178.241821,388.937103 
	C1180.961670,385.915497 1184.230713,385.067627 1187.804810,387.252197 
	C1190.414917,388.847534 1192.062744,391.212921 1191.984985,395.231018 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1088.000000,359.178314 
	C1087.111084,360.000336 1086.222168,360.000641 1084.666626,360.001709 
	C1082.831421,358.102570 1080.578247,358.183350 1078.916626,357.199188 
	C1076.268188,355.630493 1075.727539,353.132172 1076.364014,350.315704 
	C1076.948730,347.727966 1078.756470,346.456116 1081.297974,346.192200 
	C1084.542847,345.855194 1086.012695,347.971558 1087.145142,350.534027 
	C1088.259766,353.056122 1087.916626,355.727417 1088.000000,359.178314 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2003.841064,386.071838 
	C2003.589966,388.572449 2002.906982,390.151428 2001.363037,390.927185 
	C1998.584961,392.322998 1995.327393,392.991669 1993.158203,390.447357 
	C1991.106323,388.040802 1991.380737,384.658264 1993.467896,382.227905 
	C1996.005249,379.273560 1999.267090,379.288574 2002.183716,381.830383 
	C2003.068848,382.601746 2003.311279,384.110657 2003.841064,386.071838 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1213.229980,310.013184 
	C1216.884277,310.179382 1218.034424,311.862976 1217.990845,315.295929 
	C1217.814941,318.107513 1216.760864,319.519409 1214.850220,320.513885 
	C1211.964111,322.016144 1209.132690,322.545166 1207.140503,319.489258 
	C1205.404419,316.826263 1205.589600,313.919128 1207.971191,311.510712 
	C1209.180298,310.288055 1210.824585,310.106262 1213.229980,310.013184 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M909.465515,469.502594 
	C908.125793,469.525238 907.434509,469.571503 906.311279,469.930115 
	C904.777100,470.984924 903.570740,471.322601 901.674561,470.872711 
	C899.624023,469.725891 898.032898,468.643616 899.077026,466.784393 
	C900.867065,463.597168 903.225464,460.785034 907.156677,460.193054 
	C910.041321,459.758636 912.267700,460.978607 914.065063,464.216492 
	C914.831848,465.780121 914.722534,466.581787 913.477661,467.452301 
	C912.819214,467.570160 912.321594,467.370239 912.133911,467.561707 
	C911.493652,468.507690 910.875427,469.091034 909.465515,469.502594 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M976.249878,409.464966 
	C973.423096,406.922302 973.764832,404.231689 974.566956,401.683411 
	C975.351379,399.191406 977.419434,398.184143 980.015259,398.157654 
	C982.366394,398.133636 983.554932,399.573212 984.602905,401.396271 
	C986.041016,403.897797 985.156616,405.783844 983.302673,407.584412 
	C981.507263,409.328308 979.458679,410.148682 976.249878,409.464966 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2237.033203,222.776520 
	C2242.479004,228.922821 2242.531250,232.471725 2237.793457,233.616531 
	C2234.566162,234.396301 2231.464600,233.646973 2230.555420,230.162994 
	C2229.364014,225.597778 2230.677979,222.208206 2237.033203,222.776520 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1494.404541,258.467773 
	C1498.439453,257.749725 1500.752197,259.402374 1502.569214,261.893616 
	C1504.394043,264.395325 1504.176270,266.898376 1501.674316,268.720398 
	C1499.368164,270.399719 1496.493042,270.668854 1494.629272,268.328735 
	C1492.404419,265.535339 1490.531494,262.244019 1494.404541,258.467773 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1514.478027,244.528671 
	C1516.029297,240.498230 1519.052246,237.544174 1519.929688,232.683807 
	C1523.450439,232.082672 1525.194336,234.239532 1526.529053,237.116348 
	C1528.209839,240.738907 1528.441406,243.586182 1523.407593,244.016754 
	C1520.573486,244.259155 1518.045410,246.977524 1514.478027,244.528671 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1480.526855,286.596558 
	C1483.751099,283.836670 1486.262329,283.302307 1488.311890,286.870148 
	C1489.680176,289.252228 1490.609131,291.711395 1488.406006,294.068756 
	C1486.365723,296.251495 1483.680298,296.531494 1481.215698,295.224121 
	C1477.432983,293.217621 1477.483887,290.270386 1480.526855,286.596558 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2134.392090,185.876984 
	C2136.050537,188.960236 2136.878662,191.690094 2133.906982,193.313644 
	C2131.335693,194.718445 2128.832764,193.592911 2126.770996,191.620056 
	C2124.741699,189.678543 2123.587402,187.444839 2124.418457,184.577133 
	C2124.857666,183.062607 2126.031250,182.528946 2127.439941,182.968170 
	C2129.616211,183.646820 2131.731445,184.521881 2134.392090,185.876984 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1011.686035,342.411285 
	C1015.260010,343.820648 1016.213806,346.145782 1015.764465,349.016846 
	C1015.209839,352.560303 1012.865662,354.146301 1009.426392,353.718689 
	C1005.732361,353.259460 1005.975037,350.271881 1006.130371,347.635284 
	C1006.304504,344.678894 1007.794006,342.703552 1011.686035,342.411285 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1101.181519,327.672882 
	C1097.681396,330.070435 1094.561646,331.454315 1092.493042,327.352173 
	C1091.494873,325.372955 1091.400757,322.558441 1093.525879,321.087219 
	C1096.098389,319.306213 1099.142578,319.488342 1101.727295,321.348846 
	C1104.210693,323.136322 1103.461792,325.212708 1101.181519,327.672882 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M971.823486,363.869873 
	C970.607056,364.573639 970.044373,365.075562 969.445557,365.123383 
	C964.297852,365.534546 962.141296,364.035095 962.192017,360.176941 
	C962.238953,356.608948 964.606628,355.993927 967.476135,356.076050 
	C972.113342,356.208771 973.011658,357.552307 971.823486,363.869873 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1024.089844,386.730530 
	C1027.640625,388.167358 1028.220093,390.580597 1027.712524,393.390533 
	C1027.251221,395.944519 1025.609741,397.395355 1023.063904,397.741425 
	C1021.382507,397.970001 1019.654785,397.774567 1018.762756,396.162292 
	C1017.749878,394.331390 1017.949585,392.313110 1019.013123,390.531799 
	C1020.031433,388.826019 1021.411499,387.419220 1024.089844,386.730530 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2249.050781,175.605988 
	C2247.980225,178.365692 2247.368408,180.606964 2246.189453,182.493637 
	C2245.202637,184.072968 2243.562988,185.937988 2241.428467,184.772522 
	C2239.475098,183.705887 2239.919678,181.325211 2240.139404,179.445496 
	C2240.555908,175.879776 2242.644531,173.465622 2246.063232,172.469666 
	C2247.922852,171.927811 2249.151855,172.868683 2249.050781,175.605988 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M924.264160,446.273254 
	C919.183533,448.825256 916.767700,446.941650 916.237793,442.392090 
	C915.910156,439.579254 917.598633,437.904144 920.404480,438.237732 
	C924.951050,438.778290 926.831116,441.198792 924.264160,446.273254 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1003.579285,432.769379 
	C1007.096985,431.609589 1010.169800,430.811127 1013.802002,429.644257 
	C1016.618835,428.768311 1018.876465,428.260742 1021.691895,427.349365 
	C1023.101929,426.944916 1023.954163,426.944275 1025.396973,427.183960 
	C1018.660034,433.162170 1009.461853,433.357513 1000.210327,435.737610 
	C1000.633545,434.796539 1001.883972,433.963623 1003.579285,432.769379 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1253.533691,391.570038 
	C1264.707886,392.385193 1275.455566,391.552155 1287.106934,391.463440 
	C1290.245239,389.827454 1292.506104,389.833069 1295.370972,391.770752 
	C1293.697266,394.440796 1290.943359,394.011475 1288.330322,393.942383 
	C1276.718140,393.635284 1265.085693,394.655365 1252.854492,392.925476 
	C1252.508423,392.239075 1252.796753,392.040710 1253.533691,391.570038 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1493.911499,215.287262 
	C1490.454956,215.927689 1487.183228,216.322281 1486.086914,221.291397 
	C1482.525513,221.627060 1481.620117,219.415298 1482.323242,216.425201 
	C1483.048462,213.341476 1485.059082,211.090546 1488.175049,210.437195 
	C1491.308228,209.780212 1493.028931,211.701080 1493.911499,215.287262 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1156.767822,399.958435 
	C1155.622559,393.705627 1158.909180,391.627991 1165.223633,391.999817 
	C1167.801514,393.158661 1167.987671,394.996552 1168.088013,397.589508 
	C1168.127441,398.292053 1168.206543,399.004944 1168.189331,399.363159 
	C1166.600464,399.939240 1165.007568,399.969025 1162.869385,400.410522 
	C1160.710938,400.427979 1159.126709,400.289551 1156.767822,399.958435 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1153.592285,282.892090 
	C1154.434692,282.377228 1154.755615,282.257935 1155.082642,282.237793 
	C1157.878418,282.065430 1160.520874,282.279266 1160.968262,285.823639 
	C1161.110962,286.953064 1160.103638,287.582458 1159.058594,287.667114 
	C1155.867554,287.925598 1152.941406,287.710205 1153.592285,282.892090 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1381.717041,271.693817 
	C1384.913330,269.861176 1386.755371,270.979156 1387.197998,273.657257 
	C1387.567139,275.891022 1385.942261,277.537476 1383.694458,277.177338 
	C1380.989380,276.743988 1379.925171,274.883484 1381.717041,271.693817 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1179.070923,397.264648 
	C1182.435425,396.882782 1185.489380,396.917908 1189.259521,397.268616 
	C1187.071777,401.700775 1183.066406,399.652527 1178.882812,399.060242 
	C1178.500610,398.324127 1178.630615,398.002869 1179.070923,397.264648 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1490.243652,419.738495 
	C1493.038086,418.201050 1495.660767,420.108704 1499.251953,420.334534 
	C1500.399048,420.761597 1500.862549,421.163544 1501.590332,421.911743 
	C1497.545898,424.358063 1494.048828,422.123962 1490.243652,419.738495 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1792.450684,140.407593 
	C1795.023682,140.206482 1797.376343,140.061951 1796.987427,142.817429 
	C1796.700317,144.851440 1794.720703,146.091278 1792.686401,145.508179 
	C1789.617065,144.628510 1789.750610,142.683380 1792.450684,140.407593 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1029.588623,426.768494 
	C1031.072754,423.935516 1034.465942,424.736389 1037.479248,422.937866 
	C1038.365601,422.744873 1038.707886,422.913086 1039.507324,423.425293 
	C1037.248169,426.602386 1033.977539,427.740143 1029.588623,426.768494 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M947.295654,452.932037 
	C946.198364,457.324738 941.866760,456.472321 937.830200,457.627716 
	C939.469055,454.361237 943.304626,454.114624 947.295654,452.932037 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1435.325195,406.497803 
	C1436.521606,406.755188 1437.116211,406.966003 1438.240112,406.896973 
	C1438.893677,407.100067 1439.085571,407.391937 1439.465942,408.172180 
	C1437.161987,410.497101 1434.747681,410.611206 1432.237305,407.810242 
	C1432.907227,407.071777 1433.781494,406.857025 1435.325195,406.497803 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M913.533569,467.532867 
	C913.185120,466.992188 913.550964,466.414185 914.150391,465.378723 
	C916.498596,464.283051 918.613281,463.644897 921.367554,463.139587 
	C920.647461,466.934082 916.811096,466.045258 913.533569,467.532867 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1128.610840,272.972748 
	C1127.102905,271.787964 1126.135254,270.625824 1127.168457,269.403198 
	C1128.270386,268.099213 1129.641113,268.826538 1130.440674,269.970520 
	C1131.545532,271.551422 1131.717651,273.016113 1128.610840,272.972748 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1459.304688,412.054932 
	C1457.941650,414.339722 1456.169434,414.403992 1454.237061,411.964783 
	C1455.679077,410.581085 1457.278564,410.965759 1459.304688,412.054932 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M900.759644,471.060303 
	C902.299377,470.410400 903.490051,470.254639 905.280029,470.170654 
	C904.753601,472.532227 902.999329,473.820221 899.656494,473.580872 
	C899.436401,472.823547 899.923523,472.189026 900.759644,471.060303 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1485.035156,416.825989 
	C1485.658447,416.770416 1485.739746,417.551453 1485.772461,417.942566 
	C1484.603271,419.996735 1483.430542,419.972931 1482.151611,417.846893 
	C1482.814941,417.241241 1483.613281,417.061371 1485.035156,416.825989 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1215.103027,246.749893 
	C1214.661865,245.187988 1215.210083,244.624756 1216.420898,244.863846 
	C1216.672729,244.913544 1217.011963,245.270020 1217.050293,245.524338 
	C1217.234497,246.748367 1216.639282,247.261536 1215.103027,246.749893 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1044.433838,421.447571 
	C1045.312622,421.104980 1046.116821,421.159271 1047.454346,421.495483 
	C1047.401611,423.229095 1046.556885,424.143494 1044.589966,422.967285 
	C1044.321655,422.651306 1044.359253,421.844513 1044.433838,421.447571 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M957.411377,449.198547 
	C957.332397,451.154266 956.008240,451.846375 953.536865,451.559967 
	C953.824036,449.978943 955.243774,449.361176 957.411377,449.198547 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1467.455811,413.838501 
	C1466.737427,415.899811 1465.572998,416.016937 1464.172241,413.971771 
	C1465.011108,412.861633 1466.039185,412.994720 1467.455811,413.838501 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1449.405518,410.107880 
	C1448.636841,412.028290 1447.512207,411.984192 1446.198608,410.216919 
	C1447.006714,409.097015 1448.027710,409.164856 1449.405518,410.107880 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1477.410889,416.001221 
	C1476.681396,417.962463 1475.533325,418.002869 1474.177246,416.088013 
	C1475.004150,415.005402 1476.016357,415.166748 1477.410889,416.001221 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1634.084473,4.615191 
	C1634.889526,4.025394 1635.778809,4.019376 1637.334961,4.023870 
	C1637.811279,5.327392 1637.718140,6.802978 1636.084229,7.024312 
	C1634.948608,7.178134 1634.440918,6.200937 1634.084473,4.615191 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M935.288147,457.901764 
	C935.294556,458.412872 934.668762,458.943359 933.400208,459.485535 
	C933.390259,458.971863 934.023132,458.446533 935.288147,457.901764 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M982.625122,440.607788 
	C983.220032,441.497650 982.634155,441.760132 981.428345,441.613342 
	C981.372314,441.236450 981.684570,440.954163 982.625122,440.607788 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M700.462280,1179.562256 
	C691.595276,1180.067749 683.462585,1178.094604 675.367126,1177.325928 
	C658.080811,1175.684204 641.993530,1168.999634 624.676025,1167.610229 
	C613.249451,1166.693481 602.110229,1162.411987 590.794495,1159.848511 
	C570.533020,1155.258545 550.409485,1149.563110 529.896545,1146.739136 
	C514.002136,1144.550903 498.944977,1139.133301 483.258789,1137.066040 
	C469.978668,1135.316040 457.491913,1130.166748 444.558075,1128.644165 
	C429.369202,1126.855957 415.236969,1120.738037 399.980682,1119.925293 
	C394.366150,1119.625977 389.461212,1115.694336 382.785400,1116.000488 
	C380.500305,1114.829224 379.970734,1113.297729 380.331177,1110.835449 
	C380.464111,1109.238770 380.487183,1108.271973 380.867554,1106.664795 
	C382.097778,1103.984131 381.875763,1101.746460 382.590576,1099.031372 
	C383.198761,1096.369629 384.282043,1094.364380 383.023102,1091.601440 
	C382.639282,1090.131348 382.642914,1089.268799 383.029297,1087.789551 
	C385.302979,1084.803955 385.163116,1081.416016 387.509827,1078.500000 
	C387.466858,1073.654663 389.794586,1069.799438 390.144379,1064.807739 
	C389.614471,1061.986694 389.843719,1060.017212 390.943176,1057.411133 
	C395.864960,1046.802490 398.341980,1036.178833 401.754181,1025.863892 
	C407.462799,1008.606812 414.168915,991.655151 420.779816,974.701416 
	C426.188324,960.831299 432.098969,947.158142 437.841980,932.654541 
	C437.604584,930.371155 437.727173,928.880005 438.624756,926.776367 
	C447.500641,918.198120 449.586700,906.623840 455.366852,897.117493 
	C461.340302,887.293152 464.975677,876.207825 470.919617,865.521118 
	C473.027557,862.309631 475.814453,860.303284 475.949280,856.046143 
	C476.053864,851.981628 477.664429,849.233948 480.031677,846.116028 
	C482.004150,844.148254 484.320892,843.552063 485.650208,840.912720 
	C486.356873,839.800842 486.605743,839.131287 487.307098,838.155884 
	C489.606812,836.522583 489.793671,834.145020 491.385010,831.908691 
	C491.628143,831.315430 491.789490,830.500427 492.098328,830.222534 
	C494.348999,826.475830 496.048157,822.836121 499.358826,819.591797 
	C500.947601,813.475952 504.851868,809.470337 508.379089,804.459595 
	C509.827362,802.618042 511.099518,801.672241 513.331726,800.671997 
	C521.490234,799.948120 528.628235,802.146179 535.584534,803.884338 
	C572.635681,813.141968 610.435120,818.951477 647.472656,828.009277 
	C681.347717,836.293640 715.812439,841.547791 749.651428,849.881714 
	C758.947815,852.171326 768.698792,852.574707 777.761414,856.194214 
	C780.179138,857.159851 783.310669,858.090027 785.420837,856.241577 
	C788.307800,853.712830 785.002319,851.535339 783.975098,849.375977 
	C781.918091,845.052063 781.900696,841.653564 788.130432,840.103088 
	C791.108337,840.291382 792.865417,841.313110 794.732788,843.516541 
	C797.604858,850.155579 799.588501,856.595398 807.809448,858.259766 
	C809.377686,858.092834 810.281799,858.086426 811.867126,858.251648 
	C815.808533,859.433411 818.055298,861.522156 819.079163,865.517822 
	C818.945068,866.868774 818.578796,867.364075 818.002625,867.660828 
	C817.421509,867.960022 817.620239,867.878296 819.208862,867.163940 
	C825.240173,867.327881 826.959900,872.276062 830.081970,875.437256 
	C835.860291,881.288147 841.659058,887.100830 848.495605,892.849976 
	C849.399902,894.263184 849.748352,895.158997 850.131958,896.813110 
	C850.341736,898.509705 850.338379,899.486023 850.161621,901.184814 
	C849.930298,902.372437 849.800903,902.837708 849.379639,903.961182 
	C845.784607,909.127258 841.968201,913.197388 837.756653,917.808228 
	C836.932190,918.545044 836.585510,918.811462 835.687073,919.406799 
	C833.375671,920.666687 831.302490,921.216492 830.391418,924.028076 
	C830.002380,924.989563 829.839661,925.376404 829.397827,926.338013 
	C828.260437,928.451538 827.188599,929.815552 825.281616,931.324829 
	C822.405701,932.916687 820.053040,934.101562 818.673828,937.307007 
	C818.261108,938.311096 818.081421,938.705505 817.586853,939.666504 
	C816.790283,940.933960 816.263184,941.598572 815.252258,942.661987 
	C813.995056,943.965027 813.054626,944.729858 812.241760,946.360352 
	C811.287781,948.327271 810.575195,949.750244 809.406311,951.600220 
	C808.777710,952.359741 808.495728,952.634399 807.736267,953.245056 
	C806.299377,954.184082 805.273560,954.688843 804.061646,955.894043 
	C803.445496,956.600952 803.209290,956.894897 802.644043,957.652710 
	C801.392700,959.382935 800.729797,960.765381 800.295959,962.917908 
	C799.609863,965.621765 798.809753,967.613342 797.240601,969.984497 
	C795.874207,971.473083 794.750854,972.210876 793.053955,973.297058 
	C789.453491,975.002930 787.905273,977.581055 786.584106,981.136597 
	C786.196533,982.137756 786.023315,982.527771 785.534058,983.466309 
	C784.290039,985.359497 783.045227,986.470886 782.034180,988.505005 
	C781.552063,989.408508 781.349426,989.767029 780.807251,990.644409 
	C779.404480,992.465027 778.618408,993.908020 778.051392,996.178589 
	C776.843384,999.746033 775.531616,1002.553589 773.460205,1005.721680 
	C772.736023,1006.553894 772.416077,1006.855774 771.572144,1007.544678 
	C768.678101,1009.161743 767.191650,1011.062439 766.534119,1014.333984 
	C765.501526,1018.456726 763.949036,1021.669434 761.965454,1025.422241 
	C761.127075,1026.724854 760.577637,1027.410034 759.518677,1028.502319 
	C756.737244,1030.776978 754.956726,1032.951660 754.387817,1036.624268 
	C754.010681,1038.093506 753.708923,1038.912354 753.016602,1040.294312 
	C747.283447,1047.634521 743.696045,1055.338867 740.806030,1064.134399 
	C740.562805,1066.214111 740.198914,1067.558472 739.422729,1069.511108 
	C734.801331,1075.111572 732.244812,1080.923462 730.829468,1088.012207 
	C730.606567,1090.119507 730.246643,1091.481201 729.499146,1093.466797 
	C726.104858,1098.749146 723.382141,1103.548828 722.729004,1109.961548 
	C722.560791,1112.126099 722.230774,1113.533813 721.499329,1115.593262 
	C716.078918,1123.596924 715.410583,1132.498291 712.484741,1141.363037 
	C709.732239,1148.678101 707.341797,1155.336670 707.626343,1163.314941 
	C707.727966,1164.989990 707.641052,1165.941040 707.214111,1167.555664 
	C704.167053,1171.414673 702.992004,1175.495483 700.462280,1179.562256 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M790.364014,841.350586 
	C782.939148,843.824646 782.945984,843.819336 787.018921,848.565430 
	C788.088440,849.811829 789.262512,851.011292 790.097534,852.406494 
	C791.482971,854.721375 792.692444,857.216675 790.684265,859.804016 
	C788.835815,862.185608 786.608276,860.834229 784.325195,860.497253 
	C779.434570,859.775452 774.497253,859.839294 770.187744,856.565552 
	C768.497131,855.281189 765.773682,854.950195 763.504333,854.898254 
	C745.826233,854.493347 729.721497,845.654236 711.854370,845.644348 
	C705.100708,845.640625 698.385986,842.369019 691.586914,840.893738 
	C682.551331,838.933105 673.825745,835.215149 664.293030,835.911743 
	C663.329407,835.982178 662.232544,835.831177 661.368469,835.421997 
	C648.291199,829.230530 633.826721,828.506897 620.034058,825.287598 
	C600.402222,820.705505 580.540283,817.103333 560.867676,812.564392 
	C552.876770,810.720703 544.858521,809.204285 536.867249,807.063354 
	C529.325073,805.042847 521.341187,804.116028 512.898315,801.996948 
	C511.809753,801.647644 511.511292,801.324646 511.531860,800.424133 
	C511.956451,799.500244 512.062012,799.153809 512.546448,798.418213 
	C513.989502,796.063171 515.569763,794.490845 517.247559,792.171143 
	C517.552673,791.582153 517.926758,791.759094 517.724731,791.714294 
	C519.737122,790.724976 519.690918,788.180115 521.369629,786.087524 
	C521.662415,785.525940 521.901855,784.627991 522.233398,784.302368 
	C523.312073,782.918945 523.841125,781.769043 524.170776,779.854736 
	C524.470764,778.840820 524.641296,778.452393 525.155029,777.532776 
	C526.228149,775.993469 527.120056,775.101074 527.966553,773.411438 
	C528.890137,771.752502 529.640076,770.734497 530.930176,769.328247 
	C532.771790,767.925903 534.380676,767.236694 535.739502,765.267456 
	C536.635193,764.169067 537.015686,763.443909 537.925659,762.388794 
	C539.285950,760.981567 540.113037,759.901428 541.370728,758.296570 
	C542.324463,756.713989 542.892395,755.691528 543.973328,754.362793 
	C545.303345,752.978271 546.120117,751.899719 547.383423,750.312866 
	C548.349182,748.736023 548.924316,747.711548 550.021118,746.392334 
	C551.309692,745.010803 552.108826,743.949219 553.439453,742.460876 
	C555.087402,740.230774 556.297729,738.500854 558.009155,736.370361 
	C559.903015,734.167053 561.495422,732.538208 563.361023,730.251221 
	C563.773193,729.026978 564.041565,728.488159 564.952820,727.859741 
	C567.610840,726.875366 567.604004,724.331726 569.485962,722.484741 
	C571.008972,720.373596 572.109497,718.714355 573.351318,716.474121 
	C573.540710,713.331177 575.071411,711.828186 577.775024,710.438660 
	C578.373596,710.142029 579.355286,710.131653 579.841553,710.064575 
	C581.204712,708.979858 582.072693,707.954529 583.416138,706.452637 
	C584.614075,704.620789 585.373962,703.298157 586.264648,701.415283 
	C586.421082,698.328430 587.930725,696.764282 590.421814,695.125610 
	C594.019592,693.291748 596.475159,690.996582 599.454895,688.388428 
	C600.621277,686.686279 601.380737,685.457642 602.246216,683.692505 
	C604.510498,675.948486 610.809082,672.729614 616.971680,668.465576 
	C623.241333,667.072937 626.805786,670.414429 630.406189,673.812988 
	C633.217651,676.466736 635.580322,679.678040 639.963989,681.533081 
	C649.980713,686.910278 655.136536,696.174927 662.173218,703.566711 
	C672.442139,714.353821 683.946716,723.949585 693.533936,736.342041 
	C702.949402,750.440979 715.086609,760.940063 727.966064,771.610352 
	C732.873108,773.978455 735.909973,777.558838 739.781250,781.213806 
	C740.587646,782.032837 740.896240,782.371460 741.625122,783.249146 
	C744.954285,791.015137 750.579285,796.016846 756.652466,801.497803 
	C758.090027,802.862732 759.129517,803.675232 760.763916,804.823608 
	C768.290039,811.806030 775.583740,818.092346 781.600525,826.529785 
	C783.322327,832.607300 789.515747,835.022827 790.364014,841.350586 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M692.604004,738.455261 
	C687.088318,730.994141 680.586121,725.382751 674.663330,719.240295 
	C663.468628,707.630188 652.123047,696.165527 640.234131,684.332214 
	C634.578796,677.262024 626.842712,672.872375 622.907349,664.399658 
	C630.383728,654.110168 637.238953,644.067261 648.396729,637.902161 
	C655.661987,633.887756 654.788696,627.651123 646.418640,623.809692 
	C643.913879,624.199463 642.088013,624.243469 639.609497,623.722961 
	C637.241455,622.867004 636.021729,621.529846 634.191895,619.912720 
	C633.104553,618.814514 632.614563,618.087952 632.110046,616.646057 
	C631.688599,614.710876 631.373169,613.425537 631.071777,612.136902 
	C629.373413,604.876587 630.275574,602.249146 637.357544,600.084717 
	C643.657288,598.159363 647.404297,595.468933 646.076416,588.281494 
	C645.790344,586.733093 645.877380,584.653381 646.706421,583.445984 
	C649.451782,579.448242 650.674866,573.244995 656.168579,572.617859 
	C661.860535,571.968201 664.312317,577.275085 666.807983,581.611267 
	C671.401306,589.592102 671.428955,589.576172 680.629761,588.223145 
	C688.493408,587.066711 690.730042,588.415039 693.949097,597.007935 
	C692.834167,599.177917 691.722168,600.594055 690.304810,602.461121 
	C687.891052,604.707458 689.886047,606.953003 689.145630,609.556519 
	C686.760376,614.840637 679.040833,619.205933 684.900635,624.500977 
	C690.766907,629.801880 695.146301,622.853455 699.439270,619.270142 
	C699.636047,619.105896 700.080017,619.237854 700.894653,619.708191 
	C705.552917,622.968018 708.370422,627.092590 711.991150,631.292847 
	C711.640869,633.120361 712.067749,631.584595 711.884155,632.845703 
	C710.117371,644.986572 707.631714,656.603271 693.907715,661.157043 
	C693.348877,661.342468 692.782410,662.239380 692.899597,662.795654 
	C694.969055,672.614319 691.089478,681.675232 687.485291,691.502563 
	C693.388428,690.253601 692.906921,686.760803 693.498108,684.047913 
	C694.216614,680.750916 694.851440,677.180542 697.445618,675.072510 
	C704.008301,669.739563 707.120605,663.162354 708.401367,654.750977 
	C709.365479,648.418945 716.417603,646.452148 721.946594,642.980286 
	C736.608032,654.953979 748.193604,669.345886 761.075317,683.375122 
	C759.581421,684.262329 758.676514,685.554749 756.940674,686.942993 
	C743.744080,688.045471 740.644897,686.087341 737.367920,675.210693 
	C736.523621,672.408325 736.446472,668.947998 732.526733,668.669434 
	C728.992737,668.418213 725.935669,669.900696 724.234131,673.055908 
	C722.333801,676.579895 722.903809,680.122375 725.470154,683.203918 
	C727.722839,685.908936 730.997314,686.665649 734.220886,687.445007 
	C740.682617,689.007324 745.770874,692.238037 748.267456,699.557617 
	C749.096069,707.029907 745.862427,711.660217 740.481018,715.213501 
	C737.543640,717.153198 733.310547,718.396301 734.161987,723.101196 
	C735.075439,728.148560 739.264465,730.054871 743.660645,730.548584 
	C752.934387,731.589966 756.666870,737.473938 758.070129,745.732117 
	C758.906677,750.654785 758.056152,755.496216 753.770691,758.190552 
	C747.164185,762.344360 744.398743,767.992004 744.214294,775.527954 
	C744.141846,778.490112 742.963440,781.359619 740.187500,784.041077 
	C735.118286,782.030945 732.717041,777.481750 728.181763,774.328247 
	C716.577026,761.859192 704.429932,750.794434 692.604004,738.455261 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M599.389221,537.552856 
	C606.777222,541.082642 612.248108,545.090698 614.832581,552.792603 
	C616.512695,557.799561 620.518799,558.760925 625.494263,557.163208 
	C634.885498,554.147522 635.826538,552.264954 633.043030,542.062744 
	C630.965759,534.448914 631.737549,532.772522 638.750427,529.665649 
	C645.373901,526.731262 649.139587,528.179382 652.398315,534.914001 
	C655.579041,541.487488 654.716736,546.200684 648.087463,548.705139 
	C639.207642,552.059631 636.705505,557.946106 637.990051,566.542358 
	C638.892822,572.583069 635.951111,576.669556 630.317688,577.416138 
	C623.401917,578.332642 623.663025,582.721863 624.119141,587.467896 
	C624.402344,590.415039 625.596008,593.278259 625.844971,596.224426 
	C626.291565,601.509521 624.529846,603.461731 619.120850,603.933533 
	C610.605530,604.676208 603.155762,603.132507 599.121582,594.321533 
	C597.768066,591.365356 596.502014,587.620911 592.178955,588.441711 
	C588.165039,589.203735 584.493652,591.231628 582.759338,595.145630 
	C581.432678,598.139465 580.581055,601.440674 580.118591,604.690674 
	C579.727600,607.438049 579.080933,609.782166 577.143311,611.863037 
	C573.110107,616.194214 565.310181,617.539429 561.897461,614.319092 
	C558.787354,611.384277 559.414978,604.125488 563.245178,599.820312 
	C564.569153,598.332153 565.913940,596.177856 567.584290,595.796875 
	C576.481262,593.767395 576.679871,587.197388 575.935547,580.321045 
	C575.288208,574.340820 579.638123,572.376526 583.383911,569.679504 
	C585.849854,567.903931 587.672302,568.761780 589.503601,570.594238 
	C591.927002,573.018982 593.120911,576.172607 594.534302,579.166016 
	C596.611694,583.565796 599.785767,585.641541 603.985107,582.552856 
	C607.589783,579.901489 611.518433,580.458618 615.365479,579.718994 
	C621.706909,578.499817 622.662476,575.906006 619.303406,570.114441 
	C613.461853,560.042786 611.752197,559.145081 601.147095,560.581848 
	C594.595581,561.469482 591.025635,559.395081 588.849487,553.536011 
	C586.900757,548.289368 587.980042,544.575378 593.714355,542.668518 
	C594.662720,542.353149 595.122559,540.568787 595.904053,538.731689 
	C596.796021,537.297546 597.722168,536.999573 599.389221,537.552856 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M191.185516,1244.000000 
	C193.167740,1244.980713 194.337906,1245.961426 195.754333,1247.471069 
	C195.839020,1251.145142 199.689774,1254.648193 194.582336,1257.701904 
	C187.167419,1260.830811 180.843460,1264.320679 176.546570,1271.563843 
	C172.893890,1274.851685 174.192368,1279.302246 172.084045,1283.273071 
	C167.771759,1287.125977 162.600159,1289.301880 160.462433,1295.501343 
	C158.552200,1300.600220 152.796875,1302.282837 152.422897,1307.953979 
	C152.278519,1310.143433 149.207672,1312.196289 146.077286,1311.533325 
	C143.412170,1310.968506 142.108963,1308.928711 142.143784,1306.437988 
	C142.208176,1301.833374 140.362198,1299.537231 134.805054,1300.004272 
	C132.579102,1300.924561 131.522995,1300.199463 130.260986,1298.610840 
	C129.065781,1293.506470 126.041794,1291.601440 122.097694,1293.436646 
	C118.671379,1295.030884 114.631027,1297.355835 116.500809,1302.540771 
	C117.557411,1305.470825 118.541290,1308.208862 116.007057,1310.865479 
	C112.920013,1314.101440 108.928665,1315.786621 104.828835,1317.138062 
	C103.502762,1317.575073 102.689293,1316.303101 102.136070,1314.901001 
	C99.681740,1308.680908 99.721016,1305.405884 105.367012,1302.070679 
	C112.714943,1297.729858 112.688019,1291.916748 111.392174,1285.018677 
	C110.164772,1278.485107 110.422653,1278.890869 116.764931,1277.882080 
	C125.195381,1276.541382 131.183762,1280.120850 137.272827,1285.908203 
	C139.638702,1285.870239 141.271927,1286.303833 142.892441,1286.215698 
	C152.316788,1285.703857 154.597855,1282.028931 150.760406,1273.608154 
	C150.082825,1272.121338 149.064362,1270.807983 148.176056,1268.662598 
	C148.234772,1264.996826 147.372070,1261.887207 149.453522,1258.510498 
	C156.050919,1254.792358 163.713120,1253.565796 165.826385,1244.642822 
	C170.499390,1237.433594 171.716217,1236.838867 177.331879,1240.384399 
	C181.425095,1242.968628 185.575562,1244.411133 191.185516,1244.000000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M351.629211,975.232788 
	C352.380249,971.355042 350.987671,968.604858 350.334991,965.706238 
	C349.380249,961.465820 350.179993,957.495605 354.232056,955.316101 
	C358.227295,953.167053 362.764008,952.872009 366.462891,955.814941 
	C369.813446,958.480652 372.833405,961.702454 375.474274,965.088379 
	C380.048004,970.952698 384.566406,966.136658 388.978516,965.272339 
	C393.100861,964.464722 392.980103,961.689819 392.490784,957.727722 
	C391.342865,948.432983 400.834442,941.381470 409.689392,944.341309 
	C414.130280,945.825745 415.237671,949.788879 415.859680,953.785217 
	C416.412231,957.335693 415.452728,960.419861 411.804688,962.025269 
	C410.287750,962.692871 408.751862,963.318237 407.216370,963.942505 
	C399.873260,966.927856 399.872192,966.925293 401.269287,974.695679 
	C402.350006,980.706421 397.437317,988.201843 391.389191,989.770020 
	C384.678833,991.510010 380.557129,988.877686 377.577576,981.877319 
	C376.321930,978.927063 377.480194,974.371582 374.028931,973.170105 
	C370.744202,972.026733 368.144501,975.478760 365.298004,977.062256 
	C364.190735,977.678162 362.752319,977.961731 361.468689,977.950378 
	C356.951141,977.910400 355.885773,980.517273 355.985901,984.406372 
	C356.096527,988.703186 356.446075,993.014526 352.658936,996.405518 
	C350.034058,998.755798 347.492859,1000.669128 343.804840,999.584290 
	C340.388489,998.579224 336.225616,992.774170 336.172394,988.625366 
	C336.122864,984.761963 337.400879,981.631958 341.386719,979.863342 
	C344.677277,978.403259 348.677673,978.834229 351.629211,975.232788 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M242.432968,982.179077 
	C239.749832,980.114258 237.172195,978.725098 235.876831,976.566406 
	C232.023270,970.144592 227.140839,966.251892 219.246628,965.677856 
	C214.326935,965.320190 211.057327,961.428528 210.142395,956.414795 
	C209.240326,951.471680 211.726425,947.920532 216.102173,946.068054 
	C221.577286,943.750183 224.770752,940.440125 224.151901,934.018921 
	C223.823074,930.607117 226.222092,927.800598 227.633759,924.814209 
	C229.009048,921.904846 230.896545,919.426025 234.484146,920.549377 
	C237.593338,921.522888 241.014923,922.679626 241.717041,926.599609 
	C242.322174,929.977966 242.331863,933.393860 238.865555,935.428040 
	C236.003693,937.107300 232.881027,938.347046 230.044830,940.063965 
	C225.973328,942.528687 225.398224,945.821777 228.922791,948.804932 
	C234.704895,953.698853 241.943359,955.050476 249.249481,955.650574 
	C251.374161,955.825012 252.896240,954.090576 253.534821,952.065430 
	C253.925110,950.827820 254.014511,949.437134 253.958969,948.127136 
	C253.732864,942.795898 254.481064,937.964111 260.559814,936.293152 
	C266.920929,934.544617 270.301605,939.143799 273.904510,943.029968 
	C276.314514,945.629578 275.728424,948.669922 272.710449,949.382751 
	C261.889801,951.938782 260.115295,957.739868 261.345032,968.581543 
	C262.586700,979.528076 253.483521,985.061096 242.432968,982.179077 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M618.201233,669.368225 
	C612.838135,673.896484 608.224915,678.210083 602.982056,682.839844 
	C602.134888,675.449280 597.591003,669.437439 594.284729,662.981934 
	C591.905823,658.337219 587.275513,660.095215 583.511963,660.197693 
	C580.326355,660.284485 577.059204,662.597351 574.067322,659.810486 
	C570.623596,656.602661 567.892212,652.807434 566.458008,648.308167 
	C565.589355,645.583313 565.977112,643.059692 569.333008,641.905823 
	C570.872131,641.376526 572.203247,640.272095 573.688965,639.553040 
	C581.841125,635.607849 588.723572,638.357178 591.947754,646.825623 
	C592.997742,649.583618 594.001831,652.359070 594.958313,654.941345 
	C598.203979,655.480652 600.616455,654.109192 603.083008,653.323669 
	C611.607483,650.609192 612.074646,650.515015 611.852478,641.600586 
	C611.654297,633.644592 615.905579,630.192810 623.269348,628.078613 
	C627.894287,625.071533 631.171875,626.646973 634.754761,630.043396 
	C638.194641,638.931824 635.405457,645.411133 628.845154,650.518860 
	C624.847290,653.631592 621.158997,656.741577 621.836914,663.268921 
	C621.788574,666.254883 620.970825,668.042725 618.201233,669.368225 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M756.513916,496.196411 
	C757.986633,489.115936 755.481323,483.275818 753.363708,477.485687 
	C751.863586,473.383850 748.466675,474.463104 744.953247,475.248413 
	C737.529602,476.907776 734.732666,474.841583 734.109009,467.928955 
	C733.811340,464.630157 733.606201,461.323425 737.419495,459.352661 
	C742.114807,456.926025 745.718018,459.560547 749.396667,461.610229 
	C750.402283,462.170563 750.960571,463.736938 751.469177,464.948608 
	C753.124878,468.892517 756.147766,470.279480 760.225037,470.011169 
	C761.878235,469.902405 763.547119,469.948059 765.205322,470.013580 
	C772.697815,470.309509 776.014282,472.394714 777.575439,477.737457 
	C779.638733,484.798889 777.714722,489.773865 771.433899,493.660370 
	C770.870850,494.008820 770.383850,494.735779 769.817627,494.785339 
	C761.508789,495.512451 760.065002,499.771637 761.735718,507.498413 
	C763.062805,513.636047 759.499695,517.196167 753.897095,517.930847 
	C747.840271,518.725037 744.171997,516.453979 742.590881,510.814362 
	C741.466553,506.804016 742.134827,503.520599 746.651123,502.133972 
	C750.185120,501.048950 753.515747,499.640778 756.513916,496.196411 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M437.566833,760.929138 
	C434.784241,759.493958 432.654510,758.267639 431.527618,756.216919 
	C429.264526,752.098694 426.291748,750.136841 421.336761,749.692505 
	C415.388062,749.159119 410.999573,741.486755 412.136047,735.598206 
	C412.710083,732.623779 414.716858,732.078247 417.237335,732.062988 
	C422.963318,732.028320 425.141541,736.160706 427.160645,740.479553 
	C431.076202,748.854980 431.407806,749.012207 440.663147,746.752625 
	C441.628601,746.516907 442.595917,746.288940 443.561401,746.053467 
	C453.846466,743.544983 454.200287,743.533875 453.876038,733.028748 
	C453.658722,725.987000 455.635529,720.712158 461.954376,717.303772 
	C464.157104,716.115723 465.785095,716.813904 467.068207,718.651794 
	C471.847748,725.497742 470.828552,735.034668 464.253906,740.927002 
	C460.929718,743.906250 459.633942,747.092896 460.167908,751.451050 
	C461.060059,758.732544 459.120819,761.955444 452.406647,763.427979 
	C447.582489,764.486023 442.481903,765.153198 437.566833,760.929138 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M730.516113,436.444580 
	C725.282837,436.541046 721.003479,435.617950 716.725220,432.134033 
	C712.808228,428.811615 713.044983,425.247345 715.428345,420.753540 
	C715.762146,416.913849 719.164368,415.899780 719.899048,412.658691 
	C721.334106,410.672577 722.912781,410.489777 725.321289,411.510498 
	C731.902405,414.104034 737.020203,416.916473 740.202576,422.901245 
	C742.318359,426.880310 746.440796,428.151093 751.192017,428.109955 
	C758.252075,428.048767 766.362671,435.255798 767.668457,442.031158 
	C767.984131,443.669128 768.354309,445.811920 766.950500,446.672638 
	C761.563599,449.975525 756.763550,455.376465 748.655396,452.286682 
	C744.423584,449.152466 743.188843,445.029022 741.747070,440.234497 
	C740.739990,435.583649 738.738953,434.198975 734.371765,436.796722 
	C732.821472,437.217468 731.920532,437.172607 730.516113,436.444580 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M261.492798,1092.871826 
	C259.526337,1095.230713 258.114807,1097.136963 256.335083,1098.593384 
	C251.634506,1102.440063 249.672546,1107.035645 249.848160,1113.307129 
	C250.145065,1123.911255 249.482269,1124.119141 238.338531,1122.086304 
	C229.037598,1120.389648 225.431931,1116.322388 225.980988,1108.577026 
	C226.185684,1105.689575 227.447739,1103.597412 229.362869,1101.638428 
	C235.375671,1095.488159 241.896515,1089.811890 246.651962,1082.494263 
	C247.887970,1080.592285 249.728256,1078.745483 252.112091,1078.393433 
	C255.664062,1077.868652 259.746094,1076.815918 262.385864,1080.092163 
	C265.533417,1083.998657 263.892395,1088.238281 261.492798,1092.871826 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M335.835266,1092.882568 
	C334.365112,1097.491089 331.403564,1099.068115 327.768677,1100.461914 
	C323.098785,1102.252441 319.315125,1101.918823 316.247162,1097.973755 
	C313.225159,1094.087769 313.682770,1090.007324 316.062592,1085.888916 
	C317.297363,1083.752197 318.987671,1082.186890 321.230194,1081.461182 
	C328.300079,1079.173340 330.619171,1074.501831 330.206818,1067.147339 
	C329.856873,1060.906006 334.435272,1056.020264 338.189514,1051.668579 
	C341.973877,1047.281860 349.961578,1050.185059 351.585571,1055.814209 
	C354.786072,1066.908203 351.534088,1073.680420 340.496918,1078.218994 
	C337.641357,1079.393311 336.202728,1081.158203 336.083771,1084.098877 
	C335.976471,1086.750977 335.985138,1089.407959 335.835266,1092.882568 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M367.066284,923.554077 
	C370.689789,926.932495 374.517609,925.801941 378.086365,925.973938 
	C380.813293,926.105347 383.740356,926.078003 385.108276,928.784302 
	C386.757477,932.046997 391.355774,934.492004 388.328430,939.295898 
	C385.818878,943.278259 383.414154,947.614990 378.105164,947.782837 
	C372.751434,947.952087 369.957642,944.495483 368.092194,939.653442 
	C364.063324,929.195740 363.053009,928.815247 351.786255,931.085571 
	C344.690552,932.515442 340.166779,930.230286 338.431152,924.339233 
	C336.682007,918.402283 339.521912,911.315735 344.596832,908.953735 
	C348.474182,907.149170 359.652069,910.828003 362.355560,915.012024 
	C363.974487,917.517456 365.183441,920.287842 367.066284,923.554077 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M594.378784,495.286011 
	C591.762878,493.996704 589.865906,494.234680 587.920288,495.010803 
	C584.997314,496.176819 581.968689,496.668671 579.596802,494.059082 
	C576.633850,490.799194 579.294922,487.858398 580.550171,484.908569 
	C581.070312,483.686249 581.660339,482.472687 582.380737,481.360138 
	C586.446411,475.080658 588.916748,475.171021 592.834351,481.710754 
	C593.346741,482.566071 593.687317,483.527435 594.225647,484.363586 
	C597.322815,489.173981 603.026917,492.506256 606.430725,491.539551 
	C610.100464,490.497314 615.548157,483.111206 615.983826,478.534424 
	C616.203430,476.226929 615.939880,473.780975 616.628540,471.632904 
	C617.586731,468.644318 619.882141,466.631927 623.168884,466.180908 
	C626.634155,465.705383 627.538879,468.171997 628.654236,470.751526 
	C629.817749,473.442627 632.181824,475.556213 631.998779,478.892426 
	C631.843079,481.729523 631.382263,484.998230 628.442749,485.332794 
	C618.236694,486.494507 616.876709,493.945465 616.012451,501.795013 
	C615.552124,505.975098 613.057495,508.243134 609.712769,510.115204 
	C606.011902,512.186584 603.515503,511.633423 602.064148,507.338409 
	C600.584900,502.961151 599.331421,498.370422 594.378784,495.286011 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M214.504730,1176.269531 
	C209.526535,1182.294434 204.557861,1179.083496 200.638351,1176.700073 
	C196.260773,1174.037964 197.481369,1168.895020 198.842407,1164.872437 
	C200.748840,1159.237671 203.456512,1153.874023 205.825287,1148.396118 
	C206.352722,1147.176270 207.408310,1145.938232 207.350433,1144.751221 
	C206.921265,1135.946655 213.833344,1134.213867 219.811874,1131.885498 
	C225.820435,1129.545288 230.056854,1131.589966 232.631607,1137.374756 
	C234.889099,1142.446777 233.064178,1146.559937 227.241989,1149.243408 
	C225.746536,1149.932739 224.047760,1150.174927 222.536942,1150.838013 
	C216.327362,1153.563477 215.103729,1155.196655 216.954605,1161.476440 
	C218.511398,1166.758545 217.892349,1171.245972 214.504730,1176.269531 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M230.323608,896.524475 
	C223.411896,899.166992 219.524872,902.356079 219.255875,910.233337 
	C219.019684,917.150024 213.556992,920.213867 206.585541,919.988281 
	C200.768097,919.799988 198.816788,917.285095 200.437592,911.771118 
	C201.992889,906.479797 206.303955,904.059326 210.964767,901.994263 
	C218.041946,898.858704 218.019135,898.807251 216.676773,891.128906 
	C215.672043,885.381775 217.898712,879.941833 221.880417,878.415955 
	C226.806412,876.528198 231.807953,878.446716 234.918350,884.038208 
	C236.826355,887.468262 238.842270,889.868225 243.109695,890.240601 
	C247.211655,890.598511 250.432465,893.309204 253.454102,895.898376 
	C256.642761,898.630615 256.913300,904.040405 254.085953,906.399475 
	C250.745102,909.187012 247.598480,907.354004 245.231705,905.034424 
	C242.903748,902.752930 241.315826,899.716431 239.402054,897.012146 
	C236.933426,893.523743 234.075302,893.507751 230.323608,896.524475 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M297.404968,995.628601 
	C300.201141,991.567566 306.105988,992.894165 307.339020,988.459351 
	C308.460724,984.425171 305.568054,980.895752 304.676331,977.088074 
	C303.432281,971.776001 305.844543,965.992615 309.889984,964.431885 
	C316.341125,961.943115 325.171570,964.910278 328.237518,970.596863 
	C331.169312,976.034668 329.831482,982.000244 324.759583,985.486572 
	C323.411407,986.413391 321.863892,987.248718 320.289215,987.612671 
	C314.026428,989.060059 311.614349,993.032227 311.968567,999.223022 
	C312.247162,1004.091858 310.933319,1008.465149 306.798920,1011.479553 
	C301.496704,1015.345459 297.627228,1014.195496 295.135193,1008.105530 
	C293.377747,1003.810669 293.284576,999.718262 297.404968,995.628601 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M695.491760,518.729004 
	C696.914307,516.118591 698.323059,514.905579 700.348267,514.191040 
	C708.913940,511.168884 711.442200,507.052307 710.355042,498.185089 
	C709.200439,488.766388 712.830750,484.461029 722.315491,484.011139 
	C722.980164,483.979614 723.663025,483.909424 724.310852,484.017212 
	C727.633118,484.569916 731.993835,482.315216 733.726685,487.265747 
	C735.327698,491.839844 733.907166,498.200592 729.824707,500.713501 
	C721.556946,505.802643 716.899170,512.773865 715.852295,522.436218 
	C715.337280,527.189880 711.857849,529.950745 707.693726,531.678833 
	C702.225708,533.947998 700.508301,528.737854 696.715698,526.137085 
	C694.040894,524.073242 693.956726,521.853638 695.491760,518.729004 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M496.010193,550.110535 
	C498.894409,561.023254 496.534821,567.033630 488.844421,569.393860 
	C483.424652,571.057251 480.295624,569.778137 477.375153,564.677673 
	C476.880676,563.814148 476.164337,562.940979 476.057068,562.013672 
	C475.030853,553.144958 469.628326,550.868286 461.598389,551.939697 
	C456.169464,552.664001 453.907257,548.847900 452.502258,544.515320 
	C451.189667,540.467773 452.905609,537.337646 456.327271,535.176575 
	C459.776733,532.997925 466.509521,533.625854 469.305695,536.544983 
	C470.875824,538.184082 471.941376,540.324463 473.144897,542.293579 
	C476.990479,548.585571 477.037292,548.616333 484.118042,545.944214 
	C491.671906,543.093445 491.671906,543.093445 496.010193,550.110535 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M199.674973,1005.824829 
	C201.677170,1014.330688 200.907715,1015.463928 192.747391,1020.264221 
	C188.597183,1022.705505 185.254822,1022.330200 182.058243,1018.938965 
	C177.618683,1014.228943 177.073837,1008.878845 180.308838,1003.413635 
	C182.090988,1000.402832 184.796661,998.563354 187.747437,996.965515 
	C193.384003,993.913269 196.842972,990.027649 196.248917,982.770813 
	C195.819733,977.528442 199.605499,974.268555 203.906845,974.138367 
	C208.973557,973.985107 213.096954,978.380859 213.780045,984.663757 
	C214.285004,989.308105 209.930313,995.000122 205.387375,995.247620 
	C203.243500,995.364380 200.754807,993.012512 198.997086,995.559937 
	C197.138123,998.254089 197.988083,1001.294373 199.085663,1004.156494 
	C199.204865,1004.467346 199.338669,1004.772705 199.674973,1005.824829 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M308.413818,1180.527832 
	C306.720734,1174.407959 303.136658,1176.068359 299.578125,1177.226807 
	C297.278931,1177.975098 295.045319,1180.898438 292.469055,1178.216553 
	C290.122955,1175.774170 289.937012,1173.006714 292.462616,1170.324097 
	C293.733215,1168.974365 293.012543,1167.317505 293.013092,1165.695801 
	C293.014587,1161.113770 297.026581,1156.559570 301.060760,1156.213379 
	C305.976013,1155.791626 307.156616,1159.474609 307.814789,1163.101685 
	C308.379547,1166.213867 308.970795,1168.954590 313.263672,1169.901978 
	C317.243439,1167.267944 320.738037,1166.837158 325.250244,1169.431885 
	C330.233368,1169.695435 334.098633,1170.170410 335.348114,1175.149902 
	C336.604797,1180.158203 336.684357,1185.168579 332.772278,1189.087891 
	C329.610016,1192.255859 325.840118,1192.598022 322.002808,1189.835327 
	C319.635864,1188.131348 318.828796,1184.626099 314.703796,1184.086060 
	C311.081787,1185.120117 310.052704,1182.915649 308.413818,1180.527832 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M354.541382,1153.461914 
	C350.302216,1155.611328 349.215027,1160.142700 345.135925,1161.546875 
	C341.139740,1162.922363 337.032684,1166.102173 333.483795,1161.814941 
	C330.254059,1157.913330 333.699524,1154.416504 335.895874,1151.293335 
	C338.324860,1147.839355 341.134216,1144.652832 343.888367,1140.677368 
	C343.416687,1137.544434 343.511322,1135.171753 345.457275,1132.483887 
	C353.113983,1128.735718 355.038452,1121.767700 357.921387,1114.714111 
	C358.611023,1112.875366 359.610199,1112.288940 361.403931,1111.988037 
	C366.965942,1110.849365 367.430664,1111.091309 366.084167,1113.678223 
	C365.033966,1115.695679 365.000519,1116.882812 365.840759,1118.973267 
	C369.770416,1128.749878 369.230560,1130.200073 360.752136,1135.703369 
	C359.600342,1136.451050 358.673859,1137.283936 358.119873,1139.300049 
	C359.628876,1144.894897 357.122803,1148.856567 354.541382,1153.461914 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M384.331787,835.502197 
	C381.293732,831.901611 378.424347,832.550842 374.864166,833.221130 
	C367.560699,834.596008 361.771423,830.538147 359.684723,823.713745 
	C357.928619,817.970581 361.189514,813.219360 366.854736,814.297852 
	C372.641083,815.399536 379.201569,816.498779 382.505463,822.023804 
	C385.441376,826.933472 389.776550,828.434326 394.574188,829.766357 
	C395.848083,830.119995 397.352875,829.914978 398.471436,830.501038 
	C401.193451,831.927551 405.422913,831.344421 405.898163,835.944885 
	C406.322693,840.054138 404.843811,843.282959 401.208832,845.038208 
	C397.723511,846.721252 394.131866,846.526550 390.955170,843.854797 
	C388.365326,841.676575 386.429749,839.007568 384.331787,835.502197 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M402.131927,679.165955 
	C404.802795,681.817749 406.887573,683.961426 409.034576,686.040894 
	C411.245575,688.182434 412.733124,690.798828 413.547791,693.680481 
	C414.755676,697.953186 411.848206,704.200317 408.307587,705.541870 
	C404.376862,707.031311 401.167084,704.954346 398.733337,699.227295 
	C398.088013,697.708679 397.810883,696.032898 397.158630,694.518005 
	C393.841461,686.813904 390.869019,684.960449 382.449097,687.002991 
	C377.995331,688.083374 375.491669,687.153198 373.636383,683.208801 
	C372.160858,680.071838 371.002533,676.926392 373.620209,673.937378 
	C376.193604,670.998962 379.091125,672.460632 381.745392,673.922729 
	C385.083801,675.761658 388.631622,676.157959 392.339325,676.012695 
	C395.685089,675.881653 399.039246,675.842041 402.131927,679.165955 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M399.171783,1033.542603 
	C394.032990,1034.155029 391.776764,1031.092651 390.929657,1027.466187 
	C389.002899,1019.217896 383.584900,1017.170959 376.082825,1017.991150 
	C371.519867,1018.489990 367.613068,1017.348755 364.606537,1013.575928 
	C361.609344,1009.814941 361.112335,1004.470947 363.832245,1000.731628 
	C366.850128,996.582581 370.734344,997.770508 374.512909,999.343445 
	C378.548676,1001.023193 381.632263,1002.989624 382.638092,1008.227173 
	C383.768158,1014.111511 386.006439,1014.596985 392.250183,1012.888916 
	C396.373718,1011.760925 400.258636,1009.600647 405.574036,1010.019043 
	C406.685974,1018.424500 402.413177,1025.515137 399.171783,1033.542603 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M75.787415,1209.926392 
	C65.814590,1211.328369 61.682430,1217.815796 65.245956,1225.746826 
	C66.320801,1228.139038 67.922745,1230.180176 68.019775,1233.017090 
	C68.214447,1238.708862 66.548820,1241.531128 62.413422,1241.842285 
	C57.181007,1242.235962 52.173561,1238.244629 52.099037,1233.428589 
	C52.074215,1231.824463 52.314262,1230.065796 52.974598,1228.626221 
	C56.743271,1220.409790 56.798805,1220.435303 53.316673,1214.576172 
	C53.761368,1213.168335 54.923374,1212.228638 56.147442,1212.006836 
	C66.235931,1210.179199 68.888924,1202.732056 69.921890,1194.041626 
	C70.235435,1191.403564 70.033813,1188.515381 73.792892,1188.230591 
	C76.859444,1187.998291 78.633652,1189.702515 80.061081,1192.202148 
	C83.804008,1198.756470 82.441185,1205.989990 75.787415,1209.926392 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M529.327332,557.787048 
	C523.366882,558.689514 520.372742,556.080933 518.860413,551.437378 
	C518.250061,549.563354 518.166748,547.518616 517.565918,545.640381 
	C515.483765,539.131897 513.843811,538.237427 506.763336,539.449890 
	C499.260529,540.734680 494.445435,537.771118 492.520050,530.683655 
	C491.139191,525.600586 494.182983,521.976868 499.389496,522.921082 
	C503.328094,523.635437 506.853394,525.335205 509.619690,528.551147 
	C514.498657,534.223206 519.974976,538.482422 528.273987,538.236206 
	C533.768738,538.073181 536.311829,542.945801 537.350037,547.461304 
	C538.599304,552.894775 534.972412,555.993042 529.327332,557.787048 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M680.199951,446.755493 
	C684.061768,448.517090 687.435669,448.050201 690.715942,447.962494 
	C696.251831,447.814392 698.306152,451.494843 699.558411,455.796051 
	C700.916138,460.460144 698.621277,463.351959 693.654846,463.943207 
	C689.415527,464.447906 685.971802,463.238342 682.943481,460.031647 
	C677.758972,454.541687 673.006042,448.752625 663.845093,449.348969 
	C659.372925,449.640076 656.499207,445.217102 656.163879,440.355743 
	C655.900208,436.534119 658.128967,433.915527 661.392151,432.669617 
	C666.044922,430.893188 669.941406,433.198273 672.908203,436.502197 
	C675.527100,439.418671 676.184021,443.793701 680.199951,446.755493 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M315.451782,873.793091 
	C313.359833,883.557495 310.025970,891.567566 300.766174,895.555115 
	C298.725525,896.433838 296.779053,898.381958 294.330597,896.708069 
	C291.725708,894.927368 291.927185,892.151855 292.144501,889.491089 
	C292.392120,886.459473 294.099182,884.662720 297.132050,884.182434 
	C297.459259,884.130615 297.795776,884.132507 298.120514,884.070557 
	C308.424103,882.103821 308.390350,882.110840 305.952301,871.511414 
	C305.140564,867.982300 303.714172,864.611206 303.971008,860.809326 
	C304.251526,856.657288 306.142090,853.716003 309.917755,852.481506 
	C313.137268,851.428894 316.422577,851.746826 319.222748,854.312805 
	C322.210480,857.050781 321.833801,859.885864 320.563416,863.335144 
	C319.293915,866.782166 318.201202,870.237000 315.451782,873.793091 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M435.958954,691.261658 
	C433.187164,697.123291 427.070282,700.635742 422.676453,699.714050 
	C417.799713,698.690979 415.996521,690.348572 419.796967,685.516846 
	C420.981842,684.010437 422.682343,682.590332 424.446899,681.916077 
	C431.062836,679.387878 434.417145,674.657349 435.163971,667.743774 
	C435.338379,666.129028 436.069794,664.560120 436.640625,663.005249 
	C438.009094,659.277954 440.563629,656.817505 444.600769,656.426575 
	C447.198059,656.175110 447.590942,658.431213 448.352814,660.284607 
	C449.936554,664.137329 451.070648,667.888428 447.537689,671.318604 
	C446.826782,672.008789 446.120392,672.937683 445.247772,673.191040 
	C436.256104,675.801819 435.012665,682.498108 435.958954,691.261658 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M441.389984,925.439941 
	C440.789001,927.160217 440.147247,928.330383 439.484924,930.179260 
	C439.540619,931.823486 439.119171,932.458923 437.568298,932.580017 
	C431.204346,930.900208 426.930878,935.053589 421.926331,936.366943 
	C414.914307,938.206970 411.046753,936.310669 408.687012,929.065491 
	C406.440430,922.167786 408.131500,918.440552 414.819092,916.085510 
	C417.901459,915.000122 420.972778,913.923096 424.395233,913.933228 
	C428.307404,913.944824 431.504089,914.255371 432.674957,918.918579 
	C433.436462,921.951538 435.428223,924.182495 439.848541,924.013062 
	C440.882202,924.321655 441.115723,924.605713 441.389984,925.439941 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M336.000000,842.828003 
	C342.074677,842.999695 347.643768,839.685608 353.663361,839.978882 
	C361.000763,840.336304 366.114471,847.871582 363.414825,854.584473 
	C361.301086,859.840454 351.097473,863.876526 346.350647,860.781006 
	C340.308929,856.841003 333.746613,852.791443 336.000000,842.828003 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M385.601349,1087.297363 
	C385.093994,1088.923584 384.744263,1089.840332 384.455750,1091.499756 
	C384.516968,1092.242432 383.730743,1092.690308 383.304749,1092.537964 
	C377.893158,1092.098267 372.920258,1091.774658 368.217438,1089.824585 
	C366.060699,1088.930176 363.977295,1088.046631 362.316345,1086.252441 
	C357.288269,1080.820801 356.755249,1076.348755 360.823273,1072.299805 
	C366.317841,1066.831055 373.378784,1066.576904 377.934753,1072.186279 
	C379.943726,1074.659668 382.374512,1076.093140 385.624969,1077.826416 
	C387.809875,1081.039062 385.619690,1083.741821 385.601349,1087.297363 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M306.827454,1127.808594 
	C298.079315,1125.816650 298.470062,1118.661011 296.773682,1112.878418 
	C296.539154,1112.078735 296.941895,1110.900879 297.414703,1110.118774 
	C299.332642,1106.946045 311.183563,1103.811401 314.669373,1105.455322 
	C320.035858,1107.986206 324.005219,1117.336914 321.369080,1122.375122 
	C318.493073,1127.871826 313.066864,1128.191528 306.827454,1127.808594 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M108.079628,1191.990479 
	C110.174957,1183.891235 113.703400,1180.642334 119.887390,1180.061646 
	C125.451881,1179.538818 128.466843,1182.663574 130.555420,1187.230957 
	C133.094940,1192.784424 130.206558,1200.889404 124.836487,1203.296021 
	C118.281784,1206.233887 111.799919,1203.454956 109.259056,1196.584351 
	C108.801949,1195.348389 108.495560,1194.056519 108.079628,1191.990479 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M301.698914,832.788086 
	C304.765900,834.350464 307.758820,833.557922 309.911865,835.441101 
	C311.559906,836.882690 312.061218,838.783813 311.694153,840.847778 
	C311.261932,843.278137 309.356873,843.781128 307.240143,843.936584 
	C304.139587,844.164246 301.770386,843.124451 299.112793,841.242493 
	C289.715881,834.587952 283.893799,824.688049 275.928955,816.770081 
	C273.829651,814.683105 274.371948,812.505493 276.402100,810.733582 
	C279.905945,807.675232 283.849304,805.471558 288.393433,804.708862 
	C290.918243,808.128906 290.102661,811.548035 289.806854,814.712280 
	C288.879517,824.632935 289.609344,826.292908 298.308075,831.147949 
	C299.176300,831.632507 300.099518,832.018555 301.698914,832.788086 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M366.311768,1178.223145 
	C366.672455,1182.588013 366.234894,1186.814209 365.408813,1191.719238 
	C361.224792,1187.578979 355.896637,1188.041260 350.571228,1187.930542 
	C342.636902,1187.765503 339.649109,1184.441162 340.018646,1176.988281 
	C340.249298,1172.335693 341.766296,1167.871582 346.615479,1167.148926 
	C350.911194,1166.508789 355.954742,1166.716064 358.699341,1171.553467 
	C360.332001,1174.431274 361.605286,1177.611572 366.311768,1178.223145 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M436.767731,933.110352 
	C437.575195,932.173889 438.123322,931.814209 439.022766,931.087402 
	C439.233429,939.121399 434.304688,945.725708 431.365295,952.977600 
	C419.550201,982.127136 408.129059,1011.391907 399.674164,1041.738159 
	C398.185638,1047.080566 396.097626,1052.255859 393.651794,1057.761475 
	C386.990326,1051.535889 391.223846,1046.340332 395.839722,1040.571045 
	C397.214691,1038.460693 397.882019,1036.883545 398.557617,1034.657471 
	C401.166016,1026.522095 403.766144,1019.035767 406.388733,1010.787354 
	C414.713013,988.178040 422.507935,966.132874 431.952576,944.732178 
	C433.548035,941.116943 435.052307,937.461609 436.767731,933.110352 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M532.768005,769.308105 
	C531.753052,770.892700 530.981140,771.814331 530.032410,773.314636 
	C529.000977,774.921082 528.108276,775.918640 527.025757,777.611572 
	C526.680786,778.184265 526.262512,778.312805 526.259277,778.531555 
	C525.054321,779.011902 524.590759,780.161072 523.202393,781.013672 
	C522.389465,776.301392 519.934448,773.635681 515.202026,771.885559 
	C508.678436,769.473145 506.998993,765.753357 508.100250,759.514587 
	C509.436584,751.944519 518.000916,748.620361 524.073303,753.305176 
	C528.245667,756.524048 529.408752,761.649841 532.370972,766.552979 
	C532.795410,767.728577 532.903198,768.186829 532.768005,769.308105 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M568.515747,686.770874 
	C564.546204,688.189819 561.328430,688.573486 558.175842,686.772522 
	C553.314026,683.995239 549.894409,677.555725 551.225037,673.675415 
	C553.181335,667.970459 557.526672,665.489929 564.648560,666.012512 
	C570.179443,666.418335 574.605408,670.139465 575.579895,675.818909 
	C576.461121,680.955139 574.934265,685.051575 568.515747,686.770874 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M256.019531,1128.133057 
	C256.050323,1122.352173 258.342438,1119.084351 263.311951,1118.182739 
	C266.518524,1117.601318 276.030090,1122.125122 277.079407,1124.956177 
	C278.600922,1129.061157 279.302704,1133.865234 276.699066,1137.377197 
	C273.861420,1141.205078 268.815338,1141.829712 264.104828,1141.897705 
	C259.327515,1141.966675 258.254211,1138.346680 257.318268,1134.717651 
	C256.826660,1132.811523 256.450745,1130.875732 256.019531,1128.133057 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M535.925171,621.845581 
	C530.568420,630.691345 521.173279,632.358276 515.323608,626.280212 
	C511.122070,621.914612 510.633545,615.127563 514.302979,612.100098 
	C520.250061,607.193481 529.134338,607.399536 533.113525,612.710022 
	C534.916992,615.116882 536.119019,617.900024 535.925171,621.845581 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M246.251068,1016.479858 
	C247.361542,1013.599609 248.481400,1011.546570 249.303375,1009.380432 
	C251.217773,1004.335632 255.212448,1003.563049 259.839447,1004.069824 
	C264.121063,1004.538757 269.255676,1008.818298 269.704803,1012.660278 
	C270.249878,1017.323486 268.303284,1021.115234 264.416962,1023.706787 
	C256.732330,1028.831055 249.057312,1026.077271 246.251068,1016.479858 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M430.645691,702.297241 
	C439.282745,699.423218 444.054535,701.512756 445.710144,708.163330 
	C447.540527,715.515930 444.333405,720.537842 436.977631,721.837097 
	C429.798340,723.105225 423.059784,718.668335 422.420624,711.998901 
	C421.899170,706.557312 426.596954,705.104431 430.645691,702.297241 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M655.311951,383.526154 
	C659.100098,385.473785 660.174194,388.078156 659.977905,391.319031 
	C659.700317,395.904480 661.099365,400.722626 659.001099,405.032745 
	C656.845337,409.460815 647.278076,409.287262 644.540466,404.608765 
	C642.228821,400.658295 640.844116,396.161957 639.087830,391.891266 
	C638.071533,389.419830 639.594971,388.110321 641.554871,387.363190 
	C643.993408,386.433533 646.548767,385.810303 649.526855,384.526733 
	C651.343201,382.713654 652.904053,382.494995 655.311951,383.526154 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M603.716187,436.405518 
	C601.867493,445.711334 593.936951,446.659332 587.645264,449.551300 
	C585.736755,450.428558 583.919861,448.840851 582.717712,447.112183 
	C579.455444,442.420776 579.449036,437.173096 580.511902,431.921173 
	C581.011414,429.453125 583.187378,428.304352 585.710205,428.104523 
	C592.971558,427.529358 599.587097,428.487946 603.716187,436.405518 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M44.120407,1203.584717 
	C45.093872,1204.988037 45.861053,1205.881348 45.863316,1206.776367 
	C45.871426,1209.984619 51.127216,1211.871948 48.270599,1215.608521 
	C44.628891,1220.372070 40.375389,1224.573608 34.229961,1225.861328 
	C30.404972,1226.662842 27.799559,1224.733154 26.735035,1221.042725 
	C25.506294,1216.782959 24.756380,1211.779663 28.056377,1208.783691 
	C32.165516,1205.053101 36.695053,1200.246704 44.120407,1203.584717 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M361.969147,1027.333496 
	C365.319763,1030.543579 369.259247,1032.774902 367.065094,1037.712036 
	C365.173065,1041.969238 363.390808,1046.285645 358.169250,1047.651123 
	C351.479126,1049.400757 345.867462,1045.750854 344.474945,1038.586548 
	C343.508057,1033.612183 348.212036,1026.947632 353.513947,1026.154541 
	C356.104889,1025.767090 358.815063,1025.680664 361.969147,1027.333496 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M395.647766,1040.024658 
	C395.288300,1045.528564 394.029266,1051.019287 392.893677,1057.262329 
	C392.369598,1059.708130 391.722076,1061.401611 390.578217,1063.557129 
	C386.804382,1063.768066 383.409027,1064.627686 380.293182,1062.868164 
	C375.957367,1060.419556 373.372894,1055.610107 374.120422,1051.258423 
	C374.855743,1046.978149 381.197052,1040.692749 385.762939,1040.144775 
	C388.720764,1039.789917 391.750610,1040.035156 395.647766,1040.024658 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M136.974762,1033.132568 
	C131.744858,1022.010315 135.986710,1012.927124 145.881287,1012.069763 
	C150.569077,1011.663513 153.161942,1013.572510 154.444855,1018.253357 
	C155.619476,1022.539001 157.510437,1026.716187 152.529495,1029.595581 
	C147.999786,1032.214111 143.420059,1035.223145 136.974762,1033.132568 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M293.835052,1099.051636 
	C293.600494,1103.314453 295.072144,1107.005737 291.726654,1110.043945 
	C286.818787,1114.500977 282.087585,1114.611694 276.940948,1109.835449 
	C271.917114,1105.173218 271.194794,1100.306763 274.905640,1096.123657 
	C280.291779,1090.052002 284.734039,1089.273315 290.285004,1093.514282 
	C291.880280,1094.733032 293.141693,1096.275513 293.835052,1099.051636 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M200.717941,1113.815674 
	C196.092255,1113.827271 191.883469,1114.983276 188.751358,1111.617432 
	C184.069061,1106.585815 178.007172,1102.742188 175.188049,1096.093872 
	C174.440979,1094.332031 174.783417,1092.902832 176.808777,1092.261230 
	C188.393021,1088.592285 203.125748,1100.677002 202.269699,1113.172974 
	C202.256546,1113.364868 201.741913,1113.522583 200.717941,1113.815674 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M483.052063,845.304016 
	C480.462555,848.169312 479.295868,851.166443 477.745483,854.666992 
	C477.565613,856.203125 477.088440,856.697327 475.694061,856.690430 
	C472.401917,855.383118 471.048462,852.266418 467.637299,851.897461 
	C462.289368,851.318970 461.001617,846.877075 460.157867,842.559692 
	C459.386414,838.612244 460.747986,835.108704 464.349548,833.189880 
	C468.154633,831.162659 472.123810,831.272644 475.373474,834.559082 
	C477.701965,836.914001 479.798706,839.498108 482.381073,842.657471 
	C482.908447,843.768250 483.053650,844.201477 483.052063,845.304016 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M668.094055,546.283875 
	C676.799622,544.230103 680.601135,545.883850 683.033203,552.237610 
	C685.564697,558.851074 683.736328,562.283630 676.820679,563.846863 
	C676.181763,563.991333 675.474426,564.108887 674.847778,563.987122 
	C670.726440,563.186462 665.869995,569.433533 662.494812,563.156494 
	C660.035095,558.581848 662.616882,551.064880 668.094055,546.283875 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M543.946289,455.764587 
	C540.753479,444.426575 542.381897,439.933014 549.970459,437.032776 
	C551.950928,436.275848 553.767639,436.011932 555.686829,437.085754 
	C560.230652,439.628204 563.227844,449.622223 560.709534,453.930878 
	C556.773804,460.664795 551.298401,461.515503 543.946289,455.764587 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M441.894470,781.880737 
	C442.558868,783.447083 443.419678,784.544250 443.170502,785.249084 
	C442.111023,788.246155 431.997223,794.159912 428.577209,793.641907 
	C423.612122,792.889771 420.249847,789.941406 418.697205,785.103577 
	C416.988312,779.778748 419.746613,774.987183 425.347931,774.182312 
	C432.083710,773.214294 437.665070,775.437988 441.894470,781.880737 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M306.043335,1077.713867 
	C304.691254,1083.045654 302.524078,1086.560913 296.982483,1085.301147 
	C291.978180,1084.163574 288.236908,1079.034546 288.054413,1073.505737 
	C287.903809,1068.942627 291.781891,1063.632446 296.238342,1062.299805 
	C303.670990,1060.077026 308.586517,1064.323608 307.576813,1072.213135 
	C307.370911,1073.822021 306.628357,1075.362183 306.043335,1077.713867 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M140.903412,965.104858 
	C136.278625,955.148132 142.226654,943.727295 151.864471,942.398376 
	C155.000214,941.966003 156.840179,943.544861 157.721771,946.437256 
	C160.618759,955.941772 157.040207,962.396851 147.407867,965.242249 
	C145.447800,965.821167 143.557846,966.033081 140.903412,965.104858 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M695.110840,517.998474 
	C695.999084,520.131592 696.000549,522.265564 696.003479,525.199829 
	C696.460022,530.944336 695.414734,534.841858 690.135681,536.979309 
	C685.344238,538.919312 682.040771,537.246155 678.807434,533.992676 
	C677.944824,533.124695 676.572021,532.763733 674.716736,532.086243 
	C673.744080,531.669067 673.488098,531.335632 673.614868,530.501099 
	C674.352661,520.155090 675.668945,518.705261 685.295898,518.051331 
	C688.259460,517.850037 691.247375,518.006653 695.110840,517.998474 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M569.324646,497.130920 
	C567.987366,498.711945 567.216064,499.946075 566.104797,500.507294 
	C562.623779,502.265228 558.037231,504.393951 555.156982,502.357025 
	C551.162048,499.531799 550.192017,493.922394 550.325806,488.998840 
	C550.458679,484.109009 555.462219,481.552338 562.496033,482.012238 
	C568.335815,482.394012 571.597534,485.173462 571.867188,490.004150 
	C572.003174,492.438629 570.684326,494.397308 569.324646,497.130920 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M468.812805,667.404480 
	C462.439697,668.346497 457.782349,667.767273 455.373932,661.274170 
	C453.581512,656.441772 454.619385,652.636536 458.027527,649.662048 
	C461.294708,646.810608 465.470215,647.723938 469.331970,648.939331 
	C469.929260,649.127197 470.410828,649.687073 470.942047,650.080078 
	C479.623871,656.501465 479.155731,662.225159 468.812805,667.404480 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M270.017242,908.112549 
	C270.127441,904.872864 270.497589,902.113708 273.507843,902.355042 
	C279.096802,902.803162 284.660156,904.147156 288.776398,908.271729 
	C292.736084,912.239197 292.402405,918.028015 288.537384,921.412415 
	C284.108276,925.290771 276.588379,924.300232 272.807068,919.193054 
	C270.580170,916.185303 269.701324,912.693237 270.017242,908.112549 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M449.600494,906.099731 
	C445.930725,905.817871 443.189240,906.614624 440.350220,907.765869 
	C433.192383,910.668396 430.408813,909.362305 427.284790,902.515564 
	C426.136749,899.999390 425.870270,897.439209 426.059143,894.794250 
	C426.424652,889.676514 428.631439,887.569275 433.721497,888.136475 
	C439.215027,888.748535 443.964355,890.955261 445.765289,896.776855 
	C446.453979,899.003296 446.536591,901.410461 450.183167,902.152710 
	C451.425171,903.648926 451.194641,904.852600 449.600494,906.099731 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M451.952332,828.014282 
	C450.309601,830.120483 449.201385,831.878052 447.627472,832.955505 
	C439.575836,838.467896 433.334473,835.905762 432.163208,826.535339 
	C431.679443,822.665161 431.391388,818.637207 435.755829,816.143860 
	C439.837646,813.811890 443.793823,813.326172 447.802704,815.970642 
	C451.915588,818.683777 454.849976,821.963196 451.952332,828.014282 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M351.403168,799.400513 
	C352.365479,804.853943 352.312531,809.253113 348.222290,812.828430 
	C343.550385,816.912109 338.141754,816.995789 334.442291,812.190613 
	C332.662872,809.879272 331.561523,806.992798 330.439209,804.249695 
	C329.820709,802.738037 329.676025,800.676208 330.958832,799.554626 
	C334.600952,796.370361 339.523468,796.499756 343.853271,795.059448 
	C347.606201,793.811096 349.287537,796.282593 351.403168,799.400513 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M526.637146,499.168457 
	C526.031372,509.624969 522.687134,512.859070 514.423157,511.948517 
	C509.786346,511.437622 505.959412,506.915253 506.328339,502.382629 
	C506.691498,497.921021 512.864685,490.584900 516.929016,490.241791 
	C522.728271,489.752258 525.182312,493.464142 526.637146,499.168457 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M411.338501,872.217102 
	C413.316467,872.909485 414.706726,873.248108 415.661041,874.084290 
	C419.615021,877.548401 421.152618,883.145569 419.230408,886.394165 
	C416.987946,890.184082 407.183228,893.131775 403.073212,891.251770 
	C398.887634,889.337158 396.466278,883.426880 398.370514,878.441833 
	C400.464966,872.958984 405.321136,871.979736 411.338501,872.217102 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M263.808960,1065.518921 
	C263.002777,1063.236572 262.226074,1061.684814 262.115387,1060.086792 
	C261.587616,1052.468018 263.118378,1050.470703 269.474487,1050.018921 
	C277.568939,1049.443604 281.545502,1052.326782 281.976318,1059.083252 
	C282.423950,1066.103882 279.215485,1070.650024 273.159393,1071.208740 
	C269.143738,1071.579224 266.260071,1069.502075 263.808960,1065.518921 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M37.841736,1351.112793 
	C36.936207,1348.872681 36.121544,1347.432251 35.330795,1345.978882 
	C34.147228,1343.803589 34.799580,1341.692627 36.841805,1340.993408 
	C41.668633,1339.340576 46.846172,1338.865112 51.226944,1341.918213 
	C55.388279,1344.818481 56.242130,1349.652710 55.780018,1354.393066 
	C55.382309,1358.473022 43.252438,1363.627441 39.919510,1361.204834 
	C36.664841,1358.838867 38.495193,1355.043457 37.841736,1351.112793 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M435.787537,855.289551 
	C434.492096,858.823486 433.821320,862.173950 430.682983,863.205994 
	C426.872742,864.458984 422.775848,865.000183 419.397949,861.916992 
	C416.285034,859.075562 415.087616,852.449158 416.813751,848.876404 
	C418.555084,845.272156 424.913544,841.518127 428.383881,842.514526 
	C432.755280,843.769714 436.433990,845.973389 435.990173,851.492493 
	C435.910278,852.486267 435.936035,853.488586 435.787537,855.289551 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M774.495178,538.241089 
	C774.165710,540.501343 772.365479,541.518921 769.916809,542.542542 
	C765.411377,541.935486 761.888977,539.738403 757.725037,539.958801 
	C752.800293,540.219421 749.353149,537.989563 748.223938,533.040283 
	C747.399658,529.427612 748.612915,526.796997 752.126892,524.862244 
	C758.406250,521.404968 761.598389,521.198547 765.750061,524.786377 
	C768.378113,527.057495 770.023865,529.750488 770.260681,533.327393 
	C770.403198,535.479675 771.977173,536.830505 774.495178,538.241089 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M527.056030,588.589722 
	C534.024231,601.985291 534.019836,601.959412 520.159790,604.324829 
	C517.392761,604.797058 514.443420,607.334473 512.132690,603.718933 
	C509.574615,599.716492 509.174835,595.039429 508.653656,590.471497 
	C508.584198,589.863220 509.762177,588.596375 510.481842,588.496765 
	C515.820862,587.757446 521.085388,583.500305 527.056030,588.589722 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M545.688049,527.940430 
	C537.890625,526.981018 535.366699,525.065186 534.332825,519.977051 
	C533.496277,515.859924 535.846313,511.147858 540.839661,508.953186 
	C544.284912,507.438995 548.178101,504.572205 551.999146,506.911835 
	C555.686401,509.169525 553.659546,513.533020 553.949707,516.969482 
	C554.417847,522.513184 552.520508,526.669312 545.688049,527.940430 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M584.502686,453.991669 
	C585.671448,457.094208 586.590393,459.612579 586.967896,462.209686 
	C587.879517,468.481842 584.853271,472.754242 579.030884,473.829468 
	C573.118530,474.921295 567.563171,471.358826 566.299011,465.655609 
	C565.563782,462.338501 566.809265,459.667145 569.424133,457.813721 
	C573.753723,454.744873 578.387329,452.359833 584.502686,453.991669 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M321.593445,1040.682373 
	C324.665588,1044.896484 324.765747,1048.635010 322.379547,1052.349487 
	C318.904877,1057.758057 312.394806,1059.596802 307.871704,1056.542114 
	C303.511658,1053.597290 302.546814,1045.344116 305.983124,1040.386963 
	C309.658264,1035.085327 314.264160,1034.999878 321.593445,1040.682373 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M680.269653,479.301453 
	C683.389282,482.845245 686.427002,485.744171 684.763123,490.275696 
	C683.549133,493.582123 681.495605,496.101135 677.514160,495.946686 
	C673.662354,495.797241 669.490601,497.007996 666.606445,492.965210 
	C663.867920,489.126587 663.055908,481.578979 665.320557,478.879913 
	C668.186768,475.463867 673.164917,475.424561 680.269653,479.301453 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M642.799438,477.785095 
	C633.823914,469.706909 634.230164,463.586212 643.223145,459.452332 
	C649.178650,456.714722 653.341919,457.616852 656.049866,462.231903 
	C659.258972,467.701141 658.206116,471.809723 652.980713,475.967896 
	C650.063599,478.289215 646.855530,477.963623 642.799438,477.785095 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M226.129562,1009.998169 
	C217.431046,1008.700073 216.576996,1007.269958 220.004074,1001.048157 
	C221.111740,999.037170 222.538315,997.175293 223.436661,995.081177 
	C225.319534,990.691956 228.687439,989.326538 233.021027,990.227417 
	C237.401871,991.138062 239.656082,994.066772 239.975113,998.577942 
	C240.301453,1003.192444 239.428177,1007.358704 234.732452,1009.175354 
	C232.392258,1010.080750 229.579102,1009.763550 226.129562,1009.998169 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M298.825134,925.078003 
	C301.418549,921.653442 304.499847,921.893921 307.456726,922.075867 
	C313.011993,922.417725 316.892365,925.520569 317.598602,929.944824 
	C318.183990,933.612366 314.725708,941.293213 311.609589,942.925110 
	C307.798553,944.920837 304.545624,943.855591 301.887177,940.712769 
	C298.197144,936.350525 297.264496,931.311035 298.825134,925.078003 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M97.343002,1150.502686 
	C95.230911,1145.947266 97.034081,1143.677124 100.376823,1141.821655 
	C104.872162,1139.326416 110.020714,1139.836914 114.781921,1138.487427 
	C117.649284,1137.674438 119.956886,1140.371338 119.737511,1143.326782 
	C119.371429,1148.258911 118.478996,1153.286865 114.087517,1156.542603 
	C110.161392,1159.453369 106.523537,1157.263672 102.963646,1155.472656 
	C100.899673,1154.434204 98.744606,1153.459473 97.343002,1150.502686 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M680.144043,370.490326 
	C677.302673,359.644501 680.038940,354.689636 688.815369,354.033356 
	C695.382629,353.542297 699.282532,356.933136 699.899658,363.670898 
	C700.351440,368.602417 695.721497,373.651794 690.142334,373.774872 
	C687.944763,373.823303 685.722412,372.747650 682.757812,372.092560 
	C681.309448,371.869385 680.743286,371.520477 680.144043,370.490326 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M609.534546,517.765686 
	C618.866882,511.894806 629.000671,516.947998 629.820068,527.010315 
	C630.035400,529.653809 629.031311,531.271545 626.382568,532.165344 
	C621.965393,533.655945 617.617676,535.452148 613.297791,532.122009 
	C608.686401,528.567139 606.433350,524.213318 609.534546,517.765686 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M354.542969,1154.407593 
	C353.461761,1149.325317 355.025299,1145.214844 357.702332,1140.661621 
	C362.674408,1140.852539 366.859070,1137.803833 372.343231,1138.450439 
	C375.628937,1145.416504 371.168915,1151.699097 371.384338,1159.170898 
	C370.872528,1160.881836 370.611420,1161.792725 370.496399,1163.410278 
	C370.642456,1164.116943 369.881836,1164.352295 369.510590,1164.486816 
	C363.954926,1162.069702 357.670258,1161.094604 354.542969,1154.407593 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M490.865479,786.570312 
	C491.857819,780.700989 495.152344,777.893311 499.800751,776.047852 
	C505.226318,773.893738 508.756165,775.579285 509.845795,781.262817 
	C510.030945,782.228394 509.985870,783.246338 509.977661,784.239441 
	C509.926697,790.420776 505.358856,796.541260 500.031281,797.594971 
	C495.657288,798.460144 492.883331,795.410156 490.865479,786.570312 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M359.871948,766.368652 
	C367.582916,770.410767 368.951447,772.682617 367.891724,778.551025 
	C367.103210,782.917847 360.815094,789.329285 356.601288,789.847900 
	C352.882660,790.305542 350.368896,789.437988 349.952576,784.832642 
	C349.110107,775.513550 351.274292,770.677734 359.871948,766.368652 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M634.531128,632.647156 
	C631.783752,629.299194 628.835083,628.159729 624.712280,628.005127 
	C623.818909,626.304504 623.011902,625.008789 621.839111,623.751831 
	C618.385010,620.049866 621.288574,616.938293 623.358154,614.260925 
	C626.416382,610.304504 628.169434,615.508972 631.347595,615.896118 
	C632.631897,616.219177 633.149841,616.599243 633.776855,617.570190 
	C635.084290,619.050964 636.121399,620.144409 637.602173,621.592896 
	C640.131836,621.998108 642.266357,621.999695 645.201294,622.001831 
	C650.980652,627.923523 650.805542,632.616394 645.444641,636.816406 
	C640.189514,640.933594 637.025879,638.870239 634.531128,632.647156 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M489.370178,681.361633 
	C486.389069,679.487915 484.633026,677.674194 484.123566,674.805481 
	C483.109955,669.098022 485.464539,663.804016 489.812439,662.414429 
	C493.816620,661.134583 498.473785,663.297119 501.050598,668.337524 
	C502.792938,671.745605 506.603088,675.255127 504.794220,679.108215 
	C502.529297,683.932617 497.163696,681.507568 493.086212,681.944641 
	C492.121490,682.048035 491.116669,681.777344 489.370178,681.361633 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M552.497375,624.243713 
	C559.544189,626.200684 564.936829,634.337891 563.457886,639.575500 
	C563.286865,640.181335 562.935425,640.786987 562.520508,641.265076 
	C559.219116,645.069092 548.967285,644.890381 545.031555,640.987915 
	C540.854980,636.846436 541.710571,630.872314 547.273193,626.517456 
	C548.544556,625.522095 550.239563,625.067932 552.497375,624.243713 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M465.781219,792.767700 
	C466.571167,798.930664 465.322021,803.331482 460.040894,805.961426 
	C455.841125,808.052734 451.421051,807.063049 448.855286,803.201660 
	C445.273224,797.810730 445.298615,791.291382 448.911285,788.843567 
	C455.221680,784.567810 460.409149,785.538574 465.781219,792.767700 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M283.377686,1150.047241 
	C281.895081,1141.147827 283.889557,1137.257690 290.850403,1134.846802 
	C296.813293,1132.781494 298.815582,1138.342773 302.023804,1141.258179 
	C304.709503,1143.698853 304.008392,1146.448975 301.800323,1149.185791 
	C295.957428,1156.427979 290.674103,1156.934692 283.377686,1150.047241 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M12.251418,1171.470215 
	C12.465822,1166.047974 13.588388,1162.131958 19.400330,1162.010010 
	C25.109461,1161.890381 29.778410,1163.870239 33.021267,1168.634521 
	C34.543659,1170.871094 33.558846,1173.121582 32.289371,1175.139160 
	C30.274099,1178.341919 27.206842,1180.481812 23.771469,1181.583008 
	C20.540197,1182.618774 17.117182,1182.405884 15.336174,1178.534180 
	C14.368832,1176.431396 13.362444,1174.346313 12.251418,1171.470215 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M213.381653,1086.688477 
	C216.644714,1088.111816 218.176773,1090.186646 219.330215,1092.646240 
	C221.000107,1096.207153 223.608688,1099.882935 220.620834,1103.695801 
	C217.746460,1107.363770 213.312561,1105.968140 209.480774,1105.814331 
	C204.994736,1105.634399 203.630707,1101.867554 202.565384,1098.426025 
	C201.906281,1096.296631 201.859955,1093.818848 202.162094,1091.581665 
	C202.951385,1085.737427 205.884384,1084.379761 213.381653,1086.688477 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M369.550049,714.214233 
	C362.877899,717.543945 357.319336,715.913513 352.794403,711.491089 
	C350.160309,708.916687 346.646423,705.807312 349.901367,701.286804 
	C352.824280,697.227539 358.740967,695.582031 362.955811,697.528748 
	C369.515594,700.558594 371.599152,705.308655 369.550049,714.214233 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M57.576794,1335.033569 
	C49.908806,1325.874023 51.071186,1318.560913 60.061287,1315.049561 
	C65.514992,1312.919434 69.002228,1313.903442 70.949219,1318.121582 
	C73.470383,1323.583618 72.051270,1329.391602 67.752678,1332.093384 
	C64.822548,1333.935059 61.393978,1333.738037 57.576794,1335.033569 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M546.622192,559.291748 
	C555.232788,550.751648 559.936340,551.096375 564.603149,559.886597 
	C567.094666,564.579529 566.200317,569.577148 562.371338,572.357361 
	C558.884827,574.889038 554.237305,574.475159 550.487000,571.435791 
	C546.778809,568.430542 545.214661,564.715576 546.622192,559.291748 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M167.189743,1060.898193 
	C169.004883,1069.046265 163.372925,1072.226685 158.544479,1075.271362 
	C154.802231,1077.630981 147.840622,1073.082031 146.368088,1068.073730 
	C145.117676,1063.820923 149.349640,1057.373901 154.551666,1056.321899 
	C159.197006,1055.382324 163.805023,1055.582397 167.189743,1060.898193 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M596.616089,510.639587 
	C595.814697,512.170471 595.469421,513.166504 594.819763,513.888855 
	C591.953613,517.075562 589.352661,521.028809 584.125732,519.622375 
	C579.151733,518.284058 578.365173,513.715271 576.850037,509.684509 
	C575.369080,505.744690 577.197388,503.169800 580.210266,501.286346 
	C587.762146,496.565521 595.615417,500.711884 596.616089,510.639587 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M464.586395,774.730530 
	C464.208862,772.286255 464.017822,770.627380 464.023987,768.969116 
	C464.035034,765.999878 463.592651,762.706970 466.809906,760.985107 
	C470.393738,759.066956 473.227448,761.501953 475.900818,763.310730 
	C477.486877,764.383789 478.682281,766.132996 479.830231,767.737732 
	C484.666199,774.498047 484.740692,777.300842 480.331970,780.391113 
	C475.712189,783.629272 469.677704,782.367493 465.744904,777.303406 
	C465.345551,776.789124 465.151215,776.115723 464.586395,774.730530 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M247.799973,1167.854004 
	C241.666290,1163.808472 240.594009,1159.873169 243.187668,1153.787598 
	C245.067963,1149.375854 250.673386,1146.025391 254.983887,1146.736816 
	C260.608795,1147.665161 263.157867,1152.276978 261.010559,1157.818970 
	C258.802490,1163.517578 254.549698,1166.775635 247.799973,1167.854004 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M65.721649,1148.060059 
	C73.176270,1151.614014 77.906075,1159.129272 77.129440,1165.203491 
	C77.023369,1166.033203 76.361664,1167.085571 75.647629,1167.494995 
	C71.479271,1169.885498 61.685265,1167.190796 58.588551,1162.925537 
	C53.648640,1156.121582 55.853779,1150.950439 65.721649,1148.060059 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M541.021729,738.622864 
	C538.389221,740.908997 536.036560,741.835144 533.278381,742.001892 
	C528.621216,742.283325 524.697754,741.227234 522.632385,736.654175 
	C521.059753,733.171936 523.792175,726.349915 527.619202,723.632629 
	C530.934448,721.278748 535.895020,721.760681 539.410217,724.999817 
	C543.443665,728.716553 541.934692,733.446716 541.021729,738.622864 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M318.241333,728.106689 
	C316.112823,726.936707 314.410156,726.347839 313.320190,725.184692 
	C310.419678,722.089600 308.802734,718.433411 311.158936,714.331238 
	C313.981140,709.417603 318.847565,709.787781 323.550812,710.094482 
	C328.294952,710.403809 329.302765,714.008667 329.885712,717.729797 
	C331.464569,727.808777 328.494110,730.667969 318.241333,728.106689 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M505.376892,635.556030 
	C508.170227,636.821838 510.471588,637.408325 512.484314,638.518188 
	C517.218018,641.128540 518.752808,646.600647 516.302612,651.275818 
	C513.908081,655.844727 509.664093,657.232666 504.493256,655.137756 
	C500.351074,653.459534 495.716248,645.675781 496.148041,641.357300 
	C496.455627,638.281433 499.292328,638.324951 501.538147,636.531982 
	C502.759247,635.212830 503.677460,634.917725 505.376892,635.556030 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M528.915161,654.812500 
	C533.962402,650.929260 538.672424,650.899719 543.082642,654.333557 
	C547.141052,657.493469 546.085449,662.192383 545.827759,666.422058 
	C545.578430,670.513367 542.855896,672.240295 538.945496,671.745667 
	C536.998596,671.499390 535.105713,670.707214 533.228821,670.046997 
	C525.586182,667.358521 525.245483,666.616882 527.644470,658.359985 
	C527.923157,657.400635 528.213867,656.444641 528.915161,654.812500 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M209.196777,1017.841980 
	C211.933289,1014.726562 214.305573,1013.921082 217.552216,1015.770508 
	C222.666870,1018.684021 225.764465,1026.782715 223.532120,1032.223389 
	C222.145264,1035.603394 216.894653,1037.055908 211.173447,1035.849609 
	C208.170410,1035.216309 206.321793,1033.532349 206.178284,1030.556152 
	C205.974747,1026.335571 204.997498,1021.855957 209.196777,1017.841980 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M653.571289,360.676147 
	C642.202759,367.740479 632.709290,364.071198 630.479919,352.525513 
	C629.533752,347.625336 630.935242,345.861328 636.240051,346.066681 
	C645.328003,346.418579 650.580933,351.814453 653.571289,360.676147 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M103.265366,1364.969482 
	C99.947540,1369.519897 96.070328,1371.713745 91.137268,1371.963379 
	C87.439240,1372.150635 84.706009,1370.475830 82.997086,1367.364990 
	C81.170013,1364.039185 81.948631,1360.861938 84.702896,1358.417603 
	C87.729950,1355.731323 89.704315,1351.025635 95.214958,1352.700562 
	C100.509941,1354.310059 102.855560,1357.427124 103.265366,1364.969482 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M307.524048,1180.531250 
	C310.436340,1179.914429 311.700745,1181.604370 313.487732,1183.641113 
	C314.308563,1185.287720 314.541901,1186.597900 314.932404,1187.859497 
	C317.896484,1197.435059 314.544586,1197.940186 306.866791,1199.757690 
	C301.319794,1201.070801 296.013947,1198.631958 294.883362,1195.074341 
	C293.679840,1191.287109 297.715729,1184.199341 302.285339,1182.317627 
	C303.790070,1181.697998 305.455902,1181.469604 307.524048,1180.531250 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M393.699951,902.061035 
	C395.969421,902.739441 397.675720,903.109741 398.877258,904.095276 
	C403.492523,907.881042 405.212524,912.827026 403.671143,917.052063 
	C402.847015,919.311096 394.900360,922.484863 391.547943,921.449829 
	C387.729309,920.270752 384.294006,918.577881 383.982056,913.569458 
	C383.582550,907.156372 384.978241,904.804749 391.924316,902.093872 
	C392.214569,901.980652 392.576416,902.050842 393.699951,902.061035 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M567.499512,525.614746 
	C577.227905,523.691895 580.847717,525.277039 583.254517,532.838989 
	C584.279846,536.060425 584.936829,539.613586 582.167419,542.127258 
	C578.595581,545.369324 573.968872,544.352173 569.885742,543.429810 
	C566.507263,542.666565 564.490479,539.901978 564.059753,536.196289 
	C563.697937,533.083679 564.979858,530.376587 565.902954,526.771973 
	C566.333008,525.743958 566.666016,525.487976 567.499512,525.614746 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M743.394409,437.442444 
	C745.277893,442.180878 746.555786,446.362946 747.918030,451.272522 
	C744.566040,453.036682 741.079956,453.935120 737.706299,455.146484 
	C733.864075,456.526154 730.622131,455.978943 727.984070,452.799927 
	C725.269653,449.528961 725.521851,446.205994 728.048035,442.963226 
	C729.306274,441.348114 729.991394,439.571716 729.984253,436.762482 
	C730.887024,435.999268 731.776428,435.998505 733.332947,435.997070 
	C737.226562,433.359497 740.085266,434.356720 743.394409,437.442444 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M16.027981,1262.145020 
	C16.061874,1259.698486 15.964207,1257.769531 17.429096,1256.802002 
	C23.256132,1252.953735 28.593178,1248.916504 29.612362,1241.215698 
	C29.880516,1239.189575 31.856617,1237.860718 34.162930,1238.517700 
	C36.687744,1239.236938 38.375061,1241.237427 37.550327,1243.727295 
	C35.386669,1250.259277 33.164360,1256.833374 30.179466,1263.010864 
	C28.049126,1267.419922 22.796465,1266.706909 18.781134,1267.358643 
	C16.443203,1267.737915 16.161650,1264.946655 16.027981,1262.145020 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M472.875397,692.807495 
	C478.772858,691.970581 482.150543,695.148315 485.428772,698.496582 
	C486.596344,699.689148 487.673798,700.988342 487.695496,702.768799 
	C487.734680,705.983521 485.516663,707.636047 482.935211,708.392761 
	C478.091064,709.812866 473.417877,714.168335 468.054169,710.397156 
	C465.251251,708.426392 465.674744,704.994446 466.372253,702.114624 
	C467.239563,698.533875 469.076080,695.356079 472.875397,692.807495 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M606.310608,615.820740 
	C607.216003,617.645447 607.809082,618.879700 607.881470,620.143799 
	C608.145020,624.750122 606.651489,628.463501 602.321533,630.789246 
	C598.797668,632.682007 595.685059,631.561157 593.332703,629.150940 
	C590.143188,625.882874 587.102600,622.260376 588.169128,617.007690 
	C588.882935,613.492493 591.156799,612.155762 594.502625,612.061096 
	C598.594849,611.945435 602.124939,613.767700 606.310608,615.820740 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M463.804321,877.664307 
	C459.577179,878.010437 455.918427,877.977356 452.259979,877.997742 
	C448.336914,878.019653 444.840820,877.436523 444.144745,872.621582 
	C443.500122,868.162903 445.151245,864.828308 449.105560,862.663452 
	C454.380707,859.775452 458.077759,860.057495 462.791901,864.026794 
	C464.285248,865.284241 465.340088,867.062561 466.978699,869.351196 
	C467.650909,873.035706 466.275055,875.281311 463.804321,877.664307 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M317.881165,799.988953 
	C309.874908,799.031372 306.885284,796.614197 306.202179,791.220154 
	C305.667053,786.994263 308.259064,782.529175 312.233582,780.978516 
	C316.694061,779.238281 319.843384,781.247375 322.243927,784.803040 
	C323.336151,786.420837 324.234741,788.222412 324.918030,790.053650 
	C327.188202,796.138000 326.165558,797.701904 317.881165,799.988953 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M77.926636,1091.777588 
	C77.178879,1097.306519 73.820877,1097.993042 69.890167,1098.010620 
	C66.218361,1098.027100 62.632324,1098.088135 59.993938,1094.836182 
	C56.919254,1091.046143 57.385807,1085.376587 61.101292,1082.587891 
	C66.057579,1078.867920 72.891617,1079.307861 76.243416,1083.454834 
	C78.073624,1085.719238 77.979431,1088.322388 77.926636,1091.777588 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M320.377319,913.944336 
	C316.012848,913.361084 312.568207,911.450623 312.912201,907.874634 
	C313.372101,903.094116 314.421265,897.844116 319.038116,894.853943 
	C322.318695,892.729248 327.321320,894.127808 329.599365,897.367004 
	C332.815033,901.939392 332.842529,908.270203 329.414764,910.979553 
	C327.057861,912.842346 324.295319,914.048767 320.377319,913.944336 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M328.453186,954.098267 
	C325.654419,951.545349 323.731781,949.282349 325.129822,945.893616 
	C326.564758,942.415344 328.742950,939.632629 332.210999,937.921082 
	C337.299652,935.409607 342.247192,937.625427 344.765533,943.639709 
	C346.838989,948.591553 342.840088,954.797241 336.775696,955.837830 
	C334.113007,956.294800 331.488525,955.914917 328.453186,954.098267 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M136.884857,987.717285 
	C131.144531,987.795654 126.163589,988.664001 120.693665,987.036072 
	C122.373665,979.696838 125.943863,973.990479 131.982895,970.128235 
	C137.278778,966.741333 140.838242,968.514954 141.748062,974.790283 
	C142.442825,979.582397 141.209579,983.971924 136.884857,987.717285 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M427.566284,660.723022 
	C430.536591,664.103699 430.265991,667.503906 429.785126,670.736938 
	C429.130615,675.138000 422.834717,678.784851 418.317474,677.707520 
	C413.819183,676.634705 409.409576,670.550720 410.264282,666.596436 
	C411.105194,662.705994 418.647919,657.906555 423.581848,658.367981 
	C424.773010,658.479309 425.875977,659.534180 427.566284,660.723022 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M147.283066,1268.080811 
	C154.470932,1270.248169 155.210312,1275.911377 155.845596,1281.506104 
	C155.977692,1282.669312 155.432175,1284.271973 154.620163,1285.113770 
	C151.967957,1287.863281 148.064972,1288.100952 144.712814,1289.443237 
	C142.242661,1290.432251 140.208694,1289.306763 138.335205,1286.624023 
	C137.522064,1278.454956 137.827560,1271.284302 147.283066,1268.080811 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M463.483215,592.442444 
	C461.231201,590.179626 460.203949,588.250427 460.018036,585.770447 
	C459.516296,579.076538 461.226990,576.510010 466.775055,576.044312 
	C473.388214,575.489136 477.380280,578.288208 477.863983,584.377808 
	C478.142609,587.885620 479.217499,592.169006 475.732819,594.554016 
	C471.762909,597.271179 467.558197,596.498169 463.483215,592.442444 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M705.786011,570.731079 
	C705.972656,573.507629 706.135559,575.548157 705.047241,577.344727 
	C703.188416,580.413147 700.554932,582.006897 696.818237,582.006165 
	C692.859131,582.005371 690.329590,579.993652 689.430725,576.524231 
	C688.376404,572.454590 683.509033,568.262146 688.552490,564.006531 
	C692.854553,560.376465 698.626892,561.585266 703.499817,566.637817 
	C704.398560,567.569580 704.947327,568.838867 705.786011,570.731079 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M679.289429,369.909607 
	C680.634033,370.218140 681.151611,370.598389 681.778442,371.569153 
	C677.961304,380.158478 670.218689,383.222687 662.862854,379.735443 
	C658.753723,377.787354 660.380859,374.143585 660.021362,371.090118 
	C659.544189,367.036804 660.850098,363.950989 665.037537,362.640778 
	C668.086060,361.686920 670.960632,361.768250 673.041382,364.588226 
	C674.585815,366.681244 675.566895,369.305420 679.289429,369.909607 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M641.272827,418.783691 
	C644.550415,427.483948 641.192993,434.219055 633.493591,435.717224 
	C631.108948,436.181244 628.897949,435.766510 627.305847,433.686005 
	C624.666321,430.236786 625.778198,418.991638 629.029053,416.134613 
	C632.525269,413.061981 634.932739,413.471069 641.272827,418.783691 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M204.516281,1134.959473 
	C193.176224,1136.340088 188.661728,1134.028442 185.270981,1126.569580 
	C183.426086,1122.511230 184.821655,1120.326416 188.508194,1118.852173 
	C198.803513,1114.735229 205.379059,1120.908203 204.516281,1134.959473 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M438.511475,649.957947 
	C434.002808,649.661926 431.741913,647.103699 429.765808,644.465759 
	C426.758881,640.451599 427.541138,634.978210 431.221649,631.958008 
	C435.166382,628.720947 439.250000,629.568420 443.069122,634.497986 
	C443.876556,635.540161 444.439941,636.768982 445.143677,637.894409 
	C450.055328,645.749207 448.758911,648.439636 438.511475,649.957947 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M735.056030,565.543091 
	C729.590088,570.638855 723.539856,575.355347 716.814209,580.237427 
	C716.039307,577.390625 715.965515,574.280518 712.946716,572.557495 
	C710.303650,571.048950 709.704224,568.405273 709.093933,565.920105 
	C707.835571,560.796326 710.916321,557.721985 716.115417,558.337097 
	C721.904846,559.022095 726.115967,562.592651 731.266968,565.900513 
	C732.673096,565.291260 733.508911,565.036499 735.056030,565.543091 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M385.410919,744.976440 
	C383.648895,739.575806 386.804474,737.525024 390.281647,736.296326 
	C394.188293,734.915955 398.266144,732.472534 402.544525,734.948303 
	C406.507996,737.241760 407.050140,743.997070 403.509399,746.903564 
	C401.764130,748.336243 399.502258,749.127930 397.513153,750.277161 
	C389.261505,755.044617 389.266998,755.054138 385.410919,744.976440 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M273.494385,1194.730225 
	C273.481812,1187.945312 277.294952,1185.068359 282.143890,1183.030640 
	C284.947693,1181.852661 288.077911,1181.046265 290.567657,1183.165161 
	C293.211548,1185.415161 290.783508,1188.080811 290.096130,1190.430054 
	C288.446960,1196.066162 287.337372,1202.003784 280.791901,1204.672485 
	C277.891663,1205.855225 276.506989,1204.748169 274.528503,1202.373291 
	C272.013031,1200.076172 271.983002,1197.848633 273.494385,1194.730225 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M99.374176,1187.056152 
	C105.958138,1197.346191 103.481972,1206.493530 93.684937,1210.865234 
	C91.409607,1211.880615 89.810951,1210.907593 88.806305,1208.986938 
	C84.343376,1200.455688 89.028984,1190.005493 99.374176,1187.056152 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M119.811913,1116.173828 
	C123.214172,1114.236450 126.030090,1113.283325 128.622726,1115.832642 
	C131.381989,1118.545532 135.056854,1120.650146 135.758240,1124.923584 
	C136.223267,1127.757080 135.437286,1130.545410 132.474335,1131.293457 
	C128.390549,1132.324341 124.137817,1132.781494 119.928558,1133.174805 
	C118.140564,1133.341919 116.708870,1131.819580 116.543045,1130.174438 
	C116.064178,1125.423706 114.255157,1120.308105 119.811913,1116.173828 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M166.378311,1030.008423 
	C176.457108,1031.206055 181.366516,1036.009888 181.630600,1044.331177 
	C181.748108,1048.033569 179.653763,1050.313843 176.095932,1049.498047 
	C171.009247,1048.331543 165.528198,1047.238281 163.904465,1040.820190 
	C163.340927,1038.592651 162.102768,1036.544434 161.312714,1034.363647 
	C159.745422,1030.037598 162.880539,1030.209839 166.378311,1030.008423 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M395.226440,729.386353 
	C387.004333,732.485352 382.625763,731.697510 380.997955,727.307922 
	C379.303345,722.738220 384.259552,715.383240 390.209259,714.377563 
	C393.959534,713.743591 398.269653,712.728943 401.012177,716.825317 
	C403.313873,720.263123 401.663116,723.974243 395.226440,729.386353 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M493.699036,826.148987 
	C490.333191,825.293335 487.639252,824.278564 484.635132,823.853333 
	C480.444580,823.260315 476.311951,818.259644 476.140564,814.415283 
	C475.933441,809.769897 479.232758,807.242371 482.475189,805.111877 
	C485.980957,802.808289 491.629852,806.411316 493.615082,811.949707 
	C494.481781,814.367493 493.441559,817.283386 496.098633,819.884888 
	C497.210968,822.760864 495.851746,824.400208 493.699036,826.148987 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M286.500183,783.756348 
	C281.143158,782.386292 278.754028,778.701477 276.821381,774.882385 
	C275.469360,772.210754 275.171875,769.005310 277.668518,766.598022 
	C279.707123,764.632507 282.192719,764.034119 284.971039,765.374268 
	C286.145325,765.940674 287.547913,766.019592 288.755188,766.534668 
	C292.449646,768.110901 296.694580,769.676086 295.753876,774.759766 
	C294.912964,779.304077 293.508270,784.046814 286.500183,783.756348 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M473.029175,623.251099 
	C483.322876,618.308289 489.907867,621.003601 491.683594,630.066101 
	C492.536377,634.418457 490.661011,637.165344 486.330566,637.906738 
	C477.152374,639.478027 472.289764,634.525879 473.029175,623.251099 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M542.086975,599.980042 
	C536.249084,597.952820 532.099915,593.308289 532.687378,589.646362 
	C533.360962,585.447266 535.854980,582.254089 540.079956,581.120667 
	C544.556641,579.919678 547.713867,582.263123 549.890503,585.939941 
	C552.018433,589.534546 553.154053,593.262695 549.911072,596.943726 
	C548.036621,599.071350 545.711487,600.101746 542.086975,599.980042 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M453.581329,604.339966 
	C455.973541,605.518921 457.761810,606.445679 459.254211,607.719238 
	C464.940674,612.571716 465.144867,616.079285 460.184753,620.786804 
	C455.893585,624.859314 449.883698,623.963623 445.825287,618.646606 
	C442.540283,614.342834 443.471252,609.102966 448.257019,605.997070 
	C449.598694,605.126343 451.303345,604.814941 453.581329,604.339966 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M132.542130,1158.531128 
	C137.365051,1154.994995 141.025848,1155.219727 143.912216,1159.936523 
	C146.677551,1164.455322 146.431335,1169.288574 143.215088,1172.734741 
	C140.551819,1175.588379 134.532043,1176.890747 131.305801,1175.308350 
	C129.361069,1174.354736 128.392639,1172.727417 128.133850,1170.635254 
	C127.581810,1166.172119 128.101791,1162.058228 132.542130,1158.531128 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M158.204224,1013.229919 
	C157.954132,1009.760315 157.995026,1007.149719 160.909012,1005.670593 
	C163.869431,1004.168091 166.979385,1002.911194 170.265701,1002.863770 
	C172.507950,1002.831421 173.685547,1004.906738 173.757767,1006.979919 
	C173.942490,1012.282043 174.295929,1017.423462 176.877502,1022.312866 
	C178.164429,1024.750244 175.751556,1026.630859 173.942200,1025.403687 
	C168.617371,1021.792114 161.357086,1020.711609 158.204224,1013.229919 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M708.616577,418.454102 
	C706.611267,415.683105 704.485596,417.138245 702.667236,416.880066 
	C696.843933,416.053314 692.192078,409.964783 692.723572,404.113556 
	C692.937317,401.759796 694.560852,400.768524 696.611633,400.245209 
	C702.832947,398.657776 707.605957,401.790009 711.915466,405.450317 
	C715.800232,408.749878 713.261902,412.765472 712.091431,417.243622 
	C711.236877,418.782990 710.314575,419.087769 708.616577,418.454102 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M408.751129,802.239380 
	C414.469269,801.588196 418.695374,802.162415 420.835693,807.664368 
	C422.886993,812.937439 419.886566,817.244446 418.515808,821.795837 
	C417.934998,823.724304 415.453949,824.162659 413.370056,823.373657 
	C409.224182,821.803833 403.344757,810.110596 404.529968,805.698792 
	C404.981171,804.019165 406.358582,803.017761 408.751129,802.239380 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M102.126831,1334.186523 
	C102.257278,1331.692017 102.950691,1330.208374 104.139725,1328.981323 
	C106.896484,1326.136841 109.379242,1322.658447 114.228874,1325.173828 
	C118.638718,1327.460815 120.250481,1331.232788 119.870895,1335.879028 
	C119.564987,1339.623291 118.600967,1343.262695 113.970161,1343.865479 
	C109.378326,1344.463013 105.264786,1343.831055 103.419136,1338.707153 
	C102.972076,1337.466187 102.566063,1336.210205 102.126831,1334.186523 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M346.161255,884.494873 
	C342.672363,886.367493 339.649872,886.310425 336.746643,885.684509 
	C331.361115,884.523315 331.819916,880.083740 332.127991,876.156006 
	C332.539398,870.911194 335.872284,868.183105 341.474274,868.031250 
	C345.302551,867.927429 349.048462,868.252258 349.757507,873.070312 
	C350.343964,877.055725 350.448883,881.070129 346.161255,884.494873 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M635.605591,383.746399 
	C633.359985,388.664185 628.962402,388.743103 625.326477,389.627136 
	C620.851074,390.715332 616.986267,388.061462 616.128601,384.335236 
	C614.921753,379.091736 616.827148,375.321899 621.759644,373.194275 
	C626.978699,370.943054 630.306763,371.586212 632.757568,375.762878 
	C634.064331,377.989807 634.762756,380.573669 635.605591,383.746399 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M228.000305,1179.999390 
	C229.797241,1178.573975 231.511887,1177.026611 233.411224,1175.755127 
	C235.800201,1174.155762 238.091766,1171.760620 241.381119,1173.093140 
	C244.181274,1174.227661 246.353317,1181.042236 245.985001,1185.490356 
	C245.679703,1189.177490 243.288910,1190.584351 240.367798,1191.497559 
	C231.559967,1194.250977 228.337967,1191.667603 227.998383,1180.864502 
	C227.997559,1180.000000 228.000000,1180.000000 228.000305,1179.999390 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M152.172150,1177.843506 
	C156.912857,1172.291138 163.950577,1170.380493 168.854980,1172.763916 
	C171.650940,1174.122559 173.657486,1176.273071 173.848953,1179.633789 
	C174.050034,1183.163208 171.958755,1184.993164 169.071457,1186.426880 
	C161.612793,1190.130371 157.133942,1188.104492 152.172150,1177.843506 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M45.539574,1250.062256 
	C50.966999,1250.808838 55.206940,1252.877441 55.146336,1257.869385 
	C55.088161,1262.661011 52.090023,1266.660889 47.000607,1267.915039 
	C44.407379,1268.553955 42.796806,1271.226929 38.995316,1270.913086 
	C37.025620,1265.828369 37.976940,1260.274048 38.327972,1254.883423 
	C38.562279,1251.285400 41.416103,1250.109985 45.539574,1250.062256 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M182.875458,936.853333 
	C193.672318,930.926514 196.740402,931.407410 201.462845,939.059204 
	C204.771835,944.420715 202.848724,948.712769 196.612976,949.882935 
	C188.635025,951.380127 184.567795,947.809204 182.875458,936.853333 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M617.746094,442.066284 
	C626.028931,446.676941 627.853333,451.739838 623.902100,456.985229 
	C620.268799,461.808685 615.470764,463.245789 612.018921,460.544464 
	C607.781494,457.228271 606.703247,449.220734 609.987549,445.195007 
	C611.773621,443.005676 614.092651,441.898010 617.746094,442.066284 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M388.666595,871.975830 
	C381.310638,878.991028 376.204254,878.583801 372.883698,871.169678 
	C371.306122,867.647156 371.502258,864.071167 374.215149,860.919739 
	C376.985809,857.701294 380.661591,857.679321 384.319672,858.186340 
	C388.387970,858.750366 389.304016,862.135132 389.852264,865.493530 
	C390.173218,867.459534 390.055511,869.478760 388.666595,871.975830 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M486.814728,598.923584 
	C489.087463,597.014771 491.011444,595.756897 492.944031,594.512390 
	C500.086487,589.912964 503.627441,592.931396 506.771088,599.759766 
	C508.731354,604.017700 506.297668,608.528076 501.772797,609.680786 
	C496.121948,611.120483 488.373535,606.006409 486.814728,598.923584 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M378.218323,794.674194 
	C379.904449,789.705261 381.624786,785.945557 387.175415,785.962952 
	C392.895996,785.980835 396.556488,789.692444 395.781464,795.284790 
	C395.123810,800.030334 388.311127,805.902405 383.657959,805.277283 
	C377.794342,804.489624 377.703705,800.021118 378.218323,794.674194 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M97.631577,1111.945068 
	C94.195847,1111.957886 91.430321,1112.248779 89.849876,1109.378906 
	C88.416107,1106.775391 86.739586,1104.274292 86.304985,1101.239014 
	C86.259750,1100.923218 86.343445,1100.582275 86.401321,1100.259277 
	C86.921547,1097.356201 94.708702,1093.583252 98.932396,1094.183228 
	C103.336494,1094.808838 106.703659,1099.151245 105.662125,1103.537720 
	C104.741142,1107.416504 103.342461,1111.298706 97.631577,1111.945068 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M659.593140,502.348511 
	C668.340393,505.196503 667.208069,512.648193 669.323181,518.605896 
	C657.044189,521.258423 652.042053,519.838562 650.284241,513.495544 
	C648.585571,507.365662 650.245361,505.184631 659.593140,502.348511 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M52.711952,1123.788574 
	C50.447220,1122.918823 48.683323,1122.466553 47.548096,1121.365845 
	C43.954983,1117.881714 42.772099,1111.708252 45.117901,1108.630493 
	C48.064175,1104.765137 52.423550,1105.491333 56.126728,1106.569214 
	C60.946262,1107.971924 62.176914,1112.096191 62.026478,1116.893921 
	C61.844807,1122.687866 58.606827,1124.325684 52.711952,1123.788574 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M615.973755,407.944824 
	C613.847778,415.420105 611.736816,416.884918 605.700684,415.920105 
	C600.953552,415.161346 596.124023,410.130646 596.155029,405.967743 
	C596.167847,404.250153 596.562561,402.574097 598.031555,401.600983 
	C602.255371,398.803040 606.986694,399.891907 611.480957,400.412476 
	C615.078125,400.829163 615.931946,403.878021 615.973755,407.944824 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M80.689705,1218.559448 
	C85.061440,1220.175781 87.558578,1222.327393 88.455765,1226.426147 
	C89.450729,1230.971436 87.372406,1235.506714 82.764763,1237.354004 
	C78.770676,1238.955322 75.626991,1237.307983 73.355614,1232.613037 
	C72.308243,1230.448242 72.034958,1228.214600 71.997314,1225.868774 
	C71.889229,1219.132202 72.154411,1218.854492 80.689705,1218.559448 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M191.651337,1056.396118 
	C189.422897,1052.490845 189.720047,1049.430298 192.377563,1046.780640 
	C194.999054,1044.166748 198.089783,1042.281372 201.888535,1042.192993 
	C204.907608,1042.122803 209.570328,1048.201904 209.617264,1052.370850 
	C209.665604,1056.664673 206.896774,1059.027344 203.053574,1059.724487 
	C199.159500,1060.430908 195.122299,1060.536133 191.651337,1056.396118 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M160.137634,1108.033691 
	C164.308044,1093.662842 164.909866,1093.515259 174.877609,1103.907959 
	C176.453705,1105.551392 178.197220,1107.195801 179.220612,1109.172363 
	C181.064148,1112.733154 179.361145,1115.337402 175.215546,1115.937622 
	C167.018433,1117.124390 164.214828,1115.798706 160.137634,1108.033691 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M265.564941,983.672974 
	C267.212982,981.927856 268.229187,980.515198 269.600555,979.699890 
	C274.894897,976.552612 280.939209,978.003235 283.120819,982.765564 
	C284.456543,985.681396 280.987366,994.082581 277.840118,995.553589 
	C273.473663,997.594482 267.793640,995.384766 265.438965,990.794189 
	C264.337036,988.645874 263.733398,986.529968 265.564941,983.672974 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M233.816864,860.622375 
	C234.029633,849.219604 238.195236,844.808899 246.312805,846.063660 
	C250.364700,846.689941 251.914017,849.047363 251.962402,852.867126 
	C252.075607,861.803223 243.334259,865.929871 233.816864,860.622375 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M449.684204,695.906250 
	C441.693756,694.613892 439.059235,691.234680 440.193359,684.838806 
	C441.174133,679.307800 446.084991,675.554443 451.586456,676.109375 
	C453.297485,676.282043 454.748444,676.742859 455.549500,678.501648 
	C457.737030,683.304382 455.308746,691.754517 449.684204,695.906250 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M637.217041,503.226349 
	C635.692505,504.100525 634.829712,504.626617 633.899963,504.973175 
	C628.865295,506.850128 625.627380,504.504364 623.251282,500.311951 
	C620.546692,495.539642 623.915283,492.825958 626.951843,490.244873 
	C630.303528,487.395905 637.364075,487.037659 639.927124,489.545349 
	C643.618042,493.156525 641.543213,496.877472 639.689026,500.460999 
	C639.241882,501.325317 638.470276,502.021759 637.217041,503.226349 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M47.649746,1400.296753 
	C46.008652,1406.123169 42.912334,1409.764404 37.161449,1409.897705 
	C33.406513,1409.984741 29.618622,1409.211548 28.331703,1405.005371 
	C26.994421,1400.634644 29.272959,1397.390381 32.459171,1394.567383 
	C35.588802,1391.794556 38.852379,1391.052612 42.341457,1393.631836 
	C44.471828,1395.206543 46.418453,1397.051147 47.649746,1400.296753 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M486.109436,712.676025 
	C490.439331,714.570129 491.940491,717.487427 492.047119,721.534668 
	C492.228790,728.427673 485.918518,733.520874 479.212616,731.800964 
	C475.666382,730.891479 476.536224,727.759216 475.516266,725.529053 
	C473.894897,721.983948 474.672394,718.861389 477.489685,716.671326 
	C479.779724,714.890930 482.716614,713.942444 486.109436,712.676025 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M398.868164,777.143982 
	C392.899109,768.362061 392.834534,765.965759 397.792511,761.243042 
	C401.882263,757.347168 405.597687,757.033447 409.143250,760.284546 
	C412.676025,763.523865 413.206848,769.212280 409.933868,772.815186 
	C407.228363,775.793457 403.962372,778.097717 398.868164,777.143982 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M62.628834,1353.014282 
	C59.118454,1343.804077 61.494041,1338.453369 69.158195,1336.600586 
	C71.260986,1336.092163 73.048439,1336.370483 74.487297,1338.049316 
	C77.650703,1341.739990 76.403938,1353.674194 72.470879,1356.263794 
	C68.439896,1358.917603 65.824211,1355.821533 62.628834,1353.014282 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M117.486496,1013.739319 
	C111.613060,1011.450012 107.795105,1006.313904 108.366585,1002.275940 
	C109.049393,997.451294 112.730606,994.690491 116.636017,993.227539 
	C120.827156,991.657593 121.310547,996.872009 123.583984,998.849304 
	C126.721504,1001.578064 126.824722,1005.211548 124.202835,1008.563782 
	C122.584579,1010.632690 120.767792,1012.576355 117.486496,1013.739319 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M140.357391,1139.735596 
	C140.911545,1134.608887 144.462753,1132.287354 147.469711,1129.859985 
	C151.686462,1126.456177 157.835281,1127.699341 160.635880,1131.901855 
	C161.852646,1133.727539 162.168320,1135.627075 160.994217,1137.496826 
	C158.335342,1141.731323 153.842407,1143.521362 149.491272,1144.949707 
	C145.568924,1146.237427 142.596191,1143.752808 140.357391,1139.735596 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M364.462891,884.255920 
	C369.057312,883.876343 371.596497,885.878662 373.197815,889.049622 
	C375.407501,893.425354 373.817017,899.951477 370.380280,901.450867 
	C366.151489,903.295837 360.333710,901.657288 358.067291,897.983093 
	C354.765747,892.630798 355.538025,889.238098 360.964111,885.607056 
	C361.780609,885.060669 362.777679,884.784119 364.462891,884.255920 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M309.923767,752.028687 
	C306.271027,757.308838 302.166992,756.654602 298.372009,753.827576 
	C294.502777,750.945312 295.638153,746.642578 296.898193,742.955750 
	C298.184662,739.191528 305.165253,735.312683 308.220490,736.519958 
	C311.338989,737.752197 314.267609,739.681824 312.953888,743.921692 
	C312.175385,746.434143 311.171417,748.876770 309.923767,752.028687 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M273.199341,1193.894531 
	C274.000366,1196.133423 274.000732,1198.266724 274.001770,1201.200073 
	C269.579834,1207.746826 263.458527,1206.432495 257.788086,1205.367554 
	C254.474335,1204.745361 252.177048,1201.909790 252.225082,1198.142090 
	C252.279526,1193.870972 255.663437,1192.803223 258.908783,1192.263306 
	C263.480469,1191.502808 268.062164,1191.869751 273.199341,1193.894531 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M339.457336,740.102356 
	C338.656982,737.843323 338.054596,736.239075 338.066925,734.639587 
	C338.121063,727.603699 340.190125,725.657166 346.885437,726.027161 
	C352.112274,726.315918 355.678406,730.081116 355.312683,734.924744 
	C354.815674,741.507263 351.026550,744.724121 344.887482,743.808228 
	C342.788086,743.495056 341.313995,742.219788 339.457336,740.102356 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M719.725952,534.349365 
	C725.581787,537.701782 724.498779,542.484436 723.141541,546.820679 
	C722.111755,550.110718 719.189392,551.842041 715.473633,551.979797 
	C711.376099,552.131714 708.368286,550.431152 706.742188,546.820374 
	C704.980835,542.909546 706.686951,539.752930 709.891968,537.410645 
	C712.558838,535.461609 715.436096,533.841248 719.725952,534.349365 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M498.577820,724.910645 
	C496.674164,721.593628 495.988251,718.789368 495.962402,715.688232 
	C495.933319,712.196167 497.436523,710.112122 500.557220,708.819885 
	C505.037231,706.964844 508.074005,709.060669 511.131287,712.064392 
	C513.779419,714.666199 513.636108,717.068420 511.979431,720.053101 
	C508.415192,726.474487 504.980316,728.016968 498.577820,724.910645 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M345.911072,1131.264282 
	C345.855225,1134.372803 346.447418,1136.844849 344.530334,1139.528687 
	C334.857605,1142.293945 331.979950,1141.163818 329.156433,1134.175781 
	C326.530792,1127.677368 329.014404,1124.108765 336.049988,1123.989014 
	C340.914764,1123.906128 344.252350,1125.822021 345.911072,1131.264282 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M726.318726,411.378906 
	C724.500000,412.003357 723.000000,412.003052 720.750000,412.003845 
	C717.534729,410.343872 717.759521,407.331512 716.561707,405.026703 
	C714.782471,401.602844 712.079712,397.874420 717.093750,394.716400 
	C721.728760,391.797058 726.488098,391.662567 728.913940,394.345337 
	C732.301392,398.091705 732.700806,402.714050 729.858154,406.989807 
	C728.950562,408.354980 727.720093,409.505463 726.318726,411.378906 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M707.520203,418.542908 
	C708.888916,417.997772 709.777771,417.998016 711.333374,417.997345 
	C712.938416,418.632263 713.876831,419.268066 715.407654,419.950104 
	C716.000793,423.426178 716.001587,426.855988 716.003662,431.142944 
	C713.686584,433.754822 711.540344,435.830841 709.008728,437.187469 
	C705.405579,439.118256 701.550232,437.399811 700.324646,433.776672 
	C698.200562,427.497253 700.565979,422.323547 707.520203,418.542908 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M556.623047,708.033325 
	C555.722534,709.159424 555.286316,709.649109 554.833862,710.123230 
	C551.641785,713.467712 548.123291,715.821655 543.774231,712.208801 
	C540.773132,709.715759 540.190552,701.961426 542.330444,698.495850 
	C544.828674,694.449768 548.775269,696.282837 552.143555,696.159729 
	C555.034790,696.054077 557.135864,697.646667 557.718201,700.665649 
	C558.158020,702.946167 558.144165,705.229736 556.623047,708.033325 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M388.795288,650.607666 
	C390.582092,646.219849 392.861969,643.767639 397.287048,644.013245 
	C401.180969,644.229431 403.603455,645.868103 403.900055,649.917114 
	C404.045532,651.903442 404.090851,653.912659 403.972046,655.899048 
	C403.797760,658.812805 404.722137,661.874817 402.519348,665.309509 
	C396.431244,661.991577 388.985870,660.425171 388.795288,650.607666 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M772.508667,402.905518 
	C779.469116,406.113983 781.925537,411.529633 779.292419,416.645813 
	C777.473145,420.180542 774.006775,421.420227 770.308167,421.813324 
	C767.837769,422.075867 765.427002,421.156891 764.785156,418.651520 
	C763.741821,414.579071 762.534973,410.131470 765.864746,406.570343 
	C767.355469,404.976166 769.795410,404.269653 772.508667,402.905518 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M362.000580,1111.178467 
	C361.062347,1112.635132 360.123444,1113.270386 358.592285,1113.952759 
	C356.008057,1113.975220 353.993500,1114.132690 352.028870,1113.888306 
	C347.847534,1113.368164 344.114197,1112.156494 344.042816,1106.880127 
	C343.992035,1103.125244 343.987152,1099.446777 348.748962,1098.245117 
	C353.664948,1097.004517 358.892090,1098.762085 361.002869,1102.551636 
	C362.373718,1105.012573 361.889893,1107.726440 362.000580,1111.178467 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M326.093933,1169.242676 
	C322.572083,1170.000000 319.142212,1170.000000 314.855103,1170.000000 
	C313.955750,1167.223755 312.264557,1165.039673 311.358002,1162.572266 
	C309.664978,1157.964600 310.929504,1154.665527 314.963013,1152.775879 
	C318.738831,1151.006958 323.283783,1152.098999 325.580780,1155.318604 
	C328.620392,1159.578979 328.203918,1163.994507 326.093933,1169.242676 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M96.715111,1219.078125 
	C97.913826,1217.380249 98.673523,1216.247925 99.675491,1215.403198 
	C104.720284,1211.149902 109.232857,1210.800903 111.621094,1214.380859 
	C115.110558,1219.611450 114.444153,1225.701538 110.066505,1228.587769 
	C105.380920,1231.677368 99.281693,1229.999634 96.682602,1224.627075 
	C96.030113,1223.278320 96.456985,1221.407349 96.715111,1219.078125 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M151.244797,1215.662476 
	C148.490402,1218.091919 145.847565,1218.255737 143.209763,1217.826416 
	C139.783493,1217.269043 137.584946,1215.545288 139.268005,1211.713867 
	C140.455276,1209.011108 141.719574,1206.262207 143.442490,1203.892456 
	C146.340881,1199.906006 152.396835,1198.771851 155.688141,1201.227417 
	C158.842697,1203.580933 158.474472,1207.625488 154.603165,1212.348145 
	C153.771805,1213.362305 152.749268,1214.219727 151.244797,1215.662476 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M65.755096,1301.411987 
	C64.560623,1305.541992 62.641842,1308.162354 59.158493,1309.238403 
	C55.902180,1310.244263 52.432373,1310.882812 49.808098,1308.121582 
	C46.956360,1305.120972 47.618263,1301.195435 48.617249,1297.716919 
	C49.618126,1294.231812 52.893494,1294.003906 56.009880,1294.007690 
	C60.786770,1294.013672 65.802986,1293.621094 65.755096,1301.411987 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M463.054688,878.761536 
	C464.560059,875.735779 465.884369,873.451599 467.285187,870.633606 
	C468.248352,868.750549 469.134979,867.401306 470.124207,865.459167 
	C470.401123,864.507446 470.575470,864.148560 471.534241,864.075867 
	C472.068970,866.330322 472.344879,868.570374 471.489075,870.225159 
	C461.931976,888.705017 452.200195,907.094482 441.973083,925.749146 
	C441.265259,925.678345 441.099792,925.366699 440.791504,924.546326 
	C443.322021,918.594666 445.995361,913.151794 448.820740,906.999268 
	C449.568054,905.338074 450.163330,904.386414 450.852325,902.869385 
	C454.921906,894.703735 458.897766,887.103394 463.054688,878.761536 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M482.127441,738.140625 
	C492.399078,733.292297 498.263580,736.248230 497.947998,745.291931 
	C497.788910,749.851318 495.726349,751.766663 491.173798,751.992859 
	C487.428375,752.178955 485.071472,750.057861 482.671967,747.667786 
	C479.874603,744.881531 479.610779,741.989319 482.127441,738.140625 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M72.760880,1381.126953 
	C75.103287,1377.790405 78.357018,1377.757690 81.067520,1376.680176 
	C83.655014,1375.651611 86.291115,1375.693237 88.058212,1378.500122 
	C89.726028,1381.149292 90.970505,1384.164185 89.164276,1386.895752 
	C87.098442,1390.019897 85.288750,1394.037354 80.092430,1393.026611 
	C73.685333,1391.780396 72.454254,1390.147583 72.760880,1381.126953 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M331.156311,1010.718262 
	C334.028168,1011.952698 335.747925,1013.365295 336.731415,1015.614990 
	C338.297913,1019.198486 336.693939,1024.916870 333.493195,1026.954956 
	C330.516266,1028.850586 324.589050,1027.575806 321.783142,1024.323730 
	C318.889069,1020.969666 319.942291,1017.534485 322.046326,1014.357239 
	C323.986755,1011.426941 326.823669,1009.953003 331.156311,1010.718262 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M190.127319,1088.562744 
	C178.541916,1090.003052 173.978256,1085.475830 176.089050,1075.814941 
	C176.580521,1073.565430 177.684616,1072.330078 180.000504,1072.188232 
	C184.528214,1071.911011 192.751312,1077.894653 193.619003,1082.194214 
	C194.154633,1084.848267 192.430359,1086.493164 190.127319,1088.562744 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M235.980347,1072.061768 
	C235.945770,1077.755615 233.671188,1080.624268 228.635834,1079.674072 
	C224.371140,1078.869019 220.268005,1076.982666 218.740372,1072.426392 
	C217.798492,1069.617188 222.369598,1063.536621 225.719040,1062.431885 
	C230.561035,1060.834839 233.745132,1063.570801 235.980347,1072.061768 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M57.876823,1183.971436 
	C54.205326,1191.276489 48.969017,1194.863403 45.290485,1193.347778 
	C42.202644,1192.075195 40.525642,1182.902466 42.483376,1177.819824 
	C43.444725,1175.323975 45.102108,1174.177979 47.884842,1175.014282 
	C52.377567,1176.364380 56.910381,1177.599487 57.876823,1183.971436 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M568.081665,525.289429 
	C567.666687,525.998230 567.333313,525.998840 566.500000,525.999756 
	C562.520569,526.029114 558.969482,525.664734 558.357056,521.459351 
	C557.798828,517.625854 556.947449,513.491333 559.576660,509.969788 
	C562.053406,506.652527 567.539673,505.485657 570.089050,507.531097 
	C573.452698,510.229889 574.383545,515.357483 571.943420,518.894714 
	C570.649536,520.770447 568.588196,522.122864 568.081665,525.289429 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M176.710602,1272.312500 
	C176.459625,1270.430298 176.928436,1268.862671 177.381348,1267.290527 
	C179.571793,1259.687256 184.592270,1256.646606 193.172958,1258.000000 
	C196.084167,1272.632446 192.143600,1276.108398 176.710602,1272.312500 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M262.653198,832.009766 
	C261.062408,833.793213 260.077179,835.236816 258.718231,836.073608 
	C255.856339,837.835938 253.001801,841.656677 249.330597,837.776001 
	C245.340683,833.558533 246.010498,827.242615 250.403000,823.947571 
	C250.664337,823.751587 250.954117,823.581360 251.252701,823.448792 
	C254.429901,822.038635 257.311340,819.113342 261.227936,821.748596 
	C265.136292,824.378113 264.187866,827.849792 262.653198,832.009766 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M506.122437,635.299927 
	C505.110931,635.998352 504.221832,635.999146 502.665955,635.999878 
	C498.886322,631.812561 495.477783,627.799622 494.434357,622.446106 
	C493.739624,618.881775 494.086243,615.595337 498.064911,614.460754 
	C501.770691,613.403992 505.098938,613.637573 506.478729,618.520447 
	C508.025146,623.993103 511.924896,629.302551 506.122437,635.299927 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M145.964478,1097.950562 
	C142.724670,1102.581543 139.233093,1103.173462 135.599747,1099.936523 
	C133.247742,1097.841064 133.398102,1090.947632 135.484436,1087.865234 
	C137.221634,1085.298584 139.811569,1083.805298 142.626373,1082.847900 
	C147.382584,1081.230347 150.447800,1083.962402 149.320068,1088.943481 
	C148.674606,1091.794312 147.340393,1094.489258 145.964478,1097.950562 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M786.294983,533.424316 
	C784.710327,534.280945 783.660034,534.744446 782.281006,535.695190 
	C781.533203,536.386047 781.114136,536.589783 780.156982,536.347656 
	C776.237549,531.784607 772.962708,527.666809 774.070129,521.743530 
	C775.002991,516.753845 779.245605,514.439575 783.556030,517.123535 
	C787.270081,519.436218 790.218018,522.607239 790.381042,528.312500 
	C790.527893,529.145447 790.379517,530.030273 790.280090,530.467712 
	C788.992065,531.501160 787.856018,532.179993 786.294983,533.424316 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M83.417786,1243.612061 
	C84.702377,1242.408936 85.354630,1241.556885 86.217216,1241.120361 
	C89.350578,1239.535278 92.426582,1236.375488 96.144386,1239.664185 
	C99.510239,1242.641479 96.819733,1245.859619 95.981133,1248.884277 
	C94.807190,1253.118286 92.207710,1255.978760 87.474701,1255.836304 
	C80.700172,1255.632568 79.082031,1251.414551 83.417786,1243.612061 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M335.999939,841.191528 
	C330.950134,842.262451 326.034546,841.989990 321.855164,838.602112 
	C318.099854,835.558105 316.995453,831.115112 319.299316,828.197998 
	C321.361145,825.587341 326.771179,825.200378 330.259064,827.563293 
	C334.781952,830.627258 336.802063,834.893677 335.999939,841.191528 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M273.383423,1165.561890 
	C275.634552,1165.954102 277.273956,1165.979492 278.902313,1165.857300 
	C281.616852,1165.653564 284.627380,1162.976318 286.892029,1166.501953 
	C288.930511,1169.675659 287.576355,1172.724854 286.093048,1175.763062 
	C284.393158,1179.244873 281.578918,1180.223267 278.013885,1179.925415 
	C273.936432,1179.584595 271.346893,1177.308472 270.335358,1173.489746 
	C269.845001,1171.638428 270.088043,1169.593140 269.998291,1166.817871 
	C270.791992,1165.300781 271.715057,1165.010254 273.383423,1165.561890 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M61.399723,1375.479492 
	C59.154804,1377.028320 57.546490,1378.278931 55.726799,1378.983398 
	C52.611126,1380.189575 48.896683,1381.365234 46.772694,1377.916748 
	C44.952717,1374.961914 46.006207,1371.456299 47.932659,1368.525391 
	C50.437229,1364.714844 57.009026,1362.428833 60.157894,1364.750000 
	C63.675476,1367.342896 65.269958,1370.858521 61.399723,1375.479492 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M528.515747,692.205872 
	C527.365051,693.541626 526.694275,694.275513 525.986755,694.972107 
	C523.455017,697.464539 520.429199,699.333923 517.236816,696.819336 
	C514.178528,694.410461 513.407837,690.810547 514.673157,686.920898 
	C516.274292,681.998779 519.255310,679.581787 523.141785,680.219238 
	C527.827942,680.987854 529.626282,684.490173 528.515747,692.205872 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M74.703400,1134.835693 
	C73.416847,1129.751831 74.166245,1126.264893 78.970734,1124.647217 
	C83.494820,1123.124146 86.754204,1124.908813 89.084633,1128.597290 
	C90.431870,1130.729492 92.482666,1133.009277 90.727028,1135.824463 
	C89.064903,1138.489380 86.634277,1139.917480 83.326447,1140.000000 
	C79.621483,1140.092407 77.019386,1138.486450 74.703400,1134.835693 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M22.806828,1348.860840 
	C31.070549,1350.593750 33.907379,1355.071777 31.657213,1361.819336 
	C30.702017,1364.683594 28.924578,1367.569458 25.525604,1367.192993 
	C22.293655,1366.834961 19.011967,1365.281128 18.323380,1361.507690 
	C17.475620,1356.862183 17.541920,1352.281616 22.806828,1348.860840 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M700.588867,548.938904 
	C701.817627,554.252380 700.596497,557.459167 695.396606,557.913452 
	C690.726807,558.321533 687.129028,554.966553 686.263916,549.577209 
	C685.629211,545.623840 688.142883,541.541138 691.919373,540.391479 
	C696.288086,539.061584 698.467651,541.088074 700.588867,548.938904 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M540.089783,467.397400 
	C544.688904,470.745697 543.422180,474.026917 541.238464,477.251617 
	C538.932861,480.656464 535.812012,483.287872 531.596375,483.218445 
	C527.705383,483.154327 525.013123,477.076508 526.709900,473.080231 
	C528.618591,468.584930 533.079834,466.449677 540.089783,467.397400 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M388.259277,817.504150 
	C387.844879,813.856812 389.138092,811.677917 391.274841,809.892700 
	C394.018402,807.600647 396.715027,807.562378 398.958252,810.463745 
	C400.760590,812.794861 402.436890,815.265808 403.842712,817.852112 
	C406.672394,823.058105 404.799774,825.999878 398.938507,825.978027 
	C393.518890,825.957764 390.845673,822.279175 388.259277,817.504150 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M73.715958,1263.894165 
	C71.349434,1263.347656 69.785843,1262.492554 68.189697,1262.426636 
	C61.963249,1262.169922 62.016937,1258.054321 61.932011,1253.421631 
	C61.836693,1248.222046 65.796082,1247.870605 69.061707,1246.670288 
	C71.132240,1245.908936 73.242706,1246.371338 73.663261,1248.876221 
	C74.342171,1252.919800 76.350761,1256.232056 78.318741,1259.718506 
	C80.633202,1263.818604 77.253326,1263.838501 73.715958,1263.894165 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M644.462280,450.346344 
	C643.004150,451.337952 642.140869,451.838867 641.263123,452.313049 
	C638.021240,454.064362 634.884033,454.754486 632.754517,450.785339 
	C630.709045,446.972809 631.940369,440.853638 635.546143,439.516663 
	C638.953918,438.253113 642.951904,434.187958 646.386597,438.209503 
	C649.493896,441.847717 648.639587,446.312622 644.462280,450.346344 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M290.628113,1037.406738 
	C286.972992,1038.079834 284.095642,1038.307983 281.497986,1036.289307 
	C277.675934,1033.319214 277.010895,1028.744141 280.006897,1025.149658 
	C283.119202,1021.415649 287.512360,1021.084595 291.179108,1024.307739 
	C295.835419,1028.400757 295.879486,1032.031372 290.628113,1037.406738 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M125.291847,1233.522339 
	C126.582748,1231.552856 127.299828,1229.894897 128.560806,1229.027344 
	C130.629868,1227.603638 132.881805,1225.563110 135.698776,1227.216187 
	C138.392944,1228.796875 139.882004,1231.198853 139.976059,1234.488892 
	C140.124939,1239.697510 137.594025,1243.553345 133.543716,1243.919067 
	C127.923752,1244.426270 125.151863,1241.283325 125.291847,1233.522339 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M93.890579,1328.665771 
	C97.003036,1332.298950 95.743530,1336.066650 95.946114,1339.627808 
	C96.126900,1342.806030 95.644562,1345.614990 91.458679,1345.935547 
	C87.445587,1346.242920 84.258202,1345.513672 82.741837,1341.222168 
	C80.465759,1334.780518 84.245132,1330.041870 93.890579,1328.665771 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M681.355286,392.182739 
	C680.257263,396.353027 677.924438,398.604492 674.480774,399.475647 
	C670.773315,400.413544 667.181519,400.602020 665.209106,396.242889 
	C663.725708,392.964691 663.194519,389.619263 666.352539,387.224854 
	C669.510620,384.830383 673.076355,382.440521 677.016724,386.126740 
	C678.703186,387.704376 680.549561,389.170197 681.355286,392.182739 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M185.182556,1198.211304 
	C183.932999,1189.071533 184.615906,1186.955933 189.002304,1186.239380 
	C192.799713,1185.619019 196.289612,1185.960083 197.888931,1190.511230 
	C199.518814,1195.149292 198.131042,1200.178345 193.982162,1202.671265 
	C189.476990,1205.378418 187.288925,1202.545166 185.182556,1198.211304 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M296.398560,810.748169 
	C301.331512,806.269470 305.062958,808.965088 308.208618,811.838440 
	C310.907440,814.303711 310.644653,817.983643 309.038544,821.011292 
	C306.913513,825.017090 302.836121,824.057556 299.315948,823.795776 
	C295.796661,823.534058 294.233856,821.194458 294.070526,817.781982 
	C293.957306,815.416870 294.215515,813.178955 296.398560,810.748169 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M78.771255,1312.707275 
	C85.341949,1307.305786 87.874146,1306.949829 90.955612,1310.427490 
	C93.818420,1313.658447 93.884514,1317.910278 91.179543,1321.258179 
	C88.126953,1325.036255 83.748993,1324.844482 80.263374,1323.362671 
	C75.699310,1321.422485 75.901634,1317.285278 78.771255,1312.707275 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M242.124512,1049.918457 
	C235.616974,1046.055908 234.417007,1041.766113 237.827194,1037.384277 
	C240.853302,1033.495972 246.353882,1033.012329 250.028381,1036.311401 
	C252.744141,1038.749634 252.683151,1043.656616 249.880051,1046.958252 
	C248.061554,1049.100098 245.737427,1050.100464 242.124512,1049.918457 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M135.980286,1049.942017 
	C136.618652,1054.355957 140.173630,1058.633423 134.826294,1061.195801 
	C130.491028,1063.273193 128.260651,1059.178589 125.814964,1056.720703 
	C121.531006,1052.415405 120.983032,1048.203247 123.980904,1045.551025 
	C127.478645,1042.456543 132.029053,1043.835815 135.980286,1049.942017 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M223.860596,1119.860107 
	C223.636734,1123.222168 222.114258,1124.787109 219.940628,1125.991455 
	C214.906052,1128.780762 211.778748,1128.490601 209.579712,1124.886841 
	C207.241776,1121.055542 207.603531,1116.220337 210.390625,1114.048096 
	C214.313507,1110.990601 219.600784,1111.493530 222.497040,1115.376221 
	C223.248901,1116.384033 223.415955,1117.828369 223.860596,1119.860107 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M186.204407,1147.420654 
	C186.268417,1157.580811 184.793198,1159.907227 179.115585,1159.946777 
	C174.238480,1159.980713 172.271484,1157.969116 172.026367,1152.697021 
	C171.746841,1146.684082 173.611282,1144.290894 178.699524,1144.038330 
	C181.485931,1143.900024 183.845215,1144.737183 186.204407,1147.420654 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M712.714111,330.669678 
	C713.675354,331.206482 713.988464,331.376587 714.167786,331.638397 
	C716.149292,334.531952 719.283936,337.284302 716.540222,341.184998 
	C714.690247,343.814911 706.918335,344.920135 703.534363,343.412476 
	C701.146606,342.348541 700.239929,340.410431 700.079834,337.919403 
	C699.896362,335.065399 700.588989,332.825470 703.376221,331.394592 
	C706.176331,329.957153 709.023376,329.827820 712.714111,330.669678 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M736.313782,565.761230 
	C734.828552,565.949890 734.016907,565.977539 732.595276,565.998047 
	C732.071960,562.088745 731.879395,558.260803 733.695679,554.481689 
	C735.755615,550.195801 739.713379,549.369019 743.396179,548.831604 
	C746.786865,548.336853 749.776611,550.128113 749.951294,555.077759 
	C746.354126,560.019592 741.313721,562.337769 736.313782,565.761230 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M271.674500,877.677185 
	C264.303680,879.435425 261.405731,878.340820 260.299164,873.592224 
	C259.321594,869.397095 260.369171,865.734558 264.121063,863.224854 
	C266.759308,861.460083 269.115723,862.265259 271.215576,864.300232 
	C274.055603,867.052734 277.457275,869.650208 274.727417,874.322327 
	C274.077850,875.434021 273.158722,876.388245 271.674500,877.677185 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M593.061157,695.432129 
	C591.005310,697.380371 589.300415,698.815613 586.995483,700.552979 
	C585.069214,699.018311 583.721863,697.196289 582.420593,695.341980 
	C578.441833,689.672241 579.557068,685.783386 585.901917,683.130676 
	C591.322754,680.864319 594.648315,681.706482 597.960571,686.947876 
	C597.824219,690.983704 594.989197,692.551575 593.061157,695.432129 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M536.205688,578.199341 
	C533.019958,579.259399 529.780518,581.160950 528.660828,577.718018 
	C527.380127,573.779968 526.636963,569.001709 530.038879,565.569397 
	C532.273499,563.314880 535.349670,561.234924 538.918091,562.850586 
	C542.216675,564.344177 541.934204,567.590881 541.986267,570.575439 
	C542.050171,574.244141 540.904236,577.046875 536.205688,578.199341 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M673.201538,529.895752 
	C673.998108,530.333740 673.998596,530.667480 673.999512,531.501831 
	C675.557434,539.906555 675.159302,541.061584 670.595154,541.880005 
	C664.273499,543.013672 659.260498,540.240295 658.193604,535.019226 
	C657.247314,530.388550 658.977905,528.314026 663.748108,527.997559 
	C666.842346,527.792358 669.575623,528.933350 673.201538,529.895752 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M160.768585,1296.099365 
	C160.294159,1285.475952 160.294159,1285.475952 171.194550,1284.001709 
	C175.279785,1286.201172 179.276611,1288.325073 177.071823,1293.179321 
	C175.015472,1297.706909 170.810684,1298.632324 166.207047,1297.700195 
	C164.613632,1297.377563 163.090927,1296.705933 160.768585,1296.099365 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M713.540771,476.260071 
	C711.748657,473.124786 711.719788,470.611359 713.214355,468.168854 
	C715.284302,464.786072 720.186462,462.861115 723.494263,464.436401 
	C727.255188,466.227417 728.309753,469.657043 727.676941,473.506866 
	C727.038635,477.390076 723.085449,480.119293 718.973511,479.800354 
	C716.872253,479.637329 715.392822,478.320709 713.540771,476.260071 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M269.824402,793.456665 
	C272.979431,791.746765 275.479095,791.714233 277.924988,793.272949 
	C282.743073,796.343567 283.137512,801.486572 278.200958,804.315979 
	C274.797363,806.266663 270.827057,809.667664 266.561890,806.300720 
	C262.935425,803.437866 263.893524,799.817322 269.824402,793.456665 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M94.075729,1037.637085 
	C94.178802,1032.612427 95.732452,1029.216431 99.747650,1027.184814 
	C102.444946,1025.820190 104.767792,1026.094849 107.026726,1028.121704 
	C109.287903,1030.150391 109.702797,1032.168213 108.481880,1035.136230 
	C104.770065,1044.159912 99.793037,1045.395020 94.075729,1037.637085 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M429.832031,588.374451 
	C435.329590,591.390991 434.220276,595.892822 433.505707,599.973755 
	C432.990173,602.917725 430.371582,603.856567 427.495361,603.958923 
	C424.310455,604.072327 421.724792,603.257324 420.152039,600.198547 
	C418.919708,597.801758 417.658813,595.514282 420.030914,593.065979 
	C422.538055,590.478210 424.839569,587.557678 429.832031,588.374451 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M35.608910,1284.032349 
	C34.357929,1288.916626 34.309471,1294.511108 27.365126,1292.698120 
	C23.844448,1291.778809 20.212223,1290.879639 20.076477,1286.126709 
	C19.989410,1283.077759 20.030144,1279.758423 23.461876,1278.755615 
	C27.123959,1277.685059 31.227047,1276.621216 34.134178,1280.669312 
	C34.699116,1281.456055 35.035278,1282.406982 35.608910,1284.032349 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M737.662109,521.357544 
	C736.355591,523.894287 734.604736,524.890381 732.715332,525.398621 
	C727.361328,526.838928 724.550903,524.801575 724.045593,519.336731 
	C723.583679,514.341187 725.986511,509.438782 729.257935,508.702209 
	C732.450317,507.983398 736.297424,511.500366 737.744263,516.687256 
	C738.084595,517.907288 737.837219,519.291321 737.662109,521.357544 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M194.209106,1064.024414 
	C197.228821,1064.546753 199.491623,1064.943848 201.666611,1065.622559 
	C203.665527,1066.246460 207.102142,1065.367798 207.000305,1068.606567 
	C206.912155,1071.410278 206.318619,1074.609131 203.826355,1076.612183 
	C201.546021,1078.444946 198.716599,1078.550171 196.476303,1076.881592 
	C193.870667,1074.940796 191.266617,1072.679199 189.500229,1070.003418 
	C186.707993,1065.773682 189.179718,1064.116821 194.209106,1064.024414 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M233.069702,1261.146484 
	C227.171967,1262.901245 224.246674,1259.988403 222.002106,1255.894775 
	C220.331528,1252.848145 218.911301,1249.682861 222.565842,1247.053711 
	C225.526443,1244.923706 231.270721,1245.881836 233.279251,1249.025269 
	C235.644989,1252.727539 237.748459,1256.703125 233.069702,1261.146484 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M556.535400,537.572327 
	C559.455078,540.697510 561.650452,544.003174 558.532959,546.673706 
	C555.442993,549.320557 550.906372,548.582642 547.247375,547.150635 
	C543.956299,545.862671 542.760437,542.453369 542.405273,539.097717 
	C542.215576,537.305847 543.762085,536.287415 545.269958,535.458618 
	C549.256226,533.267639 552.824158,533.667664 556.535400,537.572327 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M165.186462,1243.997070 
	C167.748550,1249.903320 164.176178,1256.739746 158.543793,1257.816284 
	C156.316940,1258.242065 153.954742,1257.959839 150.825562,1258.000000 
	C150.351883,1246.941772 152.581039,1244.770874 165.186462,1243.997070 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M186.899414,1026.183838 
	C188.325089,1026.031860 189.023117,1025.841187 189.641876,1025.986938 
	C192.897003,1026.753662 196.496628,1021.522522 199.359390,1026.317871 
	C200.595078,1028.387573 195.785965,1037.795044 193.082596,1039.088989 
	C191.954239,1039.629028 190.480469,1039.942017 189.273056,1039.731445 
	C185.299973,1039.038818 184.813293,1035.241821 183.327423,1032.422607 
	C181.689041,1029.314087 183.223877,1027.437866 186.899414,1026.183838 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M375.274475,641.200195 
	C373.075958,646.355530 370.618317,649.466553 365.124908,646.550110 
	C362.313263,645.057495 360.027313,643.416260 360.137177,639.840881 
	C360.241302,636.452515 362.187714,634.230774 364.973358,632.836975 
	C367.947357,631.349060 370.769287,632.016602 373.200073,634.325500 
	C374.982849,636.019043 376.169891,637.905884 375.274475,641.200195 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M87.797852,1075.839355 
	C89.772217,1075.196289 91.020416,1074.433472 92.280144,1074.413940 
	C96.640160,1074.346313 98.919327,1077.104858 99.760666,1080.973267 
	C100.419342,1084.001831 100.145004,1086.970215 96.691010,1088.546753 
	C92.073959,1090.654175 88.946159,1087.875122 86.278412,1084.983398 
	C83.583656,1082.062378 82.425896,1078.633789 87.797852,1075.839355 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M207.635468,844.401855 
	C205.804398,841.535400 206.083099,839.435852 207.768768,837.424194 
	C210.596008,834.050049 215.745911,832.777893 219.395111,835.005554 
	C221.919052,836.546448 224.436783,838.448364 222.822311,842.214355 
	C221.194382,846.011780 216.770584,848.502075 212.207062,847.588867 
	C210.727112,847.292664 209.468964,845.887939 207.635468,844.401855 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M22.828924,1380.723389 
	C26.540039,1377.329102 30.176168,1376.889893 32.707844,1380.465454 
	C35.309521,1384.140137 32.733929,1387.269043 29.945135,1389.830322 
	C28.494955,1391.162109 26.877043,1392.309570 25.366165,1393.577515 
	C23.552458,1395.099731 21.548462,1396.780518 19.310448,1394.853149 
	C17.279461,1393.104004 17.963346,1390.596924 18.902342,1388.434814 
	C19.950258,1386.021851 21.216183,1383.703735 22.828924,1380.723389 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M716.421814,362.347351 
	C713.785156,365.261658 711.247070,367.011597 708.216248,364.772491 
	C705.344727,362.651123 702.293762,360.400726 702.135315,356.241028 
	C701.979675,352.152100 705.132141,349.495697 709.247803,350.229858 
	C713.876709,351.055573 716.955627,355.713776 716.421814,362.347351 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M600.418945,537.436646 
	C599.111084,538.000000 598.222229,538.000000 596.666626,538.000000 
	C595.410217,537.718079 594.789734,537.486206 594.235413,537.146423 
	C588.594604,533.689392 586.882507,530.614563 588.820251,527.470581 
	C590.526306,524.702515 597.945129,522.010864 599.993042,523.416931 
	C603.508911,525.830994 604.226196,531.599243 601.564575,536.220154 
	C601.410095,536.488342 601.084106,536.657837 600.418945,537.436646 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M78.342072,1058.584717 
	C84.921883,1053.640625 88.467476,1053.730469 93.106201,1058.219971 
	C96.158257,1061.173828 95.939690,1063.836060 92.439796,1066.338379 
	C86.585152,1070.524292 80.947105,1067.752808 78.342072,1058.584717 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M581.933105,558.209229 
	C582.036560,561.375122 581.381958,563.470825 579.649231,565.224670 
	C576.157166,568.759399 573.507996,568.481018 571.219910,564.256531 
	C570.908936,563.682373 570.492920,563.086304 570.430054,562.469299 
	C570.037476,558.620422 565.529541,554.507385 570.774170,550.996826 
	C574.035339,548.813904 578.193054,551.363037 581.933105,558.209229 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M514.987610,566.669617 
	C521.383850,568.503906 522.840332,570.582336 521.800415,575.120056 
	C520.966309,578.759827 515.521606,582.353027 511.973907,581.605164 
	C507.813751,580.728149 505.937683,576.481750 507.732971,572.549805 
	C509.085968,569.586487 511.522369,568.130920 514.987610,566.669617 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M189.421844,892.236267 
	C190.071533,897.607788 187.934067,901.222412 184.640015,904.102356 
	C181.292587,907.029053 177.311188,905.868286 176.376144,901.645386 
	C175.680405,898.503113 175.018387,894.785889 177.494324,892.272705 
	C180.874435,888.841797 185.071823,889.228088 189.421844,892.236267 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M68.321594,1268.336426 
	C71.500999,1267.871460 73.591446,1268.799683 75.657242,1269.874146 
	C78.135048,1271.162964 80.159470,1272.756714 79.571602,1275.957642 
	C78.935318,1279.422241 74.702934,1282.121704 70.474037,1281.950928 
	C67.124779,1281.815430 64.693115,1280.511719 64.214172,1276.957397 
	C63.759487,1273.583252 63.854767,1270.297485 68.321594,1268.336426 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M572.636475,416.923828 
	C575.126526,420.163757 577.334717,423.121399 574.232239,426.226135 
	C571.309204,429.151276 567.544006,430.439453 563.333435,429.792450 
	C560.949524,429.426147 560.246216,427.685822 560.080994,425.514038 
	C559.611572,419.343170 563.401245,416.454498 572.636475,416.923828 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M351.195007,656.737305 
	C352.509979,657.317993 353.097046,657.630920 353.699066,657.911682 
	C358.271820,660.044373 358.924530,664.001343 357.340149,667.964600 
	C356.195251,670.828491 352.998627,672.360840 349.825623,671.440125 
	C346.422607,670.452698 344.257324,667.839417 344.100037,664.097656 
	C343.915192,659.699097 344.651825,655.914551 351.195007,656.737305 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M227.434326,1052.508301 
	C224.719025,1056.466919 221.588852,1060.354126 217.651276,1058.521362 
	C214.131332,1056.883057 216.238632,1051.951538 216.131500,1048.492188 
	C215.992218,1043.995361 218.677383,1042.055420 223.043976,1042.056274 
	C227.857391,1042.057129 228.072723,1045.305176 227.966324,1048.816650 
	C227.936462,1049.802246 227.807037,1050.785034 227.434326,1052.508301 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M28.093620,1111.593018 
	C24.637583,1109.948486 22.360008,1107.965820 22.196705,1104.682495 
	C22.056654,1101.866577 20.855679,1098.409180 24.217201,1096.676025 
	C26.618866,1095.437744 29.558218,1095.460449 31.708313,1097.348267 
	C34.220951,1099.554321 36.300694,1102.315552 34.868946,1105.998779 
	C33.789509,1108.775757 32.515854,1111.589111 28.093620,1111.593018 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M400.378052,626.472046 
	C402.235413,622.032776 405.641754,620.734802 409.253418,620.198059 
	C413.145294,619.619507 417.711334,623.291687 417.613708,626.801086 
	C417.491028,631.210205 414.227478,632.040100 410.699432,631.942566 
	C406.635529,631.830200 401.734589,633.261658 400.378052,626.472046 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M129.236053,1298.018066 
	C130.989868,1298.517578 131.979752,1299.039917 133.485718,1299.781250 
	C134.658890,1304.371948 132.864029,1308.358887 131.827240,1312.412598 
	C130.883972,1316.100464 128.315857,1316.592163 125.326126,1314.129028 
	C119.708534,1309.500854 121.157967,1302.088745 129.236053,1298.018066 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M734.217224,383.404297 
	C731.035278,379.856812 731.835876,376.157043 732.360413,372.691467 
	C732.981750,368.586700 736.250122,367.914459 739.825562,368.126129 
	C743.358215,368.335297 743.875732,370.717316 743.981689,373.582031 
	C744.211670,379.800995 742.540894,381.728729 734.217224,383.404297 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M271.968872,1031.031006 
	C271.694122,1041.591675 271.660095,1041.418091 264.692261,1042.784180 
	C261.748199,1043.361328 260.439941,1042.789673 260.050507,1039.760010 
	C259.270538,1033.692139 262.414948,1028.685059 268.311188,1027.069580 
	C271.005249,1026.331421 271.720520,1028.046509 271.968872,1031.031006 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M121.061836,1079.258057 
	C119.637009,1081.127563 118.543365,1082.369141 117.376732,1083.537842 
	C115.639198,1085.278320 113.606209,1086.415527 111.148849,1085.272705 
	C108.777542,1084.169922 108.032433,1081.971436 108.057564,1079.502930 
	C108.094032,1075.920288 107.284798,1071.302612 112.107948,1070.639648 
	C117.418335,1069.909546 120.689972,1073.123535 121.061836,1079.258057 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M194.700531,875.015259 
	C191.591263,872.258850 191.665985,869.241150 192.348328,866.344299 
	C193.065109,863.301270 195.110382,861.029968 198.283463,860.418396 
	C201.455185,859.807190 202.830154,862.157593 204.254608,864.515381 
	C206.106445,867.580444 205.438675,870.319397 203.281418,872.616760 
	C201.231323,874.799988 198.628586,876.306702 194.700531,875.015259 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M156.995819,988.865967 
	C159.649338,988.416016 161.733093,987.872437 163.504883,988.392212 
	C168.155869,989.756714 169.482010,995.045471 166.052979,998.383057 
	C164.704300,999.695862 162.820938,1000.637939 161.013245,1001.265686 
	C156.338028,1002.889099 154.261703,1001.383728 154.047958,996.436707 
	C153.934021,993.799805 153.989975,991.166748 156.995819,988.865967 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M270.976227,930.951172 
	C275.728760,925.980225 281.110107,927.481384 286.117035,929.648987 
	C288.802704,930.811646 290.851654,933.596802 289.150177,936.974548 
	C287.458374,940.333130 284.590942,940.285278 281.593811,938.738647 
	C277.833923,936.798462 273.584686,935.564697 270.976227,930.951172 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M629.567871,549.467896 
	C625.113892,553.257874 621.290588,552.493713 618.024658,548.782043 
	C615.570984,545.993591 615.055969,542.683716 617.768005,539.884766 
	C620.492249,537.073242 623.717773,537.636780 626.672546,539.895386 
	C629.618835,542.147461 630.319702,545.229065 629.567871,549.467896 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M215.250046,1268.886108 
	C213.271652,1270.697510 211.740753,1272.008423 209.989838,1272.874512 
	C207.531540,1274.090698 204.610825,1274.904785 202.795990,1272.191162 
	C201.165909,1269.754028 202.304672,1267.009521 203.822479,1264.708496 
	C204.532303,1263.632446 205.443726,1262.523560 206.532974,1261.898926 
	C208.681564,1260.666992 210.262650,1257.492676 213.407928,1259.160645 
	C216.233398,1260.658936 216.006744,1263.536133 215.900970,1266.218628 
	C215.874985,1266.877808 215.703812,1267.531128 215.250046,1268.886108 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M286.604767,863.022217 
	C290.091980,860.333191 293.042084,856.006348 296.950836,860.694885 
	C299.473877,863.721191 297.751648,868.174988 292.918335,871.358948 
	C290.796997,872.756287 288.939240,874.866272 285.564117,875.204956 
	C282.571289,871.266357 284.296509,867.460938 286.604767,863.022217 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M710.167725,377.831512 
	C713.115295,371.835571 717.765808,374.050415 721.684448,374.657806 
	C724.150696,375.040039 724.749878,380.580048 722.994080,383.400238 
	C721.114441,386.419250 716.029785,388.078857 713.625732,386.349915 
	C711.019592,384.475616 709.787354,381.878754 710.167725,377.831512 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M147.638992,1195.801514 
	C146.600601,1196.094604 146.275848,1196.160156 145.965820,1196.268066 
	C142.911255,1197.332031 139.693588,1199.313599 137.191269,1195.469727 
	C135.856613,1193.419434 138.309433,1186.257812 140.753098,1184.974731 
	C144.125198,1183.204102 147.151794,1184.072266 149.640793,1186.792480 
	C152.756012,1190.197144 152.574905,1193.211792 147.638992,1195.801514 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M88.246826,1288.362671 
	C88.070290,1292.363037 86.589081,1294.846558 83.986305,1296.687500 
	C82.192833,1297.956055 80.259140,1298.119751 78.413551,1296.867188 
	C76.576332,1295.620239 75.918884,1293.745239 76.453270,1291.627197 
	C77.775742,1286.385498 82.025528,1283.583496 86.023659,1280.665405 
	C86.544617,1280.285156 88.138313,1280.618286 88.688622,1281.168091 
	C90.836136,1283.313721 88.994926,1285.474243 88.246826,1288.362671 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M703.844055,477.995544 
	C702.566101,484.752380 698.136353,484.499969 693.798035,483.465546 
	C691.233826,482.854126 688.828552,480.989563 688.823914,478.005035 
	C688.819336,475.017792 691.225159,473.152802 693.787720,472.537628 
	C698.126099,471.496124 702.552673,471.246033 703.844055,477.995544 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M285.121399,957.089600 
	C287.823212,955.017761 290.140991,953.786926 292.928619,954.196228 
	C296.690521,954.748596 298.784698,958.140991 297.866974,962.367188 
	C297.023956,966.248901 294.277618,968.005859 290.628204,967.004883 
	C286.158539,965.778809 282.869385,963.194092 285.121399,957.089600 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M341.655212,688.804382 
	C342.540680,689.920898 343.068268,690.429199 343.219574,691.032043 
	C344.011200,694.185852 345.452881,697.817688 341.281525,699.508728 
	C338.048615,700.819336 334.812653,699.911194 332.297729,697.191528 
	C330.309906,695.041870 329.385651,692.671448 331.274994,690.111572 
	C333.909790,686.541687 337.017731,684.513428 341.655212,688.804382 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M351.725708,826.549072 
	C351.963654,831.149963 350.358582,833.560486 346.305542,833.843445 
	C342.958527,834.077026 340.722992,832.171387 339.121765,829.598877 
	C337.650543,827.235229 337.586456,824.621826 339.311279,822.264282 
	C341.064423,819.868103 343.234375,820.852966 345.466583,821.553467 
	C347.990051,822.345276 350.544159,822.925110 351.725708,826.549072 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M334.298401,768.171021 
	C325.853119,769.852783 324.135803,768.755432 324.039185,762.471436 
	C323.991730,759.385376 324.066132,756.335388 328.332001,756.113708 
	C331.965759,755.924988 334.981049,756.743652 335.753296,760.881531 
	C336.181213,763.174377 336.135651,765.486145 334.298401,768.171021 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M687.509521,415.696655 
	C680.385376,420.651459 677.847778,420.816406 674.411438,417.282593 
	C672.704529,415.527313 671.623474,413.566864 672.762390,411.114136 
	C673.668518,409.162659 675.401672,408.271362 677.488708,408.104126 
	C682.698792,407.686768 686.464233,409.453766 687.509521,415.696655 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M370.409485,744.745117 
	C373.530975,741.976807 376.265472,741.227173 378.585266,744.250061 
	C380.753510,747.075317 380.579529,750.588440 379.320709,753.603943 
	C377.858551,757.106384 374.050842,756.546204 371.591614,755.657471 
	C365.592255,753.489380 367.810608,749.235962 370.409485,744.745117 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M121.854660,1265.950562 
	C119.194481,1268.520386 116.864571,1270.382202 113.606735,1268.692261 
	C112.150948,1267.937134 110.643684,1267.121338 110.324768,1265.317017 
	C109.799194,1262.343506 109.585770,1259.282349 112.364624,1257.253174 
	C114.677162,1255.564575 117.341736,1255.618774 119.732750,1257.202393 
	C122.716125,1259.178467 124.694580,1261.616943 121.854660,1265.950562 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M689.352905,442.953796 
	C684.402405,441.667572 679.262268,433.190979 680.697571,430.060913 
	C681.721802,427.827332 683.840698,428.077789 685.770081,428.099457 
	C688.675537,428.132050 691.057068,429.306580 691.589172,432.306976 
	C692.211243,435.814758 692.825684,439.496185 689.352905,442.953796 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M655.999817,383.192047 
	C654.500000,383.998047 653.000000,383.998535 650.750000,383.998901 
	C649.004395,382.539734 647.412781,382.154602 645.869934,381.609558 
	C642.976440,380.587341 641.940369,378.337891 642.203430,375.436920 
	C642.522522,371.917786 645.733826,372.065613 647.988342,371.088226 
	C651.075012,369.750153 652.878784,371.778259 654.542236,373.883972 
	C656.559204,376.437134 655.840515,379.494965 655.999817,383.192047 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M277.338806,965.842163 
	C276.339996,969.494995 275.128052,972.223206 271.286652,971.719971 
	C268.253693,971.322754 268.236908,968.786072 267.784576,966.559021 
	C267.165192,963.509277 264.737244,960.420959 268.049530,957.492920 
	C270.719849,955.132446 274.433136,955.977966 275.809448,959.416870 
	C276.531555,961.221191 276.830109,963.195007 277.338806,965.842163 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M169.025208,967.425781 
	C172.335114,960.149353 175.462723,958.480347 179.745529,961.227173 
	C181.950668,962.641418 184.219543,964.417419 182.989120,967.717102 
	C181.959457,970.478394 180.164368,972.001953 177.006256,972.010986 
	C173.677551,972.020569 171.277634,970.605469 169.025208,967.425781 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M170.212280,978.516357 
	C175.492340,978.193542 180.096786,978.073425 184.691376,978.234375 
	C186.715454,978.305359 187.759796,979.927063 186.700729,981.638367 
	C184.528137,985.148987 181.122070,988.037781 177.031021,987.040710 
	C173.336166,986.140198 168.384338,984.847900 170.212280,978.516357 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M501.930664,508.226959 
	C501.888306,512.090698 500.979950,514.360107 497.217529,513.355042 
	C495.950348,513.016541 494.743958,512.370239 493.582520,511.732208 
	C490.748444,510.175385 489.171906,507.555206 488.852570,504.519653 
	C488.595886,502.079437 491.093201,501.489166 492.860687,500.752136 
	C496.314240,499.311890 498.602417,501.302063 500.447998,503.832581 
	C501.193115,504.854279 501.435120,506.242920 501.930664,508.226959 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M93.385101,1268.959229 
	C94.074806,1264.279785 94.974358,1260.478271 97.921043,1257.539429 
	C99.186012,1256.277832 100.864914,1255.917603 102.387146,1256.851562 
	C103.066032,1257.268311 103.766312,1258.600464 103.592392,1259.303223 
	C102.418625,1264.046265 101.309570,1268.888306 98.692162,1273.058960 
	C97.723541,1274.602173 95.455437,1275.965698 93.557816,1274.914917 
	C91.403496,1273.722168 92.420601,1271.512573 93.385101,1268.959229 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M505.289062,701.763550 
	C503.849396,701.912537 503.145966,702.077271 502.530731,701.912598 
	C497.196411,700.484619 494.920166,697.438110 496.548462,694.001282 
	C497.846588,691.261292 503.444397,689.244019 506.111237,690.555176 
	C509.326538,692.135986 510.108154,696.674683 507.752686,700.642883 
	C507.462280,701.132080 506.641296,701.306335 505.289062,701.763550 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M84.490784,1172.392700 
	C86.541100,1169.656250 88.937302,1169.770020 91.159363,1170.258057 
	C93.993561,1170.880371 97.451263,1171.494019 97.526588,1175.248535 
	C97.593254,1178.571289 94.993210,1180.567871 92.087029,1181.547729 
	C88.733070,1182.678711 86.269371,1181.157593 85.102364,1177.894531 
	C84.565186,1176.392578 84.510010,1174.718140 84.490784,1172.392700 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M602.394531,483.627350 
	C599.455139,482.579773 597.696716,481.095428 596.761902,478.917114 
	C595.658997,476.347382 595.718262,473.784454 597.855591,471.664093 
	C599.426880,470.105225 601.318970,469.997620 603.289001,470.800995 
	C605.825500,471.835358 607.912415,473.199890 607.941650,476.406464 
	C607.974121,479.966095 607.365540,482.991364 602.394531,483.627350 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M701.296875,310.985565 
	C704.722168,315.334717 705.518982,319.155090 700.935425,322.357025 
	C698.981018,323.722351 696.739014,324.393616 694.523193,322.885529 
	C691.985474,321.158356 691.473022,318.452576 692.476501,315.908691 
	C693.853882,312.416809 696.151672,309.636963 701.296875,310.985565 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M123.886734,1029.605225 
	C119.479652,1028.766357 115.730080,1027.056763 117.226921,1022.643250 
	C118.542488,1018.764160 122.608513,1016.938660 126.679756,1016.460449 
	C129.233002,1016.160645 130.044113,1018.315613 129.799011,1020.436462 
	C129.372498,1024.126953 128.033676,1027.435181 123.886734,1029.605225 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M672.263184,320.596100 
	C674.882141,315.377441 678.582397,314.700104 682.129395,317.827484 
	C685.789307,321.054443 682.759155,324.469421 680.968079,327.476349 
	C679.894287,329.279144 678.001343,330.185333 675.874695,329.487457 
	C671.815002,328.155212 671.980469,324.722992 672.263184,320.596100 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M747.267395,482.972778 
	C749.515808,484.491730 751.021179,485.833099 751.558899,487.791351 
	C752.296265,490.476898 752.021606,493.102386 749.554016,494.827454 
	C747.551086,496.227692 745.229675,496.274597 743.035522,495.159607 
	C740.267761,493.753143 739.956787,491.160675 740.078552,488.442352 
	C740.264282,484.294403 742.985168,482.974762 747.267395,482.972778 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M46.373466,1330.987427 
	C45.283455,1332.296265 44.645050,1333.381714 43.830170,1333.536133 
	C38.152893,1334.612183 34.999126,1333.177979 34.299240,1329.345703 
	C33.509918,1325.023560 36.396889,1323.319702 39.772789,1322.500610 
	C43.782398,1321.527710 45.925640,1324.104614 46.373466,1330.987427 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M580.724243,388.781433 
	C586.381958,387.884155 588.120789,390.608398 587.758179,394.980408 
	C587.424377,399.005676 584.062744,400.271088 580.872620,401.192627 
	C578.590942,401.851715 577.020081,400.221252 576.479431,398.175110 
	C575.481018,394.396515 575.640991,390.862762 580.724243,388.781433 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M115.468330,1111.277832 
	C113.060196,1112.115112 111.295074,1114.266846 109.500313,1112.799805 
	C107.440689,1111.116089 109.446510,1109.145142 110.298241,1107.616089 
	C113.697441,1101.513306 117.637383,1099.291626 121.790817,1101.024170 
	C123.210648,1101.616333 124.993561,1102.182861 125.083458,1104.225708 
	C125.148064,1105.693726 124.200546,1106.666260 123.050133,1107.312622 
	C120.768265,1108.594727 118.413422,1109.747070 115.468330,1111.277832 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M680.284912,342.533508 
	C681.910889,338.463135 684.677551,337.278107 687.789001,338.556702 
	C690.612000,339.716766 692.151001,342.649780 693.190613,345.423279 
	C693.817749,347.096344 692.443604,348.530884 690.806152,349.298523 
	C686.001526,351.551025 682.456299,349.547363 680.284912,342.533508 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M288.019562,850.644165 
	C286.460754,851.351624 285.523468,851.806885 284.568207,851.848328 
	C281.176605,851.995361 278.771240,850.616028 278.239532,847.032654 
	C277.811401,844.147461 278.706909,841.658508 281.571625,840.572021 
	C284.648712,839.404968 287.347900,840.384155 289.649170,842.737671 
	C292.569031,845.723938 291.174469,848.015564 288.019562,850.644165 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M317.491821,1147.113281 
	C311.736023,1146.487427 311.161560,1143.183594 313.029694,1139.381958 
	C314.617920,1136.150024 320.883514,1135.051270 323.646881,1137.218994 
	C326.101227,1139.144287 326.490845,1141.561890 324.431793,1144.104492 
	C322.834076,1146.077515 320.243530,1145.888062 317.491821,1147.113281 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M242.304199,1063.767822 
	C242.076126,1059.078979 243.668839,1057.151001 247.569748,1059.120850 
	C249.266632,1059.977661 250.624832,1061.625732 251.940109,1063.091187 
	C254.274231,1065.691528 254.738571,1068.673096 251.588821,1070.725952 
	C248.426208,1072.787354 245.270676,1072.676025 243.836166,1068.231812 
	C243.430954,1066.976440 242.911270,1065.757935 242.304199,1063.767822 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M776.475952,437.701904 
	C771.855713,435.347107 770.742920,432.187988 773.613831,428.719788 
	C775.229431,426.768036 777.911987,425.528168 780.720154,426.713867 
	C783.109131,427.722565 783.998962,429.811798 783.828552,432.310059 
	C783.550293,436.388519 781.093018,437.967834 776.475952,437.701904 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M705.462402,495.685120 
	C706.974548,501.489777 705.546082,505.064697 702.309937,505.313049 
	C699.765930,505.508301 694.534302,500.348755 694.421387,497.464508 
	C694.344177,495.493805 695.491455,494.395874 697.335754,494.212646 
	C699.934265,493.954529 702.595398,493.538422 705.462402,495.685120 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M586.940674,414.272064 
	C592.516418,413.733795 597.067993,413.952759 599.182739,419.441315 
	C592.659607,424.054504 589.492126,424.296417 585.741394,420.282776 
	C583.889038,418.300598 583.600098,416.194397 586.940674,414.272064 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M763.600952,396.224121 
	C762.910095,395.461792 762.670471,395.209442 762.553772,394.909271 
	C760.350769,389.243439 761.223633,385.834564 765.355042,384.609009 
	C769.483154,383.384399 770.592346,386.692657 771.428894,389.416901 
	C772.668396,393.453613 770.326538,395.599762 763.600952,396.224121 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M244.580475,780.264526 
	C245.669052,780.137207 246.003006,780.122498 246.333511,780.149780 
	C250.511185,780.494080 252.083557,783.000427 251.798050,786.907654 
	C251.640625,789.062195 250.511124,790.790894 248.446808,791.417908 
	C244.897919,792.495728 242.688400,790.188354 241.127457,787.595947 
	C239.176987,784.356628 240.569916,781.919128 244.580475,780.264526 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M614.919250,321.417603 
	C613.185974,323.689362 611.079712,323.778900 609.249207,324.507690 
	C606.909851,325.439148 604.653198,325.974243 603.082214,323.460480 
	C601.767212,321.356323 601.458557,318.886017 603.277222,316.979187 
	C604.864563,315.314880 606.959778,313.841248 609.500549,314.961243 
	C612.138550,316.124115 615.459045,316.782654 614.919250,321.417603 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M657.047607,346.539124 
	C658.327087,344.990570 659.155884,343.892761 660.248779,343.231445 
	C662.674622,341.763580 665.673096,341.114380 667.177734,343.904236 
	C668.768555,346.853790 668.689758,350.414154 665.573608,352.785980 
	C662.954224,354.779663 660.644714,353.464142 658.601440,351.486481 
	C657.384888,350.309082 656.470520,349.004242 657.047607,346.539124 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M796.078857,410.448242 
	C795.224915,411.095490 794.945374,411.290833 794.635986,411.371643 
	C790.134033,412.547333 786.732849,411.593781 786.225891,406.353333 
	C785.865295,402.625793 788.624451,401.085205 791.687073,400.750214 
	C795.297852,400.355194 797.149780,404.044403 796.078857,410.448242 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M274.083099,1165.272217 
	C273.110657,1165.996704 272.221222,1165.998291 270.664673,1166.000000 
	C266.200134,1166.119507 263.403656,1165.111694 264.315826,1160.485718 
	C264.894226,1157.552490 269.696625,1154.153320 272.403442,1154.704956 
	C274.116333,1155.053955 275.147278,1156.305908 275.599579,1157.994629 
	C276.250183,1160.423706 274.490509,1162.330566 274.083099,1165.272217 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M277.173889,883.370850 
	C281.087372,881.917175 282.962646,883.413086 283.665192,886.389343 
	C284.182251,888.580017 284.533234,891.018799 282.702515,892.871460 
	C281.071320,894.522217 275.176453,892.708313 273.291443,889.781799 
	C270.948212,886.143738 272.993286,884.429932 277.173889,883.370850 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M288.692627,1219.211182 
	C284.968719,1217.511230 283.051697,1215.322632 284.752747,1212.009399 
	C286.227997,1209.136230 289.254303,1209.895386 291.730042,1210.376709 
	C294.173553,1210.852051 295.878326,1212.572754 295.604706,1215.198242 
	C295.228546,1218.807861 292.870544,1220.087280 288.692627,1219.211182 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M688.905823,382.837463 
	C689.788696,381.750458 690.232178,381.158112 690.817017,380.933075 
	C694.717590,379.432251 698.209961,379.595917 699.523071,384.307953 
	C700.259888,386.951843 698.505554,388.731781 696.069763,389.578766 
	C692.317505,390.883453 690.304016,389.212921 688.905823,382.837463 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M769.174011,508.984253 
	C766.210388,505.031586 765.234497,501.737122 770.644714,500.311127 
	C773.418030,499.580078 776.092590,500.373260 777.278015,503.250885 
	C778.680359,506.655426 776.094116,508.039490 773.571411,509.042542 
	C772.428162,509.497162 771.031799,509.315247 769.174011,508.984253 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M751.759766,423.575165 
	C746.883545,422.985504 745.534119,420.343842 746.503235,416.589752 
	C747.262939,413.646576 749.962463,413.897217 752.182251,414.193848 
	C756.731018,414.801727 756.811707,417.617462 751.759766,423.575165 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M109.802963,1060.609375 
	C107.842957,1057.385010 108.989929,1055.603394 111.444260,1054.597290 
	C113.928909,1053.578613 115.862808,1054.905396 117.522346,1056.654907 
	C118.902092,1058.109619 120.132439,1059.656738 119.397964,1061.863647 
	C118.915520,1063.313354 117.682610,1063.691162 116.331230,1063.831055 
	C113.807831,1064.092529 111.924423,1062.890137 109.802963,1060.609375 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M562.029968,587.813049 
	C557.700012,586.825623 557.415100,584.194641 558.893921,581.646301 
	C560.248352,579.312256 562.729797,578.013977 565.680481,578.628906 
	C567.224854,578.950745 567.704163,580.276855 567.775696,581.618591 
	C567.962463,585.122559 566.333313,587.273987 562.029968,587.813049 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M470.269531,566.293701 
	C469.170990,566.977600 468.528503,567.406128 467.958130,567.325378 
	C463.965973,566.760681 461.438843,564.467346 460.838959,560.471558 
	C460.607330,558.928406 462.113098,558.097717 463.412628,558.213257 
	C467.952332,558.617126 471.935913,559.774658 470.269531,566.293701 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M651.717773,494.231689 
	C650.844666,492.783783 650.289612,491.891907 650.208923,490.959015 
	C649.969421,488.188812 650.434692,485.111847 653.651611,484.945587 
	C657.617737,484.740631 657.999390,488.162231 657.915955,491.233002 
	C657.810120,495.126404 656.091675,496.716736 651.717773,494.231689 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M540.078369,494.440338 
	C536.678528,496.087952 533.693542,497.056976 532.395386,493.096893 
	C531.410828,490.093597 533.313232,488.227295 535.951355,487.161560 
	C539.808960,485.603210 541.192017,487.622559 540.078369,494.440338 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M371.758850,1159.687134 
	C369.819427,1153.188721 373.122650,1146.878052 373.173126,1139.411133 
	C373.197449,1138.589600 373.979889,1138.425293 374.379761,1138.409790 
	C377.413330,1145.788696 373.767059,1152.466919 371.758850,1159.687134 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M212.379135,933.660889 
	C209.399048,932.435486 207.461700,930.734375 209.379288,928.272583 
	C211.403061,925.674438 214.368835,923.865234 217.928345,924.619568 
	C219.311386,924.912659 219.553864,926.463318 218.939774,927.845581 
	C217.736176,930.554626 216.669357,933.403809 212.379135,933.660889 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M258.619995,1184.898682 
	C257.590607,1184.047485 257.019775,1183.593872 256.813660,1183.011475 
	C255.615784,1179.625732 255.452011,1176.368042 259.503082,1174.883545 
	C261.215210,1174.256226 262.788910,1175.620117 263.262024,1177.272095 
	C264.338348,1181.030151 264.500366,1184.564209 258.619995,1184.898682 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M623.023682,400.568054 
	C623.782776,399.440369 624.180054,398.894409 624.674805,398.459351 
	C626.773315,396.613983 629.305664,394.730469 631.301941,397.964447 
	C632.880432,400.521667 631.676697,403.080536 628.782715,404.495575 
	C625.190796,406.251862 623.054321,405.393188 623.023682,400.568054 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M23.748749,1426.714966 
	C23.764854,1431.518188 21.325932,1432.793091 18.093910,1431.254883 
	C15.188990,1429.872559 15.530014,1426.723511 17.181347,1424.587036 
	C19.865993,1421.113647 22.063221,1422.743774 23.748749,1426.714966 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M660.544800,331.973419 
	C654.508728,331.892578 653.004639,330.265900 654.915833,326.828278 
	C655.952942,324.962738 657.735168,323.657654 659.784058,324.664032 
	C662.904724,326.196777 662.013550,328.901947 660.544800,331.973419 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M468.521118,637.299072 
	C469.815796,643.675720 465.887329,641.913513 463.304718,641.234131 
	C461.296539,640.705933 459.794342,638.739197 461.189392,636.629578 
	C463.305145,633.430054 465.880493,633.247070 468.521118,637.299072 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M267.509186,765.565308 
	C265.683075,765.203674 264.285645,764.942383 263.400970,764.125732 
	C261.860504,762.703552 259.161255,760.927979 262.024872,758.753906 
	C263.944275,757.296631 266.449829,757.927979 267.893738,760.276550 
	C268.890564,761.897827 270.212372,763.592468 267.509186,765.565308 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M382.587891,611.473877 
	C380.312958,609.044312 379.910034,607.054565 382.272186,605.289551 
	C383.356476,604.479370 384.722412,604.428284 385.814423,605.378113 
	C388.016815,607.293762 388.676056,609.769409 387.139954,612.237549 
	C385.971863,614.114380 384.383698,612.856506 382.587891,611.473877 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M380.053711,1110.440918 
	C381.976654,1111.366455 381.983032,1113.048096 381.976105,1115.364990 
	C378.375946,1118.250977 381.629974,1123.183960 377.647400,1125.750488 
	C376.198761,1123.967163 376.830963,1121.943359 376.970581,1119.150513 
	C376.232971,1116.485107 375.955017,1114.614502 377.834961,1112.415771 
	C378.946075,1111.653931 379.357269,1111.212646 380.053711,1110.440918 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M102.587799,1019.850281 
	C102.674744,1016.218567 103.877480,1014.004883 107.261040,1015.136353 
	C109.257240,1015.803833 110.387367,1017.921021 109.304718,1019.864563 
	C107.680077,1022.781128 105.196426,1022.311584 102.587799,1019.850281 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M160.426941,924.220581 
	C161.941666,920.970581 163.887497,919.077087 166.698105,921.215515 
	C168.595703,922.659302 167.810669,924.916443 166.194931,926.262756 
	C163.871735,928.198547 161.503082,928.785156 160.426941,924.220581 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M712.598145,451.642029 
	C708.892395,448.399384 710.244934,446.160889 713.518555,444.854706 
	C715.160645,444.199463 716.681152,445.541534 717.237915,447.182770 
	C718.454956,450.770294 716.474731,451.864136 712.598145,451.642029 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M488.483337,489.701447 
	C488.796051,486.166901 489.912659,483.873047 493.387695,485.161713 
	C495.020142,485.767059 495.929199,487.495667 494.976959,489.152527 
	C493.457886,491.795776 491.299561,492.761475 488.483337,489.701447 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M792.637878,480.918823 
	C789.750061,481.981201 787.328430,482.433990 786.574036,479.268890 
	C786.247986,477.900787 787.112305,476.650299 788.629150,476.428345 
	C791.622131,475.990326 794.129944,476.290344 792.637878,480.918823 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M492.929443,826.934448 
	C494.176239,824.712646 495.268127,823.090149 496.545197,820.899780 
	C497.331696,820.007141 497.933044,819.682312 499.007690,819.148071 
	C500.224182,823.952942 496.742889,826.702026 493.060547,829.819153 
	C492.529633,829.141052 492.652100,828.337402 492.929443,826.934448 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M166.667007,1084.866333 
	C164.369568,1082.816772 163.290451,1080.894409 165.553986,1078.923828 
	C166.544739,1078.061401 168.161270,1078.112183 168.866501,1079.333984 
	C170.198151,1081.641235 170.968170,1084.078979 166.667007,1084.866333 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M443.384460,586.455444 
	C445.723480,587.709473 445.374725,589.163391 444.534180,590.632935 
	C443.929169,591.690735 443.421417,593.155029 441.853363,592.764954 
	C439.762054,592.244812 440.159454,590.412659 440.306213,588.901367 
	C440.442047,587.502625 441.408234,586.717712 443.384460,586.455444 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M593.336670,695.861938 
	C592.759583,692.593750 595.760803,691.185242 597.680786,688.290344 
	C597.989380,687.718628 598.927551,687.805847 599.394653,687.860413 
	C599.828979,691.986511 597.283447,694.173279 593.336670,695.861938 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M577.598755,710.101074 
	C577.146667,711.896423 575.919739,713.650818 574.092651,715.649170 
	C571.804260,715.546326 570.071655,714.961609 570.468140,712.855286 
	C571.184998,709.047729 574.408691,710.345825 577.598755,710.101074 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M761.669250,458.548584 
	C763.987732,460.313171 764.162354,461.991669 762.124329,463.278717 
	C761.010498,463.982117 759.486023,463.651093 758.879150,462.417480 
	C757.847290,460.320251 758.636719,458.858246 761.669250,458.548584 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M43.660759,1077.449707 
	C40.634018,1077.128418 39.841255,1075.670410 40.883495,1073.573364 
	C41.496639,1072.339844 43.024700,1072.017578 44.131477,1072.722046 
	C46.159370,1074.012939 45.991264,1075.692139 43.660759,1077.449707 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M386.015686,1087.693237 
	C384.017548,1085.011841 385.989990,1082.378784 386.311432,1078.840332 
	C386.280670,1078.107422 387.116364,1078.049194 387.534607,1078.034912 
	C387.728973,1081.173950 389.030487,1084.549805 386.015686,1087.693237 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M382.951904,1098.596191 
	C383.768768,1100.600830 384.845703,1103.418701 381.804810,1105.767578 
	C380.399170,1103.616089 381.015228,1101.367310 382.951904,1098.596191 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M474.962646,857.129272 
	C475.726532,856.312683 476.264160,856.018127 477.186340,855.480591 
	C477.887970,858.929932 476.731567,861.859070 472.970825,864.117676 
	C472.318665,864.362061 472.186615,864.208618 472.126404,864.127197 
	C471.781799,863.715942 471.497375,863.386108 471.599823,862.529663 
	C472.921082,860.585083 473.855499,859.166992 474.962646,857.129272 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M563.139038,729.867310 
	C564.026917,732.749390 562.705688,734.782410 559.156860,735.885010 
	C558.661438,733.184082 560.635010,731.641418 563.139038,729.867310 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M516.982117,791.795898 
	C518.142639,794.592651 516.856262,796.573181 513.539185,797.902527 
	C512.738525,795.241333 514.640442,793.663391 516.982117,791.795898 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M54.974854,1284.566650 
	C54.234768,1282.818970 54.271332,1281.557983 55.785297,1281.077515 
	C56.196022,1280.947021 57.183868,1281.429199 57.312397,1281.823730 
	C57.860027,1283.505249 57.788116,1285.012451 54.974854,1284.566650 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M90.567101,993.025391 
	C88.818932,993.765808 87.557739,993.728882 87.076950,992.214722 
	C86.946465,991.803772 87.428535,990.815674 87.823174,990.687134 
	C89.505234,990.139221 91.012596,990.211548 90.567101,993.025391 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M377.707886,1112.090088 
	C378.179962,1113.757568 377.927094,1115.514771 377.300415,1117.825439 
	C373.626190,1116.282471 372.594269,1114.206543 377.707886,1112.090088 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M491.056885,831.648865 
	C492.058044,833.873657 491.304626,835.927063 488.408081,837.596436 
	C487.822296,835.501160 488.991089,833.666077 491.056885,831.648865 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M384.160828,1097.529541 
	C383.919037,1098.034668 383.429565,1098.059326 383.188660,1098.099365 
	C382.912170,1096.704102 382.876526,1095.268677 382.859802,1093.109497 
	C382.878723,1092.385620 383.695953,1092.293823 384.106445,1092.268066 
	C386.468658,1093.884033 385.203217,1095.448608 384.160828,1097.529541 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M483.470612,845.819519 
	C482.626587,845.406738 482.582916,844.822571 482.768799,843.778076 
	C483.536194,842.521484 484.309113,841.707886 485.594971,840.682251 
	C485.938599,842.410034 486.206726,844.524170 483.470612,845.819519 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M533.108643,769.880981 
	C532.335876,769.361938 532.363403,768.762695 532.647583,767.721924 
	C533.524353,766.561035 534.361084,765.851746 535.726318,765.018311 
	C535.987976,766.833801 536.010559,768.924866 533.108643,769.880981 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M522.619751,781.654114 
	C523.502991,780.450073 524.340210,779.716370 525.716736,778.866516 
	C525.994568,780.714417 526.081848,782.853455 523.151001,783.874756 
	C522.310486,783.358093 522.313416,782.740662 522.619751,781.654114 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M521.063599,785.782043 
	C522.053406,788.093811 521.206726,790.070801 518.204041,791.506714 
	C517.671875,789.357971 518.770935,787.542725 521.063599,785.782043 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M569.301392,722.208496 
	C569.958740,724.497375 568.978027,726.347046 566.031372,727.538452 
	C565.800598,725.472595 566.953308,723.742737 569.301392,722.208496 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M801.223755,523.916138 
	C801.038147,526.207092 799.461304,527.590759 796.292236,527.794312 
	C796.521118,525.517944 798.511108,524.679749 801.223755,523.916138 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M553.318848,742.119324 
	C553.926208,743.682312 553.419617,745.092407 551.125732,745.962402 
	C550.490906,744.365051 551.520996,743.260681 553.318848,742.119324 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M597.909729,367.164673 
	C596.484802,366.387207 596.470215,365.603119 597.483887,364.909119 
	C597.696289,364.763733 598.189026,364.768524 598.396423,364.919128 
	C599.389160,365.640045 599.352600,366.423645 597.909729,367.164673 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M55.250488,1273.103394 
	C56.811741,1272.662109 57.374851,1273.209961 57.135731,1274.420410 
	C57.086006,1274.672241 56.729748,1275.011597 56.475590,1275.049805 
	C55.252430,1275.233643 54.738728,1274.639404 55.250488,1273.103394 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M547.211304,749.942627 
	C547.903381,751.530396 547.476196,753.012329 545.087646,753.923706 
	C544.393616,752.298584 545.368835,751.127930 547.211304,749.942627 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M541.199646,757.931030 
	C541.906982,759.524536 541.475525,761.013184 539.061768,761.926208 
	C538.389709,760.305664 539.419434,759.161743 541.199646,757.931030 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M583.278809,706.078979 
	C583.880554,707.709290 583.351990,709.141785 580.932129,709.899292 
	C580.306519,708.225891 581.335510,707.113831 583.278809,706.078979 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M511.315308,800.023682 
	C511.905579,800.199341 511.960266,800.552002 512.061584,801.437683 
	C511.365540,802.598083 510.622864,803.225464 509.391052,803.922607 
	C508.667480,802.302307 509.613861,801.197205 511.315308,800.023682 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M809.429321,518.932617 
	C809.623474,520.688782 808.623901,521.686951 806.260071,521.788940 
	C806.194031,520.185120 807.419067,519.404175 809.429321,518.932617 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M755.178955,553.581543 
	C755.429810,554.774902 754.621521,555.569763 752.728638,555.925049 
	C752.947815,555.204041 753.773560,554.437073 755.178955,553.581543 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M779.600403,536.365356 
	C780.009644,535.934875 780.400513,535.967957 781.371826,536.091675 
	C781.479004,536.653809 781.005737,537.125244 780.025330,537.675659 
	C779.518127,537.754639 779.582031,536.828918 779.600403,536.365356 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M471.507446,862.344482 
	C472.024689,862.342712 472.062714,862.682312 472.083496,863.533875 
	C471.766266,864.196106 471.466370,864.346375 470.696655,864.681396 
	C470.493927,864.139404 470.761078,863.412598 471.507446,862.344482 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M711.198120,585.687378 
	C711.297729,586.153687 710.830811,586.797485 709.751404,587.552551 
	C709.636536,587.064148 710.134094,586.464478 711.198120,585.687378 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M200.212189,571.042603 
	C198.802902,561.305969 201.482330,554.012451 208.668686,548.349365 
	C211.561386,546.069824 214.597076,545.247498 217.839142,546.749023 
	C220.868332,548.151917 219.841431,551.299622 219.963440,553.810303 
	C220.107559,556.776184 220.130356,559.761902 219.961746,562.725098 
	C219.799194,565.581665 221.271820,569.451233 218.268539,570.971008 
	C213.983276,573.139526 209.852158,576.476990 204.494873,575.664795 
	C202.322510,575.335449 201.092072,573.823792 200.212189,571.042603 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M342.420105,446.636719 
	C345.669556,443.616516 347.874359,440.745544 349.362061,437.333862 
	C350.442017,434.857208 351.904907,432.619293 354.255157,431.190735 
	C356.344452,429.920837 358.847809,429.231964 360.680664,431.168457 
	C363.063446,433.685944 360.442963,434.971924 358.900421,436.710754 
	C354.425690,441.754883 350.527557,447.052917 353.671783,454.499908 
	C354.443573,456.327942 354.163666,458.855103 352.410645,460.007477 
	C347.468384,463.256378 342.805725,466.699371 338.763306,471.110504 
	C337.360077,472.641754 334.861115,471.560760 334.327179,469.091461 
	C333.764557,466.489410 333.531281,463.721649 334.708893,461.254639 
	C336.979065,456.498779 339.499603,451.862427 342.420105,446.636719 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M200.186462,587.337036 
	C202.535294,591.458435 205.175720,594.378479 208.080597,597.089661 
	C210.026566,598.905945 211.646988,600.954285 212.680099,603.445984 
	C213.439209,605.276794 214.539505,607.216248 212.723129,608.871216 
	C210.910980,610.522400 208.857101,609.684631 207.461777,608.208923 
	C203.661621,604.189941 198.684448,602.605713 193.701767,600.824768 
	C187.060043,598.450928 184.055099,592.207092 186.800430,587.085632 
	C188.822800,583.312988 192.796082,583.217529 200.186462,587.337036 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M128.120331,709.765747 
	C117.457176,708.386292 116.052971,698.633911 110.846581,692.760925 
	C109.091309,690.780945 110.679855,687.764343 113.773384,688.493103 
	C123.684700,690.828125 131.773300,696.081848 137.201935,704.929138 
	C138.139664,706.457458 137.907837,708.155701 136.886780,709.578918 
	C134.407745,713.034180 131.558502,710.391479 128.120331,709.765747 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M441.663269,369.445740 
	C428.412140,372.935272 427.852081,372.551422 426.321320,359.777191 
	C425.666016,354.308807 429.546600,350.474579 436.137268,350.078461 
	C441.518585,349.755035 443.775452,351.678162 443.891144,357.664581 
	C443.964996,361.486877 445.146179,365.601715 441.663269,369.445740 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M499.308838,368.817383 
	C498.211731,365.302460 497.389099,362.500061 496.676422,360.072235 
	C498.183685,357.728058 500.344727,357.662231 502.128967,357.032227 
	C505.574829,355.815430 509.163452,354.833923 511.974274,358.425598 
	C514.591614,361.770020 514.893005,369.184113 512.289062,372.397705 
	C509.977783,375.250214 506.982147,377.944763 503.123047,377.032013 
	C499.609497,376.201019 500.250244,372.311096 499.308838,368.817383 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M167.117371,650.276489 
	C165.772461,658.931274 160.298553,662.267029 153.549301,659.430786 
	C151.058945,658.384277 149.792297,656.482727 151.179169,653.942139 
	C154.142456,648.513977 158.295364,643.779907 160.455338,637.854919 
	C160.921600,636.575989 162.410004,636.226257 163.833099,636.666260 
	C165.341766,637.132751 165.700821,638.422607 165.862976,639.737122 
	C166.264053,642.988098 165.555801,646.348755 167.117371,650.276489 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M259.129333,556.998901 
	C255.447647,561.101135 251.266800,560.176392 247.429855,559.692993 
	C243.876221,559.245239 241.675339,554.591736 242.112732,550.226624 
	C242.543915,545.923584 245.640961,546.148071 248.681030,545.999451 
	C258.240753,545.532532 259.563385,546.761475 259.129333,556.998901 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M195.761902,552.792480 
	C192.687790,558.491211 187.887527,559.363708 182.216812,556.042908 
	C178.264938,553.728699 176.733551,548.963013 178.761719,545.095398 
	C179.785477,543.143188 181.324692,542.348633 183.618988,542.916443 
	C188.961609,544.238586 193.358261,546.724670 195.761902,552.792480 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M303.725159,542.515930 
	C303.711456,549.122314 299.372772,547.897095 295.949463,547.889404 
	C291.434479,547.879272 289.988007,544.326355 288.651154,540.915955 
	C287.502747,537.986389 289.045593,535.806519 291.159485,534.017639 
	C295.016510,530.753540 299.342987,531.585632 301.674713,536.130066 
	C302.566498,537.868103 302.979736,539.851685 303.725159,542.515930 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M379.319153,465.261383 
	C380.410889,469.859131 381.439697,473.723663 381.843262,477.652405 
	C382.148499,480.623505 380.565063,481.929138 377.455383,480.650543 
	C373.930450,479.201202 371.170074,476.781250 369.184418,473.675598 
	C367.141968,470.481110 367.826721,467.306030 370.510498,464.631500 
	C373.295929,461.855652 376.131439,461.142609 379.319153,465.261383 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M233.392914,576.334778 
	C235.240311,577.099487 236.525772,577.638367 237.418015,578.558533 
	C239.181564,580.377197 242.253143,581.878357 241.073410,584.996094 
	C239.676254,588.688416 236.196838,590.345947 232.584427,591.264771 
	C230.814774,591.714966 229.492966,590.411804 228.709549,588.811584 
	C226.760712,584.830994 228.309006,579.950500 233.392914,576.334778 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M425.020996,438.332184 
	C427.324463,433.422424 430.664703,433.234528 434.406464,434.993225 
	C435.241180,435.385590 435.495514,436.841949 434.694824,437.586853 
	C432.070801,440.028015 429.441345,442.802734 425.318817,440.762665 
	C424.937103,440.573792 424.944977,439.597656 425.020996,438.332184 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2292.534424,1777.545166 
	C2290.310547,1777.695435 2288.717529,1777.217529 2288.300537,1775.249023 
	C2286.868164,1768.487915 2291.646729,1761.941284 2298.844727,1760.767578 
	C2303.862305,1759.949219 2311.469971,1766.935303 2311.717773,1772.544678 
	C2311.854004,1775.631104 2309.704102,1777.368042 2307.765869,1779.125244 
	C2306.310303,1780.445068 2304.577637,1781.487427 2302.882812,1782.511108 
	C2295.516602,1786.959839 2295.505371,1786.940918 2298.333252,1794.741333 
	C2300.553467,1800.864380 2299.584961,1803.589966 2293.893799,1807.020264 
	C2292.757324,1807.705322 2291.573730,1808.376099 2290.325928,1808.801758 
	C2281.653564,1811.758667 2276.299316,1816.485718 2277.748047,1826.952271 
	C2278.485352,1832.281738 2273.688965,1836.235107 2267.907227,1837.732788 
	C2262.620605,1839.102051 2259.867920,1836.107788 2257.428223,1832.271973 
	C2257.071289,1831.711060 2256.714355,1831.148560 2256.328369,1830.607788 
	C2253.854492,1827.140503 2253.687988,1820.905151 2246.820312,1822.708496 
	C2239.040283,1824.751343 2236.192627,1828.139771 2236.092285,1836.830566 
	C2236.037842,1841.588745 2234.779785,1845.199585 2230.565186,1847.698730 
	C2224.474365,1851.309814 2216.956543,1850.778198 2214.459961,1846.391968 
	C2209.970947,1838.505371 2211.436279,1831.918335 2218.681152,1827.722656 
	C2220.693848,1826.557007 2222.773682,1825.482788 2224.900391,1824.542725 
	C2229.274170,1822.609497 2231.167236,1819.324097 2229.252686,1814.922852 
	C2226.770752,1809.217529 2228.786377,1805.190918 2233.258789,1801.979614 
	C2238.036377,1798.549561 2243.627686,1799.314697 2248.579590,1800.888916 
	C2252.688965,1802.195435 2253.317383,1806.755249 2254.072754,1810.797607 
	C2255.029297,1815.918213 2256.842285,1816.791016 2261.536377,1815.147705 
	C2267.366211,1813.106567 2271.040527,1808.368774 2271.209717,1802.674561 
	C2271.535889,1791.692627 2275.018555,1786.941895 2285.259033,1784.163940 
	C2287.537842,1783.545776 2289.841797,1783.390137 2291.655762,1780.627930 
	C2293.569580,1778.239624 2295.731689,1777.526611 2297.810303,1776.627686 
	C2299.600098,1775.853760 2301.423340,1774.902832 2301.303223,1772.545410 
	C2301.228760,1771.090698 2300.202637,1770.245728 2298.750732,1770.134399 
	C2296.301025,1769.946655 2295.459473,1771.757324 2294.701904,1773.581909 
	C2294.206055,1774.776001 2293.773926,1775.995239 2292.534424,1777.545166 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2379.361816,1776.279907 
	C2382.152832,1776.143188 2383.560547,1777.315552 2384.658691,1779.115845 
	C2385.976074,1781.276123 2388.100586,1782.006958 2391.270020,1781.992310 
	C2392.990967,1782.984009 2393.400879,1784.192993 2393.396729,1785.561401 
	C2393.385498,1789.392456 2391.811279,1794.265991 2396.814453,1795.787964 
	C2402.164795,1797.415649 2402.639160,1791.718506 2405.460938,1788.425537 
	C2407.685791,1788.293945 2409.265381,1788.772583 2409.701904,1790.721558 
	C2410.791992,1795.588013 2408.852295,1799.051758 2404.732422,1801.583740 
	C2399.699951,1804.676270 2394.381836,1804.818970 2390.910645,1801.718750 
	C2389.937988,1800.850342 2389.239502,1799.679810 2388.382812,1798.676025 
	C2385.689941,1795.521606 2387.067627,1789.453247 2381.663330,1788.417969 
	C2376.545166,1787.437500 2372.130615,1790.586304 2367.422852,1791.968750 
	C2366.521973,1792.233398 2365.737061,1792.892456 2365.021484,1793.299683 
	C2364.381592,1795.598633 2365.514160,1797.415283 2366.121826,1799.232910 
	C2369.085449,1808.093262 2370.847900,1808.934082 2379.923096,1806.292480 
	C2387.168213,1804.183594 2389.046387,1804.692627 2391.489258,1809.428589 
	C2395.176758,1816.577881 2394.071533,1823.613281 2388.524902,1828.298096 
	C2383.153564,1832.835327 2380.400879,1832.660767 2374.120605,1826.695923 
	C2376.068115,1823.778442 2379.082764,1824.932251 2381.480713,1823.902954 
	C2384.186279,1822.741333 2385.749512,1820.727051 2385.494141,1817.719727 
	C2385.344238,1815.955566 2384.281982,1814.619263 2382.440674,1814.264038 
	C2379.637939,1813.723511 2378.178223,1815.496826 2377.027588,1817.653320 
	C2376.403809,1818.822266 2375.869629,1820.039673 2374.546875,1821.561768 
	C2373.360840,1821.834229 2372.340332,1821.864502 2372.139404,1821.473755 
	C2368.836426,1815.042725 2364.538330,1812.707886 2357.087891,1815.586914 
	C2352.237793,1817.460938 2343.947021,1811.410156 2342.412598,1806.201050 
	C2341.607422,1803.467773 2342.262207,1801.003906 2344.228027,1798.830811 
	C2346.491699,1796.328735 2349.162109,1794.491699 2352.111572,1792.862305 
	C2355.127441,1791.196289 2360.006104,1790.771484 2359.694092,1786.087402 
	C2359.342773,1780.817139 2357.920166,1775.429321 2353.984375,1771.591064 
	C2350.313965,1768.011841 2339.585693,1772.760864 2338.114014,1778.401489 
	C2337.788086,1779.651367 2338.020996,1781.046875 2337.993164,1783.187744 
	C2333.153320,1786.390381 2331.089600,1783.514038 2329.792969,1778.787354 
	C2334.304688,1773.881104 2333.614014,1768.120605 2335.461426,1762.508667 
	C2340.976074,1761.856201 2346.518311,1768.240601 2351.427246,1760.356201 
	C2356.517090,1760.210327 2359.490234,1765.233154 2365.235107,1764.002441 
	C2368.121826,1766.133667 2366.951416,1768.274170 2365.842041,1770.241821 
	C2363.717285,1774.010010 2362.710449,1777.700195 2366.907715,1780.593140 
	C2370.655273,1783.175781 2373.687012,1780.985352 2376.471680,1778.446045 
	C2377.195801,1777.785522 2377.933350,1777.141602 2379.361816,1776.279907 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2440.356934,1772.575562 
	C2440.293945,1769.181641 2441.784180,1767.551270 2444.609375,1768.549316 
	C2449.056641,1770.120483 2452.458984,1772.621826 2454.309570,1777.560181 
	C2457.061768,1784.904663 2457.676514,1785.056274 2465.327148,1782.337524 
	C2469.268799,1780.936768 2475.101562,1781.916504 2475.978271,1774.758667 
	C2477.636230,1772.316895 2479.665527,1772.502808 2481.534668,1773.193604 
	C2487.904785,1775.547852 2490.621338,1771.586914 2493.475098,1766.413086 
	C2494.933594,1766.292603 2496.316406,1766.291626 2496.729736,1766.924072 
	C2500.204102,1772.242554 2504.812256,1773.161499 2510.409912,1770.833252 
	C2514.253906,1769.234619 2517.290039,1771.145264 2518.655518,1774.171997 
	C2520.260742,1777.729370 2525.737305,1780.785400 2520.644287,1785.896729 
	C2519.711670,1785.854248 2519.367920,1785.766724 2519.142822,1785.554077 
	C2509.988281,1776.908325 2509.413818,1777.052368 2504.508789,1789.563354 
	C2500.472168,1789.980835 2499.092285,1787.384033 2497.266113,1784.916016 
	C2493.675293,1780.062988 2486.132812,1779.207031 2481.669678,1782.854614 
	C2481.003662,1783.398804 2480.262207,1784.692749 2480.475342,1785.334595 
	C2481.824219,1789.398193 2482.890381,1793.711670 2485.107666,1797.286865 
	C2487.299072,1800.820557 2490.870605,1801.655640 2495.500732,1800.677124 
	C2500.986328,1799.517578 2505.656738,1803.482300 2507.338379,1808.981201 
	C2508.659424,1813.300293 2506.674316,1818.910278 2503.002686,1821.235352 
	C2497.723389,1824.578735 2493.757568,1824.085693 2488.123535,1818.700684 
	C2489.779053,1816.064453 2492.131104,1816.280029 2494.439697,1816.236816 
	C2496.856445,1816.191772 2499.142090,1815.744141 2499.837158,1812.938965 
	C2500.288574,1811.117310 2499.495361,1809.705566 2497.847412,1808.879883 
	C2495.472900,1807.690308 2493.361572,1808.287598 2491.559082,1810.096069 
	C2490.628662,1811.029419 2489.953369,1812.186035 2488.550537,1813.596680 
	C2484.524414,1813.684082 2483.996582,1811.234985 2483.929932,1808.418823 
	C2483.849365,1805.019897 2481.769287,1804.047974 2478.736328,1804.048828 
	C2470.477051,1804.051147 2464.550293,1809.776367 2464.000000,1819.188354 
	C2462.607910,1821.355591 2461.087158,1821.136719 2459.549072,1820.326050 
	C2456.744141,1818.847778 2453.874268,1816.088135 2450.833740,1819.437256 
	C2448.109131,1822.438232 2449.754395,1825.513184 2451.639893,1828.347534 
	C2452.561768,1829.733276 2453.210449,1831.194458 2452.432617,1833.457886 
	C2446.007324,1834.674072 2443.514404,1830.763184 2442.409180,1825.971436 
	C2441.250488,1820.947021 2441.481689,1815.913086 2446.699463,1812.798950 
	C2448.995850,1811.428589 2451.244629,1810.049561 2452.866455,1807.856689 
	C2455.952637,1803.684814 2455.674561,1798.270264 2452.430908,1793.042236 
	C2449.746826,1788.716553 2446.340332,1790.256714 2442.814941,1791.375732 
	C2441.572021,1791.770386 2440.213379,1791.895630 2438.899170,1791.953979 
	C2432.048096,1792.258789 2430.041748,1790.344360 2430.041016,1783.294678 
	C2430.040527,1780.761230 2429.292480,1777.818359 2433.244141,1776.174805 
	C2434.562012,1776.383423 2435.001953,1776.867920 2435.364990,1777.423706 
	C2437.046387,1779.998535 2436.780029,1784.411133 2441.512695,1784.114990 
	C2443.317139,1784.002197 2444.681885,1782.901733 2445.217285,1781.219238 
	C2446.554688,1777.016357 2442.894043,1775.469116 2440.356934,1772.575562 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2140.446289,1799.453247 
	C2133.274414,1804.652344 2133.273682,1805.105103 2136.760498,1811.387939 
	C2140.430176,1818.000732 2145.684570,1821.549561 2153.359619,1822.076172 
	C2160.348633,1822.555664 2164.848877,1828.806519 2163.738525,1835.575928 
	C2162.723877,1841.760742 2156.239502,1846.541748 2149.922363,1845.954834 
	C2146.916016,1845.675537 2144.986328,1844.177979 2143.849609,1841.535645 
	C2142.933838,1839.407471 2142.358398,1837.110352 2141.265869,1835.085693 
	C2139.160889,1831.184814 2135.994385,1829.227051 2131.371582,1830.490967 
	C2126.275391,1831.884521 2121.605957,1836.002075 2122.492676,1839.774414 
	C2124.903564,1850.028076 2117.949707,1853.205322 2110.872314,1856.453979 
	C2109.105957,1857.264526 2107.096680,1857.821777 2105.164795,1857.941040 
	C2100.388428,1858.236084 2099.643311,1860.513672 2101.180420,1864.589111 
	C2103.139404,1869.782593 2101.552734,1874.425293 2098.239014,1878.520386 
	C2095.400879,1882.027832 2089.811768,1883.083862 2086.589600,1880.964111 
	C2083.536377,1878.955322 2083.484375,1875.378540 2086.449707,1870.460815 
	C2086.792236,1869.892700 2087.117188,1869.283691 2087.578125,1868.820923 
	C2094.684570,1861.690186 2099.901123,1854.282593 2096.266113,1843.123169 
	C2094.773682,1838.541870 2098.673340,1835.123657 2103.409424,1833.921265 
	C2109.907715,1832.271729 2112.367432,1828.378906 2112.141357,1821.569946 
	C2111.802734,1811.374023 2112.221191,1811.401245 2121.777832,1807.783447 
	C2127.414307,1805.649536 2133.497803,1803.786133 2132.000000,1794.806641 
	C2133.233154,1793.142700 2134.597900,1793.166504 2136.677246,1793.571777 
	C2138.249268,1794.066772 2139.077637,1794.508789 2140.308594,1795.594482 
	C2141.068359,1797.048950 2141.125977,1797.970947 2140.446289,1799.453247 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2235.350342,1654.849121 
	C2236.571289,1660.037476 2239.421631,1660.127930 2243.205811,1659.368042 
	C2253.935791,1657.213867 2256.969971,1658.598755 2260.310059,1668.777832 
	C2262.241211,1674.662354 2265.361084,1676.748779 2271.203857,1676.067993 
	C2273.471680,1675.803833 2275.976807,1675.849854 2278.111572,1676.552002 
	C2281.920410,1677.804688 2283.855957,1680.713013 2284.001709,1684.893433 
	C2284.157471,1689.365601 2281.546387,1691.499634 2277.906494,1692.984619 
	C2274.111328,1694.532837 2270.755859,1694.386108 2268.325684,1690.550049 
	C2267.081055,1688.585449 2265.690674,1686.702515 2264.579102,1684.666260 
	C2260.575195,1677.330566 2260.449951,1677.236084 2252.351807,1678.872559 
	C2244.814697,1680.395874 2243.420654,1679.771606 2239.577637,1673.060791 
	C2238.916748,1671.906616 2238.212402,1670.740356 2237.792969,1669.490723 
	C2235.784912,1663.508179 2231.657471,1661.371582 2225.488770,1661.917725 
	C2221.586670,1662.262939 2217.579590,1662.507690 2214.232178,1659.283813 
	C2211.111084,1656.277710 2209.069092,1652.990601 2210.293701,1648.690063 
	C2211.552979,1644.267578 2214.584961,1641.085449 2219.201172,1640.223267 
	C2223.605469,1639.400513 2227.859863,1639.873901 2230.797607,1644.053955 
	C2232.950684,1647.117554 2233.821289,1650.689331 2235.350342,1654.849121 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2066.762207,1748.499512 
	C2067.993652,1746.765015 2069.044922,1745.559082 2070.588867,1744.019897 
	C2074.625977,1744.422363 2078.140381,1745.419067 2081.722656,1745.833740 
	C2087.334229,1746.483765 2089.544434,1744.449829 2089.959473,1738.729614 
	C2090.078857,1737.085449 2089.950928,1735.422607 2089.923340,1733.768555 
	C2089.866211,1730.365112 2085.886230,1726.116333 2090.044922,1723.776733 
	C2095.059814,1720.955444 2100.273193,1717.534302 2106.603760,1718.127319 
	C2109.135742,1718.364380 2110.880859,1719.713501 2111.721924,1722.161133 
	C2114.986084,1731.661133 2117.011475,1738.092651 2102.704590,1745.919922 
	C2098.270996,1748.583618 2098.283936,1752.387573 2098.218262,1756.415527 
	C2098.033447,1767.688965 2093.235107,1771.103271 2080.556641,1768.478271 
	C2077.207031,1766.505493 2074.893555,1764.589966 2074.064697,1760.656982 
	C2071.777344,1758.040649 2071.811279,1754.477661 2068.540039,1752.501709 
	C2068.093750,1752.057129 2067.490479,1751.618652 2067.182617,1751.408569 
	C2066.571777,1750.502686 2066.474365,1749.779175 2066.762207,1748.499512 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2312.579590,1859.640625 
	C2309.814941,1859.871338 2308.559326,1858.516846 2307.281982,1856.869385 
	C2304.349854,1853.088257 2300.314453,1853.183105 2296.598633,1855.081055 
	C2292.656738,1857.094482 2291.611572,1860.578735 2292.575195,1865.129517 
	C2294.830322,1875.780273 2294.580322,1876.246216 2285.096680,1881.383301 
	C2281.995850,1883.062744 2279.569092,1886.318970 2274.743164,1885.988159 
	C2273.263184,1884.522827 2272.523682,1883.046997 2271.790283,1881.568237 
	C2265.428223,1868.743774 2266.312988,1864.199463 2277.730469,1855.528931 
	C2282.411377,1851.974243 2285.286133,1848.199341 2283.082031,1842.152832 
	C2282.412109,1840.315308 2282.749023,1838.978149 2285.334961,1838.117920 
	C2288.943115,1839.779053 2289.239502,1843.679199 2292.056641,1845.558716 
	C2294.456787,1847.160156 2296.930420,1847.326172 2299.421875,1845.822144 
	C2300.946777,1844.901611 2301.754150,1843.460083 2301.459473,1841.702393 
	C2300.934326,1838.569336 2298.513184,1837.656738 2295.779053,1837.223755 
	C2292.878174,1836.764282 2289.908203,1838.073730 2286.518066,1836.440918 
	C2290.025635,1827.189697 2295.508545,1825.705688 2303.976318,1831.362671 
	C2306.749756,1833.215454 2309.164551,1835.645874 2310.359619,1838.868896 
	C2312.375977,1844.306396 2316.053223,1846.965088 2321.875732,1845.972778 
	C2328.216553,1844.892212 2330.843750,1848.714233 2332.825928,1853.727661 
	C2334.711670,1858.496338 2334.342773,1862.562012 2330.581543,1866.512329 
	C2326.481689,1870.818359 2321.579834,1870.398682 2316.677490,1869.591309 
	C2313.729248,1869.105835 2313.000732,1866.068115 2312.093750,1862.758545 
	C2314.403076,1859.704956 2316.876465,1861.370728 2319.307373,1861.903320 
	C2322.110840,1862.517456 2324.558838,1862.214111 2325.848877,1859.293945 
	C2326.535645,1857.738892 2326.452393,1856.034424 2325.154297,1854.773315 
	C2322.896240,1852.579834 2320.401611,1853.198608 2317.993896,1854.524292 
	C2315.953613,1855.647583 2314.764404,1857.687256 2312.579590,1859.640625 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2224.067383,1623.825562 
	C2224.370850,1614.063599 2232.214355,1614.398804 2237.755615,1612.623657 
	C2242.510010,1611.100464 2244.502197,1615.669678 2246.599854,1619.052979 
	C2246.949707,1619.617188 2247.508057,1620.092041 2247.719727,1620.696045 
	C2250.437012,1628.445679 2254.780518,1631.924927 2263.426025,1628.317261 
	C2267.036377,1626.810669 2271.353760,1627.665527 2273.201904,1632.606689 
	C2275.379150,1638.428101 2273.427002,1645.065552 2268.327881,1648.435669 
	C2264.207031,1651.159424 2260.819580,1649.915894 2257.695068,1646.686401 
	C2255.843750,1644.773193 2253.763672,1643.057861 2252.077393,1641.013550 
	C2248.833984,1637.081055 2244.833740,1635.862061 2239.774414,1635.891724 
	C2228.541016,1635.957764 2228.287109,1635.534790 2224.067383,1623.825562 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2463.464111,1748.455444 
	C2469.220215,1752.360596 2469.357910,1758.611572 2464.317627,1762.422607 
	C2458.027832,1767.178467 2453.091797,1766.286743 2448.948242,1759.562256 
	C2447.560547,1757.310669 2446.658936,1754.876587 2445.948242,1752.273071 
	C2443.849365,1744.585449 2442.281250,1743.879517 2434.948486,1746.475830 
	C2426.695801,1749.398193 2420.830566,1746.727783 2417.397705,1738.795410 
	C2415.779297,1735.056274 2417.101562,1733.176147 2421.314941,1732.078979 
	C2423.639648,1733.278442 2424.378906,1735.169800 2425.355469,1736.903687 
	C2426.384277,1738.729980 2427.756836,1740.141724 2430.045898,1739.988037 
	C2431.622803,1739.882080 2432.333984,1738.720825 2432.503662,1737.305298 
	C2432.773926,1735.052246 2431.682373,1733.481323 2429.714844,1732.505737 
	C2428.218018,1731.763550 2426.481689,1731.710449 2424.492188,1730.473145 
	C2424.303711,1726.018433 2426.500000,1724.193604 2430.443604,1724.019897 
	C2434.170898,1723.855591 2436.942627,1725.145020 2438.282959,1728.705933 
	C2440.977783,1735.866577 2445.940186,1738.686768 2453.642334,1738.217529 
	C2457.912109,1737.957397 2462.133301,1739.678589 2463.904785,1745.266968 
	C2462.214355,1747.902832 2459.831055,1747.329346 2457.634277,1747.547241 
	C2455.010742,1747.807617 2453.411377,1749.105713 2453.610596,1751.911987 
	C2453.733398,1753.638306 2454.669189,1755.046265 2456.302002,1755.604126 
	C2459.169678,1756.584229 2460.385498,1754.648560 2461.284668,1752.403564 
	C2461.764404,1751.205566 2462.221924,1750.000732 2463.464111,1748.455444 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2232.856445,1756.688965 
	C2234.526611,1757.901489 2235.706787,1758.652832 2236.439941,1759.713013 
	C2241.810059,1767.475586 2241.437256,1772.745605 2233.207275,1776.959595 
	C2225.357178,1780.979004 2222.280029,1785.451416 2224.850098,1794.202759 
	C2226.312012,1799.182129 2222.758545,1803.369873 2217.250244,1805.245728 
	C2211.645752,1807.154419 2207.603760,1805.739624 2204.446045,1800.764038 
	C2201.018555,1795.363037 2201.429932,1791.749634 2205.546631,1787.411987 
	C2207.731201,1785.110229 2210.570801,1784.411133 2213.270264,1783.187744 
	C2218.768311,1780.696411 2220.065918,1777.958008 2219.094971,1772.219849 
	C2217.042480,1760.088623 2219.045654,1757.658569 2232.856445,1756.688965 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2551.477051,1731.566528 
	C2551.096680,1738.416382 2546.202637,1740.692993 2540.903320,1741.778442 
	C2536.399414,1742.700928 2535.344482,1745.038452 2536.627441,1748.809082 
	C2537.613770,1751.707520 2538.218994,1754.578369 2537.931641,1757.591187 
	C2537.419678,1762.958374 2532.426758,1767.323853 2526.273926,1767.912964 
	C2521.283936,1768.390869 2518.418945,1766.330200 2516.695557,1761.171387 
	C2515.662842,1758.080444 2515.912598,1755.292847 2518.237305,1752.866333 
	C2519.616455,1751.427002 2520.785645,1749.585083 2522.456543,1748.660645 
	C2530.247559,1744.349854 2532.967041,1737.494385 2533.449951,1728.538574 
	C2539.367432,1730.581421 2544.751953,1733.070190 2551.477051,1731.566528 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2160.360352,1684.562988 
	C2164.196533,1678.906494 2167.413818,1678.539673 2170.387451,1683.157471 
	C2171.985107,1685.638062 2173.053223,1688.506592 2174.063965,1691.307129 
	C2175.462158,1695.180908 2177.857178,1696.513550 2181.781006,1695.100098 
	C2185.314697,1693.827393 2189.711914,1692.531250 2191.973389,1695.836670 
	C2194.874023,1700.077026 2197.756592,1704.943726 2197.720215,1710.377197 
	C2197.687988,1715.212891 2187.467529,1719.293213 2183.424805,1716.138794 
	C2180.838135,1714.120361 2178.334473,1711.670044 2176.663574,1708.890381 
	C2174.806152,1705.801147 2172.236328,1704.050903 2168.621582,1702.273193 
	C2165.373779,1696.458252 2168.579346,1688.404907 2160.360352,1684.562988 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2180.061035,1656.655762 
	C2181.237793,1650.837280 2183.998779,1651.280273 2186.830078,1654.482178 
	C2188.048584,1655.859985 2188.243896,1658.119873 2188.988037,1659.944946 
	C2190.217285,1662.960693 2190.353271,1666.561157 2193.076904,1668.792236 
	C2195.987061,1671.175659 2198.736816,1668.448975 2201.506592,1668.015625 
	C2210.806641,1666.561157 2215.978027,1679.051392 2213.371338,1684.360962 
	C2211.047119,1689.095581 2205.856445,1689.160645 2201.400391,1689.881104 
	C2197.694580,1690.480347 2194.975098,1688.667480 2193.668701,1685.134155 
	C2192.877197,1682.993530 2192.439453,1680.724609 2191.776855,1678.533203 
	C2190.803223,1675.313477 2189.804443,1672.078857 2184.757324,1672.020264 
	C2181.377441,1667.454956 2183.713867,1661.600586 2180.061035,1656.655762 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2215.742676,1618.349365 
	C2213.735107,1618.978027 2212.500000,1619.676270 2211.232178,1619.741821 
	C2207.385498,1619.940918 2202.631348,1621.320190 2200.834229,1616.551636 
	C2199.222412,1612.274414 2198.978027,1607.486572 2201.892090,1603.292480 
	C2205.126465,1598.637695 2210.936768,1595.846802 2214.322021,1597.257324 
	C2218.103760,1598.833130 2223.840576,1607.828857 2223.269775,1611.855835 
	C2222.742188,1615.581055 2219.885498,1617.249512 2215.742676,1618.349365 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2323.905273,1735.956787 
	C2324.950684,1738.512207 2325.724854,1740.340332 2326.301758,1742.228882 
	C2328.098633,1748.112305 2327.228516,1751.109741 2323.249268,1753.124634 
	C2319.626465,1754.958862 2311.461426,1754.120605 2309.167725,1751.678955 
	C2305.419922,1747.689087 2303.995850,1738.266724 2306.692383,1735.299072 
	C2310.542969,1731.061401 2317.106201,1731.045166 2323.905273,1735.956787 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2107.250000,1708.375488 
	C2105.794434,1698.893555 2106.639404,1696.815308 2112.561279,1693.770630 
	C2118.075684,1690.935669 2121.518799,1691.694092 2125.544922,1696.630371 
	C2129.099609,1700.988647 2128.931885,1705.589355 2124.998047,1709.940552 
	C2124.115234,1710.916870 2123.148682,1711.849365 2122.096191,1712.635498 
	C2115.310059,1717.703613 2112.196045,1716.925903 2107.250000,1708.375488 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2154.403809,1726.399780 
	C2143.619873,1731.598877 2135.946533,1728.322144 2134.473145,1718.665649 
	C2134.212402,1716.954102 2134.378906,1715.432983 2135.348389,1713.944214 
	C2138.022217,1709.837769 2147.775391,1706.797241 2151.411621,1708.998291 
	C2156.755127,1712.232422 2158.368652,1719.863403 2154.403809,1726.399780 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2342.456055,1864.522461 
	C2342.860352,1858.699585 2347.072510,1860.122681 2350.317383,1860.047241 
	C2354.757324,1859.944214 2357.828125,1858.600464 2357.981445,1852.791748 
	C2364.928223,1852.144897 2371.196289,1851.208496 2373.472656,1842.438721 
	C2378.937744,1847.649902 2379.348389,1852.813599 2373.505127,1856.712524 
	C2367.833984,1860.496704 2366.211670,1864.921265 2365.534424,1871.318237 
	C2364.795166,1878.298584 2359.533447,1882.831177 2352.971680,1885.319214 
	C2350.457520,1886.272583 2347.744873,1886.695679 2346.138184,1882.703369 
	C2348.939941,1878.261963 2356.565186,1878.333740 2355.804443,1871.995361 
	C2354.922363,1864.643311 2346.923340,1868.022827 2342.456055,1864.522461 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2296.799805,1596.000000 
	C2288.035400,1595.140381 2286.416748,1593.691528 2286.029785,1587.078003 
	C2285.668457,1580.902588 2288.234619,1577.093262 2293.414307,1576.116455 
	C2299.682373,1574.934692 2305.174805,1577.786743 2307.321533,1582.751465 
	C2309.461670,1587.701294 2305.424316,1590.672485 2304.090820,1595.264404 
	C2301.866699,1595.996826 2299.733154,1595.998413 2296.799805,1596.000000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2162.798096,1798.827637 
	C2172.410645,1795.968628 2177.018311,1797.731445 2180.421875,1804.952393 
	C2182.713867,1809.814819 2182.123291,1811.973755 2177.045898,1814.332153 
	C2173.569092,1815.947388 2170.023682,1818.147949 2165.846436,1816.833496 
	C2157.325684,1814.151855 2155.863037,1807.132568 2162.798096,1798.827637 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2184.006836,1636.438477 
	C2185.823975,1628.915283 2190.370605,1625.202393 2195.441162,1626.259155 
	C2199.745605,1627.156128 2204.194580,1633.671021 2203.863770,1638.592407 
	C2203.473389,1644.394043 2198.781738,1648.077026 2191.909668,1647.976196 
	C2185.459473,1647.881714 2184.581543,1646.694580 2184.006836,1636.438477 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2086.340820,1799.663086 
	C2090.583252,1792.818604 2096.637451,1790.335205 2102.110596,1792.416260 
	C2104.993408,1793.512451 2109.944580,1802.036499 2109.831055,1805.746094 
	C2109.697510,1810.109985 2106.368896,1811.128418 2103.071777,1811.775269 
	C2096.466797,1813.070801 2090.987305,1809.216797 2086.340820,1799.663086 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2058.644531,1786.973999 
	C2059.462646,1777.368042 2062.447266,1775.028198 2071.372559,1776.043579 
	C2077.836426,1776.778931 2080.902344,1781.074097 2079.928711,1788.029297 
	C2079.197266,1793.252930 2075.618408,1796.293823 2070.314209,1795.905884 
	C2064.907959,1795.510254 2060.898926,1792.968994 2058.644531,1786.973999 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2151.453125,1659.206421 
	C2144.378174,1657.916382 2140.006348,1653.363647 2140.291260,1648.611816 
	C2140.512207,1644.926147 2145.816406,1639.386230 2150.145264,1638.319580 
	C2153.968018,1637.377441 2159.239746,1640.565063 2161.247314,1645.032471 
	C2163.332031,1649.671265 2161.946533,1654.772461 2157.791016,1656.956665 
	C2156.053223,1657.870117 2154.052246,1658.283447 2151.453125,1659.206421 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2139.609375,1683.383179 
	C2132.651367,1688.720703 2131.805908,1688.768921 2127.604980,1684.573242 
	C2123.428955,1680.402466 2122.635010,1673.445923 2125.868652,1669.357666 
	C2128.533691,1665.988403 2135.412109,1664.788818 2139.460205,1666.987427 
	C2143.894043,1669.395264 2145.198975,1674.309570 2142.690674,1679.857300 
	C2142.172363,1681.003540 2141.009521,1681.858276 2139.609375,1683.383179 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2253.138184,1734.576782 
	C2256.454834,1739.051758 2255.720947,1743.000732 2252.565918,1745.849487 
	C2249.427002,1748.683838 2245.256104,1750.458862 2240.802002,1749.175781 
	C2236.546143,1747.949951 2234.575928,1744.562256 2234.101807,1740.306763 
	C2233.469971,1734.639404 2236.574463,1730.715576 2242.206543,1730.075928 
	C2246.331543,1729.607544 2250.109131,1730.240967 2253.138184,1734.576782 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2423.047363,1798.636230 
	C2426.108887,1797.872925 2428.322998,1798.127930 2430.436768,1799.308228 
	C2434.859375,1801.777954 2436.997803,1806.819214 2435.300781,1810.879395 
	C2433.455566,1815.295044 2427.864502,1818.597046 2423.408936,1817.902954 
	C2418.923584,1817.203979 2413.915771,1811.835693 2414.154785,1807.785400 
	C2414.456299,1802.668945 2418.431152,1800.798706 2423.047363,1798.636230 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2315.419922,1879.527344 
	C2316.214844,1885.878784 2317.213623,1891.434204 2309.945312,1894.133057 
	C2304.244873,1896.249756 2299.778809,1895.020386 2296.933350,1889.420410 
	C2294.583740,1884.796265 2296.267090,1879.086914 2301.054932,1876.755615 
	C2306.068359,1874.314453 2311.125000,1873.377075 2315.419922,1879.527344 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2080.083008,1768.697754 
	C2081.630127,1767.999634 2083.262939,1768.056763 2084.890137,1767.989258 
	C2093.923828,1767.614746 2097.066162,1764.482788 2096.802734,1755.542847 
	C2096.689453,1751.698364 2095.013184,1747.547241 2101.310059,1746.081787 
	C2101.479980,1749.787476 2099.708252,1753.277222 2099.932373,1757.289917 
	C2100.315918,1764.163574 2100.486084,1764.551392 2109.186523,1765.997314 
	C2108.739746,1773.605225 2109.646729,1779.891724 2119.554932,1781.486084 
	C2114.927490,1789.426758 2109.571777,1789.968384 2104.909424,1783.431152 
	C2103.776123,1781.842041 2102.983643,1779.999268 2102.116455,1778.233154 
	C2097.447266,1768.726074 2097.381836,1768.528198 2087.681885,1772.247681 
	C2083.868652,1773.709961 2081.391846,1773.752563 2080.083008,1768.697754 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2258.506592,1606.614746 
	C2247.752686,1608.454590 2243.028564,1605.912842 2242.104736,1598.558716 
	C2241.447266,1593.324097 2243.806885,1590.094482 2249.456299,1588.497437 
	C2254.554932,1587.056152 2258.160156,1588.296387 2260.227295,1592.717773 
	C2262.369629,1597.299927 2263.863525,1602.053345 2258.506592,1606.614746 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2313.399414,1825.198242 
	C2305.574951,1825.817139 2303.078857,1820.442749 2300.986572,1815.289429 
	C2299.593750,1811.858643 2302.257568,1808.947510 2304.577393,1806.623413 
	C2309.209229,1801.983154 2315.534180,1803.183716 2318.453369,1809.045654 
	C2321.723633,1815.612427 2320.432861,1820.312378 2313.399414,1825.198242 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2230.377197,1686.065674 
	C2234.438477,1686.168823 2238.101074,1685.130371 2240.515137,1688.044189 
	C2243.080322,1691.140137 2244.851807,1694.510498 2242.591553,1698.874023 
	C2239.930664,1704.011353 2236.650146,1706.340942 2231.888428,1705.945557 
	C2226.861084,1705.528198 2225.490723,1701.676758 2224.376709,1697.910645 
	C2222.760742,1692.449585 2224.287842,1689.400879 2230.377197,1686.065674 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2135.442627,1851.332764 
	C2142.050781,1851.065552 2146.017090,1853.411255 2147.556885,1857.772827 
	C2149.211670,1862.458618 2147.624023,1866.626221 2143.417480,1869.713501 
	C2140.112549,1872.139160 2136.937988,1872.832031 2133.466309,1870.255249 
	C2129.783691,1867.521973 2127.607422,1861.749146 2129.021729,1858.115112 
	C2130.125244,1855.279785 2131.717773,1852.794189 2135.442627,1851.332764 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2380.000000,1775.200073 
	C2379.221191,1781.871948 2375.047363,1784.598145 2369.942383,1785.185547 
	C2366.724609,1785.555664 2363.846680,1783.224365 2362.063232,1780.095337 
	C2360.092773,1776.639038 2359.300049,1773.419800 2362.681152,1770.312988 
	C2364.131348,1768.980347 2365.481689,1767.498535 2365.918213,1764.712158 
	C2367.575195,1763.373779 2369.150146,1762.742676 2371.362793,1762.058228 
	C2375.304932,1762.394043 2377.172363,1764.783325 2379.545898,1767.550415 
	C2380.000000,1770.133423 2380.000000,1772.266724 2380.000000,1775.200073 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2252.833984,1772.220703 
	C2262.453857,1772.751099 2266.512207,1778.701294 2263.448975,1786.475830 
	C2262.082764,1789.944214 2256.530029,1793.728149 2253.352295,1793.356812 
	C2249.664062,1792.925659 2246.260010,1788.706909 2246.110596,1783.897339 
	C2245.959961,1779.049561 2247.311279,1774.790405 2252.833984,1772.220703 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2341.404785,1864.312744 
	C2344.660400,1864.002808 2347.324951,1864.105713 2349.979980,1863.986084 
	C2354.464844,1863.784180 2357.915771,1865.496948 2359.478760,1869.713623 
	C2361.183105,1874.312378 2357.980469,1877.127441 2355.004395,1879.907837 
	C2352.852295,1881.918457 2350.241211,1882.040283 2346.775146,1881.998535 
	C2340.965088,1877.195801 2336.945312,1872.088257 2341.404785,1864.312744 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2301.880371,1657.972412 
	C2301.367432,1662.403809 2298.757812,1664.291504 2295.860107,1666.063599 
	C2292.340332,1668.216309 2288.630371,1668.545654 2285.909180,1665.525635 
	C2283.335449,1662.669312 2281.341309,1658.988892 2283.671387,1654.792847 
	C2284.308350,1653.645508 2284.912598,1652.444702 2285.745605,1651.447144 
	C2291.269775,1644.832031 2296.006104,1645.196045 2300.211670,1652.603516 
	C2301.007568,1654.005127 2301.336670,1655.671753 2301.880371,1657.972412 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2327.451660,1648.173828 
	C2325.331055,1644.146851 2326.074707,1641.245972 2328.566895,1638.432983 
	C2332.625977,1633.851562 2336.038574,1633.550537 2340.349854,1637.701538 
	C2346.349365,1643.477905 2347.510254,1649.267334 2343.490723,1653.366699 
	C2339.251953,1657.689697 2335.717773,1656.649536 2327.451660,1648.173828 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2404.020508,1764.001953 
	C2403.984863,1760.380615 2404.545166,1757.605835 2407.435303,1756.629150 
	C2410.195557,1755.696289 2412.921387,1753.596680 2415.951660,1754.505371 
	C2420.846191,1755.972900 2422.186768,1759.878540 2422.021240,1764.637329 
	C2421.880615,1768.682251 2422.215332,1772.842896 2416.787842,1773.853271 
	C2410.919678,1774.945801 2406.206299,1771.629761 2404.020508,1764.001953 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2472.533691,1714.867188 
	C2479.369629,1715.163330 2481.469727,1719.192871 2481.949219,1724.652954 
	C2482.329590,1728.984741 2479.916016,1731.298950 2476.244629,1732.830444 
	C2470.601807,1735.184448 2466.680908,1733.454834 2463.636963,1727.168701 
	C2461.114990,1721.960571 2462.097412,1719.465454 2468.083984,1716.303223 
	C2469.226318,1715.699951 2470.577881,1715.492554 2472.533691,1714.867188 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2508.008301,1898.705566 
	C2510.703613,1897.047119 2511.494385,1894.145386 2513.529541,1892.545532 
	C2519.846680,1887.578735 2526.934570,1890.435547 2527.903809,1898.390747 
	C2528.219727,1900.984985 2527.983643,1903.646362 2528.000000,1907.136108 
	C2527.111084,1907.996826 2526.222168,1907.998413 2524.666504,1908.000000 
	C2521.400391,1910.241577 2518.567871,1910.609253 2514.748535,1908.528442 
	C2510.588623,1906.124023 2507.939209,1903.717407 2508.008301,1898.705566 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2544.076660,1792.109497 
	C2549.429688,1795.936646 2548.639404,1800.682007 2547.048828,1805.035278 
	C2545.690674,1808.754150 2542.280762,1810.160767 2538.188477,1809.971191 
	C2533.102051,1809.735229 2531.549561,1805.958862 2530.466553,1802.171021 
	C2529.452637,1798.624390 2529.447021,1794.861328 2533.243652,1792.472168 
	C2536.484619,1790.433105 2539.810303,1789.272461 2544.076660,1792.109497 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2486.335938,1846.485840 
	C2482.165771,1850.783691 2478.382324,1850.980103 2474.466797,1847.405762 
	C2471.676758,1844.859131 2469.188477,1842.165039 2470.387207,1837.941406 
	C2471.587646,1833.712769 2478.835938,1829.402954 2483.227783,1830.226562 
	C2486.982910,1830.930786 2489.869141,1836.252197 2489.012695,1841.471680 
	C2488.756592,1843.031494 2487.579102,1844.439941 2486.335938,1846.485840 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2297.283691,1730.912354 
	C2295.209473,1734.220825 2292.693604,1735.482544 2289.706787,1736.409546 
	C2282.177490,1738.746216 2278.146240,1736.071899 2278.021484,1728.300049 
	C2277.919434,1721.942261 2279.880859,1719.973999 2286.270996,1720.021240 
	C2293.796631,1720.077026 2296.645996,1722.639893 2297.283691,1730.912354 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2227.361816,1591.779419 
	C2225.922363,1591.916504 2225.223877,1592.074219 2224.601074,1591.921631 
	C2217.981934,1590.301392 2215.515869,1587.395142 2216.079590,1581.968018 
	C2216.494629,1577.972656 2220.380859,1574.581177 2225.040527,1574.148071 
	C2228.736816,1573.804443 2234.578857,1577.896362 2235.574219,1581.861694 
	C2237.132324,1588.069580 2232.644287,1589.924194 2227.361816,1591.779419 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2208.725098,1744.129761 
	C2210.548828,1755.518311 2206.978760,1760.480347 2198.346924,1759.945679 
	C2194.364014,1759.698975 2192.223633,1757.766479 2192.082275,1753.750122 
	C2191.916748,1749.064575 2193.484375,1745.334595 2197.872559,1743.074707 
	C2201.455322,1741.229736 2204.993896,1738.796265 2208.725098,1744.129761 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2373.554199,1841.477051 
	C2373.994141,1842.996460 2374.110107,1844.006226 2373.963623,1844.976685 
	C2372.440430,1855.069824 2368.843262,1856.914673 2358.629395,1852.280762 
	C2357.080078,1849.551758 2354.457520,1848.088257 2354.062500,1844.650146 
	C2354.476807,1840.785400 2356.672607,1838.689575 2359.417480,1836.288574 
	C2365.277588,1835.245239 2368.510742,1839.905640 2373.554199,1841.477051 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2449.618164,1940.500000 
	C2451.411133,1938.965332 2451.591064,1937.386719 2452.097900,1935.844360 
	C2454.506836,1928.513672 2458.937744,1926.938721 2465.916016,1930.697632 
	C2466.757568,1931.151123 2467.679443,1931.455078 2469.282227,1931.914185 
	C2470.000000,1932.888916 2470.000000,1933.777832 2470.000000,1935.333374 
	C2467.822998,1947.002930 2461.754883,1949.055298 2450.724121,1942.137207 
	C2449.745361,1941.666626 2449.490967,1941.333374 2449.618164,1940.500000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2256.500000,1863.999268 
	C2254.029053,1863.996460 2252.050781,1864.100830 2250.088379,1863.969238 
	C2243.714355,1863.542236 2241.571533,1861.506470 2242.229492,1856.652588 
	C2243.056152,1850.554688 2248.551270,1845.374756 2253.278320,1846.237061 
	C2257.829346,1847.067383 2260.420654,1851.404785 2259.448242,1856.735840 
	C2259.098145,1858.655762 2258.511719,1860.532471 2258.016602,1863.212036 
	C2257.666748,1863.996216 2257.333252,1863.997437 2256.500000,1863.999268 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2218.709473,1731.371094 
	C2212.809082,1732.765503 2208.728027,1731.440674 2207.145264,1725.970093 
	C2205.860596,1721.530518 2208.253662,1718.444458 2211.804932,1716.160889 
	C2216.051270,1713.430664 2220.243652,1713.920410 2223.352539,1717.378296 
	C2226.603760,1720.994507 2226.383545,1724.010010 2222.409180,1728.515991 
	C2221.550293,1729.489990 2220.419922,1730.224731 2218.709473,1731.371094 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2166.718018,1728.443359 
	C2168.860352,1726.528442 2170.721436,1726.089966 2172.751953,1726.026123 
	C2179.503662,1725.813965 2182.025146,1727.750854 2181.948242,1733.169312 
	C2181.871094,1738.610962 2176.054443,1744.412231 2171.235352,1743.854248 
	C2165.677979,1743.210815 2163.371094,1736.479858 2166.718018,1728.443359 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2505.045410,1749.123047 
	C2499.759033,1750.769165 2496.065186,1749.493896 2492.887207,1745.923462 
	C2490.489990,1743.229980 2489.143799,1740.400391 2490.816162,1737.017578 
	C2492.357910,1733.899658 2494.925049,1731.601318 2498.640625,1732.216064 
	C2502.535645,1732.860596 2506.688232,1733.982910 2507.635986,1738.587402 
	C2508.348877,1742.048584 2508.836426,1745.820801 2505.045410,1749.123047 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2452.556641,1717.394531 
	C2450.349854,1720.282227 2447.881104,1721.152588 2444.662109,1721.932617 
	C2438.489502,1718.613037 2434.531494,1714.492310 2437.505859,1706.654053 
	C2438.980713,1704.830688 2439.961426,1703.661377 2441.471191,1702.246094 
	C2444.621338,1699.883057 2447.478760,1699.702271 2451.255859,1701.481323 
	C2453.749268,1703.086670 2453.985840,1704.819946 2453.994629,1707.326416 
	C2456.642578,1711.226074 2455.643066,1714.084717 2452.556641,1717.394531 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2265.615967,1717.260864 
	C2262.436035,1719.696289 2259.969238,1722.170288 2256.210205,1720.971558 
	C2252.031738,1719.639160 2249.423828,1714.660767 2250.788574,1710.661743 
	C2252.180908,1706.580078 2259.025879,1701.640259 2262.153809,1702.459351 
	C2266.398193,1703.570801 2268.193848,1710.010620 2265.615967,1717.260864 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2191.531494,1774.516357 
	C2198.057129,1775.335938 2195.628418,1780.171143 2195.831543,1783.737061 
	C2196.044922,1787.486816 2192.991455,1789.043335 2190.061035,1789.558594 
	C2178.147949,1791.653564 2172.831299,1787.625732 2174.175049,1777.462646 
	C2175.052734,1770.824097 2184.269287,1766.151978 2190.464844,1768.952271 
	C2191.819580,1769.564697 2191.751709,1771.151123 2191.973145,1773.225830 
	C2191.530762,1774.475220 2190.990723,1774.830078 2190.407959,1775.122314 
	C2187.764160,1776.448364 2183.249023,1774.985474 2183.056396,1779.917603 
	C2183.017822,1780.904663 2184.040527,1781.707397 2185.057617,1781.756714 
	C2189.763428,1781.984863 2188.871826,1777.116943 2191.531494,1774.516357 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2344.576660,1839.474365 
	C2343.111084,1839.995483 2342.222168,1839.995850 2340.666504,1839.995605 
	C2328.710449,1837.695068 2326.511963,1833.618652 2331.481445,1822.619263 
	C2332.000000,1822.000000 2333.000000,1822.000000 2333.500000,1822.000000 
	C2340.937988,1816.814575 2345.753418,1820.689941 2349.549561,1826.175659 
	C2353.559326,1831.970337 2350.163330,1835.901733 2344.576660,1839.474365 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2341.562256,1895.441895 
	C2341.877930,1900.820923 2343.117920,1906.102295 2336.883789,1908.552612 
	C2333.645020,1909.825562 2330.799561,1910.738892 2327.857910,1907.833618 
	C2325.386475,1905.392456 2323.177246,1903.197388 2325.193604,1899.366821 
	C2325.776123,1898.260376 2325.729004,1896.822632 2325.985352,1894.768311 
	C2331.134766,1892.697144 2336.326904,1890.414917 2341.562256,1895.441895 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2286.000000,1836.500000 
	C2289.615479,1835.656616 2292.864258,1833.381226 2296.697266,1834.089722 
	C2300.965576,1834.878784 2304.557617,1836.865723 2305.194336,1841.313232 
	C2305.681885,1844.716797 2303.780518,1847.781494 2300.480713,1849.387207 
	C2296.895264,1851.131836 2290.718506,1849.882935 2288.666748,1846.943726 
	C2287.147705,1844.767456 2285.964844,1842.341553 2286.014648,1838.769531 
	C2286.000000,1838.000000 2286.000000,1837.000000 2286.000000,1836.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2296.286133,1628.473145 
	C2298.834473,1623.501343 2302.775391,1622.254272 2307.265381,1622.049683 
	C2312.329102,1621.819092 2314.162109,1625.436890 2315.385254,1629.298584 
	C2316.696045,1633.438110 2313.694336,1635.223511 2310.530518,1636.661499 
	C2303.079590,1640.047241 2298.962646,1637.920898 2296.286133,1628.473145 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2175.767822,1623.341431 
	C2172.895996,1628.271362 2169.371094,1631.038696 2164.239990,1628.747681 
	C2160.375244,1627.022095 2158.728516,1620.291138 2160.511475,1615.610962 
	C2162.676514,1609.926270 2167.457520,1608.907349 2172.040527,1613.032837 
	C2174.924316,1615.629028 2176.490234,1618.640137 2175.767822,1623.341431 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2329.254883,1778.000732 
	C2331.492432,1780.791382 2333.405518,1783.104492 2337.334473,1783.935181 
	C2337.993408,1784.888916 2337.996826,1785.777832 2338.000000,1787.333374 
	C2336.851074,1789.227173 2336.299072,1790.884644 2335.254883,1792.129761 
	C2331.315674,1796.825317 2326.179688,1800.195190 2320.660156,1796.002197 
	C2315.916992,1792.399048 2314.070801,1786.815552 2319.428223,1780.619385 
	C2322.647949,1778.531006 2325.451904,1777.725830 2329.254883,1778.000732 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2146.323242,1570.031006 
	C2149.299072,1569.817383 2151.608643,1569.739746 2153.850830,1570.091553 
	C2159.599121,1570.993774 2162.787598,1575.144165 2161.864258,1580.246094 
	C2161.173096,1584.064575 2157.277100,1586.405884 2151.868652,1585.820679 
	C2149.317139,1585.544678 2146.843018,1584.551880 2143.468506,1583.742188 
	C2141.442383,1578.692505 2143.983398,1574.630127 2146.323242,1570.031006 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2262.353027,1754.136841 
	C2263.024170,1752.215332 2263.392334,1750.873413 2264.175537,1749.849365 
	C2267.830078,1745.072876 2274.064941,1743.439209 2277.855469,1746.138428 
	C2282.206055,1749.236694 2283.562256,1757.819946 2280.407715,1762.293701 
	C2277.586914,1766.294312 2273.136475,1767.238770 2269.302002,1764.012329 
	C2266.370361,1761.545044 2262.784180,1759.293457 2262.353027,1754.136841 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2494.000000,1765.500000 
	C2493.116455,1777.802612 2489.994629,1779.339355 2476.714844,1774.078613 
	C2476.000000,1774.000000 2476.000000,1773.000000 2476.000000,1772.500000 
	C2472.185059,1766.142334 2474.613281,1762.585693 2481.166992,1760.121338 
	C2483.500000,1760.000000 2485.000000,1760.000000 2487.250000,1760.000000 
	C2490.244141,1760.170166 2491.642334,1761.721069 2493.561035,1763.569336 
	C2494.000000,1764.000000 2494.000000,1765.000000 2494.000000,1765.500000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2406.000000,1787.333374 
	C2405.326172,1796.738647 2402.083496,1800.802734 2396.631104,1799.741943 
	C2391.050049,1798.656128 2389.183838,1793.685913 2391.262451,1785.427368 
	C2391.421875,1784.793457 2391.624512,1784.170288 2391.903320,1782.773560 
	C2392.888916,1782.003296 2393.777832,1782.001709 2395.333496,1782.000000 
	C2399.226074,1779.357300 2402.084717,1780.357422 2405.394531,1783.443359 
	C2406.000000,1784.888916 2406.000000,1785.777832 2406.000000,1787.333374 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2159.202637,1684.031982 
	C2170.172119,1685.999634 2171.585449,1688.839600 2168.096191,1701.228394 
	C2164.255615,1702.373657 2160.826416,1700.922974 2157.676270,1699.417725 
	C2152.041260,1696.725098 2152.603760,1687.958374 2159.202637,1684.031982 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2062.885742,1867.157227 
	C2058.940186,1863.146240 2056.826172,1859.333618 2059.841064,1854.371216 
	C2062.372070,1850.205444 2067.924805,1848.604004 2071.668213,1851.194702 
	C2075.510498,1853.853882 2076.287842,1859.625977 2073.067139,1863.370728 
	C2070.623535,1866.211670 2067.550537,1868.064575 2062.885742,1867.157227 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2123.637207,1739.295532 
	C2127.910156,1737.740479 2131.703613,1736.967773 2134.511230,1740.074341 
	C2136.658691,1742.450562 2138.847412,1745.448242 2137.171875,1749.039185 
	C2135.520996,1752.577759 2132.254395,1754.655762 2128.630371,1755.230103 
	C2125.190186,1755.775269 2123.465332,1752.670654 2122.104980,1750.038208 
	C2120.279785,1746.505493 2118.124512,1742.738770 2123.637207,1739.295532 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2197.191895,1574.543823 
	C2192.670898,1572.696777 2189.405762,1570.507080 2188.381348,1566.184570 
	C2187.737305,1563.466797 2187.922607,1560.734131 2190.578613,1559.098755 
	C2194.284668,1556.817139 2197.658936,1558.646729 2200.817871,1560.529541 
	C2204.124023,1562.500366 2206.796143,1565.238037 2205.653564,1569.436523 
	C2204.652588,1573.114868 2202.636963,1576.199341 2197.191895,1574.543823 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2120.545410,1781.473877 
	C2119.035645,1781.999878 2118.071045,1782.015747 2117.106934,1781.997437 
	C2105.159668,1781.770264 2103.028809,1777.748291 2109.660400,1766.654053 
	C2111.086182,1764.249756 2112.820068,1764.014526 2115.326416,1764.005371 
	C2117.048584,1765.084717 2118.129150,1766.137451 2119.604492,1767.595459 
	C2123.310791,1772.067627 2122.221191,1776.505859 2120.545410,1781.473877 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2392.033691,1720.863037 
	C2392.268066,1715.910889 2394.553467,1714.030884 2399.273438,1714.010498 
	C2404.832031,1710.761353 2409.132080,1711.686646 2411.357422,1716.822876 
	C2413.693359,1722.214233 2412.218750,1727.191528 2406.726318,1730.284424 
	C2402.089844,1732.895264 2397.901367,1732.439941 2394.545166,1728.046021 
	C2393.135742,1726.200439 2392.131592,1724.130737 2392.033691,1720.863037 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2212.666504,1874.000000 
	C2210.345703,1873.947632 2208.604736,1874.211304 2207.052734,1873.785767 
	C2201.781738,1872.340942 2198.896240,1868.068604 2200.202637,1863.445801 
	C2201.532471,1858.738647 2205.498047,1857.958252 2209.658936,1858.099731 
	C2214.135254,1858.252197 2217.417725,1861.916382 2217.303711,1866.728027 
	C2217.258057,1868.660400 2216.472412,1870.575439 2216.011719,1873.246826 
	C2215.111084,1873.996704 2214.222168,1873.998291 2212.666504,1874.000000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2452.666504,1833.995850 
	C2451.869629,1831.833618 2450.314941,1830.737793 2448.947510,1829.283813 
	C2444.930176,1825.011841 2445.017578,1819.936157 2448.747070,1816.397339 
	C2452.375732,1812.954224 2455.227783,1813.401367 2460.237793,1818.121094 
	C2460.928711,1818.771973 2461.813232,1819.217041 2463.304199,1819.878662 
	C2464.000000,1821.500000 2464.000000,1823.000000 2464.000000,1825.250000 
	C2462.454834,1829.191895 2459.401367,1830.872803 2456.445312,1833.546265 
	C2455.111084,1833.995605 2454.222168,1833.996094 2452.666504,1833.995850 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2355.427246,1665.924316 
	C2354.151367,1661.282349 2351.894287,1656.934692 2357.104248,1654.100708 
	C2361.089844,1651.932983 2365.904297,1652.574341 2368.611328,1656.081787 
	C2370.515869,1658.549438 2372.846436,1661.214844 2370.102295,1664.849854 
	C2366.667725,1669.399170 2363.914062,1670.352539 2358.402832,1668.108154 
	C2357.509766,1667.744507 2356.744629,1667.067017 2355.427246,1665.924316 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2410.355957,1702.875000 
	C2407.113770,1699.264404 2407.943115,1695.509277 2408.139404,1691.999146 
	C2408.389893,1687.522827 2411.090576,1684.820190 2415.524902,1684.126343 
	C2420.405273,1683.362793 2423.453369,1685.847412 2425.957520,1689.837036 
	C2428.495117,1693.879395 2426.873291,1696.515381 2423.876465,1699.145020 
	C2420.149902,1702.415039 2417.316162,1708.245483 2410.355957,1702.875000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2272.000000,1616.666626 
	C2272.093750,1613.404541 2271.666260,1610.731567 2273.097412,1608.330933 
	C2275.293945,1604.646362 2280.888428,1602.796753 2284.227539,1604.641479 
	C2287.960693,1606.703979 2288.937988,1612.860107 2286.089600,1616.759033 
	C2282.805908,1621.253662 2278.751953,1623.069214 2272.725342,1620.082520 
	C2272.000000,1619.111084 2272.000000,1618.222168 2272.000000,1616.666626 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2468.103027,1912.743408 
	C2469.932861,1902.559326 2470.446777,1902.200928 2483.168945,1902.000000 
	C2484.000000,1903.500000 2484.000000,1905.000000 2484.000000,1907.250000 
	C2485.155518,1909.371826 2485.480225,1910.912842 2484.471191,1913.314697 
	C2477.325195,1919.824829 2473.782715,1919.709717 2468.103027,1912.743408 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2147.094482,1568.945312 
	C2144.828125,1573.565674 2143.895508,1577.859253 2142.706299,1582.850708 
	C2140.948242,1587.911987 2139.293457,1592.223633 2137.628174,1597.256592 
	C2140.012695,1603.258545 2137.901367,1607.436523 2133.577148,1611.465088 
	C2131.030029,1615.201660 2129.273438,1618.739746 2126.962158,1622.654785 
	C2126.539551,1614.469238 2131.467529,1607.427246 2133.944092,1599.608032 
	C2138.718018,1584.535645 2144.086670,1569.651733 2149.714844,1554.373901 
	C2151.161133,1559.191895 2147.785645,1563.393677 2147.094482,1568.945312 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2371.698730,1695.832275 
	C2376.332520,1693.622559 2379.505859,1694.860229 2381.853516,1698.179199 
	C2384.284180,1701.615967 2385.030029,1705.624512 2382.965576,1709.378052 
	C2381.039307,1712.880005 2377.883789,1715.390381 2374.070068,1716.890137 
	C2372.813232,1717.384399 2371.456055,1717.750488 2370.345459,1716.771851 
	C2366.377930,1713.276245 2365.310059,1708.236694 2364.502197,1703.508179 
	C2363.794189,1699.365112 2367.328613,1697.259155 2371.698730,1695.832275 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2362.293457,1722.069336 
	C2369.175293,1724.918579 2371.255371,1728.924927 2369.805908,1734.999268 
	C2368.916992,1738.724121 2364.535645,1741.821533 2360.090576,1741.867554 
	C2355.623535,1741.913574 2349.458008,1737.886841 2348.423340,1734.085083 
	C2347.784668,1731.738281 2348.058350,1729.581543 2350.310303,1727.980347 
	C2353.785400,1725.509155 2357.041992,1722.668213 2362.293457,1722.069336 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2393.301270,1739.493652 
	C2394.000000,1741.500000 2394.000000,1743.000000 2394.000000,1745.250000 
	C2396.750977,1749.815308 2396.483398,1753.405273 2392.598145,1757.382568 
	C2390.500000,1757.996826 2389.000000,1757.998413 2386.750000,1758.000000 
	C2377.707764,1757.649658 2376.470215,1755.050903 2379.500488,1742.652588 
	C2383.675781,1738.800171 2387.655029,1736.869019 2393.301270,1739.493652 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2463.407959,1858.047485 
	C2469.703857,1857.320190 2472.071533,1860.981934 2473.549316,1865.545410 
	C2475.020020,1870.088989 2472.519775,1872.827759 2468.426270,1875.444092 
	C2467.111084,1876.000000 2466.222168,1876.000000 2464.666504,1876.000000 
	C2462.809082,1875.956299 2461.734863,1875.593140 2460.402832,1874.416748 
	C2459.366699,1873.779663 2458.849854,1873.400513 2458.224854,1872.431396 
	C2454.800049,1868.131958 2456.525879,1864.679810 2459.452148,1860.641357 
	C2460.938721,1859.364990 2461.877441,1858.729980 2463.407959,1858.047485 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2312.000000,1860.500000 
	C2311.328613,1854.046509 2315.217285,1851.653564 2319.970459,1850.407227 
	C2323.193848,1849.562256 2326.585205,1849.430420 2328.534668,1853.266602 
	C2330.157471,1856.460205 2330.619385,1859.526611 2328.238281,1862.529297 
	C2325.971680,1865.388062 2323.074707,1866.772705 2319.518066,1865.430176 
	C2317.392822,1864.628052 2315.472900,1863.281738 2312.730469,1862.089966 
	C2312.000000,1862.000000 2312.000000,1861.000000 2312.000000,1860.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2185.966309,1599.955811 
	C2184.045166,1600.756348 2182.765381,1601.686401 2181.575928,1601.583008 
	C2177.478271,1601.226562 2173.510986,1600.076050 2172.358643,1595.472290 
	C2171.303711,1591.259277 2173.645508,1588.238403 2177.296631,1586.742798 
	C2181.262207,1585.118408 2185.258789,1585.622681 2188.073486,1589.323975 
	C2190.956299,1593.114746 2190.727539,1596.681641 2185.966309,1599.955811 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2533.314941,1930.077637 
	C2534.054443,1932.086670 2534.991699,1933.775757 2536.248779,1935.375488 
	C2539.242188,1939.184937 2537.861572,1942.919922 2535.685059,1946.396606 
	C2532.734619,1951.109741 2527.605469,1951.118652 2524.391113,1946.660767 
	C2521.770752,1943.026489 2521.973877,1939.308716 2523.913818,1934.741943 
	C2527.573730,1934.280762 2529.415283,1930.678711 2533.314941,1930.077637 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2338.053223,1682.712891 
	C2339.856201,1676.181030 2344.132324,1675.252441 2348.991699,1676.859009 
	C2353.656494,1678.401611 2358.218262,1687.263184 2357.089111,1691.455688 
	C2356.079834,1695.204346 2351.754395,1697.997559 2347.026123,1697.954956 
	C2342.148438,1697.911011 2339.017822,1695.408447 2338.172607,1690.441040 
	C2337.790283,1688.194214 2338.048340,1685.838379 2338.053223,1682.712891 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2382.748291,1680.771484 
	C2382.003174,1669.760132 2382.898193,1668.249146 2389.501465,1668.028442 
	C2395.253418,1667.836182 2397.473145,1669.433228 2397.910400,1674.078979 
	C2398.356445,1678.817627 2395.695801,1682.867432 2391.267822,1683.723633 
	C2388.286865,1684.300049 2385.276367,1684.261963 2382.748291,1680.771484 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2335.458252,1712.424805 
	C2340.957764,1713.212280 2342.420410,1716.236206 2340.483154,1720.881470 
	C2338.473389,1725.701050 2330.584717,1729.061890 2326.400879,1726.960571 
	C2321.146240,1724.321533 2318.508301,1717.446411 2320.907471,1712.644287 
	C2323.929443,1706.596313 2328.780029,1705.283691 2335.656250,1709.372925 
	C2334.215820,1712.664551 2329.770264,1712.486694 2329.049316,1716.588745 
	C2333.528564,1719.187378 2332.950684,1713.958740 2335.458252,1712.424805 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2150.643555,1762.235229 
	C2148.880859,1761.162964 2147.852051,1759.942993 2148.383301,1758.676147 
	C2150.127197,1754.517944 2159.044922,1750.936890 2162.772461,1752.692627 
	C2166.638428,1754.513428 2169.357666,1762.444824 2167.311279,1766.710815 
	C2165.296143,1770.910889 2161.462891,1773.534790 2157.088135,1773.546265 
	C2152.580078,1773.558105 2150.287598,1770.040405 2150.012207,1764.749634 
	C2152.661621,1762.406006 2155.589355,1765.309448 2158.812744,1763.187012 
	C2156.359375,1760.244873 2153.647461,1762.530396 2150.643555,1762.235229 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2510.637207,1863.945801 
	C2499.399414,1863.171387 2498.370850,1861.357788 2501.902344,1848.773926 
	C2502.000000,1848.000000 2503.000000,1848.000000 2503.500000,1848.000000 
	C2514.449951,1845.232910 2518.777100,1849.351562 2516.558105,1861.242432 
	C2514.424805,1862.630493 2512.849365,1863.261108 2510.637207,1863.945801 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2179.260498,1656.000610 
	C2186.680176,1659.321533 2186.967773,1664.480469 2184.087402,1671.262451 
	C2183.111084,1672.000000 2182.222168,1672.000000 2180.666504,1672.000000 
	C2176.773926,1674.642700 2173.915283,1673.642578 2170.605469,1670.556641 
	C2170.000000,1669.111084 2170.000000,1668.222168 2170.000000,1666.666626 
	C2168.844482,1664.628174 2168.519775,1663.087158 2169.528809,1660.685303 
	C2171.670410,1656.174316 2174.984131,1655.849731 2179.260498,1656.000610 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2442.047363,1859.407959 
	C2437.599365,1859.702515 2432.576172,1861.338379 2429.933350,1855.799316 
	C2428.624023,1853.055420 2427.196777,1850.413330 2429.629883,1847.619751 
	C2432.059570,1844.829468 2434.983643,1842.158569 2438.791260,1842.894287 
	C2441.730469,1843.462036 2443.588623,1846.220581 2443.885010,1849.478027 
	C2444.032959,1851.107666 2443.968506,1852.756592 2444.000000,1855.198486 
	C2443.364990,1856.938599 2442.729736,1857.877197 2442.047363,1859.407959 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2344.730957,1839.998047 
	C2344.292725,1839.055420 2344.355225,1837.937744 2344.919434,1837.207764 
	C2347.052002,1834.447754 2351.322754,1832.103271 2348.524658,1828.023926 
	C2345.534180,1823.663818 2341.718018,1819.585083 2334.656738,1821.943115 
	C2337.866943,1817.296631 2342.278076,1816.553101 2346.846436,1820.043823 
	C2349.178223,1821.825562 2350.873047,1824.193848 2352.471436,1826.704956 
	C2354.367676,1829.684326 2356.150879,1832.864624 2359.610840,1835.464355 
	C2359.974854,1839.504028 2357.693115,1841.535034 2354.589355,1843.707275 
	C2351.644531,1841.619629 2349.269287,1839.281494 2344.730957,1839.998047 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2228.000000,1905.333374 
	C2228.021484,1908.309448 2227.830566,1910.556274 2226.605225,1912.622437 
	C2224.229492,1916.627319 2220.080811,1918.733154 2216.930664,1917.158081 
	C2212.937012,1915.161011 2211.425049,1911.659180 2212.148682,1907.349121 
	C2212.945801,1902.599365 2216.208496,1901.033447 2220.672363,1901.388672 
	C2222.617920,1901.543335 2224.555664,1901.792480 2227.248535,1901.999390 
	C2228.000000,1902.888916 2228.000000,1903.777832 2228.000000,1905.333374 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2374.000000,1822.666626 
	C2374.108643,1820.039917 2373.809082,1817.945068 2374.403320,1816.145386 
	C2376.067871,1811.106812 2380.059814,1809.243286 2384.226807,1811.198730 
	C2389.226318,1813.544800 2390.514648,1817.669556 2387.739746,1822.447998 
	C2384.743652,1827.607422 2383.015625,1828.129883 2374.723145,1826.082275 
	C2374.000000,1825.111084 2374.000000,1824.222168 2374.000000,1822.666626 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2391.477539,1720.457275 
	C2393.514160,1721.003784 2393.731934,1722.712402 2394.409424,1724.211304 
	C2396.227051,1728.233154 2399.177734,1730.658325 2403.864746,1729.645386 
	C2407.218994,1728.920288 2411.321533,1723.876587 2410.833252,1720.765747 
	C2410.023193,1715.603882 2406.614502,1713.518188 2400.759277,1714.001465 
	C2403.987549,1709.182739 2410.745361,1709.126831 2413.339111,1713.889771 
	C2414.917480,1716.788208 2414.002686,1726.646606 2411.736328,1729.046875 
	C2407.817627,1733.196899 2402.623779,1735.423340 2397.384766,1733.585205 
	C2392.049072,1731.713257 2389.834961,1726.807373 2391.477539,1720.457275 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2504.410400,1790.407471 
	C2504.000732,1788.341064 2503.989014,1786.681885 2504.005371,1785.023071 
	C2504.042236,1781.335205 2503.787109,1777.409790 2508.581299,1776.305298 
	C2513.475830,1775.177612 2517.033203,1776.853027 2518.825928,1781.722900 
	C2519.168457,1782.653076 2519.495117,1783.588867 2519.914551,1785.260986 
	C2517.826660,1790.329468 2514.417725,1792.492676 2508.745361,1791.995239 
	C2506.809814,1791.953491 2505.740479,1791.585571 2504.410400,1790.407471 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2136.470703,1795.501221 
	C2135.010498,1795.479004 2134.020996,1794.958008 2132.515625,1794.218506 
	C2132.266113,1785.101318 2133.777832,1782.827393 2140.540283,1780.797485 
	C2142.182861,1780.304321 2143.688232,1780.204346 2145.333984,1780.760498 
	C2149.790039,1782.266113 2152.599121,1785.370972 2153.530273,1789.840332 
	C2154.436768,1794.190674 2150.737793,1796.155273 2148.129150,1798.532349 
	C2146.270996,1800.225220 2143.841064,1799.950806 2140.772217,1799.998535 
	C2140.000000,1799.111084 2140.000000,1798.222168 2140.000000,1796.666626 
	C2140.387207,1793.950684 2144.843750,1792.352905 2142.254150,1790.684082 
	C2139.449219,1788.876465 2138.828369,1793.537109 2136.470703,1795.501221 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2300.447266,1705.490967 
	C2294.785645,1705.455322 2293.290771,1702.246826 2294.503418,1697.668091 
	C2295.549561,1693.719116 2302.549316,1689.405151 2306.327637,1690.512695 
	C2310.463379,1691.725098 2314.475098,1693.709595 2315.671875,1698.406982 
	C2316.616455,1702.116333 2316.122070,1705.943237 2312.580811,1708.061157 
	C2308.582275,1710.452515 2304.196533,1711.912598 2300.162598,1706.736328 
	C2300.450928,1705.544678 2300.974609,1705.175049 2301.445801,1704.751587 
	C2303.237549,1703.141602 2306.774902,1703.769165 2307.155273,1700.429077 
	C2307.269287,1699.428711 2306.408447,1698.529663 2305.415039,1698.576782 
	C2301.263916,1698.773193 2302.336182,1702.787231 2300.447266,1705.490967 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2439.359863,1772.057861 
	C2445.736328,1771.447754 2448.804688,1774.771973 2449.195801,1779.795654 
	C2449.544189,1784.272705 2445.940186,1786.679810 2441.865723,1787.654663 
	C2436.513428,1788.935059 2434.580322,1786.374146 2434.000000,1776.823975 
	C2434.930176,1773.924072 2436.381104,1772.480713 2439.359863,1772.057861 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2230.510254,1888.544067 
	C2229.575928,1886.420410 2229.190186,1884.829224 2228.719727,1883.263550 
	C2227.694580,1879.851074 2227.502441,1876.455200 2231.273682,1874.791260 
	C2234.755127,1873.255005 2238.326172,1873.576050 2241.325928,1876.443115 
	C2244.185059,1879.175781 2244.512207,1881.958740 2241.959961,1885.109253 
	C2241.160156,1886.096924 2240.755615,1887.404663 2240.084961,1889.280518 
	C2236.999268,1889.767822 2233.888916,1890.628052 2230.510254,1888.544067 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2488.000000,1814.666626 
	C2488.699707,1807.513916 2491.526611,1804.315063 2496.279053,1804.631836 
	C2500.362305,1804.903931 2504.004883,1808.569214 2503.864258,1812.263916 
	C2503.694824,1816.699585 2499.804688,1820.015259 2495.234375,1819.425415 
	C2493.307373,1819.176636 2491.434326,1818.506958 2488.768555,1818.014282 
	C2488.000000,1817.111084 2488.000000,1816.222168 2488.000000,1814.666626 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2497.500000,1920.000000 
	C2501.270508,1920.237915 2504.755127,1919.211914 2507.732666,1921.214966 
	C2510.289551,1922.934814 2512.736084,1925.195190 2511.356689,1928.601685 
	C2509.666016,1932.776245 2506.095947,1934.174316 2501.638916,1934.017700 
	C2498.014404,1933.890259 2495.969971,1932.587280 2496.028076,1928.743896 
	C2496.063477,1926.416260 2496.012207,1924.087158 2496.000000,1920.879395 
	C2496.000000,1920.000000 2497.000000,1920.000000 2497.500000,1920.000000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2314.538574,1675.622070 
	C2309.762451,1675.524048 2309.683350,1672.422241 2310.197266,1669.405762 
	C2310.941162,1665.043701 2315.114014,1664.403931 2318.294922,1663.090942 
	C2321.855469,1661.621582 2324.723877,1663.875732 2326.848877,1666.421997 
	C2330.013428,1670.213501 2330.252686,1676.359131 2327.762939,1679.107056 
	C2324.503662,1682.704468 2321.217773,1682.747925 2314.357178,1678.640137 
	C2314.694336,1677.278687 2315.518311,1676.750122 2316.420410,1676.323486 
	C2317.813232,1675.664551 2320.569092,1674.904541 2319.389404,1673.417603 
	C2317.448242,1670.970581 2316.463623,1674.330078 2314.538574,1675.622070 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2464.000000,1747.500000 
	C2463.992432,1749.659668 2463.987549,1751.319336 2463.976318,1752.979004 
	C2463.947510,1757.310181 2462.122559,1760.057373 2457.447266,1759.822266 
	C2452.840820,1759.590698 2449.518799,1754.890747 2450.084473,1749.801270 
	C2450.607422,1745.098755 2453.478760,1743.635986 2457.744385,1744.315918 
	C2459.358398,1744.573364 2460.897949,1745.299316 2463.235840,1745.905884 
	C2464.000000,1746.000000 2464.000000,1747.000000 2464.000000,1747.500000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2351.972900,1759.220581 
	C2352.020752,1763.402832 2351.718262,1766.689331 2347.636230,1767.687988 
	C2342.919678,1768.841919 2339.328125,1767.314087 2336.562744,1762.435181 
	C2336.000000,1761.111084 2336.000000,1760.222168 2336.000000,1758.666626 
	C2336.043945,1756.809326 2336.412109,1755.738525 2337.588867,1754.407471 
	C2338.771973,1753.243408 2339.692139,1752.948853 2341.379883,1753.555420 
	C2345.592529,1754.857178 2351.037109,1751.575562 2351.972900,1759.220581 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2482.000000,1692.666626 
	C2483.577148,1691.834595 2485.184570,1691.810425 2486.726318,1691.479858 
	C2494.500488,1689.813477 2494.540527,1689.819824 2495.998047,1699.213379 
	C2495.607178,1705.437012 2491.875000,1706.154419 2486.761963,1705.998535 
	C2481.648193,1704.629883 2480.542969,1701.418701 2481.530273,1696.643921 
	C2482.000000,1695.111084 2482.000000,1694.222168 2482.000000,1692.666626 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2423.775635,1730.431641 
	C2432.276367,1728.310303 2435.600586,1730.072876 2435.930176,1736.388428 
	C2436.072754,1739.116943 2435.785400,1741.808228 2432.949951,1743.161133 
	C2429.948486,1744.593140 2427.249756,1743.873047 2424.782959,1741.669556 
	C2422.298828,1739.450806 2421.888916,1736.626343 2422.001709,1732.785400 
	C2422.634033,1731.780396 2423.151123,1731.401489 2423.775635,1730.431641 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2552.000000,1731.250000 
	C2551.048096,1732.193604 2549.993164,1732.185791 2549.160156,1732.611938 
	C2540.316406,1737.136719 2540.326172,1737.155884 2534.547607,1728.420898 
	C2534.346924,1726.896606 2534.693848,1725.793091 2535.520264,1724.344727 
	C2540.920898,1724.177734 2546.354736,1720.095825 2551.307373,1725.880127 
	C2552.000000,1727.500000 2552.000000,1729.000000 2552.000000,1731.250000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2292.000000,1778.500000 
	C2292.022461,1776.045288 2291.997070,1774.088745 2292.078125,1772.136475 
	C2292.217529,1768.782837 2293.770020,1766.499023 2297.283203,1766.195068 
	C2301.444824,1765.835083 2304.255859,1768.111206 2305.449951,1771.788696 
	C2306.595947,1775.317383 2303.854736,1776.964600 2301.121582,1778.417969 
	C2298.724121,1779.693115 2296.218750,1780.084473 2292.787598,1779.998291 
	C2292.000000,1780.000000 2292.000000,1779.000000 2292.000000,1778.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2319.260254,1780.100220 
	C2319.468018,1781.872681 2318.906982,1783.737549 2318.409668,1785.619385 
	C2317.341553,1789.661987 2318.921875,1792.756592 2322.278564,1794.800171 
	C2325.871826,1796.987549 2329.096680,1795.914795 2331.927246,1792.992065 
	C2333.477783,1791.391479 2334.111328,1788.872925 2337.312988,1788.114258 
	C2336.392822,1795.893799 2328.501465,1801.402588 2321.040283,1799.792603 
	C2320.100342,1799.589722 2318.990479,1799.345581 2318.350830,1798.720093 
	C2315.055908,1795.498047 2315.487305,1790.861694 2314.301758,1786.875000 
	C2313.370361,1783.742798 2315.047119,1781.127808 2319.260254,1780.100220 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2529.753662,1826.608154 
	C2527.325684,1834.126343 2524.041748,1835.738770 2519.538818,1832.260132 
	C2516.701904,1830.068115 2514.949463,1827.414429 2517.475098,1823.771484 
	C2520.013916,1820.110229 2523.086914,1819.351196 2526.675049,1821.958374 
	C2527.936768,1822.875122 2528.660645,1824.532104 2529.753662,1826.608154 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2379.237305,1742.181274 
	C2380.128174,1747.685181 2376.599121,1754.433105 2385.300049,1757.915283 
	C2386.141602,1762.292725 2380.424561,1762.623169 2380.078613,1767.319580 
	C2376.500488,1767.976440 2374.467285,1765.696777 2372.293213,1762.593628 
	C2375.404053,1759.459351 2376.143799,1756.008911 2376.119141,1751.906860 
	C2376.099609,1748.663330 2374.451660,1744.715088 2379.237305,1742.181274 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2082.730469,1720.017578 
	C2086.083984,1707.499512 2092.861816,1696.050293 2099.963867,1684.250000 
	C2096.834229,1696.896606 2089.933350,1708.237793 2082.730469,1720.017578 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2133.663574,1611.747925 
	C2134.117188,1607.489502 2135.447266,1603.315430 2137.197754,1598.559814 
	C2141.862793,1597.940063 2145.732666,1598.523682 2145.828857,1604.009277 
	C2145.914551,1608.875488 2142.450684,1611.209351 2133.663574,1611.747925 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2110.792969,1662.075928 
	C2112.779541,1650.359497 2118.603516,1639.586426 2124.188232,1628.252319 
	C2122.383057,1640.079346 2116.716553,1650.841675 2110.792969,1662.075928 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2516.754883,1861.976685 
	C2515.747070,1850.427002 2515.177002,1849.661377 2504.789795,1848.001709 
	C2504.527100,1843.797485 2507.366211,1843.690308 2510.512451,1844.467773 
	C2516.018311,1845.828125 2521.191406,1851.581177 2521.805420,1856.874512 
	C2522.176514,1860.073242 2520.867920,1861.889526 2516.754883,1861.976685 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2336.000000,1711.500000 
	C2335.878418,1714.617920 2336.556641,1717.477783 2334.712158,1719.675659 
	C2332.491455,1722.321777 2329.431396,1722.942871 2326.849365,1720.580200 
	C2324.551758,1718.477783 2323.505371,1715.683838 2326.294189,1712.760132 
	C2328.598145,1710.344849 2331.382080,1709.866455 2335.229004,1710.001465 
	C2336.000000,1710.000000 2336.000000,1711.000000 2336.000000,1711.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2331.259033,1822.101318 
	C2331.823486,1823.609009 2331.717285,1825.229248 2331.458252,1826.824951 
	C2330.356689,1833.615967 2331.358887,1835.228760 2339.557861,1839.472656 
	C2333.880371,1841.867676 2330.458740,1840.553589 2327.693604,1835.268799 
	C2324.799316,1829.736328 2325.457275,1826.692505 2331.259033,1822.101318 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2150.000000,1762.500000 
	C2152.083008,1760.624023 2153.192383,1757.914185 2156.367188,1757.992188 
	C2159.232178,1758.062378 2161.431152,1758.709351 2162.671631,1761.520874 
	C2163.375000,1763.115479 2163.678223,1764.627808 2162.465576,1766.042358 
	C2160.780518,1768.007935 2158.436035,1768.364868 2156.219971,1767.639282 
	C2154.433350,1767.054199 2152.906738,1765.675659 2150.632324,1764.324707 
	C2150.000000,1764.000000 2150.000000,1763.000000 2150.000000,1762.500000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2314.000000,1676.500000 
	C2314.001709,1675.674683 2313.994385,1675.348999 2314.006592,1675.024048 
	C2314.128418,1671.798462 2313.589111,1667.942139 2318.596680,1668.237793 
	C2322.643066,1668.476807 2324.203613,1671.193359 2323.789062,1674.987793 
	C2323.206787,1680.317139 2319.445312,1678.408813 2316.405273,1678.062134 
	C2316.082764,1678.025269 2315.755371,1678.029907 2314.715332,1678.007568 
	C2314.000000,1678.000000 2314.000000,1677.000000 2314.000000,1676.500000 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2545.247803,1832.091797 
	C2545.265625,1836.851196 2539.689209,1840.982910 2543.918457,1847.279785 
	C2539.342285,1847.645020 2538.192627,1844.695190 2537.945312,1840.537964 
	C2537.650635,1835.587036 2540.111572,1833.240845 2545.247803,1832.091797 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2437.287598,1706.145020 
	C2436.786865,1712.094482 2439.423340,1716.671387 2443.874023,1721.289062 
	C2435.199219,1720.123779 2432.339600,1714.075317 2437.287598,1706.145020 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2481.570312,1759.512451 
	C2478.737061,1762.778931 2474.985352,1765.278809 2476.001465,1771.250977 
	C2471.433594,1768.324219 2470.641113,1764.441895 2474.206299,1761.338013 
	C2476.041016,1759.740845 2478.189453,1757.839355 2481.570312,1759.512451 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2072.786133,1738.121582 
	C2073.155029,1732.241821 2075.833740,1726.889893 2080.714355,1722.151123 
	C2080.149658,1728.000977 2076.859131,1732.952637 2072.786133,1738.121582 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2456.716309,1833.987305 
	C2456.372070,1829.826050 2458.765869,1827.365723 2463.315674,1826.074707 
	C2465.295898,1831.089478 2464.486572,1832.072998 2456.716309,1833.987305 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2393.850098,1739.282227 
	C2389.738525,1739.824341 2385.522461,1739.963379 2380.776611,1741.902100 
	C2384.672363,1735.180420 2386.713623,1734.668457 2393.850098,1739.282227 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2392.780762,1757.967773 
	C2392.331787,1754.448975 2394.583008,1751.269897 2393.998535,1746.774170 
	C2399.766113,1750.381226 2399.621582,1754.319458 2392.780762,1757.967773 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2481.355469,1696.107178 
	C2481.532227,1699.536255 2483.139648,1702.273193 2485.688477,1705.383789 
	C2485.179932,1706.442505 2484.084473,1707.471069 2483.583252,1707.235474 
	C2479.528564,1705.329102 2478.518555,1701.154297 2481.355469,1696.107178 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2459.295654,1860.125244 
	C2459.671143,1863.548218 2457.416748,1866.728394 2458.001465,1871.225708 
	C2452.489258,1867.966919 2452.548340,1866.792358 2459.295654,1860.125244 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2514.106201,1908.669434 
	C2516.777832,1908.000000 2519.555664,1908.000000 2523.166748,1908.000000 
	C2521.154785,1915.066284 2520.036133,1915.219238 2514.106201,1908.669434 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2170.093018,1670.716553 
	C2172.841553,1670.659424 2175.683105,1671.318848 2179.262207,1671.989136 
	C2176.542480,1677.530273 2174.430176,1677.408203 2170.093018,1670.716553 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2405.906738,1783.283569 
	C2403.158447,1783.340698 2400.316895,1782.681274 2396.737793,1782.010986 
	C2399.457520,1776.470825 2401.571289,1776.593018 2405.906738,1783.283569 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2452.716309,1717.906738 
	C2452.659424,1715.158325 2453.318848,1712.316772 2453.989014,1708.737549 
	C2459.529053,1711.457886 2459.406738,1713.571167 2452.716309,1717.906738 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2068.137451,1752.742920 
	C2072.928955,1751.542969 2074.348877,1754.179810 2073.997559,1759.226562 
	C2069.955078,1759.673828 2069.152832,1756.476196 2068.137451,1752.742920 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2451.854492,1701.286621 
	C2449.222168,1702.000000 2446.444336,1702.000000 2442.833252,1702.000000 
	C2445.114502,1696.977051 2446.561768,1696.764404 2451.854492,1701.286621 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2046.655029,1781.923584 
	C2046.255127,1778.958862 2047.210693,1776.142700 2050.688477,1774.145386 
	C2051.171875,1777.201050 2049.310547,1779.495483 2046.655029,1781.923584 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2104.959961,1674.675659 
	C2103.916748,1671.600342 2105.057129,1668.766479 2108.193848,1666.231567 
	C2109.235352,1669.374146 2107.338623,1671.825806 2104.959961,1674.675659 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2502.662109,1691.936768 
	C2502.706543,1687.879883 2505.198730,1686.361328 2509.604004,1687.526123 
	C2508.350586,1690.283569 2505.880615,1691.152832 2502.662109,1691.936768 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2536.799805,1704.000000 
	C2538.602783,1699.035767 2539.425293,1698.889893 2543.868652,1703.313843 
	C2541.866699,1704.000000 2539.733154,1704.000000 2536.799805,1704.000000 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2056.666016,1765.943848 
	C2056.217773,1763.011230 2057.224121,1760.251587 2060.536621,1758.157227 
	C2061.162842,1761.221436 2059.342529,1763.524414 2056.666016,1765.943848 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2493.934570,1763.357178 
	C2491.707275,1763.971069 2489.852539,1763.110352 2488.289062,1760.573242 
	C2491.955322,1756.582764 2492.730469,1760.041870 2493.934570,1763.357178 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2484.660156,1913.892090 
	C2484.000000,1912.500000 2484.000000,1911.000000 2484.000000,1908.750000 
	C2488.327148,1909.040527 2489.220703,1910.865112 2484.660156,1913.892090 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2169.339355,1660.107910 
	C2170.000000,1661.500000 2170.000000,1663.000000 2170.000000,1665.250000 
	C2165.671387,1664.959961 2164.779053,1663.135132 2169.339355,1660.107910 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2030.705200,1806.000732 
	C2029.994141,1803.827759 2030.821655,1801.870361 2033.604736,1800.332520 
	C2034.101440,1802.403687 2033.030029,1804.241455 2030.705200,1806.000732 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2066.405273,1748.139282 
	C2066.974854,1748.686768 2067.007812,1749.402588 2066.957520,1750.658447 
	C2066.153320,1751.819458 2065.432373,1752.440430 2064.246582,1753.159668 
	C2064.066406,1751.434570 2063.801025,1749.379639 2066.405273,1748.139282 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2052.691895,1772.148438 
	C2052.079346,1770.696777 2052.299805,1769.153687 2054.591797,1768.135742 
	C2055.413574,1769.725464 2054.467773,1770.894653 2052.691895,1772.148438 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2119.908936,1767.363770 
	C2118.197998,1767.831665 2116.636475,1767.326782 2116.090820,1764.636108 
	C2117.801514,1764.168823 2119.363281,1764.673584 2119.908936,1767.363770 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2042.008301,1784.737305 
	C2042.684814,1783.987793 2043.369507,1783.965698 2044.564819,1783.929810 
	C2045.342773,1785.656250 2044.398438,1786.827759 2042.682007,1788.130371 
	C2042.106812,1787.404907 2042.061768,1786.434937 2042.008301,1784.737305 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2038.696167,1794.178955 
	C2038.127930,1792.736206 2038.298828,1791.156006 2040.657471,1790.179077 
	C2041.392334,1791.753418 2040.424927,1792.907227 2038.696167,1794.178955 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2315.500000,1604.000000 
	C2316.635010,1604.938599 2317.270020,1605.877319 2317.952637,1607.407959 
	C2316.197998,1607.831787 2314.637207,1607.326050 2314.091309,1604.636108 
	C2314.000000,1604.000000 2315.000000,1604.000000 2315.500000,1604.000000 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2545.519775,1712.344482 
	C2548.122803,1713.814697 2547.616211,1715.054688 2544.577148,1715.933594 
	C2544.346436,1714.896240 2544.693115,1713.792603 2545.519775,1712.344482 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2341.916992,1753.407715 
	C2341.111084,1753.996704 2340.222168,1753.998413 2338.666504,1754.000000 
	C2338.469482,1752.982544 2338.682373,1751.468750 2339.468018,1751.062378 
	C2340.677979,1750.436890 2341.482910,1751.603271 2341.916992,1753.407715 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2337.423096,1754.066650 
	C2337.653564,1755.103760 2337.307129,1756.207520 2336.480225,1757.655640 
	C2333.877930,1756.185059 2334.384033,1754.945190 2337.423096,1754.066650 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2460.066406,1874.577148 
	C2461.103760,1874.346436 2462.207520,1874.692871 2463.655762,1875.519653 
	C2462.185059,1878.123047 2460.945557,1877.614624 2460.066406,1874.577148 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2504.066406,1790.577148 
	C2505.103516,1790.345337 2506.206787,1790.690796 2507.655273,1791.515625 
	C2506.187744,1794.122314 2504.947510,1793.617432 2504.066406,1790.577148 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2004.704834,1842.151001 
	C2004.133667,1840.591431 2004.368652,1838.956055 2006.970947,1838.142578 
	C2007.572510,1839.773315 2006.586548,1840.956421 2004.704834,1842.151001 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2026.609985,1811.985107 
	C2026.116577,1810.591553 2026.342041,1809.092896 2028.567871,1808.173340 
	C2029.361206,1809.748291 2028.349121,1810.818115 2026.609985,1811.985107 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2020.739502,1820.234375 
	C2020.122803,1818.693604 2020.322998,1817.029053 2022.905396,1816.066895 
	C2023.563110,1817.681152 2022.581543,1818.913940 2020.739502,1820.234375 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2016.640869,1826.067383 
	C2016.123657,1824.632812 2016.348999,1823.085327 2018.684326,1822.169434 
	C2019.368408,1823.737061 2018.377075,1824.850464 2016.640869,1826.067383 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2010.660767,1833.956543 
	C2010.122192,1832.439453 2010.497314,1830.928589 2012.873779,1830.036621 
	C2013.489624,1831.612915 2012.531250,1832.790527 2010.660767,1833.956543 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2248.091309,1564.636108 
	C2249.802002,1564.168335 2251.363281,1564.673462 2251.908691,1567.363892 
	C2250.197998,1567.831787 2248.637207,1567.326050 2248.091309,1564.636108 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2034.693726,1800.039795 
	C2034.126465,1798.572144 2034.374634,1797.056152 2036.698608,1796.161255 
	C2037.451050,1797.752075 2036.460449,1798.864258 2034.693726,1800.039795 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1998.685059,1850.122070 
	C1998.119263,1848.550293 1998.395264,1846.941284 2000.921143,1846.053955 
	C2001.675659,1846.523071 2001.631836,1847.145264 2001.348145,1848.220337 
	C2000.621338,1849.104126 1999.938599,1849.521362 1998.685059,1850.122070 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2008.704224,1836.467285 
	C2008.518311,1836.078857 2008.823975,1835.368530 2009.636719,1834.357056 
	C2009.827881,1834.752441 2009.511841,1835.448975 2008.704224,1836.467285 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M2102.504639,1680.049805 
	C2102.119141,1679.686890 2102.299316,1679.175415 2102.954102,1678.456055 
	C2103.506592,1678.818970 2103.386963,1679.369873 2102.504639,1680.049805 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2216.847168,737.219604 
	C2217.990723,738.483826 2218.765869,739.274841 2218.982910,740.197205 
	C2221.305664,750.067017 2225.997314,756.447449 2237.602051,754.082886 
	C2242.697510,753.044678 2245.717529,756.120850 2247.228760,760.731812 
	C2248.885498,765.785400 2245.286865,767.907959 2241.824707,770.037964 
	C2240.977783,770.559082 2240.072754,770.990845 2239.175293,771.423645 
	C2232.954590,774.423218 2231.599365,773.918152 2228.786377,767.365784 
	C2227.873535,765.239502 2227.375244,762.918518 2226.329590,760.869263 
	C2223.764893,755.843201 2221.530273,754.835876 2216.866455,757.760010 
	C2211.381104,761.199341 2205.395752,764.374939 2202.477295,771.531494 
	C2199.187744,768.990906 2196.811035,766.446167 2199.559570,762.539612 
	C2203.287842,757.240479 2202.522949,752.210510 2199.913818,746.790710 
	C2197.026367,740.792786 2198.461914,738.733765 2205.411621,738.010071 
	C2209.017090,737.634644 2212.617188,737.209839 2216.847168,737.219604 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2396.133789,659.979858 
	C2387.869629,657.866272 2385.563477,655.518127 2386.220215,650.719543 
	C2386.861572,646.032227 2389.437012,644.027161 2395.387207,644.044067 
	C2399.540771,644.055908 2404.367188,642.994019 2405.782959,648.984985 
	C2407.065430,654.410217 2405.502930,657.363464 2399.894775,659.636597 
	C2399.012207,659.994324 2397.936523,659.875366 2396.133789,659.979858 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2445.735352,645.052612 
	C2445.175537,646.356812 2444.891113,647.076416 2444.367188,647.373535 
	C2439.203613,650.302368 2432.168945,649.341736 2430.434082,645.535645 
	C2428.334229,640.928589 2430.782715,634.914368 2435.904297,632.099060 
	C2440.165527,629.756775 2443.642090,630.917358 2445.378418,635.408386 
	C2446.485596,638.271790 2445.909912,641.304504 2445.735352,645.052612 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2223.512207,804.405273 
	C2227.661621,803.643311 2231.111084,804.512085 2235.242676,805.908081 
	C2239.694092,805.373779 2240.837158,807.445923 2240.457031,811.321777 
	C2232.515869,820.445312 2226.435303,821.400635 2219.280029,815.053467 
	C2218.455078,814.321594 2218.429932,812.688110 2218.017090,810.737549 
	C2218.339600,806.979553 2220.752686,805.962219 2223.512207,804.405273 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2311.377686,748.888733 
	C2310.619629,750.496704 2310.314453,751.557068 2309.625244,752.214783 
	C2306.902344,754.812683 2303.959961,757.244995 2300.026367,754.527649 
	C2297.020752,752.451538 2295.039062,744.972473 2296.510742,741.687378 
	C2298.443359,737.372559 2302.427002,737.605530 2305.980957,738.203430 
	C2311.554688,739.141296 2312.017822,743.539856 2311.377686,748.888733 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2268.000000,763.177917 
	C2265.352539,765.469177 2262.548340,766.273315 2258.745117,765.999146 
	C2255.834229,763.584167 2253.184570,761.568298 2252.347412,758.136414 
	C2250.878662,752.117920 2253.562744,749.095154 2259.502686,750.250610 
	C2265.623779,751.441223 2267.437988,754.026367 2268.000000,763.177917 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2333.954102,699.841675 
	C2328.370117,697.670654 2327.125732,693.717651 2328.801025,689.207581 
	C2330.382324,684.951355 2334.213623,683.890747 2338.607178,683.972717 
	C2343.209961,684.058472 2344.530518,686.626282 2343.830566,690.443848 
	C2342.913330,695.445679 2339.613770,698.519409 2333.954102,699.841675 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2474.633545,628.721924 
	C2473.662842,623.807495 2474.815430,620.602417 2479.519531,620.180359 
	C2483.044678,619.864014 2487.178467,619.033264 2489.169678,623.209961 
	C2490.650635,626.316650 2490.452637,629.641907 2488.226807,632.578247 
	C2485.529541,636.136963 2482.652100,636.620361 2478.958252,633.787659 
	C2477.412598,632.602295 2476.264160,630.899109 2474.633545,628.721924 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2376.471191,639.314697 
	C2373.262695,645.368835 2369.456543,647.387329 2365.804688,645.406616 
	C2362.234131,643.469910 2361.090332,637.228088 2363.557373,633.143738 
	C2366.021973,629.063416 2368.762695,629.060120 2375.423096,633.564941 
	C2377.153809,635.372192 2377.479004,636.913086 2376.471191,639.314697 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2522.011963,796.745972 
	C2527.222412,795.589783 2531.881592,796.917114 2535.586182,800.735107 
	C2538.699463,803.943665 2538.372314,807.063965 2534.822021,810.041687 
	C2531.313965,812.984070 2528.679199,811.906128 2527.100098,808.042419 
	C2525.616455,804.412354 2521.805420,801.916321 2522.011963,796.745972 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2240.529785,812.390991 
	C2239.968506,809.706787 2239.108154,807.852600 2236.572754,806.289551 
	C2235.500488,804.817505 2235.282471,803.358215 2234.445801,802.507141 
	C2232.389160,800.415039 2231.162842,798.093262 2232.976318,795.561584 
	C2234.735107,793.106567 2237.070312,794.901428 2239.221924,795.487793 
	C2242.084717,796.268005 2244.221436,797.231689 2242.671143,800.845642 
	C2241.035889,804.658447 2244.430664,806.792236 2245.744141,809.638489 
	C2246.786377,811.896790 2249.435791,814.857666 2246.691895,816.648804 
	C2243.581299,818.679321 2242.758301,814.456604 2240.529785,812.390991 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2191.826416,744.439331 
	C2195.358398,745.925415 2195.998291,748.356750 2195.978516,751.130981 
	C2195.955078,754.413635 2196.325928,758.037598 2192.360107,759.390625 
	C2188.911865,760.567017 2186.584473,758.213379 2185.192627,755.603394 
	C2183.434814,752.307007 2182.873047,748.631226 2186.543213,746.000183 
	C2187.806885,745.094360 2189.538086,744.840698 2191.826416,744.439331 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2515.346191,637.713257 
	C2515.209717,648.871338 2513.047363,650.681091 2502.672852,648.295166 
	C2502.823975,637.920288 2505.130371,635.998840 2515.346191,637.713257 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2492.007812,931.856689 
	C2486.062012,930.605774 2484.907471,927.106812 2487.049316,922.865356 
	C2488.892334,919.216248 2492.478760,919.620972 2495.775879,920.998596 
	C2500.875488,923.129395 2501.203369,927.163696 2496.503662,930.564514 
	C2495.486816,931.300293 2494.041504,931.444458 2492.007812,931.856689 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2543.658447,853.904907 
	C2541.874268,853.950684 2540.882080,853.991028 2539.898926,853.913452 
	C2536.997070,853.684082 2534.710938,852.499756 2534.405029,849.331299 
	C2534.146729,846.656006 2535.752441,844.870728 2538.252197,844.379822 
	C2541.517578,843.738464 2545.129395,843.329224 2547.000244,846.928711 
	C2548.485107,849.785828 2548.618164,852.766846 2543.658447,853.904907 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2497.162109,597.298157 
	C2500.013916,595.857422 2502.260254,595.834473 2504.126953,597.678650 
	C2506.278809,599.804626 2506.376709,602.385376 2505.156006,604.968262 
	C2504.236084,606.915527 2502.540771,607.939148 2500.327881,607.571228 
	C2497.658936,607.127380 2496.373291,605.244568 2496.195801,602.733765 
	C2496.081787,601.127686 2496.468018,599.486267 2497.162109,597.298157 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2422.095947,673.275879 
	C2418.289307,672.039612 2417.456543,669.093689 2416.490479,666.391235 
	C2415.783936,664.414185 2416.462891,662.482666 2418.294922,661.286804 
	C2420.358398,659.940063 2422.061768,661.038818 2423.392090,662.563110 
	C2426.615967,666.257629 2427.529297,669.932129 2422.095947,673.275879 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2309.105469,831.388184 
	C2315.615479,835.578796 2315.682861,839.927917 2308.444824,846.274780 
	C2310.511230,840.561279 2308.558838,836.306580 2309.105469,831.388184 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2530.761230,611.728027 
	C2531.346924,613.603394 2531.750000,614.840759 2531.804932,616.093445 
	C2531.861084,617.375366 2531.530273,618.679321 2529.955078,618.985596 
	C2528.438965,619.280334 2527.459473,618.277710 2526.916992,617.155884 
	C2525.764160,614.770447 2525.229980,612.022888 2526.901123,609.858582 
	C2528.432861,607.874756 2529.508545,609.864319 2530.761230,611.728027 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2253.170410,796.715698 
	C2257.640625,796.140930 2258.270264,798.460388 2257.590576,801.427979 
	C2257.101318,803.563293 2255.404297,803.491028 2253.746582,802.729187 
	C2250.806152,801.377869 2249.430664,799.648010 2253.170410,796.715698 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2322.015137,830.657593 
	C2324.999268,831.858948 2326.478271,833.480713 2324.485107,835.991516 
	C2323.010254,837.849426 2321.028564,837.873413 2319.549561,835.996399 
	C2317.579102,833.495483 2319.016846,831.856506 2322.015137,830.657593 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2538.240967,814.169189 
	C2541.086914,814.788330 2542.601807,816.327820 2541.089600,818.246582 
	C2539.100586,820.770447 2536.845703,818.686157 2535.585938,817.098633 
	C2534.026855,815.134155 2535.996826,814.547791 2538.240967,814.169189 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2223.301025,804.010132 
	C2222.960693,806.350281 2221.143555,808.002808 2218.557617,809.734619 
	C2216.213623,805.844238 2216.789307,805.095642 2223.301025,804.010132 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2376.660645,639.892212 
	C2376.000000,638.500000 2376.000000,637.000000 2376.000000,634.750000 
	C2380.328857,635.040039 2381.221191,636.864929 2376.660645,639.892212 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2278.975098,812.566772 
	C2278.235352,810.819153 2278.271240,809.557922 2279.785156,809.077148 
	C2280.196045,808.946716 2281.183594,809.428711 2281.312256,809.823303 
	C2281.860107,811.504883 2281.788574,813.011963 2278.975098,812.566772 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2201.015137,782.026367 
	C2200.040527,783.761108 2198.826660,783.958923 2197.643066,783.152832 
	C2196.680420,782.497070 2196.687500,781.443604 2197.674316,780.813416 
	C2198.876953,780.045410 2200.088135,780.258362 2201.015137,782.026367 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2287.078125,815.156433 
	C2285.453125,815.346558 2284.568359,814.782471 2284.929932,813.663513 
	C2285.399658,812.209595 2286.792725,811.866333 2287.979004,812.648682 
	C2289.087402,813.379578 2288.273926,814.262573 2287.078125,815.156433 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2243.165039,832.090088 
	C2242.387207,833.515625 2241.603027,833.528992 2240.908691,832.515930 
	C2240.763184,832.303650 2240.768066,831.810730 2240.918701,831.603455 
	C2241.639893,830.611206 2242.423828,830.646606 2243.165039,832.090088 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2427.658691,833.163757 
	C2418.828369,842.998291 2408.608643,848.687134 2395.512451,848.029480 
	C2390.596436,847.782593 2387.318359,845.789062 2386.184814,840.876343 
	C2384.666016,834.292236 2386.301758,829.863464 2391.326904,827.448364 
	C2393.693604,826.310913 2396.259277,825.573792 2398.761230,824.734314 
	C2401.763916,823.726807 2405.416016,824.042786 2406.685791,819.905640 
	C2407.218018,818.172546 2409.305664,817.894775 2410.944580,818.080933 
	C2417.839844,818.864014 2421.166504,814.709778 2423.590088,807.404541 
	C2428.166748,816.368347 2423.959717,825.074158 2427.658691,833.163757 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2393.013672,783.017883 
	C2397.824707,789.766846 2400.461426,796.429016 2393.713379,802.263916 
	C2386.035156,808.903259 2385.977783,818.714111 2382.062988,826.883972 
	C2379.317627,832.613098 2376.681641,834.549133 2371.530762,833.913940 
	C2369.447754,833.657043 2367.439697,832.985962 2366.979492,830.758850 
	C2366.524902,828.559875 2368.766113,828.523071 2370.078613,827.662354 
	C2376.920410,823.174683 2377.072266,822.555847 2372.353027,815.386597 
	C2370.891113,813.166321 2369.657715,811.169739 2372.788818,809.783630 
	C2379.187012,806.951172 2378.561768,802.683960 2375.864990,797.599121 
	C2373.033447,792.260254 2375.581543,787.748291 2379.135742,784.168152 
	C2382.848145,780.428589 2387.473145,778.530762 2393.013672,783.017883 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2424.081299,910.616638 
	C2434.595459,915.829590 2436.113037,919.926941 2431.821045,929.585022 
	C2429.295898,935.266296 2423.773926,937.646240 2417.874512,935.595886 
	C2412.667725,933.786194 2410.052490,927.610535 2411.745117,921.860901 
	C2413.519531,915.832886 2417.888428,912.700134 2424.081299,910.616638 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2398.063232,957.998657 
	C2397.421631,956.715881 2397.087891,956.136414 2396.843994,955.521240 
	C2394.845215,950.476562 2392.677246,944.366028 2397.951416,941.129700 
	C2402.589111,938.283813 2408.872070,939.222473 2414.128906,942.125244 
	C2415.928955,943.119263 2417.489502,944.419312 2417.706787,946.595276 
	C2418.305664,952.590210 2414.943359,956.806396 2410.640625,960.044617 
	C2406.497314,963.162720 2402.030518,963.247192 2398.063232,957.998657 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2360.257812,837.523743 
	C2368.593018,846.728638 2367.602783,854.595215 2358.583740,858.756470 
	C2354.286865,860.738953 2351.742432,858.809814 2349.041748,856.066406 
	C2345.982178,852.958801 2342.637939,850.073853 2344.743408,844.953857 
	C2347.414551,838.459778 2351.622803,836.188232 2360.257812,837.523743 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2338.407715,936.794739 
	C2339.642822,938.019043 2340.293701,938.786987 2340.749756,939.657104 
	C2345.517334,948.750061 2343.331299,953.238159 2333.498779,956.526184 
	C2328.920166,958.057190 2326.474121,956.400208 2324.751221,952.803223 
	C2323.781250,950.777588 2323.472412,948.388916 2323.117432,946.124390 
	C2322.210938,940.346313 2325.041016,936.601746 2330.832520,936.085693 
	C2333.105713,935.883118 2335.431396,936.268250 2338.407715,936.794739 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2432.176758,696.350342 
	C2440.347412,697.707031 2443.321533,703.966187 2446.567627,709.574524 
	C2448.654297,713.179565 2444.014404,719.649353 2438.749023,721.406616 
	C2436.049316,722.307617 2433.677979,722.125122 2427.388184,720.521667 
	C2427.230713,718.040955 2429.253662,718.236145 2430.714355,717.941101 
	C2433.660156,717.346130 2435.483398,715.762085 2435.816406,712.694763 
	C2436.197754,709.182373 2433.599365,708.541138 2431.119141,707.341492 
	C2428.694580,706.168457 2424.385742,706.853699 2424.484863,702.640442 
	C2424.582520,698.507019 2428.581055,697.935791 2432.176758,696.350342 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2351.957275,874.456604 
	C2352.762207,882.315796 2348.212891,885.408997 2342.598389,887.521240 
	C2338.606201,889.023010 2333.884766,889.474854 2332.244385,894.279541 
	C2330.544189,899.259521 2327.671387,897.177063 2325.478027,895.311890 
	C2323.229980,893.400208 2321.032959,890.508362 2323.727051,887.591675 
	C2325.939453,885.196289 2325.091064,878.906250 2331.693848,881.392212 
	C2334.611084,882.490540 2338.358154,882.269348 2341.523193,881.630310 
	C2347.239502,880.476135 2348.760742,875.731018 2345.208740,871.265808 
	C2344.404053,870.254395 2343.156250,869.604492 2342.155762,868.737976 
	C2341.084961,867.810852 2340.333008,866.478821 2341.215820,865.303406 
	C2342.421143,863.698181 2344.274170,864.068298 2345.650146,865.126343 
	C2348.538818,867.347351 2351.524902,869.588501 2351.957275,874.456604 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2463.375000,861.907959 
	C2464.190918,863.644104 2464.228760,865.318542 2464.598145,866.916565 
	C2466.469727,875.012207 2462.257324,882.128662 2454.387451,883.910645 
	C2452.142822,884.418884 2449.852539,884.725647 2447.581299,885.113586 
	C2444.193604,885.692078 2441.800537,884.055054 2442.971436,880.899658 
	C2444.231934,877.503601 2442.466797,874.475647 2443.049805,870.841187 
	C2446.844971,870.551575 2450.530029,876.063171 2454.362793,870.719360 
	C2457.004395,867.036560 2457.430420,863.199646 2456.926025,859.147705 
	C2460.038330,858.799377 2460.619873,861.738342 2463.375000,861.907959 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2406.000000,733.998779 
	C2409.093262,734.067017 2410.278809,731.117981 2412.539551,729.856567 
	C2418.280029,726.653992 2422.278320,727.411133 2425.156738,732.339966 
	C2428.239014,737.617859 2426.932373,742.391541 2421.234863,746.667175 
	C2417.670166,749.342163 2412.235107,748.136780 2409.134277,743.759583 
	C2407.412109,741.328674 2405.988770,738.665283 2406.012939,734.758301 
	C2406.000000,734.002441 2406.000000,734.000000 2406.000000,733.998779 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2408.833496,758.814819 
	C2411.338867,762.160461 2416.446045,763.997681 2411.322021,768.736755 
	C2406.355469,773.330200 2400.382568,775.482361 2396.454102,772.900757 
	C2393.443359,770.922241 2391.141357,763.573486 2392.420166,760.444397 
	C2393.481689,757.846741 2396.085693,757.973999 2398.057373,757.016174 
	C2401.702393,755.245667 2405.070557,756.246704 2408.833496,758.814819 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2417.956543,882.856262 
	C2421.339111,889.007385 2416.946289,890.842896 2412.726807,891.717957 
	C2407.445068,892.813354 2402.530273,892.032104 2398.270508,887.535706 
	C2394.783447,883.854736 2393.341064,878.929199 2389.637939,875.513062 
	C2388.156982,874.146606 2388.979248,872.581848 2389.922119,871.083923 
	C2391.136230,869.154785 2392.141846,867.094116 2393.235107,865.093750 
	C2401.342041,868.243713 2401.409912,868.253601 2400.225830,876.397644 
	C2399.602295,880.687927 2400.342041,884.412659 2404.223877,886.785156 
	C2407.898926,889.031433 2411.142334,887.840759 2414.052734,884.996704 
	C2414.975830,884.094666 2416.191895,883.492371 2417.956543,882.856262 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2447.097168,905.300903 
	C2438.918701,912.010254 2434.704590,911.322754 2427.975098,902.885437 
	C2422.409424,895.907349 2422.821045,892.220642 2429.791260,886.837280 
	C2432.794434,888.060303 2430.337158,890.153137 2430.584229,891.808838 
	C2431.624512,898.775330 2435.890869,901.977112 2443.758301,901.035767 
	C2447.162109,900.628479 2447.992920,901.629639 2447.097168,905.300903 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2311.284668,908.451660 
	C2310.641113,906.124146 2310.128418,904.517029 2310.091064,902.898926 
	C2310.027832,900.168823 2310.402588,897.194641 2313.791748,896.877747 
	C2316.844971,896.592285 2318.536133,899.120422 2319.421875,901.625610 
	C2320.285400,904.068237 2320.223389,906.829712 2321.014648,909.308594 
	C2321.662109,911.337769 2324.791016,911.915527 2324.930664,914.589600 
	C2316.031982,916.505615 2316.031982,916.505615 2311.284668,908.451660 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2424.372559,776.752319 
	C2428.104248,774.446594 2431.201904,769.946716 2435.015869,774.700378 
	C2437.170410,777.385559 2439.370605,780.599243 2435.685303,784.364136 
	C2432.467041,787.651978 2429.391846,788.991089 2425.216797,786.496765 
	C2420.971436,783.960388 2421.521973,780.771851 2424.372559,776.752319 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2485.210938,695.983215 
	C2485.887695,697.961975 2486.140381,700.035095 2485.583740,701.861633 
	C2484.562012,705.213928 2482.230469,707.458496 2478.543457,707.828186 
	C2474.709717,708.212585 2473.651367,705.169983 2472.296875,702.580322 
	C2471.084229,700.262451 2469.617920,697.933105 2471.732666,694.625427 
	C2476.359375,693.272583 2480.242188,695.557129 2485.210938,695.983215 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2377.512207,866.564575 
	C2378.482178,867.496460 2379.025391,867.904541 2379.403320,868.431335 
	C2380.821045,870.407288 2384.812744,872.132141 2382.641113,874.634705 
	C2379.956055,877.729431 2377.455566,874.245117 2375.415039,872.318359 
	C2374.250732,871.218933 2373.259277,869.834290 2372.532959,868.403992 
	C2371.914307,867.186218 2372.208252,865.668030 2373.498291,864.994873 
	C2374.813721,864.308594 2375.974121,865.267273 2377.512207,866.564575 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2447.133789,694.079041 
	C2450.325195,691.835571 2453.539062,690.197571 2456.834717,688.745056 
	C2458.375244,688.065979 2460.290527,687.834106 2460.945801,689.850647 
	C2461.572266,691.778809 2459.980713,693.131653 2458.396973,693.456909 
	C2454.717773,694.212769 2451.292725,697.672852 2447.133789,694.079041 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2437.276367,763.278198 
	C2435.982422,761.119934 2433.969971,759.775879 2435.269775,757.440125 
	C2438.453857,756.407227 2438.600586,759.941528 2440.429199,760.976624 
	C2442.446045,762.118347 2445.134766,761.386719 2447.185303,764.021729 
	C2443.871826,767.353882 2440.834961,765.361206 2437.276367,763.278198 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2381.075439,856.577271 
	C2379.020752,857.063599 2376.139648,857.709961 2377.345947,855.473633 
	C2379.935791,850.671570 2385.292480,851.337219 2389.030029,856.401001 
	C2386.562988,858.558899 2384.124512,855.279968 2381.075439,856.577271 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2454.120117,834.931763 
	C2450.114014,832.892151 2448.969238,830.518127 2451.561279,826.765808 
	C2454.744629,827.872864 2454.563965,831.528564 2456.761230,833.285278 
	C2457.720947,834.052551 2456.230957,835.335571 2454.120117,834.931763 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2308.846191,871.741943 
	C2305.037354,868.429321 2308.637695,868.033508 2310.199463,867.050537 
	C2311.550537,866.200317 2313.256348,865.758667 2314.606934,867.177612 
	C2315.297119,867.902832 2315.279541,868.891541 2314.633301,869.781738 
	C2313.355713,871.541260 2311.525879,871.916809 2308.846191,871.741943 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2464.000000,861.997559 
	C2464.022461,861.335693 2464.022949,860.674561 2464.072021,860.017090 
	C2464.201904,858.273804 2464.615479,856.612061 2466.843994,856.930298 
	C2468.250977,857.131226 2469.197266,858.322754 2469.103760,859.731689 
	C2468.949951,862.046448 2466.923584,861.719482 2464.686035,861.990479 
	C2464.000000,862.004883 2464.000000,862.000000 2464.000000,861.997559 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2405.560059,807.599731 
	C2404.311279,809.464355 2403.252930,809.303467 2402.539307,807.850647 
	C2402.093018,806.942322 2402.230225,805.757812 2403.197998,805.298340 
	C2404.770508,804.551941 2405.439209,805.590149 2405.560059,807.599731 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2451.379883,720.988159 
	C2451.019531,718.161194 2452.531738,718.124207 2454.204102,718.716858 
	C2454.593994,718.855042 2455.048340,719.861511 2454.905029,720.268250 
	C2454.377686,721.764648 2453.116211,721.782959 2451.379883,720.988159 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2444.749756,816.896790 
	C2443.189453,817.337402 2442.624023,816.791626 2442.864502,815.579956 
	C2442.914307,815.328003 2443.270508,814.988342 2443.524414,814.950256 
	C2444.747559,814.766296 2445.261230,815.360779 2444.749756,816.896790 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2464.090088,804.835571 
	C2465.515137,805.612976 2465.529053,806.396912 2464.515625,807.090881 
	C2464.303223,807.236267 2463.811035,807.231445 2463.603516,807.080933 
	C2462.609131,806.359985 2462.648438,805.576538 2464.090088,804.835571 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2409.909668,799.164673 
	C2408.484619,798.387085 2408.470947,797.602966 2409.484131,796.909058 
	C2409.696533,796.763611 2410.189697,796.768433 2410.396729,796.919067 
	C2411.388916,797.640442 2411.352783,798.424072 2409.909668,799.164673 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2352.896240,813.250488 
	C2353.337402,814.811035 2352.790283,815.374817 2351.579834,815.135559 
	C2351.328125,815.085815 2350.989014,814.729675 2350.950928,814.475464 
	C2350.766113,813.252014 2351.360840,812.739258 2352.896240,813.250488 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2544.749756,786.896606 
	C2543.187988,787.338196 2542.625732,786.789246 2542.864014,785.579346 
	C2542.913818,785.327576 2543.270020,784.988281 2543.524414,784.950073 
	C2544.747559,784.766357 2545.261230,785.360657 2544.749756,786.896606 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2414.749512,854.896851 
	C2413.188232,855.338257 2412.625000,854.789734 2412.863770,853.579407 
	C2412.913574,853.327637 2413.270020,852.988342 2413.524414,852.950134 
	C2414.747803,852.766235 2415.261230,853.360901 2414.749512,854.896851 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2405.383789,1985.562012 
	C2411.869873,1985.105103 2414.570557,1981.352905 2413.881104,1975.805664 
	C2413.121582,1969.693481 2415.560059,1965.317017 2419.867920,1960.718506 
	C2420.333252,1959.744019 2420.666748,1959.487915 2421.500000,1959.615967 
	C2426.908447,1959.314453 2430.090820,1961.064209 2431.120850,1966.196289 
	C2431.500977,1968.089966 2432.250732,1969.920288 2432.937744,1971.739624 
	C2435.385742,1978.221436 2435.389160,1978.171631 2428.164795,1980.483276 
	C2427.397217,1980.728882 2426.911377,1981.853760 2426.147461,1983.285400 
	C2425.476318,1984.745239 2424.834717,1985.364868 2423.459717,1986.131104 
	C2419.071289,1987.578857 2418.472656,1989.844482 2420.812012,1993.669189 
	C2421.228271,1995.194702 2421.156250,1996.082886 2420.443115,1997.479004 
	C2420.666016,2003.949951 2425.316162,2004.986084 2429.933838,2005.897949 
	C2431.864502,2006.279053 2434.005615,2005.821655 2435.840820,2006.406006 
	C2439.189453,2007.472656 2441.516846,2009.779663 2441.839355,2013.531372 
	C2442.096436,2016.518311 2440.665771,2018.539307 2438.065674,2019.917480 
	C2429.527588,2024.442749 2427.905762,2025.358276 2424.333496,2016.849731 
	C2422.731689,2013.034790 2420.181396,2010.025757 2414.740479,2010.014893 
	C2412.888184,2011.061035 2411.569336,2011.644775 2409.301758,2011.704224 
	C2403.548340,2010.802368 2399.774658,2007.842407 2395.740234,2003.917480 
	C2393.412842,2001.743286 2391.816895,1999.927124 2391.729980,1996.677368 
	C2390.707275,1989.999390 2385.843018,1992.591797 2382.325928,1992.020020 
	C2379.551758,1991.568970 2375.981201,1993.114746 2374.458496,1989.533447 
	C2373.227295,1986.638184 2370.876953,1983.602417 2373.200439,1980.243042 
	C2375.560547,1976.830933 2378.942383,1974.656860 2383.065674,1974.361694 
	C2386.187256,1974.138062 2387.496094,1976.834717 2388.594971,1979.277344 
	C2390.559570,1983.644775 2393.284668,1987.192139 2397.973389,1988.924561 
	C2399.880859,1989.629272 2401.114746,1989.215576 2401.898926,1986.643066 
	C2402.793945,1985.300903 2403.716309,1985.010376 2405.383789,1985.562012 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2461.333740,2013.851074 
	C2466.948730,2013.243652 2466.332031,2009.515137 2465.620850,2006.354492 
	C2464.827393,2002.830444 2463.533691,1999.213501 2459.263184,1998.277100 
	C2457.985596,1997.996948 2456.627441,1998.082275 2455.305664,1998.005859 
	C2445.293213,1997.427124 2441.306641,1994.241211 2438.627197,1984.693970 
	C2438.129639,1982.921753 2438.445557,1981.476196 2440.126709,1980.482788 
	C2445.982666,1977.022217 2451.486328,1977.942139 2455.597900,1983.397461 
	C2457.011475,1985.273193 2458.038330,1987.350342 2461.300781,1987.916504 
	C2462.300781,1987.721069 2462.601562,1987.442261 2463.513672,1987.229492 
	C2465.601807,1987.924927 2466.834229,1989.077393 2469.090332,1989.458984 
	C2470.925781,1989.877197 2472.090088,1990.316162 2473.545166,1991.556641 
	C2483.750488,1993.658813 2488.758545,1998.755493 2489.555664,2007.732910 
	C2489.764160,2010.079834 2488.826416,2011.360352 2486.532715,2011.908936 
	C2482.825195,2012.795654 2478.743896,2012.932739 2476.138184,2017.285889 
	C2469.944336,2019.343872 2472.171875,2024.076050 2472.394287,2027.627441 
	C2472.530762,2029.803833 2474.026611,2031.896729 2474.920166,2034.023682 
	C2476.268799,2037.234497 2474.224854,2039.058716 2472.001465,2040.558228 
	C2469.934814,2041.952026 2459.043701,2039.710938 2457.182861,2037.744385 
	C2453.874268,2034.247803 2453.008057,2027.990723 2455.438965,2023.915649 
	C2456.770752,2021.682861 2459.327393,2020.263428 2459.913574,2016.723633 
	C2459.639404,2015.064697 2459.862305,2014.298828 2461.333740,2013.851074 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2352.615234,1978.434814 
	C2345.444580,1978.591919 2343.341064,1974.182983 2342.199707,1969.005737 
	C2341.092285,1963.980591 2343.442627,1960.749268 2348.090088,1958.923828 
	C2349.316650,1958.442139 2350.568604,1957.848633 2351.580811,1957.025757 
	C2361.899658,1948.638794 2361.909912,1942.836182 2350.642822,1934.327759 
	C2346.166260,1930.947388 2342.575439,1933.877319 2338.713135,1935.636841 
	C2331.233398,1939.044312 2330.271240,1938.412964 2330.000977,1930.243408 
	C2329.478516,1914.459351 2329.861084,1914.020264 2346.803467,1911.100952 
	C2347.773193,1913.837524 2348.442871,1916.766602 2349.799561,1919.332275 
	C2352.353027,1924.159668 2355.614990,1928.344849 2361.958008,1927.997681 
	C2368.666748,1927.630493 2372.292969,1931.384521 2374.567139,1937.180176 
	C2376.843506,1942.981445 2376.740723,1944.023926 2370.480957,1946.735352 
	C2362.866455,1950.033325 2359.506104,1956.400269 2358.297852,1963.727783 
	C2357.602051,1967.947144 2356.541992,1972.118652 2356.020020,1977.187378 
	C2355.205322,1978.698730 2354.282227,1978.988892 2352.615234,1978.434814 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2391.171875,1996.000000 
	C2393.161377,1997.635376 2394.322510,1999.270752 2395.741943,2001.453125 
	C2398.811523,2005.687500 2399.233887,2012.558716 2407.353516,2010.017334 
	C2409.500000,2010.000610 2411.000000,2010.001099 2413.250000,2010.003174 
	C2414.154785,2010.640259 2414.110840,2011.451050 2414.493896,2011.885132 
	C2423.222412,2021.781006 2420.508789,2021.721924 2416.093262,2031.258301 
	C2415.666748,2031.996216 2415.333252,2031.997437 2414.500000,2031.999268 
	C2405.775146,2033.432739 2399.678955,2030.594482 2396.650391,2022.678345 
	C2395.393311,2019.392212 2393.577393,2018.185303 2390.162842,2017.824951 
	C2386.940186,2017.484985 2383.579590,2016.534302 2380.733154,2015.007202 
	C2376.739990,2012.865234 2374.442627,2009.021362 2374.434326,2004.432373 
	C2374.428223,2000.983276 2379.823730,1996.683960 2384.378906,1996.085449 
	C2386.336914,1995.828125 2388.353760,1996.015015 2391.171875,1996.000000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2397.291016,1913.912354 
	C2398.378418,1916.782715 2400.048828,1917.977417 2402.774658,1917.964600 
	C2406.098633,1917.948975 2409.437012,1918.192505 2412.742920,1917.954956 
	C2417.395508,1917.620605 2420.599609,1919.263672 2421.584229,1923.953491 
	C2422.271973,1927.228638 2422.625488,1930.681152 2419.277832,1932.969727 
	C2416.460449,1934.895752 2407.884033,1934.598877 2406.324707,1931.814453 
	C2401.039795,1922.377563 2392.551025,1921.678589 2383.214844,1921.906616 
	C2376.644775,1922.067017 2370.025146,1911.456177 2372.589844,1905.487061 
	C2374.048340,1902.092163 2377.183594,1902.329712 2380.164307,1901.885254 
	C2387.622070,1900.773193 2387.592285,1900.666870 2390.827393,1907.487793 
	C2392.100098,1910.171021 2393.099609,1913.134277 2397.291016,1913.912354 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2332.474609,2019.526123 
	C2328.911865,2021.010254 2328.268799,2024.585571 2325.610352,2026.069458 
	C2322.881836,2027.592651 2320.233398,2028.790527 2317.479248,2026.087280 
	C2314.319092,2022.986084 2313.476074,2018.296997 2315.849609,2015.406372 
	C2316.877686,2014.154785 2318.193848,2012.966064 2319.629639,2012.253052 
	C2326.321777,2008.929321 2326.853271,2003.400513 2325.385498,1997.052979 
	C2324.940918,1995.129883 2324.298828,1993.219849 2324.135986,1991.271362 
	C2323.877930,1988.181152 2325.211426,1986.316284 2328.608643,1986.051270 
	C2334.782471,1985.569458 2340.329346,1986.032593 2344.660889,1991.528687 
	C2348.998779,1997.032471 2349.105957,1998.314941 2342.977051,2001.998169 
	C2341.801758,2002.704468 2340.720459,2003.278442 2340.124023,2005.307373 
	C2339.269287,2007.663330 2337.747559,2008.454224 2335.802734,2009.674072 
	C2333.736816,2010.907104 2333.297119,2012.282227 2333.683105,2014.611572 
	C2333.827148,2016.587891 2333.606934,2017.866821 2332.474609,2019.526123 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2415.903809,1866.016113 
	C2407.762207,1870.924561 2406.726562,1873.033813 2408.555664,1880.637329 
	C2409.172852,1883.202637 2410.236816,1885.658936 2410.892090,1888.217407 
	C2411.102295,1889.037720 2410.835938,1890.739502 2410.480469,1890.829834 
	C2406.062500,1891.952393 2401.625244,1893.185303 2397.114746,1893.691162 
	C2394.100342,1894.029175 2392.792969,1891.238892 2391.437500,1888.879395 
	C2386.577148,1880.418457 2386.827148,1878.391479 2396.196289,1875.171265 
	C2403.266113,1872.741455 2406.463867,1869.082642 2406.254883,1861.520020 
	C2406.133789,1857.134033 2408.799561,1853.246216 2412.683594,1850.890259 
	C2415.337402,1849.280273 2418.262451,1846.523804 2421.570801,1849.752197 
	C2424.804932,1852.907959 2424.706787,1858.969116 2421.382080,1862.158691 
	C2419.963135,1863.519531 2418.196533,1864.517944 2415.903809,1866.016113 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2555.248535,1994.089844 
	C2555.995605,1997.979126 2555.887207,2001.961792 2556.019531,2005.936401 
	C2556.130859,2009.288818 2554.993896,2011.676025 2551.791504,2013.019165 
	C2548.400635,2014.441650 2545.320068,2014.245850 2542.647705,2011.557129 
	C2539.376953,2008.266846 2535.799805,2005.196533 2533.020996,2001.526855 
	C2530.592041,1998.319702 2528.184326,1997.851318 2524.486572,1998.712524 
	C2517.568604,2000.323853 2512.045410,1996.836792 2510.499756,1990.384888 
	C2510.082031,1988.640869 2510.542236,1987.222168 2512.342285,1986.302979 
	C2515.569336,1984.654907 2518.694336,1982.807983 2521.905029,1981.125732 
	C2525.379883,1979.304810 2527.551025,1980.797485 2528.928955,1984.072266 
	C2529.185791,1984.682861 2529.506104,1985.283813 2529.648438,1985.922241 
	C2530.404785,1989.317261 2529.060059,1993.993530 2533.555420,1995.312256 
	C2538.465820,1996.753174 2543.553955,1999.087402 2548.872803,1996.095337 
	C2550.569824,1995.140747 2552.612793,1994.800781 2555.248535,1994.089844 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2331.206055,1950.534668 
	C2332.563477,1956.207153 2328.973389,1959.067261 2325.713135,1960.734741 
	C2317.396240,1964.988281 2317.119873,1971.541138 2318.695312,1979.283569 
	C2319.957520,1985.486694 2319.549072,1985.707153 2312.923340,1986.023193 
	C2308.385742,1986.239624 2304.685791,1985.802124 2302.253174,1980.896484 
	C2300.024414,1976.401123 2300.378906,1973.017456 2304.666504,1970.893066 
	C2312.780029,1966.873047 2314.931641,1960.355103 2314.079834,1951.956787 
	C2313.759277,1948.795410 2313.448730,1945.541016 2317.731934,1943.757690 
	C2325.015381,1940.725342 2327.570557,1941.644043 2331.206055,1950.534668 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1978.773926,1874.580322 
	C1979.848633,1873.359131 1980.566406,1872.715820 1981.613403,1871.423828 
	C1982.990356,1870.441650 1983.559204,1869.458496 1984.970825,1868.784180 
	C1986.482178,1871.479980 1989.419922,1872.905396 1990.322754,1875.993042 
	C1992.270386,1882.652710 1996.322388,1886.890503 2004.029785,1886.120605 
	C2006.498901,1885.873901 2008.483765,1887.319702 2009.971069,1889.190430 
	C2012.723877,1892.653076 2013.114502,1896.916138 2010.877075,1900.271729 
	C2008.769897,1903.432373 2004.628052,1902.519165 2001.860352,1900.722900 
	C1995.084473,1896.325439 1988.140991,1893.352905 1979.795654,1893.400513 
	C1976.259644,1893.420776 1973.079346,1890.790894 1970.959717,1886.701172 
	C1970.925293,1885.277588 1971.382935,1884.300293 1971.970459,1882.788574 
	C1974.001587,1879.707153 1976.594238,1877.775269 1978.773926,1874.580322 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2003.352173,1920.931152 
	C2002.223022,1918.382690 2001.274902,1916.613647 2000.636841,1914.739136 
	C2000.345947,1913.884888 2000.270264,1912.390137 2000.776489,1911.925049 
	C2003.799683,1909.145752 2007.548584,1908.070923 2011.609375,1908.017700 
	C2015.253906,1907.969971 2019.127930,1907.460815 2020.857666,1911.905151 
	C2022.055298,1914.982300 2023.312866,1917.970215 2025.100952,1920.816162 
	C2028.661133,1926.482422 2031.133301,1928.044434 2037.750610,1927.005005 
	C2039.723511,1926.695190 2041.680908,1925.723145 2043.433960,1927.059692 
	C2045.898438,1928.938599 2047.890137,1931.651245 2047.099365,1934.692871 
	C2046.166016,1938.284058 2042.631470,1938.019165 2039.605591,1937.916992 
	C2037.081177,1937.831787 2035.086670,1936.487671 2033.712280,1934.613037 
	C2029.246216,1928.521484 2023.136963,1927.410767 2016.118042,1927.904053 
	C2012.608032,1928.150757 2008.628662,1929.061523 2005.708008,1926.093262 
	C2004.634644,1925.002441 2004.320312,1923.164795 2003.352173,1920.931152 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1954.081421,1945.292480 
	C1953.111084,1946.000000 1952.222168,1946.000000 1950.666626,1946.000000 
	C1937.743286,1945.738525 1935.470215,1943.457397 1932.870361,1928.754883 
	C1932.397461,1928.225708 1932.247559,1927.257812 1932.177979,1926.772949 
	C1934.632812,1923.404419 1936.988403,1920.331055 1941.353760,1918.562988 
	C1943.064453,1918.407349 1944.014282,1918.608643 1945.463867,1919.495117 
	C1946.281250,1921.667236 1946.825439,1922.992310 1948.639404,1923.740479 
	C1960.874878,1928.787354 1962.113647,1932.702759 1954.835571,1942.754395 
	C1954.468750,1943.261230 1954.380615,1943.969971 1954.081421,1945.292480 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2293.366699,1974.505859 
	C2296.780273,1978.489624 2298.010254,1982.371338 2298.084473,1986.884766 
	C2298.154053,1991.093384 2296.904785,1993.531982 2292.615723,1994.832886 
	C2285.776123,1996.907715 2280.966797,1996.369873 2278.292236,1992.421753 
	C2275.321533,1988.036621 2275.163086,1980.540283 2277.954834,1976.455322 
	C2280.992188,1972.010742 2285.143066,1971.310913 2293.366699,1974.505859 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2241.544189,1954.616577 
	C2245.086426,1951.579346 2242.621582,1949.291260 2241.574951,1947.274780 
	C2239.840820,1943.933105 2239.709229,1941.234619 2243.602051,1938.540283 
	C2246.448486,1935.694580 2249.115967,1934.043945 2253.342285,1935.533691 
	C2260.100342,1934.779663 2261.566162,1938.425781 2262.992188,1943.445068 
	C2264.485840,1948.703735 2263.793701,1952.657227 2259.108643,1955.239502 
	C2254.299316,1957.890137 2249.321533,1960.827026 2242.713379,1958.077637 
	C2241.215332,1957.236206 2240.911377,1956.313843 2241.544189,1954.616577 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2420.672852,1907.347168 
	C2420.034424,1906.083130 2419.607422,1905.508423 2419.486084,1904.875122 
	C2418.693848,1900.747192 2411.725342,1897.150024 2415.266113,1893.733521 
	C2419.581055,1889.570312 2426.923096,1889.755127 2433.058594,1888.551270 
	C2434.802734,1888.208740 2435.830322,1890.208618 2435.872803,1891.997803 
	C2435.966797,1895.991943 2436.179443,1900.013306 2435.837646,1903.980103 
	C2435.403809,1909.016357 2430.614258,1909.496948 2427.208252,1911.201538 
	C2424.014404,1912.799927 2422.311768,1910.592163 2420.672852,1907.347168 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1951.094238,1906.408447 
	C1953.482056,1905.116333 1954.799927,1903.537964 1956.043335,1901.111816 
	C1958.059692,1897.727295 1960.290771,1895.327271 1963.979736,1893.599609 
	C1969.429443,1896.067993 1970.711060,1901.270142 1973.241943,1905.404907 
	C1975.360107,1908.865356 1972.547485,1914.818848 1968.797852,1917.565186 
	C1964.814331,1920.483032 1961.192139,1919.352783 1957.927124,1916.593262 
	C1955.672974,1914.688477 1953.864624,1912.255981 1951.159058,1909.736328 
	C1950.350586,1908.565918 1950.461670,1907.748901 1951.094238,1906.408447 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2398.616211,1966.437988 
	C2389.624268,1965.721436 2385.167969,1961.347412 2384.697266,1953.034790 
	C2384.593750,1951.206909 2385.177246,1949.721802 2386.720947,1948.856201 
	C2390.707275,1946.621216 2395.171631,1943.344116 2399.467041,1945.468384 
	C2403.874756,1947.648071 2404.400146,1952.981445 2403.892334,1957.760132 
	C2403.652344,1960.017578 2402.785156,1962.208496 2402.101074,1965.214844 
	C2401.206055,1966.699097 2400.283691,1966.989624 2398.616211,1966.437988 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2156.000000,1870.838135 
	C2158.166016,1869.257202 2160.360840,1868.588867 2162.493164,1867.758667 
	C2169.823975,1864.903931 2172.727783,1866.478149 2175.262207,1874.765869 
	C2177.106689,1880.798218 2174.378174,1884.676880 2166.937988,1886.599609 
	C2161.135254,1888.099121 2157.252686,1885.316284 2156.163330,1878.597046 
	C2155.797363,1876.340576 2156.036865,1873.986206 2156.000000,1870.838135 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2505.860596,2065.778320 
	C2505.768555,2069.475830 2503.381836,2071.192139 2502.249268,2073.553955 
	C2499.840332,2078.577637 2495.456299,2078.535156 2491.115479,2077.644531 
	C2487.198486,2076.840820 2486.476074,2073.277100 2486.089844,2069.891113 
	C2485.566162,2065.302734 2486.319336,2061.101807 2490.958008,2058.865234 
	C2494.073242,2057.363037 2497.526855,2057.754150 2500.786621,2058.297363 
	C2504.345215,2058.890137 2505.064209,2062.059570 2505.860596,2065.778320 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2319.912842,1994.210449 
	C2321.923584,1997.568726 2322.409668,2000.354980 2321.204834,2003.364014 
	C2319.556885,2007.478638 2316.416992,2009.438965 2312.145996,2009.918213 
	C2308.809814,2010.292358 2306.489746,2009.086304 2304.982422,2005.987671 
	C2303.097656,2002.112549 2300.636475,1998.206909 2302.752930,1993.869141 
	C2304.707275,1989.863281 2313.241211,1989.890381 2319.912842,1994.210449 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2506.058838,1969.793457 
	C2505.843018,1966.179810 2507.087402,1963.993042 2509.014160,1961.982422 
	C2513.032959,1957.788940 2514.399170,1957.876831 2521.098633,1961.499756 
	C2525.293213,1963.767944 2526.822266,1966.659302 2525.290771,1971.198120 
	C2523.652832,1976.051392 2518.152588,1980.640747 2514.342041,1979.533447 
	C2510.015869,1978.276367 2507.089844,1975.157959 2506.058838,1969.793457 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2254.085449,1935.279785 
	C2251.158447,1936.655518 2248.316650,1937.315674 2244.737549,1937.985596 
	C2243.971680,1935.511108 2242.449463,1933.837158 2241.053711,1931.959717 
	C2236.878906,1926.343018 2237.167725,1923.775879 2241.739258,1919.262085 
	C2244.896240,1916.145386 2248.230957,1914.813354 2252.258789,1917.548828 
	C2256.735840,1920.589111 2258.275391,1926.337891 2255.924805,1931.082886 
	C2255.348145,1932.247314 2254.755859,1933.404053 2254.085449,1935.279785 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2533.499023,2045.616699 
	C2541.943359,2044.355225 2544.348145,2045.463623 2546.911377,2051.950439 
	C2548.940430,2057.085693 2547.807373,2060.485107 2542.754883,2063.526367 
	C2539.620361,2065.413330 2536.421143,2067.103516 2532.912109,2063.854248 
	C2529.291992,2060.502197 2527.742676,2055.647705 2529.513428,2051.713379 
	C2530.176758,2050.238525 2531.051270,2048.858643 2531.915039,2046.720215 
	C2532.332764,2045.747681 2532.665283,2045.490601 2533.499023,2045.616699 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2376.613281,2038.031128 
	C2374.424805,2040.204956 2372.925049,2042.190063 2370.931641,2043.146606 
	C2366.088135,2045.470703 2363.202881,2043.678833 2361.949463,2038.361450 
	C2360.870605,2033.784790 2360.003174,2029.432129 2363.675293,2025.427246 
	C2366.148682,2022.729736 2368.990723,2021.525024 2372.503906,2022.184692 
	C2376.520752,2022.938843 2377.401611,2026.280518 2377.848145,2029.595093 
	C2378.197266,2032.185791 2378.309570,2034.880737 2376.613281,2038.031128 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2351.881836,1978.688477 
	C2352.888916,1978.000000 2353.777832,1978.000000 2355.333496,1978.000000 
	C2366.212891,1978.822021 2370.567627,1985.340454 2366.259033,1993.356445 
	C2362.989502,1999.438477 2356.001221,1999.807495 2352.116211,1994.103149 
	C2347.775635,1987.730103 2347.724365,1985.592651 2351.881836,1978.688477 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2422.079590,1959.283081 
	C2422.000000,1960.000000 2421.000000,1960.000000 2420.500000,1960.000000 
	C2412.026123,1959.343628 2406.149658,1953.495117 2406.729736,1946.328125 
	C2407.057861,1942.275513 2410.299072,1939.593140 2413.657959,1938.672607 
	C2417.745361,1937.552246 2421.311279,1939.871826 2423.560547,1943.601440 
	C2426.762939,1948.911255 2424.330322,1953.736206 2422.079590,1959.283081 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2174.739258,1908.577148 
	C2170.345459,1910.904541 2167.814453,1908.896729 2165.394287,1906.379883 
	C2162.580811,1903.453979 2160.378906,1900.234253 2160.179199,1896.011719 
	C2160.112549,1894.602905 2160.728760,1893.459839 2161.813477,1892.586914 
	C2165.677734,1889.476929 2173.833008,1889.222900 2176.695312,1892.111206 
	C2181.285400,1896.742920 2180.789307,1902.978149 2174.739258,1908.577148 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2156.645996,1913.316406 
	C2153.275391,1913.745728 2150.636475,1914.033447 2148.022217,1913.886108 
	C2143.937988,1913.655396 2141.138428,1911.308960 2140.369141,1907.391846 
	C2139.759033,1904.286011 2138.959229,1900.725708 2142.134033,1898.260010 
	C2145.636719,1895.540039 2149.325195,1895.559814 2153.214844,1897.637085 
	C2159.400391,1900.939941 2160.827881,1905.965332 2156.645996,1913.316406 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2315.443848,1919.332031 
	C2323.357666,1919.115356 2325.397949,1920.685791 2325.958252,1926.564697 
	C2326.458984,1931.816406 2322.641846,1938.853882 2318.644531,1939.245117 
	C2315.145996,1939.587524 2312.398193,1937.426880 2310.130127,1934.942627 
	C2307.348633,1931.896240 2307.388672,1928.280151 2308.929443,1924.778198 
	C2310.019043,1922.302246 2312.278809,1920.760620 2315.443848,1919.332031 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2266.544922,1972.720703 
	C2265.354980,1975.314941 2263.404053,1976.050415 2261.901855,1977.298462 
	C2258.852783,1979.831421 2255.641357,1981.124023 2252.063477,1978.546631 
	C2248.631104,1976.073853 2246.690674,1968.310303 2248.894043,1965.004028 
	C2251.229248,1961.500000 2254.843994,1959.784180 2259.085938,1960.243530 
	C2263.533936,1960.725098 2266.037109,1964.742798 2266.544922,1972.720703 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2474.125488,1991.299683 
	C2472.500000,1991.995605 2471.000000,1991.996216 2468.750000,1991.995850 
	C2466.949707,1990.913330 2465.869873,1989.861084 2464.395020,1988.404419 
	C2464.000000,1988.000000 2463.000000,1988.000000 2462.500000,1988.000000 
	C2459.469971,1977.928589 2460.766602,1975.465820 2469.866699,1973.060791 
	C2475.637695,1971.535645 2482.383545,1977.714722 2481.697021,1983.628784 
	C2481.160889,1988.247559 2475.442383,1986.928955 2474.125488,1991.299683 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2523.797852,2093.929688 
	C2520.129639,2094.056885 2517.915283,2093.034424 2516.294189,2090.517090 
	C2513.001709,2085.404785 2513.320068,2079.176758 2517.197510,2075.975830 
	C2520.664307,2073.114014 2526.161865,2073.330078 2528.943848,2076.437500 
	C2533.171631,2081.159912 2532.916992,2088.177979 2528.199463,2092.402832 
	C2527.283936,2093.222412 2525.808350,2093.416016 2523.797852,2093.929688 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2476.000000,2018.828125 
	C2478.553711,2017.372070 2481.082764,2016.366211 2483.666504,2016.197388 
	C2488.662109,2015.870850 2493.162109,2019.361694 2493.910156,2023.642822 
	C2494.909912,2029.364746 2493.134521,2032.851562 2488.207031,2034.843506 
	C2483.543213,2036.728638 2477.773682,2033.387329 2476.346680,2027.564331 
	C2475.730713,2025.051025 2476.085938,2022.299561 2476.000000,2018.828125 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2333.547852,2008.482056 
	C2335.574951,2007.372803 2337.150146,2006.740723 2339.362793,2006.054443 
	C2346.952881,2007.488525 2349.936279,2010.734741 2349.951172,2016.827271 
	C2349.962891,2021.680420 2346.951416,2024.706055 2341.265869,2025.819946 
	C2336.994385,2026.656860 2334.324951,2025.065674 2332.539551,2020.474365 
	C2332.000000,2018.500000 2332.000000,2017.000000 2332.000000,2014.750000 
	C2332.044922,2012.250122 2331.977783,2010.475952 2333.547852,2008.482056 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2381.680908,1968.094971 
	C2378.403320,1970.385010 2375.351562,1971.550903 2372.066895,1971.883423 
	C2369.772949,1972.115845 2367.455811,1972.027344 2365.668213,1970.150146 
	C2362.731445,1967.065918 2365.015869,1958.141724 2369.712402,1954.394531 
	C2373.016846,1951.757812 2378.612305,1952.463745 2380.800537,1956.458130 
	C2382.595703,1959.735474 2384.849854,1963.447754 2381.680908,1968.094971 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2241.451660,1953.581055 
	C2242.000000,1954.888916 2242.000000,1955.777832 2242.000000,1957.333374 
	C2240.434570,1959.208496 2238.786377,1960.325439 2237.321289,1961.645386 
	C2234.519043,1964.170044 2231.400391,1964.844360 2228.245361,1962.773438 
	C2224.769043,1960.491577 2222.423828,1956.996826 2222.393311,1952.869995 
	C2222.364502,1948.942383 2224.939697,1946.163086 2228.712646,1944.773926 
	C2232.163330,1943.503418 2235.282715,1943.758667 2237.450439,1947.128906 
	C2238.702393,1949.075073 2239.758545,1951.146973 2241.451660,1953.581055 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2465.459473,1969.748291 
	C2458.964111,1967.837036 2454.315918,1961.494385 2454.726562,1956.196777 
	C2454.774902,1955.573975 2454.974365,1954.910645 2455.284424,1954.369873 
	C2456.468506,1952.304565 2467.798096,1950.036621 2469.908203,1951.400269 
	C2473.605713,1953.789673 2474.921631,1960.875610 2472.162354,1964.596924 
	C2470.608643,1966.692749 2468.746094,1968.598999 2465.459473,1969.748291 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2495.971680,1948.073975 
	C2497.930176,1952.173096 2499.427002,1955.664795 2495.173340,1958.245728 
	C2490.931152,1960.819580 2486.536621,1963.324951 2481.293701,1961.273193 
	C2478.840576,1960.313232 2478.268066,1958.098267 2478.040771,1955.658203 
	C2477.570557,1950.612183 2480.593750,1947.425049 2484.312500,1945.297607 
	C2488.257812,1943.040405 2492.537109,1942.989136 2495.971680,1948.073975 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2190.125000,1914.138428 
	C2190.273926,1911.653564 2190.900146,1910.090210 2192.191895,1908.985962 
	C2195.441406,1906.208374 2198.679443,1902.785889 2203.511719,1905.168823 
	C2206.735596,1906.758789 2208.855957,1914.620972 2207.824707,1918.705811 
	C2206.869141,1922.491211 2203.374268,1922.305176 2200.806396,1923.346436 
	C2197.866943,1924.538330 2194.763428,1924.213013 2192.890381,1921.218506 
	C2191.686523,1919.293823 2191.034180,1917.024048 2190.125000,1914.138428 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2513.284912,2022.704590 
	C2504.718506,2027.404663 2494.291016,2021.682739 2494.469238,2013.252808 
	C2494.486816,2012.413086 2495.295654,2010.872559 2495.747314,2010.869019 
	C2500.974121,2010.827026 2505.870361,2006.234497 2511.123047,2009.075806 
	C2515.499268,2011.443115 2513.677490,2016.149780 2513.906006,2019.984253 
	C2513.944824,2020.634644 2513.731934,2021.300171 2513.284912,2022.704590 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2184.940918,1914.433594 
	C2188.872559,1919.551147 2186.917480,1922.887085 2183.062256,1925.815674 
	C2179.627197,1928.425293 2173.096680,1928.827637 2170.132812,1926.602295 
	C2164.703613,1922.525757 2165.247559,1916.106201 2171.376953,1913.425049 
	C2175.732422,1911.519775 2180.194336,1910.905884 2184.940918,1914.433594 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2510.137207,2032.070679 
	C2519.772949,2034.910034 2522.252197,2042.032593 2516.241699,2048.191162 
	C2513.751465,2050.742920 2510.453369,2053.082275 2506.491943,2050.865723 
	C2502.608398,2048.692871 2500.692871,2040.542114 2503.062744,2036.487549 
	C2504.432617,2034.143799 2506.457520,2032.413940 2510.137207,2032.070679 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2441.052490,1973.249756 
	C2439.823730,1972.483643 2439.174316,1972.152954 2438.818604,1971.624390 
	C2435.226074,1966.284790 2434.963867,1960.707275 2438.144775,1957.040771 
	C2440.000000,1954.902588 2442.138428,1953.656372 2445.168457,1954.704102 
	C2449.069092,1956.052734 2453.367920,1962.687378 2453.348877,1967.490479 
	C2453.339600,1969.776733 2451.899658,1971.118652 2450.348633,1972.373047 
	C2447.756104,1974.470215 2444.760742,1974.108765 2441.052490,1973.249756 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2426.623535,1885.388916 
	C2424.268066,1885.782715 2422.633057,1885.877808 2420.998047,1885.975708 
	C2416.041748,1886.272827 2413.924561,1882.987793 2412.801758,1879.000732 
	C2411.931641,1875.911865 2415.702148,1870.075439 2419.120117,1868.718872 
	C2423.604736,1866.938965 2426.678467,1869.107300 2429.154785,1872.612671 
	C2432.700439,1877.631470 2432.417969,1879.498413 2426.623535,1885.388916 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2526.260010,2004.346069 
	C2529.956543,2004.401123 2531.602539,2006.643188 2533.460938,2008.489258 
	C2538.589355,2013.583496 2538.966797,2015.638428 2535.599121,2019.293579 
	C2531.753662,2023.467163 2526.605713,2024.672974 2523.333008,2022.166260 
	C2518.899658,2018.770752 2517.772705,2013.646606 2520.509277,2009.121704 
	C2521.733887,2007.096802 2523.335938,2005.440063 2526.260010,2004.346069 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2289.568359,1965.519775 
	C2286.750244,1968.574097 2283.528320,1969.401855 2280.249512,1969.860352 
	C2277.144287,1970.294678 2274.380615,1969.651367 2272.420898,1966.719116 
	C2269.643311,1962.563599 2269.235107,1956.561157 2271.846191,1954.781982 
	C2275.012939,1952.624146 2285.420898,1954.171753 2287.493652,1957.302490 
	C2288.954834,1959.509277 2290.186035,1961.932129 2289.568359,1965.519775 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2536.126953,2082.127930 
	C2531.178467,2071.674072 2531.640381,2071.094727 2542.291016,2068.774414 
	C2546.402344,2067.878662 2548.511719,2069.245361 2550.266357,2072.599121 
	C2554.095215,2079.914795 2551.572754,2084.769287 2543.324463,2085.785645 
	C2540.430664,2086.142090 2538.082520,2085.358154 2536.126953,2082.127930 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2266.064209,1940.281616 
	C2270.257568,1931.718628 2273.591309,1930.151245 2278.616943,1933.847168 
	C2282.240967,1936.512451 2284.743652,1939.877808 2283.867676,1944.804321 
	C2283.336914,1947.789062 2281.625000,1949.519165 2278.623779,1949.856689 
	C2273.777344,1950.401489 2269.243408,1949.989136 2266.793945,1944.913208 
	C2266.245361,1943.776733 2266.274170,1942.361816 2266.064209,1940.281616 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2421.443115,1984.609009 
	C2422.888916,1984.002686 2423.777832,1984.001343 2425.333496,1984.000000 
	C2431.369141,1983.414185 2434.609131,1986.721069 2436.990967,1990.692627 
	C2438.708252,1993.555664 2438.724121,1997.059814 2436.500244,1999.894775 
	C2434.400635,2002.571411 2431.184082,2002.396240 2428.383057,2001.636353 
	C2425.951660,2000.976807 2423.775879,1999.374756 2420.743652,1998.094727 
	C2420.000000,1997.111084 2420.000000,1996.222168 2420.000000,1994.666626 
	C2417.358887,1990.775146 2418.355713,1987.917236 2421.443115,1984.609009 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2435.683105,2027.654785 
	C2443.337646,2024.000122 2445.949463,2024.378906 2448.495361,2029.285034 
	C2450.605713,2033.350708 2450.998535,2037.504639 2447.619629,2041.190552 
	C2444.810791,2044.254395 2441.501465,2044.879395 2437.893555,2042.561035 
	C2434.003662,2040.061523 2432.327637,2035.348511 2433.723145,2030.737915 
	C2434.001465,2029.819458 2434.676270,2029.021118 2435.683105,2027.654785 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2388.249512,1926.060791 
	C2389.716797,1926.024658 2390.374512,1926.024414 2391.031982,1926.029663 
	C2395.545898,1926.065430 2398.848633,1928.191040 2399.522705,1932.616333 
	C2400.050293,1936.079224 2397.922852,1938.880615 2394.721436,1940.507690 
	C2390.985352,1942.406372 2387.188965,1942.867676 2383.560791,1940.272461 
	C2380.958984,1938.411255 2379.877441,1935.807251 2380.055908,1932.577759 
	C2380.317627,1927.835083 2383.825684,1926.941406 2388.249512,1926.060791 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2397.920898,1966.702515 
	C2398.888916,1966.003296 2399.777832,1966.001587 2401.333496,1966.000000 
	C2410.612549,1969.918335 2411.911865,1973.187988 2407.965088,1981.017700 
	C2407.375244,1982.187622 2406.779297,1983.354614 2406.093262,1985.259033 
	C2405.111084,1985.996826 2404.222168,1985.998413 2402.666504,1986.000000 
	C2399.573242,1985.977173 2397.869141,1984.615967 2396.088623,1983.134033 
	C2392.572998,1980.207764 2391.621826,1977.097534 2394.432129,1973.148193 
	C2395.719238,1971.339233 2396.714600,1969.322632 2397.920898,1966.702515 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2449.265137,1939.908081 
	C2450.000000,1940.000000 2450.000000,1941.000000 2450.000000,1941.500000 
	C2450.408203,1946.980347 2449.379639,1950.573242 2443.128906,1950.072510 
	C2440.872559,1949.891602 2438.469727,1950.319458 2436.269287,1950.945679 
	C2432.950928,1951.889893 2431.001221,1950.622925 2430.261475,1947.591187 
	C2429.664795,1945.145264 2427.496826,1942.765869 2429.432373,1940.036621 
	C2430.947510,1937.899536 2439.437256,1935.455322 2442.424805,1936.560181 
	C2444.568115,1937.352905 2446.502441,1938.710571 2449.265137,1939.908081 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2178.300293,1843.899658 
	C2182.503662,1841.817139 2186.278320,1840.802979 2188.803955,1844.599243 
	C2190.904053,1847.755981 2190.644775,1851.731079 2189.058594,1855.143677 
	C2187.357666,1858.803955 2184.103516,1860.327881 2180.018555,1859.933960 
	C2173.673096,1859.322021 2170.997803,1854.522949 2173.728760,1848.642090 
	C2174.591309,1846.784302 2175.773193,1845.231567 2178.300293,1843.899658 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2417.269531,1831.909912 
	C2417.933838,1834.632812 2418.196289,1837.287598 2417.029541,1839.805542 
	C2414.745361,1844.735718 2409.053955,1847.237183 2404.773926,1845.123535 
	C2400.702637,1843.112915 2398.783447,1837.470703 2400.700439,1833.147095 
	C2402.881592,1828.227539 2407.235596,1827.131714 2413.036621,1830.044922 
	C2414.206055,1830.632202 2415.371582,1831.228027 2417.269531,1831.909912 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2282.380371,1912.219482 
	C2284.934814,1906.579346 2289.021973,1905.043335 2294.002686,1906.447510 
	C2297.349609,1907.391113 2299.480957,1909.937866 2299.906494,1913.597778 
	C2300.418457,1918.003174 2298.847900,1921.462158 2294.781006,1923.279053 
	C2290.866699,1925.027344 2287.744873,1923.257812 2285.379639,1920.088867 
	C2283.808105,1917.983398 2282.523193,1915.680420 2282.380371,1912.219482 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2351.335449,1940.482178 
	C2354.306641,1947.730957 2352.879395,1952.225586 2347.616699,1954.980713 
	C2344.811279,1956.449463 2342.425781,1955.472290 2340.230469,1953.877686 
	C2337.025879,1951.550171 2335.531250,1948.266602 2336.359619,1944.354492 
	C2337.023438,1941.219116 2339.240967,1939.092407 2342.339844,1938.347534 
	C2345.292725,1937.637573 2348.283691,1937.740112 2351.335449,1940.482178 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2293.626465,1951.632568 
	C2294.864258,1950.376465 2295.517334,1949.506226 2296.385498,1949.121582 
	C2300.728760,1947.197144 2304.822021,1947.398438 2308.051025,1951.281250 
	C2310.662842,1954.421265 2310.914307,1958.211426 2308.797607,1961.446045 
	C2306.990723,1964.207886 2304.022949,1966.000732 2300.261230,1965.007080 
	C2295.257568,1963.685303 2292.417236,1959.796875 2292.396973,1954.057373 
	C2292.395020,1953.453369 2292.881104,1952.847412 2293.626465,1951.632568 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2398.869629,1914.000000 
	C2397.460205,1912.103882 2396.729004,1910.238892 2396.416504,1908.306030 
	C2395.478027,1902.498047 2398.601074,1898.490234 2404.221924,1898.066284 
	C2409.818359,1897.644043 2413.827881,1901.249512 2413.946045,1906.786499 
	C2414.038086,1911.099487 2412.248779,1913.768799 2407.668213,1913.924561 
	C2405.027588,1914.014526 2402.382324,1913.979004 2398.869629,1914.000000 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2194.197266,1878.231445 
	C2191.531982,1880.141968 2189.189941,1880.114136 2186.897949,1879.932861 
	C2181.591553,1879.512573 2180.103516,1877.800415 2180.031006,1872.363037 
	C2179.964844,1867.410645 2185.169678,1861.919312 2189.893799,1862.211182 
	C2194.673096,1862.506714 2195.405762,1866.323608 2195.870117,1869.963501 
	C2196.199951,1872.547852 2196.311523,1875.253784 2194.197266,1878.231445 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2354.026855,2018.873047 
	C2354.013672,2015.777344 2354.023438,2013.484985 2354.024902,2011.192749 
	C2354.027344,2007.536133 2355.218994,2004.744629 2359.282471,2004.149902 
	C2363.619873,2003.515015 2367.194336,2004.883423 2369.114990,2008.911377 
	C2370.931152,2012.718872 2369.805664,2015.867676 2366.004150,2017.990356 
	C2363.162109,2019.577271 2360.535645,2021.631836 2357.561035,2022.874390 
	C2355.013184,2023.938721 2354.253906,2021.830322 2354.026855,2018.873047 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1997.158447,1918.732178 
	C1999.615112,1923.300293 2001.822388,1927.317749 1997.400024,1931.031250 
	C1994.309692,1933.626099 1990.882446,1934.157349 1987.376953,1931.652344 
	C1984.351440,1929.490234 1981.129761,1927.352295 1982.737915,1922.835327 
	C1984.153198,1918.859497 1986.274414,1915.641602 1991.290039,1916.022217 
	C1993.342285,1916.177979 1995.240356,1916.505371 1997.158447,1918.732178 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2457.338623,1891.702026 
	C2458.358643,1896.548950 2457.597168,1900.555908 2453.316162,1903.256470 
	C2449.919434,1905.398926 2446.499756,1906.446289 2443.374268,1903.290161 
	C2440.410645,1900.297607 2438.759033,1896.536987 2441.101318,1892.447632 
	C2443.082275,1888.989502 2446.261719,1887.171875 2450.360840,1888.468384 
	C2452.556396,1889.162476 2454.577393,1890.407593 2457.338623,1891.702026 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2482.916260,1888.574951 
	C2481.820557,1883.255737 2480.885742,1878.555542 2486.399902,1875.837524 
	C2489.505127,1874.307007 2492.736328,1872.948853 2495.734863,1875.371338 
	C2499.056641,1878.055420 2498.312988,1882.089233 2497.607422,1885.599487 
	C2496.904541,1889.094971 2494.354492,1891.352783 2490.680420,1891.828857 
	C2487.867920,1892.193359 2485.525879,1890.881226 2482.916260,1888.574951 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2537.530273,1862.279785 
	C2542.762939,1864.511353 2544.626465,1868.040405 2543.828125,1872.851685 
	C2542.979004,1877.969971 2537.807373,1881.082886 2532.643066,1879.736084 
	C2528.747803,1878.720337 2526.940430,1875.177734 2528.366699,1870.186523 
	C2529.549316,1866.047974 2531.092285,1861.812134 2537.530273,1862.279785 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2493.518066,1991.360596 
	C2496.161377,1990.679932 2498.149658,1989.974487 2500.059082,1990.146973 
	C2504.102783,1990.512207 2509.315674,1995.197632 2509.307373,1998.011597 
	C2509.298828,2000.926636 2503.492432,2005.857910 2500.045166,2005.877930 
	C2495.474854,2005.904419 2490.152100,2000.999146 2490.080811,1996.655151 
	C2490.045410,1994.506958 2490.812012,1992.760376 2493.518066,1991.360596 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2322.236816,1975.353027 
	C2322.144775,1973.269531 2321.948242,1971.896973 2322.280762,1970.667603 
	C2323.317383,1966.835327 2325.751221,1964.280884 2329.878174,1964.194702 
	C2334.047363,1964.107544 2336.800781,1966.633667 2337.595703,1970.452637 
	C2338.299072,1973.832886 2339.182373,1977.771118 2335.243164,1980.196167 
	C2331.512939,1982.492432 2327.825439,1982.815552 2324.555420,1979.354492 
	C2323.676025,1978.423462 2323.093506,1977.211914 2322.236816,1975.353027 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2458.365234,2050.245605 
	C2460.183594,2046.556274 2462.212158,2043.527710 2466.073486,2044.516846 
	C2469.816162,2045.476074 2474.049316,2045.956909 2476.792969,2049.108398 
	C2479.891602,2052.667725 2476.219482,2059.204834 2470.634521,2059.838135 
	C2464.029053,2060.587158 2460.302979,2056.836914 2458.365234,2050.245605 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1957.400879,2005.065186 
	C1953.051392,1996.476440 1953.057617,1996.488525 1960.206421,1992.831665 
	C1961.679810,1992.078125 1963.148438,1991.285767 1964.512329,1990.354736 
	C1966.448975,1989.033203 1968.403076,1987.290039 1970.717651,1989.170410 
	C1972.427124,1990.559326 1972.274292,1992.905518 1971.816040,1994.776123 
	C1969.332275,2004.915894 1967.959351,2007.709839 1957.400879,2005.065186 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1972.443604,1938.801147 
	C1969.100342,1939.958130 1966.414917,1940.695557 1964.596802,1937.844727 
	C1963.089478,1935.481445 1963.980591,1926.113281 1965.796631,1924.547607 
	C1968.174805,1922.496704 1971.056030,1921.378418 1974.102051,1922.460571 
	C1978.672607,1924.084595 1978.782471,1928.727539 1979.490967,1932.396606 
	C1980.330811,1936.745972 1976.457153,1937.629395 1972.443604,1938.801147 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2195.010742,1884.769043 
	C2197.876221,1886.751221 2199.625000,1888.626587 2199.921631,1891.534180 
	C2200.375000,1895.976318 2198.877441,1899.487427 2194.742188,1901.286743 
	C2190.784424,1903.008911 2187.458984,1901.354980 2185.393799,1897.911011 
	C2183.181152,1894.220825 2183.255371,1890.353638 2186.258301,1886.898071 
	C2188.427490,1884.401978 2191.124756,1883.612183 2195.010742,1884.769043 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2026.279053,1910.463135 
	C2028.511230,1905.252075 2032.008057,1903.450195 2036.832397,1904.151611 
	C2041.228149,1904.790527 2042.454956,1908.364014 2043.512085,1911.798340 
	C2044.422607,1914.756226 2042.476196,1916.848755 2040.262573,1918.396851 
	C2036.996704,1920.680786 2033.428467,1920.671265 2030.084473,1918.639648 
	C2027.420288,1917.020874 2025.840088,1914.558105 2026.279053,1910.463135 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2438.626953,1930.558594 
	C2434.654785,1932.312012 2431.582520,1932.507080 2428.984619,1929.486206 
	C2425.870117,1925.864258 2425.199219,1920.898193 2427.629639,1917.675049 
	C2429.509521,1915.181885 2431.759521,1913.582764 2435.248779,1914.708618 
	C2440.348877,1916.354248 2442.296631,1919.266479 2441.957520,1925.237793 
	C2441.838867,1927.330444 2441.272217,1929.105957 2438.626953,1930.558594 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2388.592773,1856.564697 
	C2391.626221,1853.793457 2394.562500,1853.737915 2397.557861,1854.314331 
	C2399.653564,1854.717651 2401.537354,1856.039551 2401.467041,1858.170044 
	C2401.313721,1862.816406 2400.227539,1867.474365 2396.805176,1870.794312 
	C2393.719238,1873.787842 2387.476562,1870.568604 2386.311768,1865.514404 
	C2385.629395,1862.553711 2385.800537,1859.583130 2388.592773,1856.564697 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2197.489746,1931.822510 
	C2201.035400,1927.858643 2204.499268,1926.864136 2208.413818,1929.694336 
	C2211.360596,1931.824829 2212.513428,1934.733276 2211.601074,1938.337036 
	C2210.563477,1942.432617 2206.486084,1946.096069 2203.217773,1945.246216 
	C2199.260742,1944.217285 2195.736084,1942.232300 2196.078369,1937.213013 
	C2196.187744,1935.609741 2196.695557,1934.033813 2197.489746,1931.822510 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2534.087402,2045.256348 
	C2533.666748,2046.000488 2533.333252,2046.000977 2532.500000,2046.003174 
	C2523.911133,2045.020264 2523.640137,2044.694702 2524.009033,2036.392822 
	C2524.290527,2030.055176 2525.968262,2028.061523 2531.025146,2028.054199 
	C2536.314941,2028.046509 2538.923584,2031.200562 2537.509521,2036.361572 
	C2536.739502,2039.172241 2535.307861,2041.801514 2534.087402,2045.256348 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2256.022217,1898.028809 
	C2258.584229,1888.785645 2262.943115,1886.438477 2267.868652,1890.946411 
	C2270.024170,1892.919189 2272.880615,1895.105957 2271.420654,1898.389648 
	C2269.823486,1901.983276 2267.210205,1905.581543 2262.834961,1905.563965 
	C2259.005127,1905.548584 2255.916504,1903.461182 2256.022217,1898.028809 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2487.451172,1969.836914 
	C2489.342773,1967.868408 2490.694336,1966.413330 2492.235596,1965.199097 
	C2493.609375,1964.116821 2495.443359,1963.838745 2496.875000,1964.773438 
	C2501.779785,1967.975464 2499.611328,1973.048584 2499.872803,1977.428711 
	C2500.033203,1980.113159 2498.581299,1981.636230 2495.764404,1981.898315 
	C2491.666016,1982.279785 2488.732422,1980.576416 2486.837158,1977.078735 
	C2485.664551,1974.915405 2485.891113,1972.639038 2487.451172,1969.836914 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2481.086914,2077.169678 
	C2472.280273,2081.177734 2470.480957,2080.849609 2467.260498,2074.234131 
	C2466.153076,2071.958496 2462.332275,2068.630859 2466.267822,2066.751709 
	C2469.250488,2065.327637 2473.427979,2062.626709 2477.250977,2066.293457 
	C2480.189697,2069.112305 2482.991455,2071.887939 2481.086914,2077.169678 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2114.000000,1886.831055 
	C2117.595703,1885.672363 2120.814209,1883.407715 2124.629150,1884.077148 
	C2127.862061,1884.644653 2130.522217,1886.355225 2131.160889,1889.373657 
	C2131.827393,1892.522827 2129.667236,1894.894897 2126.851562,1896.478394 
	C2119.435547,1900.649170 2114.696045,1897.411743 2114.000000,1886.831055 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2537.909668,1976.734375 
	C2543.199951,1976.142090 2545.078857,1981.129395 2549.406006,1983.704346 
	C2550.060547,1986.660400 2549.762939,1989.163452 2547.710693,1991.198486 
	C2544.808838,1994.076294 2541.580322,1994.962891 2538.058105,1992.641479 
	C2534.773926,1990.476807 2533.110840,1987.371826 2534.607666,1983.419556 
	C2535.399658,1981.328857 2536.731201,1979.442627 2537.909668,1976.734375 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1965.835083,1983.966553 
	C1958.298828,1988.535767 1953.809570,1987.679199 1952.380859,1981.785889 
	C1951.511597,1978.200439 1951.449341,1974.373047 1955.716187,1972.484985 
	C1959.408813,1970.850952 1963.760620,1972.446045 1965.924438,1975.982056 
	C1967.400391,1978.394043 1968.027710,1980.808350 1965.835083,1983.966553 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2385.706543,1888.381836 
	C2383.864014,1895.229614 2380.870605,1898.141357 2376.963379,1897.164429 
	C2374.121826,1896.453857 2371.251465,1895.171631 2370.361816,1891.876953 
	C2369.519043,1888.756104 2370.528809,1885.872192 2372.619385,1883.660645 
	C2374.944824,1881.200684 2378.051514,1881.675293 2380.885010,1882.772949 
	C2383.099854,1883.631104 2384.564453,1885.462524 2385.706543,1888.381836 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1938.630737,2005.364136 
	C1940.093628,2002.906860 1941.889038,2002.067017 1943.692871,2001.250366 
	C1944.919922,2000.694824 1946.251953,2000.322021 1947.424561,2001.181396 
	C1951.380127,2004.080811 1949.683960,2008.380737 1949.944824,2012.151855 
	C1950.157227,2015.221069 1949.680298,2018.270508 1946.240479,2019.434814 
	C1943.469360,2020.372803 1941.106323,2019.898071 1939.939819,2016.632690 
	C1938.712646,2013.197754 1937.429688,2009.822021 1938.630737,2005.364136 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2462.060547,2013.324219 
	C2461.366211,2014.219727 2460.849365,2014.598633 2460.224609,2015.568359 
	C2455.920410,2016.932129 2451.912354,2018.567993 2448.847412,2013.596436 
	C2445.710693,2008.508301 2445.519043,2005.680664 2449.137695,2003.549194 
	C2454.040771,2000.661255 2459.485840,2001.794312 2461.981201,2006.030884 
	C2463.322754,2008.307861 2462.684814,2010.432983 2462.060547,2013.324219 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1978.057617,1906.276123 
	C1981.945923,1898.269409 1986.164673,1896.864258 1991.684570,1901.190552 
	C1993.801758,1902.849854 1995.433838,1905.207764 1995.038940,1908.005127 
	C1994.695923,1910.434570 1991.935303,1910.027588 1990.250610,1910.836670 
	C1988.775513,1911.545166 1987.067017,1911.753418 1985.551147,1912.394287 
	C1980.080933,1914.707764 1978.239258,1912.052856 1978.057617,1906.276123 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2367.149902,1911.140259 
	C2369.767334,1914.957642 2370.934326,1918.166016 2367.484131,1921.431885 
	C2365.397949,1923.406738 2363.100586,1924.343018 2360.282715,1923.684082 
	C2356.619629,1922.827393 2353.440186,1918.623413 2354.473877,1915.695312 
	C2355.496338,1912.798096 2357.835449,1910.787720 2360.337646,1909.171509 
	C2362.757568,1907.608765 2364.682129,1909.511719 2367.149902,1911.140259 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2547.232178,1908.015869 
	C2550.291992,1908.030396 2552.146973,1908.890747 2553.710449,1911.427124 
	C2553.994385,1912.987305 2554.001953,1913.974731 2553.980713,1914.961792 
	C2553.885254,1919.393066 2552.089844,1923.140503 2547.415039,1923.151611 
	C2543.460938,1923.161011 2541.140381,1919.711182 2540.369385,1915.926392 
	C2539.401611,1911.177490 2541.313477,1908.254883 2547.232178,1908.015869 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1974.625610,1959.135010 
	C1970.078979,1956.901367 1967.461304,1954.201294 1969.397949,1949.503296 
	C1970.779541,1946.151367 1973.643555,1944.433594 1977.155762,1944.366699 
	C1980.285767,1944.307007 1981.395386,1946.980713 1982.631226,1949.349976 
	C1984.339478,1952.625000 1982.813354,1955.127197 1980.641968,1957.264771 
	C1979.262207,1958.622803 1977.424805,1959.552979 1974.625610,1959.135010 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2523.343750,2059.006836 
	C2523.997314,2061.675293 2524.168457,2063.678223 2522.977295,2065.385742 
	C2520.517578,2068.912354 2514.913330,2070.642822 2512.924561,2068.613770 
	C2510.046631,2065.678223 2510.079590,2059.976807 2512.991699,2057.026611 
	C2516.315430,2053.659424 2519.038818,2054.002686 2523.343750,2059.006836 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2498.928223,2082.179443 
	C2501.323975,2082.244141 2503.110107,2082.036133 2504.524902,2082.664307 
	C2508.246826,2084.317139 2508.404541,2087.700684 2507.618408,2091.046387 
	C2506.795410,2094.548096 2503.689453,2093.828857 2501.165771,2093.963623 
	C2497.532227,2094.157227 2494.409180,2092.696777 2493.184326,2089.390869 
	C2491.650635,2085.251221 2495.237061,2083.804443 2498.928223,2082.179443 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2190.341309,1822.283691 
	C2192.382324,1818.415405 2194.242188,1815.153442 2198.877441,1817.485352 
	C2201.271484,1818.689941 2204.057129,1819.929443 2203.572998,1823.037109 
	C2203.005127,1826.680176 2199.457031,1828.565063 2196.569092,1829.078735 
	C2192.875000,1829.735962 2190.964355,1826.505737 2190.341309,1822.283691 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2269.264648,1982.952637 
	C2272.480713,1986.150635 2272.717529,1989.155273 2270.309570,1992.123169 
	C2268.671387,1994.142212 2266.239502,1994.287476 2264.001709,1993.585327 
	C2261.447266,1992.783569 2259.174805,1991.160645 2258.823975,1988.291138 
	C2258.475830,1985.446533 2261.023926,1984.613647 2263.021484,1983.548096 
	C2264.781738,1982.609009 2266.582031,1981.880249 2269.264648,1982.952637 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2291.907471,2010.754395 
	C2288.121582,2009.749390 2286.039062,2007.769409 2286.417236,2004.250244 
	C2286.653564,2002.048828 2288.301758,2000.863037 2290.373047,2000.279175 
	C2294.576172,1999.094360 2298.981689,2000.739014 2299.492920,2003.981689 
	C2300.323486,2009.253052 2296.048584,2009.589844 2291.907471,2010.754395 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1950.759521,1906.005981 
	C1951.222534,1906.652344 1951.051514,1907.450195 1950.670776,1908.830566 
	C1950.061523,1909.527588 1949.767700,1909.770508 1949.584106,1910.437744 
	C1949.139526,1915.249756 1946.512207,1917.959106 1941.637207,1919.525146 
	C1938.365601,1921.743774 1935.838867,1923.859131 1932.710327,1926.131348 
	C1935.011963,1916.801636 1943.266846,1912.104370 1950.759521,1906.005981 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2086.423340,1924.149414 
	C2081.736572,1926.408936 2080.443604,1923.928345 2080.408447,1920.484985 
	C2080.386719,1918.368774 2081.914551,1916.354614 2084.156494,1916.843994 
	C2087.882568,1917.657349 2088.541748,1920.339478 2086.423340,1924.149414 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1964.864502,1892.888672 
	C1962.244141,1895.674561 1959.805542,1897.865967 1956.776855,1900.279419 
	C1956.304321,1895.040649 1960.026733,1892.395264 1964.924316,1890.022461 
	C1965.402832,1890.691406 1965.224487,1891.492676 1964.864502,1892.888672 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1941.742065,1919.732300 
	C1942.778198,1916.339600 1945.586792,1913.878662 1948.954224,1911.041748 
	C1949.555908,1913.850952 1951.392700,1917.397949 1946.770874,1919.818848 
	C1944.863892,1919.945435 1943.727905,1919.890747 1941.742065,1919.732300 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2346.429199,2034.544189 
	C2348.366211,2031.874023 2349.746582,2032.840942 2350.883057,2034.650757 
	C2351.418213,2035.502563 2351.362061,2036.560913 2350.436279,2037.082520 
	C2348.291748,2038.290771 2346.965088,2037.402344 2346.429199,2034.544189 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1985.700195,1868.165771 
	C1984.647217,1869.298584 1983.809937,1869.950562 1982.457764,1870.688721 
	C1981.961182,1867.631470 1982.924316,1865.105103 1986.894775,1864.006104 
	C1986.980225,1865.143188 1986.447998,1866.414185 1985.700195,1868.165771 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1992.566162,1857.737305 
	C1992.116943,1856.684937 1992.405884,1855.427490 1994.236694,1854.388916 
	C1994.287842,1855.276733 1993.701416,1856.361084 1992.566162,1857.737305 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M41.421555,572.529419 
	C53.893219,572.050598 54.902775,572.923645 57.174088,582.103821 
	C58.032185,585.572021 57.171780,587.865540 54.870934,590.119080 
	C52.253456,592.682678 49.752937,595.368225 47.086861,597.878967 
	C44.098309,600.693420 41.760056,603.612122 41.835243,608.136658 
	C41.892586,611.587219 40.217587,614.504944 37.049629,616.369202 
	C33.007057,618.748291 29.127857,618.325012 26.221874,615.081299 
	C23.189571,611.696594 23.193810,608.255249 26.701017,604.460876 
	C28.474674,602.542053 30.776781,601.098267 32.896118,599.514954 
	C40.425510,593.889648 41.024990,591.889465 38.465096,582.539856 
	C37.497936,579.007507 34.470169,574.787170 41.421555,572.529419 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2292.856934,83.999977 
	C2291.961426,80.714874 2294.789062,79.708717 2296.795166,78.133926 
	C2300.192627,75.467384 2299.672363,72.557625 2297.671387,69.416710 
	C2293.846191,63.411346 2288.133057,61.571430 2281.380127,61.994129 
	C2277.380615,62.244473 2274.776855,61.500244 2273.613525,56.601547 
	C2271.392090,47.249409 2271.376465,46.826332 2280.765381,44.631317 
	C2284.538330,43.749329 2287.265381,44.240387 2288.964111,47.962261 
	C2289.652588,49.471027 2290.527100,50.895237 2291.206787,52.407497 
	C2293.319580,57.108604 2296.905518,59.831333 2302.065674,59.537098 
	C2309.013428,59.140957 2314.604004,54.879074 2316.066406,49.251629 
	C2316.894775,46.064095 2317.897949,42.950142 2318.195801,39.578556 
	C2318.591553,35.102901 2321.504639,32.587406 2326.083740,32.062012 
	C2330.758301,31.525599 2332.769043,34.362309 2333.729248,38.190926 
	C2334.954834,43.078236 2337.325439,46.711502 2343.277344,47.919819 
	C2341.250488,52.561836 2339.004639,56.990753 2343.465332,62.017639 
	C2344.595703,63.291286 2343.172852,65.095581 2340.683594,65.881798 
	C2337.078857,64.608047 2336.266846,61.539703 2334.549316,59.181782 
	C2329.738281,52.577053 2325.160400,52.881092 2321.102539,60.043083 
	C2319.959717,62.060047 2319.085205,64.231346 2318.668945,66.492676 
	C2317.187012,74.542603 2312.898926,80.343254 2304.677246,83.827316 
	C2300.571289,84.000488 2297.142578,84.000374 2292.856934,83.999977 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2277.100098,4.024464 
	C2278.325684,5.312644 2278.508057,6.647937 2278.999756,7.857650 
	C2282.630127,16.792219 2282.649658,16.784285 2272.878418,18.030817 
	C2265.416748,18.982714 2260.159424,27.970812 2262.918457,35.239395 
	C2263.611572,37.065804 2265.089355,38.627899 2265.607178,40.479084 
	C2266.288086,42.913589 2265.693604,45.139938 2262.696777,45.781147 
	C2260.118164,46.332890 2257.512207,46.772583 2254.956299,47.413010 
	C2251.141357,48.368996 2249.060547,47.627716 2247.749512,43.245262 
	C2245.518066,35.784565 2239.630127,32.369183 2231.950439,32.008480 
	C2229.302734,31.884130 2226.565186,32.166283 2224.024414,31.583603 
	C2217.797363,30.155561 2213.902100,22.148182 2216.440674,16.558409 
	C2218.047363,13.020815 2228.812988,11.042762 2232.553711,13.809132 
	C2234.670410,15.374469 2236.392578,17.467260 2238.330566,19.281439 
	C2241.888916,22.612171 2246.056396,24.141081 2250.995605,24.039677 
	C2259.916016,23.856537 2262.777344,20.312588 2260.847168,11.529583 
	C2260.424072,9.605119 2260.278076,7.619776 2260.002441,4.853176 
	C2265.400146,4.033739 2270.800049,4.023558 2277.100098,4.024464 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2382.676758,53.882912 
	C2382.502686,49.429840 2381.239502,45.650482 2377.617188,42.537384 
	C2373.877197,39.323151 2370.572510,35.702663 2366.403809,32.867016 
	C2360.641113,28.946882 2360.729004,25.819836 2366.761475,21.733912 
	C2372.708252,17.706142 2374.869141,12.507403 2374.000000,4.852817 
	C2382.049072,4.026044 2390.098389,4.021327 2399.073730,4.026097 
	C2412.184082,6.283006 2419.300537,17.873343 2431.534180,21.445692 
	C2431.735107,24.208059 2430.743652,25.826721 2428.332520,25.924788 
	C2425.127686,26.055136 2423.852783,28.355879 2422.289795,31.361778 
	C2412.388672,32.274670 2403.916992,29.928707 2398.430908,21.269852 
	C2394.657471,15.314150 2390.300293,13.792527 2384.470459,18.571846 
	C2378.601318,23.383665 2378.356445,27.106955 2383.477783,32.747585 
	C2386.171875,35.714855 2390.321533,36.989231 2392.179688,41.326599 
	C2387.241455,44.543800 2387.429688,50.721519 2382.676758,53.882912 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2392.799805,42.002014 
	C2386.487305,39.510757 2382.107178,35.579681 2378.187744,31.079573 
	C2375.381104,27.857218 2375.193848,24.422234 2377.995605,21.196594 
	C2380.378662,18.453341 2382.811279,15.701632 2386.134766,13.947340 
	C2392.041260,10.829945 2394.520996,11.383942 2398.543457,17.007612 
	C2400.085693,19.164026 2401.438232,21.456482 2402.980957,23.612665 
	C2404.140137,25.232798 2405.933350,27.803282 2407.405273,27.167751 
	C2413.544922,24.516785 2416.136963,30.649807 2421.308105,31.922443 
	C2424.825195,35.665974 2426.854492,39.589260 2426.000000,45.220005 
	C2425.756836,47.766483 2424.718262,48.937553 2422.598145,49.874886 
	C2415.685059,50.459076 2410.473389,48.408142 2406.316162,42.621140 
	C2404.502441,40.425129 2402.939453,39.236950 2400.427734,41.565212 
	C2397.866699,42.000282 2395.733154,42.000870 2392.799805,42.002014 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2304.001465,84.781799 
	C2304.201416,82.299026 2304.669678,80.572159 2306.400146,79.984741 
	C2313.020508,77.737114 2314.955811,72.243576 2315.910156,66.232666 
	C2316.553955,62.178421 2318.348389,58.634293 2320.485840,55.379551 
	C2324.620117,49.084759 2331.552490,49.236553 2335.684814,55.635921 
	C2337.449707,58.369560 2338.478271,61.578949 2339.920898,65.287125 
	C2338.781006,71.844810 2335.120850,74.783913 2329.341064,76.183273 
	C2322.331543,77.880249 2322.479248,78.216377 2323.959229,85.771996 
	C2324.804688,90.086594 2327.487305,94.371010 2322.654785,98.490425 
	C2317.713379,102.702438 2314.457520,103.157196 2309.788330,98.744461 
	C2306.013428,95.177208 2303.706299,90.933144 2304.001465,84.781799 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2477.474609,48.444149 
	C2480.719482,53.135479 2482.859619,58.379547 2490.057861,59.380505 
	C2493.933838,59.919456 2496.624756,66.940369 2495.299072,70.899734 
	C2493.705811,75.658775 2490.859131,79.504814 2485.347656,81.659012 
	C2482.862061,76.529747 2483.996338,71.393135 2482.832031,66.686356 
	C2481.556885,61.531826 2478.872314,59.395813 2474.418457,58.517544 
	C2470.216553,57.688957 2465.554443,60.634026 2463.466064,65.304192 
	C2462.670898,67.082321 2462.568848,69.162529 2461.837891,70.978996 
	C2460.483398,74.344734 2459.308350,77.892586 2457.314697,80.866005 
	C2454.212158,85.493484 2447.624268,85.021080 2446.631836,79.829659 
	C2445.401611,73.391899 2441.983398,72.098175 2436.412598,71.552940 
	C2432.867920,71.206001 2429.404053,69.694695 2424.847656,69.999580 
	C2428.486572,63.217369 2428.526123,54.271824 2435.291016,48.126965 
	C2437.964111,49.613892 2438.263428,51.897808 2438.562744,54.212582 
	C2439.016602,57.721127 2438.391602,62.077068 2442.750244,63.416771 
	C2447.123535,64.761009 2450.166260,61.716702 2452.936768,58.785839 
	C2454.067627,57.589577 2455.090820,56.285011 2457.339355,55.820091 
	C2467.972900,58.096706 2472.374023,56.445045 2477.474609,48.444149 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2463.563965,4.546648 
	C2470.943848,4.028773 2477.887695,3.998421 2484.831055,4.052779 
	C2486.425537,4.065263 2488.328125,3.902125 2488.964600,5.911155 
	C2489.517090,7.654292 2488.521484,9.212752 2487.483887,10.406076 
	C2485.251709,12.973595 2482.095459,14.460688 2478.978516,15.258259 
	C2474.557129,16.389549 2472.504395,18.874737 2471.181152,23.116922 
	C2469.917969,27.166813 2467.565430,30.891787 2465.560547,34.690525 
	C2464.037842,37.575825 2461.729980,38.081680 2458.933350,36.413471 
	C2454.633301,33.848328 2450.331299,31.288223 2450.010254,24.737804 
	C2448.489014,18.488419 2452.128906,15.605343 2456.272461,14.799997 
	C2462.312988,13.625980 2463.221191,9.971652 2463.563965,4.546648 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2432.666504,22.003002 
	C2424.492432,21.821760 2417.397705,20.827332 2413.456055,13.130252 
	C2412.291992,10.857280 2409.860352,10.528217 2407.753418,9.574265 
	C2405.177490,8.408037 2401.644287,8.781803 2400.132812,4.733605 
	C2415.375244,4.028908 2430.750244,4.022230 2447.062744,4.023991 
	C2449.725586,13.039499 2445.493408,18.558918 2436.770264,21.951658 
	C2435.111084,22.002754 2434.222168,22.002626 2432.666504,22.003002 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2236.062256,107.349289 
	C2231.235107,106.602867 2226.429688,105.654381 2221.403076,105.948105 
	C2217.188232,106.194412 2214.526611,104.393158 2213.938477,99.866310 
	C2213.601318,97.273987 2212.499023,94.781845 2212.153809,92.189659 
	C2211.620605,88.184296 2212.761475,85.023651 2217.256348,83.924797 
	C2221.048096,82.997818 2224.524170,80.808258 2229.219238,81.008064 
	C2229.429688,88.667618 2232.497559,94.870110 2239.676758,99.387192 
	C2239.080566,102.449203 2236.456543,103.911102 2236.062256,107.349289 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2457.911133,55.284222 
	C2455.721436,60.919197 2452.498535,64.670578 2447.071045,66.509377 
	C2441.287842,68.468575 2437.134033,66.645103 2436.230469,60.653332 
	C2435.692871,57.087170 2436.046631,53.386658 2436.000000,48.873123 
	C2444.939209,45.017918 2451.808350,47.085747 2457.911133,55.284222 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2436.433105,22.512691 
	C2442.469238,18.286676 2444.734375,11.567524 2447.915039,4.737032 
	C2452.741211,4.025091 2457.482178,4.017753 2463.111816,4.019388 
	C2464.037842,4.356784 2464.089844,4.684281 2464.111328,5.013773 
	C2464.329590,8.329845 2468.245361,11.091340 2466.771729,14.185684 
	C2465.112793,17.669436 2460.778809,15.364707 2457.762207,16.355364 
	C2454.404785,17.457901 2452.010742,19.483940 2450.295898,23.348877 
	C2445.758789,21.843027 2441.193604,24.028755 2436.433105,22.512691 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2415.333496,71.999695 
	C2416.305420,77.892799 2415.233887,83.851608 2417.475586,89.652061 
	C2418.631836,92.643074 2417.836426,95.573044 2414.854980,97.418663 
	C2411.687256,99.379433 2408.345947,100.713623 2404.540283,99.500572 
	C2403.954834,99.314003 2403.109863,98.871681 2403.007324,98.409660 
	C2402.160889,94.591003 2401.427246,90.746002 2400.728760,86.896461 
	C2400.229736,84.147133 2402.394775,82.766739 2403.918213,81.109093 
	C2406.375000,78.436172 2408.904541,75.830162 2411.701660,72.597511 
	C2412.888916,71.999184 2413.777832,71.999290 2415.333496,71.999695 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2343.100098,4.024387 
	C2344.056885,6.806898 2345.733154,8.993418 2346.656006,11.453828 
	C2348.817383,17.216242 2347.931396,20.098431 2343.139160,23.316084 
	C2337.628418,27.016174 2335.002686,26.466297 2333.879150,19.887184 
	C2332.859131,13.914459 2326.082520,11.660713 2326.014648,4.793760 
	C2331.400146,4.032142 2336.800049,4.022579 2343.100098,4.024387 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2254.683105,91.889328 
	C2254.391113,88.210464 2256.275879,84.839981 2254.749512,80.517555 
	C2253.029541,75.647552 2254.625244,74.347496 2260.137939,74.039650 
	C2264.766113,73.781181 2269.177002,73.798470 2272.906494,77.650406 
	C2275.116699,79.933205 2278.383789,81.192780 2281.587891,83.457062 
	C2279.966797,86.725647 2277.988525,84.742302 2275.944336,83.978645 
	C2264.953857,79.873138 2264.605469,77.674019 2258.250977,89.296844 
	C2257.593018,90.500412 2256.689209,91.371185 2254.683105,91.889328 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2209.091797,4.023024 
	C2209.650879,6.764682 2211.066650,10.259196 2207.408203,11.665135 
	C2203.216553,13.275934 2198.917725,16.177118 2194.542725,15.276162 
	C2190.054688,14.351948 2190.056885,9.573096 2190.001953,4.826399 
	C2196.061279,4.028527 2202.122314,4.020639 2209.091797,4.023024 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2350.482666,48.535423 
	C2351.082031,47.317154 2352.081787,46.398663 2353.259033,45.984814 
	C2360.916992,43.293121 2362.701416,44.029480 2363.794678,51.992577 
	C2364.567871,57.624187 2366.376709,61.409039 2373.233398,61.987854 
	C2373.069824,66.964821 2369.790527,66.507736 2366.511719,64.925758 
	C2363.718994,63.578136 2361.721924,60.911671 2361.184326,58.010555 
	C2360.087646,52.092628 2356.361572,49.769794 2350.482666,48.535423 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2333.286377,104.143723 
	C2334.000000,106.776543 2334.000000,109.555138 2334.000000,113.167305 
	C2328.975098,110.886200 2328.762451,109.438591 2333.286377,104.143723 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2400.750000,42.000031 
	C2400.287842,40.027168 2399.287354,37.154316 2402.416016,36.908382 
	C2404.471924,36.746777 2405.395752,38.743801 2405.922363,41.325394 
	C2404.500000,42.000633 2403.000000,42.000500 2400.750000,42.000031 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2422.364258,50.460262 
	C2422.980469,48.832516 2423.960938,47.662285 2425.470703,46.246170 
	C2428.520508,50.041767 2427.042480,51.423149 2422.364258,50.460262 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2504.913818,1037.449951 
	C2510.642090,1043.461304 2507.465088,1048.958740 2505.175781,1054.270142 
	C2504.300049,1056.301880 2501.809326,1056.110107 2499.872559,1055.579468 
	C2496.539307,1054.666016 2490.180420,1045.347046 2490.348633,1041.364380 
	C2490.526611,1037.150024 2493.317139,1034.954956 2497.198242,1034.189209 
	C2500.048584,1033.626831 2502.219971,1035.275391 2504.913818,1037.449951 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2396.065918,1084.618164 
	C2399.572266,1085.669067 2402.320557,1086.862305 2404.125244,1089.336548 
	C2406.703613,1092.871094 2407.091553,1096.863403 2404.226318,1100.172485 
	C2401.479736,1103.344604 2397.747070,1104.588501 2393.727539,1101.834473 
	C2390.761963,1099.802368 2386.907471,1097.835815 2386.831543,1094.084473 
	C2386.726807,1088.914307 2390.600098,1086.073364 2396.065918,1084.618164 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2518.932617,1023.188416 
	C2516.909424,1023.679688 2515.579590,1023.964539 2514.267578,1023.896729 
	C2510.388428,1023.696167 2507.724121,1022.043457 2508.515625,1017.681519 
	C2509.110107,1014.406067 2514.764160,1010.097778 2517.269043,1010.871826 
	C2519.515137,1011.565735 2521.624268,1012.737305 2521.858887,1015.536621 
	C2522.086182,1018.250244 2522.035889,1020.900574 2518.932617,1023.188416 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2360.677979,1113.921631 
	C2360.157227,1110.941162 2361.484375,1108.816406 2365.322266,1108.071533 
	C2365.843750,1111.050293 2364.523926,1113.182495 2360.677979,1113.921631 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2424.626465,1151.053589 
	C2425.902344,1148.628052 2426.752197,1146.798828 2427.940186,1145.224854 
	C2430.959717,1141.223145 2434.888428,1138.684692 2439.995117,1140.431885 
	C2444.881592,1142.103760 2446.918213,1146.466187 2447.811523,1151.190552 
	C2448.545898,1155.075195 2447.602783,1158.484741 2443.478516,1160.222290 
	C2442.563232,1160.607910 2441.718750,1161.158203 2440.827637,1161.605103 
	C2428.942139,1167.565308 2425.686768,1165.619751 2424.626465,1151.053589 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2480.793213,1186.965210 
	C2481.336670,1174.861328 2488.381348,1170.364624 2497.073975,1175.682617 
	C2500.818115,1177.973511 2502.587891,1181.468750 2501.586670,1185.702515 
	C2500.675781,1189.556030 2497.803955,1191.660156 2493.724121,1191.954834 
	C2488.911865,1192.302368 2484.605957,1191.262939 2480.793213,1186.965210 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2538.095459,1694.584473 
	C2530.440186,1697.661377 2525.188477,1694.500244 2520.718750,1689.587036 
	C2516.352051,1684.786865 2517.261963,1680.474731 2522.913574,1677.615112 
	C2527.639893,1675.223633 2532.663330,1675.249268 2537.415283,1676.929443 
	C2545.064453,1679.633789 2545.481201,1686.671753 2538.095459,1694.584473 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2551.280273,1952.093872 
	C2551.511475,1955.534424 2549.472412,1959.047974 2551.928711,1963.310425 
	C2544.343018,1960.160889 2544.060059,1957.838745 2551.280273,1952.093872 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M823.134766,930.510132 
	C824.662537,928.810852 825.901611,927.716614 827.718384,926.380615 
	C832.313904,925.220337 833.176147,928.558594 834.577576,930.956604 
	C836.500244,934.246582 839.121277,935.523010 842.775391,934.364441 
	C845.088867,933.630859 846.875244,932.180115 847.309570,929.692200 
	C847.992004,925.782043 845.623840,923.646729 842.480286,922.107056 
	C840.435364,921.105408 838.186890,920.507080 836.002075,918.424194 
	C838.410583,912.655334 842.754700,908.784973 847.446899,904.468018 
	C850.515259,906.471741 852.275146,909.460449 856.016724,911.189087 
	C858.408691,914.791626 856.824768,918.115234 856.974060,921.358154 
	C857.129578,924.735840 857.356018,928.259155 861.238770,929.499207 
	C863.763977,930.305603 865.713562,928.695679 867.064514,926.672729 
	C869.105774,923.616333 869.109375,920.462891 866.986755,917.400940 
	C865.829834,915.732178 864.068237,914.732788 862.014038,913.020874 
	C860.358826,910.757690 860.376221,908.770447 860.667969,906.813171 
	C861.583069,900.673828 858.335876,899.272949 852.400146,899.974487 
	C850.747864,899.707581 849.892822,899.303406 848.703491,898.144043 
	C848.265259,896.891418 848.076355,896.280518 847.646240,895.242065 
	C852.639893,886.024658 864.388428,885.520935 869.451416,893.806030 
	C871.414490,897.018311 871.558716,902.177673 876.909729,901.985840 
	C882.450806,901.787109 883.321594,896.998596 885.161682,892.345276 
	C893.874878,889.916992 894.398682,899.579285 900.453430,902.227539 
	C900.951782,903.499207 901.035950,904.145447 900.939087,904.779480 
	C900.392944,908.352722 897.521729,913.434814 903.703613,913.963623 
	C909.524658,914.461487 907.948853,908.780090 908.698608,904.545288 
	C910.809937,900.220825 913.074890,896.739868 914.872681,892.258423 
	C921.595032,888.881470 929.135132,886.821655 924.290527,876.383118 
	C924.363647,870.135071 928.285095,867.041626 932.549255,863.366089 
	C941.437500,860.607788 942.828918,854.167603 943.045715,846.211182 
	C946.489746,842.868225 950.501221,841.210083 953.356323,837.093018 
	C958.679443,834.147339 962.619324,831.836365 962.500061,824.894104 
	C962.368774,817.256958 967.468811,811.833801 974.913940,809.836243 
	C980.386230,808.368164 982.126709,805.743347 982.162476,799.992310 
	C982.241760,787.236145 990.644409,782.866272 1001.501282,789.319275 
	C1003.501892,790.508362 1005.258118,792.115540 1007.405518,793.048950 
	C1013.769226,795.814941 1018.198486,793.947083 1018.858765,786.986450 
	C1019.616516,778.998291 1022.893250,773.046997 1029.267822,768.609131 
	C1033.947266,765.351440 1035.352051,760.944092 1034.418701,754.800293 
	C1034.959473,750.464600 1036.729980,747.403076 1039.059570,743.806885 
	C1041.626465,741.486694 1044.173340,740.679810 1046.706421,739.951538 
	C1051.323608,738.624084 1053.215576,735.678589 1052.289062,731.005615 
	C1050.536987,722.168945 1054.518188,716.658447 1062.801147,714.825378 
	C1069.885498,713.257568 1072.232422,710.086182 1070.003540,703.068420 
	C1069.103149,700.233582 1069.820679,697.107178 1073.404053,694.947998 
	C1080.428833,695.886230 1083.934814,692.617676 1086.369263,686.464172 
	C1087.134521,685.546143 1087.484863,685.209961 1088.457275,684.476196 
	C1092.835693,682.648560 1096.594727,680.849976 1100.618408,684.816223 
	C1101.267700,687.854736 1099.890015,689.844543 1099.450806,692.043457 
	C1098.895020,694.826355 1099.253052,697.326965 1102.296509,698.414307 
	C1104.235229,699.106995 1106.185791,698.771484 1107.578247,697.081421 
	C1109.242676,695.061157 1109.018311,692.884521 1107.706665,690.781433 
	C1106.665161,689.111389 1104.954590,688.059143 1103.278442,685.963867 
	C1102.375488,678.998962 1103.678589,673.575623 1110.838135,670.564087 
	C1117.635498,673.505676 1123.962769,675.422302 1131.290283,676.679321 
	C1135.181396,680.644104 1136.307983,685.175659 1137.689087,690.365234 
	C1137.488159,693.975464 1135.824829,695.986511 1133.767334,697.746033 
	C1115.794189,713.117249 1100.224731,730.545715 1088.125854,750.958435 
	C1087.105469,752.679871 1085.680786,754.077698 1083.254883,755.357544 
	C1079.396606,756.951477 1076.209717,754.535645 1072.872681,755.527222 
	C1073.393066,758.668762 1076.896973,758.567871 1078.583496,761.289307 
	C1080.153198,765.387634 1078.543213,768.216492 1076.340088,771.529663 
	C1074.845093,773.359436 1073.813843,774.693115 1073.481323,777.103027 
	C1073.017822,779.102295 1072.284668,780.173340 1070.369385,781.028625 
	C1065.600464,781.207825 1063.202515,778.268188 1060.415405,775.930176 
	C1057.890015,773.811768 1054.786011,772.497559 1052.872070,776.157410 
	C1051.038574,779.663086 1053.724731,781.865723 1056.828613,782.774231 
	C1061.431763,784.121765 1066.038940,785.166687 1066.511230,791.902588 
	C1066.750610,796.950378 1066.778320,801.275269 1064.709229,805.981079 
	C1063.430542,808.360779 1061.845825,809.858887 1061.929810,812.708435 
	C1062.148315,814.973755 1062.114136,816.623413 1061.581299,818.856567 
	C1060.754150,820.949158 1059.909302,822.372681 1059.709229,824.675537 
	C1059.580811,826.177490 1059.405518,827.029297 1058.896973,828.491821 
	C1056.027588,834.332703 1054.925537,840.417786 1047.908325,842.518921 
	C1042.896606,844.019653 1044.530396,848.137146 1046.124146,851.648682 
	C1048.336182,856.522583 1053.614624,858.122742 1057.305908,862.458374 
	C1059.202393,867.084900 1058.926880,871.185791 1058.382812,876.042725 
	C1055.763306,883.574219 1056.887329,889.974121 1060.696533,896.741821 
	C1061.897705,899.093872 1062.139526,900.948181 1062.134277,903.514648 
	C1062.007324,905.888184 1062.064331,907.557861 1063.579834,909.508057 
	C1066.544434,913.847595 1067.326904,918.223511 1067.893799,923.309814 
	C1067.689819,926.012146 1067.764282,928.007690 1069.597900,930.216980 
	C1071.807739,933.957397 1073.724609,937.140564 1073.031982,941.752380 
	C1068.723633,948.119019 1064.252808,953.409241 1057.767700,956.563110 
	C1056.874023,956.997742 1056.020386,957.531921 1055.292969,958.211487 
	C1053.083740,960.275696 1052.736450,962.765747 1053.855835,965.469116 
	C1054.542603,967.127686 1055.887329,968.162903 1057.696899,968.088623 
	C1060.378296,967.978577 1061.769287,966.109680 1062.651123,963.834839 
	C1063.967285,960.439026 1064.371216,956.738647 1066.089966,953.471191 
	C1067.944458,949.945496 1070.679199,947.877136 1075.550049,948.257812 
	C1083.891602,953.439514 1085.337891,962.294678 1089.328857,970.300476 
	C1089.184570,971.685059 1088.928955,972.295166 1088.696289,972.912720 
	C1087.476318,976.151672 1082.214722,978.557007 1084.849731,982.292847 
	C1087.384155,985.886047 1091.507446,981.016846 1095.721924,982.180725 
	C1100.962769,983.882446 1102.976196,987.851013 1105.555298,992.226074 
	C1107.298950,995.604980 1107.576660,1000.126953 1112.066040,999.022400 
	C1117.759644,997.621521 1115.203491,991.864197 1117.074219,987.567688 
	C1133.797363,974.851257 1152.820923,968.447998 1171.721924,961.832886 
	C1175.735352,960.428162 1179.891846,959.307190 1184.795166,958.419495 
	C1187.691528,958.326843 1189.871216,958.201782 1192.511963,956.943298 
	C1194.067261,956.724731 1194.942139,956.886414 1196.302246,957.673096 
	C1198.296021,960.607300 1197.648315,963.218201 1197.356323,965.837585 
	C1196.923218,969.722717 1195.791870,973.859436 1199.636841,976.783447 
	C1201.039551,977.850159 1202.837158,977.661560 1204.258179,976.578552 
	C1208.299683,973.498474 1206.977295,969.478943 1205.746216,965.738892 
	C1204.262085,961.229248 1204.510254,957.318054 1208.826416,953.629883 
	C1210.585571,952.519470 1211.906250,952.219727 1213.947998,952.162170 
	C1217.142944,952.760864 1219.598267,952.848511 1222.363403,950.765869 
	C1224.318481,950.106567 1225.685669,950.035767 1227.766724,950.284058 
	C1233.064453,951.523560 1235.672485,954.753296 1237.726807,958.771301 
	C1239.278442,961.805969 1241.388062,964.504272 1245.398682,963.928345 
	C1248.862793,963.430786 1250.728760,960.829102 1251.057129,957.773987 
	C1252.049561,948.540405 1260.979736,950.385803 1266.631348,946.421509 
	C1270.122437,945.463928 1272.771240,945.585938 1275.592407,948.018005 
	C1285.484497,956.885193 1285.648438,957.362610 1294.558472,957.885925 
	C1300.291748,958.222656 1300.724121,962.425537 1301.427612,965.988159 
	C1302.302368,970.417664 1299.496216,973.396423 1295.479736,975.145996 
	C1291.548462,976.858643 1289.188843,974.475525 1287.125854,971.764832 
	C1285.936279,970.201782 1285.134644,968.342651 1284.165894,966.612549 
	C1282.811401,964.194214 1280.572388,963.577515 1278.214722,964.356140 
	C1273.183716,966.017639 1268.295776,968.233398 1264.100952,971.428040 
	C1259.769653,974.726501 1264.346924,978.763184 1263.980713,983.235840 
	C1257.214233,989.044189 1249.444336,986.251221 1241.305420,986.606567 
	C1229.371338,979.867188 1229.363770,979.868103 1219.857666,989.246826 
	C1211.819702,991.869141 1204.489380,994.448792 1195.883789,994.538086 
	C1187.302734,992.721680 1179.498657,991.109192 1173.423950,999.787964 
	C1171.285645,1002.151672 1169.103394,1003.118408 1166.141235,1004.116089 
	C1164.125000,1004.698364 1162.734375,1004.917664 1160.894775,1005.972900 
	C1156.880615,1007.993774 1153.442993,1009.550537 1148.828125,1009.413757 
	C1142.506348,1006.349670 1137.680420,1005.617737 1135.700562,1014.318909 
	C1128.000610,1021.860046 1119.681641,1027.149902 1109.016113,1029.364746 
	C1105.198242,1026.820801 1104.786255,1022.896057 1102.885376,1019.833679 
	C1100.941772,1016.702271 1098.609863,1014.453125 1094.841919,1016.975403 
	C1091.777100,1019.027039 1091.779175,1021.863220 1093.743652,1024.753906 
	C1095.788452,1027.762573 1098.216187,1030.586548 1097.818359,1035.277832 
	C1091.164673,1045.464233 1080.303955,1049.830688 1072.130371,1057.435913 
	C1068.027710,1061.253174 1063.570068,1064.654541 1059.792114,1069.747314 
	C1057.244873,1072.477051 1055.139160,1074.696045 1052.250732,1076.995605 
	C1050.388306,1078.238892 1048.948242,1079.017334 1047.822021,1081.055664 
	C1046.830566,1082.710327 1046.023071,1083.722534 1044.633545,1085.134277 
	C1040.536621,1087.538940 1037.988892,1091.533569 1032.526855,1091.088867 
	C1031.249634,1090.714722 1030.712402,1090.354492 1030.194824,1089.963379 
	C1027.541016,1087.958008 1025.176636,1083.352783 1021.345642,1087.041138 
	C1017.630981,1090.617432 1021.854858,1093.360107 1023.772522,1096.128052 
	C1024.519531,1097.206421 1025.154785,1098.324341 1025.643188,1100.263306 
	C1025.831543,1103.319458 1025.010742,1105.496460 1023.998291,1108.336670 
	C1023.471924,1109.379395 1023.223389,1109.777588 1022.482300,1110.681030 
	C1020.449158,1112.339355 1018.736389,1113.056641 1016.114990,1113.153320 
	C1011.634338,1111.840088 1007.721252,1110.357178 1004.829590,1114.595947 
	C1002.257446,1118.366455 1004.878967,1121.376953 1007.006714,1125.068237 
	C1007.674500,1126.589478 1007.860901,1127.516968 1007.844604,1129.189941 
	C1007.656433,1130.366333 1007.526550,1130.826538 1007.059326,1131.918457 
	C1004.392029,1134.848755 1002.136536,1137.229248 998.843628,1139.453613 
	C991.663940,1141.106201 987.518311,1143.873657 991.614014,1152.046997 
	C992.490845,1158.291138 989.171082,1162.077637 985.404480,1166.369385 
	C972.708679,1170.656250 972.708679,1170.656250 977.789185,1182.268677 
	C978.726685,1187.221924 977.820496,1191.013672 974.182678,1194.629761 
	C969.981750,1197.370605 965.150146,1195.560303 961.573486,1198.608276 
	C961.605469,1202.934326 966.213745,1202.442017 968.560669,1205.304443 
	C969.851501,1207.196167 969.992615,1208.681641 969.853210,1210.977417 
	C969.574402,1212.770020 969.298767,1213.768921 968.761108,1215.505493 
	C963.313904,1231.545410 962.566345,1247.817261 958.025208,1264.025879 
	C953.658813,1268.539307 953.748596,1272.849609 956.436768,1278.222412 
	C957.750366,1296.014038 955.799255,1313.143311 958.239868,1330.885742 
	C957.740784,1332.552368 957.481934,1333.646729 956.713257,1334.138306 
	C948.802979,1339.193848 952.209961,1342.304077 959.099487,1345.442627 
	C964.485779,1353.043701 962.578674,1361.460571 964.042603,1369.956665 
	C955.501526,1381.614624 953.251465,1396.473755 941.454956,1405.268921 
	C939.147827,1406.988892 937.828369,1410.177124 937.490540,1413.168335 
	C936.616089,1420.911377 932.323853,1426.473877 927.187805,1431.960327 
	C918.389404,1441.359253 919.990906,1447.434204 931.774902,1451.795776 
	C945.833618,1456.999146 948.444580,1464.037476 941.043152,1477.306030 
	C939.244751,1480.529907 939.024902,1483.591064 940.764832,1486.743896 
	C942.360168,1489.634644 945.108582,1489.626465 947.763184,1488.858154 
	C954.316345,1486.962036 958.567566,1490.047119 962.175537,1495.000122 
	C963.929810,1497.408325 965.695312,1499.895264 968.336304,1501.449707 
	C974.970276,1505.354126 981.353333,1502.566895 981.512146,1495.043091 
	C981.685974,1486.805664 986.397705,1483.147827 993.148193,1480.870117 
	C998.188171,1479.169434 1002.368469,1480.054688 1004.523376,1485.584961 
	C1004.885315,1486.513794 1005.236877,1487.448975 1005.640259,1488.359985 
	C1012.731201,1504.376343 1012.743652,1504.414795 996.082947,1508.923096 
	C993.566895,1509.603882 991.614258,1510.527222 991.848083,1513.449463 
	C992.162964,1517.383789 993.974060,1521.705566 997.853699,1521.528809 
	C1008.009583,1521.065796 1014.457703,1526.051636 1020.733215,1533.132080 
	C1024.899048,1537.832275 1029.920288,1536.127197 1033.473267,1529.876831 
	C1035.739014,1525.890747 1036.098267,1520.837891 1040.843750,1517.512573 
	C1044.692749,1516.081665 1047.579712,1517.033936 1049.676147,1519.332886 
	C1060.418457,1531.112183 1073.839478,1539.923340 1085.183350,1552.028809 
	C1085.152832,1552.821655 1084.813110,1552.880981 1084.522583,1553.033691 
	C1080.291016,1555.256226 1073.701782,1555.788086 1074.358521,1562.265259 
	C1074.935059,1567.950806 1078.569580,1572.613159 1084.187988,1575.089111 
	C1088.539673,1577.006958 1092.268921,1579.377808 1094.191284,1584.186401 
	C1095.486450,1587.425903 1095.899536,1589.864746 1092.450195,1591.753052 
	C1084.355469,1596.184082 1082.807617,1604.248657 1082.228271,1612.163452 
	C1081.846558,1617.377563 1080.657715,1621.097412 1075.874512,1623.436523 
	C1074.730835,1623.995728 1073.914673,1625.213989 1072.927856,1626.107056 
	C1069.824707,1628.915405 1069.274658,1632.549561 1070.504639,1636.180786 
	C1071.779053,1639.943604 1074.758667,1641.942017 1078.935425,1641.994873 
	C1083.167480,1642.048340 1087.386230,1641.376465 1090.219360,1646.279541 
	C1094.897827,1654.376587 1095.024048,1655.825195 1088.412842,1662.582642 
	C1086.782471,1664.249268 1085.060181,1665.829468 1083.485962,1667.546387 
	C1077.849854,1673.693115 1077.697998,1680.772827 1082.736938,1687.191406 
	C1085.220093,1690.354736 1088.544678,1689.867065 1091.829834,1690.008667 
	C1098.746338,1690.306519 1105.336792,1696.585205 1105.841919,1703.403320 
	C1106.060547,1706.353638 1104.945923,1708.671631 1101.949707,1709.583252 
	C1100.700562,1709.963379 1099.285889,1709.769409 1098.002441,1710.072998 
	C1090.337158,1711.887085 1087.824707,1715.969238 1089.612549,1723.637329 
	C1090.214111,1726.217041 1090.736938,1728.832153 1091.580444,1731.335083 
	C1093.856323,1738.087280 1093.917114,1738.066772 1100.605957,1735.723022 
	C1107.798828,1733.202759 1108.089600,1733.039917 1111.658447,1739.407349 
	C1118.847290,1752.233276 1124.374023,1751.838379 1137.277466,1746.285034 
	C1140.740112,1744.794678 1142.596313,1742.449829 1141.183472,1738.394775 
	C1139.581787,1733.797363 1138.662354,1729.285889 1143.893311,1726.105469 
	C1148.583984,1723.253540 1157.443726,1722.674194 1160.823486,1726.216797 
	C1165.639038,1731.264404 1171.088501,1733.850952 1177.864136,1735.247559 
	C1183.232178,1736.354126 1186.398926,1741.100098 1189.057617,1745.959839 
	C1193.625854,1754.310303 1194.572998,1754.830811 1204.098267,1752.819458 
	C1208.155029,1751.962769 1210.545532,1752.926880 1212.144287,1756.453491 
	C1212.964600,1758.262573 1213.455322,1760.224487 1214.312012,1762.013306 
	C1217.887573,1769.480957 1223.217773,1771.269287 1230.503784,1767.539307 
	C1235.930786,1764.760986 1238.851318,1755.606201 1236.091309,1750.275146 
	C1234.533936,1747.267212 1232.429443,1745.605103 1228.879517,1746.641235 
	C1227.291382,1747.104736 1225.708008,1747.675903 1224.081299,1747.901123 
	C1212.183105,1749.548096 1212.179688,1749.524170 1207.085083,1738.283203 
	C1204.293457,1732.123535 1202.504272,1731.141113 1194.711914,1731.490112 
	C1186.633789,1731.851929 1179.426025,1724.142578 1180.019287,1716.083374 
	C1180.318115,1712.023682 1182.869507,1710.013550 1186.128784,1709.079346 
	C1194.722290,1706.616333 1198.718628,1701.490112 1198.160034,1692.274780 
	C1197.821045,1686.682983 1208.324097,1680.441406 1213.515015,1682.486938 
	C1215.373901,1683.219482 1215.611206,1684.762207 1215.938477,1686.438354 
	C1217.078613,1692.275635 1213.721313,1696.043701 1209.730713,1699.168579 
	C1201.998291,1705.223633 1203.347778,1713.267822 1204.858276,1721.078735 
	C1205.790527,1725.899414 1208.523926,1726.686157 1213.116821,1724.353027 
	C1217.987305,1721.878906 1221.678101,1718.080322 1224.285645,1713.296753 
	C1225.557129,1710.964355 1227.037720,1708.602295 1227.619995,1706.068970 
	C1228.684814,1701.435913 1231.737549,1699.054688 1235.944824,1698.806519 
	C1239.265747,1698.610596 1240.759888,1701.873413 1242.215942,1704.513550 
	C1244.321411,1708.330933 1244.900391,1712.033691 1241.465088,1715.475708 
	C1238.877197,1718.068726 1236.220093,1720.599731 1233.746582,1723.298462 
	C1228.781494,1728.715942 1229.148682,1737.174072 1234.282104,1742.133667 
	C1236.607300,1744.380249 1238.657471,1742.552246 1240.728149,1742.018311 
	C1250.095703,1739.603271 1253.890259,1741.306885 1258.482666,1749.554321 
	C1260.585449,1753.330688 1259.752441,1755.819092 1256.260498,1757.810791 
	C1254.237793,1758.964355 1251.995239,1759.804932 1250.151245,1761.186279 
	C1244.235596,1765.617554 1240.294067,1770.770020 1242.492920,1779.014648 
	C1243.848633,1784.097900 1241.483032,1786.883911 1235.714478,1789.054077 
	C1230.064087,1791.179932 1224.883545,1790.232178 1222.299927,1786.327881 
	C1220.837769,1784.118408 1219.830322,1781.612305 1218.549927,1779.277222 
	C1216.377319,1775.315186 1212.796509,1774.055176 1208.513062,1774.062500 
	C1204.187866,1774.069946 1203.276978,1777.588379 1201.825562,1780.487427 
	C1201.090942,1781.955078 1199.959106,1783.760620 1200.267456,1785.129272 
	C1202.883545,1796.737549 1192.307373,1797.178223 1186.452026,1801.317383 
	C1183.918457,1803.108521 1180.561401,1801.982910 1178.650757,1799.012573 
	C1176.495483,1795.661743 1174.050537,1792.406616 1172.496826,1788.781860 
	C1170.397949,1783.884766 1167.492920,1781.405884 1161.879028,1781.897827 
	C1156.342529,1782.383301 1152.157715,1779.928467 1150.447021,1774.312134 
	C1148.578491,1768.177612 1150.080322,1765.295532 1156.193359,1762.926025 
	C1156.813110,1762.685791 1157.433472,1762.435425 1158.072388,1762.258301 
	C1162.405029,1761.058472 1166.584351,1759.765137 1165.928955,1753.861938 
	C1165.381104,1748.926392 1160.410645,1744.305786 1155.022949,1744.073364 
	C1153.062012,1743.988770 1150.980957,1744.123291 1149.125854,1744.704224 
	C1145.614624,1745.803711 1143.723999,1747.591431 1144.912598,1752.088623 
	C1148.269897,1764.791016 1148.039795,1764.851929 1135.052002,1768.615234 
	C1126.403931,1771.121094 1126.273193,1771.324219 1127.681519,1780.068115 
	C1128.943359,1787.902588 1127.994751,1789.677002 1120.921265,1793.591187 
	C1117.551025,1795.456055 1112.974243,1796.108765 1112.223877,1800.958740 
	C1111.277100,1807.078979 1112.332397,1812.986572 1115.607422,1818.205933 
	C1118.606934,1822.985962 1123.688232,1822.757446 1128.190308,1821.459106 
	C1132.041626,1820.348633 1134.629150,1820.922852 1136.768433,1824.108154 
	C1141.327881,1830.897217 1140.047119,1834.689453 1132.210693,1837.690186 
	C1123.685791,1840.954468 1123.266724,1840.803833 1117.500000,1833.138672 
	C1116.304810,1831.550293 1115.021362,1829.993042 1113.577759,1828.635132 
	C1111.270386,1826.464355 1109.390991,1823.060913 1105.227051,1825.457642 
	C1102.054443,1827.283813 1099.928101,1830.013794 1100.449341,1833.516602 
	C1101.039673,1837.482788 1102.683838,1841.305786 1107.625000,1841.905151 
	C1107.954590,1841.945190 1108.294434,1841.912231 1108.621094,1841.965088 
	C1119.774902,1843.762695 1119.774780,1843.763428 1119.999756,1855.696045 
	C1089.743042,1849.758911 1060.944824,1838.712891 1032.766724,1826.001099 
	C1019.466797,1820.001099 1006.485413,1813.294922 992.668579,1806.918213 
	C991.373840,1806.505981 990.770264,1806.084229 989.603516,1805.681152 
	C984.500061,1802.837036 980.179932,1799.604126 974.610962,1797.150635 
	C973.757263,1796.591187 973.496521,1796.355835 972.717896,1796.023315 
	C970.106323,1794.033936 967.612000,1792.757324 964.600647,1790.994507 
	C964.009094,1790.622925 963.334900,1789.988770 962.877441,1789.918823 
	C961.275391,1789.149902 960.276611,1788.246582 958.584106,1787.165649 
	C957.783508,1786.571899 957.551453,1786.331177 956.829468,1785.983643 
	C955.266418,1785.139160 954.283936,1784.274536 952.590637,1783.291748 
	C951.758789,1782.720947 951.497437,1782.464600 950.704346,1782.071045 
	C947.419006,1779.483276 944.014648,1777.958984 940.592285,1775.268311 
	C939.742310,1774.669800 939.484070,1774.421265 938.702148,1774.051514 
	C937.161255,1773.085083 936.183838,1772.191406 934.560059,1771.047119 
	C934.013306,1770.674805 933.410461,1770.000366 932.968628,1769.903809 
	C930.456055,1768.750732 929.073547,1766.823730 926.583496,1765.197510 
	C926.004456,1764.829590 925.361206,1764.092407 924.887573,1763.969971 
	C922.464355,1762.669067 921.047302,1760.833740 918.578674,1759.227417 
	C918.001892,1758.870972 917.342041,1758.124023 916.861206,1757.993286 
	C914.432922,1756.619995 912.975464,1754.795410 910.563782,1753.039795 
	C910.002686,1752.641968 909.481140,1751.973755 909.069702,1751.871948 
	C904.867859,1749.783936 902.678040,1745.940186 898.591553,1743.241455 
	C896.922668,1742.213501 895.847961,1741.551758 894.316223,1740.443848 
	C891.065430,1737.070190 888.374939,1734.036011 884.571899,1731.202393 
	C880.532776,1728.661377 877.320923,1726.210327 874.667847,1722.254150 
	C864.318176,1712.349609 854.695557,1702.607666 844.492310,1692.478271 
	C841.067993,1689.265259 838.615173,1686.141846 835.892578,1682.453613 
	C833.141907,1678.576050 829.882690,1676.002075 826.513489,1672.608398 
	C825.343323,1671.065674 824.682129,1669.981323 823.559387,1668.449219 
	C821.561279,1665.161987 819.029724,1663.175415 816.514893,1660.281250 
	C815.530396,1658.721680 814.967651,1657.693970 813.854431,1656.416260 
	C812.140991,1654.137939 810.494263,1652.501831 808.532410,1650.228516 
	C807.607910,1648.648071 807.093140,1647.628052 806.039185,1646.368652 
	C804.715454,1644.978516 803.870239,1643.874634 802.526733,1642.276611 
	C802.007385,1641.385986 801.912659,1641.046387 801.430420,1640.347168 
	C800.446289,1638.870728 799.761780,1637.814941 798.453735,1636.434692 
	C797.421265,1634.912476 796.833252,1633.838257 795.757324,1632.374756 
	C794.556641,1630.870850 793.788879,1629.796997 792.505005,1628.283325 
	C792.014587,1627.424927 791.935669,1627.083740 791.487549,1626.369019 
	C789.036072,1622.981323 787.026978,1619.917847 784.507812,1616.375000 
	C783.960327,1615.494263 783.861694,1615.134399 783.367065,1614.378418 
	C782.393311,1612.836060 781.725891,1611.747803 780.487610,1610.270508 
	C780.009338,1609.425537 779.931580,1609.080200 779.479370,1608.358398 
	C778.452698,1606.830933 777.733276,1605.725342 776.518799,1604.157227 
	C776.108765,1601.688477 775.030396,1600.256714 773.389038,1598.413818 
	C772.344421,1596.826416 771.710388,1595.737183 770.486755,1594.275146 
	C770.018494,1593.439087 769.947632,1593.095093 769.518921,1592.364624 
	C767.856628,1589.511108 766.605164,1587.013184 764.539307,1584.185303 
	C763.681274,1580.265137 761.711975,1577.643677 759.452698,1574.443970 
	C743.322571,1543.850586 728.882385,1513.182251 718.535522,1480.813354 
	C709.640747,1452.987305 702.007080,1424.794556 697.496948,1395.060913 
	C697.225098,1393.301025 697.176147,1392.292480 696.727051,1390.630371 
	C695.818787,1387.370972 696.373230,1384.550415 694.590332,1381.517822 
	C694.904053,1380.323853 695.040405,1379.708130 694.626526,1378.578613 
	C693.625244,1374.679565 694.443909,1371.090698 693.287354,1367.039673 
	C693.032288,1364.785400 693.053955,1363.130249 692.706909,1360.721680 
	C689.404541,1327.343262 689.752075,1294.645630 690.317261,1260.994995 
	C690.728210,1259.034668 690.988831,1258.025757 691.067261,1256.245361 
	C692.944946,1250.995361 691.565491,1246.220947 692.134888,1240.830688 
	C693.498413,1237.963745 693.517212,1235.637329 693.257507,1232.436646 
	C694.600525,1228.339355 693.644775,1224.809692 694.409790,1220.745728 
	C694.877380,1219.081787 695.188599,1218.134155 695.398804,1216.436157 
	C696.127686,1213.635010 695.918213,1211.442017 696.265137,1208.672852 
	C696.731934,1207.093140 697.103577,1206.152954 697.392517,1204.446777 
	C698.139160,1201.632324 697.887268,1199.421631 698.410950,1196.674561 
	C698.891357,1195.105347 699.227966,1194.167358 699.482178,1192.475830 
	C700.238342,1184.164062 703.071899,1177.024414 704.133240,1168.742676 
	C704.573730,1167.049561 704.941345,1166.111572 705.246643,1164.410889 
	C707.036499,1156.948120 709.026245,1150.286255 710.906860,1142.816528 
	C713.453918,1133.828247 715.797180,1125.559082 718.738525,1116.682861 
	C719.545105,1114.775757 720.031738,1113.558716 720.487244,1111.678711 
	C721.568481,1108.264404 722.248962,1105.333984 724.179321,1102.259277 
	C725.198120,1100.780151 726.075439,1099.929077 726.196045,1098.065674 
	C726.214844,1096.673462 726.330566,1095.888550 726.735657,1094.551147 
	C727.439880,1092.771484 727.947449,1091.558105 728.441406,1089.678223 
	C730.362549,1085.195679 731.336609,1080.931152 734.421753,1076.954346 
	C740.898621,1074.693115 745.140686,1071.966553 741.027710,1064.188965 
	C740.678772,1058.830444 743.503906,1055.357056 746.237488,1051.171021 
	C759.845886,1047.097900 759.992798,1046.870361 755.131592,1036.717651 
	C754.015259,1033.488281 755.566040,1031.469116 756.751709,1028.645996 
	C757.597168,1027.481812 758.129272,1026.961914 759.139038,1026.150635 
	C761.241821,1024.669434 762.987671,1023.872009 765.006592,1023.433350 
	C778.829285,1020.429504 779.762634,1018.004395 771.376953,1006.235229 
	C772.662781,1002.642456 774.107605,999.713379 775.702393,996.098633 
	C776.934570,994.620972 777.715698,993.407715 779.805054,992.995728 
	C784.314148,992.969971 788.691589,994.113708 790.895386,989.731995 
	C792.359863,986.820312 789.475708,985.099426 787.487610,982.572266 
	C785.846130,978.131714 788.704041,975.863525 790.898193,972.598511 
	C792.120667,971.328369 792.941895,970.644104 794.269531,969.785645 
	C795.749329,969.423889 796.582581,968.655090 797.476257,968.552246 
	C807.097046,967.445312 810.115601,962.139648 807.536072,952.445190 
	C808.310242,950.309875 809.040039,948.856567 809.964966,946.817505 
	C810.938232,945.153076 811.844177,944.177490 813.059448,942.598633 
	C814.108826,941.606018 814.757568,941.143127 815.962219,940.461182 
	C818.229431,937.788452 824.647034,941.459717 823.073120,934.400024 
	C822.660217,932.885498 822.661011,932.000244 823.134766,930.510132 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1174.714111,1868.709106 
	C1173.960815,1866.802002 1174.153320,1865.103760 1173.868408,1863.489990 
	C1172.229248,1854.201416 1171.432251,1853.725586 1162.381104,1856.151245 
	C1156.005493,1857.859863 1151.666138,1856.656616 1149.388794,1852.548218 
	C1146.421997,1847.195557 1147.518921,1840.012085 1152.939087,1836.814697 
	C1160.165039,1832.551880 1162.688232,1826.908691 1162.167236,1818.706177 
	C1161.722412,1811.703613 1171.155640,1804.885742 1177.947266,1806.452148 
	C1179.711426,1806.859009 1180.924316,1808.004272 1181.460205,1809.635376 
	C1181.972778,1811.195435 1182.001343,1812.909668 1182.458618,1814.493774 
	C1185.106079,1823.664185 1185.176392,1823.689209 1194.520996,1822.243408 
	C1204.362671,1820.720703 1206.843994,1822.184204 1210.114624,1831.447144 
	C1210.335205,1832.071777 1210.520508,1832.708740 1210.732422,1833.336426 
	C1214.386719,1844.156494 1214.101807,1844.595459 1202.514282,1845.991089 
	C1193.025391,1847.134033 1192.502808,1847.116943 1192.190918,1856.605225 
	C1192.013062,1862.013550 1187.054688,1864.220825 1186.074219,1869.540039 
	C1182.479736,1869.852173 1178.959595,1869.404663 1174.714111,1868.709106 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M816.032227,2084.166748 
	C814.710205,2092.235596 814.684509,2092.308594 807.923889,2089.926270 
	C805.731201,2089.153809 803.643799,2087.628418 801.510498,2089.717773 
	C797.232117,2093.907959 792.759888,2097.757324 787.504456,2100.779541 
	C785.301819,2102.045898 785.737854,2104.989990 786.727234,2107.187256 
	C788.336853,2110.761719 786.593750,2113.124268 783.865051,2114.670654 
	C780.193665,2116.751221 778.010986,2113.667969 776.828430,2111.167236 
	C773.449829,2104.022217 767.594360,2103.120850 760.946716,2104.228027 
	C753.877441,2105.405762 750.421692,2110.193359 748.580444,2116.894531 
	C746.306580,2125.170410 740.118225,2127.025635 735.840637,2120.221191 
	C730.778870,2112.169189 724.820190,2112.345947 717.184814,2114.461182 
	C708.262146,2116.933105 704.257446,2113.593750 703.984863,2104.395752 
	C703.850098,2099.845703 705.127441,2096.609131 710.089355,2095.679932 
	C711.700439,2095.377930 713.211548,2094.570801 714.790527,2094.063477 
	C723.696167,2091.200928 723.652161,2091.240234 726.975891,2099.850586 
	C728.216064,2103.062988 728.162781,2107.509277 733.210876,2107.700928 
	C738.232544,2107.891113 743.805725,2103.946289 745.272095,2099.008057 
	C745.827820,2097.136963 746.006958,2095.084961 745.971313,2093.122070 
	C745.901123,2089.262939 747.944519,2087.215088 751.119751,2085.392090 
	C761.608032,2079.371094 761.544983,2079.270996 768.354614,2089.450195 
	C769.643860,2091.376953 770.736267,2093.511963 772.337708,2095.139404 
	C777.493347,2100.379150 785.563416,2098.920166 788.775757,2092.309570 
	C789.208862,2091.418457 789.507385,2090.461426 789.857910,2089.530762 
	C793.901917,2078.792969 793.967651,2078.681885 803.388733,2084.317139 
	C806.625183,2086.252930 808.258118,2084.894775 810.130493,2081.673828 
	C812.176941,2081.888916 813.927368,2082.795654 816.032227,2084.166748 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1348.674194,2202.800049 
	C1354.695190,2206.485840 1360.167725,2209.562256 1364.472656,2214.624756 
	C1366.761963,2217.316650 1371.543701,2217.926514 1375.598633,2218.072021 
	C1378.397095,2218.172363 1379.692749,2219.620850 1379.932861,2222.408936 
	C1380.451294,2228.426270 1374.963501,2229.778076 1371.748047,2232.645996 
	C1369.053589,2235.049316 1367.046509,2231.844238 1365.180786,2230.141602 
	C1362.978394,2228.131836 1360.958862,2225.920654 1358.741089,2223.928711 
	C1355.954712,2221.426758 1352.592407,2221.660400 1349.336304,2222.563232 
	C1346.472534,2223.357422 1343.365479,2225.206787 1340.959717,2222.618652 
	C1338.276611,2219.731934 1336.172852,2216.109619 1336.221924,2211.963379 
	C1336.248535,2209.725830 1337.271240,2207.500244 1337.923340,2204.480957 
	C1341.287598,2203.378174 1344.572998,2203.063232 1348.674194,2202.800049 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1401.183350,2197.099121 
	C1404.010742,2206.554932 1410.596313,2209.612549 1419.344971,2210.052002 
	C1426.654053,2210.419189 1428.354858,2212.362061 1427.969727,2218.899170 
	C1427.674805,2223.904785 1424.664795,2226.862061 1419.106812,2227.835693 
	C1414.281372,2228.680664 1411.341431,2226.548828 1410.337158,2222.031982 
	C1408.685181,2214.602051 1404.043335,2211.568604 1396.725952,2211.951660 
	C1396.072144,2211.986084 1395.398926,2211.905029 1394.752319,2211.784180 
	C1385.839233,2210.116699 1385.242188,2208.719238 1389.991577,2199.671631 
	C1393.346191,2197.228027 1396.886841,2197.142334 1401.183350,2197.099121 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1692.880127,2105.062988 
	C1694.572266,2107.430176 1697.071411,2107.394775 1699.108032,2108.353760 
	C1704.382935,2110.836670 1707.280273,2117.828613 1705.756348,2123.335449 
	C1704.778809,2126.867676 1697.725708,2131.813965 1693.492065,2131.936035 
	C1688.452026,2132.081299 1683.696167,2126.384277 1684.134399,2120.295166 
	C1684.367188,2117.058350 1685.250610,2113.868652 1685.774414,2109.760742 
	C1687.889771,2107.639160 1690.071045,2106.415039 1692.880127,2105.062988 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1206.755371,1873.066406 
	C1205.294678,1868.413574 1207.616821,1866.489990 1211.585327,1864.985596 
	C1216.489746,1863.126587 1218.327515,1859.446533 1217.062378,1853.833130 
	C1215.071411,1844.999878 1215.323120,1844.808838 1223.937256,1840.086548 
	C1226.617798,1838.617188 1229.248291,1834.299927 1232.543457,1837.203003 
	C1235.443481,1839.757812 1234.460205,1844.130371 1233.051147,1847.518188 
	C1231.028442,1852.381958 1229.144409,1857.523560 1223.867432,1860.077759 
	C1218.505127,1862.673340 1217.516113,1867.306641 1218.005493,1873.461426 
	C1214.379761,1875.163818 1211.005615,1873.443604 1206.755371,1873.066406 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1284.756348,1876.915039 
	C1284.147095,1875.111816 1283.665527,1872.977539 1284.518555,1871.899780 
	C1288.382202,1867.019775 1288.176880,1861.428711 1287.995850,1855.792847 
	C1287.851562,1851.298340 1289.663086,1847.860352 1293.916748,1846.484863 
	C1297.973755,1845.172852 1301.863159,1845.992554 1304.494995,1849.815796 
	C1307.238037,1853.800293 1306.006592,1857.691772 1303.103027,1860.663452 
	C1300.614380,1863.210327 1297.374268,1865.183350 1294.166626,1866.824341 
	C1290.588013,1868.655518 1289.707031,1871.407593 1290.001953,1875.809082 
	C1288.499756,1876.779541 1286.999146,1876.925049 1284.756348,1876.915039 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1283.108032,2205.919434 
	C1282.425049,2212.987305 1279.229248,2215.304443 1270.720459,2215.276367 
	C1265.815552,2215.260254 1263.608398,2212.494141 1264.003052,2206.864990 
	C1270.053345,2205.133301 1276.140869,2205.732666 1283.108032,2205.919434 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1716.789429,2092.621582 
	C1717.538696,2094.699463 1719.093750,2097.376953 1716.304810,2098.690674 
	C1714.472412,2099.553711 1713.753906,2097.115479 1711.790039,2095.946777 
	C1712.380737,2093.927979 1714.233276,2093.325928 1716.789429,2092.621582 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M696.862122,1394.904053 
	C701.035522,1404.302002 701.929749,1414.953003 704.233765,1425.274536 
	C715.246277,1474.608398 732.517700,1521.587769 756.123657,1566.263794 
	C757.207275,1568.314697 758.052002,1570.491821 758.969360,1573.293579 
	C756.683105,1573.507935 755.864929,1571.651001 754.956482,1569.882690 
	C744.517090,1549.563110 734.470703,1529.063965 726.187744,1507.743408 
	C716.723328,1483.381592 709.873657,1458.216675 702.566406,1432.516846 
	C702.404053,1422.359375 698.317932,1413.514160 696.930542,1404.171143 
	C696.496033,1401.245361 695.660767,1398.451294 696.862122,1394.904053 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M844.078491,1692.682861 
	C855.273315,1700.144043 863.997559,1710.923706 873.878296,1721.333252 
	C873.094910,1721.795898 871.833923,1721.942139 871.223083,1721.380981 
	C861.647278,1712.581421 851.583313,1704.241821 844.078491,1692.682861 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M435.465149,1661.642822 
	C431.095367,1651.420166 427.163849,1641.409058 423.389099,1630.721436 
	C427.291656,1631.947388 427.355652,1635.903564 428.688995,1639.174561 
	C431.403687,1645.833984 434.946899,1652.188843 436.037170,1660.167480 
	C436.056366,1660.893188 435.903412,1661.854370 435.465149,1661.642822 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M974.192200,1797.435303 
	C979.611206,1797.840210 984.096863,1800.913452 988.671265,1805.103882 
	C982.891113,1805.558716 978.883789,1801.312622 974.192200,1797.435303 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M434.255005,1661.656738 
	C435.026886,1661.431274 435.530884,1661.141968 435.793640,1661.017578 
	C436.872009,1662.873047 437.687622,1664.852905 439.025635,1667.443970 
	C439.498932,1668.415771 439.449799,1668.776367 439.039185,1669.545898 
	C436.753357,1669.681763 434.446320,1669.988159 432.980713,1669.020386 
	C429.432343,1666.677490 428.869568,1663.947388 434.255005,1661.656738 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M884.120728,1731.454346 
	C888.414185,1732.013428 890.990295,1735.456787 893.791992,1739.350830 
	C889.025513,1739.326416 886.428040,1735.944458 884.120728,1731.454346 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M826.080261,1672.810913 
	C830.543457,1673.505737 832.775146,1677.270508 835.204590,1681.535889 
	C830.862671,1680.708130 827.855103,1677.775269 826.080261,1672.810913 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M898.126587,1743.495117 
	C902.679749,1743.702637 905.105530,1747.504272 908.382874,1751.158447 
	C903.206360,1751.915283 900.674561,1748.092041 898.126587,1743.495117 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M439.088501,1670.463867 
	C438.780762,1669.619507 438.883789,1669.284058 439.267456,1668.501953 
	C443.532959,1670.788208 444.689148,1675.077881 445.757233,1680.160767 
	C442.178650,1678.526855 441.688843,1674.218140 439.088501,1670.463867 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M784.104248,1616.548584 
	C787.736450,1617.753662 789.086853,1621.498901 791.106201,1625.359253 
	C786.279419,1625.081055 785.443237,1620.979736 784.104248,1616.548584 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M940.138184,1775.534790 
	C944.093445,1775.424072 946.748901,1778.320068 949.930420,1781.338867 
	C946.059448,1781.399780 942.314575,1780.235474 940.138184,1775.534790 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M816.121765,1660.426758 
	C819.437561,1661.074829 821.451172,1663.720459 823.078003,1667.385498 
	C819.357666,1667.136963 817.042358,1664.837280 816.121765,1660.426758 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M764.153503,1584.296753 
	C767.098755,1585.070923 768.043762,1587.963379 769.181885,1591.340820 
	C765.539734,1591.044922 764.924805,1587.961548 764.153503,1584.296753 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M964.160889,1791.244385 
	C967.227417,1790.780396 969.484436,1792.724609 971.947021,1795.341797 
	C968.992310,1795.696777 966.119812,1794.816040 964.160889,1791.244385 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M926.135498,1765.457031 
	C928.782104,1764.891235 930.377930,1766.814087 932.276733,1769.230469 
	C929.571350,1770.027100 927.333801,1769.039917 926.135498,1765.457031 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M918.134277,1759.489014 
	C920.812622,1758.853760 922.310425,1760.864136 924.166748,1763.275146 
	C921.508423,1764.008301 919.315674,1762.997437 918.134277,1759.489014 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M910.118042,1753.280273 
	C912.807007,1752.775513 914.368835,1754.729492 916.154541,1757.274414 
	C913.407227,1757.988403 911.203064,1756.915527 910.118042,1753.280273 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M808.137207,1650.337891 
	C810.680725,1650.584717 812.196777,1652.512939 813.262207,1655.542725 
	C810.479492,1655.552490 808.510193,1654.084473 808.137207,1650.337891 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M934.150269,1771.250122 
	C935.762207,1770.540405 936.820190,1771.607300 937.979980,1773.386230 
	C936.529907,1773.878418 935.006958,1773.594482 934.150269,1771.250122 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M780.107910,1610.350586 
	C781.655518,1610.252319 782.580200,1611.356934 783.028320,1613.425049 
	C781.341675,1613.600098 780.308472,1612.662476 780.107910,1610.350586 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M802.132568,1642.354248 
	C803.761292,1642.223022 804.761841,1643.402710 805.461914,1645.531006 
	C803.767090,1645.738770 802.430603,1644.927734 802.132568,1642.354248 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M798.061401,1636.550293 
	C799.616394,1636.334717 800.541504,1637.410400 801.069824,1639.434082 
	C799.453369,1639.654663 798.374817,1638.800903 798.061401,1636.550293 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M952.190063,1783.528076 
	C953.762329,1782.632446 954.906555,1783.563843 956.124023,1785.337891 
	C954.736206,1785.890137 953.205811,1785.742065 952.190063,1783.528076 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M958.176758,1787.387939 
	C959.757385,1786.604248 960.901978,1787.587891 962.180908,1789.314575 
	C960.754272,1789.880859 959.176758,1789.721924 958.176758,1787.387939 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M792.120972,1628.369385 
	C793.669556,1628.260864 794.658325,1629.366333 795.280518,1631.413330 
	C793.556763,1631.677612 792.384766,1630.809814 792.120972,1628.369385 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M776.151611,1604.215210 
	C777.687439,1604.191040 778.588623,1605.364014 779.130066,1607.414795 
	C777.389221,1607.611450 776.307495,1606.649292 776.151611,1604.215210 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M770.106873,1594.353638 
	C771.643127,1594.267822 772.519409,1595.389893 772.939209,1597.430298 
	C771.275757,1597.575439 770.286804,1596.621826 770.106873,1594.353638 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1410.845581,1863.071045 
	C1411.865967,1860.553467 1414.366577,1860.704224 1416.552612,1860.149414 
	C1447.017700,1852.416626 1476.720947,1842.430786 1505.650391,1830.137817 
	C1507.150757,1829.500366 1508.788452,1829.186035 1511.078613,1828.718628 
	C1509.913940,1831.779175 1506.632935,1832.882080 1503.628052,1834.114502 
	C1474.836914,1845.922241 1445.229858,1855.330322 1415.303467,1863.764771 
	C1414.123413,1864.097534 1412.708130,1863.596191 1410.845581,1863.071045 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1320.981934,1877.135010 
	C1320.340576,1876.715698 1320.759399,1875.820435 1320.991211,1875.383789 
	C1324.189331,1870.081543 1328.288330,1871.100464 1333.256104,1873.323242 
	C1356.508545,1872.658081 1378.508423,1868.097534 1400.540894,1863.746826 
	C1401.832764,1863.491699 1403.148315,1863.356323 1405.201050,1863.404419 
	C1403.564575,1866.973633 1399.708740,1867.281128 1396.254883,1867.864136 
	C1375.714355,1871.332031 1355.153198,1874.692749 1334.551270,1877.769775 
	C1330.346313,1878.397705 1325.937866,1877.661743 1320.981934,1877.135010 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1519.754272,1825.733398 
	C1528.481812,1818.230347 1539.864624,1814.313965 1551.306885,1809.094971 
	C1551.656616,1810.298462 1550.996460,1811.438599 1549.752441,1812.027710 
	C1540.032104,1816.629028 1530.915649,1822.514893 1519.754272,1825.733398 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1925.601685,1934.615234 
	C1926.974731,1935.505127 1927.718872,1936.573608 1928.477173,1937.632080 
	C1931.374146,1941.675415 1929.106445,1944.500854 1925.958252,1946.647949 
	C1922.477661,1949.021851 1919.815552,1947.712036 1918.202637,1943.251099 
	C1919.434082,1939.132080 1922.361084,1937.096313 1925.601685,1934.615234 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1658.306396,1735.834717 
	C1659.969727,1732.090454 1663.074585,1729.093384 1667.522217,1726.732666 
	C1666.631470,1731.215942 1663.742676,1734.436157 1658.306396,1735.834717 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1978.515869,1874.128662 
	C1978.755249,1877.773560 1975.822510,1879.642090 1972.705566,1882.039307 
	C1972.089233,1878.177856 1974.497925,1875.855957 1978.515869,1874.128662 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1558.177490,1805.822998 
	C1559.191772,1803.141479 1561.868164,1801.921875 1565.346924,1801.026733 
	C1564.841064,1804.521240 1561.842773,1805.160278 1558.177490,1805.822998 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1634.145874,1755.805908 
	C1634.744751,1753.534912 1636.424438,1751.678467 1639.500977,1750.569092 
	C1639.602783,1753.506226 1638.095093,1755.528931 1634.145874,1755.805908 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1582.770020,1791.932617 
	C1582.524414,1789.401245 1584.675293,1788.783203 1587.304932,1787.902588 
	C1587.162354,1789.993042 1585.736450,1791.439941 1582.770020,1791.932617 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1612.273193,1771.847656 
	C1612.690186,1769.771973 1614.470947,1768.596069 1617.332764,1767.982422 
	C1616.999878,1770.179565 1615.456421,1771.644653 1612.273193,1771.847656 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1620.799805,1765.929932 
	C1620.376465,1764.309326 1621.428711,1763.440674 1623.440918,1762.986450 
	C1623.670776,1764.521851 1622.902100,1765.573242 1620.799805,1765.929932 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1646.247559,1745.830933 
	C1646.311890,1744.351196 1647.397705,1743.221924 1649.497559,1742.428955 
	C1649.750244,1744.169312 1648.999634,1745.613159 1646.247559,1745.830933 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M355.430145,1856.424194 
	C359.528595,1860.361084 363.179352,1861.743896 368.523041,1860.437500 
	C375.699371,1858.682861 375.249023,1860.673096 378.370117,1867.182251 
	C383.092499,1877.031006 378.333832,1881.370483 371.239319,1885.842651 
	C368.831879,1887.360107 366.841492,1891.338623 363.765503,1889.003052 
	C360.301025,1886.372559 362.046204,1882.399170 363.632538,1879.021973 
	C363.911957,1878.427368 364.313782,1877.880737 364.715057,1877.354614 
	C366.214325,1875.387939 370.176147,1874.616943 368.779663,1871.326660 
	C367.745880,1868.890991 364.603210,1868.160156 362.151154,1867.197266 
	C353.602539,1863.840210 341.420593,1867.700684 337.302582,1875.750488 
	C334.371033,1881.480957 329.540131,1883.462646 323.540283,1885.648926 
	C321.030518,1880.015991 321.358124,1875.394287 325.770203,1871.227173 
	C329.892639,1867.333740 333.379181,1863.055054 336.234100,1858.018433 
	C339.990417,1851.391602 347.804413,1850.843994 355.430145,1856.424194 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M333.333221,1950.049927 
	C335.830353,1953.416138 336.140137,1955.945190 331.747620,1955.426270 
	C326.330688,1954.786377 323.651855,1951.276489 324.125244,1945.658081 
	C324.483276,1941.408569 325.723297,1937.228638 326.635529,1933.031738 
	C328.013855,1926.690796 327.077637,1924.829834 321.050507,1922.709595 
	C319.503815,1922.165649 317.789459,1922.119751 316.192322,1921.694092 
	C306.413849,1919.088623 304.976715,1916.980225 306.031189,1906.949463 
	C306.624359,1901.306763 306.899475,1901.068726 318.465881,1896.540527 
	C321.288971,1903.516357 325.382629,1909.234131 332.783020,1912.811157 
	C339.160553,1915.893677 340.646851,1922.955811 338.249573,1929.898071 
	C337.062683,1933.335205 335.535706,1936.666748 333.987213,1939.963745 
	C332.541412,1943.041870 331.204041,1946.050293 333.333221,1950.049927 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M516.461914,1918.266602 
	C518.572937,1911.227783 525.012390,1911.084595 529.756836,1908.556396 
	C531.718567,1907.510864 533.390076,1909.192383 534.474609,1911.118896 
	C535.662659,1913.229248 535.673523,1915.538208 536.108459,1917.809570 
	C537.308594,1924.076172 539.214233,1925.314575 545.466675,1924.495605 
	C546.777039,1924.323975 548.109009,1923.952637 549.398743,1924.060425 
	C552.472168,1924.317017 556.349670,1922.738281 557.766541,1927.289429 
	C559.227661,1931.982788 556.527283,1938.463867 551.688965,1940.788208 
	C547.935364,1942.591675 543.933960,1943.335205 541.387024,1938.617188 
	C538.208313,1932.728638 532.798889,1930.078857 526.639526,1930.193604 
	C520.305420,1930.311401 517.217712,1928.375122 517.579895,1921.830444 
	C517.630371,1920.917236 516.948914,1919.963501 516.461914,1918.266602 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M416.942200,1729.360840 
	C417.727325,1734.343018 421.437866,1738.447144 418.389435,1743.197998 
	C414.769348,1748.840210 410.377716,1753.605347 404.376038,1756.738647 
	C402.883026,1757.518066 401.225250,1758.158936 399.697021,1757.163452 
	C397.723907,1755.878296 397.687103,1753.629517 398.464020,1751.852051 
	C400.589630,1746.988525 401.486694,1741.941528 402.484741,1736.750122 
	C403.842163,1729.689331 410.307159,1728.925781 416.942200,1729.360840 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M373.596130,2016.225220 
	C370.694733,2023.265991 365.142090,2022.263306 359.966187,2021.495728 
	C357.455688,2021.123291 355.844574,2018.950562 357.051697,2016.262329 
	C358.385162,2013.292847 356.863495,2008.587769 362.409210,2008.008301 
	C368.436951,2007.378540 371.870300,2009.916260 373.596130,2016.225220 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M532.024170,1843.983398 
	C530.270325,1841.615723 531.041687,1840.505493 533.135132,1840.368164 
	C534.545959,1840.275757 535.517090,1841.331055 536.126221,1842.555786 
	C536.819946,1843.950562 538.285095,1845.784180 536.358826,1846.788574 
	C534.670898,1847.668579 533.765808,1845.311279 532.024170,1843.983398 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M689.868530,1260.425171 
	C690.756897,1261.322876 691.335083,1262.611694 691.293396,1263.880249 
	C690.257812,1295.372803 690.423279,1326.841064 692.662354,1359.118042 
	C690.238770,1358.883911 690.194458,1356.936035 689.963379,1354.895752 
	C687.533936,1333.438599 687.785400,1311.895264 688.079651,1290.371460 
	C688.214417,1280.520508 686.613892,1270.564697 689.868530,1260.425171 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M703.688904,1168.303711 
	C705.895264,1176.045776 701.114746,1183.013916 699.892334,1191.193359 
	C696.402100,1188.155029 699.108704,1184.817993 699.861694,1180.692627 
	C699.900574,1175.882202 700.161255,1171.856079 703.688904,1168.303711 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M691.669861,1240.427490 
	C693.592834,1244.877075 692.939148,1249.675537 691.444214,1254.972046 
	C689.546143,1250.557861 689.277527,1245.661255 691.669861,1240.427490 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M694.017822,1220.314819 
	C695.898071,1223.598877 695.221375,1227.083862 693.598633,1231.065430 
	C691.561340,1227.860840 691.163696,1224.182007 694.017822,1220.314819 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M692.665649,1367.034668 
	C695.823608,1369.508301 695.130676,1373.268677 694.744385,1377.520752 
	C690.597900,1375.255615 692.230469,1371.288818 692.665649,1367.034668 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M694.316284,1381.622314 
	C697.040710,1382.901367 697.008484,1385.779541 696.624634,1389.325806 
	C693.061157,1388.159912 694.184875,1385.114624 694.316284,1381.622314 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M695.880127,1208.286865 
	C697.461548,1210.279663 697.005371,1212.495728 695.763916,1215.195557 
	C693.574951,1213.278687 693.391357,1210.893799 695.880127,1208.286865 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M698.050537,1196.270264 
	C699.607849,1198.316406 698.953186,1200.502686 697.763550,1203.182739 
	C695.526733,1201.224854 695.378357,1198.822876 698.050537,1196.270264 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1370.227295,2288.196289 
	C1375.695435,2286.544922 1378.185547,2283.418701 1377.976440,2278.415039 
	C1377.800659,2274.204834 1379.250977,2270.611816 1381.803833,2267.377686 
	C1384.392700,2264.097900 1387.855713,2263.457031 1391.669922,2264.359863 
	C1395.287598,2265.216064 1395.533691,2268.187744 1396.109253,2271.275635 
	C1397.003052,2276.071045 1398.203735,2280.333252 1390.940063,2280.821289 
	C1388.857300,2280.960938 1386.903198,2282.961426 1384.882935,2284.095459 
	C1380.944336,2286.307129 1379.532959,2289.046631 1380.798584,2293.925537 
	C1383.181641,2303.110840 1376.858887,2311.139404 1367.597168,2311.632812 
	C1366.658325,2311.683105 1365.343384,2311.591309 1364.798584,2311.008789 
	C1361.083496,2307.034180 1359.142090,2301.910645 1358.546021,2296.821289 
	C1358.079468,2292.836182 1361.953613,2290.791992 1365.746216,2289.784912 
	C1367.023071,2289.445801 1368.235962,2288.866211 1370.227295,2288.196289 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1456.204102,2230.486816 
	C1458.817627,2240.871826 1458.780884,2241.561768 1449.617065,2243.582275 
	C1443.509277,2244.929199 1440.067627,2247.445557 1439.879272,2253.986328 
	C1439.750488,2258.457031 1437.163208,2262.190918 1434.807007,2265.767822 
	C1432.124023,2269.840576 1425.839600,2271.638672 1423.634155,2268.965576 
	C1420.853638,2265.595459 1421.236816,2261.398438 1423.562622,2257.857422 
	C1425.728394,2254.560059 1428.013428,2250.949951 1431.147583,2248.778809 
	C1435.009277,2246.103760 1436.328247,2243.044434 1436.026245,2238.727295 
	C1435.934082,2237.409424 1435.931030,2236.024170 1436.231689,2234.750732 
	C1437.535645,2229.229492 1440.513794,2224.812256 1446.088257,2223.143066 
	C1451.651245,2221.477295 1453.163208,2226.734131 1456.204102,2230.486816 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1533.931152,2255.803223 
	C1532.998901,2253.928955 1532.283203,2252.783447 1531.819214,2251.543701 
	C1529.385864,2245.042236 1529.892944,2244.314697 1537.090698,2244.019531 
	C1539.417847,2243.924072 1541.753052,2243.957031 1544.083008,2244.009033 
	C1552.169189,2244.189697 1555.634033,2247.734131 1555.308472,2255.501465 
	C1555.160278,2259.038330 1552.460815,2260.546875 1549.850586,2262.015381 
	C1546.528809,2263.883789 1543.004395,2265.170410 1539.643311,2262.328369 
	C1537.637817,2260.633057 1536.043091,2258.451660 1533.931152,2255.803223 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1354.663940,2263.554199 
	C1350.714966,2258.189697 1348.541260,2252.460693 1343.791260,2248.531738 
	C1342.710938,2247.638428 1342.341309,2246.153076 1343.451904,2245.084473 
	C1344.035156,2244.523193 1345.320190,2244.298096 1346.173828,2244.474365 
	C1352.222168,2245.723389 1357.995728,2248.837646 1364.515381,2246.874512 
	C1365.080322,2246.704590 1366.241455,2247.762207 1366.810059,2248.494629 
	C1368.654175,2250.870361 1368.734497,2259.764160 1366.516113,2261.804932 
	C1363.358398,2264.709961 1359.829102,2267.710938 1354.663940,2263.554199 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1423.770142,2289.243652 
	C1420.297485,2295.576172 1414.037720,2295.190186 1408.962036,2297.155029 
	C1407.714478,2297.637939 1406.625366,2296.506104 1405.788452,2295.325195 
	C1403.151978,2291.605469 1401.484131,2283.260010 1403.114868,2281.302979 
	C1405.037476,2278.995605 1415.869751,2276.882568 1419.274170,2278.390869 
	C1423.659546,2280.333740 1424.041382,2284.321533 1423.770142,2289.243652 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1585.737549,2231.201172 
	C1591.358643,2229.167480 1593.841919,2230.471436 1594.061768,2236.097168 
	C1594.410278,2245.021973 1592.230469,2250.136719 1586.416504,2252.759766 
	C1583.060913,2254.273193 1580.717041,2253.957520 1579.737183,2249.970215 
	C1579.503662,2249.020020 1579.017334,2248.134277 1578.682617,2247.206055 
	C1574.921997,2236.780273 1574.923828,2236.779541 1585.737549,2231.201172 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1606.157471,2264.894043 
	C1604.854370,2256.176270 1608.139160,2250.808594 1615.284302,2247.353760 
	C1619.209839,2245.455811 1621.532715,2246.572754 1623.087158,2250.347412 
	C1626.053711,2257.551025 1617.230713,2269.775391 1609.378174,2269.156250 
	C1607.588745,2269.015137 1606.806763,2267.279541 1606.157471,2264.894043 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1507.980469,2265.833496 
	C1508.195190,2270.334229 1506.558472,2273.066162 1503.512085,2274.981689 
	C1497.036987,2279.053467 1494.029053,2277.892822 1492.069092,2270.594482 
	C1491.725952,2269.316650 1491.543701,2267.996094 1491.263306,2266.700439 
	C1490.077637,2261.220947 1491.571655,2257.890137 1495.894165,2256.401855 
	C1500.903564,2254.677490 1505.095459,2256.339355 1507.304565,2261.127197 
	C1507.838013,2262.283691 1507.768677,2263.718262 1507.980469,2265.833496 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1397.290771,2238.585449 
	C1400.027832,2238.211914 1402.000000,2238.145752 1403.966553,2238.002441 
	C1408.043091,2237.705566 1410.786255,2239.300781 1412.576904,2243.125732 
	C1414.324341,2246.857666 1412.682251,2249.716309 1410.435547,2252.037354 
	C1407.631836,2254.933838 1403.885254,2256.942871 1399.733398,2255.482422 
	C1395.314697,2253.927734 1393.438232,2249.873535 1392.320679,2245.632812 
	C1391.383301,2242.075439 1393.483398,2240.103271 1397.290771,2238.585449 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1291.366821,2298.678711 
	C1290.174194,2296.194336 1289.182373,2294.445801 1288.560059,2292.574463 
	C1287.877441,2290.521729 1288.355835,2288.371826 1290.300415,2287.371094 
	C1294.643066,2285.136475 1299.354004,2285.130127 1303.626953,2287.250732 
	C1307.932251,2289.387207 1309.078125,2293.996582 1309.097656,2298.235352 
	C1309.113403,2301.681641 1305.303833,2302.590576 1302.560425,2303.402100 
	C1298.137573,2304.710693 1293.945068,2304.429199 1291.366821,2298.678711 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1567.350586,2277.070801 
	C1566.358154,2276.080078 1565.899170,2275.572266 1565.642090,2274.977295 
	C1561.103271,2264.471436 1562.375000,2261.658203 1572.984497,2258.657227 
	C1577.858276,2257.278564 1581.586792,2259.962646 1581.729858,2264.953369 
	C1581.957031,2272.864990 1576.801147,2277.573730 1567.350586,2277.070801 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1471.986938,2205.917725 
	C1472.088257,2212.535645 1468.703491,2213.992920 1463.596558,2214.053711 
	C1458.610474,2214.113037 1456.677002,2211.518555 1455.361938,2207.153320 
	C1453.911865,2202.339600 1455.493896,2199.936768 1459.776245,2197.680176 
	C1469.338623,2192.641113 1470.625732,2193.255615 1471.986938,2205.917725 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1591.297119,2314.716797 
	C1589.718994,2317.215576 1587.813354,2317.771973 1585.870605,2318.302246 
	C1582.534424,2319.212402 1579.046997,2321.978027 1576.251831,2317.344482 
	C1573.500732,2312.783936 1573.339111,2306.702881 1575.944824,2304.341553 
	C1578.587646,2301.946289 1586.396118,2301.034180 1589.202393,2303.021973 
	C1593.233643,2305.877686 1591.891602,2310.089355 1591.297119,2314.716797 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1456.557861,2285.716309 
	C1452.018188,2283.842529 1451.420166,2280.747314 1452.612793,2277.262939 
	C1453.919189,2273.446289 1455.781982,2269.806396 1459.970459,2268.408936 
	C1464.544800,2266.882812 1468.471191,2270.026367 1470.369873,2276.465088 
	C1471.989868,2281.958740 1471.773071,2282.311523 1465.025513,2284.104248 
	C1462.483276,2284.779785 1459.894165,2285.278564 1456.557861,2285.716309 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1470.026855,2257.821533 
	C1465.111816,2256.684082 1465.328735,2252.717285 1464.441040,2249.790039 
	C1463.484985,2246.637451 1463.266602,2242.733154 1466.961670,2241.026367 
	C1470.621094,2239.335938 1475.196045,2238.666260 1478.101929,2241.920410 
	C1480.605713,2244.724365 1482.843018,2248.816406 1481.113281,2252.823486 
	C1479.305420,2257.011719 1474.375977,2256.379639 1470.026855,2257.821533 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1480.650024,2222.595703 
	C1480.207275,2212.339844 1480.638672,2211.768311 1487.749756,2212.013672 
	C1492.697388,2212.184326 1498.114136,2218.171631 1497.669556,2223.154541 
	C1497.391113,2226.272949 1495.266235,2227.660156 1492.348755,2227.891846 
	C1487.830688,2228.250488 1483.995972,2226.785645 1480.650024,2222.595703 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1625.609375,2311.087891 
	C1618.513428,2307.964600 1616.455811,2304.201660 1618.652344,2299.351807 
	C1620.293457,2295.728271 1623.193970,2293.937500 1627.335327,2294.025146 
	C1631.074097,2294.104736 1632.658081,2296.524658 1633.430420,2299.481689 
	C1634.359131,2303.036865 1634.847290,2306.831055 1630.958984,2309.189209 
	C1629.583618,2310.023438 1627.874512,2310.307373 1625.609375,2311.087891 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1651.835938,2275.980225 
	C1644.881104,2284.287354 1639.954956,2284.027588 1636.032471,2276.204590 
	C1634.270508,2272.690186 1634.277466,2269.971191 1637.624268,2267.617676 
	C1640.944946,2265.282471 1646.091919,2265.351318 1648.587524,2268.082520 
	C1650.380005,2270.044189 1651.475464,2272.502930 1651.835938,2275.980225 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1313.765137,2225.438232 
	C1311.131714,2230.934570 1306.731689,2233.992920 1303.107178,2237.746826 
	C1301.715942,2239.187744 1299.959839,2240.303955 1297.853638,2239.209229 
	C1295.710449,2238.095459 1296.110840,2235.909668 1296.034790,2234.000732 
	C1295.895996,2230.518799 1296.425049,2227.282227 1300.429688,2226.229492 
	C1303.179932,2225.506104 1304.663330,2223.625244 1306.394043,2221.536865 
	C1310.247314,2216.887207 1311.334229,2217.433838 1313.765137,2225.438232 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1537.273438,2204.810547 
	C1538.656860,2206.312256 1539.551025,2207.309570 1540.146729,2208.461182 
	C1541.514526,2211.104980 1543.278809,2214.187744 1540.682983,2216.643311 
	C1538.084229,2219.101318 1534.422363,2218.383301 1531.299805,2217.291748 
	C1527.111694,2215.827393 1523.597656,2210.435303 1524.497314,2207.487061 
	C1525.864258,2203.008301 1529.998779,2201.949707 1537.273438,2204.810547 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1548.113037,2189.369629 
	C1542.912109,2187.830566 1539.739014,2185.194580 1541.145630,2179.974365 
	C1541.950073,2176.989258 1542.063721,2172.863037 1546.330811,2172.480957 
	C1550.140503,2172.139893 1553.673950,2173.834473 1555.235962,2177.384766 
	C1556.726807,2180.772949 1556.759277,2184.561035 1553.224121,2187.148682 
	C1551.922607,2188.101562 1550.309082,2188.628418 1548.113037,2189.369629 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1434.125244,2307.923828 
	C1434.284912,2301.363770 1436.708862,2297.101074 1442.308228,2294.913086 
	C1444.784058,2293.945312 1446.710327,2294.177490 1448.191650,2296.629150 
	C1450.162964,2299.891846 1448.630493,2307.189697 1444.831665,2309.885498 
	C1441.174927,2312.480469 1437.152710,2314.276123 1434.125244,2307.923828 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1594.218018,2221.106201 
	C1594.060181,2218.983398 1593.930054,2217.662109 1594.026978,2216.357666 
	C1594.495361,2210.055176 1596.196289,2207.873291 1600.114746,2208.417236 
	C1605.223633,2209.126709 1608.415771,2213.048828 1607.923340,2218.010986 
	C1607.461304,2222.666504 1603.848267,2226.025635 1599.476074,2225.821045 
	C1596.889282,2225.700439 1595.243896,2224.287354 1594.218018,2221.106201 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1322.781250,2236.982422 
	C1325.830933,2232.040771 1329.947266,2231.624268 1334.390869,2232.143799 
	C1337.548706,2232.512939 1338.645630,2234.982910 1339.444702,2237.499756 
	C1340.329956,2240.287842 1338.451782,2241.707031 1336.278198,2242.809814 
	C1334.817261,2243.551270 1333.396240,2244.413330 1331.865723,2244.968750 
	C1325.438965,2247.300781 1323.284546,2245.607666 1322.781250,2236.982422 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1469.948242,2310.141113 
	C1474.833008,2310.808105 1476.523315,2313.487061 1475.683960,2317.258545 
	C1474.524658,2322.468994 1470.326904,2324.276611 1465.715942,2325.427490 
	C1460.406006,2314.143311 1460.406006,2314.143311 1469.948242,2310.141113 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1607.762085,2284.631348 
	C1607.867554,2287.978760 1607.069458,2290.233643 1603.976807,2289.480225 
	C1601.491455,2288.874756 1599.170654,2287.495361 1596.859375,2286.299805 
	C1593.881836,2284.759766 1593.482910,2282.416504 1595.472900,2279.854004 
	C1597.328003,2277.464844 1599.428223,2275.086670 1602.724609,2277.903076 
	C1604.710205,2279.599365 1606.688965,2281.342285 1607.762085,2284.631348 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1591.559326,2164.070801 
	C1596.521606,2165.772705 1599.400024,2168.337402 1595.705322,2172.677490 
	C1593.944946,2174.745117 1591.029053,2176.346924 1587.785889,2174.792236 
	C1585.592896,2173.740967 1583.960327,2172.329346 1584.177490,2169.598633 
	C1584.503784,2165.498291 1587.073364,2164.093994 1591.559326,2164.070801 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1499.295410,2193.245117 
	C1502.420288,2191.776855 1505.043945,2191.785156 1507.612183,2192.333252 
	C1510.091919,2192.862793 1511.708252,2194.520020 1511.613892,2197.152344 
	C1511.519653,2199.774902 1509.775024,2201.131104 1507.309570,2201.763428 
	C1500.835205,2203.423828 1498.504883,2201.291016 1499.295410,2193.245117 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1577.528320,2192.454102 
	C1579.651855,2193.836914 1579.928223,2195.401123 1579.936279,2197.062744 
	C1579.951782,2200.248291 1579.140991,2203.153809 1575.522339,2203.573975 
	C1571.347046,2204.058594 1569.960815,2200.619141 1569.038330,2197.542480 
	C1567.851440,2193.583496 1570.670654,2192.468018 1573.881104,2192.100342 
	C1574.836426,2191.990967 1575.823730,2192.161377 1577.528320,2192.454102 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1522.359863,2237.577148 
	C1521.635132,2243.201904 1519.276367,2244.964600 1515.611694,2243.518555 
	C1512.630249,2242.342285 1509.828613,2237.223145 1511.018311,2234.791016 
	C1512.187622,2232.400635 1514.422729,2231.509277 1516.713257,2232.705811 
	C1518.665405,2233.725342 1520.200928,2235.542725 1522.359863,2237.577148 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1561.169189,2221.556641 
	C1565.091309,2219.853760 1566.989502,2221.388916 1567.656860,2224.396973 
	C1568.218628,2226.928711 1568.502808,2229.584473 1566.099121,2231.677734 
	C1563.003662,2234.373779 1559.271362,2233.665283 1558.387207,2229.856201 
	C1557.722900,2226.993896 1557.312622,2223.888428 1561.169189,2221.556641 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1259.116943,2230.821045 
	C1260.521851,2231.810059 1261.359985,2232.390869 1261.977783,2233.151123 
	C1263.513672,2235.040283 1264.959229,2237.430908 1262.301636,2239.092773 
	C1259.117798,2241.083984 1256.614624,2239.362793 1255.213135,2236.182617 
	C1253.784302,2232.940186 1253.402100,2230.128418 1259.116943,2230.821045 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M787.249512,2172.401367 
	C790.995911,2180.113770 797.509155,2182.517578 804.447632,2183.871582 
	C807.764832,2184.519043 811.796509,2184.481934 813.050659,2187.748291 
	C814.661987,2191.945312 815.079102,2196.670654 815.514954,2201.215820 
	C815.695374,2203.096924 813.602783,2204.087402 811.910034,2203.466309 
	C807.661438,2201.907959 802.994690,2202.000488 799.186035,2198.502197 
	C794.533020,2194.228027 788.777222,2191.909912 782.009338,2191.851562 
	C774.354797,2191.785400 773.171204,2189.498779 776.076782,2182.886475 
	C778.656982,2177.014648 778.657104,2177.014648 775.218445,2169.253174 
	C783.215576,2164.766846 783.215576,2164.766846 787.249512,2172.401367 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M948.625183,2161.944092 
	C951.249146,2167.482178 948.904175,2170.114746 944.411438,2171.500732 
	C934.758484,2174.477539 927.003906,2168.084473 928.407654,2158.210205 
	C928.970947,2154.247559 931.566833,2151.683838 935.359192,2150.536865 
	C938.869324,2149.475586 940.966309,2151.789307 942.861450,2154.171143 
	C944.712158,2156.496826 946.416443,2158.938721 948.625183,2161.944092 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M915.406616,2153.536133 
	C913.159058,2155.048828 911.567261,2156.374268 909.737183,2156.981934 
	C905.170410,2158.498535 902.704529,2157.063965 902.192200,2152.297363 
	C901.771362,2148.381592 902.056458,2144.385742 902.102417,2140.426270 
	C902.134705,2137.641846 903.652588,2136.204102 906.415771,2136.111816 
	C912.635315,2135.904053 915.046082,2141.609131 918.774292,2144.818604 
	C921.945984,2147.549316 918.178650,2150.639893 915.406616,2153.536133 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M766.709229,2072.957520 
	C769.854919,2072.932617 769.627747,2074.419189 768.516479,2075.992188 
	C767.708435,2077.135742 766.326233,2077.882568 765.227844,2076.553711 
	C764.210938,2075.323242 765.186951,2074.146729 766.709229,2072.957520 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1920.207642,1965.153076 
	C1919.276978,1958.436768 1921.243652,1954.087646 1926.952271,1951.542847 
	C1932.515991,1949.062622 1937.110596,1949.565552 1939.373047,1953.250000 
	C1943.013184,1959.177612 1942.563843,1962.832153 1937.643921,1967.311890 
	C1930.886841,1973.464722 1927.276489,1973.177856 1920.207642,1965.153076 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2010.785645,1993.313843 
	C2006.466431,1994.259644 2003.391846,1993.697998 2002.330933,1989.548096 
	C2001.605713,1986.711792 2002.638184,1984.345337 2004.747070,1982.401001 
	C2007.154663,1980.181274 2009.961548,1979.016235 2012.785034,1981.139160 
	C2014.951904,1982.768433 2016.182251,1985.248657 2014.832275,1988.165039 
	C2013.997681,1989.968018 2013.204102,1991.815063 2010.785645,1993.313843 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1040.268555,743.312134 
	C1040.467896,747.535583 1038.862549,750.272644 1036.312012,753.381714 
	C1028.746216,757.529602 1023.669067,762.733215 1022.670593,771.150024 
	C1022.556152,772.114807 1021.943665,773.003235 1021.459290,773.877869 
	C1016.856384,782.189148 1006.909119,786.533752 1000.629028,782.980896 
	C993.478760,778.935791 992.464050,768.689941 998.351685,759.985352 
	C1010.989929,741.300232 1010.434448,740.069214 987.713989,737.369263 
	C983.980042,734.465515 981.722046,731.331360 980.043701,727.678711 
	C977.835327,722.872437 973.933716,723.576660 969.971741,724.944336 
	C967.539001,725.783997 965.775330,727.373596 966.790222,730.091309 
	C968.279236,734.078552 971.051880,736.684448 975.700378,736.360107 
	C978.899536,736.136902 981.873962,733.815552 985.781372,735.814148 
	C996.909912,746.940674 997.102295,755.452026 985.696472,764.618713 
	C979.385864,769.690430 975.901245,774.682434 977.583557,783.089722 
	C978.714600,788.741821 974.595398,792.351624 970.039307,794.806030 
	C964.736206,797.662842 961.270264,801.582581 960.151611,807.650085 
	C959.201782,812.802002 955.484619,816.178772 951.917114,819.740845 
	C945.244507,826.403442 945.642700,830.020813 953.559692,837.411865 
	C953.310486,842.969299 950.495361,845.663574 944.729370,845.991394 
	C943.308594,846.687988 942.587280,847.397278 941.676575,847.715820 
	C930.476624,851.632507 930.473206,851.622742 934.285278,863.375244 
	C932.265686,868.204590 927.210693,869.959717 926.070435,875.327271 
	C919.992004,879.040405 913.207336,881.561279 916.106689,891.316772 
	C916.417480,896.620178 915.585815,900.716003 910.629272,903.675659 
	C907.384155,906.225708 904.506104,906.663025 900.679565,904.633545 
	C893.990417,902.012634 890.681213,897.126099 886.687622,892.119385 
	C880.713318,891.359314 875.832336,889.153992 870.648621,888.012451 
	C864.069885,886.563660 860.897156,881.437073 859.956604,875.053101 
	C859.201050,869.924805 861.229248,865.905457 865.917603,863.527405 
	C871.912537,860.486633 877.453125,861.362061 882.505005,865.771362 
	C885.250610,868.167664 887.688660,870.953735 890.927795,872.738647 
	C893.338074,874.066833 895.875244,874.891174 898.414062,873.092712 
	C900.964661,871.285828 901.004456,868.572083 900.516846,865.897217 
	C899.946716,862.770020 898.356812,859.396301 894.918335,860.040344 
	C884.632507,861.966797 877.766907,857.591858 872.131653,849.616516 
	C870.332336,847.069885 867.358948,845.907532 864.141907,847.239258 
	C860.220764,848.862305 858.921326,852.349731 858.977112,856.151794 
	C859.114258,865.486206 854.706970,871.182739 845.818542,873.550842 
	C841.174561,874.788086 836.151672,874.073975 834.794434,869.432861 
	C831.511597,858.207031 823.831604,856.676514 813.356323,858.053101 
	C807.270325,856.950989 804.262085,852.994019 800.956726,848.390747 
	C799.622681,845.545593 799.233887,842.821106 795.599976,841.933777 
	C789.386597,838.492371 785.672913,833.215576 780.578674,828.442993 
	C774.615356,820.114929 766.822998,814.405396 760.608887,806.427246 
	C762.536072,796.255188 768.087646,787.423035 766.406921,777.070251 
	C766.335754,776.632263 766.641724,776.223389 766.749756,776.159729 
	C778.820496,769.055908 780.785767,755.928650 786.122253,743.979858 
	C793.299866,739.651672 797.389099,734.790222 793.250366,726.059937 
	C790.963440,722.257812 788.295166,724.094971 785.877686,724.583862 
	C781.693481,725.430115 777.260620,727.230286 774.302368,722.432251 
	C771.583618,718.022888 770.687317,713.163452 772.835205,708.242554 
	C774.261292,704.975403 777.141785,702.340271 777.332764,697.792114 
	C785.346802,688.793091 795.015747,682.814819 804.555298,675.736206 
	C809.154541,674.341125 811.208191,677.208069 813.499817,679.466553 
	C816.041443,681.971313 818.843079,683.533997 822.186340,681.218689 
	C825.562866,678.880249 824.917419,675.651306 823.539551,672.439697 
	C822.517517,670.057251 821.011780,667.817444 821.617798,664.394958 
	C822.831299,661.735474 824.663940,660.724243 827.154785,659.644348 
	C836.455017,658.876587 843.995117,656.435486 847.593140,646.603699 
	C848.841614,645.343140 849.665833,644.631592 851.055420,643.884583 
	C854.358582,642.685303 856.933960,641.261414 859.611572,638.807190 
	C861.010864,636.741455 862.653320,636.080872 864.928833,635.272949 
	C869.724548,636.060913 871.106201,639.488403 872.459229,642.851746 
	C873.841614,646.287720 875.771423,648.565613 879.897644,647.210083 
	C883.638306,645.981140 886.307007,643.903076 886.142822,639.491333 
	C885.938477,634.000793 883.951843,628.402954 887.543457,622.595703 
	C888.002563,622.088440 888.358887,621.584045 888.663940,621.632324 
	C894.304199,618.881165 899.811890,616.405579 905.461304,612.742432 
	C911.667908,607.934509 918.267700,605.280029 925.325928,602.127136 
	C932.556702,606.251038 930.022766,610.931824 926.679626,615.500305 
	C924.683411,618.228333 921.494507,619.652649 919.001892,621.845276 
	C915.382080,625.029663 914.982849,629.634827 917.930908,632.524109 
	C921.723755,636.241455 925.136536,632.320068 927.897949,629.543091 
	C929.600098,627.831360 930.139160,625.384216 929.984314,623.028137 
	C929.494873,615.581726 933.434937,611.103149 939.752808,608.337585 
	C944.496765,606.260864 947.457947,603.441467 946.655212,597.704224 
	C946.030823,593.241028 949.361206,591.271240 953.396118,589.286743 
	C955.126099,588.399597 956.241211,587.829346 957.988037,587.368774 
	C963.637817,586.846558 969.208008,578.721436 973.465271,588.468079 
	C976.797485,596.096924 973.674683,603.579895 966.069702,607.728699 
	C963.024841,609.389832 956.864319,608.660706 958.444885,614.693054 
	C959.537781,618.863953 963.370178,620.858948 967.820374,620.747253 
	C973.445068,620.606140 974.961853,616.803284 975.350891,612.029785 
	C975.687012,607.905396 977.146545,604.279114 980.282837,601.425232 
	C985.973938,596.246582 993.571045,596.708252 997.731018,602.515869 
	C1002.215149,608.776001 1001.463684,618.169739 995.033447,620.720886 
	C986.399658,624.146118 983.063232,628.423340 986.014038,637.849487 
	C987.713074,643.276978 983.303528,646.945801 978.741089,649.692444 
	C975.408997,651.698669 971.078918,653.332336 972.415222,658.569275 
	C973.568787,663.090515 977.352112,664.533997 981.447876,665.329529 
	C985.084900,666.035950 988.832581,666.874634 991.497192,669.465759 
	C998.391846,676.170288 1005.166809,682.014160 1015.526672,683.811218 
	C1021.839294,684.906128 1025.073853,691.928345 1023.931152,699.038818 
	C1022.977905,704.970642 1018.740662,708.400940 1013.100586,709.393738 
	C1005.884583,710.664001 1001.790588,706.460022 999.881958,700.036377 
	C998.419312,695.113892 995.613159,692.251465 990.454956,693.605469 
	C980.543579,696.207153 973.810974,692.874146 968.953003,684.009949 
	C966.615540,679.744812 962.433044,678.260986 957.830994,681.011475 
	C953.853699,683.388550 954.397888,687.037903 955.651123,690.734802 
	C957.056213,694.879700 960.167603,695.193237 963.728516,694.260620 
	C972.101135,692.067749 977.939636,694.947449 981.697205,702.715088 
	C983.740967,706.939941 987.686096,708.774719 992.092285,709.738831 
	C999.667175,711.396179 1005.572998,715.325806 1009.101196,722.406433 
	C1010.891907,726.000122 1013.212769,727.870789 1017.742004,727.405762 
	C1032.873779,725.852234 1035.313965,727.655212 1040.268555,743.312134 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1495.462402,552.903931 
	C1501.945190,557.634766 1505.377075,562.839355 1504.162842,570.685547 
	C1503.451416,575.282166 1506.337036,576.530334 1510.480591,574.794067 
	C1510.787842,574.665344 1511.093994,574.524353 1511.413574,574.435425 
	C1524.605103,570.763916 1524.605225,570.764709 1527.944824,583.617493 
	C1530.239868,592.450256 1530.437744,592.550415 1539.324341,589.385193 
	C1545.267456,587.268372 1548.517334,588.226746 1551.211060,592.889771 
	C1554.838623,599.169678 1554.851318,606.164734 1551.241455,609.632141 
	C1546.924072,613.779175 1540.418701,614.173584 1535.837769,610.625793 
	C1533.078979,608.489258 1531.720825,605.473389 1530.359497,602.412170 
	C1527.361084,595.668823 1526.845337,595.427063 1520.032837,596.987183 
	C1518.092041,597.431519 1516.081421,597.677246 1514.227173,598.354614 
	C1513.063599,598.779663 1511.456421,599.668457 1511.210327,600.642883 
	C1510.020386,605.352844 1513.771606,608.555908 1515.314819,612.448303 
	C1516.340454,615.035095 1518.147217,615.759888 1520.912109,614.703064 
	C1523.057495,613.882935 1525.474854,613.802612 1527.682617,613.110596 
	C1531.545166,611.899902 1534.111328,613.616821 1536.129517,616.586487 
	C1537.059448,617.954895 1537.631104,619.561279 1538.488403,620.985718 
	C1540.527710,624.373901 1541.173218,628.818237 1544.771973,630.997009 
	C1548.563354,633.292542 1552.497070,631.388550 1556.341309,630.327576 
	C1558.723877,629.669922 1560.919434,630.362549 1562.844482,631.983093 
	C1566.483521,635.046448 1569.150391,644.679565 1567.383545,648.585876 
	C1566.041748,651.552063 1556.473145,656.227844 1552.599365,655.640442 
	C1548.868286,655.074768 1547.357422,651.980530 1545.511108,649.176880 
	C1539.265381,639.692993 1539.214478,639.726501 1527.719849,641.949951 
	C1519.915894,643.459595 1519.104614,644.791992 1521.832031,651.619873 
	C1525.446533,660.668518 1526.301025,661.265808 1535.794922,658.992920 
	C1540.221191,657.933228 1544.606934,656.924744 1547.708252,661.013245 
	C1551.026001,665.387329 1551.766357,671.082214 1550.553833,676.018311 
	C1549.427612,680.602234 1544.770996,682.991455 1539.941040,683.944946 
	C1531.651978,685.581360 1531.664551,685.575134 1533.595581,693.728943 
	C1533.978271,695.344727 1534.033447,697.055115 1534.551392,698.618652 
	C1536.921021,705.771301 1539.461304,706.788818 1546.393677,703.864990 
	C1549.324341,702.628906 1552.164429,699.112061 1555.462402,701.293335 
	C1559.149780,703.731995 1560.359863,708.289307 1561.671509,712.384094 
	C1562.556152,715.145508 1561.456055,717.647583 1559.299316,719.570496 
	C1556.004883,722.507568 1552.066895,724.461060 1547.912964,725.588745 
	C1542.744873,726.991760 1540.097412,723.450989 1537.736938,719.491577 
	C1533.512451,712.405762 1528.672119,710.383118 1521.467041,712.159546 
	C1519.074707,712.749451 1518.158691,714.102905 1518.518677,716.440491 
	C1519.787476,724.677673 1525.484253,729.754944 1533.715210,730.000671 
	C1542.711182,730.269226 1546.881348,735.108032 1545.995361,743.809753 
	C1545.469971,748.969666 1542.026245,751.648743 1537.866333,752.916870 
	C1530.686890,755.105347 1526.850220,759.532104 1526.145020,766.881470 
	C1525.847778,769.980164 1525.306885,773.031921 1521.514526,773.612366 
	C1518.799072,774.027954 1517.283691,772.220703 1516.075195,770.063293 
	C1514.359253,766.999634 1513.167969,763.993408 1516.126099,760.952087 
	C1519.126587,757.867371 1522.314697,755.083374 1522.070801,749.987061 
	C1521.708862,742.431396 1516.436157,738.267151 1509.346924,740.558716 
	C1505.307617,741.864380 1503.551025,744.243286 1504.480713,748.862549 
	C1506.210083,757.456421 1504.927979,759.888306 1497.678223,764.105957 
	C1495.953857,765.109131 1494.195679,766.301880 1492.301514,766.719299 
	C1486.706665,767.952393 1484.388306,771.115601 1483.179443,776.869507 
	C1481.136108,786.596008 1479.509033,786.987915 1468.232788,784.079468 
	C1464.186768,782.806580 1462.696045,780.376709 1462.677002,776.269104 
	C1464.184570,770.654297 1468.493164,768.407166 1471.944946,765.352356 
	C1474.861816,762.770935 1474.681885,759.483521 1473.470215,756.166077 
	C1472.401245,753.239563 1470.178955,753.751709 1467.698608,754.069702 
	C1458.516846,755.246338 1450.889404,750.812012 1448.475952,742.828369 
	C1446.659668,736.820007 1448.122681,731.576172 1453.487061,727.934937 
	C1459.804810,723.646667 1470.915161,724.850342 1476.636230,730.265869 
	C1478.574585,732.100769 1479.852539,734.521790 1481.864624,736.277710 
	C1484.968506,738.986389 1488.099976,738.024963 1490.949097,735.913452 
	C1494.555420,733.240662 1493.795776,729.470215 1492.881226,725.876099 
	C1491.836426,721.770569 1488.783447,722.121338 1485.725464,723.089722 
	C1475.981323,726.175293 1468.907227,722.866394 1463.789551,714.310669 
	C1462.542969,712.226562 1461.970825,708.667969 1458.355835,709.656067 
	C1455.174805,710.525391 1453.844727,713.383911 1453.152710,716.431702 
	C1452.710083,718.381653 1452.728882,720.395874 1452.493774,722.375793 
	C1451.697998,729.074097 1448.686523,733.655945 1440.557129,733.941284 
	C1433.167480,731.216919 1428.612183,726.514954 1425.878540,719.141113 
	C1425.272217,713.662842 1427.685059,710.396729 1431.082397,707.478027 
	C1434.667358,704.398132 1436.939331,700.286499 1432.695312,696.677124 
	C1428.627075,693.217285 1425.469360,696.644287 1423.282959,700.192505 
	C1421.308105,703.397095 1419.176147,706.134399 1414.214111,705.935303 
	C1410.365479,705.107178 1407.877686,703.520569 1406.174072,699.870117 
	C1404.912964,694.787659 1406.452637,690.774414 1407.566284,686.627808 
	C1409.719604,678.610413 1408.207520,677.215698 1399.872681,679.186829 
	C1396.035156,680.094360 1392.294556,681.460144 1387.576172,681.298340 
	C1386.450806,680.935974 1386.027954,680.710022 1385.152832,679.922607 
	C1383.748657,677.575562 1383.384277,675.614990 1383.323364,673.646973 
	C1383.082397,665.871094 1379.140259,662.257446 1371.383057,662.724121 
	C1364.791382,663.120667 1360.403198,660.356689 1357.074463,654.427490 
	C1350.431641,642.594849 1346.395752,642.581299 1337.956787,653.511597 
	C1337.147949,654.559265 1336.272461,655.529602 1334.594238,656.734192 
	C1330.769287,658.059692 1327.886230,657.123474 1324.457031,655.332764 
	C1320.618286,650.653992 1321.999268,646.749817 1325.025879,643.225403 
	C1328.080200,639.668884 1329.563354,635.974243 1327.539673,631.403931 
	C1325.401611,626.575195 1321.332153,627.359131 1317.326294,627.751587 
	C1309.746216,628.494385 1305.004395,624.022949 1300.729370,618.658997 
	C1298.910400,616.376587 1297.247437,613.349121 1293.523071,615.323608 
	C1291.255615,616.525635 1290.395996,618.721375 1290.639771,621.208618 
	C1290.980835,624.685730 1293.241333,626.375244 1296.483765,627.013672 
	C1299.720581,627.651062 1303.112427,627.867310 1305.815308,630.079041 
	C1310.199097,633.666138 1312.642090,638.223999 1311.941772,643.975525 
	C1311.075928,651.086853 1304.626709,647.851929 1300.199707,649.865112 
	C1297.073120,650.519165 1294.645630,650.557251 1291.529785,649.822388 
	C1285.545898,647.994995 1281.598511,638.753723 1273.976074,647.096313 
	C1271.462646,648.179932 1269.547974,648.208374 1266.947144,647.414795 
	C1261.850586,642.873108 1260.121704,636.929321 1256.842407,631.948853 
	C1254.885498,628.976624 1252.557739,626.667664 1248.654907,627.742004 
	C1244.603149,628.857300 1244.112671,632.139771 1244.275513,635.686218 
	C1244.458374,639.666138 1245.059448,643.682861 1242.809937,648.051025 
	C1240.791016,649.835571 1238.935059,650.112061 1236.312622,650.083923 
	C1232.960938,649.369812 1230.385132,649.276367 1227.440674,651.396057 
	C1224.888794,652.198364 1222.993896,652.177246 1220.448242,651.263672 
	C1210.396240,638.312988 1211.363525,631.809692 1224.425049,624.925232 
	C1229.898071,622.040527 1232.686523,619.038452 1230.543091,612.533386 
	C1228.220459,605.484375 1230.726562,600.241760 1237.855835,597.508057 
	C1240.345581,596.553406 1242.643921,595.254639 1244.574341,593.392090 
	C1247.750732,590.327576 1247.172119,586.988708 1245.432373,583.418701 
	C1243.692261,579.847900 1240.953735,580.105591 1237.899780,581.046692 
	C1235.682861,581.729919 1233.449951,582.329712 1230.373535,582.269409 
	C1221.799805,577.595032 1219.299072,570.101440 1223.344116,563.340088 
	C1227.122925,557.023743 1236.783081,555.448975 1243.694702,560.022583 
	C1255.101562,567.570862 1255.697876,567.352417 1259.721924,554.151733 
	C1261.652222,547.819519 1270.355225,542.219299 1277.752319,542.549561 
	C1284.121582,542.833923 1290.362671,549.231995 1291.484741,556.415588 
	C1292.280762,561.512207 1289.661499,564.568604 1285.687256,566.984375 
	C1282.848511,568.710022 1279.572632,569.670654 1277.010254,571.863281 
	C1273.943237,574.487671 1274.385864,577.758301 1275.620605,581.010986 
	C1277.015869,584.686218 1279.891602,585.996765 1283.618042,585.220947 
	C1287.129761,584.489746 1289.776978,582.691772 1290.068359,578.692871 
	C1290.189941,577.025208 1289.924316,575.374451 1289.761108,573.720398 
	C1289.244141,568.476318 1289.661865,563.478577 1295.212402,561.003601 
	C1301.429443,558.231506 1307.776611,556.269897 1313.974243,561.326477 
	C1317.036133,563.824707 1319.557495,567.184387 1323.682129,568.094360 
	C1326.037109,568.613892 1328.628296,568.656067 1329.430054,565.748047 
	C1330.203369,562.943420 1328.290039,560.687988 1325.837891,560.932556 
	C1313.088867,562.204163 1307.362183,554.274658 1302.744019,544.346985 
	C1300.900513,540.383606 1296.938354,540.458923 1293.195801,540.503235 
	C1288.672974,540.556702 1284.591431,539.487122 1281.817261,535.538086 
	C1277.400146,529.250244 1280.273682,522.599670 1287.785645,522.092102 
	C1293.769409,521.687744 1300.009521,521.323303 1305.141724,525.071411 
	C1310.158569,528.735229 1315.042603,528.216919 1320.183350,525.998840 
	C1323.612915,524.519043 1327.139893,523.868103 1330.871216,524.056763 
	C1336.151001,524.323669 1337.719849,526.615234 1336.317993,531.906006 
	C1333.176025,543.763855 1334.593628,545.837830 1346.795166,547.199280 
	C1352.896729,547.880127 1357.765259,550.025879 1360.528564,555.624634 
	C1362.711304,560.047241 1365.507690,562.655396 1370.740234,560.741394 
	C1372.993652,559.917114 1375.392090,559.050659 1374.969727,556.059265 
	C1374.235107,550.856812 1371.239258,547.498291 1365.899536,546.992432 
	C1359.519287,546.387939 1354.442261,544.059387 1351.217651,538.197449 
	C1346.642578,529.880920 1348.437012,526.772278 1359.125732,526.260376 
	C1360.801758,526.323792 1361.751099,526.283020 1363.355957,526.543945 
	C1375.123169,528.098938 1383.655029,537.368225 1395.499512,536.798218 
	C1398.266235,536.665039 1400.384033,539.966675 1402.462769,542.158325 
	C1410.766724,550.913208 1413.304565,550.726929 1419.560181,540.864197 
	C1420.830566,538.861389 1421.887085,536.796875 1425.186523,536.276855 
	C1426.842407,536.292175 1427.788086,536.315674 1429.368652,536.675049 
	C1431.461792,537.768677 1433.053345,537.993042 1435.250122,538.280273 
	C1436.804565,538.403687 1437.764648,538.420410 1439.366943,538.782166 
	C1456.848267,543.468018 1473.198853,549.711121 1491.218750,552.171509 
	C1492.882446,552.314880 1493.864990,552.394409 1495.462402,552.903931 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1359.184814,525.928955 
	C1357.596191,529.385620 1353.183716,526.560852 1350.679443,529.947144 
	C1353.116089,538.877441 1357.139526,545.467041 1368.427856,544.182922 
	C1372.944214,543.669189 1380.730225,555.368530 1379.497314,559.597107 
	C1379.057007,561.107178 1377.902710,561.656128 1376.630127,562.027161 
	C1373.133667,563.046448 1369.554077,563.812500 1366.118652,565.000793 
	C1362.435547,566.274719 1361.040649,565.251892 1359.810181,561.411682 
	C1356.416626,550.820923 1355.284058,550.284607 1344.233276,549.999329 
	C1335.434082,549.772217 1332.197510,546.845886 1330.456665,538.892944 
	C1329.361938,533.891052 1334.291870,532.221008 1335.330078,527.911621 
	C1331.645386,524.692566 1327.427124,525.155579 1323.818726,527.633545 
	C1320.583984,529.854858 1316.870605,529.724487 1313.543335,531.145935 
	C1310.005005,532.657471 1307.514893,531.558899 1304.958008,528.512390 
	C1301.432251,524.311829 1289.589233,522.373230 1284.680908,524.389587 
	C1282.393311,525.329285 1282.097412,527.208191 1282.093384,529.248901 
	C1282.081421,535.274902 1286.479004,538.489624 1293.926270,537.947510 
	C1302.567627,537.318604 1302.568848,537.317993 1306.330811,544.719604 
	C1307.084351,546.202148 1307.804321,547.702148 1308.575195,549.175476 
	C1313.066162,557.758301 1315.052124,559.054077 1324.275757,557.461243 
	C1327.551514,556.895508 1330.081787,556.313049 1331.833496,559.749939 
	C1333.363892,562.752563 1334.954468,565.782776 1333.041016,569.159058 
	C1331.242676,572.332275 1328.040405,571.835022 1325.067627,571.999023 
	C1319.954956,572.281189 1317.520874,568.329895 1314.449951,565.423401 
	C1308.938477,560.207214 1301.271118,559.524719 1294.918213,563.680481 
	C1290.544556,566.541504 1291.881836,570.722717 1292.583984,574.484924 
	C1293.128418,577.402405 1294.631714,580.141052 1293.152100,583.154297 
	C1290.479736,588.596497 1284.869995,588.525574 1280.229614,589.120178 
	C1275.681641,589.702881 1273.473999,585.769348 1272.236572,581.662231 
	C1269.406250,572.268555 1269.850464,571.258423 1278.765869,567.494019 
	C1279.378540,567.235352 1279.975464,566.940125 1280.583130,566.669617 
	C1291.229248,561.929688 1292.423584,557.516724 1285.148071,548.743469 
	C1282.489258,545.537231 1279.259155,543.723572 1274.650269,545.441101 
	C1270.895142,546.840454 1266.986816,547.924133 1263.901001,550.499634 
	C1260.578125,553.273010 1262.187866,557.355652 1262.038086,560.857483 
	C1261.809937,566.193298 1257.827515,566.807922 1254.092041,568.307190 
	C1250.455811,569.766602 1247.710693,569.453674 1245.422729,566.192932 
	C1243.555908,563.532410 1242.263306,560.476440 1238.222290,559.990417 
	C1232.114624,559.255920 1226.537231,560.608521 1225.082520,564.663086 
	C1223.107178,570.168762 1222.875610,575.750610 1229.270996,579.864380 
	C1232.078735,582.903198 1230.435425,584.817383 1227.575439,586.898071 
	C1213.463135,587.376953 1210.932251,588.935669 1211.027222,597.112427 
	C1211.057251,599.696716 1211.878296,602.217651 1211.745117,605.543152 
	C1211.299683,607.725586 1210.557373,608.976746 1208.980835,610.548340 
	C1202.120605,614.152466 1192.514648,611.518921 1189.947266,622.232422 
	C1185.212402,638.450012 1181.734985,641.797791 1169.387207,641.601685 
	C1165.818970,639.477234 1165.739868,636.357483 1165.160522,633.495972 
	C1164.385376,629.667236 1162.866577,626.467041 1158.419189,626.208801 
	C1153.864380,625.944397 1150.220703,628.283020 1149.698975,632.580505 
	C1148.575806,641.830811 1143.199341,648.145142 1136.849487,654.060364 
	C1131.371338,659.163574 1133.729736,664.874939 1135.675659,671.276978 
	C1135.801636,674.153381 1135.130859,675.994263 1132.713623,677.690552 
	C1128.670410,677.996338 1125.327393,677.805481 1122.014771,678.041321 
	C1117.788208,678.342224 1115.053223,676.434265 1112.576660,672.452637 
	C1107.385132,665.499939 1109.440308,659.730164 1114.862671,655.360962 
	C1119.948120,651.263367 1122.833740,647.161194 1121.913818,640.167969 
	C1120.917725,632.595398 1127.029541,629.248108 1132.544067,625.943298 
	C1136.148193,623.783508 1141.030029,622.412964 1138.161987,616.364624 
	C1135.751587,611.280945 1132.226318,607.931030 1126.362305,610.053772 
	C1118.326294,612.962891 1113.770874,610.287842 1111.185303,602.429138 
	C1109.986450,598.785522 1107.080811,596.233521 1102.963135,596.109558 
	C1099.032715,595.991211 1095.392456,597.348206 1094.320923,601.450073 
	C1093.245239,605.568726 1095.651489,608.461975 1099.354370,610.139526 
	C1101.830200,611.261230 1104.558838,611.210938 1107.213745,611.338440 
	C1113.126465,611.622375 1117.457153,614.137512 1119.312744,619.980042 
	C1121.113525,625.648987 1119.849121,631.348206 1115.280396,634.463806 
	C1107.471924,639.788696 1103.262085,645.442139 1107.372559,655.096313 
	C1108.463501,657.658569 1107.127563,661.138550 1104.514404,661.904846 
	C1092.791748,665.342163 1090.815674,675.015808 1088.468384,685.454590 
	C1084.712524,689.514221 1081.005127,692.551453 1076.605835,695.746399 
	C1071.741577,696.474182 1071.706665,699.624695 1072.186768,702.620911 
	C1072.542725,704.842163 1073.574463,706.989380 1074.513184,709.075989 
	C1076.447510,713.375244 1074.448853,715.222107 1070.452148,715.908264 
	C1068.515503,716.240723 1066.513184,716.300232 1064.628784,716.809570 
	C1055.006836,719.410339 1053.674438,721.595459 1055.493164,731.380798 
	C1056.850098,738.681152 1055.848389,740.199890 1048.248779,742.265381 
	C1046.037476,742.866394 1043.807739,743.400085 1040.793213,743.982300 
	C1037.945801,740.587158 1035.947632,737.139099 1033.824951,733.769348 
	C1030.224365,728.053101 1028.133057,727.330444 1021.364380,729.265137 
	C1020.084290,729.631042 1018.809326,730.014526 1017.530701,730.385803 
	C1010.600342,732.398315 1010.214172,732.538269 1007.904053,726.189148 
	C1004.818604,717.709229 998.879333,712.915405 990.249268,712.244751 
	C984.317322,711.783752 981.428467,708.734436 978.934937,704.004822 
	C974.105408,694.844238 973.079895,694.530640 963.365662,697.281067 
	C960.833679,697.997986 958.305542,698.728577 955.311035,699.585938 
	C954.041199,695.435730 953.256897,691.534729 951.669678,687.993652 
	C949.179504,682.437866 952.374817,679.989075 956.474609,677.820251 
	C961.775208,675.016296 966.241089,675.267334 969.169800,678.823120 
	C971.060486,681.118652 972.512573,683.779724 974.120605,686.302917 
	C977.860718,692.171448 979.461792,692.894470 986.328003,691.567322 
	C988.599915,691.128174 990.823547,690.243408 993.105042,690.088196 
	C999.233826,689.671021 1000.675720,690.868042 1001.979187,696.741760 
	C1003.752502,704.732727 1007.250122,708.416992 1012.274780,707.586548 
	C1017.687805,706.691956 1022.173218,701.563538 1021.946594,696.528320 
	C1021.661438,690.191895 1015.438904,682.898193 1009.840515,684.449036 
	C1002.392273,686.512390 999.909912,682.672852 996.405457,677.827026 
	C992.255188,672.088318 986.947815,667.844421 978.947144,667.818420 
	C973.158142,667.799622 968.534973,662.362610 968.132141,656.773193 
	C967.952271,654.277771 968.646362,652.139648 970.864197,650.746338 
	C971.989685,650.039246 973.193298,649.456665 974.359985,648.814880 
	C985.390198,642.746887 985.526672,642.698364 981.180786,630.444580 
	C979.618774,626.040344 980.477356,623.406128 984.974548,622.009033 
	C987.832092,621.121460 990.755859,620.337830 993.463257,619.099609 
	C998.583923,616.757751 999.622314,610.787842 996.215088,604.563721 
	C993.548523,599.692444 988.234314,598.399536 983.578186,601.708374 
	C979.871216,604.342590 977.973572,607.782898 977.880920,612.681030 
	C977.696777,622.410278 972.571716,626.002625 963.117615,623.855042 
	C961.416565,623.468567 959.809082,622.895447 958.972839,621.381226 
	C956.916199,617.657349 953.278320,614.784241 952.790649,609.968811 
	C954.528931,606.917297 958.068787,607.770752 960.676025,606.865662 
	C973.037354,602.574585 974.829834,598.723633 969.484985,585.770325 
	C966.121094,584.646667 963.528015,588.235840 959.412598,587.593384 
	C968.117432,580.341064 979.614441,577.763367 991.182617,573.523560 
	C994.936584,576.504517 994.751038,580.797729 996.405334,584.339417 
	C998.196838,588.174927 1000.471313,591.569031 1005.384033,589.624878 
	C1009.958923,587.814453 1013.561646,584.636841 1012.128540,579.116333 
	C1010.920593,574.463440 1007.139771,573.465698 1002.710388,574.366150 
	C999.543091,575.010010 996.373657,576.477234 992.876587,573.947021 
	C1002.710510,567.409485 1013.923340,564.324280 1024.892700,560.697876 
	C1067.835571,546.501221 1111.694458,536.092834 1156.431396,529.417053 
	C1159.706055,528.928406 1163.022583,528.718994 1167.157959,528.585693 
	C1169.891602,530.538574 1169.323120,533.129700 1170.199219,535.217834 
	C1172.166870,539.907776 1175.437500,543.229614 1180.805420,542.137939 
	C1186.012085,541.078979 1187.062378,536.875122 1186.464355,532.113403 
	C1186.255981,530.454346 1186.297241,528.818542 1187.604980,526.813171 
	C1196.995361,523.189453 1206.409668,523.764282 1215.565063,523.076782 
	C1263.267822,519.494629 1310.941162,520.273438 1359.184814,525.928955 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1740.391846,519.504395 
	C1739.559326,515.780640 1735.763428,515.618774 1734.272583,512.547485 
	C1736.237061,507.979309 1736.416016,503.953094 1734.895752,499.524689 
	C1733.468018,495.365601 1731.835938,493.221313 1727.016113,495.236206 
	C1723.606445,496.661591 1719.802612,496.499237 1716.287109,495.011414 
	C1709.210205,492.016144 1707.280273,482.007660 1712.661133,476.354889 
	C1714.497803,474.425262 1716.313232,472.452484 1718.328369,470.720428 
	C1722.353516,467.260620 1724.319214,463.273315 1724.145264,457.683533 
	C1723.906982,450.021271 1729.316895,443.760681 1736.781982,442.278137 
	C1740.743774,441.491302 1744.715210,441.451141 1747.216675,445.870056 
	C1748.673096,448.443054 1751.122314,450.483704 1752.414795,453.113007 
	C1754.317871,456.984863 1757.105835,458.063965 1761.215332,458.080719 
	C1771.533569,458.122803 1772.730957,456.616455 1769.351562,446.617950 
	C1767.521362,441.202545 1768.757935,437.597717 1773.929443,435.211700 
	C1777.825806,433.413940 1781.935059,432.074036 1786.360107,431.815796 
	C1789.385132,431.639221 1790.214600,429.540497 1789.225708,426.821472 
	C1788.091309,423.701965 1786.666260,420.681580 1785.650024,417.527100 
	C1783.555298,411.025696 1784.231934,409.518890 1790.429932,406.899719 
	C1793.177490,405.738617 1796.062500,404.878448 1798.927734,404.025269 
	C1803.428223,402.685181 1804.692139,399.939331 1802.867188,395.653992 
	C1802.478271,394.740509 1802.238281,393.761841 1801.952148,392.806519 
	C1799.622070,385.028168 1801.167969,381.625031 1808.234009,378.960022 
	C1814.827637,376.473267 1819.713135,378.676849 1822.676270,385.473877 
	C1825.281738,391.450439 1823.520142,395.945343 1817.199463,399.392426 
	C1816.323608,399.870087 1815.233521,400.080139 1814.530640,400.727081 
	C1812.046021,403.014130 1805.351807,399.995544 1806.655396,407.072266 
	C1808.446777,416.795898 1812.607666,421.742340 1819.485840,421.988983 
	C1821.149170,422.048645 1822.817627,421.959381 1824.481689,422.007751 
	C1831.856812,422.222198 1834.722290,424.048889 1835.840576,429.204956 
	C1837.342529,436.130402 1835.710205,439.831543 1829.658325,443.166840 
	C1828.784302,443.648499 1827.853516,444.026459 1826.974609,444.499847 
	C1819.542847,448.502716 1819.161133,449.367828 1820.983032,457.953583 
	C1822.778198,466.413025 1822.339233,467.561646 1815.997803,470.995453 
	C1805.171997,476.857574 1799.099365,474.148468 1796.394165,462.247925 
	C1796.320557,461.924072 1796.329590,461.570923 1796.205078,461.270813 
	C1794.876587,458.066528 1798.763306,451.209442 1790.453491,452.878021 
	C1780.192383,454.938385 1775.289062,459.149536 1776.154297,464.966064 
	C1777.248535,472.321381 1782.541992,477.127502 1788.999146,475.121002 
	C1794.438721,473.430664 1797.121460,475.906097 1800.091187,479.202026 
	C1800.313843,479.449188 1800.578735,479.685791 1800.716797,479.977936 
	C1802.931396,484.666260 1808.012939,489.216492 1805.103760,494.535797 
	C1802.419678,499.443542 1797.220703,502.436523 1790.917725,502.080933 
	C1789.685669,502.011444 1788.418335,502.567505 1786.815918,502.910187 
	C1787.042603,507.117310 1790.270630,509.539734 1791.483154,512.854492 
	C1792.953125,516.872803 1796.081665,517.821472 1800.155151,518.091187 
	C1812.556763,518.912109 1816.969849,527.627197 1810.877930,538.658447 
	C1810.561646,539.231384 1810.412720,539.896851 1810.090454,541.258423 
	C1807.155029,542.657654 1804.314819,543.317749 1800.737305,543.988892 
	C1797.659058,545.881897 1798.141724,549.735291 1794.332642,551.307861 
	C1792.607910,551.563354 1791.641968,551.384583 1790.076172,550.583740 
	C1789.426758,550.213562 1788.556763,550.051208 1788.289307,549.698608 
	C1787.311646,548.699463 1786.734619,547.952576 1786.140137,546.403687 
	C1785.866699,544.723022 1785.719238,543.635498 1786.133667,542.759521 
	C1788.477295,537.805420 1791.121582,531.401245 1786.014526,528.323547 
	C1781.056885,525.335938 1776.625366,531.171082 1772.055908,534.960388 
	C1768.108276,536.444763 1765.573486,534.698242 1762.403809,532.589844 
	C1761.796997,532.123352 1761.940552,532.053406 1761.931396,532.132751 
	C1760.978882,531.188354 1759.711670,530.424561 1759.339600,528.264038 
	C1759.917603,525.660339 1761.189575,524.042358 1761.600952,522.091187 
	C1762.167725,519.404053 1762.094971,516.673584 1760.030273,514.692383 
	C1757.592651,512.353210 1755.121094,514.121521 1752.791138,515.271545 
	C1749.827271,516.734558 1747.306885,518.902283 1743.814941,520.657959 
	C1742.358032,520.465393 1741.578735,520.221497 1740.391846,519.504395 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M787.582642,743.373169 
	C785.692932,748.628296 783.314880,753.015686 783.824524,758.685181 
	C784.383728,764.904724 780.597412,768.788391 775.050049,771.647461 
	C768.185669,775.185242 766.443176,778.186768 768.415588,785.187500 
	C770.209778,791.555603 769.267822,795.889038 763.870911,799.677856 
	C762.490417,800.646973 762.146667,803.092896 760.868042,805.331116 
	C759.201233,805.606995 757.976685,805.445984 757.375122,803.687988 
	C755.047913,799.182556 758.004333,796.322021 759.456726,793.179443 
	C761.040894,789.751526 762.009033,786.164490 759.183044,783.082947 
	C756.389832,780.037109 753.138367,781.750000 750.178833,783.189331 
	C747.223022,784.626953 744.370544,786.360779 740.256042,784.567444 
	C739.597717,784.330933 739.535645,784.337830 739.520630,784.373169 
	C740.236206,781.529907 741.713257,778.610779 741.559265,775.780334 
	C741.070862,766.804565 743.027527,760.035950 752.377075,756.069763 
	C757.305542,753.979004 756.604675,748.398315 754.874756,743.714783 
	C753.211792,739.212708 752.906738,733.437805 745.821655,734.005310 
	C742.727173,734.253052 740.013916,732.886902 737.179077,732.032715 
	C731.821228,730.418335 730.508484,726.067688 730.083679,721.256714 
	C729.662842,716.490601 733.246826,715.331604 736.775696,714.023438 
	C742.509766,711.897888 746.317322,708.212158 745.998535,700.773254 
	C750.713074,696.659607 757.486633,695.453552 758.686890,687.449219 
	C759.403625,686.443848 759.759033,686.089600 760.864380,685.670288 
	C764.510010,685.973938 766.162415,688.061584 768.088013,690.730347 
	C770.305664,698.786682 766.491699,703.109985 760.659241,706.946777 
	C749.294434,714.422913 749.591736,720.603394 761.792969,729.010498 
	C763.268433,730.963074 763.328735,732.578613 762.713379,734.183105 
	C760.992188,738.671265 761.270081,742.781616 765.633850,745.495422 
	C770.278687,748.384094 774.450806,746.949829 778.049683,743.211914 
	C778.736145,742.498901 779.516296,741.888550 781.035095,741.114136 
	C783.830750,740.626099 785.595947,741.398132 787.582642,743.373169 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1556.537476,434.405975 
	C1554.798950,425.803650 1558.092407,420.378082 1566.113525,418.282410 
	C1570.407959,417.160400 1572.074951,414.669189 1572.017944,410.412689 
	C1571.957275,405.894897 1571.026855,401.765564 1567.199097,398.996613 
	C1564.634521,397.141510 1562.134277,399.323212 1559.600586,399.720917 
	C1551.905518,400.928864 1548.304688,398.933594 1546.491333,392.549713 
	C1545.006958,387.323883 1546.424561,383.593536 1551.044800,380.566193 
	C1556.356689,377.085724 1559.796143,377.301910 1564.405884,381.434540 
	C1565.146729,382.098755 1566.073364,382.713501 1566.487183,383.559845 
	C1570.281982,391.320709 1576.724243,392.733185 1584.683838,392.178345 
	C1589.995239,391.808075 1593.910400,395.715820 1595.309814,400.881714 
	C1596.489746,405.237274 1594.553101,408.425354 1588.728882,411.647064 
	C1587.567627,412.289398 1586.345215,412.819641 1585.168823,413.435822 
	C1576.940063,417.746185 1576.471802,418.262604 1579.688599,427.378815 
	C1581.552490,432.660950 1581.354736,437.622131 1580.011963,443.607025 
	C1577.266357,444.544586 1574.865234,443.481598 1572.019287,441.860840 
	C1568.402710,437.052856 1575.287720,430.704010 1570.097046,427.872620 
	C1564.130249,424.617889 1564.207764,434.710266 1558.994263,434.943207 
	C1558.349731,434.971954 1557.709717,435.001007 1556.537476,434.405975 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M722.437378,642.266846 
	C721.393127,645.681885 719.613831,648.316956 716.790833,649.430908 
	C711.286743,651.602783 709.122986,655.317505 709.984314,661.064575 
	C710.784790,666.405090 707.989014,670.260376 703.852844,672.714172 
	C698.371887,675.965820 695.934265,680.400330 695.945801,686.612183 
	C695.952759,690.354187 695.337158,694.121277 691.171570,695.584351 
	C688.802490,696.416321 686.446167,695.648193 685.088074,693.385193 
	C682.771973,689.525757 684.987366,686.558777 687.093628,683.410828 
	C690.282959,678.644348 692.767029,673.659912 689.711365,667.698059 
	C687.184204,662.767273 689.489380,659.458557 693.846619,657.121094 
	C696.191467,655.863037 698.620911,654.763184 700.976562,653.524292 
	C707.675171,650.001282 707.594849,649.998596 706.413147,642.160889 
	C706.070679,639.889587 706.085388,637.518494 706.286194,635.223755 
	C706.502747,632.749084 708.515015,632.211975 711.423950,631.975830 
	C716.394104,634.327820 719.138550,638.184937 722.437378,642.266846 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M953.318237,588.937195 
	C951.324402,592.722778 946.653137,595.500061 949.731140,601.614075 
	C951.074524,604.282776 949.696777,607.309875 945.875183,608.347473 
	C943.362732,609.029602 941.034790,610.468506 938.700012,611.710938 
	C934.359314,614.020630 931.736328,616.520691 932.863770,622.619507 
	C934.308228,630.433167 926.315002,637.959961 918.311096,637.795166 
	C917.365051,637.775635 916.048340,637.622803 915.549500,637.007751 
	C912.636292,633.416443 914.501892,628.714661 912.870056,624.658875 
	C911.828186,622.069458 914.650818,620.792786 916.710144,619.684753 
	C919.325195,618.277710 921.959961,616.975525 924.183472,614.870605 
	C927.714294,611.528137 929.193481,607.949829 926.322754,602.748657 
	C934.178894,596.242981 943.608887,592.990479 953.318237,588.937195 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1425.285522,535.832642 
	C1423.696899,538.277222 1422.301025,540.490784 1421.541138,543.618774 
	C1420.498901,547.907776 1417.257080,551.020813 1412.635986,551.856628 
	C1407.775879,552.735535 1404.356934,550.422546 1402.147461,546.234985 
	C1398.638184,539.584656 1393.165405,537.179749 1385.803833,537.932129 
	C1381.219238,538.400696 1376.854736,538.462769 1374.753296,532.520264 
	C1373.214355,528.168762 1367.080566,531.721130 1364.246826,527.497314 
	C1376.639893,526.428284 1388.909302,529.355652 1401.305786,530.997070 
	C1409.151855,532.036011 1416.888672,533.901733 1425.285522,535.832642 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M762.731812,730.454651 
	C759.129456,729.775574 755.914368,730.749939 753.932922,727.530273 
	C751.301147,723.253723 749.308105,718.682495 748.801453,713.704041 
	C748.677002,712.481445 750.294250,710.823242 751.479431,709.786987 
	C753.208801,708.274963 755.140259,706.857666 757.217468,705.906128 
	C762.979431,703.266785 766.820618,699.248657 768.015259,692.066528 
	C770.710022,692.260437 772.040588,694.370911 774.006104,696.600098 
	C771.842957,707.754028 774.605957,719.379211 767.414551,729.777222 
	C765.740051,730.923340 764.632935,731.104797 762.731812,730.454651 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M887.291870,622.134644 
	C888.289551,628.001526 887.342346,633.949585 889.490906,639.797363 
	C890.987610,643.871033 888.883179,646.820984 884.971191,648.451965 
	C883.751526,648.960449 882.531921,649.475342 881.287048,649.916016 
	C873.153748,652.794922 872.255005,652.558167 870.196655,644.451416 
	C869.418457,641.386353 867.862610,639.059448 865.918091,635.871277 
	C871.838684,629.626221 879.227051,625.931274 887.291870,622.134644 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1081.480469,402.621521 
	C1083.838257,400.705444 1083.705566,398.707153 1084.065674,396.776581 
	C1085.228882,390.539825 1090.125732,386.503876 1096.220459,386.369629 
	C1098.125610,386.327698 1099.358765,387.121674 1099.853882,388.883209 
	C1101.554443,394.933380 1105.825562,399.685028 1108.276367,406.190308 
	C1108.420898,406.957001 1108.697876,407.784698 1108.484619,408.165466 
	C1107.283081,408.598816 1106.294678,408.651367 1104.651367,409.069122 
	C1102.491211,409.865356 1100.928955,409.973022 1098.830811,410.394928 
	C1096.647827,410.672302 1095.029541,410.799622 1092.707886,411.352600 
	C1091.157471,411.881592 1090.313477,412.005585 1088.849854,412.297607 
	C1087.239624,412.517029 1086.252563,412.592102 1084.623901,413.057495 
	C1082.899292,413.633179 1081.835815,413.554138 1080.124023,412.748840 
	C1077.688599,408.892517 1078.922119,406.000122 1081.480469,402.621521 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M992.429138,573.274048 
	C996.118469,574.427673 999.124268,572.446472 1002.279541,571.634399 
	C1008.327087,570.077881 1011.943909,571.261841 1014.765503,576.148254 
	C1017.129578,580.242310 1016.193481,584.716064 1012.278931,588.721680 
	C1010.126160,590.924438 1007.587708,592.485901 1004.719299,593.424377 
	C1001.157104,594.589966 998.141846,593.805115 996.212830,590.307739 
	C993.622253,585.610718 991.164612,580.873840 991.983643,574.359680 
	C991.972168,573.500000 992.244507,573.242981 992.429138,573.274048 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M701.192383,619.574463 
	C700.762207,620.376465 700.067688,620.447327 699.538391,620.780640 
	C696.864319,622.464417 701.402588,626.497009 697.730713,627.434631 
	C693.353271,628.552307 688.676025,629.632263 684.274719,629.209229 
	C679.632874,628.763000 678.353943,618.132080 682.363220,614.080872 
	C684.199219,612.225708 686.456970,610.788452 688.117859,607.743591 
	C688.430176,607.034058 689.148376,606.436707 689.613403,606.480408 
	C693.720337,610.670837 697.362305,614.817566 701.192383,619.574463 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1187.398926,526.186279 
	C1188.407593,528.264465 1188.377197,530.341187 1189.106934,532.102966 
	C1191.346680,537.509705 1188.547119,540.921875 1184.808960,544.053101 
	C1180.661865,547.526733 1176.594727,545.791870 1172.989136,543.306702 
	C1168.449463,540.177734 1164.958740,536.262634 1167.890381,529.428345 
	C1168.905762,528.541870 1169.815308,528.292236 1171.428589,528.172974 
	C1175.660767,527.627747 1179.329712,528.567444 1183.410034,527.063965 
	C1184.907104,526.515808 1185.807373,526.278259 1187.398926,526.186279 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1296.816650,392.281433 
	C1293.821899,392.198059 1291.701172,391.935333 1288.801025,391.464905 
	C1288.019043,388.947205 1288.127441,386.630524 1287.989380,384.328644 
	C1287.753052,380.388855 1289.467529,378.872559 1293.359985,377.627258 
	C1306.803223,373.326538 1311.148193,377.462616 1310.064697,390.898987 
	C1305.963257,391.856323 1301.826904,391.979218 1296.816650,392.281433 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M766.508423,730.449890 
	C768.868896,723.815430 771.233154,717.490967 769.970642,710.511902 
	C769.112854,705.770081 773.000793,702.820068 774.136841,697.972717 
	C775.020630,697.106384 775.766357,697.074036 777.067566,697.106812 
	C779.307190,699.886169 783.308594,701.785278 777.936035,705.627136 
	C772.862183,709.255371 772.953064,716.330566 776.323792,721.681580 
	C777.670349,723.819336 779.358459,723.883667 781.402039,723.203979 
	C784.223877,722.265381 787.006653,721.181702 789.874878,720.418457 
	C792.190186,719.802307 794.541931,719.742493 795.852844,723.280762 
	C790.666870,727.171021 784.336243,729.381165 783.132324,737.485840 
	C779.882996,740.048584 777.559387,738.796509 776.000244,736.419800 
	C773.807007,733.076599 770.626038,731.734985 766.508423,730.449890 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M821.191772,663.895996 
	C823.524963,666.585571 825.343567,669.332642 826.808105,672.257019 
	C829.374329,677.381165 828.230469,681.447083 823.747437,684.062073 
	C818.717712,686.995667 815.578064,686.526428 812.024353,681.851746 
	C810.414795,679.734558 808.875244,677.661133 805.893921,675.927246 
	C809.472656,670.634705 815.168518,667.563354 821.191772,663.895996 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1491.387939,551.726929 
	C1485.516968,555.567261 1480.376587,556.758057 1473.583618,550.834656 
	C1467.960571,545.931396 1458.851440,544.205627 1451.097168,545.152832 
	C1445.540527,545.831543 1443.321411,543.313843 1440.218994,539.706177 
	C1457.383667,541.395020 1474.126099,546.322388 1491.387939,551.726929 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1743.186523,520.689880 
	C1745.486328,514.410950 1751.588379,512.714050 1756.778687,510.422821 
	C1760.333862,508.853424 1763.703491,510.090851 1764.120850,515.368347 
	C1764.474609,519.842590 1766.908325,524.466980 1760.622070,527.689636 
	C1759.130005,528.802490 1758.107056,529.117432 1756.186890,528.576904 
	C1755.437744,528.202698 1754.572876,528.115662 1754.283203,527.791748 
	C1751.241089,524.735413 1747.421387,523.538635 1743.961182,520.785706 
	C1743.337769,520.643616 1743.235596,520.670410 1743.186523,520.689880 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1762.080078,532.716553 
	C1764.698975,532.740784 1767.601074,533.358276 1771.251465,533.987915 
	C1773.208618,532.881104 1774.284668,531.510193 1775.787598,530.854065 
	C1779.064209,529.423706 1782.660156,527.097107 1785.970825,529.891174 
	C1789.130615,532.558228 1788.652466,536.369812 1787.058228,539.929932 
	C1786.334717,541.545654 1786.443237,543.116943 1787.551758,545.348511 
	C1788.001953,546.742004 1788.008667,547.486938 1788.018677,548.788940 
	C1778.753784,545.145020 1770.685547,539.024048 1762.080078,532.716553 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1555.196777,434.061401 
	C1559.530640,433.846893 1560.859619,431.645294 1562.249756,428.616913 
	C1565.074097,422.464417 1567.227417,421.557068 1570.948120,423.587555 
	C1575.463501,426.051727 1576.421265,429.971222 1573.843140,435.245758 
	C1573.121948,436.721313 1572.514526,438.252441 1571.699463,440.584503 
	C1569.509644,441.070007 1567.475220,440.729095 1564.663330,440.421326 
	C1561.121460,437.469940 1556.776978,437.768188 1553.206787,434.918884 
	C1553.300903,434.251862 1553.842407,434.194855 1555.196777,434.061401 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1878.271973,640.338745 
	C1886.863892,640.856079 1889.517090,642.775696 1889.936035,648.193481 
	C1890.327759,653.261658 1886.915649,657.616943 1882.369507,657.851501 
	C1878.328979,658.059937 1876.539795,655.866272 1876.020630,649.942688 
	C1875.878052,648.316833 1875.911865,646.675476 1875.771484,644.142822 
	C1876.357056,642.336121 1877.035767,641.427734 1878.271973,640.338745 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1403.445435,388.406006 
	C1408.170654,389.056152 1412.333374,390.712585 1417.275635,388.082642 
	C1417.567139,393.065247 1412.522583,396.055084 1412.040039,401.865082 
	C1410.687378,403.656311 1409.174072,403.853973 1406.809326,403.580505 
	C1404.495850,403.010315 1402.950439,402.580902 1400.600220,402.274323 
	C1398.928955,402.216278 1398.055054,402.084167 1396.512695,401.953918 
	C1395.850708,401.913452 1395.727417,401.238098 1395.730957,400.895538 
	C1394.790649,394.610046 1400.043335,392.444061 1403.445435,388.406006 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1081.300903,402.079407 
	C1082.396851,405.244537 1080.730469,408.064880 1080.088623,411.884094 
	C1079.810303,413.032349 1079.577148,413.401001 1078.783813,414.107513 
	C1077.237305,414.519684 1076.251099,414.593933 1074.632568,415.072144 
	C1073.250244,415.605408 1072.518311,415.537872 1071.382324,414.903809 
	C1065.056152,411.162292 1060.768311,406.615814 1060.011963,398.746429 
	C1060.789673,396.539703 1061.622070,394.938080 1063.486938,394.908386 
	C1065.732910,394.872620 1065.801880,396.753174 1065.945068,398.380249 
	C1066.031494,399.360657 1065.879272,400.377319 1066.069336,401.330811 
	C1067.250854,407.256287 1070.758301,408.716156 1075.673462,405.240448 
	C1077.267578,404.113190 1078.524902,402.500702 1081.300903,402.079407 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1608.519043,451.553467 
	C1606.402954,452.060150 1604.805908,452.117798 1602.418457,452.316223 
	C1601.628052,452.456940 1601.668579,452.391235 1601.697876,452.399170 
	C1597.709595,441.490662 1597.709595,441.490662 1587.971558,446.552490 
	C1586.828247,446.918701 1585.862061,446.615875 1584.524414,445.977173 
	C1583.684937,441.718231 1584.174683,438.099243 1588.626343,436.898743 
	C1593.432373,435.602661 1599.041504,434.300720 1602.918701,437.542297 
	C1606.667358,440.676697 1610.813477,444.896057 1608.519043,451.553467 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M847.339294,646.173584 
	C847.709900,657.407837 840.991394,662.511414 828.227661,660.136780 
	C833.195435,653.870117 840.296143,650.606140 847.339294,646.173584 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1310.205078,393.700745 
	C1322.252563,391.253662 1334.215820,395.402985 1347.077881,396.141724 
	C1347.146606,396.938538 1346.622314,397.511597 1346.040527,397.577759 
	C1333.992920,398.947571 1322.331665,395.977905 1310.205078,393.700745 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1202.911011,397.003967 
	C1213.499512,393.751862 1224.897461,392.631470 1237.287964,392.858398 
	C1237.510864,394.278473 1236.842285,395.721191 1235.419678,395.641571 
	C1224.713013,395.042267 1214.310547,399.628021 1202.911011,397.003967 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1588.313232,447.614014 
	C1592.174194,438.177368 1595.465332,437.033386 1601.153931,442.125488 
	C1604.416138,445.045593 1602.995239,447.905823 1601.865234,451.686340 
	C1597.121704,451.840057 1592.952271,449.995209 1588.313232,447.614014 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1116.624268,405.953949 
	C1116.625244,401.635376 1120.275146,400.202362 1123.299683,398.807831 
	C1126.513062,397.326233 1130.333496,396.940460 1132.307739,402.322876 
	C1132.499268,403.108368 1132.702637,403.879059 1132.496948,404.220428 
	C1130.672852,404.634369 1129.054443,404.706940 1126.715332,405.166718 
	C1124.474854,405.899384 1122.916260,405.975128 1120.814941,406.354553 
	C1119.278320,406.368317 1118.308594,406.247375 1116.624268,405.953949 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M905.293579,612.318726 
	C902.943726,618.858948 896.319885,619.602844 889.769104,621.725281 
	C893.123230,616.808228 899.253113,615.237549 905.293579,612.318726 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1743.590088,521.232788 
	C1748.065063,520.107483 1751.638672,521.758667 1753.881348,526.806763 
	C1749.940796,526.788818 1746.896973,524.295593 1743.590088,521.232788 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1793.567505,550.520508 
	C1796.471191,548.799683 1795.505859,544.812927 1799.351196,544.098877 
	C1799.349609,547.411499 1801.748535,551.765869 1796.159668,554.074707 
	C1795.378052,554.257446 1794.532715,554.102844 1794.271484,553.761719 
	C1793.319214,552.773315 1793.027222,551.979370 1793.567505,550.520508 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1361.240234,396.485077 
	C1363.618042,396.741638 1365.248413,397.163391 1367.312744,398.031006 
	C1364.053955,400.741089 1360.346191,400.642853 1356.339111,397.992279 
	C1357.532349,397.175415 1359.012573,396.912811 1361.240234,396.485077 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1183.236084,526.561890 
	C1181.474243,532.240601 1177.080566,529.713379 1172.651489,528.786621 
	C1175.208984,525.694092 1178.957275,526.674683 1183.236084,526.561890 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M859.476685,638.458618 
	C859.493347,642.457397 857.009949,644.112915 852.357117,643.893066 
	C853.299438,641.087830 856.090149,639.820068 859.476685,638.458618 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1406.278198,403.957703 
	C1407.518188,403.218811 1408.995239,402.997864 1411.229004,402.692322 
	C1412.387207,403.013184 1412.843140,403.343689 1413.575195,403.957489 
	C1411.417969,406.565277 1408.989258,406.549347 1406.278198,403.957703 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1132.715576,404.961121 
	C1132.291260,404.561798 1132.355835,403.828033 1132.427490,403.468201 
	C1134.528809,403.062134 1136.558350,403.015930 1139.289062,403.260620 
	C1138.387817,406.733337 1135.789429,406.143616 1132.715576,404.961121 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1108.716553,408.957245 
	C1108.271484,408.546295 1108.322021,407.747406 1108.371460,407.352173 
	C1110.510620,406.861176 1112.600342,406.765350 1115.444336,406.880920 
	C1114.725220,410.548218 1112.049561,410.286499 1108.716553,408.957245 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1098.630371,410.929535 
	C1099.416748,408.973816 1101.081909,408.833893 1103.410156,409.170654 
	C1103.052368,411.984894 1101.278809,412.328613 1098.630371,410.929535 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1078.582520,414.843323 
	C1078.429321,413.862946 1078.820312,413.460327 1079.719971,412.950623 
	C1080.943481,412.743835 1081.843506,412.824005 1083.362793,413.175995 
	C1083.009521,416.034210 1081.217896,416.319122 1078.582520,414.843323 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1162.644775,400.945618 
	C1163.535156,399.008423 1165.244629,399.018311 1167.582764,399.440186 
	C1166.941895,401.856598 1165.223022,402.414124 1162.644775,400.945618 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1383.328857,398.915436 
	C1384.433350,399.173370 1384.884155,399.519440 1385.533936,400.218628 
	C1383.999634,402.368805 1382.263672,402.367401 1380.269287,400.269226 
	C1380.909058,399.572601 1381.778076,399.306396 1383.328857,398.915436 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1120.602783,406.880005 
	C1121.493042,405.094666 1123.145386,404.955170 1125.425049,405.274170 
	C1124.968384,408.041656 1123.191040,408.325348 1120.602783,406.880005 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1435.394653,537.931885 
	C1433.888794,540.355713 1432.026245,540.637573 1430.162109,537.546265 
	C1431.730957,536.313538 1433.357910,536.683228 1435.394653,537.931885 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1755.760742,528.783691 
	C1756.452393,528.143494 1757.467163,528.084290 1759.243286,528.015869 
	C1760.526855,529.039246 1761.048950,530.071960 1761.746704,531.658386 
	C1759.560791,532.114685 1757.733154,530.922363 1755.760742,528.783691 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M755.959595,686.789551 
	C756.909607,684.713806 758.180237,684.124939 760.487000,684.082275 
	C761.481445,684.398926 761.600952,684.743225 761.609619,685.366150 
	C761.387329,686.032776 761.160400,686.460266 760.466736,687.443848 
	C758.499023,689.223328 757.156677,688.909363 755.959595,686.789551 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1052.558105,420.945862 
	C1052.891357,419.571533 1053.855469,419.176086 1055.515137,419.414124 
	C1055.443970,421.174683 1054.609985,422.148132 1052.558105,420.945862 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1088.481689,412.787354 
	C1088.914185,411.445435 1089.906128,411.169250 1091.526611,411.513916 
	C1091.347290,413.272034 1090.449829,414.185822 1088.481689,412.787354 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1422.174072,406.032776 
	C1423.007935,404.907501 1424.031128,405.055328 1425.436523,405.928772 
	C1424.703491,407.953369 1423.546753,408.011230 1422.174072,406.032776 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1396.090088,402.271118 
	C1396.895996,401.829041 1397.941162,401.744629 1399.390869,402.028687 
	C1398.742310,404.005066 1397.580078,403.979706 1396.090088,402.271118 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1793.237427,550.012817 
	C1794.001709,550.762756 1794.003296,551.523010 1794.007690,552.851929 
	C1792.262207,553.462891 1791.078125,552.428528 1789.687012,550.752930 
	C1790.442749,550.150085 1791.458740,550.086609 1793.237427,550.012817 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1148.433105,402.703369 
	C1148.929932,401.410553 1149.929443,401.182159 1151.520264,401.567444 
	C1151.289062,403.349182 1150.349609,404.201691 1148.433105,402.703369 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1070.744385,414.961884 
	C1071.665771,414.660767 1072.371338,414.787994 1073.538574,415.195648 
	C1073.430176,417.124695 1072.587402,418.191040 1070.432983,416.650665 
	C1070.167847,416.279266 1070.528320,415.390198 1070.744385,414.961884 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M786.355103,533.833984 
	C786.307983,532.225159 787.550476,531.391296 789.606567,530.861938 
	C789.698608,532.539612 788.753723,533.666382 786.355103,533.833984 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1060.533447,418.922729 
	C1060.921387,417.600189 1061.888672,417.246552 1063.517090,417.545776 
	C1063.379883,419.287109 1062.492920,420.156311 1060.533447,418.922729 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M690.077881,605.620667 
	C690.078369,606.524109 689.701843,607.033752 689.701843,607.033752 
	C689.701843,607.033752 689.068359,607.005859 688.749268,607.019958 
	C688.580261,605.628906 687.636230,604.035522 689.573425,602.888306 
	C690.025330,603.513794 690.051331,604.115479 690.077881,605.620667 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M909.461060,469.453400 
	C909.441284,468.941376 910.065369,468.403778 911.317871,467.809662 
	C911.332458,468.311371 910.718689,468.869598 909.461060,469.453400 
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none" 
	d="
M1043.427002,1084.071289 
	C1044.438110,1082.500122 1045.136963,1081.505249 1046.407959,1080.261475 
	C1047.489014,1079.025879 1048.107788,1078.129883 1049.531128,1077.232178 
	C1052.074463,1074.655029 1054.139160,1072.348755 1056.846924,1069.892456 
	C1081.356934,1046.593994 1109.070923,1028.934326 1138.862793,1014.747925 
	C1164.396484,1002.589111 1191.393433,994.267578 1219.455322,989.989685 
	C1300.036743,977.705566 1375.162598,992.634399 1444.595215,1035.532715 
	C1448.263184,1037.798950 1451.340942,1040.950439 1455.928833,1043.321899 
	C1456.639893,1043.702026 1457.609985,1043.853394 1457.798340,1044.306763 
	C1463.756836,1048.457275 1468.785400,1053.130127 1474.762207,1057.669189 
	C1475.222900,1058.176636 1475.802856,1058.092407 1475.831543,1058.384033 
	C1480.290161,1061.549561 1483.356445,1065.930542 1488.052246,1069.435547 
	C1492.397949,1071.335815 1494.481201,1074.874756 1497.683594,1078.025024 
	C1502.988037,1085.166382 1508.989624,1090.840332 1514.906006,1097.514160 
	C1516.201660,1098.828735 1517.100098,1099.580444 1518.130127,1100.915771 
	C1518.875610,1102.743164 1519.803833,1103.770630 1521.001465,1105.447266 
	C1522.908936,1107.428223 1524.413208,1108.851807 1526.087402,1110.877930 
	C1531.381958,1119.451416 1536.798584,1127.220825 1542.751465,1135.444946 
	C1543.430664,1136.191772 1543.746094,1136.364868 1544.145752,1137.071289 
	C1557.220337,1158.621704 1567.518555,1181.134521 1574.683472,1204.528564 
	C1587.201294,1245.401001 1593.019287,1287.638916 1587.678955,1330.322510 
	C1581.488892,1379.797729 1567.179199,1426.765259 1538.237305,1468.359375 
	C1534.457397,1473.791626 1530.634399,1479.259399 1526.643311,1485.572021 
	C1525.714233,1488.515747 1523.746948,1489.691528 1521.886475,1491.669556 
	C1520.051025,1493.874146 1518.472412,1495.504517 1516.577148,1497.752686 
	C1515.579712,1499.323975 1514.970337,1500.337402 1513.849487,1501.670654 
	C1502.493408,1514.043335 1490.799072,1525.252686 1478.553223,1536.879517 
	C1477.987305,1537.282471 1477.533325,1538.166626 1477.038452,1538.210693 
	C1473.521118,1539.810059 1471.682373,1542.770630 1468.427002,1545.013550 
	C1467.913696,1545.368408 1467.816040,1545.963013 1467.520020,1545.906982 
	C1437.837524,1568.822021 1405.063354,1585.968018 1369.851562,1597.341797 
	C1337.725830,1607.718750 1304.285400,1612.771606 1270.189453,1612.074463 
	C1240.539673,1611.468262 1210.974243,1608.697510 1182.889648,1599.624634 
	C1142.926636,1586.714478 1105.273438,1568.615234 1072.813477,1540.984619 
	C1055.294800,1526.072388 1039.280762,1509.733032 1023.045288,1492.485107 
	C1022.074890,1491.681152 1021.722839,1491.325195 1020.953979,1490.358154 
	C1018.296997,1482.288330 1012.865173,1477.060303 1007.331787,1470.996582 
	C1006.552307,1470.009888 1006.266296,1469.585327 1005.640747,1468.457520 
	C992.100952,1446.536377 981.031006,1424.159302 973.092834,1400.563110 
	C967.742859,1384.660522 964.904480,1367.888550 961.377502,1351.384521 
	C956.006226,1326.250000 957.017273,1301.244019 957.545105,1276.152588 
	C957.990967,1254.962646 963.540283,1234.488403 968.845825,1213.972168 
	C974.593811,1191.744873 983.582214,1171.011841 993.688232,1150.598267 
	C996.803772,1144.305054 1001.051819,1138.774048 1005.300903,1132.251465 
	C1005.822449,1131.230957 1005.869812,1130.881592 1006.378174,1130.273560 
	C1009.262817,1126.408325 1011.344238,1122.602539 1013.641724,1118.174683 
	C1014.107544,1117.197632 1014.318604,1116.820190 1014.931702,1115.937012 
	C1017.498596,1114.145752 1019.661072,1112.857300 1021.197266,1110.022217 
	C1021.371765,1109.422729 1021.964478,1109.939819 1021.653931,1109.698730 
	C1024.575928,1107.549927 1025.433228,1104.254028 1026.562012,1100.355835 
	C1027.284058,1098.987061 1027.823364,1098.285767 1028.925049,1097.189209 
	C1034.842529,1093.683472 1039.009399,1089.200317 1043.427002,1084.071289 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1407.540527,698.106079 
	C1408.144653,701.668945 1410.759888,702.416138 1413.258057,703.958008 
	C1419.857056,706.974976 1424.836670,710.922546 1427.540283,718.039917 
	C1429.728516,724.158447 1434.700073,727.270813 1438.525635,732.015625 
	C1450.421753,744.639832 1460.104004,757.928772 1463.562866,775.482300 
	C1462.883545,779.207031 1465.427979,780.866882 1466.938599,783.602661 
	C1466.732910,789.177917 1468.360962,794.237671 1470.348633,798.506653 
	C1475.120972,808.755859 1476.082031,819.601257 1477.083496,830.457336 
	C1477.785889,838.070374 1479.816895,845.449646 1479.935913,853.183350 
	C1480.229858,872.268921 1478.038696,891.242126 1473.462158,909.496277 
	C1466.506104,937.240784 1454.571411,963.143372 1437.098633,986.151855 
	C1432.166382,992.646851 1432.103394,992.577820 1424.293457,988.210388 
	C1378.744873,962.739563 1330.004517,948.940979 1276.848511,948.475952 
	C1273.269165,947.558533 1270.416504,948.153015 1266.808838,948.447998 
	C1253.921997,950.374146 1242.113403,955.304688 1228.717773,951.715088 
	C1226.338257,951.634766 1224.831787,951.681641 1222.664551,952.110840 
	C1220.516357,953.529053 1218.900879,954.049194 1216.433228,953.586304 
	C1214.239136,952.807922 1212.749146,953.225098 1210.636719,954.188477 
	C1206.098022,956.898438 1202.306641,959.592407 1196.644043,957.881653 
	C1194.996460,957.748352 1194.079346,957.792053 1192.585938,958.242493 
	C1191.073853,959.199036 1190.135498,959.743042 1188.479248,959.840454 
	C1171.970093,962.090454 1157.554565,969.031250 1142.911865,975.122925 
	C1134.662598,978.554749 1126.919556,983.203003 1118.478394,987.845947 
	C1114.947388,992.913086 1111.709717,997.089600 1104.644531,994.354614 
	C1102.866577,989.968689 1099.775269,987.459839 1096.802490,984.184326 
	C1091.912964,981.601135 1088.967651,978.253113 1088.199951,972.599976 
	C1084.543701,964.856323 1080.837280,957.803833 1076.541260,950.383423 
	C1074.016724,948.094482 1072.079224,946.174561 1072.466064,942.459961 
	C1072.902588,937.648071 1069.546631,934.794434 1068.227905,930.510437 
	C1066.983276,929.089539 1066.361572,928.134094 1066.488403,926.339355 
	C1066.807617,920.529419 1064.132080,915.954834 1062.590088,910.491577 
	C1061.082153,909.201721 1060.437134,908.244751 1060.426025,906.393250 
	C1060.401733,903.683228 1060.294678,901.562622 1059.827759,898.724121 
	C1056.790039,892.115601 1055.462646,885.979797 1056.179321,878.694214 
	C1056.197876,873.166931 1056.143799,868.431702 1055.804199,862.851562 
	C1049.186401,850.870605 1054.653687,840.263123 1057.519409,828.757690 
	C1058.396851,827.161743 1058.729126,826.322815 1058.794189,824.837524 
	C1058.262329,823.089783 1058.258057,822.007385 1059.025879,820.475464 
	C1060.652344,818.085022 1060.261353,815.820740 1060.430908,812.901733 
	C1060.149170,810.964050 1060.312744,809.889893 1061.269287,808.457031 
	C1064.516602,804.291931 1064.824097,799.680847 1065.781006,794.653442 
	C1065.205444,789.235901 1065.376099,784.671875 1069.756836,780.619751 
	C1071.720947,779.675049 1072.194458,778.533020 1072.501221,776.747559 
	C1072.192261,774.977600 1072.343506,773.885620 1073.370972,772.449219 
	C1076.266113,769.757996 1076.744629,766.302795 1078.660156,762.960144 
	C1077.761353,759.203918 1078.898071,756.862427 1081.788940,754.529480 
	C1087.428711,750.916321 1088.892212,745.102234 1091.964478,740.484009 
	C1103.997070,722.397095 1118.991333,707.115479 1135.772339,692.607910 
	C1141.736450,682.397522 1151.929565,678.299438 1160.664551,672.624817 
	C1166.129761,669.074524 1172.071045,665.953125 1178.695923,662.833191 
	C1182.780273,661.292358 1186.008423,659.541931 1190.036377,657.941040 
	C1192.874756,657.269348 1194.893799,656.385071 1197.382080,654.874390 
	C1198.407349,654.409485 1198.830200,654.250916 1199.908691,653.918762 
	C1205.026367,653.163513 1209.374390,652.040344 1214.392334,650.783691 
	C1216.422852,650.312439 1217.782715,650.300903 1219.720947,651.112427 
	C1222.432251,651.183167 1224.544556,650.913147 1227.328003,650.193787 
	C1229.431396,648.555359 1231.035522,647.952759 1233.569336,648.438110 
	C1236.372803,649.469482 1238.486938,648.835632 1241.299072,647.983521 
	C1249.132690,643.490417 1256.539062,641.637512 1265.276611,645.400635 
	C1268.067993,647.061829 1270.290405,646.650330 1273.237549,646.291016 
	C1278.980957,641.342285 1283.659790,645.436340 1289.229980,646.813171 
	C1292.530640,648.768127 1295.412109,648.661255 1299.035400,648.655701 
	C1307.714966,648.523071 1315.855713,647.083496 1323.392334,653.001343 
	C1326.809814,654.533142 1329.610474,655.560181 1333.150146,656.454590 
	C1339.883911,654.827087 1344.801270,658.205078 1349.888672,660.193481 
	C1362.453491,665.104309 1374.495850,671.095093 1385.023193,680.349243 
	C1384.933228,681.095947 1385.353638,680.304688 1385.187988,680.720947 
	C1394.639526,683.585266 1401.577026,689.708923 1407.540527,698.106079 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1878.698242,477.915802 
	C1867.906738,474.563873 1864.714111,466.159515 1869.899414,456.370575 
	C1870.816650,454.639008 1872.164673,453.112762 1873.439575,451.597504 
	C1879.138550,444.823792 1878.147827,437.203064 1869.873779,434.580688 
	C1862.487793,432.239746 1860.092407,426.010010 1855.935669,421.198944 
	C1852.761475,417.525177 1854.029297,413.798920 1858.259521,411.180176 
	C1859.636353,410.327728 1861.339966,410.003510 1862.893433,409.435699 
	C1869.199219,407.131042 1872.864746,403.126099 1872.038574,395.909424 
	C1871.567749,391.795746 1872.289795,388.046173 1875.958984,385.250031 
	C1882.732422,380.088104 1890.835083,381.170624 1895.375000,389.449097 
	C1898.553101,395.244080 1902.476929,396.435547 1908.232910,396.080017 
	C1912.115356,395.840179 1916.175659,395.307434 1919.504883,398.579987 
	C1925.096191,404.075867 1925.397217,411.321381 1919.941895,417.023407 
	C1918.566528,418.460815 1917.085571,419.814636 1915.542480,421.070892 
	C1910.289551,425.347504 1908.557129,430.471344 1910.539795,436.525513 
	C1911.516357,439.507599 1913.019531,442.024780 1916.739258,441.967682 
	C1920.223755,441.914154 1923.252319,443.286072 1925.954346,445.294159 
	C1928.097412,446.886841 1930.341797,448.787659 1929.547729,451.855042 
	C1928.635620,455.378326 1926.093384,457.503998 1922.437500,457.886536 
	C1916.575928,458.499908 1912.484009,455.252563 1908.431519,451.547729 
	C1903.502563,447.041718 1900.015991,446.969116 1895.361450,450.901428 
	C1894.513306,451.618011 1894.458496,453.273651 1894.016846,455.247620 
	C1893.429565,456.770233 1892.306152,457.599701 1892.380249,458.303162 
	C1893.447998,468.450928 1885.192993,472.314087 1878.698242,477.915802 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1022.296021,1490.005615 
	C1027.356689,1490.834473 1029.655884,1494.393433 1032.137085,1497.358765 
	C1055.785278,1525.619995 1083.034668,1549.398193 1115.162842,1567.849976 
	C1135.790283,1579.696777 1157.500732,1588.730225 1179.922363,1595.911499 
	C1195.260498,1600.824219 1211.098877,1604.452026 1227.322998,1606.179688 
	C1243.795166,1607.933960 1260.208862,1610.489258 1276.805542,1609.881714 
	C1310.694580,1608.641235 1343.901611,1603.825562 1376.142090,1592.431396 
	C1397.253052,1584.970581 1417.304565,1575.553955 1436.623779,1564.487061 
	C1444.943359,1559.721313 1452.606079,1553.801636 1460.507324,1548.320068 
	C1462.174683,1547.163330 1463.757080,1546.010254 1466.538818,1545.865479 
	C1458.395020,1555.053833 1447.396118,1561.276123 1436.575684,1567.614868 
	C1418.798584,1578.028931 1400.364868,1587.175049 1380.440796,1594.706787 
	C1376.456665,1600.875122 1371.282593,1602.345825 1364.385620,1600.827393 
	C1355.274170,1601.288330 1347.344971,1604.362793 1338.480957,1606.474854 
	C1333.766113,1613.555786 1327.964844,1613.647583 1320.740356,1610.587158 
	C1309.832520,1610.860962 1299.676880,1611.703003 1288.749878,1612.961670 
	C1284.287354,1617.487427 1280.062134,1617.494263 1274.752197,1614.375000 
	C1269.325439,1612.012573 1264.473877,1612.989746 1258.902588,1613.205078 
	C1258.639404,1614.539429 1260.036133,1615.391479 1258.230713,1616.428955 
	C1255.673340,1617.898438 1253.446289,1617.418213 1252.216064,1614.505005 
	C1247.681274,1610.416504 1241.598267,1611.814331 1235.925781,1610.791260 
	C1229.832520,1609.692017 1223.662842,1609.016846 1216.626709,1608.331299 
	C1214.802002,1612.466919 1211.473389,1611.181152 1209.279663,1610.946411 
	C1196.345825,1609.562744 1184.003784,1606.193604 1172.519043,1598.189697 
	C1167.367554,1593.540894 1161.227539,1592.977539 1155.907959,1590.520142 
	C1147.270264,1586.529541 1138.522217,1582.778076 1129.083496,1578.836914 
	C1124.958740,1580.400635 1122.668457,1578.790894 1120.565430,1575.454346 
	C1109.514648,1566.826050 1097.094238,1561.265503 1086.023438,1552.745117 
	C1071.433838,1540.781128 1056.718506,1529.610107 1043.420288,1515.777710 
	C1031.132568,1510.790771 1024.056519,1502.323486 1022.296021,1490.005615 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1456.358765,1043.083984 
	C1453.395508,1044.233154 1450.751221,1042.656128 1448.321045,1040.966675 
	C1417.966797,1019.865234 1384.267578,1006.094971 1348.764648,996.872681 
	C1333.159546,992.819031 1317.054443,990.700745 1300.770020,989.654053 
	C1290.202759,988.974670 1279.651855,987.839966 1269.053101,988.060669 
	C1238.802246,988.690491 1209.069458,992.828064 1180.074341,1001.729004 
	C1145.516968,1012.337402 1113.609253,1028.223755 1084.574951,1049.776978 
	C1077.936890,1054.704712 1071.232300,1059.588379 1065.425781,1065.552856 
	C1063.593384,1067.435059 1061.888062,1069.609863 1058.211304,1069.786499 
	C1068.545410,1057.219238 1082.274048,1047.947388 1096.066895,1037.770264 
	C1098.354614,1032.408447 1101.156738,1028.711426 1107.646362,1029.333008 
	C1116.781494,1025.355347 1125.298340,1020.988831 1134.218018,1016.072266 
	C1136.775269,1009.704590 1141.117676,1007.867493 1147.646118,1009.105713 
	C1152.132690,1008.908630 1155.573975,1007.365601 1159.428223,1005.148010 
	C1160.706055,1002.965759 1162.441650,1003.054565 1164.629639,1002.510132 
	C1167.580322,1003.099426 1169.325073,1001.789429 1171.621582,1000.736572 
	C1177.485107,992.153992 1186.016846,992.838196 1194.910400,992.977783 
	C1203.590454,993.760620 1210.824219,989.877686 1219.335205,988.917480 
	C1224.768921,983.295227 1230.347290,982.073547 1237.461426,985.458374 
	C1246.227173,986.434265 1254.277466,986.059631 1263.142822,984.402710 
	C1279.836304,985.326782 1295.750000,985.366638 1311.560547,987.267273 
	C1362.960693,993.446289 1409.939697,1011.270752 1452.729248,1040.308105 
	C1453.827637,1041.053467 1454.960693,1041.747803 1456.358765,1043.083984 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1526.776123,1486.011108 
	C1526.860596,1477.671509 1533.433594,1472.153320 1537.754150,1465.800781 
	C1553.425537,1442.759399 1564.366333,1417.543091 1572.884521,1391.347656 
	C1578.164307,1375.111206 1581.127197,1358.102173 1583.930420,1341.164917 
	C1587.867554,1317.376099 1586.622925,1293.376709 1585.479736,1269.615723 
	C1584.663818,1252.656006 1580.808105,1235.697998 1576.325073,1219.000854 
	C1573.052002,1206.810547 1568.556519,1195.130249 1564.453613,1183.307007 
	C1561.107666,1173.665039 1555.988403,1164.640259 1551.679810,1155.330444 
	C1549.174927,1149.918213 1545.729126,1144.941284 1544.197754,1138.349121 
	C1550.846924,1145.182861 1554.118530,1154.645752 1558.808472,1163.317993 
	C1565.774658,1176.199585 1570.872192,1189.995850 1575.261108,1203.732422 
	C1579.651489,1217.474243 1583.052124,1231.723877 1585.437988,1246.201660 
	C1589.185791,1268.943604 1590.415527,1291.648682 1590.188110,1314.616821 
	C1590.068359,1326.721802 1586.880615,1338.226807 1585.179565,1349.990967 
	C1579.415894,1389.851074 1565.252930,1426.807495 1544.159668,1461.069702 
	C1538.945679,1469.538818 1533.008667,1477.562744 1526.776123,1486.011108 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1172.002930,1598.298340 
	C1186.166382,1600.901489 1200.319092,1604.277222 1215.099365,1608.079590 
	C1216.359985,1610.728394 1216.830811,1613.012939 1217.655640,1615.161743 
	C1220.443604,1622.423828 1220.895386,1624.322510 1214.778687,1627.713745 
	C1207.093018,1631.974976 1208.001099,1638.238525 1207.983521,1644.831177 
	C1207.960327,1653.528687 1204.819824,1658.408081 1197.728149,1661.049683 
	C1190.257446,1663.832642 1186.503540,1661.245117 1185.973877,1653.241943 
	C1185.416504,1644.816772 1185.954224,1637.270142 1195.759155,1633.963379 
	C1200.106567,1632.497192 1200.526367,1629.081299 1198.518188,1625.029907 
	C1195.557007,1619.055298 1192.718262,1617.318848 1185.556763,1617.765869 
	C1175.421387,1618.398682 1169.855469,1610.727417 1172.002930,1598.298340 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2067.565186,524.617432 
	C2068.137939,520.349976 2068.044189,516.948853 2064.180420,514.765625 
	C2062.607178,513.876709 2060.935547,512.060425 2060.560791,510.385834 
	C2059.819580,507.074738 2056.847412,504.904968 2056.448242,501.673492 
	C2055.869141,496.984802 2061.764893,498.658203 2062.887207,495.561127 
	C2063.180176,494.752838 2062.947754,493.754303 2062.478516,492.420959 
	C2061.246582,491.230499 2060.973145,490.318146 2061.589355,488.631042 
	C2066.938965,488.781799 2067.433105,492.676056 2067.988770,497.268341 
	C2070.342041,501.975464 2067.291016,508.945435 2073.915527,510.326050 
	C2080.916748,511.785126 2081.685547,504.563812 2085.524902,500.494202 
	C2087.166992,498.403442 2088.627686,498.118103 2090.131836,499.376465 
	C2092.130371,501.048401 2093.915039,502.980927 2095.947021,504.606812 
	C2097.972656,506.227570 2100.214111,506.256592 2102.140381,504.397736 
	C2104.440186,502.178284 2104.080322,499.824127 2102.247559,497.426453 
	C2100.290039,494.865204 2097.542480,494.288483 2094.576904,493.709778 
	C2091.026855,493.017059 2089.604492,490.799042 2091.734863,486.625122 
	C2095.367432,481.895020 2098.700684,477.766327 2101.538330,472.485687 
	C2102.429932,469.348389 2104.142334,466.976379 2106.118896,469.821777 
	C2108.933350,473.873657 2113.036621,477.294128 2113.983398,483.272461 
	C2112.547607,490.602783 2112.423828,496.792267 2119.615479,501.414124 
	C2118.397461,507.865845 2119.663574,514.464111 2114.740723,519.834473 
	C2109.238770,515.733276 2103.532471,514.212646 2096.645020,514.124939 
	C2086.750732,512.830200 2079.707520,515.928528 2076.043945,524.833008 
	C2074.685303,528.135132 2072.170898,527.911133 2068.769775,527.997437 
	C2067.301025,527.205994 2067.011230,526.283508 2067.565186,524.617432 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1274.583984,1680.700439 
	C1280.786987,1678.270752 1283.696289,1674.584961 1284.182739,1668.426758 
	C1284.574707,1663.465698 1288.793335,1660.761719 1294.831299,1660.191650 
	C1299.119141,1659.786743 1301.846802,1661.953003 1303.435791,1665.601074 
	C1305.247925,1669.761597 1303.868774,1675.582520 1300.410278,1678.314697 
	C1298.605835,1679.740112 1296.391357,1680.636597 1294.407715,1681.846924 
	C1288.255615,1685.600464 1287.646729,1686.995850 1288.984985,1693.960205 
	C1290.195068,1700.257690 1286.015137,1707.654663 1280.143433,1709.606201 
	C1275.755859,1711.064331 1271.887451,1709.424438 1270.762451,1704.922852 
	C1269.484375,1699.809448 1268.800659,1694.533569 1268.088257,1689.296997 
	C1267.489990,1684.899170 1270.252075,1682.605713 1274.583984,1680.700439 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2142.520264,500.461914 
	C2140.119141,497.051270 2136.267334,498.735718 2134.021973,496.600433 
	C2132.727295,495.369354 2131.826660,493.866302 2132.552246,492.202698 
	C2133.458496,490.125214 2134.955322,491.003540 2136.613525,491.658203 
	C2144.203369,494.654480 2148.526367,492.470795 2149.791260,484.477203 
	C2150.473145,480.168671 2151.141846,475.882874 2153.314453,472.191895 
	C2156.454590,466.857483 2160.592529,467.126495 2163.976807,473.241943 
	C2163.050049,477.318085 2158.278809,479.199188 2160.300537,483.599548 
	C2160.901123,484.906555 2162.217285,485.565948 2163.626465,485.026978 
	C2168.256836,483.256104 2166.632568,478.002502 2169.541504,474.497040 
	C2172.455322,470.893433 2175.237061,473.045593 2176.612305,474.553101 
	C2180.390137,478.694092 2185.281494,482.272278 2185.989258,489.265381 
	C2185.752930,494.469421 2185.108887,498.845154 2182.481445,503.431946 
	C2179.548828,506.718719 2177.322266,506.229462 2175.799072,503.201324 
	C2174.782471,501.179993 2174.356445,498.860382 2173.677734,496.670776 
	C2173.083496,494.755463 2171.579590,493.933685 2169.883301,494.507416 
	C2167.405029,495.345764 2165.050781,496.595215 2162.718506,497.812561 
	C2159.188965,499.654785 2161.611816,502.362183 2161.800537,504.763184 
	C2162.063965,508.121552 2162.551270,511.682892 2156.771484,511.973450 
	C2152.994141,506.770447 2149.325439,502.316101 2142.520264,500.461914 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1277.395264,1647.222656 
	C1277.803589,1652.112549 1279.579590,1656.581177 1273.411621,1658.533447 
	C1267.290039,1660.471069 1262.619751,1660.575317 1259.170410,1655.351440 
	C1255.119873,1649.217407 1250.190308,1649.149292 1244.520386,1650.905762 
	C1239.807617,1652.365723 1236.164795,1652.324829 1233.679321,1647.311523 
	C1230.875122,1641.655151 1231.337158,1633.856079 1234.959717,1630.649414 
	C1241.879272,1624.524170 1244.849121,1624.633911 1250.009521,1632.221802 
	C1253.697632,1637.645142 1258.006836,1640.743164 1264.841675,1640.069092 
	C1270.128784,1639.547729 1274.779785,1640.957886 1277.395264,1647.222656 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1153.967041,1615.191406 
	C1153.371704,1623.463989 1147.698853,1626.099609 1141.865356,1627.516724 
	C1137.351685,1628.613403 1135.509644,1630.521729 1136.012817,1634.914795 
	C1136.446655,1638.701782 1134.527222,1642.046997 1134.091919,1645.648071 
	C1133.548584,1650.144409 1131.054565,1651.698608 1126.743042,1652.067017 
	C1121.689819,1652.498901 1119.832275,1649.527466 1117.797852,1645.774780 
	C1115.721558,1641.944946 1117.250122,1639.632935 1119.853760,1637.099243 
	C1122.313721,1634.705811 1125.253052,1633.166626 1128.318604,1631.922119 
	C1132.051392,1630.406616 1133.109375,1628.283325 1131.921509,1624.265991 
	C1130.569458,1619.694092 1126.047241,1614.928467 1129.555542,1610.300781 
	C1132.358887,1606.603027 1137.986328,1607.006836 1142.444824,1606.054321 
	C1146.526245,1605.182739 1148.449097,1602.206299 1150.744385,1599.384888 
	C1151.688477,1598.224365 1153.197998,1598.062744 1154.316772,1598.877930 
	C1154.914307,1599.313354 1155.338135,1600.784790 1155.065063,1601.486816 
	C1153.426514,1605.698853 1154.213745,1610.060303 1153.967041,1615.191406 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1345.989746,1654.235352 
	C1346.170654,1659.839478 1345.329834,1663.681030 1339.316284,1663.998657 
	C1333.504761,1664.305786 1330.379272,1662.684204 1328.289062,1657.636597 
	C1324.648804,1648.846191 1324.499146,1648.782593 1315.519531,1652.215210 
	C1306.098877,1655.816284 1297.105835,1649.155518 1298.128784,1639.334839 
	C1298.773438,1633.144653 1308.841431,1628.357056 1315.797241,1630.983521 
	C1320.046997,1632.588135 1322.912231,1635.563843 1324.856323,1639.716187 
	C1328.999878,1648.566162 1329.182251,1648.890991 1337.852173,1646.920166 
	C1343.961548,1645.531494 1345.794678,1648.077637 1345.989746,1654.235352 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1272.188232,1737.478516 
	C1267.833252,1735.674561 1264.151733,1734.362183 1260.126343,1733.822754 
	C1255.000854,1733.136230 1253.517578,1730.639771 1254.090942,1725.520874 
	C1254.671997,1720.331909 1258.438599,1715.354736 1262.632935,1714.233765 
	C1268.691528,1712.614502 1273.556885,1714.129639 1276.733032,1720.221069 
	C1280.152710,1726.779541 1284.318848,1730.409180 1292.184082,1730.286499 
	C1297.412231,1730.204956 1298.760742,1733.648682 1296.643799,1738.590576 
	C1294.314941,1744.027588 1287.073242,1748.433105 1281.413574,1747.864746 
	C1278.850098,1747.607300 1277.003296,1746.357422 1276.301514,1743.841553 
	C1275.658325,1741.535034 1274.666870,1739.502075 1272.188232,1737.478516 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1843.959106,1163.213013 
	C1843.919067,1164.494873 1843.649414,1164.954956 1842.937866,1165.568359 
	C1839.272583,1160.656006 1838.829590,1154.597046 1837.311035,1148.918579 
	C1827.362305,1111.714844 1813.292480,1076.087158 1796.645996,1040.738403 
	C1801.704468,1041.489990 1802.247192,1046.432861 1803.879761,1050.128418 
	C1813.799561,1072.584717 1823.884644,1095.003174 1831.132202,1118.514893 
	C1835.622314,1133.081299 1839.615723,1147.800781 1843.959106,1163.213013 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2098.464355,453.495422 
	C2097.614746,455.506409 2097.612793,457.423950 2095.150146,456.775452 
	C2094.874023,456.702789 2094.518311,456.432465 2094.440674,456.179718 
	C2091.003174,444.983917 2082.762207,447.485504 2074.751221,449.195160 
	C2074.318604,449.287445 2073.737061,448.682404 2072.814697,448.177490 
	C2073.966797,445.120544 2078.342041,446.127045 2079.685547,442.593994 
	C2085.888184,438.758087 2086.819092,432.507446 2089.534180,426.530457 
	C2090.173096,423.771667 2089.496338,421.353394 2091.093994,419.416870 
	C2092.267090,417.995483 2093.949219,417.966766 2095.563477,418.522430 
	C2097.029053,419.026886 2097.334229,420.246429 2097.005127,421.647736 
	C2096.781738,422.598450 2096.336426,423.520416 2096.256104,424.477478 
	C2095.654541,431.651093 2096.579102,432.973206 2103.801025,433.922760 
	C2106.876465,434.327148 2109.807861,434.273621 2109.969238,439.207611 
	C2104.832031,443.072571 2101.055664,447.330750 2098.464355,453.495422 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1846.162842,1414.822266 
	C1849.054688,1419.710327 1846.108765,1424.666992 1844.982544,1429.531738 
	C1837.148926,1463.370117 1825.846558,1496.119263 1812.737915,1528.249390 
	C1811.134521,1532.179321 1809.561768,1536.257812 1806.040527,1539.742920 
	C1806.211426,1532.542969 1810.667603,1526.516846 1813.342651,1519.828125 
	C1826.068359,1488.010986 1836.734131,1455.577881 1843.854004,1422.022705 
	C1844.333862,1419.760498 1845.025024,1417.543335 1846.162842,1414.822266 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1157.359497,1801.037842 
	C1156.736450,1808.721558 1155.291748,1810.239502 1148.097656,1811.645630 
	C1143.466797,1812.550781 1139.504639,1811.940186 1137.471558,1806.906738 
	C1136.483643,1804.460938 1134.986328,1802.168091 1134.343384,1799.646973 
	C1133.107666,1794.801147 1134.698120,1792.133789 1139.446411,1790.521606 
	C1141.306030,1789.890137 1143.456055,1790.007690 1145.217163,1789.214233 
	C1149.073853,1787.476929 1151.492554,1788.584839 1153.154541,1792.286865 
	C1154.373535,1795.002075 1155.767822,1797.638306 1157.359497,1801.037842 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1133.343506,1718.704712 
	C1131.417847,1721.694458 1128.854126,1722.586548 1126.512207,1723.728271 
	C1120.354370,1726.729980 1115.615967,1725.088135 1112.812256,1719.130005 
	C1110.351929,1713.901123 1112.213745,1708.915894 1117.654053,1706.166382 
	C1128.166504,1700.853271 1133.481323,1704.782349 1133.343506,1718.704712 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1346.298340,1621.910645 
	C1357.630737,1618.783691 1360.997070,1619.954834 1363.349365,1626.878662 
	C1364.916626,1631.492798 1362.738159,1634.501099 1359.615356,1637.356812 
	C1356.490845,1640.213745 1352.441040,1642.025879 1348.785156,1640.709106 
	C1344.938477,1639.323608 1344.182129,1634.444946 1342.671143,1630.824463 
	C1341.236206,1627.386230 1342.144897,1624.277710 1346.298340,1621.910645 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1318.263184,1693.634521 
	C1311.308472,1684.967163 1312.651001,1675.735840 1320.638184,1671.735352 
	C1326.100098,1668.999878 1328.512085,1670.084961 1329.921143,1675.950439 
	C1330.074097,1676.587158 1330.142456,1677.296143 1330.034302,1677.935181 
	C1329.347900,1681.990234 1336.421143,1685.137573 1332.622925,1688.519409 
	C1329.194336,1691.571899 1324.307373,1693.945068 1318.263184,1693.634521 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1273.999512,1614.612793 
	C1277.991699,1612.087891 1282.197266,1612.967285 1287.145996,1613.062622 
	C1287.686035,1617.101807 1290.657959,1619.314941 1292.092407,1622.236938 
	C1295.620605,1629.424683 1294.354370,1632.204468 1286.564575,1634.214722 
	C1277.701782,1636.501831 1277.796997,1636.481445 1275.822632,1627.197876 
	C1274.996216,1623.312012 1273.545044,1619.552368 1273.999512,1614.612793 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1866.722778,501.850952 
	C1864.363892,501.953461 1862.646240,502.212616 1861.106445,501.802948 
	C1855.473877,500.304443 1851.511597,495.126129 1852.234253,490.533417 
	C1852.967529,485.872345 1860.406128,480.018036 1865.214355,480.279266 
	C1868.389526,480.451782 1869.328247,483.169434 1871.452759,485.585175 
	C1871.796265,491.614838 1871.661621,497.249725 1866.722778,501.850952 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2032.056396,453.304016 
	C2031.409546,459.729370 2033.173096,464.996552 2035.069092,470.268768 
	C2036.546997,474.378357 2036.574707,478.101501 2030.732178,479.900208 
	C2027.208618,474.203644 2029.720337,465.514008 2020.379639,462.544861 
	C2020.103149,461.362549 2020.061157,460.656891 2020.330933,460.102936 
	C2025.265747,449.965363 2024.968994,448.142181 2016.405273,438.553040 
	C2014.375000,434.839996 2015.229858,431.909180 2017.413818,428.523499 
	C2023.781372,428.105927 2024.207764,433.931854 2027.700684,437.400879 
	C2029.354248,442.873596 2030.595459,447.779053 2032.056396,453.304016 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2061.614014,487.463257 
	C2062.000000,488.888641 2062.000000,489.777252 2062.000000,491.332336 
	C2059.853027,492.733917 2057.671875,493.383362 2055.564697,494.218719 
	C2045.520142,498.200256 2040.594360,495.182983 2040.008667,484.622040 
	C2039.954468,483.643524 2040.000488,482.659454 2040.000000,480.839600 
	C2041.902222,478.135773 2044.104370,476.785309 2047.347412,476.050110 
	C2054.942871,476.574554 2056.470703,483.705231 2061.614014,487.463257 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1320.270874,1799.599854 
	C1322.727173,1791.257324 1330.745117,1787.430908 1336.906982,1790.834839 
	C1340.527466,1792.834595 1339.848145,1796.356567 1339.995117,1799.600464 
	C1340.140503,1802.805176 1339.361328,1805.332031 1336.124756,1806.864868 
	C1329.686646,1809.913574 1324.473145,1807.847046 1320.270874,1799.599854 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2051.416992,552.760193 
	C2052.524658,548.672852 2055.944336,546.694580 2056.808594,549.603333 
	C2059.018311,557.038330 2066.070557,561.211609 2067.987061,569.255005 
	C2067.515137,573.222412 2065.443848,575.334839 2062.490723,577.586914 
	C2054.527100,578.443542 2052.980469,573.255188 2052.012695,566.750977 
	C2048.775391,562.102600 2048.489502,557.933167 2051.416992,552.760193 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1116.731323,1668.125610 
	C1119.632568,1679.971680 1116.445190,1679.839111 1110.589478,1682.587036 
	C1106.089233,1684.698730 1101.949585,1682.696411 1100.399536,1678.179443 
	C1098.859619,1673.692139 1101.483643,1667.101685 1105.592529,1664.218628 
	C1110.720215,1660.620850 1113.393799,1664.247314 1116.731323,1668.125610 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2028.130249,523.284424 
	C2028.186157,528.234619 2028.088867,532.113586 2022.227051,532.398376 
	C2020.769531,532.469177 2019.384644,533.975281 2017.961060,534.812622 
	C2011.943115,538.352356 2009.148682,540.517029 2004.590454,529.268433 
	C2011.324097,528.237061 2015.772339,524.664490 2017.335815,517.716187 
	C2018.334595,513.277771 2021.791260,515.017578 2025.305664,515.927612 
	C2028.173096,517.701111 2028.492188,520.040283 2028.130249,523.284424 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1163.849365,1638.545654 
	C1162.284180,1637.161865 1161.180298,1636.359497 1160.445679,1635.300903 
	C1157.428101,1630.952271 1157.246338,1626.175903 1159.869385,1623.686279 
	C1162.717896,1620.982666 1170.352539,1621.310059 1173.415039,1624.658447 
	C1176.030762,1627.518555 1179.144043,1630.852295 1177.074341,1635.067749 
	C1174.457520,1640.397461 1169.726196,1641.018066 1163.849365,1638.545654 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2019.354492,462.335663 
	C2031.359863,463.949280 2032.790405,466.298645 2030.011230,479.232056 
	C2029.995117,479.998779 2028.997559,479.998840 2028.498779,479.999420 
	C2027.219238,480.882507 2026.311768,481.573822 2024.577026,481.944092 
	C2011.992920,478.010376 2010.345825,471.994293 2019.354492,462.335663 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1169.927734,1680.440063 
	C1168.398315,1678.173096 1167.182861,1676.519287 1166.613525,1674.666748 
	C1165.433594,1670.827393 1166.420044,1668.210571 1171.064697,1667.998413 
	C1173.344360,1667.894165 1175.612671,1667.416748 1177.872314,1667.027588 
	C1183.193481,1666.111328 1185.766357,1667.748779 1187.295532,1672.825073 
	C1188.753296,1677.663696 1185.525146,1679.372803 1182.064819,1680.855469 
	C1178.275146,1682.479126 1174.392822,1682.534790 1169.927734,1680.440063 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2120.655273,501.705597 
	C2110.245361,499.985748 2107.711426,493.975433 2113.356934,484.360229 
	C2114.998291,484.001038 2116.000000,484.053345 2116.994629,483.993805 
	C2122.167480,483.684235 2126.301270,485.190918 2127.736084,490.682983 
	C2129.205322,496.306793 2126.144531,499.444397 2120.655273,501.705597 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2085.280762,499.916107 
	C2086.250732,503.101074 2085.218750,505.850800 2083.720947,508.480774 
	C2081.346924,512.649841 2077.891113,514.726318 2073.033203,513.812195 
	C2068.253906,512.912903 2067.223389,508.883911 2066.192871,505.054352 
	C2065.660645,503.077057 2066.404785,501.137238 2067.701172,498.682343 
	C2073.665771,497.293610 2079.500244,495.055206 2085.280762,499.916107 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1307.724365,1700.065674 
	C1314.538208,1701.185059 1314.502808,1705.630737 1313.589844,1710.001587 
	C1312.618774,1714.651367 1309.356079,1717.356323 1304.554565,1717.844727 
	C1300.534302,1718.253662 1298.712769,1715.585815 1297.239136,1712.399658 
	C1295.541260,1708.728760 1295.651367,1705.472534 1298.664795,1702.449585 
	C1301.027222,1700.079712 1303.904053,1699.935547 1307.724365,1700.065674 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1223.392578,1675.745117 
	C1215.483032,1672.261597 1213.460938,1663.689087 1218.586914,1658.585938 
	C1221.533325,1655.652710 1224.819214,1655.172729 1228.311646,1657.606689 
	C1232.121826,1660.262329 1233.298706,1665.786987 1230.693848,1669.849365 
	C1229.104614,1672.327759 1226.989502,1674.439575 1223.392578,1675.745117 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1307.484497,1819.836670 
	C1311.079224,1815.891235 1314.603271,1814.635864 1318.356567,1817.940796 
	C1321.303223,1820.535034 1322.526611,1828.924194 1320.757812,1831.839355 
	C1317.515381,1837.183472 1311.143677,1837.213257 1308.007202,1831.857544 
	C1305.890381,1828.242798 1305.225098,1824.452393 1307.484497,1819.836670 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1824.332520,548.617798 
	C1826.323364,536.458984 1830.481323,534.411011 1841.290283,539.916626 
	C1842.017334,540.650818 1842.102539,541.307922 1842.040283,541.950745 
	C1841.750732,544.936279 1845.557007,548.507996 1841.523315,550.802979 
	C1838.269775,552.654175 1834.637817,554.406006 1830.461060,552.466858 
	C1828.424683,551.521484 1826.040527,551.339111 1824.332520,548.617798 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2032.772217,453.999390 
	C2028.822876,449.609283 2024.408569,445.600891 2027.718750,438.642456 
	C2030.991577,438.008514 2033.983398,438.043243 2036.974731,438.019165 
	C2041.106201,437.985901 2044.177124,439.887390 2045.428711,443.703461 
	C2046.720581,447.642242 2043.222412,449.572906 2040.976196,451.894775 
	C2038.925781,454.014313 2036.232422,454.037903 2032.772217,453.999390 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1259.067749,1674.611084 
	C1262.439697,1682.886353 1261.258423,1685.718262 1254.386719,1687.562012 
	C1248.108643,1689.246216 1244.670166,1686.872314 1243.092773,1680.278442 
	C1241.954102,1675.518677 1244.773804,1673.358398 1248.355225,1672.420044 
	C1251.746704,1671.531616 1255.550171,1671.175781 1259.067749,1674.611084 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1319.875977,1610.715820 
	C1325.183472,1607.785034 1330.887939,1607.912231 1337.062988,1606.706421 
	C1337.898560,1607.895386 1337.957153,1608.886841 1337.965210,1609.878906 
	C1338.066650,1622.242310 1336.721802,1623.430786 1324.328003,1621.952637 
	C1316.316162,1620.997070 1315.209473,1618.441406 1319.875977,1610.715820 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2096.000000,514.750000 
	C2105.708008,510.256561 2108.499512,510.965942 2113.906738,519.263428 
	C2114.000000,520.888367 2114.000000,521.776672 2114.000000,523.331299 
	C2112.511230,525.395752 2111.199951,527.017883 2108.607422,527.893494 
	C2105.866699,527.998352 2103.733154,527.999146 2100.799805,528.000000 
	C2095.298828,528.050476 2094.914307,524.908813 2095.543213,520.677734 
	C2096.000000,518.500000 2096.000000,517.000000 2096.000000,514.750000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1913.680298,530.415771 
	C1910.992920,528.103516 1909.569458,525.830505 1910.214966,523.038330 
	C1911.099731,519.212097 1912.164673,515.247253 1916.833252,514.241882 
	C1920.269287,513.501953 1926.449463,517.661194 1927.458862,521.454285 
	C1928.635132,525.874329 1925.080933,527.899414 1922.500000,530.233521 
	C1920.052124,532.447510 1917.162720,532.385498 1913.680298,530.415771 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1857.165039,1268.613281 
	C1859.860962,1269.336304 1859.969360,1271.646973 1859.968628,1274.001953 
	C1859.963501,1291.195923 1859.983887,1308.390015 1859.900391,1325.583618 
	C1859.894531,1326.797852 1859.123169,1328.008423 1858.105713,1329.596558 
	C1856.163574,1327.489624 1856.565918,1324.791992 1856.574097,1322.154541 
	C1856.629028,1304.546997 1856.706665,1286.939453 1857.165039,1268.613281 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2100.776855,345.997925 
	C2099.904297,343.533295 2098.441895,341.984528 2096.803223,340.250397 
	C2093.252930,336.492920 2093.216309,331.615936 2096.265625,329.269897 
	C2099.688721,326.636322 2105.526611,327.969666 2107.659424,332.324890 
	C2108.842041,334.739868 2109.550049,337.180206 2113.274170,337.907166 
	C2112.701172,345.101379 2107.157227,345.595642 2100.776855,345.997925 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2182.789062,504.014954 
	C2182.593994,499.518738 2180.290527,494.452332 2185.343750,490.372375 
	C2189.426025,490.000946 2192.851807,490.001923 2197.134033,490.003265 
	C2202.739258,495.473511 2203.197754,500.856262 2196.831543,506.058044 
	C2191.640381,506.726715 2187.757568,504.443390 2182.789062,504.014954 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1854.733154,554.244385 
	C1857.170898,554.098877 1858.851685,553.871521 1860.449585,554.139221 
	C1864.833374,554.873718 1867.604492,557.401855 1867.819458,562.002869 
	C1868.001343,565.897217 1864.688599,569.317749 1860.462280,569.901611 
	C1855.920288,570.529175 1852.913086,568.660828 1851.224243,564.371582 
	C1849.618774,560.294189 1849.199707,556.676941 1854.733154,554.244385 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1326.260254,1731.322510 
	C1326.078369,1729.537476 1325.916016,1728.534912 1326.040527,1727.569214 
	C1326.884766,1721.027954 1330.226685,1717.532349 1334.928345,1718.185913 
	C1339.072388,1718.761841 1342.842285,1725.244995 1341.669800,1729.779053 
	C1340.455566,1734.474854 1335.170166,1737.069824 1329.759399,1735.506104 
	C1328.110229,1735.029419 1327.064941,1733.709961 1326.260254,1731.322510 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1994.488770,579.315430 
	C1992.717896,581.576294 1991.014771,581.871948 1990.208740,579.981384 
	C1987.120483,572.737671 1981.934937,569.918274 1974.144653,571.090576 
	C1972.158325,571.389404 1972.231567,568.956421 1972.013672,566.701660 
	C1973.722534,563.828552 1976.071045,562.709473 1979.339600,562.013428 
	C1981.291870,561.846863 1982.735352,562.014893 1983.851196,561.488525 
	C1991.301270,557.974426 1991.278564,557.926392 1991.999878,567.198608 
	C1994.856812,571.023926 1996.699951,574.329285 1994.488770,579.315430 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1254.566528,1784.946289 
	C1259.000488,1781.580566 1262.604736,1782.525757 1265.902954,1785.349243 
	C1268.492920,1787.565918 1268.284302,1790.686401 1267.692749,1793.610962 
	C1266.999390,1797.039185 1261.845581,1801.955811 1259.599365,1801.220947 
	C1256.004517,1800.045044 1253.427002,1797.305054 1252.371094,1793.721680 
	C1251.536865,1790.890381 1251.581787,1787.813965 1254.566528,1784.946289 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1956.092773,440.725159 
	C1957.905029,439.182373 1958.882935,437.414001 1960.251953,436.017792 
	C1964.551758,431.632751 1969.161743,430.898376 1972.360718,433.777771 
	C1975.943848,437.002930 1976.028809,441.041199 1972.316895,447.379456 
	C1965.850952,447.936676 1959.368408,448.675629 1956.092773,440.725159 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2196.121826,506.697571 
	C2200.453125,501.684692 2198.900879,496.535278 2198.004883,490.741455 
	C2200.715576,489.917450 2203.187988,490.234161 2204.526855,493.156006 
	C2205.891846,496.134949 2207.713135,498.808472 2210.029297,501.183685 
	C2213.679688,504.927124 2211.031250,508.811188 2209.326660,511.981110 
	C2207.638428,515.121216 2204.633545,512.171326 2202.323486,511.720184 
	C2199.824951,511.232269 2197.258301,510.247986 2196.121826,506.697571 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1279.774292,1767.322510 
	C1278.214111,1773.262817 1274.721313,1775.191772 1269.861084,1773.470459 
	C1264.926514,1771.723022 1266.023315,1767.156006 1266.163696,1763.280396 
	C1266.268799,1760.376587 1268.356812,1758.552612 1270.302734,1756.780396 
	C1274.432861,1753.019409 1277.240479,1753.666260 1279.223511,1758.692505 
	C1280.229614,1761.242798 1279.969116,1763.885498 1279.774292,1767.322510 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1958.698853,475.681580 
	C1955.376465,475.979401 1952.752686,475.967957 1950.129272,475.936188 
	C1945.639771,475.881805 1944.095337,472.554596 1942.729004,469.138550 
	C1941.373047,465.748199 1943.253906,463.464539 1945.718872,461.586884 
	C1949.144409,458.977661 1952.523682,460.040405 1955.765137,462.056305 
	C1958.154053,463.542114 1959.106689,465.989868 1959.917603,469.274414 
	C1961.701538,472.001343 1960.995239,473.732300 1958.698853,475.681580 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2061.301270,594.904907 
	C2064.826904,597.360535 2066.005371,600.122620 2066.050537,603.704590 
	C2066.098389,607.460938 2064.827881,609.964294 2061.224609,611.263000 
	C2057.306641,612.675110 2054.155029,611.655884 2051.695312,608.423584 
	C2049.423828,605.438599 2049.380371,602.252502 2051.817871,599.453064 
	C2054.103760,596.828003 2056.177490,593.435608 2061.301270,594.904907 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2037.297241,591.711304 
	C2041.547852,594.854919 2041.840088,597.651001 2037.834229,600.610229 
	C2033.807373,603.585083 2030.135986,606.699463 2027.103760,610.694397 
	C2025.823975,612.380493 2023.473877,611.929749 2020.754883,611.997681 
	C2019.301270,611.205933 2019.011108,610.283386 2019.565186,608.617371 
	C2019.596802,603.937317 2021.634644,600.651794 2023.711426,596.642090 
	C2027.619873,592.880554 2032.102295,592.138245 2037.297241,591.711304 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2064.187500,467.989563 
	C2058.629395,467.989685 2055.671631,466.075775 2056.251465,460.890717 
	C2056.705078,456.835876 2062.495850,451.832581 2065.801270,452.364899 
	C2069.375732,452.940521 2074.193359,458.925232 2073.814209,462.499207 
	C2073.229248,468.007812 2069.097900,468.007812 2064.187500,467.989563 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2037.998535,591.228516 
	C2034.332764,594.823792 2030.410278,596.853638 2024.780273,595.997925 
	C2024.437378,592.605713 2022.434204,589.692444 2022.123535,586.459351 
	C2021.867188,583.792480 2022.048096,581.352844 2024.816406,579.674438 
	C2027.513306,578.039307 2029.750244,578.832336 2032.152466,580.107239 
	C2036.328369,582.323608 2038.461304,585.644531 2037.998535,591.228516 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2033.260498,404.956268 
	C2030.635498,408.872131 2027.655518,410.995850 2023.671875,409.438171 
	C2019.914795,407.969086 2018.751953,404.290222 2018.178711,400.647797 
	C2017.654541,397.317108 2019.606201,394.981873 2022.164917,393.231598 
	C2025.187012,391.164246 2028.004272,392.596283 2030.300781,394.506897 
	C2033.263672,396.971863 2034.483521,400.337982 2033.260498,404.956268 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1363.772827,1601.372314 
	C1368.262817,1597.648926 1373.584473,1596.986328 1379.197754,1595.149536 
	C1380.074707,1596.861572 1379.915894,1598.599365 1380.405396,1600.129761 
	C1381.427490,1603.325684 1382.953857,1606.470337 1379.411743,1609.055298 
	C1375.750000,1611.727417 1371.522949,1612.882080 1367.214233,1611.627075 
	C1362.334839,1610.205566 1364.586792,1605.582275 1363.772827,1601.372314 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1098.261719,1618.349365 
	C1107.276123,1623.171997 1108.623901,1629.870117 1102.080444,1633.852661 
	C1099.202881,1635.604248 1096.100220,1637.122314 1093.242798,1633.755615 
	C1090.283203,1630.268433 1089.682739,1623.564331 1092.323975,1621.209351 
	C1093.745361,1619.941772 1095.764282,1619.344116 1098.261719,1618.349365 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2141.901367,500.777710 
	C2142.964111,500.001099 2143.928711,499.980316 2144.892334,500.004089 
	C2154.381836,500.238068 2154.514404,500.364105 2155.997559,511.189331 
	C2155.436035,512.318909 2154.791260,512.547913 2154.321533,512.971313 
	C2150.851807,516.096619 2146.701660,517.433838 2142.758789,514.860535 
	C2138.372559,511.997803 2139.808594,507.514954 2141.257812,503.420410 
	C2141.473633,502.810425 2141.622803,502.176819 2141.901367,500.777710 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2098.697754,454.075989 
	C2098.734619,442.884644 2099.761230,441.507568 2109.215820,440.002136 
	C2110.961670,442.432007 2113.516602,443.975922 2113.818604,446.764465 
	C2114.181152,450.112152 2114.221680,453.360992 2110.874756,455.484009 
	C2107.887939,457.378845 2104.999756,458.325531 2102.048828,455.329315 
	C2101.417725,454.688690 2100.292725,454.534180 2098.697754,454.075989 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1987.581055,519.298096 
	C1992.587769,517.035339 1995.341309,519.472839 1997.049072,522.856628 
	C1998.715698,526.159119 1998.831543,530.096375 1996.878906,533.296509 
	C1994.837280,536.642456 1991.430786,536.626465 1988.210205,534.761292 
	C1982.294678,531.335449 1981.846313,525.569031 1987.581055,519.298096 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1892.487427,618.588745 
	C1895.597656,615.168152 1898.520264,612.993469 1902.608887,614.645020 
	C1905.520752,615.821167 1905.935913,618.470093 1905.973267,621.288208 
	C1906.034790,625.943359 1902.988770,628.640808 1899.622070,630.772217 
	C1896.756348,632.586487 1891.356567,629.418457 1890.326172,625.638672 
	C1889.670288,623.232666 1890.310059,621.029236 1892.487427,618.588745 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2101.232422,471.904541 
	C2102.676514,478.807800 2099.647949,483.316162 2092.707764,485.918243 
	C2090.491699,484.779602 2088.938232,483.610413 2087.485840,482.326508 
	C2085.487793,480.560089 2083.427734,478.580902 2084.545654,475.636780 
	C2085.780518,472.384003 2088.248291,470.416962 2091.907227,470.041321 
	C2094.986816,469.725159 2097.659912,470.999634 2101.232422,471.904541 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1994.729614,579.998413 
	C1994.553589,576.283081 1992.027100,573.148865 1992.014893,568.770264 
	C1993.533325,567.440247 1995.290283,567.182190 1996.553833,566.253113 
	C1999.246460,564.272949 2001.742676,563.348572 2004.619995,565.793823 
	C2007.089844,567.893005 2008.429810,570.400452 2007.704102,573.694580 
	C2007.206543,575.953491 2006.592041,578.186707 2006.012573,581.213257 
	C2005.225220,582.754700 2004.306274,583.048950 2002.619141,582.437866 
	C2000.339722,579.629639 1997.819458,580.076355 1994.729614,579.998413 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2089.170898,426.002899 
	C2089.957520,428.899139 2090.172363,431.826813 2089.814697,434.682800 
	C2089.228271,439.366089 2086.962402,442.519379 2080.795410,441.996155 
	C2077.503906,438.905640 2072.990234,436.732666 2075.315918,431.462738 
	C2076.719482,428.283112 2078.672852,425.953461 2082.519775,426.034393 
	C2084.459229,426.075226 2086.400879,426.016083 2089.170898,426.002899 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1878.888062,528.713379 
	C1884.447388,534.781555 1885.187012,537.952759 1881.742188,540.703308 
	C1879.229126,542.709900 1876.277954,544.952148 1872.698120,543.034180 
	C1869.549683,541.347290 1867.979492,538.617554 1868.010742,534.888184 
	C1868.046509,530.626587 1870.895508,529.216797 1874.250366,528.357544 
	C1875.478271,528.043030 1876.867432,528.358459 1878.888062,528.713379 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1478.611694,1537.166504 
	C1478.266235,1536.347534 1478.260864,1535.131348 1478.866333,1534.519531 
	C1489.737671,1523.536499 1499.895630,1511.817871 1512.691162,1502.067871 
	C1503.820557,1515.476685 1491.305054,1526.046509 1478.611694,1537.166504 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1894.295166,553.599976 
	C1894.467773,548.059814 1895.948120,544.250854 1901.799316,545.018860 
	C1907.610107,545.781677 1910.006836,548.307373 1909.957031,553.093933 
	C1909.901733,558.423340 1906.586548,561.026367 1901.438110,559.443909 
	C1898.625977,558.579590 1895.768677,557.424194 1894.295166,553.599976 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1980.000000,561.191528 
	C1978.724121,564.864868 1976.461182,566.093323 1972.696167,565.992920 
	C1970.517212,563.898071 1968.104248,562.649231 1967.066772,560.074036 
	C1965.120361,555.242249 1966.790283,550.298828 1971.182861,548.660828 
	C1974.840088,547.297058 1978.654053,550.209045 1979.860352,555.519470 
	C1980.212769,557.071167 1979.970093,558.758118 1980.000000,561.191528 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1991.936279,598.365112 
	C1991.949219,604.329590 1989.058838,606.281982 1984.243530,605.898132 
	C1981.252075,605.659668 1976.412354,600.578735 1976.709473,597.757568 
	C1977.097778,594.069824 1979.490967,591.621094 1982.949219,590.757507 
	C1988.522095,589.365723 1990.726074,592.929016 1991.936279,598.365112 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2067.189453,524.001831 
	C2068.000000,524.890808 2068.000000,525.779114 2068.000000,527.333740 
	C2066.067627,537.441589 2065.551758,537.801331 2052.831055,537.997803 
	C2049.407471,535.441895 2049.453125,532.496216 2051.362305,528.684692 
	C2056.108154,524.204956 2061.066406,523.465698 2067.189453,524.001831 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2005.611328,494.060974 
	C2014.749878,498.353516 2015.878418,501.985352 2010.266846,506.529175 
	C2005.744019,510.191498 2002.034424,510.059143 1999.455444,506.143677 
	C1996.722412,501.994385 1997.678467,497.218689 2001.947021,494.464172 
	C2002.688232,493.985840 2003.854004,494.165283 2005.611328,494.060974 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1907.291016,472.082886 
	C1910.915405,471.866028 1912.740723,473.906952 1915.414551,475.712341 
	C1915.979004,477.321991 1916.034668,478.649261 1915.922974,479.962311 
	C1915.575928,484.041016 1913.448486,487.082275 1909.411621,487.531830 
	C1905.441528,487.973938 1902.696777,485.443604 1900.990479,481.849518 
	C1899.176025,478.028229 1901.159546,475.548859 1903.909546,473.379120 
	C1904.655151,472.790955 1905.683472,472.561218 1907.291016,472.082886 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2051.525391,527.600586 
	C2052.000000,530.777161 2052.000000,533.554321 2052.000000,537.164551 
	C2051.789795,539.966980 2051.864502,542.024841 2051.288818,543.880981 
	C2050.711914,545.740967 2048.820557,545.909851 2047.114502,545.627441 
	C2045.736572,545.399475 2044.604492,544.572510 2044.384644,543.116699 
	C2043.223267,535.427612 2044.149536,527.900818 2046.341553,520.496643 
	C2046.652710,519.446045 2047.584595,518.775024 2048.551514,518.991699 
	C2049.418213,519.186035 2050.316895,519.872681 2050.898438,520.588379 
	C2052.613281,522.698608 2049.447754,525.016235 2051.525391,527.600586 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2028.783325,523.998230 
	C2025.631836,522.339966 2026.076538,519.820190 2026.000488,516.729736 
	C2025.925903,512.080872 2026.599243,508.545990 2031.427612,508.181305 
	C2035.622803,507.864471 2038.414185,510.284363 2039.536255,514.023804 
	C2040.898926,518.564880 2038.371094,521.637573 2034.412231,523.424500 
	C2032.998901,524.062439 2031.193237,523.831055 2028.783325,523.998230 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1969.210083,477.959137 
	C1973.278564,478.146912 1976.591553,477.637421 1979.790527,478.965668 
	C1984.092285,480.751801 1984.687378,484.173706 1983.549927,487.952728 
	C1982.351440,491.934448 1978.997559,492.588806 1975.519775,491.462921 
	C1971.710083,490.229645 1967.901611,488.629120 1968.013916,482.759552 
	C1966.769409,480.498688 1967.090820,479.157196 1969.210083,477.959137 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2017.670898,427.364136 
	C2017.969971,430.954407 2018.293945,433.966431 2016.296387,437.324493 
	C2006.082397,437.306549 2004.165894,436.064392 2004.038940,430.158813 
	C2003.982178,427.519073 2003.948730,424.766266 2006.539185,423.152008 
	C2009.348633,421.401276 2012.166870,421.738281 2014.677246,423.871246 
	C2015.662964,424.708801 2016.459351,425.769287 2017.670898,427.364136 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1907.159058,658.697998 
	C1911.047852,657.803955 1914.077026,658.072144 1915.329346,661.526978 
	C1916.473389,664.683350 1916.610596,668.127319 1914.988770,671.191101 
	C1913.538940,673.929565 1910.734253,674.463623 1908.064087,673.558899 
	C1904.318481,672.289795 1901.949707,669.624390 1902.157471,665.367615 
	C1902.300903,662.428528 1904.258423,660.621826 1907.159058,658.697998 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1925.991943,632.022400 
	C1931.663940,632.055908 1934.580933,634.218201 1933.651001,639.329651 
	C1932.933350,643.275208 1930.184448,645.790955 1926.012329,645.799561 
	C1921.836914,645.808167 1919.085205,643.294678 1918.355591,639.352844 
	C1917.410034,634.245300 1920.319458,632.072083 1925.991943,632.022400 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1999.903931,453.270294 
	C1999.809937,457.808044 2000.857788,462.240479 1995.585693,463.650787 
	C1992.358276,464.514130 1989.822998,463.112396 1987.853638,460.630341 
	C1984.853027,456.848419 1985.855225,453.360077 1988.772339,450.061188 
	C1988.987915,449.817383 1989.157593,449.532837 1989.674316,448.633057 
	C1993.901489,448.147614 1998.322998,447.173340 1999.903931,453.270294 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1842.817627,526.000000 
	C1842.002197,524.070740 1841.906738,522.135498 1842.023315,520.213196 
	C1842.564087,511.295685 1845.363525,509.437256 1855.265625,511.914612 
	C1855.731934,524.176147 1854.750488,525.287415 1842.817627,526.000000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1937.701660,569.530884 
	C1934.694214,575.182312 1930.277100,575.024353 1926.435181,572.619995 
	C1922.852905,570.378113 1923.380615,566.157593 1924.966064,562.705322 
	C1927.519409,557.145386 1933.200562,556.952026 1936.692261,562.053345 
	C1938.116089,564.133667 1937.991821,566.430481 1937.701660,569.530884 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1938.995850,617.243164 
	C1937.378784,616.011414 1936.130859,615.274597 1935.556152,614.183228 
	C1933.139404,609.593506 1934.138184,605.631287 1938.093872,603.221008 
	C1941.357666,601.232361 1945.975708,603.252686 1948.523560,607.783997 
	C1950.233765,610.825500 1948.469482,615.412292 1944.441284,617.367981 
	C1943.128296,618.005371 1941.278809,617.537415 1938.995850,617.243164 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1333.995850,1873.110474 
	C1330.354004,1875.229736 1326.516602,1874.902222 1321.984375,1875.052734 
	C1319.479980,1873.799194 1318.359253,1872.313110 1318.108521,1870.133789 
	C1317.636841,1866.035034 1319.128296,1862.885864 1322.687256,1860.957764 
	C1326.599243,1858.838135 1328.739868,1861.984985 1331.166016,1864.187012 
	C1333.617432,1866.411865 1334.175415,1869.239258 1333.995850,1873.110474 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1926.118896,493.955109 
	C1930.321533,486.822845 1933.169922,485.337463 1936.563232,487.774567 
	C1940.277954,490.442535 1941.163574,496.291504 1938.456177,500.274628 
	C1936.059570,503.800537 1933.579468,504.145935 1930.309692,501.222565 
	C1928.336670,499.458466 1926.324585,497.628906 1926.118896,493.955109 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1893.328613,575.201782 
	C1894.228882,580.141235 1893.454102,583.997925 1889.081909,585.597229 
	C1886.294189,586.616943 1882.873169,586.447021 1881.183228,583.423462 
	C1879.098755,579.694031 1879.413940,575.847778 1882.558594,572.585999 
	C1884.885376,570.172241 1887.474487,569.302917 1890.346069,571.631958 
	C1891.349487,572.445740 1892.131836,573.532104 1893.328613,575.201782 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1915.458984,601.715759 
	C1912.728149,601.919495 1910.543579,602.353210 1909.085205,600.782471 
	C1906.206909,597.682678 1904.802246,594.054688 1907.337158,590.110291 
	C1908.973511,587.564026 1911.305908,585.255493 1914.654175,586.664429 
	C1918.716064,588.373657 1920.362427,591.787720 1919.920044,596.229492 
	C1919.669678,598.743958 1918.575317,600.548706 1915.458984,601.715759 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2062.562988,578.436279 
	C2062.025391,574.500061 2064.304688,572.465820 2067.410645,570.292847 
	C2076.355225,570.682983 2078.608398,572.293213 2077.723633,577.293518 
	C2077.206787,580.215027 2076.181641,583.102417 2072.713135,583.816772 
	C2068.242432,584.737549 2065.159912,582.774841 2062.562988,578.436279 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2169.250000,474.001831 
	C2169.991211,476.334320 2169.888916,478.670441 2169.994141,480.997162 
	C2170.195801,485.466858 2167.479980,487.577026 2163.792725,488.983826 
	C2160.495117,490.241821 2158.694580,488.024963 2157.278809,485.807343 
	C2154.939697,482.143860 2155.971436,478.778351 2159.127441,476.066711 
	C2160.099121,475.231934 2161.410889,474.792786 2163.283447,474.085693 
	C2165.500000,473.999603 2167.000000,474.000427 2169.250000,474.001831 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2051.157715,552.001892 
	C2052.000000,556.084412 2052.000000,560.166321 2052.000000,565.122925 
	C2050.001953,565.976318 2047.965210,566.198608 2046.013672,565.886719 
	C2040.874512,565.065552 2037.671143,561.497986 2038.189941,557.315186 
	C2038.797363,552.416748 2042.425049,551.971741 2046.318481,552.006592 
	C2047.650635,552.018494 2048.982910,552.003845 2051.157715,552.001892 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1975.875732,625.965088 
	C1975.679932,628.429321 1975.081665,630.026123 1973.572388,630.916687 
	C1970.820801,632.540283 1968.058960,635.213257 1964.905884,631.446350 
	C1961.485229,627.359680 1961.540161,623.076050 1965.080811,620.030273 
	C1968.833008,616.802673 1971.791870,618.370361 1974.324097,621.639160 
	C1975.095093,622.634399 1975.370361,624.013672 1975.875732,625.965088 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2019.172119,608.002258 
	C2020.000000,608.890808 2020.000000,609.779114 2020.000000,611.333740 
	C2020.177124,615.094788 2019.456055,617.796997 2016.976685,619.931763 
	C2014.708130,621.885132 2012.401001,622.181152 2009.751953,620.809937 
	C2007.564697,619.677917 2006.124634,618.220886 2006.045044,615.538269 
	C2005.957520,612.592957 2006.969116,610.580078 2009.682739,609.227356 
	C2012.484375,607.830627 2015.412354,608.072510 2019.172119,608.002258 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1965.448242,517.408203 
	C1958.194458,520.265747 1956.360474,519.799988 1954.827148,515.388550 
	C1953.643433,511.983673 1955.466675,508.195068 1959.151978,506.723602 
	C1961.746948,505.687500 1964.426514,505.649841 1966.358643,507.953369 
	C1968.842407,510.914520 1968.263062,513.983398 1965.448242,517.408203 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1243.407959,1817.392700 
	C1247.263062,1815.570190 1249.989502,1816.113037 1251.389893,1819.451172 
	C1252.605225,1822.348389 1250.710083,1824.471680 1248.611450,1826.169922 
	C1247.357422,1827.184570 1245.883545,1827.957764 1244.433838,1828.692505 
	C1242.665771,1829.588623 1240.751587,1830.389771 1239.062378,1828.620728 
	C1237.811768,1827.311279 1237.927734,1825.559937 1238.374756,1823.989624 
	C1239.099365,1821.444336 1240.211792,1819.073364 1243.407959,1817.392700 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2095.189941,520.034424 
	C2096.108643,522.764038 2097.395508,525.047119 2099.473633,527.611084 
	C2099.985596,530.618042 2100.019043,533.341309 2097.445312,534.910339 
	C2095.399902,536.157288 2092.895264,536.586853 2091.238525,534.596130 
	C2088.981689,531.884583 2090.230713,528.384583 2090.051025,525.221069 
	C2089.879639,522.211975 2091.069580,520.216675 2095.189941,520.034424 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1156.369629,1662.095215 
	C1153.101807,1663.663208 1150.673218,1663.676514 1148.239990,1661.908691 
	C1146.380371,1660.557495 1145.770996,1658.775635 1146.407959,1656.741699 
	C1147.506958,1653.231689 1151.119507,1653.592407 1153.710693,1652.525635 
	C1155.694458,1651.708862 1157.799683,1652.582397 1158.826660,1654.472778 
	C1160.359375,1657.293579 1160.859131,1660.166992 1156.369629,1662.095215 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1852.862915,1224.866943 
	C1853.859741,1224.599243 1855.315308,1225.167358 1855.327148,1225.764282 
	C1855.531006,1236.012939 1859.483032,1245.990967 1857.136841,1257.013062 
	C1853.724976,1247.209839 1853.909912,1236.371094 1852.862915,1224.866943 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1543.021729,1135.367920 
	C1541.380737,1135.883179 1539.680664,1135.217651 1538.903809,1133.776489 
	C1535.037231,1126.603027 1528.398560,1121.127441 1526.217163,1112.221436 
	C1533.093750,1118.308228 1537.264771,1127.048096 1543.021729,1135.367920 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1135.206421,1676.192017 
	C1138.652588,1677.523804 1140.593384,1679.167114 1138.390259,1682.283081 
	C1136.834351,1684.483643 1134.795288,1686.438232 1131.811890,1685.518066 
	C1129.238037,1684.724487 1126.610840,1682.922363 1126.878784,1680.101807 
	C1127.304077,1675.624268 1131.201172,1676.075317 1135.206421,1676.192017 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1515.201538,1097.442749 
	C1507.317871,1094.177368 1501.800415,1087.931396 1498.001953,1079.309570 
	C1504.904541,1083.510010 1509.500122,1090.634277 1515.201538,1097.442749 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1969.917969,477.292419 
	C1969.364990,478.937744 1968.729980,479.876709 1968.047485,481.407837 
	C1963.832397,482.455292 1960.857422,480.567780 1958.311401,476.613098 
	C1958.630371,474.424774 1959.260864,472.849548 1959.945557,470.637146 
	C1964.938599,469.716370 1968.293823,471.797302 1969.917969,477.292419 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1474.997559,1057.588013 
	C1467.507812,1056.985107 1463.479004,1050.609375 1458.074219,1045.402832 
	C1464.458374,1047.637573 1469.501343,1052.474609 1474.997559,1057.588013 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1856.190186,1340.899414 
	C1858.561035,1346.028076 1859.042358,1351.724243 1855.837402,1357.682739 
	C1854.146362,1352.450073 1854.883911,1346.966675 1856.190186,1340.899414 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1488.430542,1069.061768 
	C1482.093384,1069.518921 1479.320435,1064.449219 1475.972412,1059.326660 
	C1480.959106,1060.680420 1484.128418,1065.130859 1488.430542,1069.061768 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1120.315186,1575.575439 
	C1123.218262,1574.717407 1125.061768,1576.933228 1127.921265,1578.262207 
	C1128.168579,1579.695679 1128.098145,1580.679443 1127.791138,1581.583008 
	C1127.151245,1583.467529 1126.191406,1585.231079 1123.855103,1585.100220 
	C1121.557739,1584.971558 1120.589966,1583.199707 1120.274292,1581.226074 
	C1120.024292,1579.661987 1120.217651,1578.027100 1120.315186,1575.575439 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1843.423584,1170.716553 
	C1846.826416,1173.681274 1847.206421,1178.169067 1847.010498,1183.197266 
	C1843.696777,1180.088135 1843.926758,1175.616089 1843.423584,1170.716553 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1252.170166,1614.296021 
	C1254.384888,1613.608032 1255.798340,1613.559570 1257.656982,1613.570801 
	C1261.234131,1618.221558 1258.508301,1620.753906 1254.481567,1621.057861 
	C1250.620605,1621.349121 1249.823364,1618.325195 1252.170166,1614.296021 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1787.211426,1575.875977 
	C1787.422241,1580.360352 1785.527954,1584.419800 1781.335693,1587.828125 
	C1781.250244,1583.333252 1783.980957,1579.780151 1787.211426,1575.875977 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1753.285400,1630.023193 
	C1753.396484,1634.079224 1752.166748,1637.934814 1747.089600,1639.983398 
	C1747.118042,1635.948975 1750.130005,1633.256470 1753.285400,1630.023193 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2075.580322,586.700317 
	C2077.329834,592.485352 2072.233398,591.419800 2068.970215,594.300537 
	C2068.684570,588.486572 2072.419678,588.124817 2075.580322,586.700317 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1841.354126,752.735840 
	C1841.262573,756.573608 1838.871338,758.834290 1834.477539,759.833862 
	C1835.066284,756.459351 1837.822510,754.537292 1841.354126,752.735840 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1919.482666,684.675415 
	C1919.267456,688.380859 1916.974976,690.770142 1912.609619,691.846436 
	C1913.161255,688.436829 1915.900146,686.480408 1919.482666,684.675415 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1779.504028,806.686157 
	C1779.276489,810.400757 1776.976196,812.809326 1772.562256,813.861084 
	C1773.294434,810.598755 1775.843750,808.441589 1779.504028,806.686157 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1706.754272,910.653442 
	C1710.533447,910.708801 1712.700073,913.142639 1713.860962,917.339111 
	C1710.529419,916.798401 1708.488892,914.212097 1706.754272,910.653442 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1857.361816,738.705811 
	C1857.316284,742.545166 1854.890625,744.780151 1850.539062,745.853638 
	C1851.203613,742.576538 1853.951660,740.646790 1857.361816,738.705811 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1851.091797,1210.713623 
	C1855.364624,1212.142090 1853.919556,1215.548828 1853.023682,1219.218994 
	C1850.551880,1217.259521 1850.835083,1214.299683 1851.091797,1210.713623 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2264.786133,488.952515 
	C2267.610596,488.751007 2269.479736,489.600800 2268.940674,492.137787 
	C2268.509277,494.167114 2266.416504,494.110168 2264.848145,493.631042 
	C2261.830078,492.709137 2262.698486,490.962402 2264.786133,488.952515 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1825.364868,766.688354 
	C1825.292969,770.534302 1822.898804,772.822083 1818.476562,773.837769 
	C1819.077637,770.466064 1821.852783,768.548767 1825.364868,766.688354 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1468.535889,1545.296387 
	C1468.721558,1541.354004 1471.134521,1538.948730 1475.847046,1538.203003 
	C1474.081665,1540.578003 1471.619751,1542.901245 1468.535889,1545.296387 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1935.963989,675.267090 
	C1933.830444,676.506653 1931.563110,677.165344 1928.587402,677.846680 
	C1929.651245,674.614746 1931.258423,670.947266 1935.963989,675.267090 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1770.668701,994.687134 
	C1774.405518,994.809814 1774.945679,997.966125 1775.812012,1001.540283 
	C1772.758667,1000.904541 1771.922729,997.950012 1770.668701,994.687134 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1784.885254,1018.647705 
	C1788.462402,1018.979675 1789.033203,1022.034424 1789.759155,1025.614624 
	C1786.745605,1024.880127 1786.016602,1021.925415 1784.885254,1018.647705 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2047.603516,475.525085 
	C2046.351562,478.284149 2043.880249,479.152161 2040.662109,479.937622 
	C2040.705566,475.880707 2043.197632,474.361511 2047.603516,475.525085 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1773.212524,1599.859253 
	C1773.803101,1602.953369 1772.833618,1605.835938 1769.171265,1607.846191 
	C1768.652466,1604.719360 1770.500000,1602.350952 1773.212524,1599.859253 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1851.019287,1389.557617 
	C1851.857178,1391.867554 1852.740845,1394.672729 1850.302246,1397.603516 
	C1848.545654,1395.189331 1848.960693,1392.545898 1851.019287,1389.557617 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1765.403564,818.785767 
	C1765.684204,821.528442 1764.156860,823.212524 1760.880371,823.968506 
	C1760.808350,821.448120 1762.651733,819.985107 1765.403564,818.785767 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2108.385254,528.466553 
	C2108.929932,525.921448 2110.381592,524.479248 2113.359863,524.055664 
	C2113.540527,527.002991 2113.089600,530.017212 2108.385254,528.466553 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1743.265381,1643.882324 
	C1744.018555,1646.579956 1742.924194,1648.715942 1739.456665,1649.885254 
	C1738.702759,1647.116089 1740.838013,1645.704468 1743.265381,1643.882324 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1901.450439,700.487671 
	C1901.705444,703.352295 1900.224365,705.295105 1896.508423,705.835632 
	C1896.604736,703.234863 1898.689453,701.876221 1901.450439,700.487671 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1871.469238,726.544922 
	C1871.694458,729.351990 1870.241577,731.266785 1866.643433,731.872742 
	C1866.747437,729.337646 1868.680664,727.859436 1871.469238,726.544922 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1516.798096,1498.178711 
	C1515.912720,1495.291138 1517.164429,1493.225708 1520.676270,1492.077393 
	C1521.171753,1494.754150 1519.140259,1496.303955 1516.798096,1498.178711 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1699.306030,876.425171 
	C1699.745850,879.402283 1698.182129,881.237000 1694.482178,881.778320 
	C1694.468872,879.112549 1696.568481,877.794678 1699.306030,876.425171 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1848.462158,1402.763672 
	C1849.326416,1403.262329 1849.671997,1404.135376 1850.045654,1405.494385 
	C1849.562012,1406.570557 1849.050293,1407.160522 1848.171631,1407.890625 
	C1846.848999,1406.371338 1847.085571,1404.745850 1848.462158,1402.763672 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1849.439453,1200.595459 
	C1852.043823,1201.089966 1852.313721,1202.833862 1850.981201,1205.337402 
	C1849.038818,1204.533569 1849.017212,1202.877563 1849.439453,1200.595459 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1847.473999,1190.598633 
	C1850.017700,1190.994873 1850.281372,1192.717407 1849.226318,1195.189575 
	C1847.139526,1194.571167 1847.094482,1192.902954 1847.473999,1190.598633 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1721.483032,927.034424 
	C1723.922729,926.659973 1725.277588,928.220642 1725.855469,931.304688 
	C1723.571899,931.411804 1722.583496,929.551575 1721.483032,927.034424 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1767.191284,1609.683960 
	C1767.883545,1611.234741 1767.731812,1612.898315 1765.134644,1613.853760 
	C1764.384155,1612.201294 1765.395630,1611.006226 1767.191284,1609.683960 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1754.669434,970.607422 
	C1756.436768,970.267029 1757.554199,971.178528 1757.797119,973.599976 
	C1756.138306,973.810120 1755.313721,972.581970 1754.669434,970.607422 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1732.394287,940.596558 
	C1734.176636,940.228149 1735.471069,941.039124 1735.757080,943.609253 
	C1734.065430,943.831543 1733.127197,942.634033 1732.394287,940.596558 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1885.479248,714.501038 
	C1885.802979,716.164612 1885.037964,717.455627 1882.585449,717.874573 
	C1882.341187,716.260315 1883.560913,715.356750 1885.479248,714.501038 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1738.604858,948.614624 
	C1740.360352,948.242249 1741.510742,949.120239 1741.812256,951.539185 
	C1740.151489,951.792603 1739.284302,950.593079 1738.604858,948.614624 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1744.714355,956.608032 
	C1746.453369,956.262634 1747.550781,957.153442 1747.815430,959.515381 
	C1746.189331,959.735657 1745.331299,958.571533 1744.714355,956.608032 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1745.426758,836.415161 
	C1745.801514,838.105469 1745.044800,839.391846 1742.600830,839.814087 
	C1742.279541,838.144348 1743.455566,837.211670 1745.426758,836.415161 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1750.566528,964.644531 
	C1752.412354,964.282715 1753.554565,965.228882 1753.718750,967.770386 
	C1752.084595,967.876526 1751.241699,966.630005 1750.566528,964.644531 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1779.317383,1589.950317 
	C1779.908447,1591.371216 1779.677856,1592.864502 1777.456787,1593.845703 
	C1776.638550,1592.283936 1777.600708,1591.166382 1779.317383,1589.950317 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1521.399414,1105.407471 
	C1519.489502,1105.764282 1518.292603,1104.803467 1518.212036,1102.135864 
	C1520.092773,1101.858643 1520.569580,1103.498901 1521.399414,1105.407471 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1776.722900,1004.595459 
	C1778.575684,1004.330994 1779.637695,1005.343323 1779.709717,1007.839233 
	C1778.066040,1007.889465 1777.239746,1006.648987 1776.722900,1004.595459 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1715.327881,862.466614 
	C1715.800293,864.165344 1715.027588,865.388916 1712.635864,865.848267 
	C1712.229248,864.181396 1713.365601,863.246582 1715.327881,862.466614 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2002.083008,582.586060 
	C2002.887817,581.997375 2003.775757,581.997253 2005.329346,581.996094 
	C2005.527100,583.014404 2005.316406,584.532349 2004.531494,584.937500 
	C2003.319214,585.563171 2002.515503,584.393005 2002.083008,582.586060 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1780.455200,1010.664795 
	C1782.520020,1010.351318 1783.711914,1011.415222 1783.545288,1014.275574 
	C1781.892456,1014.161804 1780.973267,1012.871643 1780.455200,1010.664795 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1793.414307,794.558899 
	C1793.812866,796.198059 1793.074707,797.434998 1790.725586,797.912537 
	C1790.393311,796.322998 1791.493652,795.363586 1793.414307,794.558899 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2132.834961,563.909546 
	C2133.612793,562.485107 2134.396973,562.470398 2135.091064,563.484253 
	C2135.236328,563.696472 2135.231201,564.189087 2135.080566,564.396545 
	C2134.359375,565.389709 2133.575928,565.352844 2132.834961,563.909546 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1807.481201,782.449219 
	C1807.825195,784.103333 1807.086304,785.434021 1804.604980,785.889404 
	C1804.326538,784.256958 1805.494263,783.293640 1807.481201,782.449219 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1852.231445,1378.498291 
	C1853.814209,1379.171997 1854.034668,1380.207275 1852.586182,1381.634644 
	C1850.982300,1380.942505 1851.243408,1379.859619 1852.231445,1378.498291 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1799.097168,1553.371094 
	C1799.841675,1554.824829 1799.941772,1556.561157 1797.433838,1557.794922 
	C1796.542236,1556.198120 1797.501709,1554.923706 1799.097168,1553.371094 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1731.452148,848.516052 
	C1731.806030,850.162842 1731.036499,851.398804 1728.694458,851.871033 
	C1728.316162,850.204651 1729.428589,849.240784 1731.452148,848.516052 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M1803.063232,1545.327393 
	C1803.835205,1546.786987 1803.946289,1548.532593 1801.431274,1549.796875 
	C1800.463257,1548.177490 1801.418335,1546.885376 1803.063232,1545.327393 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2024.350342,482.440887 
	C2024.938477,481.364655 2025.877075,480.729340 2027.407715,480.046997 
	C2027.621582,481.786346 2027.698120,484.093689 2024.350342,482.440887 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1687.522949,886.888184 
	C1687.930054,887.447937 1687.941772,887.976013 1687.842163,889.287720 
	C1685.874512,889.310242 1686.008545,888.175720 1687.522949,886.888184 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1687.978760,890.740540 
	C1688.589966,890.327087 1689.126099,890.675720 1689.606934,891.774963 
	C1689.178955,891.913086 1688.629761,891.572144 1687.978760,890.740540 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1719.094238,859.636841 
	C1719.205566,860.093140 1718.789673,860.727844 1717.781494,861.441895 
	C1717.648438,860.952576 1718.107666,860.383972 1719.094238,859.636841 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1911.376953,692.062378 
	C1911.482788,692.471313 1911.090088,693.002563 1910.208740,693.671143 
	C1910.106201,693.267090 1910.492432,692.725830 1911.376953,692.062378 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M1703.066406,873.640930 
	C1703.175171,874.101990 1702.754395,874.729858 1701.740479,875.426147 
	C1701.610474,874.932373 1702.073608,874.370056 1703.066406,873.640930 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M2062.482910,1224.008057 
	C2056.966309,1223.882568 2051.806396,1224.426514 2050.337891,1218.457031 
	C2049.434326,1214.783936 2052.408936,1213.089233 2060.604004,1211.971680 
	C2062.219727,1211.751343 2063.907227,1211.590942 2065.390869,1210.984985 
	C2067.418457,1210.156982 2069.085693,1207.459473 2071.554443,1209.147217 
	C2074.790039,1211.358765 2078.747803,1212.751587 2080.888672,1216.335938 
	C2082.833496,1219.592041 2081.306641,1223.156372 2077.254150,1223.672363 
	C2072.690186,1224.253418 2068.011719,1223.935669 2062.482910,1224.008057 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M2138.475098,1228.242432 
	C2139.568115,1228.118774 2139.914062,1228.060181 2140.232422,1228.128662 
	C2144.151611,1228.972168 2148.364258,1229.662109 2149.506104,1234.331177 
	C2150.229980,1237.290283 2147.513916,1238.265503 2145.410889,1239.145996 
	C2140.913330,1241.028931 2133.599365,1239.909302 2131.289795,1237.104370 
	C2129.754150,1235.239502 2130.032959,1233.192139 2131.719727,1231.818115 
	C2133.484619,1230.380615 2135.697754,1229.494019 2138.475098,1228.242432 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M1908.705322,1182.819092 
	C1912.343872,1180.188110 1915.452271,1180.602295 1918.728760,1181.887939 
	C1920.954834,1182.761475 1923.471069,1183.350342 1923.191162,1186.343872 
	C1922.954346,1188.876343 1920.941650,1190.471924 1918.745483,1191.295898 
	C1914.712280,1192.808960 1910.764893,1192.152710 1907.531738,1189.305542 
	C1905.262573,1187.307129 1906.318726,1185.124268 1908.705322,1182.819092 
z"/>
<path fill="#F34500" opacity="1.000000" stroke="none" 
	d="
M1999.941406,1206.694092 
	C1995.713867,1208.549316 1992.220093,1208.301025 1988.908203,1206.317993 
	C1985.780518,1204.445190 1985.555908,1201.148193 1988.353882,1199.202881 
	C1991.511230,1197.007812 1999.667725,1197.658936 2002.265381,1200.584106 
	C2004.505615,1203.106934 2002.080322,1204.636475 1999.941406,1206.694092 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2023.916382,783.144836 
	C2026.634399,783.764343 2027.834229,786.316956 2029.110107,789.392822 
	C2025.554810,789.443848 2024.152222,787.116455 2023.916382,783.144836 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1960.121582,702.645630 
	C1962.713745,702.663635 1964.117554,704.659973 1965.429932,707.443359 
	C1962.627930,707.695435 1960.748291,706.219177 1960.121582,702.645630 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2004.192383,756.343262 
	C2005.835693,756.161072 2006.741333,757.378174 2007.474365,759.384399 
	C2005.690430,759.745605 2004.463013,758.883545 2004.192383,756.343262 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M2042.234619,810.324402 
	C2043.869995,810.272888 2044.653198,811.544373 2045.173218,813.601562 
	C2043.502930,813.692322 2042.387085,812.728455 2042.234619,810.324402 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M2030.274414,792.407837 
	C2031.926880,792.275757 2032.728760,793.486206 2033.212402,795.517822 
	C2031.526123,795.682922 2030.433228,794.761475 2030.274414,792.407837 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2000.084717,750.740601 
	C2000.821411,750.935059 2001.613281,751.745605 2002.524414,753.130920 
	C2001.317261,753.446655 2000.480103,752.666443 2000.084717,750.740601 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M1968.456299,711.968140 
	C1968.917358,711.827637 1969.518799,712.248108 1970.301758,713.198486 
	C1969.854492,713.328613 1969.225586,712.928833 1968.456299,711.968140 
z"/>
<path fill="#EF3B01" opacity="1.000000" stroke="none" 
	d="
M2186.856689,1274.978760 
	C2189.227539,1276.567139 2188.658447,1279.321777 2188.661133,1281.895142 
	C2188.675293,1296.069214 2189.202148,1310.251099 2187.684082,1325.038696 
	C2184.953125,1322.002319 2186.059326,1317.949097 2186.053223,1314.091187 
	C2186.032471,1301.275757 2186.281738,1288.460083 2186.856689,1274.978760 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2181.712891,1398.397339 
	C2181.817383,1397.690796 2182.176758,1397.475708 2183.103027,1396.987671 
	C2183.537354,1397.470337 2183.404541,1398.226196 2182.892822,1399.416992 
	C2182.331787,1399.530884 2182.149658,1399.209839 2181.712891,1398.397339 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2242.967041,1235.189453 
	C2239.936279,1232.394409 2238.072021,1229.655762 2238.403564,1226.077148 
	C2238.796143,1221.844727 2242.365723,1218.224365 2245.968506,1218.130859 
	C2250.424316,1218.015137 2256.971924,1222.473022 2257.606445,1226.103882 
	C2258.153809,1229.235229 2256.251709,1231.318726 2253.943359,1232.600830 
	C2250.807129,1234.342773 2247.435547,1235.853027 2242.967041,1235.189453 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2228.530518,1200.415039 
	C2231.567139,1200.725708 2233.574219,1201.633667 2232.913086,1204.562744 
	C2232.794678,1205.086304 2231.229980,1205.775391 2230.548096,1205.591431 
	C2228.022949,1204.910156 2225.427734,1203.978271 2228.530518,1200.415039 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2101.748047,695.934387 
	C2097.943115,695.938293 2094.208740,696.479431 2093.106201,693.111877 
	C2091.702881,688.825012 2088.925781,684.382019 2090.591553,679.744568 
	C2092.568115,674.241577 2098.633301,676.196350 2102.680908,674.372192 
	C2105.482666,673.109314 2107.662109,675.194458 2108.907715,677.880371 
	C2109.046875,678.180786 2109.216064,678.467957 2109.379150,678.756775 
	C2116.053955,690.566711 2115.351562,692.337097 2101.748047,695.934387 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2304.208252,1565.929199 
	C2301.655273,1561.816040 2298.703857,1558.292969 2302.905518,1554.056763 
	C2307.396729,1549.528687 2312.482422,1547.072021 2318.930176,1548.291260 
	C2322.292969,1548.927002 2322.186035,1552.169067 2323.097412,1554.469238 
	C2324.991211,1559.248901 2323.932861,1563.341553 2320.075928,1567.004028 
	C2316.292480,1570.596802 2312.533203,1570.490601 2308.352783,1568.162842 
	C2307.198242,1567.519775 2306.011475,1566.934814 2304.208252,1565.929199 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2328.000000,1544.879639 
	C2330.448486,1543.080078 2331.911377,1540.456909 2335.349609,1540.062012 
	C2339.280029,1539.749390 2341.896729,1540.774048 2342.932373,1544.125244 
	C2343.990234,1547.549438 2344.951172,1551.019165 2345.673828,1554.526855 
	C2346.297363,1557.554688 2345.064209,1559.171387 2341.765381,1560.003784 
	C2329.360352,1563.133789 2328.086670,1562.297119 2328.000977,1549.694092 
	C2327.992188,1548.382446 2328.000000,1547.070923 2328.000000,1544.879639 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2294.471191,1567.314697 
	C2291.823242,1571.820557 2288.851318,1573.572144 2285.419922,1569.872070 
	C2283.321533,1567.609253 2280.864502,1564.517578 2284.024414,1561.195068 
	C2286.963867,1558.104736 2290.210449,1556.010742 2293.865234,1561.303711 
	C2295.155518,1563.371826 2295.480225,1564.912842 2294.471191,1567.314697 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M2321.568848,1577.406128 
	C2320.050293,1581.256104 2318.102051,1584.299927 2314.225830,1583.498779 
	C2310.034912,1582.632690 2309.296143,1578.937500 2308.677734,1574.631958 
	C2313.476074,1574.696411 2318.012451,1571.621216 2321.568848,1577.406128 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2294.660645,1567.892090 
	C2294.000000,1566.500000 2294.000000,1565.000000 2294.000000,1562.750000 
	C2298.328369,1563.040039 2299.221191,1564.864868 2294.660645,1567.892090 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2251.908691,1291.363892 
	C2250.198486,1291.830933 2248.636963,1291.325928 2248.091064,1288.635986 
	C2249.802002,1288.168213 2251.362793,1288.673950 2251.908691,1291.363892 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2308.752930,1255.693970 
	C2309.976562,1258.251953 2310.265381,1260.284546 2309.549072,1262.197998 
	C2307.834717,1266.777710 2302.909668,1269.096558 2299.163330,1267.275513 
	C2295.543457,1265.516113 2293.016846,1258.568115 2294.738037,1255.106812 
	C2296.595459,1251.372314 2301.600098,1249.932129 2305.764893,1252.151611 
	C2306.848633,1252.729126 2307.537109,1254.048218 2308.752930,1255.693970 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2153.850098,256.153625 
	C2152.532959,257.685547 2151.694336,258.984009 2150.571777,259.312561 
	C2147.018555,260.352386 2143.229004,260.929535 2140.928223,257.052155 
	C2139.111572,253.990601 2141.245605,251.340683 2142.783203,248.893890 
	C2144.892334,245.537292 2148.500244,245.215622 2151.547607,246.516098 
	C2155.424561,248.170639 2156.420654,251.564056 2153.850098,256.153625 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2110.918457,312.927063 
	C2108.913330,309.811584 2106.985596,307.135895 2109.243408,304.176117 
	C2111.696045,300.961243 2114.864258,297.809235 2119.157959,299.090149 
	C2122.998779,300.236084 2124.269531,303.927490 2123.947021,307.989441 
	C2123.550293,312.981476 2120.028320,314.658783 2115.914062,315.236938 
	C2114.527588,315.431732 2112.925049,314.089905 2110.918457,312.927063 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1753.118408,386.525970 
	C1751.122681,395.740967 1743.250000,395.561096 1736.924561,397.615417 
	C1735.368896,398.120636 1733.917969,396.648804 1732.821289,395.293549 
	C1726.684448,387.709808 1731.935913,374.111755 1741.658081,372.412689 
	C1744.307495,371.949677 1746.265259,372.962219 1747.477905,375.198029 
	C1749.374390,378.694763 1751.081299,382.294464 1753.118408,386.525970 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1958.462402,406.710388 
	C1951.828125,409.451324 1948.411621,406.420135 1945.809082,401.530640 
	C1943.169189,396.570831 1945.610107,392.471680 1948.425415,388.853912 
	C1951.489624,384.916290 1956.619141,385.248383 1961.739014,389.065643 
	C1966.243652,392.424286 1967.403076,397.630920 1964.524536,402.123230 
	C1963.247314,404.116547 1961.320190,405.431274 1958.462402,406.710388 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1929.428711,419.886108 
	C1937.521484,412.362183 1943.144287,412.353729 1948.087036,419.224976 
	C1951.249634,423.621582 1950.565796,427.774719 1946.132080,431.099609 
	C1941.903564,434.270691 1935.807739,435.114014 1932.239746,432.755890 
	C1927.619019,429.701904 1927.103271,425.390106 1929.428711,419.886108 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1848.308594,412.335388 
	C1844.342773,415.070496 1841.050537,416.803040 1836.734863,414.411469 
	C1830.962769,411.212677 1828.506836,406.603851 1830.562500,401.437897 
	C1832.360474,396.920044 1839.546021,393.339233 1843.653564,394.914276 
	C1849.225098,397.050720 1852.325195,403.652588 1850.309692,409.220459 
	C1849.976562,410.140594 1849.335449,410.949280 1848.308594,412.335388 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1839.397705,485.541870 
	C1835.620239,488.866089 1832.668335,488.012695 1830.235962,485.039673 
	C1828.785400,483.266571 1827.583496,481.193634 1826.690796,479.077850 
	C1823.398193,471.273804 1827.789307,464.652405 1836.291016,464.349365 
	C1837.734985,464.297882 1838.720825,464.909302 1839.754883,465.878265 
	C1846.801880,472.482086 1846.880249,477.698822 1839.397705,485.541870 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1861.739258,449.523743 
	C1860.323608,453.106628 1858.186157,455.269958 1855.639038,456.846039 
	C1851.868530,459.179260 1846.820801,458.285004 1843.943481,454.707672 
	C1841.452026,451.609985 1838.967163,448.484070 1842.546021,444.155548 
	C1846.011963,439.963928 1850.341309,437.645447 1854.390747,439.326019 
	C1858.531128,441.044342 1862.102051,443.476379 1861.739258,449.523743 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1816.752197,511.781921 
	C1808.509766,504.338928 1808.313354,499.611969 1815.620361,495.336517 
	C1818.241821,493.802704 1821.066284,490.943481 1824.540039,493.764160 
	C1827.654541,496.292999 1830.255981,499.035522 1830.014404,503.640381 
	C1829.777710,508.151062 1826.819824,509.913025 1823.319702,511.138123 
	C1821.518799,511.768494 1819.465454,511.677521 1816.752197,511.781921 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1862.064941,385.890076 
	C1853.919189,388.308533 1846.312378,384.529907 1844.289062,377.775787 
	C1842.585327,372.088531 1844.511475,368.358887 1850.263916,366.205994 
	C1857.004639,363.683228 1862.927368,364.949219 1864.744263,369.990204 
	C1866.651489,375.281555 1867.817017,380.916016 1862.064941,385.890076 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1938.704346,319.873596 
	C1938.330444,316.450287 1940.582886,313.270142 1939.998779,308.773193 
	C1945.512207,312.033722 1945.453003,313.209412 1938.704346,319.873596 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1937.306152,292.317261 
	C1939.503662,291.998383 1941.002441,291.999176 1943.250610,292.000610 
	C1944.239502,295.086823 1940.833252,296.102234 1940.097778,299.346863 
	C1938.892700,299.654510 1937.790161,299.307800 1936.343872,298.481171 
	C1934.298584,295.997528 1935.005005,294.266479 1937.306152,292.317261 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1968.066406,306.576538 
	C1969.104004,306.346161 1970.207886,306.693054 1971.656006,307.520569 
	C1970.183838,310.124390 1968.944458,309.615082 1968.066406,306.576538 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1659.401611,275.411224 
	C1651.369873,268.412872 1650.864136,263.066101 1656.972900,257.046661 
	C1661.800293,252.289673 1667.384644,253.370422 1670.140503,259.605408 
	C1670.807861,261.115356 1671.482422,262.626007 1672.058350,264.171906 
	C1674.505981,270.743774 1671.943359,275.114868 1665.061890,275.931366 
	C1663.446533,276.123016 1661.769531,275.793427 1659.401611,275.411224 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1624.000000,339.251038 
	C1620.957031,339.015076 1617.914062,338.028900 1614.435547,336.522156 
	C1616.290283,333.105499 1619.541260,334.266693 1623.227051,334.000000 
	C1624.000000,335.500305 1624.000000,337.000580 1624.000000,339.251038 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1142.000000,391.720154 
	C1130.631592,397.504730 1129.793701,396.971619 1129.963989,385.414612 
	C1130.013550,382.051239 1130.425171,378.901093 1132.080078,375.893311 
	C1134.236206,371.974457 1137.663330,371.540649 1141.433716,372.325104 
	C1145.590576,373.189941 1146.424561,376.528778 1145.817383,379.972870 
	C1145.141724,383.804474 1143.731079,387.506439 1142.000000,391.720154 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1098.437012,363.408478 
	C1103.022827,357.534637 1108.789062,360.003510 1113.903320,360.810455 
	C1116.776245,361.263702 1118.121094,364.887756 1117.543945,368.066864 
	C1116.840698,371.942413 1114.246216,374.438446 1110.490112,375.516388 
	C1107.427246,376.395325 1104.463379,376.059418 1102.721802,373.028259 
	C1101.094849,370.196350 1099.847900,367.146088 1098.437012,363.408478 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1143.043945,352.574005 
	C1145.488403,348.990906 1148.344360,347.880432 1151.924683,347.975586 
	C1155.849243,348.079895 1159.170044,348.674408 1159.890991,353.413727 
	C1160.640137,358.337402 1157.694458,362.819031 1152.407227,364.747925 
	C1147.654053,366.481903 1145.795410,363.256256 1144.323242,359.868805 
	C1143.429932,357.813171 1143.224243,355.458740 1143.043945,352.574005 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1191.297363,295.481537 
	C1191.998779,297.637543 1192.082397,299.282684 1191.982544,300.916656 
	C1191.453979,309.576202 1186.503174,311.935089 1178.153198,306.730835 
	C1174.403076,295.335541 1177.744995,292.408813 1191.297363,295.481537 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1191.829834,295.249634 
	C1190.676758,295.913086 1189.351318,295.854034 1188.030762,295.739990 
	C1179.460938,294.999939 1178.756348,295.604431 1177.997070,305.200989 
	C1172.949585,305.381042 1173.732666,300.808411 1172.497070,297.676636 
	C1172.237915,297.020020 1172.816650,295.708466 1173.414917,295.093353 
	C1176.217041,292.212677 1186.839844,291.942657 1191.829834,295.249634 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2296.109863,33.847824 
	C2293.572266,33.588814 2292.164795,32.608532 2291.648682,30.973534 
	C2290.581787,27.595583 2285.641846,24.258318 2290.227539,20.657534 
	C2293.864746,17.801636 2300.945068,20.525587 2303.508545,25.046118 
	C2304.302979,26.447157 2304.807129,28.012798 2305.629883,29.937490 
	C2303.213379,32.638691 2299.884521,32.944450 2296.109863,33.847824 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1472.668457,350.718140 
	C1471.000366,351.219696 1469.840454,351.894073 1469.118042,351.575714 
	C1464.340210,349.470001 1462.308350,341.285583 1464.160278,333.103210 
	C1465.524536,327.075836 1470.952759,327.346619 1475.082886,326.327881 
	C1479.611328,325.210876 1484.103638,328.834290 1485.511597,333.477417 
	C1487.234375,339.158691 1484.578735,345.385742 1478.936035,348.423187 
	C1477.220459,349.346680 1475.238892,349.776062 1472.668457,350.718140 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1420.577271,385.933533 
	C1420.346558,384.896149 1420.692993,383.792297 1421.519775,382.344238 
	C1424.124268,383.815125 1423.616333,385.054718 1420.577271,385.933533 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1539.798828,430.355225 
	C1537.400513,430.638000 1535.142822,430.143646 1532.345337,429.223938 
	C1531.902710,426.171936 1532.515015,423.399658 1531.277344,420.994385 
	C1529.334717,417.219391 1531.010620,413.910950 1532.180786,410.556946 
	C1533.833008,405.821442 1537.900146,404.202454 1542.333130,404.231567 
	C1547.435181,404.265045 1549.365723,408.514587 1551.125366,412.477234 
	C1553.040161,416.789520 1551.419434,420.114258 1547.917847,422.824219 
	C1545.160767,424.958160 1540.870972,425.288116 1539.798828,430.355225 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1624.684448,355.882751 
	C1624.659302,353.157227 1625.318604,350.315674 1625.989014,346.736450 
	C1631.048462,349.234375 1630.984985,350.216919 1624.684448,355.882751 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1523.922241,425.847290 
	C1522.057617,426.161987 1520.125366,425.778931 1517.621460,424.904114 
	C1519.371216,424.166870 1522.101074,420.153168 1523.922241,425.847290 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1785.926514,16.093658 
	C1793.933716,18.926149 1795.123901,21.471321 1792.283325,27.395468 
	C1790.461426,31.195208 1787.491211,33.608368 1783.679199,35.049454 
	C1778.565308,36.982849 1776.483521,35.583675 1776.017822,30.074448 
	C1775.160278,19.930326 1775.495361,19.417427 1785.926514,16.093658 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1351.869385,358.821411 
	C1350.863159,354.939728 1349.353271,351.955994 1348.683105,348.794281 
	C1347.827393,344.756378 1346.420776,340.291168 1351.343628,337.462585 
	C1355.327026,335.173645 1361.672852,335.350067 1365.164795,338.368408 
	C1368.123169,340.925476 1370.665771,343.963593 1373.696167,347.395660 
	C1377.267334,352.804565 1372.011597,355.686462 1370.875610,360.243805 
	C1367.167480,363.219482 1363.477783,364.058960 1358.790527,364.359863 
	C1355.055176,363.874481 1352.637573,362.763336 1351.869385,358.821411 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1369.555542,360.506958 
	C1370.114258,356.044434 1373.090942,353.131714 1373.923828,348.707275 
	C1375.608398,348.499054 1377.216919,348.995667 1379.412598,349.747375 
	C1374.589600,358.492493 1373.737183,358.764008 1376.540161,367.563599 
	C1378.712036,374.381561 1375.777710,376.600586 1370.724121,378.619049 
	C1364.486084,381.110657 1360.976929,385.304657 1361.997192,393.189331 
	C1355.661255,388.904846 1347.277954,389.035950 1340.168823,384.746277 
	C1351.388916,377.727020 1351.388916,377.727020 1349.688965,362.618225 
	C1350.346436,360.896637 1350.692871,359.793274 1351.519653,358.346191 
	C1352.930908,360.077515 1354.381958,361.520203 1357.359863,361.943115 
	C1358.225098,362.244446 1358.426025,362.516754 1358.679077,362.726379 
	C1361.737305,365.261230 1359.719116,372.953400 1365.888794,371.544708 
	C1370.769287,370.430328 1367.370605,364.424042 1369.555542,360.506958 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1349.177612,362.000122 
	C1351.564331,365.634094 1353.890503,368.904449 1354.043823,373.154053 
	C1354.318848,380.784607 1353.084229,382.624451 1345.657959,383.912384 
	C1344.360962,384.137360 1342.997681,383.980286 1340.832520,384.000427 
	C1339.356689,383.849670 1338.551880,383.893555 1338.094971,383.516235 
	C1333.559937,379.771423 1329.825684,374.714569 1331.143311,369.122711 
	C1332.539429,363.197174 1339.305786,363.289429 1344.379761,362.091675 
	C1345.641846,361.793793 1347.026733,362.016754 1349.177612,362.000122 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1955.894409,275.249451 
	C1955.361816,275.903564 1954.672729,275.929230 1954.093018,275.690033 
	C1946.274414,272.464294 1939.679688,273.250244 1934.630493,281.665649 
	C1932.743530,282.742889 1931.486816,282.373505 1930.234375,281.977966 
	C1926.537842,280.810425 1922.951538,280.720856 1920.426758,284.160675 
	C1918.173218,287.230804 1919.445923,290.434540 1920.845337,293.487244 
	C1921.667358,295.280701 1922.856567,296.877228 1923.839355,299.337585 
	C1923.948242,303.931305 1920.665649,306.128357 1918.528809,309.611511 
	C1911.958740,308.630310 1906.489990,305.691620 1899.870850,305.647980 
	C1892.844604,305.601654 1889.220337,293.739380 1893.860718,287.385590 
	C1895.811890,284.713898 1898.264526,282.494598 1901.772217,281.753693 
	C1906.978638,280.654022 1908.479126,277.065369 1908.024292,272.134949 
	C1907.587280,267.398438 1908.145874,263.075470 1912.232056,259.640533 
	C1918.279297,254.557220 1924.410034,254.684021 1929.535034,260.661621 
	C1931.021240,262.395172 1932.100098,264.492065 1933.272949,266.477203 
	C1935.535645,270.307770 1938.328003,271.924316 1943.123779,270.752045 
	C1947.710693,269.630798 1953.171875,267.929169 1955.894409,275.249451 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1958.577393,217.933563 
	C1958.346558,216.896088 1958.692993,215.792145 1959.519775,214.343719 
	C1962.123413,215.814178 1961.616943,217.054382 1958.577393,217.933563 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1562.074951,180.678848 
	C1565.054443,180.157166 1567.182617,181.480362 1567.924927,185.321747 
	C1564.945557,185.843307 1562.817383,184.520279 1562.074951,180.678848 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2085.422852,214.065521 
	C2085.653564,215.102875 2085.307129,216.207001 2084.480469,217.655579 
	C2081.875244,216.184738 2082.385010,214.945297 2085.422852,214.065521 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1405.301270,370.085999 
	C1405.379517,372.208954 1404.758911,374.415436 1404.066772,377.310974 
	C1401.972900,377.725128 1400.157959,377.094818 1400.335083,374.600372 
	C1400.517090,372.037048 1402.235718,370.739258 1405.301270,370.085999 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1924.768311,299.987549 
	C1917.602661,297.320465 1915.864990,291.755402 1916.220947,285.719818 
	C1916.646484,278.501526 1925.477905,276.223572 1933.424805,281.565002 
	C1933.718384,285.577179 1937.325684,287.415802 1937.929443,291.312866 
	C1937.372681,293.573639 1936.740601,295.149750 1936.054199,297.363525 
	C1932.284058,297.447754 1929.148315,299.973083 1924.768311,299.987549 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M810.531494,857.237549 
	C814.424683,855.679504 818.427856,856.037659 822.362061,854.967163 
	C828.847839,853.202454 831.357910,854.779236 833.941528,860.873108 
	C834.199097,861.480713 834.275391,862.163025 834.507446,862.783875 
	C837.678467,871.266357 839.138184,872.623596 844.016296,871.659912 
	C851.828064,870.116638 855.757202,865.768005 855.998169,858.398987 
	C856.361816,847.280762 857.166992,846.167419 864.145813,843.633118 
	C867.378235,842.459290 869.845825,842.456299 872.150757,845.138977 
	C873.448547,846.649475 875.355530,847.789917 876.226318,849.487732 
	C880.212341,857.259644 885.789124,859.848816 894.217224,856.439636 
	C897.755798,855.008240 900.493408,857.113586 902.249146,860.528198 
	C903.678101,863.307312 904.079224,866.171997 903.999573,869.207153 
	C903.820435,876.033630 899.212646,879.356384 892.741211,877.242798 
	C888.453613,875.842468 885.581970,872.544373 882.487000,869.523621 
	C880.146423,867.239075 878.163391,864.474365 874.442383,864.047852 
	C868.805969,863.401855 862.776550,866.981201 862.098145,871.598389 
	C861.200195,877.709534 865.925476,885.227112 871.751587,885.793457 
	C876.829590,886.287048 881.701050,886.548279 885.657471,891.364624 
	C886.954346,900.097534 885.912048,902.408020 880.224060,904.809937 
	C874.012146,907.433228 871.433838,906.320557 868.965637,899.881592 
	C868.253052,898.022644 867.748901,896.082397 867.007996,894.236023 
	C865.731445,891.054626 863.303833,889.072327 859.995911,890.489319 
	C856.272766,892.084106 851.985657,891.069763 848.057251,894.103943 
	C837.014038,887.128540 829.323608,876.537231 819.096924,867.701294 
	C817.758667,864.258118 815.019409,862.633728 812.259521,860.288635 
	C811.157898,859.367188 810.774475,858.643616 810.531494,857.237549 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M835.114258,917.847900 
	C839.032959,917.677734 842.139954,918.971558 845.226929,920.128479 
	C848.444153,921.334229 852.383179,927.667175 851.215027,930.421570 
	C849.491089,934.486389 846.544434,937.714661 841.611816,937.935913 
	C837.143127,938.136414 832.620483,938.222229 832.055298,932.056213 
	C831.864258,929.972290 831.170166,928.197815 828.907471,926.498230 
	C828.296021,926.138855 828.215210,925.193054 828.206177,924.718506 
	C829.536377,922.348633 831.296570,920.823242 833.200378,918.502808 
	C833.633911,917.962524 834.618958,917.856323 835.114258,917.847900 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M770.754883,1005.636353 
	C772.965576,1006.483887 774.886414,1007.169434 776.430298,1008.348572 
	C782.536438,1013.011902 781.188599,1021.862915 774.056763,1024.897705 
	C769.926575,1026.655151 765.631287,1025.773560 760.507751,1025.901611 
	C760.080322,1022.066040 762.955383,1019.341064 764.166260,1015.152710 
	C765.776917,1011.978760 767.420166,1009.566528 769.055054,1006.422363 
	C769.374878,1005.885254 770.291748,1005.701172 770.754883,1005.636353 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M850.613647,898.961914 
	C854.650391,898.457031 858.325378,894.102600 861.952332,897.628845 
	C865.970337,901.535278 863.496521,906.131592 862.099854,911.223267 
	C860.667969,913.320923 859.098206,913.497864 856.688782,912.475708 
	C851.592529,912.190491 847.379883,912.127808 848.061218,905.033752 
	C848.087708,903.907654 848.098572,903.553894 848.138123,902.670105 
	C848.867126,901.232056 849.648438,900.388306 850.613647,898.961914 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M807.098389,951.797424 
	C810.881714,956.068542 813.846130,961.163635 811.100464,966.141479 
	C808.126953,971.532471 801.865967,969.909241 795.722778,969.715332 
	C795.803101,967.576477 796.830200,965.541382 798.004639,962.838867 
	C799.541382,960.629272 800.441040,958.788391 801.835327,956.582886 
	C802.331543,956.219238 802.029419,956.147949 802.165161,956.223267 
	C803.032959,955.135010 803.940186,954.105957 805.232361,952.509155 
	C805.660461,951.974487 806.616394,951.831726 807.098389,951.797424 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M810.059692,856.309387 
	C810.872681,857.357117 811.193970,858.095154 811.588989,859.429810 
	C810.871338,860.003357 810.080017,859.980225 808.694092,859.942261 
	C801.835999,857.488770 798.110718,852.449036 794.423462,846.411377 
	C793.072205,844.727783 792.114929,843.599426 790.650208,842.234497 
	C787.744324,837.037231 781.821838,834.847046 780.140991,828.622620 
	C785.908508,830.462158 788.858276,836.215942 794.247559,840.115234 
	C798.227234,840.663818 800.243042,842.678040 801.535522,846.443237 
	C803.536255,850.786804 806.869019,853.107056 810.059692,856.309387 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M786.141846,981.184082 
	C790.910522,982.338501 795.326355,983.623047 795.107117,989.034607 
	C794.921021,993.627625 789.132690,996.431763 782.640808,995.560364 
	C781.768005,995.443176 780.993103,994.596985 779.722290,993.396362 
	C779.130188,992.263000 778.988708,991.821594 779.013123,990.705017 
	C779.428955,989.795532 779.678833,989.561279 780.072998,988.833862 
	C780.905151,987.226135 781.779480,986.243042 782.817383,984.576904 
	C783.400757,983.765442 783.645935,983.513977 784.029663,982.754211 
	C784.407166,981.533020 784.912048,981.140930 786.141846,981.184082 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M754.173706,1035.249512 
	C756.324402,1036.495361 758.273438,1037.312134 759.505188,1038.745361 
	C763.816711,1043.762329 761.861389,1049.995605 755.399048,1051.672852 
	C753.241089,1052.232788 750.819397,1051.776855 747.630737,1051.678711 
	C746.107666,1047.534668 749.259521,1044.788696 750.471436,1040.650513 
	C751.165527,1039.280029 751.632507,1038.562866 752.202271,1037.205078 
	C752.417664,1035.771851 752.880676,1035.300293 754.173706,1035.249512 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M740.415405,1063.399170 
	C745.938293,1064.179565 746.291748,1067.666870 745.891907,1071.458374 
	C745.301819,1077.054321 741.107056,1077.644653 735.851929,1077.755859 
	C733.863831,1075.274048 735.729553,1073.415039 736.350830,1070.649170 
	C737.167297,1068.807129 737.808350,1067.612915 738.469360,1065.728760 
	C738.431763,1064.076782 738.892029,1063.485596 740.415405,1063.399170 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M741.189392,1062.917725 
	C740.394531,1063.782471 739.839417,1064.118652 738.929199,1064.816650 
	C739.452515,1055.607056 744.938354,1048.215576 750.141113,1040.221069 
	C751.162781,1043.989746 748.033508,1046.704102 746.908447,1050.881104 
	C744.943665,1055.131226 743.144104,1058.690430 741.189392,1062.917725 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M718.430176,1116.215576 
	C717.772400,1124.563721 714.816956,1132.656494 711.025208,1141.372070 
	C711.784180,1133.192261 713.477966,1124.417969 718.430176,1116.215576 
z"/>
<path fill="#E72600" opacity="1.000000" stroke="none" 
	d="
M709.755859,1142.628906 
	C710.089844,1141.966309 710.577576,1141.984375 710.820129,1141.986328 
	C711.596863,1149.397339 707.992188,1155.855347 705.737976,1163.199707 
	C704.135376,1156.350342 705.974365,1149.653442 709.755859,1142.628906 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M794.028809,846.604736 
	C799.227295,849.410706 803.246277,854.191101 807.778748,859.349243 
	C807.000916,861.317017 805.021912,862.668213 803.979614,861.344849 
	C800.445312,856.857788 794.366333,854.098999 794.028809,846.604736 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M735.980835,1070.256714 
	C737.416504,1072.387817 735.694458,1074.236328 735.115112,1077.012451 
	C733.176331,1081.189819 731.343445,1084.696777 728.969238,1088.607788 
	C728.822998,1082.110107 731.318115,1076.003784 735.980835,1070.256714 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M821.849976,933.588928 
	C825.116699,934.001282 828.050171,934.428528 827.453796,938.051270 
	C827.041626,940.554810 824.994568,941.876404 822.473755,941.815735 
	C820.911499,941.778259 819.362793,941.175232 817.163086,940.534058 
	C816.518127,940.242126 816.364990,939.344666 816.325195,938.891174 
	C817.463379,936.397156 819.052612,934.781372 821.849976,933.588928 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M726.154785,1101.670166 
	C724.238464,1104.744385 722.881042,1107.492432 720.989868,1110.628174 
	C719.267029,1104.552856 723.270142,1099.743286 726.332764,1094.214111 
	C727.020325,1094.797852 727.108398,1095.610596 727.215576,1097.047607 
	C727.636902,1098.977417 727.511841,1100.208496 726.154785,1101.670166 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M786.879150,980.711548 
	C786.069763,981.513794 785.536072,981.760498 784.603516,982.165894 
	C784.549683,977.989502 785.855957,974.274719 790.664307,972.125916 
	C791.272888,975.409668 788.287903,977.272888 786.879150,980.711548 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M822.719482,932.880371 
	C820.815247,934.997620 819.098328,936.526001 816.833435,938.246033 
	C815.991150,934.096985 818.644409,931.840027 822.776428,930.038086 
	C823.251221,930.700500 823.078979,931.495972 822.719482,932.880371 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M754.895691,1034.757812 
	C754.137390,1035.603394 753.621460,1035.899658 752.730713,1036.424561 
	C752.059387,1033.213745 753.204285,1030.466309 756.461304,1028.187378 
	C757.434753,1030.373779 755.825745,1032.106079 754.895691,1034.757812 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M768.745483,1006.077026 
	C769.287048,1009.157776 767.449097,1011.569153 764.854065,1014.183838 
	C764.128235,1011.071106 765.246094,1008.259644 768.745483,1006.077026 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M832.977722,918.067932 
	C833.352600,920.744019 831.288086,922.242615 828.793701,924.052490 
	C828.022827,921.167908 829.349548,919.111755 832.977722,918.067932 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M778.612061,990.168457 
	C779.436951,990.611267 779.466248,991.203857 779.269409,992.255981 
	C778.477905,993.484375 777.684204,994.264526 776.371399,995.228821 
	C776.063599,993.487915 775.838196,991.375244 778.612061,990.168457 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M801.692871,956.420532 
	C802.205688,958.523254 801.071533,960.281372 798.752075,961.947021 
	C797.997559,959.734924 798.888245,957.844910 801.692871,956.420532 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M812.865967,942.176575 
	C813.517334,943.792542 812.537292,944.920898 810.715210,946.058044 
	C810.124268,944.520081 810.470398,943.012939 812.865967,942.176575 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M805.042908,952.099854 
	C805.649780,953.707703 804.653320,954.877686 802.856812,956.103394 
	C802.122742,954.478638 802.467102,952.931030 805.042908,952.099854 
z"/>
<path fill="#F95700" opacity="1.000000" stroke="none" 
	d="
M818.236389,867.782715 
	C818.259155,868.178040 818.136047,868.816956 817.839783,869.361633 
	C817.259155,870.429077 816.395020,872.041870 815.267761,870.311707 
	C814.442627,869.045227 816.064758,868.337158 817.830200,867.733765 
	C818.417847,867.538086 818.012207,867.983582 818.236389,867.782715 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M850.480652,898.331787 
	C850.717102,899.822876 850.462891,901.141724 848.662354,902.030518 
	C848.153748,901.119141 848.140625,900.098267 848.210938,898.314575 
	C848.938843,897.586365 849.519592,897.796875 850.480652,898.331787 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M782.587219,984.169128 
	C783.419312,985.741882 782.435303,986.867859 780.751099,988.127380 
	C780.096497,986.677673 780.340942,985.178223 782.587219,984.169128 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M739.814941,784.985229 
	C743.451721,784.381531 746.376465,782.298096 749.503784,780.384705 
	C753.213135,778.115112 757.412415,776.355835 761.417419,779.689514 
	C764.628174,782.361938 765.024963,790.369507 762.226135,794.484985 
	C760.580872,796.904175 757.964539,798.703857 757.716553,802.559692 
	C749.242249,799.727112 744.765869,792.554443 739.814941,784.985229 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M692.167297,738.639160 
	C698.981079,741.695679 703.431091,748.066040 708.846985,753.347473 
	C715.250305,759.591797 721.226868,766.273865 727.482605,773.409180 
	C726.938110,773.913147 726.109009,773.984741 725.688416,773.604553 
	C713.818726,762.869202 701.758850,752.314087 692.167297,738.639160 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M618.218384,669.696716 
	C618.275513,668.349365 619.099670,667.115723 620.137329,665.362183 
	C620.958496,663.546387 621.963440,663.054688 623.411316,664.295715 
	C628.792358,671.069519 634.122070,676.902832 639.539917,683.380127 
	C634.477234,683.288330 632.289673,678.678894 628.869507,675.707947 
	C625.902954,673.131042 623.578796,669.613403 618.218384,669.696716 
z"/>
<path fill="#E92B00" opacity="1.000000" stroke="none" 
	d="
M527.251343,778.009338 
	C526.538330,776.437622 527.524902,775.282837 529.299561,774.071533 
	C529.944641,775.602844 529.469910,777.021362 527.251343,778.009338 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M755.210327,685.982788 
	C756.938538,686.635193 757.877136,687.270447 759.407837,687.952820 
	C759.200928,698.278870 758.110107,699.336853 746.813965,699.999878 
	C743.597595,694.027893 739.423889,690.548035 732.802979,689.936218 
	C726.912964,689.391907 721.732178,687.248718 720.199646,680.777222 
	C718.116516,671.980408 725.611450,663.663513 734.711243,664.351196 
	C736.576965,664.492188 737.595520,665.639465 738.458252,667.129089 
	C739.659058,669.202820 739.789612,671.464294 740.041138,673.779114 
	C740.976379,682.384766 741.040588,682.390564 749.637695,684.855591 
	C751.208923,685.306030 752.825195,685.599548 755.210327,685.982788 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M623.812744,664.551270 
	C622.768555,665.168823 622.074463,665.101440 620.865662,664.938232 
	C617.335144,656.390625 617.449768,654.882324 625.536072,649.778381 
	C631.802429,645.822998 634.629211,640.813782 634.004944,632.808167 
	C634.330444,632.054077 634.665466,632.192505 634.974854,632.148987 
	C638.614075,631.636475 637.132935,639.292358 642.082520,636.615479 
	C646.671509,634.133606 648.022339,630.082336 646.292603,622.666626 
	C650.150085,618.075195 652.762695,621.283813 654.737854,624.329895 
	C658.436646,630.034424 655.870361,637.792053 649.434692,640.368103 
	C643.251221,642.843262 638.681152,647.322327 635.152832,652.469971 
	C632.051208,656.995117 628.177551,660.412354 623.812744,664.551270 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M705.165894,703.826477 
	C707.711243,698.658203 710.524292,694.983154 716.255615,696.467834 
	C720.135742,697.472961 724.363403,705.704956 723.863953,710.609802 
	C723.645386,712.755676 722.727173,714.967896 720.718018,715.254395 
	C715.960510,715.932800 711.814758,722.011597 707.037781,718.457153 
	C702.668701,715.206055 703.475159,709.548218 705.165894,703.826477 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M637.906799,621.361206 
	C636.195923,621.831238 634.637207,621.326050 634.092773,618.638000 
	C635.802856,618.169250 637.361877,618.674133 637.906799,621.361206 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M743.906921,437.282349 
	C741.158386,437.339233 738.316772,436.679718 734.737549,436.008240 
	C737.459961,430.469879 739.572449,430.592468 743.906921,437.282349 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2283.521973,1807.754150 
	C2277.706299,1807.791382 2274.513184,1805.223267 2274.231201,1800.222290 
	C2273.951904,1795.266357 2277.667969,1792.386475 2281.573242,1790.626465 
	C2286.359131,1788.469849 2289.788330,1792.135254 2292.703369,1795.083252 
	C2295.147705,1797.555054 2293.928955,1800.595825 2291.798584,1803.057007 
	C2289.783936,1805.384399 2287.035156,1806.519897 2283.521973,1807.754150 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2247.318848,1815.164307 
	C2246.263428,1816.513794 2245.716797,1817.447632 2244.903076,1817.941406 
	C2241.985352,1819.711914 2239.294678,1823.374634 2235.396973,1819.930298 
	C2232.158447,1817.068481 2231.262695,1811.314575 2233.267334,1808.096436 
	C2235.429199,1804.626099 2241.994629,1802.456909 2245.675293,1804.460938 
	C2250.079346,1806.859009 2250.148926,1810.552246 2247.318848,1815.164307 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2230.241699,1831.769043 
	C2232.299561,1834.764771 2232.438232,1837.516968 2231.560547,1840.005859 
	C2230.256348,1843.703003 2227.541504,1846.275024 2223.316650,1845.795898 
	C2219.264160,1845.336182 2216.654053,1842.724854 2216.203857,1838.667236 
	C2215.735107,1834.440674 2218.308105,1831.731079 2222.009277,1830.435547 
	C2224.499268,1829.563843 2227.251221,1829.697754 2230.241699,1831.769043 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2273.912109,1826.001099 
	C2272.828857,1832.071045 2268.958252,1832.339844 2264.803467,1831.726807 
	C2261.233887,1831.200439 2260.223145,1828.582031 2260.019287,1825.313843 
	C2259.750244,1820.992554 2262.017822,1818.565430 2265.754395,1817.213745 
	C2270.024170,1815.669312 2271.729492,1817.372070 2273.912109,1826.001099 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2477.872803,1793.942139 
	C2476.901367,1800.136597 2472.592285,1802.121216 2468.145020,1803.569824 
	C2464.096436,1804.888550 2460.954102,1802.859985 2459.005127,1799.367188 
	C2457.154541,1796.050781 2458.094971,1793.020020 2460.733398,1790.366211 
	C2467.093262,1783.969360 2473.033203,1784.922729 2477.872803,1793.942139 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2130.967285,1825.310791 
	C2129.039795,1826.014648 2127.756348,1826.367554 2126.490234,1826.774414 
	C2121.668457,1828.323120 2118.867188,1825.838745 2117.029541,1821.844360 
	C2114.762207,1816.916016 2118.174316,1814.477051 2121.633301,1812.239258 
	C2125.387207,1809.810791 2128.924561,1809.341553 2132.208252,1813.294067 
	C2135.991699,1817.848389 2136.007568,1819.611816 2130.967285,1825.310791 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2102.036865,1842.015015 
	C2104.921387,1837.436279 2108.041748,1834.694458 2113.058838,1836.822021 
	C2116.951172,1838.472778 2118.850098,1843.070679 2117.372803,1846.713623 
	C2115.766602,1850.674561 2110.440918,1853.221191 2105.645996,1851.804077 
	C2101.021484,1850.437134 2099.347168,1847.318481 2102.036865,1842.015015 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2145.755859,1829.454834 
	C2149.102539,1825.877197 2152.400635,1824.998413 2155.998047,1827.397827 
	C2158.238037,1828.891846 2160.236328,1830.890869 2159.556152,1833.941162 
	C2158.977295,1836.535522 2158.003418,1839.161011 2154.901123,1839.741211 
	C2152.248779,1840.237427 2149.373779,1840.370361 2147.529053,1838.045532 
	C2145.745361,1835.797607 2143.562500,1833.378662 2145.755859,1829.454834 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2136.666504,1796.000000 
	C2136.025146,1794.681763 2136.004883,1793.360962 2136.083740,1792.045898 
	C2136.322998,1788.057739 2138.466797,1786.023926 2142.460938,1786.170044 
	C2144.980957,1786.262085 2147.133057,1787.397461 2147.489014,1790.034424 
	C2148.075684,1794.380737 2145.291260,1795.780762 2140.757324,1795.985596 
	C2139.111084,1796.000000 2138.222168,1796.000000 2136.666504,1796.000000 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2289.301270,1870.898193 
	C2287.379639,1873.236694 2286.008301,1875.238037 2284.130859,1876.465332 
	C2279.563477,1879.450684 2273.812012,1877.105225 2272.361328,1871.938721 
	C2270.978760,1867.013672 2279.077393,1857.966187 2284.232910,1858.682617 
	C2285.645508,1858.878784 2286.614746,1859.757080 2287.305908,1860.909668 
	C2289.018555,1863.765259 2290.566406,1866.682983 2289.301270,1870.898193 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2223.406250,1772.101562 
	C2222.165771,1769.978882 2221.780518,1768.316284 2222.252441,1766.682129 
	C2223.584229,1762.071289 2226.707764,1759.907104 2230.015869,1761.126343 
	C2233.758057,1762.505615 2235.181885,1767.026978 2233.180908,1771.176636 
	C2231.321777,1775.032104 2228.794922,1775.444092 2223.406250,1772.101562 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2219.921631,1795.856934 
	C2219.212402,1800.701416 2216.686279,1802.243896 2212.788086,1801.723267 
	C2210.175781,1801.374390 2208.676514,1799.728149 2208.240967,1797.164429 
	C2207.671143,1793.813477 2209.218506,1791.352295 2211.809814,1789.508667 
	C2215.736572,1786.714355 2217.668701,1788.061279 2219.921631,1795.856934 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2191.301758,1773.926270 
	C2191.992432,1775.656128 2191.983643,1777.312378 2191.977295,1778.968506 
	C2191.960205,1783.289551 2190.128174,1786.121582 2185.489014,1785.808594 
	C2181.876709,1785.564819 2178.786377,1783.477417 2178.813477,1779.760986 
	C2178.843262,1775.747192 2181.816895,1773.189453 2185.852051,1772.700439 
	C2187.366943,1772.516846 2189.015869,1773.436035 2191.301758,1773.926270 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2275.090820,1759.152710 
	C2269.872803,1759.865845 2267.463379,1757.840088 2268.770752,1753.292725 
	C2269.576416,1750.491211 2272.307861,1749.309326 2275.010010,1750.891357 
	C2278.597656,1752.991699 2278.640869,1755.872314 2275.090820,1759.152710 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2413.191895,1696.770996 
	C2411.598877,1692.106934 2412.275635,1688.763672 2417.232178,1688.417847 
	C2419.838379,1688.236084 2421.793945,1690.212646 2421.582275,1692.807861 
	C2421.180420,1697.732788 2417.847656,1698.424072 2413.191895,1696.770996 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2368.867188,1707.080811 
	C2368.988525,1705.210693 2369.151123,1703.862549 2369.794922,1702.808472 
	C2371.992432,1699.210083 2375.068359,1699.293579 2378.019043,1701.596313 
	C2380.507568,1703.538452 2380.191162,1706.095215 2378.330811,1708.452148 
	C2375.964355,1711.450439 2373.378418,1712.679932 2370.358398,1709.241943 
	C2369.931152,1708.755859 2369.538086,1708.239868 2368.867188,1707.080811 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2357.668945,1727.574219 
	C2361.574219,1725.416504 2364.281982,1726.255371 2365.441650,1729.705933 
	C2366.602539,1733.160156 2364.030518,1735.266846 2361.496338,1736.962280 
	C2359.677002,1738.179321 2357.603027,1738.090698 2356.011230,1736.523315 
	C2352.751709,1733.313965 2354.457031,1730.578369 2357.668945,1727.574219 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2346.331299,1693.666016 
	C2344.648438,1692.743408 2343.417480,1692.087524 2342.714111,1691.067749 
	C2340.593018,1687.992920 2340.174805,1684.634766 2343.876953,1682.688965 
	C2347.275635,1680.903076 2350.630615,1682.594604 2352.270020,1685.685425 
	C2355.060303,1690.946777 2350.749512,1692.330688 2346.331299,1693.666016 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M2300.812744,1706.000000 
	C2299.703613,1704.726562 2299.457764,1703.438843 2299.102051,1702.182251 
	C2297.770996,1697.478149 2300.699219,1695.197754 2304.398926,1694.483887 
	C2308.176758,1693.755127 2310.738770,1696.670166 2311.454590,1699.983765 
	C2312.371582,1704.227783 2309.331787,1705.728882 2305.571289,1705.942871 
	C2304.259277,1706.017578 2302.940918,1705.984009 2300.812744,1706.000000 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M2398.168945,835.872192 
	C2396.043701,833.639465 2395.804932,831.692505 2398.132812,830.595459 
	C2400.374512,829.539062 2402.736328,830.035828 2404.485596,831.987793 
	C2405.667725,833.307251 2406.249512,835.041870 2405.039062,836.478210 
	C2403.025391,838.868469 2400.848145,837.269897 2398.168945,835.872192 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2407.569092,2009.483887 
	C2399.154053,2015.794922 2397.659668,2014.994141 2396.001465,2002.785645 
	C2400.638184,2002.843262 2402.177490,2008.639893 2407.569092,2009.483887 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2421.283203,1984.095947 
	C2421.340576,1986.844482 2420.681152,1989.684814 2420.010742,1993.262695 
	C2414.470215,1990.541504 2414.592285,1988.427979 2421.283203,1984.095947 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2464.091064,1988.635986 
	C2465.800293,1988.168335 2467.361816,1988.671509 2467.908691,1991.359619 
	C2466.196777,1991.831421 2464.637695,1991.325439 2464.091064,1988.635986 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M2333.357910,2008.100098 
	C2333.946045,2009.773071 2334.175537,2011.594971 2332.512695,2013.577881 
	C2329.561035,2011.734985 2329.338623,2009.743286 2333.357910,2008.100098 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1022.548828,1489.730225 
	C1027.921997,1499.364014 1035.608521,1506.534790 1042.598633,1514.928955 
	C1040.771240,1520.363281 1037.881592,1524.794434 1036.741455,1530.088501 
	C1035.957764,1533.727783 1033.129517,1536.260010 1029.747803,1538.148315 
	C1026.048462,1540.213989 1022.885925,1540.290039 1019.946838,1536.948242 
	C1018.629944,1535.450806 1016.829041,1534.280396 1015.839783,1532.610840 
	C1012.057190,1526.227173 1007.604187,1523.386719 999.464294,1525.365479 
	C992.864380,1526.969727 985.932922,1515.722168 988.348206,1508.865967 
	C989.173645,1506.522949 991.003296,1506.110840 993.074219,1506.065430 
	C996.734314,1505.985229 1000.425903,1506.248169 1004.049744,1505.859131 
	C1009.331726,1505.292114 1010.168091,1503.359741 1007.714233,1498.640869 
	C1005.877686,1495.109009 1003.823608,1491.655273 1002.364868,1487.969360 
	C999.717346,1481.279785 999.131348,1480.898193 992.524475,1483.766724 
	C984.300537,1487.337280 983.323669,1488.401367 984.883484,1497.240356 
	C985.639404,1501.523560 984.000671,1503.661133 980.878479,1505.215942 
	C975.507263,1507.890259 967.091125,1505.614868 963.298889,1500.790283 
	C962.477844,1499.745728 961.382019,1498.859741 960.781799,1497.708374 
	C957.355530,1491.135132 952.720825,1488.468384 945.554810,1492.329956 
	C941.051880,1494.756470 939.002441,1492.459839 937.693237,1488.132080 
	C935.997131,1482.525024 934.015442,1477.274170 940.829163,1473.396973 
	C944.761902,1471.159424 944.451843,1467.472046 942.823608,1463.752441 
	C940.164490,1457.677979 935.435852,1454.943115 928.959778,1453.890259 
	C918.918457,1452.257935 915.156372,1442.782471 920.973511,1434.455566 
	C922.481445,1432.297119 924.462097,1430.426636 926.415466,1428.630371 
	C930.905884,1424.500977 934.192078,1420.317871 934.399902,1413.423706 
	C934.591492,1407.066162 939.052124,1401.807007 944.241455,1397.973145 
	C948.710144,1394.671631 951.937500,1391.294189 952.327698,1385.137451 
	C952.705261,1379.179077 956.968811,1375.038452 962.809753,1371.767090 
	C971.444031,1382.482422 971.631348,1396.202881 976.647217,1408.315796 
	C985.282471,1429.169189 994.725220,1449.437866 1007.609985,1468.854736 
	C1008.129089,1469.390503 1008.057251,1469.868774 1008.298340,1469.888184 
	C1011.891541,1476.299438 1017.150330,1481.317017 1021.417603,1487.875488 
	C1021.860229,1488.802368 1021.958374,1489.151245 1022.548828,1489.730225 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M954.766724,837.904175 
	C950.259766,838.113525 946.430847,838.261230 944.989441,833.715149 
	C943.541260,829.148071 942.861023,824.529907 946.542053,820.601562 
	C948.116516,818.921265 949.889465,817.309204 951.853088,816.136353 
	C955.650879,813.868042 957.710938,810.389954 957.805115,806.327148 
	C957.957581,799.741638 961.217773,796.192627 966.890564,793.443604 
	C975.739807,789.155334 975.559326,788.867554 974.201294,779.122437 
	C973.374573,773.189758 974.933533,769.391907 980.509277,765.234680 
	C994.003723,755.173584 995.198364,754.427734 986.088745,736.727173 
	C990.632324,735.947205 995.204407,736.107239 999.770813,734.526855 
	C1003.800232,733.132385 1006.773254,734.834900 1008.103088,739.230530 
	C1009.166138,742.744141 1010.144348,746.159607 1010.006775,749.924622 
	C1009.838684,754.527649 1005.614014,755.313843 1003.336670,757.932007 
	C996.982727,765.237122 994.601074,771.072876 998.514771,777.417786 
	C1001.128662,781.655334 1004.165039,782.808960 1008.422424,781.504150 
	C1016.237183,779.108948 1020.074219,773.229797 1021.755554,765.587463 
	C1023.961731,755.559448 1023.984802,755.564514 1035.202026,754.000000 
	C1039.301514,763.848389 1039.156982,764.574524 1030.991211,770.538574 
	C1025.021606,774.898682 1021.367920,779.881836 1021.771973,788.020569 
	C1022.173401,796.104492 1014.745239,799.917114 1007.144958,796.551758 
	C1004.312134,795.297363 1002.389343,792.932129 999.931946,791.259705 
	C996.599915,788.992065 993.110046,786.801453 988.939514,789.640991 
	C984.911255,792.383728 983.598022,796.004150 984.506165,800.849548 
	C986.205872,809.918274 985.908264,810.178833 977.185059,811.986511 
	C968.118408,813.865356 963.734192,819.848267 965.464661,828.972778 
	C966.370789,833.750793 965.023254,835.871948 960.273010,836.299866 
	C958.660950,836.445068 957.111572,837.285583 954.766724,837.904175 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1220.210938,650.605347 
	C1219.270386,651.868652 1218.221069,652.284180 1216.633301,652.468628 
	C1205.937378,642.445496 1205.937378,642.445496 1200.342529,656.379883 
	C1200.107178,657.022278 1199.913208,657.020508 1199.828125,656.974121 
	C1199.308228,656.722839 1198.873535,656.518005 1197.796143,656.628784 
	C1193.560669,655.899902 1193.813477,652.492371 1192.887695,649.864136 
	C1191.609375,646.235168 1190.024902,642.903198 1185.352539,644.204224 
	C1181.038574,645.405334 1179.156128,648.639404 1179.300293,653.101562 
	C1179.415039,656.648132 1182.260498,659.763916 1180.585205,664.139282 
	C1169.152466,671.999695 1156.820068,677.220947 1146.269653,685.391846 
	C1143.379883,687.629883 1140.325562,689.655701 1136.667725,691.872803 
	C1135.736938,687.474487 1130.785400,684.488037 1132.001221,678.761353 
	C1132.630493,676.423035 1133.260986,674.848511 1133.945801,672.636963 
	C1139.977905,667.241150 1147.368042,663.864502 1150.534546,655.414307 
	C1152.122437,654.896667 1153.075439,654.960510 1154.034058,655.166931 
	C1157.265015,655.862305 1160.327515,660.357727 1163.643433,656.846191 
	C1166.589844,653.725891 1163.067139,650.190125 1162.396729,646.091187 
	C1162.459717,642.535889 1163.717285,640.528625 1167.249023,639.818237 
	C1180.237549,639.736328 1183.236328,637.036926 1187.470215,622.475098 
	C1192.140503,621.459656 1192.407959,625.228943 1193.881958,627.479004 
	C1196.114746,630.887146 1198.705322,633.019775 1202.924316,631.232483 
	C1207.173828,629.432312 1208.799072,626.190796 1207.920288,621.627686 
	C1207.246948,618.130798 1205.261230,614.717041 1207.549561,610.508911 
	C1208.520752,609.009155 1209.041626,608.020813 1209.781250,606.517456 
	C1210.712158,605.335938 1211.398315,604.379395 1212.280762,604.221130 
	C1221.980957,602.481384 1225.559692,596.281067 1225.523560,586.504395 
	C1228.075439,585.070251 1229.518921,583.620178 1229.942017,580.642334 
	C1233.871704,580.403503 1237.014038,578.384399 1240.340332,576.929871 
	C1243.686401,575.466492 1246.317383,576.491760 1247.606934,579.823608 
	C1251.784180,590.617615 1251.095459,595.242249 1240.474609,599.606628 
	C1230.806519,603.579529 1230.659180,603.924377 1233.786865,614.221130 
	C1236.196167,622.152649 1236.196167,622.152649 1228.733765,625.668701 
	C1213.753174,632.726990 1213.643799,633.001221 1219.647705,647.824829 
	C1219.893188,648.430969 1219.954834,649.111633 1220.210938,650.605347 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1088.738281,685.988159 
	C1088.000854,683.010864 1088.076294,680.019531 1087.988159,677.033020 
	C1087.764526,669.458130 1090.986816,664.615051 1098.377930,662.059021 
	C1106.564575,659.227966 1106.454102,658.908875 1103.528564,650.960327 
	C1100.510620,642.760254 1101.450806,639.687744 1109.379761,636.022095 
	C1113.780029,633.987793 1116.168335,630.705688 1117.444214,626.526428 
	C1119.307983,620.420715 1114.979736,614.530029 1108.565063,614.043640 
	C1106.252930,613.868225 1103.909546,614.118103 1101.594238,613.965210 
	C1095.985229,613.594666 1092.711182,610.840759 1090.764893,605.371460 
	C1089.347534,601.388367 1090.085449,597.838928 1093.622437,595.773743 
	C1097.823975,593.320557 1102.286743,590.710815 1107.516968,593.760315 
	C1110.481567,595.488770 1112.949463,597.430176 1114.002930,600.897461 
	C1114.855835,603.704346 1116.033569,606.412537 1117.164062,609.421875 
	C1118.815308,609.040833 1120.081299,608.811218 1121.310913,608.455383 
	C1135.243408,604.423828 1136.500732,605.035828 1142.726074,617.938965 
	C1144.608276,621.839905 1143.629272,624.469849 1139.711914,625.707275 
	C1135.832886,626.932556 1132.660889,629.274597 1129.184204,631.168823 
	C1124.077271,633.951294 1122.695190,638.086853 1124.729004,642.809448 
	C1127.384033,648.974609 1124.651611,652.514893 1119.772827,654.816040 
	C1112.865356,658.074158 1111.225830,663.488770 1112.000000,671.172729 
	C1105.299927,673.625366 1106.527344,680.201721 1104.084595,685.268188 
	C1103.204590,686.701172 1102.278564,686.999878 1100.611084,686.447021 
	C1096.501709,681.732849 1092.982666,686.692444 1088.738281,685.988159 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1008.116333,1468.688232 
	C1001.584167,1463.947510 998.296021,1456.130859 994.513245,1448.994019 
	C983.834839,1428.847656 974.036438,1408.244263 968.967957,1385.755859 
	C967.961182,1381.288574 965.913208,1377.056152 963.950378,1372.112549 
	C962.387024,1363.365479 961.218689,1355.221069 959.481201,1346.475708 
	C954.405945,1343.279907 953.935547,1339.358643 956.120056,1334.476562 
	C956.200378,1315.435791 955.266174,1296.760010 955.940063,1277.173340 
	C953.845276,1273.266846 952.988220,1270.199097 955.907837,1266.507568 
	C960.148315,1254.077026 961.216553,1241.636963 963.714783,1229.475952 
	C964.571899,1225.303589 965.810242,1221.209473 966.892517,1216.394531 
	C966.266846,1214.743896 966.319275,1213.817871 967.662659,1212.442383 
	C968.775879,1210.561035 969.294983,1209.168701 969.703308,1207.028809 
	C966.817566,1201.806885 967.600952,1197.983154 972.500854,1194.618164 
	C976.659485,1191.702881 976.448730,1187.380127 977.816895,1183.058594 
	C975.149841,1175.511963 979.390747,1171.178345 984.006348,1166.399658 
	C987.597595,1162.284180 989.956482,1158.171997 991.845581,1153.049316 
	C989.118774,1145.649414 993.945801,1142.375610 998.652039,1138.627930 
	C1001.136841,1136.345947 1002.885071,1134.153198 1005.204224,1131.770264 
	C1005.635315,1136.859497 1002.400879,1140.793579 999.978149,1145.106567 
	C992.341431,1158.701782 985.381226,1172.558472 979.712585,1187.179321 
	C975.542236,1197.935791 973.154419,1209.195679 968.861389,1219.921875 
	C966.507080,1225.804077 965.689636,1232.759033 964.788574,1239.262817 
	C962.703979,1254.308594 958.689758,1269.113037 959.855896,1284.613525 
	C960.652771,1295.205566 960.055420,1305.905884 960.005371,1316.557495 
	C959.898499,1339.294922 964.615417,1361.205200 971.292603,1382.779297 
	C973.522827,1389.985107 974.785095,1397.358887 977.571106,1404.544312 
	C985.756226,1425.654175 995.201050,1446.020020 1007.387634,1465.107422 
	C1007.892029,1465.897339 1007.876831,1467.018799 1008.116333,1468.688232 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1173.913818,1780.565552 
	C1164.338013,1766.394165 1166.812744,1761.207764 1182.837158,1760.041138 
	C1191.132202,1759.437378 1193.773804,1762.698975 1191.443359,1770.667480 
	C1188.882568,1779.424194 1183.960205,1782.447021 1173.913818,1780.565552 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1228.255127,952.171692 
	C1239.784058,948.171082 1252.084961,948.614075 1265.156982,948.457031 
	C1264.246216,954.650452 1257.844604,949.981018 1255.145142,953.463928 
	C1252.648315,956.685364 1255.263428,961.394592 1252.032349,964.609314 
	C1246.948486,969.667419 1240.100952,968.816223 1236.240845,962.335205 
	C1234.129639,958.790466 1233.708740,953.965637 1228.255127,952.171692 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1071.918091,941.923157 
	C1074.581421,943.706665 1074.927124,946.393372 1075.989380,949.362549 
	C1071.195557,949.614807 1068.754883,951.792419 1067.457153,956.429993 
	C1066.552490,959.663086 1066.539062,963.031616 1065.506226,966.120544 
	C1064.255981,969.859680 1061.363770,971.907837 1057.156128,971.984436 
	C1053.496704,972.050964 1051.471558,970.052856 1050.737061,966.924316 
	C1049.848022,963.137817 1048.175171,957.734802 1052.592529,956.236938 
	C1060.655029,953.503174 1064.968384,946.679016 1071.918091,941.923157 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1195.917603,958.544067 
	C1199.715210,955.037537 1204.298950,955.286072 1209.282227,954.481201 
	C1207.750977,958.265808 1206.551270,961.437500 1208.706055,966.142090 
	C1212.129639,973.616516 1210.280396,977.909607 1204.634277,980.067871 
	C1198.489380,982.416931 1195.061890,980.476135 1194.058716,974.071289 
	C1193.263916,968.997192 1195.166260,964.262512 1195.917603,958.544067 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M855.897461,912.790649 
	C857.499573,912.003174 859.000549,912.001404 861.251953,911.998657 
	C869.454468,913.578735 873.147339,918.515564 871.476562,924.663086 
	C870.224976,929.268616 864.867981,933.897888 860.985962,933.728699 
	C857.437622,933.574036 854.465027,928.937500 854.002136,923.139099 
	C853.731873,919.754883 854.728943,916.674866 855.897461,912.790649 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1057.331665,828.143127 
	C1058.346924,838.805054 1054.972412,849.385681 1055.804688,861.124023 
	C1046.828125,860.427368 1043.245972,854.256226 1041.145142,846.469238 
	C1040.275513,843.245728 1041.105957,840.639832 1044.076904,840.484802 
	C1051.468506,840.099243 1054.166870,835.832886 1055.057983,829.358643 
	C1055.115845,828.938293 1056.064575,828.640503 1057.331665,828.143127 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1108.211914,1028.846680 
	C1104.770386,1032.163696 1101.276001,1034.605835 1097.104004,1037.135986 
	C1096.422729,1032.656982 1094.266113,1029.286987 1091.176880,1025.989746 
	C1086.839233,1021.359741 1087.640381,1017.966797 1093.174438,1013.952454 
	C1097.675415,1010.687378 1101.319580,1011.576843 1104.367920,1016.892273 
	C1106.332031,1020.317261 1108.223389,1023.825745 1108.211914,1028.846680 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M891.406189,925.543213 
	C882.382202,930.726074 876.983276,928.654114 876.081604,920.352661 
	C875.532349,915.295898 878.031677,910.806824 882.186646,908.969055 
	C887.137329,906.779358 889.551392,910.427551 892.104553,913.304138 
	C895.503418,917.133728 897.105042,921.219421 891.406189,925.543213 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M847.653442,959.081482 
	C840.029297,959.275696 838.871033,953.492188 836.630798,948.845947 
	C836.048706,947.638550 836.221436,946.298218 837.065735,945.106873 
	C838.708801,942.788513 846.937988,939.502197 849.649292,940.347168 
	C853.971069,941.693970 855.835022,944.798706 856.034180,949.307434 
	C856.256409,954.339294 854.646423,957.705139 849.285156,958.487000 
	C848.965027,958.533752 848.664185,958.712830 847.653442,959.081482 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1069.773682,779.898132 
	C1069.174927,784.435486 1067.920288,788.690430 1066.141235,793.450867 
	C1064.325195,788.692871 1061.908936,785.392944 1055.543579,785.707397 
	C1050.733032,785.945129 1049.158691,781.486145 1048.436768,777.565430 
	C1047.814209,774.183716 1050.390747,772.063049 1053.131226,770.765015 
	C1056.544189,769.148560 1059.625122,770.281738 1061.922241,773.107605 
	C1064.001831,775.665771 1065.870361,778.380310 1069.773682,779.898132 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M818.273743,957.686646 
	C817.976196,954.902405 818.449402,953.081238 819.727295,951.425171 
	C824.753540,944.911804 830.313049,945.320801 834.214172,952.529175 
	C837.221008,958.085083 836.323730,960.522400 830.428467,962.822083 
	C829.817505,963.060547 829.224487,963.349487 828.604187,963.558716 
	C821.555908,965.936096 821.554932,965.933167 818.273743,957.686646 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M934.743530,863.988525 
	C933.851990,863.712280 933.743896,863.393860 933.549988,863.141418 
	C930.659973,859.378540 925.986694,855.925842 928.550537,850.489685 
	C931.302246,844.655457 937.279480,846.239929 943.150146,846.001648 
	C944.041077,846.998474 943.940674,848.024597 944.145264,848.985840 
	C946.188049,858.586182 945.152161,860.405212 934.743530,863.988525 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M831.118896,985.844604 
	C828.705444,984.639221 826.952148,983.684998 825.491760,982.398254 
	C822.481628,979.745911 820.757996,976.773132 824.065674,973.058960 
	C826.926941,969.846008 832.518127,968.932922 835.756042,971.307922 
	C836.530579,971.876099 837.255310,972.678040 837.675903,973.533325 
	C839.222046,976.677734 843.173706,979.170593 841.518799,983.225830 
	C839.669800,987.756470 835.251343,985.430298 831.118896,985.844604 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1002.630859,825.349609 
	C996.292358,826.558777 991.187439,826.422058 988.925476,819.772095 
	C988.023804,817.121277 987.558594,814.546570 989.362915,812.193176 
	C991.229370,809.758789 994.020691,809.855530 996.691101,810.151489 
	C1000.404846,810.563110 1002.428162,813.187134 1004.057373,816.212158 
	C1005.722412,819.303528 1006.953430,822.364319 1002.630859,825.349609 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1099.550293,686.591980 
	C1100.888916,685.999817 1101.777832,685.999573 1103.333374,685.998474 
	C1111.275391,687.585327 1113.484375,690.795166 1111.737549,697.241272 
	C1110.626953,701.339539 1105.577026,703.306519 1100.383057,701.664062 
	C1095.066040,699.982483 1094.546997,694.121765 1099.550293,686.591980 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M916.805237,892.001343 
	C914.117432,890.806824 913.952026,888.721191 913.400879,886.866394 
	C911.568909,880.701050 913.255493,877.631775 919.458496,876.149963 
	C921.021667,875.776550 922.735413,876.033020 925.189941,876.000000 
	C927.031555,879.244873 930.231201,881.780212 929.029602,885.764099 
	C927.256775,891.641846 922.809082,892.473389 916.805237,892.001343 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1040.712402,918.828552 
	C1042.581055,914.057190 1045.112671,911.564453 1049.904907,912.058594 
	C1053.603394,912.439880 1054.779663,915.077881 1055.598389,917.945862 
	C1056.767578,922.041443 1054.727173,924.997070 1051.444580,927.056580 
	C1049.320557,928.389404 1047.058960,930.476562 1044.267212,928.775024 
	C1040.842896,926.687927 1039.380493,923.586914 1040.712402,918.828552 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1031.147217,1097.518311 
	C1030.132812,1098.578613 1029.400635,1099.139771 1028.352051,1100.323486 
	C1027.037231,1101.419556 1026.473389,1102.425781 1025.012085,1103.106689 
	C1024.090820,1100.148315 1022.744507,1097.773438 1020.133301,1095.849487 
	C1017.385986,1093.825317 1015.417419,1090.896606 1016.704895,1087.324463 
	C1017.744995,1084.438477 1020.076355,1082.452637 1023.377197,1082.174438 
	C1027.352661,1081.839478 1029.308716,1084.354980 1030.757324,1087.549683 
	C1031.301025,1088.748901 1031.914307,1089.916382 1032.787842,1091.943115 
	C1033.081055,1094.413330 1032.225952,1095.704590 1031.147217,1097.518311 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M863.805420,990.013916 
	C866.926392,995.002502 864.359802,997.747009 860.803040,999.163818 
	C857.169006,1000.611511 852.826538,1001.191162 849.705139,997.998474 
	C847.044250,995.276733 847.509583,991.942627 850.232971,989.230469 
	C853.622742,985.854431 857.177490,985.952393 863.805420,990.013916 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1017.031372,1115.402466 
	C1016.552795,1116.159790 1016.241272,1116.309692 1015.831238,1116.968994 
	C1013.581543,1120.433228 1011.487549,1123.433960 1008.253113,1126.280273 
	C998.789307,1120.427246 998.055420,1115.306641 1005.070862,1109.999390 
	C1009.696289,1106.500244 1012.864685,1109.174316 1016.454712,1112.883911 
	C1016.952393,1113.991943 1017.075439,1114.393555 1017.031372,1115.402466 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M899.579895,904.565308 
	C902.777771,904.000000 905.555603,904.000000 909.166687,904.000000 
	C910.308960,905.284973 910.419617,906.661438 910.962341,907.838623 
	C912.956421,912.164001 910.801147,914.979248 907.418091,916.965759 
	C904.158142,918.880005 900.956177,918.063538 898.431335,915.264465 
	C895.202576,911.685059 894.966736,908.223999 899.579895,904.565308 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1026.927002,828.627930 
	C1028.211060,829.206482 1028.821655,829.466553 1029.363159,829.829712 
	C1031.955933,831.568909 1034.143555,833.906067 1032.932251,837.092529 
	C1031.652710,840.458374 1028.165649,839.863953 1025.235352,839.985596 
	C1021.694458,840.132629 1019.768005,838.172791 1018.747986,835.113831 
	C1017.286621,830.731445 1018.911194,829.296326 1026.927002,828.627930 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1165.274292,983.080322 
	C1166.035522,987.414673 1164.214600,989.366699 1160.782593,989.819092 
	C1158.531616,990.115723 1156.243774,990.219421 1154.426270,988.239868 
	C1151.642456,985.207947 1151.241455,979.721802 1153.959961,977.531677 
	C1157.441895,974.726562 1159.996094,977.025208 1162.390625,979.440063 
	C1163.308472,980.365662 1164.112549,981.404236 1165.274292,983.080322 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1087.611328,972.206482 
	C1091.255615,975.177734 1094.006958,978.634155 1096.165649,983.242188 
	C1093.588257,983.957520 1091.084961,984.241882 1088.905518,986.025330 
	C1086.735229,987.801086 1084.310547,988.841614 1082.225464,985.920776 
	C1080.472168,983.465088 1079.096802,980.719543 1081.431885,977.926514 
	C1083.081299,975.953918 1085.112061,974.300232 1087.611328,972.206482 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M983.776672,1166.036499 
	C984.906982,1172.066895 980.079346,1176.047241 978.112061,1181.828613 
	C972.397217,1179.670898 969.526367,1174.719482 970.901245,1169.613159 
	C972.442932,1163.886963 978.619446,1166.585938 983.776672,1166.036499 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M972.381836,1194.345703 
	C972.381165,1198.068359 971.458130,1201.665161 970.063843,1205.771484 
	C966.424805,1205.432983 963.225281,1204.685547 960.100769,1203.700073 
	C958.141541,1203.082153 956.604614,1201.789307 956.443665,1199.525146 
	C956.231018,1196.534058 958.620239,1195.685913 960.708435,1194.836060 
	C964.184448,1193.421265 967.853516,1194.091064 972.381836,1194.345703 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1104.107666,994.547241 
	C1109.099854,993.970215 1112.603516,990.559204 1117.326050,988.389832 
	C1117.845215,992.795166 1121.711304,997.750122 1115.452148,1001.271667 
	C1110.301514,1004.169617 1108.607544,1004.134521 1105.519897,998.872498 
	C1104.878784,997.780029 1104.600098,996.474854 1104.107666,994.547241 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1036.785645,953.260010 
	C1032.880249,953.852112 1029.100708,955.189392 1028.217041,950.319763 
	C1027.667236,947.290527 1028.013916,944.234070 1031.308594,942.717102 
	C1033.525146,941.696533 1036.022949,941.668945 1037.800293,943.444153 
	C1040.912231,946.552490 1040.655396,949.851074 1036.785645,953.260010 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1238.101562,985.096313 
	C1232.889893,988.516052 1227.012329,987.493713 1220.790771,988.679688 
	C1220.118530,983.275635 1223.728394,980.947693 1227.829102,979.192383 
	C1233.205688,976.890930 1234.739746,977.716553 1238.101562,985.096313 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M979.024170,849.273926 
	C977.147461,847.866394 975.864807,846.825439 974.726807,845.645020 
	C973.354614,844.221619 971.886475,842.671326 973.188782,840.497986 
	C974.564148,838.202759 976.874207,837.758240 979.237671,838.264587 
	C982.746704,839.016418 985.438782,841.203918 985.597107,844.843018 
	C985.753845,848.443787 983.304260,850.047791 979.024170,849.273926 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1194.858643,992.854675 
	C1188.719360,997.256897 1180.712769,997.613098 1172.757446,1000.365601 
	C1171.639893,995.157410 1173.718140,992.641724 1179.064209,991.680725 
	C1184.268555,990.745117 1189.201050,988.761902 1194.858643,992.854675 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1081.589844,754.081177 
	C1082.774780,757.029419 1080.796509,759.099548 1079.257080,761.885376 
	C1076.261963,761.459229 1073.833984,760.567200 1071.350342,759.875244 
	C1067.935303,758.923889 1067.631104,756.417542 1068.539062,753.770447 
	C1069.551514,750.818726 1071.705566,749.640930 1074.569092,751.742493 
	C1076.465454,753.134338 1078.447144,754.075989 1081.589844,754.081177 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M998.524902,1138.397461 
	C998.860840,1143.712158 994.620605,1146.996826 992.305786,1151.904297 
	C987.511963,1150.640747 985.239685,1147.439453 986.901611,1143.077759 
	C988.696899,1138.366333 993.024109,1137.547241 998.524902,1138.397461 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M956.079590,1334.081299 
	C958.697998,1337.315308 958.293701,1340.963623 958.999939,1345.118530 
	C957.274841,1345.887695 955.630310,1346.006714 954.001831,1345.893677 
	C949.423645,1345.575928 947.907471,1342.740845 948.099854,1338.534180 
	C948.324951,1333.612793 951.925781,1334.100586 956.079590,1334.081299 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1148.073486,1008.671387 
	C1144.244385,1011.486877 1140.148315,1013.506042 1135.336548,1015.523682 
	C1134.184570,1011.737244 1132.626953,1007.315369 1136.975708,1005.076538 
	C1140.933594,1003.038879 1145.175781,1003.171082 1148.073486,1008.671387 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1076.477783,696.530457 
	C1076.638062,689.597839 1082.658203,688.993591 1087.302979,686.078125 
	C1087.383545,688.117981 1086.696777,690.218506 1086.164551,692.357422 
	C1084.886963,697.489990 1081.802979,698.970703 1076.477783,696.530457 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1031.501221,1097.924927 
	C1030.694580,1096.179688 1032.301270,1095.204956 1033.007202,1093.272705 
	C1036.187012,1089.824097 1039.294189,1086.860229 1043.070312,1083.695557 
	C1043.083130,1090.872437 1036.919189,1093.793091 1031.501221,1097.924927 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1055.656738,878.409424 
	C1059.902344,883.605530 1058.365356,890.287903 1059.607422,897.212891 
	C1054.287354,892.499878 1052.827393,886.134521 1055.656738,878.409424 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1007.557495,1127.125732 
	C1010.865723,1124.369751 1011.610840,1120.226807 1015.125427,1117.637939 
	C1015.376282,1122.932129 1012.319336,1126.723389 1007.486450,1129.917236 
	C1007.062683,1129.254028 1007.286133,1128.493286 1007.557495,1127.125732 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M955.844238,1266.079834 
	C957.817017,1269.045166 956.678406,1272.030029 956.081848,1275.656616 
	C949.078491,1271.217651 949.010925,1270.028076 955.844238,1266.079834 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1081.656006,722.429321 
	C1079.965576,718.322205 1082.060181,717.805664 1084.621826,718.639038 
	C1086.940430,719.393188 1088.667847,721.688904 1087.361572,723.890503 
	C1085.506470,727.017151 1083.703369,724.258057 1081.656006,722.429321 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1024.405273,1103.830322 
	C1025.302246,1102.521118 1026.121704,1101.809082 1027.488281,1101.021729 
	C1028.332520,1105.074707 1026.166138,1107.640625 1022.016174,1109.416260 
	C1022.338196,1107.780884 1023.333008,1106.104248 1024.405273,1103.830322 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1017.516235,1115.905762 
	C1016.546753,1115.458984 1016.579651,1114.929810 1016.896240,1114.006348 
	C1017.946655,1112.341064 1019.063904,1111.091797 1020.776489,1109.632568 
	C1022.258484,1112.530640 1020.987915,1114.555176 1017.516235,1115.905762 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1216.131348,954.016296 
	C1217.129272,951.895386 1219.001587,952.163696 1221.376709,952.250000 
	C1221.188477,955.922913 1219.384521,956.725098 1216.131348,954.016296 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1058.738281,820.113403 
	C1059.300903,821.112244 1059.312744,822.235657 1058.925781,823.775146 
	C1056.516846,823.036377 1055.691772,821.779785 1058.738281,820.113403 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1188.225708,960.287354 
	C1188.556030,958.618835 1189.721191,958.444336 1191.449707,958.462646 
	C1191.552124,960.527466 1191.031616,962.301025 1188.225708,960.287354 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1066.085815,926.058228 
	C1067.076660,926.803162 1067.552734,927.832947 1067.867432,929.432129 
	C1065.704834,929.534485 1063.618408,929.117126 1066.085815,926.058228 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1073.138672,772.084961 
	C1073.572021,773.129456 1073.428833,774.260925 1072.831177,775.764648 
	C1070.220093,774.711548 1069.939331,773.373840 1073.138672,772.084961 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1059.996338,906.113281 
	C1061.696045,906.455261 1061.934937,907.642273 1062.110596,909.405151 
	C1060.053589,909.597534 1057.557129,909.574341 1059.996338,906.113281 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M726.251221,1101.932739 
	C725.857422,1100.838135 726.119019,1099.680054 726.807617,1098.096680 
	C729.815063,1099.281128 730.275757,1100.724854 726.251221,1101.932739 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1061.019043,808.087524 
	C1061.460938,809.127869 1061.341187,810.259949 1060.750977,811.746460 
	C1058.189331,810.696960 1057.941772,809.375977 1061.019043,808.087524 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1049.523193,1076.962891 
	C1049.992554,1078.412964 1049.381226,1079.450195 1047.464844,1079.963989 
	C1046.811890,1078.420654 1048.109497,1077.817505 1049.523193,1076.962891 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1164.606934,1002.400635 
	C1164.509033,1003.977844 1162.990234,1004.372986 1160.675903,1004.681885 
	C1160.752319,1003.096313 1162.042603,1002.302673 1164.606934,1002.400635 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M967.718018,1212.434692 
	C968.194458,1212.901978 968.132080,1213.850586 967.490173,1215.254395 
	C967.000183,1214.778320 967.089783,1213.847290 967.718018,1212.434692 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M930.174744,686.951172 
	C929.328308,688.101440 928.649719,688.702209 928.701050,689.232300 
	C929.692322,699.468445 924.424011,706.156128 916.022217,710.591064 
	C910.696167,713.402405 909.523132,717.540771 909.964722,722.917725 
	C910.275269,726.698730 909.753357,730.080505 905.727356,732.150879 
	C902.171265,733.979492 899.234314,733.563171 896.920715,730.572693 
	C893.997070,726.793884 894.256653,719.302368 897.629761,718.447205 
	C907.069275,716.054077 908.901550,709.988953 908.148743,701.392395 
	C907.651733,695.716553 910.699890,691.194885 915.621948,688.227844 
	C920.722717,685.153015 923.957947,681.344177 924.395447,674.840088 
	C924.717896,670.046204 926.436646,665.170654 931.804260,662.752258 
	C933.805359,661.850708 935.081787,659.465515 936.950073,658.119812 
	C941.507507,654.837219 941.581848,650.980469 939.847168,645.975464 
	C936.967041,637.665710 937.839722,636.316772 945.538513,633.283020 
	C951.628845,630.883179 954.954712,632.248962 958.287781,638.762268 
	C959.336304,640.811157 959.916016,643.094727 960.824646,645.221985 
	C961.578186,646.986084 963.601135,648.196960 963.097107,650.578003 
	C961.194336,653.001099 958.202026,653.800171 955.601135,655.184937 
	C949.060364,658.667358 944.372864,663.489868 944.030212,671.304932 
	C943.865662,675.057251 942.041016,677.656494 939.017883,679.344666 
	C935.748047,681.170471 933.241272,683.769836 930.174744,686.951172 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M823.297241,818.492554 
	C826.465149,825.335510 831.142883,827.447632 837.484985,825.136353 
	C841.740723,823.585388 844.308472,824.478760 846.030518,828.898193 
	C848.734802,835.838501 848.656982,840.504150 845.122192,843.725525 
	C841.899353,846.662537 836.996460,846.968567 833.270386,844.029724 
	C830.686096,841.991455 827.485107,839.893616 826.725342,836.688538 
	C825.156616,830.070435 820.581055,829.690735 815.297668,829.995239 
	C814.634766,830.033447 813.967529,830.010071 813.302612,829.998413 
	C805.104553,829.854187 803.361023,828.771667 802.202942,823.114136 
	C800.487976,814.736267 802.350037,811.155701 809.911987,808.291077 
	C818.410767,805.071533 818.626160,805.172302 821.731567,814.011292 
	C822.171326,815.262878 822.547241,816.536926 823.297241,818.492554 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M911.622925,761.854126 
	C917.674316,758.697876 921.599731,760.855957 923.680908,765.691162 
	C926.699829,772.705078 931.971375,774.180908 938.871582,774.108032 
	C946.801453,774.024292 953.711731,781.839111 953.286743,789.646729 
	C953.130859,792.510437 951.131836,793.625977 948.633728,793.834717 
	C942.293518,794.364258 936.035400,794.765991 931.583252,788.649353 
	C927.809998,783.465454 922.728699,781.109314 916.094849,781.901489 
	C912.609985,782.317627 909.181641,782.552979 907.774780,777.340698 
	C905.330383,768.283997 905.218262,766.707214 911.622925,761.854126 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M827.404541,803.758911 
	C823.509338,803.987427 820.453857,804.077576 820.077576,799.780701 
	C819.933960,798.140320 819.864075,796.402344 819.261902,794.910156 
	C817.395569,790.285645 818.458557,787.531860 823.432922,785.798828 
	C830.891724,783.200317 833.352722,783.121582 836.078003,788.553589 
	C840.024841,796.420349 845.112793,801.106628 854.656311,800.337769 
	C858.408142,800.035522 862.807495,801.970520 863.655273,806.684448 
	C864.516602,811.474365 862.148560,815.026978 857.775635,817.072815 
	C854.525024,818.593567 851.553101,820.841797 847.488586,821.371521 
	C845.466187,817.181152 843.580017,813.022278 841.479370,808.974731 
	C837.510986,801.328064 837.444214,801.348450 827.404541,803.758911 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M821.455566,723.113647 
	C822.019653,716.266602 826.578552,711.044922 831.882935,710.407227 
	C836.373901,709.867249 838.339783,713.118103 840.116821,716.369263 
	C842.955627,721.562805 842.128418,726.872253 837.767944,730.785583 
	C836.056152,732.321777 834.034363,733.548706 832.042358,734.728394 
	C828.680664,736.719177 826.527649,739.515564 826.092529,743.408325 
	C825.670044,747.187927 824.238831,750.503967 821.659607,753.202393 
	C819.220642,755.754211 816.995728,759.256409 812.489563,757.008179 
	C808.009949,754.773254 805.145386,748.944153 806.260193,744.560974 
	C807.176392,740.958618 809.883545,740.480225 813.022217,739.920166 
	C820.220520,738.635681 823.547302,736.014404 823.561951,731.456970 
	C823.570190,728.907104 822.370483,726.353394 821.455566,723.113647 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M908.451660,849.655701 
	C904.799438,848.316589 903.016541,846.023926 901.667236,843.261047 
	C898.997009,837.793701 899.445679,836.028870 904.558838,832.724731 
	C905.945496,831.828735 907.417236,831.062744 908.791382,830.149109 
	C916.708801,824.884583 916.702881,824.875610 914.889038,815.710754 
	C913.514771,808.766418 915.970093,805.336548 923.171387,804.140930 
	C930.206299,802.972961 935.308472,806.592163 935.863647,813.131470 
	C936.186890,816.938538 934.215393,819.504211 931.115967,821.154846 
	C928.810547,822.382690 926.378723,823.375977 924.034790,824.566345 
	C918.684875,827.283386 917.389038,831.400146 918.127625,836.859863 
	C919.432739,846.508240 919.378052,846.515625 908.451660,849.655701 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M949.840210,746.301270 
	C952.882812,746.988708 955.125244,747.537048 957.382385,748.015808 
	C962.402832,749.080872 965.276855,752.269470 965.902649,757.417175 
	C966.362915,761.202576 965.050415,763.814941 961.341980,765.211487 
	C956.238098,767.133484 951.101685,766.030518 948.082153,762.018005 
	C946.489624,759.901672 945.098267,757.629944 943.677002,755.389709 
	C941.601196,752.117920 938.964172,749.600098 934.812195,750.060791 
	C929.410217,750.660156 926.116150,747.483215 923.000244,743.945251 
	C918.866028,739.251038 920.118958,734.435303 925.890381,732.416138 
	C932.367310,730.150208 937.652100,732.607971 940.181580,739.412170 
	C941.765991,743.674377 944.599854,745.858643 949.840210,746.301270 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M955.812256,712.283691 
	C956.269714,715.769226 959.447388,718.493225 956.235229,721.202026 
	C954.175842,722.938843 942.936035,723.419189 941.213623,722.065491 
	C933.523132,716.021545 934.663879,707.055908 943.606567,703.259033 
	C950.126526,700.490784 951.932556,701.733765 955.812256,712.283691 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M866.069702,789.823975 
	C864.788513,787.449890 863.766846,785.746399 862.997986,783.935486 
	C861.785522,781.079651 859.033813,778.430298 862.099609,774.987793 
	C864.895508,771.848328 868.428772,771.739441 872.069031,772.110779 
	C875.942566,772.505859 880.668091,778.261536 881.524109,783.492432 
	C882.335999,788.453918 878.678833,790.326477 875.217834,792.358826 
	C871.641968,794.458862 868.983032,792.841309 866.069702,789.823975 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M985.915771,735.266357 
	C983.240906,736.045349 980.955139,737.478699 978.634277,738.671326 
	C974.074707,741.014648 970.446716,739.827820 967.196655,736.200317 
	C964.742554,733.461182 961.896667,730.489807 962.565063,726.797546 
	C963.342529,722.503052 967.897888,722.929932 971.221497,721.706909 
	C978.240662,719.124023 981.222290,720.143127 982.806274,727.266907 
	C983.366882,729.788452 984.797974,732.116394 985.915771,735.266357 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M914.476685,660.044739 
	C904.787781,665.341431 900.813843,664.307556 897.319702,656.641052 
	C895.684387,653.052979 895.880310,649.972229 899.592407,648.367432 
	C903.940308,646.487610 908.980408,640.640808 912.513367,643.842346 
	C915.905212,646.915894 917.565552,653.670105 914.476685,660.044739 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M907.192749,785.820496 
	C907.748535,790.796143 907.947327,795.078186 907.952637,799.360596 
	C907.955444,801.592041 908.409607,804.340759 905.651367,805.315613 
	C902.489136,806.433533 899.114319,806.661255 896.177551,804.580139 
	C891.747681,801.440918 890.762695,794.736389 894.554565,790.680542 
	C897.718140,787.296753 900.459839,782.014648 907.192749,785.820496 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M848.348511,686.273804 
	C856.470032,686.205994 857.476196,692.445435 859.761353,697.315247 
	C860.263123,698.384766 859.721924,699.880798 858.703552,700.918213 
	C856.591919,703.069397 847.478699,704.858582 844.515259,703.571838 
	C841.402100,702.220093 840.573853,699.378174 840.110046,696.368591 
	C839.303040,691.132629 842.162415,688.389221 846.669250,686.778442 
	C846.979797,686.667358 847.282227,686.533569 848.348511,686.273804 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M781.556030,738.622986 
	C782.270386,725.823120 783.250732,724.713318 795.182373,723.998779 
	C796.424683,725.582886 796.901184,727.156433 797.265625,728.755493 
	C799.329407,737.810608 798.368042,739.655457 788.742065,743.917175 
	C786.391724,743.506165 784.783508,743.007446 782.587646,742.254395 
	C781.212830,741.240173 780.917786,740.322144 781.556030,738.622986 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M779.718079,797.654724 
	C781.119507,796.623352 781.958069,796.103394 782.830566,795.648560 
	C785.882812,794.057190 789.084900,793.020874 792.005432,795.612915 
	C794.843811,798.132019 794.206970,801.702393 793.749084,804.891235 
	C793.189331,808.789612 785.367126,814.294495 781.948181,813.575073 
	C777.357422,812.609131 775.284119,807.432068 777.276855,801.642517 
	C777.697266,800.421082 778.528687,799.341125 779.718079,797.654724 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M868.432373,674.175415 
	C864.827393,676.639771 861.808655,679.148682 858.315735,675.223999 
	C855.373230,671.917725 853.299011,663.863281 854.924072,661.374023 
	C856.191711,659.432251 864.593079,655.912537 866.641724,656.791992 
	C870.683594,658.527100 870.833618,662.692932 871.156799,666.109619 
	C871.385254,668.524841 869.735840,671.117737 868.432373,674.175415 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M811.751343,709.376526 
	C810.712341,712.523804 808.746521,713.711121 806.574036,714.634216 
	C803.121216,716.101318 799.434509,717.302551 796.477905,714.106506 
	C793.562500,710.955017 793.285522,706.739807 794.437073,702.840515 
	C795.555298,699.053955 799.606079,698.724976 802.635620,698.492310 
	C806.328674,698.208740 809.809631,700.010010 811.439270,703.721924 
	C812.062805,705.142151 811.771423,706.964050 811.751343,709.376526 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M840.960632,756.668274 
	C847.305237,755.374084 850.673767,757.955383 851.808167,763.259827 
	C852.754883,767.686890 850.950989,770.877747 846.589050,772.693726 
	C842.485840,774.401978 838.975403,774.669006 836.239929,770.399780 
	C833.346741,765.884338 833.374756,762.345825 836.787109,758.869690 
	C837.670227,757.969971 839.070007,757.577393 840.960632,756.668274 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M891.532837,689.747559 
	C884.545105,690.101196 883.244019,685.359497 882.246460,680.866150 
	C881.395630,677.033142 883.965698,674.790833 887.300720,673.421753 
	C890.704773,672.024231 894.279541,670.601685 897.294434,673.854065 
	C900.423279,677.229492 900.397766,683.080688 897.261536,686.563782 
	C896.012085,687.951477 893.969177,688.624756 891.532837,689.747559 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M855.659180,747.613403 
	C850.510986,743.206543 848.509094,737.407288 850.617126,734.000000 
	C852.750244,730.552124 856.353271,729.901550 860.157715,730.078430 
	C864.693970,730.289429 866.146057,733.762573 867.363159,737.185791 
	C868.607849,740.686829 866.503906,742.755859 863.559875,744.170105 
	C861.184998,745.310974 858.798218,746.427368 855.659180,747.613403 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M889.025818,761.340149 
	C879.377869,761.514709 877.378296,759.619568 877.998962,752.660828 
	C878.329346,748.955505 880.566406,747.235779 883.569092,746.570251 
	C887.042358,745.800476 890.978699,744.727539 893.723816,748.190430 
	C896.124878,751.219299 897.096802,754.940369 894.929504,758.370422 
	C894.035950,759.784729 891.554932,760.195923 889.025818,761.340149 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M883.863403,707.743164 
	C886.795471,712.640747 884.638489,715.598206 881.022583,717.068787 
	C877.473450,718.512329 873.190735,719.426697 870.216248,715.703613 
	C867.586060,712.411560 867.125916,708.469299 869.122864,704.630920 
	C870.320862,702.328125 872.767578,702.243164 875.105347,701.993652 
	C879.276978,701.548584 882.044922,703.189026 883.863403,707.743164 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M805.986389,781.741333 
	C802.061890,786.315063 798.264404,785.996765 794.410034,782.909912 
	C791.371094,780.475830 791.524292,777.031128 792.478455,773.909729 
	C793.477112,770.642639 795.930847,768.395935 799.648926,768.150696 
	C803.114075,767.922180 804.905090,769.999939 806.402527,772.807068 
	C807.932495,775.675110 808.171997,778.347778 805.986389,781.741333 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M876.729614,828.836060 
	C876.327881,827.809082 876.204468,827.482544 876.218628,827.162048 
	C876.511658,820.538574 879.365784,816.578918 883.773926,816.655212 
	C886.915894,816.709595 891.292969,822.273926 891.809753,826.870605 
	C892.338867,831.576965 889.410095,834.437866 884.686218,833.750854 
	C883.728577,833.611572 882.719666,833.331604 881.900024,832.840210 
	C880.230957,831.839600 878.674805,830.650635 876.729614,828.836060 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M801.705566,846.298950 
	C799.020935,845.937622 797.320129,843.696533 795.145203,841.002808 
	C798.714111,839.883240 802.148865,840.017151 801.705566,846.298950 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1464.052246,775.845947 
	C1456.383423,761.485901 1448.746826,747.090088 1439.177490,733.025696 
	C1448.781006,730.407959 1450.295776,729.357300 1449.798828,720.235413 
	C1449.441284,713.670898 1451.773438,709.501160 1456.911743,706.135193 
	C1461.049072,703.424927 1462.527100,703.543396 1463.853394,708.265503 
	C1464.713867,711.329651 1466.465820,713.661133 1468.135864,716.054810 
	C1472.061157,721.681030 1477.331543,723.206970 1483.856079,720.973145 
	C1485.424072,720.436279 1486.881714,719.581970 1488.404053,718.904968 
	C1489.995239,718.197388 1491.599487,718.072327 1493.183960,718.945374 
	C1496.930298,721.009888 1498.022583,735.226318 1494.554443,737.629456 
	C1493.196777,738.570251 1491.632202,739.228821 1490.122925,739.932251 
	C1483.232910,743.144104 1481.973511,743.138489 1478.307007,736.382996 
	C1474.072388,728.580750 1467.563354,727.209595 1459.784058,728.083435 
	C1455.479858,728.566956 1452.192871,730.590332 1450.753540,734.857544 
	C1449.388916,738.903320 1449.581055,742.728699 1452.929199,745.904358 
	C1454.137695,747.050720 1455.424805,748.156738 1456.426147,749.471497 
	C1459.618530,753.662964 1463.206177,754.133545 1467.603394,751.284607 
	C1469.491455,750.061340 1471.521362,748.728638 1474.363525,748.932800 
	C1477.286987,751.187683 1475.509766,755.044312 1476.903687,757.965393 
	C1479.453125,763.307739 1477.217407,766.957153 1471.999390,768.971008 
	C1468.702271,770.243469 1466.633057,772.774536 1464.052246,775.845947 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1472.489502,680.552612 
	C1475.524048,677.893799 1478.965698,676.891663 1480.781738,673.917664 
	C1482.317627,671.402466 1483.545044,669.061890 1482.990723,665.626282 
	C1481.440308,656.016663 1482.011353,655.378418 1490.443237,650.778442 
	C1491.609985,650.141846 1492.798340,649.539062 1494.005493,648.982971 
	C1497.222290,647.501038 1498.441650,645.386047 1496.994141,641.801147 
	C1495.888550,639.063477 1495.489990,636.049255 1494.537109,633.239319 
	C1492.314941,626.685425 1492.570068,625.962280 1498.712158,624.191162 
	C1501.892578,623.274170 1505.113770,622.498169 1508.321167,621.675964 
	C1514.167725,620.177124 1515.080322,620.802429 1515.966797,626.891602 
	C1516.014282,627.218506 1515.962769,627.559326 1516.004517,627.887634 
	C1517.708374,641.259216 1517.781372,641.479675 1504.553101,645.825317 
	C1500.843018,647.044067 1499.915894,648.955139 1500.002563,652.268066 
	C1500.063354,654.594482 1499.914429,656.927979 1500.017944,659.251282 
	C1500.252441,664.512634 1499.541260,668.251587 1493.471069,670.911926 
	C1487.732422,673.426880 1481.759033,677.950073 1485.060425,686.574219 
	C1486.258179,689.703613 1484.415771,692.920898 1481.956177,694.380310 
	C1477.432983,697.064026 1472.447510,699.039368 1467.506470,700.920776 
	C1464.779541,701.959167 1464.035522,699.684265 1464.108032,697.560547 
	C1464.333496,690.958069 1466.716919,685.309509 1472.489502,680.552612 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1414.877441,647.381836 
	C1417.134399,646.402710 1418.614136,645.641846 1420.147583,645.011597 
	C1423.978638,643.437073 1427.101074,644.494263 1427.666992,648.634399 
	C1429.146118,659.457825 1435.331299,662.928955 1445.679688,662.170471 
	C1451.730347,661.726990 1457.668213,671.399902 1455.683594,677.252319 
	C1454.583740,680.495422 1450.387695,682.459900 1446.687134,681.186707 
	C1442.118164,679.614563 1438.510864,676.564148 1436.273926,672.367188 
	C1433.543945,667.244873 1429.434204,665.182373 1423.982056,666.059021 
	C1416.849609,667.205750 1412.630737,663.770996 1409.960205,657.771179 
	C1406.902466,650.901428 1402.816162,647.440857 1394.471191,649.680115 
	C1387.895142,651.444702 1380.528809,643.652710 1380.701050,636.478027 
	C1380.716309,635.843384 1380.852173,635.156494 1381.131226,634.592529 
	C1382.640015,631.543396 1396.387451,627.258606 1399.175781,628.935303 
	C1400.687988,629.844543 1401.451538,631.227783 1401.841064,632.925476 
	C1402.432129,635.501648 1403.105225,638.060364 1403.800049,640.611084 
	C1405.670410,647.476624 1405.682251,647.473389 1414.877441,647.381836 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1470.669922,653.307861 
	C1458.723267,654.221069 1456.368530,653.122559 1453.004395,645.505981 
	C1451.459961,642.009399 1451.484131,639.065308 1455.993774,637.742310 
	C1458.851196,636.903931 1461.711060,635.951355 1464.402100,634.691711 
	C1470.647949,631.767944 1472.073120,626.310242 1467.769287,620.980408 
	C1464.197754,616.557434 1460.060303,612.632874 1453.937622,611.995850 
	C1448.848145,611.466370 1446.619385,607.766968 1444.962280,603.681702 
	C1442.913208,598.630310 1444.374268,595.691650 1449.411499,593.326233 
	C1454.298096,591.031555 1456.481079,593.026978 1458.303833,597.669922 
	C1461.630859,606.144897 1467.515137,610.878723 1477.434082,610.166626 
	C1483.902588,609.702271 1489.238770,617.436157 1487.672485,623.629761 
	C1487.019043,626.213989 1485.125977,627.097839 1482.781982,627.957764 
	C1472.252441,631.820435 1470.791870,634.426453 1473.045898,645.861633 
	C1473.607910,648.713379 1473.955566,651.048462 1470.669922,653.307861 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1324.015015,652.757446 
	C1316.140869,653.355591 1308.812012,650.244995 1300.467041,648.869202 
	C1302.151489,644.563477 1305.791870,646.756287 1308.865723,646.439758 
	C1310.515625,635.145142 1307.288940,631.020386 1295.649292,630.049683 
	C1292.051880,629.749695 1289.446289,628.994690 1287.957642,625.168152 
	C1286.346924,621.028015 1286.385132,617.427368 1289.305664,614.090576 
	C1293.646362,609.131409 1298.015625,609.565491 1301.663086,615.279846 
	C1306.235962,622.443970 1311.371216,627.773621 1321.133179,624.299988 
	C1324.645020,623.050537 1328.152588,624.177063 1329.941528,628.579468 
	C1332.644897,635.231384 1332.979004,640.174255 1329.034546,643.135681 
	C1325.825562,645.544922 1323.556519,647.825928 1324.015015,652.757446 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1396.708984,611.052490 
	C1396.273804,608.534546 1396.622070,606.900085 1398.566528,606.395813 
	C1401.436890,605.651428 1404.398315,605.256348 1407.265381,604.501587 
	C1412.104126,603.227905 1415.511353,604.356812 1417.737549,609.244080 
	C1420.620483,615.573486 1425.565918,619.143982 1432.830444,617.955933 
	C1439.901978,616.799500 1442.980957,620.759338 1445.237671,626.543579 
	C1449.150269,636.571350 1447.374268,639.360291 1436.452271,640.007874 
	C1431.022339,640.329773 1427.410767,639.258850 1424.998779,633.209534 
	C1423.037231,628.289673 1418.755859,623.200012 1412.062622,624.117310 
	C1404.723877,625.123169 1400.911377,621.728638 1398.661377,615.386780 
	C1398.219604,614.141785 1397.538452,612.981750 1396.708984,611.052490 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1513.354980,690.206299 
	C1511.556152,693.718567 1511.711182,696.817444 1512.085693,699.721558 
	C1513.031006,707.056702 1510.547119,711.448547 1503.235474,714.049744 
	C1496.352051,716.498718 1494.297607,716.238281 1492.227173,709.503479 
	C1488.856323,698.538757 1489.259521,697.655518 1499.723267,693.080811 
	C1508.854980,689.088501 1509.163696,688.488953 1505.484009,678.970459 
	C1504.246094,675.768250 1502.506348,671.797424 1505.174561,669.652771 
	C1508.907715,666.652161 1513.529907,664.215332 1518.742798,664.239441 
	C1520.574097,664.247925 1521.684570,665.619629 1522.476318,667.159485 
	C1523.847290,669.825623 1525.354614,672.437622 1526.507935,675.196350 
	C1529.101074,681.398499 1528.373291,683.191650 1521.889893,685.688477 
	C1519.081299,686.770081 1516.237549,687.645142 1513.354980,690.206299 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1385.221802,680.188965 
	C1379.698608,680.426392 1376.408569,676.217773 1372.071045,673.893005 
	C1360.051514,667.450989 1347.606812,662.075439 1334.365479,656.845764 
	C1335.374878,653.357117 1336.554443,650.183899 1338.404419,647.467041 
	C1343.484253,640.006531 1352.342041,640.380981 1357.011230,648.097229 
	C1357.867432,649.512329 1358.719971,650.982971 1359.238403,652.539795 
	C1361.208374,658.454468 1365.155640,660.908569 1371.341064,660.015686 
	C1383.205688,658.303223 1386.455444,664.151550 1385.946899,675.330933 
	C1385.886841,676.651855 1385.659912,677.965149 1385.221802,680.188965 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1371.437866,603.100708 
	C1369.807983,598.896423 1367.216553,596.357422 1364.738647,593.663818 
	C1361.591309,590.242554 1358.385376,589.387146 1354.218994,591.844543 
	C1350.577759,593.992126 1346.878662,595.301270 1344.295044,590.087036 
	C1340.944824,583.325500 1341.338379,576.981384 1345.537598,573.694763 
	C1352.432739,568.298218 1357.606201,569.554443 1360.971313,578.091125 
	C1363.306763,584.015442 1367.317871,587.699707 1373.366821,587.734436 
	C1380.956299,587.778015 1384.104736,593.487000 1388.455322,597.776001 
	C1389.975098,599.274292 1390.322510,601.414001 1389.025391,603.237976 
	C1386.464355,606.839294 1382.156006,606.906250 1378.408813,607.806030 
	C1375.267456,608.560303 1372.417236,607.700256 1371.437866,603.100708 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1427.373779,573.308411 
	C1433.080322,570.638184 1431.703247,566.972778 1430.712769,562.853088 
	C1428.714355,554.540833 1430.701660,551.024963 1437.184692,550.169739 
	C1440.270630,549.762634 1443.210571,549.902588 1444.214355,553.850281 
	C1444.617310,555.435059 1445.555054,556.877319 1446.174561,558.414612 
	C1448.689209,564.654968 1448.394165,565.391113 1442.398682,568.153687 
	C1433.571655,572.221069 1432.810669,573.758362 1434.814087,583.476257 
	C1436.324219,590.801270 1430.584961,597.831726 1423.158447,597.727295 
	C1420.565796,597.690857 1418.684326,596.168640 1417.541260,594.135925 
	C1416.260376,591.858154 1415.285278,589.331970 1414.624390,586.797241 
	C1413.006104,580.590210 1414.058838,578.762268 1420.217773,576.222839 
	C1422.358521,575.340149 1424.527100,574.524963 1427.373779,573.308411 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1481.301880,580.112732 
	C1475.846680,585.689636 1468.637451,585.601074 1462.252319,587.726440 
	C1460.684814,588.248169 1458.527222,587.277832 1458.524902,585.420288 
	C1458.518066,580.090393 1455.077271,576.321167 1453.057373,571.902161 
	C1451.744873,569.031311 1452.094727,566.720276 1455.787231,566.100891 
	C1456.111206,566.046509 1456.451782,566.084778 1456.772705,566.020325 
	C1474.872559,562.379395 1473.490234,561.828369 1481.301880,580.112732 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1265.993042,645.210327 
	C1258.650146,647.704041 1251.075684,646.891479 1242.826172,647.729248 
	C1241.732056,642.991882 1242.411255,638.426758 1241.075806,633.854553 
	C1239.704102,629.157532 1242.625854,626.335144 1246.663940,624.869019 
	C1250.499268,623.476440 1255.039673,622.772888 1257.204468,627.054199 
	C1260.135620,632.850586 1264.643433,637.881836 1265.993042,645.210327 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1257.477173,598.002686 
	C1258.818115,596.871948 1259.609985,596.229248 1260.509399,595.826843 
	C1271.538208,590.892822 1271.557861,590.961609 1276.101562,602.117798 
	C1277.403320,605.314148 1279.056885,608.366394 1275.384644,610.972351 
	C1271.760254,613.544373 1260.907959,614.832886 1259.267578,612.685974 
	C1257.907471,610.905762 1257.105591,608.587891 1256.478394,606.387939 
	C1255.744385,603.813232 1255.681885,601.123596 1257.477173,598.002686 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1323.916260,601.269653 
	C1319.086426,602.304443 1314.169800,601.502869 1309.259033,603.198853 
	C1303.854736,605.065247 1301.606323,600.849121 1299.555176,596.955383 
	C1297.381836,592.829529 1299.484009,590.077454 1302.709106,587.761353 
	C1311.411011,581.512146 1316.457275,583.056519 1320.719971,593.254395 
	C1321.738403,595.690674 1322.794067,598.111450 1323.916260,601.269653 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1485.487305,591.339600 
	C1485.974365,584.637024 1487.733276,583.437683 1495.150269,581.215149 
	C1499.416504,579.936768 1501.402710,582.009766 1503.245972,584.832825 
	C1504.679688,587.028381 1505.684937,589.506104 1506.852905,591.872131 
	C1507.900757,593.995361 1507.391968,596.017883 1505.401245,596.958008 
	C1501.545532,598.778809 1497.597168,600.615479 1493.485840,601.628357 
	C1488.472778,602.863464 1486.877197,600.629822 1485.487305,591.339600 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1427.829102,717.902588 
	C1422.427002,715.064453 1418.497437,710.006836 1414.004639,704.716064 
	C1417.183838,704.192749 1419.487183,703.273499 1420.493774,699.557739 
	C1421.250854,696.763123 1422.479858,693.851562 1425.609741,692.545349 
	C1429.292114,691.008667 1434.541260,692.196228 1436.355103,695.018860 
	C1439.152466,699.372070 1438.645508,705.870850 1434.831421,708.366882 
	C1431.448242,710.580933 1427.636841,712.125977 1427.829102,717.902588 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1324.014893,602.773438 
	C1329.457275,602.475647 1334.444946,600.274231 1339.587158,599.098755 
	C1343.556641,598.191345 1345.154175,599.783752 1345.863525,603.297852 
	C1347.718262,612.484680 1340.446655,620.164307 1330.816528,619.197632 
	C1329.260376,619.041443 1328.277222,618.205322 1328.211304,616.767334 
	C1327.991577,611.968994 1324.026489,608.388000 1324.014893,602.773438 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1407.802734,697.935913 
	C1400.369141,693.291992 1393.014038,687.792236 1385.340698,681.714844 
	C1390.596191,678.153687 1396.895630,677.455200 1402.812622,675.546509 
	C1409.972290,673.237061 1413.350098,676.573975 1411.622803,683.972229 
	C1411.255127,685.547119 1410.521362,687.075256 1409.739258,688.506348 
	C1408.265503,691.203308 1407.922485,694.097717 1407.802734,697.935913 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1388.968018,577.294312 
	C1388.350586,576.007263 1388.191650,575.359802 1387.951416,574.744080 
	C1383.381470,563.030273 1383.878662,562.300354 1396.029297,560.928162 
	C1398.258423,560.676392 1399.906494,560.979187 1401.370728,562.504272 
	C1404.429810,565.690186 1405.989014,569.734436 1407.501831,573.753357 
	C1407.951538,574.948059 1407.715820,576.858765 1406.273560,577.140808 
	C1400.707275,578.229370 1395.232178,582.601929 1388.968018,577.294312 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1364.047241,633.981018 
	C1359.993164,634.134216 1357.419800,632.861389 1355.553833,630.235352 
	C1352.777832,626.328735 1353.654785,621.886414 1357.674438,619.212402 
	C1368.243164,612.181824 1370.429077,613.047119 1372.688110,625.155518 
	C1373.909912,631.704712 1373.910034,631.704712 1364.047241,633.981018 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1289.815918,646.521118 
	C1285.141113,647.992249 1280.331421,646.860352 1274.745239,646.324829 
	C1277.475952,639.048340 1278.480835,638.561523 1284.124023,642.386292 
	C1285.927246,643.608398 1288.507080,643.633362 1289.815918,646.521118 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1233.871338,648.004395 
	C1232.891968,650.096741 1231.013184,649.939880 1228.634521,649.970337 
	C1228.700928,646.248840 1230.432251,645.216187 1233.871338,648.004395 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1042.864868,628.642944 
	C1048.470337,624.436768 1049.407959,617.237671 1045.875854,611.004578 
	C1043.835083,607.403320 1039.188354,606.885803 1033.553955,609.632202 
	C1025.957397,613.335022 1025.957397,613.335022 1027.479614,621.350891 
	C1029.027100,629.499329 1028.161499,631.212341 1020.780762,634.562866 
	C1019.872314,634.975281 1018.926453,635.307190 1018.027222,635.737610 
	C1014.615173,637.370789 1009.201538,636.564819 1008.363159,641.371277 
	C1007.359802,647.123169 1010.048828,652.413513 1012.954529,657.329346 
	C1014.044128,659.172607 1015.970764,659.926514 1018.076233,659.917175 
	C1020.735657,659.905396 1023.476257,660.123352 1026.034790,659.566528 
	C1030.163330,658.668030 1034.213501,655.917786 1036.494629,662.513184 
	C1039.042603,669.880127 1038.610596,674.981018 1034.198853,677.822266 
	C1029.240967,681.015259 1021.990112,680.784424 1018.411987,677.272583 
	C1017.705994,676.579712 1016.915955,675.813782 1016.582642,674.924805 
	C1013.638672,667.073242 1008.134705,663.720520 999.673767,663.751099 
	C994.312927,663.770569 990.764343,660.508057 989.213867,654.793945 
	C986.822083,645.979492 987.544373,644.005066 996.390564,640.848633 
	C997.955994,640.290100 999.579712,639.889832 1001.130371,639.295898 
	C1004.689697,637.932556 1006.015869,636.014771 1005.059875,631.660461 
	C1002.772766,621.243286 1003.735535,620.111084 1013.871094,616.308777 
	C1015.114868,615.842163 1016.436707,615.583557 1017.680237,615.116394 
	C1024.744995,612.462158 1025.062622,611.732239 1022.136597,605.194885 
	C1018.481079,597.027100 1021.156982,589.654480 1029.324463,585.391357 
	C1037.944702,580.891968 1037.944702,580.891907 1035.255371,572.616211 
	C1031.369507,560.658325 1032.140747,559.969482 1044.733765,559.882690 
	C1052.964233,559.825989 1057.027832,564.596191 1059.287354,571.176392 
	C1061.188721,576.713806 1063.633057,579.225403 1069.442261,576.547058 
	C1070.311523,576.146240 1071.388428,576.153687 1072.377563,576.061890 
	C1079.239380,575.425110 1082.179199,576.888977 1083.560791,581.594666 
	C1084.932129,586.265686 1083.223389,591.542297 1079.523071,594.063782 
	C1075.302856,596.939270 1069.713013,596.363586 1065.839111,592.362488 
	C1064.488770,590.967773 1063.746948,588.997620 1062.645752,587.344543 
	C1061.075317,584.987122 1060.852783,580.535400 1057.307373,581.007202 
	C1052.481567,581.649414 1047.844116,583.762390 1043.164551,585.357727 
	C1042.726929,585.506958 1042.452148,586.437805 1042.294556,587.054993 
	C1041.063110,591.873474 1047.649780,601.409912 1052.656860,601.922791 
	C1054.968384,602.159607 1057.320435,601.970154 1059.651001,602.057678 
	C1064.818970,602.251831 1067.017456,605.958191 1068.940308,609.988525 
	C1070.986328,614.277100 1069.623169,617.674194 1066.330566,620.685425 
	C1064.123901,622.703613 1062.033569,624.767883 1059.407715,626.352905 
	C1053.819214,629.726379 1052.647583,633.620178 1054.892212,639.598267 
	C1057.067139,645.390564 1059.883667,646.790955 1066.743652,645.446777 
	C1067.389648,645.320190 1067.981079,644.919617 1068.626587,644.784851 
	C1077.020020,643.033142 1079.243896,644.330627 1081.249146,652.892029 
	C1082.387085,657.750610 1083.344238,662.503113 1077.855103,666.186646 
	C1070.258423,671.284668 1068.009399,671.419250 1061.726929,664.661194 
	C1060.160034,662.975769 1058.599976,661.120667 1057.649658,659.060791 
	C1055.866943,655.197144 1053.162842,653.473206 1048.954468,653.986694 
	C1047.969482,654.106873 1046.956665,654.012207 1045.956909,653.998535 
	C1034.495361,653.841187 1028.524170,645.495300 1032.317993,634.881897 
	C1033.959595,630.289490 1038.637939,630.587219 1042.864868,628.642944 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1161.207397,608.652832 
	C1157.436523,603.188293 1152.831909,601.188110 1147.024780,602.005615 
	C1139.010498,603.133911 1134.142334,599.294800 1132.340820,591.880798 
	C1130.837646,585.694885 1128.113403,583.916321 1121.758911,585.741455 
	C1117.252319,587.035767 1112.615723,585.635254 1109.585938,581.068420 
	C1105.043823,574.222046 1105.279541,570.406494 1110.887817,566.664124 
	C1117.642090,562.157043 1125.352905,562.948914 1127.575928,569.948975 
	C1130.802612,580.109863 1135.360352,582.895508 1145.252197,578.341064 
	C1149.577515,576.349548 1154.021484,579.257629 1155.700928,583.739075 
	C1158.936768,592.374023 1164.947510,594.757812 1173.659790,594.181213 
	C1180.110474,593.754333 1187.871582,605.735107 1185.621948,611.512268 
	C1183.567383,616.788879 1172.211670,619.732849 1167.328491,616.106689 
	C1164.929321,614.325134 1162.889404,612.091187 1161.207397,608.652832 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1168.000000,639.156616 
	C1165.922607,640.928162 1164.480835,642.380005 1164.055786,645.357422 
	C1160.364258,649.080139 1155.601440,650.798645 1152.493286,655.556030 
	C1151.761719,656.214905 1151.344116,656.405334 1151.311035,656.648193 
	C1150.046753,665.905945 1144.173584,670.332825 1134.739258,671.912964 
	C1132.862183,669.611206 1131.472656,667.306030 1130.643799,664.814514 
	C1129.305786,660.792236 1129.756836,657.021851 1133.093262,653.899231 
	C1135.750122,651.412476 1138.155518,648.653931 1140.844238,646.204712 
	C1144.171143,643.174194 1146.220947,639.880554 1146.147461,635.042786 
	C1146.074951,630.289978 1147.727539,626.134766 1152.846680,623.992310 
	C1160.977295,620.589417 1168.736206,625.495178 1168.008301,633.349792 
	C1167.856201,634.990417 1167.995239,636.658081 1168.000000,639.156616 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1207.159180,609.998413 
	C1207.693115,614.128235 1209.806152,617.672363 1210.795898,621.487732 
	C1212.496948,628.044800 1210.168213,631.786438 1202.502075,634.705933 
	C1197.482788,636.617432 1194.972656,635.416809 1191.723267,629.278442 
	C1190.649414,627.249695 1189.934814,625.030762 1188.528076,622.449341 
	C1187.069336,616.468506 1189.914795,613.643799 1194.719849,611.552673 
	C1198.561279,609.880981 1202.402344,610.099426 1207.159180,609.998413 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1039.962891,723.998169 
	C1030.412842,722.886230 1028.303589,721.108826 1028.021606,714.636963 
	C1027.790283,709.328857 1033.248901,701.563416 1038.152100,700.339905 
	C1040.925171,699.647888 1043.323730,700.423889 1045.348511,702.464966 
	C1049.259888,706.408020 1050.671631,711.585754 1051.543091,716.701477 
	C1052.249634,720.848267 1048.504395,723.064148 1039.962891,723.998169 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1080.753174,563.484619 
	C1079.266846,560.127136 1076.930176,557.444885 1079.078003,554.495789 
	C1081.186523,551.600708 1083.412720,548.437866 1086.340576,546.579773 
	C1090.268921,544.086670 1096.455933,547.760254 1099.866333,553.802429 
	C1102.942383,559.252625 1102.425537,560.953125 1096.498169,564.885254 
	C1089.739746,569.368774 1086.850098,569.233582 1080.753174,563.484619 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1167.253540,573.374268 
	C1162.074219,576.776001 1157.715576,576.029724 1154.038696,572.528564 
	C1151.119385,569.748840 1149.128296,566.040405 1150.501709,561.862061 
	C1151.885376,557.653381 1155.293701,555.741882 1159.733887,556.031555 
	C1163.541992,556.280029 1167.690918,554.879211 1170.871216,558.358948 
	C1175.289917,563.193481 1174.502441,567.244446 1167.253540,573.374268 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1045.543701,681.738220 
	C1048.457520,677.956665 1052.304443,677.469543 1055.705322,676.498657 
	C1061.104370,674.957520 1064.284790,676.868347 1066.848022,682.157593 
	C1069.019043,686.637146 1066.524170,689.905090 1063.739990,692.732056 
	C1060.280396,696.244812 1054.063110,697.060974 1049.836182,694.763428 
	C1044.840088,692.047729 1042.820801,687.962158 1045.543701,681.738220 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1088.382324,640.148560 
	C1081.313477,640.923035 1077.356689,637.931519 1076.272705,631.707275 
	C1075.486816,627.195923 1078.438232,621.579468 1082.254639,620.323364 
	C1087.756592,618.512573 1093.219238,620.744202 1095.626709,625.786377 
	C1099.044800,632.945007 1097.775146,635.702698 1088.382324,640.148560 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1196.514526,571.540588 
	C1198.307861,573.980774 1199.884888,575.750549 1200.762085,577.817261 
	C1202.994995,583.079041 1202.259888,584.386902 1196.743286,586.167358 
	C1194.871460,586.771545 1193.001465,587.382202 1191.122437,587.963501 
	C1181.721680,590.872131 1178.667358,588.055603 1180.008789,578.032776 
	C1180.556152,573.943542 1183.063599,571.762939 1186.312744,569.853516 
	C1189.915283,567.736450 1193.105591,567.684570 1196.514526,571.540588 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1225.304688,585.694275 
	C1226.006958,586.326355 1225.969727,586.660706 1226.027100,586.977966 
	C1228.694336,601.729370 1227.069092,603.873108 1210.797119,605.999634 
	C1209.472534,604.099182 1208.819824,602.220703 1208.438232,600.288635 
	C1205.986694,587.878967 1211.879150,582.469116 1225.304688,585.694275 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1126.208984,553.203735 
	C1125.076050,546.931213 1127.626831,543.093750 1131.434937,539.417969 
	C1134.774658,536.194275 1137.448486,535.811707 1140.452148,539.466309 
	C1141.288452,540.483765 1142.301636,541.369568 1143.048584,542.444397 
	C1146.688599,547.682434 1146.944336,553.230042 1143.742554,555.879944 
	C1137.823486,560.778748 1131.220459,560.059875 1126.208984,553.203735 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1740.456055,468.050659 
	C1744.155029,468.289825 1747.678467,466.935699 1749.562988,470.012726 
	C1751.789307,473.647827 1753.487305,477.621338 1755.198120,481.542511 
	C1755.479248,482.187042 1754.924194,483.753632 1754.289917,484.151031 
	C1749.747070,486.997345 1744.646973,488.445190 1739.394897,489.151215 
	C1738.581299,489.260590 1737.206055,487.696747 1736.641968,486.618286 
	C1735.572754,484.574005 1734.934814,482.307983 1734.062012,480.156677 
	C1730.738892,471.965851 1730.879395,471.646790 1740.456055,468.050659 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1766.339111,505.435669 
	C1764.317871,501.499084 1762.932373,497.809296 1761.776611,494.048889 
	C1759.641846,487.102234 1759.697998,487.084991 1766.501709,485.565735 
	C1775.093018,483.647308 1782.256592,488.730988 1783.545898,497.680573 
	C1783.887451,500.050751 1782.843018,501.342499 1780.491577,501.936707 
	C1775.994873,503.073059 1771.546875,504.401703 1766.339111,505.435669 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1774.856079,441.001160 
	C1776.903564,438.283600 1779.176758,438.000824 1781.564941,438.022552 
	C1785.347656,438.056946 1789.282227,438.077515 1789.620728,443.196411 
	C1789.872681,447.008667 1785.584473,451.272736 1781.257690,451.761536 
	C1776.789917,452.266357 1774.247559,450.269379 1774.101318,445.666443 
	C1774.059692,444.353821 1774.336182,443.031128 1774.856079,441.001160 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1803.342041,421.527710 
	C1801.964844,422.563751 1801.189941,423.300873 1800.284058,423.538910 
	C1795.733765,424.734192 1792.582275,422.669037 1790.719604,418.725739 
	C1789.515015,416.175507 1789.802856,413.593506 1792.570679,411.898132 
	C1795.889038,409.865479 1799.262817,409.095093 1802.572876,411.800385 
	C1805.773804,414.416565 1807.105347,417.412476 1803.342041,421.527710 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1788.019409,545.234253 
	C1785.370850,544.654175 1783.818848,542.906067 1785.090210,539.678406 
	C1786.198242,536.865356 1786.648926,533.968140 1784.758667,531.063965 
	C1780.650757,530.537170 1777.245239,532.959656 1772.739990,533.912903 
	C1773.297607,526.456970 1780.057495,526.207764 1785.372925,524.265442 
	C1787.264648,523.574158 1788.933716,524.860596 1789.836060,527.095337 
	C1792.328247,533.267639 1791.791382,539.004089 1788.019409,545.234253 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1818.508057,387.147278 
	C1817.768066,394.117004 1815.195679,396.632812 1810.714478,395.751648 
	C1806.854248,394.992615 1804.927368,390.845459 1806.322510,386.298828 
	C1807.987427,380.872864 1812.669189,380.946594 1818.508057,387.147278 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1799.488770,435.830627 
	C1801.819824,433.319763 1804.157593,430.946777 1806.542725,433.152466 
	C1809.103394,435.520569 1808.570190,439.287994 1807.080811,442.205597 
	C1805.897705,444.523224 1803.095337,444.339935 1800.960938,443.613708 
	C1797.077026,442.292084 1797.920044,439.328796 1799.488770,435.830627 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M781.301270,737.877441 
	C781.998413,738.888916 781.999207,739.777771 782.000000,741.333374 
	C779.565857,744.434021 779.027527,748.428101 774.827209,749.499451 
	C769.540222,750.847900 764.432190,749.894592 761.410645,746.171021 
	C757.344849,741.160889 757.416992,737.990723 761.873169,730.706238 
	C762.888916,730.001343 763.777771,730.000305 765.333374,729.998413 
	C773.693970,728.111572 773.652222,728.135986 777.850037,735.311890 
	C778.439087,736.318848 779.670715,736.949890 781.301270,737.877441 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M779.333984,760.003113 
	C778.534912,762.908569 777.628845,764.999756 775.403076,766.167908 
	C772.399048,767.744385 769.213989,769.302612 766.469971,766.155151 
	C764.241333,763.598877 763.102722,760.353210 764.873718,757.022095 
	C766.796753,753.405090 770.315491,753.752686 773.573120,754.312866 
	C776.329163,754.786743 778.118347,756.777832 779.333984,760.003113 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1377.638794,1085.985718 
	C1370.634033,1084.933716 1364.987793,1088.349609 1359.012329,1087.944824 
	C1330.911621,1086.041748 1303.126221,1083.377808 1276.973755,1070.998047 
	C1260.619385,1063.256592 1245.491821,1054.078247 1231.631104,1042.630005 
	C1229.442505,1040.822266 1227.154053,1039.883789 1224.352539,1039.998291 
	C1222.691162,1040.066284 1221.024048,1039.982910 1219.359985,1040.003174 
	C1198.122803,1040.261353 1177.004517,1038.735474 1155.926758,1036.184082 
	C1150.345581,1035.508667 1144.622070,1036.009155 1138.963867,1035.973877 
	C1136.535522,1035.958740 1134.066528,1035.588135 1133.024780,1033.160156 
	C1131.875122,1030.481445 1134.037231,1028.720581 1135.796387,1027.331421 
	C1138.908203,1024.873901 1141.992554,1021.955017 1145.602661,1020.625427 
	C1166.418579,1012.958679 1187.293091,1005.410095 1209.033081,1000.645691 
	C1214.208862,999.511475 1219.521973,999.215393 1224.735840,998.477112 
	C1248.810059,995.067688 1273.180298,994.753723 1297.316650,996.423462 
	C1316.328979,997.738647 1335.331421,1000.721558 1353.817505,1006.583679 
	C1363.263062,1009.578857 1372.829224,1012.361145 1382.066772,1015.883240 
	C1405.981201,1025.001465 1429.014771,1035.941284 1449.425903,1051.716553 
	C1455.448486,1056.371338 1455.413208,1058.871582 1448.927246,1062.463379 
	C1430.205688,1072.830566 1410.445557,1080.384033 1389.269409,1083.988037 
	C1385.683960,1084.598389 1382.116089,1085.311768 1377.638794,1085.985718 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1225.068359,1430.448853 
	C1204.811401,1429.086548 1191.154785,1419.295532 1182.562622,1402.142090 
	C1180.294312,1397.613647 1179.449585,1392.769043 1179.475586,1387.638550 
	C1179.580444,1366.975586 1179.485474,1346.311768 1179.437134,1325.648193 
	C1179.413940,1315.724609 1179.386230,1315.765381 1169.469360,1315.667847 
	C1165.182617,1315.625732 1160.870483,1316.286133 1156.710327,1314.239868 
	C1149.544312,1310.715820 1147.016968,1304.472290 1150.188599,1297.116333 
	C1156.529907,1282.409424 1165.539429,1269.217896 1173.952637,1255.703491 
	C1180.443481,1245.276855 1187.448975,1235.171753 1194.039917,1224.805664 
	C1200.248901,1215.040527 1209.721924,1213.958374 1216.644775,1223.236816 
	C1224.791992,1234.156128 1232.270386,1245.598389 1239.620117,1257.081909 
	C1246.423950,1267.712280 1252.681763,1278.692139 1259.163330,1289.528198 
	C1260.188843,1291.242798 1261.270996,1292.945923 1262.079468,1294.764282 
	C1267.086182,1306.024658 1261.712036,1314.944946 1249.419067,1315.705200 
	C1246.099854,1315.910400 1242.755005,1315.736328 1239.422729,1315.680420 
	C1235.345703,1315.612061 1233.157837,1317.483521 1233.189819,1321.651611 
	C1233.364380,1344.306396 1232.966187,1366.986328 1233.945679,1389.606689 
	C1234.561646,1403.830322 1243.321045,1414.121704 1254.506836,1422.285278 
	C1256.111084,1423.456299 1257.974731,1424.268311 1259.698120,1425.281006 
	C1260.864990,1425.966675 1261.989990,1426.801147 1261.714600,1428.354858 
	C1261.347046,1430.428955 1259.625122,1430.755615 1257.947388,1430.746582 
	C1247.284180,1430.688843 1236.621460,1430.565430 1225.068359,1430.448853 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1325.148682,1430.449951 
	C1314.921997,1430.864868 1311.357788,1423.107544 1307.592285,1416.864868 
	C1296.621460,1398.677734 1284.111084,1381.467285 1273.752686,1362.891846 
	C1271.473633,1358.804810 1269.599487,1354.590698 1267.613770,1350.400513 
	C1263.827148,1342.410156 1268.519653,1333.403931 1277.373535,1332.107178 
	C1280.960083,1331.581787 1284.681641,1332.029785 1288.338013,1331.916626 
	C1295.972412,1331.680786 1297.237671,1330.608643 1297.265503,1323.327271 
	C1297.343140,1303.020386 1298.102783,1282.664917 1296.961182,1262.420776 
	C1296.066895,1246.565186 1288.995483,1233.077637 1274.712158,1224.418823 
	C1272.271606,1222.939453 1268.001465,1222.049805 1269.089722,1218.509033 
	C1270.130493,1215.123169 1274.267700,1216.419678 1277.129028,1216.487549 
	C1287.761475,1216.739502 1298.377686,1216.188965 1309.033569,1217.373291 
	C1335.248291,1220.286987 1351.891602,1242.758301 1351.441772,1265.705322 
	C1351.076538,1284.340942 1351.348633,1302.989502 1351.373047,1321.632324 
	C1351.386475,1331.918091 1351.419067,1331.920410 1362.049194,1331.908691 
	C1364.046631,1331.906494 1366.052856,1331.747803 1368.039917,1331.884155 
	C1379.571655,1332.675049 1384.887085,1342.346558 1379.385498,1352.319092 
	C1369.918213,1369.480347 1359.530273,1386.079834 1348.915771,1402.543579 
	C1345.140869,1408.398804 1341.630859,1414.442627 1337.560425,1420.083130 
	C1334.500000,1424.324341 1331.653076,1429.117432 1325.148682,1430.449951 
z"/>
<path fill="#F3F5F4" opacity="1.000000" stroke="none" 
	d="
M1021.794312,1487.721558 
	C1016.238647,1483.610107 1012.268494,1477.587769 1008.623657,1470.581055 
	C1014.467712,1474.435303 1019.794250,1479.431152 1021.794312,1487.721558 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M1180.978760,664.760742 
	C1180.114868,661.948425 1178.212402,659.937378 1177.147095,657.552612 
	C1175.330078,653.485596 1174.886108,649.015015 1177.970825,645.328125 
	C1180.814209,641.929688 1184.630737,639.493835 1189.293213,640.334534 
	C1194.026489,641.187927 1194.944458,645.467651 1195.838989,649.359009 
	C1196.203125,650.942749 1195.958008,652.666504 1195.982910,655.140503 
	C1195.240479,657.332703 1193.900146,658.110413 1192.406982,659.532043 
	C1188.951416,662.355896 1185.246338,663.393372 1180.978760,664.760742 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1200.901489,657.091675 
	C1200.090576,654.038513 1199.853027,651.035645 1200.109131,648.075439 
	C1200.497070,643.587036 1203.027344,640.623169 1207.596680,640.220642 
	C1212.361206,639.800903 1213.773071,643.024963 1214.191406,647.119812 
	C1214.321289,648.391113 1215.045410,649.601746 1215.796143,651.538879 
	C1211.604736,654.784058 1206.474609,655.458801 1200.901489,657.091675 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1192.713501,660.018555 
	C1192.151123,658.122437 1192.709717,656.616028 1195.348633,656.057861 
	C1196.612183,656.075562 1197.248657,656.196655 1198.814209,656.622681 
	C1198.081909,658.870056 1195.705688,659.394775 1192.713501,660.018555 
z"/>
<path fill="#140A07" opacity="1.000000" stroke="none" 
	d="
M1896.328125,420.222900 
	C1893.714600,421.788574 1891.727905,423.181061 1889.539551,423.668732 
	C1884.131470,424.873962 1881.462158,423.337769 1879.271606,418.397491 
	C1876.838867,412.911285 1877.695068,410.040985 1882.306641,406.483032 
	C1884.492432,404.796631 1887.010010,404.186005 1889.447754,403.209839 
	C1893.472656,401.598083 1896.357178,402.396088 1895.836304,407.129700 
	C1895.359131,411.464966 1899.289673,415.278961 1896.328125,420.222900 
z"/>
<path fill="#0F0404" opacity="1.000000" stroke="none" 
	d="
M1850.063721,375.792725 
	C1850.117554,370.452576 1852.698120,368.333344 1856.986816,368.948639 
	C1860.280273,369.421173 1862.730591,374.894714 1861.842529,378.666931 
	C1860.810669,383.049347 1856.321655,384.563812 1852.793945,381.636047 
	C1851.243286,380.348999 1850.229980,378.647827 1850.063721,375.792725 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1369.231689,360.012573 
	C1370.628540,362.520782 1371.711670,365.032166 1371.777954,367.570068 
	C1371.874878,371.288696 1370.818481,374.815674 1366.475952,375.839752 
	C1362.281738,376.828857 1359.584106,374.794983 1358.315918,369.516663 
	C1357.866577,367.646210 1358.086060,365.614990 1358.000000,362.829224 
	C1361.715576,362.550720 1364.851562,360.027618 1369.231689,360.012573 
z"/>
<path fill="#120704" opacity="1.000000" stroke="none" 
	d="
M947.744629,1425.815918 
	C957.400818,1423.431885 961.880066,1425.858398 961.962952,1432.888062 
	C962.018005,1437.554321 952.340454,1446.292480 947.674744,1445.813721 
	C946.287292,1445.671265 945.136475,1445.135864 944.286133,1444.028198 
	C941.883972,1440.899170 941.984009,1437.238403 941.992065,1433.560059 
	C942.000061,1429.897095 942.993958,1427.006226 947.744629,1425.815918 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1152.625244,656.319702 
	C1153.427368,647.715332 1153.975952,647.190247 1163.222168,645.999329 
	C1165.111206,648.639221 1167.899414,650.396729 1167.940308,653.618225 
	C1167.973755,656.233093 1168.173828,658.985718 1165.757080,660.686768 
	C1163.109863,662.549927 1160.259155,662.371887 1157.662720,660.414856 
	C1156.119995,659.251953 1154.716553,657.904114 1152.625244,656.319702 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1218.561523,620.875244 
	C1215.796143,613.860901 1216.866211,611.337097 1221.412964,612.284485 
	C1223.907349,612.804199 1225.818848,614.307556 1225.569824,616.825195 
	C1225.218140,620.384949 1222.326782,621.205322 1218.561523,620.875244 
z"/>
<path fill="#150807" opacity="1.000000" stroke="none" 
	d="
M1240.361816,592.389160 
	C1234.338745,593.806519 1233.717651,590.392822 1234.565308,586.515564 
	C1235.206543,583.582886 1238.082520,583.679932 1240.179688,584.532898 
	C1244.685913,586.365479 1243.875366,589.142944 1240.361816,592.389160 
z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
